const signs = [
  [-2208825235,-2208649845,'Aquarius'],
  [-2208649845,-2208471255,'Pisces'],
  [-2208471255,-2208285221,'Aries'],
  [-2208285221,-2208090180,'Taurus'],
  [-2208090180,-2207886816,'Gemini'],
  [-2207886816,-2207676529,'Cancer'],
  [-2207676529,-2207460766,'Leo'],
  [-2207460766,-2207242359,'Virgo'],
  [-2207242359,-2207027111,'Libra'],
  [-2207027111,-2206822176,'Scorpio'],
  [-2206822176,-2206631548,'Sagittarius'],
  [-2206631548,-2206453605,'Capricorn'],
  [-2206453605,-2206282348,'Aquarius'],
  [-2206282348,-2206110110,'Pisces'],
  [-2206110110,-2205929883,'Aries'],
  [-2205929883,-2205737539,'Taurus'],
  [-2205737539,-2205533386,'Gemini'],
  [-2205533386,-2205321040,'Cancer'],
  [-2205321040,-2205104387,'Leo'],
  [-2205104387,-2204886193,'Virgo'],
  [-2204886193,-2204669726,'Libra'],
  [-2204669726,-2204460373,'Scorpio'],
  [-2204460373,-2204263607,'Sagittarius'],
  [-2204263607,-2204081050,'Capricorn'],
  [-2204081050,-2203908914,'Aquarius'],
  [-2203908914,-2203739871,'Pisces'],
  [-2203739871,-2203565711,'Aries'],
  [-2203565711,-2203379692,'Taurus'],
  [-2203379692,-2203179238,'Gemini'],
  [-2203179238,-2202967262,'Cancer'],
  [-2202967262,-2202749733,'Leo'],
  [-2202749733,-2202531641,'Virgo'],
  [-2202531641,-2202315892,'Libra'],
  [-2202315892,-2202105398,'Scorpio'],
  [-2202105398,-2201904169,'Sagittarius'],
  [-2201904169,-2201715261,'Capricorn'],
  [-2201715261,-2201537865,'Aquarius'],
  [-2201537865,-2201366853,'Pisces'],
  [-2201366853,-2201194736,'Aries'],
  [-2201194736,-2201013952,'Taurus'],
  [-2201013952,-2200819374,'Gemini'],
  [-2200819374,-2200610964,'Cancer'],
  [-2200610964,-2200394092,'Leo'],
  [-2200394092,-2200175925,'Virgo'],
  [-2200175925,-2199961306,'Libra'],
  [-2199961306,-2199752468,'Scorpio'],
  [-2199752468,-2199550977,'Sagittarius'],
  [-2199550977,-2199358459,'Capricorn'],
  [-2199358459,-2199175234,'Aquarius'],
  [-2199175234,-2198998801,'Pisces'],
  [-2198998801,-2198823957,'Aries'],
  [-2198823957,-2198644210,'Taurus'],
  [-2198644210,-2198453747,'Gemini'],
  [-2198453747,-2198249939,'Cancer'],
  [-2198249939,-2198035436,'Leo'],
  [-2198035436,-2197817407,'Virgo'],
  [-2197817407,-2197603102,'Libra'],
  [-2197603102,-2197396319,'Scorpio'],
  [-2197396319,-2197197619,'Sagittarius'],
  [-2197197619,-2197006155,'Capricorn'],
  [-2197006155,-2196820715,'Aquarius'],
  [-2196820715,-2196639494,'Pisces'],
  [-2196639494,-2196459562,'Aries'],
  [-2196459562,-2196276815,'Taurus'],
  [-2196276815,-2196086680,'Gemini'],
  [-2196086680,-2195885724,'Cancer'],
  [-2195885724,-2195673952,'Leo'],
  [-2195673952,-2195456401,'Virgo'],
  [-2195456401,-2195241248,'Libra'],
  [-2195241248,-2195034856,'Scorpio'],
  [-2195034856,-2194838920,'Sagittarius'],
  [-2194838920,-2194651315,'Capricorn'],
  [-2194651315,-2194468369,'Aquarius'],
  [-2194468369,-2194286565,'Pisces'],
  [-2194286565,-2194103181,'Aries'],
  [-2194103181,-2193916083,'Taurus'],
  [-2193916083,-2193723130,'Gemini'],
  [-2193723130,-2193522074,'Cancer'],
  [-2193522074,-2193311834,'Leo'],
  [-2193311834,-2193094844,'Virgo'],
  [-2193094844,-2192878062,'Libra'],
  [-2192878062,-2192669696,'Scorpio'],
  [-2192669696,-2192473984,'Sagittarius'],
  [-2192473984,-2192289523,'Capricorn'],
  [-2192289523,-2192111268,'Aquarius'],
  [-2192111268,-2191933323,'Pisces'],
  [-2191933323,-2191751000,'Aries'],
  [-2191751000,-2191561894,'Taurus'],
  [-2191561894,-2191365595,'Gemini'],
  [-2191365595,-2191162243,'Cancer'],
  [-2191162243,-2190951714,'Leo'],
  [-2190951714,-2190734999,'Virgo'],
  [-2190734999,-2190516665,'Libra'],
  [-2190516665,-2190304735,'Scorpio'],
  [-2190304735,-2190105953,'Sagittarius'],
  [-2190105953,-2189921292,'Capricorn'],
  [-2189921292,-2189746174,'Aquarius'],
  [-2189746174,-2189573447,'Pisces'],
  [-2189573447,-2189396135,'Aries'],
  [-2189396135,-2189209555,'Taurus'],
  [-2189209555,-2189012619,'Gemini'],
  [-2189012619,-2188807033,'Cancer'],
  [-2188807033,-2188594966,'Leo'],
  [-2188594966,-2188378031,'Virgo'],
  [-2188378031,-2188158994,'Libra'],
  [-2188158994,-2187943838,'Scorpio'],
  [-2187943838,-2187739973,'Sagittarius'],
  [-2187739973,-2187551204,'Capricorn'],
  [-2187551204,-2187375173,'Aquarius'],
  [-2187375173,-2187205202,'Pisces'],
  [-2187205202,-2187033308,'Aries'],
  [-2187033308,-2186852545,'Taurus'],
  [-2186852545,-2186659219,'Gemini'],
  [-2186659219,-2186454071,'Cancer'],
  [-2186454071,-2186240797,'Leo'],
  [-2186240797,-2186023253,'Virgo'],
  [-2186023253,-2185804425,'Libra'],
  [-2185804425,-2185588181,'Scorpio'],
  [-2185588181,-2185380187,'Sagittarius'],
  [-2185380187,-2185185367,'Capricorn'],
  [-2185185367,-2185004266,'Aquarius'],
  [-2185004266,-2184832429,'Pisces'],
  [-2184832429,-2184662605,'Aries'],
  [-2184662605,-2184487105,'Taurus'],
  [-2184487105,-2184299889,'Gemini'],
  [-2184299889,-2184098801,'Cancer'],
  [-2184098801,-2183886474,'Leo'],
  [-2183886474,-2183668510,'Virgo'],
  [-2183668510,-2183450127,'Libra'],
  [-2183450127,-2183234987,'Scorpio'],
  [-2183234987,-2183026355,'Sagittarius'],
  [-2183026355,-2182827477,'Capricorn'],
  [-2182827477,-2182640030,'Aquarius'],
  [-2182640030,-2182462373,'Pisces'],
  [-2182462373,-2182289679,'Aries'],
  [-2182289679,-2182115384,'Taurus'],
  [-2182115384,-2181932868,'Gemini'],
  [-2181932868,-2181737464,'Cancer'],
  [-2181737464,-2181528739,'Leo'],
  [-2181528739,-2181311468,'Virgo'],
  [-2181311468,-2181093100,'Libra'],
  [-2181093100,-2180879466,'Scorpio'],
  [-2180879466,-2180673231,'Sagittarius'],
  [-2180673231,-2180474992,'Capricorn'],
  [-2180474992,-2180284580,'Aquarius'],
  [-2180284580,-2180101100,'Pisces'],
  [-2180101100,-2179922326,'Aries'],
  [-2179922326,-2179744397,'Taurus'],
  [-2179744397,-2179562188,'Gemini'],
  [-2179562188,-2179370488,'Cancer'],
  [-2179370488,-2179166189,'Leo'],
  [-2179166189,-2178951059,'Virgo'],
  [-2178951059,-2178732385,'Libra'],
  [-2178732385,-2178518758,'Scorpio'],
  [-2178518758,-2178314849,'Sagittarius'],
  [-2178314849,-2178120364,'Capricorn'],
  [-2178120364,-2177932399,'Aquarius'],
  [-2177932399,-2177747900,'Pisces'],
  [-2177747900,-2177564702,'Aries'],
  [-2177564702,-2177381169,'Taurus'],
  [-2177381169,-2177195052,'Gemini'],
  [-2177195052,-2177002880,'Cancer'],
  [-2177002880,-2176800990,'Leo'],
  [-2176800990,-2176588358,'Virgo'],
  [-2176588358,-2176369650,'Libra'],
  [-2176369650,-2176154214,'Scorpio'],
  [-2176154214,-2175949826,'Sagittarius'],
  [-2175949826,-2175757955,'Capricorn'],
  [-2175757955,-2175574741,'Aquarius'],
  [-2175574741,-2175394530,'Pisces'],
  [-2175394530,-2175212657,'Aries'],
  [-2175212657,-2175026750,'Taurus'],
  [-2175026750,-2174836228,'Gemini'],
  [-2174836228,-2174640456,'Cancer'],
  [-2174640456,-2174437640,'Leo'],
  [-2174437640,-2174226142,'Virgo'],
  [-2174226142,-2174007809,'Libra'],
  [-2174007809,-2173790041,'Scorpio'],
  [-2173790041,-2173582225,'Sagittarius'],
  [-2173582225,-2173389008,'Capricorn'],
  [-2173389008,-2173208061,'Aquarius'],
  [-2173208061,-2173032968,'Pisces'],
  [-2173032968,-2172856762,'Aries'],
  [-2172856762,-2172674311,'Taurus'],
  [-2172674311,-2172483578,'Gemini'],
  [-2172483578,-2172284982,'Cancer'],
  [-2172284982,-2172079379,'Leo'],
  [-2172079379,-2171867000,'Virgo'],
  [-2171867000,-2171648906,'Libra'],
  [-2171648906,-2171429778,'Scorpio'],
  [-2171429778,-2171217817,'Sagittarius'],
  [-2171217817,-2171019820,'Capricorn'],
  [-2171019820,-2170836493,'Aquarius'],
  [-2170836493,-2170662858,'Pisces'],
  [-2170662858,-2170491525,'Aries'],
  [-2170491525,-2170315389,'Taurus'],
  [-2170315389,-2170129527,'Gemini'],
  [-2170129527,-2169932395,'Cancer'],
  [-2169932395,-2169725438,'Leo'],
  [-2169725438,-2169511374,'Virgo'],
  [-2169511374,-2169292943,'Libra'],
  [-2169292943,-2169073764,'Scorpio'],
  [-2169073764,-2168859505,'Sagittarius'],
  [-2168859505,-2168656383,'Capricorn'],
  [-2168656383,-2168467417,'Aquarius'],
  [-2168467417,-2168290461,'Pisces'],
  [-2168290461,-2168119637,'Aries'],
  [-2168119637,-2167947744,'Taurus'],
  [-2167947744,-2167768119,'Gemini'],
  [-2167768119,-2167576317,'Cancer'],
  [-2167576317,-2167371602,'Leo'],
  [-2167371602,-2167157170,'Virgo'],
  [-2167157170,-2166938188,'Libra'],
  [-2166938188,-2166719572,'Scorpio'],
  [-2166719572,-2166505590,'Sagittarius'],
  [-2166505590,-2166300109,'Capricorn'],
  [-2166300109,-2166105893,'Aquarius'],
  [-2166105893,-2165922992,'Pisces'],
  [-2165922992,-2165748211,'Aries'],
  [-2165748211,-2165576003,'Taurus'],
  [-2165576003,-2165399816,'Gemini'],
  [-2165399816,-2165213580,'Cancer'],
  [-2165213580,-2165013698,'Leo'],
  [-2165013698,-2164801295,'Virgo'],
  [-2164801295,-2164582349,'Libra'],
  [-2164582349,-2164364164,'Scorpio'],
  [-2164364164,-2164151807,'Sagittarius'],
  [-2164151807,-2163947403,'Capricorn'],
  [-2163947403,-2163751504,'Aquarius'],
  [-2163751504,-2163563930,'Pisces'],
  [-2163563930,-2163383412,'Aries'],
  [-2163383412,-2163206990,'Taurus'],
  [-2163206990,-2163029881,'Gemini'],
  [-2163029881,-2162846213,'Cancer'],
  [-2162846213,-2162650772,'Leo'],
  [-2162650772,-2162441885,'Virgo'],
  [-2162441885,-2162223955,'Libra'],
  [-2162223955,-2162005723,'Scorpio'],
  [-2162005723,-2161794537,'Sagittarius'],
  [-2161794537,-2161592789,'Capricorn'],
  [-2161592789,-2161399064,'Aquarius'],
  [-2161399064,-2161211018,'Pisces'],
  [-2161211018,-2161026920,'Aries'],
  [-2161026920,-2160845396,'Taurus'],
  [-2160845396,-2160664155,'Gemini'],
  [-2160664155,-2160479165,'Cancer'],
  [-2160479165,-2160285427,'Leo'],
  [-2160285427,-2160079521,'Virgo'],
  [-2160079521,-2159863190,'Libra'],
  [-2159863190,-2159644468,'Scorpio'],
  [-2159644468,-2159432805,'Sagittarius'],
  [-2159432805,-2159232656,'Capricorn'],
  [-2159232656,-2159042450,'Aquarius'],
  [-2159042450,-2158857824,'Pisces'],
  [-2158857824,-2158674795,'Aries'],
  [-2158674795,-2158491133,'Taurus'],
  [-2158491133,-2158305749,'Gemini'],
  [-2158305749,-2158116986,'Cancer'],
  [-2158116986,-2157921754,'Leo'],
  [-2157921754,-2157716759,'Virgo'],
  [-2157716759,-2157501733,'Libra'],
  [-2157501733,-2157282390,'Scorpio'],
  [-2157282390,-2157068521,'Sagittarius'],
  [-2157068521,-2156867195,'Capricorn'],
  [-2156867195,-2156678642,'Aquarius'],
  [-2156678642,-2156498160,'Pisces'],
  [-2156498160,-2156319793,'Aries'],
  [-2156319793,-2156138865,'Taurus'],
  [-2156138865,-2155952960,'Gemini'],
  [-2155952960,-2155761219,'Cancer'],
  [-2155761219,-2155562830,'Leo'],
  [-2155562830,-2155356469,'Virgo'],
  [-2155356469,-2155141728,'Libra'],
  [-2155141728,-2154922012,'Scorpio'],
  [-2154922012,-2154705339,'Sagittarius'],
  [-2154705339,-2154500102,'Capricorn'],
  [-2154500102,-2154309427,'Aquarius'],
  [-2154309427,-2154130262,'Pisces'],
  [-2154130262,-2153956358,'Aries'],
  [-2153956358,-2153781148,'Taurus'],
  [-2153781148,-2153599541,'Gemini'],
  [-2153599541,-2153408863,'Cancer'],
  [-2153408863,-2153208716,'Leo'],
  [-2153208716,-2153000058,'Virgo'],
  [-2153000058,-2152784442,'Libra'],
  [-2152784442,-2152564700,'Scorpio'],
  [-2152564700,-2152346324,'Sagittarius'],
  [-2152346324,-2152136525,'Capricorn'],
  [-2152136525,-2151940442,'Aquarius'],
  [-2151940442,-2151758039,'Pisces'],
  [-2151758039,-2151584762,'Aries'],
  [-2151584762,-2151413930,'Taurus'],
  [-2151413930,-2151238674,'Gemini'],
  [-2151238674,-2151053460,'Cancer'],
  [-2151053460,-2150855628,'Leo'],
  [-2150855628,-2150646286,'Virgo'],
  [-2150646286,-2150429407,'Libra'],
  [-2150429407,-2150209647,'Scorpio'],
  [-2150209647,-2149991448,'Sagittarius'],
  [-2149991448,-2149779367,'Capricorn'],
  [-2149779367,-2149577780,'Aquarius'],
  [-2149577780,-2149388910,'Pisces'],
  [-2149388910,-2149211293,'Aries'],
  [-2149211293,-2149040132,'Taurus'],
  [-2149040132,-2148868678,'Gemini'],
  [-2148868678,-2148689793,'Cancer'],
  [-2148689793,-2148497854,'Leo'],
  [-2148497854,-2148291378,'Virgo'],
  [-2148291378,-2148074495,'Libra'],
  [-2148074495,-2147854490,'Scorpio'],
  [-2147854490,-2147637385,'Sagittarius'],
  [-2147637385,-2147426292,'Capricorn'],
  [-2147426292,-2147222883,'Aquarius'],
  [-2147222883,-2147028657,'Pisces'],
  [-2147028657,-2146844226,'Aries'],
  [-2146844226,-2146667896,'Taurus'],
  [-2146667896,-2146495037,'Gemini'],
  [-2146495037,-2146318933,'Cancer'],
  [-2146318933,-2146132567,'Leo'],
  [-2146132567,-2145931425,'Virgo'],
  [-2145931425,-2145716973,'Libra'],
  [-2145716973,-2145497017,'Scorpio'],
  [-2145497017,-2145280391,'Sagittarius'],
  [-2145280391,-2145071510,'Capricorn'],
  [-2145071510,-2144870378,'Aquarius'],
  [-2144870378,-2144675777,'Pisces'],
  [-2144675777,-2144487249,'Aries'],
  [-2144487249,-2144304655,'Taurus'],
  [-2144304655,-2144126311,'Gemini'],
  [-2144126311,-2143947857,'Cancer'],
  [-2143947857,-2143763058,'Leo'],
  [-2143763058,-2143566149,'Virgo'],
  [-2143566149,-2143355495,'Libra'],
  [-2143355495,-2143136557,'Scorpio'],
  [-2143136557,-2142919344,'Sagittarius'],
  [-2142919344,-2142711172,'Capricorn'],
  [-2142711172,-2142513076,'Aquarius'],
  [-2142513076,-2142322171,'Pisces'],
  [-2142322171,-2142135265,'Aries'],
  [-2142135265,-2141950621,'Taurus'],
  [-2141950621,-2141767388,'Gemini'],
  [-2141767388,-2141583792,'Cancer'],
  [-2141583792,-2141396138,'Leo'],
  [-2141396138,-2141199746,'Virgo'],
  [-2141199746,-2140991699,'Libra'],
  [-2140991699,-2140774382,'Scorpio'],
  [-2140774382,-2140556179,'Sagittarius'],
  [-2140556179,-2140346307,'Capricorn'],
  [-2140346307,-2140148646,'Aquarius'],
  [-2140148646,-2139961143,'Pisces'],
  [-2139961143,-2139779081,'Aries'],
  [-2139779081,-2139598004,'Taurus'],
  [-2139598004,-2139414989,'Gemini'],
  [-2139414989,-2139228340,'Cancer'],
  [-2139228340,-2139036483,'Leo'],
  [-2139036483,-2138837357,'Virgo'],
  [-2138837357,-2138629209,'Libra'],
  [-2138629209,-2138412938,'Scorpio'],
  [-2138412938,-2138194083,'Sagittarius'],
  [-2138194083,-2137981193,'Capricorn'],
  [-2137981193,-2137780607,'Aquarius'],
  [-2137780607,-2137592938,'Pisces'],
  [-2137592938,-2137414200,'Aries'],
  [-2137414200,-2137238597,'Taurus'],
  [-2137238597,-2137060590,'Gemini'],
  [-2137060590,-2136876093,'Cancer'],
  [-2136876093,-2136682979,'Leo'],
  [-2136682979,-2136480919,'Virgo'],
  [-2136480919,-2136270730,'Libra'],
  [-2136270730,-2136054240,'Scorpio'],
  [-2136054240,-2135835229,'Sagittarius'],
  [-2135835229,-2135619840,'Capricorn'],
  [-2135619840,-2135414663,'Aquarius'],
  [-2135414663,-2135223031,'Pisces'],
  [-2135223031,-2135043430,'Aries'],
  [-2135043430,-2134870741,'Taurus'],
  [-2134870741,-2134698281,'Gemini'],
  [-2134698281,-2134519543,'Cancer'],
  [-2134519543,-2134329838,'Leo'],
  [-2134329838,-2134127877,'Virgo'],
  [-2134127877,-2133916037,'Libra'],
  [-2133916037,-2133698525,'Scorpio'],
  [-2133698525,-2133479591,'Sagittarius'],
  [-2133479591,-2133263390,'Capricorn'],
  [-2133263390,-2133054627,'Aquarius'],
  [-2133054627,-2132857494,'Pisces'],
  [-2132857494,-2132673223,'Aries'],
  [-2132673223,-2132499001,'Taurus'],
  [-2132499001,-2132328817,'Gemini'],
  [-2132328817,-2132155250,'Cancer'],
  [-2132155250,-2131971388,'Leo'],
  [-2131971388,-2131773282,'Virgo'],
  [-2131773282,-2131562256,'Libra'],
  [-2131562256,-2131344136,'Scorpio'],
  [-2131344136,-2131125268,'Sagittarius'],
  [-2131125268,-2130909762,'Capricorn'],
  [-2130909762,-2130700186,'Aquarius'],
  [-2130700186,-2130499240,'Pisces'],
  [-2130499240,-2130309212,'Aries'],
  [-2130309212,-2130129936,'Taurus'],
  [-2130129936,-2129957599,'Gemini'],
  [-2129957599,-2129785552,'Cancer'],
  [-2129785552,-2129606195,'Leo'],
  [-2129606195,-2129413421,'Virgo'],
  [-2129413421,-2129205865,'Libra'],
  [-2129205865,-2128988576,'Scorpio'],
  [-2128988576,-2128769763,'Sagittarius'],
  [-2128769763,-2128555345,'Capricorn'],
  [-2128555345,-2128347365,'Aquarius'],
  [-2128347365,-2128146284,'Pisces'],
  [-2128146284,-2127952993,'Aries'],
  [-2127952993,-2127768266,'Taurus'],
  [-2127768266,-2127590760,'Gemini'],
  [-2127590760,-2127416023,'Cancer'],
  [-2127416023,-2127237439,'Leo'],
  [-2127237439,-2127048325,'Virgo'],
  [-2127048325,-2126845027,'Libra'],
  [-2126845027,-2126630031,'Scorpio'],
  [-2126630031,-2126411414,'Sagittarius'],
  [-2126411414,-2126197336,'Capricorn'],
  [-2126197336,-2125991350,'Aquarius'],
  [-2125991350,-2125792999,'Pisces'],
  [-2125792999,-2125600813,'Aries'],
  [-2125600813,-2125413997,'Taurus'],
  [-2125413997,-2125231826,'Gemini'],
  [-2125231826,-2125052081,'Cancer'],
  [-2125052081,-2124870457,'Leo'],
  [-2124870457,-2124681496,'Virgo'],
  [-2124681496,-2124480868,'Libra'],
  [-2124480868,-2124268516,'Scorpio'],
  [-2124268516,-2124050350,'Sagittarius'],
  [-2124050350,-2123835339,'Capricorn'],
  [-2123835339,-2123629629,'Aquarius'],
  [-2123629629,-2123433985,'Pisces'],
  [-2123433985,-2123245758,'Aries'],
  [-2123245758,-2123061646,'Taurus'],
  [-2123061646,-2122879030,'Gemini'],
  [-2122879030,-2122695827,'Cancer'],
  [-2122695827,-2122509699,'Leo'],
  [-2122509699,-2122317677,'Virgo'],
  [-2122317677,-2122116794,'Libra'],
  [-2122116794,-2121905995,'Scorpio'],
  [-2121905995,-2121688447,'Sagittarius'],
  [-2121688447,-2121471657,'Capricorn'],
  [-2121471657,-2121263585,'Aquarius'],
  [-2121263585,-2121067802,'Pisces'],
  [-2121067802,-2120882670,'Aries'],
  [-2120882670,-2120703605,'Taurus'],
  [-2120703605,-2120525391,'Gemini'],
  [-2120525391,-2120343660,'Cancer'],
  [-2120343660,-2120155611,'Leo'],
  [-2120155611,-2119959977,'Virgo'],
  [-2119959977,-2119756441,'Libra'],
  [-2119756441,-2119545255,'Scorpio'],
  [-2119545255,-2119328159,'Sagittarius'],
  [-2119328159,-2119109896,'Capricorn'],
  [-2119109896,-2118897845,'Aquarius'],
  [-2118897845,-2118698181,'Pisces'],
  [-2118698181,-2118512152,'Aries'],
  [-2118512152,-2118336080,'Taurus'],
  [-2118336080,-2118163549,'Gemini'],
  [-2118163549,-2117987670,'Cancer'],
  [-2117987670,-2117802971,'Leo'],
  [-2117802971,-2117607075,'Virgo'],
  [-2117607075,-2117401129,'Libra'],
  [-2117401129,-2117188101,'Scorpio'],
  [-2117188101,-2116970827,'Sagittarius'],
  [-2116970827,-2116752243,'Capricorn'],
  [-2116752243,-2116537124,'Aquarius'],
  [-2116537124,-2116331804,'Pisces'],
  [-2116331804,-2116140536,'Aries'],
  [-2116140536,-2115962525,'Taurus'],
  [-2115962525,-2115792284,'Gemini'],
  [-2115792284,-2115622034,'Cancer'],
  [-2115622034,-2115444016,'Leo'],
  [-2115444016,-2115252860,'Virgo'],
  [-2115252860,-2115048050,'Libra'],
  [-2115048050,-2114833838,'Scorpio'],
  [-2114833838,-2114615764,'Sagittarius'],
  [-2114615764,-2114397612,'Capricorn'],
  [-2114397612,-2114182093,'Aquarius'],
  [-2114182093,-2113973144,'Pisces'],
  [-2113973144,-2113775467,'Aries'],
  [-2113775467,-2113591273,'Taurus'],
  [-2113591273,-2113417917,'Gemini'],
  [-2113417917,-2113248774,'Cancer'],
  [-2113248774,-2113075662,'Leo'],
  [-2113075662,-2112891169,'Virgo'],
  [-2112891169,-2112691554,'Libra'],
  [-2112691554,-2112479120,'Scorpio'],
  [-2112479120,-2112260707,'Sagittarius'],
  [-2112260707,-2112042793,'Capricorn'],
  [-2112042793,-2111828676,'Aquarius'],
  [-2111828676,-2111620099,'Pisces'],
  [-2111620099,-2111419439,'Aries'],
  [-2111419439,-2111229161,'Taurus'],
  [-2111229161,-2111049300,'Gemini'],
  [-2111049300,-2110876039,'Cancer'],
  [-2110876039,-2110702749,'Leo'],
  [-2110702749,-2110522037,'Virgo'],
  [-2110522037,-2110328214,'Libra'],
  [-2110328214,-2110120259,'Scorpio'],
  [-2110120259,-2109903212,'Sagittarius'],
  [-2109903212,-2109685190,'Capricorn'],
  [-2109685190,-2109472129,'Aquarius'],
  [-2109472129,-2109266082,'Pisces'],
  [-2109266082,-2109067176,'Aries'],
  [-2109067176,-2108875465,'Taurus'],
  [-2108875465,-2108690781,'Gemini'],
  [-2108690781,-2108511434,'Cancer'],
  [-2108511434,-2108333552,'Leo'],
  [-2108333552,-2108151695,'Virgo'],
  [-2108151695,-2107960435,'Libra'],
  [-2107960435,-2107756725,'Scorpio'],
  [-2107756725,-2107542399,'Sagittarius'],
  [-2107542399,-2107324439,'Capricorn'],
  [-2107324439,-2107110946,'Aquarius'],
  [-2107110946,-2106906435,'Pisces'],
  [-2106906435,-2106711060,'Aries'],
  [-2106711060,-2106522609,'Taurus'],
  [-2106522609,-2106338417,'Gemini'],
  [-2106338417,-2106156067,'Cancer'],
  [-2106156067,-2105973173,'Leo'],
  [-2105973173,-2105786937,'Virgo'],
  [-2105786937,-2105594098,'Libra'],
  [-2105594098,-2105391845,'Scorpio'],
  [-2105391845,-2105179846,'Sagittarius'],
  [-2105179846,-2104962292,'Capricorn'],
  [-2104962292,-2104747164,'Aquarius'],
  [-2104747164,-2104541588,'Pisces'],
  [-2104541588,-2104347875,'Aries'],
  [-2104347875,-2104163588,'Taurus'],
  [-2104163588,-2103983892,'Gemini'],
  [-2103983892,-2103803864,'Cancer'],
  [-2103803864,-2103619894,'Leo'],
  [-2103619894,-2103430085,'Virgo'],
  [-2103430085,-2103233639,'Libra'],
  [-2103233639,-2103029879,'Scorpio'],
  [-2103029879,-2102818468,'Sagittarius'],
  [-2102818468,-2102601320,'Capricorn'],
  [-2102601320,-2102384320,'Aquarius'],
  [-2102384320,-2102175505,'Pisces'],
  [-2102175505,-2101980003,'Aries'],
  [-2101980003,-2101797169,'Taurus'],
  [-2101797169,-2101621817,'Gemini'],
  [-2101621817,-2101447093,'Cancer'],
  [-2101447093,-2101266901,'Leo'],
  [-2101266901,-2101077691,'Virgo'],
  [-2101077691,-2100879135,'Libra'],
  [-2100879135,-2100672832,'Scorpio'],
  [-2100672832,-2100460354,'Sagittarius'],
  [-2100460354,-2100243240,'Capricorn'],
  [-2100243240,-2100025075,'Aquarius'],
  [-2100025075,-2099812600,'Pisces'],
  [-2099812600,-2099612610,'Aries'],
  [-2099612610,-2099427258,'Taurus'],
  [-2099427258,-2099252858,'Gemini'],
  [-2099252858,-2099082274,'Cancer'],
  [-2099082274,-2098907768,'Leo'],
  [-2098907768,-2098723284,'Virgo'],
  [-2098723284,-2098526523,'Libra'],
  [-2098526523,-2098319324,'Scorpio'],
  [-2098319324,-2098105408,'Sagittarius'],
  [-2098105408,-2097887916,'Capricorn'],
  [-2097887916,-2097669634,'Aquarius'],
  [-2097669634,-2097455058,'Pisces'],
  [-2097455058,-2097250328,'Aries'],
  [-2097250328,-2097059642,'Taurus'],
  [-2097059642,-2096881993,'Gemini'],
  [-2096881993,-2096711660,'Cancer'],
  [-2096711660,-2096540846,'Leo'],
  [-2096540846,-2096362050,'Virgo'],
  [-2096362050,-2096170372,'Libra'],
  [-2096170372,-2095965516,'Scorpio'],
  [-2095965516,-2095751465,'Sagittarius'],
  [-2095751465,-2095533537,'Capricorn'],
  [-2095533537,-2095315775,'Aquarius'],
  [-2095315775,-2095101449,'Pisces'],
  [-2095101449,-2094894481,'Aries'],
  [-2094894481,-2094698717,'Taurus'],
  [-2094698717,-2094515258,'Gemini'],
  [-2094515258,-2094340982,'Cancer'],
  [-2094340982,-2094169655,'Leo'],
  [-2094169655,-2093993977,'Virgo'],
  [-2093993977,-2093807612,'Libra'],
  [-2093807612,-2093607505,'Scorpio'],
  [-2093607505,-2093395551,'Sagittarius'],
  [-2093395551,-2093177711,'Capricorn'],
  [-2093177711,-2092960369,'Aquarius'],
  [-2092960369,-2092747664,'Pisces'],
  [-2092747664,-2092541872,'Aries'],
  [-2092541872,-2092344533,'Taurus'],
  [-2092344533,-2092156381,'Gemini'],
  [-2092156381,-2091976219,'Cancer'],
  [-2091976219,-2091800419,'Leo'],
  [-2091800419,-2091623543,'Virgo'],
  [-2091623543,-2091439627,'Libra'],
  [-2091439627,-2091244015,'Scorpio'],
  [-2091244015,-2091035691,'Sagittarius'],
  [-2091035691,-2090818883,'Capricorn'],
  [-2090818883,-2090601354,'Aquarius'],
  [-2090601354,-2090389734,'Pisces'],
  [-2090389734,-2090186757,'Aries'],
  [-2090186757,-2089991954,'Taurus'],
  [-2089991954,-2089803606,'Gemini'],
  [-2089803606,-2089619842,'Cancer'],
  [-2089619842,-2089438588,'Leo'],
  [-2089438588,-2089257055,'Virgo'],
  [-2089257055,-2089071443,'Libra'],
  [-2089071443,-2088877506,'Scorpio'],
  [-2088877506,-2088672376,'Sagittarius'],
  [-2088672376,-2088457326,'Capricorn'],
  [-2088457326,-2088239117,'Aquarius'],
  [-2088239117,-2088026609,'Pisces'],
  [-2088026609,-2087825048,'Aries'],
  [-2087825048,-2087634070,'Taurus'],
  [-2087634070,-2087449803,'Gemini'],
  [-2087449803,-2087267757,'Cancer'],
  [-2087267757,-2087084633,'Leo'],
  [-2087084633,-2086898679,'Virgo'],
  [-2086898679,-2086708713,'Libra'],
  [-2086708713,-2086512846,'Scorpio'],
  [-2086512846,-2086308584,'Sagittarius'],
  [-2086308584,-2086095083,'Capricorn'],
  [-2086095083,-2085876311,'Aquarius'],
  [-2085876311,-2085661095,'Pisces'],
  [-2085661095,-2085457587,'Aries'],
  [-2085457587,-2085267831,'Taurus'],
  [-2085267831,-2085087905,'Gemini'],
  [-2085087905,-2084911307,'Cancer'],
  [-2084911307,-2084731990,'Leo'],
  [-2084731990,-2084546307,'Virgo'],
  [-2084546307,-2084353472,'Libra'],
  [-2084353472,-2084154044,'Scorpio'],
  [-2084154044,-2083947980,'Sagittarius'],
  [-2083947980,-2083734727,'Capricorn'],
  [-2083734727,-2083515903,'Aquarius'],
  [-2083515903,-2083297913,'Pisces'],
  [-2083297913,-2083089783,'Aries'],
  [-2083089783,-2082896807,'Taurus'],
  [-2082896807,-2082717325,'Gemini'],
  [-2082717325,-2082544904,'Cancer'],
  [-2082544904,-2082371849,'Leo'],
  [-2082371849,-2082191723,'Virgo'],
  [-2082191723,-2082001225,'Libra'],
  [-2082001225,-2081800649,'Scorpio'],
  [-2081800649,-2081592148,'Sagittarius'],
  [-2081592148,-2081377658,'Capricorn'],
  [-2081377658,-2081158918,'Aquarius'],
  [-2081158918,-2080939829,'Pisces'],
  [-2080939829,-2080727440,'Aries'],
  [-2080727440,-2080528459,'Taurus'],
  [-2080528459,-2080344501,'Gemini'],
  [-2080344501,-2080171352,'Cancer'],
  [-2080171352,-2080001715,'Leo'],
  [-2080001715,-2079827922,'Virgo'],
  [-2079827922,-2079643920,'Libra'],
  [-2079643920,-2079447070,'Scorpio'],
  [-2079447070,-2079238769,'Sagittarius'],
  [-2079238769,-2079023011,'Capricorn'],
  [-2079023011,-2078803972,'Aquarius'],
  [-2078803972,-2078585399,'Pisces'],
  [-2078585399,-2078371766,'Aries'],
  [-2078371766,-2078168124,'Taurus'],
  [-2078168124,-2077977585,'Gemini'],
  [-2077977585,-2077799024,'Cancer'],
  [-2077799024,-2077627469,'Leo'],
  [-2077627469,-2077456039,'Virgo'],
  [-2077456039,-2077277761,'Libra'],
  [-2077277761,-2077087310,'Scorpio'],
  [-2077087310,-2076883005,'Sagittarius'],
  [-2076883005,-2076667994,'Capricorn'],
  [-2076667994,-2076448614,'Aquarius'],
  [-2076448614,-2076230840,'Pisces'],
  [-2076230840,-2076018642,'Aries'],
  [-2076018642,-2075814473,'Taurus'],
  [-2075814473,-2075619914,'Gemini'],
  [-2075619914,-2075435060,'Cancer'],
  [-2075435060,-2075257741,'Leo'],
  [-2075257741,-2075083545,'Virgo'],
  [-2075083545,-2074906580,'Libra'],
  [-2074906580,-2074720759,'Scorpio'],
  [-2074720759,-2074521787,'Sagittarius'],
  [-2074521787,-2074309865,'Capricorn'],
  [-2074309865,-2074090927,'Aquarius'],
  [-2074090927,-2073873345,'Pisces'],
  [-2073873345,-2073662953,'Aries'],
  [-2073662953,-2073461325,'Taurus'],
  [-2073461325,-2073267494,'Gemini'],
  [-2073267494,-2073079987,'Cancer'],
  [-2073079987,-2072897380,'Leo'],
  [-2072897380,-2072717711,'Virgo'],
  [-2072717711,-2072537612,'Libra'],
  [-2072537612,-2072352230,'Scorpio'],
  [-2072352230,-2072156553,'Sagittarius'],
  [-2072156553,-2071948200,'Capricorn'],
  [-2071948200,-2071730603,'Aquarius'],
  [-2071730603,-2071512568,'Pisces'],
  [-2071512568,-2071302503,'Aries'],
  [-2071302503,-2071103389,'Taurus'],
  [-2071103389,-2070913122,'Gemini'],
  [-2070913122,-2070727795,'Cancer'],
  [-2070727795,-2070544238,'Leo'],
  [-2070544238,-2070360714,'Virgo'],
  [-2070360714,-2070175921,'Libra'],
  [-2070175921,-2069987471,'Scorpio'],
  [-2069987471,-2069791631,'Sagittarius'],
  [-2069791631,-2069585213,'Capricorn'],
  [-2069585213,-2069369075,'Aquarius'],
  [-2069369075,-2069150287,'Pisces'],
  [-2069150287,-2068938616,'Aries'],
  [-2068938616,-2068739631,'Taurus'],
  [-2068739631,-2068552203,'Gemini'],
  [-2068552203,-2068371248,'Cancer'],
  [-2068371248,-2068191269,'Leo'],
  [-2068191269,-2068008523,'Virgo'],
  [-2068008523,-2067821436,'Libra'],
  [-2067821436,-2067629324,'Scorpio'],
  [-2067629324,-2067430829,'Sagittarius'],
  [-2067430829,-2067223974,'Capricorn'],
  [-2067223974,-2067008535,'Aquarius'],
  [-2067008535,-2066789109,'Pisces'],
  [-2066789109,-2066574672,'Aries'],
  [-2066574672,-2066372902,'Taurus'],
  [-2066372902,-2066185130,'Gemini'],
  [-2066185130,-2066007000,'Cancer'],
  [-2066007000,-2065831943,'Leo'],
  [-2065831943,-2065653949,'Virgo'],
  [-2065653949,-2065469166,'Libra'],
  [-2065469166,-2065276210,'Scorpio'],
  [-2065276210,-2065075152,'Sagittarius'],
  [-2065075152,-2064866343,'Capricorn'],
  [-2064866343,-2064650531,'Aquarius'],
  [-2064650531,-2064430839,'Pisces'],
  [-2064430839,-2064214002,'Aries'],
  [-2064214002,-2064007808,'Taurus'],
  [-2064007808,-2063816151,'Gemini'],
  [-2063816151,-2063637005,'Cancer'],
  [-2063637005,-2063464501,'Leo'],
  [-2063464501,-2063291699,'Virgo'],
  [-2063291699,-2063112490,'Libra'],
  [-2063112490,-2062922972,'Scorpio'],
  [-2062922972,-2062722196,'Sagittarius'],
  [-2062722196,-2062511861,'Capricorn'],
  [-2062511861,-2062295029,'Aquarius'],
  [-2062295029,-2062075379,'Pisces'],
  [-2062075379,-2061857772,'Aries'],
  [-2061857772,-2061648034,'Taurus'],
  [-2061648034,-2061450808,'Gemini'],
  [-2061450808,-2061266811,'Cancer'],
  [-2061266811,-2061092508,'Leo'],
  [-2061092508,-2060921780,'Virgo'],
  [-2060921780,-2060747707,'Libra'],
  [-2060747707,-2060564107,'Scorpio'],
  [-2060564107,-2060367312,'Sagittarius'],
  [-2060367312,-2060157868,'Capricorn'],
  [-2060157868,-2059940381,'Aquarius'],
  [-2059940381,-2059720795,'Pisces'],
  [-2059720795,-2059504023,'Aries'],
  [-2059504023,-2059293665,'Taurus'],
  [-2059293665,-2059092603,'Gemini'],
  [-2059092603,-2058902519,'Cancer'],
  [-2058902519,-2058722640,'Leo'],
  [-2058722640,-2058549310,'Virgo'],
  [-2058549310,-2058376622,'Libra'],
  [-2058376622,-2058197702,'Scorpio'],
  [-2058197702,-2058006556,'Sagittarius'],
  [-2058006556,-2057800848,'Capricorn'],
  [-2057800848,-2057584204,'Aquarius'],
  [-2057584204,-2057364546,'Pisces'],
  [-2057364546,-2057148937,'Aries'],
  [-2057148937,-2056940549,'Taurus'],
  [-2056940549,-2056739781,'Gemini'],
  [-2056739781,-2056546545,'Cancer'],
  [-2056546545,-2056360822,'Leo'],
  [-2056360822,-2056181597,'Virgo'],
  [-2056181597,-2056005585,'Libra'],
  [-2056005585,-2055827178,'Scorpio'],
  [-2055827178,-2055639837,'Sagittarius'],
  [-2055639837,-2055438796,'Capricorn'],
  [-2055438796,-2055224742,'Aquarius'],
  [-2055224742,-2055005168,'Pisces'],
  [-2055005168,-2054789631,'Aries'],
  [-2054789631,-2054583289,'Taurus'],
  [-2054583289,-2054385785,'Gemini'],
  [-2054385785,-2054194440,'Cancer'],
  [-2054194440,-2054007180,'Leo'],
  [-2054007180,-2053823200,'Virgo'],
  [-2053823200,-2053641544,'Libra'],
  [-2053641544,-2053459339,'Scorpio'],
  [-2053459339,-2053271630,'Sagittarius'],
  [-2053271630,-2053073222,'Capricorn'],
  [-2053073222,-2052862183,'Aquarius'],
  [-2052862183,-2052643260,'Pisces'],
  [-2052643260,-2052426421,'Aries'],
  [-2052426421,-2052219756,'Taurus'],
  [-2052219756,-2052024716,'Gemini'],
  [-2052024716,-2051837786,'Cancer'],
  [-2051837786,-2051654322,'Leo'],
  [-2051654322,-2051471044,'Virgo'],
  [-2051471044,-2051286465,'Libra'],
  [-2051286465,-2051099514,'Scorpio'],
  [-2051099514,-2050908005,'Sagittarius'],
  [-2050908005,-2050708629,'Capricorn'],
  [-2050708629,-2050499004,'Aquarius'],
  [-2050499004,-2050281071,'Pisces'],
  [-2050281071,-2050062561,'Aries'],
  [-2050062561,-2049852881,'Taurus'],
  [-2049852881,-2049656646,'Gemini'],
  [-2049656646,-2049472020,'Cancer'],
  [-2049472020,-2049293660,'Leo'],
  [-2049293660,-2049115844,'Virgo'],
  [-2049115844,-2048934271,'Libra'],
  [-2048934271,-2048746574,'Scorpio'],
  [-2048746574,-2048551730,'Sagittarius'],
  [-2048551730,-2048349144,'Capricorn'],
  [-2048349144,-2048138472,'Aquarius'],
  [-2048138472,-2047921000,'Pisces'],
  [-2047921000,-2047701600,'Aries'],
  [-2047701600,-2047488154,'Taurus'],
  [-2047488154,-2047287297,'Gemini'],
  [-2047287297,-2047100375,'Cancer'],
  [-2047100375,-2046923685,'Leo'],
  [-2046923685,-2046751022,'Virgo'],
  [-2046751022,-2046575880,'Libra'],
  [-2046575880,-2046392946,'Scorpio'],
  [-2046392946,-2046199286,'Sagittarius'],
  [-2046199286,-2045994912,'Capricorn'],
  [-2045994912,-2045782099,'Aquarius'],
  [-2045782099,-2045564051,'Pisces'],
  [-2045564051,-2045344670,'Aries'],
  [-2045344670,-2045129099,'Taurus'],
  [-2045129099,-2044923143,'Gemini'],
  [-2044923143,-2044730479,'Cancer'],
  [-2044730479,-2044550485,'Leo'],
  [-2044550485,-2044378601,'Virgo'],
  [-2044378601,-2044208062,'Libra'],
  [-2044208062,-2044031675,'Scorpio'],
  [-2044031675,-2043843601,'Sagittarius'],
  [-2043843601,-2043641573,'Capricorn'],
  [-2043641573,-2043428214,'Aquarius'],
  [-2043428214,-2043209249,'Pisces'],
  [-2043209249,-2042990139,'Aries'],
  [-2042990139,-2042774733,'Taurus'],
  [-2042774733,-2042566332,'Gemini'],
  [-2042566332,-2042368213,'Cancer'],
  [-2042368213,-2042182026,'Leo'],
  [-2042182026,-2042006132,'Virgo'],
  [-2042006132,-2041835426,'Libra'],
  [-2041835426,-2041662713,'Scorpio'],
  [-2041662713,-2041480591,'Sagittarius'],
  [-2041480591,-2041283961,'Capricorn'],
  [-2041283961,-2041073108,'Aquarius'],
  [-2041073108,-2040854245,'Pisces'],
  [-2040854245,-2040635268,'Aries'],
  [-2040635268,-2040421126,'Taurus'],
  [-2040421126,-2040213556,'Gemini'],
  [-2040213556,-2040013550,'Cancer'],
  [-2040013550,-2039822411,'Leo'],
  [-2039822411,-2039640502,'Virgo'],
  [-2039640502,-2039465426,'Libra'],
  [-2039465426,-2039291715,'Scorpio'],
  [-2039291715,-2039112239,'Sagittarius'],
  [-2039112239,-2038920502,'Capricorn'],
  [-2038920502,-2038713973,'Aquarius'],
  [-2038713973,-2038496833,'Pisces'],
  [-2038496833,-2038277967,'Aries'],
  [-2038277967,-2038064689,'Taurus'],
  [-2038064689,-2037859366,'Gemini'],
  [-2037859366,-2037661237,'Cancer'],
  [-2037661237,-2037469385,'Leo'],
  [-2037469385,-2037283621,'Virgo'],
  [-2037283621,-2037103169,'Libra'],
  [-2037103169,-2036925056,'Scorpio'],
  [-2036925056,-2036744012,'Sagittarius'],
  [-2036744012,-2036553999,'Capricorn'],
  [-2036553999,-2036351007,'Aquarius'],
  [-2036351007,-2036136434,'Pisces'],
  [-2036136434,-2035917835,'Aries'],
  [-2035917835,-2035704207,'Taurus'],
  [-2035704207,-2035500162,'Gemini'],
  [-2035500162,-2035305158,'Cancer'],
  [-2035305158,-2035116415,'Leo'],
  [-2035116415,-2034931437,'Virgo'],
  [-2034931437,-2034748570,'Libra'],
  [-2034748570,-2034566029,'Scorpio'],
  [-2034566029,-2034380869,'Sagittarius'],
  [-2034380869,-2034189068,'Capricorn'],
  [-2034189068,-2033987055,'Aquarius'],
  [-2033987055,-2033774460,'Pisces'],
  [-2033774460,-2033556256,'Aries'],
  [-2033556256,-2033341119,'Taurus'],
  [-2033341119,-2033135995,'Gemini'],
  [-2033135995,-2032942394,'Cancer'],
  [-2032942394,-2032757473,'Leo'],
  [-2032757473,-2032576811,'Virgo'],
  [-2032576811,-2032396321,'Libra'],
  [-2032396321,-2032212952,'Scorpio'],
  [-2032212952,-2032024505,'Sagittarius'],
  [-2032024505,-2031829193,'Capricorn'],
  [-2031829193,-2031625554,'Aquarius'],
  [-2031625554,-2031413374,'Pisces'],
  [-2031413374,-2031195507,'Aries'],
  [-2031195507,-2030978512,'Taurus'],
  [-2030978512,-2030770097,'Gemini'],
  [-2030770097,-2030574545,'Cancer'],
  [-2030574545,-2030390873,'Leo'],
  [-2030390873,-2030214452,'Virgo'],
  [-2030214452,-2030039285,'Libra'],
  [-2030039285,-2029859777,'Scorpio'],
  [-2029859777,-2029672044,'Sagittarius'],
  [-2029672044,-2029474668,'Capricorn'],
  [-2029474668,-2029268419,'Aquarius'],
  [-2029268419,-2029055122,'Pisces'],
  [-2029055122,-2028837321,'Aries'],
  [-2028837321,-2028619202,'Taurus'],
  [-2028619202,-2028406985,'Gemini'],
  [-2028406985,-2028206586,'Cancer'],
  [-2028206586,-2028020009,'Leo'],
  [-2028020009,-2027844371,'Virgo'],
  [-2027844371,-2027673459,'Libra'],
  [-2027673459,-2027499915,'Scorpio'],
  [-2027499915,-2027317222,'Sagittarius'],
  [-2027317222,-2027121845,'Capricorn'],
  [-2027121845,-2026914683,'Aquarius'],
  [-2026914683,-2026699848,'Pisces'],
  [-2026699848,-2026481716,'Aries'],
  [-2026481716,-2026263678,'Taurus'],
  [-2026263678,-2026049456,'Gemini'],
  [-2026049456,-2025844019,'Cancer'],
  [-2025844019,-2025651446,'Leo'],
  [-2025651446,-2025471913,'Virgo'],
  [-2025471913,-2025300952,'Libra'],
  [-2025300952,-2025131187,'Scorpio'],
  [-2025131187,-2024954591,'Sagittarius'],
  [-2024954591,-2024764880,'Capricorn'],
  [-2024764880,-2024560469,'Aquarius'],
  [-2024560469,-2024345551,'Pisces'],
  [-2024345551,-2024126906,'Aries'],
  [-2024126906,-2023909540,'Taurus'],
  [-2023909540,-2023695978,'Gemini'],
  [-2023695978,-2023488620,'Cancer'],
  [-2023488620,-2023290769,'Leo'],
  [-2023290769,-2023104674,'Virgo'],
  [-2023104674,-2022928894,'Libra'],
  [-2022928894,-2022757967,'Scorpio'],
  [-2022757967,-2022584244,'Sagittarius'],
  [-2022584244,-2022400171,'Capricorn'],
  [-2022400171,-2022201236,'Aquarius'],
  [-2022201236,-2021988966,'Pisces'],
  [-2021988966,-2021770450,'Aries'],
  [-2021770450,-2021553333,'Taurus'],
  [-2021553333,-2021341555,'Gemini'],
  [-2021341555,-2021136041,'Cancer'],
  [-2021136041,-2020937416,'Leo'],
  [-2020937416,-2020746901,'Virgo'],
  [-2020746901,-2020564745,'Libra'],
  [-2020564745,-2020388383,'Scorpio'],
  [-2020388383,-2020212412,'Sagittarius'],
  [-2020212412,-2020030110,'Capricorn'],
  [-2020030110,-2019835777,'Aquarius'],
  [-2019835777,-2019627821,'Pisces'],
  [-2019627821,-2019410817,'Aries'],
  [-2019410817,-2019193307,'Taurus'],
  [-2019193307,-2018982119,'Gemini'],
  [-2018982119,-2018779390,'Cancer'],
  [-2018779390,-2018584129,'Leo'],
  [-2018584129,-2018394735,'Virgo'],
  [-2018394735,-2018209952,'Libra'],
  [-2018209952,-2018028244,'Scorpio'],
  [-2018028244,-2017846847,'Sagittarius'],
  [-2017846847,-2017661629,'Capricorn'],
  [-2017661629,-2017468049,'Aquarius'],
  [-2017468049,-2017263223,'Pisces'],
  [-2017263223,-2017048535,'Aries'],
  [-2017048535,-2016830595,'Taurus'],
  [-2016830595,-2016617927,'Gemini'],
  [-2016617927,-2016415665,'Cancer'],
  [-2016415665,-2016223820,'Leo'],
  [-2016223820,-2016039152,'Virgo'],
  [-2016039152,-2015857556,'Libra'],
  [-2015857556,-2015675508,'Scorpio'],
  [-2015675508,-2015490478,'Sagittarius'],
  [-2015490478,-2015300593,'Capricorn'],
  [-2015300593,-2015104077,'Aquarius'],
  [-2015104077,-2014899284,'Pisces'],
  [-2014899284,-2014686114,'Aries'],
  [-2014686114,-2014468147,'Taurus'],
  [-2014468147,-2014252884,'Gemini'],
  [-2014252884,-2014047855,'Cancer'],
  [-2014047855,-2013855981,'Leo'],
  [-2013855981,-2013674815,'Virgo'],
  [-2013674815,-2013498744,'Libra'],
  [-2013498744,-2013321562,'Scorpio'],
  [-2013321562,-2013138381,'Sagittarius'],
  [-2013138381,-2012946818,'Capricorn'],
  [-2012946818,-2012746933,'Aquarius'],
  [-2012746933,-2012539785,'Pisces'],
  [-2012539785,-2012326350,'Aries'],
  [-2012326350,-2012108525,'Taurus'],
  [-2012108525,-2011891176,'Gemini'],
  [-2011891176,-2011681762,'Cancer'],
  [-2011681762,-2011485986,'Leo'],
  [-2011485986,-2011304069,'Virgo'],
  [-2011304069,-2011131049,'Libra'],
  [-2011131049,-2010959517,'Scorpio'],
  [-2010959517,-2010782195,'Sagittarius'],
  [-2010782195,-2010594087,'Capricorn'],
  [-2010594087,-2010394199,'Aquarius'],
  [-2010394199,-2010185095,'Pisces'],
  [-2010185095,-2009970246,'Aries'],
  [-2009970246,-2009752298,'Taurus'],
  [-2009752298,-2009534262,'Gemini'],
  [-2009534262,-2009321469,'Cancer'],
  [-2009321469,-2009120229,'Leo'],
  [-2009120229,-2008933595,'Virgo'],
  [-2008933595,-2008759002,'Libra'],
  [-2008759002,-2008589727,'Scorpio'],
  [-2008589727,-2008417675,'Sagittarius'],
  [-2008417675,-2008235703,'Capricorn'],
  [-2008235703,-2008040041,'Aquarius'],
  [-2008040041,-2007831949,'Pisces'],
  [-2007831949,-2007616287,'Aries'],
  [-2007616287,-2007397976,'Taurus'],
  [-2007397976,-2007180355,'Gemini'],
  [-2007180355,-2006966758,'Cancer'],
  [-2006966758,-2006761761,'Leo'],
  [-2006761761,-2006569306,'Virgo'],
  [-2006569306,-2006389508,'Libra'],
  [-2006389508,-2006217881,'Scorpio'],
  [-2006217881,-2006047217,'Sagittarius'],
  [-2006047217,-2005869867,'Capricorn'],
  [-2005869867,-2005679982,'Aquarius'],
  [-2005679982,-2005475978,'Pisces'],
  [-2005475978,-2005261512,'Aries'],
  [-2005261512,-2005043096,'Taurus'],
  [-2005043096,-2004826137,'Gemini'],
  [-2004826137,-2004613834,'Cancer'],
  [-2004613834,-2004408609,'Leo'],
  [-2004408609,-2004212819,'Virgo'],
  [-2004212819,-2004027435,'Libra'],
  [-2004027435,-2003850422,'Scorpio'],
  [-2003850422,-2003676814,'Sagittarius'],
  [-2003676814,-2003500110,'Capricorn'],
  [-2003500110,-2003314062,'Aquarius'],
  [-2003314062,-2003114892,'Pisces'],
  [-2003114892,-2002903492,'Aries'],
  [-2002903492,-2002685700,'Taurus'],
  [-2002685700,-2002468956,'Gemini'],
  [-2002468956,-2002258264,'Cancer'],
  [-2002258264,-2002055444,'Leo'],
  [-2002055444,-2001860517,'Virgo'],
  [-2001860517,-2001672834,'Libra'],
  [-2001672834,-2001490952,'Scorpio'],
  [-2001490952,-2001312110,'Sagittarius'],
  [-2001312110,-2001132168,'Capricorn'],
  [-2001132168,-2000946217,'Aquarius'],
  [-2000946217,-2000749963,'Pisces'],
  [-2000749963,-2000541903,'Aries'],
  [-2000541903,-2000325426,'Taurus'],
  [-2000325426,-2000108221,'Gemini'],
  [-2000108221,-1999897768,'Cancer'],
  [-1999897768,-1999697354,'Leo'],
  [-1999697354,-1999505988,'Virgo'],
  [-1999505988,-1999320576,'Libra'],
  [-1999320576,-1999137877,'Scorpio'],
  [-1999137877,-1998955290,'Sagittarius'],
  [-1998955290,-1998770639,'Capricorn'],
  [-1998770639,-1998581502,'Aquarius'],
  [-1998581502,-1998384974,'Pisces'],
  [-1998384974,-1998178767,'Aries'],
  [-1998178767,-1997963694,'Taurus'],
  [-1997963694,-1997745627,'Gemini'],
  [-1997745627,-1997533363,'Cancer'],
  [-1997533363,-1997332926,'Leo'],
  [-1997332926,-1997144440,'Virgo'],
  [-1997144440,-1996963600,'Libra'],
  [-1996963600,-1996784715,'Scorpio'],
  [-1996784715,-1996603073,'Sagittarius'],
  [-1996603073,-1996416124,'Capricorn'],
  [-1996416124,-1996223169,'Aquarius'],
  [-1996223169,-1996023841,'Pisces'],
  [-1996023841,-1995817173,'Aries'],
  [-1995817173,-1995602853,'Taurus'],
  [-1995602853,-1995384107,'Gemini'],
  [-1995384107,-1995168763,'Cancer'],
  [-1995168763,-1994965065,'Leo'],
  [-1994965065,-1994775940,'Virgo'],
  [-1994775940,-1994597971,'Libra'],
  [-1994597971,-1994424338,'Scorpio'],
  [-1994424338,-1994247958,'Sagittarius'],
  [-1994247958,-1994063769,'Capricorn'],
  [-1994063769,-1993870127,'Aquarius'],
  [-1993870127,-1993668124,'Pisces'],
  [-1993668124,-1993459340,'Aries'],
  [-1993459340,-1993244654,'Taurus'],
  [-1993244654,-1993025792,'Gemini'],
  [-1993025792,-1992808013,'Cancer'],
  [-1992808013,-1992599382,'Leo'],
  [-1992599382,-1992405589,'Virgo'],
  [-1992405589,-1992225983,'Libra'],
  [-1992225983,-1992054655,'Scorpio'],
  [-1992054655,-1991883708,'Sagittarius'],
  [-1991883708,-1991705833,'Capricorn'],
  [-1991705833,-1991516474,'Aquarius'],
  [-1991516474,-1991315244,'Pisces'],
  [-1991315244,-1991104951,'Aries'],
  [-1991104951,-1990889072,'Taurus'],
  [-1990889072,-1990670349,'Gemini'],
  [-1990670349,-1990452191,'Cancer'],
  [-1990452191,-1990240212,'Leo'],
  [-1990240212,-1990040371,'Virgo'],
  [-1990040371,-1989854920,'Libra'],
  [-1989854920,-1989680719,'Scorpio'],
  [-1989680719,-1989511065,'Sagittarius'],
  [-1989511065,-1989338236,'Capricorn'],
  [-1989338236,-1989155537,'Aquarius'],
  [-1989155537,-1988959377,'Pisces'],
  [-1988959377,-1988750707,'Aries'],
  [-1988750707,-1988534212,'Taurus'],
  [-1988534212,-1988315343,'Gemini'],
  [-1988315343,-1988098271,'Cancer'],
  [-1988098271,-1987886486,'Leo'],
  [-1987886486,-1987683522,'Virgo'],
  [-1987683522,-1987491898,'Libra'],
  [-1987491898,-1987311184,'Scorpio'],
  [-1987311184,-1987137530,'Sagittarius'],
  [-1987137530,-1986964826,'Capricorn'],
  [-1986964826,-1986786298,'Aquarius'],
  [-1986786298,-1986596259,'Pisces'],
  [-1986596259,-1986392338,'Aries'],
  [-1986392338,-1986177344,'Taurus'],
  [-1986177344,-1985958255,'Gemini'],
  [-1985958255,-1985741995,'Cancer'],
  [-1985741995,-1985532501,'Leo'],
  [-1985532501,-1985330992,'Virgo'],
  [-1985330992,-1985137522,'Libra'],
  [-1985137522,-1984951555,'Scorpio'],
  [-1984951555,-1984771501,'Sagittarius'],
  [-1984771501,-1984594168,'Capricorn'],
  [-1984594168,-1984414752,'Aquarius'],
  [-1984414752,-1984227693,'Pisces'],
  [-1984227693,-1984028537,'Aries'],
  [-1984028537,-1983816836,'Taurus'],
  [-1983816836,-1983598173,'Gemini'],
  [-1983598173,-1983381536,'Cancer'],
  [-1983381536,-1983173492,'Leo'],
  [-1983173492,-1982975363,'Virgo'],
  [-1982975363,-1982784870,'Libra'],
  [-1982784870,-1982598970,'Scorpio'],
  [-1982598970,-1982415396,'Sagittarius'],
  [-1982415396,-1982232606,'Capricorn'],
  [-1982232606,-1982048612,'Aquarius'],
  [-1982048612,-1981860014,'Pisces'],
  [-1981860014,-1981662587,'Aries'],
  [-1981662587,-1981453786,'Taurus'],
  [-1981453786,-1981236223,'Gemini'],
  [-1981236223,-1981018377,'Cancer'],
  [-1981018377,-1980809370,'Leo'],
  [-1980809370,-1980612860,'Virgo'],
  [-1980612860,-1980426420,'Libra'],
  [-1980426420,-1980244853,'Scorpio'],
  [-1980244853,-1980063354,'Sagittarius'],
  [-1980063354,-1979879120,'Capricorn'],
  [-1979879120,-1979691161,'Aquarius'],
  [-1979691161,-1979498622,'Pisces'],
  [-1979498622,-1979299475,'Aries'],
  [-1979299475,-1979091375,'Taurus'],
  [-1979091375,-1978874763,'Gemini'],
  [-1978874763,-1978655691,'Cancer'],
  [-1978655691,-1978443776,'Leo'],
  [-1978443776,-1978245496,'Virgo'],
  [-1978245496,-1978060394,'Libra'],
  [-1978060394,-1977883072,'Scorpio'],
  [-1977883072,-1977706854,'Sagittarius'],
  [-1977706854,-1977526373,'Capricorn'],
  [-1977526373,-1977338892,'Aquarius'],
  [-1977338892,-1977143989,'Pisces'],
  [-1977143989,-1976941887,'Aries'],
  [-1976941887,-1976732360,'Taurus'],
  [-1976732360,-1976515816,'Gemini'],
  [-1976515816,-1976296053,'Cancer'],
  [-1976296053,-1976080970,'Leo'],
  [-1976080970,-1975878373,'Virgo'],
  [-1975878373,-1975690645,'Libra'],
  [-1975690645,-1975514088,'Scorpio'],
  [-1975514088,-1975341942,'Sagittarius'],
  [-1975341942,-1975167229,'Capricorn'],
  [-1975167229,-1974984626,'Aquarius'],
  [-1974984626,-1974791624,'Pisces'],
  [-1974791624,-1974588498,'Aries'],
  [-1974588498,-1974377121,'Taurus'],
  [-1974377121,-1974159821,'Gemini'],
  [-1974159821,-1973939948,'Cancer'],
  [-1973939948,-1973723110,'Leo'],
  [-1973723110,-1973516068,'Virgo'],
  [-1973516068,-1973323041,'Libra'],
  [-1973323041,-1973143070,'Scorpio'],
  [-1973143070,-1972971016,'Sagittarius'],
  [-1972971016,-1972799982,'Capricorn'],
  [-1972799982,-1972623201,'Aquarius'],
  [-1972623201,-1972435556,'Pisces'],
  [-1972435556,-1972235054,'Aries'],
  [-1972235054,-1972023525,'Taurus'],
  [-1972023525,-1971805442,'Gemini'],
  [-1971805442,-1971585736,'Cancer'],
  [-1971585736,-1971369078,'Leo'],
  [-1971369078,-1971159931,'Virgo'],
  [-1971159931,-1970961934,'Libra'],
  [-1970961934,-1970776122,'Scorpio'],
  [-1970776122,-1970600020,'Sagittarius'],
  [-1970600020,-1970428428,'Capricorn'],
  [-1970428428,-1970254791,'Aquarius'],
  [-1970254791,-1970072609,'Pisces'],
  [-1970072609,-1969877250,'Aries'],
  [-1969877250,-1969668264,'Taurus'],
  [-1969668264,-1969450383,'Gemini'],
  [-1969450383,-1969230827,'Cancer'],
  [-1969230827,-1969015414,'Leo'],
  [-1969015414,-1968807186,'Virgo'],
  [-1968807186,-1968607485,'Libra'],
  [-1968607485,-1968416911,'Scorpio'],
  [-1968416911,-1968234876,'Sagittarius'],
  [-1968234876,-1968058825,'Capricorn'],
  [-1968058825,-1967884037,'Aquarius'],
  [-1967884037,-1967704330,'Pisces'],
  [-1967704330,-1967513668,'Aries'],
  [-1967513668,-1967308883,'Taurus'],
  [-1967308883,-1967092676,'Gemini'],
  [-1967092676,-1966873190,'Cancer'],
  [-1966873190,-1966658648,'Leo'],
  [-1966658648,-1966452775,'Virgo'],
  [-1966452775,-1966255122,'Libra'],
  [-1966255122,-1966063957,'Scorpio'],
  [-1966063957,-1965878055,'Sagittarius'],
  [-1965878055,-1965696461,'Capricorn'],
  [-1965696461,-1965517069,'Aquarius'],
  [-1965517069,-1965335694,'Pisces'],
  [-1965335694,-1965146731,'Aries'],
  [-1965146731,-1964945487,'Taurus'],
  [-1964945487,-1964731840,'Gemini'],
  [-1964731840,-1964512504,'Cancer'],
  [-1964512504,-1964297446,'Leo'],
  [-1964297446,-1964092833,'Virgo'],
  [-1964092833,-1963898509,'Libra'],
  [-1963898509,-1963710794,'Scorpio'],
  [-1963710794,-1963525987,'Sagittarius'],
  [-1963525987,-1963342036,'Capricorn'],
  [-1963342036,-1963157992,'Aquarius'],
  [-1963157992,-1962972189,'Pisces'],
  [-1962972189,-1962781212,'Aries'],
  [-1962781212,-1962580893,'Taurus'],
  [-1962580893,-1962369317,'Gemini'],
  [-1962369317,-1962150386,'Cancer'],
  [-1962150386,-1961933524,'Leo'],
  [-1961933524,-1961727398,'Virgo'],
  [-1961727398,-1961534244,'Libra'],
  [-1961534244,-1961350508,'Scorpio'],
  [-1961350508,-1961170583,'Sagittarius'],
  [-1961170583,-1960989722,'Capricorn'],
  [-1960989722,-1960805279,'Aquarius'],
  [-1960805279,-1960616168,'Pisces'],
  [-1960616168,-1960421331,'Aries'],
  [-1960421331,-1960218999,'Taurus'],
  [-1960218999,-1960007751,'Gemini'],
  [-1960007751,-1959789345,'Cancer'],
  [-1959789345,-1959570619,'Leo'],
  [-1959570619,-1959360644,'Virgo'],
  [-1959360644,-1959164677,'Libra'],
  [-1959164677,-1958981503,'Scorpio'],
  [-1958981503,-1958805712,'Sagittarius'],
  [-1958805712,-1958630826,'Capricorn'],
  [-1958630826,-1958451349,'Aquarius'],
  [-1958451349,-1958263897,'Pisces'],
  [-1958263897,-1958067343,'Aries'],
  [-1958067343,-1957862113,'Taurus'],
  [-1957862113,-1957649332,'Gemini'],
  [-1957649332,-1957431043,'Cancer'],
  [-1957431043,-1957211635,'Leo'],
  [-1957211635,-1956997973,'Virgo'],
  [-1956997973,-1956796454,'Libra'],
  [-1956796454,-1956609104,'Scorpio'],
  [-1956609104,-1956432883,'Sagittarius'],
  [-1956432883,-1956261710,'Capricorn'],
  [-1956261710,-1956088616,'Aquarius'],
  [-1956088616,-1955907380,'Pisces'],
  [-1955907380,-1955714116,'Aries'],
  [-1955714116,-1955508619,'Taurus'],
  [-1955508619,-1955294127,'Gemini'],
  [-1955294127,-1955075221,'Cancer'],
  [-1955075221,-1954856239,'Leo'],
  [-1954856239,-1954641431,'Virgo'],
  [-1954641431,-1954435370,'Libra'],
  [-1954435370,-1954241506,'Scorpio'],
  [-1954241506,-1954060021,'Sagittarius'],
  [-1954060021,-1953887293,'Capricorn'],
  [-1953887293,-1953716987,'Aquarius'],
  [-1953716987,-1953541732,'Pisces'],
  [-1953541732,-1953354959,'Aries'],
  [-1953354959,-1953153443,'Taurus'],
  [-1953153443,-1952939549,'Gemini'],
  [-1952939549,-1952720012,'Cancer'],
  [-1952720012,-1952501523,'Leo'],
  [-1952501523,-1952287930,'Virgo'],
  [-1952287930,-1952081175,'Libra'],
  [-1952081175,-1951883084,'Scorpio'],
  [-1951883084,-1951695079,'Sagittarius'],
  [-1951695079,-1951516551,'Capricorn'],
  [-1951516551,-1951343687,'Aquarius'],
  [-1951343687,-1951170026,'Pisces'],
  [-1951170026,-1950988196,'Aries'],
  [-1950988196,-1950792434,'Taurus'],
  [-1950792434,-1950582049,'Gemini'],
  [-1950582049,-1950363121,'Cancer'],
  [-1950363121,-1950144663,'Leo'],
  [-1950144663,-1949932574,'Virgo'],
  [-1949932574,-1949728090,'Libra'],
  [-1949728090,-1949530498,'Scorpio'],
  [-1949530498,-1949339537,'Sagittarius'],
  [-1949339537,-1949155371,'Capricorn'],
  [-1949155371,-1948976812,'Aquarius'],
  [-1948976812,-1948799932,'Pisces'],
  [-1948799932,-1948618578,'Aries'],
  [-1948618578,-1948426420,'Taurus'],
  [-1948426420,-1948220246,'Gemini'],
  [-1948220246,-1948003341,'Cancer'],
  [-1948003341,-1947784720,'Leo'],
  [-1947784720,-1947572820,'Virgo'],
  [-1947572820,-1947370557,'Libra'],
  [-1947370557,-1947176316,'Scorpio'],
  [-1947176316,-1946987385,'Sagittarius'],
  [-1946987385,-1946802033,'Capricorn'],
  [-1946802033,-1946619291,'Aquarius'],
  [-1946619291,-1946437374,'Pisces'],
  [-1946437374,-1946252627,'Aries'],
  [-1946252627,-1946060176,'Taurus'],
  [-1946060176,-1945856245,'Gemini'],
  [-1945856245,-1945641534,'Cancer'],
  [-1945641534,-1945422865,'Leo'],
  [-1945422865,-1945209589,'Virgo'],
  [-1945209589,-1945007281,'Libra'],
  [-1945007281,-1944815641,'Scorpio'],
  [-1944815641,-1944630969,'Sagittarius'],
  [-1944630969,-1944449133,'Capricorn'],
  [-1944449133,-1944267044,'Aquarius'],
  [-1944267044,-1944082601,'Pisces'],
  [-1944082601,-1943893827,'Aries'],
  [-1943893827,-1943698307,'Taurus'],
  [-1943698307,-1943493762,'Gemini'],
  [-1943493762,-1943280066,'Cancer'],
  [-1943280066,-1943061460,'Leo'],
  [-1943061460,-1942845987,'Virgo'],
  [-1942845987,-1942641015,'Libra'],
  [-1942641015,-1942448869,'Scorpio'],
  [-1942448869,-1942266880,'Sagittarius'],
  [-1942266880,-1942089916,'Capricorn'],
  [-1942089916,-1941912552,'Aquarius'],
  [-1941912552,-1941730383,'Pisces'],
  [-1941730383,-1941540643,'Aries'],
  [-1941540643,-1941342253,'Taurus'],
  [-1941342253,-1941135369,'Gemini'],
  [-1941135369,-1940921135,'Cancer'],
  [-1940921135,-1940702543,'Leo'],
  [-1940702543,-1940485226,'Virgo'],
  [-1940485226,-1940276230,'Libra'],
  [-1940276230,-1940080277,'Scorpio'],
  [-1940080277,-1939897214,'Sagittarius'],
  [-1939897214,-1939722754,'Capricorn'],
  [-1939722754,-1939550516,'Aquarius'],
  [-1939550516,-1939373885,'Pisces'],
  [-1939373885,-1939187637,'Aries'],
  [-1939187637,-1938989536,'Taurus'],
  [-1938989536,-1938780934,'Gemini'],
  [-1938780934,-1938565342,'Cancer'],
  [-1938565342,-1938346586,'Leo'],
  [-1938346586,-1938128637,'Virgo'],
  [-1938128637,-1937916442,'Libra'],
  [-1937916442,-1937715190,'Scorpio'],
  [-1937715190,-1937527410,'Sagittarius'],
  [-1937527410,-1937351231,'Capricorn'],
  [-1937351231,-1937181048,'Aquarius'],
  [-1937181048,-1937009432,'Pisces'],
  [-1937009432,-1936829085,'Aries'],
  [-1936829085,-1936635146,'Taurus'],
  [-1936635146,-1936427620,'Gemini'],
  [-1936427620,-1936211296,'Cancer'],
  [-1936211296,-1935992247,'Leo'],
  [-1935992247,-1935774788,'Virgo'],
  [-1935774788,-1935561872,'Libra'],
  [-1935561872,-1935356882,'Scorpio'],
  [-1935356882,-1935163175,'Sagittarius'],
  [-1935163175,-1934981617,'Capricorn'],
  [-1934981617,-1934808977,'Aquarius'],
  [-1934808977,-1934638708,'Pisces'],
  [-1934638708,-1934462937,'Aries'],
  [-1934462937,-1934274763,'Taurus'],
  [-1934274763,-1934071371,'Gemini'],
  [-1934071371,-1933856279,'Cancer'],
  [-1933856279,-1933637144,'Leo'],
  [-1933637144,-1933420428,'Virgo'],
  [-1933420428,-1933208972,'Libra'],
  [-1933208972,-1933003913,'Scorpio'],
  [-1933003913,-1932806860,'Sagittarius'],
  [-1932806860,-1932619438,'Capricorn'],
  [-1932619438,-1932441034,'Aquarius'],
  [-1932441034,-1932267533,'Pisces'],
  [-1932267533,-1932092248,'Aries'],
  [-1932092248,-1931907931,'Taurus'],
  [-1931907931,-1931709580,'Gemini'],
  [-1931709580,-1931497758,'Cancer'],
  [-1931497758,-1931279260,'Leo'],
  [-1931279260,-1931062654,'Virgo'],
  [-1931062654,-1930852847,'Libra'],
  [-1930852847,-1930650494,'Scorpio'],
  [-1930650494,-1930454750,'Sagittarius'],
  [-1930454750,-1930265268,'Capricorn'],
  [-1930265268,-1930081796,'Aquarius'],
  [-1930081796,-1929902550,'Pisces'],
  [-1929902550,-1929723430,'Aries'],
  [-1929723430,-1929538779,'Taurus'],
  [-1929538779,-1929343336,'Gemini'],
  [-1929343336,-1929135184,'Cancer'],
  [-1929135184,-1928918229,'Leo'],
  [-1928918229,-1928700962,'Virgo'],
  [-1928700962,-1928490974,'Libra'],
  [-1928490974,-1928290880,'Scorpio'],
  [-1928290880,-1928099135,'Sagittarius'],
  [-1928099135,-1927912789,'Capricorn'],
  [-1927912789,-1927729246,'Aquarius'],
  [-1927729246,-1927546448,'Pisces'],
  [-1927546448,-1927362184,'Aries'],
  [-1927362184,-1927173548,'Taurus'],
  [-1927173548,-1926977209,'Gemini'],
  [-1926977209,-1926770879,'Cancer'],
  [-1926770879,-1926555700,'Leo'],
  [-1926555700,-1926337668,'Virgo'],
  [-1926337668,-1926125282,'Libra'],
  [-1926125282,-1925924270,'Scorpio'],
  [-1925924270,-1925734924,'Sagittarius'],
  [-1925734924,-1925553533,'Capricorn'],
  [-1925553533,-1925374915,'Aquarius'],
  [-1925374915,-1925194336,'Pisces'],
  [-1925194336,-1925008551,'Aries'],
  [-1925008551,-1924815993,'Taurus'],
  [-1924815993,-1924616139,'Gemini'],
  [-1924616139,-1924408762,'Cancer'],
  [-1924408762,-1924194393,'Leo'],
  [-1924194393,-1923976142,'Virgo'],
  [-1923976142,-1923760683,'Libra'],
  [-1923760683,-1923555519,'Scorpio'],
  [-1923555519,-1923364237,'Sagittarius'],
  [-1923364237,-1923184827,'Capricorn'],
  [-1923184827,-1923011439,'Aquarius'],
  [-1923011439,-1922837020,'Pisces'],
  [-1922837020,-1922655473,'Aries'],
  [-1922655473,-1922463475,'Taurus'],
  [-1922463475,-1922261285,'Gemini'],
  [-1922261285,-1922051386,'Cancer'],
  [-1922051386,-1921836278,'Leo'],
  [-1921836278,-1921618200,'Virgo'],
  [-1921618200,-1921401019,'Libra'],
  [-1921401019,-1921191119,'Scorpio'],
  [-1921191119,-1920994341,'Sagittarius'],
  [-1920994341,-1920811915,'Capricorn'],
  [-1920811915,-1920639593,'Aquarius'],
  [-1920639593,-1920469932,'Pisces'],
  [-1920469932,-1920294949,'Aries'],
  [-1920294949,-1920108426,'Taurus'],
  [-1920108426,-1919908348,'Gemini'],
  [-1919908348,-1919697568,'Cancer'],
  [-1919697568,-1919481132,'Leo'],
  [-1919481132,-1919263019,'Virgo'],
  [-1919263019,-1919045979,'Libra'],
  [-1919045979,-1918833795,'Scorpio'],
  [-1918833795,-1918631636,'Sagittarius'],
  [-1918631636,-1918443026,'Capricorn'],
  [-1918443026,-1918266749,'Aquarius'],
  [-1918266749,-1918096998,'Pisces'],
  [-1918096998,-1917925817,'Aries'],
  [-1917925817,-1917745489,'Taurus'],
  [-1917745489,-1917551094,'Gemini'],
  [-1917551094,-1917342999,'Cancer'],
  [-1917342999,-1917126543,'Leo'],
  [-1917126543,-1916908170,'Virgo'],
  [-1916908170,-1916692046,'Libra'],
  [-1916692046,-1916480606,'Scorpio'],
  [-1916480606,-1916276588,'Sagittarius'],
  [-1916276588,-1916082936,'Capricorn'],
  [-1916082936,-1915900464,'Aquarius'],
  [-1915900464,-1915726147,'Pisces'],
  [-1915726147,-1915553842,'Aries'],
  [-1915553842,-1915376250,'Taurus'],
  [-1915376250,-1915187123,'Gemini'],
  [-1915187123,-1914983905,'Cancer'],
  [-1914983905,-1914769607,'Leo'],
  [-1914769607,-1914551339,'Virgo'],
  [-1914551339,-1914335739,'Libra'],
  [-1914335739,-1914126251,'Scorpio'],
  [-1914126251,-1913924033,'Sagittarius'],
  [-1913924033,-1913729633,'Capricorn'],
  [-1913729633,-1913543161,'Aquarius'],
  [-1913543161,-1913363204,'Pisces'],
  [-1913363204,-1913186178,'Aries'],
  [-1913186178,-1913006812,'Taurus'],
  [-1913006812,-1912819481,'Gemini'],
  [-1912819481,-1912620230,'Cancer'],
  [-1912620230,-1912409175,'Leo'],
  [-1912409175,-1912191679,'Virgo'],
  [-1912191679,-1911975758,'Libra'],
  [-1911975758,-1911767288,'Scorpio'],
  [-1911767288,-1911567983,'Sagittarius'],
  [-1911567983,-1911376593,'Capricorn'],
  [-1911376593,-1911190824,'Aquarius'],
  [-1911190824,-1911008311,'Pisces'],
  [-1911008311,-1910826608,'Aries'],
  [-1910826608,-1910642829,'Taurus'],
  [-1910642829,-1910453514,'Gemini'],
  [-1910453514,-1910255294,'Cancer'],
  [-1910255294,-1910046657,'Leo'],
  [-1910046657,-1909830252,'Virgo'],
  [-1909830252,-1909613304,'Libra'],
  [-1909613304,-1909403813,'Scorpio'],
  [-1909403813,-1909205750,'Sagittarius'],
  [-1909205750,-1909017993,'Capricorn'],
  [-1909017993,-1908836363,'Aquarius'],
  [-1908836363,-1908656094,'Pisces'],
  [-1908656094,-1908473445,'Aries'],
  [-1908473445,-1908286205,'Taurus'],
  [-1908286205,-1908093159,'Gemini'],
  [-1908093159,-1907893109,'Cancer'],
  [-1907893109,-1907684898,'Leo'],
  [-1907684898,-1907469262,'Virgo'],
  [-1907469262,-1907251121,'Libra'],
  [-1907251121,-1907038796,'Scorpio'],
  [-1907038796,-1906838905,'Sagittarius'],
  [-1906838905,-1906652305,'Capricorn'],
  [-1906652305,-1906474678,'Aquarius'],
  [-1906474678,-1906299466,'Pisces'],
  [-1906299466,-1906120513,'Aries'],
  [-1906120513,-1905933908,'Taurus'],
  [-1905933908,-1905738716,'Gemini'],
  [-1905738716,-1905535864,'Cancer'],
  [-1905535864,-1905326259,'Leo'],
  [-1905326259,-1905110635,'Virgo'],
  [-1905110635,-1904891751,'Libra'],
  [-1904891751,-1904676212,'Scorpio'],
  [-1904676212,-1904471915,'Sagittarius'],
  [-1904471915,-1904282603,'Capricorn'],
  [-1904282603,-1904105692,'Aquarius'],
  [-1904105692,-1903934475,'Pisces'],
  [-1903934475,-1903761210,'Aries'],
  [-1903761210,-1903579497,'Taurus'],
  [-1903579497,-1903386294,'Gemini'],
  [-1903386294,-1903182519,'Cancer'],
  [-1903182519,-1902971136,'Leo'],
  [-1902971136,-1902754801,'Virgo'],
  [-1902754801,-1902535841,'Libra'],
  [-1902535841,-1902318528,'Scorpio'],
  [-1902318528,-1902109605,'Sagittarius'],
  [-1902109605,-1901914670,'Capricorn'],
  [-1901914670,-1901734071,'Aquarius'],
  [-1901734071,-1901562784,'Pisces'],
  [-1901562784,-1901393146,'Aries'],
  [-1901393146,-1901217392,'Taurus'],
  [-1901217392,-1901029831,'Gemini'],
  [-1901029831,-1900828928,'Cancer'],
  [-1900828928,-1900617500,'Leo'],
  [-1900617500,-1900400366,'Virgo'],
  [-1900400366,-1900181626,'Libra'],
  [-1900181626,-1899964670,'Scorpio'],
  [-1899964670,-1899753767,'Sagittarius'],
  [-1899753767,-1899553647,'Capricorn'],
  [-1899553647,-1899366664,'Aquarius'],
  [-1899366664,-1899190704,'Pisces'],
  [-1899190704,-1899019991,'Aries'],
  [-1899019991,-1898847198,'Taurus'],
  [-1898847198,-1898665398,'Gemini'],
  [-1898665398,-1898470195,'Cancer'],
  [-1898470195,-1898261745,'Leo'],
  [-1898261745,-1898044871,'Virgo'],
  [-1898044871,-1897826151,'Libra'],
  [-1897826151,-1897610553,'Scorpio'],
  [-1897610553,-1897401051,'Sagittarius'],
  [-1897401051,-1897199724,'Capricorn'],
  [-1897199724,-1897007989,'Aquarius'],
  [-1897007989,-1896825506,'Pisces'],
  [-1896825506,-1896649379,'Aries'],
  [-1896649379,-1896474530,'Taurus'],
  [-1896474530,-1896294817,'Gemini'],
  [-1896294817,-1896104603,'Cancer'],
  [-1896104603,-1895901002,'Leo'],
  [-1895901002,-1895686221,'Virgo'],
  [-1895686221,-1895467403,'Libra'],
  [-1895467403,-1895252342,'Scorpio'],
  [-1895252342,-1895045341,'Sagittarius'],
  [-1895045341,-1894846868,'Capricorn'],
  [-1894846868,-1894655545,'Aquarius'],
  [-1894655545,-1894469737,'Pisces'],
  [-1894469737,-1894287769,'Aries'],
  [-1894287769,-1894107332,'Taurus'],
  [-1894107332,-1893924871,'Gemini'],
  [-1893924871,-1893735770,'Cancer'],
  [-1893735770,-1893535842,'Leo'],
  [-1893535842,-1893324161,'Virgo'],
  [-1893324161,-1893105679,'Libra'],
  [-1893105679,-1892889579,'Scorpio'],
  [-1892889579,-1892683183,'Sagittarius'],
  [-1892683183,-1892488008,'Capricorn'],
  [-1892488008,-1892300974,'Aquarius'],
  [-1892300974,-1892117636,'Pisces'],
  [-1892117636,-1891934501,'Aries'],
  [-1891934501,-1891749731,'Taurus'],
  [-1891749731,-1891562245,'Gemini'],
  [-1891562245,-1891370172,'Cancer'],
  [-1891370172,-1891170488,'Leo'],
  [-1891170488,-1890960886,'Virgo'],
  [-1890960886,-1890743238,'Libra'],
  [-1890743238,-1890525309,'Scorpio'],
  [-1890525309,-1890316588,'Sagittarius'],
  [-1890316588,-1890121578,'Capricorn'],
  [-1890121578,-1889938025,'Aquarius'],
  [-1889938025,-1889759970,'Pisces'],
  [-1889759970,-1889581232,'Aries'],
  [-1889581232,-1889397652,'Taurus'],
  [-1889397652,-1889207827,'Gemini'],
  [-1889207827,-1889011896,'Cancer'],
  [-1889011896,-1888809552,'Leo'],
  [-1888809552,-1888599691,'Virgo'],
  [-1888599691,-1888382666,'Libra'],
  [-1888382666,-1888163410,'Scorpio'],
  [-1888163410,-1887950881,'Sagittarius'],
  [-1887950881,-1887752239,'Capricorn'],
  [-1887752239,-1887568015,'Aquarius'],
  [-1887568015,-1887393014,'Pisces'],
  [-1887393014,-1887219909,'Aries'],
  [-1887219909,-1887042056,'Taurus'],
  [-1887042056,-1886855366,'Gemini'],
  [-1886855366,-1886658999,'Cancer'],
  [-1886658999,-1886454198,'Leo'],
  [-1886454198,-1886242461,'Virgo'],
  [-1886242461,-1886025196,'Libra'],
  [-1886025196,-1885805627,'Scorpio'],
  [-1885805627,-1885590263,'Sagittarius'],
  [-1885590263,-1885386461,'Capricorn'],
  [-1885386461,-1885197546,'Aquarius'],
  [-1885197546,-1885020894,'Pisces'],
  [-1885020894,-1884850057,'Aries'],
  [-1884850057,-1884677616,'Taurus'],
  [-1884677616,-1884497189,'Gemini'],
  [-1884497189,-1884305066,'Cancer'],
  [-1884305066,-1884101117,'Leo'],
  [-1884101117,-1883888163,'Virgo'],
  [-1883888163,-1883670080,'Libra'],
  [-1883670080,-1883450783,'Scorpio'],
  [-1883450783,-1883234872,'Sagittarius'],
  [-1883234872,-1883027624,'Capricorn'],
  [-1883027624,-1882832971,'Aquarius'],
  [-1882832971,-1882650972,'Pisces'],
  [-1882650972,-1882477633,'Aries'],
  [-1882477633,-1882306609,'Taurus'],
  [-1882306609,-1882130991,'Gemini'],
  [-1882130991,-1881944901,'Cancer'],
  [-1881944901,-1881745308,'Leo'],
  [-1881745308,-1881533624,'Virgo'],
  [-1881533624,-1881315181,'Libra'],
  [-1881315181,-1881096176,'Scorpio'],
  [-1881096176,-1880881405,'Sagittarius'],
  [-1880881405,-1880674028,'Capricorn'],
  [-1880674028,-1880476167,'Aquarius'],
  [-1880476167,-1880288554,'Pisces'],
  [-1880288554,-1880109662,'Aries'],
  [-1880109662,-1879935580,'Taurus'],
  [-1879935580,-1879760628,'Gemini'],
  [-1879760628,-1879578510,'Cancer'],
  [-1879578510,-1879384071,'Leo'],
  [-1879384071,-1879175905,'Virgo'],
  [-1879175905,-1878958338,'Libra'],
  [-1878958338,-1878739415,'Scorpio'],
  [-1878739415,-1878525940,'Sagittarius'],
  [-1878525940,-1878320741,'Capricorn'],
  [-1878320741,-1878123673,'Aquarius'],
  [-1878123673,-1877933759,'Pisces'],
  [-1877933759,-1877749941,'Aries'],
  [-1877749941,-1877570524,'Taurus'],
  [-1877570524,-1877392264,'Gemini'],
  [-1877392264,-1877210190,'Cancer'],
  [-1877210190,-1877018743,'Leo'],
  [-1877018743,-1876814330,'Virgo'],
  [-1876814330,-1876598688,'Libra'],
  [-1876598688,-1876379671,'Scorpio'],
  [-1876379671,-1876166362,'Sagittarius'],
  [-1876166362,-1875963241,'Capricorn'],
  [-1875963241,-1875769393,'Aquarius'],
  [-1875769393,-1875581538,'Pisces'],
  [-1875581538,-1875396802,'Aries'],
  [-1875396802,-1875213577,'Taurus'],
  [-1875213577,-1875030558,'Gemini'],
  [-1875030558,-1874845190,'Cancer'],
  [-1874845190,-1874653316,'Leo'],
  [-1874653316,-1874450844,'Virgo'],
  [-1874450844,-1874237157,'Libra'],
  [-1874237157,-1874018011,'Scorpio'],
  [-1874018011,-1873803308,'Sagittarius'],
  [-1873803308,-1873600115,'Capricorn'],
  [-1873600115,-1873408799,'Aquarius'],
  [-1873408799,-1873225108,'Pisces'],
  [-1873225108,-1873043869,'Aries'],
  [-1873043869,-1872861387,'Taurus'],
  [-1872861387,-1872675974,'Gemini'],
  [-1872675974,-1872486699,'Cancer'],
  [-1872486699,-1872291810,'Leo'],
  [-1872291810,-1872088667,'Virgo'],
  [-1872088667,-1871875885,'Libra'],
  [-1871875885,-1871656706,'Scorpio'],
  [-1871656706,-1871439677,'Sagittarius'],
  [-1871439677,-1871233640,'Capricorn'],
  [-1871233640,-1871041679,'Aquarius'],
  [-1871041679,-1870860593,'Pisces'],
  [-1870860593,-1870684263,'Aries'],
  [-1870684263,-1870506693,'Taurus'],
  [-1870506693,-1870323757,'Gemini'],
  [-1870323757,-1870133632,'Cancer'],
  [-1870133632,-1869935875,'Leo'],
  [-1869935875,-1869730297,'Virgo'],
  [-1869730297,-1869516918,'Libra'],
  [-1869516918,-1869297783,'Scorpio'],
  [-1869297783,-1869078883,'Sagittarius'],
  [-1869078883,-1868868522,'Capricorn'],
  [-1868868522,-1868672259,'Aquarius'],
  [-1868672259,-1868489640,'Pisces'],
  [-1868489640,-1868315593,'Aries'],
  [-1868315593,-1868143332,'Taurus'],
  [-1868143332,-1867966446,'Gemini'],
  [-1867966446,-1867780338,'Cancer'],
  [-1867780338,-1867583163,'Leo'],
  [-1867583163,-1867375820,'Virgo'],
  [-1867375820,-1867160896,'Libra'],
  [-1867160896,-1866941630,'Scorpio'],
  [-1866941630,-1866722354,'Sagittarius'],
  [-1866722354,-1866508876,'Capricorn'],
  [-1866508876,-1866306854,'Aquarius'],
  [-1866306854,-1866118641,'Pisces'],
  [-1866118641,-1865941979,'Aries'],
  [-1865941979,-1865771297,'Taurus'],
  [-1865771297,-1865599609,'Gemini'],
  [-1865599609,-1865420113,'Cancer'],
  [-1865420113,-1865227939,'Leo'],
  [-1865227939,-1865022163,'Virgo'],
  [-1865022163,-1864806450,'Libra'],
  [-1864806450,-1864586727,'Scorpio'],
  [-1864586727,-1864368192,'Sagittarius'],
  [-1864368192,-1864154609,'Capricorn'],
  [-1864154609,-1863949226,'Aquarius'],
  [-1863949226,-1863754709,'Pisces'],
  [-1863754709,-1863571595,'Aries'],
  [-1863571595,-1863397239,'Taurus'],
  [-1863397239,-1863226115,'Gemini'],
  [-1863226115,-1863051114,'Cancer'],
  [-1863051114,-1862865313,'Leo'],
  [-1862865313,-1862664598,'Virgo'],
  [-1862664598,-1862450649,'Libra'],
  [-1862450649,-1862230729,'Scorpio'],
  [-1862230729,-1862012773,'Sagittarius'],
  [-1862012773,-1861801068,'Capricorn'],
  [-1861801068,-1861596598,'Aquarius'],
  [-1861596598,-1861399632,'Pisces'],
  [-1861399632,-1861210749,'Aries'],
  [-1861210749,-1861029793,'Taurus'],
  [-1861029793,-1860854206,'Gemini'],
  [-1860854206,-1860678633,'Cancer'],
  [-1860678633,-1860496172,'Leo'],
  [-1860496172,-1860300776,'Virgo'],
  [-1860300776,-1860090854,'Libra'],
  [-1860090854,-1859871945,'Scorpio'],
  [-1859871945,-1859653791,'Sagittarius'],
  [-1859653791,-1859443368,'Capricorn'],
  [-1859443368,-1859241895,'Aquarius'],
  [-1859241895,-1859047361,'Pisces'],
  [-1859047361,-1858857842,'Aries'],
  [-1858857842,-1858672643,'Taurus'],
  [-1858672643,-1858491130,'Gemini'],
  [-1858491130,-1858310811,'Cancer'],
  [-1858310811,-1858126844,'Leo'],
  [-1858126844,-1857933504,'Virgo'],
  [-1857933504,-1857727245,'Libra'],
  [-1857727245,-1857510421,'Scorpio'],
  [-1857510421,-1857291752,'Sagittarius'],
  [-1857291752,-1857080555,'Capricorn'],
  [-1857080555,-1856880569,'Aquarius'],
  [-1856880569,-1856689851,'Pisces'],
  [-1856689851,-1856504324,'Aries'],
  [-1856504324,-1856320641,'Taurus'],
  [-1856320641,-1856136992,'Gemini'],
  [-1856136992,-1855952095,'Cancer'],
  [-1855952095,-1855763730,'Leo'],
  [-1855763730,-1855568460,'Virgo'],
  [-1855568460,-1855363170,'Libra'],
  [-1855363170,-1855148116,'Scorpio'],
  [-1855148116,-1854929190,'Sagittarius'],
  [-1854929190,-1854715648,'Capricorn'],
  [-1854715648,-1854513974,'Aquarius'],
  [-1854513974,-1854324499,'Pisces'],
  [-1854324499,-1854143165,'Aries'],
  [-1854143165,-1853964656,'Taurus'],
  [-1853964656,-1853784439,'Gemini'],
  [-1853784439,-1853599529,'Cancer'],
  [-1853599529,-1853408231,'Leo'],
  [-1853408231,-1853209452,'Virgo'],
  [-1853209452,-1853002423,'Libra'],
  [-1853002423,-1852787646,'Scorpio'],
  [-1852787646,-1852568756,'Sagittarius'],
  [-1852568756,-1852352805,'Capricorn'],
  [-1852352805,-1852147153,'Aquarius'],
  [-1852147153,-1851955030,'Pisces'],
  [-1851955030,-1851774428,'Aries'],
  [-1851774428,-1851600057,'Taurus'],
  [-1851600057,-1851425622,'Gemini'],
  [-1851425622,-1851245469,'Cancer'],
  [-1851245469,-1851055829,'Leo'],
  [-1851055829,-1850855635,'Virgo'],
  [-1850855635,-1850646282,'Libra'],
  [-1850646282,-1850430439,'Scorpio'],
  [-1850430439,-1850211573,'Sagittarius'],
  [-1850211573,-1849994404,'Capricorn'],
  [-1849994404,-1849784815,'Aquarius'],
  [-1849784815,-1849587568,'Pisces'],
  [-1849587568,-1849403523,'Aries'],
  [-1849403523,-1849229263,'Taurus'],
  [-1849229263,-1849058558,'Gemini'],
  [-1849058558,-1848884235,'Cancer'],
  [-1848884235,-1848699972,'Leo'],
  [-1848699972,-1848502399,'Virgo'],
  [-1848502399,-1848292737,'Libra'],
  [-1848292737,-1848075767,'Scorpio'],
  [-1848075767,-1847856756,'Sagittarius'],
  [-1847856756,-1847639774,'Capricorn'],
  [-1847639774,-1847428399,'Aquarius'],
  [-1847428399,-1847226504,'Pisces'],
  [-1847226504,-1847036741,'Aries'],
  [-1847036741,-1846858463,'Taurus'],
  [-1846858463,-1846687199,'Gemini'],
  [-1846687199,-1846515954,'Cancer'],
  [-1846515954,-1846337130,'Leo'],
  [-1846337130,-1846144858,'Virgo'],
  [-1846144858,-1845937980,'Libra'],
  [-1845937980,-1845721256,'Scorpio'],
  [-1845721256,-1845502108,'Sagittarius'],
  [-1845502108,-1845285990,'Capricorn'],
  [-1845285990,-1845075386,'Aquarius'],
  [-1845075386,-1844871918,'Pisces'],
  [-1844871918,-1844677586,'Aries'],
  [-1844677586,-1844493497,'Taurus'],
  [-1844493497,-1844317823,'Gemini'],
  [-1844317823,-1844145342,'Cancer'],
  [-1844145342,-1843968836,'Leo'],
  [-1843968836,-1843781286,'Virgo'],
  [-1843781286,-1843578952,'Libra'],
  [-1843578952,-1843364367,'Scorpio'],
  [-1843364367,-1843145429,'Sagittarius'],
  [-1843145429,-1842929877,'Capricorn'],
  [-1842929877,-1842721171,'Aquarius'],
  [-1842721171,-1842519472,'Pisces'],
  [-1842519472,-1842324497,'Aries'],
  [-1842324497,-1842136596,'Taurus'],
  [-1842136596,-1841955456,'Gemini'],
  [-1841955456,-1841778363,'Cancer'],
  [-1841778363,-1841600035,'Leo'],
  [-1841600035,-1841414051,'Virgo'],
  [-1841414051,-1841215428,'Libra'],
  [-1841215428,-1841003963,'Scorpio'],
  [-1841003963,-1840785784,'Sagittarius'],
  [-1840785784,-1840569891,'Capricorn'],
  [-1840569891,-1840362159,'Aquarius'],
  [-1840362159,-1840163347,'Pisces'],
  [-1840163347,-1839971454,'Aries'],
  [-1839971454,-1839784386,'Taurus'],
  [-1839784386,-1839600751,'Gemini'],
  [-1839600751,-1839418949,'Cancer'],
  [-1839418949,-1839236087,'Leo'],
  [-1839236087,-1839047931,'Virgo'],
  [-1839047931,-1838850206,'Libra'],
  [-1838850206,-1838641149,'Scorpio'],
  [-1838641149,-1838424085,'Sagittarius'],
  [-1838424085,-1838207043,'Capricorn'],
  [-1838207043,-1837998028,'Aquarius'],
  [-1837998028,-1837800259,'Pisces'],
  [-1837800259,-1837612060,'Aries'],
  [-1837612060,-1837429480,'Taurus'],
  [-1837429480,-1837248487,'Gemini'],
  [-1837248487,-1837065936,'Cancer'],
  [-1837065936,-1836879524,'Leo'],
  [-1836879524,-1836687306,'Virgo'],
  [-1836687306,-1836487428,'Libra'],
  [-1836487428,-1836278742,'Scorpio'],
  [-1836278742,-1836062598,'Sagittarius'],
  [-1836062598,-1835844371,'Capricorn'],
  [-1835844371,-1835632101,'Aquarius'],
  [-1835632101,-1835431844,'Pisces'],
  [-1835431844,-1835244358,'Aries'],
  [-1835244358,-1835065885,'Taurus'],
  [-1835065885,-1834890558,'Gemini'],
  [-1834890558,-1834712485,'Cancer'],
  [-1834712485,-1834527273,'Leo'],
  [-1834527273,-1834332979,'Virgo'],
  [-1834332979,-1834129943,'Libra'],
  [-1834129943,-1833919547,'Scorpio'],
  [-1833919547,-1833703488,'Sagittarius'],
  [-1833703488,-1833484819,'Capricorn'],
  [-1833484819,-1833269287,'Aquarius'],
  [-1833269287,-1833063890,'Pisces'],
  [-1833063890,-1832872620,'Aries'],
  [-1832872620,-1832694104,'Taurus'],
  [-1832694104,-1832522683,'Gemini'],
  [-1832522683,-1832350882,'Cancer'],
  [-1832350882,-1832171600,'Leo'],
  [-1832171600,-1831980276,'Virgo'],
  [-1831980276,-1831776689,'Libra'],
  [-1831776689,-1831564316,'Scorpio'],
  [-1831564316,-1831347351,'Sagittarius'],
  [-1831347351,-1831128887,'Capricorn'],
  [-1831128887,-1830912143,'Aquarius'],
  [-1830912143,-1830702232,'Pisces'],
  [-1830702232,-1830504567,'Aries'],
  [-1830504567,-1830321098,'Taurus'],
  [-1830321098,-1830148516,'Gemini'],
  [-1830148516,-1829979770,'Cancer'],
  [-1829979770,-1829806612,'Leo'],
  [-1829806612,-1829621891,'Virgo'],
  [-1829621891,-1829422364,'Libra'],
  [-1829422364,-1829210563,'Scorpio'],
  [-1829210563,-1828992734,'Sagittarius'],
  [-1828992734,-1828774379,'Capricorn'],
  [-1828774379,-1828558475,'Aquarius'],
  [-1828558475,-1828347540,'Pisces'],
  [-1828347540,-1828145304,'Aries'],
  [-1828145304,-1827955090,'Taurus'],
  [-1827955090,-1827776734,'Gemini'],
  [-1827776734,-1827605591,'Cancer'],
  [-1827605591,-1827434253,'Leo'],
  [-1827434253,-1827254855,'Virgo'],
  [-1827254855,-1827061625,'Libra'],
  [-1827061625,-1826853875,'Scorpio'],
  [-1826853875,-1826636902,'Sagittarius'],
  [-1826636902,-1826418408,'Capricorn'],
  [-1826418408,-1826203635,'Aquarius'],
  [-1826203635,-1825994605,'Pisces'],
  [-1825994605,-1825792452,'Aries'],
  [-1825792452,-1825598728,'Taurus'],
  [-1825598728,-1825414224,'Gemini'],
  [-1825414224,-1825237063,'Cancer'],
  [-1825237063,-1825062375,'Leo'],
  [-1825062375,-1824883597,'Virgo'],
  [-1824883597,-1824694494,'Libra'],
  [-1824694494,-1824491796,'Scorpio'],
  [-1824491796,-1824277685,'Sagittarius'],
  [-1824277685,-1824059415,'Capricorn'],
  [-1824059415,-1823844728,'Aquarius'],
  [-1823844728,-1823637661,'Pisces'],
  [-1823637661,-1823438623,'Aries'],
  [-1823438623,-1823246567,'Taurus'],
  [-1823246567,-1823060316,'Gemini'],
  [-1823060316,-1822878357,'Cancer'],
  [-1822878357,-1822698097,'Leo'],
  [-1822698097,-1822515614,'Virgo'],
  [-1822515614,-1822326282,'Libra'],
  [-1822326282,-1822126363,'Scorpio'],
  [-1822126363,-1821915380,'Sagittarius'],
  [-1821915380,-1821697954,'Capricorn'],
  [-1821697954,-1821482273,'Aquarius'],
  [-1821482273,-1821275116,'Pisces'],
  [-1821275116,-1821078557,'Aries'],
  [-1821078557,-1820890630,'Taurus'],
  [-1820890630,-1820707619,'Gemini'],
  [-1820707619,-1820525873,'Cancer'],
  [-1820525873,-1820342550,'Leo'],
  [-1820342550,-1820155511,'Virgo'],
  [-1820155511,-1819962755,'Libra'],
  [-1819962755,-1819762197,'Scorpio'],
  [-1819762197,-1819552688,'Sagittarius'],
  [-1819552688,-1819336201,'Capricorn'],
  [-1819336201,-1819119114,'Aquarius'],
  [-1819119114,-1818909606,'Pisces'],
  [-1818909606,-1818712541,'Aries'],
  [-1818712541,-1818527231,'Taurus'],
  [-1818527231,-1818348959,'Gemini'],
  [-1818348959,-1818171718,'Cancer'],
  [-1818171718,-1817990380,'Leo'],
  [-1817990380,-1817802016,'Virgo'],
  [-1817802016,-1817605999,'Libra'],
  [-1817605999,-1817402754,'Scorpio'],
  [-1817402754,-1817192585,'Sagittarius'],
  [-1817192585,-1816976473,'Capricorn'],
  [-1816976473,-1816758306,'Aquarius'],
  [-1816758306,-1816545428,'Pisces'],
  [-1816545428,-1816344821,'Aries'],
  [-1816344821,-1816158446,'Taurus'],
  [-1816158446,-1815982554,'Gemini'],
  [-1815982554,-1815810237,'Cancer'],
  [-1815810237,-1815634254,'Leo'],
  [-1815634254,-1815449234,'Virgo'],
  [-1815449234,-1815253348,'Libra'],
  [-1815253348,-1815048130,'Scorpio'],
  [-1815048130,-1814836233,'Sagittarius'],
  [-1814836233,-1814619751,'Capricorn'],
  [-1814619751,-1814401226,'Aquarius'],
  [-1814401226,-1814185787,'Pisces'],
  [-1814185787,-1813980417,'Aries'],
  [-1813980417,-1813789560,'Taurus'],
  [-1813789560,-1813611923,'Gemini'],
  [-1813611923,-1813441454,'Cancer'],
  [-1813441454,-1813270250,'Leo'],
  [-1813270250,-1813091001,'Virgo'],
  [-1813091001,-1812899267,'Libra'],
  [-1812899267,-1812695144,'Scorpio'],
  [-1812695144,-1812482323,'Sagittarius'],
  [-1812482323,-1812265132,'Capricorn'],
  [-1812265132,-1812046819,'Aquarius'],
  [-1812046819,-1811830831,'Pisces'],
  [-1811830831,-1811622191,'Aries'],
  [-1811622191,-1811425821,'Taurus'],
  [-1811425821,-1811242998,'Gemini'],
  [-1811242998,-1811070018,'Cancer'],
  [-1811070018,-1810899967,'Leo'],
  [-1810899967,-1810725123,'Virgo'],
  [-1810725123,-1810539119,'Libra'],
  [-1810539119,-1810339280,'Scorpio'],
  [-1810339280,-1810127846,'Sagittarius'],
  [-1810127846,-1809910400,'Capricorn'],
  [-1809910400,-1809692393,'Aquarius'],
  [-1809692393,-1809477526,'Pisces'],
  [-1809477526,-1809268815,'Aries'],
  [-1809268815,-1809069308,'Taurus'],
  [-1809069308,-1808880857,'Gemini'],
  [-1808880857,-1808702238,'Cancer'],
  [-1808702238,-1808528942,'Leo'],
  [-1808528942,-1808354526,'Virgo'],
  [-1808354526,-1808172360,'Libra'],
  [-1808172360,-1807977680,'Scorpio'],
  [-1807977680,-1807769849,'Sagittarius'],
  [-1807769849,-1807553316,'Capricorn'],
  [-1807553316,-1807335324,'Aquarius'],
  [-1807335324,-1807121731,'Pisces'],
  [-1807121731,-1806915347,'Aries'],
  [-1806915347,-1806716889,'Taurus'],
  [-1806716889,-1806526246,'Gemini'],
  [-1806526246,-1806342539,'Cancer'],
  [-1806342539,-1806163521,'Leo'],
  [-1806163521,-1805985334,'Virgo'],
  [-1805985334,-1805802937,'Libra'],
  [-1805802937,-1805611296,'Scorpio'],
  [-1805611296,-1805407441,'Sagittarius'],
  [-1805407441,-1805192979,'Capricorn'],
  [-1805192979,-1804974741,'Aquarius'],
  [-1804974741,-1804761040,'Pisces'],
  [-1804761040,-1804556713,'Aries'],
  [-1804556713,-1804361869,'Taurus'],
  [-1804361869,-1804173866,'Gemini'],
  [-1804173866,-1803989631,'Cancer'],
  [-1803989631,-1803806749,'Leo'],
  [-1803806749,-1803623298,'Virgo'],
  [-1803623298,-1803436982,'Libra'],
  [-1803436982,-1803244578,'Scorpio'],
  [-1803244578,-1803042744,'Sagittarius'],
  [-1803042744,-1802830513,'Capricorn'],
  [-1802830513,-1802612165,'Aquarius'],
  [-1802612165,-1802396595,'Pisces'],
  [-1802396595,-1802191623,'Aries'],
  [-1802191623,-1801999180,'Taurus'],
  [-1801999180,-1801815824,'Gemini'],
  [-1801815824,-1801635977,'Cancer'],
  [-1801635977,-1801454709,'Leo'],
  [-1801454709,-1801269225,'Virgo'],
  [-1801269225,-1801078709,'Libra'],
  [-1801078709,-1800882707,'Scorpio'],
  [-1800882707,-1800679814,'Sagittarius'],
  [-1800679814,-1800468554,'Capricorn'],
  [-1800468554,-1800250454,'Aquarius'],
  [-1800250454,-1800032415,'Pisces'],
  [-1800032415,-1799823798,'Aries'],
  [-1799823798,-1799629772,'Taurus'],
  [-1799629772,-1799448527,'Gemini'],
  [-1799448527,-1799273794,'Cancer'],
  [-1799273794,-1799098377,'Leo'],
  [-1799098377,-1798916669,'Virgo'],
  [-1798916669,-1798726230,'Libra'],
  [-1798726230,-1798527520,'Scorpio'],
  [-1798527520,-1798321797,'Sagittarius'],
  [-1798321797,-1798109582,'Capricorn'],
  [-1798109582,-1797891699,'Aquarius'],
  [-1797891699,-1797672242,'Pisces'],
  [-1797672242,-1797459225,'Aries'],
  [-1797459225,-1797259991,'Taurus'],
  [-1797259991,-1797075966,'Gemini'],
  [-1797075966,-1796902461,'Cancer'],
  [-1796902461,-1796731936,'Leo'],
  [-1796731936,-1796556864,'Virgo'],
  [-1796556864,-1796371817,'Libra'],
  [-1796371817,-1796175006,'Scorpio'],
  [-1796175006,-1795968075,'Sagittarius'],
  [-1795968075,-1795754096,'Capricorn'],
  [-1795754096,-1795535839,'Aquarius'],
  [-1795535839,-1795316443,'Pisces'],
  [-1795316443,-1795101178,'Aries'],
  [-1795101178,-1794896527,'Taurus'],
  [-1794896527,-1794706263,'Gemini'],
  [-1794706263,-1794528802,'Cancer'],
  [-1794528802,-1794358327,'Leo'],
  [-1794358327,-1794187389,'Virgo'],
  [-1794187389,-1794008939,'Libra'],
  [-1794008939,-1793818150,'Scorpio'],
  [-1793818150,-1793614072,'Sagittarius'],
  [-1793614072,-1793399919,'Capricorn'],
  [-1793399919,-1793181009,'Aquarius'],
  [-1793181009,-1792962197,'Pisces'],
  [-1792962197,-1792747515,'Aries'],
  [-1792747515,-1792540800,'Taurus'],
  [-1792540800,-1792345161,'Gemini'],
  [-1792345161,-1792161153,'Cancer'],
  [-1792161153,-1791985907,'Leo'],
  [-1791985907,-1791813938,'Virgo'],
  [-1791813938,-1791638605,'Libra'],
  [-1791638605,-1791453640,'Scorpio'],
  [-1791453640,-1791255093,'Sagittarius'],
  [-1791255093,-1791043598,'Capricorn'],
  [-1791043598,-1790824850,'Aquarius'],
  [-1790824850,-1790606299,'Pisces'],
  [-1790606299,-1790393299,'Aries'],
  [-1790393299,-1790188157,'Taurus'],
  [-1790188157,-1789991444,'Gemini'],
  [-1789991444,-1789802990,'Cancer'],
  [-1789802990,-1789621631,'Leo'],
  [-1789621631,-1789444648,'Virgo'],
  [-1789444648,-1789267546,'Libra'],
  [-1789267546,-1789084648,'Scorpio'],
  [-1789084648,-1788890637,'Sagittarius'],
  [-1788890637,-1788683226,'Capricorn'],
  [-1788683226,-1788465951,'Aquarius'],
  [-1788465951,-1788247276,'Pisces'],
  [-1788247276,-1788035123,'Aries'],
  [-1788035123,-1787832632,'Taurus'],
  [-1787832632,-1787638644,'Gemini'],
  [-1787638644,-1787450558,'Cancer'],
  [-1787450558,-1787266231,'Leo'],
  [-1787266231,-1787084143,'Virgo'],
  [-1787084143,-1786902329,'Libra'],
  [-1786902329,-1786717315,'Scorpio'],
  [-1786717315,-1786524444,'Sagittarius'],
  [-1786524444,-1786320013,'Capricorn'],
  [-1786320013,-1786104769,'Aquarius'],
  [-1786104769,-1785885830,'Pisces'],
  [-1785885830,-1785672876,'Aries'],
  [-1785672876,-1785471453,'Taurus'],
  [-1785471453,-1785280783,'Gemini'],
  [-1785280783,-1785096518,'Cancer'],
  [-1785096518,-1784914135,'Leo'],
  [-1784914135,-1784730776,'Virgo'],
  [-1784730776,-1784545179,'Libra'],
  [-1784545179,-1784356127,'Scorpio'],
  [-1784356127,-1784161151,'Sagittarius'],
  [-1784161151,-1783957162,'Capricorn'],
  [-1783957162,-1783743286,'Aquarius'],
  [-1783743286,-1783524128,'Pisces'],
  [-1783524128,-1783309055,'Aries'],
  [-1783309055,-1783105970,'Taurus'],
  [-1783105970,-1782916236,'Gemini'],
  [-1782916236,-1782735627,'Cancer'],
  [-1782735627,-1782557984,'Leo'],
  [-1782557984,-1782378045,'Virgo'],
  [-1782378045,-1782192833,'Libra'],
  [-1782192833,-1782001387,'Scorpio'],
  [-1782001387,-1781803259,'Sagittarius'],
  [-1781803259,-1781597517,'Capricorn'],
  [-1781597517,-1781383665,'Aquarius'],
  [-1781383665,-1781164400,'Pisces'],
  [-1781164400,-1780947034,'Aries'],
  [-1780947034,-1780740154,'Taurus'],
  [-1780740154,-1780547821,'Gemini'],
  [-1780547821,-1780367721,'Cancer'],
  [-1780367721,-1780193784,'Leo'],
  [-1780193784,-1780019250,'Virgo'],
  [-1780019250,-1779838663,'Libra'],
  [-1779838663,-1779649009,'Scorpio'],
  [-1779649009,-1779449737,'Sagittarius'],
  [-1779449737,-1779241835,'Capricorn'],
  [-1779241835,-1779026897,'Aquarius'],
  [-1779026897,-1778807569,'Pisces'],
  [-1778807569,-1778588992,'Aries'],
  [-1778588992,-1778378226,'Taurus'],
  [-1778378226,-1778180756,'Gemini'],
  [-1778180756,-1777997098,'Cancer'],
  [-1777997098,-1777823035,'Leo'],
  [-1777823035,-1777652003,'Virgo'],
  [-1777652003,-1777477155,'Libra'],
  [-1777477155,-1777292903,'Scorpio'],
  [-1777292903,-1777096366,'Sagittarius'],
  [-1777096366,-1776888246,'Capricorn'],
  [-1776888246,-1776672163,'Aquarius'],
  [-1776672163,-1776452685,'Pisces'],
  [-1776452685,-1776234381,'Aries'],
  [-1776234381,-1776021928,'Taurus'],
  [-1776021928,-1775819711,'Gemini'],
  [-1775819711,-1775630013,'Cancer'],
  [-1775630013,-1775451500,'Leo'],
  [-1775451500,-1775279575,'Virgo'],
  [-1775279575,-1775107755,'Libra'],
  [-1775107755,-1774929141,'Scorpio'],
  [-1774929141,-1774738186,'Sagittarius'],
  [-1774738186,-1774533057,'Capricorn'],
  [-1774533057,-1774317205,'Aquarius'],
  [-1774317205,-1774097501,'Pisces'],
  [-1774097501,-1773880173,'Aries'],
  [-1773880173,-1773668820,'Taurus'],
  [-1773668820,-1773465287,'Gemini'],
  [-1773465287,-1773270892,'Cancer'],
  [-1773270892,-1773086012,'Leo'],
  [-1773086012,-1772908957,'Virgo'],
  [-1772908957,-1772735409,'Libra'],
  [-1772735409,-1772559049,'Scorpio'],
  [-1772559049,-1772373112,'Sagittarius'],
  [-1772373112,-1772172978,'Capricorn'],
  [-1772172978,-1771959515,'Aquarius'],
  [-1771959515,-1771739905,'Pisces'],
  [-1771739905,-1771522998,'Aries'],
  [-1771522998,-1771313762,'Taurus'],
  [-1771313762,-1771112587,'Gemini'],
  [-1771112587,-1770918145,'Cancer'],
  [-1770918145,-1770729606,'Leo'],
  [-1770729606,-1770546602,'Virgo'],
  [-1770546602,-1770367630,'Libra'],
  [-1770367630,-1770188762,'Scorpio'],
  [-1770188762,-1770004099,'Sagittarius'],
  [-1770004099,-1769807866,'Capricorn'],
  [-1769807866,-1769597977,'Aquarius'],
  [-1769597977,-1769379283,'Pisces'],
  [-1769379283,-1769161699,'Aries'],
  [-1769161699,-1768953070,'Taurus'],
  [-1768953070,-1768754892,'Gemini'],
  [-1768754892,-1768564260,'Cancer'],
  [-1768564260,-1768377608,'Leo'],
  [-1768377608,-1768192847,'Virgo'],
  [-1768192847,-1768009148,'Libra'],
  [-1768009148,-1767825119,'Scorpio'],
  [-1767825119,-1767637459,'Sagittarius'],
  [-1767637459,-1767441564,'Capricorn'],
  [-1767441564,-1767234137,'Aquarius'],
  [-1767234137,-1767016953,'Pisces'],
  [-1767016953,-1766798204,'Aries'],
  [-1766798204,-1766587619,'Taurus'],
  [-1766587619,-1766389675,'Gemini'],
  [-1766389675,-1766202422,'Cancer'],
  [-1766202422,-1766020832,'Leo'],
  [-1766020832,-1765840042,'Virgo'],
  [-1765840042,-1765656944,'Libra'],
  [-1765656944,-1765470030,'Scorpio'],
  [-1765470030,-1765278086,'Sagittarius'],
  [-1765278086,-1765079246,'Capricorn'],
  [-1765079246,-1764871561,'Aquarius'],
  [-1764871561,-1764655399,'Pisces'],
  [-1764655399,-1764435937,'Aries'],
  [-1764435937,-1764222016,'Taurus'],
  [-1764222016,-1764020650,'Gemini'],
  [-1764020650,-1763832814,'Cancer'],
  [-1763832814,-1763654421,'Leo'],
  [-1763654421,-1763479381,'Virgo'],
  [-1763479381,-1763301902,'Libra'],
  [-1763301902,-1763117788,'Scorpio'],
  [-1763117788,-1762924954,'Sagittarius'],
  [-1762924954,-1762723142,'Capricorn'],
  [-1762723142,-1762513171,'Aquarius'],
  [-1762513171,-1762296676,'Pisces'],
  [-1762296676,-1762077164,'Aries'],
  [-1762077164,-1761860743,'Taurus'],
  [-1761860743,-1761654355,'Gemini'],
  [-1761654355,-1761461819,'Cancer'],
  [-1761461819,-1761281863,'Leo'],
  [-1761281863,-1761109388,'Virgo'],
  [-1761109388,-1760937639,'Libra'],
  [-1760937639,-1760759969,'Scorpio'],
  [-1760759969,-1760571416,'Sagittarius'],
  [-1760571416,-1760370298,'Capricorn'],
  [-1760370298,-1760158735,'Aquarius'],
  [-1760158735,-1759941024,'Pisces'],
  [-1759941024,-1759721605,'Aries'],
  [-1759721605,-1759504681,'Taurus'],
  [-1759504681,-1759294875,'Gemini'],
  [-1759294875,-1759096462,'Cancer'],
  [-1759096462,-1758910998,'Leo'],
  [-1758910998,-1758736079,'Virgo'],
  [-1758736079,-1758566001,'Libra'],
  [-1758566001,-1758393445,'Scorpio'],
  [-1758393445,-1758211292,'Sagittarius'],
  [-1758211292,-1758014932,'Capricorn'],
  [-1758014932,-1757804846,'Aquarius'],
  [-1757804846,-1757586618,'Pisces'],
  [-1757586618,-1757367133,'Aries'],
  [-1757367133,-1757151071,'Taurus'],
  [-1757151071,-1756940991,'Gemini'],
  [-1756940991,-1756739217,'Cancer'],
  [-1756739217,-1756547881,'Leo'],
  [-1756547881,-1756367194,'Virgo'],
  [-1756367194,-1756194010,'Libra'],
  [-1756194010,-1756022173,'Scorpio'],
  [-1756022173,-1755844187,'Sagittarius'],
  [-1755844187,-1755653483,'Capricorn'],
  [-1755653483,-1755447622,'Aquarius'],
  [-1755447622,-1755230753,'Pisces'],
  [-1755230753,-1755011314,'Aries'],
  [-1755011314,-1754796181,'Taurus'],
  [-1754796181,-1754587913,'Gemini'],
  [-1754587913,-1754386693,'Cancer'],
  [-1754386693,-1754192840,'Leo'],
  [-1754192840,-1754006961,'Virgo'],
  [-1754006961,-1753828209,'Libra'],
  [-1753828209,-1753652867,'Scorpio'],
  [-1753652867,-1753474782,'Sagittarius'],
  [-1753474782,-1753287214,'Capricorn'],
  [-1753287214,-1753085746,'Aquarius'],
  [-1753085746,-1752871717,'Pisces'],
  [-1752871717,-1752652763,'Aries'],
  [-1752652763,-1752437756,'Taurus'],
  [-1752437756,-1752231170,'Gemini'],
  [-1752231170,-1752032780,'Cancer'],
  [-1752032780,-1751840706,'Leo'],
  [-1751840706,-1751653654,'Virgo'],
  [-1751653654,-1751470839,'Libra'],
  [-1751470839,-1751290472,'Scorpio'],
  [-1751290472,-1751108782,'Sagittarius'],
  [-1751108782,-1750920570,'Capricorn'],
  [-1750920570,-1750721240,'Aquarius'],
  [-1750721240,-1750509947,'Pisces'],
  [-1750509947,-1750291858,'Aries'],
  [-1750291858,-1750076000,'Taurus'],
  [-1750076000,-1749869277,'Gemini'],
  [-1749869277,-1749673061,'Cancer'],
  [-1749673061,-1749484786,'Leo'],
  [-1749484786,-1749300897,'Virgo'],
  [-1749300897,-1749118508,'Libra'],
  [-1749118508,-1748935470,'Scorpio'],
  [-1748935470,-1748749569,'Sagittarius'],
  [-1748749569,-1748557995,'Capricorn'],
  [-1748557995,-1748357804,'Aquarius'],
  [-1748357804,-1748147706,'Pisces'],
  [-1748147706,-1747930446,'Aries'],
  [-1747930446,-1747713218,'Taurus'],
  [-1747713218,-1747504141,'Gemini'],
  [-1747504141,-1747307281,'Cancer'],
  [-1747307281,-1747121396,'Leo'],
  [-1747121396,-1746942096,'Virgo'],
  [-1746942096,-1746764200,'Libra'],
  [-1746764200,-1746583238,'Scorpio'],
  [-1746583238,-1746396160,'Sagittarius'],
  [-1746396160,-1746201396,'Capricorn'],
  [-1746201396,-1745998453,'Aquarius'],
  [-1745998453,-1745787607,'Pisces'],
  [-1745787607,-1745570697,'Aries'],
  [-1745570697,-1745352394,'Taurus'],
  [-1745352394,-1745139823,'Gemini'],
  [-1745139823,-1744939143,'Cancer'],
  [-1744939143,-1744751910,'Leo'],
  [-1744751910,-1744574887,'Virgo'],
  [-1744574887,-1744402040,'Libra'],
  [-1744402040,-1744226661,'Scorpio'],
  [-1744226661,-1744043150,'Sagittarius'],
  [-1744043150,-1743848625,'Capricorn'],
  [-1743848625,-1743643634,'Aquarius'],
  [-1743643634,-1743430951,'Pisces'],
  [-1743430951,-1743213708,'Aries'],
  [-1743213708,-1742995187,'Taurus'],
  [-1742995187,-1742780045,'Gemini'],
  [-1742780045,-1742574227,'Cancer'],
  [-1742574227,-1742381896,'Leo'],
  [-1742381896,-1742202640,'Virgo'],
  [-1742202640,-1742031535,'Libra'],
  [-1742031535,-1741861186,'Scorpio'],
  [-1741861186,-1741683917,'Sagittarius'],
  [-1741683917,-1741494044,'Capricorn'],
  [-1741494044,-1741290392,'Aquarius'],
  [-1741290392,-1741076730,'Pisces'],
  [-1741076730,-1740858712,'Aries'],
  [-1740858712,-1740640586,'Taurus'],
  [-1740640586,-1740425222,'Gemini'],
  [-1740425222,-1740216209,'Cancer'],
  [-1740216209,-1740017887,'Leo'],
  [-1740017887,-1739832590,'Virgo'],
  [-1739832590,-1739658226,'Libra'],
  [-1739658226,-1739488655,'Scorpio'],
  [-1739488655,-1739315867,'Sagittarius'],
  [-1739315867,-1739132277,'Capricorn'],
  [-1739132277,-1738933645,'Aquarius'],
  [-1738933645,-1738721785,'Pisces'],
  [-1738721785,-1738503488,'Aries'],
  [-1738503488,-1738285602,'Taurus'],
  [-1738285602,-1738071668,'Gemini'],
  [-1738071668,-1737863213,'Cancer'],
  [-1737863213,-1737662214,'Leo'],
  [-1737662214,-1737471070,'Virgo'],
  [-1737471070,-1737290238,'Libra'],
  [-1737290238,-1737116422,'Scorpio'],
  [-1737116422,-1736943230,'Sagittarius'],
  [-1736943230,-1736763160,'Capricorn'],
  [-1736763160,-1736570122,'Aquarius'],
  [-1736570122,-1736362655,'Pisces'],
  [-1736362655,-1736145687,'Aries'],
  [-1736145687,-1735927628,'Taurus'],
  [-1735927628,-1735714711,'Gemini'],
  [-1735714711,-1735508882,'Cancer'],
  [-1735508882,-1735309905,'Leo'],
  [-1735309905,-1735117635,'Virgo'],
  [-1735117635,-1734932122,'Libra'],
  [-1734932122,-1734752129,'Scorpio'],
  [-1734752129,-1734574099,'Sagittarius'],
  [-1734574099,-1734392599,'Capricorn'],
  [-1734392599,-1734201935,'Aquarius'],
  [-1734201935,-1733998680,'Pisces'],
  [-1733998680,-1733784449,'Aries'],
  [-1733784449,-1733566330,'Taurus'],
  [-1733566330,-1733352739,'Gemini'],
  [-1733352739,-1733148305,'Cancer'],
  [-1733148305,-1732953010,'Leo'],
  [-1732953010,-1732764451,'Virgo'],
  [-1732764451,-1732579943,'Libra'],
  [-1732579943,-1732397222,'Scorpio'],
  [-1732397222,-1732214095,'Sagittarius'],
  [-1732214095,-1732027860,'Capricorn'],
  [-1732027860,-1731835226,'Aquarius'],
  [-1731835226,-1731633247,'Pisces'],
  [-1731633247,-1731421395,'Aries'],
  [-1731421395,-1731203697,'Taurus'],
  [-1731203697,-1730988165,'Gemini'],
  [-1730988165,-1730782162,'Cancer'],
  [-1730782162,-1730588196,'Leo'],
  [-1730588196,-1730403920,'Virgo'],
  [-1730403920,-1730224497,'Libra'],
  [-1730224497,-1730044888,'Scorpio'],
  [-1730044888,-1729861277,'Sagittarius'],
  [-1729861277,-1729671587,'Capricorn'],
  [-1729671587,-1729475026,'Aquarius'],
  [-1729475026,-1729271129,'Pisces'],
  [-1729271129,-1729059714,'Aries'],
  [-1729059714,-1728842535,'Taurus'],
  [-1728842535,-1728625099,'Gemini'],
  [-1728625099,-1728415352,'Cancer'],
  [-1728415352,-1728218826,'Leo'],
  [-1728218826,-1728035427,'Virgo'],
  [-1728035427,-1727860286,'Libra'],
  [-1727860286,-1727686506,'Scorpio'],
  [-1727686506,-1727507608,'Sagittarius'],
  [-1727507608,-1727319411,'Capricorn'],
  [-1727319411,-1727121134,'Aquarius'],
  [-1727121134,-1726914531,'Pisces'],
  [-1726914531,-1726701739,'Aries'],
  [-1726701739,-1726484569,'Taurus'],
  [-1726484569,-1726266209,'Gemini'],
  [-1726266209,-1726052811,'Cancer'],
  [-1726052811,-1725851232,'Leo'],
  [-1725851232,-1725664400,'Virgo'],
  [-1725664400,-1725489408,'Libra'],
  [-1725489408,-1725319404,'Scorpio'],
  [-1725319404,-1725146451,'Sagittarius'],
  [-1725146451,-1724963843,'Capricorn'],
  [-1724963843,-1724768369,'Aquarius'],
  [-1724768369,-1724561429,'Pisces'],
  [-1724561429,-1724347180,'Aries'],
  [-1724347180,-1724129469,'Taurus'],
  [-1724129469,-1723911159,'Gemini'],
  [-1723911159,-1723696115,'Cancer'],
  [-1723696115,-1723490005,'Leo'],
  [-1723490005,-1723297421,'Virgo'],
  [-1723297421,-1723118305,'Libra'],
  [-1723118305,-1722947607,'Scorpio'],
  [-1722947607,-1722777668,'Sagittarius'],
  [-1722777668,-1722600667,'Capricorn'],
  [-1722600667,-1722410912,'Aquarius'],
  [-1722410912,-1722207227,'Pisces'],
  [-1722207227,-1721993373,'Aries'],
  [-1721993373,-1721775222,'Taurus'],
  [-1721775222,-1721557349,'Gemini'],
  [-1721557349,-1721342878,'Cancer'],
  [-1721342878,-1721135209,'Leo'],
  [-1721135209,-1720938049,'Virgo'],
  [-1720938049,-1720753018,'Libra'],
  [-1720753018,-1720577709,'Scorpio'],
  [-1720577709,-1720406304,'Sagittarius'],
  [-1720406304,-1720231540,'Capricorn'],
  [-1720231540,-1720046746,'Aquarius'],
  [-1720046746,-1719848192,'Pisces'],
  [-1719848192,-1719637129,'Aries'],
  [-1719637129,-1719419407,'Taurus'],
  [-1719419407,-1719201821,'Gemini'],
  [-1719201821,-1718988834,'Cancer'],
  [-1718988834,-1718782684,'Leo'],
  [-1718782684,-1718584744,'Virgo'],
  [-1718584744,-1718395773,'Libra'],
  [-1718395773,-1718214834,'Scorpio'],
  [-1718214834,-1718038593,'Sagittarius'],
  [-1718038593,-1717861810,'Capricorn'],
  [-1717861810,-1717678566,'Aquarius'],
  [-1717678566,-1717484050,'Pisces'],
  [-1717484050,-1717276837,'Aries'],
  [-1717276837,-1717060622,'Taurus'],
  [-1717060622,-1716842957,'Gemini'],
  [-1716842957,-1716630730,'Cancer'],
  [-1716630730,-1716427095,'Leo'],
  [-1716427095,-1716231878,'Virgo'],
  [-1716231878,-1716043411,'Libra'],
  [-1716043411,-1715859707,'Scorpio'],
  [-1715859707,-1715678534,'Sagittarius'],
  [-1715678534,-1715497030,'Capricorn'],
  [-1715497030,-1715311506,'Aquarius'],
  [-1715311506,-1715117937,'Pisces'],
  [-1715117937,-1714913550,'Aries'],
  [-1714913550,-1714699296,'Taurus'],
  [-1714699296,-1714481296,'Gemini'],
  [-1714481296,-1714268134,'Cancer'],
  [-1714268134,-1714065467,'Leo'],
  [-1714065467,-1713873614,'Virgo'],
  [-1713873614,-1713689133,'Libra'],
  [-1713689133,-1713507541,'Scorpio'],
  [-1713507541,-1713325185,'Sagittarius'],
  [-1713325185,-1713139839,'Capricorn'],
  [-1713139839,-1712950099,'Aquarius'],
  [-1712950099,-1712754289,'Pisces'],
  [-1712754289,-1712550320,'Aries'],
  [-1712550320,-1712337460,'Taurus'],
  [-1712337460,-1712119178,'Gemini'],
  [-1712119178,-1711903615,'Cancer'],
  [-1711903615,-1711698933,'Leo'],
  [-1711698933,-1711507877,'Virgo'],
  [-1711507877,-1711327226,'Libra'],
  [-1711327226,-1711150748,'Scorpio'],
  [-1711150748,-1710972229,'Sagittarius'],
  [-1710972229,-1710787522,'Capricorn'],
  [-1710787522,-1710595345,'Aquarius'],
  [-1710595345,-1710396173,'Pisces'],
  [-1710396173,-1710190304,'Aries'],
  [-1710190304,-1709977504,'Taurus'],
  [-1709977504,-1709759216,'Gemini'],
  [-1709759216,-1709541211,'Cancer'],
  [-1709541211,-1709332178,'Leo'],
  [-1709332178,-1709137869,'Virgo'],
  [-1709137869,-1708957365,'Libra'],
  [-1708957365,-1708784645,'Scorpio'],
  [-1708784645,-1708612002,'Sagittarius'],
  [-1708612002,-1708432676,'Capricorn'],
  [-1708432676,-1708242921,'Aquarius'],
  [-1708242921,-1708042816,'Pisces'],
  [-1708042816,-1707834653,'Aries'],
  [-1707834653,-1707620610,'Taurus'],
  [-1707620610,-1707402385,'Gemini'],
  [-1707402385,-1707183431,'Cancer'],
  [-1707183431,-1706970415,'Leo'],
  [-1706970415,-1706770256,'Virgo'],
  [-1706770256,-1706585218,'Libra'],
  [-1706585218,-1706411558,'Scorpio'],
  [-1706411558,-1706242040,'Sagittarius'],
  [-1706242040,-1706068777,'Capricorn'],
  [-1706068777,-1705885384,'Aquarius'],
  [-1705885384,-1705689017,'Pisces'],
  [-1705689017,-1705481133,'Aries'],
  [-1705481133,-1705265858,'Taurus'],
  [-1705265858,-1705047340,'Gemini'],
  [-1705047340,-1704828989,'Cancer'],
  [-1704828989,-1704614944,'Leo'],
  [-1704614944,-1704410306,'Virgo'],
  [-1704410306,-1704218666,'Libra'],
  [-1704218666,-1704039393,'Scorpio'],
  [-1704039393,-1703867674,'Sagittarius'],
  [-1703867674,-1703696516,'Capricorn'],
  [-1703696516,-1703518724,'Aquarius'],
  [-1703518724,-1703328799,'Pisces'],
  [-1703328799,-1703125018,'Aries'],
  [-1703125018,-1702910520,'Taurus'],
  [-1702910520,-1702691590,'Gemini'],
  [-1702691590,-1702474043,'Cancer'],
  [-1702474043,-1702261652,'Leo'],
  [-1702261652,-1702056850,'Virgo'],
  [-1702056850,-1701861403,'Libra'],
  [-1701861403,-1701675718,'Scorpio'],
  [-1701675718,-1701497849,'Sagittarius'],
  [-1701497849,-1701323457,'Capricorn'],
  [-1701323457,-1701146644,'Aquarius'],
  [-1701146644,-1700961290,'Pisces'],
  [-1700961290,-1700763016,'Aries'],
  [-1700763016,-1700551791,'Taurus'],
  [-1700551791,-1700333249,'Gemini'],
  [-1700333249,-1700115688,'Cancer'],
  [-1700115688,-1699905084,'Leo'],
  [-1699905084,-1699703191,'Virgo'],
  [-1699703191,-1699509078,'Libra'],
  [-1699509078,-1699321189,'Scorpio'],
  [-1699321189,-1699138035,'Sagittarius'],
  [-1699138035,-1698957740,'Capricorn'],
  [-1698957740,-1698777192,'Aquarius'],
  [-1698777192,-1698591829,'Pisces'],
  [-1698591829,-1698396745,'Aries'],
  [-1698396745,-1698189269,'Taurus'],
  [-1698189269,-1697972190,'Gemini'],
  [-1697972190,-1697753936,'Cancer'],
  [-1697753936,-1697543256,'Leo'],
  [-1697543256,-1697343757,'Virgo'],
  [-1697343757,-1697153616,'Libra'],
  [-1697153616,-1696968716,'Scorpio'],
  [-1696968716,-1696785406,'Sagittarius'],
  [-1696785406,-1696601592,'Capricorn'],
  [-1696601592,-1696416104,'Aquarius'],
  [-1696416104,-1696227099,'Pisces'],
  [-1696227099,-1696031347,'Aries'],
  [-1696031347,-1695825646,'Taurus'],
  [-1695825646,-1695610160,'Gemini'],
  [-1695610160,-1695391137,'Cancer'],
  [-1695391137,-1695178383,'Leo'],
  [-1695178383,-1694978373,'Virgo'],
  [-1694978373,-1694790738,'Libra'],
  [-1694790738,-1694610463,'Scorpio'],
  [-1694610463,-1694431564,'Sagittarius'],
  [-1694431564,-1694249578,'Capricorn'],
  [-1694249578,-1694062503,'Aquarius'],
  [-1694062503,-1693869904,'Pisces'],
  [-1693869904,-1693671087,'Aries'],
  [-1693671087,-1693464505,'Taurus'],
  [-1693464505,-1693249615,'Gemini'],
  [-1693249615,-1693030116,'Cancer'],
  [-1693030116,-1692814507,'Leo'],
  [-1692814507,-1692611105,'Virgo'],
  [-1692611105,-1692422293,'Libra'],
  [-1692422293,-1692244228,'Scorpio'],
  [-1692244228,-1692070188,'Sagittarius'],
  [-1692070188,-1691893601,'Capricorn'],
  [-1691893601,-1691709923,'Aquarius'],
  [-1691709923,-1691517411,'Pisces'],
  [-1691517411,-1691316358,'Aries'],
  [-1691316358,-1691107602,'Taurus'],
  [-1691107602,-1690892061,'Gemini'],
  [-1690892061,-1690672384,'Cancer'],
  [-1690672384,-1690454700,'Leo'],
  [-1690454700,-1690246869,'Virgo'],
  [-1690246869,-1690053594,'Libra'],
  [-1690053594,-1689873596,'Scorpio'],
  [-1689873596,-1689701240,'Sagittarius'],
  [-1689701240,-1689529424,'Capricorn'],
  [-1689529424,-1689351646,'Aquarius'],
  [-1689351646,-1689163502,'Pisces'],
  [-1689163502,-1688963673,'Aries'],
  [-1688963673,-1688753799,'Taurus'],
  [-1688753799,-1688537127,'Gemini'],
  [-1688537127,-1688317390,'Cancer'],
  [-1688317390,-1688099262,'Leo'],
  [-1688099262,-1687888448,'Virgo'],
  [-1687888448,-1687689825,'Libra'],
  [-1687689825,-1687504594,'Scorpio'],
  [-1687504594,-1687329583,'Sagittarius'],
  [-1687329583,-1687158847,'Capricorn'],
  [-1687158847,-1686985507,'Aquarius'],
  [-1686985507,-1686803266,'Pisces'],
  [-1686803266,-1686608070,'Aries'],
  [-1686608070,-1686399859,'Taurus'],
  [-1686399859,-1686182840,'Gemini'],
  [-1686182840,-1685963043,'Cancer'],
  [-1685963043,-1685745733,'Leo'],
  [-1685745733,-1685534768,'Virgo'],
  [-1685534768,-1685333046,'Libra'],
  [-1685333046,-1685142209,'Scorpio'],
  [-1685142209,-1684961525,'Sagittarius'],
  [-1684961525,-1684787536,'Capricorn'],
  [-1684787536,-1684614652,'Aquarius'],
  [-1684614652,-1684436290,'Pisces'],
  [-1684436290,-1684246490,'Aries'],
  [-1684246490,-1684042398,'Taurus'],
  [-1684042398,-1683826740,'Gemini'],
  [-1683826740,-1683606989,'Cancer'],
  [-1683606989,-1683390622,'Leo'],
  [-1683390622,-1683181561,'Virgo'],
  [-1683181561,-1682980541,'Libra'],
  [-1682980541,-1682787284,'Scorpio'],
  [-1682787284,-1682601388,'Sagittarius'],
  [-1682601388,-1682421673,'Capricorn'],
  [-1682421673,-1682245108,'Aquarius'],
  [-1682245108,-1682066563,'Pisces'],
  [-1682066563,-1681879862,'Aries'],
  [-1681879862,-1681680134,'Taurus'],
  [-1681680134,-1681467291,'Gemini'],
  [-1681467291,-1681247933,'Cancer'],
  [-1681247933,-1681031605,'Leo'],
  [-1681031605,-1680824291,'Virgo'],
  [-1680824291,-1680626336,'Libra'],
  [-1680626336,-1680435134,'Scorpio'],
  [-1680435134,-1680248214,'Sagittarius'],
  [-1680248214,-1680064321,'Capricorn'],
  [-1680064321,-1679882420,'Aquarius'],
  [-1679882420,-1679699988,'Pisces'],
  [-1679699988,-1679512511,'Aries'],
  [-1679512511,-1679314940,'Taurus'],
  [-1679314940,-1679104932,'Gemini'],
  [-1679104932,-1678886419,'Cancer'],
  [-1678886419,-1678668989,'Leo'],
  [-1678668989,-1678461270,'Virgo'],
  [-1678461270,-1678265479,'Libra'],
  [-1678265479,-1678078399,'Scorpio'],
  [-1678078399,-1677895195,'Sagittarius'],
  [-1677895195,-1677712212,'Capricorn'],
  [-1677712212,-1677527742,'Aquarius'],
  [-1677527742,-1677340837,'Pisces'],
  [-1677340837,-1677149596,'Aries'],
  [-1677149596,-1676950869,'Taurus'],
  [-1676950869,-1676742055,'Gemini'],
  [-1676742055,-1676524531,'Cancer'],
  [-1676524531,-1676305626,'Leo'],
  [-1676305626,-1676095004,'Virgo'],
  [-1676095004,-1675897920,'Libra'],
  [-1675897920,-1675712895,'Scorpio'],
  [-1675712895,-1675534529,'Sagittarius'],
  [-1675534529,-1675356868,'Capricorn'],
  [-1675356868,-1675175444,'Aquarius'],
  [-1675175444,-1674987941,'Pisces'],
  [-1674987941,-1674793500,'Aries'],
  [-1674793500,-1674591574,'Taurus'],
  [-1674591574,-1674381631,'Gemini'],
  [-1674381631,-1674164548,'Cancer'],
  [-1674164548,-1673944877,'Leo'],
  [-1673944877,-1673730613,'Virgo'],
  [-1673730613,-1673528859,'Libra'],
  [-1673528859,-1673341339,'Scorpio'],
  [-1673341339,-1673164398,'Sagittarius'],
  [-1673164398,-1672991724,'Capricorn'],
  [-1672991724,-1672816723,'Aquarius'],
  [-1672816723,-1672634093,'Pisces'],
  [-1672634093,-1672440957,'Aries'],
  [-1672440957,-1672237275,'Taurus'],
  [-1672237275,-1672025122,'Gemini'],
  [-1672025122,-1671807435,'Cancer'],
  [-1671807435,-1671587923,'Leo'],
  [-1671587923,-1671371745,'Virgo'],
  [-1671371745,-1671164901,'Libra'],
  [-1671164901,-1670971363,'Scorpio'],
  [-1670971363,-1670790704,'Sagittarius'],
  [-1670790704,-1670618464,'Capricorn'],
  [-1670618464,-1670447948,'Aquarius'],
  [-1670447948,-1670272008,'Pisces'],
  [-1670272008,-1670084750,'Aries'],
  [-1670084750,-1669883652,'Taurus'],
  [-1669883652,-1669670967,'Gemini'],
  [-1669670967,-1669452250,'Cancer'],
  [-1669452250,-1669233055,'Leo'],
  [-1669233055,-1669017365,'Virgo'],
  [-1669017365,-1668808433,'Libra'],
  [-1668808433,-1668609446,'Scorpio'],
  [-1668609446,-1668422163,'Sagittarius'],
  [-1668422163,-1668245278,'Capricorn'],
  [-1668245278,-1668074075,'Aquarius'],
  [-1668074075,-1667901601,'Pisces'],
  [-1667901601,-1667720448,'Aries'],
  [-1667720448,-1667525144,'Taurus'],
  [-1667525144,-1667315287,'Gemini'],
  [-1667315287,-1667096667,'Cancer'],
  [-1667096667,-1666877462,'Leo'],
  [-1666877462,-1666663155,'Virgo'],
  [-1666663155,-1666455574,'Libra'],
  [-1666455574,-1666255312,'Scorpio'],
  [-1666255312,-1666063300,'Sagittarius'],
  [-1666063300,-1665880037,'Capricorn'],
  [-1665880037,-1665703755,'Aquarius'],
  [-1665703755,-1665529600,'Pisces'],
  [-1665529600,-1665350691,'Aries'],
  [-1665350691,-1665160301,'Taurus'],
  [-1665160301,-1664955115,'Gemini'],
  [-1664955115,-1664738479,'Cancer'],
  [-1664738479,-1664519263,'Leo'],
  [-1664519263,-1664305574,'Virgo'],
  [-1664305574,-1664100335,'Libra'],
  [-1664100335,-1663902581,'Scorpio'],
  [-1663902581,-1663710749,'Sagittarius'],
  [-1663710749,-1663524229,'Capricorn'],
  [-1663524229,-1663342520,'Aquarius'],
  [-1663342520,-1663163387,'Pisces'],
  [-1663163387,-1662982168,'Aries'],
  [-1662982168,-1662792936,'Taurus'],
  [-1662792936,-1662591166,'Gemini'],
  [-1662591166,-1662377323,'Cancer'],
  [-1662377323,-1662158457,'Leo'],
  [-1662158457,-1661944080,'Virgo'],
  [-1661944080,-1661739667,'Libra'],
  [-1661739667,-1661544968,'Scorpio'],
  [-1661544968,-1661356824,'Sagittarius'],
  [-1661356824,-1661172140,'Capricorn'],
  [-1661172140,-1660988961,'Aquarius'],
  [-1660988961,-1660805754,'Pisces'],
  [-1660805754,-1660620121,'Aries'],
  [-1660620121,-1660428439,'Taurus'],
  [-1660428439,-1660227070,'Gemini'],
  [-1660227070,-1660015065,'Cancer'],
  [-1660015065,-1659796755,'Leo'],
  [-1659796755,-1659580782,'Virgo'],
  [-1659580782,-1659374739,'Libra'],
  [-1659374739,-1659180749,'Scorpio'],
  [-1659180749,-1658996089,'Sagittarius'],
  [-1658996089,-1658816080,'Capricorn'],
  [-1658816080,-1658636270,'Aquarius'],
  [-1658636270,-1658453354,'Pisces'],
  [-1658453354,-1658265107,'Aries'],
  [-1658265107,-1658069893,'Taurus'],
  [-1658069893,-1657866409,'Gemini'],
  [-1657866409,-1657654396,'Cancer'],
  [-1657654396,-1657436437,'Leo'],
  [-1657436437,-1657218829,'Virgo'],
  [-1657218829,-1657009366,'Libra'],
  [-1657009366,-1656812774,'Scorpio'],
  [-1656812774,-1656628492,'Sagittarius'],
  [-1656628492,-1656452103,'Capricorn'],
  [-1656452103,-1656277631,'Aquarius'],
  [-1656277631,-1656099305,'Pisces'],
  [-1656099305,-1655912845,'Aries'],
  [-1655912845,-1655716365,'Taurus'],
  [-1655716365,-1655510417,'Gemini'],
  [-1655510417,-1655296990,'Cancer'],
  [-1655296990,-1655078916,'Leo'],
  [-1655078916,-1654860443,'Virgo'],
  [-1654860443,-1654647563,'Libra'],
  [-1654647563,-1654446105,'Scorpio'],
  [-1654446105,-1654258335,'Sagittarius'],
  [-1654258335,-1654081829,'Capricorn'],
  [-1654081829,-1653910802,'Aquarius'],
  [-1653910802,-1653738097,'Pisces'],
  [-1653738097,-1653557027,'Aries'],
  [-1653557027,-1653363387,'Taurus'],
  [-1653363387,-1653157242,'Gemini'],
  [-1653157242,-1652942456,'Cancer'],
  [-1652942456,-1652723885,'Leo'],
  [-1652723885,-1652505505,'Virgo'],
  [-1652505505,-1652291061,'Libra'],
  [-1652291061,-1652085113,'Scorpio'],
  [-1652085113,-1651891523,'Sagittarius'],
  [-1651891523,-1651710754,'Capricorn'],
  [-1651710754,-1651538938,'Aquarius'],
  [-1651538938,-1651369183,'Pisces'],
  [-1651369183,-1651193632,'Aries'],
  [-1651193632,-1651005663,'Taurus'],
  [-1651005663,-1650802798,'Gemini'],
  [-1650802798,-1650588441,'Cancer'],
  [-1650588441,-1650369470,'Leo'],
  [-1650369470,-1650151625,'Virgo'],
  [-1650151625,-1649937895,'Libra'],
  [-1649937895,-1649730468,'Scorpio'],
  [-1649730468,-1649532187,'Sagittarius'],
  [-1649532187,-1649345189,'Capricorn'],
  [-1649345189,-1649168451,'Aquarius'],
  [-1649168451,-1648997068,'Pisces'],
  [-1648997068,-1648823712,'Aries'],
  [-1648823712,-1648640781,'Taurus'],
  [-1648640781,-1648443233,'Gemini'],
  [-1648443233,-1648231814,'Cancer'],
  [-1648231814,-1648013281,'Leo'],
  [-1648013281,-1647795701,'Virgo'],
  [-1647795701,-1647583588,'Libra'],
  [-1647583588,-1647377972,'Scorpio'],
  [-1647377972,-1647179185,'Sagittarius'],
  [-1647179185,-1646988213,'Capricorn'],
  [-1646988213,-1646805446,'Aquarius'],
  [-1646805446,-1646628699,'Pisces'],
  [-1646628699,-1646452864,'Aries'],
  [-1646452864,-1646271250,'Taurus'],
  [-1646271250,-1646077877,'Gemini'],
  [-1646077877,-1645870664,'Cancer'],
  [-1645870664,-1645653832,'Leo'],
  [-1645653832,-1645436020,'Virgo'],
  [-1645436020,-1645224442,'Libra'],
  [-1645224442,-1645021430,'Scorpio'],
  [-1645021430,-1644825900,'Sagittarius'],
  [-1644825900,-1644636136,'Capricorn'],
  [-1644636136,-1644450966,'Aquarius'],
  [-1644450966,-1644269080,'Pisces'],
  [-1644269080,-1644087879,'Aries'],
  [-1644087879,-1643903209,'Taurus'],
  [-1643903209,-1643710332,'Gemini'],
  [-1643710332,-1643506075,'Cancer'],
  [-1643506075,-1643291604,'Leo'],
  [-1643291604,-1643073501,'Virgo'],
  [-1643073501,-1642860459,'Libra'],
  [-1642860459,-1642657784,'Scorpio'],
  [-1642657784,-1642465517,'Sagittarius'],
  [-1642465517,-1642280434,'Capricorn'],
  [-1642280434,-1642098528,'Aquarius'],
  [-1642098528,-1641916421,'Pisces'],
  [-1641916421,-1641731646,'Aries'],
  [-1641731646,-1641542244,'Taurus'],
  [-1641542244,-1641346263,'Gemini'],
  [-1641346263,-1641141915,'Cancer'],
  [-1641141915,-1640929003,'Leo'],
  [-1640929003,-1640711018,'Virgo'],
  [-1640711018,-1640495396,'Libra'],
  [-1640495396,-1640289751,'Scorpio'],
  [-1640289751,-1640097187,'Sagittarius'],
  [-1640097187,-1639915474,'Capricorn'],
  [-1639915474,-1639739185,'Aquarius'],
  [-1639739185,-1639562187,'Pisces'],
  [-1639562187,-1639379495,'Aries'],
  [-1639379495,-1639188486,'Taurus'],
  [-1639188486,-1638989000,'Gemini'],
  [-1638989000,-1638782094,'Cancer'],
  [-1638782094,-1638568879,'Leo'],
  [-1638568879,-1638351228,'Virgo'],
  [-1638351228,-1638133700,'Libra'],
  [-1638133700,-1637923510,'Scorpio'],
  [-1637923510,-1637726569,'Sagittarius'],
  [-1637726569,-1637543630,'Capricorn'],
  [-1637543630,-1637370182,'Aquarius'],
  [-1637370182,-1637198965,'Pisces'],
  [-1637198965,-1637022533,'Aries'],
  [-1637022533,-1636835440,'Taurus'],
  [-1636835440,-1636636191,'Gemini'],
  [-1636636191,-1636427248,'Cancer'],
  [-1636427248,-1636212443,'Leo'],
  [-1636212443,-1635994731,'Virgo'],
  [-1635994731,-1635776868,'Libra'],
  [-1635776868,-1635563561,'Scorpio'],
  [-1635563561,-1635360921,'Sagittarius'],
  [-1635360921,-1635172600,'Capricorn'],
  [-1635172600,-1634996888,'Aquarius'],
  [-1634996888,-1634827502,'Pisces'],
  [-1634827502,-1634656316,'Aries'],
  [-1634656316,-1634475755,'Taurus'],
  [-1634475755,-1634281334,'Gemini'],
  [-1634281334,-1634073800,'Cancer'],
  [-1634073800,-1633858182,'Leo'],
  [-1633858182,-1633639983,'Virgo'],
  [-1633639983,-1633422720,'Libra'],
  [-1633422720,-1633209171,'Scorpio'],
  [-1633209171,-1633003268,'Sagittarius'],
  [-1633003268,-1632809037,'Capricorn'],
  [-1632809037,-1632627466,'Aquarius'],
  [-1632627466,-1632454893,'Pisces'],
  [-1632454893,-1632284403,'Aries'],
  [-1632284403,-1632108167,'Taurus'],
  [-1632108167,-1631919760,'Gemini'],
  [-1631919760,-1631716876,'Cancer'],
  [-1631716876,-1631502845,'Leo'],
  [-1631502845,-1631284508,'Virgo'],
  [-1631284508,-1631067770,'Libra'],
  [-1631067770,-1630855777,'Scorpio'],
  [-1630855777,-1630650415,'Sagittarius'],
  [-1630650415,-1630453662,'Capricorn'],
  [-1630453662,-1630266758,'Aquarius'],
  [-1630266758,-1630088373,'Pisces'],
  [-1630088373,-1629914113,'Aries'],
  [-1629914113,-1629737653,'Taurus'],
  [-1629737653,-1629552552,'Gemini'],
  [-1629552552,-1629354543,'Cancer'],
  [-1629354543,-1629143976,'Leo'],
  [-1629143976,-1628926473,'Virgo'],
  [-1628926473,-1628709735,'Libra'],
  [-1628709735,-1628499091,'Scorpio'],
  [-1628499091,-1628296361,'Sagittarius'],
  [-1628296361,-1628101336,'Capricorn'],
  [-1628101336,-1627913197,'Aquarius'],
  [-1627913197,-1627730587,'Pisces'],
  [-1627730587,-1627551024,'Aries'],
  [-1627551024,-1627370664,'Taurus'],
  [-1627370664,-1627184783,'Gemini'],
  [-1627184783,-1626989078,'Cancer'],
  [-1626989078,-1626781784,'Leo'],
  [-1626781784,-1626565826,'Virgo'],
  [-1626565826,-1626348595,'Libra'],
  [-1626348595,-1626137734,'Scorpio'],
  [-1626137734,-1625936944,'Sagittarius'],
  [-1625936944,-1625745539,'Capricorn'],
  [-1625745539,-1625560432,'Aquarius'],
  [-1625560432,-1625378144,'Pisces'],
  [-1625378144,-1625195765,'Aries'],
  [-1625195765,-1625010968,'Taurus'],
  [-1625010968,-1624821487,'Gemini'],
  [-1624821487,-1624624786,'Cancer'],
  [-1624624786,-1624418835,'Leo'],
  [-1624418835,-1624204261,'Virgo'],
  [-1624204261,-1623986327,'Libra'],
  [-1623986327,-1623773461,'Scorpio'],
  [-1623773461,-1623572029,'Sagittarius'],
  [-1623572029,-1623382849,'Capricorn'],
  [-1623382849,-1623202092,'Aquarius'],
  [-1623202092,-1623024070,'Pisces'],
  [-1623024070,-1622843625,'Aries'],
  [-1622843625,-1622657543,'Taurus'],
  [-1622657543,-1622464734,'Gemini'],
  [-1622464734,-1622265072,'Cancer'],
  [-1622265072,-1622058182,'Leo'],
  [-1622058182,-1621844072,'Virgo'],
  [-1621844072,-1621625598,'Libra'],
  [-1621625598,-1621409863,'Scorpio'],
  [-1621409863,-1621204983,'Sagittarius'],
  [-1621204983,-1621014547,'Capricorn'],
  [-1621014547,-1620835921,'Aquarius'],
  [-1620835921,-1620662645,'Pisces'],
  [-1620662645,-1620487505,'Aries'],
  [-1620487505,-1620304841,'Taurus'],
  [-1620304841,-1620112220,'Gemini'],
  [-1620112220,-1619910427,'Cancer'],
  [-1619910427,-1619701436,'Leo'],
  [-1619701436,-1619486704,'Virgo'],
  [-1619486704,-1619268048,'Libra'],
  [-1619268048,-1619050175,'Scorpio'],
  [-1619050175,-1618840678,'Sagittarius'],
  [-1618840678,-1618645524,'Capricorn'],
  [-1618645524,-1618464810,'Aquarius'],
  [-1618464810,-1618293163,'Pisces'],
  [-1618293163,-1618122805,'Aries'],
  [-1618122805,-1617946169,'Taurus'],
  [-1617946169,-1617758118,'Gemini'],
  [-1617758118,-1617557704,'Cancer'],
  [-1617557704,-1617347658,'Leo'],
  [-1617347658,-1617131802,'Virgo'],
  [-1617131802,-1616913149,'Libra'],
  [-1616913149,-1616694936,'Scorpio'],
  [-1616694936,-1616482425,'Sagittarius'],
  [-1616482425,-1616281579,'Capricorn'],
  [-1616281579,-1616095109,'Aquarius'],
  [-1616095109,-1615920351,'Pisces'],
  [-1615920351,-1615750781,'Aries'],
  [-1615750781,-1615578597,'Taurus'],
  [-1615578597,-1615396829,'Gemini'],
  [-1615396829,-1615201546,'Cancer'],
  [-1615201546,-1614993484,'Leo'],
  [-1614993484,-1614777300,'Virgo'],
  [-1614777300,-1614558527,'Libra'],
  [-1614558527,-1614341298,'Scorpio'],
  [-1614341298,-1614129015,'Sagittarius'],
  [-1614129015,-1613925278,'Capricorn'],
  [-1613925278,-1613732890,'Aquarius'],
  [-1613732890,-1613551720,'Pisces'],
  [-1613551720,-1613378018,'Aries'],
  [-1613378018,-1613205617,'Taurus'],
  [-1613205617,-1613027620,'Gemini'],
  [-1613027620,-1612838225,'Cancer'],
  [-1612838225,-1612634970,'Leo'],
  [-1612634970,-1612420507,'Virgo'],
  [-1612420507,-1612201633,'Libra'],
  [-1612201633,-1611985181,'Scorpio'],
  [-1611985181,-1611775124,'Sagittarius'],
  [-1611775124,-1611572884,'Capricorn'],
  [-1611572884,-1611378767,'Aquarius'],
  [-1611378767,-1611192426,'Pisces'],
  [-1611192426,-1611012285,'Aries'],
  [-1611012285,-1610835067,'Taurus'],
  [-1610835067,-1610655920,'Gemini'],
  [-1610655920,-1610469315,'Cancer'],
  [-1610469315,-1610270820,'Leo'],
  [-1610270820,-1610059809,'Virgo'],
  [-1610059809,-1609841479,'Libra'],
  [-1609841479,-1609624604,'Scorpio'],
  [-1609624604,-1609415908,'Sagittarius'],
  [-1609415908,-1609217074,'Capricorn'],
  [-1609217074,-1609026093,'Aquarius'],
  [-1609026093,-1608839973,'Pisces'],
  [-1608839973,-1608656332,'Aries'],
  [-1608656332,-1608473481,'Taurus'],
  [-1608473481,-1608289449,'Gemini'],
  [-1608289449,-1608101038,'Cancer'],
  [-1608101038,-1607904202,'Leo'],
  [-1607904202,-1607696249,'Virgo'],
  [-1607696249,-1607479222,'Libra'],
  [-1607479222,-1607261097,'Scorpio'],
  [-1607261097,-1607051180,'Sagittarius'],
  [-1607051180,-1606853779,'Capricorn'],
  [-1606853779,-1606666934,'Aquarius'],
  [-1606666934,-1606485471,'Pisces'],
  [-1606485471,-1606304277,'Aries'],
  [-1606304277,-1606120167,'Taurus'],
  [-1606120167,-1605932041,'Gemini'],
  [-1605932041,-1605739351,'Cancer'],
  [-1605739351,-1605540495,'Leo'],
  [-1605540495,-1605333209,'Virgo'],
  [-1605333209,-1605117371,'Libra'],
  [-1605117371,-1604898186,'Scorpio'],
  [-1604898186,-1604685112,'Sagittarius'],
  [-1604685112,-1604485426,'Capricorn'],
  [-1604485426,-1604299538,'Aquarius'],
  [-1604299538,-1604122304,'Pisces'],
  [-1604122304,-1603946769,'Aries'],
  [-1603946769,-1603767018,'Taurus'],
  [-1603767018,-1603579861,'Gemini'],
  [-1603579861,-1603384911,'Cancer'],
  [-1603384911,-1603182858,'Leo'],
  [-1603182858,-1602973864,'Virgo'],
  [-1602973864,-1602758124,'Libra'],
  [-1602758124,-1602538586,'Scorpio'],
  [-1602538586,-1602322509,'Sagittarius'],
  [-1602322509,-1602118117,'Capricorn'],
  [-1602118117,-1601928864,'Aquarius'],
  [-1601928864,-1601751744,'Pisces'],
  [-1601751744,-1601579997,'Aries'],
  [-1601579997,-1601406253,'Taurus'],
  [-1601406253,-1601224649,'Gemini'],
  [-1601224649,-1601032318,'Cancer'],
  [-1601032318,-1600829586,'Leo'],
  [-1600829586,-1600618637,'Virgo'],
  [-1600618637,-1600401951,'Libra'],
  [-1600401951,-1600182485,'Scorpio'],
  [-1600182485,-1599965192,'Sagittarius'],
  [-1599965192,-1599756667,'Capricorn'],
  [-1599756667,-1599561770,'Aquarius'],
  [-1599561770,-1599380405,'Pisces'],
  [-1599380405,-1599207854,'Aries'],
  [-1599207854,-1599037185,'Taurus'],
  [-1599037185,-1598861368,'Gemini'],
  [-1598861368,-1598674937,'Cancer'],
  [-1598674937,-1598475565,'Leo'],
  [-1598475565,-1598264878,'Virgo'],
  [-1598264878,-1598047354,'Libra'],
  [-1598047354,-1597827963,'Scorpio'],
  [-1597827963,-1597611227,'Sagittarius'],
  [-1597611227,-1597401395,'Capricorn'],
  [-1597401395,-1597202115,'Aquarius'],
  [-1597202115,-1597014800,'Pisces'],
  [-1597014800,-1596837460,'Aries'],
  [-1596837460,-1596665231,'Taurus'],
  [-1596665231,-1596491720,'Gemini'],
  [-1596491720,-1596310432,'Cancer'],
  [-1596310432,-1596116499,'Leo'],
  [-1596116499,-1595908924,'Virgo'],
  [-1595908924,-1595691878,'Libra'],
  [-1595691878,-1595472499,'Scorpio'],
  [-1595472499,-1595256932,'Sagittarius'],
  [-1595256932,-1595048512,'Capricorn'],
  [-1595048512,-1594848513,'Aquarius'],
  [-1594848513,-1594657316,'Pisces'],
  [-1594657316,-1594474278,'Aries'],
  [-1594474278,-1594297097,'Taurus'],
  [-1594297097,-1594121515,'Gemini'],
  [-1594121515,-1593941784,'Cancer'],
  [-1593941784,-1593752040,'Leo'],
  [-1593752040,-1593548740,'Virgo'],
  [-1593548740,-1593333698,'Libra'],
  [-1593333698,-1593114419,'Scorpio'],
  [-1593114419,-1592899410,'Sagittarius'],
  [-1592899410,-1592693171,'Capricorn'],
  [-1592693171,-1592495645,'Aquarius'],
  [-1592495645,-1592304848,'Pisces'],
  [-1592304848,-1592119009,'Aries'],
  [-1592119009,-1591936845,'Taurus'],
  [-1591936845,-1591756498,'Gemini'],
  [-1591756498,-1591574411,'Cancer'],
  [-1591574411,-1591385531,'Leo'],
  [-1591385531,-1591185236,'Virgo'],
  [-1591185236,-1590972732,'Libra'],
  [-1590972732,-1590753754,'Scorpio'],
  [-1590753754,-1590538063,'Sagittarius'],
  [-1590538063,-1590332613,'Capricorn'],
  [-1590332613,-1590138059,'Aquarius'],
  [-1590138059,-1589950877,'Pisces'],
  [-1589950877,-1589766908,'Aries'],
  [-1589766908,-1589583433,'Taurus'],
  [-1589583433,-1589399190,'Gemini'],
  [-1589399190,-1589212823,'Cancer'],
  [-1589212823,-1589021528,'Leo'],
  [-1589021528,-1588821526,'Virgo'],
  [-1588821526,-1588610691,'Libra'],
  [-1588610691,-1588392145,'Scorpio'],
  [-1588392145,-1588174754,'Sagittarius'],
  [-1588174754,-1587967572,'Capricorn'],
  [-1587967572,-1587773670,'Aquarius'],
  [-1587773670,-1587589943,'Pisces'],
  [-1587589943,-1587410687,'Aries'],
  [-1587410687,-1587230706,'Taurus'],
  [-1587230706,-1587046872,'Gemini'],
  [-1587046872,-1586857949,'Cancer'],
  [-1586857949,-1586663120,'Leo'],
  [-1586663120,-1586460939,'Virgo'],
  [-1586460939,-1586250041,'Libra'],
  [-1586250041,-1586031826,'Scorpio'],
  [-1586031826,-1585812708,'Sagittarius'],
  [-1585812708,-1585601819,'Capricorn'],
  [-1585601819,-1585404954,'Aquarius'],
  [-1585404954,-1585221343,'Pisces'],
  [-1585221343,-1585045656,'Aries'],
  [-1585045656,-1584871269,'Taurus'],
  [-1584871269,-1584692464,'Gemini'],
  [-1584692464,-1584505676,'Cancer'],
  [-1584505676,-1584309707,'Leo'],
  [-1584309707,-1584104947,'Virgo'],
  [-1584104947,-1583892470,'Libra'],
  [-1583892470,-1583674173,'Scorpio'],
  [-1583674173,-1583454338,'Sagittarius'],
  [-1583454338,-1583239938,'Capricorn'],
  [-1583239938,-1583037660,'Aquarius'],
  [-1583037660,-1582849786,'Pisces'],
  [-1582849786,-1582673334,'Aries'],
  [-1582673334,-1582502202,'Taurus'],
  [-1582502202,-1582329423,'Gemini'],
  [-1582329423,-1582148789,'Cancer'],
  [-1582148789,-1581956359,'Leo'],
  [-1581956359,-1581751690,'Virgo'],
  [-1581751690,-1581537693,'Libra'],
  [-1581537693,-1581318760,'Scorpio'],
  [-1581318760,-1581099279,'Sagittarius'],
  [-1581099279,-1580883768,'Capricorn'],
  [-1580883768,-1580677039,'Aquarius'],
  [-1580677039,-1580482662,'Pisces'],
  [-1580482662,-1580300800,'Aries'],
  [-1580300800,-1580127832,'Taurus'],
  [-1580127832,-1579957546,'Gemini'],
  [-1579957546,-1579782722,'Cancer'],
  [-1579782722,-1579596822,'Leo'],
  [-1579596822,-1579396355,'Virgo'],
  [-1579396355,-1579183162,'Libra'],
  [-1579183162,-1578963657,'Scorpio'],
  [-1578963657,-1578744663,'Sagittarius'],
  [-1578744663,-1578530413,'Capricorn'],
  [-1578530413,-1578323077,'Aquarius'],
  [-1578323077,-1578124466,'Pisces'],
  [-1578124466,-1577935911,'Aries'],
  [-1577935911,-1577756832,'Taurus'],
  [-1577756832,-1577583660,'Gemini'],
  [-1577583660,-1577410221,'Cancer'],
  [-1577410221,-1577229257,'Leo'],
  [-1577229257,-1577034756,'Virgo'],
  [-1577034756,-1576825367,'Libra'],
  [-1576825367,-1576606588,'Scorpio'],
  [-1576606588,-1576387575,'Sagittarius'],
  [-1576387575,-1576174835,'Capricorn'],
  [-1576174835,-1575969952,'Aquarius'],
  [-1575969952,-1575772074,'Pisces'],
  [-1575772074,-1575580626,'Aries'],
  [-1575580626,-1575395683,'Taurus'],
  [-1575395683,-1575216378,'Gemini'],
  [-1575216378,-1575039276,'Cancer'],
  [-1575039276,-1574858519,'Leo'],
  [-1574858519,-1574667653,'Virgo'],
  [-1574667653,-1574462793,'Libra'],
  [-1574462793,-1574246350,'Scorpio'],
  [-1574246350,-1574027164,'Sagittarius'],
  [-1574027164,-1573814406,'Capricorn'],
  [-1573814406,-1573611689,'Aquarius'],
  [-1573611689,-1573417428,'Pisces'],
  [-1573417428,-1573228473,'Aries'],
  [-1573228473,-1573042691,'Taurus'],
  [-1573042691,-1572859176,'Gemini'],
  [-1572859176,-1572676646,'Cancer'],
  [-1572676646,-1572491976,'Leo'],
  [-1572491976,-1572300434,'Virgo'],
  [-1572300434,-1572097808,'Libra'],
  [-1572097808,-1571883894,'Scorpio'],
  [-1571883894,-1571664892,'Sagittarius'],
  [-1571664892,-1571450535,'Capricorn'],
  [-1571450535,-1571247321,'Aquarius'],
  [-1571247321,-1571055412,'Pisces'],
  [-1571055412,-1570870927,'Aries'],
  [-1570870927,-1570689285,'Taurus'],
  [-1570689285,-1570507105,'Gemini'],
  [-1570507105,-1570322387,'Cancer'],
  [-1570322387,-1570133534,'Leo'],
  [-1570133534,-1569938449,'Virgo'],
  [-1569938449,-1569734798,'Libra'],
  [-1569734798,-1569521909,'Scorpio'],
  [-1569521909,-1569303327,'Sagittarius'],
  [-1569303327,-1569086910,'Capricorn'],
  [-1569086910,-1568880596,'Aquarius'],
  [-1568880596,-1568687455,'Pisces'],
  [-1568687455,-1568505118,'Aries'],
  [-1568505118,-1568328346,'Taurus'],
  [-1568328346,-1568151475,'Gemini'],
  [-1568151475,-1567969891,'Cancer'],
  [-1567969891,-1567780727,'Leo'],
  [-1567780727,-1567582894,'Virgo'],
  [-1567582894,-1567376576,'Libra'],
  [-1567376576,-1567162852,'Scorpio'],
  [-1567162852,-1566944451,'Sagittarius'],
  [-1566944451,-1566726674,'Capricorn'],
  [-1566726674,-1566516483,'Aquarius'],
  [-1566516483,-1566319010,'Pisces'],
  [-1566319010,-1566134684,'Aries'],
  [-1566134684,-1565959612,'Taurus'],
  [-1565959612,-1565787561,'Gemini'],
  [-1565787561,-1565611854,'Cancer'],
  [-1565611854,-1565426982,'Leo'],
  [-1565426982,-1565230205,'Virgo'],
  [-1565230205,-1565022443,'Libra'],
  [-1565022443,-1564807183,'Scorpio'],
  [-1564807183,-1564588519,'Sagittarius'],
  [-1564588519,-1564370524,'Capricorn'],
  [-1564370524,-1564157837,'Aquarius'],
  [-1564157837,-1563955372,'Pisces'],
  [-1563955372,-1563765897,'Aries'],
  [-1563765897,-1563588176,'Taurus'],
  [-1563588176,-1563417217,'Gemini'],
  [-1563417217,-1563245914,'Cancer'],
  [-1563245914,-1563066933,'Leo'],
  [-1563066933,-1562874880,'Virgo'],
  [-1562874880,-1562668853,'Libra'],
  [-1562668853,-1562453109,'Scorpio'],
  [-1562453109,-1562234035,'Sagittarius'],
  [-1562234035,-1562016581,'Capricorn'],
  [-1562016581,-1561803791,'Aquarius'],
  [-1561803791,-1561598509,'Pisces'],
  [-1561598509,-1561403668,'Aries'],
  [-1561403668,-1561220391,'Taurus'],
  [-1561220391,-1561046220,'Gemini'],
  [-1561046220,-1560875299,'Cancer'],
  [-1560875299,-1560700070,'Leo'],
  [-1560700070,-1560513455,'Virgo'],
  [-1560513455,-1560311832,'Libra'],
  [-1560311832,-1560097751,'Scorpio'],
  [-1560097751,-1559878689,'Sagittarius'],
  [-1559878689,-1559661799,'Capricorn'],
  [-1559661799,-1559450523,'Aquarius'],
  [-1559450523,-1559245820,'Pisces'],
  [-1559245820,-1559048657,'Aries'],
  [-1559048657,-1558860311,'Taurus'],
  [-1558860311,-1558680532,'Gemini'],
  [-1558680532,-1558505931,'Cancer'],
  [-1558505931,-1558330367,'Leo'],
  [-1558330367,-1558146735,'Virgo'],
  [-1558146735,-1557949662,'Libra'],
  [-1557949662,-1557738909,'Scorpio'],
  [-1557738909,-1557520697,'Sagittarius'],
  [-1557520697,-1557303841,'Capricorn'],
  [-1557303841,-1557093908,'Aquarius'],
  [-1557093908,-1556891819,'Pisces'],
  [-1556891819,-1556696434,'Aries'],
  [-1556696434,-1556506946,'Taurus'],
  [-1556506946,-1556322983,'Gemini'],
  [-1556322983,-1556143072,'Cancer'],
  [-1556143072,-1555963543,'Leo'],
  [-1555963543,-1555778984,'Virgo'],
  [-1555778984,-1555584074,'Libra'],
  [-1555584074,-1555376540,'Scorpio'],
  [-1555376540,-1555159872,'Sagittarius'],
  [-1555159872,-1554942442,'Capricorn'],
  [-1554942442,-1554732148,'Aquarius'],
  [-1554732148,-1554531922,'Pisces'],
  [-1554531922,-1554340263,'Aries'],
  [-1554340263,-1554154086,'Taurus'],
  [-1554154086,-1553970677,'Gemini'],
  [-1553970677,-1553787976,'Cancer'],
  [-1553787976,-1553603830,'Leo'],
  [-1553603830,-1553415356,'Virgo'],
  [-1553415356,-1553219193,'Libra'],
  [-1553219193,-1553012983,'Scorpio'],
  [-1553012983,-1552797820,'Sagittarius'],
  [-1552797820,-1552579658,'Capricorn'],
  [-1552579658,-1552366999,'Aquarius'],
  [-1552366999,-1552165657,'Pisces'],
  [-1552165657,-1551976010,'Aries'],
  [-1551976010,-1551794452,'Taurus'],
  [-1551794452,-1551615931,'Gemini'],
  [-1551615931,-1551435765,'Cancer'],
  [-1551435765,-1551250607,'Leo'],
  [-1551250607,-1551058626,'Virgo'],
  [-1551058626,-1550859054,'Libra'],
  [-1550859054,-1550651624,'Scorpio'],
  [-1550651624,-1550437028,'Sagittarius'],
  [-1550437028,-1550218548,'Capricorn'],
  [-1550218548,-1550002832,'Aquarius'],
  [-1550002832,-1549797284,'Pisces'],
  [-1549797284,-1549605487,'Aries'],
  [-1549605487,-1549425612,'Taurus'],
  [-1549425612,-1549252090,'Gemini'],
  [-1549252090,-1549078045,'Cancer'],
  [-1549078045,-1548897314,'Leo'],
  [-1548897314,-1548706211,'Virgo'],
  [-1548706211,-1548504541,'Libra'],
  [-1548504541,-1548294640,'Scorpio'],
  [-1548294640,-1548079244,'Sagittarius'],
  [-1548079244,-1547860880,'Capricorn'],
  [-1547860880,-1547643412,'Aquarius'],
  [-1547643412,-1547433022,'Pisces'],
  [-1547433022,-1547235496,'Aries'],
  [-1547235496,-1547052308,'Taurus'],
  [-1547052308,-1546879616,'Gemini'],
  [-1546879616,-1546710237,'Cancer'],
  [-1546710237,-1546536171,'Leo'],
  [-1546536171,-1546350829,'Virgo'],
  [-1546350829,-1546151579,'Libra'],
  [-1546151579,-1545940943,'Scorpio'],
  [-1545940943,-1545724216,'Sagittarius'],
  [-1545724216,-1545505825,'Capricorn'],
  [-1545505825,-1545288582,'Aquarius'],
  [-1545288582,-1545075924,'Pisces'],
  [-1545075924,-1544872798,'Aries'],
  [-1544872798,-1544682994,'Taurus'],
  [-1544682994,-1544505891,'Gemini'],
  [-1544505891,-1544336110,'Cancer'],
  [-1544336110,-1544165761,'Leo'],
  [-1544165761,-1543986823,'Virgo'],
  [-1543986823,-1543793717,'Libra'],
  [-1543793717,-1543586184,'Scorpio'],
  [-1543586184,-1543369564,'Sagittarius'],
  [-1543369564,-1543150864,'Capricorn'],
  [-1543150864,-1542934600,'Aquarius'],
  [-1542934600,-1542722928,'Pisces'],
  [-1542722928,-1542518130,'Aries'],
  [-1542518130,-1542323138,'Taurus'],
  [-1542323138,-1542139341,'Gemini'],
  [-1542139341,-1541964375,'Cancer'],
  [-1541964375,-1541792389,'Leo'],
  [-1541792389,-1541615954,'Virgo'],
  [-1541615954,-1541428317,'Libra'],
  [-1541428317,-1541226210,'Scorpio'],
  [-1541226210,-1541012210,'Sagittarius'],
  [-1541012210,-1540793665,'Capricorn'],
  [-1540793665,-1540577776,'Aquarius'],
  [-1540577776,-1540368116,'Pisces'],
  [-1540368116,-1540165524,'Aries'],
  [-1540165524,-1539970278,'Taurus'],
  [-1539970278,-1539782641,'Gemini'],
  [-1539782641,-1539601704,'Cancer'],
  [-1539601704,-1539424341,'Leo'],
  [-1539424341,-1539245438,'Virgo'],
  [-1539245438,-1539059190,'Libra'],
  [-1539059190,-1538861168,'Scorpio'],
  [-1538861168,-1538650922,'Sagittarius'],
  [-1538650922,-1538433498,'Capricorn'],
  [-1538433498,-1538217135,'Aquarius'],
  [-1538217135,-1538008141,'Pisces'],
  [-1538008141,-1537808417,'Aries'],
  [-1537808417,-1537616661,'Taurus'],
  [-1537616661,-1537430493,'Gemini'],
  [-1537430493,-1537247560,'Cancer'],
  [-1537247560,-1537065543,'Leo'],
  [-1537065543,-1536881727,'Virgo'],
  [-1536881727,-1536692780,'Libra'],
  [-1536692780,-1536495317,'Scorpio'],
  [-1536495317,-1536287562,'Sagittarius'],
  [-1536287562,-1536071658,'Capricorn'],
  [-1536071658,-1535854421,'Aquarius'],
  [-1535854421,-1535643991,'Pisces'],
  [-1535643991,-1535444901,'Aries'],
  [-1535444901,-1535256529,'Taurus'],
  [-1535256529,-1535074872,'Gemini'],
  [-1535074872,-1534895023,'Cancer'],
  [-1534895023,-1534712911,'Leo'],
  [-1534712911,-1534526023,'Virgo'],
  [-1534526023,-1534333113,'Libra'],
  [-1534333113,-1534133255,'Scorpio'],
  [-1534133255,-1533925552,'Sagittarius'],
  [-1533925552,-1533710574,'Capricorn'],
  [-1533710574,-1533492565,'Aquarius'],
  [-1533492565,-1533279321,'Pisces'],
  [-1533279321,-1533077803,'Aries'],
  [-1533077803,-1532889773,'Taurus'],
  [-1532889773,-1532711606,'Gemini'],
  [-1532711606,-1532536894,'Cancer'],
  [-1532536894,-1532359155,'Leo'],
  [-1532359155,-1532173820,'Virgo'],
  [-1532173820,-1531979371,'Libra'],
  [-1531979371,-1531776721,'Scorpio'],
  [-1531776721,-1531567281,'Sagittarius'],
  [-1531567281,-1531352158,'Capricorn'],
  [-1531352158,-1531133772,'Aquarius'],
  [-1531133772,-1530917853,'Pisces'],
  [-1530917853,-1530711976,'Aries'],
  [-1530711976,-1530520626,'Taurus'],
  [-1530520626,-1530342278,'Gemini'],
  [-1530342278,-1530170793,'Cancer'],
  [-1530170793,-1529998436,'Leo'],
  [-1529998436,-1529818337,'Virgo'],
  [-1529818337,-1529626644,'Libra'],
  [-1529626644,-1529423697,'Scorpio'],
  [-1529423697,-1529212612,'Sagittarius'],
  [-1529212612,-1528996605,'Capricorn'],
  [-1528996605,-1528778204,'Aquarius'],
  [-1528778204,-1528561109,'Pisces'],
  [-1528561109,-1528351337,'Aries'],
  [-1528351337,-1528154594,'Taurus'],
  [-1528154594,-1527972131,'Gemini'],
  [-1527972131,-1527799750,'Cancer'],
  [-1527799750,-1527630103,'Leo'],
  [-1527630103,-1527455319,'Virgo'],
  [-1527455319,-1527269231,'Libra'],
  [-1527269231,-1527069639,'Scorpio'],
  [-1527069639,-1526859001,'Sagittarius'],
  [-1526859001,-1526642304,'Capricorn'],
  [-1526642304,-1526423998,'Aquarius'],
  [-1526423998,-1526207423,'Pisces'],
  [-1526207423,-1525996389,'Aries'],
  [-1525996389,-1525795338,'Taurus'],
  [-1525795338,-1525606958,'Gemini'],
  [-1525606958,-1525429770,'Cancer'],
  [-1525429770,-1525258422,'Leo'],
  [-1525258422,-1525085702,'Virgo'],
  [-1525085702,-1524904573,'Libra'],
  [-1524904573,-1524710373,'Scorpio'],
  [-1524710373,-1524502917,'Sagittarius'],
  [-1524502917,-1524286764,'Capricorn'],
  [-1524286764,-1524068462,'Aquarius'],
  [-1524068462,-1523853063,'Pisces'],
  [-1523853063,-1523643546,'Aries'],
  [-1523643546,-1523441926,'Taurus'],
  [-1523441926,-1523249651,'Gemini'],
  [-1523249651,-1523066555,'Cancer'],
  [-1523066555,-1522889918,'Leo'],
  [-1522889918,-1522714763,'Virgo'],
  [-1522714763,-1522535005,'Libra'],
  [-1522535005,-1522345070,'Scorpio'],
  [-1522345070,-1522142092,'Sagittarius'],
  [-1522142092,-1521928071,'Capricorn'],
  [-1521928071,-1521709766,'Aquarius'],
  [-1521709766,-1521494771,'Pisces'],
  [-1521494771,-1521287514,'Aries'],
  [-1521287514,-1521088751,'Taurus'],
  [-1521088751,-1520897295,'Gemini'],
  [-1520897295,-1520711520,'Cancer'],
  [-1520711520,-1520529608,'Leo'],
  [-1520529608,-1520349089,'Virgo'],
  [-1520349089,-1520166405,'Libra'],
  [-1520166405,-1519977133,'Scorpio'],
  [-1519977133,-1519777344,'Sagittarius'],
  [-1519777344,-1519566157,'Capricorn'],
  [-1519566157,-1519348155,'Aquarius'],
  [-1519348155,-1519132082,'Pisces'],
  [-1519132082,-1518925251,'Aries'],
  [-1518925251,-1518729577,'Taurus'],
  [-1518729577,-1518542369,'Gemini'],
  [-1518542369,-1518359277,'Cancer'],
  [-1518359277,-1518176591,'Leo'],
  [-1518176591,-1517992112,'Virgo'],
  [-1517992112,-1517804564,'Libra'],
  [-1517804564,-1517612242,'Scorpio'],
  [-1517612242,-1517412475,'Sagittarius'],
  [-1517412475,-1517203132,'Capricorn'],
  [-1517203132,-1516985818,'Aquarius'],
  [-1516985818,-1516767801,'Pisces'],
  [-1516767801,-1516558472,'Aries'],
  [-1516558472,-1516362764,'Taurus'],
  [-1516362764,-1516178917,'Gemini'],
  [-1516178917,-1516001143,'Cancer'],
  [-1516001143,-1515823067,'Leo'],
  [-1515823067,-1515640085,'Virgo'],
  [-1515640085,-1515450434,'Libra'],
  [-1515450434,-1515254313,'Scorpio'],
  [-1515254313,-1515051813,'Sagittarius'],
  [-1515051813,-1514842112,'Capricorn'],
  [-1514842112,-1514625354,'Aquarius'],
  [-1514625354,-1514405901,'Pisces'],
  [-1514405901,-1514192499,'Aries'],
  [-1514192499,-1513992793,'Taurus'],
  [-1513992793,-1513807983,'Gemini'],
  [-1513807983,-1513633156,'Cancer'],
  [-1513633156,-1513460840,'Leo'],
  [-1513460840,-1513283953,'Virgo'],
  [-1513283953,-1513097890,'Libra'],
  [-1513097890,-1512901627,'Scorpio'],
  [-1512901627,-1512696702,'Sagittarius'],
  [-1512696702,-1512485022,'Capricorn'],
  [-1512485022,-1512267992,'Aquarius'],
  [-1512267992,-1512048286,'Pisces'],
  [-1512048286,-1511831969,'Aries'],
  [-1511831969,-1511626700,'Taurus'],
  [-1511626700,-1511436615,'Gemini'],
  [-1511436615,-1511259633,'Cancer'],
  [-1511259633,-1511089322,'Leo'],
  [-1511089322,-1510917945,'Virgo'],
  [-1510917945,-1510738648,'Libra'],
  [-1510738648,-1510547306,'Scorpio'],
  [-1510547306,-1510343702,'Sagittarius'],
  [-1510343702,-1510130871,'Capricorn'],
  [-1510130871,-1509912910,'Aquarius'],
  [-1509912910,-1509693533,'Pisces'],
  [-1509693533,-1509476912,'Aries'],
  [-1509476912,-1509268278,'Taurus'],
  [-1509268278,-1509072074,'Gemini'],
  [-1509072074,-1508889026,'Cancer'],
  [-1508889026,-1508715460,'Leo'],
  [-1508715460,-1508544973,'Virgo'],
  [-1508544973,-1508370422,'Libra'],
  [-1508370422,-1508185606,'Scorpio'],
  [-1508185606,-1507987138,'Sagittarius'],
  [-1507987138,-1507776132,'Capricorn'],
  [-1507776132,-1507557860,'Aquarius'],
  [-1507557860,-1507338650,'Pisces'],
  [-1507338650,-1507123331,'Aries'],
  [-1507123331,-1506915057,'Taurus'],
  [-1506915057,-1506716032,'Gemini'],
  [-1506716032,-1506527239,'Cancer'],
  [-1506527239,-1506347464,'Leo'],
  [-1506347464,-1506173032,'Virgo'],
  [-1506173032,-1505998400,'Libra'],
  [-1505998400,-1505817288,'Scorpio'],
  [-1505817288,-1505624327,'Sagittarius'],
  [-1505624327,-1505417540,'Capricorn'],
  [-1505417540,-1505200583,'Aquarius'],
  [-1505200583,-1504981364,'Pisces'],
  [-1504981364,-1504767138,'Aries'],
  [-1504767138,-1504561242,'Taurus'],
  [-1504561242,-1504363678,'Gemini'],
  [-1504363678,-1504173302,'Cancer'],
  [-1504173302,-1503988861,'Leo'],
  [-1503988861,-1503808712,'Virgo'],
  [-1503808712,-1503629963,'Libra'],
  [-1503629963,-1503448080,'Scorpio'],
  [-1503448080,-1503257699,'Sagittarius'],
  [-1503257699,-1503054867,'Capricorn'],
  [-1503054867,-1502840361,'Aquarius'],
  [-1502840361,-1502621243,'Pisces'],
  [-1502621243,-1502406864,'Aries'],
  [-1502406864,-1502202675,'Taurus'],
  [-1502202675,-1502008423,'Gemini'],
  [-1502008423,-1501820769,'Cancer'],
  [-1501820769,-1501636326,'Leo'],
  [-1501636326,-1501452995,'Virgo'],
  [-1501452995,-1501269473,'Libra'],
  [-1501269473,-1501083731,'Scorpio'],
  [-1501083731,-1500892200,'Sagittarius'],
  [-1500892200,-1500690900,'Capricorn'],
  [-1500690900,-1500478517,'Aquarius'],
  [-1500478517,-1500259662,'Pisces'],
  [-1500259662,-1500043867,'Aries'],
  [-1500043867,-1499839079,'Taurus'],
  [-1499839079,-1499646776,'Gemini'],
  [-1499646776,-1499463113,'Cancer'],
  [-1499463113,-1499282616,'Leo'],
  [-1499282616,-1499100927,'Virgo'],
  [-1499100927,-1498915842,'Libra'],
  [-1498915842,-1498726497,'Scorpio'],
  [-1498726497,-1498531672,'Sagittarius'],
  [-1498531672,-1498329172,'Capricorn'],
  [-1498329172,-1498117445,'Aquarius'],
  [-1498117445,-1497898847,'Pisces'],
  [-1497898847,-1497681123,'Aries'],
  [-1497681123,-1497473401,'Taurus'],
  [-1497473401,-1497279840,'Gemini'],
  [-1497279840,-1497098016,'Cancer'],
  [-1497098016,-1496921922,'Leo'],
  [-1496921922,-1496745223,'Virgo'],
  [-1496745223,-1496563277,'Libra'],
  [-1496563277,-1496373900,'Scorpio'],
  [-1496373900,-1496176678,'Sagittarius'],
  [-1496176678,-1495971678,'Capricorn'],
  [-1495971678,-1495759040,'Aquarius'],
  [-1495759040,-1495540477,'Pisces'],
  [-1495540477,-1495321382,'Aries'],
  [-1495321382,-1495109857,'Taurus'],
  [-1495109857,-1494912004,'Gemini'],
  [-1494912004,-1494728107,'Cancer'],
  [-1494728107,-1494553462,'Leo'],
  [-1494553462,-1494381309,'Virgo'],
  [-1494381309,-1494205100,'Libra'],
  [-1494205100,-1494020027,'Scorpio'],
  [-1494020027,-1493824001,'Sagittarius'],
  [-1493824001,-1493617682,'Capricorn'],
  [-1493617682,-1493403515,'Aquarius'],
  [-1493403515,-1493184661,'Pisces'],
  [-1493184661,-1492965374,'Aries'],
  [-1492965374,-1492751389,'Taurus'],
  [-1492751389,-1492548427,'Gemini'],
  [-1492548427,-1492359126,'Cancer'],
  [-1492359126,-1492181509,'Leo'],
  [-1492181509,-1492010201,'Virgo'],
  [-1492010201,-1491838376,'Libra'],
  [-1491838376,-1491659362,'Scorpio'],
  [-1491659362,-1491468277,'Sagittarius'],
  [-1491468277,-1491263849,'Capricorn'],
  [-1491263849,-1491049171,'Aquarius'],
  [-1491049171,-1490829847,'Pisces'],
  [-1490829847,-1490611205,'Aries'],
  [-1490611205,-1490397358,'Taurus'],
  [-1490397358,-1490191671,'Gemini'],
  [-1490191671,-1489996720,'Cancer'],
  [-1489996720,-1489812954,'Leo'],
  [-1489812954,-1489637811,'Virgo'],
  [-1489637811,-1489466044,'Libra'],
  [-1489466044,-1489290878,'Scorpio'],
  [-1489290878,-1489105610,'Sagittarius'],
  [-1489105610,-1488906016,'Capricorn'],
  [-1488906016,-1488693185,'Aquarius'],
  [-1488693185,-1488473754,'Pisces'],
  [-1488473754,-1488255627,'Aries'],
  [-1488255627,-1488043594,'Taurus'],
  [-1488043594,-1487839013,'Gemini'],
  [-1487839013,-1487642069,'Cancer'],
  [-1487642069,-1487453026,'Leo'],
  [-1487453026,-1487271544,'Virgo'],
  [-1487271544,-1487095267,'Libra'],
  [-1487095267,-1486919252,'Scorpio'],
  [-1486919252,-1486736926,'Sagittarius'],
  [-1486736926,-1486542267,'Capricorn'],
  [-1486542267,-1486333256,'Aquarius'],
  [-1486333256,-1486114786,'Pisces'],
  [-1486114786,-1485896416,'Aries'],
  [-1485896416,-1485685586,'Taurus'],
  [-1485685586,-1485483994,'Gemini'],
  [-1485483994,-1485289648,'Cancer'],
  [-1485289648,-1485100273,'Leo'],
  [-1485100273,-1484914842,'Virgo'],
  [-1484914842,-1484732762,'Libra'],
  [-1484732762,-1484551939,'Scorpio'],
  [-1484551939,-1484367933,'Sagittarius'],
  [-1484367933,-1484175114,'Capricorn'],
  [-1484175114,-1483969583,'Aquarius'],
  [-1483969583,-1483753073,'Pisces'],
  [-1483753073,-1483534039,'Aries'],
  [-1483534039,-1483322255,'Taurus'],
  [-1483322255,-1483122041,'Gemini'],
  [-1483122041,-1482931568,'Cancer'],
  [-1482931568,-1482746441,'Leo'],
  [-1482746441,-1482562883,'Virgo'],
  [-1482562883,-1482378932,'Libra'],
  [-1482378932,-1482193577,'Scorpio'],
  [-1482193577,-1482005031,'Sagittarius'],
  [-1482005031,-1481810074,'Capricorn'],
  [-1481810074,-1481605373,'Aquarius'],
  [-1481605373,-1481390586,'Pisces'],
  [-1481390586,-1481171193,'Aries'],
  [-1481171193,-1480956755,'Taurus'],
  [-1480956755,-1480754461,'Gemini'],
  [-1480754461,-1480564984,'Cancer'],
  [-1480564984,-1480384098,'Leo'],
  [-1480384098,-1480206106,'Virgo'],
  [-1480206106,-1480026172,'Libra'],
  [-1480026172,-1479841277,'Scorpio'],
  [-1479841277,-1479649943,'Sagittarius'],
  [-1479649943,-1479451307,'Capricorn'],
  [-1479451307,-1479244606,'Aquarius'],
  [-1479244606,-1479030005,'Pisces'],
  [-1479030005,-1478810707,'Aries'],
  [-1478810707,-1478593742,'Taurus'],
  [-1478593742,-1478386971,'Gemini'],
  [-1478386971,-1478194183,'Cancer'],
  [-1478194183,-1478013527,'Leo'],
  [-1478013527,-1477839579,'Virgo'],
  [-1477839579,-1477665846,'Libra'],
  [-1477665846,-1477486490,'Scorpio'],
  [-1477486490,-1477297577,'Sagittarius'],
  [-1477297577,-1477097886,'Capricorn'],
  [-1477097886,-1476888750,'Aquarius'],
  [-1476888750,-1476672853,'Pisces'],
  [-1476672853,-1476453608,'Aries'],
  [-1476453608,-1476235646,'Taurus'],
  [-1476235646,-1476024888,'Gemini'],
  [-1476024888,-1475826397,'Cancer'],
  [-1475826397,-1475641421,'Leo'],
  [-1475641421,-1475466813,'Virgo'],
  [-1475466813,-1475296470,'Libra'],
  [-1475296470,-1475123206,'Scorpio'],
  [-1475123206,-1474940459,'Sagittarius'],
  [-1474940459,-1474744309,'Capricorn'],
  [-1474744309,-1474535367,'Aquarius'],
  [-1474535367,-1474318303,'Pisces'],
  [-1474318303,-1474098783,'Aries'],
  [-1474098783,-1473881224,'Taurus'],
  [-1473881224,-1473669140,'Gemini'],
  [-1473669140,-1473466173,'Cancer'],
  [-1473466173,-1473275029,'Leo'],
  [-1473275029,-1473095497,'Virgo'],
  [-1473095497,-1472923661,'Libra'],
  [-1472923661,-1472752873,'Scorpio'],
  [-1472752873,-1472575548,'Sagittarius'],
  [-1472575548,-1472385318,'Capricorn'],
  [-1472385318,-1472180018,'Aquarius'],
  [-1472180018,-1471963659,'Pisces'],
  [-1471963659,-1471743946,'Aries'],
  [-1471743946,-1471527182,'Taurus'],
  [-1471527182,-1471316228,'Gemini'],
  [-1471316228,-1471112379,'Cancer'],
  [-1471112379,-1470917161,'Leo'],
  [-1470917161,-1470731684,'Virgo'],
  [-1470731684,-1470554723,'Libra'],
  [-1470554723,-1470381764,'Scorpio'],
  [-1470381764,-1470205972,'Sagittarius'],
  [-1470205972,-1470020188,'Capricorn'],
  [-1470020188,-1469819831,'Aquarius'],
  [-1469819831,-1469606262,'Pisces'],
  [-1469606262,-1469387019,'Aries'],
  [-1469387019,-1469170628,'Taurus'],
  [-1469170628,-1468961432,'Gemini'],
  [-1468961432,-1468759706,'Cancer'],
  [-1468759706,-1468564656,'Leo'],
  [-1468564656,-1468376149,'Virgo'],
  [-1468376149,-1468193972,'Libra'],
  [-1468193972,-1468016020,'Scorpio'],
  [-1468016020,-1467837617,'Sagittarius'],
  [-1467837617,-1467652575,'Capricorn'],
  [-1467652575,-1467455542,'Aquarius'],
  [-1467455542,-1467245352,'Pisces'],
  [-1467245352,-1467027311,'Aries'],
  [-1467027311,-1466810599,'Taurus'],
  [-1466810599,-1466601982,'Gemini'],
  [-1466601982,-1466402807,'Cancer'],
  [-1466402807,-1466211007,'Leo'],
  [-1466211007,-1466024072,'Virgo'],
  [-1466024072,-1465840310,'Libra'],
  [-1465840310,-1465658214,'Scorpio'],
  [-1465658214,-1465475242,'Sagittarius'],
  [-1465475242,-1465287468,'Capricorn'],
  [-1465287468,-1465090628,'Aquarius'],
  [-1465090628,-1464882541,'Pisces'],
  [-1464882541,-1464665885,'Aries'],
  [-1464665885,-1464448365,'Taurus'],
  [-1464448365,-1464238339,'Gemini'],
  [-1464238339,-1464039652,'Cancer'],
  [-1464039652,-1463850977,'Leo'],
  [-1463850977,-1463668385,'Virgo'],
  [-1463668385,-1463487717,'Libra'],
  [-1463487717,-1463305679,'Scorpio'],
  [-1463305679,-1463119852,'Sagittarius'],
  [-1463119852,-1462928220,'Capricorn'],
  [-1462928220,-1462728903,'Aquarius'],
  [-1462728903,-1462520717,'Pisces'],
  [-1462520717,-1462304897,'Aries'],
  [-1462304897,-1462086591,'Taurus'],
  [-1462086591,-1461873668,'Gemini'],
  [-1461873668,-1461672365,'Cancer'],
  [-1461672365,-1461483819,'Leo'],
  [-1461483819,-1461304630,'Virgo'],
  [-1461304630,-1461129187,'Libra'],
  [-1461129187,-1460951683,'Scorpio'],
  [-1460951683,-1460767559,'Sagittarius'],
  [-1460767559,-1460574444,'Capricorn'],
  [-1460574444,-1460372238,'Aquarius'],
  [-1460372238,-1460162203,'Pisces'],
  [-1460162203,-1459946251,'Aries'],
  [-1459946251,-1459727647,'Taurus'],
  [-1459727647,-1459511976,'Gemini'],
  [-1459511976,-1459305942,'Cancer'],
  [-1459305942,-1459113566,'Leo'],
  [-1459113566,-1458933869,'Virgo'],
  [-1458933869,-1458761691,'Libra'],
  [-1458761691,-1458589896,'Scorpio'],
  [-1458589896,-1458411447,'Sagittarius'],
  [-1458411447,-1458221450,'Capricorn'],
  [-1458221450,-1458019035,'Aquarius'],
  [-1458019035,-1457807222,'Pisces'],
  [-1457807222,-1457590328,'Aries'],
  [-1457590328,-1457371885,'Taurus'],
  [-1457371885,-1457155254,'Gemini'],
  [-1457155254,-1456945196,'Cancer'],
  [-1456945196,-1456746800,'Leo'],
  [-1456746800,-1456562170,'Virgo'],
  [-1456562170,-1456388550,'Libra'],
  [-1456388550,-1456219372,'Scorpio'],
  [-1456219372,-1456046573,'Sagittarius'],
  [-1456046573,-1455862844,'Capricorn'],
  [-1455862844,-1455664423,'Aquarius'],
  [-1455664423,-1455453296,'Pisces'],
  [-1455453296,-1455235626,'Aries'],
  [-1455235626,-1455017290,'Taurus'],
  [-1455017290,-1454801545,'Gemini'],
  [-1454801545,-1454590705,'Cancer'],
  [-1454590705,-1454388084,'Leo'],
  [-1454388084,-1454196931,'Virgo'],
  [-1454196931,-1454017530,'Libra'],
  [-1454017530,-1453845780,'Scorpio'],
  [-1453845780,-1453674530,'Sagittarius'],
  [-1453674530,-1453495828,'Capricorn'],
  [-1453495828,-1453303490,'Aquarius'],
  [-1453303490,-1453096341,'Pisces'],
  [-1453096341,-1452879524,'Aries'],
  [-1452879524,-1452661031,'Taurus'],
  [-1452661031,-1452446422,'Gemini'],
  [-1452446422,-1452237613,'Cancer'],
  [-1452237613,-1452035335,'Leo'],
  [-1452035335,-1451840923,'Virgo'],
  [-1451840923,-1451655438,'Libra'],
  [-1451655438,-1451477539,'Scorpio'],
  [-1451477539,-1451302705,'Sagittarius'],
  [-1451302705,-1451124375,'Capricorn'],
  [-1451124375,-1450936001,'Aquarius'],
  [-1450936001,-1450733869,'Pisces'],
  [-1450733869,-1450519914,'Aries'],
  [-1450519914,-1450301548,'Taurus'],
  [-1450301548,-1450086875,'Gemini'],
  [-1450086875,-1449880005,'Cancer'],
  [-1449880005,-1449681073,'Leo'],
  [-1449681073,-1449488753,'Virgo'],
  [-1449488753,-1449301882,'Libra'],
  [-1449301882,-1449119256,'Scorpio'],
  [-1449119256,-1448938627,'Sagittarius'],
  [-1448938627,-1448756212,'Capricorn'],
  [-1448756212,-1448567279,'Aquarius'],
  [-1448567279,-1448367813,'Pisces'],
  [-1448367813,-1448157060,'Aries'],
  [-1448157060,-1447939533,'Taurus'],
  [-1447939533,-1447723588,'Gemini'],
  [-1447723588,-1447516258,'Cancer'],
  [-1447516258,-1447319671,'Leo'],
  [-1447319671,-1447131781,'Virgo'],
  [-1447131781,-1446948798,'Libra'],
  [-1446948798,-1446767036,'Scorpio'],
  [-1446767036,-1446583655,'Sagittarius'],
  [-1446583655,-1446396536,'Capricorn'],
  [-1446396536,-1446203737,'Aquarius'],
  [-1446203737,-1446003242,'Pisces'],
  [-1446003242,-1445793873,'Aries'],
  [-1445793873,-1445577394,'Taurus'],
  [-1445577394,-1445359939,'Gemini'],
  [-1445359939,-1445149736,'Cancer'],
  [-1445149736,-1444951998,'Leo'],
  [-1444951998,-1444766393,'Virgo'],
  [-1444766393,-1444588375,'Libra'],
  [-1444588375,-1444411856,'Scorpio'],
  [-1444411856,-1444231388,'Sagittarius'],
  [-1444231388,-1444043599,'Capricorn'],
  [-1444043599,-1443847623,'Aquarius'],
  [-1443847623,-1443644088,'Pisces'],
  [-1443644088,-1443433719,'Aries'],
  [-1443433719,-1443217611,'Taurus'],
  [-1443217611,-1442999248,'Gemini'],
  [-1442999248,-1442785509,'Cancer'],
  [-1442785509,-1442583536,'Leo'],
  [-1442583536,-1442395997,'Virgo'],
  [-1442395997,-1442219776,'Libra'],
  [-1442219776,-1442048154,'Scorpio'],
  [-1442048154,-1441873642,'Sagittarius'],
  [-1441873642,-1441690218,'Capricorn'],
  [-1441690218,-1441495265,'Aquarius'],
  [-1441495265,-1441290066,'Pisces'],
  [-1441290066,-1441077778,'Aries'],
  [-1441077778,-1440861112,'Taurus'],
  [-1440861112,-1440642568,'Gemini'],
  [-1440642568,-1440426601,'Cancer'],
  [-1440426601,-1440219797,'Leo'],
  [-1440219797,-1440027103,'Virgo'],
  [-1440027103,-1439848184,'Libra'],
  [-1439848184,-1439677592,'Scorpio'],
  [-1439677592,-1439507485,'Sagittarius'],
  [-1439507485,-1439330137,'Capricorn'],
  [-1439330137,-1439140240,'Aquarius'],
  [-1439140240,-1438937052,'Pisces'],
  [-1438937052,-1438724225,'Aries'],
  [-1438724225,-1438506759,'Taurus'],
  [-1438506759,-1438288391,'Gemini'],
  [-1438288391,-1438072260,'Cancer'],
  [-1438072260,-1437862759,'Leo'],
  [-1437862759,-1437664739,'Virgo'],
  [-1437664739,-1437480181,'Libra'],
  [-1437480181,-1437306206,'Scorpio'],
  [-1437306206,-1437136293,'Sagittarius'],
  [-1437136293,-1436962673,'Capricorn'],
  [-1436962673,-1436778495,'Aquarius'],
  [-1436778495,-1436580257,'Pisces'],
  [-1436580257,-1436369575,'Aries'],
  [-1436369575,-1436152136,'Taurus'],
  [-1436152136,-1435933947,'Gemini'],
  [-1435933947,-1435718946,'Cancer'],
  [-1435718946,-1435509881,'Leo'],
  [-1435509881,-1435309509,'Virgo'],
  [-1435309509,-1435119821,'Libra'],
  [-1435119821,-1434940096,'Scorpio'],
  [-1434940096,-1434766280,'Sagittarius'],
  [-1434766280,-1434592136,'Capricorn'],
  [-1434592136,-1434410972,'Aquarius'],
  [-1434410972,-1434217673,'Pisces'],
  [-1434217673,-1434011031,'Aries'],
  [-1434011031,-1433795029,'Taurus'],
  [-1433795029,-1433576924,'Gemini'],
  [-1433576924,-1433362920,'Cancer'],
  [-1433362920,-1433156089,'Leo'],
  [-1433156089,-1432957222,'Virgo'],
  [-1432957222,-1432766177,'Libra'],
  [-1432766177,-1432582090,'Scorpio'],
  [-1432582090,-1432402780,'Sagittarius'],
  [-1432402780,-1432224488,'Capricorn'],
  [-1432224488,-1432042300,'Aquarius'],
  [-1432042300,-1431851274,'Pisces'],
  [-1431851274,-1431648357,'Aries'],
  [-1431648357,-1431434740,'Taurus'],
  [-1431434740,-1431216716,'Gemini'],
  [-1431216716,-1431002481,'Cancer'],
  [-1431002481,-1430797273,'Leo'],
  [-1430797273,-1430601738,'Virgo'],
  [-1430601738,-1430413545,'Libra'],
  [-1430413545,-1430229586,'Scorpio'],
  [-1430229586,-1430047162,'Sagittarius'],
  [-1430047162,-1429864032,'Capricorn'],
  [-1429864032,-1429677811,'Aquarius'],
  [-1429677811,-1429485495,'Pisces'],
  [-1429485495,-1429284060,'Aries'],
  [-1429284060,-1429072557,'Taurus'],
  [-1429072557,-1428854732,'Gemini'],
  [-1428854732,-1428638859,'Cancer'],
  [-1428638859,-1428432813,'Leo'],
  [-1428432813,-1428239198,'Virgo'],
  [-1428239198,-1428055220,'Libra'],
  [-1428055220,-1427875545,'Scorpio'],
  [-1427875545,-1427695045,'Sagittarius'],
  [-1427695045,-1427510426,'Capricorn'],
  [-1427510426,-1427320423,'Aquarius'],
  [-1427320423,-1427124565,'Pisces'],
  [-1427124565,-1426921818,'Aries'],
  [-1426921818,-1426711026,'Taurus'],
  [-1426711026,-1426493517,'Gemini'],
  [-1426493517,-1426275511,'Cancer'],
  [-1426275511,-1426066016,'Leo'],
  [-1426066016,-1425870665,'Virgo'],
  [-1425870665,-1425688408,'Libra'],
  [-1425688408,-1425513408,'Scorpio'],
  [-1425513408,-1425338466,'Sagittarius'],
  [-1425338466,-1425157623,'Capricorn'],
  [-1425157623,-1424967943,'Aquarius'],
  [-1424967943,-1424769647,'Pisces'],
  [-1424769647,-1424564170,'Aries'],
  [-1424564170,-1424352348,'Taurus'],
  [-1424352348,-1424135008,'Gemini'],
  [-1424135008,-1423915760,'Cancer'],
  [-1423915760,-1423702150,'Leo'],
  [-1423702150,-1423501712,'Virgo'],
  [-1423501712,-1423316561,'Libra'],
  [-1423316561,-1423142526,'Scorpio'],
  [-1423142526,-1422972150,'Sagittarius'],
  [-1422972150,-1422797680,'Capricorn'],
  [-1422797680,-1422613301,'Aquarius'],
  [-1422613301,-1422416972,'Pisces'],
  [-1422416972,-1422210400,'Aries'],
  [-1422210400,-1421996860,'Taurus'],
  [-1421996860,-1421779148,'Gemini'],
  [-1421779148,-1421560043,'Cancer'],
  [-1421560043,-1421344391,'Leo'],
  [-1421344391,-1421138690,'Virgo'],
  [-1421138690,-1420947262,'Libra'],
  [-1420947262,-1420769081,'Scorpio'],
  [-1420769081,-1420598507,'Sagittarius'],
  [-1420598507,-1420427942,'Capricorn'],
  [-1420427942,-1420250056,'Aquarius'],
  [-1420250056,-1420059781,'Pisces'],
  [-1420059781,-1419856146,'Aries'],
  [-1419856146,-1419642458,'Taurus'],
  [-1419642458,-1419424058,'Gemini'],
  [-1419424058,-1419205581,'Cancer'],
  [-1419205581,-1418990727,'Leo'],
  [-1418990727,-1418783241,'Virgo'],
  [-1418783241,-1418586515,'Libra'],
  [-1418586515,-1418401579,'Scorpio'],
  [-1418401579,-1418225854,'Sagittarius'],
  [-1418225854,-1418053873,'Capricorn'],
  [-1418053873,-1417878872,'Aquarius'],
  [-1417878872,-1417694445,'Pisces'],
  [-1417694445,-1417496538,'Aries'],
  [-1417496538,-1417285665,'Taurus'],
  [-1417285665,-1417067371,'Gemini'],
  [-1417067371,-1416849028,'Cancer'],
  [-1416849028,-1416635943,'Leo'],
  [-1416635943,-1416430436,'Virgo'],
  [-1416430436,-1416233127,'Libra'],
  [-1416233127,-1416043945,'Scorpio'],
  [-1416043945,-1415861872,'Sagittarius'],
  [-1415861872,-1415684340,'Capricorn'],
  [-1415684340,-1415507010,'Aquarius'],
  [-1415507010,-1415324330,'Pisces'],
  [-1415324330,-1415130989,'Aries'],
  [-1415130989,-1414924448,'Taurus'],
  [-1414924448,-1414707745,'Gemini'],
  [-1414707745,-1414489064,'Cancer'],
  [-1414489064,-1414276556,'Leo'],
  [-1414276556,-1414073780,'Virgo'],
  [-1414073780,-1413879755,'Libra'],
  [-1413879755,-1413691712,'Scorpio'],
  [-1413691712,-1413507197,'Sagittarius'],
  [-1413507197,-1413324541,'Capricorn'],
  [-1413324541,-1413141999,'Aquarius'],
  [-1413141999,-1412956566,'Pisces'],
  [-1412956566,-1412763945,'Aries'],
  [-1412763945,-1412560348,'Taurus'],
  [-1412560348,-1412345864,'Gemini'],
  [-1412345864,-1412126875,'Cancer'],
  [-1412126875,-1411913120,'Leo'],
  [-1411913120,-1411710934,'Virgo'],
  [-1411710934,-1411520172,'Libra'],
  [-1411520172,-1411336491,'Scorpio'],
  [-1411336491,-1411154873,'Sagittarius'],
  [-1411154873,-1410971831,'Capricorn'],
  [-1410971831,-1410785855,'Aquarius'],
  [-1410785855,-1410596119,'Pisces'],
  [-1410596119,-1410400831,'Aries'],
  [-1410400831,-1410197243,'Taurus'],
  [-1410197243,-1409984082,'Gemini'],
  [-1409984082,-1409765010,'Cancer'],
  [-1409765010,-1409548936,'Leo'],
  [-1409548936,-1409344436,'Virgo'],
  [-1409344436,-1409153902,'Libra'],
  [-1409153902,-1408973554,'Scorpio'],
  [-1408973554,-1408796996,'Sagittarius'],
  [-1408796996,-1408618304,'Capricorn'],
  [-1408618304,-1408433808,'Aquarius'],
  [-1408433808,-1408242352,'Pisces'],
  [-1408242352,-1408043929,'Aries'],
  [-1408043929,-1407838194,'Taurus'],
  [-1407838194,-1407624752,'Gemini'],
  [-1407624752,-1407405659,'Cancer'],
  [-1407405659,-1407187493,'Leo'],
  [-1407187493,-1406978974,'Virgo'],
  [-1406978974,-1406785112,'Libra'],
  [-1406785112,-1406604386,'Scorpio'],
  [-1406604386,-1406430896,'Sagittarius'],
  [-1406430896,-1406257579,'Capricorn'],
  [-1406257579,-1406078417,'Aquarius'],
  [-1406078417,-1405889835,'Pisces'],
  [-1405889835,-1405691088,'Aries'],
  [-1405691088,-1405483386,'Taurus'],
  [-1405483386,-1405268627,'Gemini'],
  [-1405268627,-1405049372,'Cancer'],
  [-1405049372,-1404830317,'Leo'],
  [-1404830317,-1404618307,'Virgo'],
  [-1404618307,-1404419237,'Libra'],
  [-1404419237,-1404234315,'Scorpio'],
  [-1404234315,-1404059748,'Sagittarius'],
  [-1404059748,-1403889050,'Capricorn'],
  [-1403889050,-1403715242,'Aquarius'],
  [-1403715242,-1403532439,'Pisces'],
  [-1403532439,-1403337316,'Aries'],
  [-1403337316,-1403130155,'Taurus'],
  [-1403130155,-1402914446,'Gemini'],
  [-1402914446,-1402694889,'Cancer'],
  [-1402694889,-1402476176,'Leo'],
  [-1402476176,-1402263014,'Virgo'],
  [-1402263014,-1402059815,'Libra'],
  [-1402059815,-1401869045,'Scorpio'],
  [-1401869045,-1401689616,'Sagittarius'],
  [-1401689616,-1401517166,'Capricorn'],
  [-1401517166,-1401345425,'Aquarius'],
  [-1401345425,-1401167638,'Pisces'],
  [-1401167638,-1400978155,'Aries'],
  [-1400978155,-1400774600,'Taurus'],
  [-1400774600,-1400559673,'Gemini'],
  [-1400559673,-1400339957,'Cancer'],
  [-1400339957,-1400122037,'Leo'],
  [-1400122037,-1399910077,'Virgo'],
  [-1399910077,-1399706144,'Libra'],
  [-1399706144,-1399511415,'Scorpio'],
  [-1399511415,-1399326053,'Sagittarius'],
  [-1399326053,-1399148343,'Capricorn'],
  [-1399148343,-1398974254,'Aquarius'],
  [-1398974254,-1398797885,'Pisces'],
  [-1398797885,-1398612754,'Aries'],
  [-1398612754,-1398414074,'Taurus'],
  [-1398414074,-1398201912,'Gemini'],
  [-1398201912,-1397982606,'Cancer'],
  [-1397982606,-1397765028,'Leo'],
  [-1397765028,-1397554924,'Virgo'],
  [-1397554924,-1397353335,'Libra'],
  [-1397353335,-1397158966,'Scorpio'],
  [-1397158966,-1396970596,'Sagittarius'],
  [-1396970596,-1396787460,'Capricorn'],
  [-1396787460,-1396608054,'Aquarius'],
  [-1396608054,-1396428855,'Pisces'],
  [-1396428855,-1396244419,'Aries'],
  [-1396244419,-1396049120,'Taurus'],
  [-1396049120,-1395840422,'Gemini'],
  [-1395840422,-1395622285,'Cancer'],
  [-1395622285,-1395404196,'Leo'],
  [-1395404196,-1395194550,'Virgo'],
  [-1395194550,-1394995655,'Libra'],
  [-1394995655,-1394804921,'Scorpio'],
  [-1394804921,-1394618563,'Sagittarius'],
  [-1394618563,-1394434059,'Capricorn'],
  [-1394434059,-1394250341,'Aquarius'],
  [-1394250341,-1394066179,'Pisces'],
  [-1394066179,-1393878647,'Aries'],
  [-1393878647,-1393683370,'Taurus'],
  [-1393683370,-1393476856,'Gemini'],
  [-1393476856,-1393260243,'Cancer'],
  [-1393260243,-1393041194,'Leo'],
  [-1393041194,-1392829675,'Virgo'],
  [-1392829675,-1392630870,'Libra'],
  [-1392630870,-1392443244,'Scorpio'],
  [-1392443244,-1392261716,'Sagittarius'],
  [-1392261716,-1392081132,'Capricorn'],
  [-1392081132,-1391898155,'Aquarius'],
  [-1391898155,-1391711320,'Pisces'],
  [-1391711320,-1391519638,'Aries'],
  [-1391519638,-1391321384,'Taurus'],
  [-1391321384,-1391114480,'Gemini'],
  [-1391114480,-1390898833,'Cancer'],
  [-1390898833,-1390679190,'Leo'],
  [-1390679190,-1390464458,'Virgo'],
  [-1390464458,-1390262190,'Libra'],
  [-1390262190,-1390073804,'Scorpio'],
  [-1390073804,-1389895251,'Sagittarius'],
  [-1389895251,-1389720271,'Capricorn'],
  [-1389720271,-1389542911,'Aquarius'],
  [-1389542911,-1389358973,'Pisces'],
  [-1389358973,-1389166499,'Aries'],
  [-1389166499,-1388965291,'Taurus'],
  [-1388965291,-1388756030,'Gemini'],
  [-1388756030,-1388540024,'Cancer'],
  [-1388540024,-1388320445,'Leo'],
  [-1388320445,-1388103369,'Virgo'],
  [-1388103369,-1387896044,'Libra'],
  [-1387896044,-1387702702,'Scorpio'],
  [-1387702702,-1387522255,'Sagittarius'],
  [-1387522255,-1387349594,'Capricorn'],
  [-1387349594,-1387177931,'Aquarius'],
  [-1387177931,-1387000612,'Pisces'],
  [-1387000612,-1386812669,'Aries'],
  [-1386812669,-1386612304,'Taurus'],
  [-1386612304,-1386401407,'Gemini'],
  [-1386401407,-1386184080,'Cancer'],
  [-1386184080,-1385964667,'Leo'],
  [-1385964667,-1385747377,'Virgo'],
  [-1385747377,-1385536852,'Libra'],
  [-1385536852,-1385337477,'Scorpio'],
  [-1385337477,-1385151031,'Sagittarius'],
  [-1385151031,-1384975365,'Capricorn'],
  [-1384975365,-1384805002,'Aquarius'],
  [-1384805002,-1384632760,'Pisces'],
  [-1384632760,-1384451496,'Aries'],
  [-1384451496,-1384256303,'Taurus'],
  [-1384256303,-1384047129,'Gemini'],
  [-1384047129,-1383829226,'Cancer'],
  [-1383829226,-1383609647,'Leo'],
  [-1383609647,-1383393418,'Virgo'],
  [-1383393418,-1383183126,'Libra'],
  [-1383183126,-1382980804,'Scorpio'],
  [-1382980804,-1382788405,'Sagittarius'],
  [-1382788405,-1382606395,'Capricorn'],
  [-1382606395,-1382432193,'Aquarius'],
  [-1382432193,-1382260111,'Pisces'],
  [-1382260111,-1382082821,'Aries'],
  [-1382082821,-1381893502,'Taurus'],
  [-1381893502,-1381688990,'Gemini'],
  [-1381688990,-1381472681,'Cancer'],
  [-1381472681,-1381253024,'Leo'],
  [-1381253024,-1381037592,'Virgo'],
  [-1381037592,-1380829388,'Libra'],
  [-1380829388,-1380628331,'Scorpio'],
  [-1380628331,-1380434143,'Sagittarius'],
  [-1380434143,-1380247166,'Capricorn'],
  [-1380247166,-1380066985,'Aquarius'],
  [-1380066985,-1379890655,'Pisces'],
  [-1379890655,-1379712553,'Aries'],
  [-1379712553,-1379525975,'Taurus'],
  [-1379525975,-1379325926,'Gemini'],
  [-1379325926,-1379112778,'Cancer'],
  [-1379112778,-1378893686,'Leo'],
  [-1378893686,-1378678082,'Virgo'],
  [-1378678082,-1378471288,'Libra'],
  [-1378471288,-1378273272,'Scorpio'],
  [-1378273272,-1378081661,'Sagittarius'],
  [-1378081661,-1377894525,'Capricorn'],
  [-1377894525,-1377710908,'Aquarius'],
  [-1377710908,-1377529498,'Pisces'],
  [-1377529498,-1377347212,'Aries'],
  [-1377347212,-1377159246,'Taurus'],
  [-1377159246,-1376960836,'Gemini'],
  [-1376960836,-1376750402,'Cancer'],
  [-1376750402,-1376532359,'Leo'],
  [-1376532359,-1376315772,'Virgo'],
  [-1376315772,-1376108311,'Libra'],
  [-1376108311,-1375911965,'Scorpio'],
  [-1375911965,-1375724154,'Sagittarius'],
  [-1375724154,-1375540884,'Capricorn'],
  [-1375540884,-1375358819,'Aquarius'],
  [-1375358819,-1375175681,'Pisces'],
  [-1375175681,-1374989503,'Aries'],
  [-1374989503,-1374797845,'Taurus'],
  [-1374797845,-1374597941,'Gemini'],
  [-1374597941,-1374388280,'Cancer'],
  [-1374388280,-1374171101,'Leo'],
  [-1374171101,-1373953285,'Virgo'],
  [-1373953285,-1373743202,'Libra'],
  [-1373743202,-1373545506,'Scorpio'],
  [-1373545506,-1373359340,'Sagittarius'],
  [-1373359340,-1373180359,'Capricorn'],
  [-1373180359,-1373003216,'Aquarius'],
  [-1373003216,-1372823169,'Pisces'],
  [-1372823169,-1372636880,'Aries'],
  [-1372636880,-1372442593,'Taurus'],
  [-1372442593,-1372239821,'Gemini'],
  [-1372239821,-1372028977,'Cancer'],
  [-1372028977,-1371811952,'Leo'],
  [-1371811952,-1371593291,'Virgo'],
  [-1371593291,-1371379942,'Libra'],
  [-1371379942,-1371178178,'Scorpio'],
  [-1371178178,-1370989922,'Sagittarius'],
  [-1370989922,-1370812329,'Capricorn'],
  [-1370812329,-1370639643,'Aquarius'],
  [-1370639643,-1370465226,'Pisces'],
  [-1370465226,-1370283222,'Aries'],
  [-1370283222,-1370090145,'Taurus'],
  [-1370090145,-1369885930,'Gemini'],
  [-1369885930,-1369673256,'Cancer'],
  [-1369673256,-1369455659,'Leo'],
  [-1369455659,-1369236824,'Virgo'],
  [-1369236824,-1369021347,'Libra'],
  [-1369021347,-1368814836,'Scorpio'],
  [-1368814836,-1368621393,'Sagittarius'],
  [-1368621393,-1368440959,'Capricorn'],
  [-1368440959,-1368269160,'Aquarius'],
  [-1368269160,-1368099013,'Pisces'],
  [-1368099013,-1367922944,'Aries'],
  [-1367922944,-1367734867,'Taurus'],
  [-1367734867,-1367532707,'Gemini'],
  [-1367532707,-1367319541,'Cancer'],
  [-1367319541,-1367101196,'Leo'],
  [-1367101196,-1366882623,'Virgo'],
  [-1366882623,-1366667087,'Libra'],
  [-1366667087,-1366457907,'Scorpio'],
  [-1366457907,-1366258984,'Sagittarius'],
  [-1366258984,-1366072624,'Capricorn'],
  [-1366072624,-1365897216,'Aquarius'],
  [-1365897216,-1365727194,'Pisces'],
  [-1365727194,-1365554871,'Aries'],
  [-1365554871,-1365372595,'Taurus'],
  [-1365372595,-1365175521,'Gemini'],
  [-1365175521,-1364964592,'Cancer'],
  [-1364964592,-1364746279,'Leo'],
  [-1364746279,-1364527922,'Virgo'],
  [-1364527922,-1364313687,'Libra'],
  [-1364313687,-1364105175,'Scorpio'],
  [-1364105175,-1363903993,'Sagittarius'],
  [-1363903993,-1363712265,'Capricorn'],
  [-1363712265,-1363530627,'Aquarius'],
  [-1363530627,-1363356257,'Pisces'],
  [-1363356257,-1363183133,'Aries'],
  [-1363183133,-1363003818,'Taurus'],
  [-1363003818,-1362811917,'Gemini'],
  [-1362811917,-1362605365,'Cancer'],
  [-1362605365,-1362388636,'Leo'],
  [-1362388636,-1362170264,'Virgo'],
  [-1362170264,-1361956966,'Libra'],
  [-1361956966,-1361750923,'Scorpio'],
  [-1361750923,-1361551754,'Sagittarius'],
  [-1361551754,-1361359108,'Capricorn'],
  [-1361359108,-1361173088,'Aquarius'],
  [-1361173088,-1360992742,'Pisces'],
  [-1360992742,-1360814772,'Aries'],
  [-1360814772,-1360633801,'Taurus'],
  [-1360633801,-1360443940,'Gemini'],
  [-1360443940,-1360241394,'Cancer'],
  [-1360241394,-1360027460,'Leo'],
  [-1360027460,-1359809186,'Virgo'],
  [-1359809186,-1359595245,'Libra'],
  [-1359595245,-1359390480,'Scorpio'],
  [-1359390480,-1359194858,'Sagittarius'],
  [-1359194858,-1359005900,'Capricorn'],
  [-1359005900,-1358820981,'Aquarius'],
  [-1358820981,-1358638031,'Pisces'],
  [-1358638031,-1358455018,'Aries'],
  [-1358455018,-1358269231,'Taurus'],
  [-1358269231,-1358077218,'Gemini'],
  [-1358077218,-1357875804,'Cancer'],
  [-1357875804,-1357664270,'Leo'],
  [-1357664270,-1357446550,'Virgo'],
  [-1357446550,-1357230690,'Libra'],
  [-1357230690,-1357024208,'Scorpio'],
  [-1357024208,-1356829727,'Sagittarius'],
  [-1356829727,-1356644986,'Capricorn'],
  [-1356644986,-1356465264,'Aquarius'],
  [-1356465264,-1356285620,'Pisces'],
  [-1356285620,-1356102257,'Aries'],
  [-1356102257,-1355912989,'Taurus'],
  [-1355912989,-1355716861,'Gemini'],
  [-1355716861,-1355513335,'Cancer'],
  [-1355513335,-1355302222,'Leo'],
  [-1355302222,-1355085199,'Virgo'],
  [-1355085199,-1354867556,'Libra'],
  [-1354867556,-1354657138,'Scorpio'],
  [-1354657138,-1354459689,'Sagittarius'],
  [-1354459689,-1354275491,'Capricorn'],
  [-1354275491,-1354099996,'Aquarius'],
  [-1354099996,-1353926426,'Pisces'],
  [-1353926426,-1353748180,'Aries'],
  [-1353748180,-1353560740,'Taurus'],
  [-1353560740,-1353362961,'Gemini'],
  [-1353362961,-1353156538,'Cancer'],
  [-1353156538,-1352943871,'Leo'],
  [-1352943871,-1352726951,'Virgo'],
  [-1352726951,-1352508693,'Libra'],
  [-1352508693,-1352294733,'Scorpio'],
  [-1352294733,-1352091854,'Sagittarius'],
  [-1352091854,-1351903562,'Capricorn'],
  [-1351903562,-1351727671,'Aquarius'],
  [-1351727671,-1351557676,'Pisces'],
  [-1351557676,-1351385581,'Aries'],
  [-1351385581,-1351204256,'Taurus'],
  [-1351204256,-1351009834,'Gemini'],
  [-1351009834,-1350803311,'Cancer'],
  [-1350803311,-1350589076,'Leo'],
  [-1350589076,-1350371505,'Virgo'],
  [-1350371505,-1350153538,'Libra'],
  [-1350153538,-1349938430,'Scorpio'],
  [-1349938430,-1349731257,'Sagittarius'],
  [-1349731257,-1349536835,'Capricorn'],
  [-1349536835,-1349356040,'Aquarius'],
  [-1349356040,-1349184590,'Pisces'],
  [-1349184590,-1349015035,'Aries'],
  [-1349015035,-1348839304,'Taurus'],
  [-1348839304,-1348651069,'Gemini'],
  [-1348651069,-1348448418,'Cancer'],
  [-1348448418,-1348234889,'Leo'],
  [-1348234889,-1348016799,'Virgo'],
  [-1348016799,-1347799215,'Libra'],
  [-1347799215,-1347585068,'Scorpio'],
  [-1347585068,-1347377085,'Sagittarius'],
  [-1347377085,-1347178618,'Capricorn'],
  [-1347178618,-1346991764,'Aquarius'],
  [-1346991764,-1346815004,'Pisces'],
  [-1346815004,-1346643097,'Aries'],
  [-1346643097,-1346468865,'Taurus'],
  [-1346468865,-1346285311,'Gemini'],
  [-1346285311,-1346088077,'Cancer'],
  [-1346088077,-1345877843,'Leo'],
  [-1345877843,-1345660382,'Virgo'],
  [-1345660382,-1345442903,'Libra'],
  [-1345442903,-1345230148,'Scorpio'],
  [-1345230148,-1345024139,'Sagittarius'],
  [-1345024139,-1344825846,'Capricorn'],
  [-1344825846,-1344635917,'Aquarius'],
  [-1344635917,-1344453766,'Pisces'],
  [-1344453766,-1344276582,'Aries'],
  [-1344276582,-1344099476,'Taurus'],
  [-1344099476,-1343916607,'Gemini'],
  [-1343916607,-1343722962,'Cancer'],
  [-1343722962,-1343516691,'Leo'],
  [-1343516691,-1343301040,'Virgo'],
  [-1343301040,-1343083443,'Libra'],
  [-1343083443,-1342871056,'Scorpio'],
  [-1342871056,-1342667320,'Sagittarius'],
  [-1342667320,-1342472131,'Capricorn'],
  [-1342472131,-1342283697,'Aquarius'],
  [-1342283697,-1342099873,'Pisces'],
  [-1342099873,-1341918371,'Aries'],
  [-1341918371,-1341736433,'Taurus'],
  [-1341736433,-1341550603,'Gemini'],
  [-1341550603,-1341357096,'Cancer'],
  [-1341357096,-1341153202,'Leo'],
  [-1341153202,-1340939569,'Virgo'],
  [-1340939569,-1340721777,'Libra'],
  [-1340721777,-1340508193,'Scorpio'],
  [-1340508193,-1340304824,'Sagittarius'],
  [-1340304824,-1340112546,'Capricorn'],
  [-1340112546,-1339928241,'Aquarius'],
  [-1339928241,-1339747338,'Pisces'],
  [-1339747338,-1339565772,'Aries'],
  [-1339565772,-1339380839,'Taurus'],
  [-1339380839,-1339190966,'Gemini'],
  [-1339190966,-1338994785,'Cancer'],
  [-1338994785,-1338790704,'Leo'],
  [-1338790704,-1338578178,'Virgo'],
  [-1338578178,-1338360239,'Libra'],
  [-1338360239,-1338144354,'Scorpio'],
  [-1338144354,-1337938627,'Sagittarius'],
  [-1337938627,-1337746459,'Capricorn'],
  [-1337746459,-1337565347,'Aquarius'],
  [-1337565347,-1337389361,'Pisces'],
  [-1337389361,-1337212076,'Aries'],
  [-1337212076,-1337028705,'Taurus'],
  [-1337028705,-1336837262,'Gemini'],
  [-1336837262,-1336638061,'Cancer'],
  [-1336638061,-1336431884,'Leo'],
  [-1336431884,-1336219063,'Virgo'],
  [-1336219063,-1336001058,'Libra'],
  [-1336001058,-1335783005,'Scorpio'],
  [-1335783005,-1335573100,'Sagittarius'],
  [-1335573100,-1335377426,'Capricorn'],
  [-1335377426,-1335195857,'Aquarius'],
  [-1335195857,-1335022931,'Pisces'],
  [-1335022931,-1334851040,'Aries'],
  [-1334851040,-1334673092,'Taurus'],
  [-1334673092,-1334484652,'Gemini'],
  [-1334484652,-1334285218,'Cancer'],
  [-1334285218,-1334077114,'Leo'],
  [-1334077114,-1333863000,'Virgo'],
  [-1333863000,-1333644887,'Libra'],
  [-1333644887,-1333425977,'Scorpio'],
  [-1333425977,-1333212443,'Sagittarius'],
  [-1333212443,-1333011177,'Capricorn'],
  [-1333011177,-1332824991,'Aquarius'],
  [-1332824991,-1332650717,'Pisces'],
  [-1332650717,-1332481346,'Aries'],
  [-1332481346,-1332308895,'Taurus'],
  [-1332308895,-1332126612,'Gemini'],
  [-1332126612,-1331931184,'Cancer'],
  [-1331931184,-1331723823,'Leo'],
  [-1331723823,-1331508750,'Virgo'],
  [-1331508750,-1331290324,'Libra'],
  [-1331290324,-1331071923,'Scorpio'],
  [-1331071923,-1330857467,'Sagittarius'],
  [-1330857467,-1330652015,'Capricorn'],
  [-1330652015,-1330459466,'Aquarius'],
  [-1330459466,-1330279595,'Pisces'],
  [-1330279595,-1330107784,'Aries'],
  [-1330107784,-1329937002,'Taurus'],
  [-1329937002,-1329759882,'Gemini'],
  [-1329759882,-1329570704,'Cancer'],
  [-1329570704,-1329367586,'Leo'],
  [-1329367586,-1329153562,'Virgo'],
  [-1329153562,-1328934854,'Libra'],
  [-1328934854,-1328717214,'Scorpio'],
  [-1328717214,-1328504356,'Sagittarius'],
  [-1328504356,-1328298810,'Capricorn'],
  [-1328298810,-1328102600,'Aquarius'],
  [-1328102600,-1327916410,'Pisces'],
  [-1327916410,-1327738400,'Aries'],
  [-1327738400,-1327564174,'Taurus'],
  [-1327564174,-1327387740,'Gemini'],
  [-1327387740,-1327202920,'Cancer'],
  [-1327202920,-1327005301,'Leo'],
  [-1327005301,-1326794718,'Virgo'],
  [-1326794718,-1326576532,'Libra'],
  [-1326576532,-1326358868,'Scorpio'],
  [-1326358868,-1326147743,'Sagittarius'],
  [-1326147743,-1325945143,'Capricorn'],
  [-1325945143,-1325750391,'Aquarius'],
  [-1325750391,-1325562082,'Pisces'],
  [-1325562082,-1325378736,'Aries'],
  [-1325378736,-1325198396,'Taurus'],
  [-1325198396,-1325017928,'Gemini'],
  [-1325017928,-1324832868,'Cancer'],
  [-1324832868,-1324638405,'Leo'],
  [-1324638405,-1324431745,'Virgo'],
  [-1324431745,-1324215212,'Libra'],
  [-1324215212,-1323996825,'Scorpio'],
  [-1323996825,-1323785448,'Sagittarius'],
  [-1323785448,-1323585166,'Capricorn'],
  [-1323585166,-1323394545,'Aquarius'],
  [-1323394545,-1323209527,'Pisces'],
  [-1323209527,-1323026259,'Aries'],
  [-1323026259,-1322842391,'Taurus'],
  [-1322842391,-1322656707,'Gemini'],
  [-1322656707,-1322467626,'Cancer'],
  [-1322467626,-1322272250,'Leo'],
  [-1322272250,-1322067404,'Virgo'],
  [-1322067404,-1321852724,'Libra'],
  [-1321852724,-1321633687,'Scorpio'],
  [-1321633687,-1321419978,'Sagittarius'],
  [-1321419978,-1321218781,'Capricorn'],
  [-1321218781,-1321030477,'Aquarius'],
  [-1321030477,-1320850263,'Pisces'],
  [-1320850263,-1320671877,'Aries'],
  [-1320671877,-1320490354,'Taurus'],
  [-1320490354,-1320303334,'Gemini'],
  [-1320303334,-1320110520,'Cancer'],
  [-1320110520,-1319911722,'Leo'],
  [-1319911722,-1319705739,'Virgo'],
  [-1319705739,-1319491745,'Libra'],
  [-1319491745,-1319272541,'Scorpio'],
  [-1319272541,-1319056007,'Sagittarius'],
  [-1319056007,-1318850940,'Capricorn'],
  [-1318850940,-1318660802,'Aquarius'],
  [-1318660802,-1318482365,'Pisces'],
  [-1318482365,-1318308845,'Aries'],
  [-1318308845,-1318133200,'Taurus'],
  [-1318133200,-1317950307,'Gemini'],
  [-1317950307,-1317758136,'Cancer'],
  [-1317758136,-1317557205,'Leo'],
  [-1317557205,-1317348799,'Virgo'],
  [-1317348799,-1317133968,'Libra'],
  [-1317133968,-1316914807,'Scorpio'],
  [-1316914807,-1316696638,'Sagittarius'],
  [-1316696638,-1316487204,'Capricorn'],
  [-1316487204,-1316292040,'Aquarius'],
  [-1316292040,-1316110819,'Pisces'],
  [-1316110819,-1315938254,'Aries'],
  [-1315938254,-1315767077,'Taurus'],
  [-1315767077,-1315590378,'Gemini'],
  [-1315590378,-1315403309,'Cancer'],
  [-1315403309,-1315204309,'Leo'],
  [-1315204309,-1314995047,'Virgo'],
  [-1314995047,-1314778938,'Libra'],
  [-1314778938,-1314559664,'Scorpio'],
  [-1314559664,-1314341488,'Sagittarius'],
  [-1314341488,-1314129753,'Capricorn'],
  [-1314129753,-1313929503,'Aquarius'],
  [-1313929503,-1313742602,'Pisces'],
  [-1313742602,-1313566479,'Aries'],
  [-1313566479,-1313395430,'Taurus'],
  [-1313395430,-1313222560,'Gemini'],
  [-1313222560,-1313041402,'Cancer'],
  [-1313041402,-1312847590,'Leo'],
  [-1312847590,-1312640626,'Virgo'],
  [-1312640626,-1312424393,'Libra'],
  [-1312424393,-1312204922,'Scorpio'],
  [-1312204922,-1311987614,'Sagittarius'],
  [-1311987614,-1311776363,'Capricorn'],
  [-1311776363,-1311573950,'Aquarius'],
  [-1311573950,-1311382012,'Pisces'],
  [-1311382012,-1311200049,'Aries'],
  [-1311200049,-1311024966,'Taurus'],
  [-1311024966,-1310851544,'Gemini'],
  [-1310851544,-1310673463,'Cancer'],
  [-1310673463,-1310484790,'Leo'],
  [-1310484790,-1310282256,'Virgo'],
  [-1310282256,-1310067798,'Libra'],
  [-1310067798,-1309848400,'Scorpio'],
  [-1309848400,-1309631791,'Sagittarius'],
  [-1309631791,-1309422484,'Capricorn'],
  [-1309422484,-1309221456,'Aquarius'],
  [-1309221456,-1309028173,'Pisces'],
  [-1309028173,-1308841854,'Aries'],
  [-1308841854,-1308661224,'Taurus'],
  [-1308661224,-1308483607,'Gemini'],
  [-1308483607,-1308304458,'Cancer'],
  [-1308304458,-1308118046,'Leo'],
  [-1308118046,-1307919482,'Virgo'],
  [-1307919482,-1307707964,'Libra'],
  [-1307707964,-1307489136,'Scorpio'],
  [-1307489136,-1307272374,'Sagittarius'],
  [-1307272374,-1307064411,'Capricorn'],
  [-1307064411,-1306866338,'Aquarius'],
  [-1306866338,-1306675621,'Pisces'],
  [-1306675621,-1306489289,'Aries'],
  [-1306489289,-1306305480,'Taurus'],
  [-1306305480,-1306123004,'Gemini'],
  [-1306123004,-1305939782,'Cancer'],
  [-1305939782,-1305751952,'Leo'],
  [-1305751952,-1305554830,'Virgo'],
  [-1305554830,-1305345790,'Libra'],
  [-1305345790,-1305127879,'Scorpio'],
  [-1305127879,-1304910063,'Sagittarius'],
  [-1304910063,-1304701387,'Capricorn'],
  [-1304701387,-1304504963,'Aquarius'],
  [-1304504963,-1304318032,'Pisces'],
  [-1304318032,-1304135592,'Aries'],
  [-1304135592,-1303953425,'Taurus'],
  [-1303953425,-1303769304,'Gemini'],
  [-1303769304,-1303582234,'Cancer'],
  [-1303582234,-1303390724,'Leo'],
  [-1303390724,-1303192069,'Virgo'],
  [-1303192069,-1302983732,'Libra'],
  [-1302983732,-1302766618,'Scorpio'],
  [-1302766618,-1302547453,'Sagittarius'],
  [-1302547453,-1302335922,'Capricorn'],
  [-1302335922,-1302137926,'Aquarius'],
  [-1302137926,-1301952534,'Pisces'],
  [-1301952534,-1301774437,'Aries'],
  [-1301774437,-1301597444,'Taurus'],
  [-1301597444,-1301416727,'Gemini'],
  [-1301416727,-1301229727,'Cancer'],
  [-1301229727,-1301035597,'Leo'],
  [-1301035597,-1300833940,'Virgo'],
  [-1300833940,-1300624295,'Libra'],
  [-1300624295,-1300407355,'Scorpio'],
  [-1300407355,-1300187398,'Sagittarius'],
  [-1300187398,-1299972398,'Capricorn'],
  [-1299972398,-1299769806,'Aquarius'],
  [-1299769806,-1299581730,'Pisces'],
  [-1299581730,-1299404635,'Aries'],
  [-1299404635,-1299232151,'Taurus'],
  [-1299232151,-1299057584,'Gemini'],
  [-1299057584,-1298875555,'Cancer'],
  [-1298875555,-1298683124,'Leo'],
  [-1298683124,-1298480114,'Virgo'],
  [-1298480114,-1298268414,'Libra'],
  [-1298268414,-1298050792,'Scorpio'],
  [-1298050792,-1297830888,'Sagittarius'],
  [-1297830888,-1297614018,'Capricorn'],
  [-1297614018,-1297406443,'Aquarius'],
  [-1297406443,-1297212354,'Pisces'],
  [-1297212354,-1297031366,'Aries'],
  [-1297031366,-1296858995,'Taurus'],
  [-1296858995,-1296688591,'Gemini'],
  [-1296688591,-1296513090,'Cancer'],
  [-1296513090,-1296326617,'Leo'],
  [-1296326617,-1296126452,'Virgo'],
  [-1296126452,-1295914441,'Libra'],
  [-1295914441,-1295695846,'Scorpio'],
  [-1295695846,-1295476237,'Sagittarius'],
  [-1295476237,-1295259871,'Capricorn'],
  [-1295259871,-1295050258,'Aquarius'],
  [-1295050258,-1294850684,'Pisces'],
  [-1294850684,-1294662895,'Aries'],
  [-1294662895,-1294485590,'Taurus'],
  [-1294485590,-1294314207,'Gemini'],
  [-1294314207,-1294141999,'Cancer'],
  [-1294141999,-1293961659,'Leo'],
  [-1293961659,-1293767515,'Virgo'],
  [-1293767515,-1293558602,'Libra'],
  [-1293558602,-1293340204,'Scorpio'],
  [-1293340204,-1293120562,'Sagittarius'],
  [-1293120562,-1292905622,'Capricorn'],
  [-1292905622,-1292697521,'Aquarius'],
  [-1292697521,-1292496799,'Pisces'],
  [-1292496799,-1292304196,'Aries'],
  [-1292304196,-1292120183,'Taurus'],
  [-1292120183,-1291943272,'Gemini'],
  [-1291943272,-1291769013,'Cancer'],
  [-1291769013,-1291590762,'Leo'],
  [-1291590762,-1291401665,'Virgo'],
  [-1291401665,-1291197785,'Libra'],
  [-1291197785,-1290981654,'Scorpio'],
  [-1290981654,-1290761984,'Sagittarius'],
  [-1290761984,-1290547540,'Capricorn'],
  [-1290547540,-1290341852,'Aquarius'],
  [-1290341852,-1290143957,'Pisces'],
  [-1290143957,-1289951888,'Aries'],
  [-1289951888,-1289764718,'Taurus'],
  [-1289764718,-1289582100,'Gemini'],
  [-1289582100,-1289402349,'Cancer'],
  [-1289402349,-1289221291,'Leo'],
  [-1289221291,-1289033098,'Virgo'],
  [-1289033098,-1288832764,'Libra'],
  [-1288832764,-1288619817,'Scorpio'],
  [-1288619817,-1288400694,'Sagittarius'],
  [-1288400694,-1288185349,'Capricorn'],
  [-1288185349,-1287980176,'Aquarius'],
  [-1287980176,-1287785312,'Pisces'],
  [-1287785312,-1287597324,'Aries'],
  [-1287597324,-1287412613,'Taurus'],
  [-1287412613,-1287228986,'Gemini'],
  [-1287228986,-1287045169,'Cancer'],
  [-1287045169,-1286859296,'Leo'],
  [-1286859296,-1286668105,'Virgo'],
  [-1286668105,-1286467835,'Libra'],
  [-1286467835,-1286256843,'Scorpio'],
  [-1286256843,-1286038640,'Sagittarius'],
  [-1286038640,-1285821744,'Capricorn'],
  [-1285821744,-1285614481,'Aquarius'],
  [-1285614481,-1285419742,'Pisces'],
  [-1285419742,-1285234979,'Aries'],
  [-1285234979,-1285055245,'Taurus'],
  [-1285055245,-1284875737,'Gemini'],
  [-1284875737,-1284692986,'Cancer'],
  [-1284692986,-1284504875,'Leo'],
  [-1284504875,-1284309990,'Virgo'],
  [-1284309990,-1284107139,'Libra'],
  [-1284107139,-1283895857,'Scorpio'],
  [-1283895857,-1283678215,'Sagittarius'],
  [-1283678215,-1283460080,'Capricorn'],
  [-1283460080,-1283249347,'Aquarius'],
  [-1283249347,-1283051360,'Pisces'],
  [-1283051360,-1282866132,'Aries'],
  [-1282866132,-1282689464,'Taurus'],
  [-1282689464,-1282515343,'Gemini'],
  [-1282515343,-1282337829,'Cancer'],
  [-1282337829,-1282152391,'Leo'],
  [-1282152391,-1281956856,'Virgo'],
  [-1281956856,-1281751587,'Libra'],
  [-1281751587,-1281538588,'Scorpio'],
  [-1281538588,-1281320743,'Sagittarius'],
  [-1281320743,-1281102171,'Capricorn'],
  [-1281102171,-1280888568,'Aquarius'],
  [-1280888568,-1280685725,'Pisces'],
  [-1280685725,-1280496334,'Aries'],
  [-1280496334,-1280318570,'Taurus'],
  [-1280318570,-1280147086,'Gemini'],
  [-1280147086,-1279974905,'Cancer'],
  [-1279974905,-1279795213,'Leo'],
  [-1279795213,-1279603289,'Virgo'],
  [-1279603289,-1279398458,'Libra'],
  [-1279398458,-1279184222,'Scorpio'],
  [-1279184222,-1278965716,'Sagittarius'],
  [-1278965716,-1278747367,'Capricorn'],
  [-1278747367,-1278532875,'Aquarius'],
  [-1278532875,-1278326311,'Pisces'],
  [-1278326311,-1278131318,'Aries'],
  [-1278131318,-1277948774,'Taurus'],
  [-1277948774,-1277775567,'Gemini'],
  [-1277775567,-1277605392,'Cancer'],
  [-1277605392,-1277430617,'Leo'],
  [-1277430617,-1277244373,'Virgo'],
  [-1277244373,-1277043337,'Libra'],
  [-1277043337,-1276830004,'Scorpio'],
  [-1276830004,-1276611155,'Sagittarius'],
  [-1276611155,-1276393208,'Capricorn'],
  [-1276393208,-1276179662,'Aquarius'],
  [-1276179662,-1275972428,'Pisces'],
  [-1275972428,-1275773705,'Aries'],
  [-1275773705,-1275585423,'Taurus'],
  [-1275585423,-1275407081,'Gemini'],
  [-1275407081,-1275234557,'Cancer'],
  [-1275234557,-1275061049,'Leo'],
  [-1275061049,-1274879059,'Virgo'],
  [-1274879059,-1274683081,'Libra'],
  [-1274683081,-1274472934,'Scorpio'],
  [-1274472934,-1274254776,'Sagittarius'],
  [-1274254776,-1274037004,'Capricorn'],
  [-1274037004,-1273824858,'Aquarius'],
  [-1273824858,-1273619588,'Pisces'],
  [-1273619588,-1273421097,'Aries'],
  [-1273421097,-1273229841,'Taurus'],
  [-1273229841,-1273046175,'Gemini'],
  [-1273046175,-1272868413,'Cancer'],
  [-1272868413,-1272692007,'Leo'],
  [-1272692007,-1272510559,'Virgo'],
  [-1272510559,-1272317983,'Libra'],
  [-1272317983,-1272111696,'Scorpio'],
  [-1272111696,-1271895333,'Sagittarius'],
  [-1271895333,-1271677411,'Capricorn'],
  [-1271677411,-1271465583,'Aquarius'],
  [-1271465583,-1271262580,'Pisces'],
  [-1271262580,-1271067296,'Aries'],
  [-1271067296,-1270877722,'Taurus'],
  [-1270877722,-1270692478,'Gemini'],
  [-1270692478,-1270510325,'Cancer'],
  [-1270510325,-1270328900,'Leo'],
  [-1270328900,-1270144238,'Virgo'],
  [-1270144238,-1269951615,'Libra'],
  [-1269951615,-1269747702,'Scorpio'],
  [-1269747702,-1269533448,'Sagittarius'],
  [-1269533448,-1269315292,'Capricorn'],
  [-1269315292,-1269101997,'Aquarius'],
  [-1269101997,-1268899074,'Pisces'],
  [-1268899074,-1268706665,'Aries'],
  [-1268706665,-1268521559,'Taurus'],
  [-1268521559,-1268339757,'Gemini'],
  [-1268339757,-1268157901,'Cancer'],
  [-1268157901,-1267973495,'Leo'],
  [-1267973495,-1267784462,'Virgo'],
  [-1267784462,-1267588712,'Libra'],
  [-1267588712,-1267384400,'Scorpio'],
  [-1267384400,-1267171382,'Sagittarius'],
  [-1267171382,-1266953237,'Capricorn'],
  [-1266953237,-1266737392,'Aquarius'],
  [-1266737392,-1266531432,'Pisces'],
  [-1266531432,-1266338479,'Aries'],
  [-1266338479,-1266156420,'Taurus'],
  [-1266156420,-1265980034,'Gemini'],
  [-1265980034,-1265803335,'Cancer'],
  [-1265803335,-1265621301,'Leo'],
  [-1265621301,-1265431032,'Virgo'],
  [-1265431032,-1265232005,'Libra'],
  [-1265232005,-1265025134,'Scorpio'],
  [-1265025134,-1264811683,'Sagittarius'],
  [-1264811683,-1264593760,'Capricorn'],
  [-1264593760,-1264375960,'Aquarius'],
  [-1264375960,-1264165362,'Pisces'],
  [-1264165362,-1263967829,'Aries'],
  [-1263967829,-1263784277,'Taurus'],
  [-1263784277,-1263610520,'Gemini'],
  [-1263610520,-1263439541,'Cancer'],
  [-1263439541,-1263263898,'Leo'],
  [-1263263898,-1263077828,'Virgo'],
  [-1263077828,-1262879308,'Libra'],
  [-1262879308,-1262670503,'Scorpio'],
  [-1262670503,-1262455441,'Sagittarius'],
  [-1262455441,-1262237446,'Capricorn'],
  [-1262237446,-1262019340,'Aquarius'],
  [-1262019340,-1261805562,'Pisces'],
  [-1261805562,-1261602060,'Aries'],
  [-1261602060,-1261412717,'Taurus'],
  [-1261412717,-1261236324,'Gemini'],
  [-1261236324,-1261066975,'Cancer'],
  [-1261066975,-1260896606,'Leo'],
  [-1260896606,-1260717356,'Virgo'],
  [-1260717356,-1260524106,'Libra'],
  [-1260524106,-1260317033,'Scorpio'],
  [-1260317033,-1260101217,'Sagittarius'],
  [-1260101217,-1259882697,'Capricorn'],
  [-1259882697,-1259665278,'Aquarius'],
  [-1259665278,-1259451440,'Pisces'],
  [-1259451440,-1259244687,'Aries'],
  [-1259244687,-1259049101,'Taurus'],
  [-1259049101,-1258866277,'Gemini'],
  [-1258866277,-1258693189,'Cancer'],
  [-1258693189,-1258523158,'Leo'],
  [-1258523158,-1258348192,'Virgo'],
  [-1258348192,-1258161317,'Libra'],
  [-1258161317,-1257959480,'Scorpio'],
  [-1257959480,-1257745640,'Sagittarius'],
  [-1257745640,-1257526993,'Capricorn'],
  [-1257526993,-1257310024,'Aquarius'],
  [-1257310024,-1257097904,'Pisces'],
  [-1257097904,-1256892082,'Aries'],
  [-1256892082,-1256694251,'Taurus'],
  [-1256694251,-1256505939,'Gemini'],
  [-1256505939,-1256326479,'Cancer'],
  [-1256326479,-1256151976,'Leo'],
  [-1256151976,-1255976202,'Virgo'],
  [-1255976202,-1255792427,'Libra'],
  [-1255792427,-1255595784,'Scorpio'],
  [-1255595784,-1255385997,'Sagittarius'],
  [-1255385997,-1255168498,'Capricorn'],
  [-1255168498,-1254951388,'Aquarius'],
  [-1254951388,-1254740412,'Pisces'],
  [-1254740412,-1254537382,'Aries'],
  [-1254537382,-1254341861,'Taurus'],
  [-1254341861,-1254152943,'Gemini'],
  [-1254152943,-1253969480,'Cancer'],
  [-1253969480,-1253789348,'Leo'],
  [-1253789348,-1253608980,'Virgo'],
  [-1253608980,-1253423712,'Libra'],
  [-1253423712,-1253229044,'Scorpio'],
  [-1253229044,-1253022769,'Sagittarius'],
  [-1253022769,-1252807297,'Capricorn'],
  [-1252807297,-1252589798,'Aquarius'],
  [-1252589798,-1252378213,'Pisces'],
  [-1252378213,-1252176697,'Aries'],
  [-1252176697,-1251984834,'Taurus'],
  [-1251984834,-1251799567,'Gemini'],
  [-1251799567,-1251617295,'Cancer'],
  [-1251617295,-1251434962,'Leo'],
  [-1251434962,-1251250187,'Virgo'],
  [-1251250187,-1251060808,'Libra'],
  [-1251060808,-1250864481,'Scorpio'],
  [-1250864481,-1250659238,'Sagittarius'],
  [-1250659238,-1250445388,'Capricorn'],
  [-1250445388,-1250227568,'Aquarius'],
  [-1250227568,-1250013873,'Pisces'],
  [-1250013873,-1249811079,'Aries'],
  [-1249811079,-1249620777,'Taurus'],
  [-1249620777,-1249439660,'Gemini'],
  [-1249439660,-1249262092,'Cancer'],
  [-1249262092,-1249082578,'Leo'],
  [-1249082578,-1248897366,'Virgo'],
  [-1248897366,-1248704992,'Libra'],
  [-1248704992,-1248505442,'Scorpio'],
  [-1248505442,-1248298790,'Sagittarius'],
  [-1248298790,-1248085266,'Capricorn'],
  [-1248085266,-1247867279,'Aquarius'],
  [-1247867279,-1247651108,'Pisces'],
  [-1247651108,-1247444683,'Aries'],
  [-1247444683,-1247252382,'Taurus'],
  [-1247252382,-1247072553,'Gemini'],
  [-1247072553,-1246899223,'Cancer'],
  [-1246899223,-1246725098,'Leo'],
  [-1246725098,-1246543980,'Virgo'],
  [-1246543980,-1246352647,'Libra'],
  [-1246352647,-1246151446,'Scorpio'],
  [-1246151446,-1245942632,'Sagittarius'],
  [-1245942632,-1245728234,'Capricorn'],
  [-1245728234,-1245510171,'Aquarius'],
  [-1245510171,-1245292454,'Pisces'],
  [-1245292454,-1245081946,'Aries'],
  [-1245081946,-1244884848,'Taurus'],
  [-1244884848,-1244702266,'Gemini'],
  [-1244702266,-1244529667,'Cancer'],
  [-1244529667,-1244359543,'Leo'],
  [-1244359543,-1244184136,'Virgo'],
  [-1244184136,-1243997699,'Libra'],
  [-1243997699,-1243798543,'Scorpio'],
  [-1243798543,-1243589130,'Sagittarius'],
  [-1243589130,-1243373623,'Capricorn'],
  [-1243373623,-1243155446,'Aquarius'],
  [-1243155446,-1242937678,'Pisces'],
  [-1242937678,-1242724931,'Aries'],
  [-1242724931,-1242522857,'Taurus'],
  [-1242522857,-1242334678,'Gemini'],
  [-1242334678,-1242158537,'Cancer'],
  [-1242158537,-1241988395,'Leo'],
  [-1241988395,-1241816532,'Virgo'],
  [-1241816532,-1241635765,'Libra'],
  [-1241635765,-1241441719,'Scorpio'],
  [-1241441719,-1241234687,'Sagittarius'],
  [-1241234687,-1241019161,'Capricorn'],
  [-1241019161,-1240800823,'Aquarius'],
  [-1240800823,-1240583932,'Pisces'],
  [-1240583932,-1240371723,'Aries'],
  [-1240371723,-1240167552,'Taurus'],
  [-1240167552,-1239974267,'Gemini'],
  [-1239974267,-1239792107,'Cancer'],
  [-1239792107,-1239617686,'Leo'],
  [-1239617686,-1239445004,'Virgo'],
  [-1239445004,-1239267175,'Libra'],
  [-1239267175,-1239078333,'Scorpio'],
  [-1239078333,-1238875892,'Sagittarius'],
  [-1238875892,-1238662253,'Capricorn'],
  [-1238662253,-1238443936,'Aquarius'],
  [-1238443936,-1238227678,'Pisces'],
  [-1238227678,-1238017530,'Aries'],
  [-1238017530,-1237815052,'Taurus'],
  [-1237815052,-1237620651,'Gemini'],
  [-1237620651,-1237434042,'Cancer'],
  [-1237434042,-1237253662,'Leo'],
  [-1237253662,-1237076208,'Virgo'],
  [-1237076208,-1236896858,'Libra'],
  [-1236896858,-1236710206,'Scorpio'],
  [-1236710206,-1236511989,'Sagittarius'],
  [-1236511989,-1236301583,'Capricorn'],
  [-1236301583,-1236083838,'Aquarius'],
  [-1236083838,-1235867131,'Pisces'],
  [-1235867131,-1235658152,'Aries'],
  [-1235658152,-1235458904,'Taurus'],
  [-1235458904,-1235267712,'Gemini'],
  [-1235267712,-1235081687,'Cancer'],
  [-1235081687,-1234898298,'Leo'],
  [-1234898298,-1234715583,'Virgo'],
  [-1234715583,-1234531429,'Libra'],
  [-1234531429,-1234342780,'Scorpio'],
  [-1234342780,-1234145890,'Sagittarius'],
  [-1234145890,-1233938243,'Capricorn'],
  [-1233938243,-1233721655,'Aquarius'],
  [-1233721655,-1233503619,'Pisces'],
  [-1233503619,-1233293280,'Aries'],
  [-1233293280,-1233095285,'Taurus'],
  [-1233095285,-1232908133,'Gemini'],
  [-1232908133,-1232726846,'Cancer'],
  [-1232726846,-1232546156,'Leo'],
  [-1232546156,-1232362495,'Virgo'],
  [-1232362495,-1232174452,'Libra'],
  [-1232174452,-1231981537,'Scorpio'],
  [-1231981537,-1231782514,'Sagittarius'],
  [-1231782514,-1231575392,'Capricorn'],
  [-1231575392,-1231359879,'Aquarius'],
  [-1231359879,-1231140650,'Pisces'],
  [-1231140650,-1230926913,'Aries'],
  [-1230926913,-1230726344,'Taurus'],
  [-1230726344,-1230539950,'Gemini'],
  [-1230539950,-1230362874,'Cancer'],
  [-1230362874,-1230188038,'Leo'],
  [-1230188038,-1230009098,'Virgo'],
  [-1230009098,-1229822380,'Libra'],
  [-1229822380,-1229627372,'Scorpio'],
  [-1229627372,-1229425109,'Sagittarius'],
  [-1229425109,-1229216165,'Capricorn'],
  [-1229216165,-1229000710,'Aquarius'],
  [-1229000710,-1228781128,'Pisces'],
  [-1228781128,-1228564215,'Aries'],
  [-1228564215,-1228358503,'Taurus'],
  [-1228358503,-1228168241,'Gemini'],
  [-1228168241,-1227990932,'Cancer'],
  [-1227990932,-1227819807,'Leo'],
  [-1227819807,-1227647138,'Virgo'],
  [-1227647138,-1227466535,'Libra'],
  [-1227466535,-1227274723,'Scorpio'],
  [-1227274723,-1227072072,'Sagittarius'],
  [-1227072072,-1226861132,'Capricorn'],
  [-1226861132,-1226644617,'Aquarius'],
  [-1226644617,-1226425171,'Pisces'],
  [-1226425171,-1226207186,'Aries'],
  [-1226207186,-1225997214,'Taurus'],
  [-1225997214,-1225800765,'Gemini'],
  [-1225800765,-1225618495,'Cancer'],
  [-1225618495,-1225445958,'Leo'],
  [-1225445958,-1225276070,'Virgo'],
  [-1225276070,-1225101447,'Libra'],
  [-1225101447,-1224916196,'Scorpio'],
  [-1224916196,-1224717671,'Sagittarius'],
  [-1224717671,-1224507408,'Capricorn'],
  [-1224507408,-1224290023,'Aquarius'],
  [-1224290023,-1224070567,'Pisces'],
  [-1224070567,-1223853351,'Aries'],
  [-1223853351,-1223642463,'Taurus'],
  [-1223642463,-1223441732,'Gemini'],
  [-1223441732,-1223253072,'Cancer'],
  [-1223253072,-1223074940,'Leo'],
  [-1223074940,-1222902649,'Virgo'],
  [-1222902649,-1222729777,'Libra'],
  [-1222729777,-1222549679,'Scorpio'],
  [-1222549679,-1222357183,'Sagittarius'],
  [-1222357183,-1222150805,'Capricorn'],
  [-1222150805,-1221934274,'Aquarius'],
  [-1221934274,-1221714724,'Pisces'],
  [-1221714724,-1221498590,'Aries'],
  [-1221498590,-1221289457,'Taurus'],
  [-1221289457,-1221088667,'Gemini'],
  [-1221088667,-1220896583,'Cancer'],
  [-1220896583,-1220712624,'Leo'],
  [-1220712624,-1220534695,'Virgo'],
  [-1220534695,-1220358841,'Libra'],
  [-1220358841,-1220179579,'Scorpio'],
  [-1220179579,-1219991088,'Sagittarius'],
  [-1219991088,-1219789411,'Capricorn'],
  [-1219789411,-1219575489,'Aquarius'],
  [-1219575489,-1219356206,'Pisces'],
  [-1219356206,-1219140351,'Aries'],
  [-1219140351,-1218933219,'Taurus'],
  [-1218933219,-1218735249,'Gemini'],
  [-1218735249,-1218544364,'Cancer'],
  [-1218544364,-1218358386,'Leo'],
  [-1218358386,-1218175745,'Virgo'],
  [-1218175745,-1217994738,'Libra'],
  [-1217994738,-1217812337,'Scorpio'],
  [-1217812337,-1217623974,'Sagittarius'],
  [-1217623974,-1217425029,'Capricorn'],
  [-1217425029,-1217213952,'Aquarius'],
  [-1217213952,-1216995369,'Pisces'],
  [-1216995369,-1216778743,'Aries'],
  [-1216778743,-1216571904,'Taurus'],
  [-1216571904,-1216376534,'Gemini'],
  [-1216376534,-1216189428,'Cancer'],
  [-1216189428,-1216006056,'Leo'],
  [-1216006056,-1215823044,'Virgo'],
  [-1215823044,-1215638738,'Libra'],
  [-1215638738,-1215452017,'Scorpio'],
  [-1215452017,-1215260701,'Sagittarius'],
  [-1215260701,-1215061438,'Capricorn'],
  [-1215061438,-1214851837,'Aquarius'],
  [-1214851837,-1214634010,'Pisces'],
  [-1214634010,-1214415977,'Aries'],
  [-1214415977,-1214207162,'Taurus'],
  [-1214207162,-1214011790,'Gemini'],
  [-1214011790,-1213827528,'Cancer'],
  [-1213827528,-1213648703,'Leo'],
  [-1213648703,-1213469649,'Virgo'],
  [-1213469649,-1213286623,'Libra'],
  [-1213286623,-1213098093,'Scorpio'],
  [-1213098093,-1212903469,'Sagittarius'],
  [-1212903469,-1212701738,'Capricorn'],
  [-1212701738,-1212491678,'Aquarius'],
  [-1212491678,-1212274203,'Pisces'],
  [-1212274203,-1212054915,'Aries'],
  [-1212054915,-1211842731,'Taurus'],
  [-1211842731,-1211644173,'Gemini'],
  [-1211644173,-1211459347,'Cancer'],
  [-1211459347,-1211283294,'Leo'],
  [-1211283294,-1211109313,'Virgo'],
  [-1211109313,-1210931379,'Libra'],
  [-1210931379,-1210745580,'Scorpio'],
  [-1210745580,-1210550507,'Sagittarius'],
  [-1210550507,-1210346528,'Capricorn'],
  [-1210346528,-1210134766,'Aquarius'],
  [-1210134766,-1209917021,'Pisces'],
  [-1209917021,-1209697266,'Aries'],
  [-1209697266,-1209482217,'Taurus'],
  [-1209482217,-1209278716,'Gemini'],
  [-1209278716,-1209089560,'Cancer'],
  [-1209089560,-1208912176,'Leo'],
  [-1208912176,-1208740627,'Virgo'],
  [-1208740627,-1208567989,'Libra'],
  [-1208567989,-1208388044,'Scorpio'],
  [-1208388044,-1208196742,'Sagittarius'],
  [-1208196742,-1207993327,'Capricorn'],
  [-1207993327,-1207780308,'Aquarius'],
  [-1207780308,-1207561858,'Pisces'],
  [-1207561858,-1207342397,'Aries'],
  [-1207342397,-1207126601,'Taurus'],
  [-1207126601,-1206919344,'Gemini'],
  [-1206919344,-1206724242,'Cancer'],
  [-1206724242,-1206541548,'Leo'],
  [-1206541548,-1206367792,'Virgo'],
  [-1206367792,-1206196983,'Libra'],
  [-1206196983,-1206022149,'Scorpio'],
  [-1206022149,-1205836915,'Sagittarius'],
  [-1205836915,-1205637657,'Capricorn'],
  [-1205637657,-1205425654,'Aquarius'],
  [-1205425654,-1205206745,'Pisces'],
  [-1205206745,-1204987693,'Aries'],
  [-1204987693,-1204773147,'Taurus'],
  [-1204773147,-1204565610,'Gemini'],
  [-1204565610,-1204366838,'Cancer'],
  [-1204366838,-1204177938,'Leo'],
  [-1204177938,-1203998226,'Virgo'],
  [-1203998226,-1203824340,'Libra'],
  [-1203824340,-1203650476,'Scorpio'],
  [-1203650476,-1203469685,'Sagittarius'],
  [-1203469685,-1203275998,'Capricorn'],
  [-1203275998,-1203067657,'Aquarius'],
  [-1203067657,-1202849495,'Pisces'],
  [-1202849495,-1202630410,'Aries'],
  [-1202630410,-1202417305,'Taurus'],
  [-1202417305,-1202212251,'Gemini'],
  [-1202212251,-1202014450,'Cancer'],
  [-1202014450,-1201823023,'Leo'],
  [-1201823023,-1201637744,'Virgo'],
  [-1201637744,-1201457804,'Libra'],
  [-1201457804,-1201280160,'Scorpio'],
  [-1201280160,-1201099345,'Sagittarius'],
  [-1201099345,-1200909020,'Capricorn'],
  [-1200909020,-1200704991,'Aquarius'],
  [-1200704991,-1200489043,'Pisces'],
  [-1200489043,-1200269680,'Aries'],
  [-1200269680,-1200056442,'Taurus'],
  [-1200056442,-1199853508,'Gemini'],
  [-1199853508,-1199659433,'Cancer'],
  [-1199659433,-1199470764,'Leo'],
  [-1199470764,-1199284954,'Virgo'],
  [-1199284954,-1199100978,'Libra'],
  [-1199100978,-1198917874,'Scorpio'],
  [-1198917874,-1198732978,'Sagittarius'],
  [-1198732978,-1198541782,'Capricorn'],
  [-1198541782,-1198339851,'Aquarius'],
  [-1198339851,-1198126363,'Pisces'],
  [-1198126363,-1197907060,'Aries'],
  [-1197907060,-1197691958,'Taurus'],
  [-1197691958,-1197488252,'Gemini'],
  [-1197488252,-1197296430,'Cancer'],
  [-1197296430,-1197112408,'Leo'],
  [-1197112408,-1196931168,'Virgo'],
  [-1196931168,-1196749009,'Libra'],
  [-1196749009,-1196563992,'Scorpio'],
  [-1196563992,-1196374880,'Sagittarius'],
  [-1196374880,-1196179900,'Capricorn'],
  [-1196179900,-1195976703,'Aquarius'],
  [-1195976703,-1195764171,'Pisces'],
  [-1195764171,-1195545305,'Aries'],
  [-1195545305,-1195327950,'Taurus'],
  [-1195327950,-1195120655,'Gemini'],
  [-1195120655,-1194927072,'Cancer'],
  [-1194927072,-1194744914,'Leo'],
  [-1194744914,-1194568683,'Virgo'],
  [-1194568683,-1194392407,'Libra'],
  [-1194392407,-1194211278,'Scorpio'],
  [-1194211278,-1194022410,'Sagittarius'],
  [-1194022410,-1193824798,'Capricorn'],
  [-1193824798,-1193618693,'Aquarius'],
  [-1193618693,-1193405091,'Pisces'],
  [-1193405091,-1193186438,'Aries'],
  [-1193186438,-1192967844,'Taurus'],
  [-1192967844,-1192756439,'Gemini'],
  [-1192756439,-1192557850,'Cancer'],
  [-1192557850,-1192372899,'Leo'],
  [-1192372899,-1192197812,'Virgo'],
  [-1192197812,-1192026311,'Libra'],
  [-1192026311,-1191851601,'Scorpio'],
  [-1191851601,-1191667933,'Sagittarius'],
  [-1191667933,-1191472184,'Capricorn'],
  [-1191472184,-1191264923,'Aquarius'],
  [-1191264923,-1191049618,'Pisces'],
  [-1191049618,-1190830573,'Aries'],
  [-1190830573,-1190611982,'Taurus'],
  [-1190611982,-1190398397,'Gemini'],
  [-1190398397,-1190194698,'Cancer'],
  [-1190194698,-1190003904,'Leo'],
  [-1190003904,-1189825206,'Virgo'],
  [-1189825206,-1189653999,'Libra'],
  [-1189653999,-1189483372,'Scorpio'],
  [-1189483372,-1189305918,'Sagittarius'],
  [-1189305918,-1189115744,'Capricorn'],
  [-1189115744,-1188911078,'Aquarius'],
  [-1188911078,-1188695621,'Pisces'],
  [-1188695621,-1188476055,'Aries'],
  [-1188476055,-1188258003,'Taurus'],
  [-1188258003,-1188044743,'Gemini'],
  [-1188044743,-1187838804,'Cancer'],
  [-1187838804,-1187642810,'Leo'],
  [-1187642810,-1187458057,'Virgo'],
  [-1187458057,-1187282720,'Libra'],
  [-1187282720,-1187111549,'Scorpio'],
  [-1187111549,-1186937261,'Sagittarius'],
  [-1186937261,-1186752564,'Capricorn'],
  [-1186752564,-1186552958,'Aquarius'],
  [-1186552958,-1186339872,'Pisces'],
  [-1186339872,-1186120525,'Aries'],
  [-1186120525,-1185902876,'Taurus'],
  [-1185902876,-1185691158,'Gemini'],
  [-1185691158,-1185486332,'Cancer'],
  [-1185486332,-1185288817,'Leo'],
  [-1185288817,-1185099505,'Virgo'],
  [-1185099505,-1184918414,'Libra'],
  [-1184918414,-1184742873,'Scorpio'],
  [-1184742873,-1184567342,'Sagittarius'],
  [-1184567342,-1184384890,'Capricorn'],
  [-1184384890,-1184189674,'Aquarius'],
  [-1184189674,-1183980365,'Pisces'],
  [-1183980365,-1183762340,'Aries'],
  [-1183762340,-1183544709,'Taurus'],
  [-1183544709,-1183334011,'Gemini'],
  [-1183334011,-1183131700,'Cancer'],
  [-1183131700,-1182936426,'Leo'],
  [-1182936426,-1182746852,'Virgo'],
  [-1182746852,-1182562353,'Libra'],
  [-1182562353,-1182381735,'Scorpio'],
  [-1182381735,-1182201868,'Sagittarius'],
  [-1182201868,-1182017729,'Capricorn'],
  [-1182017729,-1181823955,'Aquarius'],
  [-1181823955,-1181617680,'Pisces'],
  [-1181617680,-1181401551,'Aries'],
  [-1181401551,-1181183632,'Taurus'],
  [-1181183632,-1180972361,'Gemini'],
  [-1180972361,-1180771395,'Cancer'],
  [-1180771395,-1180579505,'Leo'],
  [-1180579505,-1180393450,'Virgo'],
  [-1180393450,-1180210243,'Libra'],
  [-1180210243,-1180027689,'Scorpio'],
  [-1180027689,-1179843708,'Sagittarius'],
  [-1179843708,-1179655575,'Capricorn'],
  [-1179655575,-1179460008,'Aquarius'],
  [-1179460008,-1179254522,'Pisces'],
  [-1179254522,-1179039860,'Aries'],
  [-1179039860,-1178821601,'Taurus'],
  [-1178821601,-1178608191,'Gemini'],
  [-1178608191,-1178405825,'Cancer'],
  [-1178405825,-1178215313,'Leo'],
  [-1178215313,-1178033302,'Virgo'],
  [-1178033302,-1177854839,'Libra'],
  [-1177854839,-1177675217,'Scorpio'],
  [-1177675217,-1177490924,'Sagittarius'],
  [-1177490924,-1177299846,'Capricorn'],
  [-1177299846,-1177100965,'Aquarius'],
  [-1177100965,-1176893951,'Pisces'],
  [-1176893951,-1176679586,'Aries'],
  [-1176679586,-1176461188,'Taurus'],
  [-1176461188,-1176245207,'Gemini'],
  [-1176245207,-1176038897,'Cancer'],
  [-1176038897,-1175846006,'Leo'],
  [-1175846006,-1175665083,'Virgo'],
  [-1175665083,-1175490968,'Libra'],
  [-1175490968,-1175317056,'Scorpio'],
  [-1175317056,-1175137203,'Sagittarius'],
  [-1175137203,-1174947386,'Capricorn'],
  [-1174947386,-1174746823,'Aquarius'],
  [-1174746823,-1174537470,'Pisces'],
  [-1174537470,-1174322179,'Aries'],
  [-1174322179,-1174103847,'Taurus'],
  [-1174103847,-1173886431,'Gemini'],
  [-1173886431,-1173675779,'Cancer'],
  [-1173675779,-1173477434,'Leo'],
  [-1173477434,-1173293070,'Virgo'],
  [-1173293070,-1173119365,'Libra'],
  [-1173119365,-1172949593,'Scorpio'],
  [-1172949593,-1172775943,'Sagittarius'],
  [-1172775943,-1172591674,'Capricorn'],
  [-1172591674,-1172393623,'Aquarius'],
  [-1172393623,-1172183732,'Pisces'],
  [-1172183732,-1171967195,'Aries'],
  [-1171967195,-1171748809,'Taurus'],
  [-1171748809,-1171531689,'Gemini'],
  [-1171531689,-1171319077,'Cancer'],
  [-1171319077,-1171115508,'Leo'],
  [-1171115508,-1170924712,'Virgo'],
  [-1170924712,-1170746517,'Libra'],
  [-1170746517,-1170576096,'Scorpio'],
  [-1170576096,-1170405830,'Sagittarius'],
  [-1170405830,-1170227635,'Capricorn'],
  [-1170227635,-1170035528,'Aquarius'],
  [-1170035528,-1169828712,'Pisces'],
  [-1169828712,-1169612324,'Aries'],
  [-1169612324,-1169393644,'Taurus'],
  [-1169393644,-1169177528,'Gemini'],
  [-1169177528,-1168966047,'Cancer'],
  [-1168966047,-1168761070,'Leo'],
  [-1168761070,-1168565303,'Virgo'],
  [-1168565303,-1168380435,'Libra'],
  [-1168380435,-1168204680,'Scorpio'],
  [-1168204680,-1168032555,'Sagittarius'],
  [-1168032555,-1167856633,'Capricorn'],
  [-1167856633,-1167669836,'Aquarius'],
  [-1167669836,-1167468400,'Pisces'],
  [-1167468400,-1167254625,'Aries'],
  [-1167254625,-1167036035,'Taurus'],
  [-1167036035,-1166820221,'Gemini'],
  [-1166820221,-1166610809,'Cancer'],
  [-1166610809,-1166408299,'Leo'],
  [-1166408299,-1166212632,'Virgo'],
  [-1166212632,-1166024133,'Libra'],
  [-1166024133,-1165842334,'Scorpio'],
  [-1165842334,-1165664549,'Sagittarius'],
  [-1165664549,-1165485813,'Capricorn'],
  [-1165485813,-1165300147,'Aquarius'],
  [-1165300147,-1165102742,'Pisces'],
  [-1165102742,-1164892803,'Aries'],
  [-1164892803,-1164675318,'Taurus'],
  [-1164675318,-1164458804,'Gemini'],
  [-1164458804,-1164249829,'Cancer'],
  [-1164249829,-1164050221,'Leo'],
  [-1164050221,-1163858454,'Virgo'],
  [-1163858454,-1163672022,'Libra'],
  [-1163672022,-1163488660,'Scorpio'],
  [-1163488660,-1163306259,'Sagittarius'],
  [-1163306259,-1163122280,'Capricorn'],
  [-1163122280,-1162933441,'Aquarius'],
  [-1162933441,-1162736272,'Pisces'],
  [-1162736272,-1162528804,'Aries'],
  [-1162528804,-1162312952,'Taurus'],
  [-1162312952,-1162095423,'Gemini'],
  [-1162095423,-1161884536,'Cancer'],
  [-1161884536,-1161685089,'Leo'],
  [-1161685089,-1161496622,'Virgo'],
  [-1161496622,-1161315161,'Libra'],
  [-1161315161,-1161135704,'Scorpio'],
  [-1161135704,-1160953983,'Sagittarius'],
  [-1160953983,-1160767272,'Capricorn'],
  [-1160767272,-1160574271,'Aquarius'],
  [-1160574271,-1160374236,'Pisces'],
  [-1160374236,-1160166501,'Aries'],
  [-1160166501,-1159951602,'Taurus'],
  [-1159951602,-1159733411,'Gemini'],
  [-1159733411,-1159519422,'Cancer'],
  [-1159519422,-1159316826,'Leo'],
  [-1159316826,-1159127972,'Virgo'],
  [-1159127972,-1158949695,'Libra'],
  [-1158949695,-1158775685,'Scorpio'],
  [-1158775685,-1158599187,'Sagittarius'],
  [-1158599187,-1158415050,'Capricorn'],
  [-1158415050,-1158221162,'Aquarius'],
  [-1158221162,-1158018360,'Pisces'],
  [-1158018360,-1157808548,'Aries'],
  [-1157808548,-1157593308,'Taurus'],
  [-1157593308,-1157374907,'Gemini'],
  [-1157374907,-1157158429,'Cancer'],
  [-1157158429,-1156951167,'Leo'],
  [-1156951167,-1156758169,'Virgo'],
  [-1156758169,-1156578802,'Libra'],
  [-1156578802,-1156407432,'Scorpio'],
  [-1156407432,-1156236307,'Sagittarius'],
  [-1156236307,-1156058069,'Capricorn'],
  [-1156058069,-1155867987,'Aquarius'],
  [-1155867987,-1155665688,'Pisces'],
  [-1155665688,-1155454416,'Aries'],
  [-1155454416,-1155238106,'Taurus'],
  [-1155238106,-1155019682,'Gemini'],
  [-1155019682,-1154802411,'Cancer'],
  [-1154802411,-1154591641,'Leo'],
  [-1154591641,-1154393111,'Virgo'],
  [-1154393111,-1154208906,'Libra'],
  [-1154208906,-1154035680,'Scorpio'],
  [-1154035680,-1153866428,'Sagittarius'],
  [-1153866428,-1153693137,'Capricorn'],
  [-1153693137,-1153509027,'Aquarius'],
  [-1153509027,-1153310970,'Pisces'],
  [-1153310970,-1153100887,'Aries'],
  [-1153100887,-1152884070,'Taurus'],
  [-1152884070,-1152665616,'Gemini'],
  [-1152665616,-1152448991,'Cancer'],
  [-1152448991,-1152237540,'Leo'],
  [-1152237540,-1152035346,'Virgo'],
  [-1152035346,-1151845387,'Libra'],
  [-1151845387,-1151666899,'Scorpio'],
  [-1151666899,-1151495080,'Sagittarius'],
  [-1151495080,-1151322889,'Capricorn'],
  [-1151322889,-1151143110,'Aquarius'],
  [-1151143110,-1150950533,'Pisces'],
  [-1150950533,-1150744278,'Aries'],
  [-1150744278,-1150528548,'Taurus'],
  [-1150528548,-1150310131,'Gemini'],
  [-1150310131,-1150094483,'Cancer'],
  [-1150094483,-1149884667,'Leo'],
  [-1149884667,-1149682549,'Virgo'],
  [-1149682549,-1149489515,'Libra'],
  [-1149489515,-1149305598,'Scorpio'],
  [-1149305598,-1149128376,'Sagittarius'],
  [-1149128376,-1148953095,'Capricorn'],
  [-1148953095,-1148773767,'Aquarius'],
  [-1148773767,-1148584758,'Pisces'],
  [-1148584758,-1148382923,'Aries'],
  [-1148382923,-1148169768,'Taurus'],
  [-1148169768,-1147951658,'Gemini'],
  [-1147951658,-1147736251,'Cancer'],
  [-1147736251,-1147528340,'Leo'],
  [-1147528340,-1147329041,'Virgo'],
  [-1147329041,-1147137326,'Libra'],
  [-1147137326,-1146951531,'Scorpio'],
  [-1146951531,-1146769695,'Sagittarius'],
  [-1146769695,-1146589223,'Capricorn'],
  [-1146589223,-1146406578,'Aquarius'],
  [-1146406578,-1146217523,'Pisces'],
  [-1146217523,-1146018312,'Aries'],
  [-1146018312,-1145807959,'Taurus'],
  [-1145807959,-1145590499,'Gemini'],
  [-1145590499,-1145374169,'Cancer'],
  [-1145374169,-1145166403,'Leo'],
  [-1145166403,-1144969724,'Virgo'],
  [-1144969724,-1144782004,'Libra'],
  [-1144782004,-1144599076,'Scorpio'],
  [-1144599076,-1144417022,'Sagittarius'],
  [-1144417022,-1144233204,'Capricorn'],
  [-1144233204,-1144045998,'Aquarius'],
  [-1144045998,-1143853746,'Pisces'],
  [-1143853746,-1143654139,'Aries'],
  [-1143654139,-1143445318,'Taurus'],
  [-1143445318,-1143228647,'Gemini'],
  [-1143228647,-1143010699,'Cancer'],
  [-1143010699,-1142800535,'Leo'],
  [-1142800535,-1142603555,'Virgo'],
  [-1142603555,-1142418747,'Libra'],
  [-1142418747,-1142240757,'Scorpio'],
  [-1142240757,-1142063200,'Sagittarius'],
  [-1142063200,-1141881096,'Capricorn'],
  [-1141881096,-1141692167,'Aquarius'],
  [-1141692167,-1141496380,'Pisces'],
  [-1141496380,-1141294041,'Aries'],
  [-1141294041,-1141084694,'Taurus'],
  [-1141084694,-1140868506,'Gemini'],
  [-1140868506,-1140649326,'Cancer'],
  [-1140649326,-1140435366,'Leo'],
  [-1140435366,-1140234451,'Virgo'],
  [-1140234451,-1140048488,'Libra'],
  [-1140048488,-1139873119,'Scorpio'],
  [-1139873119,-1139700982,'Sagittarius'],
  [-1139700982,-1139524761,'Capricorn'],
  [-1139524761,-1139339423,'Aquarius'],
  [-1139339423,-1139143644,'Pisces'],
  [-1139143644,-1138939021,'Aries'],
  [-1138939021,-1138727723,'Taurus'],
  [-1138727723,-1138511238,'Gemini'],
  [-1138511238,-1138291883,'Cancer'],
  [-1138291883,-1138075217,'Leo'],
  [-1138075217,-1137868881,'Virgo'],
  [-1137868881,-1137677593,'Libra'],
  [-1137677593,-1137499882,'Scorpio'],
  [-1137499882,-1137329509,'Sagittarius'],
  [-1137329509,-1137158580,'Capricorn'],
  [-1137158580,-1136979908,'Aquarius'],
  [-1136979908,-1136789076,'Pisces'],
  [-1136789076,-1136585851,'Aries'],
  [-1136585851,-1136373435,'Taurus'],
  [-1136373435,-1136156008,'Gemini'],
  [-1136156008,-1135937041,'Cancer'],
  [-1135937041,-1135720267,'Leo'],
  [-1135720267,-1135510769,'Virgo'],
  [-1135510769,-1135313354,'Libra'],
  [-1135313354,-1135129342,'Scorpio'],
  [-1135129342,-1134955382,'Sagittarius'],
  [-1134955382,-1134785044,'Capricorn'],
  [-1134785044,-1134610973,'Aquarius'],
  [-1134610973,-1134426736,'Pisces'],
  [-1134426736,-1134228832,'Aries'],
  [-1134228832,-1134018357,'Taurus'],
  [-1134018357,-1133800567,'Gemini'],
  [-1133800567,-1133581704,'Cancer'],
  [-1133581704,-1133366383,'Leo'],
  [-1133366383,-1133157627,'Virgo'],
  [-1133157627,-1132957723,'Libra'],
  [-1132957723,-1132767947,'Scorpio'],
  [-1132767947,-1132587403,'Sagittarius'],
  [-1132587403,-1132412579,'Capricorn'],
  [-1132412579,-1132237966,'Aquarius'],
  [-1132237966,-1132057254,'Pisces'],
  [-1132057254,-1131865001,'Aries'],
  [-1131865001,-1131659030,'Taurus'],
  [-1131659030,-1131442654,'Gemini'],
  [-1131442654,-1131223603,'Cancer'],
  [-1131223603,-1131009234,'Leo'],
  [-1131009234,-1130803088,'Virgo'],
  [-1130803088,-1130605253,'Libra'],
  [-1130605253,-1130414507,'Scorpio'],
  [-1130414507,-1130229506,'Sagittarius'],
  [-1130229506,-1130048647,'Capricorn'],
  [-1130048647,-1129869280,'Aquarius'],
  [-1129869280,-1129687197,'Pisces'],
  [-1129687197,-1129497241,'Aries'],
  [-1129497241,-1129295324,'Taurus'],
  [-1129295324,-1129081639,'Gemini'],
  [-1129081639,-1128862636,'Cancer'],
  [-1128862636,-1128647729,'Leo'],
  [-1128647729,-1128443000,'Virgo'],
  [-1128443000,-1128248679,'Libra'],
  [-1128248679,-1128061386,'Scorpio'],
  [-1128061386,-1127877296,'Sagittarius'],
  [-1127877296,-1127693845,'Capricorn'],
  [-1127693845,-1127509670,'Aquarius'],
  [-1127509670,-1127323202,'Pisces'],
  [-1127323202,-1127131472,'Aries'],
  [-1127131472,-1126930732,'Taurus'],
  [-1126930732,-1126719212,'Gemini'],
  [-1126719212,-1126500601,'Cancer'],
  [-1126500601,-1126284016,'Leo'],
  [-1126284016,-1126078068,'Virgo'],
  [-1126078068,-1125885186,'Libra'],
  [-1125885186,-1125701889,'Scorpio'],
  [-1125701889,-1125522393,'Sagittarius'],
  [-1125522393,-1125341647,'Capricorn'],
  [-1125341647,-1125156836,'Aquarius'],
  [-1125156836,-1124967091,'Pisces'],
  [-1124967091,-1124771785,'Aries'],
  [-1124771785,-1124569326,'Taurus'],
  [-1124569326,-1124358168,'Gemini'],
  [-1124358168,-1124139905,'Cancer'],
  [-1124139905,-1123921481,'Leo'],
  [-1123921481,-1123712216,'Virgo'],
  [-1123712216,-1123517295,'Libra'],
  [-1123517295,-1123335089,'Scorpio'],
  [-1123335089,-1123159679,'Sagittarius'],
  [-1123159679,-1122984301,'Capricorn'],
  [-1122984301,-1122803621,'Aquarius'],
  [-1122803621,-1122614919,'Pisces'],
  [-1122614919,-1122417799,'Aries'],
  [-1122417799,-1122212785,'Taurus'],
  [-1122212785,-1122000372,'Gemini'],
  [-1122000372,-1121782044,'Cancer'],
  [-1121782044,-1121562528,'Leo'],
  [-1121562528,-1121349658,'Virgo'],
  [-1121349658,-1121150113,'Libra'],
  [-1121150113,-1120965032,'Scorpio'],
  [-1120965032,-1120790146,'Sagittarius'],
  [-1120790146,-1120618667,'Capricorn'],
  [-1120618667,-1120443737,'Aquarius'],
  [-1120443737,-1120260079,'Pisces'],
  [-1120260079,-1120065166,'Aries'],
  [-1120065166,-1119859479,'Taurus'],
  [-1119859479,-1119645583,'Gemini'],
  [-1119645583,-1119426774,'Cancer'],
  [-1119426774,-1119207187,'Leo'],
  [-1119207187,-1118992374,'Virgo'],
  [-1118992374,-1118788135,'Libra'],
  [-1118788135,-1118597529,'Scorpio'],
  [-1118597529,-1118419001,'Sagittarius'],
  [-1118419001,-1118247402,'Capricorn'],
  [-1118247402,-1118075993,'Aquarius'],
  [-1118075993,-1117898072,'Pisces'],
  [-1117898072,-1117708509,'Aries'],
  [-1117708509,-1117505505,'Taurus'],
  [-1117505505,-1117291621,'Gemini'],
  [-1117291621,-1117072345,'Cancer'],
  [-1117072345,-1116853269,'Leo'],
  [-1116853269,-1116638840,'Virgo'],
  [-1116638840,-1116432536,'Libra'],
  [-1116432536,-1116236899,'Scorpio'],
  [-1116236899,-1116052374,'Sagittarius'],
  [-1116052374,-1115876511,'Capricorn'],
  [-1115876511,-1115704334,'Aquarius'],
  [-1115704334,-1115529381,'Pisces'],
  [-1115529381,-1115345125,'Aries'],
  [-1115345125,-1115147091,'Taurus'],
  [-1115147091,-1114935578,'Gemini'],
  [-1114935578,-1114716502,'Cancer'],
  [-1114716502,-1114497829,'Leo'],
  [-1114497829,-1114285035,'Virgo'],
  [-1114285035,-1114080028,'Libra'],
  [-1114080028,-1113882995,'Scorpio'],
  [-1113882995,-1113693866,'Sagittarius'],
  [-1113693866,-1113512017,'Capricorn'],
  [-1113512017,-1113335179,'Aquarius'],
  [-1113335179,-1113158823,'Pisces'],
  [-1113158823,-1112976804,'Aries'],
  [-1112976804,-1112783215,'Taurus'],
  [-1112783215,-1112575543,'Gemini'],
  [-1112575543,-1112357750,'Cancer'],
  [-1112357750,-1112138964,'Leo'],
  [-1112138964,-1111927178,'Virgo'],
  [-1111927178,-1111724910,'Libra'],
  [-1111724910,-1111530478,'Scorpio'],
  [-1111530478,-1111341362,'Sagittarius'],
  [-1111341362,-1111156085,'Capricorn'],
  [-1111156085,-1110973825,'Aquarius'],
  [-1110973825,-1110792711,'Pisces'],
  [-1110792711,-1110608738,'Aries'],
  [-1110608738,-1110416546,'Taurus'],
  [-1110416546,-1110212049,'Gemini'],
  [-1110212049,-1109996270,'Cancer'],
  [-1109996270,-1109777039,'Leo'],
  [-1109777039,-1109564339,'Virgo'],
  [-1109564339,-1109363254,'Libra'],
  [-1109363254,-1109172430,'Scorpio'],
  [-1109172430,-1108987417,'Sagittarius'],
  [-1108987417,-1108804098,'Capricorn'],
  [-1108804098,-1108620229,'Aquarius'],
  [-1108620229,-1108434836,'Pisces'],
  [-1108434836,-1108246411,'Aries'],
  [-1108246411,-1108051972,'Taurus'],
  [-1108051972,-1107848098,'Gemini'],
  [-1107848098,-1107633961,'Cancer'],
  [-1107633961,-1107414493,'Leo'],
  [-1107414493,-1107199265,'Virgo'],
  [-1107199265,-1106996057,'Libra'],
  [-1106996057,-1106806048,'Scorpio'],
  [-1106806048,-1106625064,'Sagittarius'],
  [-1106625064,-1106447188,'Capricorn'],
  [-1106447188,-1106267356,'Aquarius'],
  [-1106267356,-1106082533,'Pisces'],
  [-1106082533,-1105891424,'Aries'],
  [-1105891424,-1105693313,'Taurus'],
  [-1105693313,-1105487359,'Gemini'],
  [-1105487359,-1105273363,'Cancer'],
  [-1105273363,-1105054080,'Leo'],
  [-1105054080,-1104836449,'Virgo'],
  [-1104836449,-1104628721,'Libra'],
  [-1104628721,-1104435188,'Scorpio'],
  [-1104435188,-1104254177,'Sagittarius'],
  [-1104254177,-1104080174,'Capricorn'],
  [-1104080174,-1103906557,'Aquarius'],
  [-1103906557,-1103727439,'Pisces'],
  [-1103727439,-1103538932,'Aries'],
  [-1103538932,-1103339840,'Taurus'],
  [-1103339840,-1103131371,'Gemini'],
  [-1103131371,-1102915988,'Cancer'],
  [-1102915988,-1102696840,'Leo'],
  [-1102696840,-1102478448,'Virgo'],
  [-1102478448,-1102266835,'Libra'],
  [-1102266835,-1102067358,'Scorpio'],
  [-1102067358,-1101881561,'Sagittarius'],
  [-1101881561,-1101706450,'Capricorn'],
  [-1101706450,-1101536002,'Aquarius'],
  [-1101536002,-1101363075,'Pisces'],
  [-1101363075,-1101181076,'Aries'],
  [-1101181076,-1100985889,'Taurus'],
  [-1100985889,-1100777759,'Gemini'],
  [-1100777759,-1100561100,'Cancer'],
  [-1100561100,-1100341613,'Leo'],
  [-1100341613,-1100123863,'Virgo'],
  [-1100123863,-1099911355,'Libra'],
  [-1099911355,-1099707594,'Scorpio'],
  [-1099707594,-1099515316,'Sagittarius'],
  [-1099515316,-1099334617,'Capricorn'],
  [-1099334617,-1099162015,'Aquarius'],
  [-1099162015,-1098991182,'Pisces'],
  [-1098991182,-1098814623,'Aries'],
  [-1098814623,-1098625733,'Taurus'],
  [-1098625733,-1098421708,'Gemini'],
  [-1098421708,-1098205928,'Cancer'],
  [-1098205928,-1097986116,'Leo'],
  [-1097986116,-1097769129,'Virgo'],
  [-1097769129,-1097558145,'Libra'],
  [-1097558145,-1097354182,'Scorpio'],
  [-1097354182,-1097158292,'Sagittarius'],
  [-1097158292,-1096971504,'Capricorn'],
  [-1096971504,-1096793118,'Aquarius'],
  [-1096793118,-1096619328,'Pisces'],
  [-1096619328,-1096443716,'Aries'],
  [-1096443716,-1096259092,'Taurus'],
  [-1096259092,-1096060276,'Gemini'],
  [-1096060276,-1095847680,'Cancer'],
  [-1095847680,-1095628404,'Leo'],
  [-1095628404,-1095411547,'Virgo'],
  [-1095411547,-1095202235,'Libra'],
  [-1095202235,-1095000838,'Scorpio'],
  [-1095000838,-1094806002,'Sagittarius'],
  [-1094806002,-1094617002,'Capricorn'],
  [-1094617002,-1094433625,'Aquarius'],
  [-1094433625,-1094254419,'Pisces'],
  [-1094254419,-1094075441,'Aries'],
  [-1094075441,-1093890840,'Taurus'],
  [-1093890840,-1093694999,'Gemini'],
  [-1093694999,-1093485907,'Cancer'],
  [-1093485907,-1093268058,'Leo'],
  [-1093268058,-1093050733,'Virgo'],
  [-1093050733,-1092841548,'Libra'],
  [-1092841548,-1092642435,'Scorpio'],
  [-1092642435,-1092451181,'Sagittarius'],
  [-1092451181,-1092264693,'Capricorn'],
  [-1092264693,-1092080812,'Aquarius'],
  [-1092080812,-1091898086,'Pisces'],
  [-1091898086,-1091714472,'Aries'],
  [-1091714472,-1091526550,'Taurus'],
  [-1091526550,-1091330201,'Gemini'],
  [-1091330201,-1091122849,'Cancer'],
  [-1091122849,-1090906472,'Leo'],
  [-1090906472,-1090688425,'Virgo'],
  [-1090688425,-1090477480,'Libra'],
  [-1090477480,-1090278184,'Scorpio'],
  [-1090278184,-1090089531,'Sagittarius'],
  [-1090089531,-1089907460,'Capricorn'],
  [-1089907460,-1089727464,'Aquarius'],
  [-1089727464,-1089545941,'Pisces'],
  [-1089545941,-1089360367,'Aries'],
  [-1089360367,-1089168829,'Taurus'],
  [-1089168829,-1088969629,'Gemini'],
  [-1088969629,-1088761638,'Cancer'],
  [-1088761638,-1088545900,'Leo'],
  [-1088545900,-1088327262,'Virgo'],
  [-1088327262,-1088113497,'Libra'],
  [-1088113497,-1087911158,'Scorpio'],
  [-1087911158,-1087721828,'Sagittarius'],
  [-1087721828,-1087542402,'Capricorn'],
  [-1087542402,-1087367371,'Aquarius'],
  [-1087367371,-1087190845,'Pisces'],
  [-1087190845,-1087007964,'Aries'],
  [-1087007964,-1086815900,'Taurus'],
  [-1086815900,-1086614210,'Gemini'],
  [-1086614210,-1086404179,'Cancer'],
  [-1086404179,-1086187997,'Leo'],
  [-1086187997,-1085969118,'Virgo'],
  [-1085969118,-1085752990,'Libra'],
  [-1085752990,-1085546113,'Scorpio'],
  [-1085546113,-1085352617,'Sagittarius'],
  [-1085352617,-1085171904,'Capricorn'],
  [-1085171904,-1084999276,'Aquarius'],
  [-1084999276,-1084827904,'Pisces'],
  [-1084827904,-1084650759,'Aries'],
  [-1084650759,-1084462490,'Taurus'],
  [-1084462490,-1084261401,'Gemini'],
  [-1084261401,-1084049982,'Cancer'],
  [-1084049982,-1083832773,'Leo'],
  [-1083832773,-1083613921,'Virgo'],
  [-1083613921,-1083397077,'Libra'],
  [-1083397077,-1083186704,'Scorpio'],
  [-1083186704,-1082987537,'Sagittarius'],
  [-1082987537,-1082801753,'Capricorn'],
  [-1082801753,-1082627104,'Aquarius'],
  [-1082627104,-1082457571,'Pisces'],
  [-1082457571,-1082285389,'Aries'],
  [-1082285389,-1082103140,'Taurus'],
  [-1082103140,-1081906383,'Gemini'],
  [-1081906383,-1081696203,'Cancer'],
  [-1081696203,-1081478494,'Leo'],
  [-1081478494,-1081259679,'Virgo'],
  [-1081259679,-1081043646,'Libra'],
  [-1081043646,-1080832744,'Scorpio'],
  [-1080832744,-1080629861,'Sagittarius'],
  [-1080629861,-1080437973,'Capricorn'],
  [-1080437973,-1080257601,'Aquarius'],
  [-1080257601,-1080085190,'Pisces'],
  [-1080085190,-1079914000,'Aries'],
  [-1079914000,-1079736163,'Taurus'],
  [-1079736163,-1079545155,'Gemini'],
  [-1079545155,-1079339083,'Cancer'],
  [-1079339083,-1079122554,'Leo'],
  [-1079122554,-1078903725,'Virgo'],
  [-1078903725,-1078688730,'Libra'],
  [-1078688730,-1078479755,'Scorpio'],
  [-1078479755,-1078277335,'Sagittarius'],
  [-1078277335,-1078082518,'Capricorn'],
  [-1078082518,-1077896394,'Aquarius'],
  [-1077896394,-1077717969,'Pisces'],
  [-1077717969,-1077543076,'Aries'],
  [-1077543076,-1077365270,'Taurus'],
  [-1077365270,-1077177819,'Gemini'],
  [-1077177819,-1076976558,'Cancer'],
  [-1076976558,-1076762993,'Leo'],
  [-1076762993,-1076544475,'Virgo'],
  [-1076544475,-1076329447,'Libra'],
  [-1076329447,-1076122294,'Scorpio'],
  [-1076122294,-1075923111,'Sagittarius'],
  [-1075923111,-1075730412,'Capricorn'],
  [-1075730412,-1075543046,'Aquarius'],
  [-1075543046,-1075360046,'Pisces'],
  [-1075360046,-1075179405,'Aries'],
  [-1075179405,-1074997408,'Taurus'],
  [-1074997408,-1074809178,'Gemini'],
  [-1074809178,-1074610406,'Cancer'],
  [-1074610406,-1074400049,'Leo'],
  [-1074400049,-1074182502,'Virgo'],
  [-1074182502,-1073966244,'Libra'],
  [-1073966244,-1073758530,'Scorpio'],
  [-1073758530,-1073561558,'Sagittarius'],
  [-1073561558,-1073373256,'Capricorn'],
  [-1073373256,-1073189883,'Aquarius'],
  [-1073189883,-1073007886,'Pisces'],
  [-1073007886,-1072824555,'Aries'],
  [-1072824555,-1072637773,'Taurus'],
  [-1072637773,-1072445475,'Gemini'],
  [-1072445475,-1072245492,'Cancer'],
  [-1072245492,-1072036514,'Leo'],
  [-1072036514,-1071820178,'Virgo'],
  [-1071820178,-1071602498,'Libra'],
  [-1071602498,-1071391735,'Scorpio'],
  [-1071391735,-1071193296,'Sagittarius'],
  [-1071193296,-1071007073,'Capricorn'],
  [-1071007073,-1070828721,'Aquarius'],
  [-1070828721,-1070652252,'Pisces'],
  [-1070652252,-1070472167,'Aries'],
  [-1070472167,-1070284893,'Taurus'],
  [-1070284893,-1070089332,'Gemini'],
  [-1070089332,-1069886055,'Cancer'],
  [-1069886055,-1069675921,'Leo'],
  [-1069675921,-1069460077,'Virgo'],
  [-1069460077,-1069241746,'Libra'],
  [-1069241746,-1069027440,'Scorpio'],
  [-1069027440,-1068824336,'Sagittarius'],
  [-1068824336,-1068635603,'Capricorn'],
  [-1068635603,-1068458682,'Aquarius'],
  [-1068458682,-1068287121,'Pisces'],
  [-1068287121,-1068113362,'Aries'],
  [-1068113362,-1067931004,'Taurus'],
  [-1067931004,-1067736883,'Gemini'],
  [-1067736883,-1067531993,'Cancer'],
  [-1067531993,-1067319734,'Leo'],
  [-1067319734,-1067103245,'Virgo'],
  [-1067103245,-1066885001,'Libra'],
  [-1066885001,-1066668860,'Scorpio'],
  [-1066668860,-1066460921,'Sagittarius'],
  [-1066460921,-1066266467,'Capricorn'],
  [-1066266467,-1066086065,'Aquarius'],
  [-1066086065,-1065914933,'Pisces'],
  [-1065914933,-1065745363,'Aries'],
  [-1065745363,-1065569338,'Taurus'],
  [-1065569338,-1065380891,'Gemini'],
  [-1065380891,-1065178591,'Cancer'],
  [-1065178591,-1064965972,'Leo'],
  [-1064965972,-1064748549,'Virgo'],
  [-1064748549,-1064530495,'Libra'],
  [-1064530495,-1064314642,'Scorpio'],
  [-1064314642,-1064104637,'Sagittarius'],
  [-1064104637,-1063905056,'Capricorn'],
  [-1063905056,-1063718540,'Aquarius'],
  [-1063718540,-1063543182,'Pisces'],
  [-1063543182,-1063372983,'Aries'],
  [-1063372983,-1063200167,'Taurus'],
  [-1063200167,-1063017454,'Gemini'],
  [-1063017454,-1062820608,'Cancer'],
  [-1062820608,-1062610685,'Leo'],
  [-1062610685,-1062393442,'Virgo'],
  [-1062393442,-1062175416,'Libra'],
  [-1062175416,-1061960755,'Scorpio'],
  [-1061960755,-1061751796,'Sagittarius'],
  [-1061751796,-1061550766,'Capricorn'],
  [-1061550766,-1061359661,'Aquarius'],
  [-1061359661,-1061178379,'Pisces'],
  [-1061178379,-1061003555,'Aries'],
  [-1061003555,-1060829290,'Taurus'],
  [-1060829290,-1060648845,'Gemini'],
  [-1060648845,-1060456723,'Cancer'],
  [-1060456723,-1060251152,'Leo'],
  [-1060251152,-1060035712,'Virgo'],
  [-1060035712,-1059817732,'Libra'],
  [-1059817732,-1059603772,'Scorpio'],
  [-1059603772,-1059397042,'Sagittarius'],
  [-1059397042,-1059198166,'Capricorn'],
  [-1059198166,-1059006780,'Aquarius'],
  [-1059006780,-1058822011,'Pisces'],
  [-1058822011,-1058641911,'Aries'],
  [-1058641911,-1058463030,'Taurus'],
  [-1058463030,-1058280695,'Gemini'],
  [-1058280695,-1058090045,'Cancer'],
  [-1058090045,-1057887884,'Leo'],
  [-1057887884,-1057674999,'Virgo'],
  [-1057674999,-1057457244,'Libra'],
  [-1057457244,-1057242768,'Scorpio'],
  [-1057242768,-1057037153,'Sagittarius'],
  [-1057037153,-1056841427,'Capricorn'],
  [-1056841427,-1056653396,'Aquarius'],
  [-1056653396,-1056469805,'Pisces'],
  [-1056469805,-1056287660,'Aries'],
  [-1056287660,-1056104492,'Taurus'],
  [-1056104492,-1055917948,'Gemini'],
  [-1055917948,-1055725338,'Cancer'],
  [-1055725338,-1055523984,'Leo'],
  [-1055523984,-1055312971,'Virgo'],
  [-1055312971,-1055095561,'Libra'],
  [-1055095561,-1054879456,'Scorpio'],
  [-1054879456,-1054672560,'Sagittarius'],
  [-1054672560,-1054478086,'Capricorn'],
  [-1054478086,-1054293852,'Aquarius'],
  [-1054293852,-1054114726,'Pisces'],
  [-1054114726,-1053935308,'Aries'],
  [-1053935308,-1053751697,'Taurus'],
  [-1053751697,-1053562089,'Gemini'],
  [-1053562089,-1053366006,'Cancer'],
  [-1053366006,-1053162926,'Leo'],
  [-1053162926,-1052952185,'Virgo'],
  [-1052952185,-1052735039,'Libra'],
  [-1052735039,-1052517030,'Scorpio'],
  [-1052517030,-1052306702,'Sagittarius'],
  [-1052306702,-1052110064,'Capricorn'],
  [-1052110064,-1051926865,'Aquarius'],
  [-1051926865,-1051751810,'Pisces'],
  [-1051751810,-1051577758,'Aries'],
  [-1051577758,-1051398335,'Taurus'],
  [-1051398335,-1051209861,'Gemini'],
  [-1051209861,-1051012026,'Cancer'],
  [-1051012026,-1050806422,'Leo'],
  [-1050806422,-1050594455,'Virgo'],
  [-1050594455,-1050377270,'Libra'],
  [-1050377270,-1050158145,'Scorpio'],
  [-1050158145,-1049944025,'Sagittarius'],
  [-1049944025,-1049742413,'Capricorn'],
  [-1049742413,-1049556047,'Aquarius'],
  [-1049556047,-1049381402,'Pisces'],
  [-1049381402,-1049211280,'Aries'],
  [-1049211280,-1049037801,'Taurus'],
  [-1049037801,-1048854686,'Gemini'],
  [-1048854686,-1048659306,'Cancer'],
  [-1048659306,-1048453127,'Leo'],
  [-1048453127,-1048239652,'Virgo'],
  [-1048239652,-1048022009,'Libra'],
  [-1048022009,-1047802945,'Scorpio'],
  [-1047802945,-1047586960,'Sagittarius'],
  [-1047586960,-1047380400,'Capricorn'],
  [-1047380400,-1047187923,'Aquarius'],
  [-1047187923,-1047009023,'Pisces'],
  [-1047009023,-1046838336,'Aries'],
  [-1046838336,-1046668247,'Taurus'],
  [-1046668247,-1046491199,'Gemini'],
  [-1046491199,-1046301791,'Cancer'],
  [-1046301791,-1046098811,'Leo'],
  [-1046098811,-1045885510,'Virgo'],
  [-1045885510,-1045667299,'Libra'],
  [-1045667299,-1045448802,'Scorpio'],
  [-1045448802,-1045233576,'Sagittarius'],
  [-1045233576,-1045025351,'Capricorn'],
  [-1045025351,-1044827760,'Aquarius'],
  [-1044827760,-1044642195,'Pisces'],
  [-1044642195,-1044466273,'Aries'],
  [-1044466273,-1044294505,'Taurus'],
  [-1044294505,-1044120002,'Gemini'],
  [-1044120002,-1043936207,'Cancer'],
  [-1043936207,-1043738965,'Leo'],
  [-1043738965,-1043528676,'Virgo'],
  [-1043528676,-1043310728,'Libra'],
  [-1043310728,-1043092377,'Scorpio'],
  [-1043092377,-1042878878,'Sagittarius'],
  [-1042878878,-1042672663,'Capricorn'],
  [-1042672663,-1042474586,'Aquarius'],
  [-1042474586,-1042284823,'Pisces'],
  [-1042284823,-1042102478,'Aries'],
  [-1042102478,-1041924947,'Taurus'],
  [-1041924947,-1041747829,'Gemini'],
  [-1041747829,-1041565570,'Cancer'],
  [-1041565570,-1041372876,'Leo'],
  [-1041372876,-1041167099,'Virgo'],
  [-1041167099,-1040950926,'Libra'],
  [-1040950926,-1040732230,'Scorpio'],
  [-1040732230,-1040519203,'Sagittarius'],
  [-1040519203,-1040315715,'Capricorn'],
  [-1040315715,-1040121100,'Aquarius'],
  [-1040121100,-1039932702,'Pisces'],
  [-1039932702,-1039747999,'Aries'],
  [-1039747999,-1039565191,'Taurus'],
  [-1039565191,-1039382514,'Gemini'],
  [-1039382514,-1039197138,'Cancer'],
  [-1039197138,-1039004988,'Leo'],
  [-1039004988,-1038802262,'Virgo'],
  [-1038802262,-1038588580,'Libra'],
  [-1038588580,-1038369669,'Scorpio'],
  [-1038369669,-1038155167,'Sagittarius'],
  [-1038155167,-1037951993,'Capricorn'],
  [-1037951993,-1037760618,'Aquarius'],
  [-1037760618,-1037576882,'Pisces'],
  [-1037576882,-1037395533,'Aries'],
  [-1037395533,-1037212677,'Taurus'],
  [-1037212677,-1037026562,'Gemini'],
  [-1037026562,-1036836558,'Cancer'],
  [-1036836558,-1036641339,'Leo'],
  [-1036641339,-1036438431,'Virgo'],
  [-1036438431,-1036226231,'Libra'],
  [-1036226231,-1036007519,'Scorpio'],
  [-1036007519,-1035790638,'Sagittarius'],
  [-1035790638,-1035584667,'Capricorn'],
  [-1035584667,-1035393005,'Aquarius'],
  [-1035393005,-1035212413,'Pisces'],
  [-1035212413,-1035036380,'Aries'],
  [-1035036380,-1034858485,'Taurus'],
  [-1034858485,-1034674496,'Gemini'],
  [-1034674496,-1034483077,'Cancer'],
  [-1034483077,-1034284584,'Leo'],
  [-1034284584,-1034079181,'Virgo'],
  [-1034079181,-1033866546,'Libra'],
  [-1033866546,-1033648065,'Scorpio'],
  [-1033648065,-1033429423,'Sagittarius'],
  [-1033429423,-1033219288,'Capricorn'],
  [-1033219288,-1033023630,'Aquarius'],
  [-1033023630,-1032841895,'Pisces'],
  [-1032841895,-1032668446,'Aries'],
  [-1032668446,-1032495949,'Taurus'],
  [-1032495949,-1032317858,'Gemini'],
  [-1032317858,-1032130116,'Cancer'],
  [-1032130116,-1031931860,'Leo'],
  [-1031931860,-1031724549,'Virgo'],
  [-1031724549,-1031510363,'Libra'],
  [-1031510363,-1031291704,'Scorpio'],
  [-1031291704,-1031072620,'Sagittarius'],
  [-1031072620,-1030859499,'Capricorn'],
  [-1030859499,-1030658578,'Aquarius'],
  [-1030658578,-1030471961,'Pisces'],
  [-1030471961,-1030296499,'Aries'],
  [-1030296499,-1030125833,'Taurus'],
  [-1030125833,-1029952797,'Gemini'],
  [-1029952797,-1029771176,'Cancer'],
  [-1029771176,-1029577283,'Leo'],
  [-1029577283,-1029371126,'Virgo'],
  [-1029371126,-1029156109,'Libra'],
  [-1029156109,-1028936997,'Scorpio'],
  [-1028936997,-1028718407,'Sagittarius'],
  [-1028718407,-1028504827,'Capricorn'],
  [-1028504827,-1028300545,'Aquarius'],
  [-1028300545,-1028108282,'Pisces'],
  [-1028108282,-1027927440,'Aries'],
  [-1027927440,-1027754069,'Taurus'],
  [-1027754069,-1027582127,'Gemini'],
  [-1027582127,-1027404941,'Cancer'],
  [-1027404941,-1027216742,'Leo'],
  [-1027216742,-1027014719,'Virgo'],
  [-1027014719,-1026800942,'Libra'],
  [-1026800942,-1026581679,'Scorpio'],
  [-1026581679,-1026363715,'Sagittarius'],
  [-1026363715,-1026151576,'Capricorn'],
  [-1026151576,-1025947408,'Aquarius'],
  [-1025947408,-1025752188,'Pisces'],
  [-1025752188,-1025565943,'Aries'],
  [-1025565943,-1025387092,'Taurus'],
  [-1025387092,-1025212008,'Gemini'],
  [-1025212008,-1025035260,'Cancer'],
  [-1025035260,-1024850679,'Leo'],
  [-1024850679,-1024653358,'Virgo'],
  [-1024653358,-1024442638,'Libra'],
  [-1024442638,-1024223992,'Scorpio'],
  [-1024223992,-1024006178,'Sagittarius'],
  [-1024006178,-1023795611,'Capricorn'],
  [-1023795611,-1023593952,'Aquarius'],
  [-1023593952,-1023399893,'Pisces'],
  [-1023399893,-1023211732,'Aries'],
  [-1023211732,-1023028251,'Taurus'],
  [-1023028251,-1022847967,'Gemini'],
  [-1022847967,-1022667881,'Cancer'],
  [-1022667881,-1022483169,'Leo'],
  [-1022483169,-1022288508,'Virgo'],
  [-1022288508,-1022081007,'Libra'],
  [-1022081007,-1021863670,'Scorpio'],
  [-1021863670,-1021645355,'Sagittarius'],
  [-1021645355,-1021434896,'Capricorn'],
  [-1021434896,-1021235502,'Aquarius'],
  [-1021235502,-1021045014,'Pisces'],
  [-1021045014,-1020859400,'Aries'],
  [-1020859400,-1020675514,'Taurus'],
  [-1020675514,-1020491806,'Gemini'],
  [-1020491806,-1020307141,'Cancer'],
  [-1020307141,-1020119134,'Leo'],
  [-1020119134,-1019923917,'Virgo'],
  [-1019923917,-1019718045,'Libra'],
  [-1019718045,-1019502070,'Scorpio'],
  [-1019502070,-1019282913,'Sagittarius'],
  [-1019282913,-1019070531,'Capricorn'],
  [-1019070531,-1018870847,'Aquarius'],
  [-1018870847,-1018682953,'Pisces'],
  [-1018682953,-1018501853,'Aries'],
  [-1018501853,-1018322054,'Taurus'],
  [-1018322054,-1018139733,'Gemini'],
  [-1018139733,-1017953163,'Cancer'],
  [-1017953163,-1017761488,'Leo'],
  [-1017761488,-1017563310,'Virgo'],
  [-1017563310,-1017356712,'Libra'],
  [-1017356712,-1017141380,'Scorpio'],
  [-1017141380,-1016921611,'Sagittarius'],
  [-1016921611,-1016706165,'Capricorn'],
  [-1016706165,-1016503000,'Aquarius'],
  [-1016503000,-1016314046,'Pisces'],
  [-1016314046,-1016135438,'Aries'],
  [-1016135438,-1015960814,'Taurus'],
  [-1015960814,-1015784013,'Gemini'],
  [-1015784013,-1015600653,'Cancer'],
  [-1015600653,-1015408712,'Leo'],
  [-1015408712,-1015207981,'Virgo'],
  [-1015207981,-1014999103,'Libra'],
  [-1014999103,-1014783248,'Scorpio'],
  [-1014783248,-1014563406,'Sagittarius'],
  [-1014563406,-1014345676,'Capricorn'],
  [-1014345676,-1014137566,'Aquarius'],
  [-1014137566,-1013943627,'Pisces'],
  [-1013943627,-1013762892,'Aries'],
  [-1013762892,-1013590215,'Taurus'],
  [-1013590215,-1013418773,'Gemini'],
  [-1013418773,-1013241918,'Cancer'],
  [-1013241918,-1013054672,'Leo'],
  [-1013054672,-1012855107,'Virgo'],
  [-1012855107,-1012644828,'Libra'],
  [-1012644828,-1012427689,'Scorpio'],
  [-1012427689,-1012207954,'Sagittarius'],
  [-1012207954,-1011989996,'Capricorn'],
  [-1011989996,-1011778721,'Aquarius'],
  [-1011778721,-1011578716,'Pisces'],
  [-1011578716,-1011391818,'Aries'],
  [-1011391818,-1011215862,'Taurus'],
  [-1011215862,-1011045440,'Gemini'],
  [-1011045440,-1010873504,'Cancer'],
  [-1010873504,-1010692986,'Leo'],
  [-1010692986,-1010498827,'Virgo'],
  [-1010498827,-1010290524,'Libra'],
  [-1010290524,-1010072900,'Scorpio'],
  [-1010072900,-1009852991,'Sagittarius'],
  [-1009852991,-1009636135,'Capricorn'],
  [-1009636135,-1009425207,'Aquarius'],
  [-1009425207,-1009222283,'Pisces'],
  [-1009222283,-1009029256,'Aries'],
  [-1009029256,-1008846595,'Taurus'],
  [-1008846595,-1008671924,'Gemini'],
  [-1008671924,-1008499858,'Cancer'],
  [-1008499858,-1008323253,'Leo'],
  [-1008323253,-1008135177,'Virgo'],
  [-1008135177,-1007931908,'Libra'],
  [-1007931908,-1007716121,'Scorpio'],
  [-1007716121,-1007496116,'Sagittarius'],
  [-1007496116,-1007280006,'Capricorn'],
  [-1007280006,-1007071305,'Aquarius'],
  [-1007071305,-1006869939,'Pisces'],
  [-1006869939,-1006675310,'Aries'],
  [-1006675310,-1006487551,'Taurus'],
  [-1006487551,-1006306460,'Gemini'],
  [-1006306460,-1006129605,'Cancer'],
  [-1006129605,-1005951782,'Leo'],
  [-1005951782,-1005766336,'Virgo'],
  [-1005766336,-1005567789,'Libra'],
  [-1005567789,-1005355589,'Scorpio'],
  [-1005355589,-1005136312,'Sagittarius'],
  [-1005136312,-1004919852,'Capricorn'],
  [-1004919852,-1004712396,'Aquarius'],
  [-1004712396,-1004514226,'Pisces'],
  [-1004514226,-1004322644,'Aries'],
  [-1004322644,-1004135222,'Taurus'],
  [-1004135222,-1003950856,'Gemini'],
  [-1003950856,-1003768633,'Cancer'],
  [-1003768633,-1003586072,'Leo'],
  [-1003586072,-1003398712,'Virgo'],
  [-1003398712,-1003201595,'Libra'],
  [-1003201595,-1002992347,'Scorpio'],
  [-1002992347,-1002774493,'Sagittarius'],
  [-1002774493,-1002557037,'Capricorn'],
  [-1002557037,-1002348494,'Aquarius'],
  [-1002348494,-1002151601,'Pisces'],
  [-1002151601,-1001963836,'Aries'],
  [-1001963836,-1001780804,'Taurus'],
  [-1001780804,-1001598758,'Gemini'],
  [-1001598758,-1001415357,'Cancer'],
  [-1001415357,-1001228946,'Leo'],
  [-1001228946,-1001037485,'Virgo'],
  [-1001037485,-1000838343,'Libra'],
  [-1000838343,-1000629652,'Scorpio'],
  [-1000629652,-1000412927,'Sagittarius'],
  [-1000412927,-1000194564,'Capricorn'],
  [-1000194564,-999983209,'Aquarius'],
  [-999983209,-999784298,'Pisces'],
  [-999784298,-999597500,'Aries'],
  [-999597500,-999418512,'Taurus'],
  [-999418512,-999241773,'Gemini'],
  [-999241773,-999062297,'Cancer'],
  [-999062297,-998876592,'Leo'],
  [-998876592,-998682862,'Virgo'],
  [-998682862,-998480653,'Libra'],
  [-998480653,-998270377,'Scorpio'],
  [-998270377,-998053743,'Sagittarius'],
  [-998053743,-997834953,'Capricorn'],
  [-997834953,-997620705,'Aquarius'],
  [-997620705,-997417485,'Pisces'],
  [-997417485,-997227790,'Aries'],
  [-997227790,-997049280,'Taurus'],
  [-997049280,-996876451,'Gemini'],
  [-996876451,-996702688,'Cancer'],
  [-996702688,-996521939,'Leo'],
  [-996521939,-996330276,'Virgo'],
  [-996330276,-996127126,'Libra'],
  [-996127126,-995914972,'Scorpio'],
  [-995914972,-995697551,'Sagittarius'],
  [-995697551,-995478768,'Capricorn'],
  [-995478768,-995263050,'Aquarius'],
  [-995263050,-995055630,'Pisces'],
  [-995055630,-994860628,'Aries'],
  [-994860628,-994678509,'Taurus'],
  [-994678509,-994505571,'Gemini'],
  [-994505571,-994335281,'Cancer'],
  [-994335281,-994160186,'Leo'],
  [-994160186,-993973884,'Virgo'],
  [-993973884,-993773480,'Libra'],
  [-993773480,-993561278,'Scorpio'],
  [-993561278,-993343092,'Sagittarius'],
  [-993343092,-993124479,'Capricorn'],
  [-993124479,-992909077,'Aquarius'],
  [-992909077,-992699851,'Pisces'],
  [-992699851,-992500143,'Aries'],
  [-992500143,-992312229,'Taurus'],
  [-992312229,-992135134,'Gemini'],
  [-992135134,-991964063,'Cancer'],
  [-991964063,-991791794,'Leo'],
  [-991791794,-991610716,'Virgo'],
  [-991610716,-991415435,'Libra'],
  [-991415435,-991205898,'Scorpio'],
  [-991205898,-990988010,'Sagittarius'],
  [-990988010,-990769513,'Capricorn'],
  [-990769513,-990555310,'Aquarius'],
  [-990555310,-990347145,'Pisces'],
  [-990347145,-990146089,'Aries'],
  [-990146089,-989953736,'Taurus'],
  [-989953736,-989770828,'Gemini'],
  [-989770828,-989595197,'Cancer'],
  [-989595197,-989421450,'Leo'],
  [-989421450,-989242450,'Virgo'],
  [-989242450,-989051642,'Libra'],
  [-989051642,-988846316,'Scorpio'],
  [-988846316,-988630217,'Sagittarius'],
  [-988630217,-988411782,'Capricorn'],
  [-988411782,-988198293,'Aquarius'],
  [-988198293,-987992383,'Pisces'],
  [-987992383,-987793560,'Aries'],
  [-987793560,-987601034,'Taurus'],
  [-987601034,-987414648,'Gemini'],
  [-987414648,-987233643,'Cancer'],
  [-987233643,-987055143,'Leo'],
  [-987055143,-986874082,'Virgo'],
  [-986874082,-986684611,'Libra'],
  [-986684611,-986482681,'Scorpio'],
  [-986482681,-986269191,'Sagittarius'],
  [-986269191,-986050947,'Capricorn'],
  [-986050947,-985836775,'Aquarius'],
  [-985836775,-985631848,'Pisces'],
  [-985631848,-985436249,'Aries'],
  [-985436249,-985247400,'Taurus'],
  [-985247400,-985062551,'Gemini'],
  [-985062551,-984879627,'Cancer'],
  [-984879627,-984696675,'Leo'],
  [-984696675,-984511030,'Virgo'],
  [-984511030,-984319211,'Libra'],
  [-984319211,-984117959,'Scorpio'],
  [-984117959,-983906485,'Sagittarius'],
  [-983906485,-983688701,'Capricorn'],
  [-983688701,-983472649,'Aquarius'],
  [-983472649,-983265909,'Pisces'],
  [-983265909,-983071163,'Aries'],
  [-983071163,-982886210,'Taurus'],
  [-982886210,-982706440,'Gemini'],
  [-982706440,-982527015,'Cancer'],
  [-982527015,-982344128,'Leo'],
  [-982344128,-982155416,'Virgo'],
  [-982155416,-981959670,'Libra'],
  [-981959670,-981756218,'Scorpio'],
  [-981756218,-981544945,'Sagittarius'],
  [-981544945,-981327694,'Capricorn'],
  [-981327694,-981109810,'Aquarius'],
  [-981109810,-980899064,'Pisces'],
  [-980899064,-980701166,'Aries'],
  [-980701166,-980516495,'Taurus'],
  [-980516495,-980340746,'Gemini'],
  [-980340746,-980167360,'Cancer'],
  [-980167360,-979989758,'Leo'],
  [-979989758,-979803173,'Virgo'],
  [-979803173,-979606026,'Libra'],
  [-979606026,-979399750,'Scorpio'],
  [-979399750,-979186872,'Sagittarius'],
  [-979186872,-978969670,'Capricorn'],
  [-978969670,-978751146,'Aquarius'],
  [-978751146,-978536752,'Pisces'],
  [-978536752,-978333157,'Aries'],
  [-978333157,-978144038,'Taurus'],
  [-978144038,-977967601,'Gemini'],
  [-977967601,-977797671,'Cancer'],
  [-977797671,-977626323,'Leo'],
  [-977626323,-977446171,'Virgo'],
  [-977446171,-977252772,'Libra'],
  [-977252772,-977046625,'Scorpio'],
  [-977046625,-976832184,'Sagittarius'],
  [-976832184,-976614299,'Capricorn'],
  [-976614299,-976396142,'Aquarius'],
  [-976396142,-976180693,'Pisces'],
  [-976180693,-975972670,'Aries'],
  [-975972670,-975776985,'Taurus'],
  [-975776985,-975595090,'Gemini'],
  [-975595090,-975423268,'Cancer'],
  [-975423268,-975254266,'Leo'],
  [-975254266,-975079837,'Virgo'],
  [-975079837,-974893090,'Libra'],
  [-974893090,-974691371,'Scorpio'],
  [-974691371,-974477923,'Sagittarius'],
  [-974477923,-974259492,'Capricorn'],
  [-974259492,-974041699,'Aquarius'],
  [-974041699,-973827417,'Pisces'],
  [-973827417,-973618875,'Aries'],
  [-973618875,-973419172,'Taurus'],
  [-973419172,-973230808,'Gemini'],
  [-973230808,-973053009,'Cancer'],
  [-973053009,-972881013,'Leo'],
  [-972881013,-972707672,'Virgo'],
  [-972707672,-972525624,'Libra'],
  [-972525624,-972329815,'Scorpio'],
  [-972329815,-972120278,'Sagittarius'],
  [-972120278,-971902732,'Capricorn'],
  [-971902732,-971684922,'Aquarius'],
  [-971684922,-971471965,'Pisces'],
  [-971471965,-971265697,'Aries'],
  [-971265697,-971066727,'Taurus'],
  [-971066727,-970875662,'Gemini'],
  [-970875662,-970692334,'Cancer'],
  [-970692334,-970514471,'Leo'],
  [-970514471,-970337491,'Virgo'],
  [-970337491,-970155516,'Libra'],
  [-970155516,-969963166,'Scorpio'],
  [-969963166,-969758009,'Sagittarius'],
  [-969758009,-969542794,'Capricorn'],
  [-969542794,-969324937,'Aquarius'],
  [-969324937,-969112019,'Pisces'],
  [-969112019,-968907805,'Aries'],
  [-968907805,-968712229,'Taurus'],
  [-968712229,-968523401,'Gemini'],
  [-968523401,-968339133,'Cancer'],
  [-968339133,-968157223,'Leo'],
  [-968157223,-967975087,'Virgo'],
  [-967975087,-967789439,'Libra'],
  [-967789439,-967596564,'Scorpio'],
  [-967596564,-967393598,'Sagittarius'],
  [-967393598,-967180747,'Capricorn'],
  [-967180747,-966963052,'Aquarius'],
  [-966963052,-966748759,'Pisces'],
  [-966748759,-966544324,'Aries'],
  [-966544324,-966351216,'Taurus'],
  [-966351216,-966166646,'Gemini'],
  [-966166646,-965986013,'Cancer'],
  [-965986013,-965804968,'Leo'],
  [-965804968,-965620460,'Virgo'],
  [-965620460,-965430767,'Libra'],
  [-965430767,-965234707,'Scorpio'],
  [-965234707,-965031014,'Sagittarius'],
  [-965031014,-964819184,'Capricorn'],
  [-964819184,-964601727,'Aquarius'],
  [-964601727,-964385394,'Pisces'],
  [-964385394,-964178251,'Aries'],
  [-964178251,-963984476,'Taurus'],
  [-963984476,-963802424,'Gemini'],
  [-963802424,-963626536,'Cancer'],
  [-963626536,-963450237,'Leo'],
  [-963450237,-963268180,'Virgo'],
  [-963268180,-963077703,'Libra'],
  [-963077703,-962878861,'Scorpio'],
  [-962878861,-962672797,'Sagittarius'],
  [-962672797,-962460355,'Capricorn'],
  [-962460355,-962242970,'Aquarius'],
  [-962242970,-962025013,'Pisces'],
  [-962025013,-961814005,'Aries'],
  [-961814005,-961616379,'Taurus'],
  [-961616379,-961433061,'Gemini'],
  [-961433061,-961259385,'Cancer'],
  [-961259385,-961087957,'Leo'],
  [-961087957,-960911399,'Virgo'],
  [-960911399,-960724568,'Libra'],
  [-960724568,-960526226,'Scorpio'],
  [-960526226,-960318566,'Sagittarius'],
  [-960318566,-960104719,'Capricorn'],
  [-960104719,-959887114,'Aquarius'],
  [-959887114,-959668671,'Pisces'],
  [-959668671,-959454776,'Aries'],
  [-959454776,-959252039,'Taurus'],
  [-959252039,-959063944,'Gemini'],
  [-959063944,-958888252,'Cancer'],
  [-958888252,-958718454,'Leo'],
  [-958718454,-958546602,'Virgo'],
  [-958546602,-958365618,'Libra'],
  [-958365618,-958171578,'Scorpio'],
  [-958171578,-957965195,'Sagittarius'],
  [-957965195,-957750664,'Capricorn'],
  [-957750664,-957532667,'Aquarius'],
  [-957532667,-957314711,'Pisces'],
  [-957314711,-957100372,'Aries'],
  [-957100372,-956894298,'Taurus'],
  [-956894298,-956700491,'Gemini'],
  [-956700491,-956519311,'Cancer'],
  [-956519311,-956346656,'Leo'],
  [-956346656,-956175695,'Virgo'],
  [-956175695,-955999013,'Libra'],
  [-955999013,-955810688,'Scorpio'],
  [-955810688,-955608553,'Sagittarius'],
  [-955608553,-955395365,'Capricorn'],
  [-955395365,-955177212,'Aquarius'],
  [-955177212,-954959876,'Pisces'],
  [-954959876,-954747084,'Aries'],
  [-954747084,-954541323,'Taurus'],
  [-954541323,-954344617,'Gemini'],
  [-954344617,-954157811,'Cancer'],
  [-954157811,-953979261,'Leo'],
  [-953979261,-953804681,'Virgo'],
  [-953804681,-953628121,'Libra'],
  [-953628121,-953443442,'Scorpio'],
  [-953443442,-953246286,'Sagittarius'],
  [-953246286,-953036421,'Capricorn'],
  [-953036421,-952818892,'Aquarius'],
  [-952818892,-952601511,'Pisces'],
  [-952601511,-952390258,'Aries'],
  [-952390258,-952187342,'Taurus'],
  [-952187342,-951992335,'Gemini'],
  [-951992335,-951803933,'Cancer'],
  [-951803933,-951620598,'Leo'],
  [-951620598,-951440216,'Virgo'],
  [-951440216,-951259576,'Libra'],
  [-951259576,-951074322,'Scorpio'],
  [-951074322,-950879877,'Sagittarius'],
  [-950879877,-950673595,'Capricorn'],
  [-950673595,-950457602,'Aquarius'],
  [-950457602,-950239461,'Pisces'],
  [-950239461,-950027835,'Aries'],
  [-950027835,-949827063,'Taurus'],
  [-949827063,-949636124,'Gemini'],
  [-949636124,-949451165,'Cancer'],
  [-949451165,-949268229,'Leo'],
  [-949268229,-949084659,'Virgo'],
  [-949084659,-948898981,'Libra'],
  [-948898981,-948709666,'Scorpio'],
  [-948709666,-948514130,'Sagittarius'],
  [-948514130,-948309456,'Capricorn'],
  [-948309456,-948095160,'Aquarius'],
  [-948095160,-947876237,'Pisces'],
  [-947876237,-947662085,'Aries'],
  [-947662085,-947460176,'Taurus'],
  [-947460176,-947271419,'Gemini'],
  [-947271419,-947091303,'Cancer'],
  [-947091303,-946913477,'Leo'],
  [-946913477,-946732585,'Virgo'],
  [-946732585,-946545842,'Libra'],
  [-946545842,-946352870,'Scorpio'],
  [-946352870,-946153820,'Sagittarius'],
  [-946153820,-945947886,'Capricorn'],
  [-945947886,-945734215,'Aquarius'],
  [-945734215,-945515071,'Pisces'],
  [-945515071,-945297874,'Aries'],
  [-945297874,-945091688,'Taurus'],
  [-945091688,-944900704,'Gemini'],
  [-944900704,-944722168,'Cancer'],
  [-944722168,-944549283,'Leo'],
  [-944549283,-944374635,'Virgo'],
  [-944374635,-944192553,'Libra'],
  [-944192553,-944000649,'Scorpio'],
  [-944000649,-943799590,'Sagittarius'],
  [-943799590,-943591115,'Capricorn'],
  [-943591115,-943376500,'Aquarius'],
  [-943376500,-943157449,'Pisces'],
  [-943157449,-942938651,'Aries'],
  [-942938651,-942727815,'Taurus'],
  [-942727815,-942531205,'Gemini'],
  [-942531205,-942349258,'Cancer'],
  [-942349258,-942176912,'Leo'],
  [-942176912,-942006678,'Virgo'],
  [-942006678,-941831197,'Libra'],
  [-941831197,-941645127,'Scorpio'],
  [-941645127,-941446654,'Sagittarius'],
  [-941446654,-941237567,'Capricorn'],
  [-941237567,-941021568,'Aquarius'],
  [-941021568,-940802348,'Pisces'],
  [-940802348,-940583752,'Aries'],
  [-940583752,-940370848,'Taurus'],
  [-940370848,-940168975,'Gemini'],
  [-940168975,-939980700,'Cancer'],
  [-939980700,-939803968,'Leo'],
  [-939803968,-939633163,'Virgo'],
  [-939633163,-939461212,'Libra'],
  [-939461212,-939281347,'Scorpio'],
  [-939281347,-939088830,'Sagittarius'],
  [-939088830,-938882797,'Capricorn'],
  [-938882797,-938666943,'Aquarius'],
  [-938666943,-938447405,'Pisces'],
  [-938447405,-938229686,'Aries'],
  [-938229686,-938017673,'Taurus'],
  [-938017673,-937814164,'Gemini'],
  [-937814164,-937620978,'Cancer'],
  [-937620978,-937437932,'Leo'],
  [-937437932,-937262226,'Virgo'],
  [-937262226,-937088834,'Libra'],
  [-937088834,-936911515,'Scorpio'],
  [-936911515,-936724233,'Sagittarius'],
  [-936724233,-936523269,'Capricorn'],
  [-936523269,-936309836,'Aquarius'],
  [-936309836,-936090497,'Pisces'],
  [-936090497,-935873254,'Aries'],
  [-935873254,-935663189,'Taurus'],
  [-935663189,-935461593,'Gemini'],
  [-935461593,-935267849,'Cancer'],
  [-935267849,-935080955,'Leo'],
  [-935080955,-934899572,'Virgo'],
  [-934899572,-934721289,'Libra'],
  [-934721289,-934542009,'Scorpio'],
  [-934542009,-934356339,'Sagittarius'],
  [-934356339,-934159280,'Capricorn'],
  [-934159280,-933949255,'Aquarius'],
  [-933949255,-933730897,'Pisces'],
  [-933730897,-933513380,'Aries'],
  [-933513380,-933304252,'Taurus'],
  [-933304252,-933105488,'Gemini'],
  [-933105488,-932914776,'Cancer'],
  [-932914776,-932728754,'Leo'],
  [-932728754,-932545000,'Virgo'],
  [-932545000,-932362109,'Libra'],
  [-932362109,-932178367,'Scorpio'],
  [-932178367,-931990544,'Sagittarius'],
  [-931990544,-931794311,'Capricorn'],
  [-931794311,-931586683,'Aquarius'],
  [-931586683,-931369620,'Pisces'],
  [-931369620,-931151262,'Aries'],
  [-931151262,-930941087,'Taurus'],
  [-930941087,-930743370,'Gemini'],
  [-930743370,-930556078,'Cancer'],
  [-930556078,-930374152,'Leo'],
  [-930374152,-930192806,'Virgo'],
  [-930192806,-930009186,'Libra'],
  [-930009186,-929822128,'Scorpio'],
  [-929822128,-929630549,'Sagittarius'],
  [-929630549,-929432284,'Capricorn'],
  [-929432284,-929224915,'Aquarius'],
  [-929224915,-929008714,'Pisces'],
  [-929008714,-928789437,'Aries'],
  [-928789437,-928576567,'Taurus'],
  [-928576567,-928376877,'Gemini'],
  [-928376877,-928190401,'Cancer'],
  [-928190401,-928012181,'Leo'],
  [-928012181,-927835833,'Virgo'],
  [-927835833,-927656060,'Libra'],
  [-927656060,-927469867,'Scorpio'],
  [-927469867,-927276300,'Sagittarius'],
  [-927276300,-927075166,'Capricorn'],
  [-927075166,-926866208,'Aquarius'],
  [-926866208,-926649972,'Pisces'],
  [-926649972,-926430194,'Aries'],
  [-926430194,-926214429,'Taurus'],
  [-926214429,-926010396,'Gemini'],
  [-926010396,-925820932,'Cancer'],
  [-925820932,-925643004,'Leo'],
  [-925643004,-925470361,'Virgo'],
  [-925470361,-925296223,'Libra'],
  [-925296223,-925115040,'Scorpio'],
  [-925115040,-924923671,'Sagittarius'],
  [-924923671,-924721721,'Capricorn'],
  [-924721721,-924510887,'Aquarius'],
  [-924510887,-924293824,'Pisces'],
  [-924293824,-924074075,'Aries'],
  [-924074075,-923856895,'Taurus'],
  [-923856895,-923648555,'Gemini'],
  [-923648555,-923453462,'Cancer'],
  [-923453462,-923271513,'Leo'],
  [-923271513,-923098419,'Virgo'],
  [-923098419,-922927681,'Libra'],
  [-922927681,-922752373,'Scorpio'],
  [-922752373,-922566700,'Sagittarius'],
  [-922566700,-922367771,'Capricorn'],
  [-922367771,-922156941,'Aquarius'],
  [-922156941,-921939004,'Pisces'],
  [-921939004,-921719455,'Aries'],
  [-921719455,-921502844,'Taurus'],
  [-921502844,-921292922,'Gemini'],
  [-921292922,-921092963,'Cancer'],
  [-921092963,-920904624,'Leo'],
  [-920904624,-920726597,'Virgo'],
  [-920726597,-920554521,'Libra'],
  [-920554521,-920381959,'Scorpio'],
  [-920381959,-920201867,'Sagittarius'],
  [-920201867,-920008620,'Capricorn'],
  [-920008620,-919800862,'Aquarius'],
  [-919800862,-919583219,'Pisces'],
  [-919583219,-919363637,'Aries'],
  [-919363637,-919148385,'Taurus'],
  [-919148385,-918940065,'Gemini'],
  [-918940065,-918739296,'Cancer'],
  [-918739296,-918546572,'Leo'],
  [-918546572,-918362120,'Virgo'],
  [-918362120,-918184527,'Libra'],
  [-918184527,-918009709,'Scorpio'],
  [-918009709,-917831393,'Sagittarius'],
  [-917831393,-917642857,'Capricorn'],
  [-917642857,-917439901,'Aquarius'],
  [-917439901,-917224436,'Pisces'],
  [-917224436,-917004772,'Aries'],
  [-917004772,-916789946,'Taurus'],
  [-916789946,-916584028,'Gemini'],
  [-916584028,-916386230,'Cancer'],
  [-916386230,-916194320,'Leo'],
  [-916194320,-916006989,'Virgo'],
  [-916006989,-915823807,'Libra'],
  [-915823807,-915643419,'Scorpio'],
  [-915643419,-915462113,'Sagittarius'],
  [-915462113,-915274283,'Capricorn'],
  [-915274283,-915074720,'Aquarius'],
  [-915074720,-914862348,'Pisces'],
  [-914862348,-914643109,'Aries'],
  [-914643109,-914427179,'Taurus'],
  [-914427179,-914221609,'Gemini'],
  [-914221609,-914026856,'Cancer'],
  [-914026856,-913839277,'Leo'],
  [-913839277,-913654811,'Virgo'],
  [-913654811,-913470966,'Libra'],
  [-913470966,-913286614,'Scorpio'],
  [-913286614,-913100344,'Sagittarius'],
  [-913100344,-912909256,'Capricorn'],
  [-912909256,-912709554,'Aquarius'],
  [-912709554,-912499086,'Pisces'],
  [-912499086,-912280749,'Aries'],
  [-912280749,-912063044,'Taurus'],
  [-912063044,-911854959,'Gemini'],
  [-911854959,-911659966,'Cancer'],
  [-911659966,-911475533,'Leo'],
  [-911475533,-911296361,'Virgo'],
  [-911296361,-911117258,'Libra'],
  [-911117258,-910934591,'Scorpio'],
  [-910934591,-910746388,'Sagittarius'],
  [-910746388,-910551512,'Capricorn'],
  [-910551512,-910348917,'Aquarius'],
  [-910348917,-910137948,'Pisces'],
  [-910137948,-909920204,'Aries'],
  [-909920204,-909701286,'Taurus'],
  [-909701286,-909489383,'Gemini'],
  [-909489383,-909290468,'Cancer'],
  [-909290468,-909104922,'Leo'],
  [-909104922,-908928515,'Virgo'],
  [-908928515,-908755038,'Libra'],
  [-908755038,-908578342,'Scorpio'],
  [-908578342,-908393700,'Sagittarius'],
  [-908393700,-908198766,'Capricorn'],
  [-908198766,-907993806,'Aquarius'],
  [-907993806,-907780851,'Pisces'],
  [-907780851,-907562782,'Aries'],
  [-907562782,-907343620,'Taurus'],
  [-907343620,-907128990,'Gemini'],
  [-907128990,-906924861,'Cancer'],
  [-906924861,-906734331,'Leo'],
  [-906734331,-906555931,'Virgo'],
  [-906555931,-906384518,'Libra'],
  [-906384518,-906213160,'Scorpio'],
  [-906213160,-906034896,'Sagittarius'],
  [-906034896,-905844549,'Capricorn'],
  [-905844549,-905640779,'Aquarius'],
  [-905640779,-905426743,'Pisces'],
  [-905426743,-905207842,'Aries'],
  [-905207842,-904988946,'Taurus'],
  [-904988946,-904773850,'Gemini'],
  [-904773850,-904566374,'Cancer'],
  [-904566374,-904370066,'Leo'],
  [-904370066,-904186116,'Virgo'],
  [-904186116,-904011987,'Libra'],
  [-904011987,-903841837,'Scorpio'],
  [-903841837,-903668194,'Sagittarius'],
  [-903668194,-903483908,'Capricorn'],
  [-903483908,-903284790,'Aquarius'],
  [-903284790,-903072350,'Pisces'],
  [-903072350,-902853231,'Aries'],
  [-902853231,-902634604,'Taurus'],
  [-902634604,-902420619,'Gemini'],
  [-902420619,-902213089,'Cancer'],
  [-902213089,-902013706,'Leo'],
  [-902013706,-901824169,'Virgo'],
  [-901824169,-901644392,'Libra'],
  [-901644392,-901470995,'Scorpio'],
  [-901470995,-901297711,'Sagittarius'],
  [-901297711,-901117134,'Capricorn'],
  [-901117134,-900923204,'Aquarius'],
  [-900923204,-900714587,'Pisces'],
  [-900714587,-900496638,'Aries'],
  [-900496638,-900278147,'Taurus'],
  [-900278147,-900065342,'Gemini'],
  [-900065342,-899859915,'Cancer'],
  [-899859915,-899661435,'Leo'],
  [-899661435,-899469787,'Virgo'],
  [-899469787,-899285184,'Libra'],
  [-899285184,-899106404,'Scorpio'],
  [-899106404,-898929561,'Sagittarius'],
  [-898929561,-898748652,'Capricorn'],
  [-898748652,-898557488,'Aquarius'],
  [-898557488,-898352730,'Pisces'],
  [-898352730,-898137027,'Aries'],
  [-898137027,-897918631,'Taurus'],
  [-897918631,-897705897,'Gemini'],
  [-897705897,-897502332,'Cancer'],
  [-897502332,-897307002,'Leo'],
  [-897307002,-897117567,'Virgo'],
  [-897117567,-896932272,'Libra'],
  [-896932272,-896749834,'Scorpio'],
  [-896749834,-896568177,'Sagittarius'],
  [-896568177,-896383680,'Capricorn'],
  [-896383680,-896191756,'Aquarius'],
  [-896191756,-895988834,'Pisces'],
  [-895988834,-895775283,'Aries'],
  [-895775283,-895557041,'Taurus'],
  [-895557041,-895342950,'Gemini'],
  [-895342950,-895139082,'Cancer'],
  [-895139082,-894946038,'Leo'],
  [-894946038,-894760731,'Virgo'],
  [-894760731,-894579089,'Libra'],
  [-894579089,-894397627,'Scorpio'],
  [-894397627,-894213745,'Sagittarius'],
  [-894213745,-894025282,'Capricorn'],
  [-894025282,-893830096,'Aquarius'],
  [-893830096,-893626303,'Pisces'],
  [-893626303,-893413686,'Aries'],
  [-893413686,-893195666,'Taurus'],
  [-893195666,-892979453,'Gemini'],
  [-892979453,-892772650,'Cancer'],
  [-892772650,-892578677,'Leo'],
  [-892578677,-892395765,'Virgo'],
  [-892395765,-892218990,'Libra'],
  [-892218990,-892042534,'Scorpio'],
  [-892042534,-891861339,'Sagittarius'],
  [-891861339,-891672198,'Capricorn'],
  [-891672198,-891474130,'Aquarius'],
  [-891474130,-891267778,'Pisces'],
  [-891267778,-891054497,'Aries'],
  [-891054497,-890836648,'Taurus'],
  [-890836648,-890618839,'Gemini'],
  [-890618839,-890407859,'Cancer'],
  [-890407859,-890209445,'Leo'],
  [-890209445,-890024752,'Virgo'],
  [-890024752,-889850066,'Libra'],
  [-889850066,-889678776,'Scorpio'],
  [-889678776,-889503615,'Sagittarius'],
  [-889503615,-889318660,'Capricorn'],
  [-889318660,-889121358,'Aquarius'],
  [-889121358,-888913316,'Pisces'],
  [-888913316,-888698464,'Aries'],
  [-888698464,-888480476,'Taurus'],
  [-888480476,-888262464,'Gemini'],
  [-888262464,-888048674,'Cancer'],
  [-888048674,-887844669,'Leo'],
  [-887844669,-887654299,'Virgo'],
  [-887654299,-887476798,'Libra'],
  [-887476798,-887306797,'Scorpio'],
  [-887306797,-887136512,'Sagittarius'],
  [-887136512,-886958045,'Capricorn'],
  [-886958045,-886765878,'Aquarius'],
  [-886765878,-886559620,'Pisces'],
  [-886559620,-886344100,'Aries'],
  [-886344100,-886125611,'Taurus'],
  [-886125611,-885908314,'Gemini'],
  [-885908314,-885694632,'Cancer'],
  [-885694632,-885487659,'Leo'],
  [-885487659,-885291249,'Virgo'],
  [-885291249,-885107308,'Libra'],
  [-885107308,-884933400,'Scorpio'],
  [-884933400,-884763223,'Sagittarius'],
  [-884763223,-884588801,'Capricorn'],
  [-884588801,-884402841,'Aquarius'],
  [-884402841,-884201764,'Pisces'],
  [-884201764,-883988219,'Aries'],
  [-883988219,-883769576,'Taurus'],
  [-883769576,-883552712,'Gemini'],
  [-883552712,-883340850,'Cancer'],
  [-883340850,-883135066,'Leo'],
  [-883135066,-882936690,'Virgo'],
  [-882936690,-882747352,'Libra'],
  [-882747352,-882566918,'Scorpio'],
  [-882566918,-882391985,'Sagittarius'],
  [-882391985,-882216465,'Capricorn'],
  [-882216465,-882033414,'Aquarius'],
  [-882033414,-881837513,'Pisces'],
  [-881837513,-881628097,'Aries'],
  [-881628097,-881410579,'Taurus'],
  [-881410579,-881193409,'Gemini'],
  [-881193409,-880982589,'Cancer'],
  [-880982589,-880779754,'Leo'],
  [-880779754,-880584123,'Virgo'],
  [-880584123,-880394652,'Libra'],
  [-880394652,-880210412,'Scorpio'],
  [-880210412,-880029676,'Sagittarius'],
  [-880029676,-879849147,'Capricorn'],
  [-879849147,-879664167,'Aquarius'],
  [-879664167,-879470013,'Pisces'],
  [-879470013,-879264159,'Aries'],
  [-879264159,-879048779,'Taurus'],
  [-879048779,-878831074,'Gemini'],
  [-878831074,-878619254,'Cancer'],
  [-878619254,-878417651,'Leo'],
  [-878417651,-878225817,'Virgo'],
  [-878225817,-878040597,'Libra'],
  [-878040597,-877858316,'Scorpio'],
  [-877858316,-877675894,'Sagittarius'],
  [-877675894,-877490978,'Capricorn'],
  [-877490978,-877301479,'Aquarius'],
  [-877301479,-877105159,'Pisces'],
  [-877105159,-876900080,'Aries'],
  [-876900080,-876686396,'Taurus'],
  [-876686396,-876468432,'Gemini'],
  [-876468432,-876254154,'Cancer'],
  [-876254154,-876050610,'Leo'],
  [-876050610,-875859812,'Virgo'],
  [-875859812,-875678733,'Libra'],
  [-875678733,-875501748,'Scorpio'],
  [-875501748,-875323104,'Sagittarius'],
  [-875323104,-875138611,'Capricorn'],
  [-875138611,-874946449,'Aquarius'],
  [-874946449,-874746663,'Pisces'],
  [-874746663,-874539738,'Aries'],
  [-874539738,-874326199,'Taurus'],
  [-874326199,-874108222,'Gemini'],
  [-874108222,-873891515,'Cancer'],
  [-873891515,-873683861,'Leo'],
  [-873683861,-873490203,'Virgo'],
  [-873490203,-873309652,'Libra'],
  [-873309652,-873136623,'Scorpio'],
  [-873136623,-872963734,'Sagittarius'],
  [-872963734,-872784267,'Capricorn'],
  [-872784267,-872594190,'Aquarius'],
  [-872594190,-872393326,'Pisces'],
  [-872393326,-872184192,'Aries'],
  [-872184192,-871969507,'Taurus'],
  [-871969507,-871751455,'Gemini'],
  [-871751455,-871533536,'Cancer'],
  [-871533536,-871321965,'Leo'],
  [-871321965,-871123083,'Virgo'],
  [-871123083,-870938894,'Libra'],
  [-870938894,-870765675,'Scorpio'],
  [-870765675,-870596187,'Sagittarius'],
  [-870596187,-870422443,'Capricorn'],
  [-870422443,-870237980,'Aquarius'],
  [-870237980,-870040162,'Pisces'],
  [-870040162,-869831062,'Aries'],
  [-869831062,-869615315,'Taurus'],
  [-869615315,-869397017,'Gemini'],
  [-869397017,-869179247,'Cancer'],
  [-869179247,-868965996,'Leo'],
  [-868965996,-868762548,'Virgo'],
  [-868762548,-868572572,'Libra'],
  [-868572572,-868395084,'Scorpio'],
  [-868395084,-868224617,'Sagittarius'],
  [-868224617,-868053569,'Capricorn'],
  [-868053569,-867874453,'Aquarius'],
  [-867874453,-867682176,'Pisces'],
  [-867682176,-867476260,'Aries'],
  [-867476260,-867261002,'Taurus'],
  [-867261002,-867042534,'Gemini'],
  [-867042534,-866825527,'Cancer'],
  [-866825527,-866613109,'Leo'],
  [-866613109,-866408288,'Virgo'],
  [-866408288,-866213872,'Libra'],
  [-866213872,-866030510,'Scorpio'],
  [-866030510,-865855320,'Sagittarius'],
  [-865855320,-865682593,'Capricorn'],
  [-865682593,-865505479,'Aquarius'],
  [-865505479,-865317889,'Pisces'],
  [-865317889,-865116759,'Aries'],
  [-865116759,-864903955,'Taurus'],
  [-864903955,-864685794,'Gemini'],
  [-864685794,-864469249,'Cancer'],
  [-864469249,-864258670,'Leo'],
  [-864258670,-864055760,'Virgo'],
  [-864055760,-863860934,'Libra'],
  [-863860934,-863673921,'Scorpio'],
  [-863673921,-863493212,'Sagittarius'],
  [-863493212,-863315578,'Capricorn'],
  [-863315578,-863136299,'Aquarius'],
  [-863136299,-862950073,'Pisces'],
  [-862950073,-862752661,'Aries'],
  [-862752661,-862543195,'Taurus'],
  [-862543195,-862325995,'Gemini'],
  [-862325995,-862109093,'Cancer'],
  [-862109093,-861899360,'Leo'],
  [-861899360,-861699308,'Virgo'],
  [-861699308,-861507689,'Libra'],
  [-861507689,-861321730,'Scorpio'],
  [-861321730,-861138719,'Sagittarius'],
  [-861138719,-860956378,'Capricorn'],
  [-860956378,-860772388,'Aquarius'],
  [-860772388,-860583788,'Pisces'],
  [-860583788,-860387139,'Aries'],
  [-860387139,-860180109,'Taurus'],
  [-860180109,-859964220,'Gemini'],
  [-859964220,-859746294,'Cancer'],
  [-859746294,-859535202,'Leo'],
  [-859535202,-859336048,'Virgo'],
  [-859336048,-859148030,'Libra'],
  [-859148030,-858966578,'Scorpio'],
  [-858966578,-858786397,'Sagittarius'],
  [-858786397,-858603537,'Capricorn'],
  [-858603537,-858416101,'Aquarius'],
  [-858416101,-858223413,'Pisces'],
  [-858223413,-858024486,'Aries'],
  [-858024486,-857817704,'Taurus'],
  [-857817704,-857602802,'Gemini'],
  [-857602802,-857383912,'Cancer'],
  [-857383912,-857169673,'Leo'],
  [-857169673,-856967926,'Virgo'],
  [-856967926,-856780388,'Libra'],
  [-856780388,-856602775,'Scorpio'],
  [-856602775,-856428142,'Sagittarius'],
  [-856428142,-856249907,'Capricorn'],
  [-856249907,-856063936,'Aquarius'],
  [-856063936,-855869385,'Pisces'],
  [-855869385,-855667351,'Aries'],
  [-855667351,-855458724,'Taurus'],
  [-855458724,-855243811,'Gemini'],
  [-855243811,-855024643,'Cancer'],
  [-855024643,-854807449,'Leo'],
  [-854807449,-854600691,'Virgo'],
  [-854600691,-854409214,'Libra'],
  [-854409214,-854231161,'Scorpio'],
  [-854231161,-854059985,'Sagittarius'],
  [-854059985,-853887805,'Capricorn'],
  [-853887805,-853707865,'Aquarius'],
  [-853707865,-853516553,'Pisces'],
  [-853516553,-853314221,'Aries'],
  [-853314221,-853103637,'Taurus'],
  [-853103637,-852887660,'Gemini'],
  [-852887660,-852668684,'Cancer'],
  [-852668684,-852450592,'Leo'],
  [-852450592,-852239727,'Virgo'],
  [-852239727,-852042014,'Libra'],
  [-852042014,-851858778,'Scorpio'],
  [-851858778,-851685917,'Sagittarius'],
  [-851685917,-851516290,'Capricorn'],
  [-851516290,-851342239,'Aquarius'],
  [-851342239,-851157570,'Pisces'],
  [-851157570,-850959513,'Aries'],
  [-850959513,-850749684,'Taurus'],
  [-850749684,-850532790,'Gemini'],
  [-850532790,-850313790,'Cancer'],
  [-850313790,-850096643,'Leo'],
  [-850096643,-849885180,'Virgo'],
  [-849885180,-849683359,'Libra'],
  [-849683359,-849493562,'Scorpio'],
  [-849493562,-849314685,'Sagittarius'],
  [-849314685,-849142182,'Capricorn'],
  [-849142182,-848969548,'Aquarius'],
  [-848969548,-848789983,'Pisces'],
  [-848789983,-848598177,'Aries'],
  [-848598177,-848392508,'Taurus'],
  [-848392508,-848176535,'Gemini'],
  [-848176535,-847957301,'Cancer'],
  [-847957301,-847741204,'Leo'],
  [-847741204,-847531819,'Virgo'],
  [-847531819,-847330497,'Libra'],
  [-847330497,-847137659,'Scorpio'],
  [-847137659,-846952868,'Sagittarius'],
  [-846952868,-846774217,'Capricorn'],
  [-846774217,-846597944,'Aquarius'],
  [-846597944,-846418726,'Pisces'],
  [-846418726,-846230805,'Aries'],
  [-846230805,-846030064,'Taurus'],
  [-846030064,-845816969,'Gemini'],
  [-845816969,-845597943,'Cancer'],
  [-845597943,-845381825,'Leo'],
  [-845381825,-845174339,'Virgo'],
  [-845174339,-844976243,'Libra'],
  [-844976243,-844785398,'Scorpio'],
  [-844785398,-844599313,'Sagittarius'],
  [-844599313,-844416173,'Capricorn'],
  [-844416173,-844234378,'Aquarius'],
  [-844234378,-844051341,'Pisces'],
  [-844051341,-843862957,'Aries'],
  [-843862957,-843664724,'Taurus'],
  [-843664724,-843454624,'Gemini'],
  [-843454624,-843236432,'Cancer'],
  [-843236432,-843019263,'Leo'],
  [-843019263,-842811546,'Virgo'],
  [-842811546,-842615781,'Libra'],
  [-842615781,-842429034,'Scorpio'],
  [-842429034,-842246426,'Sagittarius'],
  [-842246426,-842063935,'Capricorn'],
  [-842063935,-841879458,'Aquarius'],
  [-841879458,-841692048,'Pisces'],
  [-841692048,-841500186,'Aries'],
  [-841500186,-841301065,'Taurus'],
  [-841301065,-841092204,'Gemini'],
  [-841092204,-840874886,'Cancer'],
  [-840874886,-840656316,'Leo'],
  [-840656316,-840446150,'Virgo'],
  [-840446150,-840249648,'Libra'],
  [-840249648,-840065224,'Scorpio'],
  [-840065224,-839887216,'Sagittarius'],
  [-839887216,-839709418,'Capricorn'],
  [-839709418,-839527344,'Aquarius'],
  [-839527344,-839339028,'Pisces'],
  [-839339028,-839144123,'Aries'],
  [-839144123,-838942232,'Taurus'],
  [-838942232,-838732485,'Gemini'],
  [-838732485,-838515424,'Cancer'],
  [-838515424,-838295818,'Leo'],
  [-838295818,-838082292,'Virgo'],
  [-838082292,-837882077,'Libra'],
  [-837882077,-837696233,'Scorpio'],
  [-837696233,-837520218,'Sagittarius'],
  [-837520218,-837347188,'Capricorn'],
  [-837347188,-837170639,'Aquarius'],
  [-837170639,-836986061,'Pisces'],
  [-836986061,-836791693,'Aries'],
  [-836791693,-836587994,'Taurus'],
  [-836587994,-836376414,'Gemini'],
  [-836376414,-836158849,'Cancer'],
  [-836158849,-835938918,'Leo'],
  [-835938918,-835722956,'Virgo'],
  [-835722956,-835517965,'Libra'],
  [-835517965,-835327390,'Scorpio'],
  [-835327390,-835149204,'Sagittarius'],
  [-835149204,-834977660,'Capricorn'],
  [-834977660,-834805776,'Aquarius'],
  [-834805776,-834627116,'Pisces'],
  [-834627116,-834437254,'Aries'],
  [-834437254,-834234993,'Taurus'],
  [-834234993,-834022581,'Gemini'],
  [-834022581,-833804233,'Cancer'],
  [-833804233,-833584500,'Leo'],
  [-833584500,-833368134,'Virgo'],
  [-833368134,-833160020,'Libra'],
  [-833160020,-832963898,'Scorpio'],
  [-832963898,-832780246,'Sagittarius'],
  [-832780246,-832605812,'Capricorn'],
  [-832605812,-832434818,'Aquarius'],
  [-832434818,-832260472,'Pisces'],
  [-832260472,-832076438,'Aries'],
  [-832076438,-831878757,'Taurus'],
  [-831878757,-831667997,'Gemini'],
  [-831667997,-831449457,'Cancer'],
  [-831449457,-831230002,'Leo'],
  [-831230002,-831014813,'Virgo'],
  [-831014813,-830806794,'Libra'],
  [-830806794,-830607690,'Scorpio'],
  [-830607690,-830418400,'Sagittarius'],
  [-830418400,-830238112,'Capricorn'],
  [-830238112,-830063618,'Aquarius'],
  [-830063618,-829889497,'Pisces'],
  [-829889497,-829709153,'Aries'],
  [-829709153,-829516681,'Taurus'],
  [-829516681,-829309784,'Gemini'],
  [-829309784,-829092381,'Cancer'],
  [-829092381,-828872986,'Leo'],
  [-828872986,-828659028,'Virgo'],
  [-828659028,-828453349,'Libra'],
  [-828453349,-828255431,'Scorpio'],
  [-828255431,-828064143,'Sagittarius'],
  [-828064143,-827878840,'Capricorn'],
  [-827878840,-827698544,'Aquarius'],
  [-827698544,-827520486,'Pisces'],
  [-827520486,-827339659,'Aries'],
  [-827339659,-827150007,'Taurus'],
  [-827150007,-826947139,'Gemini'],
  [-826947139,-826732079,'Cancer'],
  [-826732079,-826512635,'Leo'],
  [-826512635,-826298535,'Virgo'],
  [-826298535,-826094748,'Libra'],
  [-826094748,-825900343,'Scorpio'],
  [-825900343,-825711813,'Sagittarius'],
  [-825711813,-825526232,'Capricorn'],
  [-825526232,-825342258,'Aquarius'],
  [-825342258,-825158976,'Pisces'],
  [-825158976,-824974062,'Aries'],
  [-824974062,-824783316,'Taurus'],
  [-824783316,-824582261,'Gemini'],
  [-824582261,-824369566,'Cancer'],
  [-824369566,-824150322,'Leo'],
  [-824150322,-823934481,'Virgo'],
  [-823934481,-823729862,'Libra'],
  [-823729862,-823537515,'Scorpio'],
  [-823537515,-823353434,'Sagittarius'],
  [-823353434,-823172345,'Capricorn'],
  [-823172345,-822990265,'Aquarius'],
  [-822990265,-822805222,'Pisces'],
  [-822805222,-822616203,'Aries'],
  [-822616203,-822421658,'Taurus'],
  [-822421658,-822219226,'Gemini'],
  [-822219226,-822007411,'Cancer'],
  [-822007411,-821788674,'Leo'],
  [-821788674,-821570693,'Virgo'],
  [-821570693,-821362453,'Libra'],
  [-821362453,-821168177,'Scorpio'],
  [-821168177,-820985759,'Sagittarius'],
  [-820985759,-820809556,'Capricorn'],
  [-820809556,-820633390,'Aquarius'],
  [-820633390,-820452369,'Pisces'],
  [-820452369,-820263714,'Aries'],
  [-820263714,-820066557,'Taurus'],
  [-820066557,-819861123,'Gemini'],
  [-819861123,-819648158,'Cancer'],
  [-819648158,-819429711,'Leo'],
  [-819429711,-819210673,'Virgo'],
  [-819210673,-818998348,'Libra'],
  [-818998348,-818798806,'Scorpio'],
  [-818798806,-818613205,'Sagittarius'],
  [-818613205,-818437826,'Capricorn'],
  [-818437826,-818266345,'Aquarius'],
  [-818266345,-818091927,'Pisces'],
  [-818091927,-817908804,'Aries'],
  [-817908804,-817713777,'Taurus'],
  [-817713777,-817507222,'Gemini'],
  [-817507222,-817292414,'Cancer'],
  [-817292414,-817073542,'Leo'],
  [-817073542,-816854749,'Virgo'],
  [-816854749,-816640566,'Libra'],
  [-816640566,-816435911,'Scorpio'],
  [-816435911,-816244020,'Sagittarius'],
  [-816244020,-816064386,'Capricorn'],
  [-816064386,-815892675,'Aquarius'],
  [-815892675,-815722155,'Pisces'],
  [-815722155,-815545452,'Aries'],
  [-815545452,-815356465,'Taurus'],
  [-815356465,-815152923,'Gemini'],
  [-815152923,-814938042,'Cancer'],
  [-814938042,-814718507,'Leo'],
  [-814718507,-814500302,'Virgo'],
  [-814500302,-814286886,'Libra'],
  [-814286886,-814080545,'Scorpio'],
  [-814080545,-813883613,'Sagittarius'],
  [-813883613,-813697486,'Capricorn'],
  [-813697486,-813520870,'Aquarius'],
  [-813520870,-813349090,'Pisces'],
  [-813349090,-813175161,'Aries'],
  [-813175161,-812991710,'Taurus'],
  [-812991710,-812793657,'Gemini'],
  [-812793657,-812581562,'Cancer'],
  [-812581562,-812362279,'Leo'],
  [-812362279,-812144292,'Virgo'],
  [-812144292,-811932501,'Libra'],
  [-811932501,-811727867,'Scorpio'],
  [-811727867,-811530247,'Sagittarius'],
  [-811530247,-811340059,'Capricorn'],
  [-811340059,-811157508,'Aquarius'],
  [-811157508,-810980670,'Pisces'],
  [-810980670,-810804690,'Aries'],
  [-810804690,-810622886,'Taurus'],
  [-810622886,-810429083,'Gemini'],
  [-810429083,-810221052,'Cancer'],
  [-810221052,-810003348,'Leo'],
  [-810003348,-809785234,'Virgo'],
  [-809785234,-809574127,'Libra'],
  [-809574127,-809371997,'Scorpio'],
  [-809371997,-809177222,'Sagittarius'],
  [-809177222,-808987801,'Capricorn'],
  [-808987801,-808802703,'Aquarius'],
  [-808802703,-808621006,'Pisces'],
  [-808621006,-808440268,'Aries'],
  [-808440268,-808256022,'Taurus'],
  [-808256022,-808062981,'Gemini'],
  [-808062981,-807857742,'Cancer'],
  [-807857742,-807642099,'Leo'],
  [-807642099,-807423758,'Virgo'],
  [-807423758,-807211704,'Libra'],
  [-807211704,-807010358,'Scorpio'],
  [-807010358,-806818732,'Sagittarius'],
  [-806818732,-806633275,'Capricorn'],
  [-806633275,-806450506,'Aquarius'],
  [-806450506,-806267963,'Pisces'],
  [-806267963,-806083697,'Aries'],
  [-806083697,-805895349,'Taurus'],
  [-805895349,-805699922,'Gemini'],
  [-805699922,-805494880,'Cancer'],
  [-805494880,-805280541,'Leo'],
  [-805280541,-805062029,'Virgo'],
  [-805062029,-804847786,'Libra'],
  [-804847786,-804644509,'Scorpio'],
  [-804644509,-804453498,'Sagittarius'],
  [-804453498,-804271570,'Capricorn'],
  [-804271570,-804093683,'Aquarius'],
  [-804093683,-803914901,'Pisces'],
  [-803914901,-803731430,'Aries'],
  [-803731430,-803540930,'Taurus'],
  [-803540930,-803342315,'Gemini'],
  [-803342315,-803135356,'Cancer'],
  [-803135356,-802920940,'Leo'],
  [-802920940,-802702345,'Virgo'],
  [-802702345,-802485826,'Libra'],
  [-802485826,-802278595,'Scorpio'],
  [-802278595,-802084669,'Sagittarius'],
  [-802084669,-801902981,'Capricorn'],
  [-801902981,-801728705,'Aquarius'],
  [-801728705,-801555404,'Pisces'],
  [-801555404,-801376836,'Aries'],
  [-801376836,-801188514,'Taurus'],
  [-801188514,-800989001,'Gemini'],
  [-800989001,-800779923,'Cancer'],
  [-800779923,-800564368,'Leo'],
  [-800564368,-800345698,'Virgo'],
  [-800345698,-800128024,'Libra'],
  [-800128024,-799916903,'Scorpio'],
  [-799916903,-799717661,'Sagittarius'],
  [-799717661,-799532144,'Capricorn'],
  [-799532144,-799357527,'Aquarius'],
  [-799357527,-799187568,'Pisces'],
  [-799187568,-799014696,'Aries'],
  [-799014696,-798831999,'Taurus'],
  [-798831999,-798635598,'Gemini'],
  [-798635598,-798426587,'Cancer'],
  [-798426587,-798209982,'Leo'],
  [-798209982,-797991136,'Virgo'],
  [-797991136,-797773744,'Libra'],
  [-797773744,-797561023,'Scorpio'],
  [-797561023,-797357073,'Sagittarius'],
  [-797357073,-797165398,'Capricorn'],
  [-797165398,-796986128,'Aquarius'],
  [-796986128,-796815013,'Pisces'],
  [-796815013,-796644852,'Aries'],
  [-796644852,-796467649,'Taurus'],
  [-796467649,-796277036,'Gemini'],
  [-796277036,-796071412,'Cancer'],
  [-796071412,-795855338,'Leo'],
  [-795855338,-795636306,'Virgo'],
  [-795636306,-795419807,'Libra'],
  [-795419807,-795208197,'Scorpio'],
  [-795208197,-795003097,'Sagittarius'],
  [-795003097,-794806864,'Capricorn'],
  [-794806864,-794621212,'Aquarius'],
  [-794621212,-794444774,'Pisces'],
  [-794444774,-794272490,'Aries'],
  [-794272490,-794097102,'Taurus'],
  [-794097102,-793911351,'Gemini'],
  [-793911351,-793710953,'Cancer'],
  [-793710953,-793497666,'Leo'],
  [-793497666,-793278935,'Virgo'],
  [-793278935,-793062757,'Libra'],
  [-793062757,-792853101,'Scorpio'],
  [-792853101,-792650405,'Sagittarius'],
  [-792650405,-792454378,'Capricorn'],
  [-792454378,-792265308,'Aquarius'],
  [-792265308,-792082992,'Pisces'],
  [-792082992,-791905066,'Aries'],
  [-791905066,-791726705,'Taurus'],
  [-791726705,-791541811,'Gemini'],
  [-791541811,-791345228,'Cancer'],
  [-791345228,-791135778,'Leo'],
  [-791135778,-790918295,'Virgo'],
  [-790918295,-790701483,'Libra'],
  [-790701483,-790492196,'Scorpio'],
  [-790492196,-790292301,'Sagittarius'],
  [-790292301,-790100158,'Capricorn'],
  [-790100158,-789913247,'Aquarius'],
  [-789913247,-789729473,'Pisces'],
  [-789729473,-789546956,'Aries'],
  [-789546956,-789363248,'Taurus'],
  [-789363248,-789174978,'Gemini'],
  [-789174978,-788978458,'Cancer'],
  [-788978458,-788771476,'Leo'],
  [-788771476,-788555772,'Virgo'],
  [-788555772,-788338022,'Libra'],
  [-788338022,-788126687,'Scorpio'],
  [-788126687,-787926734,'Sagittarius'],
  [-787926734,-787737789,'Capricorn'],
  [-787737789,-787555967,'Aquarius'],
  [-787555967,-787376357,'Pisces'],
  [-787376357,-787194734,'Aries'],
  [-787194734,-787008326,'Taurus'],
  [-787008326,-786815706,'Gemini'],
  [-786815706,-786616048,'Cancer'],
  [-786616048,-786408678,'Leo'],
  [-786408678,-786194068,'Virgo'],
  [-786194068,-785975867,'Libra'],
  [-785975867,-785761354,'Scorpio'],
  [-785761354,-785557844,'Sagittarius'],
  [-785557844,-785368066,'Capricorn'],
  [-785368066,-785189244,'Aquarius'],
  [-785189244,-785015261,'Pisces'],
  [-785015261,-784839306,'Aries'],
  [-784839306,-784655940,'Taurus'],
  [-784655940,-784462655,'Gemini'],
  [-784462655,-784260105,'Cancer'],
  [-784260105,-784050397,'Leo'],
  [-784050397,-783835393,'Virgo'],
  [-783835393,-783617256,'Libra'],
  [-783617256,-783400526,'Scorpio'],
  [-783400526,-783192161,'Sagittarius'],
  [-783192161,-782997598,'Capricorn'],
  [-782997598,-782817000,'Aquarius'],
  [-782817000,-782645271,'Pisces'],
  [-782645271,-782474739,'Aries'],
  [-782474739,-782297740,'Taurus'],
  [-782297740,-782108918,'Gemini'],
  [-782108918,-781907312,'Cancer'],
  [-781907312,-781696156,'Leo'],
  [-781696156,-781479902,'Virgo'],
  [-781479902,-781261809,'Libra'],
  [-781261809,-781044747,'Scorpio'],
  [-781044747,-780833317,'Sagittarius'],
  [-780833317,-780633103,'Capricorn'],
  [-780633103,-780446971,'Aquarius'],
  [-780446971,-780272533,'Pisces'],
  [-780272533,-780103219,'Aries'],
  [-780103219,-779930931,'Taurus'],
  [-779930931,-779748385,'Gemini'],
  [-779748385,-779551675,'Cancer'],
  [-779551675,-779342221,'Leo'],
  [-779342221,-779125527,'Virgo'],
  [-779125527,-778907276,'Libra'],
  [-778907276,-778691048,'Scorpio'],
  [-778691048,-778479611,'Sagittarius'],
  [-778479611,-778276458,'Capricorn'],
  [-778276458,-778084728,'Aquarius'],
  [-778084728,-777904503,'Pisces'],
  [-777904503,-777731746,'Aries'],
  [-777731746,-777559687,'Taurus'],
  [-777559687,-777380945,'Gemini'],
  [-777380945,-777189780,'Cancer'],
  [-777189780,-776984649,'Leo'],
  [-776984649,-776769432,'Virgo'],
  [-776769432,-776551174,'Libra'],
  [-776551174,-776335736,'Scorpio'],
  [-776335736,-776126150,'Sagittarius'],
  [-776126150,-775923896,'Capricorn'],
  [-775923896,-775730089,'Aquarius'],
  [-775730089,-775544963,'Pisces'],
  [-775544963,-775366609,'Aries'],
  [-775366609,-775190719,'Taurus'],
  [-775190719,-775011490,'Gemini'],
  [-775011490,-774823203,'Cancer'],
  [-774823203,-774622375,'Leo'],
  [-774622375,-774410033,'Virgo'],
  [-774410033,-774192239,'Libra'],
  [-774192239,-773976773,'Scorpio'],
  [-773976773,-773768738,'Sagittarius'],
  [-773768738,-773569416,'Capricorn'],
  [-773569416,-773377727,'Aquarius'],
  [-773377727,-773191851,'Pisces'],
  [-773191851,-773009732,'Aries'],
  [-773009732,-772828822,'Taurus'],
  [-772828822,-772645775,'Gemini'],
  [-772645775,-772456606,'Cancer'],
  [-772456606,-772257737,'Leo'],
  [-772257737,-772048049,'Virgo'],
  [-772048049,-771831084,'Libra'],
  [-771831084,-771614643,'Scorpio'],
  [-771614643,-771406275,'Sagittarius'],
  [-771406275,-771209023,'Capricorn'],
  [-771209023,-771021215,'Aquarius'],
  [-771021215,-770838769,'Pisces'],
  [-770838769,-770657476,'Aries'],
  [-770657476,-770474216,'Taurus'],
  [-770474216,-770287053,'Gemini'],
  [-770287053,-770094453,'Cancer'],
  [-770094453,-769894579,'Leo'],
  [-769894579,-769685942,'Virgo'],
  [-769685942,-769469735,'Libra'],
  [-769469735,-769251852,'Scorpio'],
  [-769251852,-769040961,'Sagittarius'],
  [-769040961,-768842863,'Capricorn'],
  [-768842863,-768657298,'Aquarius'],
  [-768657298,-768479404,'Pisces'],
  [-768479404,-768302787,'Aries'],
  [-768302787,-768121992,'Taurus'],
  [-768121992,-767934021,'Gemini'],
  [-767934021,-767738438,'Cancer'],
  [-767738438,-767535820,'Leo'],
  [-767535820,-767326304,'Virgo'],
  [-767326304,-767110340,'Libra'],
  [-767110340,-766891362,'Scorpio'],
  [-766891362,-766676923,'Sagittarius'],
  [-766676923,-766474832,'Capricorn'],
  [-766474832,-766287671,'Aquarius'],
  [-766287671,-766111760,'Pisces'],
  [-766111760,-765940002,'Aries'],
  [-765940002,-765764913,'Taurus'],
  [-765764913,-765580901,'Gemini'],
  [-765580901,-765385987,'Cancer'],
  [-765385987,-765181582,'Leo'],
  [-765181582,-764970212,'Virgo'],
  [-764970212,-764753781,'Libra'],
  [-764753781,-764534560,'Scorpio'],
  [-764534560,-764317639,'Sagittarius'],
  [-764317639,-764110410,'Capricorn'],
  [-764110410,-763917969,'Aquarius'],
  [-763917969,-763739456,'Pisces'],
  [-763739456,-763568978,'Aries'],
  [-763568978,-763398637,'Taurus'],
  [-763398637,-763220964,'Gemini'],
  [-763220964,-763031096,'Cancer'],
  [-763031096,-762828481,'Leo'],
  [-762828481,-762616339,'Virgo'],
  [-762616339,-762399049,'Libra'],
  [-762399049,-762180128,'Scorpio'],
  [-762180128,-761963090,'Sagittarius'],
  [-761963090,-761752875,'Capricorn'],
  [-761752875,-761554507,'Aquarius'],
  [-761554507,-761369747,'Pisces'],
  [-761369747,-761195532,'Aries'],
  [-761195532,-761025449,'Taurus'],
  [-761025449,-760851989,'Gemini'],
  [-760851989,-760668488,'Cancer'],
  [-760668488,-760471255,'Leo'],
  [-760471255,-760261299,'Virgo'],
  [-760261299,-760043824,'Libra'],
  [-760043824,-759825024,'Scorpio'],
  [-759825024,-759609395,'Sagittarius'],
  [-759609395,-759399951,'Capricorn'],
  [-759399951,-759199183,'Aquarius'],
  [-759199183,-759008699,'Pisces'],
  [-759008699,-758827821,'Aries'],
  [-758827821,-758653045,'Taurus'],
  [-758653045,-758478765,'Gemini'],
  [-758478765,-758298580,'Cancer'],
  [-758298580,-758106989,'Leo'],
  [-758106989,-757901715,'Virgo'],
  [-757901715,-757685836,'Libra'],
  [-757685836,-757466870,'Scorpio'],
  [-757466870,-757252139,'Sagittarius'],
  [-757252139,-757045336,'Capricorn'],
  [-757045336,-756846791,'Aquarius'],
  [-756846791,-756655465,'Pisces'],
  [-756655465,-756470095,'Aries'],
  [-756470095,-756289052,'Taurus'],
  [-756289052,-756109661,'Gemini'],
  [-756109661,-755927788,'Cancer'],
  [-755927788,-755738387,'Leo'],
  [-755738387,-755537325,'Virgo'],
  [-755537325,-755324411,'Libra'],
  [-755324411,-755105570,'Scorpio'],
  [-755105570,-754890128,'Sagittarius'],
  [-754890128,-754684588,'Capricorn'],
  [-754684588,-754489655,'Aquarius'],
  [-754489655,-754302119,'Pisces'],
  [-754302119,-754118007,'Aries'],
  [-754118007,-753934489,'Taurus'],
  [-753934489,-753750073,'Gemini'],
  [-753750073,-753563385,'Cancer'],
  [-753563385,-753371831,'Leo'],
  [-753371831,-753171847,'Virgo'],
  [-753171847,-752961324,'Libra'],
  [-752961324,-752743137,'Scorpio'],
  [-752743137,-752525910,'Sagittarius'],
  [-752525910,-752318727,'Capricorn'],
  [-752318727,-752124896,'Aquarius'],
  [-752124896,-751941394,'Pisces'],
  [-751941394,-751762306,'Aries'],
  [-751762306,-751582102,'Taurus'],
  [-751582102,-751397488,'Gemini'],
  [-751397488,-751207541,'Cancer'],
  [-751207541,-751012073,'Leo'],
  [-751012073,-750809988,'Virgo'],
  [-750809988,-750599740,'Libra'],
  [-750599740,-750382181,'Scorpio'],
  [-750382181,-750163344,'Sagittarius'],
  [-750163344,-749952559,'Capricorn'],
  [-749952559,-749756023,'Aquarius'],
  [-749756023,-749573018,'Pisces'],
  [-749573018,-749397819,'Aries'],
  [-749397819,-749223305,'Taurus'],
  [-749223305,-749043549,'Gemini'],
  [-749043549,-748855367,'Cancer'],
  [-748855367,-748658403,'Leo'],
  [-748658403,-748453609,'Virgo'],
  [-748453609,-748241812,'Libra'],
  [-748241812,-748024212,'Scorpio'],
  [-748024212,-747804707,'Sagittarius'],
  [-747804707,-747590621,'Capricorn'],
  [-747590621,-747389143,'Aquarius'],
  [-747389143,-747202462,'Pisces'],
  [-747202462,-747026941,'Aries'],
  [-747026941,-746855799,'Taurus'],
  [-746855799,-746681842,'Gemini'],
  [-746681842,-746499329,'Cancer'],
  [-746499329,-746305378,'Leo'],
  [-746305378,-746100397,'Virgo'],
  [-746100397,-745887092,'Libra'],
  [-745887092,-745668844,'Scorpio'],
  [-745668844,-745449491,'Sagittarius'],
  [-745449491,-745234128,'Capricorn'],
  [-745234128,-745028473,'Aquarius'],
  [-745028473,-744836110,'Pisces'],
  [-744836110,-744656179,'Aries'],
  [-744656179,-744483924,'Taurus'],
  [-744483924,-744312678,'Gemini'],
  [-744312678,-744135631,'Cancer'],
  [-744135631,-743947403,'Leo'],
  [-743947403,-743745788,'Virgo'],
  [-743745788,-743532928,'Libra'],
  [-743532928,-743314177,'Scorpio'],
  [-743314177,-743095240,'Sagittarius'],
  [-743095240,-742880658,'Capricorn'],
  [-742880658,-742673833,'Aquarius'],
  [-742673833,-742477231,'Pisces'],
  [-742477231,-742291445,'Aries'],
  [-742291445,-742114360,'Taurus'],
  [-742114360,-741941375,'Gemini'],
  [-741941375,-741766347,'Cancer'],
  [-741766347,-741582903,'Leo'],
  [-741582903,-741386356,'Virgo'],
  [-741386356,-741176316,'Libra'],
  [-741176316,-740957986,'Scorpio'],
  [-740957986,-740739276,'Sagittarius'],
  [-740739276,-740526196,'Capricorn'],
  [-740526196,-740321094,'Aquarius'],
  [-740321094,-740124072,'Pisces'],
  [-740124072,-739934688,'Aries'],
  [-739934688,-739752085,'Taurus'],
  [-739752085,-739574180,'Gemini'],
  [-739574180,-739396974,'Cancer'],
  [-739396974,-739214853,'Leo'],
  [-739214853,-739022122,'Virgo'],
  [-739022122,-738815847,'Libra'],
  [-738815847,-738599025,'Scorpio'],
  [-738599025,-738380194,'Sagittarius'],
  [-738380194,-738167779,'Capricorn'],
  [-738167779,-737965148,'Aquarius'],
  [-737965148,-737770980,'Pisces'],
  [-737770980,-737582446,'Aries'],
  [-737582446,-737397455,'Taurus'],
  [-737397455,-737214827,'Gemini'],
  [-737214827,-737032928,'Cancer'],
  [-737032928,-736848370,'Leo'],
  [-736848370,-736656303,'Virgo'],
  [-736656303,-736452645,'Libra'],
  [-736452645,-736237744,'Scorpio'],
  [-736237744,-736018581,'Sagittarius'],
  [-736018581,-735805122,'Capricorn'],
  [-735805122,-735603246,'Aquarius'],
  [-735603246,-735412268,'Pisces'],
  [-735412268,-735227793,'Aries'],
  [-735227793,-735045267,'Taurus'],
  [-735045267,-734861883,'Gemini'],
  [-734861883,-734676444,'Cancer'],
  [-734676444,-734487724,'Leo'],
  [-734487724,-734293201,'Virgo'],
  [-734293201,-734089682,'Libra'],
  [-734089682,-733876060,'Scorpio'],
  [-733876060,-733656657,'Sagittarius'],
  [-733656657,-733440776,'Capricorn'],
  [-733440776,-733236656,'Aquarius'],
  [-733236656,-733046101,'Pisces'],
  [-733046101,-732865176,'Aries'],
  [-732865176,-732687814,'Taurus'],
  [-732687814,-732508622,'Gemini'],
  [-732508622,-732324288,'Cancer'],
  [-732324288,-732133479,'Leo'],
  [-732133479,-731935616,'Virgo'],
  [-731935616,-731729968,'Libra'],
  [-731729968,-731516224,'Scorpio'],
  [-731516224,-731296844,'Sagittarius'],
  [-731296844,-731078631,'Capricorn'],
  [-731078631,-730870083,'Aquarius'],
  [-730870083,-730675916,'Pisces'],
  [-730675916,-730494659,'Aries'],
  [-730494659,-730320758,'Taurus'],
  [-730320758,-730147479,'Gemini'],
  [-730147479,-729968843,'Cancer'],
  [-729968843,-729780923,'Leo'],
  [-729780923,-729582465,'Virgo'],
  [-729582465,-729374527,'Libra'],
  [-729374527,-729159387,'Scorpio'],
  [-729159387,-728940032,'Sagittarius'],
  [-728940032,-728721023,'Capricorn'],
  [-728721023,-728508627,'Aquarius'],
  [-728508627,-728308492,'Pisces'],
  [-728308492,-728122292,'Aries'],
  [-728122292,-727947009,'Taurus'],
  [-727947009,-727776613,'Gemini'],
  [-727776613,-727604020,'Cancer'],
  [-727604020,-727422679,'Leo'],
  [-727422679,-727228374,'Virgo'],
  [-727228374,-727021023,'Libra'],
  [-727021023,-726804694,'Scorpio'],
  [-726804694,-726584989,'Sagittarius'],
  [-726584989,-726366637,'Capricorn'],
  [-726366637,-726153403,'Aquarius'],
  [-726153403,-725948942,'Pisces'],
  [-725948942,-725756051,'Aries'],
  [-725756051,-725574839,'Taurus'],
  [-725574839,-725401938,'Gemini'],
  [-725401938,-725231222,'Cancer'],
  [-725231222,-725055333,'Leo'],
  [-725055333,-724867574,'Virgo'],
  [-724867574,-724664680,'Libra'],
  [-724664680,-724449424,'Scorpio'],
  [-724449424,-724229379,'Sagittarius'],
  [-724229379,-724011786,'Capricorn'],
  [-724011786,-723800232,'Aquarius'],
  [-723800232,-723595776,'Pisces'],
  [-723595776,-723399282,'Aries'],
  [-723399282,-723211682,'Taurus'],
  [-723211682,-723032491,'Gemini'],
  [-723032491,-722858327,'Cancer'],
  [-722858327,-722683102,'Leo'],
  [-722683102,-722499645,'Virgo'],
  [-722499645,-722302319,'Libra'],
  [-722302319,-722090672,'Scorpio'],
  [-722090672,-721871286,'Sagittarius'],
  [-721871286,-721653690,'Capricorn'],
  [-721653690,-721443773,'Aquarius'],
  [-721443773,-721242151,'Pisces'],
  [-721242151,-721047146,'Aries'],
  [-721047146,-720857605,'Taurus'],
  [-720857605,-720673282,'Gemini'],
  [-720673282,-720493202,'Cancer'],
  [-720493202,-720314015,'Leo'],
  [-720314015,-720130156,'Virgo'],
  [-720130156,-719935759,'Libra'],
  [-719935759,-719727974,'Scorpio'],
  [-719727974,-719510391,'Sagittarius'],
  [-719510391,-719292283,'Capricorn'],
  [-719292283,-719082156,'Aquarius'],
  [-719082156,-718882635,'Pisces'],
  [-718882635,-718691464,'Aries'],
  [-718691464,-718505060,'Taurus'],
  [-718505060,-718320860,'Gemini'],
  [-718320860,-718137485,'Cancer'],
  [-718137485,-717953385,'Leo'],
  [-717953385,-717765635,'Virgo'],
  [-717765635,-717570219,'Libra'],
  [-717570219,-717364077,'Scorpio'],
  [-717364077,-717148298,'Sagittarius'],
  [-717148298,-716929730,'Capricorn'],
  [-716929730,-716717578,'Aquarius'],
  [-716717578,-716517272,'Pisces'],
  [-716517272,-716328257,'Aries'],
  [-716328257,-716146347,'Taurus'],
  [-716146347,-715966674,'Gemini'],
  [-715966674,-715785365,'Cancer'],
  [-715785365,-715599901,'Leo'],
  [-715599901,-715408578,'Virgo'],
  [-715408578,-715209894,'Libra'],
  [-715209894,-715002665,'Scorpio'],
  [-715002665,-714787515,'Sagittarius'],
  [-714787515,-714568756,'Capricorn'],
  [-714568756,-714353991,'Aquarius'],
  [-714353991,-714150226,'Pisces'],
  [-714150226,-713959712,'Aries'],
  [-713959712,-713779719,'Taurus'],
  [-713779719,-713604796,'Gemini'],
  [-713604796,-713428926,'Cancer'],
  [-713428926,-713247023,'Leo'],
  [-713247023,-713055966,'Virgo'],
  [-713055966,-712855069,'Libra'],
  [-712855069,-712645565,'Scorpio'],
  [-712645565,-712429713,'Sagittarius'],
  [-712429713,-712210928,'Capricorn'],
  [-712210928,-711994386,'Aquarius'],
  [-711994386,-711786377,'Pisces'],
  [-711786377,-711591290,'Aries'],
  [-711591290,-711409107,'Taurus'],
  [-711409107,-711235660,'Gemini'],
  [-711235660,-711064412,'Cancer'],
  [-711064412,-710888342,'Leo'],
  [-710888342,-710701740,'Virgo'],
  [-710701740,-710502203,'Libra'],
  [-710502203,-710291642,'Scorpio'],
  [-710291642,-710074646,'Sagittarius'],
  [-710074646,-709855826,'Capricorn'],
  [-709855826,-709639032,'Aquarius'],
  [-709639032,-709428339,'Pisces'],
  [-709428339,-709228080,'Aries'],
  [-709228080,-709040599,'Taurus'],
  [-709040599,-708864333,'Gemini'],
  [-708864333,-708693950,'Cancer'],
  [-708693950,-708522060,'Leo'],
  [-708522060,-708341211,'Virgo'],
  [-708341211,-708146352,'Libra'],
  [-708146352,-707937585,'Scorpio'],
  [-707937585,-707720322,'Sagittarius'],
  [-707720322,-707501426,'Capricorn'],
  [-707501426,-707285467,'Aquarius'],
  [-707285467,-707074827,'Pisces'],
  [-707074827,-706871810,'Aries'],
  [-706871810,-706678948,'Taurus'],
  [-706678948,-706497025,'Gemini'],
  [-706497025,-706323237,'Cancer'],
  [-706323237,-706151482,'Leo'],
  [-706151482,-705974161,'Virgo'],
  [-705974161,-705784535,'Libra'],
  [-705784535,-705579940,'Scorpio'],
  [-705579940,-705364167,'Sagittarius'],
  [-705364167,-705145324,'Capricorn'],
  [-705145324,-704930200,'Aquarius'],
  [-704930200,-704721447,'Pisces'],
  [-704721447,-704519386,'Aries'],
  [-704519386,-704324512,'Taurus'],
  [-704324512,-704137673,'Gemini'],
  [-704137673,-703958220,'Cancer'],
  [-703958220,-703782562,'Leo'],
  [-703782562,-703604644,'Virgo'],
  [-703604644,-703417771,'Libra'],
  [-703417771,-703217430,'Scorpio'],
  [-703217430,-703004551,'Sagittarius'],
  [-703004551,-702786154,'Capricorn'],
  [-702786154,-702570927,'Aquarius'],
  [-702570927,-702363704,'Pisces'],
  [-702363704,-702164694,'Aries'],
  [-702164694,-701972187,'Taurus'],
  [-701972187,-701784782,'Gemini'],
  [-701784782,-701601511,'Cancer'],
  [-701601511,-701420590,'Leo'],
  [-701420590,-701238517,'Virgo'],
  [-701238517,-701050476,'Libra'],
  [-701050476,-700852041,'Scorpio'],
  [-700852041,-700641961,'Sagittarius'],
  [-700641961,-700424475,'Capricorn'],
  [-700424475,-700208064,'Aquarius'],
  [-700208064,-700000146,'Pisces'],
  [-700000146,-699803035,'Aries'],
  [-699803035,-699614663,'Taurus'],
  [-699614663,-699431287,'Gemini'],
  [-699431287,-699249394,'Cancer'],
  [-699249394,-699066311,'Leo'],
  [-699066311,-698879865,'Virgo'],
  [-698879865,-698687855,'Libra'],
  [-698687855,-698488003,'Scorpio'],
  [-698488003,-698278980,'Sagittarius'],
  [-698278980,-698062503,'Capricorn'],
  [-698062503,-697844630,'Aquarius'],
  [-697844630,-697633611,'Pisces'],
  [-697633611,-697434852,'Aries'],
  [-697434852,-697248291,'Taurus'],
  [-697248291,-697069744,'Gemini'],
  [-697069744,-696893394,'Cancer'],
  [-696893394,-696713786,'Leo'],
  [-696713786,-696527181,'Virgo'],
  [-696527181,-696332152,'Libra'],
  [-696332152,-696129043,'Scorpio'],
  [-696129043,-695918763,'Sagittarius'],
  [-695918763,-695702666,'Capricorn'],
  [-695702666,-695484073,'Aquarius'],
  [-695484073,-695269395,'Pisces'],
  [-695269395,-695065737,'Aries'],
  [-695065737,-694876370,'Taurus'],
  [-694876370,-694699021,'Gemini'],
  [-694699021,-694527518,'Cancer'],
  [-694527518,-694354385,'Leo'],
  [-694354385,-694173010,'Virgo'],
  [-694173010,-693979747,'Libra'],
  [-693979747,-693775173,'Scorpio'],
  [-693775173,-693562740,'Sagittarius'],
  [-693562740,-693345958,'Capricorn'],
  [-693345958,-693127493,'Aquarius'],
  [-693127493,-692910982,'Pisces'],
  [-692910982,-692702259,'Aries'],
  [-692702259,-692506716,'Taurus'],
  [-692506716,-692325408,'Gemini'],
  [-692325408,-692154028,'Cancer'],
  [-692154028,-691985041,'Leo'],
  [-691985041,-691810258,'Virgo'],
  [-691810258,-691623169,'Libra'],
  [-691623169,-691421653,'Scorpio'],
  [-691421653,-691209029,'Sagittarius'],
  [-691209029,-690991259,'Capricorn'],
  [-690991259,-690772998,'Aquarius'],
  [-690772998,-690556970,'Pisces'],
  [-690556970,-690346324,'Aries'],
  [-690346324,-690145451,'Taurus'],
  [-690145451,-689957464,'Gemini'],
  [-689957464,-689781197,'Cancer'],
  [-689781197,-689611075,'Leo'],
  [-689611075,-689439300,'Virgo'],
  [-689439300,-689258177,'Libra'],
  [-689258177,-689062723,'Scorpio'],
  [-689062723,-688853374,'Sagittarius'],
  [-688853374,-688635957,'Capricorn'],
  [-688635957,-688417625,'Aquarius'],
  [-688417625,-688202832,'Pisces'],
  [-688202832,-687993590,'Aries'],
  [-687993590,-687791687,'Taurus'],
  [-687791687,-687599168,'Gemini'],
  [-687599168,-687416533,'Cancer'],
  [-687416533,-687241057,'Leo'],
  [-687241057,-687067115,'Virgo'],
  [-687067115,-686887830,'Libra'],
  [-686887830,-686697208,'Scorpio'],
  [-686697208,-686492784,'Sagittarius'],
  [-686492784,-686277696,'Capricorn'],
  [-686277696,-686059451,'Aquarius'],
  [-686059451,-685845117,'Pisces'],
  [-685845117,-685638087,'Aries'],
  [-685638087,-685438803,'Taurus'],
  [-685438803,-685246717,'Gemini'],
  [-685246717,-685061049,'Cancer'],
  [-685061049,-684880185,'Leo'],
  [-684880185,-684701022,'Virgo'],
  [-684701022,-684519052,'Libra'],
  [-684519052,-684329334,'Scorpio'],
  [-684329334,-684128317,'Sagittarius'],
  [-684128317,-683916250,'Capricorn'],
  [-683916250,-683698569,'Aquarius'],
  [-683698569,-683483516,'Pisces'],
  [-683483516,-683277124,'Aries'],
  [-683277124,-683080807,'Taurus'],
  [-683080807,-682892499,'Gemini'],
  [-682892499,-682708862,'Cancer'],
  [-682708862,-682526747,'Leo'],
  [-682526747,-682343581,'Virgo'],
  [-682343581,-682157064,'Libra'],
  [-682157064,-681964694,'Scorpio'],
  [-681964694,-681763950,'Sagittarius'],
  [-681763950,-681553765,'Capricorn'],
  [-681553765,-681336838,'Aquarius'],
  [-681336838,-681120312,'Pisces'],
  [-681120312,-680912200,'Aries'],
  [-680912200,-680716425,'Taurus'],
  [-680716425,-680531494,'Gemini'],
  [-680531494,-680352516,'Cancer'],
  [-680352516,-680173889,'Leo'],
  [-680173889,-679991215,'Virgo'],
  [-679991215,-679802205,'Libra'],
  [-679802205,-679606302,'Scorpio'],
  [-679606302,-679403360,'Sagittarius'],
  [-679403360,-679193098,'Capricorn'],
  [-679193098,-678976610,'Aquarius'],
  [-678976610,-678758651,'Pisces'],
  [-678758651,-678547209,'Aries'],
  [-678547209,-678348737,'Taurus'],
  [-678348737,-678163999,'Gemini'],
  [-678163999,-677988419,'Cancer'],
  [-677988419,-677814987,'Leo'],
  [-677814987,-677636965,'Virgo'],
  [-677636965,-677449931,'Libra'],
  [-677449931,-677252941,'Scorpio'],
  [-677252941,-677047604,'Sagittarius'],
  [-677047604,-676835864,'Capricorn'],
  [-676835864,-676619226,'Aquarius'],
  [-676619226,-676400563,'Pisces'],
  [-676400563,-676185965,'Aries'],
  [-676185965,-675982726,'Taurus'],
  [-675982726,-675794386,'Gemini'],
  [-675794386,-675618401,'Cancer'],
  [-675618401,-675448049,'Leo'],
  [-675448049,-675275430,'Virgo'],
  [-675275430,-675093818,'Libra'],
  [-675093818,-674899854,'Scorpio'],
  [-674899854,-674694519,'Sagittarius'],
  [-674694519,-674481451,'Capricorn'],
  [-674481451,-674264224,'Aquarius'],
  [-674264224,-674045683,'Pisces'],
  [-674045683,-673829805,'Aries'],
  [-673829805,-673622410,'Taurus'],
  [-673622410,-673428364,'Gemini'],
  [-673428364,-673247933,'Cancer'],
  [-673247933,-673076373,'Leo'],
  [-673076373,-672906274,'Virgo'],
  [-672906274,-672729966,'Libra'],
  [-672729966,-672541695,'Scorpio'],
  [-672541695,-672339810,'Sagittarius'],
  [-672339810,-672127298,'Capricorn'],
  [-672127298,-671909604,'Aquarius'],
  [-671909604,-671691502,'Pisces'],
  [-671691502,-671476473,'Aries'],
  [-671476473,-671268003,'Taurus'],
  [-671268003,-671069654,'Gemini'],
  [-671069654,-670883110,'Cancer'],
  [-670883110,-670706383,'Leo'],
  [-670706383,-670534202,'Virgo'],
  [-670534202,-670359713,'Libra'],
  [-670359713,-670176306,'Scorpio'],
  [-670176306,-669979742,'Sagittarius'],
  [-669979742,-669770273,'Capricorn'],
  [-669770273,-669553015,'Aquarius'],
  [-669553015,-669335034,'Pisces'],
  [-669335034,-669121558,'Aries'],
  [-669121558,-668915126,'Taurus'],
  [-668915126,-668716720,'Gemini'],
  [-668716720,-668526625,'Cancer'],
  [-668526625,-668344008,'Leo'],
  [-668344008,-668166251,'Virgo'],
  [-668166251,-667988939,'Libra'],
  [-667988939,-667806579,'Scorpio'],
  [-667806579,-667614025,'Sagittarius'],
  [-667614025,-667408730,'Capricorn'],
  [-667408730,-667193191,'Aquarius'],
  [-667193191,-666974872,'Pisces'],
  [-666974872,-666761754,'Aries'],
  [-666761754,-666557884,'Taurus'],
  [-666557884,-666362941,'Gemini'],
  [-666362941,-666174468,'Cancer'],
  [-666174468,-665989904,'Leo'],
  [-665989904,-665807230,'Virgo'],
  [-665807230,-665624489,'Libra'],
  [-665624489,-665438894,'Scorpio'],
  [-665438894,-665246618,'Sagittarius'],
  [-665246618,-665044093,'Capricorn'],
  [-665044093,-664830862,'Aquarius'],
  [-664830862,-664612219,'Pisces'],
  [-664612219,-664397484,'Aries'],
  [-664397484,-664193755,'Taurus'],
  [-664193755,-664001958,'Gemini'],
  [-664001958,-663818227,'Cancer'],
  [-663818227,-663637263,'Leo'],
  [-663637263,-663454851,'Virgo'],
  [-663454851,-663268885,'Libra'],
  [-663268885,-663078676,'Scorpio'],
  [-663078676,-662883208,'Sagittarius'],
  [-662883208,-662680359,'Capricorn'],
  [-662680359,-662468514,'Aquarius'],
  [-662468514,-662249975,'Pisces'],
  [-662249975,-662032635,'Aries'],
  [-662032635,-661825768,'Taurus'],
  [-661825768,-661633406,'Gemini'],
  [-661633406,-661452746,'Cancer'],
  [-661452746,-661277280,'Leo'],
  [-661277280,-661100226,'Virgo'],
  [-661100226,-660916831,'Libra'],
  [-660916831,-660725468,'Scorpio'],
  [-660725468,-660526715,'Sagittarius'],
  [-660526715,-660321214,'Capricorn'],
  [-660321214,-660108838,'Aquarius'],
  [-660108838,-659890551,'Pisces'],
  [-659890551,-659671387,'Aries'],
  [-659671387,-659459987,'Taurus'],
  [-659459987,-659263058,'Gemini'],
  [-659263058,-659080772,'Cancer'],
  [-659080772,-658907681,'Leo'],
  [-658907681,-658736185,'Virgo'],
  [-658736185,-658559232,'Libra'],
  [-658559232,-658372241,'Scorpio'],
  [-658372241,-658174197,'Sagittarius'],
  [-658174197,-657966857,'Capricorn'],
  [-657966857,-657752773,'Aquarius'],
  [-657752773,-657534273,'Pisces'],
  [-657534273,-657314835,'Aries'],
  [-657314835,-657100496,'Taurus'],
  [-657100496,-656897906,'Gemini'],
  [-656897906,-656710006,'Cancer'],
  [-656710006,-656534164,'Leo'],
  [-656534164,-656364017,'Virgo'],
  [-656364017,-656192101,'Libra'],
  [-656192101,-656011772,'Scorpio'],
  [-656011772,-655818937,'Sagittarius'],
  [-655818937,-655613397,'Capricorn'],
  [-655613397,-655398615,'Aquarius'],
  [-655398615,-655179527,'Pisces'],
  [-655179527,-654960654,'Aries'],
  [-654960654,-654746246,'Taurus'],
  [-654746246,-654540601,'Gemini'],
  [-654540601,-654346842,'Cancer'],
  [-654346842,-654164902,'Leo'],
  [-654164902,-653991140,'Virgo'],
  [-653991140,-653819567,'Libra'],
  [-653819567,-653643410,'Scorpio'],
  [-653643410,-653456658,'Sagittarius'],
  [-653456658,-653256053,'Capricorn'],
  [-653256053,-653043131,'Aquarius'],
  [-653043131,-652823959,'Pisces'],
  [-652823959,-652605552,'Aries'],
  [-652605552,-652392741,'Taurus'],
  [-652392741,-652187812,'Gemini'],
  [-652187812,-651991726,'Cancer'],
  [-651991726,-651804525,'Leo'],
  [-651804525,-651624789,'Virgo'],
  [-651624789,-651449182,'Libra'],
  [-651449182,-651272583,'Scorpio'],
  [-651272583,-651088987,'Sagittarius'],
  [-651088987,-650893276,'Capricorn'],
  [-650893276,-650684037,'Aquarius'],
  [-650684037,-650465893,'Pisces'],
  [-650465893,-650247505,'Aries'],
  [-650247505,-650035986,'Taurus'],
  [-650035986,-649833691,'Gemini'],
  [-649833691,-649639440,'Cancer'],
  [-649639440,-649451195,'Leo'],
  [-649451195,-649267351,'Virgo'],
  [-649267351,-649086403,'Libra'],
  [-649086403,-648905781,'Scorpio'],
  [-648905781,-648721220,'Sagittarius'],
  [-648721220,-648527640,'Capricorn'],
  [-648527640,-648321702,'Aquarius'],
  [-648321702,-648105318,'Pisces'],
  [-648105318,-647886588,'Aries'],
  [-647886588,-647674814,'Taurus'],
  [-647674814,-647474316,'Gemini'],
  [-647474316,-647283569,'Cancer'],
  [-647283569,-647098408,'Leo'],
  [-647098408,-646915083,'Virgo'],
  [-646915083,-646731493,'Libra'],
  [-646731493,-646546502,'Scorpio'],
  [-646546502,-646358260,'Sagittarius'],
  [-646358260,-646163465,'Capricorn'],
  [-646163465,-645958724,'Aquarius'],
  [-645958724,-645743836,'Pisces'],
  [-645743836,-645524653,'Aries'],
  [-645524653,-645310970,'Taurus'],
  [-645310970,-645109677,'Gemini'],
  [-645109677,-644920868,'Cancer'],
  [-644920868,-644739849,'Leo'],
  [-644739849,-644560821,'Virgo'],
  [-644560821,-644379366,'Libra'],
  [-644379366,-644193307,'Scorpio'],
  [-644193307,-644001839,'Sagittarius'],
  [-644001839,-643803965,'Capricorn'],
  [-643803965,-643598070,'Aquarius'],
  [-643598070,-643383610,'Pisces'],
  [-643383610,-643164128,'Aries'],
  [-643164128,-642947844,'Taurus'],
  [-642947844,-642743105,'Gemini'],
  [-642743105,-642552745,'Cancer'],
  [-642552745,-642373463,'Leo'],
  [-642373463,-642198957,'Virgo'],
  [-642198957,-642022831,'Libra'],
  [-642022831,-641840373,'Scorpio'],
  [-641840373,-641649315,'Sagittarius'],
  [-641649315,-641449378,'Capricorn'],
  [-641449378,-641241236,'Aquarius'],
  [-641241236,-641026021,'Pisces'],
  [-641026021,-640806479,'Aries'],
  [-640806479,-640588409,'Taurus'],
  [-640588409,-640379303,'Gemini'],
  [-640379303,-640184126,'Cancer'],
  [-640184126,-640002368,'Leo'],
  [-640002368,-639829104,'Virgo'],
  [-639829104,-639657574,'Libra'],
  [-639657574,-639481140,'Scorpio'],
  [-639481140,-639294790,'Sagittarius'],
  [-639294790,-639096408,'Capricorn'],
  [-639096408,-638887223,'Aquarius'],
  [-638887223,-638670772,'Pisces'],
  [-638670772,-638451221,'Aries'],
  [-638451221,-638233069,'Taurus'],
  [-638233069,-638021350,'Gemini'],
  [-638021350,-637820706,'Cancer'],
  [-637820706,-637633053,'Leo'],
  [-637633053,-637456327,'Virgo'],
  [-637456327,-637285295,'Libra'],
  [-637285295,-637113135,'Scorpio'],
  [-637113135,-636932981,'Sagittarius'],
  [-636932981,-636739800,'Capricorn'],
  [-636739800,-636532714,'Aquarius'],
  [-636532714,-636315935,'Pisces'],
  [-636315935,-636096205,'Aries'],
  [-636096205,-635879098,'Taurus'],
  [-635879098,-635667899,'Gemini'],
  [-635667899,-635464776,'Cancer'],
  [-635464776,-635271460,'Leo'],
  [-635271460,-635088256,'Virgo'],
  [-635088256,-634912883,'Libra'],
  [-634912883,-634740280,'Scorpio'],
  [-634740280,-634563631,'Sagittarius'],
  [-634563631,-634376151,'Capricorn'],
  [-634376151,-634173892,'Aquarius'],
  [-634173892,-633958923,'Pisces'],
  [-633958923,-633739092,'Aries'],
  [-633739092,-633522687,'Taurus'],
  [-633522687,-633313727,'Gemini'],
  [-633313727,-633112346,'Cancer'],
  [-633112346,-632917737,'Leo'],
  [-632917737,-632729707,'Virgo'],
  [-632729707,-632547991,'Libra'],
  [-632547991,-632370482,'Scorpio'],
  [-632370482,-632192408,'Sagittarius'],
  [-632192408,-632007335,'Capricorn'],
  [-632007335,-631809616,'Aquarius'],
  [-631809616,-631598129,'Pisces'],
  [-631598129,-631378924,'Aries'],
  [-631378924,-631162030,'Taurus'],
  [-631162030,-630954234,'Gemini'],
  [-630954234,-630756137,'Cancer'],
  [-630756137,-630564851,'Leo'],
  [-630564851,-630377505,'Virgo'],
  [-630377505,-630192735,'Libra'],
  [-630192735,-630009835,'Scorpio'],
  [-630009835,-629826819,'Sagittarius'],
  [-629826819,-629639589,'Capricorn'],
  [-629639589,-629443134,'Aquarius'],
  [-629443134,-629234553,'Pisces'],
  [-629234553,-629016728,'Aries'],
  [-629016728,-628798620,'Taurus'],
  [-628798620,-628589406,'Gemini'],
  [-628589406,-628392383,'Cancer'],
  [-628392383,-628205008,'Leo'],
  [-628205008,-628022468,'Virgo'],
  [-628022468,-627840590,'Libra'],
  [-627840590,-627656928,'Scorpio'],
  [-627656928,-627470128,'Sagittarius'],
  [-627470128,-627278559,'Capricorn'],
  [-627278559,-627079757,'Aquarius'],
  [-627079757,-626871568,'Pisces'],
  [-626871568,-626654904,'Aries'],
  [-626654904,-626435840,'Taurus'],
  [-626435840,-626223418,'Gemini'],
  [-626223418,-626023786,'Cancer'],
  [-626023786,-625836932,'Leo'],
  [-625836932,-625658396,'Virgo'],
  [-625658396,-625482290,'Libra'],
  [-625482290,-625303355,'Scorpio'],
  [-625303355,-625117997,'Sagittarius'],
  [-625117997,-624924478,'Capricorn'],
  [-624924478,-624722452,'Aquarius'],
  [-624722452,-624512353,'Pisces'],
  [-624512353,-624295677,'Aries'],
  [-624295677,-624076333,'Taurus'],
  [-624076333,-623860996,'Gemini'],
  [-623860996,-623656535,'Cancer'],
  [-623656535,-623465955,'Leo'],
  [-623465955,-623287164,'Virgo'],
  [-623287164,-623114679,'Libra'],
  [-623114679,-622941788,'Scorpio'],
  [-622941788,-622762238,'Sagittarius'],
  [-622762238,-622571744,'Capricorn'],
  [-622571744,-622369324,'Aquarius'],
  [-622369324,-622157312,'Pisces'],
  [-622157312,-621939623,'Aries'],
  [-621939623,-621720353,'Taurus'],
  [-621720353,-621503899,'Gemini'],
  [-621503899,-621295368,'Cancer'],
  [-621295368,-621099011,'Leo'],
  [-621099011,-620915693,'Virgo'],
  [-620915693,-620742161,'Libra'],
  [-620742161,-620572177,'Scorpio'],
  [-620572177,-620398332,'Sagittarius'],
  [-620398332,-620213893,'Capricorn'],
  [-620213893,-620015182,'Aquarius'],
  [-620015182,-619803714,'Pisces'],
  [-619803714,-619585276,'Aries'],
  [-619585276,-619366061,'Taurus'],
  [-619366061,-619150177,'Gemini'],
  [-619150177,-618940433,'Cancer'],
  [-618940433,-618739773,'Leo'],
  [-618739773,-618550435,'Virgo'],
  [-618550435,-618371950,'Libra'],
  [-618371950,-618200204,'Scorpio'],
  [-618200204,-618028399,'Sagittarius'],
  [-618028399,-617848930,'Capricorn'],
  [-617848930,-617655785,'Aquarius'],
  [-617655785,-617447766,'Pisces'],
  [-617447766,-617230071,'Aries'],
  [-617230071,-617010910,'Taurus'],
  [-617010910,-616796119,'Gemini'],
  [-616796119,-616587770,'Cancer'],
  [-616587770,-616386520,'Leo'],
  [-616386520,-616193437,'Virgo'],
  [-616193437,-616009270,'Libra'],
  [-616009270,-615832461,'Scorpio'],
  [-615832461,-615658314,'Sagittarius'],
  [-615658314,-615480048,'Capricorn'],
  [-615480048,-615290926,'Aquarius'],
  [-615290926,-615087351,'Pisces'],
  [-615087351,-614871998,'Aries'],
  [-614871998,-614653110,'Taurus'],
  [-614653110,-614438793,'Gemini'],
  [-614438793,-614232463,'Cancer'],
  [-614232463,-614033678,'Leo'],
  [-614033678,-613841177,'Virgo'],
  [-613841177,-613654402,'Libra'],
  [-613654402,-613472687,'Scorpio'],
  [-613472687,-613293646,'Sagittarius'],
  [-613293646,-613112681,'Capricorn'],
  [-613112681,-612924087,'Aquarius'],
  [-612924087,-612723447,'Pisces'],
  [-612723447,-612510869,'Aries'],
  [-612510869,-612292567,'Taurus'],
  [-612292567,-612077586,'Gemini'],
  [-612077586,-611871824,'Cancer'],
  [-611871824,-611675816,'Leo'],
  [-611675816,-611486961,'Virgo'],
  [-611486961,-611302261,'Libra'],
  [-611302261,-611119461,'Scorpio'],
  [-611119461,-610936626,'Sagittarius'],
  [-610936626,-610751230,'Capricorn'],
  [-610751230,-610559901,'Aquarius'],
  [-610559901,-610359336,'Pisces'],
  [-610359336,-610148483,'Aries'],
  [-610148483,-609930888,'Taurus'],
  [-609930888,-609714385,'Gemini'],
  [-609714385,-609506762,'Cancer'],
  [-609506762,-609311117,'Leo'],
  [-609311117,-609125549,'Virgo'],
  [-609125549,-608945599,'Libra'],
  [-608945599,-608766470,'Scorpio'],
  [-608766470,-608584275,'Sagittarius'],
  [-608584275,-608396433,'Capricorn'],
  [-608396433,-608201454,'Aquarius'],
  [-608201454,-607998511,'Pisces'],
  [-607998511,-607787519,'Aries'],
  [-607787519,-607570414,'Taurus'],
  [-607570414,-607352456,'Gemini'],
  [-607352456,-607141205,'Cancer'],
  [-607141205,-606942392,'Leo'],
  [-606942392,-606756674,'Virgo'],
  [-606756674,-606580141,'Libra'],
  [-606580141,-606406565,'Scorpio'],
  [-606406565,-606229501,'Sagittarius'],
  [-606229501,-606044010,'Capricorn'],
  [-606044010,-605848024,'Aquarius'],
  [-605848024,-605642487,'Pisces'],
  [-605642487,-605429844,'Aries'],
  [-605429844,-605212671,'Taurus'],
  [-605212671,-604994210,'Gemini'],
  [-604994210,-604779722,'Cancer'],
  [-604779722,-604575551,'Leo'],
  [-604575551,-604385393,'Virgo'],
  [-604385393,-604207876,'Libra'],
  [-604207876,-604037320,'Scorpio'],
  [-604037320,-603866081,'Sagittarius'],
  [-603866081,-603686751,'Capricorn'],
  [-603686751,-603494499,'Aquarius'],
  [-603494499,-603289239,'Pisces'],
  [-603289239,-603075145,'Aries'],
  [-603075145,-602857294,'Taurus'],
  [-602857294,-602639222,'Gemini'],
  [-602639222,-602423881,'Cancer'],
  [-602423881,-602215593,'Leo'],
  [-602215593,-602019058,'Virgo'],
  [-602019058,-601836034,'Libra'],
  [-601836034,-601663381,'Scorpio'],
  [-601663381,-601494224,'Sagittarius'],
  [-601494224,-601320354,'Capricorn'],
  [-601320354,-601134579,'Aquarius'],
  [-601134579,-600933705,'Pisces'],
  [-600933705,-600720628,'Aries'],
  [-600720628,-600502238,'Taurus'],
  [-600502238,-600284545,'Gemini'],
  [-600284545,-600070492,'Cancer'],
  [-600070492,-599861932,'Leo'],
  [-599861932,-599661598,'Virgo'],
  [-599661598,-599472122,'Libra'],
  [-599472122,-599293308,'Scorpio'],
  [-599293308,-599120898,'Sagittarius'],
  [-599120898,-598947877,'Capricorn'],
  [-598947877,-598766655,'Aquarius'],
  [-598766655,-598571687,'Pisces'],
  [-598571687,-598362578,'Aries'],
  [-598362578,-598145050,'Taurus'],
  [-598145050,-597927238,'Gemini'],
  [-597927238,-597714505,'Cancer'],
  [-597714505,-597508444,'Leo'],
  [-597508444,-597309242,'Virgo'],
  [-597309242,-597117374,'Libra'],
  [-597117374,-596933025,'Scorpio'],
  [-596933025,-596754452,'Sagittarius'],
  [-596754452,-596577376,'Capricorn'],
  [-596577376,-596395874,'Aquarius'],
  [-596395874,-596204237,'Pisces'],
  [-596204237,-595999611,'Aries'],
  [-595999611,-595784519,'Taurus'],
  [-595784519,-595566524,'Gemini'],
  [-595566524,-595353547,'Cancer'],
  [-595353547,-595149440,'Leo'],
  [-595149440,-594953934,'Virgo'],
  [-594953934,-594764936,'Libra'],
  [-594764936,-594580242,'Scorpio'],
  [-594580242,-594397835,'Sagittarius'],
  [-594397835,-594215361,'Capricorn'],
  [-594215361,-594029671,'Aquarius'],
  [-594029671,-593837039,'Pisces'],
  [-593837039,-593634445,'Aries'],
  [-593634445,-593421842,'Taurus'],
  [-593421842,-593204045,'Gemini'],
  [-593204045,-592989338,'Cancer'],
  [-592989338,-592784465,'Leo'],
  [-592784465,-592591139,'Virgo'],
  [-592591139,-592406664,'Libra'],
  [-592406664,-592226377,'Scorpio'],
  [-592226377,-592045741,'Sagittarius'],
  [-592045741,-591861473,'Capricorn'],
  [-591861473,-591671733,'Aquarius'],
  [-591671733,-591475466,'Pisces'],
  [-591475466,-591271676,'Aries'],
  [-591271676,-591059962,'Taurus'],
  [-591059962,-590842545,'Gemini'],
  [-590842545,-590625736,'Cancer'],
  [-590625736,-590417588,'Leo'],
  [-590417588,-590222798,'Virgo'],
  [-590222798,-590040311,'Libra'],
  [-590040311,-589864827,'Scorpio'],
  [-589864827,-589689626,'Sagittarius'],
  [-589689626,-589508863,'Capricorn'],
  [-589508863,-589319220,'Aquarius'],
  [-589319220,-589120443,'Pisces'],
  [-589120443,-588914012,'Aries'],
  [-588914012,-588701351,'Taurus'],
  [-588701351,-588484018,'Gemini'],
  [-588484018,-588265840,'Cancer'],
  [-588265840,-588053777,'Leo'],
  [-588053777,-587854501,'Virgo'],
  [-587854501,-587669817,'Libra'],
  [-587669817,-587495780,'Scorpio'],
  [-587495780,-587325176,'Sagittarius'],
  [-587325176,-587150321,'Capricorn'],
  [-587150321,-586965303,'Aquarius'],
  [-586965303,-586768007,'Pisces'],
  [-586768007,-586560413,'Aries'],
  [-586560413,-586346238,'Taurus'],
  [-586346238,-586128535,'Gemini'],
  [-586128535,-585910102,'Cancer'],
  [-585910102,-585695612,'Leo'],
  [-585695612,-585491352,'Virgo'],
  [-585491352,-585301392,'Libra'],
  [-585301392,-585124439,'Scorpio'],
  [-585124439,-584954537,'Sagittarius'],
  [-584954537,-584783778,'Capricorn'],
  [-584783778,-584604664,'Aquarius'],
  [-584604664,-584412416,'Pisces'],
  [-584412416,-584206975,'Aries'],
  [-584206975,-583992529,'Taurus'],
  [-583992529,-583774367,'Gemini'],
  [-583774367,-583556384,'Cancer'],
  [-583556384,-583341858,'Leo'],
  [-583341858,-583134944,'Virgo'],
  [-583134944,-582939672,'Libra'],
  [-582939672,-582757025,'Scorpio'],
  [-582757025,-582583552,'Sagittarius'],
  [-582583552,-582412724,'Capricorn'],
  [-582412724,-582237086,'Aquarius'],
  [-582237086,-582050320,'Pisces'],
  [-582050320,-581849600,'Aries'],
  [-581849600,-581637155,'Taurus'],
  [-581637155,-581419084,'Gemini'],
  [-581419084,-581201560,'Cancer'],
  [-581201560,-580988517,'Leo'],
  [-580988517,-580782351,'Virgo'],
  [-580782351,-580584973,'Libra'],
  [-580584973,-580397345,'Scorpio'],
  [-580397345,-580218107,'Sagittarius'],
  [-580218107,-580043220,'Capricorn'],
  [-580043220,-579866863,'Aquarius'],
  [-579866863,-579682899,'Pisces'],
  [-579682899,-579486807,'Aries'],
  [-579486807,-579277968,'Taurus'],
  [-579277968,-579060954,'Gemini'],
  [-579060954,-578843426,'Cancer'],
  [-578843426,-578631609,'Leo'],
  [-578631609,-578428084,'Virgo'],
  [-578428084,-578232677,'Libra'],
  [-578232677,-578044138,'Scorpio'],
  [-578044138,-577860839,'Sagittarius'],
  [-577860839,-577680520,'Capricorn'],
  [-577680520,-577499914,'Aquarius'],
  [-577499914,-577314775,'Pisces'],
  [-577314775,-577120732,'Aries'],
  [-577120732,-576915201,'Taurus'],
  [-576915201,-576699953,'Gemini'],
  [-576699953,-576481950,'Cancer'],
  [-576481950,-576269672,'Leo'],
  [-576269672,-576067895,'Virgo'],
  [-576067895,-575876210,'Libra'],
  [-575876210,-575691112,'Scorpio'],
  [-575691112,-575508599,'Sagittarius'],
  [-575508599,-575325663,'Capricorn'],
  [-575325663,-575140425,'Aquarius'],
  [-575140425,-574951242,'Pisces'],
  [-574951242,-574755787,'Aries'],
  [-574755787,-574551487,'Taurus'],
  [-574551487,-574337853,'Gemini'],
  [-574337853,-574119319,'Cancer'],
  [-574119319,-573904722,'Leo'],
  [-573904722,-573701697,'Virgo'],
  [-573701697,-573511842,'Libra'],
  [-573511842,-573331216,'Scorpio'],
  [-573331216,-573153615,'Sagittarius'],
  [-573153615,-572973436,'Capricorn'],
  [-572973436,-572787422,'Aquarius'],
  [-572787422,-572594854,'Pisces'],
  [-572594854,-572395963,'Aries'],
  [-572395963,-572190289,'Taurus'],
  [-572190289,-571977156,'Gemini'],
  [-571977156,-571758483,'Cancer'],
  [-571758483,-571541073,'Leo'],
  [-571541073,-571333880,'Virgo'],
  [-571333880,-571141686,'Libra'],
  [-571141686,-570962393,'Scorpio'],
  [-570962393,-570789457,'Sagittarius'],
  [-570789457,-570615324,'Capricorn'],
  [-570615324,-570433936,'Aquarius'],
  [-570433936,-570242531,'Pisces'],
  [-570242531,-570041744,'Aries'],
  [-570041744,-569833568,'Taurus'],
  [-569833568,-569619471,'Gemini'],
  [-569619471,-569400931,'Cancer'],
  [-569400931,-569182080,'Leo'],
  [-569182080,-568970367,'Virgo'],
  [-568970367,-568772486,'Libra'],
  [-568772486,-568589583,'Scorpio'],
  [-568589583,-568416957,'Sagittarius'],
  [-568416957,-568247053,'Capricorn'],
  [-568247053,-568072202,'Aquarius'],
  [-568072202,-567886705,'Pisces'],
  [-567886705,-567688615,'Aries'],
  [-567688615,-567479872,'Taurus'],
  [-567479872,-567264357,'Gemini'],
  [-567264357,-567045663,'Cancer'],
  [-567045663,-566827188,'Leo'],
  [-566827188,-566613647,'Virgo'],
  [-566613647,-566410551,'Libra'],
  [-566410551,-566221074,'Scorpio'],
  [-566221074,-566043669,'Sagittarius'],
  [-566043669,-565872822,'Capricorn'],
  [-565872822,-565701290,'Aquarius'],
  [-565701290,-565522048,'Pisces'],
  [-565522048,-565330164,'Aries'],
  [-565330164,-565124709,'Taurus'],
  [-565124709,-564909365,'Gemini'],
  [-564909365,-564690248,'Cancer'],
  [-564690248,-564472699,'Leo'],
  [-564472699,-564260399,'Virgo'],
  [-564260399,-564056107,'Libra'],
  [-564056107,-563861857,'Scorpio'],
  [-563861857,-563677832,'Sagittarius'],
  [-563677832,-563501502,'Capricorn'],
  [-563501502,-563327942,'Aquarius'],
  [-563327942,-563150909,'Pisces'],
  [-563150909,-562964303,'Aries'],
  [-562964303,-562764239,'Taurus'],
  [-562764239,-562551583,'Gemini'],
  [-562551583,-562332600,'Cancer'],
  [-562332600,-562115317,'Leo'],
  [-562115317,-561905027,'Virgo'],
  [-561905027,-561703175,'Libra'],
  [-561703175,-561509092,'Scorpio'],
  [-561509092,-561321655,'Sagittarius'],
  [-561321655,-561139516,'Capricorn'],
  [-561139516,-560960467,'Aquarius'],
  [-560960467,-560780757,'Pisces'],
  [-560780757,-560595284,'Aries'],
  [-560595284,-560399067,'Taurus'],
  [-560399067,-560190078,'Gemini'],
  [-560190078,-559972220,'Cancer'],
  [-559972220,-559754397,'Leo'],
  [-559754397,-559544655,'Virgo'],
  [-559544655,-559345614,'Libra'],
  [-559345614,-559155134,'Scorpio'],
  [-559155134,-558969515,'Sagittarius'],
  [-558969515,-558785818,'Capricorn'],
  [-558785818,-558602388,'Aquarius'],
  [-558602388,-558417823,'Pisces'],
  [-558417823,-558229522,'Aries'],
  [-558229522,-558033590,'Taurus'],
  [-558033590,-557826866,'Gemini'],
  [-557826866,-557610468,'Cancer'],
  [-557610468,-557391760,'Leo'],
  [-557391760,-557180474,'Virgo'],
  [-557180474,-556981869,'Libra'],
  [-556981869,-556794576,'Scorpio'],
  [-556794576,-556613467,'Sagittarius'],
  [-556613467,-556433156,'Capricorn'],
  [-556433156,-556250072,'Aquarius'],
  [-556250072,-556062788,'Pisces'],
  [-556062788,-555870648,'Aries'],
  [-555870648,-555672177,'Taurus'],
  [-555672177,-555465250,'Gemini'],
  [-555465250,-555249646,'Cancer'],
  [-555249646,-555030185,'Leo'],
  [-555030185,-554816059,'Virgo'],
  [-554816059,-554614842,'Libra'],
  [-554614842,-554427562,'Scorpio'],
  [-554427562,-554249631,'Sagittarius'],
  [-554249631,-554074411,'Capricorn'],
  [-554074411,-553895975,'Aquarius'],
  [-553895975,-553710680,'Pisces'],
  [-553710680,-553517371,'Aries'],
  [-553517371,-553316199,'Taurus'],
  [-553316199,-553107373,'Gemini'],
  [-553107373,-552891464,'Cancer'],
  [-552891464,-552671637,'Leo'],
  [-552671637,-552454920,'Virgo'],
  [-552454920,-552249281,'Libra'],
  [-552249281,-552058396,'Scorpio'],
  [-552058396,-551879857,'Sagittarius'],
  [-551879857,-551707542,'Capricorn'],
  [-551707542,-551534458,'Aquarius'],
  [-551534458,-551354647,'Pisces'],
  [-551354647,-551164504,'Aries'],
  [-551164504,-550963355,'Taurus'],
  [-550963355,-550752916,'Gemini'],
  [-550752916,-550536003,'Cancer'],
  [-550536003,-550316136,'Leo'],
  [-550316136,-550098379,'Virgo'],
  [-550098379,-549888948,'Libra'],
  [-549888948,-549692561,'Scorpio'],
  [-549692561,-549509560,'Sagittarius'],
  [-549509560,-549335936,'Capricorn'],
  [-549335936,-549165317,'Aquarius'],
  [-549165317,-548990802,'Pisces'],
  [-548990802,-548806468,'Aries'],
  [-548806468,-548609031,'Taurus'],
  [-548609031,-548399275,'Gemini'],
  [-548399275,-548181683,'Cancer'],
  [-548181683,-547961867,'Leo'],
  [-547961867,-547744713,'Virgo'],
  [-547744713,-547534200,'Libra'],
  [-547534200,-547333611,'Scorpio'],
  [-547333611,-547144577,'Sagittarius'],
  [-547144577,-546965835,'Capricorn'],
  [-546965835,-546793214,'Aquarius'],
  [-546793214,-546620578,'Pisces'],
  [-546620578,-546441140,'Aries'],
  [-546441140,-546249246,'Taurus'],
  [-546249246,-546042972,'Gemini'],
  [-546042972,-545826111,'Cancer'],
  [-545826111,-545606313,'Leo'],
  [-545606313,-545390323,'Virgo'],
  [-545390323,-545181414,'Libra'],
  [-545181414,-544980430,'Scorpio'],
  [-544980430,-544787642,'Sagittarius'],
  [-544787642,-544602945,'Capricorn'],
  [-544602945,-544424847,'Aquarius'],
  [-544424847,-544249571,'Pisces'],
  [-544249571,-544071279,'Aries'],
  [-544071279,-543883514,'Taurus'],
  [-543883514,-543681851,'Gemini'],
  [-543681851,-543467403,'Cancer'],
  [-543467403,-543247761,'Leo'],
  [-543247761,-543032141,'Virgo'],
  [-543032141,-542825404,'Libra'],
  [-542825404,-542627285,'Scorpio'],
  [-542627285,-542435495,'Sagittarius'],
  [-542435495,-542248331,'Capricorn'],
  [-542248331,-542065036,'Aquarius'],
  [-542065036,-541884334,'Pisces'],
  [-541884334,-541702903,'Aries'],
  [-541702903,-541515486,'Taurus'],
  [-541515486,-541316865,'Gemini'],
  [-541316865,-541105431,'Cancer'],
  [-541105431,-540886385,'Leo'],
  [-540886385,-540669775,'Virgo'],
  [-540669775,-540463293,'Libra'],
  [-540463293,-540268012,'Scorpio'],
  [-540268012,-540080396,'Sagittarius'],
  [-540080396,-539896104,'Capricorn'],
  [-539896104,-539712315,'Aquarius'],
  [-539712315,-539527851,'Pisces'],
  [-539527851,-539341554,'Aries'],
  [-539341554,-539150818,'Taurus'],
  [-539150818,-538951890,'Gemini'],
  [-538951890,-538742244,'Cancer'],
  [-538742244,-538524161,'Leo'],
  [-538524161,-538305892,'Virgo'],
  [-538305892,-538096877,'Libra'],
  [-538096877,-537901214,'Scorpio'],
  [-537901214,-537716575,'Sagittarius'],
  [-537716575,-537537482,'Capricorn'],
  [-537537482,-537358473,'Aquarius'],
  [-537358473,-537175805,'Pisces'],
  [-537175805,-536987659,'Aries'],
  [-536987659,-536793127,'Taurus'],
  [-536793127,-536591206,'Gemini'],
  [-536591206,-536380982,'Cancer'],
  [-536380982,-536163554,'Leo'],
  [-536163554,-535944214,'Virgo'],
  [-535944214,-535731369,'Libra'],
  [-535731369,-535531554,'Scorpio'],
  [-535531554,-535345502,'Sagittarius'],
  [-535345502,-535168966,'Capricorn'],
  [-535168966,-534995584,'Aquarius'],
  [-534995584,-534819098,'Pisces'],
  [-534819098,-534634783,'Aries'],
  [-534634783,-534440346,'Taurus'],
  [-534440346,-534236010,'Gemini'],
  [-534236010,-534023648,'Cancer'],
  [-534023648,-533805887,'Leo'],
  [-533805887,-533586525,'Virgo'],
  [-533586525,-533371163,'Libra'],
  [-533371163,-533165993,'Scorpio'],
  [-533165993,-532974476,'Sagittarius'],
  [-532974476,-532795396,'Capricorn'],
  [-532795396,-532623721,'Aquarius'],
  [-532623721,-532452571,'Pisces'],
  [-532452571,-532274968,'Aries'],
  [-532274968,-532085587,'Taurus'],
  [-532085587,-531882752,'Gemini'],
  [-531882752,-531669287,'Cancer'],
  [-531669287,-531450547,'Leo'],
  [-531450547,-531231554,'Virgo'],
  [-531231554,-531016155,'Libra'],
  [-531016155,-530808012,'Scorpio'],
  [-530808012,-530610599,'Sagittarius'],
  [-530610599,-530425352,'Capricorn'],
  [-530425352,-530250193,'Aquarius'],
  [-530250193,-530079685,'Pisces'],
  [-530079685,-529906541,'Aries'],
  [-529906541,-529723499,'Taurus'],
  [-529723499,-529525850,'Gemini'],
  [-529525850,-529314356,'Cancer'],
  [-529314356,-529095375,'Leo'],
  [-529095375,-528876519,'Virgo'],
  [-528876519,-528662447,'Libra'],
  [-528662447,-528454897,'Scorpio'],
  [-528454897,-528255067,'Sagittarius'],
  [-528255067,-528064362,'Capricorn'],
  [-528064362,-527883038,'Aquarius'],
  [-527883038,-527708457,'Pisces'],
  [-527708457,-527534926,'Aries'],
  [-527534926,-527355197,'Taurus'],
  [-527355197,-527162831,'Gemini'],
  [-527162831,-526955590,'Cancer'],
  [-526955590,-526738047,'Leo'],
  [-526738047,-526519190,'Virgo'],
  [-526519190,-526306091,'Libra'],
  [-526306091,-526100867,'Scorpio'],
  [-526100867,-525902720,'Sagittarius'],
  [-525902720,-525710858,'Capricorn'],
  [-525710858,-525525222,'Aquarius'],
  [-525525222,-525345062,'Pisces'],
  [-525345062,-525167281,'Aries'],
  [-525167281,-524986406,'Taurus'],
  [-524986406,-524796237,'Gemini'],
  [-524796237,-524592789,'Cancer'],
  [-524592789,-524377756,'Leo'],
  [-524377756,-524159049,'Virgo'],
  [-524159049,-523945668,'Libra'],
  [-523945668,-523741916,'Scorpio'],
  [-523741916,-523546995,'Sagittarius'],
  [-523546995,-523358096,'Capricorn'],
  [-523358096,-523172888,'Aquarius'],
  [-523172888,-522989932,'Pisces'],
  [-522989932,-522807536,'Aries'],
  [-522807536,-522622638,'Taurus'],
  [-522622638,-522430969,'Gemini'],
  [-522430969,-522228784,'Cancer'],
  [-522228784,-522015815,'Leo'],
  [-522015815,-521797426,'Virgo'],
  [-521797426,-521582556,'Libra'],
  [-521582556,-521377939,'Scorpio'],
  [-521377939,-521184680,'Sagittarius'],
  [-521184680,-520999719,'Capricorn'],
  [-520999719,-520818696,'Aquarius'],
  [-520818696,-520637790,'Pisces'],
  [-520637790,-520454219,'Aries'],
  [-520454219,-520265866,'Taurus'],
  [-520265866,-520070758,'Gemini'],
  [-520070758,-519867139,'Cancer'],
  [-519867139,-519654702,'Leo'],
  [-519654702,-519436592,'Virgo'],
  [-519436592,-519219796,'Libra'],
  [-519219796,-519012056,'Scorpio'],
  [-519012056,-518817209,'Sagittarius'],
  [-518817209,-518633837,'Capricorn'],
  [-518633837,-518457194,'Aquarius'],
  [-518457194,-518281467,'Pisces'],
  [-518281467,-518101400,'Aries'],
  [-518101400,-517913388,'Taurus'],
  [-517913388,-517716037,'Gemini'],
  [-517716037,-517509858,'Cancer'],
  [-517509858,-517296410,'Leo'],
  [-517296410,-517078318,'Virgo'],
  [-517078318,-516860201,'Libra'],
  [-516860201,-516648608,'Scorpio'],
  [-516648608,-516449228,'Sagittarius'],
  [-516449228,-516263482,'Capricorn'],
  [-516263482,-516088095,'Aquarius'],
  [-516088095,-515916841,'Pisces'],
  [-515916841,-515742603,'Aries'],
  [-515742603,-515559216,'Taurus'],
  [-515559216,-515363427,'Gemini'],
  [-515363427,-515156130,'Cancer'],
  [-515156130,-514941180,'Leo'],
  [-514941180,-514722767,'Virgo'],
  [-514722767,-514504485,'Libra'],
  [-514504485,-514290497,'Scorpio'],
  [-514290497,-514085965,'Sagittarius'],
  [-514085965,-513894610,'Capricorn'],
  [-513894610,-513716016,'Aquarius'],
  [-513716016,-513545377,'Pisces'],
  [-513545377,-513375309,'Aries'],
  [-513375309,-513197977,'Taurus'],
  [-513197977,-513007428,'Gemini'],
  [-513007428,-512802409,'Cancer'],
  [-512802409,-512587190,'Leo'],
  [-512587190,-512368327,'Virgo'],
  [-512368327,-512150645,'Libra'],
  [-512150645,-511936842,'Scorpio'],
  [-511936842,-511729716,'Sagittarius'],
  [-511729716,-511532748,'Capricorn'],
  [-511532748,-511347891,'Aquarius'],
  [-511347891,-511173183,'Pisces'],
  [-511173183,-511002800,'Aries'],
  [-511002800,-510828959,'Taurus'],
  [-510828959,-510644189,'Gemini'],
  [-510644189,-510444315,'Cancer'],
  [-510444315,-510231344,'Leo'],
  [-510231344,-510012552,'Virgo'],
  [-510012552,-509795301,'Libra'],
  [-509795301,-509583213,'Scorpio'],
  [-509583213,-509377291,'Sagittarius'],
  [-509377291,-509178564,'Capricorn'],
  [-509178564,-508988579,'Aquarius'],
  [-508988579,-508807495,'Pisces'],
  [-508807495,-508632303,'Aries'],
  [-508632303,-508457122,'Taurus'],
  [-508457122,-508274914,'Gemini'],
  [-508274914,-508079975,'Cancer'],
  [-508079975,-507871155,'Leo'],
  [-507871155,-507653662,'Virgo'],
  [-507653662,-507436189,'Libra'],
  [-507436189,-507225088,'Scorpio'],
  [-507225088,-507022030,'Sagittarius'],
  [-507022030,-506826054,'Capricorn'],
  [-506826054,-506636037,'Aquarius'],
  [-506636037,-506451247,'Pisces'],
  [-506451247,-506270265,'Aries'],
  [-506270265,-506089961,'Taurus'],
  [-506089961,-505905616,'Gemini'],
  [-505905616,-505712242,'Cancer'],
  [-505712242,-505506970,'Leo'],
  [-505506970,-505291754,'Virgo'],
  [-505291754,-505073825,'Libra'],
  [-505073825,-504861638,'Scorpio'],
  [-504861638,-504659674,'Sagittarius'],
  [-504659674,-504467458,'Capricorn'],
  [-504467458,-504281823,'Aquarius'],
  [-504281823,-504099186,'Pisces'],
  [-504099186,-503916619,'Aries'],
  [-503916619,-503731854,'Taurus'],
  [-503731854,-503542756,'Gemini'],
  [-503542756,-503346958,'Cancer'],
  [-503346958,-503142379,'Leo'],
  [-503142379,-502929009,'Virgo'],
  [-502929009,-502710999,'Libra'],
  [-502710999,-502496257,'Scorpio'],
  [-502496257,-502292010,'Sagittarius'],
  [-502292010,-502100528,'Capricorn'],
  [-502100528,-501919004,'Aquarius'],
  [-501919004,-501741943,'Pisces'],
  [-501741943,-501563576,'Aries'],
  [-501563576,-501379549,'Taurus'],
  [-501379549,-501187809,'Gemini'],
  [-501187809,-500988290,'Cancer'],
  [-500988290,-500781591,'Leo'],
  [-500781591,-500568359,'Virgo'],
  [-500568359,-500350602,'Libra'],
  [-500350602,-500133596,'Scorpio'],
  [-500133596,-499924941,'Sagittarius'],
  [-499924941,-499729978,'Capricorn'],
  [-499729978,-499548455,'Aquarius'],
  [-499548455,-499375195,'Pisces'],
  [-499375195,-499202858,'Aries'],
  [-499202858,-499024436,'Taurus'],
  [-499024436,-498835359,'Gemini'],
  [-498835359,-498635000,'Cancer'],
  [-498635000,-498425942,'Leo'],
  [-498425942,-498211355,'Virgo'],
  [-498211355,-497993638,'Libra'],
  [-497993638,-497775842,'Scorpio'],
  [-497775842,-497563505,'Sagittarius'],
  [-497563505,-497362951,'Capricorn'],
  [-497362951,-497176998,'Aquarius'],
  [-497176998,-497002794,'Pisces'],
  [-497002794,-496833440,'Aries'],
  [-496833440,-496660806,'Taurus'],
  [-496660806,-496477887,'Gemini'],
  [-496477887,-496281275,'Cancer'],
  [-496281275,-496072643,'Leo'],
  [-496072643,-495856949,'Virgo'],
  [-495856949,-495638873,'Libra'],
  [-495638873,-495421501,'Scorpio'],
  [-495421501,-495208134,'Sagittarius'],
  [-495208134,-495003476,'Capricorn'],
  [-495003476,-494811524,'Aquarius'],
  [-494811524,-494632285,'Pisces'],
  [-494632285,-494461052,'Aries'],
  [-494461052,-494290406,'Taurus'],
  [-494290406,-494112595,'Gemini'],
  [-494112595,-493921873,'Cancer'],
  [-493921873,-493717048,'Leo'],
  [-493717048,-493502206,'Virgo'],
  [-493502206,-493283893,'Libra'],
  [-493283893,-493067202,'Scorpio'],
  [-493067202,-492855063,'Sagittarius'],
  [-492855063,-492649908,'Capricorn'],
  [-492649908,-492454290,'Aquarius'],
  [-492454290,-492269298,'Pisces'],
  [-492269298,-492092796,'Aries'],
  [-492092796,-491919567,'Taurus'],
  [-491919567,-491742863,'Gemini'],
  [-491742863,-491556345,'Cancer'],
  [-491556345,-491356431,'Leo'],
  [-491356431,-491144470,'Virgo'],
  [-491144470,-490926629,'Libra'],
  [-490926629,-490710170,'Scorpio'],
  [-490710170,-490499694,'Sagittarius'],
  [-490499694,-490296842,'Capricorn'],
  [-490296842,-490101797,'Aquarius'],
  [-490101797,-489914186,'Pisces'],
  [-489914186,-489732666,'Aries'],
  [-489732666,-489554313,'Taurus'],
  [-489554313,-489374679,'Gemini'],
  [-489374679,-489188617,'Cancer'],
  [-489188617,-488991853,'Leo'],
  [-488991853,-488783227,'Virgo'],
  [-488783227,-488566581,'Libra'],
  [-488566581,-488349683,'Scorpio'],
  [-488349683,-488139603,'Sagittarius'],
  [-488139603,-487939253,'Capricorn'],
  [-487939253,-487747642,'Aquarius'],
  [-487747642,-487561963,'Pisces'],
  [-487561963,-487379261,'Aries'],
  [-487379261,-487196987,'Taurus'],
  [-487196987,-487012743,'Gemini'],
  [-487012743,-486823781,'Cancer'],
  [-486823781,-486627029,'Leo'],
  [-486627029,-486420368,'Virgo'],
  [-486420368,-486205049,'Libra'],
  [-486205049,-485987261,'Scorpio'],
  [-485987261,-485775591,'Sagittarius'],
  [-485775591,-485575547,'Capricorn'],
  [-485575547,-485386993,'Aquarius'],
  [-485386993,-485205751,'Pisces'],
  [-485205751,-485026444,'Aries'],
  [-485026444,-484844633,'Taurus'],
  [-484844633,-484657816,'Gemini'],
  [-484657816,-484465082,'Cancer'],
  [-484465082,-484265788,'Leo'],
  [-484265788,-484058879,'Virgo'],
  [-484058879,-483844289,'Libra'],
  [-483844289,-483625673,'Scorpio'],
  [-483625673,-483411007,'Sagittarius'],
  [-483411007,-483208147,'Capricorn'],
  [-483208147,-483019504,'Aquarius'],
  [-483019504,-482841472,'Pisces'],
  [-482841472,-482667349,'Aries'],
  [-482667349,-482490324,'Taurus'],
  [-482490324,-482305633,'Gemini'],
  [-482305633,-482111780,'Cancer'],
  [-482111780,-481909767,'Leo'],
  [-481909767,-481700946,'Virgo'],
  [-481700946,-481486085,'Libra'],
  [-481486085,-481267136,'Scorpio'],
  [-481267136,-481049751,'Sagittarius'],
  [-481049751,-480842085,'Capricorn'],
  [-480842085,-480649395,'Aquarius'],
  [-480649395,-480470510,'Pisces'],
  [-480470510,-480299280,'Aries'],
  [-480299280,-480127820,'Taurus'],
  [-480127820,-479949030,'Gemini'],
  [-479949030,-479758741,'Cancer'],
  [-479758741,-479556935,'Leo'],
  [-479556935,-479346481,'Virgo'],
  [-479346481,-479130567,'Libra'],
  [-479130567,-478911690,'Scorpio'],
  [-478911690,-478693437,'Sagittarius'],
  [-478693437,-478481884,'Capricorn'],
  [-478481884,-478283140,'Aquarius'],
  [-478283140,-478099046,'Pisces'],
  [-478099046,-477925881,'Aries'],
  [-477925881,-477756562,'Taurus'],
  [-477756562,-477583251,'Gemini'],
  [-477583251,-477399436,'Cancer'],
  [-477399436,-477202064,'Leo'],
  [-477202064,-476992670,'Virgo'],
  [-476992670,-476776028,'Libra'],
  [-476776028,-476557128,'Scorpio'],
  [-476557128,-476339767,'Sagittarius'],
  [-476339767,-476127656,'Capricorn'],
  [-476127656,-475924910,'Aquarius'],
  [-475924910,-475734302,'Pisces'],
  [-475734302,-475555038,'Aries'],
  [-475555038,-475382622,'Taurus'],
  [-475382622,-475210434,'Gemini'],
  [-475210434,-475031505,'Cancer'],
  [-475031505,-474840379,'Leo'],
  [-474840379,-474635336,'Virgo'],
  [-474635336,-474419805,'Libra'],
  [-474419805,-474200715,'Scorpio'],
  [-474200715,-473984381,'Sagittarius'],
  [-473984381,-473774380,'Capricorn'],
  [-473774380,-473572243,'Aquarius'],
  [-473572243,-473378645,'Pisces'],
  [-473378645,-473193365,'Aries'],
  [-473193365,-473014550,'Taurus'],
  [-473014550,-472838390,'Gemini'],
  [-472838390,-472659539,'Cancer'],
  [-472659539,-472472244,'Leo'],
  [-472472244,-472272318,'Virgo'],
  [-472272318,-472059931,'Libra'],
  [-472059931,-471841123,'Scorpio'],
  [-471841123,-471624653,'Sagittarius'],
  [-471624653,-471416494,'Capricorn'],
  [-471416494,-471217743,'Aquarius'],
  [-471217743,-471026431,'Pisces'],
  [-471026431,-470840048,'Aries'],
  [-470840048,-470656661,'Taurus'],
  [-470656661,-470474626,'Gemini'],
  [-470474626,-470291502,'Cancer'],
  [-470291502,-470103432,'Leo'],
  [-470103432,-469906014,'Virgo'],
  [-469906014,-469696907,'Libra'],
  [-469696907,-469479178,'Scorpio'],
  [-469479178,-469261539,'Sagittarius'],
  [-469261539,-469052819,'Capricorn'],
  [-469052819,-468856240,'Aquarius'],
  [-468856240,-468669240,'Pisces'],
  [-468669240,-468486825,'Aries'],
  [-468486825,-468304572,'Taurus'],
  [-468304572,-468120026,'Gemini'],
  [-468120026,-467932289,'Cancer'],
  [-467932289,-467740281,'Leo'],
  [-467740281,-467541622,'Virgo'],
  [-467541622,-467333758,'Libra'],
  [-467333758,-467117213,'Scorpio'],
  [-467117213,-466898323,'Sagittarius'],
  [-466898323,-466686805,'Capricorn'],
  [-466686805,-466488902,'Aquarius'],
  [-466488902,-466303854,'Pisces'],
  [-466303854,-466126123,'Aries'],
  [-466126123,-465949104,'Taurus'],
  [-465949104,-465767703,'Gemini'],
  [-465767703,-465579574,'Cancer'],
  [-465579574,-465384556,'Leo'],
  [-465384556,-465182793,'Virgo'],
  [-465182793,-464973731,'Libra'],
  [-464973731,-464757520,'Scorpio'],
  [-464757520,-464537978,'Sagittarius'],
  [-464537978,-464323217,'Capricorn'],
  [-464323217,-464121108,'Aquarius'],
  [-464121108,-463933838,'Pisces'],
  [-463933838,-463757442,'Aries'],
  [-463757442,-463584980,'Taurus'],
  [-463584980,-463409485,'Gemini'],
  [-463409485,-463225895,'Cancer'],
  [-463225895,-463032153,'Leo'],
  [-463032153,-462828855,'Virgo'],
  [-462828855,-462617780,'Libra'],
  [-462617780,-462400888,'Scorpio'],
  [-462400888,-462181286,'Sagittarius'],
  [-462181286,-461964666,'Capricorn'],
  [-461964666,-461758018,'Aquarius'],
  [-461758018,-461565562,'Pisces'],
  [-461565562,-461386102,'Aries'],
  [-461386102,-461214216,'Taurus'],
  [-461214216,-461042839,'Gemini'],
  [-461042839,-460865253,'Cancer'],
  [-460865253,-460676663,'Leo'],
  [-460676663,-460475545,'Virgo'],
  [-460475545,-460263973,'Libra'],
  [-460263973,-460046193,'Scorpio'],
  [-460046193,-459826755,'Sagittarius'],
  [-459826755,-459610225,'Capricorn'],
  [-459610225,-459401286,'Aquarius'],
  [-459401286,-459203772,'Pisces'],
  [-459203772,-459018610,'Aries'],
  [-459018610,-458843014,'Taurus'],
  [-458843014,-458671504,'Gemini'],
  [-458671504,-458497431,'Cancer'],
  [-458497431,-458314444,'Leo'],
  [-458314444,-458118291,'Virgo'],
  [-458118291,-457908933,'Libra'],
  [-457908933,-457691163,'Scorpio'],
  [-457691163,-457471846,'Sagittarius'],
  [-457471846,-457256515,'Capricorn'],
  [-457256515,-457048299,'Aquarius'],
  [-457048299,-456848820,'Pisces'],
  [-456848820,-456658793,'Aries'],
  [-456658793,-456477424,'Taurus'],
  [-456477424,-456301819,'Gemini'],
  [-456301819,-456127018,'Cancer'],
  [-456127018,-455946829,'Leo'],
  [-455946829,-455755443,'Virgo'],
  [-455755443,-455550089,'Libra'],
  [-455550089,-455333768,'Scorpio'],
  [-455333768,-455114492,'Sagittarius'],
  [-455114492,-454900098,'Capricorn'],
  [-454900098,-454694166,'Aquarius'],
  [-454694166,-454496432,'Pisces'],
  [-454496432,-454305427,'Aries'],
  [-454305427,-454119997,'Taurus'],
  [-454119997,-453938981,'Gemini'],
  [-453938981,-453759965,'Cancer'],
  [-453759965,-453578564,'Leo'],
  [-453578564,-453389181,'Virgo'],
  [-453389181,-453187373,'Libra'],
  [-453187373,-452973410,'Scorpio'],
  [-452973410,-452754210,'Sagittarius'],
  [-452754210,-452539489,'Capricorn'],
  [-452539489,-452335032,'Aquarius'],
  [-452335032,-452140577,'Pisces'],
  [-452140577,-451952618,'Aries'],
  [-451952618,-451767713,'Taurus'],
  [-451767713,-451583949,'Gemini'],
  [-451583949,-451400289,'Cancer'],
  [-451400289,-451214822,'Leo'],
  [-451214822,-451023900,'Virgo'],
  [-451023900,-450823295,'Libra'],
  [-450823295,-450611336,'Scorpio'],
  [-450611336,-450392360,'Sagittarius'],
  [-450392360,-450175957,'Capricorn'],
  [-450175957,-449970449,'Aquarius'],
  [-449970449,-449777610,'Pisces'],
  [-449777610,-449593709,'Aries'],
  [-449593709,-449413263,'Taurus'],
  [-449413263,-449231842,'Gemini'],
  [-449231842,-449047127,'Cancer'],
  [-449047127,-448858132,'Leo'],
  [-448858132,-448663598,'Virgo'],
  [-448663598,-448461403,'Libra'],
  [-448461403,-448249959,'Scorpio'],
  [-448249959,-448031314,'Sagittarius'],
  [-448031314,-447812847,'Capricorn'],
  [-447812847,-447603768,'Aquarius'],
  [-447603768,-447408828,'Pisces'],
  [-447408828,-447226215,'Aries'],
  [-447226215,-447050245,'Taurus'],
  [-447050245,-446874541,'Gemini'],
  [-446874541,-446694014,'Cancer'],
  [-446694014,-446505813,'Leo'],
  [-446505813,-446309093,'Virgo'],
  [-446309093,-446104075,'Libra'],
  [-446104075,-445891393,'Scorpio'],
  [-445891393,-445672867,'Sagittarius'],
  [-445672867,-445453296,'Capricorn'],
  [-445453296,-445240180,'Aquarius'],
  [-445240180,-445039952,'Pisces'],
  [-445039952,-444853984,'Aries'],
  [-444853984,-444678537,'Taurus'],
  [-444678537,-444507220,'Gemini'],
  [-444507220,-444333171,'Cancer'],
  [-444333171,-444150622,'Leo'],
  [-444150622,-443956319,'Virgo'],
  [-443956319,-443750435,'Libra'],
  [-443750435,-443535987,'Scorpio'],
  [-443535987,-443317001,'Sagittarius'],
  [-443317001,-443097650,'Capricorn'],
  [-443097650,-442882687,'Aquarius'],
  [-442882687,-442677277,'Pisces'],
  [-442677277,-442484815,'Aries'],
  [-442484815,-442304811,'Taurus'],
  [-442304811,-442132962,'Gemini'],
  [-442132962,-441962642,'Cancer'],
  [-441962642,-441786566,'Leo'],
  [-441786566,-441598567,'Virgo'],
  [-441598567,-441396016,'Libra'],
  [-441396016,-441181649,'Scorpio'],
  [-441181649,-440961987,'Sagittarius'],
  [-440961987,-440743239,'Capricorn'],
  [-440743239,-440529172,'Aquarius'],
  [-440529172,-440322176,'Pisces'],
  [-440322176,-440124541,'Aries'],
  [-440124541,-439937661,'Taurus'],
  [-439937661,-439760413,'Gemini'],
  [-439760413,-439588431,'Cancer'],
  [-439588431,-439414972,'Leo'],
  [-439414972,-439232666,'Virgo'],
  [-439232666,-439036021,'Libra'],
  [-439036021,-438824831,'Scorpio'],
  [-438824831,-438605503,'Sagittarius'],
  [-438605503,-438386884,'Capricorn'],
  [-438386884,-438174501,'Aquarius'],
  [-438174501,-437969511,'Pisces'],
  [-437969511,-437771499,'Aries'],
  [-437771499,-437580578,'Taurus'],
  [-437580578,-437397016,'Gemini'],
  [-437397016,-437219373,'Cancer'],
  [-437219373,-437043317,'Leo'],
  [-437043317,-436862381,'Virgo'],
  [-436862381,-436670112,'Libra'],
  [-436670112,-436463443,'Scorpio'],
  [-436463443,-436246054,'Sagittarius'],
  [-436246054,-436027249,'Capricorn'],
  [-436027249,-435815317,'Aquarius'],
  [-435815317,-435612840,'Pisces'],
  [-435612840,-435418078,'Aries'],
  [-435418078,-435228514,'Taurus'],
  [-435228514,-435042774,'Gemini'],
  [-435042774,-434860154,'Cancer'],
  [-434860154,-434678821,'Leo'],
  [-434678821,-434494815,'Virgo'],
  [-434494815,-434302895,'Libra'],
  [-434302895,-434099073,'Scorpio'],
  [-434099073,-433884154,'Sagittarius'],
  [-433884154,-433665340,'Capricorn'],
  [-433665340,-433452173,'Aquarius'],
  [-433452173,-433250009,'Pisces'],
  [-433250009,-433058214,'Aries'],
  [-433058214,-432872969,'Taurus'],
  [-432872969,-432690324,'Gemini'],
  [-432690324,-432507586,'Cancer'],
  [-432507586,-432322998,'Leo'],
  [-432322998,-432134621,'Virgo'],
  [-432134621,-431939747,'Libra'],
  [-431939747,-431735695,'Scorpio'],
  [-431735695,-431522153,'Sagittarius'],
  [-431522153,-431303556,'Capricorn'],
  [-431303556,-431088278,'Aquarius'],
  [-431088278,-430883676,'Pisces'],
  [-430883676,-430691758,'Aries'],
  [-430691758,-430509576,'Taurus'],
  [-430509576,-430331953,'Gemini'],
  [-430331953,-430153698,'Cancer'],
  [-430153698,-429970814,'Leo'],
  [-429970814,-429780874,'Virgo'],
  [-429780874,-429582809,'Libra'],
  [-429582809,-429376435,'Scorpio'],
  [-429376435,-429162541,'Sagittarius'],
  [-429162541,-428944103,'Capricorn'],
  [-428944103,-428727035,'Aquarius'],
  [-428727035,-428518533,'Pisces'],
  [-428518533,-428323096,'Aries'],
  [-428323096,-428140232,'Taurus'],
  [-428140232,-427965479,'Gemini'],
  [-427965479,-427792520,'Cancer'],
  [-427792520,-427615006,'Leo'],
  [-427615006,-427428097,'Virgo'],
  [-427428097,-427229833,'Libra'],
  [-427229833,-427021487,'Scorpio'],
  [-427021487,-426806223,'Sagittarius'],
  [-426806223,-426587669,'Capricorn'],
  [-426587669,-426369945,'Aquarius'],
  [-426369945,-426158234,'Pisces'],
  [-426158234,-425957671,'Aries'],
  [-425957671,-425770452,'Taurus'],
  [-425770452,-425594415,'Gemini'],
  [-425594415,-425423879,'Cancer'],
  [-425423879,-425251537,'Leo'],
  [-425251537,-425070356,'Virgo'],
  [-425070356,-424875819,'Libra'],
  [-424875819,-424668138,'Scorpio'],
  [-424668138,-424451973,'Sagittarius'],
  [-424451973,-424233107,'Capricorn'],
  [-424233107,-424015798,'Aquarius'],
  [-424015798,-423803186,'Pisces'],
  [-423803186,-423598795,'Aries'],
  [-423598795,-423405841,'Taurus'],
  [-423405841,-423224865,'Gemini'],
  [-423224865,-423052395,'Cancer'],
  [-423052395,-422881825,'Leo'],
  [-422881825,-422705376,'Virgo'],
  [-422705376,-422516393,'Libra'],
  [-422516393,-422312412,'Scorpio'],
  [-422312412,-422097159,'Sagittarius'],
  [-422097159,-421878149,'Capricorn'],
  [-421878149,-421661575,'Aquarius'],
  [-421661575,-421450226,'Pisces'],
  [-421450226,-421245399,'Aries'],
  [-421245399,-421048848,'Taurus'],
  [-421048848,-420862126,'Gemini'],
  [-420862126,-420684365,'Cancer'],
  [-420684365,-420511185,'Leo'],
  [-420511185,-420335746,'Virgo'],
  [-420335746,-420150811,'Libra'],
  [-420150811,-419951645,'Scorpio'],
  [-419951645,-419739266,'Sagittarius'],
  [-419739266,-419520733,'Capricorn'],
  [-419520733,-419304389,'Aquarius'],
  [-419304389,-419094748,'Pisces'],
  [-419094748,-418892341,'Aries'],
  [-418892341,-418696519,'Taurus'],
  [-418696519,-418507217,'Gemini'],
  [-418507217,-418324287,'Cancer'],
  [-418324287,-418145747,'Leo'],
  [-418145747,-417967135,'Virgo'],
  [-417967135,-417782475,'Libra'],
  [-417782475,-417586452,'Scorpio'],
  [-417586452,-417377534,'Sagittarius'],
  [-417377534,-417160253,'Capricorn'],
  [-417160253,-416943322,'Aquarius'],
  [-416943322,-416733880,'Pisces'],
  [-416733880,-416533972,'Aries'],
  [-416533972,-416341899,'Taurus'],
  [-416341899,-416155009,'Gemini'],
  [-416155009,-415971183,'Cancer'],
  [-415971183,-415788640,'Leo'],
  [-415788640,-415605021,'Virgo'],
  [-415605021,-415416946,'Libra'],
  [-415416946,-415220633,'Scorpio'],
  [-415220633,-415013764,'Sagittarius'],
  [-415013764,-414798043,'Capricorn'],
  [-414798043,-414580159,'Aquarius'],
  [-414580159,-414368624,'Pisces'],
  [-414368624,-414168460,'Aries'],
  [-414168460,-413979311,'Taurus'],
  [-413979311,-413797359,'Gemini'],
  [-413797359,-413617805,'Cancer'],
  [-413617805,-413436485,'Leo'],
  [-413436485,-413250547,'Virgo'],
  [-413250547,-413058349,'Libra'],
  [-413058349,-412858877,'Scorpio'],
  [-412858877,-412651443,'Sagittarius'],
  [-412651443,-412436637,'Capricorn'],
  [-412436637,-412218204,'Aquarius'],
  [-412218204,-412003391,'Pisces'],
  [-412003391,-411799478,'Aries'],
  [-411799478,-411609242,'Taurus'],
  [-411609242,-411430093,'Gemini'],
  [-411430093,-411256140,'Cancer'],
  [-411256140,-411080663,'Leo'],
  [-411080663,-410898073,'Virgo'],
  [-410898073,-410705487,'Libra'],
  [-410705487,-410503219,'Scorpio'],
  [-410503219,-410293389,'Sagittarius'],
  [-410293389,-410078126,'Capricorn'],
  [-410078126,-409859746,'Aquarius'],
  [-409859746,-409642651,'Pisces'],
  [-409642651,-409433616,'Aries'],
  [-409433616,-409238179,'Taurus'],
  [-409238179,-409056870,'Gemini'],
  [-409056870,-408884982,'Cancer'],
  [-408884982,-408714999,'Leo'],
  [-408714999,-408539110,'Virgo'],
  [-408539110,-408351460,'Libra'],
  [-408351460,-408150488,'Scorpio'],
  [-408150488,-407939277,'Sagittarius'],
  [-407939277,-407722687,'Capricorn'],
  [-407722687,-407504379,'Aquarius'],
  [-407504379,-407287091,'Pisces'],
  [-407287091,-407074983,'Aries'],
  [-407074983,-406873530,'Taurus'],
  [-406873530,-406686074,'Gemini'],
  [-406686074,-406510903,'Cancer'],
  [-406510903,-406341803,'Leo'],
  [-406341803,-406170629,'Virgo'],
  [-406170629,-405989661,'Libra'],
  [-405989661,-405794233,'Scorpio'],
  [-405794233,-405585203,'Sagittarius'],
  [-405585203,-405368254,'Capricorn'],
  [-405368254,-405149705,'Aquarius'],
  [-405149705,-404933367,'Pisces'],
  [-404933367,-404721584,'Aries'],
  [-404721584,-404517400,'Taurus'],
  [-404517400,-404324102,'Gemini'],
  [-404324102,-404142499,'Cancer'],
  [-404142499,-403969213,'Leo'],
  [-403969213,-403797688,'Virgo'],
  [-403797688,-403620326,'Libra'],
  [-403620326,-403430784,'Scorpio'],
  [-403430784,-403226760,'Sagittarius'],
  [-403226760,-403011774,'Capricorn'],
  [-403011774,-402793225,'Aquarius'],
  [-402793225,-402577527,'Pisces'],
  [-402577527,-402367743,'Aries'],
  [-402367743,-402164989,'Taurus'],
  [-402164989,-401970163,'Gemini'],
  [-401970163,-401783758,'Cancer'],
  [-401783758,-401604427,'Leo'],
  [-401604427,-401428299,'Virgo'],
  [-401428299,-401249684,'Libra'],
  [-401249684,-401062630,'Scorpio'],
  [-401062630,-400863126,'Sagittarius'],
  [-400863126,-400651595,'Capricorn'],
  [-400651595,-400433830,'Aquarius'],
  [-400433830,-400217902,'Pisces'],
  [-400217902,-400009344,'Aries'],
  [-400009344,-399809596,'Taurus'],
  [-399809596,-399617514,'Gemini'],
  [-399617514,-399431191,'Cancer'],
  [-399431191,-399248606,'Leo'],
  [-399248606,-399067363,'Virgo'],
  [-399067363,-398884310,'Libra'],
  [-398884310,-398695597,'Scorpio'],
  [-398695597,-398497603,'Sagittarius'],
  [-398497603,-398288878,'Capricorn'],
  [-398288878,-398072389,'Aquarius'],
  [-398072389,-397855573,'Pisces'],
  [-397855573,-397646222,'Aries'],
  [-397646222,-397447986,'Taurus'],
  [-397447986,-397259666,'Gemini'],
  [-397259666,-397077295,'Cancer'],
  [-397077295,-396896453,'Leo'],
  [-396896453,-396713669,'Virgo'],
  [-396713669,-396526754,'Libra'],
  [-396526754,-396334245,'Scorpio'],
  [-396334245,-396134626,'Sagittarius'],
  [-396134626,-395926618,'Capricorn'],
  [-395926618,-395711113,'Aquarius'],
  [-395711113,-395493257,'Pisces'],
  [-395493257,-395281316,'Aries'],
  [-395281316,-395081596,'Taurus'],
  [-395081596,-394894760,'Gemini'],
  [-394894760,-394716541,'Cancer'],
  [-394716541,-394540594,'Leo'],
  [-394540594,-394361044,'Virgo'],
  [-394361044,-394174211,'Libra'],
  [-394174211,-393979189,'Scorpio'],
  [-393979189,-393776705,'Sagittarius'],
  [-393776705,-393567432,'Capricorn'],
  [-393567432,-393352068,'Aquarius'],
  [-393352068,-393133539,'Pisces'],
  [-393133539,-392918537,'Aries'],
  [-392918537,-392714772,'Taurus'],
  [-392714772,-392525699,'Gemini'],
  [-392525699,-392348609,'Cancer'],
  [-392348609,-392176840,'Leo'],
  [-392176840,-392002809,'Virgo'],
  [-392002809,-391820372,'Libra'],
  [-391820372,-391626767,'Scorpio'],
  [-391626767,-391423009,'Sagittarius'],
  [-391423009,-391211909,'Capricorn'],
  [-391211909,-390995888,'Aquarius'],
  [-390995888,-390777241,'Pisces'],
  [-390777241,-390560385,'Aries'],
  [-390560385,-390352127,'Taurus'],
  [-390352127,-390157891,'Gemini'],
  [-390157891,-389977738,'Cancer'],
  [-389977738,-389806451,'Leo'],
  [-389806451,-389636319,'Virgo'],
  [-389636319,-389459684,'Libra'],
  [-389459684,-389271174,'Scorpio'],
  [-389271174,-389069679,'Sagittarius'],
  [-389069679,-388858213,'Capricorn'],
  [-388858213,-388641374,'Aquarius'],
  [-388641374,-388422917,'Pisces'],
  [-388422917,-388206174,'Aries'],
  [-388206174,-387995641,'Taurus'],
  [-387995641,-387796228,'Gemini'],
  [-387796228,-387610153,'Cancer'],
  [-387610153,-387434932,'Leo'],
  [-387434932,-387264446,'Virgo'],
  [-387264446,-387091201,'Libra'],
  [-387091201,-386908376,'Scorpio'],
  [-386908376,-386712042,'Sagittarius'],
  [-386712042,-386502965,'Capricorn'],
  [-386502965,-386286164,'Aquarius'],
  [-386286164,-386067790,'Pisces'],
  [-386067790,-385852330,'Aries'],
  [-385852330,-385642756,'Taurus'],
  [-385642756,-385441548,'Gemini'],
  [-385441548,-385250445,'Cancer'],
  [-385250445,-385068990,'Leo'],
  [-385068990,-384893817,'Virgo'],
  [-384893817,-384719357,'Libra'],
  [-384719357,-384539219,'Scorpio'],
  [-384539219,-384347942,'Sagittarius'],
  [-384347942,-384143275,'Capricorn'],
  [-384143275,-383928105,'Aquarius'],
  [-383928105,-383709610,'Pisces'],
  [-383709610,-383494933,'Aries'],
  [-383494933,-383287866,'Taurus'],
  [-383287866,-383088988,'Gemini'],
  [-383088988,-382897439,'Cancer'],
  [-382897439,-382711985,'Leo'],
  [-382711985,-382530891,'Virgo'],
  [-382530891,-382351368,'Libra'],
  [-382351368,-382169310,'Scorpio'],
  [-382169310,-381979850,'Sagittarius'],
  [-381979850,-381779045,'Capricorn'],
  [-381779045,-381566655,'Aquarius'],
  [-381566655,-381348220,'Pisces'],
  [-381348220,-381132734,'Aries'],
  [-381132734,-380926785,'Taurus'],
  [-380926785,-380731453,'Gemini'],
  [-380731453,-380543815,'Cancer'],
  [-380543815,-380359901,'Leo'],
  [-380359901,-380176643,'Virgo'],
  [-380176643,-379992272,'Libra'],
  [-379992272,-379805370,'Scorpio'],
  [-379805370,-379613594,'Sagittarius'],
  [-379613594,-379413684,'Capricorn'],
  [-379413684,-379203546,'Aquarius'],
  [-379203546,-378985648,'Pisces'],
  [-378985648,-378768178,'Aries'],
  [-378768178,-378560322,'Taurus'],
  [-378560322,-378365909,'Gemini'],
  [-378365909,-378182320,'Cancer'],
  [-378182320,-378003667,'Leo'],
  [-378003667,-377824102,'Virgo'],
  [-377824102,-377639873,'Libra'],
  [-377639873,-377449835,'Scorpio'],
  [-377449835,-377254045,'Sagittarius'],
  [-377254045,-377051863,'Capricorn'],
  [-377051863,-376841908,'Aquarius'],
  [-376841908,-376624625,'Pisces'],
  [-376624625,-376405416,'Aries'],
  [-376405416,-376193571,'Taurus'],
  [-376193571,-375995966,'Gemini'],
  [-375995966,-375812553,'Cancer'],
  [-375812553,-375637767,'Leo'],
  [-375637767,-375464211,'Virgo'],
  [-375464211,-375285424,'Libra'],
  [-375285424,-375097720,'Scorpio'],
  [-375097720,-374900699,'Sagittarius'],
  [-374900699,-374695731,'Capricorn'],
  [-374695731,-374484046,'Aquarius'],
  [-374484046,-374266701,'Pisces'],
  [-374266701,-374046925,'Aries'],
  [-374046925,-373831663,'Taurus'],
  [-373831663,-373628588,'Gemini'],
  [-373628588,-373440788,'Cancer'],
  [-373440788,-373265107,'Leo'],
  [-373265107,-373094690,'Virgo'],
  [-373094690,-372921950,'Libra'],
  [-372921950,-372740622,'Scorpio'],
  [-372740622,-372547422,'Sagittarius'],
  [-372547422,-372342731,'Capricorn'],
  [-372342731,-372129528,'Aquarius'],
  [-372129528,-371911389,'Pisces'],
  [-371911389,-371691868,'Aries'],
  [-371691868,-371475633,'Taurus'],
  [-371475633,-371268432,'Gemini'],
  [-371268432,-371074462,'Cancer'],
  [-371074462,-370893539,'Leo'],
  [-370893539,-370721175,'Virgo'],
  [-370721175,-370550619,'Libra'],
  [-370550619,-370374799,'Scorpio'],
  [-370374799,-370187971,'Sagittarius'],
  [-370187971,-369987522,'Capricorn'],
  [-369987522,-369775291,'Aquarius'],
  [-369775291,-369556639,'Pisces'],
  [-369556639,-369337427,'Aries'],
  [-369337427,-369122228,'Taurus'],
  [-369122228,-368914426,'Gemini'],
  [-368914426,-368716580,'Cancer'],
  [-368716580,-368529570,'Leo'],
  [-368529570,-368351613,'Virgo'],
  [-368351613,-368178359,'Libra'],
  [-368178359,-368003805,'Scorpio'],
  [-368003805,-367821567,'Sagittarius'],
  [-367821567,-367626651,'Capricorn'],
  [-367626651,-367417986,'Aquarius'],
  [-367417986,-367200136,'Pisces'],
  [-367200136,-366981021,'Aries'],
  [-366981021,-366767180,'Taurus'],
  [-366767180,-366561430,'Gemini'],
  [-366561430,-366363926,'Cancer'],
  [-366363926,-366174015,'Leo'],
  [-366174015,-365990688,'Virgo'],
  [-365990688,-365812007,'Libra'],
  [-365812007,-365634391,'Scorpio'],
  [-365634391,-365452648,'Sagittarius'],
  [-365452648,-365261197,'Capricorn'],
  [-365261197,-365056588,'Aquarius'],
  [-365056588,-364840776,'Pisces'],
  [-364840776,-364621661,'Aries'],
  [-364621661,-364408146,'Taurus'],
  [-364408146,-364204585,'Gemini'],
  [-364204585,-364010169,'Cancer'],
  [-364010169,-363821881,'Leo'],
  [-363821881,-363637074,'Virgo'],
  [-363637074,-363454175,'Libra'],
  [-363454175,-363271706,'Scorpio'],
  [-363271706,-363086871,'Sagittarius'],
  [-363086871,-362895340,'Capricorn'],
  [-362895340,-362692997,'Aquarius'],
  [-362692997,-362479342,'Pisces'],
  [-362479342,-362260261,'Aries'],
  [-362260261,-362045609,'Taurus'],
  [-362045609,-361842274,'Gemini'],
  [-361842274,-361650554,'Cancer'],
  [-361650554,-361466289,'Leo'],
  [-361466289,-361284515,'Virgo'],
  [-361284515,-361101767,'Libra'],
  [-361101767,-360916475,'Scorpio'],
  [-360916475,-360727633,'Sagittarius'],
  [-360727633,-360533266,'Capricorn'],
  [-360533266,-360330515,'Aquarius'],
  [-360330515,-360117950,'Pisces'],
  [-360117950,-359898959,'Aries'],
  [-359898959,-359682227,'Taurus'],
  [-359682227,-359476494,'Gemini'],
  [-359476494,-359284596,'Cancer'],
  [-359284596,-359103190,'Leo'],
  [-359103190,-358926193,'Virgo'],
  [-358926193,-358747831,'Libra'],
  [-358747831,-358564324,'Scorpio'],
  [-358564324,-358374115,'Sagittarius'],
  [-358374115,-358176741,'Capricorn'],
  [-358176741,-357971704,'Aquarius'],
  [-357971704,-357758701,'Pisces'],
  [-357758701,-357539778,'Aries'],
  [-357539778,-357321211,'Taurus'],
  [-357321211,-357111480,'Gemini'],
  [-357111480,-356915910,'Cancer'],
  [-356915910,-356733640,'Leo'],
  [-356733640,-356559344,'Virgo'],
  [-356559344,-356386251,'Libra'],
  [-356386251,-356208245,'Scorpio'],
  [-356208245,-356021241,'Sagittarius'],
  [-356021241,-355823809,'Capricorn'],
  [-355823809,-355616809,'Aquarius'],
  [-355616809,-355402362,'Pisces'],
  [-355402362,-355183326,'Aries'],
  [-355183326,-354964186,'Taurus'],
  [-354964186,-354751201,'Gemini'],
  [-354751201,-354550167,'Cancer'],
  [-354550167,-354363033,'Leo'],
  [-354363033,-354186980,'Virgo'],
  [-354186980,-354016115,'Libra'],
  [-354016115,-353843482,'Scorpio'],
  [-353843482,-353662646,'Sagittarius'],
  [-353662646,-353469369,'Capricorn'],
  [-353469369,-353263226,'Aquarius'],
  [-353263226,-353047777,'Pisces'],
  [-353047777,-352828356,'Aries'],
  [-352828356,-352609835,'Taurus'],
  [-352609835,-352396283,'Gemini'],
  [-352396283,-352191450,'Cancer'],
  [-352191450,-351998074,'Leo'],
  [-351998074,-351816216,'Virgo'],
  [-351816216,-351642621,'Libra'],
  [-351642621,-351471425,'Scorpio'],
  [-351471425,-351295549,'Sagittarius'],
  [-351295549,-351108436,'Capricorn'],
  [-351108436,-350906623,'Aquarius'],
  [-350906623,-350692304,'Pisces'],
  [-350692304,-350472579,'Aries'],
  [-350472579,-350254779,'Taurus'],
  [-350254779,-350042942,'Gemini'],
  [-350042942,-349838357,'Cancer'],
  [-349838357,-349641738,'Leo'],
  [-349641738,-349453763,'Virgo'],
  [-349453763,-349273910,'Libra'],
  [-349273910,-349099098,'Scorpio'],
  [-349099098,-348923628,'Sagittarius'],
  [-348923628,-348740545,'Capricorn'],
  [-348740545,-348544090,'Aquarius'],
  [-348544090,-348333280,'Pisces'],
  [-348333280,-348114150,'Aries'],
  [-348114150,-347896266,'Taurus'],
  [-347896266,-347686040,'Gemini'],
  [-347686040,-347484416,'Cancer'],
  [-347484416,-347289566,'Leo'],
  [-347289566,-347099943,'Virgo'],
  [-347099943,-346915088,'Libra'],
  [-346915088,-346734264,'Scorpio'],
  [-346734264,-346554610,'Sagittarius'],
  [-346554610,-346370904,'Capricorn'],
  [-346370904,-346177232,'Aquarius'],
  [-346177232,-345970235,'Pisces'],
  [-345970235,-345752848,'Aries'],
  [-345752848,-345534263,'Taurus'],
  [-345534263,-345323600,'Gemini'],
  [-345323600,-345124013,'Cancer'],
  [-345124013,-344933206,'Leo'],
  [-344933206,-344747158,'Virgo'],
  [-344747158,-344562878,'Libra'],
  [-344562878,-344378964,'Scorpio'],
  [-344378964,-344194280,'Sagittarius'],
  [-344194280,-344006379,'Capricorn'],
  [-344006379,-343811397,'Aquarius'],
  [-343811397,-343605928,'Pisces'],
  [-343605928,-343390378,'Aries'],
  [-343390378,-343171240,'Taurus'],
  [-343171240,-342958167,'Gemini'],
  [-342958167,-342757333,'Cancer'],
  [-342757333,-342568452,'Leo'],
  [-342568452,-342387084,'Virgo'],
  [-342387084,-342207929,'Libra'],
  [-342207929,-342026822,'Scorpio'],
  [-342026822,-341841267,'Sagittarius'],
  [-341841267,-341649838,'Capricorn'],
  [-341649838,-341451283,'Aquarius'],
  [-341451283,-341244395,'Pisces'],
  [-341244395,-341029402,'Aries'],
  [-341029402,-340810172,'Taurus'],
  [-340810172,-340594335,'Gemini'],
  [-340594335,-340389454,'Cancer'],
  [-340389454,-340198334,'Leo'],
  [-340198334,-340018379,'Virgo'],
  [-340018379,-339843990,'Libra'],
  [-339843990,-339668924,'Scorpio'],
  [-339668924,-339487871,'Sagittarius'],
  [-339487871,-339297511,'Capricorn'],
  [-339297511,-339097025,'Aquarius'],
  [-339097025,-338887649,'Pisces'],
  [-338887649,-338671695,'Aries'],
  [-338671695,-338452512,'Taurus'],
  [-338452512,-338235145,'Gemini'],
  [-338235145,-338025913,'Cancer'],
  [-338025913,-337829552,'Leo'],
  [-337829552,-337646466,'Virgo'],
  [-337646466,-337472779,'Libra'],
  [-337472779,-337302072,'Scorpio'],
  [-337302072,-337127257,'Sagittarius'],
  [-337127257,-336942278,'Capricorn'],
  [-336942278,-336744092,'Aquarius'],
  [-336744092,-336534074,'Pisces'],
  [-336534074,-336316865,'Aries'],
  [-336316865,-336097539,'Taurus'],
  [-336097539,-335880211,'Gemini'],
  [-335880211,-335668776,'Cancer'],
  [-335668776,-335467343,'Leo'],
  [-335467343,-335278410,'Virgo'],
  [-335278410,-335100941,'Libra'],
  [-335100941,-334930161,'Scorpio'],
  [-334930161,-334758974,'Sagittarius'],
  [-334758974,-334579845,'Capricorn'],
  [-334579845,-334387072,'Aquarius'],
  [-334387072,-334179699,'Pisces'],
  [-334179699,-333962587,'Aries'],
  [-333962587,-333743089,'Taurus'],
  [-333743089,-333526590,'Gemini'],
  [-333526590,-333315670,'Cancer'],
  [-333315670,-333112195,'Leo'],
  [-333112195,-332918289,'Virgo'],
  [-332918289,-332734908,'Libra'],
  [-332734908,-332559938,'Scorpio'],
  [-332559938,-332387930,'Sagittarius'],
  [-332387930,-332211572,'Capricorn'],
  [-332211572,-332023857,'Aquarius'],
  [-332023857,-331821148,'Pisces'],
  [-331821148,-331606152,'Aries'],
  [-331606152,-331386882,'Taurus'],
  [-331386882,-331171014,'Gemini'],
  [-331171014,-330961933,'Cancer'],
  [-330961933,-330759889,'Leo'],
  [-330759889,-330564818,'Virgo'],
  [-330564818,-330377214,'Libra'],
  [-330377214,-330196692,'Scorpio'],
  [-330196692,-330020305,'Sagittarius'],
  [-330020305,-329842517,'Capricorn'],
  [-329842517,-329656749,'Aquarius'],
  [-329656749,-329457997,'Pisces'],
  [-329457997,-329246221,'Aries'],
  [-329246221,-329027801,'Taurus'],
  [-329027801,-328811789,'Gemini'],
  [-328811789,-328603858,'Cancer'],
  [-328603858,-328404633,'Leo'],
  [-328404633,-328212221,'Virgo'],
  [-328212221,-328024827,'Libra'],
  [-328024827,-327841314,'Scorpio'],
  [-327841314,-327660087,'Sagittarius'],
  [-327660087,-327477993,'Capricorn'],
  [-327477993,-327290441,'Aquarius'],
  [-327290441,-327092914,'Pisces'],
  [-327092914,-326883710,'Aries'],
  [-326883710,-326666505,'Taurus'],
  [-326666505,-326449595,'Gemini'],
  [-326449595,-326240802,'Cancer'],
  [-326240802,-326042956,'Leo'],
  [-326042956,-325854217,'Virgo'],
  [-325854217,-325670827,'Libra'],
  [-325670827,-325489184,'Scorpio'],
  [-325489184,-325306527,'Sagittarius'],
  [-325306527,-325120611,'Capricorn'],
  [-325120611,-324929162,'Aquarius'],
  [-324929162,-324729842,'Pisces'],
  [-324729842,-324521266,'Aries'],
  [-324521266,-324305046,'Taurus'],
  [-324305046,-324087053,'Gemini'],
  [-324087053,-323875431,'Cancer'],
  [-323875431,-323675767,'Leo'],
  [-323675767,-323488306,'Virgo'],
  [-323488306,-323309166,'Libra'],
  [-323309166,-323132757,'Scorpio'],
  [-323132757,-322953694,'Sagittarius'],
  [-322953694,-322768067,'Capricorn'],
  [-322768067,-322574050,'Aquarius'],
  [-322574050,-322371616,'Pisces'],
  [-322371616,-322161614,'Aries'],
  [-322161614,-321945605,'Taurus'],
  [-321945605,-321727062,'Gemini'],
  [-321727062,-321512201,'Cancer'],
  [-321512201,-321307899,'Leo'],
  [-321307899,-321117513,'Virgo'],
  [-321117513,-320939154,'Libra'],
  [-320939154,-320767092,'Scorpio'],
  [-320767092,-320594109,'Sagittarius'],
  [-320594109,-320413579,'Capricorn'],
  [-320413579,-320221475,'Aquarius'],
  [-320221475,-320017810,'Pisces'],
  [-320017810,-319805755,'Aries'],
  [-319805755,-319589020,'Taurus'],
  [-319589020,-319370617,'Gemini'],
  [-319370617,-319154168,'Cancer'],
  [-319154168,-318945136,'Leo'],
  [-318945136,-318748732,'Virgo'],
  [-318748732,-318566305,'Libra'],
  [-318566305,-318394097,'Scorpio'],
  [-318394097,-318224943,'Sagittarius'],
  [-318224943,-318050719,'Capricorn'],
  [-318050719,-317864637,'Aquarius'],
  [-317864637,-317664037,'Pisces'],
  [-317664037,-317451854,'Aries'],
  [-317451854,-317234159,'Taurus'],
  [-317234159,-317015985,'Gemini'],
  [-317015985,-316800145,'Cancer'],
  [-316800145,-316589432,'Leo'],
  [-316589432,-316387884,'Virgo'],
  [-316387884,-316198757,'Libra'],
  [-316198757,-316021471,'Scorpio'],
  [-316021471,-315850945,'Sagittarius'],
  [-315850945,-315679518,'Capricorn'],
  [-315679518,-315499276,'Aquarius'],
  [-315499276,-315304729,'Pisces'],
  [-315304729,-315095860,'Aries'],
  [-315095860,-314878503,'Taurus'],
  [-314878503,-314660207,'Gemini'],
  [-314660207,-314445662,'Cancer'],
  [-314445662,-314236601,'Leo'],
  [-314236601,-314034350,'Virgo'],
  [-314034350,-313840850,'Libra'],
  [-313840850,-313657051,'Scorpio'],
  [-313657051,-313480835,'Sagittarius'],
  [-313480835,-313306878,'Capricorn'],
  [-313306878,-313128217,'Aquarius'],
  [-313128217,-312938457,'Pisces'],
  [-312938457,-312734645,'Aries'],
  [-312734645,-312519705,'Taurus'],
  [-312519705,-312301380,'Gemini'],
  [-312301380,-312087121,'Cancer'],
  [-312087121,-311880322,'Leo'],
  [-311880322,-311681082,'Virgo'],
  [-311681082,-311488578,'Libra'],
  [-311488578,-311302107,'Scorpio'],
  [-311302107,-311120441,'Sagittarius'],
  [-311120441,-310940855,'Capricorn'],
  [-310940855,-310758982,'Aquarius'],
  [-310758982,-310569751,'Pisces'],
  [-310569751,-310369298,'Aries'],
  [-310369298,-310157550,'Taurus'],
  [-310157550,-309939810,'Gemini'],
  [-309939810,-309724509,'Cancer'],
  [-309724509,-309517959,'Leo'],
  [-309517959,-309321634,'Virgo'],
  [-309321634,-309133382,'Libra'],
  [-309133382,-308949759,'Scorpio'],
  [-308949759,-308767553,'Sagittarius'],
  [-308767553,-308584201,'Capricorn'],
  [-308584201,-308397484,'Aquarius'],
  [-308397484,-308205034,'Pisces'],
  [-308205034,-308004421,'Aries'],
  [-308004421,-307794498,'Taurus'],
  [-307794498,-307577659,'Gemini'],
  [-307577659,-307360754,'Cancer'],
  [-307360754,-307151906,'Leo'],
  [-307151906,-306955470,'Virgo'],
  [-306955470,-306770342,'Libra'],
  [-306770342,-306591759,'Scorpio'],
  [-306591759,-306413943,'Sagittarius'],
  [-306413943,-306232088,'Capricorn'],
  [-306232088,-306043474,'Aquarius'],
  [-306043474,-305847439,'Pisces'],
  [-305847439,-305644177,'Aries'],
  [-305644177,-305433822,'Taurus'],
  [-305433822,-305217452,'Gemini'],
  [-305217452,-304999286,'Cancer'],
  [-304999286,-304786882,'Leo'],
  [-304786882,-304587003,'Virgo'],
  [-304587003,-304401207,'Libra'],
  [-304401207,-304225505,'Scorpio'],
  [-304225505,-304052985,'Sagittarius'],
  [-304052985,-303876539,'Capricorn'],
  [-303876539,-303690998,'Aquarius'],
  [-303690998,-303494696,'Pisces'],
  [-303494696,-303289211,'Aries'],
  [-303289211,-303077112,'Taurus'],
  [-303077112,-302860423,'Gemini'],
  [-302860423,-302641779,'Cancer'],
  [-302641779,-302426532,'Leo'],
  [-302426532,-302221735,'Virgo'],
  [-302221735,-302031607,'Libra'],
  [-302031607,-301854551,'Scorpio'],
  [-301854551,-301684338,'Sagittarius'],
  [-301684338,-301513025,'Capricorn'],
  [-301513025,-301333362,'Aquarius'],
  [-301333362,-301141059,'Pisces'],
  [-301141059,-300936414,'Aries'],
  [-300936414,-300723245,'Taurus'],
  [-300723245,-300505829,'Gemini'],
  [-300505829,-300287323,'Cancer'],
  [-300287323,-300071245,'Leo'],
  [-300071245,-299862833,'Virgo'],
  [-299862833,-299667082,'Libra'],
  [-299667082,-299485056,'Scorpio'],
  [-299485056,-299312744,'Sagittarius'],
  [-299312744,-299143015,'Capricorn'],
  [-299143015,-298968064,'Aquarius'],
  [-298968064,-298781582,'Pisces'],
  [-298781582,-298581113,'Aries'],
  [-298581113,-298369185,'Taurus'],
  [-298369185,-298151482,'Gemini'],
  [-298151482,-297933274,'Cancer'],
  [-297933274,-297718130,'Leo'],
  [-297718130,-297509220,'Virgo'],
  [-297509220,-297309908,'Libra'],
  [-297309908,-297122148,'Scorpio'],
  [-297122148,-296944463,'Sagittarius'],
  [-296944463,-296771951,'Capricorn'],
  [-296771951,-296597877,'Aquarius'],
  [-296597877,-296415513,'Pisces'],
  [-296415513,-296220259,'Aries'],
  [-296220259,-296011853,'Taurus'],
  [-296011853,-295795043,'Gemini'],
  [-295795043,-295576960,'Cancer'],
  [-295576960,-295363115,'Leo'],
  [-295363115,-295156243,'Virgo'],
  [-295156243,-294957389,'Libra'],
  [-294957389,-294766858,'Scorpio'],
  [-294766858,-294583878,'Sagittarius'],
  [-294583878,-294405890,'Capricorn'],
  [-294405890,-294228549,'Aquarius'],
  [-294228549,-294046453,'Pisces'],
  [-294046453,-293854530,'Aries'],
  [-293854530,-293650142,'Taurus'],
  [-293650142,-293435379,'Gemini'],
  [-293435379,-293217219,'Cancer'],
  [-293217219,-293003581,'Leo'],
  [-293003581,-292798898,'Virgo'],
  [-292798898,-292603335,'Libra'],
  [-292603335,-292414692,'Scorpio'],
  [-292414692,-292230361,'Sagittarius'],
  [-292230361,-292048059,'Capricorn'],
  [-292048059,-291865554,'Aquarius'],
  [-291865554,-291680025,'Pisces'],
  [-291680025,-291487878,'Aries'],
  [-291487878,-291285814,'Taurus'],
  [-291285814,-291073314,'Gemini'],
  [-291073314,-290855107,'Cancer'],
  [-290855107,-290640001,'Leo'],
  [-290640001,-290435260,'Virgo'],
  [-290435260,-290242454,'Libra'],
  [-290242454,-290058257,'Scorpio'],
  [-290058257,-289877511,'Sagittarius'],
  [-289877511,-289695754,'Capricorn'],
  [-289695754,-289510428,'Aquarius'],
  [-289510428,-289320534,'Pisces'],
  [-289320534,-289125158,'Aries'],
  [-289125158,-288922539,'Taurus'],
  [-288922539,-288711247,'Gemini'],
  [-288711247,-288493241,'Cancer'],
  [-288493241,-288275767,'Leo'],
  [-288275767,-288067959,'Virgo'],
  [-288067959,-287874415,'Libra'],
  [-287874415,-287692995,'Scorpio'],
  [-287692995,-287517471,'Sagittarius'],
  [-287517471,-287340936,'Capricorn'],
  [-287340936,-287158239,'Aquarius'],
  [-287158239,-286967361,'Pisces'],
  [-286967361,-286768829,'Aries'],
  [-286768829,-286563565,'Taurus'],
  [-286563565,-286351682,'Gemini'],
  [-286351682,-286133947,'Cancer'],
  [-286133947,-285914807,'Leo'],
  [-285914807,-285702588,'Virgo'],
  [-285702588,-285504415,'Libra'],
  [-285504415,-285321182,'Scorpio'],
  [-285321182,-285147821,'Sagittarius'],
  [-285147821,-284976678,'Capricorn'],
  [-284976678,-284800373,'Aquarius'],
  [-284800373,-284613929,'Pisces'],
  [-284613929,-284416194,'Aries'],
  [-284416194,-284209123,'Taurus'],
  [-284209123,-283995505,'Gemini'],
  [-283995505,-283777583,'Cancer'],
  [-283777583,-283558323,'Leo'],
  [-283558323,-283343342,'Virgo'],
  [-283343342,-283139478,'Libra'],
  [-283139478,-282950373,'Scorpio'],
  [-282950373,-282773932,'Sagittarius'],
  [-282773932,-282603869,'Capricorn'],
  [-282603869,-282432490,'Aquarius'],
  [-282432490,-282252816,'Pisces'],
  [-282252816,-282060522,'Aries'],
  [-282060522,-281855416,'Taurus'],
  [-281855416,-281641088,'Gemini'],
  [-281641088,-281422506,'Cancer'],
  [-281422506,-281203913,'Leo'],
  [-281203913,-280989188,'Virgo'],
  [-280989188,-280782559,'Libra'],
  [-280782559,-280587526,'Scorpio'],
  [-280587526,-280404565,'Sagittarius'],
  [-280404565,-280230331,'Capricorn'],
  [-280230331,-280058835,'Aquarius'],
  [-280058835,-279883161,'Pisces'],
  [-279883161,-279697129,'Aries'],
  [-279697129,-279497324,'Taurus'],
  [-279497324,-279285086,'Gemini'],
  [-279285086,-279066343,'Cancer'],
  [-279066343,-278848089,'Leo'],
  [-278848089,-278635145,'Virgo'],
  [-278635145,-278429788,'Libra'],
  [-278429788,-278232981,'Scorpio'],
  [-278232981,-278044877,'Sagittarius'],
  [-278044877,-277864260,'Capricorn'],
  [-277864260,-277688027,'Aquarius'],
  [-277688027,-277511261,'Pisces'],
  [-277511261,-277328075,'Aries'],
  [-277328075,-277133281,'Taurus'],
  [-277133281,-276925073,'Gemini'],
  [-276925073,-276707498,'Cancer'],
  [-276707498,-276489030,'Leo'],
  [-276489030,-276277139,'Virgo'],
  [-276277139,-276074618,'Libra'],
  [-276074618,-275880369,'Scorpio'],
  [-275880369,-275692085,'Sagittarius'],
  [-275692085,-275507845,'Capricorn'],
  [-275507845,-275326110,'Aquarius'],
  [-275326110,-275144680,'Pisces'],
  [-275144680,-274959809,'Aries'],
  [-274959809,-274766714,'Taurus'],
  [-274766714,-274561818,'Gemini'],
  [-274561818,-274346228,'Cancer'],
  [-274346228,-274127351,'Leo'],
  [-274127351,-273914742,'Virgo'],
  [-273914742,-273713590,'Libra'],
  [-273713590,-273522919,'Scorpio'],
  [-273522919,-273338426,'Sagittarius'],
  [-273338426,-273155766,'Capricorn'],
  [-273155766,-272972245,'Aquarius'],
  [-272972245,-272786656,'Pisces'],
  [-272786656,-272597700,'Aries'],
  [-272597700,-272402750,'Taurus'],
  [-272402750,-272198615,'Gemini'],
  [-272198615,-271984513,'Cancer'],
  [-271984513,-271765315,'Leo'],
  [-271765315,-271550547,'Virgo'],
  [-271550547,-271347936,'Libra'],
  [-271347936,-271158550,'Scorpio'],
  [-271158550,-270977999,'Sagittarius'],
  [-270977999,-270800123,'Capricorn'],
  [-270800123,-270619785,'Aquarius'],
  [-270619785,-270434196,'Pisces'],
  [-270434196,-270242544,'Aries'],
  [-270242544,-270044385,'Taurus'],
  [-270044385,-269838632,'Gemini'],
  [-269838632,-269624670,'Cancer'],
  [-269624670,-269405296,'Leo'],
  [-269405296,-269188096,'Virgo'],
  [-269188096,-268981753,'Libra'],
  [-268981753,-268790072,'Scorpio'],
  [-268790072,-268610414,'Sagittarius'],
  [-268610414,-268436528,'Capricorn'],
  [-268436528,-268261652,'Aquarius'],
  [-268261652,-268080495,'Pisces'],
  [-268080495,-267890317,'Aries'],
  [-267890317,-267690776,'Taurus'],
  [-267690776,-267482824,'Gemini'],
  [-267482824,-267267829,'Cancer'],
  [-267267829,-267048335,'Leo'],
  [-267048335,-266829702,'Virgo'],
  [-266829702,-266619327,'Libra'],
  [-266619327,-266422681,'Scorpio'],
  [-266422681,-266239882,'Sagittarius'],
  [-266239882,-266066314,'Capricorn'],
  [-266066314,-265895235,'Aquarius'],
  [-265895235,-265719862,'Pisces'],
  [-265719862,-265534883,'Aries'],
  [-265534883,-265337774,'Taurus'],
  [-265337774,-265129416,'Gemini'],
  [-265129416,-264913265,'Cancer'],
  [-264913265,-264693594,'Leo'],
  [-264693594,-264475000,'Virgo'],
  [-264475000,-264262556,'Libra'],
  [-264262556,-264060975,'Scorpio'],
  [-264060975,-263872370,'Sagittarius'],
  [-263872370,-263694877,'Capricorn'],
  [-263694877,-263523456,'Aquarius'],
  [-263523456,-263351479,'Pisces'],
  [-263351479,-263172203,'Aries'],
  [-263172203,-262980456,'Taurus'],
  [-262980456,-262774798,'Gemini'],
  [-262774798,-262558765,'Cancer'],
  [-262558765,-262338915,'Leo'],
  [-262338915,-262121209,'Virgo'],
  [-262121209,-261909442,'Libra'],
  [-261909442,-261705941,'Scorpio'],
  [-261705941,-261512290,'Sagittarius'],
  [-261512290,-261328609,'Capricorn'],
  [-261328609,-261152637,'Aquarius'],
  [-261152637,-260979612,'Pisces'],
  [-260979612,-260803098,'Aries'],
  [-260803098,-260616518,'Taurus'],
  [-260616518,-260415664,'Gemini'],
  [-260415664,-260201797,'Cancer'],
  [-260201797,-259982083,'Leo'],
  [-259982083,-259764984,'Virgo'],
  [-259764984,-259555262,'Libra'],
  [-259555262,-259353553,'Scorpio'],
  [-259353553,-259158982,'Sagittarius'],
  [-259158982,-258970983,'Capricorn'],
  [-258970983,-258789005,'Aquarius'],
  [-258789005,-258611061,'Pisces'],
  [-258611061,-258432795,'Aries'],
  [-258432795,-258248136,'Taurus'],
  [-258248136,-258051441,'Gemini'],
  [-258051441,-257841034,'Cancer'],
  [-257841034,-257622161,'Leo'],
  [-257622161,-257404670,'Virgo'],
  [-257404670,-257195984,'Libra'],
  [-257195984,-256997359,'Scorpio'],
  [-256997359,-256806040,'Sagittarius'],
  [-256806040,-256618859,'Capricorn'],
  [-256618859,-256434099,'Aquarius'],
  [-256434099,-256250988,'Pisces'],
  [-256250988,-256067824,'Aries'],
  [-256067824,-255880862,'Taurus'],
  [-255880862,-255685186,'Gemini'],
  [-255685186,-255477535,'Cancer'],
  [-255477535,-255260108,'Leo'],
  [-255260108,-255041528,'Virgo'],
  [-255041528,-254831414,'Libra'],
  [-254831414,-254633730,'Scorpio'],
  [-254633730,-254446168,'Sagittarius'],
  [-254446168,-254263726,'Capricorn'],
  [-254263726,-254081913,'Aquarius'],
  [-254081913,-253898154,'Pisces'],
  [-253898154,-253711282,'Aries'],
  [-253711282,-253519956,'Taurus'],
  [-253519956,-253321821,'Gemini'],
  [-253321821,-253114471,'Cancer'],
  [-253114471,-252898248,'Leo'],
  [-252898248,-252678830,'Virgo'],
  [-252678830,-252465492,'Libra'],
  [-252465492,-252265016,'Scorpio'],
  [-252265016,-252077760,'Sagittarius'],
  [-252077760,-251899198,'Capricorn'],
  [-251899198,-251723209,'Aquarius'],
  [-251723209,-251544368,'Pisces'],
  [-251544368,-251359119,'Aries'],
  [-251359119,-251165895,'Taurus'],
  [-251165895,-250964432,'Gemini'],
  [-250964432,-250755027,'Cancer'],
  [-250755027,-250538801,'Leo'],
  [-250538801,-250319294,'Virgo'],
  [-250319294,-250103158,'Libra'],
  [-250103158,-249897645,'Scorpio'],
  [-249897645,-249706224,'Sagittarius'],
  [-249706224,-249526989,'Capricorn'],
  [-249526989,-249354430,'Aquarius'],
  [-249354430,-249181773,'Pisces'],
  [-249181773,-249002716,'Aries'],
  [-249002716,-248812911,'Taurus'],
  [-248812911,-248611223,'Gemini'],
  [-248611223,-248399791,'Cancer'],
  [-248399791,-248182413,'Leo'],
  [-248182413,-247963117,'Virgo'],
  [-247963117,-247746234,'Libra'],
  [-247746234,-247536831,'Scorpio'],
  [-247536831,-247339314,'Sagittarius'],
  [-247339314,-247154878,'Capricorn'],
  [-247154878,-246980606,'Aquarius'],
  [-246980606,-246810489,'Pisces'],
  [-246810489,-246637205,'Aries'],
  [-246637205,-246453901,'Taurus'],
  [-246453901,-246256470,'Gemini'],
  [-246256470,-246045857,'Cancer'],
  [-246045857,-245827639,'Leo'],
  [-245827639,-245608312,'Virgo'],
  [-245608312,-245392300,'Libra'],
  [-245392300,-245182292,'Scorpio'],
  [-245182292,-244980873,'Sagittarius'],
  [-244980873,-244790201,'Capricorn'],
  [-244790201,-244610245,'Aquarius'],
  [-244610245,-244437533,'Pisces'],
  [-244437533,-244265701,'Aries'],
  [-244265701,-244087217,'Taurus'],
  [-244087217,-243895681,'Gemini'],
  [-243895681,-243689039,'Cancer'],
  [-243689039,-243471803,'Leo'],
  [-243471803,-243252392,'Virgo'],
  [-243252392,-243037397,'Libra'],
  [-243037397,-242829191,'Scorpio'],
  [-242829191,-242628015,'Sagittarius'],
  [-242628015,-242434330,'Capricorn'],
  [-242434330,-242248794,'Aquarius'],
  [-242248794,-242070473,'Pisces'],
  [-242070473,-241895460,'Aries'],
  [-241895460,-241717422,'Taurus'],
  [-241717422,-241529532,'Gemini'],
  [-241529532,-241327477,'Cancer'],
  [-241327477,-241112938,'Leo'],
  [-241112938,-240893856,'Virgo'],
  [-240893856,-240679035,'Libra'],
  [-240679035,-240472659,'Scorpio'],
  [-240472659,-240274316,'Sagittarius'],
  [-240274316,-240082154,'Capricorn'],
  [-240082154,-239895034,'Aquarius'],
  [-239895034,-239712310,'Pisces'],
  [-239712310,-239532200,'Aries'],
  [-239532200,-239350775,'Taurus'],
  [-239350775,-239162618,'Gemini'],
  [-239162618,-238963022,'Cancer'],
  [-238963022,-238751291,'Leo'],
  [-238751291,-238532975,'Virgo'],
  [-238532975,-238317316,'Libra'],
  [-238317316,-238110990,'Scorpio'],
  [-238110990,-237915016,'Sagittarius'],
  [-237915016,-237726669,'Capricorn'],
  [-237726669,-237542483,'Aquarius'],
  [-237542483,-237359821,'Pisces'],
  [-237359821,-237176741,'Aries'],
  [-237176741,-236991037,'Taurus'],
  [-236991037,-236799686,'Gemini'],
  [-236799686,-236599482,'Cancer'],
  [-236599482,-236389088,'Leo'],
  [-236389088,-236171555,'Virgo'],
  [-236171555,-235954485,'Libra'],
  [-235954485,-235745982,'Scorpio'],
  [-235745982,-235549680,'Sagittarius'],
  [-235549680,-235363969,'Capricorn'],
  [-235363969,-235184392,'Aquarius'],
  [-235184392,-235005980,'Pisces'],
  [-235005980,-234824593,'Aries'],
  [-234824593,-234637403,'Taurus'],
  [-234637403,-234442789,'Gemini'],
  [-234442789,-234239962,'Cancer'],
  [-234239962,-234028962,'Leo'],
  [-234028962,-233811758,'Virgo'],
  [-233811758,-233593474,'Libra'],
  [-233593474,-233381515,'Scorpio'],
  [-233381515,-233181747,'Sagittarius'],
  [-233181747,-232995160,'Capricorn'],
  [-232995160,-232818200,'Aquarius'],
  [-232818200,-232644888,'Pisces'],
  [-232644888,-232468813,'Aries'],
  [-232468813,-232284737,'Taurus'],
  [-232284737,-232089992,'Gemini'],
  [-232089992,-231885015,'Cancer'],
  [-231885015,-231672270,'Leo'],
  [-231672270,-231454751,'Virgo'],
  [-231454751,-231236036,'Libra'],
  [-231236036,-231021245,'Scorpio'],
  [-231021245,-230816415,'Sagittarius'],
  [-230816415,-230625231,'Capricorn'],
  [-230625231,-230446693,'Aquarius'],
  [-230446693,-230275637,'Pisces'],
  [-230275637,-230104761,'Aries'],
  [-230104761,-229926677,'Taurus'],
  [-229926677,-229736067,'Gemini'],
  [-229736067,-229531996,'Cancer'],
  [-229531996,-229318159,'Leo'],
  [-229318159,-229099933,'Virgo'],
  [-229099933,-228881491,'Libra'],
  [-228881491,-228666019,'Scorpio'],
  [-228666019,-228457507,'Sagittarius'],
  [-228457507,-228260306,'Capricorn'],
  [-228260306,-228076267,'Aquarius'],
  [-228076267,-227902760,'Pisces'],
  [-227902760,-227733400,'Aries'],
  [-227733400,-227560185,'Taurus'],
  [-227560185,-227375733,'Gemini'],
  [-227375733,-227176192,'Cancer'],
  [-227176192,-226963743,'Leo'],
  [-226963743,-226745199,'Virgo'],
  [-226745199,-226527102,'Libra'],
  [-226527102,-226312837,'Scorpio'],
  [-226312837,-226104168,'Sagittarius'],
  [-226104168,-225903471,'Capricorn'],
  [-225903471,-225713264,'Aquarius'],
  [-225713264,-225533671,'Pisces'],
  [-225533671,-225360898,'Aries'],
  [-225360898,-225188186,'Taurus'],
  [-225188186,-225007878,'Gemini'],
  [-225007878,-224814010,'Cancer'],
  [-224814010,-224605610,'Leo'],
  [-224605610,-224388139,'Virgo'],
  [-224388139,-224170017,'Libra'],
  [-224170017,-223957017,'Scorpio'],
  [-223957017,-223750782,'Sagittarius'],
  [-223750782,-223551259,'Capricorn'],
  [-223551259,-223358796,'Aquarius'],
  [-223358796,-223173782,'Pisces'],
  [-223173782,-222994848,'Aries'],
  [-222994848,-222817948,'Taurus'],
  [-222817948,-222637127,'Gemini'],
  [-222637127,-222446386,'Cancer'],
  [-222446386,-222242444,'Leo'],
  [-222242444,-222027548,'Virgo'],
  [-222027548,-221809335,'Libra'],
  [-221809335,-221596051,'Scorpio'],
  [-221596051,-221391686,'Sagittarius'],
  [-221391686,-221195859,'Capricorn'],
  [-221195859,-221006379,'Aquarius'],
  [-221006379,-220821145,'Pisces'],
  [-220821145,-220638393,'Aries'],
  [-220638393,-220455966,'Taurus'],
  [-220455966,-220270717,'Gemini'],
  [-220270717,-220078752,'Cancer'],
  [-220078752,-219876789,'Leo'],
  [-219876789,-219664536,'Virgo'],
  [-219664536,-219446675,'Libra'],
  [-219446675,-219231574,'Scorpio'],
  [-219231574,-219026193,'Sagittarius'],
  [-219026193,-218832376,'Capricorn'],
  [-218832376,-218647500,'Aquarius'],
  [-218647500,-218466975,'Pisces'],
  [-218466975,-218286314,'Aries'],
  [-218286314,-218102224,'Taurus'],
  [-218102224,-217912782,'Gemini'],
  [-217912782,-217716858,'Cancer'],
  [-217716858,-217513453,'Leo'],
  [-217513453,-217302130,'Virgo'],
  [-217302130,-217084907,'Libra'],
  [-217084907,-216867788,'Scorpio'],
  [-216867788,-216658799,'Sagittarius'],
  [-216658799,-216462991,'Capricorn'],
  [-216462991,-216279762,'Aquarius'],
  [-216279762,-216104097,'Pisces'],
  [-216104097,-215929296,'Aries'],
  [-215929296,-215749282,'Taurus'],
  [-215749282,-215560337,'Gemini'],
  [-215560337,-215361915,'Cancer'],
  [-215361915,-215155590,'Leo'],
  [-215155590,-214943115,'Virgo'],
  [-214943115,-214726128,'Libra'],
  [-214726128,-214508001,'Scorpio'],
  [-214508001,-214295141,'Sagittarius'],
  [-214295141,-214094329,'Capricorn'],
  [-214094329,-213908135,'Aquarius'],
  [-213908135,-213733344,'Pisces'],
  [-213733344,-213562996,'Aries'],
  [-213562996,-213389229,'Taurus'],
  [-213389229,-213205590,'Gemini'],
  [-213205590,-213009275,'Cancer'],
  [-213009275,-212801991,'Leo'],
  [-212801991,-212587839,'Virgo'],
  [-212587839,-212370388,'Libra'],
  [-212370388,-212152330,'Scorpio'],
  [-212152330,-211937595,'Sagittarius'],
  [-211937595,-211731966,'Capricorn'],
  [-211731966,-211539988,'Aquarius'],
  [-211539988,-211361410,'Pisces'],
  [-211361410,-211190960,'Aries'],
  [-211190960,-211020833,'Taurus'],
  [-211020833,-210843182,'Gemini'],
  [-210843182,-210652502,'Cancer'],
  [-210652502,-210448033,'Leo'],
  [-210448033,-210233881,'Virgo'],
  [-210233881,-210015865,'Libra'],
  [-210015865,-209798265,'Scorpio'],
  [-209798265,-209584003,'Sagittarius'],
  [-209584003,-209376529,'Capricorn'],
  [-209376529,-209179691,'Aquarius'],
  [-209179691,-208995144,'Pisces'],
  [-208995144,-208820330,'Aries'],
  [-208820330,-208649196,'Taurus'],
  [-208649196,-208474284,'Gemini'],
  [-208474284,-208288886,'Cancer'],
  [-208288886,-208089512,'Leo'],
  [-208089512,-207877877,'Virgo'],
  [-207877877,-207660101,'Libra'],
  [-207660101,-207442778,'Scorpio'],
  [-207442778,-207230008,'Sagittarius'],
  [-207230008,-207023892,'Capricorn'],
  [-207023892,-206825968,'Aquarius'],
  [-206825968,-206637219,'Pisces'],
  [-206637219,-206456734,'Aries'],
  [-206456734,-206280981,'Taurus'],
  [-206280981,-206104426,'Gemini'],
  [-206104426,-205920961,'Cancer'],
  [-205920961,-205725831,'Leo'],
  [-205725831,-205517980,'Virgo'],
  [-205517980,-205301552,'Libra'],
  [-205301552,-205084139,'Scorpio'],
  [-205084139,-204872227,'Sagittarius'],
  [-204872227,-204668639,'Capricorn'],
  [-204668639,-204473234,'Aquarius'],
  [-204473234,-204284638,'Pisces'],
  [-204284638,-204101106,'Aries'],
  [-204101106,-203920375,'Taurus'],
  [-203920375,-203739312,'Gemini'],
  [-203739312,-203553907,'Cancer'],
  [-203553907,-203360014,'Leo'],
  [-203360014,-203155077,'Virgo'],
  [-203155077,-202940510,'Libra'],
  [-202940510,-202722730,'Scorpio'],
  [-202722730,-202510065,'Sagittarius'],
  [-202510065,-202307670,'Capricorn'],
  [-202307670,-202115670,'Aquarius'],
  [-202115670,-201930811,'Pisces'],
  [-201930811,-201748949,'Aries'],
  [-201748949,-201566655,'Taurus'],
  [-201566655,-201381641,'Gemini'],
  [-201381641,-201192205,'Cancer'],
  [-201192205,-200996388,'Leo'],
  [-200996388,-200792078,'Virgo'],
  [-200792078,-200578879,'Libra'],
  [-200578879,-200360704,'Scorpio'],
  [-200360704,-200145768,'Sagittarius'],
  [-200145768,-199941770,'Capricorn'],
  [-199941770,-199750979,'Aquarius'],
  [-199750979,-199570084,'Pisces'],
  [-199570084,-199393076,'Aries'],
  [-199393076,-199214063,'Taurus'],
  [-199214063,-199029140,'Gemini'],
  [-199029140,-198837022,'Cancer'],
  [-198837022,-198637962,'Leo'],
  [-198637962,-198432022,'Virgo'],
  [-198432022,-198218977,'Libra'],
  [-198218977,-198000615,'Scorpio'],
  [-198000615,-197783086,'Sagittarius'],
  [-197783086,-197575010,'Capricorn'],
  [-197575010,-197381609,'Aquarius'],
  [-197381609,-197201518,'Pisces'],
  [-197201518,-197028609,'Aries'],
  [-197028609,-196855316,'Taurus'],
  [-196855316,-196675166,'Gemini'],
  [-196675166,-196484758,'Cancer'],
  [-196484758,-196284359,'Leo'],
  [-196284359,-196076156,'Virgo'],
  [-196076156,-195862055,'Libra'],
  [-195862055,-195643671,'Scorpio'],
  [-195643671,-195424768,'Sagittarius'],
  [-195424768,-195212404,'Capricorn'],
  [-195212404,-195013436,'Aquarius'],
  [-195013436,-194829595,'Pisces'],
  [-194829595,-194656637,'Aries'],
  [-194656637,-194487100,'Taurus'],
  [-194487100,-194313115,'Gemini'],
  [-194313115,-194128575,'Cancer'],
  [-194128575,-193931162,'Leo'],
  [-193931162,-193722753,'Virgo'],
  [-193722753,-193507405,'Libra'],
  [-193507405,-193288833,'Scorpio'],
  [-193288833,-193070244,'Sagittarius'],
  [-193070244,-192856120,'Capricorn'],
  [-192856120,-192652066,'Aquarius'],
  [-192652066,-192461693,'Pisces'],
  [-192461693,-192283846,'Aries'],
  [-192283846,-192113110,'Taurus'],
  [-192113110,-191942119,'Gemini'],
  [-191942119,-191763613,'Cancer'],
  [-191763613,-191572425,'Leo'],
  [-191572425,-191367520,'Virgo'],
  [-191367520,-191152550,'Libra'],
  [-191152550,-190933614,'Scorpio'],
  [-190933614,-190715934,'Sagittarius'],
  [-190715934,-190503070,'Capricorn'],
  [-190503070,-190297890,'Aquarius'],
  [-190297890,-190102749,'Pisces'],
  [-190102749,-189918158,'Aries'],
  [-189918158,-189741701,'Taurus'],
  [-189741701,-189568385,'Gemini'],
  [-189568385,-189391858,'Cancer'],
  [-189391858,-189205928,'Leo'],
  [-189205928,-189006614,'Virgo'],
  [-189006614,-188794583,'Libra'],
  [-188794583,-188575857,'Scorpio'],
  [-188575857,-188358382,'Sagittarius'],
  [-188358382,-188147534,'Capricorn'],
  [-188147534,-187944959,'Aquarius'],
  [-187944959,-187750185,'Pisces'],
  [-187750185,-187562212,'Aries'],
  [-187562212,-187379725,'Taurus'],
  [-187379725,-187200513,'Gemini'],
  [-187200513,-187020892,'Cancer'],
  [-187020892,-186835874,'Leo'],
  [-186835874,-186640500,'Virgo'],
  [-186640500,-186432459,'Libra'],
  [-186432459,-186215081,'Scorpio'],
  [-186215081,-185996962,'Sagittarius'],
  [-185996962,-185786439,'Capricorn'],
  [-185786439,-185586669,'Aquarius'],
  [-185586669,-185395811,'Pisces'],
  [-185395811,-185210100,'Aries'],
  [-185210100,-185026327,'Taurus'],
  [-185026327,-184842638,'Gemini'],
  [-184842638,-184657736,'Cancer'],
  [-184657736,-184469397,'Leo'],
  [-184469397,-184274040,'Virgo'],
  [-184274040,-184068375,'Libra'],
  [-184068375,-183852797,'Scorpio'],
  [-183852797,-183633887,'Sagittarius'],
  [-183633887,-183421469,'Capricorn'],
  [-183421469,-183221687,'Aquarius'],
  [-183221687,-183033879,'Pisces'],
  [-183033879,-182852994,'Aries'],
  [-182852994,-182673244,'Taurus'],
  [-182673244,-182490510,'Gemini'],
  [-182490510,-182303111,'Cancer'],
  [-182303111,-182110692,'Leo'],
  [-182110692,-181912345,'Virgo'],
  [-181912345,-181706202,'Libra'],
  [-181706202,-181491564,'Scorpio'],
  [-181491564,-181272242,'Sagittarius'],
  [-181272242,-181056952,'Capricorn'],
  [-181056952,-180853987,'Aquarius'],
  [-180853987,-180665493,'Pisces'],
  [-180665493,-180487384,'Aries'],
  [-180487384,-180312843,'Taurus'],
  [-180312843,-180135393,'Gemini'],
  [-180135393,-179950808,'Cancer'],
  [-179950808,-179757758,'Leo'],
  [-179757758,-179556727,'Virgo'],
  [-179556727,-179348368,'Libra'],
  [-179348368,-179133255,'Scorpio'],
  [-179133255,-178913859,'Sagittarius'],
  [-178913859,-178696429,'Capricorn'],
  [-178696429,-178489014,'Aquarius'],
  [-178489014,-178296263,'Pisces'],
  [-178296263,-178116655,'Aries'],
  [-178116655,-177944306,'Taurus'],
  [-177944306,-177771997,'Gemini'],
  [-177771997,-177593329,'Cancer'],
  [-177593329,-177404263,'Leo'],
  [-177404263,-177203932,'Virgo'],
  [-177203932,-176994129,'Libra'],
  [-176994129,-176777827,'Scorpio'],
  [-176777827,-176558403,'Sagittarius'],
  [-176558403,-176340464,'Capricorn'],
  [-176340464,-176129932,'Aquarius'],
  [-176129932,-175931829,'Pisces'],
  [-175931829,-175747209,'Aries'],
  [-175747209,-175572600,'Taurus'],
  [-175572600,-175401810,'Gemini'],
  [-175401810,-175227903,'Cancer'],
  [-175227903,-175044769,'Leo'],
  [-175044769,-174848775,'Virgo'],
  [-174848775,-174640255,'Libra'],
  [-174640255,-174423413,'Scorpio'],
  [-174423413,-174203897,'Sagittarius'],
  [-174203897,-173986718,'Capricorn'],
  [-173986718,-173775849,'Aquarius'],
  [-173775849,-173574462,'Pisces'],
  [-173574462,-173384250,'Aries'],
  [-173384250,-173204225,'Taurus'],
  [-173204225,-173030586,'Gemini'],
  [-173030586,-172857545,'Cancer'],
  [-172857545,-172678555,'Leo'],
  [-172678555,-172487937,'Virgo'],
  [-172487937,-172283263,'Libra'],
  [-172283263,-172067526,'Scorpio'],
  [-172067526,-171848001,'Sagittarius'],
  [-171848001,-171631773,'Capricorn'],
  [-171631773,-171422678,'Aquarius'],
  [-171422678,-171221688,'Pisces'],
  [-171221688,-171028774,'Aries'],
  [-171028774,-170843511,'Taurus'],
  [-170843511,-170664420,'Gemini'],
  [-170664420,-170488144,'Cancer'],
  [-170488144,-170309403,'Leo'],
  [-170309403,-170122112,'Virgo'],
  [-170122112,-169921724,'Libra'],
  [-169921724,-169708555,'Scorpio'],
  [-169708555,-169489326,'Sagittarius'],
  [-169489326,-169273258,'Capricorn'],
  [-169273258,-169065998,'Aquarius'],
  [-169065998,-168867893,'Pisces'],
  [-168867893,-168676588,'Aries'],
  [-168676588,-168489843,'Taurus'],
  [-168489843,-168306405,'Gemini'],
  [-168306405,-168125013,'Cancer'],
  [-168125013,-167942857,'Leo'],
  [-167942857,-167755257,'Virgo'],
  [-167755257,-167557231,'Libra'],
  [-167557231,-167346769,'Scorpio'],
  [-167346769,-167128205,'Sagittarius'],
  [-167128205,-166911161,'Capricorn'],
  [-166911161,-166703864,'Aquarius'],
  [-166703864,-166508175,'Pisces'],
  [-166508175,-166320840,'Aries'],
  [-166320840,-166137243,'Taurus'],
  [-166137243,-165954023,'Gemini'],
  [-165954023,-165769643,'Cancer'],
  [-165769643,-165583071,'Leo'],
  [-165583071,-165392133,'Virgo'],
  [-165392133,-165193407,'Libra'],
  [-165193407,-164984280,'Scorpio'],
  [-164984280,-164766507,'Sagittarius'],
  [-164766507,-164547880,'Capricorn'],
  [-164547880,-164338040,'Aquarius'],
  [-164338040,-164141710,'Pisces'],
  [-164141710,-163956940,'Aries'],
  [-163956940,-163778207,'Taurus'],
  [-163778207,-163599760,'Gemini'],
  [-163599760,-163417555,'Cancer'],
  [-163417555,-163229681,'Leo'],
  [-163229681,-163035356,'Virgo'],
  [-163035356,-162833719,'Libra'],
  [-162833719,-162623819,'Scorpio'],
  [-162623819,-162406469,'Sagittarius'],
  [-162406469,-162186721,'Capricorn'],
  [-162186721,-161973105,'Aquarius'],
  [-161973105,-161772583,'Pisces'],
  [-161772583,-161586188,'Aries'],
  [-161586188,-161409680,'Taurus'],
  [-161409680,-161236571,'Gemini'],
  [-161236571,-161060485,'Cancer'],
  [-161060485,-160876647,'Leo'],
  [-160876647,-160682759,'Virgo'],
  [-160682759,-160478966,'Libra'],
  [-160478966,-160266977,'Scorpio'],
  [-160266977,-160049214,'Sagittarius'],
  [-160049214,-159829373,'Capricorn'],
  [-159829373,-159613225,'Aquarius'],
  [-159613225,-159407278,'Pisces'],
  [-159407278,-159215241,'Aries'],
  [-159215241,-159035920,'Taurus'],
  [-159035920,-158864248,'Gemini'],
  [-158864248,-158693358,'Cancer'],
  [-158693358,-158516313,'Leo'],
  [-158516313,-158327746,'Virgo'],
  [-158327746,-158125742,'Libra'],
  [-158125742,-157912775,'Scorpio'],
  [-157912775,-157694020,'Sagittarius'],
  [-157694020,-157474556,'Capricorn'],
  [-157474556,-157258445,'Aquarius'],
  [-157258445,-157049524,'Pisces'],
  [-157049524,-156851376,'Aries'],
  [-156851376,-156665498,'Taurus'],
  [-156665498,-156489909,'Gemini'],
  [-156489909,-156319359,'Cancer'],
  [-156319359,-156146726,'Leo'],
  [-156146726,-155964741,'Virgo'],
  [-155964741,-155768350,'Libra'],
  [-155768350,-155557682,'Scorpio'],
  [-155557682,-155338728,'Sagittarius'],
  [-155338728,-155119349,'Capricorn'],
  [-155119349,-154904673,'Aquarius'],
  [-154904673,-154696605,'Pisces'],
  [-154696605,-154496177,'Aries'],
  [-154496177,-154304635,'Taurus'],
  [-154304635,-154122362,'Gemini'],
  [-154122362,-153947140,'Cancer'],
  [-153947140,-153773687,'Leo'],
  [-153773687,-153594907,'Virgo'],
  [-153594907,-153404084,'Libra'],
  [-153404084,-153198184,'Scorpio'],
  [-153198184,-152980985,'Sagittarius'],
  [-152980985,-152761539,'Capricorn'],
  [-152761539,-152547710,'Aquarius'],
  [-152547710,-152342126,'Pisces'],
  [-152342126,-152143833,'Aries'],
  [-152143833,-151951565,'Taurus'],
  [-151951565,-151765032,'Gemini'],
  [-151765032,-151583819,'Cancer'],
  [-151583819,-151405469,'Leo'],
  [-151405469,-151224963,'Virgo'],
  [-151224963,-151036084,'Libra'],
  [-151036084,-150834203,'Scorpio'],
  [-150834203,-150619987,'Sagittarius'],
  [-150619987,-150400871,'Capricorn'],
  [-150400871,-150186495,'Aquarius'],
  [-150186495,-149982077,'Pisces'],
  [-149982077,-149787082,'Aries'],
  [-149787082,-149598320,'Taurus'],
  [-149598320,-149412949,'Gemini'],
  [-149412949,-149229392,'Cancer'],
  [-149229392,-149046338,'Leo'],
  [-149046338,-148861291,'Virgo'],
  [-148861291,-148670286,'Libra'],
  [-148670286,-148469334,'Scorpio'],
  [-148469334,-148257369,'Sagittarius'],
  [-148257369,-148038960,'Capricorn'],
  [-148038960,-147823079,'Aquarius'],
  [-147823079,-147617282,'Pisces'],
  [-147617282,-147423379,'Aries'],
  [-147423379,-147238397,'Taurus'],
  [-147238397,-147057668,'Gemini'],
  [-147057668,-146877025,'Cancer'],
  [-146877025,-146693575,'Leo'],
  [-146693575,-146505353,'Virgo'],
  [-146505353,-146310625,'Libra'],
  [-146310625,-146107712,'Scorpio'],
  [-146107712,-145896029,'Sagittarius'],
  [-145896029,-145678174,'Capricorn'],
  [-145678174,-145460747,'Aquarius'],
  [-145460747,-145251691,'Pisces'],
  [-145251691,-145055499,'Aries'],
  [-145055499,-144871283,'Taurus'],
  [-144871283,-144694476,'Gemini'],
  [-144694476,-144519204,'Cancer'],
  [-144519204,-144340017,'Leo'],
  [-144340017,-144153031,'Virgo'],
  [-144153031,-143956571,'Libra'],
  [-143956571,-143751021,'Scorpio'],
  [-143751021,-143537987,'Sagittarius'],
  [-143537987,-143320128,'Capricorn'],
  [-143320128,-143101871,'Aquarius'],
  [-143101871,-142889460,'Pisces'],
  [-142889460,-142688635,'Aries'],
  [-142688635,-142501310,'Taurus'],
  [-142501310,-142324794,'Gemini'],
  [-142324794,-142153264,'Cancer'],
  [-142153264,-141979734,'Leo'],
  [-141979734,-141797839,'Virgo'],
  [-141797839,-141603727,'Libra'],
  [-141603727,-141397594,'Scorpio'],
  [-141397594,-141183077,'Sagittarius'],
  [-141183077,-140964728,'Capricorn'],
  [-140964728,-140746525,'Aquarius'],
  [-140746525,-140532447,'Pisces'],
  [-140532447,-140327166,'Aries'],
  [-140327166,-140134319,'Taurus'],
  [-140134319,-139954009,'Gemini'],
  [-139954009,-139782166,'Cancer'],
  [-139782166,-139611911,'Leo'],
  [-139611911,-139435555,'Virgo'],
  [-139435555,-139246789,'Libra'],
  [-139246789,-139043461,'Scorpio'],
  [-139043461,-138829071,'Sagittarius'],
  [-138829071,-138610266,'Capricorn'],
  [-138610266,-138392560,'Aquarius'],
  [-138392560,-138178996,'Pisces'],
  [-138178996,-137971966,'Aries'],
  [-137971966,-137774369,'Taurus'],
  [-137774369,-137588135,'Gemini'],
  [-137588135,-137411927,'Cancer'],
  [-137411927,-137240633,'Leo'],
  [-137240633,-137066878,'Virgo'],
  [-137066878,-136883179,'Libra'],
  [-136883179,-136684815,'Scorpio'],
  [-136684815,-136472929,'Sagittarius'],
  [-136472929,-136254399,'Capricorn'],
  [-136254399,-136037016,'Aquarius'],
  [-136037016,-135825015,'Pisces'],
  [-135825015,-135619437,'Aries'],
  [-135619437,-135420833,'Taurus'],
  [-135420833,-135230350,'Gemini'],
  [-135230350,-135048298,'Cancer'],
  [-135048298,-134872212,'Leo'],
  [-134872212,-134696673,'Virgo'],
  [-134696673,-134514800,'Libra'],
  [-134514800,-134320683,'Scorpio'],
  [-134320683,-134112670,'Sagittarius'],
  [-134112670,-133895526,'Capricorn'],
  [-133895526,-133677971,'Aquarius'],
  [-133677971,-133466763,'Pisces'],
  [-133466763,-133263812,'Aries'],
  [-133263812,-133068018,'Taurus'],
  [-133068018,-132877993,'Gemini'],
  [-132877993,-132692934,'Cancer'],
  [-132692934,-132511614,'Leo'],
  [-132511614,-132331147,'Virgo'],
  [-132331147,-132146921,'Libra'],
  [-132146921,-131953866,'Scorpio'],
  [-131953866,-131748912,'Sagittarius'],
  [-131748912,-131533841,'Capricorn'],
  [-131533841,-131315847,'Aquarius'],
  [-131315847,-131103505,'Pisces'],
  [-131103505,-130901429,'Aries'],
  [-130901429,-130709141,'Taurus'],
  [-130709141,-130523443,'Gemini'],
  [-130523443,-130340786,'Cancer'],
  [-130340786,-130158322,'Leo'],
  [-130158322,-129973803,'Virgo'],
  [-129973803,-129785000,'Libra'],
  [-129785000,-129589413,'Scorpio'],
  [-129589413,-129384877,'Sagittarius'],
  [-129384877,-129171408,'Capricorn'],
  [-129171408,-128953223,'Aquarius'],
  [-128953223,-128738253,'Pisces'],
  [-128738253,-128533736,'Aries'],
  [-128533736,-128341952,'Taurus'],
  [-128341952,-128160190,'Gemini'],
  [-128160190,-127983118,'Cancer'],
  [-127983118,-127805061,'Leo'],
  [-127805061,-127621590,'Virgo'],
  [-127621590,-127430395,'Libra'],
  [-127430395,-127231145,'Scorpio'],
  [-127231145,-127024400,'Sagittarius'],
  [-127024400,-126810961,'Capricorn'],
  [-126810961,-126592966,'Aquarius'],
  [-126592966,-126375625,'Pisces'],
  [-126375625,-126166445,'Aries'],
  [-126166445,-125970833,'Taurus'],
  [-125970833,-125788782,'Gemini'],
  [-125788782,-125615413,'Cancer'],
  [-125615413,-125443534,'Leo'],
  [-125443534,-125266022,'Virgo'],
  [-125266022,-125077894,'Libra'],
  [-125077894,-124878037,'Scorpio'],
  [-124878037,-124668920,'Sagittarius'],
  [-124668920,-124454040,'Capricorn'],
  [-124454040,-124236100,'Aquarius'],
  [-124236100,-124018036,'Pisces'],
  [-124018036,-123805039,'Aries'],
  [-123805039,-123603391,'Taurus'],
  [-123603391,-123416334,'Gemini'],
  [-123416334,-123241581,'Cancer'],
  [-123241581,-123072527,'Leo'],
  [-123072527,-122900987,'Virgo'],
  [-122900987,-122719526,'Libra'],
  [-122719526,-122524019,'Scorpio'],
  [-122524019,-122315665,'Sagittarius'],
  [-122315665,-122099669,'Capricorn'],
  [-122099669,-121881306,'Aquarius'],
  [-121881306,-121663808,'Pisces'],
  [-121663808,-121450021,'Aries'],
  [-121450021,-121244244,'Taurus'],
  [-121244244,-121050713,'Gemini'],
  [-121050713,-120870204,'Cancer'],
  [-120870204,-120698619,'Leo'],
  [-120698619,-120528688,'Virgo'],
  [-120528688,-120352387,'Libra'],
  [-120352387,-120163308,'Scorpio'],
  [-120163308,-119959477,'Sagittarius'],
  [-119959477,-119744728,'Capricorn'],
  [-119744728,-119526093,'Aquarius'],
  [-119526093,-119309211,'Pisces'],
  [-119309211,-119096906,'Aries'],
  [-119096906,-118891118,'Taurus'],
  [-118891118,-118694201,'Gemini'],
  [-118694201,-118507682,'Cancer'],
  [-118507682,-118330145,'Leo'],
  [-118330145,-118156825,'Virgo'],
  [-118156825,-117981002,'Libra'],
  [-117981002,-117795978,'Scorpio'],
  [-117795978,-117597499,'Sagittarius'],
  [-117597499,-117386288,'Capricorn'],
  [-117386288,-117168407,'Aquarius'],
  [-117168407,-116951580,'Pisces'],
  [-116951580,-116740778,'Aries'],
  [-116740778,-116537579,'Taurus'],
  [-116537579,-116341938,'Gemini'],
  [-116341938,-116153447,'Cancer'],
  [-116153447,-115971030,'Leo'],
  [-115971030,-115792140,'Virgo'],
  [-115792140,-115612592,'Libra'],
  [-115612592,-115427271,'Scorpio'],
  [-115427271,-115231662,'Sagittarius'],
  [-115231662,-115024110,'Capricorn'],
  [-115024110,-114807913,'Aquarius'],
  [-114807913,-114590689,'Pisces'],
  [-114590689,-114379867,'Aries'],
  [-114379867,-114178817,'Taurus'],
  [-114178817,-113986796,'Gemini'],
  [-113986796,-113800987,'Cancer'],
  [-113800987,-113618287,'Leo'],
  [-113618287,-113436007,'Virgo'],
  [-113436007,-113251740,'Libra'],
  [-113251740,-113062894,'Scorpio'],
  [-113062894,-112866608,'Sagittarius'],
  [-112866608,-112660765,'Capricorn'],
  [-112660765,-112446197,'Aquarius'],
  [-112446197,-112228430,'Pisces'],
  [-112228430,-112015833,'Aries'],
  [-112015833,-111814443,'Taurus'],
  [-111814443,-111624899,'Gemini'],
  [-111624899,-111443467,'Cancer'],
  [-111443467,-111264732,'Leo'],
  [-111264732,-111083847,'Virgo'],
  [-111083847,-110897774,'Libra'],
  [-110897774,-110705338,'Scorpio'],
  [-110705338,-110506132,'Sagittarius'],
  [-110506132,-110299554,'Capricorn'],
  [-110299554,-110085642,'Aquarius'],
  [-110085642,-109867462,'Pisces'],
  [-109867462,-109652197,'Aries'],
  [-109652197,-109447724,'Taurus'],
  [-109447724,-109257344,'Gemini'],
  [-109257344,-109078351,'Cancer'],
  [-109078351,-108904405,'Leo'],
  [-108904405,-108728517,'Virgo'],
  [-108728517,-108545306,'Libra'],
  [-108545306,-108352535,'Scorpio'],
  [-108352535,-108150951,'Sagittarius'],
  [-108150951,-107942302,'Capricorn'],
  [-107942302,-107727869,'Aquarius'],
  [-107727869,-107509527,'Pisces'],
  [-107509527,-107292148,'Aries'],
  [-107292148,-107083309,'Taurus'],
  [-107083309,-106888716,'Gemini'],
  [-106888716,-106708203,'Cancer'],
  [-106708203,-106536305,'Leo'],
  [-106536305,-106365289,'Virgo'],
  [-106365289,-106187775,'Libra'],
  [-106187775,-105998954,'Scorpio'],
  [-105998954,-105798190,'Sagittarius'],
  [-105798190,-105588257,'Capricorn'],
  [-105588257,-105372721,'Aquarius'],
  [-105372721,-105154360,'Pisces'],
  [-105154360,-104936457,'Aries'],
  [-104936457,-104724475,'Taurus'],
  [-104724475,-104524415,'Gemini'],
  [-104524415,-104338748,'Cancer'],
  [-104338748,-104164469,'Leo'],
  [-104164469,-103994830,'Virgo'],
  [-103994830,-103821978,'Libra'],
  [-103821978,-103639134,'Scorpio'],
  [-103639134,-103442843,'Sagittarius'],
  [-103442843,-103234330,'Capricorn'],
  [-103234330,-103018298,'Aquarius'],
  [-103018298,-102799853,'Pisces'],
  [-102799853,-102582788,'Aries'],
  [-102582788,-102370604,'Taurus'],
  [-102370604,-102167262,'Gemini'],
  [-102167262,-101975721,'Cancer'],
  [-101975721,-101795589,'Leo'],
  [-101795589,-101622648,'Virgo'],
  [-101622648,-101450347,'Libra'],
  [-101450347,-101271666,'Scorpio'],
  [-101271666,-101081072,'Sagittarius'],
  [-101081072,-100876767,'Capricorn'],
  [-100876767,-100661987,'Aquarius'],
  [-100661987,-100443424,'Pisces'],
  [-100443424,-100227270,'Aries'],
  [-100227270,-100017126,'Taurus'],
  [-100017126,-99814646,'Gemini'],
  [-99814646,-99620645,'Cancer'],
  [-99620645,-99435025,'Leo'],
  [-99435025,-99255960,'Virgo'],
  [-99255960,-99079613,'Libra'],
  [-99079613,-98900646,'Scorpio'],
  [-98900646,-98713401,'Sagittarius'],
  [-98713401,-98513822,'Capricorn'],
  [-98513822,-98302036,'Aquarius'],
  [-98302036,-98083746,'Pisces'],
  [-98083746,-97867393,'Aries'],
  [-97867393,-97658961,'Taurus'],
  [-97658961,-97459833,'Gemini'],
  [-97459833,-97268305,'Cancer'],
  [-97268305,-97081922,'Leo'],
  [-97081922,-96898614,'Virgo'],
  [-96898614,-96716538,'Libra'],
  [-96716538,-96533217,'Scorpio'],
  [-96533217,-96344977,'Sagittarius'],
  [-96344977,-96147664,'Capricorn'],
  [-96147664,-95938975,'Aquarius'],
  [-95938975,-95721645,'Pisces'],
  [-95721645,-95503969,'Aries'],
  [-95503969,-95294785,'Taurus'],
  [-95294785,-95097715,'Gemini'],
  [-95097715,-94910570,'Cancer'],
  [-94910570,-94728416,'Leo'],
  [-94728416,-94546578,'Virgo'],
  [-94546578,-94362234,'Libra'],
  [-94362234,-94174327,'Scorpio'],
  [-94174327,-93982001,'Sagittarius'],
  [-93982001,-93783272,'Capricorn'],
  [-93783272,-93575729,'Aquarius'],
  [-93575729,-93359535,'Pisces'],
  [-93359535,-93140444,'Aries'],
  [-93140444,-92928106,'Taurus'],
  [-92928106,-92729341,'Gemini'],
  [-92729341,-92543978,'Cancer'],
  [-92543978,-92366634,'Leo'],
  [-92366634,-92190436,'Virgo'],
  [-92190436,-92009773,'Libra'],
  [-92009773,-91821865,'Scorpio'],
  [-91821865,-91626599,'Sagittarius'],
  [-91626599,-91424591,'Capricorn'],
  [-91424591,-91215672,'Aquarius'],
  [-91215672,-90999798,'Pisces'],
  [-90999798,-90780088,'Aries'],
  [-90780088,-90564270,'Taurus'],
  [-90564270,-90360732,'Gemini'],
  [-90360732,-90172541,'Cancer'],
  [-90172541,-89996164,'Leo'],
  [-89996164,-89824538,'Virgo'],
  [-89824538,-89650240,'Libra'],
  [-89650240,-89467628,'Scorpio'],
  [-89467628,-89274300,'Sagittarius'],
  [-89274300,-89071002,'Capricorn'],
  [-89071002,-88859937,'Aquarius'],
  [-88859937,-88643236,'Pisces'],
  [-88643236,-88423573,'Aries'],
  [-88423573,-88206073,'Taurus'],
  [-88206073,-87997806,'Gemini'],
  [-87997806,-87803769,'Cancer'],
  [-87803769,-87623507,'Leo'],
  [-87623507,-87451799,'Virgo'],
  [-87451799,-87281373,'Libra'],
  [-87281373,-87105111,'Scorpio'],
  [-87105111,-86917762,'Sagittarius'],
  [-86917762,-86717480,'Capricorn'],
  [-86717480,-86506286,'Aquarius'],
  [-86506286,-86288606,'Pisces'],
  [-86288606,-86069041,'Aries'],
  [-86069041,-85851925,'Taurus'],
  [-85851925,-85641802,'Gemini'],
  [-85641802,-85442752,'Cancer'],
  [-85442752,-85256241,'Leo'],
  [-85256241,-85079920,'Virgo'],
  [-85079920,-84908467,'Libra'],
  [-84908467,-84735193,'Scorpio'],
  [-84735193,-84553568,'Sagittarius'],
  [-84553568,-84358963,'Capricorn'],
  [-84358963,-84150780,'Aquarius'],
  [-84150780,-83933420,'Pisces'],
  [-83933420,-83713844,'Aries'],
  [-83713844,-83497908,'Taurus'],
  [-83497908,-83288969,'Gemini'],
  [-83288969,-83088663,'Cancer'],
  [-83088663,-82897686,'Leo'],
  [-82897686,-82715348,'Virgo'],
  [-82715348,-82539011,'Libra'],
  [-82539011,-82364049,'Scorpio'],
  [-82364049,-82184519,'Sagittarius'],
  [-82184519,-81994585,'Capricorn'],
  [-81994585,-81790920,'Aquarius'],
  [-81790920,-81575598,'Pisces'],
  [-81575598,-81356155,'Aries'],
  [-81356155,-81140878,'Taurus'],
  [-81140878,-80934148,'Gemini'],
  [-80934148,-80736071,'Cancer'],
  [-80736071,-80544982,'Leo'],
  [-80544982,-80359307,'Virgo'],
  [-80359307,-80177691,'Libra'],
  [-80177691,-79998004,'Scorpio'],
  [-79998004,-79816419,'Sagittarius'],
  [-79816419,-79627759,'Capricorn'],
  [-79627759,-79427446,'Aquarius'],
  [-79427446,-79214850,'Pisces'],
  [-79214850,-78995837,'Aries'],
  [-78995837,-78780079,'Taurus'],
  [-78780079,-78574351,'Gemini'],
  [-78574351,-78379295,'Cancer'],
  [-78379295,-78191556,'Leo'],
  [-78191556,-78007224,'Virgo'],
  [-78007224,-77823755,'Libra'],
  [-77823755,-77639877,'Scorpio'],
  [-77639877,-77454049,'Sagittarius'],
  [-77454049,-77263239,'Capricorn'],
  [-77263239,-77063524,'Aquarius'],
  [-77063524,-76852812,'Pisces'],
  [-76852812,-76634378,'Aries'],
  [-76634378,-76417169,'Taurus'],
  [-76417169,-76210097,'Gemini'],
  [-76210097,-76016040,'Cancer'],
  [-76016040,-75831848,'Leo'],
  [-75831848,-75651938,'Virgo'],
  [-75651938,-75471363,'Libra'],
  [-75471363,-75287266,'Scorpio'],
  [-75287266,-75098528,'Sagittarius'],
  [-75098528,-74904198,'Capricorn'],
  [-74904198,-74702535,'Aquarius'],
  [-74702535,-74491957,'Pisces'],
  [-74491957,-74273932,'Aries'],
  [-74273932,-74055121,'Taurus'],
  [-74055121,-73844734,'Gemini'],
  [-73844734,-73648312,'Cancer'],
  [-73648312,-73464765,'Leo'],
  [-73464765,-73288627,'Virgo'],
  [-73288627,-73113372,'Libra'],
  [-73113372,-72933617,'Scorpio'],
  [-72933617,-72746245,'Sagittarius'],
  [-72746245,-72550307,'Capricorn'],
  [-72550307,-72346029,'Aquarius'],
  [-72346029,-72134040,'Pisces'],
  [-72134040,-71915980,'Aries'],
  [-71915980,-71696344,'Taurus'],
  [-71696344,-71482494,'Gemini'],
  [-71482494,-71281132,'Cancer'],
  [-71281132,-71094102,'Leo'],
  [-71094102,-70917948,'Virgo'],
  [-70917948,-70746360,'Libra'],
  [-70746360,-70572494,'Scorpio'],
  [-70572494,-70390586,'Sagittarius'],
  [-70390586,-70197302,'Capricorn'],
  [-70197302,-69992539,'Aquarius'],
  [-69992539,-69778949,'Pisces'],
  [-69778949,-69560345,'Aries'],
  [-69560345,-69340920,'Taurus'],
  [-69340920,-69125586,'Gemini'],
  [-69125586,-68919603,'Cancer'],
  [-68919603,-68726452,'Leo'],
  [-68726452,-68545721,'Virgo'],
  [-68545721,-68373229,'Libra'],
  [-68373229,-68202539,'Scorpio'],
  [-68202539,-68026574,'Sagittarius'],
  [-68026574,-67839285,'Capricorn'],
  [-67839285,-67637858,'Aquarius'],
  [-67637858,-67424498,'Pisces'],
  [-67424498,-67205273,'Aries'],
  [-67205273,-66986405,'Taurus'],
  [-66986405,-66772038,'Gemini'],
  [-66772038,-66564787,'Cancer'],
  [-66564787,-66366869,'Leo'],
  [-66366869,-66179514,'Virgo'],
  [-66179514,-66001593,'Libra'],
  [-66001593,-65828999,'Scorpio'],
  [-65828999,-65655321,'Sagittarius'],
  [-65655321,-65473399,'Capricorn'],
  [-65473399,-65277659,'Aquarius'],
  [-65277659,-65067412,'Pisces'],
  [-65067412,-64848504,'Aries'],
  [-64848504,-64629727,'Taurus'],
  [-64629727,-64417047,'Gemini'],
  [-64417047,-64211955,'Cancer'],
  [-64211955,-64013944,'Leo'],
  [-64013944,-63822804,'Virgo'],
  [-63822804,-63638642,'Libra'],
  [-63638642,-63460252,'Scorpio'],
  [-63460252,-63283751,'Sagittarius'],
  [-63283751,-63102987,'Capricorn'],
  [-63102987,-62911477,'Aquarius'],
  [-62911477,-62705686,'Pisces'],
  [-62705686,-62488656,'Aries'],
  [-62488656,-62269548,'Taurus'],
  [-62269548,-62057185,'Gemini'],
  [-62057185,-61854645,'Cancer'],
  [-61854645,-61660153,'Leo'],
  [-61660153,-61470768,'Virgo'],
  [-61470768,-61284733,'Libra'],
  [-61284733,-61101392,'Scorpio'],
  [-61101392,-60919389,'Sagittarius'],
  [-60919389,-60735245,'Capricorn'],
  [-60735245,-60543850,'Aquarius'],
  [-60543850,-60340840,'Pisces'],
  [-60340840,-60126308,'Aries'],
  [-60126308,-59907076,'Taurus'],
  [-59907076,-59693147,'Gemini'],
  [-59693147,-59490609,'Cancer'],
  [-59490609,-59299053,'Leo'],
  [-59299053,-59114337,'Virgo'],
  [-59114337,-58932018,'Libra'],
  [-58932018,-58749131,'Scorpio'],
  [-58749131,-58564090,'Sagittarius'],
  [-58564090,-58375399,'Capricorn'],
  [-58375399,-58180671,'Aquarius'],
  [-58180671,-57977140,'Pisces'],
  [-57977140,-57763953,'Aries'],
  [-57763953,-57544999,'Taurus'],
  [-57544999,-57328726,'Gemini'],
  [-57328726,-57123176,'Cancer'],
  [-57123176,-56930917,'Leo'],
  [-56930917,-56749024,'Virgo'],
  [-56749024,-56572021,'Libra'],
  [-56572021,-56394386,'Scorpio'],
  [-56394386,-56211927,'Sagittarius'],
  [-56211927,-56022218,'Capricorn'],
  [-56022218,-55824306,'Aquarius'],
  [-55824306,-55618105,'Pisces'],
  [-55618105,-55404309,'Aries'],
  [-55404309,-55185585,'Taurus'],
  [-55185585,-54967652,'Gemini'],
  [-54967652,-54757907,'Cancer'],
  [-54757907,-54561370,'Leo'],
  [-54561370,-54377945,'Virgo'],
  [-54377945,-54203287,'Libra'],
  [-54203287,-54031025,'Scorpio'],
  [-54031025,-53854644,'Sagittarius'],
  [-53854644,-53668987,'Capricorn'],
  [-53668987,-53471666,'Aquarius'],
  [-53471666,-53263679,'Pisces'],
  [-53263679,-53048279,'Aries'],
  [-53048279,-52829335,'Taurus'],
  [-52829335,-52611024,'Gemini'],
  [-52611024,-52398376,'Cancer'],
  [-52398376,-52196515,'Leo'],
  [-52196515,-52007957,'Virgo'],
  [-52007957,-51831019,'Libra'],
  [-51831019,-51660406,'Scorpio'],
  [-51660406,-51488964,'Sagittarius'],
  [-51488964,-51309496,'Capricorn'],
  [-51309496,-51116849,'Aquarius'],
  [-51116849,-50910344,'Pisces'],
  [-50910344,-50694271,'Aries'],
  [-50694271,-50474875,'Taurus'],
  [-50474875,-50257048,'Gemini'],
  [-50257048,-50044005,'Cancer'],
  [-50044005,-49838876,'Leo'],
  [-49838876,-49644646,'Virgo'],
  [-49644646,-49462174,'Libra'],
  [-49462174,-49288670,'Scorpio'],
  [-49288670,-49118081,'Sagittarius'],
  [-49118081,-48942820,'Capricorn'],
  [-48942820,-48755889,'Aquarius'],
  [-48755889,-48553813,'Pisces'],
  [-48553813,-48339303,'Aries'],
  [-48339303,-48119884,'Taurus'],
  [-48119884,-47902635,'Gemini'],
  [-47902635,-47690983,'Cancer'],
  [-47690983,-47486047,'Leo'],
  [-47486047,-47289008,'Virgo'],
  [-47289008,-47101181,'Libra'],
  [-47101181,-46922122,'Scorpio'],
  [-46922122,-46748173,'Sagittarius'],
  [-46748173,-46573002,'Capricorn'],
  [-46573002,-46389426,'Aquarius'],
  [-46389426,-46192111,'Pisces'],
  [-46192111,-45980975,'Aries'],
  [-45980975,-45762443,'Taurus'],
  [-45762443,-45545350,'Gemini'],
  [-45545350,-45335117,'Cancer'],
  [-45335117,-45132616,'Leo'],
  [-45132616,-44936872,'Virgo'],
  [-44936872,-44747337,'Libra'],
  [-44747337,-44563764,'Scorpio'],
  [-44563764,-44384556,'Sagittarius'],
  [-44384556,-44205756,'Capricorn'],
  [-44205756,-44021667,'Aquarius'],
  [-44021667,-43826823,'Pisces'],
  [-43826823,-43619049,'Aries'],
  [-43619049,-43402142,'Taurus'],
  [-43402142,-43184687,'Gemini'],
  [-43184687,-42974411,'Cancer'],
  [-42974411,-42773947,'Leo'],
  [-42773947,-42581726,'Virgo'],
  [-42581726,-42394908,'Libra'],
  [-42394908,-42211170,'Scorpio'],
  [-42211170,-42028699,'Sagittarius'],
  [-42028699,-41845249,'Capricorn'],
  [-41845249,-41657563,'Aquarius'],
  [-41657563,-41461866,'Pisces'],
  [-41461866,-41255663,'Aries'],
  [-41255663,-41040340,'Taurus'],
  [-41040340,-40822301,'Gemini'],
  [-40822301,-40610089,'Cancer'],
  [-40610089,-40409072,'Leo'],
  [-40409072,-40219214,'Virgo'],
  [-40219214,-40036886,'Libra'],
  [-40036886,-39857382,'Scorpio'],
  [-39857382,-39676536,'Sagittarius'],
  [-39676536,-39491362,'Capricorn'],
  [-39491362,-39299960,'Aquarius'],
  [-39299960,-39101091,'Pisces'],
  [-39101091,-38894011,'Aries'],
  [-38894011,-38679393,'Taurus'],
  [-38679393,-38461003,'Gemini'],
  [-38461003,-38245911,'Cancer'],
  [-38245911,-38041297,'Leo'],
  [-38041297,-37850100,'Virgo'],
  [-37850100,-37670066,'Libra'],
  [-37670066,-37495664,'Scorpio'],
  [-37495664,-37320393,'Sagittarius'],
  [-37320393,-37138635,'Capricorn'],
  [-37138635,-36947157,'Aquarius'],
  [-36947157,-36745768,'Pisces'],
  [-36745768,-36536333,'Aries'],
  [-36536333,-36321146,'Taurus'],
  [-36321146,-36102816,'Gemini'],
  [-36102816,-35885723,'Cancer'],
  [-35885723,-35676324,'Leo'],
  [-35676324,-35480027,'Virgo'],
  [-35480027,-35297642,'Libra'],
  [-35297642,-35124958,'Scorpio'],
  [-35124958,-34954815,'Sagittarius'],
  [-34954815,-34779485,'Capricorn'],
  [-34779485,-34592863,'Aquarius'],
  [-34592863,-34392857,'Pisces'],
  [-34392857,-34182145,'Aries'],
  [-34182145,-33965658,'Taurus'],
  [-33965658,-33747410,'Gemini'],
  [-33747410,-33530257,'Cancer'],
  [-33530257,-33318035,'Leo'],
  [-33318035,-33115894,'Virgo'],
  [-33115894,-32927317,'Libra'],
  [-32927317,-32751150,'Scorpio'],
  [-32751150,-32581655,'Sagittarius'],
  [-32581655,-32410832,'Capricorn'],
  [-32410832,-32230764,'Aquarius'],
  [-32230764,-32036289,'Pisces'],
  [-32036289,-31827793,'Aries'],
  [-31827793,-31610945,'Taurus'],
  [-31610945,-31392446,'Gemini'],
  [-31392446,-31176335,'Cancer'],
  [-31176335,-30964678,'Leo'],
  [-30964678,-30760056,'Virgo'],
  [-30760056,-30565682,'Libra'],
  [-30565682,-30382870,'Scorpio'],
  [-30382870,-30208869,'Sagittarius'],
  [-30208869,-30037406,'Capricorn'],
  [-30037406,-29860772,'Aquarius'],
  [-29860772,-29672195,'Pisces'],
  [-29672195,-29468836,'Aries'],
  [-29468836,-29254016,'Taurus'],
  [-29254016,-29035424,'Gemini'],
  [-29035424,-28819876,'Cancer'],
  [-28819876,-28610372,'Leo'],
  [-28610372,-28407588,'Virgo'],
  [-28407588,-28212110,'Libra'],
  [-28212110,-28024614,'Scorpio'],
  [-28024614,-27844306,'Sagittarius'],
  [-27844306,-27667771,'Capricorn'],
  [-27667771,-27489425,'Aquarius'],
  [-27489425,-27303084,'Pisces'],
  [-27303084,-27104302,'Aries'],
  [-27104302,-26893137,'Taurus'],
  [-26893137,-26675339,'Gemini'],
  [-26675339,-26459299,'Cancer'],
  [-26459299,-26250796,'Leo'],
  [-26250796,-26051167,'Virgo'],
  [-26051167,-25859022,'Libra'],
  [-25859022,-25672334,'Scorpio'],
  [-25672334,-25489193,'Sagittarius'],
  [-25489193,-25307454,'Capricorn'],
  [-25307454,-25124176,'Aquarius'],
  [-25124176,-24935588,'Pisces'],
  [-24935588,-24737979,'Aries'],
  [-24737979,-24529658,'Taurus'],
  [-24529658,-24313297,'Gemini'],
  [-24313297,-24096202,'Cancer'],
  [-24096202,-23886386,'Leo'],
  [-23886386,-23687812,'Virgo'],
  [-23687812,-23499462,'Libra'],
  [-23499462,-23317362,'Scorpio'],
  [-23317362,-23136928,'Sagittarius'],
  [-23136928,-22954445,'Capricorn'],
  [-22954445,-22767545,'Aquarius'],
  [-22767545,-22574820,'Pisces'],
  [-22574820,-22375027,'Aries'],
  [-22375027,-22167099,'Taurus'],
  [-22167099,-21951786,'Gemini'],
  [-21951786,-21733756,'Cancer'],
  [-21733756,-21521006,'Leo'],
  [-21521006,-21320190,'Virgo'],
  [-21320190,-21132624,'Libra'],
  [-21132624,-20954474,'Scorpio'],
  [-20954474,-20779400,'Sagittarius'],
  [-20779400,-20601141,'Capricorn'],
  [-20601141,-20415368,'Aquarius'],
  [-20415368,-20220675,'Pisces'],
  [-20220675,-20017908,'Aries'],
  [-20017908,-19808316,'Taurus'],
  [-19808316,-19592969,'Gemini'],
  [-19592969,-19374468,'Cancer'],
  [-19374468,-19158807,'Leo'],
  [-19158807,-18953563,'Virgo'],
  [-18953563,-18762907,'Libra'],
  [-18762907,-18585005,'Scorpio'],
  [-18585005,-18413600,'Sagittarius'],
  [-18413600,-18240987,'Capricorn'],
  [-18240987,-18060418,'Aquarius'],
  [-18060418,-17868212,'Pisces'],
  [-17868212,-17664853,'Aries'],
  [-17664853,-17453493,'Taurus'],
  [-17453493,-17237272,'Gemini'],
  [-17237272,-17018696,'Cancer'],
  [-17018696,-16801601,'Leo'],
  [-16801601,-16592196,'Virgo'],
  [-16592196,-16396142,'Libra'],
  [-16396142,-16214415,'Scorpio'],
  [-16214415,-16042545,'Sagittarius'],
  [-16042545,-15873047,'Capricorn'],
  [-15873047,-15698031,'Aquarius'],
  [-15698031,-15511423,'Pisces'],
  [-15511423,-15311230,'Aries'],
  [-15311230,-15100138,'Taurus'],
  [-15100138,-14883181,'Gemini'],
  [-14883181,-14664671,'Cancer'],
  [-14664671,-14447891,'Leo'],
  [-14447891,-14236827,'Virgo'],
  [-14236827,-14036168,'Libra'],
  [-14036168,-13848571,'Scorpio'],
  [-13848571,-13672251,'Sagittarius'],
  [-13672251,-13501522,'Capricorn'],
  [-13501522,-13328968,'Aquarius'],
  [-13328968,-13147521,'Pisces'],
  [-13147521,-12952695,'Aries'],
  [-12952695,-12744646,'Taurus'],
  [-12744646,-12528178,'Gemini'],
  [-12528178,-12309720,'Cancer'],
  [-12309720,-12094056,'Leo'],
  [-12094056,-11884158,'Virgo'],
  [-11884158,-11682376,'Libra'],
  [-11682376,-11490484,'Scorpio'],
  [-11490484,-11308279,'Sagittarius'],
  [-11308279,-11132657,'Capricorn'],
  [-11132657,-10958202,'Aquarius'],
  [-10958202,-10778563,'Pisces'],
  [-10778563,-10588198,'Aries'],
  [-10588198,-10384592,'Taurus'],
  [-10384592,-10170191,'Gemini'],
  [-10170191,-9951850,'Cancer'],
  [-9951850,-9736785,'Leo'],
  [-9736785,-9529105,'Virgo'],
  [-9529105,-9329708,'Libra'],
  [-9329708,-9137882,'Scorpio'],
  [-9137882,-8952380,'Sagittarius'],
  [-8952380,-8771343,'Capricorn'],
  [-8771343,-8591869,'Aquarius'],
  [-8591869,-8409879,'Pisces'],
  [-8409879,-8220675,'Aries'],
  [-8220675,-8020473,'Taurus'],
  [-8020473,-7808887,'Gemini'],
  [-7808887,-7590913,'Cancer'],
  [-7590913,-7375129,'Leo'],
  [-7375129,-7168303,'Virgo'],
  [-7168303,-6972086,'Libra'],
  [-6972086,-6784029,'Scorpio'],
  [-6784029,-6600280,'Sagittarius'],
  [-6600280,-6417546,'Capricorn'],
  [-6417546,-6233666,'Aquarius'],
  [-6233666,-6046977,'Pisces'],
  [-6046977,-5855261,'Aries'],
  [-5855261,-5655594,'Taurus'],
  [-5655594,-5446045,'Gemini'],
  [-5446045,-5228732,'Cancer'],
  [-5228732,-5011198,'Leo'],
  [-5011198,-4802480,'Virgo'],
  [-4802480,-4606942,'Libra'],
  [-4606942,-4422612,'Scorpio'],
  [-4422612,-4243897,'Sagittarius'],
  [-4243897,-4064837,'Capricorn'],
  [-4064837,-3881285,'Aquarius'],
  [-3881285,-3691699,'Pisces'],
  [-3691699,-3496080,'Aries'],
  [-3496080,-3294082,'Taurus'],
  [-3294082,-3084593,'Gemini'],
  [-3084593,-2867894,'Cancer'],
  [-2867894,-2648786,'Leo'],
  [-2648786,-2436199,'Virgo'],
  [-2436199,-2237398,'Libra'],
  [-2237398,-2053047,'Scorpio'],
  [-2053047,-1877983,'Sagittarius'],
  [-1877983,-1704778,'Capricorn'],
  [-1704778,-1526636,'Aquarius'],
  [-1526636,-1339459,'Pisces'],
  [-1339459,-1142698,'Aries'],
  [-1142698,-937939,'Taurus'],
  [-937939,-726690,'Gemini'],
  [-726690,-509945,'Cancer'],
  [-509945,-290404,'Leo'],
  [-290404,-74532,'Virgo'],
  [-74532,129800,'Libra'],
  [129800,318772,'Scorpio'],
  [318772,494990,'Sagittarius'],
  [494990,665246,'Capricorn'],
  [665246,837384,'Aquarius'],
  [837384,1018062,'Pisces'],
  [1018062,1210821,'Aries'],
  [1210821,1415206,'Taurus'],
  [1415206,1628010,'Gemini'],
  [1628010,1845593,'Cancer'],
  [1845593,2064755,'Leo'],
  [2064755,2281329,'Virgo'],
  [2281329,2489643,'Libra'],
  [2489643,2684989,'Scorpio'],
  [2684989,2866893,'Sagittarius'],
  [2866893,3039558,'Capricorn'],
  [3039558,3209826,'Aquarius'],
  [3209826,3385018,'Pisces'],
  [3385018,3571136,'Aries'],
  [3571136,3770930,'Taurus'],
  [3770930,3982601,'Gemini'],
  [3982601,4200785,'Cancer'],
  [4200785,4419693,'Leo'],
  [4419693,4634974,'Virgo'],
  [4634974,4843390,'Libra'],
  [4843390,5042289,'Scorpio'],
  [5042289,5230444,'Sagittarius'],
  [5230444,5409272,'Capricorn'],
  [5409272,5582924,'Aquarius'],
  [5582924,5757361,'Pisces'],
  [5757361,5939008,'Aries'],
  [5939008,6132992,'Taurus'],
  [6132992,6340702,'Gemini'],
  [6340702,6557967,'Cancer'],
  [6557967,6776975,'Leo'],
  [6776975,6990992,'Virgo'],
  [6990992,7196986,'Libra'],
  [7196986,7394791,'Scorpio'],
  [7394791,7585198,'Sagittarius'],
  [7585198,7769285,'Capricorn'],
  [7769285,7948844,'Aquarius'],
  [7948844,8127111,'Pisces'],
  [8127111,8308920,'Aries'],
  [8308920,8499705,'Taurus'],
  [8499705,8703186,'Gemini'],
  [8703186,8918132,'Cancer'],
  [8918132,9137211,'Leo'],
  [9137211,9351291,'Virgo'],
  [9351291,9555313,'Libra'],
  [9555313,9749677,'Scorpio'],
  [9749677,9937578,'Sagittarius'],
  [9937578,10122174,'Capricorn'],
  [10122174,10305444,'Aquarius'],
  [10305444,10488747,'Pisces'],
  [10488747,10674296,'Aries'],
  [10674296,10865841,'Taurus'],
  [10865841,11067400,'Gemini'],
  [11067400,11280105,'Cancer'],
  [11280105,11499029,'Leo'],
  [11499029,11714548,'Virgo'],
  [11714548,11918954,'Libra'],
  [11918954,12111050,'Scorpio'],
  [12111050,12294774,'Sagittarius'],
  [12294774,12475528,'Capricorn'],
  [12475528,12657515,'Aquarius'],
  [12657515,12842798,'Pisces'],
  [12842798,13032186,'Aries'],
  [13032186,13226975,'Taurus'],
  [13226975,13429510,'Gemini'],
  [13429510,13641392,'Cancer'],
  [13641392,13860107,'Leo'],
  [13860107,14077654,'Virgo'],
  [14077654,14284892,'Libra'],
  [14284892,14477935,'Scorpio'],
  [14477935,14659475,'Sagittarius'],
  [14659475,14835630,'Capricorn'],
  [14835630,15012686,'Aquarius'],
  [15012686,15195113,'Pisces'],
  [15195113,15384871,'Aries'],
  [15384871,15582245,'Taurus'],
  [15582245,15787250,'Gemini'],
  [15787250,15999943,'Cancer'],
  [15999943,16218650,'Leo'],
  [16218650,16437740,'Virgo'],
  [16437740,16648841,'Libra'],
  [16648841,16845944,'Scorpio'],
  [16845944,17029147,'Sagittarius'],
  [17029147,17203471,'Capricorn'],
  [17203471,17375787,'Aquarius'],
  [17375787,17552543,'Pisces'],
  [17552543,17738274,'Aries'],
  [17738274,17934761,'Taurus'],
  [17934761,18141231,'Gemini'],
  [18141231,18355431,'Cancer'],
  [18355431,18574444,'Leo'],
  [18574444,18793938,'Virgo'],
  [18793938,19007786,'Libra'],
  [19007786,19210028,'Scorpio'],
  [19210028,19398288,'Sagittarius'],
  [19398288,19575055,'Capricorn'],
  [19575055,19746062,'Aquarius'],
  [19746062,19918203,'Pisces'],
  [19918203,20097950,'Aries'],
  [20097950,20289797,'Taurus'],
  [20289797,20494673,'Gemini'],
  [20494673,20709477,'Cancer'],
  [20709477,20928936,'Leo'],
  [20928936,21147920,'Virgo'],
  [21147920,21362049,'Libra'],
  [21362049,21567477,'Scorpio'],
  [21567477,21761483,'Sagittarius'],
  [21761483,21944013,'Capricorn'],
  [21944013,22118214,'Aquarius'],
  [22118214,22289694,'Pisces'],
  [22289694,22465249,'Aries'],
  [22465249,22651308,'Taurus'],
  [22651308,22851649,'Gemini'],
  [22851649,23064851,'Cancer'],
  [23064851,23284396,'Leo'],
  [23284396,23502782,'Virgo'],
  [23502782,23715316,'Libra'],
  [23715316,23920274,'Scorpio'],
  [23920274,24117005,'Sagittarius'],
  [24117005,24305140,'Capricorn'],
  [24305140,24485404,'Aquarius'],
  [24485404,24660717,'Pisces'],
  [24660717,24836375,'Aries'],
  [24836375,25018987,'Taurus'],
  [25018987,25214317,'Gemini'],
  [25214317,25423926,'Cancer'],
  [25423926,25642610,'Leo'],
  [25642610,25861007,'Virgo'],
  [25861007,26072087,'Libra'],
  [26072087,26274237,'Scorpio'],
  [26274237,26469141,'Sagittarius'],
  [26469141,26658642,'Capricorn'],
  [26658642,26843561,'Aquarius'],
  [26843561,27024697,'Pisces'],
  [27024697,27204596,'Aries'],
  [27204596,27388094,'Taurus'],
  [27388094,27580970,'Gemini'],
  [27580970,27786934,'Cancer'],
  [27786934,28003781,'Leo'],
  [28003781,28222738,'Virgo'],
  [28222738,28434272,'Libra'],
  [28434272,28634526,'Scorpio'],
  [28634526,28825522,'Sagittarius'],
  [28825522,29011470,'Capricorn'],
  [29011470,29195711,'Aquarius'],
  [29195711,29379791,'Pisces'],
  [29379791,29564648,'Aries'],
  [29564648,29752391,'Taurus'],
  [29752391,29946719,'Gemini'],
  [29946719,30151275,'Cancer'],
  [30151275,30366260,'Leo'],
  [30366260,30585663,'Virgo'],
  [30585663,30799610,'Libra'],
  [30799610,31001246,'Scorpio'],
  [31001246,31190470,'Sagittarius'],
  [31190470,31371809,'Capricorn'],
  [31371809,31550855,'Aquarius'],
  [31550855,31731982,'Pisces'],
  [31731982,31917606,'Aries'],
  [31917606,32108891,'Taurus'],
  [32108891,32306922,'Gemini'],
  [32306922,32513027,'Cancer'],
  [32513027,32727438,'Leo'],
  [32727438,32946773,'Virgo'],
  [32946773,33163426,'Libra'],
  [33163426,33369327,'Scorpio'],
  [33369327,33561146,'Sagittarius'],
  [33561146,33741352,'Capricorn'],
  [33741352,33915686,'Aquarius'],
  [33915686,34090549,'Pisces'],
  [34090549,34271314,'Aries'],
  [34271314,34461262,'Taurus'],
  [34461262,34661195,'Gemini'],
  [34661195,34869964,'Cancer'],
  [34869964,35085454,'Leo'],
  [35085454,35304592,'Virgo'],
  [35304592,35522484,'Libra'],
  [35522484,35732719,'Scorpio'],
  [35732719,35930203,'Sagittarius'],
  [35930203,36114171,'Capricorn'],
  [36114171,36288310,'Aquarius'],
  [36288310,36458968,'Pisces'],
  [36458968,36633236,'Aries'],
  [36633236,36817279,'Taurus'],
  [36817279,37014434,'Gemini'],
  [37014434,37223710,'Cancer'],
  [37223710,37440610,'Leo'],
  [37440610,37659936,'Virgo'],
  [37659936,37877453,'Libra'],
  [37877453,38089395,'Scorpio'],
  [38089395,38291828,'Sagittarius'],
  [38291828,38482118,'Capricorn'],
  [38482118,38660850,'Aquarius'],
  [38660850,38832315,'Pisces'],
  [38832315,39003323,'Aries'],
  [39003323,39181403,'Taurus'],
  [39181403,39372634,'Gemini'],
  [39372634,39578720,'Cancer'],
  [39578720,39795361,'Leo'],
  [39795361,40015002,'Virgo'],
  [40015002,40231657,'Libra'],
  [40231657,40442564,'Scorpio'],
  [40442564,40646276,'Sagittarius'],
  [40646276,40841126,'Capricorn'],
  [40841126,41026057,'Aquarius'],
  [41026057,41202496,'Pisces'],
  [41202496,41375184,'Aries'],
  [41375184,41551097,'Taurus'],
  [41551097,41737396,'Gemini'],
  [41737396,41938463,'Cancer'],
  [41938463,42152566,'Leo'],
  [42152566,42371938,'Virgo'],
  [42371938,42588192,'Libra'],
  [42588192,42797246,'Scorpio'],
  [42797246,42998931,'Sagittarius'],
  [42998931,43193962,'Capricorn'],
  [43193962,43382347,'Aquarius'],
  [43382347,43564255,'Pisces'],
  [43564255,43741871,'Aries'],
  [43741871,43920050,'Taurus'],
  [43920050,44105149,'Gemini'],
  [44105149,44302565,'Cancer'],
  [44302565,44513265,'Leo'],
  [44513265,44731571,'Virgo'],
  [44731571,44948152,'Libra'],
  [44948152,45156476,'Scorpio'],
  [45156476,45355488,'Sagittarius'],
  [45355488,45547355,'Capricorn'],
  [45547355,45734475,'Aquarius'],
  [45734475,45918336,'Pisces'],
  [45918336,46100317,'Aries'],
  [46100317,46283021,'Taurus'],
  [46283021,46470592,'Gemini'],
  [46470592,46667510,'Cancer'],
  [46667510,46875953,'Leo'],
  [46875953,47092924,'Virgo'],
  [47092924,47310350,'Libra'],
  [47310350,47519921,'Scorpio'],
  [47519921,47718186,'Sagittarius'],
  [47718186,47906779,'Capricorn'],
  [47906779,48089647,'Aquarius'],
  [48089647,48270726,'Pisces'],
  [48270726,48453018,'Aries'],
  [48453018,48638795,'Taurus'],
  [48638795,48830189,'Gemini'],
  [48830189,49029380,'Cancer'],
  [49029380,49237748,'Leo'],
  [49237748,49453886,'Virgo'],
  [49453886,49672195,'Libra'],
  [49672195,49884572,'Scorpio'],
  [49884572,50085110,'Sagittarius'],
  [50085110,50273189,'Capricorn'],
  [50273189,50452451,'Aquarius'],
  [50452451,50628401,'Pisces'],
  [50628401,50806521,'Aries'],
  [50806521,50991028,'Taurus'],
  [50991028,51184170,'Gemini'],
  [51184170,51386242,'Cancer'],
  [51386242,51596312,'Leo'],
  [51596312,51812547,'Virgo'],
  [51812547,52031321,'Libra'],
  [52031321,52246590,'Scorpio'],
  [52246590,52451651,'Sagittarius'],
  [52451651,52643028,'Capricorn'],
  [52643028,52822240,'Aquarius'],
  [52822240,52994594,'Pisces'],
  [52994594,53167046,'Aries'],
  [53167046,53346282,'Taurus'],
  [53346282,53536835,'Gemini'],
  [53536835,53739453,'Cancer'],
  [53739453,53951324,'Leo'],
  [53951324,54168418,'Virgo'],
  [54168418,54387166,'Libra'],
  [54387166,54603787,'Scorpio'],
  [54603787,54813146,'Sagittarius'],
  [54813146,55010317,'Capricorn'],
  [55010317,55193796,'Aquarius'],
  [55193796,55366832,'Pisces'],
  [55366832,55536117,'Aries'],
  [55536117,55709577,'Taurus'],
  [55709577,55894219,'Gemini'],
  [55894219,56093417,'Cancer'],
  [56093417,56304965,'Leo'],
  [56304965,56522837,'Virgo'],
  [56522837,56741433,'Libra'],
  [56741433,56957484,'Scorpio'],
  [56957484,57168307,'Sagittarius'],
  [57168307,57370257,'Capricorn'],
  [57370257,57560200,'Aquarius'],
  [57560200,57738364,'Pisces'],
  [57738364,57909319,'Aries'],
  [57909319,58080437,'Taurus'],
  [58080437,58259679,'Gemini'],
  [58259679,58452985,'Cancer'],
  [58452985,58661042,'Leo'],
  [58661042,58878323,'Virgo'],
  [58878323,59096954,'Libra'],
  [59096954,59311772,'Scorpio'],
  [59311772,59520978,'Sagittarius'],
  [59520978,59723525,'Capricorn'],
  [59723525,59917653,'Aquarius'],
  [59917653,60102209,'Pisces'],
  [60102209,60278886,'Aries'],
  [60278886,60452714,'Taurus'],
  [60452714,60630655,'Gemini'],
  [60630655,60819409,'Cancer'],
  [60819409,61022430,'Leo'],
  [61022430,61237139,'Virgo'],
  [61237139,61455685,'Libra'],
  [61455685,61670229,'Scorpio'],
  [61670229,61877227,'Sagittarius'],
  [61877227,62076750,'Capricorn'],
  [62076750,62269789,'Aquarius'],
  [62269789,62456938,'Pisces'],
  [62456938,62639090,'Aries'],
  [62639090,62818694,'Taurus'],
  [62818694,63000075,'Gemini'],
  [63000075,63188506,'Cancer'],
  [63188506,63388206,'Leo'],
  [63388206,63599571,'Virgo'],
  [63599571,63817391,'Libra'],
  [63817391,64033033,'Scorpio'],
  [64033033,64239943,'Sagittarius'],
  [64239943,64436619,'Capricorn'],
  [64436619,64625272,'Aquarius'],
  [64625272,64809314,'Pisces'],
  [64809314,64991824,'Aries'],
  [64991824,65175220,'Taurus'],
  [65175220,65361690,'Gemini'],
  [65361690,65553674,'Cancer'],
  [65553674,65753731,'Leo'],
  [65753731,65963181,'Virgo'],
  [65963181,66179854,'Libra'],
  [66179854,66397065,'Scorpio'],
  [66397065,66606583,'Sagittarius'],
  [66606583,66803766,'Capricorn'],
  [66803766,66989451,'Aquarius'],
  [66989451,67168238,'Pisces'],
  [67168238,67345884,'Aries'],
  [67345884,67527330,'Taurus'],
  [67527330,67715522,'Gemini'],
  [67715522,67911279,'Cancer'],
  [67911279,68114338,'Leo'],
  [68114338,68324389,'Virgo'],
  [68324389,68540405,'Libra'],
  [68540405,68758582,'Scorpio'],
  [68758582,68971751,'Sagittarius'],
  [68971751,69172948,'Capricorn'],
  [69172948,69359962,'Aquarius'],
  [69359962,69536214,'Pisces'],
  [69536214,69708444,'Aries'],
  [69708444,69883944,'Taurus'],
  [69883944,70068374,'Gemini'],
  [70068374,70263950,'Cancer'],
  [70263950,70469243,'Leo'],
  [70469243,70681301,'Virgo'],
  [70681301,70897702,'Libra'],
  [70897702,71116014,'Scorpio'],
  [71116014,71331616,'Sagittarius'],
  [71331616,71537831,'Capricorn'],
  [71537831,71729868,'Aquarius'],
  [71729868,71908330,'Pisces'],
  [71908330,72078865,'Aries'],
  [72078865,72249386,'Taurus'],
  [72249386,72427549,'Gemini'],
  [72427549,72618392,'Cancer'],
  [72618392,72822250,'Leo'],
  [72822250,73035252,'Virgo'],
  [73035252,73252536,'Libra'],
  [73252536,73470632,'Scorpio'],
  [73470632,73686510,'Sagittarius'],
  [73686510,73895696,'Capricorn'],
  [73895696,74093264,'Aquarius'],
  [74093264,74277288,'Pisces'],
  [74277288,74450833,'Aries'],
  [74450833,74620621,'Taurus'],
  [74620621,74794555,'Gemini'],
  [74794555,74979458,'Cancer'],
  [74979458,75178550,'Leo'],
  [75178550,75389770,'Virgo'],
  [75389770,75607242,'Libra'],
  [75607242,75825179,'Scorpio'],
  [75825179,76039951,'Sagittarius'],
  [76039951,76248896,'Capricorn'],
  [76248896,76449109,'Aquarius'],
  [76449109,76638446,'Pisces'],
  [76638446,76817669,'Aries'],
  [76817669,76991048,'Taurus'],
  [76991048,77165073,'Gemini'],
  [77165073,77346578,'Cancer'],
  [77346578,77540583,'Leo'],
  [77540583,77747910,'Virgo'],
  [77747910,77964150,'Libra'],
  [77964150,78182046,'Scorpio'],
  [78182046,78395774,'Sagittarius'],
  [78395774,78602542,'Capricorn'],
  [78602542,78801501,'Aquarius'],
  [78801501,78992517,'Pisces'],
  [78992517,79176282,'Aries'],
  [79176282,79355075,'Taurus'],
  [79355075,79532949,'Gemini'],
  [79532949,79715105,'Cancer'],
  [79715105,79906559,'Leo'],
  [79906559,80110113,'Virgo'],
  [80110113,80324104,'Libra'],
  [80324104,80541971,'Scorpio'],
  [80541971,80755802,'Sagittarius'],
  [80755802,80960821,'Capricorn'],
  [80960821,81156520,'Aquarius'],
  [81156520,81345004,'Pisces'],
  [81345004,81529045,'Aries'],
  [81529045,81711196,'Taurus'],
  [81711196,81893857,'Gemini'],
  [81893857,82079755,'Cancer'],
  [82079755,82272157,'Leo'],
  [82272157,82474040,'Virgo'],
  [82474040,82685961,'Libra'],
  [82685961,82903729,'Scorpio'],
  [82903729,83119061,'Sagittarius'],
  [83119061,83324582,'Capricorn'],
  [83324582,83518104,'Aquarius'],
  [83518104,83702418,'Pisces'],
  [83702418,83882566,'Aries'],
  [83882566,84063340,'Taurus'],
  [84063340,84247884,'Gemini'],
  [84247884,84437608,'Cancer'],
  [84437608,84633298,'Leo'],
  [84633298,84836191,'Virgo'],
  [84836191,85047318,'Libra'],
  [85047318,85264921,'Scorpio'],
  [85264921,85482439,'Sagittarius'],
  [85482439,85691065,'Capricorn'],
  [85691065,85885738,'Aquarius'],
  [85885738,86067862,'Pisces'],
  [86067862,86243251,'Aries'],
  [86243251,86418858,'Taurus'],
  [86418858,86600313,'Gemini'],
  [86600313,86790309,'Cancer'],
  [86790309,86988635,'Leo'],
  [86988635,87194079,'Virgo'],
  [87194079,87406018,'Libra'],
  [87406018,87623539,'Scorpio'],
  [87623539,87842630,'Sagittarius'],
  [87842630,88055456,'Capricorn'],
  [88055456,88254741,'Aquarius'],
  [88254741,88438951,'Pisces'],
  [88438951,88612638,'Aries'],
  [88612638,88783332,'Taurus'],
  [88783332,88958647,'Gemini'],
  [88958647,89144051,'Cancer'],
  [89144051,89341148,'Leo'],
  [89341148,89548016,'Virgo'],
  [89548016,89761573,'Libra'],
  [89761573,89979372,'Scorpio'],
  [89979372,90198648,'Sagittarius'],
  [90198648,90414133,'Capricorn'],
  [90414133,90618966,'Aquarius'],
  [90618966,90809040,'Pisces'],
  [90809040,90985976,'Aries'],
  [90985976,91155907,'Taurus'],
  [91155907,91326651,'Gemini'],
  [91326651,91505485,'Cancer'],
  [91505485,91697059,'Leo'],
  [91697059,91901693,'Virgo'],
  [91901693,92115736,'Libra'],
  [92115736,92334138,'Scorpio'],
  [92334138,92552779,'Sagittarius'],
  [92552779,92768003,'Capricorn'],
  [92768003,92975549,'Aquarius'],
  [92975549,93171557,'Pisces'],
  [93171557,93355133,'Aries'],
  [93355133,93529457,'Taurus'],
  [93529457,93700594,'Gemini'],
  [93700594,93875639,'Cancer'],
  [93875639,94060953,'Leo'],
  [94060953,94260082,'Virgo'],
  [94260082,94471798,'Libra'],
  [94471798,94690277,'Scorpio'],
  [94690277,94908600,'Sagittarius'],
  [94908600,95122014,'Capricorn'],
  [95122014,95328157,'Aquarius'],
  [95328157,95525844,'Pisces'],
  [95525844,95714652,'Aries'],
  [95714652,95895644,'Taurus'],
  [95895644,96071913,'Gemini'],
  [96071913,96248401,'Cancer'],
  [96248401,96431005,'Leo'],
  [96431005,96624959,'Virgo'],
  [96624959,96832306,'Libra'],
  [96832306,97049416,'Scorpio'],
  [97049416,97268032,'Sagittarius'],
  [97268032,97480515,'Capricorn'],
  [97480515,97683725,'Aquarius'],
  [97683725,97878527,'Pisces'],
  [97878527,98067205,'Aries'],
  [98067205,98251779,'Taurus'],
  [98251779,98433855,'Gemini'],
  [98433855,98615522,'Cancer'],
  [98615522,98800263,'Leo'],
  [98800263,98992672,'Virgo'],
  [98992672,99196488,'Libra'],
  [99196488,99411253,'Scorpio'],
  [99411253,99630217,'Sagittarius'],
  [99630217,99843726,'Capricorn'],
  [99843726,100045855,'Aquarius'],
  [100045855,100237007,'Pisces'],
  [100237007,100421435,'Aries'],
  [100421435,100603835,'Taurus'],
  [100603835,100787329,'Gemini'],
  [100787329,100973242,'Cancer'],
  [100973242,101162517,'Leo'],
  [101162517,101357267,'Virgo'],
  [101357267,101560511,'Libra'],
  [101560511,101773560,'Scorpio'],
  [101773560,101992538,'Sagittarius'],
  [101992538,102208335,'Capricorn'],
  [102208335,102412486,'Aquarius'],
  [102412486,102602880,'Pisces'],
  [102602880,102783485,'Aries'],
  [102783485,102960700,'Taurus'],
  [102960700,103140251,'Gemini'],
  [103140251,103325465,'Cancer'],
  [103325465,103517187,'Leo'],
  [103517187,103715385,'Virgo'],
  [103715385,103920655,'Libra'],
  [103920655,104133694,'Scorpio'],
  [104133694,104352536,'Sagittarius'],
  [104352536,104570447,'Capricorn'],
  [104570447,104778567,'Aquarius'],
  [104778567,104971994,'Pisces'],
  [104971994,105152486,'Aries'],
  [105152486,105326145,'Taurus'],
  [105326145,105500087,'Gemini'],
  [105500087,105680163,'Cancer'],
  [105680163,105869561,'Leo'],
  [105869561,106068641,'Virgo'],
  [106068641,106276146,'Libra'],
  [106276146,106490481,'Scorpio'],
  [106490481,106709394,'Sagittarius'],
  [106709394,106928221,'Capricorn'],
  [106928221,107139907,'Aquarius'],
  [107139907,107338465,'Pisces'],
  [107338465,107522858,'Aries'],
  [107522858,107697157,'Taurus'],
  [107697157,107868050,'Gemini'],
  [107868050,108042537,'Cancer'],
  [108042537,108226271,'Leo'],
  [108226271,108422137,'Virgo'],
  [108422137,108629506,'Libra'],
  [108629506,108844963,'Scorpio'],
  [108844963,109064194,'Sagittarius'],
  [109064194,109282725,'Capricorn'],
  [109282725,109495712,'Aquarius'],
  [109495712,109698497,'Pisces'],
  [109698497,109888624,'Aries'],
  [109888624,110067461,'Taurus'],
  [110067461,110239684,'Gemini'],
  [110239684,110411722,'Cancer'],
  [110411722,110590253,'Leo'],
  [110590253,110780603,'Virgo'],
  [110780603,110984711,'Libra'],
  [110984711,111199658,'Scorpio'],
  [111199658,111419117,'Sagittarius'],
  [111419117,111636881,'Capricorn'],
  [111636881,111848821,'Aquarius'],
  [111848821,112052604,'Pisces'],
  [112052604,112246843,'Aries'],
  [112246843,112431489,'Taurus'],
  [112431489,112608606,'Gemini'],
  [112608606,112782534,'Cancer'],
  [112782534,112959269,'Leo'],
  [112959269,113145128,'Virgo'],
  [113145128,113344527,'Libra'],
  [113344527,113557001,'Scorpio'],
  [113557001,113776168,'Sagittarius'],
  [113776168,113993533,'Capricorn'],
  [113993533,114203632,'Aquarius'],
  [114203632,114405328,'Pisces'],
  [114405328,114599622,'Aries'],
  [114599622,114787568,'Taurus'],
  [114787568,114970061,'Gemini'],
  [114970061,115148931,'Cancer'],
  [115148931,115327982,'Leo'],
  [115327982,115512736,'Virgo'],
  [115512736,115708645,'Libra'],
  [115708645,115917852,'Scorpio'],
  [115917852,116136045,'Sagittarius'],
  [116136045,116353822,'Capricorn'],
  [116353822,116563211,'Aquarius'],
  [116563211,116762148,'Pisces'],
  [116762148,116953129,'Aries'],
  [116953129,117139663,'Taurus'],
  [117139663,117324055,'Gemini'],
  [117324055,117507380,'Cancer'],
  [117507380,117691099,'Leo'],
  [117691099,117878420,'Virgo'],
  [117878420,118073877,'Libra'],
  [118073877,118280832,'Scorpio'],
  [118280832,118497718,'Sagittarius'],
  [118497718,118716508,'Capricorn'],
  [118716508,118927403,'Aquarius'],
  [118927403,119125729,'Pisces'],
  [119125729,119313345,'Aries'],
  [119313345,119495312,'Taurus'],
  [119495312,119676506,'Gemini'],
  [119676506,119859892,'Cancer'],
  [119859892,120046718,'Leo'],
  [120046718,120238084,'Virgo'],
  [120238084,120436066,'Libra'],
  [120436066,120643044,'Scorpio'],
  [120643044,120859009,'Sagittarius'],
  [120859009,121078680,'Capricorn'],
  [121078680,121292749,'Aquarius'],
  [121292749,121493951,'Pisces'],
  [121493951,121681529,'Aries'],
  [121681529,121859969,'Taurus'],
  [121859969,122035573,'Gemini'],
  [122035573,122213984,'Cancer'],
  [122213984,122398860,'Leo'],
  [122398860,122591723,'Virgo'],
  [122591723,122792791,'Libra'],
  [122792791,123001832,'Scorpio'],
  [123001832,123217950,'Sagittarius'],
  [123217950,123437821,'Capricorn'],
  [123437821,123654710,'Aquarius'],
  [123654710,123861004,'Pisces'],
  [123861004,124052907,'Aries'],
  [124052907,124232276,'Taurus'],
  [124232276,124404711,'Gemini'],
  [124404711,124577056,'Cancer'],
  [124577056,124755629,'Leo'],
  [124755629,124944798,'Virgo'],
  [124944798,125145818,'Libra'],
  [125145818,125356779,'Scorpio'],
  [125356779,125574073,'Sagittarius'],
  [125574073,125793758,'Capricorn'],
  [125793758,126011378,'Aquarius'],
  [126011378,126221629,'Pisces'],
  [126221629,126419865,'Aries'],
  [126419865,126604789,'Taurus'],
  [126604789,126779296,'Gemini'],
  [126779296,126949317,'Cancer'],
  [126949317,127122085,'Leo'],
  [127122085,127304467,'Virgo'],
  [127304467,127500830,'Libra'],
  [127500830,127710713,'Scorpio'],
  [127710713,127928837,'Sagittarius'],
  [127928837,128148583,'Capricorn'],
  [128148583,128365220,'Aquarius'],
  [128365220,128575902,'Pisces'],
  [128575902,128778073,'Aries'],
  [128778073,128969587,'Taurus'],
  [128969587,129150337,'Gemini'],
  [129150337,129323480,'Cancer'],
  [129323480,129495090,'Leo'],
  [129495090,129672595,'Virgo'],
  [129672595,129862662,'Libra'],
  [129862662,130068052,'Scorpio'],
  [130068052,130284942,'Sagittarius'],
  [130284942,130504840,'Capricorn'],
  [130504840,130720499,'Aquarius'],
  [130720499,130929137,'Pisces'],
  [130929137,131130668,'Aries'],
  [131130668,131324997,'Taurus'],
  [131324997,131511569,'Gemini'],
  [131511569,131690925,'Cancer'],
  [131690925,131866378,'Leo'],
  [131866378,132043894,'Virgo'],
  [132043894,132230373,'Libra'],
  [132230373,132430786,'Scorpio'],
  [132430786,132644467,'Sagittarius'],
  [132644467,132863895,'Capricorn'],
  [132863895,133079600,'Aquarius'],
  [133079600,133286541,'Pisces'],
  [133286541,133484966,'Aries'],
  [133484966,133677165,'Taurus'],
  [133677165,133864766,'Gemini'],
  [133864766,134048422,'Cancer'],
  [134048422,134229382,'Leo'],
  [134229382,134410951,'Virgo'],
  [134410951,134598283,'Libra'],
  [134598283,134796418,'Scorpio'],
  [134796418,135006970,'Sagittarius'],
  [135006970,135225236,'Capricorn'],
  [135225236,135441847,'Aquarius'],
  [135441847,135649197,'Pisces'],
  [135649197,135845604,'Aries'],
  [135845604,136033845,'Taurus'],
  [136033845,136217837,'Gemini'],
  [136217837,136400588,'Cancer'],
  [136400588,136584011,'Leo'],
  [136584011,136769929,'Virgo'],
  [136769929,136960975,'Libra'],
  [136960975,137160295,'Scorpio'],
  [137160295,137369682,'Sagittarius'],
  [137369682,137586842,'Capricorn'],
  [137586842,137804573,'Aquarius'],
  [137804573,138014366,'Pisces'],
  [138014366,138211798,'Aries'],
  [138211798,138398032,'Taurus'],
  [138398032,138577534,'Gemini'],
  [138577534,138755502,'Cancer'],
  [138755502,138936317,'Leo'],
  [138936317,139122944,'Virgo'],
  [139122944,139317019,'Libra'],
  [139317019,139519273,'Scorpio'],
  [139519273,139729685,'Sagittarius'],
  [139729685,139946512,'Capricorn'],
  [139946512,140164996,'Aquarius'],
  [140164996,140377938,'Pisces'],
  [140377938,140579171,'Aries'],
  [140579171,140767118,'Taurus'],
  [140767118,140944865,'Gemini'],
  [140944865,141118171,'Cancer'],
  [141118171,141293458,'Leo'],
  [141293458,141476214,'Virgo'],
  [141476214,141669596,'Libra'],
  [141669596,141873625,'Scorpio'],
  [141873625,142085929,'Sagittarius'],
  [142085929,142303273,'Capricorn'],
  [142303273,142521919,'Aquarius'],
  [142521919,142737009,'Pisces'],
  [142737009,142942851,'Aries'],
  [142942851,143135628,'Taurus'],
  [143135628,143315757,'Gemini'],
  [143315757,143487770,'Cancer'],
  [143487770,143658576,'Leo'],
  [143658576,143835513,'Virgo'],
  [143835513,144024316,'Libra'],
  [144024316,144226774,'Scorpio'],
  [144226774,144439831,'Sagittarius'],
  [144439831,144657960,'Capricorn'],
  [144657960,144876382,'Aquarius'],
  [144876382,145091689,'Pisces'],
  [145091689,145300347,'Aries'],
  [145300347,145498484,'Taurus'],
  [145498484,145684114,'Gemini'],
  [145684114,145859169,'Cancer'],
  [145859169,146029343,'Leo'],
  [146029343,146202274,'Virgo'],
  [146202274,146385405,'Libra'],
  [146385405,146583229,'Scorpio'],
  [146583229,146794491,'Sagittarius'],
  [146794491,147012740,'Capricorn'],
  [147012740,147230933,'Aquarius'],
  [147230933,147445065,'Pisces'],
  [147445065,147653409,'Aries'],
  [147653409,147854157,'Taurus'],
  [147854157,148045170,'Gemini'],
  [148045170,148226044,'Cancer'],
  [148226044,148399906,'Leo'],
  [148399906,148572998,'Virgo'],
  [148572998,148752812,'Libra'],
  [148752812,148945571,'Scorpio'],
  [148945571,149152895,'Sagittarius'],
  [149152895,149369887,'Capricorn'],
  [149369887,149588062,'Aquarius'],
  [149588062,149801122,'Pisces'],
  [149801122,150007150,'Aries'],
  [150007150,150206425,'Taurus'],
  [150206425,150398993,'Gemini'],
  [150398993,150584549,'Cancer'],
  [150584549,150764148,'Leo'],
  [150764148,150941440,'Virgo'],
  [150941440,151122180,'Libra'],
  [151122180,151312448,'Scorpio'],
  [151312448,151515826,'Sagittarius'],
  [151515826,151730387,'Capricorn'],
  [151730387,151948596,'Aquarius'],
  [151948596,152162001,'Pisces'],
  [152162001,152366390,'Aries'],
  [152366390,152562161,'Taurus'],
  [152562161,152751644,'Gemini'],
  [152751644,152936995,'Cancer'],
  [152936995,153119876,'Leo'],
  [153119876,153302305,'Virgo'],
  [153302305,153487393,'Libra'],
  [153487393,153679118,'Scorpio'],
  [153679118,153880900,'Sagittarius'],
  [153880900,154093117,'Capricorn'],
  [154093117,154311071,'Aquarius'],
  [154311071,154526336,'Pisces'],
  [154526336,154731881,'Aries'],
  [154731881,154925864,'Taurus'],
  [154925864,155110893,'Gemini'],
  [155110893,155291472,'Cancer'],
  [155291472,155471994,'Leo'],
  [155471994,155655746,'Virgo'],
  [155655746,155844791,'Libra'],
  [155844791,156040455,'Scorpio'],
  [156040455,156243823,'Sagittarius'],
  [156243823,156455276,'Capricorn'],
  [156455276,156672705,'Aquarius'],
  [156672705,156890105,'Pisces'],
  [156890105,157099474,'Aries'],
  [157099474,157295726,'Taurus'],
  [157295726,157479328,'Gemini'],
  [157479328,157655082,'Cancer'],
  [157655082,157829555,'Leo'],
  [157829555,158008891,'Virgo'],
  [158008891,158197111,'Libra'],
  [158197111,158395133,'Scorpio'],
  [158395133,158601483,'Sagittarius'],
  [158601483,158814188,'Capricorn'],
  [158814188,159031394,'Aquarius'],
  [159031394,159249809,'Pisces'],
  [159249809,159463259,'Aries'],
  [159463259,159664962,'Taurus'],
  [159664962,159852016,'Gemini'],
  [159852016,160027199,'Cancer'],
  [160027199,160197222,'Leo'],
  [160197222,160370001,'Virgo'],
  [160370001,160552380,'Libra'],
  [160552380,160747800,'Scorpio'],
  [160747800,160954923,'Sagittarius'],
  [160954923,161169385,'Capricorn'],
  [161169385,161387109,'Aquarius'],
  [161387109,161605324,'Pisces'],
  [161605324,161820534,'Aries'],
  [161820534,162027279,'Taurus'],
  [162027279,162220718,'Gemini'],
  [162220718,162400379,'Cancer'],
  [162400379,162571001,'Leo'],
  [162571001,162740294,'Virgo'],
  [162740294,162916404,'Libra'],
  [162916404,163105525,'Scorpio'],
  [163105525,163309170,'Sagittarius'],
  [163309170,163523367,'Capricorn'],
  [163523367,163741732,'Aquarius'],
  [163741732,163959490,'Pisces'],
  [163959490,164173935,'Aries'],
  [164173935,164382176,'Taurus'],
  [164382176,164580500,'Gemini'],
  [164580500,164766669,'Cancer'],
  [164766669,164942445,'Leo'],
  [164942445,165113471,'Virgo'],
  [165113471,165287259,'Libra'],
  [165287259,165470978,'Scorpio'],
  [165470978,165668891,'Sagittarius'],
  [165668891,165879895,'Capricorn'],
  [165879895,166097802,'Aquarius'],
  [166097802,166315430,'Pisces'],
  [166315430,166528392,'Aries'],
  [166528392,166734853,'Taurus'],
  [166734853,166933620,'Gemini'],
  [166933620,167123646,'Cancer'],
  [167123646,167305337,'Leo'],
  [167305337,167481686,'Virgo'],
  [167481686,167657967,'Libra'],
  [167657967,167840379,'Scorpio'],
  [167840379,168034099,'Sagittarius'],
  [168034099,168240811,'Capricorn'],
  [168240811,168456850,'Aquarius'],
  [168456850,168674554,'Pisces'],
  [168674554,168886992,'Aries'],
  [168886992,169091051,'Taurus'],
  [169091051,169286861,'Gemini'],
  [169286861,169475894,'Cancer'],
  [169475894,169659920,'Leo'],
  [169659920,169841085,'Virgo'],
  [169841085,170022328,'Libra'],
  [170022328,170207477,'Scorpio'],
  [170207477,170400628,'Sagittarius'],
  [170400628,170604540,'Capricorn'],
  [170604540,170818315,'Aquarius'],
  [170818315,171036074,'Pisces'],
  [171036074,171249511,'Aries'],
  [171249511,171452950,'Taurus'],
  [171452950,171645687,'Gemini'],
  [171645687,171830701,'Cancer'],
  [171830701,172012235,'Leo'],
  [172012235,172194042,'Virgo'],
  [172194042,172378730,'Libra'],
  [172378730,172568063,'Scorpio'],
  [172568063,172763739,'Sagittarius'],
  [172763739,172967556,'Capricorn'],
  [172967556,173179977,'Aquarius'],
  [173179977,173397720,'Pisces'],
  [173397720,173613239,'Aries'],
  [173613239,173818697,'Taurus'],
  [173818697,174010976,'Gemini'],
  [174010976,174192601,'Cancer'],
  [174192601,174369317,'Leo'],
  [174369317,174547264,'Virgo'],
  [174547264,174730962,'Libra'],
  [174730962,174922305,'Scorpio'],
  [174922305,175121134,'Sagittarius'],
  [175121134,175326937,'Capricorn'],
  [175326937,175539499,'Aquarius'],
  [175539499,175757223,'Pisces'],
  [175757223,175974799,'Aries'],
  [175974799,176184117,'Taurus'],
  [176184117,176379409,'Gemini'],
  [176379409,176561015,'Cancer'],
  [176561015,176734402,'Leo'],
  [176734402,176907042,'Virgo'],
  [176907042,177085782,'Libra'],
  [177085782,177274752,'Scorpio'],
  [177274752,177474282,'Sagittarius'],
  [177474282,177682139,'Capricorn'],
  [177682139,177895923,'Aquarius'],
  [177895923,178113746,'Pisces'],
  [178113746,178332274,'Aries'],
  [178332274,178545188,'Taurus'],
  [178545188,178745688,'Gemini'],
  [178745688,178931266,'Cancer'],
  [178931266,179105353,'Leo'],
  [179105353,179275063,'Virgo'],
  [179275063,179448325,'Libra'],
  [179448325,179631631,'Scorpio'],
  [179631631,179827856,'Sagittarius'],
  [179827856,180035458,'Capricorn'],
  [180035458,180250300,'Aquarius'],
  [180250300,180468406,'Pisces'],
  [180468406,180686591,'Aries'],
  [180686591,180900765,'Taurus'],
  [180900765,181105603,'Gemini'],
  [181105603,181297221,'Cancer'],
  [181297221,181476185,'Leo'],
  [181476185,181647517,'Virgo'],
  [181647517,181818500,'Libra'],
  [181818500,181996511,'Scorpio'],
  [181996511,182186924,'Sagittarius'],
  [182186924,182390978,'Capricorn'],
  [182390978,182605202,'Aquarius'],
  [182605202,182823596,'Pisces'],
  [182823596,183040983,'Aries'],
  [183040983,183253871,'Taurus'],
  [183253871,183459419,'Gemini'],
  [183459419,183655176,'Cancer'],
  [183655176,183840393,'Leo'],
  [183840393,184017301,'Virgo'],
  [184017301,184190841,'Libra'],
  [184190841,184367380,'Scorpio'],
  [184367380,184553103,'Sagittarius'],
  [184553103,184751946,'Capricorn'],
  [184751946,184963301,'Aquarius'],
  [184963301,185181430,'Pisces'],
  [185181430,185398655,'Aries'],
  [185398655,185609645,'Taurus'],
  [185609645,185812564,'Gemini'],
  [185812564,186007670,'Cancer'],
  [186007670,186195852,'Leo'],
  [186195852,186378453,'Virgo'],
  [186378453,186557789,'Libra'],
  [186557789,186737579,'Scorpio'],
  [186737579,186922694,'Sagittarius'],
  [186922694,187117911,'Capricorn'],
  [187117911,187325488,'Aquarius'],
  [187325488,187542364,'Pisces'],
  [187542364,187760334,'Aries'],
  [187760334,187971135,'Taurus'],
  [187971135,188171322,'Gemini'],
  [188171322,188362404,'Cancer'],
  [188362404,188548051,'Leo'],
  [188548051,188731630,'Virgo'],
  [188731630,188915262,'Libra'],
  [188915262,189100364,'Scorpio'],
  [189100364,189288978,'Sagittarius'],
  [189288978,189484367,'Capricorn'],
  [189484367,189689689,'Aquarius'],
  [189689689,189904843,'Pisces'],
  [189904843,190123770,'Aries'],
  [190123770,190336758,'Taurus'],
  [190336758,190537216,'Gemini'],
  [190537216,190725297,'Cancer'],
  [190725297,190905895,'Leo'],
  [190905895,191085029,'Virgo'],
  [191085029,191267277,'Libra'],
  [191267277,191454663,'Scorpio'],
  [191454663,191647433,'Sagittarius'],
  [191647433,191846034,'Capricorn'],
  [191846034,192051995,'Aquarius'],
  [192051995,192266225,'Pisces'],
  [192266225,192485589,'Aries'],
  [192485589,192701748,'Taurus'],
  [192701748,192905918,'Gemini'],
  [192905918,193095144,'Cancer'],
  [193095144,193273126,'Leo'],
  [193273126,193446828,'Virgo'],
  [193446828,193623211,'Libra'],
  [193623211,193807087,'Scorpio'],
  [193807087,194000043,'Sagittarius'],
  [194000043,194201297,'Capricorn'],
  [194201297,194409692,'Aquarius'],
  [194409692,194624529,'Pisces'],
  [194624529,194843878,'Aries'],
  [194843878,195062133,'Taurus'],
  [195062133,195271123,'Gemini'],
  [195271123,195465325,'Cancer'],
  [195465325,195645518,'Leo'],
  [195645518,195817452,'Virgo'],
  [195817452,195988645,'Libra'],
  [195988645,196166010,'Scorpio'],
  [196166010,196354091,'Sagittarius'],
  [196354091,196553956,'Capricorn'],
  [196553956,196763621,'Aquarius'],
  [196763621,196979814,'Pisces'],
  [196979814,197199228,'Aries'],
  [197199228,197417717,'Taurus'],
  [197417717,197629583,'Gemini'],
  [197629583,197829394,'Cancer'],
  [197829394,198015350,'Leo'],
  [198015350,198190454,'Virgo'],
  [198190454,198360853,'Libra'],
  [198360853,198533686,'Scorpio'],
  [198533686,198715396,'Sagittarius'],
  [198715396,198910036,'Capricorn'],
  [198910036,199117661,'Aquarius'],
  [199117661,199334197,'Pisces'],
  [199334197,199553842,'Aries'],
  [199553842,199771493,'Taurus'],
  [199771493,199983192,'Gemini'],
  [199983192,200185751,'Cancer'],
  [200185751,200377258,'Leo'],
  [200377258,200558359,'Virgo'],
  [200558359,200732554,'Libra'],
  [200732554,200905435,'Scorpio'],
  [200905435,201083479,'Sagittarius'],
  [201083479,201272537,'Capricorn'],
  [201272537,201475594,'Aquarius'],
  [201475594,201690416,'Pisces'],
  [201690416,201910016,'Aries'],
  [201910016,202126919,'Taurus'],
  [202126919,202336728,'Gemini'],
  [202336728,202538246,'Cancer'],
  [202538246,202731651,'Leo'],
  [202731651,202917577,'Virgo'],
  [202917577,203097485,'Libra'],
  [203097485,203274389,'Scorpio'],
  [203274389,203453109,'Sagittarius'],
  [203453109,203639450,'Capricorn'],
  [203639450,203838194,'Aquarius'],
  [203838194,204049931,'Pisces'],
  [204049931,204268884,'Aries'],
  [204268884,204485804,'Taurus'],
  [204485804,204694138,'Gemini'],
  [204694138,204892762,'Cancer'],
  [204892762,205083967,'Leo'],
  [205083967,205270457,'Virgo'],
  [205270457,205453998,'Libra'],
  [205453998,205635918,'Scorpio'],
  [205635918,205818555,'Sagittarius'],
  [205818555,206005982,'Capricorn'],
  [206005982,206202946,'Aquarius'],
  [206202946,206411978,'Pisces'],
  [206411978,206629870,'Aries'],
  [206629870,206847622,'Taurus'],
  [206847622,207056361,'Gemini'],
  [207056361,207253113,'Cancer'],
  [207253113,207440590,'Leo'],
  [207440590,207623601,'Virgo'],
  [207623601,207806114,'Libra'],
  [207806114,207990190,'Scorpio'],
  [207990190,208176859,'Sagittarius'],
  [208176859,208367820,'Capricorn'],
  [208367820,208566029,'Aquarius'],
  [208566029,208774132,'Pisces'],
  [208774132,208991109,'Aries'],
  [208991109,209210033,'Taurus'],
  [209210033,209421227,'Gemini'],
  [209421227,209619036,'Cancer'],
  [209619036,209804611,'Leo'],
  [209804611,209983287,'Virgo'],
  [209983287,210161082,'Libra'],
  [210161082,210342490,'Scorpio'],
  [210342490,210529736,'Sagittarius'],
  [210529736,210723588,'Capricorn'],
  [210723588,210924689,'Aquarius'],
  [210924689,211133877,'Pisces'],
  [211133877,211350596,'Aries'],
  [211350596,211570326,'Taurus'],
  [211570326,211784794,'Gemini'],
  [211784794,211986634,'Cancer'],
  [211986634,212174158,'Leo'],
  [212174158,212351261,'Virgo'],
  [212351261,212524405,'Libra'],
  [212524405,212700078,'Scorpio'],
  [212700078,212883184,'Sagittarius'],
  [212883184,213076147,'Capricorn'],
  [213076147,213278988,'Aquarius'],
  [213278988,213490179,'Pisces'],
  [213490179,213707461,'Aries'],
  [213707461,213927261,'Taurus'],
  [213927261,214143828,'Gemini'],
  [214143828,214350557,'Cancer'],
  [214350557,214543484,'Leo'],
  [214543484,214723586,'Virgo'],
  [214723586,214895809,'Libra'],
  [214895809,215066911,'Scorpio'],
  [215066911,215243710,'Sagittarius'],
  [215243710,215431508,'Capricorn'],
  [215431508,215632391,'Aquarius'],
  [215632391,215844339,'Pisces'],
  [215844339,216062571,'Aries'],
  [216062571,216282054,'Taurus'],
  [216282054,216498463,'Gemini'],
  [216498463,216707766,'Cancer'],
  [216707766,216906374,'Leo'],
  [216906374,217092837,'Virgo'],
  [217092837,217269099,'Libra'],
  [217269099,217440201,'Scorpio'],
  [217440201,217613003,'Sagittarius'],
  [217613003,217794579,'Capricorn'],
  [217794579,217990036,'Aquarius'],
  [217990036,218199680,'Pisces'],
  [218199680,218418073,'Aries'],
  [218418073,218637486,'Taurus'],
  [218637486,218852446,'Gemini'],
  [218852446,219060716,'Cancer'],
  [219060716,219261298,'Leo'],
  [219261298,219453178,'Virgo'],
  [219453178,219636088,'Libra'],
  [219636088,219812029,'Scorpio'],
  [219812029,219985894,'Sagittarius'],
  [219985894,220164493,'Capricorn'],
  [220164493,220354548,'Aquarius'],
  [220354548,220559498,'Pisces'],
  [220559498,220776186,'Aries'],
  [220776186,220995762,'Taurus'],
  [220995762,221209936,'Gemini'],
  [221209936,221415623,'Cancer'],
  [221415623,221613785,'Leo'],
  [221613785,221806058,'Virgo'],
  [221806058,221993051,'Libra'],
  [221993051,222175077,'Scorpio'],
  [222175077,222354109,'Sagittarius'],
  [222354109,222534715,'Capricorn'],
  [222534715,222723004,'Aquarius'],
  [222723004,222923972,'Pisces'],
  [222923972,223137656,'Aries'],
  [223137656,223357018,'Taurus'],
  [223357018,223571997,'Gemini'],
  [223571997,223776682,'Cancer'],
  [223776682,223971422,'Leo'],
  [223971422,224159756,'Virgo'],
  [224159756,224345039,'Libra'],
  [224345039,224529059,'Scorpio'],
  [224529059,224712823,'Sagittarius'],
  [224712823,224898288,'Capricorn'],
  [224898288,225089084,'Aquarius'],
  [225089084,225289345,'Pisces'],
  [225289345,225500764,'Aries'],
  [225500764,225719387,'Taurus'],
  [225719387,225936134,'Gemini'],
  [225936134,226142696,'Cancer'],
  [226142696,226336726,'Leo'],
  [226336726,226521267,'Virgo'],
  [226521267,226701405,'Libra'],
  [226701405,226881706,'Scorpio'],
  [226881706,227065181,'Sagittarius'],
  [227065181,227253584,'Capricorn'],
  [227253584,227448331,'Aquarius'],
  [227448331,227650967,'Pisces'],
  [227650967,227862329,'Aries'],
  [227862329,228080323,'Taurus'],
  [228080323,228298589,'Gemini'],
  [228298589,228508824,'Cancer'],
  [228508824,228705891,'Leo'],
  [228705891,228890337,'Virgo'],
  [228890337,229066781,'Libra'],
  [229066781,229241310,'Scorpio'],
  [229241310,229419619,'Sagittarius'],
  [229419619,229605821,'Capricorn'],
  [229605821,229801762,'Aquarius'],
  [229801762,230007098,'Pisces'],
  [230007098,230220140,'Aries'],
  [230220140,230438238,'Taurus'],
  [230438238,230657098,'Gemini'],
  [230657098,230870574,'Cancer'],
  [230870574,231072711,'Leo'],
  [231072711,231261156,'Virgo'],
  [231261156,231438219,'Libra'],
  [231438219,231609523,'Scorpio'],
  [231609523,231782042,'Sagittarius'],
  [231782042,231962375,'Capricorn'],
  [231962375,232154933,'Aquarius'],
  [232154933,232360173,'Pisces'],
  [232360173,232574645,'Aries'],
  [232574645,232793422,'Taurus'],
  [232793422,233012121,'Gemini'],
  [233012121,233226792,'Cancer'],
  [233226792,233433056,'Leo'],
  [233433056,233627299,'Virgo'],
  [233627299,233808996,'Libra'],
  [233808996,233981618,'Scorpio'],
  [233981618,234151624,'Sagittarius'],
  [234151624,234326616,'Capricorn'],
  [234326616,234513316,'Aquarius'],
  [234513316,234714853,'Pisces'],
  [234714853,234928593,'Aries'],
  [234928593,235147784,'Taurus'],
  [235147784,235366097,'Gemini'],
  [235366097,235579990,'Cancer'],
  [235579990,235787330,'Leo'],
  [235787330,235985720,'Virgo'],
  [235985720,236173315,'Libra'],
  [236173315,236350904,'Scorpio'],
  [236350904,236522876,'Sagittarius'],
  [236522876,236696161,'Capricorn'],
  [236696161,236878259,'Aquarius'],
  [236878259,237074586,'Pisces'],
  [237074586,237285165,'Aries'],
  [237285165,237503685,'Taurus'],
  [237503685,237721766,'Gemini'],
  [237721766,237934265,'Cancer'],
  [237934265,238139898,'Leo'],
  [238139898,238338557,'Virgo'],
  [238338557,238529592,'Libra'],
  [238529592,238712663,'Scorpio'],
  [238712663,238889680,'Sagittarius'],
  [238889680,239065463,'Capricorn'],
  [239065463,239246608,'Aquarius'],
  [239246608,239439256,'Pisces'],
  [239439256,239645870,'Aries'],
  [239645870,239862551,'Taurus'],
  [239862551,240080629,'Gemini'],
  [240080629,240292600,'Cancer'],
  [240292600,240495939,'Leo'],
  [240495939,240691728,'Virgo'],
  [240691728,240881709,'Libra'],
  [240881709,241066954,'Scorpio'],
  [241066954,241248609,'Sagittarius'],
  [241248609,241429242,'Capricorn'],
  [241429242,241613187,'Aquarius'],
  [241613187,241805481,'Pisces'],
  [241805481,242009503,'Aries'],
  [242009503,242224005,'Taurus'],
  [242224005,242442162,'Gemini'],
  [242442162,242655217,'Cancer'],
  [242655217,242858056,'Leo'],
  [242858056,243050840,'Virgo'],
  [243050840,243236712,'Libra'],
  [243236712,243419279,'Scorpio'],
  [243419279,243601447,'Sagittarius'],
  [243601447,243785512,'Capricorn'],
  [243785512,243973775,'Aquarius'],
  [243973775,244168817,'Pisces'],
  [244168817,244372872,'Aries'],
  [244372872,244586003,'Taurus'],
  [244586003,244804123,'Gemini'],
  [244804123,245019456,'Cancer'],
  [245019456,245224707,'Leo'],
  [245224707,245417357,'Virgo'],
  [245417357,245599836,'Libra'],
  [245599836,245777221,'Scorpio'],
  [245777221,245955035,'Sagittarius'],
  [245955035,246137752,'Capricorn'],
  [246137752,246327975,'Aquarius'],
  [246327975,246526433,'Pisces'],
  [246526433,246732766,'Aries'],
  [246732766,246946065,'Taurus'],
  [246946065,247163990,'Gemini'],
  [247163990,247381383,'Cancer'],
  [247381383,247590988,'Leo'],
  [247590988,247787449,'Virgo'],
  [247787449,247970508,'Libra'],
  [247970508,248144612,'Scorpio'],
  [248144612,248316626,'Sagittarius'],
  [248316626,248493583,'Capricorn'],
  [248493583,248680695,'Aquarius'],
  [248680695,248879575,'Pisces'],
  [248879575,249088155,'Aries'],
  [249088155,249302900,'Taurus'],
  [249302900,249520791,'Gemini'],
  [249520791,249738764,'Cancer'],
  [249738764,249951915,'Leo'],
  [249951915,250154249,'Virgo'],
  [250154249,250342385,'Libra'],
  [250342385,250518103,'Scorpio'],
  [250518103,250687553,'Sagittarius'],
  [250687553,250858762,'Capricorn'],
  [250858762,251039331,'Aquarius'],
  [251039331,251233860,'Pisces'],
  [251233860,251441627,'Aries'],
  [251441627,251657473,'Taurus'],
  [251657473,251875779,'Gemini'],
  [251875779,252093086,'Cancer'],
  [252093086,252306804,'Leo'],
  [252306804,252513073,'Virgo'],
  [252513073,252707705,'Libra'],
  [252707705,252889410,'Scorpio'],
  [252889410,253061673,'Sagittarius'],
  [253061673,253231500,'Capricorn'],
  [253231500,253407022,'Aquarius'],
  [253407022,253595087,'Pisces'],
  [253595087,253798218,'Aries'],
  [253798218,254012781,'Taurus'],
  [254012781,254231423,'Gemini'],
  [254231423,254448118,'Cancer'],
  [254448118,254660146,'Leo'],
  [254660146,254866059,'Virgo'],
  [254866059,255063815,'Libra'],
  [255063815,255251607,'Scorpio'],
  [255251607,255430189,'Sagittarius'],
  [255430189,255603850,'Capricorn'],
  [255603850,255779248,'Aquarius'],
  [255779248,255963384,'Pisces'],
  [255963384,256161026,'Aries'],
  [256161026,256371845,'Taurus'],
  [256371845,256589737,'Gemini'],
  [256589737,256806571,'Cancer'],
  [256806571,257017167,'Leo'],
  [257017167,257220199,'Virgo'],
  [257220199,257416080,'Libra'],
  [257416080,257605312,'Scorpio'],
  [257605312,257788665,'Sagittarius'],
  [257788665,257968237,'Capricorn'],
  [257968237,258147939,'Aquarius'],
  [258147939,258332895,'Pisces'],
  [258332895,258527874,'Aries'],
  [258527874,258734894,'Taurus'],
  [258734894,258950930,'Gemini'],
  [258950930,259168330,'Cancer'],
  [259168330,259379368,'Leo'],
  [259379368,259580489,'Virgo'],
  [259580489,259772465,'Libra'],
  [259772465,259958235,'Scorpio'],
  [259958235,260141006,'Sagittarius'],
  [260141006,260323489,'Capricorn'],
  [260323489,260508024,'Aquarius'],
  [260508024,260697053,'Pisces'],
  [260697053,260893291,'Aries'],
  [260893291,261098847,'Taurus'],
  [261098847,261313136,'Gemini'],
  [261313136,261531019,'Cancer'],
  [261531019,261744229,'Leo'],
  [261744229,261946375,'Virgo'],
  [261946375,262136342,'Libra'],
  [262136342,262317607,'Scorpio'],
  [262317607,262495652,'Sagittarius'],
  [262495652,262675676,'Capricorn'],
  [262675676,262861182,'Aquarius'],
  [262861182,263053601,'Pisces'],
  [263053601,263253128,'Aries'],
  [263253128,263459902,'Taurus'],
  [263459902,263673691,'Gemini'],
  [263673691,263891811,'Cancer'],
  [263891811,264107684,'Leo'],
  [264107684,264313453,'Virgo'],
  [264313453,264505126,'Libra'],
  [264505126,264684656,'Scorpio'],
  [264684656,264858080,'Sagittarius'],
  [264858080,265032585,'Capricorn'],
  [265032585,265214186,'Aquarius'],
  [265214186,265405931,'Pisces'],
  [265405931,265607404,'Aries'],
  [265607404,265816411,'Taurus'],
  [265816411,266031010,'Gemini'],
  [266031010,266249240,'Cancer'],
  [266249240,266466882,'Leo'],
  [266466882,266676920,'Virgo'],
  [266676920,266873306,'Libra'],
  [266873306,267055251,'Scorpio'],
  [267055251,267227510,'Sagittarius'],
  [267227510,267397656,'Capricorn'],
  [267397656,267573401,'Aquarius'],
  [267573401,267760365,'Pisces'],
  [267760365,267960052,'Aries'],
  [267960052,268169848,'Taurus'],
  [268169848,268385594,'Gemini'],
  [268385594,268603963,'Cancer'],
  [268603963,268821860,'Leo'],
  [268821860,269034476,'Virgo'],
  [269034476,269236011,'Libra'],
  [269236011,269423388,'Scorpio'],
  [269423388,269598783,'Sagittarius'],
  [269598783,269768496,'Capricorn'],
  [269768496,269940363,'Aquarius'],
  [269940363,270121542,'Pisces'],
  [270121542,270316226,'Aries'],
  [270316226,270523830,'Taurus'],
  [270523830,270739676,'Gemini'],
  [270739676,270958196,'Cancer'],
  [270958196,271175327,'Leo'],
  [271175327,271387774,'Virgo'],
  [271387774,271591874,'Libra'],
  [271591874,271784567,'Scorpio'],
  [271784567,271965778,'Sagittarius'],
  [271965778,272139293,'Capricorn'],
  [272139293,272311468,'Aquarius'],
  [272311468,272489357,'Pisces'],
  [272489357,272678744,'Aries'],
  [272678744,272881867,'Taurus'],
  [272881867,273095929,'Gemini'],
  [273095929,273314362,'Cancer'],
  [273314362,273530769,'Leo'],
  [273530769,273741330,'Virgo'],
  [273741330,273944278,'Libra'],
  [273944278,274138749,'Scorpio'],
  [274138749,274324774,'Sagittarius'],
  [274324774,274504113,'Capricorn'],
  [274504113,274680557,'Aquarius'],
  [274680557,274859381,'Pisces'],
  [274859381,275046168,'Aries'],
  [275046168,275244958,'Taurus'],
  [275244958,275455868,'Gemini'],
  [275455868,275673687,'Cancer'],
  [275673687,275890256,'Leo'],
  [275890256,276099399,'Virgo'],
  [276099399,276299266,'Libra'],
  [276299266,276491190,'Scorpio'],
  [276491190,276677537,'Sagittarius'],
  [276677537,276860544,'Capricorn'],
  [276860544,277042338,'Aquarius'],
  [277042338,277225545,'Pisces'],
  [277225545,277413708,'Aries'],
  [277413708,277610709,'Taurus'],
  [277610709,277818739,'Gemini'],
  [277818739,278035432,'Cancer'],
  [278035432,278253100,'Leo'],
  [278253100,278463044,'Virgo'],
  [278463044,278661148,'Libra'],
  [278661148,278848995,'Scorpio'],
  [278848995,279031225,'Sagittarius'],
  [279031225,279212613,'Capricorn'],
  [279212613,279396355,'Aquarius'],
  [279396355,279583882,'Pisces'],
  [279583882,279776089,'Aries'],
  [279776089,279974669,'Taurus'],
  [279974669,280181753,'Gemini'],
  [280181753,280397321,'Cancer'],
  [280397321,280616225,'Leo'],
  [280616225,280829210,'Virgo'],
  [280829210,281029107,'Libra'],
  [281029107,281215396,'Scorpio'],
  [281215396,281393041,'Sagittarius'],
  [281393041,281568918,'Capricorn'],
  [281568918,281748963,'Aquarius'],
  [281748963,281936371,'Pisces'],
  [281936371,282131416,'Aries'],
  [282131416,282333265,'Taurus'],
  [282333265,282541780,'Gemini'],
  [282541780,282757036,'Cancer'],
  [282757036,282976443,'Leo'],
  [282976443,283192793,'Virgo'],
  [283192793,283397525,'Libra'],
  [283397525,283586845,'Scorpio'],
  [283586845,283763732,'Sagittarius'],
  [283763732,283935174,'Capricorn'],
  [283935174,284108864,'Aquarius'],
  [284108864,284290865,'Pisces'],
  [284290865,284483846,'Aries'],
  [284483846,284686942,'Taurus'],
  [284686942,284897653,'Gemini'],
  [284897653,285113761,'Cancer'],
  [285113761,285332997,'Leo'],
  [285332997,285550818,'Virgo'],
  [285550818,285760245,'Libra'],
  [285760245,285955675,'Scorpio'],
  [285955675,286136845,'Sagittarius'],
  [286136845,286308717,'Capricorn'],
  [286308717,286478707,'Aquarius'],
  [286478707,286654268,'Pisces'],
  [286654268,286840973,'Aries'],
  [286840973,287040769,'Taurus'],
  [287040769,287251531,'Gemini'],
  [287251531,287468715,'Cancer'],
  [287468715,287687850,'Leo'],
  [287687850,287905009,'Virgo'],
  [287905009,288115903,'Libra'],
  [288115903,288316254,'Scorpio'],
  [288316254,288504032,'Sagittarius'],
  [288504032,288681125,'Capricorn'],
  [288681125,288852731,'Aquarius'],
  [288852731,289025636,'Pisces'],
  [289025636,289206546,'Aries'],
  [289206546,289400279,'Taurus'],
  [289400279,289607641,'Gemini'],
  [289607641,289824435,'Cancer'],
  [289824435,290043741,'Leo'],
  [290043741,290259690,'Virgo'],
  [290259690,290468937,'Libra'],
  [290468937,290669877,'Scorpio'],
  [290669877,290861770,'Sagittarius'],
  [290861770,291045112,'Capricorn'],
  [291045112,291222278,'Aquarius'],
  [291222278,291397642,'Pisces'],
  [291397642,291576975,'Aries'],
  [291576975,291766097,'Taurus'],
  [291766097,291968615,'Gemini'],
  [291968615,292183053,'Cancer'],
  [292183053,292402299,'Leo'],
  [292402299,292617884,'Virgo'],
  [292617884,292824931,'Libra'],
  [292824931,293023078,'Scorpio'],
  [293023078,293214165,'Sagittarius'],
  [293214165,293400120,'Capricorn'],
  [293400120,293582461,'Aquarius'],
  [293582461,293763068,'Pisces'],
  [293763068,293945237,'Aries'],
  [293945237,294133710,'Taurus'],
  [294133710,294333070,'Gemini'],
  [294333070,294544582,'Cancer'],
  [294544582,294763271,'Leo'],
  [294763271,294979646,'Virgo'],
  [294979646,295186186,'Libra'],
  [295186186,295381472,'Scorpio'],
  [295381472,295568727,'Sagittarius'],
  [295568727,295752333,'Capricorn'],
  [295752333,295935498,'Aquarius'],
  [295935498,296119803,'Pisces'],
  [296119803,296306420,'Aries'],
  [296306420,296497671,'Taurus'],
  [296497671,296697031,'Gemini'],
  [296697031,296906863,'Cancer'],
  [296906863,297124835,'Leo'],
  [297124835,297342694,'Virgo'],
  [297342694,297551085,'Libra'],
  [297551085,297746072,'Scorpio'],
  [297746072,297930195,'Sagittarius'],
  [297930195,298109164,'Capricorn'],
  [298109164,298288552,'Aquarius'],
  [298288552,298471932,'Pisces'],
  [298471932,298660683,'Aries'],
  [298660683,298855353,'Taurus'],
  [298855353,299057070,'Gemini'],
  [299057070,299267206,'Cancer'],
  [299267206,299484821,'Leo'],
  [299484821,299704065,'Virgo'],
  [299704065,299915824,'Libra'],
  [299915824,300113736,'Scorpio'],
  [300113736,300298041,'Sagittarius'],
  [300298041,300473931,'Capricorn'],
  [300473931,300648155,'Aquarius'],
  [300648155,300826613,'Pisces'],
  [300826613,301012960,'Aries'],
  [301012960,301208364,'Taurus'],
  [301208364,301412415,'Gemini'],
  [301412415,301624187,'Cancer'],
  [301624187,301842062,'Leo'],
  [301842062,302061946,'Virgo'],
  [302061946,302276764,'Libra'],
  [302276764,302479530,'Scorpio'],
  [302479530,302667764,'Sagittarius'],
  [302667764,302844496,'Capricorn'],
  [302844496,303015929,'Aquarius'],
  [303015929,303188995,'Pisces'],
  [303188995,303369680,'Aries'],
  [303369680,303561662,'Taurus'],
  [303561662,303765422,'Gemini'],
  [303765422,303978505,'Cancer'],
  [303978505,304197061,'Leo'],
  [304197061,304416800,'Virgo'],
  [304416800,304632734,'Libra'],
  [304632734,304839551,'Scorpio'],
  [304839551,305033615,'Sagittarius'],
  [305033615,305215149,'Capricorn'],
  [305215149,305388168,'Aquarius'],
  [305388168,305558925,'Pisces'],
  [305558925,305734335,'Aries'],
  [305734335,305920437,'Taurus'],
  [305920437,306120405,'Gemini'],
  [306120405,306332710,'Cancer'],
  [306332710,306551713,'Leo'],
  [306551713,306771036,'Virgo'],
  [306771036,306986026,'Libra'],
  [306986026,307193735,'Scorpio'],
  [307193735,307391983,'Sagittarius'],
  [307391983,307579728,'Capricorn'],
  [307579728,307758189,'Aquarius'],
  [307758189,307931286,'Pisces'],
  [307931286,308105074,'Aries'],
  [308105074,308286420,'Taurus'],
  [308286420,308480932,'Gemini'],
  [308480932,308689893,'Cancer'],
  [308689893,308908265,'Leo'],
  [308908265,309127455,'Virgo'],
  [309127455,309340925,'Libra'],
  [309340925,309546540,'Scorpio'],
  [309546540,309744666,'Sagittarius'],
  [309744666,309935784,'Capricorn'],
  [309935784,310120128,'Aquarius'],
  [310120128,310298933,'Pisces'],
  [310298933,310475748,'Aries'],
  [310475748,310656330,'Taurus'],
  [310656330,310847010,'Gemini'],
  [310847010,311051660,'Cancer'],
  [311051660,311268010,'Leo'],
  [311268010,311487377,'Virgo'],
  [311487377,311700564,'Libra'],
  [311700564,311903779,'Scorpio'],
  [311903779,312098480,'Sagittarius'],
  [312098480,312287788,'Capricorn'],
  [312287788,312473821,'Aquarius'],
  [312473821,312657398,'Pisces'],
  [312657398,312839665,'Aries'],
  [312839665,313023728,'Taurus'],
  [313023728,313214491,'Gemini'],
  [313214491,313416521,'Cancer'],
  [313416521,313630357,'Leo'],
  [313630357,313849735,'Virgo'],
  [313849735,314064473,'Libra'],
  [314064473,314267787,'Scorpio'],
  [314267787,314459670,'Sagittarius'],
  [314459670,314644349,'Capricorn'],
  [314644349,314826597,'Aquarius'],
  [314826597,315009606,'Pisces'],
  [315009606,315194856,'Aries'],
  [315194856,315383518,'Taurus'],
  [315383518,315577749,'Gemini'],
  [315577749,315780422,'Cancer'],
  [315780422,315992896,'Leo'],
  [315992896,316211863,'Virgo'],
  [316211863,316428916,'Libra'],
  [316428916,316635430,'Scorpio'],
  [316635430,316828274,'Sagittarius'],
  [316828274,317010290,'Capricorn'],
  [317010290,317187179,'Aquarius'],
  [317187179,317364696,'Pisces'],
  [317364696,317547094,'Aries'],
  [317547094,317736648,'Taurus'],
  [317736648,317934145,'Gemini'],
  [317934145,318139688,'Cancer'],
  [318139688,318352861,'Leo'],
  [318352861,318571443,'Virgo'],
  [318571443,318789945,'Libra'],
  [318789945,319000748,'Scorpio'],
  [319000748,319198311,'Sagittarius'],
  [319198311,319382379,'Capricorn'],
  [319382379,319557245,'Aquarius'],
  [319557245,319729352,'Pisces'],
  [319729352,319905289,'Aries'],
  [319905289,320090286,'Taurus'],
  [320090286,320286859,'Gemini'],
  [320286859,320494202,'Cancer'],
  [320494202,320709180,'Leo'],
  [320709180,320927991,'Virgo'],
  [320927991,321146538,'Libra'],
  [321146538,321359898,'Scorpio'],
  [321359898,321562903,'Sagittarius'],
  [321562903,321752722,'Capricorn'],
  [321752722,321930644,'Aquarius'],
  [321930644,322101658,'Pisces'],
  [322101658,322272774,'Aries'],
  [322272774,322451235,'Taurus'],
  [322451235,322642523,'Gemini'],
  [322642523,322847906,'Cancer'],
  [322847906,323063505,'Leo'],
  [323063505,323282922,'Virgo'],
  [323282922,323500866,'Libra'],
  [323500866,323714065,'Scorpio'],
  [323714065,323919748,'Sagittarius'],
  [323919748,324115177,'Capricorn'],
  [324115177,324299221,'Aquarius'],
  [324299221,324474011,'Pisces'],
  [324474011,324645037,'Aries'],
  [324645037,324819663,'Taurus'],
  [324819663,325005089,'Gemini'],
  [325005089,325205514,'Cancer'],
  [325205514,325419115,'Leo'],
  [325419115,325638549,'Virgo'],
  [325638549,325856076,'Libra'],
  [325856076,326067691,'Scorpio'],
  [326067691,326272450,'Sagittarius'],
  [326272450,326469808,'Capricorn'],
  [326469808,326658801,'Aquarius'],
  [326658801,326839472,'Pisces'],
  [326839472,327014650,'Aries'],
  [327014650,327190052,'Taurus'],
  [327190052,327372719,'Gemini'],
  [327372719,327568459,'Cancer'],
  [327568459,327778343,'Leo'],
  [327778343,327996647,'Virgo'],
  [327996647,328214190,'Libra'],
  [328214190,328424672,'Scorpio'],
  [328424672,328626869,'Sagittarius'],
  [328626869,328822167,'Capricorn'],
  [328822167,329011782,'Aquarius'],
  [329011782,329196200,'Pisces'],
  [329196200,329376574,'Aries'],
  [329376574,329556151,'Taurus'],
  [329556151,329740158,'Gemini'],
  [329740158,329934109,'Cancer'],
  [329934109,330140814,'Leo'],
  [330140814,330357301,'Virgo'],
  [330357301,330575180,'Libra'],
  [330575180,330786099,'Scorpio'],
  [330786099,330986756,'Sagittarius'],
  [330986756,331178617,'Capricorn'],
  [331178617,331364899,'Aquarius'],
  [331364899,331548377,'Pisces'],
  [331548377,331731009,'Aries'],
  [331731009,331914812,'Taurus'],
  [331914812,332102672,'Gemini'],
  [332102672,332298149,'Cancer'],
  [332298149,332503868,'Leo'],
  [332503868,332718883,'Virgo'],
  [332718883,332937179,'Libra'],
  [332937179,333150131,'Scorpio'],
  [333150131,333351882,'Sagittarius'],
  [333351882,333542076,'Capricorn'],
  [333542076,333724242,'Aquarius'],
  [333724242,333903188,'Pisces'],
  [333903188,334083291,'Aries'],
  [334083291,334267778,'Taurus'],
  [334267778,334458725,'Gemini'],
  [334458725,334657401,'Cancer'],
  [334657401,334864453,'Leo'],
  [334864453,335079119,'Virgo'],
  [335079119,335297681,'Libra'],
  [335297681,335513256,'Scorpio'],
  [335513256,335718674,'Sagittarius'],
  [335718674,335910750,'Capricorn'],
  [335910750,336091399,'Aquarius'],
  [336091399,336265849,'Pisces'],
  [336265849,336440462,'Aries'],
  [336440462,336620993,'Taurus'],
  [336620993,336811154,'Gemini'],
  [336811154,337011723,'Cancer'],
  [337011723,337221040,'Leo'],
  [337221040,337436526,'Virgo'],
  [337436526,337655146,'Libra'],
  [337655146,337872455,'Scorpio'],
  [337872455,338082295,'Sagittarius'],
  [338082295,338279427,'Capricorn'],
  [338279427,338462830,'Aquarius'],
  [338462830,338636237,'Pisces'],
  [338636237,338806385,'Aries'],
  [338806385,338980843,'Taurus'],
  [338980843,339165977,'Gemini'],
  [339165977,339364605,'Cancer'],
  [339364605,339574728,'Leo'],
  [339574728,339791407,'Virgo'],
  [339791407,340010072,'Libra'],
  [340010072,340227433,'Scorpio'],
  [340227433,340439797,'Sagittarius'],
  [340439797,340642407,'Capricorn'],
  [340642407,340831875,'Aquarius'],
  [340831875,341008975,'Pisces'],
  [341008975,341178922,'Aries'],
  [341178922,341349408,'Taurus'],
  [341349408,341528386,'Gemini'],
  [341528386,341721505,'Cancer'],
  [341721505,341929112,'Leo'],
  [341929112,342145869,'Virgo'],
  [342145869,342364724,'Libra'],
  [342364724,342581117,'Scorpio'],
  [342581117,342792901,'Sagittarius'],
  [342792901,342997806,'Capricorn'],
  [342997806,343192842,'Aquarius'],
  [343192842,343376495,'Pisces'],
  [343376495,343551046,'Aries'],
  [343551046,343722428,'Taurus'],
  [343722428,343898311,'Gemini'],
  [343898311,344085781,'Cancer'],
  [344085781,344288242,'Leo'],
  [344288242,344502785,'Virgo'],
  [344502785,344721597,'Libra'],
  [344721597,344937427,'Scorpio'],
  [344937427,345147099,'Sagittarius'],
  [345147099,345350142,'Capricorn'],
  [345350142,345546192,'Aquarius'],
  [345546192,345734464,'Pisces'],
  [345734464,345915362,'Aries'],
  [345915362,346091965,'Taurus'],
  [346091965,346269783,'Gemini'],
  [346269783,346455215,'Cancer'],
  [346455215,346653134,'Leo'],
  [346653134,346863874,'Virgo'],
  [346863874,347081755,'Libra'],
  [347081755,347298096,'Scorpio'],
  [347298096,347506853,'Sagittarius'],
  [347506853,347706745,'Capricorn'],
  [347706745,347899323,'Aquarius'],
  [347899323,348086610,'Pisces'],
  [348086610,348270287,'Aries'],
  [348270287,348452230,'Taurus'],
  [348452230,348635262,'Gemini'],
  [348635262,348823245,'Cancer'],
  [348823245,349020129,'Leo'],
  [349020129,349227897,'Virgo'],
  [349227897,349444110,'Libra'],
  [349444110,349661489,'Scorpio'],
  [349661489,349871809,'Sagittarius'],
  [349871809,350070900,'Capricorn'],
  [350070900,350259686,'Aquarius'],
  [350259686,350442084,'Pisces'],
  [350442084,350622637,'Aries'],
  [350622637,350805057,'Taurus'],
  [350805057,350991757,'Gemini'],
  [350991757,351184203,'Cancer'],
  [351184203,351383635,'Leo'],
  [351383635,351591118,'Virgo'],
  [351591118,351806058,'Libra'],
  [351806058,352024138,'Scorpio'],
  [352024138,352237568,'Sagittarius'],
  [352237568,352439439,'Capricorn'],
  [352439439,352627933,'Aquarius'],
  [352627933,352806495,'Pisces'],
  [352806495,352981352,'Aries'],
  [352981352,353158930,'Taurus'],
  [353158930,353343934,'Gemini'],
  [353343934,353538147,'Cancer'],
  [353538147,353740769,'Leo'],
  [353740769,353950234,'Virgo'],
  [353950234,354165232,'Libra'],
  [354165232,354383443,'Scorpio'],
  [354383443,354599524,'Sagittarius'],
  [354599524,354806124,'Capricorn'],
  [354806124,354998467,'Aquarius'],
  [354998467,355177512,'Pisces'],
  [355177512,355349056,'Aries'],
  [355349056,355520831,'Taurus'],
  [355520831,355700013,'Gemini'],
  [355700013,355890987,'Cancer'],
  [355890987,356093774,'Leo'],
  [356093774,356305058,'Virgo'],
  [356305058,356521129,'Libra'],
  [356521129,356739280,'Scorpio'],
  [356739280,356956259,'Sagittarius'],
  [356956259,357166605,'Capricorn'],
  [357166605,357364580,'Aquarius'],
  [357364580,357548247,'Pisces'],
  [357548247,357721155,'Aries'],
  [357721155,357890469,'Taurus'],
  [357890469,358064262,'Gemini'],
  [358064262,358249209,'Cancer'],
  [358249209,358448106,'Leo'],
  [358448106,358658642,'Virgo'],
  [358658642,358875434,'Libra'],
  [358875434,359093626,'Scorpio'],
  [359093626,359309994,'Sagittarius'],
  [359309994,359521228,'Capricorn'],
  [359521228,359723122,'Aquarius'],
  [359723122,359912633,'Pisces'],
  [359912633,360090620,'Aries'],
  [360090620,360262100,'Taurus'],
  [360262100,360434316,'Gemini'],
  [360434316,360614572,'Cancer'],
  [360614572,360807938,'Leo'],
  [360807938,361014891,'Virgo'],
  [361014891,361230850,'Libra'],
  [361230850,361449071,'Scorpio'],
  [361449071,361664451,'Sagittarius'],
  [361664451,361874157,'Capricorn'],
  [361874157,362076244,'Aquarius'],
  [362076244,362269094,'Pisces'],
  [362269094,362452581,'Aries'],
  [362452581,362629276,'Taurus'],
  [362629276,362804217,'Gemini'],
  [362804217,362983629,'Cancer'],
  [362983629,363173175,'Leo'],
  [363173175,363375723,'Virgo'],
  [363375723,363589292,'Libra'],
  [363589292,363807289,'Scorpio'],
  [363807289,364022354,'Sagittarius'],
  [364022354,364230110,'Capricorn'],
  [364230110,364429535,'Aquarius'],
  [364429535,364621409,'Pisces'],
  [364621409,364807100,'Aries'],
  [364807100,364988507,'Taurus'],
  [364988507,365168452,'Gemini'],
  [365168452,365350821,'Cancer'],
  [365350821,365540069,'Leo'],
  [365540069,365739837,'Virgo'],
  [365739837,365950684,'Libra'],
  [365950684,366168139,'Scorpio'],
  [366168139,366384015,'Sagittarius'],
  [366384015,366591381,'Capricorn'],
  [366591381,366788073,'Aquarius'],
  [366788073,366976141,'Pisces'],
  [366976141,367159413,'Aries'],
  [367159413,367341500,'Taurus'],
  [367341500,367525001,'Gemini'],
  [367525001,367711795,'Cancer'],
  [367711795,367903892,'Leo'],
  [367903892,368103750,'Virgo'],
  [368103750,368313006,'Libra'],
  [368313006,368529810,'Scorpio'],
  [368529810,368747299,'Sagittarius'],
  [368747299,368956717,'Capricorn'],
  [368956717,369153236,'Aquarius'],
  [369153236,369338129,'Pisces'],
  [369338129,369516611,'Aries'],
  [369516611,369694740,'Taurus'],
  [369694740,369877179,'Gemini'],
  [369877179,370066099,'Cancer'],
  [370066099,370261715,'Leo'],
  [370261715,370464007,'Virgo'],
  [370464007,370673560,'Libra'],
  [370673560,370889967,'Scorpio'],
  [370889967,371108925,'Sagittarius'],
  [371108925,371322055,'Capricorn'],
  [371322055,371521945,'Aquarius'],
  [371521945,371707259,'Pisces'],
  [371707259,371882605,'Aries'],
  [371882605,372055279,'Taurus'],
  [372055279,372232343,'Gemini'],
  [372232343,372418466,'Cancer'],
  [372418466,372614682,'Leo'],
  [372614682,372819388,'Virgo'],
  [372819388,373030681,'Libra'],
  [373030681,373247295,'Scorpio'],
  [373247295,373466749,'Sagittarius'],
  [373466749,373683033,'Capricorn'],
  [373683033,373888327,'Aquarius'],
  [373888327,374078320,'Pisces'],
  [374078320,374255075,'Aries'],
  [374255075,374425178,'Taurus'],
  [374425178,374596597,'Gemini'],
  [374596597,374776343,'Cancer'],
  [374776343,374968370,'Leo'],
  [374968370,375172370,'Virgo'],
  [375172370,375384991,'Libra'],
  [375384991,375602412,'Scorpio'],
  [375602412,375821547,'Sagittarius'],
  [375821547,376038534,'Capricorn'],
  [376038534,376247754,'Aquarius'],
  [376247754,376444125,'Pisces'],
  [376444125,376626682,'Aries'],
  [376626682,376799416,'Taurus'],
  [376799416,376969239,'Gemini'],
  [376969239,377143702,'Cancer'],
  [377143702,377329074,'Leo'],
  [377329074,377528272,'Virgo'],
  [377528272,377739527,'Libra'],
  [377739527,377957458,'Scorpio'],
  [377957458,378176339,'Sagittarius'],
  [378176339,378392009,'Capricorn'],
  [378392009,378601252,'Aquarius'],
  [378601252,378801166,'Pisces'],
  [378801166,378990129,'Aries'],
  [378990129,379169314,'Taurus'],
  [379169314,379342868,'Gemini'],
  [379342868,379516856,'Cancer'],
  [379516856,379697821,'Leo'],
  [379697821,379891002,'Virgo'],
  [379891002,380097965,'Libra'],
  [380097965,380314803,'Scorpio'],
  [380314803,380533833,'Sagittarius'],
  [380533833,380748280,'Capricorn'],
  [380748280,380954957,'Aquarius'],
  [380954957,381153510,'Pisces'],
  [381153510,381344590,'Aries'],
  [381344590,381529194,'Taurus'],
  [381529194,381709077,'Gemini'],
  [381709077,381887408,'Cancer'],
  [381887408,382068897,'Leo'],
  [382068897,382258907,'Virgo'],
  [382258907,382461333,'Libra'],
  [382461333,382675486,'Scorpio'],
  [382675486,382894547,'Sagittarius'],
  [382894547,383109297,'Capricorn'],
  [383109297,383314133,'Aquarius'],
  [383314133,383509019,'Pisces'],
  [383509019,383697102,'Aries'],
  [383697102,383881784,'Taurus'],
  [383881784,384065303,'Gemini'],
  [384065303,384249020,'Cancer'],
  [384249020,384434811,'Leo'],
  [384434811,384626019,'Virgo'],
  [384626019,384826589,'Libra'],
  [384826589,385038187,'Scorpio'],
  [385038187,385256811,'Sagittarius'],
  [385256811,385473176,'Capricorn'],
  [385473176,385678883,'Aquarius'],
  [385678883,385871815,'Pisces'],
  [385871815,386055574,'Aries'],
  [386055574,386235826,'Taurus'],
  [386235826,386417335,'Gemini'],
  [386417335,386602589,'Cancer'],
  [386602589,386792291,'Leo'],
  [386792291,386987187,'Virgo'],
  [386987187,387189163,'Libra'],
  [387189163,387399994,'Scorpio'],
  [387399994,387618074,'Sagittarius'],
  [387618074,387836267,'Capricorn'],
  [387836267,388045175,'Aquarius'],
  [388045175,388239774,'Pisces'],
  [388239774,388421928,'Aries'],
  [388421928,388597690,'Taurus'],
  [388597690,388773798,'Gemini'],
  [388773798,388955352,'Cancer'],
  [388955352,389144695,'Leo'],
  [389144695,389341943,'Virgo'],
  [389341943,389546634,'Libra'],
  [389546634,389758588,'Scorpio'],
  [389758588,389976572,'Sagittarius'],
  [389976572,390195840,'Capricorn'],
  [390195840,390408369,'Aquarius'],
  [390408369,390607443,'Pisces'],
  [390607443,390792109,'Aries'],
  [390792109,390966882,'Taurus'],
  [390966882,391138704,'Gemini'],
  [391138704,391314405,'Cancer'],
  [391314405,391498986,'Leo'],
  [391498986,391694539,'Virgo'],
  [391694539,391900304,'Libra'],
  [391900304,392113868,'Scorpio'],
  [392113868,392332303,'Sagittarius'],
  [392332303,392551655,'Capricorn'],
  [392551655,392766227,'Aquarius'],
  [392766227,392970010,'Pisces'],
  [392970010,393160006,'Aries'],
  [393160006,393338048,'Taurus'],
  [393338048,393509562,'Gemini'],
  [393509562,393681403,'Cancer'],
  [393681403,393860160,'Leo'],
  [393860160,394050604,'Virgo'],
  [394050604,394254094,'Libra'],
  [394254094,394467917,'Scorpio'],
  [394467917,394686886,'Sagittarius'],
  [394686886,394905761,'Capricorn'],
  [394905761,395120096,'Aquarius'],
  [395120096,395326139,'Pisces'],
  [395326139,395521192,'Aries'],
  [395521192,395704994,'Taurus'],
  [395704994,395880354,'Gemini'],
  [395880354,396052521,'Cancer'],
  [396052521,396227998,'Leo'],
  [396227998,396413095,'Virgo'],
  [396413095,396611872,'Libra'],
  [396611872,396823653,'Scorpio'],
  [396823653,397042556,'Sagittarius'],
  [397042556,397261020,'Capricorn'],
  [397261020,397473800,'Aquarius'],
  [397473800,397678826,'Pisces'],
  [397678826,397875606,'Aries'],
  [397875606,398064120,'Taurus'],
  [398064120,398245236,'Gemini'],
  [398245236,398421599,'Cancer'],
  [398421599,398597978,'Leo'],
  [398597978,398780511,'Virgo'],
  [398780511,398974843,'Libra'],
  [398974843,399183052,'Scorpio'],
  [399183052,399400886,'Sagittarius'],
  [399400886,399619406,'Capricorn'],
  [399619406,399831043,'Aquarius'],
  [399831043,400033417,'Pisces'],
  [400033417,400228007,'Aries'],
  [400228007,400417042,'Taurus'],
  [400417042,400601895,'Gemini'],
  [400601895,400783562,'Cancer'],
  [400783562,400964234,'Leo'],
  [400964234,401148163,'Virgo'],
  [401148163,401340741,'Libra'],
  [401340741,401545805,'Scorpio'],
  [401545805,401761873,'Sagittarius'],
  [401761873,401980874,'Capricorn'],
  [401980874,402193105,'Aquarius'],
  [402193105,402393944,'Pisces'],
  [402393944,402584917,'Aries'],
  [402584917,402770324,'Taurus'],
  [402770324,402953972,'Gemini'],
  [402953972,403137852,'Cancer'],
  [403137852,403322928,'Leo'],
  [403322928,403510951,'Virgo'],
  [403510951,403705229,'Libra'],
  [403705229,403909336,'Scorpio'],
  [403909336,404123858,'Sagittarius'],
  [404123858,404343331,'Capricorn'],
  [404343331,404557942,'Aquarius'],
  [404557942,404760304,'Pisces'],
  [404760304,404949823,'Aries'],
  [404949823,405130951,'Taurus'],
  [405130951,405309517,'Gemini'],
  [405309517,405490209,'Cancer'],
  [405490209,405675593,'Leo'],
  [405675593,405866731,'Virgo'],
  [405866731,406064532,'Libra'],
  [406064532,406270288,'Scorpio'],
  [406270288,406484466,'Sagittarius'],
  [406484466,406704015,'Capricorn'],
  [406704015,406921348,'Aquarius'],
  [406921348,407128021,'Pisces'],
  [407128021,407320295,'Aries'],
  [407320295,407500553,'Taurus'],
  [407500553,407674660,'Gemini'],
  [407674660,407849168,'Cancer'],
  [407849168,408029536,'Leo'],
  [408029536,408219031,'Virgo'],
  [408219031,408418465,'Libra'],
  [408418465,408626796,'Scorpio'],
  [408626796,408842107,'Sagittarius'],
  [408842107,409061530,'Capricorn'],
  [409061530,409280139,'Aquarius'],
  [409280139,409491242,'Pisces'],
  [409491242,409689403,'Aries'],
  [409689403,409873720,'Taurus'],
  [409873720,410047922,'Gemini'],
  [410047922,410218379,'Cancer'],
  [410218379,410392164,'Leo'],
  [410392164,410575458,'Virgo'],
  [410575458,410771763,'Libra'],
  [410771763,410980409,'Scorpio'],
  [410980409,411197140,'Sagittarius'],
  [411197140,411416772,'Capricorn'],
  [411416772,411634927,'Aquarius'],
  [411634927,411847670,'Pisces'],
  [411847670,412050942,'Aries'],
  [412050942,412242000,'Taurus'],
  [412242000,412421313,'Gemini'],
  [412421313,412592993,'Cancer'],
  [412592993,412763668,'Leo'],
  [412763668,412940810,'Virgo'],
  [412940810,413130724,'Libra'],
  [413130724,413335706,'Scorpio'],
  [413335706,413552007,'Sagittarius'],
  [413552007,413772023,'Capricorn'],
  [413772023,413989291,'Aquarius'],
  [413989291,414200742,'Pisces'],
  [414200742,414405029,'Aries'],
  [414405029,414600700,'Taurus'],
  [414600700,414786675,'Gemini'],
  [414786675,414964002,'Cancer'],
  [414964002,415136941,'Leo'],
  [415136941,415312198,'Virgo'],
  [415312198,415497038,'Libra'],
  [415497038,415696482,'Scorpio'],
  [415696482,415909738,'Sagittarius'],
  [415909738,416129391,'Capricorn'],
  [416129391,416346421,'Aquarius'],
  [416346421,416555998,'Pisces'],
  [416555998,416757868,'Aries'],
  [416757868,416953180,'Taurus'],
  [416953180,417142338,'Gemini'],
  [417142338,417325382,'Cancer'],
  [417325382,417503883,'Leo'],
  [417503883,417682101,'Virgo'],
  [417682101,417866199,'Libra'],
  [417866199,418061974,'Scorpio'],
  [418061974,418271372,'Sagittarius'],
  [418271372,418489567,'Capricorn'],
  [418489567,418707018,'Aquarius'],
  [418707018,418916219,'Pisces'],
  [418916219,419115529,'Aries'],
  [419115529,419307286,'Taurus'],
  [419307286,419494426,'Gemini'],
  [419494426,419678770,'Cancer'],
  [419678770,419861492,'Leo'],
  [419861492,420044629,'Virgo'],
  [420044629,420231866,'Libra'],
  [420231866,420427680,'Scorpio'],
  [420427680,420634863,'Sagittarius'],
  [420634863,420851336,'Capricorn'],
  [420851336,421069407,'Aquarius'],
  [421069407,421280184,'Pisces'],
  [421280184,421479355,'Aries'],
  [421479355,421668204,'Taurus'],
  [421668204,421850869,'Gemini'],
  [421850869,422031656,'Cancer'],
  [422031656,422213791,'Leo'],
  [422213791,422399485,'Virgo'],
  [422399485,422590630,'Libra'],
  [422590630,422789230,'Scorpio'],
  [422789230,422996786,'Sagittarius'],
  [422996786,423212368,'Capricorn'],
  [423212368,423430897,'Aquarius'],
  [423430897,423644347,'Pisces'],
  [423644347,423846279,'Aries'],
  [423846279,424035438,'Taurus'],
  [424035438,424215147,'Gemini'],
  [424215147,424390882,'Cancer'],
  [424390882,424568271,'Leo'],
  [424568271,424751784,'Virgo'],
  [424751784,424943965,'Libra'],
  [424943965,425145307,'Scorpio'],
  [425145307,425354884,'Sagittarius'],
  [425354884,425570790,'Capricorn'],
  [425570790,425789490,'Aquarius'],
  [425789490,426005248,'Pisces'],
  [426005248,426211510,'Aries'],
  [426211510,426404456,'Taurus'],
  [426404456,426585024,'Gemini'],
  [426585024,426758027,'Cancer'],
  [426758027,426930174,'Leo'],
  [426930174,427108198,'Virgo'],
  [427108198,427297078,'Libra'],
  [427297078,427498281,'Scorpio'],
  [427498281,427709447,'Sagittarius'],
  [427709447,427926382,'Capricorn'],
  [427926382,428145062,'Aquarius'],
  [428145062,428361631,'Pisces'],
  [428361631,428571409,'Aries'],
  [428571409,428769774,'Taurus'],
  [428769774,428954931,'Gemini'],
  [428954931,429129425,'Cancer'],
  [429129425,429299332,'Leo'],
  [429299332,429472287,'Virgo'],
  [429472287,429655421,'Libra'],
  [429655421,429852810,'Scorpio'],
  [429852810,430063158,'Sagittarius'],
  [430063158,430280720,'Capricorn'],
  [430280720,430499372,'Aquarius'],
  [430499372,430715273,'Pisces'],
  [430715273,430925872,'Aries'],
  [430925872,431128119,'Taurus'],
  [431128119,431319169,'Gemini'],
  [431319169,431498837,'Cancer'],
  [431498837,431670962,'Leo'],
  [431670962,431842394,'Virgo'],
  [431842394,432020940,'Libra'],
  [432020940,432212861,'Scorpio'],
  [432212861,432419617,'Sagittarius'],
  [432419617,432636320,'Capricorn'],
  [432636320,432854978,'Aquarius'],
  [432854978,433069815,'Pisces'],
  [433069815,433278749,'Aries'],
  [433278749,433481060,'Taurus'],
  [433481060,433675468,'Gemini'],
  [433675468,433860870,'Cancer'],
  [433860870,434038509,'Leo'],
  [434038509,434212900,'Virgo'],
  [434212900,434390747,'Libra'],
  [434390747,434578832,'Scorpio'],
  [434578832,434781013,'Sagittarius'],
  [434781013,434995188,'Capricorn'],
  [434995188,435213663,'Aquarius'],
  [435213663,435428301,'Pisces'],
  [435428301,435635246,'Aries'],
  [435635246,435834600,'Taurus'],
  [435834600,436027614,'Gemini'],
  [436027614,436215021,'Cancer'],
  [436215021,436397567,'Leo'],
  [436397567,436577433,'Virgo'],
  [436577433,436758781,'Libra'],
  [436758781,436946923,'Scorpio'],
  [436946923,437146270,'Sagittarius'],
  [437146270,437357419,'Capricorn'],
  [437357419,437575232,'Aquarius'],
  [437575232,437790985,'Pisces'],
  [437790985,437997978,'Aries'],
  [437997978,438194700,'Taurus'],
  [438194700,438383424,'Gemini'],
  [438383424,438567567,'Cancer'],
  [438567567,438750115,'Leo'],
  [438750115,438933399,'Virgo'],
  [438933399,439119625,'Libra'],
  [439119625,439311358,'Scorpio'],
  [439311358,439511278,'Sagittarius'],
  [439511278,439720753,'Capricorn'],
  [439720753,439937568,'Aquarius'],
  [439937568,440154995,'Pisces'],
  [440154995,440364762,'Aries'],
  [440364762,440562210,'Taurus'],
  [440562210,440748138,'Gemini'],
  [440748138,440927018,'Cancer'],
  [440927018,441104492,'Leo'],
  [441104492,441285507,'Virgo'],
  [441285507,441473189,'Libra'],
  [441473189,441668615,'Scorpio'],
  [441668615,441871633,'Sagittarius'],
  [441871633,442081829,'Capricorn'],
  [442081829,442298044,'Aquarius'],
  [442298044,442516502,'Pisces'],
  [442516502,442730158,'Aries'],
  [442730158,442932017,'Taurus'],
  [442932017,443119649,'Gemini'],
  [443119649,443296170,'Cancer'],
  [443296170,443468114,'Leo'],
  [443468114,443642808,'Virgo'],
  [443642808,443826238,'Libra'],
  [443826238,444021132,'Scorpio'],
  [444021132,444226331,'Sagittarius'],
  [444226331,444438660,'Capricorn'],
  [444438660,444655309,'Aquarius'],
  [444655309,444873812,'Pisces'],
  [444873812,445089911,'Aries'],
  [445089911,445297148,'Taurus'],
  [445297148,445490429,'Gemini'],
  [445490429,445669743,'Cancer'],
  [445669743,445840301,'Leo'],
  [445840301,446009954,'Virgo'],
  [446009954,446186661,'Libra'],
  [446186661,446376128,'Scorpio'],
  [446376128,446579359,'Sagittarius'],
  [446579359,446792515,'Capricorn'],
  [446792515,447010154,'Aquarius'],
  [447010154,447228400,'Pisces'],
  [447228400,447444512,'Aries'],
  [447444512,447654566,'Taurus'],
  [447654566,447853680,'Gemini'],
  [447853680,448039264,'Cancer'],
  [448039264,448213601,'Leo'],
  [448213601,448383078,'Virgo'],
  [448383078,448555713,'Libra'],
  [448555713,448738859,'Scorpio'],
  [448738859,448936563,'Sagittarius'],
  [448936563,449147317,'Capricorn'],
  [449147317,449365016,'Aquarius'],
  [449365016,449583221,'Pisces'],
  [449583221,449798116,'Aries'],
  [449798116,450007467,'Taurus'],
  [450007467,450208768,'Gemini'],
  [450208768,450399679,'Cancer'],
  [450399679,450580256,'Leo'],
  [450580256,450754154,'Virgo'],
  [450754154,450927662,'Libra'],
  [450927662,451107820,'Scorpio'],
  [451107820,451300222,'Sagittarius'],
  [451300222,451506414,'Capricorn'],
  [451506414,451722365,'Aquarius'],
  [451722365,451940539,'Pisces'],
  [451940539,452154618,'Aries'],
  [452154618,452361705,'Taurus'],
  [452361705,452561155,'Gemini'],
  [452561155,452752978,'Cancer'],
  [452752978,452937705,'Leo'],
  [452937705,453117246,'Virgo'],
  [453117246,453295318,'Libra'],
  [453295318,453476985,'Scorpio'],
  [453476985,453667383,'Sagittarius'],
  [453667383,453869718,'Capricorn'],
  [453869718,454082905,'Aquarius'],
  [454082905,454300763,'Pisces'],
  [454300763,454515202,'Aries'],
  [454515202,454720976,'Taurus'],
  [454720976,454917217,'Gemini'],
  [454917217,455105938,'Cancer'],
  [455105938,455290025,'Leo'],
  [455290025,455472189,'Virgo'],
  [455472189,455654897,'Libra'],
  [455654897,455840777,'Scorpio'],
  [455840777,456032875,'Sagittarius'],
  [456032875,456234042,'Capricorn'],
  [456234042,456445073,'Aquarius'],
  [456445073,456662412,'Pisces'],
  [456662412,456878274,'Aries'],
  [456878274,457085034,'Taurus'],
  [457085034,457279753,'Gemini'],
  [457279753,457464596,'Cancer'],
  [457464596,457644453,'Leo'],
  [457644453,457824398,'Virgo'],
  [457824398,458008100,'Libra'],
  [458008100,458197378,'Scorpio'],
  [458197378,458392966,'Sagittarius'],
  [458392966,458595670,'Capricorn'],
  [458595670,458806215,'Aquarius'],
  [458806215,459023150,'Pisces'],
  [459023150,459240750,'Aries'],
  [459240750,459450602,'Taurus'],
  [459450602,459647039,'Gemini'],
  [459647039,459830481,'Cancer'],
  [459830481,460006149,'Leo'],
  [460006149,460180972,'Virgo'],
  [460180972,460361036,'Libra'],
  [460361036,460549774,'Scorpio'],
  [460549774,460747463,'Sagittarius'],
  [460747463,460952712,'Capricorn'],
  [460952712,461164359,'Aquarius'],
  [461164359,461381274,'Pisces'],
  [461381274,461599994,'Aries'],
  [461599994,461813475,'Taurus'],
  [461813475,462014418,'Gemini'],
  [462014418,462200408,'Cancer'],
  [462200408,462375145,'Leo'],
  [462375145,462545823,'Virgo'],
  [462545823,462720174,'Libra'],
  [462720174,462904172,'Scorpio'],
  [462904172,463100083,'Sagittarius'],
  [463100083,463306283,'Capricorn'],
  [463306283,463519457,'Aquarius'],
  [463519457,463736788,'Pisces'],
  [463736788,463955582,'Aries'],
  [463955582,464171134,'Taurus'],
  [464171134,464376947,'Gemini'],
  [464376947,464568527,'Cancer'],
  [464568527,464746748,'Leo'],
  [464746748,464917273,'Virgo'],
  [464917273,465087838,'Libra'],
  [465087838,465265905,'Scorpio'],
  [465265905,465456475,'Sagittarius'],
  [465456475,465660195,'Capricorn'],
  [465660195,465873549,'Aquarius'],
  [465873549,466091433,'Pisces'],
  [466091433,466309689,'Aries'],
  [466309689,466524835,'Taurus'],
  [466524835,466732805,'Gemini'],
  [466732805,466929669,'Cancer'],
  [466929669,467114155,'Leo'],
  [467114155,467289104,'Virgo'],
  [467289104,467460464,'Libra'],
  [467460464,467635372,'Scorpio'],
  [467635372,467820280,'Sagittarius'],
  [467820280,468018791,'Capricorn'],
  [468018791,468229773,'Aquarius'],
  [468229773,468447619,'Pisces'],
  [468447619,468665593,'Aries'],
  [468665593,468879023,'Taurus'],
  [468879023,469085476,'Gemini'],
  [469085476,469283617,'Cancer'],
  [469283617,469472859,'Leo'],
  [469472859,469654164,'Virgo'],
  [469654164,469830637,'Libra'],
  [469830637,470007245,'Scorpio'],
  [470007245,470189843,'Sagittarius'],
  [470189843,470383560,'Capricorn'],
  [470383560,470590386,'Aquarius'],
  [470590386,470806912,'Pisces'],
  [470806912,471025227,'Aries'],
  [471025227,471237825,'Taurus'],
  [471237825,471441388,'Gemini'],
  [471441388,471636501,'Cancer'],
  [471636501,471825314,'Leo'],
  [471825314,472009903,'Virgo'],
  [472009903,472192039,'Libra'],
  [472192039,472373896,'Scorpio'],
  [472373896,472558841,'Sagittarius'],
  [472558841,472751230,'Capricorn'],
  [472751230,472954683,'Aquarius'],
  [472954683,473168962,'Pisces'],
  [473168962,473387770,'Aries'],
  [473387770,473601611,'Taurus'],
  [473601611,473804257,'Gemini'],
  [473804257,473995682,'Cancer'],
  [473995682,474179976,'Leo'],
  [474179976,474362007,'Virgo'],
  [474362007,474545253,'Libra'],
  [474545253,474731288,'Scorpio'],
  [474731288,474920931,'Sagittarius'],
  [474920931,475115893,'Capricorn'],
  [475115893,475318914,'Aquarius'],
  [475318914,475531501,'Pisces'],
  [475531501,475750392,'Aries'],
  [475750392,475966831,'Taurus'],
  [475966831,476171940,'Gemini'],
  [476171940,476362904,'Cancer'],
  [476362904,476543351,'Leo'],
  [476543351,476719825,'Virgo'],
  [476719825,476898531,'Libra'],
  [476898531,477083329,'Scorpio'],
  [477083329,477275212,'Sagittarius'],
  [477275212,477473761,'Capricorn'],
  [477473761,477679065,'Aquarius'],
  [477679065,477891748,'Pisces'],
  [477891748,478110438,'Aries'],
  [478110438,478329065,'Taurus'],
  [478329065,478538612,'Gemini'],
  [478538612,478733289,'Cancer'],
  [478733289,478914156,'Leo'],
  [478914156,479087239,'Virgo'],
  [479087239,479260019,'Libra'],
  [479260019,479438934,'Scorpio'],
  [479438934,479627673,'Sagittarius'],
  [479627673,479826645,'Capricorn'],
  [479826645,480034205,'Aquarius'],
  [480034205,480248404,'Pisces'],
  [480248404,480467182,'Aries'],
  [480467182,480686509,'Taurus'],
  [480686509,480899596,'Gemini'],
  [480899596,481099897,'Cancer'],
  [481099897,481285496,'Leo'],
  [481285496,481460019,'Virgo'],
  [481460019,481630221,'Libra'],
  [481630221,481803445,'Scorpio'],
  [481803445,481985812,'Sagittarius'],
  [481985812,482180623,'Capricorn'],
  [482180623,482387426,'Aquarius'],
  [482387426,482602690,'Pisces'],
  [482602690,482821935,'Aries'],
  [482821935,483040829,'Taurus'],
  [483040829,483254761,'Gemini'],
  [483254761,483459009,'Cancer'],
  [483459009,483650649,'Leo'],
  [483650649,483830521,'Virgo'],
  [483830521,484003023,'Libra'],
  [484003023,484174546,'Scorpio'],
  [484174546,484351884,'Sagittarius'],
  [484351884,484540661,'Capricorn'],
  [484540661,484743338,'Aquarius'],
  [484743338,484957527,'Pisces'],
  [484957527,485176998,'Aries'],
  [485176998,485395254,'Taurus'],
  [485395254,485607872,'Gemini'],
  [485607872,485812433,'Cancer'],
  [485812433,486007586,'Leo'],
  [486007586,486193233,'Virgo'],
  [486193233,486371233,'Libra'],
  [486371233,486545603,'Scorpio'],
  [486545603,486722026,'Sagittarius'],
  [486722026,486906704,'Capricorn'],
  [486906704,487104376,'Aquarius'],
  [487104376,487315439,'Pisces'],
  [487315439,487534281,'Aries'],
  [487534281,487752312,'Taurus'],
  [487752312,487963302,'Gemini'],
  [487963302,488165514,'Cancer'],
  [488165514,488359952,'Leo'],
  [488359952,488548050,'Virgo'],
  [488548050,488731028,'Libra'],
  [488731028,488910617,'Scorpio'],
  [488910617,489090121,'Sagittarius'],
  [489090121,489274542,'Capricorn'],
  [489274542,489469194,'Aquarius'],
  [489469194,489676821,'Pisces'],
  [489676821,489894240,'Aries'],
  [489894240,490112600,'Taurus'],
  [490112600,490323259,'Gemini'],
  [490323259,490523098,'Cancer'],
  [490523098,490714153,'Leo'],
  [490714153,490900198,'Virgo'],
  [490900198,491084159,'Libra'],
  [491084159,491267544,'Scorpio'],
  [491267544,491451654,'Sagittarius'],
  [491451654,491639121,'Capricorn'],
  [491639121,491833999,'Aquarius'],
  [491833999,492039750,'Pisces'],
  [492039750,492255669,'Aries'],
  [492255669,492474681,'Taurus'],
  [492474681,492686899,'Gemini'],
  [492686899,492886626,'Cancer'],
  [492886626,493074892,'Leo'],
  [493074892,493256617,'Virgo'],
  [493256617,493437066,'Libra'],
  [493437066,493619764,'Scorpio'],
  [493619764,493806256,'Sagittarius'],
  [493806256,493997469,'Capricorn'],
  [493997469,494195082,'Aquarius'],
  [494195082,494401295,'Pisces'],
  [494401295,494616454,'Aries'],
  [494616454,494836015,'Taurus'],
  [494836015,495051012,'Gemini'],
  [495051012,495253643,'Cancer'],
  [495253643,495442346,'Leo'],
  [495442346,495621220,'Virgo'],
  [495621220,495796612,'Libra'],
  [495796612,495974415,'Scorpio'],
  [495974415,496158553,'Sagittarius'],
  [496158553,496350681,'Capricorn'],
  [496350681,496551024,'Aquarius'],
  [496551024,496759346,'Pisces'],
  [496759346,496974879,'Aries'],
  [496974879,497194584,'Taurus'],
  [497194584,497411938,'Gemini'],
  [497411938,497619211,'Cancer'],
  [497619211,497812168,'Leo'],
  [497812168,497992325,'Virgo'],
  [497992325,498165168,'Libra'],
  [498165168,498337522,'Scorpio'],
  [498337522,498515696,'Sagittarius'],
  [498515696,498704065,'Capricorn'],
  [498704065,498904037,'Aquarius'],
  [498904037,499114033,'Pisces'],
  [499114033,499330745,'Aries'],
  [499330745,499550341,'Taurus'],
  [499550341,499768248,'Gemini'],
  [499768248,499979018,'Cancer'],
  [499979018,500177901,'Leo'],
  [500177901,500363510,'Virgo'],
  [500363510,500538660,'Libra'],
  [500538660,500709137,'Scorpio'],
  [500709137,500881986,'Sagittarius'],
  [500881986,501063915,'Capricorn'],
  [501063915,501259327,'Aquarius'],
  [501259327,501468146,'Pisces'],
  [501468146,501685606,'Aries'],
  [501685606,501905276,'Taurus'],
  [501905276,502122179,'Gemini'],
  [502122179,502333162,'Cancer'],
  [502333162,502535642,'Leo'],
  [502535642,502727601,'Virgo'],
  [502727601,502908993,'Libra'],
  [502908993,503082799,'Scorpio'],
  [503082799,503254770,'Sagittarius'],
  [503254770,503432088,'Capricorn'],
  [503432088,503621390,'Aquarius'],
  [503621390,503825784,'Pisces'],
  [503825784,504042032,'Aries'],
  [504042032,504261902,'Taurus'],
  [504261902,504477842,'Gemini'],
  [504477842,504686653,'Cancer'],
  [504686653,504888212,'Leo'],
  [504888212,505082715,'Virgo'],
  [505082715,505269846,'Libra'],
  [505269846,505450020,'Scorpio'],
  [505450020,505626109,'Sagittarius'],
  [505626109,505803682,'Capricorn'],
  [505803682,505989538,'Aquarius'],
  [505989538,506188979,'Pisces'],
  [506188979,506402008,'Aries'],
  [506402008,506621513,'Taurus'],
  [506621513,506837676,'Gemini'],
  [506837676,507044832,'Cancer'],
  [507044832,507243060,'Leo'],
  [507243060,507434997,'Virgo'],
  [507434997,507622746,'Libra'],
  [507622746,507807093,'Scorpio'],
  [507807093,507988896,'Sagittarius'],
  [507988896,508170893,'Capricorn'],
  [508170893,508357931,'Aquarius'],
  [508357931,508555234,'Pisces'],
  [508555234,508765081,'Aries'],
  [508765081,508983413,'Taurus'],
  [508983413,509200739,'Gemini'],
  [509200739,509408685,'Cancer'],
  [509408685,509605073,'Leo'],
  [509605073,509792825,'Virgo'],
  [509792825,509976353,'Libra'],
  [509976353,510159090,'Scorpio'],
  [510159090,510342947,'Sagittarius'],
  [510342947,510529346,'Capricorn'],
  [510529346,510720481,'Aquarius'],
  [510720481,510919382,'Pisces'],
  [510919382,511128225,'Aries'],
  [511128225,511345366,'Taurus'],
  [511345366,511563861,'Gemini'],
  [511563861,511774711,'Cancer'],
  [511774711,511972775,'Leo'],
  [511972775,512158955,'Virgo'],
  [512158955,512337917,'Libra'],
  [512337917,512515216,'Scorpio'],
  [512515216,512695514,'Sagittarius'],
  [512695514,512881860,'Capricorn'],
  [512881860,513075797,'Aquarius'],
  [513075797,513277909,'Pisces'],
  [513277909,513488159,'Aries'],
  [513488159,513705046,'Taurus'],
  [513705046,513924116,'Gemini'],
  [513924116,514138176,'Cancer'],
  [514138176,514340636,'Leo'],
  [514340636,514529409,'Virgo'],
  [514529409,514707338,'Libra'],
  [514707338,514880168,'Scorpio'],
  [514880168,515054448,'Sagittarius'],
  [515054448,515235937,'Capricorn'],
  [515235937,515428204,'Aquarius'],
  [515428204,515631644,'Pisces'],
  [515631644,515843920,'Aries'],
  [515843920,516061559,'Taurus'],
  [516061559,516280670,'Gemini'],
  [516280670,516496504,'Cancer'],
  [516496504,516703505,'Leo'],
  [516703505,516897663,'Virgo'],
  [516897663,517078938,'Libra'],
  [517078938,517251399,'Scorpio'],
  [517251399,517421693,'Sagittarius'],
  [517421693,517597182,'Capricorn'],
  [517597182,517784052,'Aquarius'],
  [517784052,517984960,'Pisces'],
  [517984960,518197508,'Aries'],
  [518197508,518415991,'Taurus'],
  [518415991,518634959,'Gemini'],
  [518634959,518850670,'Cancer'],
  [518850670,519059874,'Leo'],
  [519059874,519259072,'Virgo'],
  [519259072,519446182,'Libra'],
  [519446182,519622536,'Scorpio'],
  [519622536,519793179,'Sagittarius'],
  [519793179,519965401,'Capricorn'],
  [519965401,520146745,'Aquarius'],
  [520146745,520342466,'Pisces'],
  [520342466,520552452,'Aries'],
  [520552452,520770710,'Taurus'],
  [520770710,520989553,'Gemini'],
  [520989553,521204128,'Cancer'],
  [521204128,521412580,'Leo'],
  [521412580,521613605,'Virgo'],
  [521613605,521805498,'Libra'],
  [521805498,521987671,'Scorpio'],
  [521987671,522162579,'Sagittarius'],
  [522162579,522335848,'Capricorn'],
  [522335848,522514720,'Aquarius'],
  [522514720,522705733,'Pisces'],
  [522705733,522911460,'Aries'],
  [522911460,523127937,'Taurus'],
  [523127937,523346627,'Gemini'],
  [523346627,523560377,'Cancer'],
  [523560377,523766664,'Leo'],
  [523766664,523965876,'Virgo'],
  [523965876,524158542,'Libra'],
  [524158542,524344622,'Scorpio'],
  [524344622,524524940,'Sagittarius'],
  [524524940,524702646,'Capricorn'],
  [524702646,524883124,'Aquarius'],
  [524883124,525072426,'Pisces'],
  [525072426,525274580,'Aries'],
  [525274580,525488404,'Taurus'],
  [525488404,525706774,'Gemini'],
  [525706774,525920902,'Cancer'],
  [525920902,526125941,'Leo'],
  [526125941,526321998,'Virgo'],
  [526321998,526511503,'Libra'],
  [526511503,526696819,'Scorpio'],
  [526696819,526879678,'Sagittarius'],
  [526879678,527062012,'Capricorn'],
  [527062012,527246806,'Aquarius'],
  [527246806,527437996,'Pisces'],
  [527437996,527639119,'Aries'],
  [527639119,527850809,'Taurus'],
  [527850809,528068663,'Gemini'],
  [528068663,528284363,'Cancer'],
  [528284363,528490649,'Leo'],
  [528490649,528685363,'Virgo'],
  [528685363,528870906,'Libra'],
  [528870906,529051656,'Scorpio'],
  [529051656,529231943,'Sagittarius'],
  [529231943,529415101,'Capricorn'],
  [529415101,529603386,'Aquarius'],
  [529603386,529798376,'Pisces'],
  [529798376,530001298,'Aries'],
  [530001298,530212511,'Taurus'],
  [530212511,530429830,'Gemini'],
  [530429830,530647340,'Cancer'],
  [530647340,530857197,'Leo'],
  [530857197,531054266,'Virgo'],
  [531054266,531238767,'Libra'],
  [531238767,531415152,'Scorpio'],
  [531415152,531589711,'Sagittarius'],
  [531589711,531768508,'Capricorn'],
  [531768508,531955766,'Aquarius'],
  [531955766,532152848,'Pisces'],
  [532152848,532358650,'Aries'],
  [532358650,532571184,'Taurus'],
  [532571184,532788338,'Gemini'],
  [532788338,533006705,'Cancer'],
  [533006705,533220357,'Leo'],
  [533220357,533422735,'Virgo'],
  [533422735,533610803,'Libra'],
  [533610803,533786894,'Scorpio'],
  [533786894,533957305,'Sagittarius'],
  [533957305,534129777,'Capricorn'],
  [534129777,534311290,'Aquarius'],
  [534311290,534505724,'Pisces'],
  [534505724,534712215,'Aries'],
  [534712215,534926482,'Taurus'],
  [534926482,535144150,'Gemini'],
  [535144150,535362225,'Cancer'],
  [535362225,535577425,'Leo'],
  [535577425,535784683,'Virgo'],
  [535784683,535979187,'Libra'],
  [535979187,536159982,'Scorpio'],
  [536159982,536331241,'Sagittarius'],
  [536331241,536500416,'Capricorn'],
  [536500416,536675744,'Aquarius'],
  [536675744,536863842,'Pisces'],
  [536863842,537066770,'Aries'],
  [537066770,537280754,'Taurus'],
  [537280754,537499104,'Gemini'],
  [537499104,537716678,'Cancer'],
  [537716678,537930890,'Leo'],
  [537930890,538139348,'Virgo'],
  [538139348,538338622,'Libra'],
  [538338622,538526129,'Scorpio'],
  [538526129,538702927,'Sagittarius'],
  [538702927,538874207,'Capricorn'],
  [538874207,539047451,'Aquarius'],
  [539047451,539230166,'Pisces'],
  [539230166,539427179,'Aries'],
  [539427179,539637790,'Taurus'],
  [539637790,539855700,'Gemini'],
  [539855700,540073271,'Cancer'],
  [540073271,540285951,'Leo'],
  [540285951,540492263,'Virgo'],
  [540492263,540691464,'Libra'],
  [540691464,540882542,'Scorpio'],
  [540882542,541065417,'Sagittarius'],
  [541065417,541242502,'Capricorn'],
  [541242502,541418798,'Aquarius'],
  [541418798,541600605,'Pisces'],
  [541600605,541793486,'Aries'],
  [541793486,541999578,'Taurus'],
  [541999578,542215448,'Gemini'],
  [542215448,542433252,'Cancer'],
  [542433252,542645705,'Leo'],
  [542645705,542849643,'Virgo'],
  [542849643,543045419,'Libra'],
  [543045419,543234716,'Scorpio'],
  [543234716,543419294,'Sagittarius'],
  [543419294,543601077,'Capricorn'],
  [543601077,543782733,'Aquarius'],
  [543782733,543967926,'Pisces'],
  [543967926,544160758,'Aries'],
  [544160758,544364175,'Taurus'],
  [544364175,544577598,'Gemini'],
  [544577598,544795420,'Cancer'],
  [544795420,545009268,'Leo'],
  [545009268,545213133,'Virgo'],
  [545213133,545406038,'Libra'],
  [545406038,545590887,'Scorpio'],
  [545590887,545772043,'Sagittarius'],
  [545772043,545953503,'Capricorn'],
  [545953503,546138101,'Aquarius'],
  [546138101,546327626,'Pisces'],
  [546327626,546523547,'Aries'],
  [546523547,546727371,'Taurus'],
  [546727371,546939541,'Gemini'],
  [546939541,547157185,'Cancer'],
  [547157185,547373220,'Leo'],
  [547373220,547579720,'Virgo'],
  [547579720,547772951,'Libra'],
  [547772951,547954853,'Scorpio'],
  [547954853,548130987,'Sagittarius'],
  [548130987,548307745,'Capricorn'],
  [548307745,548490235,'Aquarius'],
  [548490235,548680971,'Pisces'],
  [548680971,548879924,'Aries'],
  [548879924,549086101,'Taurus'],
  [549086101,549298752,'Gemini'],
  [549298752,549516322,'Cancer'],
  [549516322,549734167,'Leo'],
  [549734167,549944647,'Virgo'],
  [549944647,550141575,'Libra'],
  [550141575,550324371,'Scorpio'],
  [550324371,550497874,'Sagittarius'],
  [550497874,550669475,'Capricorn'],
  [550669475,550846443,'Aquarius'],
  [550846443,551033760,'Pisces'],
  [551033760,551232520,'Aries'],
  [551232520,551440466,'Taurus'],
  [551440466,551654526,'Gemini'],
  [551654526,551872321,'Cancer'],
  [551872321,552090834,'Leo'],
  [552090834,552304472,'Virgo'],
  [552304472,552506575,'Libra'],
  [552506575,552693902,'Scorpio'],
  [552693902,552868999,'Sagittarius'],
  [552868999,553038555,'Capricorn'],
  [553038555,553210556,'Aquarius'],
  [553210556,553392007,'Pisces'],
  [553392007,553586652,'Aries'],
  [553586652,553793546,'Taurus'],
  [553793546,554008375,'Gemini'],
  [554008375,554226567,'Cancer'],
  [554226567,554444724,'Leo'],
  [554444724,554659157,'Virgo'],
  [554659157,554864955,'Libra'],
  [554864955,555058032,'Scorpio'],
  [555058032,555238291,'Sagittarius'],
  [555238291,555410203,'Capricorn'],
  [555410203,555580857,'Aquarius'],
  [555580857,555757752,'Pisces'],
  [555757752,555946689,'Aries'],
  [555946689,556149511,'Taurus'],
  [556149511,556363132,'Gemini'],
  [556363132,556581455,'Cancer'],
  [556581455,556798983,'Leo'],
  [556798983,557012125,'Virgo'],
  [557012125,557218151,'Libra'],
  [557218151,557414636,'Scorpio'],
  [557414636,557600632,'Sagittarius'],
  [557600632,557778097,'Capricorn'],
  [557778097,557951796,'Aquarius'],
  [557951796,558128032,'Pisces'],
  [558128032,558313028,'Aries'],
  [558313028,558510875,'Taurus'],
  [558510875,558721313,'Gemini'],
  [558721313,558939001,'Cancer'],
  [558939001,559156375,'Leo'],
  [559156375,559367897,'Virgo'],
  [559367897,559571409,'Libra'],
  [559571409,559766932,'Scorpio'],
  [559766932,559955285,'Sagittarius'],
  [559955285,560137874,'Capricorn'],
  [560137874,560317150,'Aquarius'],
  [560317150,560496881,'Pisces'],
  [560496881,560681834,'Aries'],
  [560681834,560876608,'Taurus'],
  [560876608,561083437,'Gemini'],
  [561083437,561299643,'Cancer'],
  [561299643,561517552,'Leo'],
  [561517552,561728995,'Virgo'],
  [561728995,561930093,'Libra'],
  [561930093,562121817,'Scorpio'],
  [562121817,562307571,'Sagittarius'],
  [562307571,562490804,'Capricorn'],
  [562490804,562673965,'Aquarius'],
  [562673965,562858783,'Pisces'],
  [562858783,563047317,'Aries'],
  [563047317,563242555,'Taurus'],
  [563242555,563447400,'Gemini'],
  [563447400,563661892,'Cancer'],
  [563661892,563880561,'Leo'],
  [563880561,564094096,'Virgo'],
  [564094096,564295603,'Libra'],
  [564295603,564484582,'Scorpio'],
  [564484582,564665500,'Sagittarius'],
  [564665500,564844355,'Capricorn'],
  [564844355,565026026,'Aquarius'],
  [565026026,565212946,'Pisces'],
  [565212946,565405527,'Aries'],
  [565405527,565604007,'Taurus'],
  [565604007,565809597,'Gemini'],
  [565809597,566023205,'Cancer'],
  [566023205,566242203,'Leo'],
  [566242203,566458797,'Virgo'],
  [566458797,566664070,'Libra'],
  [566664070,566854375,'Scorpio'],
  [566854375,567032861,'Sagittarius'],
  [567032861,567206394,'Capricorn'],
  [567206394,567382199,'Aquarius'],
  [567382199,567565513,'Pisces'],
  [567565513,567758191,'Aries'],
  [567758191,567959314,'Taurus'],
  [567959314,568167395,'Gemini'],
  [568167395,568381628,'Cancer'],
  [568381628,568600499,'Leo'],
  [568600499,568819032,'Virgo'],
  [568819032,569029154,'Libra'],
  [569029154,569224700,'Scorpio'],
  [569224700,569405719,'Sagittarius'],
  [569405719,569577718,'Capricorn'],
  [569577718,569748394,'Aquarius'],
  [569748394,569925045,'Pisces'],
  [569925045,570112581,'Aries'],
  [570112581,570312125,'Taurus'],
  [570312125,570521474,'Gemini'],
  [570521474,570737159,'Cancer'],
  [570737159,570956053,'Leo'],
  [570956053,571174556,'Virgo'],
  [571174556,571387299,'Libra'],
  [571387299,571588549,'Scorpio'],
  [571588549,571775783,'Sagittarius'],
  [571775783,571951507,'Capricorn'],
  [571951507,572121824,'Aquarius'],
  [572121824,572294088,'Pisces'],
  [572294088,572475030,'Aries'],
  [572475030,572668919,'Taurus'],
  [572668919,572875903,'Gemini'],
  [572875903,573091923,'Cancer'],
  [573091923,573311173,'Leo'],
  [573311173,573528718,'Virgo'],
  [573528718,573740817,'Libra'],
  [573740817,573944322,'Scorpio'],
  [573944322,574137065,'Sagittarius'],
  [574137065,574319267,'Capricorn'],
  [574319267,574494122,'Aquarius'],
  [574494122,574667106,'Pisces'],
  [574667106,574844701,'Aries'],
  [574844701,575032858,'Taurus'],
  [575032858,575234832,'Gemini'],
  [575234832,575448823,'Cancer'],
  [575448823,575668111,'Leo'],
  [575668111,575885103,'Virgo'],
  [575885103,576095138,'Libra'],
  [576095138,576296924,'Scorpio'],
  [576296924,576490761,'Sagittarius'],
  [576490761,576677410,'Capricorn'],
  [576677410,576858256,'Aquarius'],
  [576858256,577036004,'Pisces'],
  [577036004,577215070,'Aries'],
  [577215070,577400996,'Taurus'],
  [577400996,577598657,'Gemini'],
  [577598657,577809245,'Cancer'],
  [577809245,578027748,'Leo'],
  [578027748,578245041,'Virgo'],
  [578245041,578453946,'Libra'],
  [578453946,578652726,'Scorpio'],
  [578652726,578843630,'Sagittarius'],
  [578843630,579029804,'Capricorn'],
  [579029804,579213520,'Aquarius'],
  [579213520,579396199,'Pisces'],
  [579396199,579579714,'Aries'],
  [579579714,579767480,'Taurus'],
  [579767480,579963910,'Gemini'],
  [579963910,580171882,'Cancer'],
  [580171882,580389142,'Leo'],
  [580389142,580607350,'Virgo'],
  [580607350,580817172,'Libra'],
  [580817172,581014629,'Scorpio'],
  [581014629,581201904,'Sagittarius'],
  [581201904,581384018,'Capricorn'],
  [581384018,581565619,'Aquarius'],
  [581565619,581749424,'Pisces'],
  [581749424,581936528,'Aries'],
  [581936528,582128062,'Taurus'],
  [582128062,582326324,'Gemini'],
  [582326324,582533825,'Cancer'],
  [582533825,582750196,'Leo'],
  [582750196,582969422,'Virgo'],
  [582969422,583181900,'Libra'],
  [583181900,583381066,'Scorpio'],
  [583381066,583567185,'Sagittarius'],
  [583567185,583745370,'Capricorn'],
  [583745370,583921995,'Aquarius'],
  [583921995,584102212,'Pisces'],
  [584102212,584288801,'Aries'],
  [584288801,584482557,'Taurus'],
  [584482557,584683697,'Gemini'],
  [584683697,584892665,'Cancer'],
  [584892665,585109029,'Leo'],
  [585109029,585328890,'Virgo'],
  [585328890,585544376,'Libra'],
  [585544376,585747718,'Scorpio'],
  [585747718,585936419,'Sagittarius'],
  [585936419,586113890,'Capricorn'],
  [586113890,586286563,'Aquarius'],
  [586286563,586461177,'Pisces'],
  [586461177,586643036,'Aries'],
  [586643036,586834954,'Taurus'],
  [586834954,587037130,'Gemini'],
  [587037130,587247975,'Cancer'],
  [587247975,587465125,'Leo'],
  [587465125,587685091,'Virgo'],
  [587685091,587902289,'Libra'],
  [587902289,588110076,'Scorpio'],
  [588110076,588304138,'Sagittarius'],
  [588304138,588485082,'Capricorn'],
  [588485082,588657659,'Aquarius'],
  [588657659,588828543,'Pisces'],
  [588828543,589004534,'Aries'],
  [589004534,589191067,'Taurus'],
  [589191067,589390609,'Gemini'],
  [589390609,589601650,'Cancer'],
  [589601650,589819651,'Leo'],
  [589819651,590039457,'Virgo'],
  [590039457,590256421,'Libra'],
  [590256421,590466306,'Scorpio'],
  [590466306,590665500,'Sagittarius'],
  [590665500,590852574,'Capricorn'],
  [590852574,591029442,'Aquarius'],
  [591029442,591200961,'Pisces'],
  [591200961,591373714,'Aries'],
  [591373714,591554564,'Taurus'],
  [591554564,591748708,'Gemini'],
  [591748708,591957046,'Cancer'],
  [591957046,592174866,'Leo'],
  [592174866,592394598,'Virgo'],
  [592394598,592610269,'Libra'],
  [592610269,592819067,'Scorpio'],
  [592819067,593019868,'Sagittarius'],
  [593019868,593211881,'Capricorn'],
  [593211881,593395107,'Aquarius'],
  [593395107,593571536,'Pisces'],
  [593571536,593745727,'Aries'],
  [593745727,593924120,'Taurus'],
  [593924120,594113283,'Gemini'],
  [594113283,594316998,'Cancer'],
  [594316998,594532893,'Leo'],
  [594532893,594752626,'Virgo'],
  [594752626,594967570,'Libra'],
  [594967570,595173933,'Scorpio'],
  [595173933,595372334,'Sagittarius'],
  [595372334,595564573,'Capricorn'],
  [595564573,595751615,'Aquarius'],
  [595751615,595933941,'Pisces'],
  [595933941,596113311,'Aries'],
  [596113311,596293895,'Taurus'],
  [596293895,596481568,'Gemini'],
  [596481568,596681497,'Cancer'],
  [596681497,596894364,'Leo'],
  [596894364,597113751,'Virgo'],
  [597113751,597329471,'Libra'],
  [597329471,597534920,'Scorpio'],
  [597534920,597729999,'Sagittarius'],
  [597729999,597918316,'Capricorn'],
  [597918316,598103567,'Aquarius'],
  [598103567,598287781,'Pisces'],
  [598287781,598471846,'Aries'],
  [598471846,598657362,'Taurus'],
  [598657362,598847687,'Gemini'],
  [598847687,599047036,'Cancer'],
  [599047036,599257632,'Leo'],
  [599257632,599476164,'Virgo'],
  [599476164,599693626,'Libra'],
  [599693626,599901092,'Scorpio'],
  [599901092,600095633,'Sagittarius'],
  [600095633,600280229,'Capricorn'],
  [600280229,600460244,'Aquarius'],
  [600460244,600640533,'Pisces'],
  [600640533,600824147,'Aries'],
  [600824147,601012591,'Taurus'],
  [601012591,601207014,'Gemini'],
  [601207014,601408936,'Cancer'],
  [601408936,601619531,'Leo'],
  [601619531,601837284,'Virgo'],
  [601837284,602056119,'Libra'],
  [602056119,602267407,'Scorpio'],
  [602267407,602465376,'Sagittarius'],
  [602465376,602650252,'Capricorn'],
  [602650252,602826722,'Aquarius'],
  [602826722,603001059,'Pisces'],
  [603001059,603179089,'Aries'],
  [603179089,603364934,'Taurus'],
  [603364934,603560396,'Gemini'],
  [603560396,603765156,'Cancer'],
  [603765156,603977649,'Leo'],
  [603977649,604195479,'Virgo'],
  [604195479,604414606,'Libra'],
  [604414606,604628942,'Scorpio'],
  [604628942,604832267,'Sagittarius'],
  [604832267,605021791,'Capricorn'],
  [605021791,605199529,'Aquarius'],
  [605199529,605370979,'Pisces'],
  [605370979,605543097,'Aries'],
  [605543097,605722564,'Taurus'],
  [605722564,605914035,'Gemini'],
  [605914035,606118363,'Cancer'],
  [606118363,606332359,'Leo'],
  [606332359,606551028,'Virgo'],
  [606551028,606769816,'Libra'],
  [606769816,606984827,'Scorpio'],
  [606984827,607191921,'Sagittarius'],
  [607191921,607387490,'Capricorn'],
  [607387490,607570628,'Aquarius'],
  [607570628,607744254,'Pisces'],
  [607744254,607914437,'Aries'],
  [607914437,608088660,'Taurus'],
  [608088660,608273873,'Gemini'],
  [608273873,608473864,'Cancer'],
  [608473864,608686748,'Leo'],
  [608686748,608905883,'Virgo'],
  [608905883,609124386,'Libra'],
  [609124386,609338290,'Scorpio'],
  [609338290,609545702,'Sagittarius'],
  [609545702,609744770,'Capricorn'],
  [609744770,609933799,'Aquarius'],
  [609933799,610113041,'Pisces'],
  [610113041,610286096,'Aries'],
  [610286096,610459390,'Taurus'],
  [610459390,610640367,'Gemini'],
  [610640367,610834966,'Cancer'],
  [610834966,611044205,'Leo'],
  [611044205,611262424,'Virgo'],
  [611262424,611480850,'Libra'],
  [611480850,611693498,'Scorpio'],
  [611693498,611898836,'Sagittarius'],
  [611898836,612097264,'Capricorn'],
  [612097264,612288782,'Aquarius'],
  [612288782,612473123,'Pisces'],
  [612473123,612651562,'Aries'],
  [612651562,612828136,'Taurus'],
  [612828136,613009019,'Gemini'],
  [613009019,613200484,'Cancer'],
  [613200484,613405756,'Leo'],
  [613405756,613621855,'Virgo'],
  [613621855,613840261,'Libra'],
  [613840261,614052739,'Scorpio'],
  [614052739,614256084,'Sagittarius'],
  [614256084,614451399,'Capricorn'],
  [614451399,614640967,'Aquarius'],
  [614640967,614826357,'Pisces'],
  [614826357,615008702,'Aries'],
  [615008702,615190088,'Taurus'],
  [615190088,615374323,'Gemini'],
  [615374323,615566228,'Cancer'],
  [615566228,615769454,'Leo'],
  [615769454,615983407,'Virgo'],
  [615983407,616201737,'Libra'],
  [616201737,616415473,'Scorpio'],
  [616415473,616618872,'Sagittarius'],
  [616618872,616811713,'Capricorn'],
  [616811713,616997198,'Aquarius'],
  [616997198,617179231,'Pisces'],
  [617179231,617360996,'Aries'],
  [617360996,617544882,'Taurus'],
  [617544882,617733096,'Gemini'],
  [617733096,617928056,'Cancer'],
  [617928056,618131924,'Leo'],
  [618131924,618344878,'Virgo'],
  [618344878,618563084,'Libra'],
  [618563084,618778939,'Scorpio'],
  [618778939,618984980,'Sagittarius'],
  [618984980,619178327,'Capricorn'],
  [619178327,619361132,'Aquarius'],
  [619361132,619538323,'Pisces'],
  [619538323,619715427,'Aries'],
  [619715427,619897119,'Taurus'],
  [619897119,620086378,'Gemini'],
  [620086378,620284287,'Cancer'],
  [620284287,620490551,'Leo'],
  [620490551,620704043,'Virgo'],
  [620704043,620922180,'Libra'],
  [620922180,621139835,'Scorpio'],
  [621139835,621349982,'Sagittarius'],
  [621349982,621547292,'Capricorn'],
  [621547292,621731250,'Aquarius'],
  [621731250,621905892,'Pisces'],
  [621905892,622077743,'Aries'],
  [622077743,622253744,'Taurus'],
  [622253744,622439411,'Gemini'],
  [622439411,622637042,'Cancer'],
  [622637042,622845132,'Leo'],
  [622845132,623060083,'Virgo'],
  [623060083,623278365,'Libra'],
  [623278365,623496550,'Scorpio'],
  [623496550,623709905,'Sagittarius'],
  [623709905,623912784,'Capricorn'],
  [623912784,624101849,'Aquarius'],
  [624101849,624278490,'Pisces'],
  [624278490,624448349,'Aries'],
  [624448349,624619151,'Taurus'],
  [624619151,624798541,'Gemini'],
  [624798541,624991640,'Cancer'],
  [624991640,625198493,'Leo'],
  [625198493,625414261,'Virgo'],
  [625414261,625632947,'Libra'],
  [625632947,625850551,'Scorpio'],
  [625850551,626064391,'Sagittarius'],
  [626064391,626270948,'Capricorn'],
  [626270948,626466275,'Aquarius'],
  [626466275,626648882,'Pisces'],
  [626648882,626821757,'Aries'],
  [626821757,626991529,'Taurus'],
  [626991529,627166265,'Gemini'],
  [627166265,627353124,'Cancer'],
  [627353124,627555259,'Leo'],
  [627555259,627769505,'Virgo'],
  [627769505,627988382,'Libra'],
  [627988382,628205378,'Scorpio'],
  [628205378,628417565,'Sagittarius'],
  [628417565,628623717,'Capricorn'],
  [628623717,628822055,'Aquarius'],
  [628822055,629010679,'Pisces'],
  [629010679,629189924,'Aries'],
  [629189924,629363694,'Taurus'],
  [629363694,629538542,'Gemini'],
  [629538542,629721682,'Cancer'],
  [629721682,629918362,'Leo'],
  [629918362,630128715,'Virgo'],
  [630128715,630346698,'Libra'],
  [630346698,630563819,'Scorpio'],
  [630563819,630774612,'Sagittarius'],
  [630774612,630977857,'Capricorn'],
  [630977857,631174207,'Aquarius'],
  [631174207,631364176,'Pisces'],
  [631364176,631548228,'Aries'],
  [631548228,631728093,'Taurus'],
  [631728093,631907519,'Gemini'],
  [631907519,632091737,'Cancer'],
  [632091737,632285843,'Leo'],
  [632285843,632492246,'Virgo'],
  [632492246,632708153,'Libra'],
  [632708153,632925825,'Scorpio'],
  [632925825,633137234,'Sagittarius'],
  [633137234,633338695,'Capricorn'],
  [633338695,633531040,'Aquarius'],
  [633531040,633717243,'Pisces'],
  [633717243,633900423,'Aries'],
  [633900423,634083134,'Taurus'],
  [634083134,634267607,'Gemini'],
  [634267607,634456287,'Cancer'],
  [634456287,634651977,'Leo'],
  [634651977,634856945,'Virgo'],
  [634856945,635070852,'Libra'],
  [635070852,635288816,'Scorpio'],
  [635288816,635502599,'Sagittarius'],
  [635502599,635705532,'Capricorn'],
  [635705532,635896173,'Aquarius'],
  [635896173,636077779,'Pisces'],
  [636077779,636255771,'Aries'],
  [636255771,636435451,'Taurus'],
  [636435451,636620541,'Gemini'],
  [636620541,636812665,'Cancer'],
  [636812665,637012010,'Leo'],
  [637012010,637218520,'Virgo'],
  [637218520,637431891,'Libra'],
  [637431891,637649762,'Scorpio'],
  [637649762,637866080,'Sagittarius'],
  [637866080,638073055,'Capricorn'],
  [638073055,638266121,'Aquarius'],
  [638266121,638446531,'Pisces'],
  [638446531,638619979,'Aries'],
  [638619979,638793719,'Taurus'],
  [638793719,638974173,'Gemini'],
  [638974173,639164985,'Cancer'],
  [639164985,639366086,'Leo'],
  [639366086,639575053,'Virgo'],
  [639575053,639789456,'Libra'],
  [639789456,640007260,'Scorpio'],
  [640007260,640224873,'Sagittarius'],
  [640224873,640435940,'Capricorn'],
  [640435940,640634206,'Aquarius'],
  [640634206,640817902,'Pisces'],
  [640817902,640990960,'Aries'],
  [640990960,641160720,'Taurus'],
  [641160720,641335143,'Gemini'],
  [641335143,641520502,'Cancer'],
  [641520502,641719074,'Leo'],
  [641719074,641928490,'Virgo'],
  [641928490,642144137,'Libra'],
  [642144137,642362162,'Scorpio'],
  [642362162,642579654,'Sagittarius'],
  [642579654,642792596,'Capricorn'],
  [642792596,642995623,'Aquarius'],
  [642995623,643185089,'Pisces'],
  [643185089,643362125,'Aries'],
  [643362125,643532385,'Taurus'],
  [643532385,643703621,'Gemini'],
  [643703621,643883345,'Cancer'],
  [643883345,644076460,'Leo'],
  [644076460,644283042,'Virgo'],
  [644283042,644498486,'Libra'],
  [644498486,644716758,'Scorpio'],
  [644716758,644933494,'Sagittarius'],
  [644933494,645145736,'Capricorn'],
  [645145736,645350392,'Aquarius'],
  [645350392,645544489,'Pisces'],
  [645544489,645727360,'Aries'],
  [645727360,645902064,'Taurus'],
  [645902064,646074565,'Gemini'],
  [646074565,646251890,'Cancer'],
  [646251890,646440117,'Leo'],
  [646440117,646642009,'Virgo'],
  [646642009,646855241,'Libra'],
  [646855241,647073318,'Scorpio'],
  [647073318,647289563,'Sagittarius'],
  [647289563,647499989,'Capricorn'],
  [647499989,647702944,'Aquarius'],
  [647702944,647897773,'Pisces'],
  [647897773,648084514,'Aries'],
  [648084514,648264696,'Taurus'],
  [648264696,648441812,'Gemini'],
  [648441812,648620906,'Cancer'],
  [648620906,648807442,'Leo'],
  [648807442,649005509,'Virgo'],
  [649005509,649215532,'Libra'],
  [649215532,649432778,'Scorpio'],
  [649432778,649649309,'Sagittarius'],
  [649649309,649858738,'Capricorn'],
  [649858738,650058846,'Aquarius'],
  [650058846,650250750,'Pisces'],
  [650250750,650436874,'Aries'],
  [650436874,650619684,'Taurus'],
  [650619684,650801528,'Gemini'],
  [650801528,650985055,'Cancer'],
  [650985055,651173568,'Leo'],
  [651173568,651370592,'Virgo'],
  [651370592,651578159,'Libra'],
  [651578159,651794237,'Scorpio'],
  [651794237,652011768,'Sagittarius'],
  [652011768,652222252,'Capricorn'],
  [652222252,652421131,'Aquarius'],
  [652421131,652609371,'Pisces'],
  [652609371,652791312,'Aries'],
  [652791312,652971877,'Taurus'],
  [652971877,653154761,'Gemini'],
  [653154761,653341908,'Cancer'],
  [653341908,653534303,'Leo'],
  [653534303,653733233,'Virgo'],
  [653733233,653940335,'Libra'],
  [653940335,654155518,'Scorpio'],
  [654155518,654374174,'Sagittarius'],
  [654374174,654587618,'Capricorn'],
  [654587618,654788528,'Aquarius'],
  [654788528,654975705,'Pisces'],
  [654975705,655153552,'Aries'],
  [655153552,655328819,'Taurus'],
  [655328819,655507757,'Gemini'],
  [655507757,655694179,'Cancer'],
  [655694179,655888828,'Leo'],
  [655888828,656090784,'Virgo'],
  [656090784,656299435,'Libra'],
  [656299435,656514546,'Scorpio'],
  [656514546,656733765,'Sagittarius'],
  [656733765,656950430,'Capricorn'],
  [656950430,657156096,'Aquarius'],
  [657156096,657346458,'Pisces'],
  [657346458,657523898,'Aries'],
  [657523898,657695153,'Taurus'],
  [657695153,657868037,'Gemini'],
  [657868037,658049029,'Cancer'],
  [658049029,658241285,'Leo'],
  [658241285,658444102,'Virgo'],
  [658444102,658654750,'Libra'],
  [658654750,658870738,'Scorpio'],
  [658870738,659089879,'Sagittarius'],
  [659089879,659308011,'Capricorn'],
  [659308011,659518300,'Aquarius'],
  [659518300,659714777,'Pisces'],
  [659714777,659896637,'Aries'],
  [659896637,660068568,'Taurus'],
  [660068568,660238045,'Gemini'],
  [660238045,660412789,'Cancer'],
  [660412789,660598722,'Leo'],
  [660598722,660797999,'Virgo'],
  [660797999,661008457,'Libra'],
  [661008457,661225426,'Scorpio'],
  [661225426,661444471,'Sagittarius'],
  [661444471,661661939,'Capricorn'],
  [661661939,661873661,'Aquarius'],
  [661873661,662075098,'Pisces'],
  [662075098,662263735,'Aries'],
  [662263735,662441149,'Taurus'],
  [662441149,662612536,'Gemini'],
  [662612536,662784848,'Cancer'],
  [662784848,662965002,'Leo'],
  [662965002,663157990,'Virgo'],
  [663157990,663364743,'Libra'],
  [663364743,663581171,'Scorpio'],
  [663581171,663800406,'Sagittarius'],
  [663800406,664016657,'Capricorn'],
  [664016657,664226594,'Aquarius'],
  [664226594,664428455,'Pisces'],
  [664428455,664621234,'Aries'],
  [664621234,664805183,'Taurus'],
  [664805183,664982582,'Gemini'],
  [664982582,665157806,'Cancer'],
  [665157806,665336635,'Leo'],
  [665336635,665524925,'Virgo'],
  [665524925,665726463,'Libra'],
  [665726463,665940187,'Scorpio'],
  [665940187,666159337,'Sagittarius'],
  [666159337,666375386,'Capricorn'],
  [666375386,666583124,'Aquarius'],
  [666583124,666781891,'Pisces'],
  [666781891,666973450,'Aries'],
  [666973450,667159812,'Taurus'],
  [667159812,667342581,'Gemini'],
  [667342581,667523566,'Cancer'],
  [667523566,667705806,'Leo'],
  [667705806,667893783,'Virgo'],
  [667893783,668092086,'Libra'],
  [668092086,668302490,'Scorpio'],
  [668302490,668520821,'Sagittarius'],
  [668520821,668737847,'Capricorn'],
  [668737847,668945448,'Aquarius'],
  [668945448,669141453,'Pisces'],
  [669141453,669328827,'Aries'],
  [669328827,669512197,'Taurus'],
  [669512197,669695238,'Gemini'],
  [669695238,669879803,'Cancer'],
  [669879803,670066852,'Leo'],
  [670066852,670258167,'Virgo'],
  [670258167,670456854,'Libra'],
  [670456854,670665524,'Scorpio'],
  [670665524,670882774,'Sagittarius'],
  [670882774,671101172,'Capricorn'],
  [671101172,671311051,'Aquarius'],
  [671311051,671507374,'Pisces'],
  [671507374,671691939,'Aries'],
  [671691939,671870466,'Taurus'],
  [671870466,672049036,'Gemini'],
  [672049036,672231852,'Cancer'],
  [672231852,672420555,'Leo'],
  [672420555,672615360,'Virgo'],
  [672615360,672816823,'Libra'],
  [672816823,673026116,'Scorpio'],
  [673026116,673242872,'Sagittarius'],
  [673242872,673462247,'Capricorn'],
  [673462247,673675451,'Aquarius'],
  [673675451,673875271,'Pisces'],
  [673875271,674060844,'Aries'],
  [674060844,674236915,'Taurus'],
  [674236915,674410425,'Gemini'],
  [674410425,674587792,'Cancer'],
  [674587792,674773212,'Leo'],
  [674773212,674968053,'Virgo'],
  [674968053,675171684,'Libra'],
  [675171684,675382859,'Scorpio'],
  [675382859,675600022,'Sagittarius'],
  [675600022,675819688,'Capricorn'],
  [675819688,676035369,'Aquarius'],
  [676035369,676239907,'Pisces'],
  [676239907,676429952,'Aries'],
  [676429952,676607789,'Taurus'],
  [676607789,676779395,'Gemini'],
  [676779395,676951827,'Cancer'],
  [676951827,677131371,'Leo'],
  [677131371,677322068,'Virgo'],
  [677322068,677524707,'Libra'],
  [677524707,677736964,'Scorpio'],
  [677736964,677954952,'Sagittarius'],
  [677954952,678174436,'Capricorn'],
  [678174436,678390636,'Aquarius'],
  [678390636,678598407,'Pisces'],
  [678598407,678793913,'Aries'],
  [678793913,678976900,'Taurus'],
  [678976900,679150962,'Gemini'],
  [679150962,679322099,'Cancer'],
  [679322099,679497098,'Leo'],
  [679497098,679682037,'Virgo'],
  [679682037,679880436,'Libra'],
  [679880436,680091392,'Scorpio'],
  [680091392,680309707,'Sagittarius'],
  [680309707,680528933,'Capricorn'],
  [680528933,680744067,'Aquarius'],
  [680744067,680951998,'Pisces'],
  [680951998,681150695,'Aries'],
  [681150695,681339256,'Taurus'],
  [681339256,681518816,'Gemini'],
  [681518816,681692956,'Cancer'],
  [681692956,681867283,'Leo'],
  [681867283,682048309,'Virgo'],
  [682048309,682241612,'Libra'],
  [682241612,682449038,'Scorpio'],
  [682449038,682666446,'Sagittarius'],
  [682666446,682885599,'Capricorn'],
  [682885599,683099467,'Aquarius'],
  [683099467,683305245,'Pisces'],
  [683305245,683503176,'Aries'],
  [683503176,683694126,'Taurus'],
  [683694126,683878767,'Gemini'],
  [683878767,684058383,'Cancer'],
  [684058383,684236094,'Leo'],
  [684236094,684417082,'Virgo'],
  [684417082,684607320,'Libra'],
  [684607320,684810853,'Scorpio'],
  [684810853,685026206,'Sagittarius'],
  [685026206,685245448,'Capricorn'],
  [685245448,685459219,'Aquarius'],
  [685459219,685662933,'Pisces'],
  [685662933,685857549,'Aries'],
  [685857549,686046321,'Taurus'],
  [686046321,686231890,'Gemini'],
  [686231890,686415510,'Cancer'],
  [686415510,686598272,'Leo'],
  [686598272,686782815,'Virgo'],
  [686782815,686973584,'Libra'],
  [686973584,687175054,'Scorpio'],
  [687175054,687388204,'Sagittarius'],
  [687388204,687607452,'Capricorn'],
  [687607452,687822765,'Aquarius'],
  [687822765,688026784,'Pisces'],
  [688026784,688218923,'Aries'],
  [688218923,688403307,'Taurus'],
  [688403307,688585005,'Gemini'],
  [688585005,688767617,'Cancer'],
  [688767617,688952797,'Leo'],
  [688952797,689141545,'Virgo'],
  [689141545,689335716,'Libra'],
  [689335716,689538057,'Scorpio'],
  [689538057,689750161,'Sagittarius'],
  [689750161,689969158,'Capricorn'],
  [689969158,690186791,'Aquarius'],
  [690186791,690394058,'Pisces'],
  [690394058,690587343,'Aries'],
  [690587343,690769346,'Taurus'],
  [690769346,690945913,'Gemini'],
  [690945913,691123038,'Cancer'],
  [691123038,691305121,'Leo'],
  [691305121,691494405,'Virgo'],
  [691494405,691691576,'Libra'],
  [691691576,691896735,'Scorpio'],
  [691896735,692109646,'Sagittarius'],
  [692109646,692328386,'Capricorn'],
  [692328386,692547538,'Aquarius'],
  [692547538,692759189,'Pisces'],
  [692759189,692957381,'Aries'],
  [692957381,693141686,'Taurus'],
  [693141686,693316477,'Gemini'],
  [693316477,693488302,'Cancer'],
  [693488302,693663809,'Leo'],
  [693663809,693848243,'Virgo'],
  [693848243,694044185,'Libra'],
  [694044185,694250997,'Scorpio'],
  [694250997,694465736,'Sagittarius'],
  [694465736,694684741,'Capricorn'],
  [694684741,694903911,'Aquarius'],
  [694903911,695118143,'Pisces'],
  [695118143,695322010,'Aries'],
  [695322010,695512475,'Taurus'],
  [695512475,695690759,'Gemini'],
  [695690759,695861793,'Cancer'],
  [695861793,696032508,'Leo'],
  [696032508,696210128,'Virgo'],
  [696210128,696400312,'Libra'],
  [696400312,696604772,'Scorpio'],
  [696604772,696820039,'Sagittarius'],
  [696820039,697039717,'Capricorn'],
  [697039717,697258230,'Aquarius'],
  [697258230,697472091,'Pisces'],
  [697472091,697678537,'Aries'],
  [697678537,697874871,'Taurus'],
  [697874871,698059851,'Gemini'],
  [698059851,698235305,'Cancer'],
  [698235305,698406381,'Leo'],
  [698406381,698580260,'Virgo'],
  [698580260,698764261,'Libra'],
  [698764261,698963169,'Scorpio'],
  [698963169,699175986,'Sagittarius'],
  [699175986,699395641,'Capricorn'],
  [699395641,699613845,'Aquarius'],
  [699613845,699825990,'Pisces'],
  [699825990,700031100,'Aries'],
  [700031100,700228996,'Taurus'],
  [700228996,700418972,'Gemini'],
  [700418972,700600831,'Cancer'],
  [700600831,700776793,'Leo'],
  [700776793,700952069,'Virgo'],
  [700952069,701133582,'Libra'],
  [701133582,701327575,'Scorpio'],
  [701327575,701536106,'Sagittarius'],
  [701536106,701754260,'Capricorn'],
  [701754260,701972584,'Aquarius'],
  [701972584,702183825,'Pisces'],
  [702183825,702386271,'Aries'],
  [702386271,702581567,'Taurus'],
  [702581567,702771485,'Gemini'],
  [702771485,702956749,'Cancer'],
  [702956749,703138136,'Leo'],
  [703138136,703318220,'Virgo'],
  [703318220,703501779,'Libra'],
  [703501779,703694400,'Scorpio'],
  [703694400,703899624,'Sagittarius'],
  [703899624,704115499,'Capricorn'],
  [704115499,704333981,'Aquarius'],
  [704333981,704545997,'Pisces'],
  [704545997,704747356,'Aries'],
  [704747356,704939291,'Taurus'],
  [704939291,705125369,'Gemini'],
  [705125369,705308823,'Cancer'],
  [705308823,705491757,'Leo'],
  [705491757,705675900,'Virgo'],
  [705675900,705863703,'Libra'],
  [705863703,706058493,'Scorpio'],
  [706058493,706263141,'Sagittarius'],
  [706263141,706477404,'Capricorn'],
  [706477404,706695904,'Aquarius'],
  [706695904,706909949,'Pisces'],
  [706909949,707112959,'Aries'],
  [707112959,707303940,'Taurus'],
  [707303940,707486258,'Gemini'],
  [707486258,707664888,'Cancer'],
  [707664888,707844460,'Leo'],
  [707844460,708028388,'Virgo'],
  [708028388,708218802,'Libra'],
  [708218802,708416929,'Scorpio'],
  [708416929,708623379,'Sagittarius'],
  [708623379,708837523,'Capricorn'],
  [708837523,709055977,'Aquarius'],
  [709055977,709272187,'Pisces'],
  [709272187,709478905,'Aries'],
  [709478905,709672425,'Taurus'],
  [709672425,709854123,'Gemini'],
  [709854123,710028905,'Cancer'],
  [710028905,710203040,'Leo'],
  [710203040,710382433,'Virgo'],
  [710382433,710571202,'Libra'],
  [710571202,710770635,'Scorpio'],
  [710770635,710979330,'Sagittarius'],
  [710979330,711194562,'Capricorn'],
  [711194562,711413050,'Aquarius'],
  [711413050,711630433,'Pisces'],
  [711630433,711840949,'Aries'],
  [711840949,712039451,'Taurus'],
  [712039451,712224492,'Gemini'],
  [712224492,712399154,'Cancer'],
  [712399154,712569672,'Leo'],
  [712569672,712743415,'Virgo'],
  [712743415,712926954,'Libra'],
  [712926954,713123819,'Scorpio'],
  [713123819,713332815,'Sagittarius'],
  [713332815,713549183,'Capricorn'],
  [713549183,713767853,'Aquarius'],
  [713767853,713985076,'Pisces'],
  [713985076,714197380,'Aries'],
  [714197380,714400567,'Taurus'],
  [714400567,714591390,'Gemini'],
  [714591390,714770104,'Cancer'],
  [714770104,714941184,'Leo'],
  [714941184,715111837,'Virgo'],
  [715111837,715289896,'Libra'],
  [715289896,715481399,'Scorpio'],
  [715481399,715687558,'Sagittarius'],
  [715687558,715903688,'Capricorn'],
  [715903688,716122550,'Aquarius'],
  [716122550,716338926,'Pisces'],
  [716338926,716550419,'Aries'],
  [716550419,716755181,'Taurus'],
  [716755181,716950734,'Gemini'],
  [716950734,717135533,'Cancer'],
  [717135533,717311281,'Leo'],
  [717311281,717483318,'Virgo'],
  [717483318,717659032,'Libra'],
  [717659032,717845603,'Scorpio'],
  [717845603,718046941,'Sagittarius'],
  [718046941,718260763,'Capricorn'],
  [718260763,718479450,'Aquarius'],
  [718479450,718695353,'Pisces'],
  [718695353,718904902,'Aries'],
  [718904902,719107694,'Taurus'],
  [719107694,719303741,'Gemini'],
  [719303741,719492461,'Cancer'],
  [719492461,719674046,'Leo'],
  [719674046,719851163,'Virgo'],
  [719851163,720029054,'Libra'],
  [720029054,720214116,'Scorpio'],
  [720214116,720411471,'Sagittarius'],
  [720411471,720621784,'Capricorn'],
  [720621784,720839545,'Aquarius'],
  [720839545,721055956,'Pisces'],
  [721055956,721264736,'Aries'],
  [721264736,721464564,'Taurus'],
  [721464564,721657136,'Gemini'],
  [721657136,721844577,'Cancer'],
  [721844577,722028484,'Leo'],
  [722028484,722210552,'Virgo'],
  [722210552,722393502,'Libra'],
  [722393502,722581244,'Scorpio'],
  [722581244,722777880,'Sagittarius'],
  [722777880,722985534,'Capricorn'],
  [722985534,723201792,'Aquarius'],
  [723201792,723419316,'Pisces'],
  [723419316,723629781,'Aries'],
  [723629781,723828993,'Taurus'],
  [723828993,724017912,'Gemini'],
  [724017912,724200418,'Cancer'],
  [724200418,724380960,'Leo'],
  [724380960,724563189,'Virgo'],
  [724563189,724749573,'Libra'],
  [724749573,724941740,'Scorpio'],
  [724941740,725141052,'Sagittarius'],
  [725141052,725348580,'Capricorn'],
  [725348580,725563673,'Aquarius'],
  [725563673,725781999,'Pisces'],
  [725781999,725995795,'Aries'],
  [725995795,726198108,'Taurus'],
  [726198108,726387011,'Gemini'],
  [726387011,726565758,'Cancer'],
  [726565758,726740418,'Leo'],
  [726740418,726917422,'Virgo'],
  [726917422,727101707,'Libra'],
  [727101707,727295422,'Scorpio'],
  [727295422,727497968,'Sagittarius'],
  [727497968,727707628,'Capricorn'],
  [727707628,727922832,'Aquarius'],
  [727922832,728141252,'Pisces'],
  [728141252,728357807,'Aries'],
  [728357807,728565267,'Taurus'],
  [728565267,728758589,'Gemini'],
  [728758589,728938262,'Cancer'],
  [728938262,729109736,'Leo'],
  [729109736,729280698,'Virgo'],
  [729280698,729458607,'Libra'],
  [729458607,729648453,'Scorpio'],
  [729648453,729850806,'Sagittarius'],
  [729850806,730062303,'Capricorn'],
  [730062303,730278710,'Aquarius'],
  [730278710,730497014,'Pisces'],
  [730497014,730714276,'Aries'],
  [730714276,730925525,'Taurus'],
  [730925525,731124980,'Gemini'],
  [731124980,731310030,'Cancer'],
  [731310030,731483525,'Leo'],
  [731483525,731652363,'Virgo'],
  [731652363,731824775,'Libra'],
  [731824775,732008003,'Scorpio'],
  [732008003,732205675,'Sagittarius'],
  [732205675,732415930,'Capricorn'],
  [732415930,732633035,'Aquarius'],
  [732633035,732851473,'Pisces'],
  [732851473,733067942,'Aries'],
  [733067942,733279670,'Taurus'],
  [733279670,733482844,'Gemini'],
  [733482844,733674085,'Cancer'],
  [733674085,733853423,'Leo'],
  [733853423,734025258,'Virgo'],
  [734025258,734196708,'Libra'],
  [734196708,734375382,'Scorpio'],
  [734375382,734567042,'Sagittarius'],
  [734567042,734772942,'Capricorn'],
  [734772942,734988746,'Aquarius'],
  [734988746,735207254,'Pisces'],
  [735207254,735422858,'Aries'],
  [735422858,735632802,'Taurus'],
  [735632802,735835531,'Gemini'],
  [735835531,736029559,'Cancer'],
  [736029559,736214389,'Leo'],
  [736214389,736392000,'Virgo'],
  [736392000,736567037,'Libra'],
  [736567037,736745671,'Scorpio'],
  [736745671,736933851,'Sagittarius'],
  [736933851,737135027,'Capricorn'],
  [737135027,737347826,'Aquarius'],
  [737347826,737565845,'Pisces'],
  [737565845,737781370,'Aries'],
  [737781370,737989629,'Taurus'],
  [737989629,738189482,'Gemini'],
  [738189482,738381786,'Cancer'],
  [738381786,738567975,'Leo'],
  [738567975,738749881,'Virgo'],
  [738749881,738930151,'Libra'],
  [738930151,739112466,'Scorpio'],
  [739112466,739301159,'Sagittarius'],
  [739301159,739499950,'Capricorn'],
  [739499950,739709795,'Aquarius'],
  [739709795,739926830,'Pisces'],
  [739926830,740143156,'Aries'],
  [740143156,740351509,'Taurus'],
  [740351509,740549105,'Gemini'],
  [740549105,740737571,'Cancer'],
  [740737571,740920691,'Leo'],
  [740920691,741102330,'Virgo'],
  [741102330,741285439,'Libra'],
  [741285439,741472079,'Scorpio'],
  [741472079,741664107,'Sagittarius'],
  [741664107,741863637,'Capricorn'],
  [741863637,742072166,'Aquarius'],
  [742072166,742288264,'Pisces'],
  [742288264,742505840,'Aries'],
  [742505840,742716392,'Taurus'],
  [742716392,742914462,'Gemini'],
  [742914462,743100434,'Cancer'],
  [743100434,743279032,'Leo'],
  [743279032,743456369,'Virgo'],
  [743456369,743637600,'Libra'],
  [743637600,743825560,'Scorpio'],
  [743825560,744020788,'Sagittarius'],
  [744020788,744222984,'Capricorn'],
  [744222984,744432212,'Aquarius'],
  [744432212,744647955,'Pisces'],
  [744647955,744866549,'Aries'],
  [744866549,745080398,'Taurus'],
  [745080398,745281973,'Gemini'],
  [745281973,745469003,'Cancer'],
  [745469003,745645252,'Leo'],
  [745645252,745817712,'Virgo'],
  [745817712,745993641,'Libra'],
  [745993641,746178314,'Scorpio'],
  [746178314,746373462,'Sagittarius'],
  [746373462,746577685,'Capricorn'],
  [746577685,746788709,'Aquarius'],
  [746788709,747004846,'Pisces'],
  [747004846,747223759,'Aries'],
  [747223759,747440148,'Taurus'],
  [747440148,747646595,'Gemini'],
  [747646595,747838283,'Cancer'],
  [747838283,748016405,'Leo'],
  [748016405,748187032,'Virgo'],
  [748187032,748358063,'Libra'],
  [748358063,748536778,'Scorpio'],
  [748536778,748727627,'Sagittarius'],
  [748727627,748930721,'Capricorn'],
  [748930721,749142763,'Aquarius'],
  [749142763,749359712,'Pisces'],
  [749359712,749578384,'Aries'],
  [749578384,749795207,'Taurus'],
  [749795207,750004935,'Gemini'],
  [750004935,750202414,'Cancer'],
  [750202414,750386148,'Leo'],
  [750386148,750559641,'Virgo'],
  [750559641,750729643,'Libra'],
  [750729643,750903778,'Scorpio'],
  [750903778,751088510,'Sagittarius'],
  [751088510,751286937,'Capricorn'],
  [751286937,751497434,'Aquarius'],
  [751497434,751714738,'Pisces'],
  [751714738,751933199,'Aries'],
  [751933199,752148760,'Taurus'],
  [752148760,752358276,'Gemini'],
  [752358276,752558784,'Cancer'],
  [752558784,752748428,'Leo'],
  [752748428,752928138,'Virgo'],
  [752928138,753101972,'Libra'],
  [753101972,753276012,'Scorpio'],
  [753276012,753456836,'Sagittarius'],
  [753456836,753649661,'Capricorn'],
  [753649661,753856035,'Aquarius'],
  [753856035,754072226,'Pisces'],
  [754072226,754290837,'Aries'],
  [754290837,754505256,'Taurus'],
  [754505256,754712221,'Gemini'],
  [754712221,754911166,'Cancer'],
  [754911166,755102579,'Leo'],
  [755102579,755287401,'Virgo'],
  [755287401,755467450,'Libra'],
  [755467450,755645950,'Scorpio'],
  [755645950,755827557,'Sagittarius'],
  [755827557,756017481,'Capricorn'],
  [756017481,756219515,'Aquarius'],
  [756219515,756433123,'Pisces'],
  [756433123,756651870,'Aries'],
  [756651870,756866739,'Taurus'],
  [756866739,757071957,'Gemini'],
  [757071957,757267147,'Cancer'],
  [757267147,757455282,'Leo'],
  [757455282,757639848,'Virgo'],
  [757639848,757823323,'Libra'],
  [757823323,758007235,'Scorpio'],
  [758007235,758193351,'Sagittarius'],
  [758193351,758384703,'Capricorn'],
  [758384703,758585013,'Aquarius'],
  [758585013,758796105,'Pisces'],
  [758796105,759014506,'Aries'],
  [759014506,759231270,'Taurus'],
  [759231270,759437691,'Gemini'],
  [759437691,759631078,'Cancer'],
  [759631078,759814726,'Leo'],
  [759814726,759994424,'Virgo'],
  [759994424,760175363,'Libra'],
  [760175363,760360469,'Scorpio'],
  [760360469,760550497,'Sagittarius'],
  [760550497,760745786,'Capricorn'],
  [760745786,760947754,'Aquarius'],
  [760947754,761158154,'Pisces'],
  [761158154,761375974,'Aries'],
  [761375974,761594720,'Taurus'],
  [761594720,761804834,'Gemini'],
  [761804834,762000460,'Cancer'],
  [762000460,762182829,'Leo'],
  [762182829,762357957,'Virgo'],
  [762357957,762532981,'Libra'],
  [762532981,762713614,'Scorpio'],
  [762713614,762902645,'Sagittarius'],
  [762902645,763100084,'Capricorn'],
  [763100084,763304956,'Aquarius'],
  [763304956,763516720,'Pisces'],
  [763516720,763734443,'Aries'],
  [763734443,763954129,'Taurus'],
  [763954129,764168026,'Gemini'],
  [764168026,764368756,'Cancer'],
  [764368756,764554435,'Leo'],
  [764554435,764729179,'Virgo'],
  [764729179,764900091,'Libra'],
  [764900091,765074461,'Scorpio'],
  [765074461,765257851,'Sagittarius'],
  [765257851,765452718,'Capricorn'],
  [765452718,765658251,'Aquarius'],
  [765658251,765871717,'Pisces'],
  [765871717,766090051,'Aries'],
  [766090051,766309659,'Taurus'],
  [766309659,766525257,'Gemini'],
  [766525257,766730699,'Cancer'],
  [766730699,766922289,'Leo'],
  [766922289,767101216,'Virgo'],
  [767101216,767272691,'Libra'],
  [767272691,767443689,'Scorpio'],
  [767443689,767621086,'Sagittarius'],
  [767621086,767810058,'Capricorn'],
  [767810058,768012404,'Aquarius'],
  [768012404,768225674,'Pisces'],
  [768225674,768444607,'Aries'],
  [768444607,768663808,'Taurus'],
  [768663808,768878816,'Gemini'],
  [768878816,769085906,'Cancer'],
  [769085906,769282253,'Leo'],
  [769282253,769467276,'Virgo'],
  [769467276,769643448,'Libra'],
  [769643448,769815770,'Scorpio'],
  [769815770,769990610,'Sagittarius'],
  [769990610,770174329,'Capricorn'],
  [770174329,770371390,'Aquarius'],
  [770371390,770581869,'Pisces'],
  [770581869,770800438,'Aries'],
  [770800438,771019388,'Taurus'],
  [771019388,771232902,'Gemini'],
  [771232902,771438518,'Cancer'],
  [771438518,771635778,'Leo'],
  [771635778,771824885,'Virgo'],
  [771824885,772006796,'Libra'],
  [772006796,772183929,'Scorpio'],
  [772183929,772360605,'Sagittarius'],
  [772360605,772542570,'Capricorn'],
  [772542570,772735452,'Aquarius'],
  [772735452,772941986,'Pisces'],
  [772941986,773158983,'Aries'],
  [773158983,773377943,'Taurus'],
  [773377943,773590652,'Gemini'],
  [773590652,773793795,'Cancer'],
  [773793795,773988494,'Leo'],
  [773988494,774177282,'Virgo'],
  [774177282,774362082,'Libra'],
  [774362082,774544161,'Scorpio'],
  [774544161,774725418,'Sagittarius'],
  [774725418,774909498,'Capricorn'],
  [774909498,775101362,'Aquarius'],
  [775101362,775305027,'Pisces'],
  [775305027,775519968,'Aries'],
  [775519968,775739087,'Taurus'],
  [775739087,775952542,'Gemini'],
  [775952542,776154651,'Cancer'],
  [776154651,776346125,'Leo'],
  [776346125,776531194,'Virgo'],
  [776531194,776714150,'Libra'],
  [776714150,776897584,'Scorpio'],
  [776897584,777082670,'Sagittarius'],
  [777082670,777270822,'Capricorn'],
  [777270822,777464833,'Aquarius'],
  [777464833,777668075,'Pisces'],
  [777668075,777881595,'Aries'],
  [777881595,778100842,'Taurus'],
  [778100842,778316398,'Gemini'],
  [778316398,778520227,'Cancer'],
  [778520227,778710810,'Leo'],
  [778710810,778892193,'Virgo'],
  [778892193,779070331,'Libra'],
  [779070331,779250308,'Scorpio'],
  [779250308,779435062,'Sagittarius'],
  [779435062,779625736,'Capricorn'],
  [779625736,779823066,'Aquarius'],
  [779823066,780028173,'Pisces'],
  [780028173,780241639,'Aries'],
  [780241639,780460873,'Taurus'],
  [780460873,780678697,'Gemini'],
  [780678697,780886512,'Cancer'],
  [780886512,781079962,'Leo'],
  [781079962,781260971,'Virgo'],
  [781260971,781435304,'Libra'],
  [781435304,781609599,'Scorpio'],
  [781609599,781789430,'Sagittarius'],
  [781789430,781978157,'Capricorn'],
  [781978157,782176691,'Aquarius'],
  [782176691,782384165,'Pisces'],
  [782384165,782598848,'Aries'],
  [782598848,782818052,'Taurus'],
  [782818052,783036915,'Gemini'],
  [783036915,783248676,'Cancer'],
  [783248676,783447675,'Leo'],
  [783447675,783632771,'Virgo'],
  [783632771,783807566,'Libra'],
  [783807566,783978349,'Scorpio'],
  [783978349,784152091,'Sagittarius'],
  [784152091,784334873,'Capricorn'],
  [784334873,784530233,'Aquarius'],
  [784530233,784737823,'Pisces'],
  [784737823,784953826,'Aries'],
  [784953826,785173273,'Taurus'],
  [785173273,785391651,'Gemini'],
  [785391651,785604780,'Cancer'],
  [785604780,785808519,'Leo'],
  [785808519,786000133,'Virgo'],
  [786000133,786180093,'Libra'],
  [786180093,786352367,'Scorpio'],
  [786352367,786523344,'Sagittarius'],
  [786523344,786700282,'Capricorn'],
  [786700282,786889439,'Aquarius'],
  [786889439,787093396,'Pisces'],
  [787093396,787308944,'Aries'],
  [787308944,787528786,'Taurus'],
  [787528786,787746272,'Gemini'],
  [787746272,787957968,'Cancer'],
  [787957968,788162445,'Leo'],
  [788162445,788358439,'Virgo'],
  [788358439,788545028,'Libra'],
  [788545028,788723134,'Scorpio'],
  [788723134,788896643,'Sagittarius'],
  [788896643,789071921,'Capricorn'],
  [789071921,789256135,'Aquarius'],
  [789256135,789454581,'Pisces'],
  [789454581,789667082,'Aries'],
  [789667082,789886644,'Taurus'],
  [789886644,790103997,'Gemini'],
  [790103997,790313778,'Cancer'],
  [790313778,790515565,'Leo'],
  [790515565,790710811,'Virgo'],
  [790710811,790900324,'Libra'],
  [790900324,791084194,'Scorpio'],
  [791084194,791263569,'Sagittarius'],
  [791263569,791442169,'Capricorn'],
  [791442169,791625897,'Aquarius'],
  [791625897,791820742,'Pisces'],
  [791820742,792029306,'Aries'],
  [792029306,792247410,'Taurus'],
  [792247410,792465409,'Gemini'],
  [792465409,792675067,'Cancer'],
  [792675067,792874293,'Leo'],
  [792874293,793065615,'Virgo'],
  [793065615,793252498,'Libra'],
  [793252498,793437156,'Scorpio'],
  [793437156,793620633,'Sagittarius'],
  [793620633,793804429,'Capricorn'],
  [793804429,793991743,'Aquarius'],
  [793991743,794186982,'Pisces'],
  [794186982,794393410,'Aries'],
  [794393410,794609693,'Taurus'],
  [794609693,794828405,'Gemini'],
  [794828405,795040083,'Cancer'],
  [795040083,795239668,'Leo'],
  [795239668,795428261,'Virgo'],
  [795428261,795610327,'Libra'],
  [795610327,795790638,'Scorpio'],
  [795790638,795972683,'Sagittarius'],
  [795972683,796158573,'Capricorn'],
  [796158573,796349872,'Aquarius'],
  [796349872,796548325,'Pisces'],
  [796548325,796755506,'Aries'],
  [796755506,796970941,'Taurus'],
  [796970941,797189986,'Gemini'],
  [797189986,797404529,'Cancer'],
  [797404529,797607531,'Leo'],
  [797607531,797797208,'Virgo'],
  [797797208,797976778,'Libra'],
  [797976778,798151884,'Scorpio'],
  [798151884,798328407,'Sagittarius'],
  [798328407,798511070,'Capricorn'],
  [798511070,798702627,'Aquarius'],
  [798702627,798903657,'Pisces'],
  [798903657,799113166,'Aries'],
  [799113166,799329190,'Taurus'],
  [799329190,799548287,'Gemini'],
  [799548287,799764890,'Cancer'],
  [799764890,799972395,'Leo'],
  [799972395,800166599,'Virgo'],
  [800166599,800347994,'Libra'],
  [800347994,800521101,'Scorpio'],
  [800521101,800692532,'Sagittarius'],
  [800692532,800869153,'Capricorn'],
  [800869153,801056386,'Aquarius'],
  [801056386,801256380,'Pisces'],
  [801256380,801467189,'Aries'],
  [801467189,801684413,'Taurus'],
  [801684413,801903559,'Gemini'],
  [801903559,802120615,'Cancer'],
  [802120615,802331170,'Leo'],
  [802331170,802530784,'Virgo'],
  [802530784,802717403,'Libra'],
  [802717403,802892988,'Scorpio'],
  [802892988,803063091,'Sagittarius'],
  [803063091,803235112,'Capricorn'],
  [803235112,803416372,'Aquarius'],
  [803416372,803611731,'Pisces'],
  [803611731,803820926,'Aries'],
  [803820926,804038526,'Taurus'],
  [804038526,804257767,'Gemini'],
  [804257767,804474087,'Cancer'],
  [804474087,804684919,'Leo'],
  [804684919,804887715,'Virgo'],
  [804887715,805079931,'Libra'],
  [805079931,805261054,'Scorpio'],
  [805261054,805434200,'Sagittarius'],
  [805434200,805605647,'Capricorn'],
  [805605647,805783017,'Aquarius'],
  [805783017,805972969,'Pisces'],
  [805972969,806178012,'Aries'],
  [806178012,806394185,'Taurus'],
  [806394185,806613341,'Gemini'],
  [806613341,806828793,'Cancer'],
  [806828793,807037913,'Leo'],
  [807037913,807240210,'Virgo'],
  [807240210,807434956,'Libra'],
  [807434956,807621242,'Scorpio'],
  [807621242,807799914,'Sagittarius'],
  [807799914,807974861,'Capricorn'],
  [807974861,808152373,'Aquarius'],
  [808152373,808339243,'Pisces'],
  [808339243,808539910,'Aries'],
  [808539910,808753187,'Taurus'],
  [808753187,808971811,'Gemini'],
  [808971811,809187153,'Cancer'],
  [809187153,809394626,'Leo'],
  [809394626,809594098,'Virgo'],
  [809594098,809787073,'Libra'],
  [809787073,809974611,'Scorpio'],
  [809974611,810157490,'Sagittarius'],
  [810157490,810337626,'Capricorn'],
  [810337626,810518879,'Aquarius'],
  [810518879,810706436,'Pisces'],
  [810706436,810904888,'Aries'],
  [810904888,811115284,'Taurus'],
  [811115284,811332937,'Gemini'],
  [811332937,811549170,'Cancer'],
  [811549170,811756880,'Leo'],
  [811756880,811954174,'Virgo'],
  [811954174,812143206,'Libra'],
  [812143206,812327415,'Scorpio'],
  [812327415,812509821,'Sagittarius'],
  [812509821,812692766,'Capricorn'],
  [812692766,812878505,'Aquarius'],
  [812878505,813069689,'Pisces'],
  [813069689,813269095,'Aries'],
  [813269095,813478174,'Taurus'],
  [813478174,813694799,'Gemini'],
  [813694799,813912380,'Cancer'],
  [813912380,814122689,'Leo'],
  [814122689,814320904,'Virgo'],
  [814320904,814507591,'Libra'],
  [814507591,814686969,'Scorpio'],
  [814686969,814864479,'Sagittarius'],
  [814864479,815045007,'Capricorn'],
  [815045007,815231846,'Aquarius'],
  [815231846,815426431,'Pisces'],
  [815426431,815628903,'Aries'],
  [815628903,815838869,'Taurus'],
  [815838869,816054992,'Gemini'],
  [816054992,816273428,'Cancer'],
  [816273428,816487332,'Leo'],
  [816487332,816689856,'Virgo'],
  [816689856,816878429,'Libra'],
  [816878429,817055788,'Scorpio'],
  [817055788,817228099,'Sagittarius'],
  [817228099,817402516,'Capricorn'],
  [817402516,817585125,'Aquarius'],
  [817585125,817779050,'Pisces'],
  [817779050,817983587,'Aries'],
  [817983587,818195672,'Taurus'],
  [818195672,818412253,'Gemini'],
  [818412253,818630654,'Cancer'],
  [818630654,818846789,'Leo'],
  [818846789,819054540,'Virgo'],
  [819054540,819248823,'Libra'],
  [819248823,819429200,'Scorpio'],
  [819429200,819600367,'Sagittarius'],
  [819600367,819769920,'Capricorn'],
  [819769920,819945881,'Aquarius'],
  [819945881,820134346,'Pisces'],
  [820134346,820336847,'Aries'],
  [820336847,820549748,'Taurus'],
  [820549748,820767342,'Gemini'],
  [820767342,820985423,'Cancer'],
  [820985423,821201359,'Leo'],
  [821201359,821411699,'Virgo'],
  [821411699,821611804,'Libra'],
  [821611804,821798709,'Scorpio'],
  [821798709,821974010,'Sagittarius'],
  [821974010,822143671,'Capricorn'],
  [822143671,822315701,'Aquarius'],
  [822315701,822497793,'Pisces'],
  [822497793,822694578,'Aries'],
  [822694578,822904941,'Taurus'],
  [822904941,823122630,'Gemini'],
  [823122630,823340737,'Cancer'],
  [823340737,823555325,'Leo'],
  [823555325,823764589,'Virgo'],
  [823764589,823966503,'Libra'],
  [823966503,824158685,'Scorpio'],
  [824158685,824340569,'Sagittarius'],
  [824340569,824515170,'Capricorn'],
  [824515170,824688540,'Aquarius'],
  [824688540,824867895,'Pisces'],
  [824867895,825059301,'Aries'],
  [825059301,825264823,'Taurus'],
  [825264823,825480610,'Gemini'],
  [825480610,825698823,'Cancer'],
  [825698823,825912768,'Leo'],
  [825912768,826119620,'Virgo'],
  [826119620,826319125,'Libra'],
  [826319125,826511547,'Scorpio'],
  [826511547,826697258,'Sagittarius'],
  [826697258,826877707,'Capricorn'],
  [826877707,827056216,'Aquarius'],
  [827056216,827237721,'Pisces'],
  [827237721,827427519,'Aries'],
  [827427519,827629165,'Taurus'],
  [827629165,827841940,'Gemini'],
  [827841940,828059810,'Cancer'],
  [828059810,828274468,'Leo'],
  [828274468,828480382,'Virgo'],
  [828480382,828676615,'Libra'],
  [828676615,828865284,'Scorpio'],
  [828865284,829049408,'Sagittarius'],
  [829049408,829231768,'Capricorn'],
  [829231768,829414788,'Aquarius'],
  [829414788,829600952,'Pisces'],
  [829600952,829793117,'Aries'],
  [829793117,829994045,'Taurus'],
  [829994045,830204679,'Gemini'],
  [830204679,830421863,'Cancer'],
  [830421863,830638113,'Leo'],
  [830638113,830845622,'Virgo'],
  [830845622,831040953,'Libra'],
  [831040953,831225878,'Scorpio'],
  [831225878,831405224,'Sagittarius'],
  [831405224,831584331,'Capricorn'],
  [831584331,831767331,'Aquarius'],
  [831767331,831956414,'Pisces'],
  [831956414,832152268,'Aries'],
  [832152268,832355264,'Taurus'],
  [832355264,832565762,'Gemini'],
  [832565762,832782475,'Cancer'],
  [832782475,833000309,'Leo'],
  [833000309,833211201,'Virgo'],
  [833211201,833409023,'Libra'],
  [833409023,833593366,'Scorpio'],
  [833593366,833768937,'Sagittarius'],
  [833768937,833942672,'Capricorn'],
  [833942672,834121137,'Aquarius'],
  [834121137,834308573,'Pisces'],
  [834308573,834505835,'Aries'],
  [834505835,834711351,'Taurus'],
  [834711351,834923276,'Gemini'],
  [834923276,835140107,'Cancer'],
  [835140107,835358797,'Leo'],
  [835358797,835573047,'Virgo'],
  [835573047,835775610,'Libra'],
  [835775610,835963261,'Scorpio'],
  [835963261,836138819,'Sagittarius'],
  [836138819,836309107,'Capricorn'],
  [836309107,836481998,'Aquarius'],
  [836481998,836664097,'Pisces'],
  [836664097,836858592,'Aries'],
  [836858592,837064341,'Taurus'],
  [837064341,837277664,'Gemini'],
  [837277664,837495082,'Cancer'],
  [837495082,837713777,'Leo'],
  [837713777,837929614,'Virgo'],
  [837929614,838136568,'Libra'],
  [838136568,838329827,'Scorpio'],
  [838329827,838509438,'Sagittarius'],
  [838509438,838680453,'Capricorn'],
  [838680453,838850442,'Aquarius'],
  [838850442,839027086,'Pisces'],
  [839027086,839215989,'Aries'],
  [839215989,839418519,'Taurus'],
  [839418519,839631437,'Gemini'],
  [839631437,839849319,'Cancer'],
  [839849319,840067617,'Leo'],
  [840067617,840282896,'Virgo'],
  [840282896,840491411,'Libra'],
  [840491411,840689297,'Scorpio'],
  [840689297,840874914,'Sagittarius'],
  [840874914,841050629,'Capricorn'],
  [841050629,841222124,'Aquarius'],
  [841222124,841396501,'Pisces'],
  [841396501,841580375,'Aries'],
  [841580375,841777695,'Taurus'],
  [841777695,841987758,'Gemini'],
  [841987758,842205225,'Cancer'],
  [842205225,842423286,'Leo'],
  [842423286,842637066,'Virgo'],
  [842637066,842843987,'Libra'],
  [842843987,843042636,'Scorpio'],
  [843042636,843232336,'Sagittarius'],
  [843232336,843413964,'Capricorn'],
  [843413964,843590583,'Aquarius'],
  [843590583,843767132,'Pisces'],
  [843767132,843949412,'Aries'],
  [843949412,844142493,'Taurus'],
  [844142493,844348461,'Gemini'],
  [844348461,844564297,'Cancer'],
  [844564297,844782508,'Leo'],
  [844782508,844995614,'Virgo'],
  [844995614,845199938,'Libra'],
  [845199938,845395633,'Scorpio'],
  [845395633,845584632,'Sagittarius'],
  [845584632,845769058,'Capricorn'],
  [845769058,845950918,'Aquarius'],
  [845950918,846132608,'Pisces'],
  [846132608,846317480,'Aries'],
  [846317480,846509667,'Taurus'],
  [846509667,846712583,'Gemini'],
  [846712583,846926149,'Cancer'],
  [846926149,847144631,'Leo'],
  [847144631,847358914,'Virgo'],
  [847358914,847562507,'Libra'],
  [847562507,847754786,'Scorpio'],
  [847754786,847939423,'Sagittarius'],
  [847939423,848121240,'Capricorn'],
  [848121240,848303988,'Aquarius'],
  [848303988,848489619,'Pisces'],
  [848489619,848679110,'Aries'],
  [848679110,848873974,'Taurus'],
  [848873974,849076639,'Gemini'],
  [849076639,849288588,'Cancer'],
  [849288588,849507041,'Leo'],
  [849507041,849723802,'Virgo'],
  [849723802,849929910,'Libra'],
  [849929910,850121908,'Scorpio'],
  [850121908,850302876,'Sagittarius'],
  [850302876,850479233,'Capricorn'],
  [850479233,850657422,'Aquarius'],
  [850657422,850841715,'Pisces'],
  [850841715,851033367,'Aries'],
  [851033367,851231828,'Taurus'],
  [851231828,851436845,'Gemini'],
  [851436845,851648919,'Cancer'],
  [851648919,851867079,'Leo'],
  [851867079,852085904,'Virgo'],
  [852085904,852296501,'Libra'],
  [852296501,852492443,'Scorpio'],
  [852492443,852674079,'Sagittarius'],
  [852674079,852847190,'Capricorn'],
  [852847190,853019443,'Aquarius'],
  [853019443,853197688,'Pisces'],
  [853197688,853385995,'Aries'],
  [853385995,853584784,'Taurus'],
  [853584784,853792111,'Gemini'],
  [853792111,854005788,'Cancer'],
  [854005788,854223972,'Leo'],
  [854223972,854443270,'Virgo'],
  [854443270,854657272,'Libra'],
  [854657272,854859050,'Scorpio'],
  [854859050,855045871,'Sagittarius'],
  [855045871,855220868,'Capricorn'],
  [855220868,855390814,'Aquarius'],
  [855390814,855563349,'Pisces'],
  [855563349,855744966,'Aries'],
  [855744966,855939195,'Taurus'],
  [855939195,856145546,'Gemini'],
  [856145546,856360344,'Cancer'],
  [856360344,856579087,'Leo'],
  [856579087,856797775,'Virgo'],
  [856797775,857012193,'Libra'],
  [857012193,857217641,'Scorpio'],
  [857217641,857410719,'Sagittarius'],
  [857410719,857591674,'Capricorn'],
  [857591674,857764614,'Aquarius'],
  [857764614,857935952,'Pisces'],
  [857935952,858112641,'Aries'],
  [858112641,858300505,'Taurus'],
  [858300505,858502233,'Gemini'],
  [858502233,858715691,'Cancer'],
  [858715691,858934760,'Leo'],
  [858934760,859152911,'Virgo'],
  [859152911,859365713,'Libra'],
  [859365713,859570787,'Scorpio'],
  [859570787,859766804,'Sagittarius'],
  [859766804,859953525,'Capricorn'],
  [859953525,860132533,'Aquarius'],
  [860132533,860307547,'Pisces'],
  [860307547,860484026,'Aries'],
  [860484026,860668074,'Taurus'],
  [860668074,860864591,'Gemini'],
  [860864591,861074506,'Cancer'],
  [861074506,861292810,'Leo'],
  [861292810,861510982,'Virgo'],
  [861510982,861722331,'Libra'],
  [861722331,861924709,'Scorpio'],
  [861924709,862119144,'Sagittarius'],
  [862119144,862307412,'Capricorn'],
  [862307412,862491006,'Aquarius'],
  [862491006,862671553,'Pisces'],
  [862671553,862851872,'Aries'],
  [862851872,863036435,'Taurus'],
  [863036435,863230354,'Gemini'],
  [863230354,863436768,'Cancer'],
  [863436768,863653408,'Leo'],
  [863653408,863872008,'Virgo'],
  [863872008,864083490,'Libra'],
  [864083490,864283836,'Scorpio'],
  [864283836,864474660,'Sagittarius'],
  [864474660,864660012,'Capricorn'],
  [864660012,864843477,'Aquarius'],
  [864843477,865027061,'Pisces'],
  [865027061,865211936,'Aries'],
  [865211936,865400076,'Taurus'],
  [865400076,865594915,'Gemini'],
  [865594915,865799872,'Cancer'],
  [865799872,866014979,'Leo'],
  [866014979,866234120,'Virgo'],
  [866234120,866447456,'Libra'],
  [866447456,866648345,'Scorpio'],
  [866648345,866836945,'Sagittarius'],
  [866836945,867018030,'Capricorn'],
  [867018030,867197330,'Aquarius'],
  [867197330,867379111,'Pisces'],
  [867379111,867565393,'Aries'],
  [867565393,867756917,'Taurus'],
  [867756917,867954758,'Gemini'],
  [867954758,868160689,'Cancer'],
  [868160689,868375294,'Leo'],
  [868375294,868594834,'Virgo'],
  [868594834,868810824,'Libra'],
  [868810824,869014954,'Scorpio'],
  [869014954,869204725,'Sagittarius'],
  [869204725,869383732,'Capricorn'],
  [869383732,869558378,'Aquarius'],
  [869558378,869734972,'Pisces'],
  [869734972,869917993,'Aries'],
  [869917993,870109444,'Taurus'],
  [870109444,870309494,'Gemini'],
  [870309494,870517611,'Cancer'],
  [870517611,870732900,'Leo'],
  [870732900,870952606,'Virgo'],
  [870952606,871170599,'Libra'],
  [871170599,871379104,'Scorpio'],
  [871379104,871573339,'Sagittarius'],
  [871573339,871754294,'Capricorn'],
  [871754294,871927258,'Aquarius'],
  [871927258,872099083,'Pisces'],
  [872099083,872276237,'Aries'],
  [872276237,872463365,'Taurus'],
  [872463365,872662227,'Gemini'],
  [872662227,872871523,'Cancer'],
  [872871523,873088003,'Leo'],
  [873088003,873307771,'Virgo'],
  [873307771,873526163,'Libra'],
  [873526163,873737662,'Scorpio'],
  [873737662,873937398,'Sagittarius'],
  [873937398,874123808,'Capricorn'],
  [874123808,874299562,'Aquarius'],
  [874299562,874470292,'Pisces'],
  [874470292,874642872,'Aries'],
  [874642872,874823909,'Taurus'],
  [874823909,875017974,'Gemini'],
  [875017974,875225546,'Cancer'],
  [875225546,875442440,'Leo'],
  [875442440,875662325,'Virgo'],
  [875662325,875879837,'Libra'],
  [875879837,876091368,'Scorpio'],
  [876091368,876294224,'Sagittarius'],
  [876294224,876486523,'Capricorn'],
  [876486523,876668376,'Aquarius'],
  [876668376,876842700,'Pisces'],
  [876842700,877014949,'Aries'],
  [877014949,877191980,'Taurus'],
  [877191980,877380307,'Gemini'],
  [877380307,877583389,'Cancer'],
  [877583389,877798762,'Leo'],
  [877798762,878018689,'Virgo'],
  [878018689,878235325,'Libra'],
  [878235325,878444800,'Scorpio'],
  [878444800,878646649,'Sagittarius'],
  [878646649,878841202,'Capricorn'],
  [878841202,879028471,'Aquarius'],
  [879028471,879209022,'Pisces'],
  [879209022,879385503,'Aries'],
  [879385503,879563088,'Taurus'],
  [879563088,879748327,'Gemini'],
  [879748327,879946669,'Cancer'],
  [879946669,880158761,'Leo'],
  [880158761,880378161,'Virgo'],
  [880378161,880594984,'Libra'],
  [880594984,880802897,'Scorpio'],
  [880802897,881001498,'Sagittarius'],
  [881001498,881193463,'Capricorn'],
  [881193463,881381230,'Aquarius'],
  [881381230,881565828,'Pisces'],
  [881565828,881747998,'Aries'],
  [881747998,881930106,'Taurus'],
  [881930106,882116700,'Gemini'],
  [882116700,882313055,'Cancer'],
  [882313055,882521973,'Leo'],
  [882521973,882740089,'Virgo'],
  [882740089,882958038,'Libra'],
  [882958038,883166835,'Scorpio'],
  [883166835,883363705,'Sagittarius'],
  [883363705,883551504,'Capricorn'],
  [883551504,883734950,'Aquarius'],
  [883734950,883917788,'Pisces'],
  [883917788,884101941,'Aries'],
  [884101941,884288520,'Taurus'],
  [884288520,884479385,'Gemini'],
  [884479385,884677513,'Cancer'],
  [884677513,884885459,'Leo'],
  [884885459,885102242,'Virgo'],
  [885102242,885321257,'Libra'],
  [885321257,885533110,'Scorpio'],
  [885533110,885731962,'Sagittarius'],
  [885731962,885918422,'Capricorn'],
  [885918422,886097306,'Aquarius'],
  [886097306,886274452,'Pisces'],
  [886274452,886454682,'Aries'],
  [886454682,886640966,'Taurus'],
  [886640966,886834645,'Gemini'],
  [886834645,887036207,'Cancer'],
  [887036207,887245761,'Leo'],
  [887245761,887462230,'Virgo'],
  [887462230,887681560,'Libra'],
  [887681560,887896557,'Scorpio'],
  [887896557,888100172,'Sagittarius'],
  [888100172,888289813,'Capricorn'],
  [888289813,888468135,'Aquarius'],
  [888468135,888640925,'Pisces'],
  [888640925,888814823,'Aries'],
  [888814823,888995682,'Taurus'],
  [888995682,889187192,'Gemini'],
  [889187192,889389930,'Cancer'],
  [889389930,889601697,'Leo'],
  [889601697,889819069,'Virgo'],
  [889819069,890038229,'Libra'],
  [890038229,890254564,'Scorpio'],
  [890254564,890462600,'Sagittarius'],
  [890462600,890658094,'Capricorn'],
  [890658094,890840576,'Aquarius'],
  [890840576,891013724,'Pisces'],
  [891013724,891183970,'Aries'],
  [891183970,891358648,'Taurus'],
  [891358648,891544172,'Gemini'],
  [891544172,891743742,'Cancer'],
  [891743742,891955520,'Leo'],
  [891955520,892173862,'Virgo'],
  [892173862,892392926,'Libra'],
  [892392926,892608730,'Scorpio'],
  [892608730,892818288,'Sagittarius'],
  [892818288,893018476,'Capricorn'],
  [893018476,893207146,'Aquarius'],
  [893207146,893385037,'Pisces'],
  [893385037,893556523,'Aries'],
  [893556523,893728523,'Taurus'],
  [893728523,893908604,'Gemini'],
  [893908604,894102555,'Cancer'],
  [894102555,894311204,'Leo'],
  [894311204,894529114,'Virgo'],
  [894529114,894748199,'Libra'],
  [894748199,894962863,'Scorpio'],
  [894962863,895171121,'Sagittarius'],
  [895171121,895372217,'Capricorn'],
  [895372217,895564995,'Aquarius'],
  [895564995,895748745,'Pisces'],
  [895748745,895925162,'Aries'],
  [895925162,896099112,'Taurus'],
  [896099112,896277498,'Gemini'],
  [896277498,896467069,'Cancer'],
  [896467069,896671241,'Leo'],
  [896671241,896887005,'Virgo'],
  [896887005,897105924,'Libra'],
  [897105924,897320050,'Scorpio'],
  [897320050,897526221,'Sagittarius'],
  [897526221,897724972,'Capricorn'],
  [897724972,897917480,'Aquarius'],
  [897917480,898104170,'Pisces'],
  [898104170,898285646,'Aries'],
  [898285646,898464375,'Taurus'],
  [898464375,898645139,'Gemini'],
  [898645139,898833821,'Cancer'],
  [898833821,899034851,'Leo'],
  [899034851,899247877,'Virgo'],
  [899247877,899466309,'Libra'],
  [899466309,899681025,'Scorpio'],
  [899681025,899886440,'Sagittarius'],
  [899886440,900082322,'Capricorn'],
  [900082322,900271329,'Aquarius'],
  [900271329,900456285,'Pisces'],
  [900456285,900639197,'Aries'],
  [900639197,900821881,'Taurus'],
  [900821881,901006968,'Gemini'],
  [901006968,901198103,'Cancer'],
  [901198103,901398806,'Leo'],
  [901398806,901610043,'Virgo'],
  [901610043,901827855,'Libra'],
  [901827855,902044068,'Scorpio'],
  [902044068,902251075,'Sagittarius'],
  [902251075,902446265,'Capricorn'],
  [902446265,902631842,'Aquarius'],
  [902631842,902812213,'Pisces'],
  [902812213,902991868,'Aries'],
  [902991868,903174352,'Taurus'],
  [903174352,903362114,'Gemini'],
  [903362114,903556827,'Cancer'],
  [903556827,903759674,'Leo'],
  [903759674,903970907,'Virgo'],
  [903970907,904188311,'Libra'],
  [904188311,904406106,'Scorpio'],
  [904406106,904616574,'Sagittarius'],
  [904616574,904814447,'Capricorn'],
  [904814447,904999660,'Aquarius'],
  [904999660,905176348,'Pisces'],
  [905176348,905350578,'Aries'],
  [905350578,905528413,'Taurus'],
  [905528413,905714400,'Gemini'],
  [905714400,905910468,'Cancer'],
  [905910468,906115903,'Leo'],
  [906115903,906328621,'Virgo'],
  [906328621,906546098,'Libra'],
  [906546098,906764672,'Scorpio'],
  [906764672,906978602,'Sagittarius'],
  [906978602,907181597,'Capricorn'],
  [907181597,907370587,'Aquarius'],
  [907370587,907547524,'Pisces'],
  [907547524,907718243,'Aries'],
  [907718243,907890216,'Taurus'],
  [907890216,908070495,'Gemini'],
  [908070495,908263502,'Cancer'],
  [908263502,908469116,'Leo'],
  [908469116,908683328,'Virgo'],
  [908683328,908901380,'Libra'],
  [908901380,909119752,'Scorpio'],
  [909119752,909335085,'Sagittarius'],
  [909335085,909542660,'Capricorn'],
  [909542660,909737898,'Aquarius'],
  [909737898,909919634,'Pisces'],
  [909919634,910091531,'Aries'],
  [910091531,910260654,'Taurus'],
  [910260654,910435154,'Gemini'],
  [910435154,910621963,'Cancer'],
  [910621963,910823816,'Leo'],
  [910823816,911037452,'Virgo'],
  [911037452,911256046,'Libra'],
  [911256046,911473944,'Scorpio'],
  [911473944,911688318,'Sagittarius'],
  [911688318,911897001,'Capricorn'],
  [911897001,912096858,'Aquarius'],
  [912096858,912285236,'Pisces'],
  [912285236,912462755,'Aries'],
  [912462755,912634185,'Taurus'],
  [912634185,912806874,'Gemini'],
  [912806874,912988526,'Cancer'],
  [912988526,913184488,'Leo'],
  [913184488,913394584,'Virgo'],
  [913394584,913612581,'Libra'],
  [913612581,913830438,'Scorpio'],
  [913830438,914043293,'Sagittarius'],
  [914043293,914249799,'Capricorn'],
  [914249799,914449500,'Aquarius'],
  [914449500,914641407,'Pisces'],
  [914641407,914825084,'Aries'],
  [914825084,915002513,'Taurus'],
  [915002513,915178501,'Gemini'],
  [915178501,915359465,'Cancer'],
  [915359465,915551348,'Leo'],
  [915551348,915756765,'Virgo'],
  [915756765,915972518,'Libra'],
  [915972518,916190580,'Scorpio'],
  [916190580,916403308,'Sagittarius'],
  [916403308,916607471,'Capricorn'],
  [916607471,916803602,'Aquarius'],
  [916803602,916993487,'Pisces'],
  [916993487,917178734,'Aries'],
  [917178734,917360962,'Taurus'],
  [917360962,917542617,'Gemini'],
  [917542617,917727349,'Cancer'],
  [917727349,917919438,'Leo'],
  [917919438,918122131,'Virgo'],
  [918122131,918335160,'Libra'],
  [918335160,918553084,'Scorpio'],
  [918553084,918767393,'Sagittarius'],
  [918767393,918971807,'Capricorn'],
  [918971807,919165191,'Aquarius'],
  [919165191,919350388,'Pisces'],
  [919350388,919531734,'Aries'],
  [919531734,919713224,'Taurus'],
  [919713224,919897720,'Gemini'],
  [919897720,920087052,'Cancer'],
  [920087052,920282672,'Leo'],
  [920282672,920486049,'Virgo'],
  [920486049,920697720,'Libra'],
  [920697720,920915146,'Scorpio'],
  [920915146,921131609,'Sagittarius'],
  [921131609,921339110,'Capricorn'],
  [921339110,921533422,'Aquarius'],
  [921533422,921715981,'Pisces'],
  [921715981,921892121,'Aries'],
  [921892121,922068316,'Taurus'],
  [922068316,922250008,'Gemini'],
  [922250008,922440136,'Cancer'],
  [922440136,922638859,'Leo'],
  [922638859,922844950,'Virgo'],
  [922844950,923057310,'Libra'],
  [923057310,923274447,'Scorpio'],
  [923274447,923492331,'Sagittarius'],
  [923492331,923703845,'Capricorn'],
  [923703845,923902488,'Aquarius'],
  [923902488,924086770,'Pisces'],
  [924086770,924260840,'Aries'],
  [924260840,924431941,'Taurus'],
  [924431941,924607632,'Gemini'],
  [924607632,924793545,'Cancer'],
  [924793545,924991439,'Leo'],
  [924991439,925199165,'Virgo'],
  [925199165,925413146,'Libra'],
  [925413146,925630565,'Scorpio'],
  [925630565,925848706,'Sagittarius'],
  [925848706,926062812,'Capricorn'],
  [926062812,926266558,'Aquarius'],
  [926266558,926455988,'Pisces'],
  [926455988,926632577,'Aries'],
  [926632577,926802442,'Taurus'],
  [926802442,926973572,'Gemini'],
  [926973572,927153419,'Cancer'],
  [927153419,927346515,'Leo'],
  [927346515,927552537,'Virgo'],
  [927552537,927767088,'Libra'],
  [927767088,927985029,'Scorpio'],
  [927985029,928202725,'Sagittarius'],
  [928202725,928417003,'Capricorn'],
  [928417003,928623624,'Aquarius'],
  [928623624,928818470,'Pisces'],
  [928818470,929000614,'Aries'],
  [929000614,929173693,'Taurus'],
  [929173693,929344439,'Gemini'],
  [929344439,929520431,'Cancer'],
  [929520431,929707923,'Leo'],
  [929707923,929909423,'Virgo'],
  [929909423,930122272,'Libra'],
  [930122272,930340257,'Scorpio'],
  [930340257,930557496,'Sagittarius'],
  [930557496,930770356,'Capricorn'],
  [930770356,930976459,'Aquarius'],
  [930976459,931173683,'Pisces'],
  [931173683,931360911,'Aries'],
  [931360911,931539591,'Taurus'],
  [931539591,931714035,'Gemini'],
  [931714035,931890333,'Cancer'],
  [931890333,932074728,'Leo'],
  [932074728,932271559,'Virgo'],
  [932271559,932480992,'Libra'],
  [932480992,932698082,'Scorpio'],
  [932698082,932915295,'Sagittarius'],
  [932915295,933126860,'Capricorn'],
  [933126860,933330425,'Aquarius'],
  [933330425,933526004,'Pisces'],
  [933526004,933714514,'Aries'],
  [933714514,933897426,'Taurus'],
  [933897426,934077154,'Gemini'],
  [934077154,934257327,'Cancer'],
  [934257327,934442490,'Leo'],
  [934442490,934637034,'Virgo'],
  [934637034,934843194,'Libra'],
  [934843194,935058682,'Scorpio'],
  [935058682,935276358,'Sagittarius'],
  [935276358,935488150,'Capricorn'],
  [935488150,935689782,'Aquarius'],
  [935689782,935881741,'Pisces'],
  [935881741,936067236,'Aries'],
  [936067236,936249898,'Taurus'],
  [936249898,936432578,'Gemini'],
  [936432578,936617333,'Cancer'],
  [936617333,936806191,'Leo'],
  [936806191,937001748,'Virgo'],
  [937001748,937206497,'Libra'],
  [937206497,937420482,'Scorpio'],
  [937420482,937638802,'Sagittarius'],
  [937638802,937852686,'Capricorn'],
  [937852686,938055074,'Aquarius'],
  [938055074,938244813,'Pisces'],
  [938244813,938425836,'Aries'],
  [938425836,938604052,'Taurus'],
  [938604052,938784694,'Gemini'],
  [938784694,938970801,'Cancer'],
  [938970801,939163181,'Leo'],
  [939163181,939361909,'Virgo'],
  [939361909,939567685,'Libra'],
  [939567685,939781103,'Scorpio'],
  [939781103,939999804,'Sagittarius'],
  [939999804,940216610,'Capricorn'],
  [940216610,940422762,'Aquarius'],
  [940422762,940614091,'Pisces'],
  [940614091,940793112,'Aries'],
  [940793112,940966412,'Taurus'],
  [940966412,941141347,'Gemini'],
  [941141347,941323622,'Cancer'],
  [941323622,941515629,'Leo'],
  [941515629,941716599,'Virgo'],
  [941716599,941924738,'Libra'],
  [941924738,942138889,'Scorpio'],
  [942138889,942357594,'Sagittarius'],
  [942357594,942576322,'Capricorn'],
  [942576322,942787239,'Aquarius'],
  [942787239,942983837,'Pisces'],
  [942983837,943165575,'Aries'],
  [943165575,943337634,'Taurus'],
  [943337634,943507747,'Gemini'],
  [943507747,943683510,'Cancer'],
  [943683510,943870258,'Leo'],
  [943870258,944069361,'Virgo'],
  [944069361,944278518,'Libra'],
  [944278518,944494040,'Scorpio'],
  [944494040,944712798,'Sagittarius'],
  [944712798,944931521,'Capricorn'],
  [944931521,945145053,'Aquarius'],
  [945145053,945347408,'Pisces'],
  [945347408,945535520,'Aries'],
  [945535520,945711535,'Taurus'],
  [945711535,945881547,'Gemini'],
  [945881547,946053112,'Cancer'],
  [946053112,946233249,'Leo'],
  [946233249,946426467,'Virgo'],
  [946426467,946632982,'Libra'],
  [946632982,946848704,'Scorpio'],
  [946848704,947067817,'Sagittarius'],
  [947067817,947285559,'Capricorn'],
  [947285559,947498347,'Aquarius'],
  [947498347,947702903,'Pisces'],
  [947702903,947896669,'Aries'],
  [947896669,948079497,'Taurus'],
  [948079497,948254461,'Gemini'],
  [948254461,948427106,'Cancer'],
  [948427106,948604043,'Leo'],
  [948604043,948791353,'Virgo'],
  [948791353,948992464,'Libra'],
  [948992464,949205848,'Scorpio'],
  [949205848,949424981,'Sagittarius'],
  [949424981,949642260,'Capricorn'],
  [949642260,949852902,'Aquarius'],
  [949852902,950055442,'Pisces'],
  [950055442,950250042,'Aries'],
  [950250042,950437358,'Taurus'],
  [950437358,950618702,'Gemini'],
  [950618702,950796691,'Cancer'],
  [950796691,950975608,'Leo'],
  [950975608,951160881,'Virgo'],
  [951160881,951357461,'Libra'],
  [951357461,951566991,'Scorpio'],
  [951566991,951785105,'Sagittarius'],
  [951785105,952002854,'Capricorn'],
  [952002854,952212601,'Aquarius'],
  [952212601,952412050,'Pisces'],
  [952412050,952603252,'Aries'],
  [952603252,952789535,'Taurus'],
  [952789535,952973471,'Gemini'],
  [952973471,953156596,'Cancer'],
  [953156596,953340522,'Leo'],
  [953340522,953528216,'Virgo'],
  [953528216,953723838,'Libra'],
  [953723838,953930567,'Scorpio'],
  [953930567,954147043,'Sagittarius'],
  [954147043,954365655,'Capricorn'],
  [954365655,954576737,'Aquarius'],
  [954576737,954775314,'Pisces'],
  [954775314,954962940,'Aries'],
  [954962940,955144700,'Taurus'],
  [955144700,955325751,'Gemini'],
  [955325751,955509357,'Cancer'],
  [955509357,955696726,'Leo'],
  [955696726,955888540,'Virgo'],
  [955888540,956086518,'Libra'],
  [956086518,956293046,'Scorpio'],
  [956293046,956508427,'Sagittarius'],
  [956508427,956727707,'Capricorn'],
  [956727707,956941553,'Aquarius'],
  [956941553,957142471,'Pisces'],
  [957142471,957329640,'Aries'],
  [957329640,957507804,'Taurus'],
  [957507804,957683626,'Gemini'],
  [957683626,957862873,'Cancer'],
  [957862873,958048864,'Leo'],
  [958048864,958242437,'Virgo'],
  [958242437,958443386,'Libra'],
  [958443386,958651753,'Scorpio'],
  [958651753,958867258,'Sagittarius'],
  [958867258,959086813,'Capricorn'],
  [959086813,959303240,'Aquarius'],
  [959303240,959508461,'Pisces'],
  [959508461,959698925,'Aries'],
  [959698925,959877270,'Taurus'],
  [959877270,960049799,'Gemini'],
  [960049799,960223530,'Cancer'],
  [960223530,960404232,'Leo'],
  [960404232,960595112,'Virgo'],
  [960595112,960796498,'Libra'],
  [960796498,961006681,'Scorpio'],
  [961006681,961223182,'Sagittarius'],
  [961223182,961442755,'Capricorn'],
  [961442755,961660286,'Aquarius'],
  [961660286,961869326,'Pisces'],
  [961869326,962065119,'Aries'],
  [962065119,962247564,'Taurus'],
  [962247564,962420967,'Gemini'],
  [962420967,962591876,'Cancer'],
  [962591876,962767145,'Leo'],
  [962767145,962952406,'Virgo'],
  [962952406,963150496,'Libra'],
  [963150496,963360347,'Scorpio'],
  [963360347,963577648,'Sagittarius'],
  [963577648,963797193,'Capricorn'],
  [963797193,964014228,'Aquarius'],
  [964014228,964224548,'Pisces'],
  [964224548,964424622,'Aries'],
  [964424622,964612895,'Taurus'],
  [964612895,964790989,'Gemini'],
  [964790989,964963413,'Cancer'],
  [964963413,965136430,'Leo'],
  [965136430,965316686,'Virgo'],
  [965316686,965509456,'Libra'],
  [965509456,965716213,'Scorpio'],
  [965716213,965933018,'Sagittarius'],
  [965933018,966152562,'Capricorn'],
  [966152562,966368467,'Aquarius'],
  [966368467,966577417,'Pisces'],
  [966577417,966778250,'Aries'],
  [966778250,966970487,'Taurus'],
  [966970487,967154383,'Gemini'],
  [967154383,967331819,'Cancer'],
  [967331819,967506909,'Leo'],
  [967506909,967685579,'Virgo'],
  [967685579,967874107,'Libra'],
  [967874107,968076497,'Scorpio'],
  [968076497,968291215,'Sagittarius'],
  [968291215,968510661,'Capricorn'],
  [968510661,968726048,'Aquarius'],
  [968726048,968932812,'Pisces'],
  [968932812,969131113,'Aries'],
  [969131113,969322927,'Taurus'],
  [969322927,969509745,'Gemini'],
  [969509745,969692409,'Cancer'],
  [969692409,969872515,'Leo'],
  [969872515,970053705,'Virgo'],
  [970053705,970241373,'Libra'],
  [970241373,970440591,'Scorpio'],
  [970440591,970652538,'Sagittarius'],
  [970652538,970871588,'Capricorn'],
  [970871588,971087770,'Aquarius'],
  [971087770,971293875,'Pisces'],
  [971293875,971489161,'Aries'],
  [971489161,971677125,'Taurus'],
  [971677125,971861819,'Gemini'],
  [971861819,972045741,'Cancer'],
  [972045741,972229954,'Leo'],
  [972229954,972415791,'Virgo'],
  [972415791,972606206,'Libra'],
  [972606206,972805218,'Scorpio'],
  [972805218,973015283,'Sagittarius'],
  [973015283,973233635,'Capricorn'],
  [973233635,973451551,'Aquarius'],
  [973451551,973659741,'Pisces'],
  [973659741,973854712,'Aries'],
  [973854712,974039240,'Taurus'],
  [974039240,974218856,'Gemini'],
  [974218856,974398733,'Cancer'],
  [974398733,974582130,'Leo'],
  [974582130,974770495,'Virgo'],
  [974770495,974964772,'Libra'],
  [974964772,975166371,'Scorpio'],
  [975166371,975376622,'Sagittarius'],
  [975376622,975594379,'Capricorn'],
  [975594379,975813752,'Aquarius'],
  [975813752,976025843,'Pisces'],
  [976025843,976224400,'Aries'],
  [976224400,976409433,'Taurus'],
  [976409433,976585721,'Gemini'],
  [976585721,976759721,'Cancer'],
  [976759721,976937389,'Leo'],
  [976937389,977122863,'Virgo'],
  [977122863,977317902,'Libra'],
  [977317902,977522224,'Scorpio'],
  [977522224,977734414,'Sagittarius'],
  [977734414,977952315,'Capricorn'],
  [977952315,978172012,'Aquarius'],
  [978172012,978387238,'Pisces'],
  [978387238,978591401,'Aries'],
  [978591401,978781435,'Taurus'],
  [978781435,978959334,'Gemini'],
  [978959334,979130647,'Cancer'],
  [979130647,979302343,'Leo'],
  [979302343,979481117,'Virgo'],
  [979481117,979671736,'Libra'],
  [979671736,979875332,'Scorpio'],
  [979875332,980088994,'Sagittarius'],
  [980088994,980307799,'Capricorn'],
  [980307799,980527108,'Aquarius'],
  [980527108,980742881,'Pisces'],
  [980742881,980950871,'Aries'],
  [980950871,981147338,'Taurus'],
  [981147338,981331223,'Gemini'],
  [981331223,981505256,'Cancer'],
  [981505256,981675307,'Leo'],
  [981675307,981848753,'Virgo'],
  [981848753,982032665,'Libra'],
  [982032665,982231327,'Scorpio'],
  [982231327,982443522,'Sagittarius'],
  [982443522,982662807,'Capricorn'],
  [982662807,982881892,'Aquarius'],
  [982881892,983096371,'Pisces'],
  [983096371,983304333,'Aries'],
  [983304333,983504168,'Taurus'],
  [983504168,983694272,'Gemini'],
  [983694272,983874605,'Cancer'],
  [983874605,984048244,'Leo'],
  [984048244,984221230,'Virgo'],
  [984221230,984400954,'Libra'],
  [984400954,984593797,'Scorpio'],
  [984593797,984801714,'Sagittarius'],
  [984801714,985019767,'Capricorn'],
  [985019767,985238880,'Aquarius'],
  [985238880,985452207,'Pisces'],
  [985452207,985657831,'Aries'],
  [985657831,985856456,'Taurus'],
  [985856456,986048579,'Gemini'],
  [986048579,986234036,'Cancer'],
  [986234036,986413597,'Leo'],
  [986413597,986590618,'Virgo'],
  [986590618,986770884,'Libra'],
  [986770884,986960818,'Scorpio'],
  [986960818,987164449,'Sagittarius'],
  [987164449,987379857,'Capricorn'],
  [987379857,987598810,'Aquarius'],
  [987598810,987812266,'Pisces'],
  [987812266,988016160,'Aries'],
  [988016160,988211478,'Taurus'],
  [988211478,988400969,'Gemini'],
  [988400969,988586683,'Cancer'],
  [988586683,988769759,'Leo'],
  [988769759,988951797,'Virgo'],
  [988951797,989136042,'Libra'],
  [989136042,989327095,'Scorpio'],
  [989327095,989528979,'Sagittarius'],
  [989528979,989741985,'Capricorn'],
  [989741985,989960476,'Aquarius'],
  [989960476,990175273,'Pisces'],
  [990175273,990379763,'Aries'],
  [990379763,990573122,'Taurus'],
  [990573122,990758555,'Gemini'],
  [990758555,990940307,'Cancer'],
  [990940307,991121872,'Leo'],
  [991121872,991305687,'Virgo'],
  [991305687,991493759,'Libra'],
  [991493759,991688273,'Scorpio'],
  [991688273,991891367,'Sagittarius'],
  [991891367,992103567,'Capricorn'],
  [992103567,992321601,'Aquarius'],
  [992321601,992538180,'Pisces'],
  [992538180,992745534,'Aries'],
  [992745534,992940126,'Taurus'],
  [992940126,993123646,'Gemini'],
  [993123646,993300887,'Cancer'],
  [993300887,993477456,'Leo'],
  [993477456,993658241,'Virgo'],
  [993658241,993846510,'Libra'],
  [993846510,994043597,'Scorpio'],
  [994043597,994249285,'Sagittarius'],
  [994249285,994462379,'Capricorn'],
  [994462379,994680294,'Aquarius'],
  [994680294,994898141,'Pisces'],
  [994898141,995109177,'Aries'],
  [995109177,995307929,'Taurus'],
  [995307929,995493367,'Gemini'],
  [995493367,995668976,'Cancer'],
  [995668976,995840926,'Leo'],
  [995840926,996016071,'Virgo'],
  [996016071,996200201,'Libra'],
  [996200201,996396258,'Scorpio'],
  [996396258,996603360,'Sagittarius'],
  [996603360,996817986,'Capricorn'],
  [996817986,997036200,'Aquarius'],
  [997036200,997254283,'Pisces'],
  [997254283,997467785,'Aries'],
  [997467785,997671512,'Taurus'],
  [997671512,997862087,'Gemini'],
  [997862087,998040317,'Cancer'],
  [998040317,998211163,'Leo'],
  [998211163,998381928,'Virgo'],
  [998381928,998560196,'Libra'],
  [998560196,998751544,'Scorpio'],
  [998751544,998956909,'Sagittarius'],
  [998956909,999172045,'Capricorn'],
  [999172045,999390715,'Aquarius'],
  [999390715,999608274,'Pisces'],
  [999608274,999821865,'Aries'],
  [999821865,1000028451,'Taurus'],
  [1000028451,1000224562,'Gemini'],
  [1000224562,1000408560,'Cancer'],
  [1000408560,1000582764,'Leo'],
  [1000582764,1000753191,'Virgo'],
  [1000753191,1000927622,'Libra'],
  [1000927622,1001113339,'Scorpio'],
  [1001113339,1001314099,'Sagittarius'],
  [1001314099,1001527478,'Capricorn'],
  [1001527478,1001746190,'Aquarius'],
  [1001746190,1001963244,'Pisces'],
  [1001963244,1002175260,'Aries'],
  [1002175260,1002381131,'Taurus'],
  [1002381131,1002579555,'Gemini'],
  [1002579555,1002768864,'Cancer'],
  [1002768864,1002949080,'Leo'],
  [1002949080,1003123574,'Virgo'],
  [1003123574,1003298552,'Libra'],
  [1003298552,1003481205,'Scorpio'],
  [1003481205,1003677080,'Sagittarius'],
  [1003677080,1003886775,'Capricorn'],
  [1003886775,1004104525,'Aquarius'],
  [1004104525,1004321688,'Pisces'],
  [1004321688,1004532460,'Aries'],
  [1004532460,1004735550,'Taurus'],
  [1004735550,1004931836,'Gemini'],
  [1004931836,1005122034,'Cancer'],
  [1005122034,1005306529,'Leo'],
  [1005306529,1005486767,'Virgo'],
  [1005486767,1005666271,'Libra'],
  [1005666271,1005850250,'Scorpio'],
  [1005850250,1006043975,'Sagittarius'],
  [1006043975,1006250090,'Capricorn'],
  [1006250090,1006465920,'Aquarius'],
  [1006465920,1006683668,'Pisces'],
  [1006683668,1006895146,'Aries'],
  [1006895146,1007096616,'Taurus'],
  [1007096616,1007289001,'Gemini'],
  [1007289001,1007475331,'Cancer'],
  [1007475331,1007658660,'Leo'],
  [1007658660,1007841410,'Virgo'],
  [1007841410,1008025748,'Libra'],
  [1008025748,1008214189,'Scorpio'],
  [1008214189,1008409672,'Sagittarius'],
  [1008409672,1008614569,'Capricorn'],
  [1008614569,1008828554,'Aquarius'],
  [1008828554,1009046711,'Pisces'],
  [1009046711,1009260744,'Aries'],
  [1009260744,1009463927,'Taurus'],
  [1009463927,1009654801,'Gemini'],
  [1009654801,1009836542,'Cancer'],
  [1009836542,1010014462,'Leo'],
  [1010014462,1010193827,'Virgo'],
  [1010193827,1010378471,'Libra'],
  [1010378471,1010570242,'Scorpio'],
  [1010570242,1010769481,'Sagittarius'],
  [1010769481,1010976079,'Capricorn'],
  [1010976079,1011189601,'Aquarius'],
  [1011189601,1011407682,'Pisces'],
  [1011407682,1011624418,'Aries'],
  [1011624418,1011832052,'Taurus'],
  [1011832052,1012025818,'Gemini'],
  [1012025818,1012206654,'Cancer'],
  [1012206654,1012379999,'Leo'],
  [1012379999,1012553065,'Virgo'],
  [1012553065,1012732515,'Libra'],
  [1012732515,1012922480,'Scorpio'],
  [1012922480,1013123300,'Sagittarius'],
  [1013123300,1013332479,'Capricorn'],
  [1013332479,1013547167,'Aquarius'],
  [1013547167,1013765130,'Pisces'],
  [1013765130,1013983064,'Aries'],
  [1013983064,1014195000,'Taurus'],
  [1014195000,1014394564,'Gemini'],
  [1014394564,1014579389,'Cancer'],
  [1014579389,1014752825,'Leo'],
  [1014752825,1014922011,'Virgo'],
  [1014922011,1015095085,'Libra'],
  [1015095085,1015278886,'Scorpio'],
  [1015278886,1015476463,'Sagittarius'],
  [1015476463,1015685775,'Capricorn'],
  [1015685775,1015901785,'Aquarius'],
  [1015901785,1016120041,'Pisces'],
  [1016120041,1016337651,'Aries'],
  [1016337651,1016551176,'Taurus'],
  [1016551176,1016755581,'Gemini'],
  [1016755581,1016946776,'Cancer'],
  [1016946776,1017125023,'Leo'],
  [1017125023,1017295426,'Virgo'],
  [1017295426,1017465686,'Libra'],
  [1017465686,1017643690,'Scorpio'],
  [1017643690,1017835113,'Sagittarius'],
  [1017835113,1018040798,'Capricorn'],
  [1018040798,1018256245,'Aquarius'],
  [1018256245,1018474823,'Pisces'],
  [1018474823,1018691707,'Aries'],
  [1018691707,1018904180,'Taurus'],
  [1018904180,1019109658,'Gemini'],
  [1019109658,1019305242,'Cancer'],
  [1019305242,1019489688,'Leo'],
  [1019489688,1019665320,'Virgo'],
  [1019665320,1019837722,'Libra'],
  [1019837722,1020013967,'Scorpio'],
  [1020013967,1020200567,'Sagittarius'],
  [1020200567,1020401009,'Capricorn'],
  [1020401009,1020613562,'Aquarius'],
  [1020613562,1020831722,'Pisces'],
  [1020831722,1021048312,'Aries'],
  [1021048312,1021259051,'Taurus'],
  [1021259051,1021462408,'Gemini'],
  [1021462408,1021657938,'Cancer'],
  [1021657938,1021845642,'Leo'],
  [1021845642,1022026725,'Virgo'],
  [1022026725,1022204303,'Libra'],
  [1022204303,1022383193,'Scorpio'],
  [1022383193,1022568860,'Sagittarius'],
  [1022568860,1022765683,'Capricorn'],
  [1022765683,1022974625,'Aquarius'],
  [1022974625,1023191484,'Pisces'],
  [1023191484,1023408388,'Aries'],
  [1023408388,1023618549,'Taurus'],
  [1023618549,1023819305,'Gemini'],
  [1023819305,1024011571,'Cancer'],
  [1024011571,1024197811,'Leo'],
  [1024197811,1024380649,'Virgo'],
  [1024380649,1024562548,'Libra'],
  [1024562548,1024746122,'Scorpio'],
  [1024746122,1024934483,'Sagittarius'],
  [1024934483,1025130953,'Capricorn'],
  [1025130953,1025337619,'Aquarius'],
  [1025337619,1025552958,'Pisces'],
  [1025552958,1025770568,'Aries'],
  [1025770568,1025982037,'Taurus'],
  [1025982037,1026182194,'Gemini'],
  [1026182194,1026371267,'Cancer'],
  [1026371267,1026553240,'Leo'],
  [1026553240,1026733157,'Virgo'],
  [1026733157,1026915170,'Libra'],
  [1026915170,1027101721,'Scorpio'],
  [1027101721,1027293937,'Sagittarius'],
  [1027293937,1027492780,'Capricorn'],
  [1027492780,1027699462,'Aquarius'],
  [1027699462,1027913909,'Pisces'],
  [1027913909,1028132212,'Aries'],
  [1028132212,1028346387,'Taurus'],
  [1028346387,1028548904,'Gemini'],
  [1028548904,1028737633,'Cancer'],
  [1028737633,1028916190,'Leo'],
  [1028916190,1029091084,'Virgo'],
  [1029091084,1029268838,'Libra'],
  [1029268838,1029453921,'Scorpio'],
  [1029453921,1029647718,'Sagittarius'],
  [1029647718,1029849383,'Capricorn'],
  [1029849383,1030057843,'Aquarius'],
  [1030057843,1030272449,'Pisces'],
  [1030272449,1030491089,'Aries'],
  [1030491089,1030707910,'Taurus'],
  [1030707910,1030914846,'Gemini'],
  [1030914846,1031106984,'Cancer'],
  [1031106984,1031285771,'Leo'],
  [1031285771,1031457417,'Virgo'],
  [1031457417,1031629699,'Libra'],
  [1031629699,1031809452,'Scorpio'],
  [1031809452,1032000457,'Sagittarius'],
  [1032000457,1032202459,'Capricorn'],
  [1032202459,1032412674,'Aquarius'],
  [1032412674,1032628245,'Pisces'],
  [1032628245,1032846864,'Aries'],
  [1032846864,1033064782,'Taurus'],
  [1033064782,1033275682,'Gemini'],
  [1033275682,1033473495,'Cancer'],
  [1033473495,1033656731,'Leo'],
  [1033656731,1033829488,'Virgo'],
  [1033829488,1033999049,'Libra'],
  [1033999049,1034173243,'Scorpio'],
  [1034173243,1034358293,'Sagittarius'],
  [1034358293,1034556679,'Capricorn'],
  [1034556679,1034766405,'Aquarius'],
  [1034766405,1034982802,'Pisces'],
  [1034982802,1035201385,'Aries'],
  [1035201385,1035418633,'Taurus'],
  [1035418633,1035630605,'Gemini'],
  [1035630605,1035832791,'Cancer'],
  [1035832791,1036022360,'Leo'],
  [1036022360,1036200497,'Virgo'],
  [1036200497,1036372213,'Libra'],
  [1036372213,1036544480,'Scorpio'],
  [1036544480,1036724321,'Sagittarius'],
  [1036724321,1036916806,'Capricorn'],
  [1036916806,1037122901,'Aquarius'],
  [1037122901,1037338655,'Pisces'],
  [1037338655,1037557400,'Aries'],
  [1037557400,1037773503,'Taurus'],
  [1037773503,1037983658,'Gemini'],
  [1037983658,1038185986,'Cancer'],
  [1038185986,1038379293,'Leo'],
  [1038379293,1038563659,'Virgo'],
  [1038563659,1038741318,'Libra'],
  [1038741318,1038916677,'Scorpio'],
  [1038916677,1039095520,'Sagittarius'],
  [1039095520,1039283641,'Capricorn'],
  [1039283641,1039484748,'Aquarius'],
  [1039484748,1039697879,'Pisces'],
  [1039697879,1039916591,'Aries'],
  [1039916591,1040132581,'Taurus'],
  [1040132581,1040340588,'Gemini'],
  [1040340588,1040539703,'Cancer'],
  [1040539703,1040731506,'Leo'],
  [1040731506,1040917991,'Virgo'],
  [1040917991,1041100877,'Libra'],
  [1041100877,1041282073,'Scorpio'],
  [1041282073,1041464554,'Sagittarius'],
  [1041464554,1041652590,'Capricorn'],
  [1041652590,1041850602,'Aquarius'],
  [1041850602,1042060474,'Pisces'],
  [1042060474,1042278463,'Aries'],
  [1042278463,1042495654,'Taurus'],
  [1042495654,1042703750,'Gemini'],
  [1042703750,1042900136,'Cancer'],
  [1042900136,1043087505,'Leo'],
  [1043087505,1043270566,'Virgo'],
  [1043270566,1043453323,'Libra'],
  [1043453323,1043637946,'Scorpio'],
  [1043637946,1043825385,'Sagittarius'],
  [1043825385,1044017053,'Capricorn'],
  [1044017053,1044215670,'Aquarius'],
  [1044215670,1044423856,'Pisces'],
  [1044423856,1044640750,'Aries'],
  [1044640750,1044859509,'Taurus'],
  [1044859509,1045070336,'Gemini'],
  [1045070336,1045267463,'Cancer'],
  [1045267463,1045452144,'Leo'],
  [1045452144,1045630081,'Virgo'],
  [1045630081,1045807757,'Libra'],
  [1045807757,1045989956,'Scorpio'],
  [1045989956,1046178661,'Sagittarius'],
  [1046178661,1046373860,'Capricorn'],
  [1046373860,1046575547,'Aquarius'],
  [1046575547,1046784582,'Pisces'],
  [1046784582,1047000966,'Aries'],
  [1047000966,1047220648,'Taurus'],
  [1047220648,1047435095,'Gemini'],
  [1047435095,1047636387,'Cancer'],
  [1047636387,1047822747,'Leo'],
  [1047822747,1047998587,'Virgo'],
  [1047998587,1048171076,'Libra'],
  [1048171076,1048347175,'Scorpio'],
  [1048347175,1048531686,'Sagittarius'],
  [1048531686,1048726235,'Capricorn'],
  [1048726235,1048929926,'Aquarius'],
  [1048929926,1049141062,'Pisces'],
  [1049141062,1049358010,'Aries'],
  [1049358010,1049577829,'Taurus'],
  [1049577829,1049794566,'Gemini'],
  [1049794566,1050000834,'Cancer'],
  [1050000834,1050192417,'Leo'],
  [1050192417,1050370907,'Virgo'],
  [1050370907,1050542161,'Libra'],
  [1050542161,1050713490,'Scorpio'],
  [1050713490,1050891620,'Sagittarius'],
  [1050891620,1051081071,'Capricorn'],
  [1051081071,1051282929,'Aquarius'],
  [1051282929,1051494862,'Pisces'],
  [1051494862,1051712777,'Aries'],
  [1051712777,1051932440,'Taurus'],
  [1051932440,1052149324,'Gemini'],
  [1052149324,1052358384,'Cancer'],
  [1052358384,1052555463,'Leo'],
  [1052555463,1052739743,'Virgo'],
  [1052739743,1052914418,'Libra'],
  [1052914418,1053085360,'Scorpio'],
  [1053085360,1053259407,'Sagittarius'],
  [1053259407,1053442851,'Capricorn'],
  [1053442851,1053639660,'Aquarius'],
  [1053639660,1053849521,'Pisces'],
  [1053849521,1054067541,'Aries'],
  [1054067541,1054287093,'Taurus'],
  [1054287093,1054502840,'Gemini'],
  [1054502840,1054711496,'Cancer'],
  [1054711496,1054911051,'Leo'],
  [1054911051,1055100601,'Virgo'],
  [1055100601,1055281136,'Libra'],
  [1055281136,1055455947,'Scorpio'],
  [1055455947,1055630301,'Sagittarius'],
  [1055630301,1055810486,'Capricorn'],
  [1055810486,1056002190,'Aquarius'],
  [1056002190,1056207935,'Pisces'],
  [1056207935,1056424510,'Aries'],
  [1056424510,1056643972,'Taurus'],
  [1056643972,1056858712,'Gemini'],
  [1056858712,1057065173,'Cancer'],
  [1057065173,1057263359,'Leo'],
  [1057263359,1057454417,'Virgo'],
  [1057454417,1057639410,'Libra'],
  [1057639410,1057819707,'Scorpio'],
  [1057819707,1057998055,'Sagittarius'],
  [1057998055,1058179076,'Capricorn'],
  [1058179076,1058368408,'Aquarius'],
  [1058368408,1058570366,'Pisces'],
  [1058570366,1058784475,'Aries'],
  [1058784475,1059003730,'Taurus'],
  [1059003730,1059218579,'Gemini'],
  [1059218579,1059423403,'Cancer'],
  [1059423403,1059618412,'Leo'],
  [1059618412,1059806868,'Virgo'],
  [1059806868,1059991945,'Libra'],
  [1059991945,1060175449,'Scorpio'],
  [1060175449,1060358545,'Sagittarius'],
  [1060358545,1060543409,'Capricorn'],
  [1060543409,1060733922,'Aquarius'],
  [1060733922,1060934385,'Pisces'],
  [1060934385,1061146340,'Aries'],
  [1061146340,1061365242,'Taurus'],
  [1061365242,1061581465,'Gemini'],
  [1061581465,1061786909,'Cancer'],
  [1061786909,1061980000,'Leo'],
  [1061980000,1062164468,'Virgo'],
  [1062164468,1062345598,'Libra'],
  [1062345598,1062527511,'Scorpio'],
  [1062527511,1062712277,'Sagittarius'],
  [1062712277,1062900875,'Capricorn'],
  [1062900875,1063094810,'Aquarius'],
  [1063094810,1063296537,'Pisces'],
  [1063296537,1063507785,'Aries'],
  [1063507785,1063726313,'Taurus'],
  [1063726313,1063944438,'Gemini'],
  [1063944438,1064152955,'Cancer'],
  [1064152955,1064347470,'Leo'],
  [1064347470,1064530136,'Virgo'],
  [1064530136,1064706723,'Libra'],
  [1064706723,1064883420,'Scorpio'],
  [1064883420,1065064887,'Sagittarius'],
  [1065064887,1065253515,'Capricorn'],
  [1065253515,1065450008,'Aquarius'],
  [1065450008,1065654452,'Pisces'],
  [1065654452,1065866696,'Aries'],
  [1065866696,1066085076,'Taurus'],
  [1066085076,1066304439,'Gemini'],
  [1066304439,1066516879,'Cancer'],
  [1066516879,1066716081,'Leo'],
  [1066716081,1066901222,'Virgo'],
  [1066901222,1067076516,'Libra'],
  [1067076516,1067248496,'Scorpio'],
  [1067248496,1067423807,'Sagittarius'],
  [1067423807,1067607675,'Capricorn'],
  [1067607675,1067802723,'Aquarius'],
  [1067802723,1068008551,'Pisces'],
  [1068008551,1068222543,'Aries'],
  [1068222543,1068441260,'Taurus'],
  [1068441260,1068660596,'Gemini'],
  [1068660596,1068875293,'Cancer'],
  [1068875293,1069079784,'Leo'],
  [1069079784,1069270913,'Virgo'],
  [1069270913,1069449829,'Libra'],
  [1069449829,1069621365,'Scorpio'],
  [1069621365,1069792295,'Sagittarius'],
  [1069792295,1069969677,'Capricorn'],
  [1069969677,1070159115,'Aquarius'],
  [1070159115,1070362551,'Pisces'],
  [1070362551,1070576993,'Aries'],
  [1070576993,1070796374,'Taurus'],
  [1070796374,1071015048,'Gemini'],
  [1071015048,1071229221,'Cancer'],
  [1071229221,1071436009,'Leo'],
  [1071436009,1071632788,'Virgo'],
  [1071632788,1071818397,'Libra'],
  [1071818397,1071994555,'Scorpio'],
  [1071994555,1072166117,'Sagittarius'],
  [1072166117,1072339986,'Capricorn'],
  [1072339986,1072523381,'Aquarius'],
  [1072523381,1072721299,'Pisces'],
  [1072721299,1072933288,'Aries'],
  [1072933288,1073152699,'Taurus'],
  [1073152699,1073371111,'Gemini'],
  [1073371111,1073583479,'Cancer'],
  [1073583479,1073788652,'Leo'],
  [1073788652,1073986680,'Virgo'],
  [1073986680,1074177156,'Libra'],
  [1074177156,1074359874,'Scorpio'],
  [1074359874,1074536652,'Sagittarius'],
  [1074536652,1074712235,'Capricorn'],
  [1074712235,1074893324,'Aquarius'],
  [1074893324,1075086341,'Pisces'],
  [1075086341,1075293958,'Aries'],
  [1075293958,1075511882,'Taurus'],
  [1075511882,1075730592,'Gemini'],
  [1075730592,1075942189,'Cancer'],
  [1075942189,1076144560,'Leo'],
  [1076144560,1076339554,'Virgo'],
  [1076339554,1076529456,'Libra'],
  [1076529456,1076715304,'Scorpio'],
  [1076715304,1076897638,'Sagittarius'],
  [1076897638,1077078432,'Capricorn'],
  [1077078432,1077261997,'Aquarius'],
  [1077261997,1077453900,'Pisces'],
  [1077453900,1077658203,'Aries'],
  [1077658203,1077873735,'Taurus'],
  [1077873735,1078092718,'Gemini'],
  [1078092718,1078305470,'Cancer'],
  [1078305470,1078507070,'Leo'],
  [1078507070,1078698643,'Virgo'],
  [1078698643,1078884175,'Libra'],
  [1078884175,1079067426,'Scorpio'],
  [1079067426,1079250694,'Sagittarius'],
  [1079250694,1079435419,'Capricorn'],
  [1079435419,1079623549,'Aquarius'],
  [1079623549,1079818115,'Pisces'],
  [1079818115,1080022165,'Aries'],
  [1080022165,1080236073,'Taurus'],
  [1080236073,1080454988,'Gemini'],
  [1080454988,1080670042,'Cancer'],
  [1080670042,1080873925,'Leo'],
  [1080873925,1081065131,'Virgo'],
  [1081065131,1081247063,'Libra'],
  [1081247063,1081425026,'Scorpio'],
  [1081425026,1081603996,'Sagittarius'],
  [1081603996,1081787567,'Capricorn'],
  [1081787567,1081977831,'Aquarius'],
  [1081977831,1082175856,'Pisces'],
  [1082175856,1082382141,'Aries'],
  [1082382141,1082596190,'Taurus'],
  [1082596190,1082814948,'Gemini'],
  [1082814948,1083032047,'Cancer'],
  [1083032047,1083239998,'Leo'],
  [1083239998,1083434559,'Virgo'],
  [1083434559,1083616723,'Libra'],
  [1083616723,1083791288,'Scorpio'],
  [1083791288,1083964597,'Sagittarius'],
  [1083964597,1084142775,'Capricorn'],
  [1084142775,1084330318,'Aquarius'],
  [1084330318,1084528939,'Pisces'],
  [1084528939,1084737412,'Aries'],
  [1084737412,1084952832,'Taurus'],
  [1084952832,1085171689,'Gemini'],
  [1085171689,1085389637,'Cancer'],
  [1085389637,1085601117,'Leo'],
  [1085601117,1085800943,'Virgo'],
  [1085800943,1085987287,'Libra'],
  [1085987287,1086162728,'Scorpio'],
  [1086162728,1086333137,'Sagittarius'],
  [1086333137,1086505778,'Capricorn'],
  [1086505778,1086687491,'Aquarius'],
  [1086687491,1086882551,'Pisces'],
  [1086882551,1087090603,'Aries'],
  [1087090603,1087307044,'Taurus'],
  [1087307044,1087526234,'Gemini'],
  [1087526234,1087743881,'Cancer'],
  [1087743881,1087956591,'Leo'],
  [1087956591,1088160596,'Virgo'],
  [1088160596,1088352769,'Libra'],
  [1088352769,1088532932,'Scorpio'],
  [1088532932,1088704870,'Sagittarius'],
  [1088704870,1088875305,'Capricorn'],
  [1088875305,1089051970,'Aquarius'],
  [1089051970,1089241381,'Pisces'],
  [1089241381,1089445832,'Aries'],
  [1089445832,1089661475,'Taurus'],
  [1089661475,1089880820,'Gemini'],
  [1089880820,1090097755,'Cancer'],
  [1090097755,1090309430,'Leo'],
  [1090309430,1090514323,'Virgo'],
  [1090514323,1090710498,'Libra'],
  [1090710498,1090896485,'Scorpio'],
  [1090896485,1091073448,'Sagittarius'],
  [1091073448,1091246048,'Capricorn'],
  [1091246048,1091421272,'Aquarius'],
  [1091421272,1091606366,'Pisces'],
  [1091606366,1091805944,'Aries'],
  [1091805944,1092018764,'Taurus'],
  [1092018764,1092237597,'Gemini'],
  [1092237597,1092454176,'Cancer'],
  [1092454176,1092664147,'Leo'],
  [1092664147,1092866954,'Virgo'],
  [1092866954,1093063005,'Libra'],
  [1093063005,1093252109,'Scorpio'],
  [1093252109,1093434393,'Sagittarius'],
  [1093434393,1093612085,'Capricorn'],
  [1093612085,1093789993,'Aquarius'],
  [1093789993,1093974353,'Pisces'],
  [1093974353,1094170542,'Aries'],
  [1094170542,1094379867,'Taurus'],
  [1094379867,1094597411,'Gemini'],
  [1094597411,1094814334,'Cancer'],
  [1094814334,1095023782,'Leo'],
  [1095023782,1095224015,'Virgo'],
  [1095224015,1095416710,'Libra'],
  [1095416710,1095604179,'Scorpio'],
  [1095604179,1095788124,'Sagittarius'],
  [1095788124,1095970175,'Capricorn'],
  [1095970175,1096152924,'Aquarius'],
  [1096152924,1096340216,'Pisces'],
  [1096340216,1096536224,'Aries'],
  [1096536224,1096743284,'Taurus'],
  [1096743284,1096959251,'Gemini'],
  [1096959251,1097176968,'Cancer'],
  [1097176968,1097388014,'Leo'],
  [1097388014,1097587915,'Virgo'],
  [1097587915,1097777419,'Libra'],
  [1097777419,1097960267,'Scorpio'],
  [1097960267,1098140808,'Sagittarius'],
  [1098140808,1098322658,'Capricorn'],
  [1098322658,1098508390,'Aquarius'],
  [1098508390,1098699859,'Pisces'],
  [1098699859,1098898637,'Aries'],
  [1098898637,1099105848,'Taurus'],
  [1099105848,1099320781,'Gemini'],
  [1099320781,1099539103,'Cancer'],
  [1099539103,1099753202,'Leo'],
  [1099753202,1099956164,'Virgo'],
  [1099956164,1100145908,'Libra'],
  [1100145908,1100325389,'Scorpio'],
  [1100325389,1100500371,'Sagittarius'],
  [1100500371,1100677122,'Capricorn'],
  [1100677122,1100860654,'Aquarius'],
  [1100860654,1101053456,'Pisces'],
  [1101053456,1101255336,'Aries'],
  [1101255336,1101464708,'Taurus'],
  [1101464708,1101679825,'Gemini'],
  [1101679825,1101898176,'Cancer'],
  [1101898176,1102114813,'Leo'],
  [1102114813,1102322774,'Virgo'],
  [1102322774,1102517012,'Libra'],
  [1102517012,1102697656,'Scorpio'],
  [1102697656,1102869705,'Sagittarius'],
  [1102869705,1103040597,'Capricorn'],
  [1103040597,1103217822,'Aquarius'],
  [1103217822,1103406713,'Pisces'],
  [1103406713,1103608326,'Aries'],
  [1103608326,1103819523,'Taurus'],
  [1103819523,1104035860,'Gemini'],
  [1104035860,1104254033,'Cancer'],
  [1104254033,1104471186,'Leo'],
  [1104471186,1104682763,'Virgo'],
  [1104682763,1104883178,'Libra'],
  [1104883178,1105069461,'Scorpio'],
  [1105069461,1105243835,'Sagittarius'],
  [1105243835,1105412814,'Capricorn'],
  [1105412814,1105584612,'Aquarius'],
  [1105584612,1105766799,'Pisces'],
  [1105766799,1105963569,'Aries'],
  [1105963569,1106173442,'Taurus'],
  [1106173442,1106390521,'Gemini'],
  [1106390521,1106608849,'Cancer'],
  [1106608849,1106825037,'Leo'],
  [1106825037,1107036760,'Virgo'],
  [1107036760,1107240673,'Libra'],
  [1107240673,1107433283,'Scorpio'],
  [1107433283,1107613925,'Sagittarius'],
  [1107613925,1107786370,'Capricorn'],
  [1107786370,1107957547,'Aquarius'],
  [1107957547,1108135280,'Pisces'],
  [1108135280,1108325857,'Aries'],
  [1108325857,1108531084,'Taurus'],
  [1108531084,1108746751,'Gemini'],
  [1108746751,1108965265,'Cancer'],
  [1108965265,1109180647,'Leo'],
  [1109180647,1109390321,'Virgo'],
  [1109390321,1109593237,'Libra'],
  [1109593237,1109788170,'Scorpio'],
  [1109788170,1109974295,'Sagittarius'],
  [1109974295,1110152954,'Capricorn'],
  [1110152954,1110328344,'Aquarius'],
  [1110328344,1110506584,'Pisces'],
  [1110506584,1110693911,'Aries'],
  [1110693911,1110894251,'Taurus'],
  [1110894251,1111106619,'Gemini'],
  [1111106619,1111324627,'Cancer'],
  [1111324627,1111540216,'Leo'],
  [1111540216,1111748391,'Virgo'],
  [1111748391,1111948145,'Libra'],
  [1111948145,1112140593,'Scorpio'],
  [1112140593,1112327274,'Sagittarius'],
  [1112327274,1112509864,'Capricorn'],
  [1112509864,1112690719,'Aquarius'],
  [1112690719,1112873277,'Pisces'],
  [1112873277,1113061785,'Aries'],
  [1113061785,1113260073,'Taurus'],
  [1113260073,1113469390,'Gemini'],
  [1113469390,1113686230,'Cancer'],
  [1113686230,1113902817,'Leo'],
  [1113902817,1114111624,'Virgo'],
  [1114111624,1114309518,'Libra'],
  [1114309518,1114497950,'Scorpio'],
  [1114497950,1114680755,'Sagittarius'],
  [1114680755,1114862024,'Capricorn'],
  [1114862024,1115044964,'Aquarius'],
  [1115044964,1115231747,'Pisces'],
  [1115231747,1115424067,'Aries'],
  [1115424067,1115623714,'Taurus'],
  [1115623714,1115832024,'Gemini'],
  [1115832024,1116047827,'Cancer'],
  [1116047827,1116265583,'Leo'],
  [1116265583,1116476986,'Virgo'],
  [1116476986,1116676119,'Libra'],
  [1116676119,1116862686,'Scorpio'],
  [1116862686,1117041038,'Sagittarius'],
  [1117041038,1117217378,'Capricorn'],
  [1117217378,1117397349,'Aquarius'],
  [1117397349,1117584452,'Pisces'],
  [1117584452,1117779579,'Aries'],
  [1117779579,1117982136,'Taurus'],
  [1117982136,1118191585,'Gemini'],
  [1118191585,1118407172,'Cancer'],
  [1118407172,1118625721,'Leo'],
  [1118625721,1118840324,'Virgo'],
  [1118840324,1119043412,'Libra'],
  [1119043412,1119231893,'Scorpio'],
  [1119231893,1119408716,'Sagittarius'],
  [1119408716,1119580579,'Capricorn'],
  [1119580579,1119754967,'Aquarius'],
  [1119754967,1119937866,'Pisces'],
  [1119937866,1120131887,'Aries'],
  [1120131887,1120335939,'Taurus'],
  [1120335939,1120547245,'Gemini'],
  [1120547245,1120763460,'Cancer'],
  [1120763460,1120982232,'Leo'],
  [1120982232,1121198944,'Virgo'],
  [1121198944,1121406649,'Libra'],
  [1121406649,1121600099,'Scorpio'],
  [1121600099,1121779569,'Sagittarius'],
  [1121779569,1121950509,'Capricorn'],
  [1121950509,1122120702,'Aquarius'],
  [1122120702,1122297752,'Pisces'],
  [1122297752,1122486866,'Aries'],
  [1122486866,1122688922,'Taurus'],
  [1122688922,1122900740,'Gemini'],
  [1122900740,1123117774,'Cancer'],
  [1123117774,1123336418,'Leo'],
  [1123336418,1123553304,'Virgo'],
  [1123553304,1123763679,'Libra'],
  [1123763679,1123962449,'Scorpio'],
  [1123962449,1124147573,'Sagittarius'],
  [1124147573,1124321926,'Capricorn'],
  [1124321926,1124491947,'Aquarius'],
  [1124491947,1124665272,'Pisces'],
  [1124665272,1124848664,'Aries'],
  [1124848664,1125045760,'Taurus'],
  [1125045760,1125255411,'Gemini'],
  [1125255411,1125472448,'Cancer'],
  [1125472448,1125690956,'Leo'],
  [1125690956,1125906707,'Virgo'],
  [1125906707,1126116607,'Libra'],
  [1126116607,1126317768,'Scorpio'],
  [1126317768,1126508194,'Sagittarius'],
  [1126508194,1126688542,'Capricorn'],
  [1126688542,1126862665,'Aquarius'],
  [1126862665,1127036571,'Pisces'],
  [1127036571,1127216847,'Aries'],
  [1127216847,1127408807,'Taurus'],
  [1127408807,1127614226,'Gemini'],
  [1127614226,1127829752,'Cancer'],
  [1127829752,1128048245,'Leo'],
  [1128048245,1128263036,'Virgo'],
  [1128263036,1128470597,'Libra'],
  [1128470597,1128670079,'Scorpio'],
  [1128670079,1128861809,'Sagittarius'],
  [1128861809,1129046713,'Capricorn'],
  [1129046713,1129226715,'Aquarius'],
  [1129226715,1129405148,'Pisces'],
  [1129405148,1129586638,'Aries'],
  [1129586638,1129776249,'Taurus'],
  [1129776249,1129977654,'Gemini'],
  [1129977654,1130190508,'Cancer'],
  [1130190508,1130408890,'Leo'],
  [1130408890,1130624100,'Virgo'],
  [1130624100,1130830139,'Libra'],
  [1130830139,1131026112,'Scorpio'],
  [1131026112,1131214608,'Sagittarius'],
  [1131214608,1131399053,'Capricorn'],
  [1131399053,1131582147,'Aquarius'],
  [1131582147,1131765742,'Pisces'],
  [1131765742,1131951739,'Aries'],
  [1131951739,1132142993,'Taurus'],
  [1132142993,1132342940,'Gemini'],
  [1132342940,1132553378,'Cancer'],
  [1132553378,1132771285,'Leo'],
  [1132771285,1132988264,'Virgo'],
  [1132988264,1133195569,'Libra'],
  [1133195569,1133389932,'Scorpio'],
  [1133389932,1133574119,'Sagittarius'],
  [1133574119,1133753763,'Capricorn'],
  [1133753763,1133934259,'Aquarius'],
  [1133934259,1134118916,'Pisces'],
  [1134118916,1134308742,'Aries'],
  [1134308742,1134503963,'Taurus'],
  [1134503963,1134705669,'Gemini'],
  [1134705669,1134915472,'Cancer'],
  [1134915472,1135132723,'Leo'],
  [1135132723,1135351574,'Virgo'],
  [1135351574,1135562618,'Libra'],
  [1135562618,1135759412,'Scorpio'],
  [1135759412,1135942508,'Sagittarius'],
  [1135942508,1136117671,'Capricorn'],
  [1136117671,1136292210,'Aquarius'],
  [1136292210,1136472251,'Pisces'],
  [1136472251,1136660949,'Aries'],
  [1136660949,1136858301,'Taurus'],
  [1136858301,1137062996,'Gemini'],
  [1137062996,1137274237,'Cancer'],
  [1137274237,1137491321,'Leo'],
  [1137491321,1137710927,'Virgo'],
  [1137710927,1137925708,'Libra'],
  [1137925708,1138127863,'Scorpio'],
  [1138127863,1138314665,'Sagittarius'],
  [1138314665,1138489761,'Capricorn'],
  [1138489761,1138660308,'Aquarius'],
  [1138660308,1138833945,'Pisces'],
  [1138833945,1139016666,'Aries'],
  [1139016666,1139211137,'Taurus'],
  [1139211137,1139416397,'Gemini'],
  [1139416397,1139629447,'Cancer'],
  [1139629447,1139847199,'Leo'],
  [1139847199,1140066527,'Virgo'],
  [1140066527,1140282673,'Libra'],
  [1140282673,1140489470,'Scorpio'],
  [1140489470,1140682569,'Sagittarius'],
  [1140682569,1140862467,'Capricorn'],
  [1140862467,1141034143,'Aquarius'],
  [1141034143,1141204709,'Pisces'],
  [1141204709,1141381328,'Aries'],
  [1141381328,1141569455,'Taurus'],
  [1141569455,1141771052,'Gemini'],
  [1141771052,1141983733,'Cancer'],
  [1141983733,1142202207,'Leo'],
  [1142202207,1142421149,'Virgo'],
  [1142421149,1142636330,'Libra'],
  [1142636330,1142844182,'Scorpio'],
  [1142844182,1143041756,'Sagittarius'],
  [1143041756,1143228061,'Capricorn'],
  [1143228061,1143405163,'Aquarius'],
  [1143405163,1143577849,'Pisces'],
  [1143577849,1143752441,'Aries'],
  [1143752441,1143935360,'Taurus'],
  [1143935360,1144131278,'Gemini'],
  [1144131278,1144340699,'Cancer'],
  [1144340699,1144558702,'Leo'],
  [1144558702,1144777595,'Virgo'],
  [1144777595,1144991301,'Libra'],
  [1144991301,1145197160,'Scorpio'],
  [1145197160,1145394783,'Sagittarius'],
  [1145394783,1145584540,'Capricorn'],
  [1145584540,1145767398,'Aquarius'],
  [1145767398,1145945521,'Pisces'],
  [1145945521,1146122811,'Aries'],
  [1146122811,1146304663,'Taurus'],
  [1146304663,1146496631,'Gemini'],
  [1146496631,1146701866,'Cancer'],
  [1146701866,1146917998,'Leo'],
  [1146917998,1147137003,'Virgo'],
  [1147137003,1147350276,'Libra'],
  [1147350276,1147553771,'Scorpio'],
  [1147553771,1147748318,'Sagittarius'],
  [1147748318,1147936750,'Capricorn'],
  [1147936750,1148121533,'Aquarius'],
  [1148121533,1148304225,'Pisces'],
  [1148304225,1148486434,'Aries'],
  [1148486434,1148671146,'Taurus'],
  [1148671146,1148862807,'Gemini'],
  [1148862807,1149065484,'Cancer'],
  [1149065484,1149279436,'Leo'],
  [1149279436,1149498504,'Virgo'],
  [1149498504,1149712859,'Libra'],
  [1149712859,1149915899,'Scorpio'],
  [1149915899,1150107533,'Sagittarius'],
  [1150107533,1150291926,'Capricorn'],
  [1150291926,1150473917,'Aquarius'],
  [1150473917,1150656830,'Pisces'],
  [1150656830,1150842160,'Aries'],
  [1150842160,1151030942,'Taurus'],
  [1151030942,1151225269,'Gemini'],
  [1151225269,1151428117,'Cancer'],
  [1151428117,1151640878,'Leo'],
  [1151640878,1151859934,'Virgo'],
  [1151859934,1152076388,'Libra'],
  [1152076388,1152281613,'Scorpio'],
  [1152281613,1152473089,'Sagittarius'],
  [1152473089,1152654369,'Capricorn'],
  [1152654369,1152831565,'Aquarius'],
  [1152831565,1153010331,'Pisces'],
  [1153010331,1153194241,'Aries'],
  [1153194241,1153384674,'Taurus'],
  [1153384674,1153582064,'Gemini'],
  [1153582064,1153787069,'Cancer'],
  [1153787069,1154000163,'Leo'],
  [1154000163,1154219226,'Virgo'],
  [1154219226,1154437663,'Libra'],
  [1154437663,1154646804,'Scorpio'],
  [1154646804,1154841570,'Sagittarius'],
  [1154841570,1155023247,'Capricorn'],
  [1155023247,1155197425,'Aquarius'],
  [1155197425,1155370897,'Pisces'],
  [1155370897,1155549578,'Aries'],
  [1155549578,1155737217,'Taurus'],
  [1155737217,1155934973,'Gemini'],
  [1155934973,1156141998,'Cancer'],
  [1156141998,1156356455,'Leo'],
  [1156356455,1156575676,'Virgo'],
  [1156575676,1156794956,'Libra'],
  [1156794956,1157007588,'Scorpio'],
  [1157007588,1157207669,'Sagittarius'],
  [1157207669,1157393680,'Capricorn'],
  [1157393680,1157568989,'Aquarius'],
  [1157568989,1157739784,'Pisces'],
  [1157739784,1157912994,'Aries'],
  [1157912994,1158094742,'Taurus'],
  [1158094742,1158288808,'Gemini'],
  [1158288808,1158495308,'Cancer'],
  [1158495308,1158710807,'Leo'],
  [1158710807,1158930374,'Virgo'],
  [1158930374,1159149250,'Libra'],
  [1159149250,1159362961,'Scorpio'],
  [1159362961,1159567270,'Sagittarius'],
  [1159567270,1159759444,'Capricorn'],
  [1159759444,1159939973,'Aquarius'],
  [1159939973,1160112726,'Pisces'],
  [1160112726,1160283854,'Aries'],
  [1160283854,1160460369,'Taurus'],
  [1160460369,1160648463,'Gemini'],
  [1160648463,1160851082,'Cancer'],
  [1160851082,1161065735,'Leo'],
  [1161065735,1161285559,'Virgo'],
  [1161285559,1161503654,'Libra'],
  [1161503654,1161715993,'Scorpio'],
  [1161715993,1161920829,'Sagittarius'],
  [1161920829,1162116994,'Capricorn'],
  [1162116994,1162303833,'Aquarius'],
  [1162303833,1162482380,'Pisces'],
  [1162482380,1162656296,'Aries'],
  [1162656296,1162831577,'Taurus'],
  [1162831577,1163015147,'Gemini'],
  [1163015147,1163212437,'Cancer'],
  [1163212437,1163423910,'Leo'],
  [1163423910,1163643257,'Virgo'],
  [1163643257,1163861191,'Libra'],
  [1163861191,1164071716,'Scorpio'],
  [1164071716,1164273915,'Sagittarius'],
  [1164273915,1164469246,'Capricorn'],
  [1164469246,1164658826,'Aquarius'],
  [1164658826,1164842988,'Pisces'],
  [1164842988,1165022773,'Aries'],
  [1165022773,1165201525,'Taurus'],
  [1165201525,1165384833,'Gemini'],
  [1165384833,1165578709,'Cancer'],
  [1165578709,1165786260,'Leo'],
  [1165786260,1166004028,'Virgo'],
  [1166004028,1166222552,'Libra'],
  [1166222552,1166433015,'Scorpio'],
  [1166433015,1166632726,'Sagittarius'],
  [1166632726,1166824125,'Capricorn'],
  [1166824125,1167010983,'Aquarius'],
  [1167010983,1167195829,'Pisces'],
  [1167195829,1167379701,'Aries'],
  [1167379701,1167563756,'Taurus'],
  [1167563756,1167750830,'Gemini'],
  [1167750830,1167945257,'Cancer'],
  [1167945257,1168150690,'Leo'],
  [1168150690,1168366505,'Virgo'],
  [1168366505,1168585661,'Libra'],
  [1168585661,1168798270,'Scorpio'],
  [1168798270,1168998552,'Sagittarius'],
  [1168998552,1169187333,'Capricorn'],
  [1169187333,1169369286,'Aquarius'],
  [1169369286,1169549527,'Pisces'],
  [1169549527,1169731712,'Aries'],
  [1169731712,1169917783,'Taurus'],
  [1169917783,1170108980,'Gemini'],
  [1170108980,1170306874,'Cancer'],
  [1170306874,1170513222,'Leo'],
  [1170513222,1170728098,'Virgo'],
  [1170728098,1170947368,'Libra'],
  [1170947368,1171162861,'Scorpio'],
  [1171162861,1171366933,'Sagittarius'],
  [1171366933,1171557266,'Capricorn'],
  [1171557266,1171736999,'Aquarius'],
  [1171736999,1171911954,'Pisces'],
  [1171911954,1172088193,'Aries'],
  [1172088193,1172270520,'Taurus'],
  [1172270520,1172461657,'Gemini'],
  [1172461657,1172662166,'Cancer'],
  [1172662166,1172871105,'Leo'],
  [1172871105,1173086694,'Virgo'],
  [1173086694,1173305790,'Libra'],
  [1173305790,1173523017,'Scorpio'],
  [1173523017,1173731669,'Sagittarius'],
  [1173731669,1173927110,'Capricorn'],
  [1173927110,1174109416,'Aquarius'],
  [1174109416,1174282900,'Pisces'],
  [1174282900,1174454117,'Aries'],
  [1174454117,1174629985,'Taurus'],
  [1174629985,1174816125,'Gemini'],
  [1174816125,1175015061,'Cancer'],
  [1175015061,1175225205,'Leo'],
  [1175225205,1175442191,'Virgo'],
  [1175442191,1175661340,'Libra'],
  [1175661340,1175878586,'Scorpio'],
  [1175878586,1176089759,'Sagittarius'],
  [1176089759,1176290578,'Capricorn'],
  [1176290578,1176478726,'Aquarius'],
  [1176478726,1176655601,'Pisces'],
  [1176655601,1176826253,'Aries'],
  [1176826253,1176997851,'Taurus'],
  [1176997851,1177177800,'Gemini'],
  [1177177800,1177371477,'Cancer'],
  [1177371477,1177579437,'Leo'],
  [1177579437,1177796676,'Virgo'],
  [1177796676,1178016064,'Libra'],
  [1178016064,1178232453,'Scorpio'],
  [1178232453,1178443260,'Sagittarius'],
  [1178443260,1178646463,'Capricorn'],
  [1178646463,1178839892,'Aquarius'],
  [1178839892,1179022729,'Pisces'],
  [1179022729,1179197301,'Aries'],
  [1179197301,1179369222,'Taurus'],
  [1179369222,1179545875,'Gemini'],
  [1179545875,1179734195,'Cancer'],
  [1179734195,1179937572,'Leo'],
  [1179937572,1180152968,'Virgo'],
  [1180152968,1180372270,'Libra'],
  [1180372270,1180587993,'Scorpio'],
  [1180587993,1180796950,'Sagittarius'],
  [1180796950,1180998910,'Capricorn'],
  [1180998910,1181193838,'Aquarius'],
  [1181193838,1181381176,'Pisces'],
  [1181381176,1181561343,'Aries'],
  [1181561343,1181737420,'Taurus'],
  [1181737420,1181915107,'Gemini'],
  [1181915107,1182101093,'Cancer'],
  [1182101093,1182300335,'Leo'],
  [1182300335,1182512603,'Virgo'],
  [1182512603,1182731184,'Libra'],
  [1182731184,1182947012,'Scorpio'],
  [1182947012,1183154691,'Sagittarius'],
  [1183154691,1183353828,'Capricorn'],
  [1183353828,1183546318,'Aquarius'],
  [1183546318,1183733797,'Pisces'],
  [1183733797,1183917231,'Aries'],
  [1183917231,1184098186,'Taurus'],
  [1184098186,1184279966,'Gemini'],
  [1184279966,1184467402,'Cancer'],
  [1184467402,1184665155,'Leo'],
  [1184665155,1184874801,'Virgo'],
  [1184874801,1185092267,'Libra'],
  [1185092267,1185308970,'Scorpio'],
  [1185308970,1185517289,'Sagittarius'],
  [1185517289,1185714819,'Capricorn'],
  [1185714819,1185903623,'Aquarius'],
  [1185903623,1186087365,'Pisces'],
  [1186087365,1186269353,'Aries'],
  [1186269353,1186452082,'Taurus'],
  [1186452082,1186637762,'Gemini'],
  [1186637762,1186828901,'Cancer'],
  [1186828901,1187028163,'Leo'],
  [1187028163,1187237036,'Virgo'],
  [1187237036,1187453586,'Libra'],
  [1187453586,1187671448,'Scorpio'],
  [1187671448,1187882391,'Sagittarius'],
  [1187882391,1188081303,'Capricorn'],
  [1188081303,1188268455,'Aquarius'],
  [1188268455,1188447873,'Pisces'],
  [1188447873,1188624925,'Aries'],
  [1188624925,1188804595,'Taurus'],
  [1188804595,1188990466,'Gemini'],
  [1188990466,1189184349,'Cancer'],
  [1189184349,1189386587,'Leo'],
  [1189386587,1189596675,'Virgo'],
  [1189596675,1189813013,'Libra'],
  [1189813013,1190031641,'Scorpio'],
  [1190031641,1190245897,'Sagittarius'],
  [1190245897,1190449081,'Capricorn'],
  [1190449081,1190638502,'Aquarius'],
  [1190638502,1190816552,'Pisces'],
  [1190816552,1190989012,'Aries'],
  [1190989012,1191162829,'Taurus'],
  [1191162829,1191344210,'Gemini'],
  [1191344210,1191536814,'Cancer'],
  [1191536814,1191740584,'Leo'],
  [1191740584,1191952652,'Virgo'],
  [1191952652,1192169604,'Libra'],
  [1192169604,1192388291,'Scorpio'],
  [1192388291,1192604585,'Sagittarius'],
  [1192604585,1192812697,'Capricorn'],
  [1192812697,1193007738,'Aquarius'],
  [1193007738,1193189045,'Pisces'],
  [1193189045,1193360822,'Aries'],
  [1193360822,1193530284,'Taurus'],
  [1193530284,1193705364,'Gemini'],
  [1193705364,1193892484,'Cancer'],
  [1193892484,1194093878,'Leo'],
  [1194093878,1194306430,'Virgo'],
  [1194306430,1194524290,'Libra'],
  [1194524290,1194742719,'Scorpio'],
  [1194742719,1194958824,'Sagittarius'],
  [1194958824,1195169381,'Capricorn'],
  [1195169381,1195370061,'Aquarius'],
  [1195370061,1195557853,'Pisces'],
  [1195557853,1195733909,'Aries'],
  [1195733909,1195903751,'Taurus'],
  [1195903751,1196075222,'Gemini'],
  [1196075222,1196256199,'Cancer'],
  [1196256199,1196451857,'Leo'],
  [1196451857,1196661664,'Virgo'],
  [1196661664,1196879441,'Libra'],
  [1196879441,1197097853,'Scorpio'],
  [1197097853,1197312624,'Sagittarius'],
  [1197312624,1197522074,'Capricorn'],
  [1197522074,1197724493,'Aquarius'],
  [1197724493,1197917540,'Pisces'],
  [1197917540,1198100275,'Aries'],
  [1198100275,1198275246,'Taurus'],
  [1198275246,1198448287,'Gemini'],
  [1198448287,1198626722,'Cancer'],
  [1198626722,1198817039,'Leo'],
  [1198817039,1199021841,'Virgo'],
  [1199021841,1199237525,'Libra'],
  [1199237525,1199455999,'Scorpio'],
  [1199455999,1199670165,'Sagittarius'],
  [1199670165,1199877179,'Capricorn'],
  [1199877179,1200077049,'Aquarius'],
  [1200077049,1200270189,'Pisces'],
  [1200270189,1200456755,'Aries'],
  [1200456755,1200637778,'Taurus'],
  [1200637778,1200816286,'Gemini'],
  [1200816286,1200997205,'Cancer'],
  [1200997205,1201186088,'Leo'],
  [1201186088,1201386903,'Virgo'],
  [1201386903,1201599290,'Libra'],
  [1201599290,1201817285,'Scorpio'],
  [1201817285,1202032311,'Sagittarius'],
  [1202032311,1202238581,'Capricorn'],
  [1202238581,1202435160,'Aquarius'],
  [1202435160,1202624240,'Pisces'],
  [1202624240,1202808825,'Aries'],
  [1202808825,1202991557,'Taurus'],
  [1202991557,1203174708,'Gemini'],
  [1203174708,1203360686,'Cancer'],
  [1203360686,1203552379,'Leo'],
  [1203552379,1203752668,'Virgo'],
  [1203752668,1203962730,'Libra'],
  [1203962730,1204179731,'Scorpio'],
  [1204179731,1204396374,'Sagittarius'],
  [1204396374,1204604658,'Capricorn'],
  [1204604658,1204800770,'Aquarius'],
  [1204800770,1204986185,'Pisces'],
  [1204986185,1205165612,'Aries'],
  [1205165612,1205344457,'Taurus'],
  [1205344457,1205527053,'Gemini'],
  [1205527053,1205715819,'Cancer'],
  [1205715819,1205911500,'Leo'],
  [1205911500,1206114290,'Virgo'],
  [1206114290,1206324376,'Libra'],
  [1206324376,1206540649,'Scorpio'],
  [1206540649,1206758572,'Sagittarius'],
  [1206758572,1206970424,'Capricorn'],
  [1206970424,1207169703,'Aquarius'],
  [1207169703,1207355230,'Pisces'],
  [1207355230,1207531178,'Aries'],
  [1207531178,1207704405,'Taurus'],
  [1207704405,1207881780,'Gemini'],
  [1207881780,1208068120,'Cancer'],
  [1208068120,1208264791,'Leo'],
  [1208264791,1208470197,'Virgo'],
  [1208470197,1208682016,'Libra'],
  [1208682016,1208898434,'Scorpio'],
  [1208898434,1209116800,'Sagittarius'],
  [1209116800,1209331617,'Capricorn'],
  [1209331617,1209535843,'Aquarius'],
  [1209535843,1209725460,'Pisces'],
  [1209725460,1209902278,'Aries'],
  [1209902278,1210072645,'Taurus'],
  [1210072645,1210244510,'Gemini'],
  [1210244510,1210424995,'Cancer'],
  [1210424995,1210618093,'Leo'],
  [1210618093,1210823178,'Virgo'],
  [1210823178,1211036345,'Libra'],
  [1211036345,1211253514,'Scorpio'],
  [1211253514,1211471722,'Sagittarius'],
  [1211471722,1211687489,'Capricorn'],
  [1211687489,1211895497,'Aquarius'],
  [1211895497,1212090753,'Pisces'],
  [1212090753,1212272307,'Aries'],
  [1212272307,1212444348,'Taurus'],
  [1212444348,1212614158,'Gemini'],
  [1212614158,1212789602,'Cancer'],
  [1212789602,1212976875,'Leo'],
  [1212976875,1213178097,'Virgo'],
  [1213178097,1213390368,'Libra'],
  [1213390368,1213607965,'Scorpio'],
  [1213607965,1213825890,'Sagittarius'],
  [1213825890,1214040805,'Capricorn'],
  [1214040805,1214249532,'Aquarius'],
  [1214249532,1214448546,'Pisces'],
  [1214448546,1214635824,'Aries'],
  [1214635824,1214812982,'Taurus'],
  [1214812982,1214985167,'Gemini'],
  [1214985167,1215159324,'Cancer'],
  [1215159324,1215342232,'Leo'],
  [1215342232,1215538280,'Virgo'],
  [1215538280,1215747287,'Libra'],
  [1215747287,1215964181,'Scorpio'],
  [1215964181,1216181990,'Sagittarius'],
  [1216181990,1216395601,'Capricorn'],
  [1216395601,1216602453,'Aquarius'],
  [1216602453,1216801329,'Pisces'],
  [1216801329,1216991645,'Aries'],
  [1216991645,1217174108,'Taurus'],
  [1217174108,1217351494,'Gemini'],
  [1217351494,1217528492,'Cancer'],
  [1217528492,1217710744,'Leo'],
  [1217710744,1217903286,'Virgo'],
  [1217903286,1218108375,'Libra'],
  [1218108375,1218323418,'Scorpio'],
  [1218323418,1218541316,'Sagittarius'],
  [1218541316,1218754569,'Capricorn'],
  [1218754569,1218959176,'Aquarius'],
  [1218959176,1219154984,'Pisces'],
  [1219154984,1219343864,'Aries'],
  [1219343864,1219528095,'Taurus'],
  [1219528095,1219709916,'Gemini'],
  [1219709916,1219891840,'Cancer'],
  [1219891840,1220077089,'Leo'],
  [1220077089,1220269471,'Virgo'],
  [1220269471,1220472116,'Libra'],
  [1220472116,1220685041,'Scorpio'],
  [1220685041,1220903081,'Sagittarius'],
  [1220903081,1221117583,'Capricorn'],
  [1221117583,1221321872,'Aquarius'],
  [1221321872,1221514736,'Pisces'],
  [1221514736,1221699388,'Aries'],
  [1221699388,1221880613,'Taurus'],
  [1221880613,1222062527,'Gemini'],
  [1222062527,1222247611,'Cancer'],
  [1222247611,1222437116,'Leo'],
  [1222437116,1222632327,'Virgo'],
  [1222632327,1222835174,'Libra'],
  [1222835174,1223046858,'Scorpio'],
  [1223046858,1223264905,'Sagittarius'],
  [1223264905,1223481770,'Capricorn'],
  [1223481770,1223688665,'Aquarius'],
  [1223688665,1223881615,'Pisces'],
  [1223881615,1224063059,'Aries'],
  [1224063059,1224239128,'Taurus'],
  [1224239128,1224416415,'Gemini'],
  [1224416415,1224599705,'Cancer'],
  [1224599705,1224790798,'Leo'],
  [1224790798,1224989254,'Virgo'],
  [1224989254,1225194446,'Libra'],
  [1225194446,1225406469,'Scorpio'],
  [1225406469,1225624390,'Sagittarius'],
  [1225624390,1225843284,'Capricorn'],
  [1225843284,1226054590,'Aquarius'],
  [1226054590,1226251564,'Pisces'],
  [1226251564,1226433931,'Aries'],
  [1226433931,1226607097,'Taurus'],
  [1226607097,1226778741,'Gemini'],
  [1226778741,1226956043,'Cancer'],
  [1226956043,1227143561,'Leo'],
  [1227143561,1227341993,'Virgo'],
  [1227341993,1227549251,'Libra'],
  [1227549251,1227762835,'Scorpio'],
  [1227762835,1227980855,'Sagittarius'],
  [1227980855,1228200274,'Capricorn'],
  [1228200274,1228414982,'Aquarius'],
  [1228414982,1228617838,'Pisces'],
  [1228617838,1228805540,'Aries'],
  [1228805540,1228980813,'Taurus'],
  [1228980813,1229150396,'Gemini'],
  [1229150396,1229322154,'Cancer'],
  [1229322154,1229502940,'Leo'],
  [1229502940,1229696574,'Virgo'],
  [1229696574,1229902594,'Libra'],
  [1229902594,1230117177,'Scorpio'],
  [1230117177,1230335747,'Sagittarius'],
  [1230335747,1230554543,'Capricorn'],
  [1230554543,1230769623,'Aquarius'],
  [1230769623,1230976181,'Pisces'],
  [1230976181,1231170343,'Aries'],
  [1231170343,1231351895,'Taurus'],
  [1231351895,1231524820,'Gemini'],
  [1231524820,1231695654,'Cancer'],
  [1231695654,1231871568,'Leo'],
  [1231871568,1232058607,'Virgo'],
  [1232058607,1232259622,'Libra'],
  [1232259622,1232472605,'Scorpio'],
  [1232472605,1232691488,'Sagittarius'],
  [1232691488,1232909783,'Capricorn'],
  [1232909783,1233123130,'Aquarius'],
  [1233123130,1233329089,'Pisces'],
  [1233329089,1233526109,'Aries'],
  [1233526109,1233713660,'Taurus'],
  [1233713660,1233893134,'Gemini'],
  [1233893134,1234068194,'Cancer'],
  [1234068194,1234244294,'Leo'],
  [1234244294,1234427562,'Virgo'],
  [1234427562,1234623030,'Libra'],
  [1234623030,1234831997,'Scorpio'],
  [1234831997,1235049919,'Sagittarius'],
  [1235049919,1235268372,'Capricorn'],
  [1235268372,1235480376,'Aquarius'],
  [1235480376,1235683425,'Pisces'],
  [1235683425,1235878398,'Aries'],
  [1235878398,1236067129,'Taurus'],
  [1236067129,1236251216,'Gemini'],
  [1236251216,1236432263,'Cancer'],
  [1236432263,1236612854,'Leo'],
  [1236612854,1236797153,'Virgo'],
  [1236797153,1236990141,'Libra'],
  [1236990141,1237195284,'Scorpio'],
  [1237195284,1237411122,'Sagittarius'],
  [1237411122,1237629988,'Capricorn'],
  [1237629988,1237842485,'Aquarius'],
  [1237842485,1238043765,'Pisces'],
  [1238043765,1238234938,'Aries'],
  [1238234938,1238420143,'Taurus'],
  [1238420143,1238603408,'Gemini'],
  [1238603408,1238787144,'Cancer'],
  [1238787144,1238972488,'Leo'],
  [1238972488,1239160925,'Virgo'],
  [1239160925,1239355377,'Libra'],
  [1239355377,1239559230,'Scorpio'],
  [1239559230,1239773242,'Sagittarius'],
  [1239773242,1239992342,'Capricorn'],
  [1239992342,1240206895,'Aquarius'],
  [1240206895,1240409324,'Pisces'],
  [1240409324,1240598771,'Aries'],
  [1240598771,1240779724,'Taurus'],
  [1240779724,1240958276,'Gemini'],
  [1240958276,1241139341,'Cancer'],
  [1241139341,1241325403,'Leo'],
  [1241325403,1241517076,'Virgo'],
  [1241517076,1241714873,'Libra'],
  [1241714873,1241920148,'Scorpio'],
  [1241920148,1242133743,'Sagittarius'],
  [1242133743,1242352878,'Capricorn'],
  [1242352878,1242569810,'Aquarius'],
  [1242569810,1242775804,'Pisces'],
  [1242775804,1242967197,'Aries'],
  [1242967197,1243146828,'Taurus'],
  [1243146828,1243321071,'Gemini'],
  [1243321071,1243496659,'Cancer'],
  [1243496659,1243678648,'Leo'],
  [1243678648,1243869406,'Virgo'],
  [1243869406,1244069018,'Libra'],
  [1244069018,1244276618,'Scorpio'],
  [1244276618,1244491170,'Sagittarius'],
  [1244491170,1244710346,'Capricorn'],
  [1244710346,1244928718,'Aquarius'],
  [1244928718,1245138695,'Pisces'],
  [1245138695,1245334819,'Aries'],
  [1245334819,1245517203,'Taurus'],
  [1245517203,1245690711,'Gemini'],
  [1245690711,1245862208,'Cancer'],
  [1245862208,1246038395,'Leo'],
  [1246038395,1246224264,'Virgo'],
  [1246224264,1246421913,'Libra'],
  [1246421913,1246630250,'Scorpio'],
  [1246630250,1246846044,'Sagittarius'],
  [1246846044,1247065398,'Capricorn'],
  [1247065398,1247283808,'Aquarius'],
  [1247283808,1247495974,'Pisces'],
  [1247495974,1247696989,'Aries'],
  [1247696989,1247884878,'Taurus'],
  [1247884878,1248061856,'Gemini'],
  [1248061856,1248233249,'Cancer'],
  [1248233249,1248405756,'Leo'],
  [1248405756,1248585935,'Virgo'],
  [1248585935,1248778545,'Libra'],
  [1248778545,1248984601,'Scorpio'],
  [1248984601,1249200500,'Sagittarius'],
  [1249200500,1249420067,'Capricorn'],
  [1249420067,1249637658,'Aquarius'],
  [1249637658,1249849377,'Pisces'],
  [1249849377,1250052572,'Aries'],
  [1250052572,1250245527,'Taurus'],
  [1250245527,1250428373,'Gemini'],
  [1250428373,1250603789,'Cancer'],
  [1250603789,1250776817,'Leo'],
  [1250776817,1250953909,'Virgo'],
  [1250953909,1251141379,'Libra'],
  [1251141379,1251342973,'Scorpio'],
  [1251342973,1251557056,'Sagittarius'],
  [1251557056,1251776561,'Capricorn'],
  [1251776561,1251993481,'Aquarius'],
  [1251993481,1252203258,'Pisces'],
  [1252203258,1252405051,'Aries'],
  [1252405051,1252599400,'Taurus'],
  [1252599400,1252786772,'Gemini'],
  [1252786772,1252967961,'Cancer'],
  [1252967961,1253145351,'Leo'],
  [1253145351,1253323574,'Virgo'],
  [1253323574,1253508721,'Libra'],
  [1253508721,1253706170,'Scorpio'],
  [1253706170,1253917118,'Sagittarius'],
  [1253917118,1254135987,'Capricorn'],
  [1254135987,1254353141,'Aquarius'],
  [1254353141,1254561630,'Pisces'],
  [1254561630,1254760385,'Aries'],
  [1254760385,1254951982,'Taurus'],
  [1254951982,1255139264,'Gemini'],
  [1255139264,1255323754,'Cancer'],
  [1255323754,1255506317,'Leo'],
  [1255506317,1255688964,'Virgo'],
  [1255688964,1255875759,'Libra'],
  [1255875759,1256071738,'Scorpio'],
  [1256071738,1256279944,'Sagittarius'],
  [1256279944,1256497653,'Capricorn'],
  [1256497653,1256715911,'Aquarius'],
  [1256715911,1256925386,'Pisces'],
  [1256925386,1257122669,'Aries'],
  [1257122669,1257310351,'Taurus'],
  [1257310351,1257493337,'Gemini'],
  [1257493337,1257675769,'Cancer'],
  [1257675769,1257859829,'Leo'],
  [1257859829,1258046534,'Virgo'],
  [1258046534,1258237438,'Libra'],
  [1258237438,1258435312,'Scorpio'],
  [1258435312,1258642829,'Sagittarius'],
  [1258642829,1258859437,'Capricorn'],
  [1258859437,1259078842,'Aquarius'],
  [1259078842,1259291433,'Pisces'],
  [1259291433,1259490845,'Aries'],
  [1259490845,1259677407,'Taurus'],
  [1259677407,1259856030,'Gemini'],
  [1259856030,1260032798,'Cancer'],
  [1260032798,1260212736,'Leo'],
  [1260212736,1260398829,'Virgo'],
  [1260398829,1260592282,'Libra'],
  [1260592282,1260793503,'Scorpio'],
  [1260793503,1261002703,'Sagittarius'],
  [1261002703,1261219114,'Capricorn'],
  [1261219114,1261438918,'Aquarius'],
  [1261438918,1261654769,'Pisces'],
  [1261654769,1261859168,'Aries'],
  [1261859168,1262049199,'Taurus'],
  [1262049199,1262227523,'Gemini'],
  [1262227523,1262400060,'Cancer'],
  [1262400060,1262573550,'Leo'],
  [1262573550,1262753891,'Virgo'],
  [1262753891,1262944811,'Libra'],
  [1262944811,1263147000,'Scorpio'],
  [1263147000,1263358424,'Sagittarius'],
  [1263358424,1263575807,'Capricorn'],
  [1263575807,1263795420,'Aquarius'],
  [1263795420,1264012572,'Pisces'],
  [1264012572,1264221566,'Aries'],
  [1264221566,1264417880,'Taurus'],
  [1264417880,1264600887,'Gemini'],
  [1264600887,1264774199,'Cancer'],
  [1264774199,1264944173,'Leo'],
  [1264944173,1265118108,'Virgo'],
  [1265118108,1265302530,'Libra'],
  [1265302530,1265501016,'Scorpio'],
  [1265501016,1265712213,'Sagittarius'],
  [1265712213,1265930626,'Capricorn'],
  [1265930626,1266150175,'Aquarius'],
  [1266150175,1266366607,'Pisces'],
  [1266366607,1266576901,'Aries'],
  [1266576901,1266778012,'Taurus'],
  [1266778012,1266967727,'Gemini'],
  [1266967727,1267146504,'Cancer'],
  [1267146504,1267318331,'Leo'],
  [1267318331,1267489865,'Virgo'],
  [1267489865,1267668669,'Libra'],
  [1267668669,1267860955,'Scorpio'],
  [1267860955,1268068393,'Sagittarius'],
  [1268068393,1268286141,'Capricorn'],
  [1268286141,1268505816,'Aquarius'],
  [1268505816,1268721109,'Pisces'],
  [1268721109,1268929755,'Aries'],
  [1268929755,1269131292,'Taurus'],
  [1269131292,1269324937,'Gemini'],
  [1269324937,1269509936,'Cancer'],
  [1269509936,1269687428,'Leo'],
  [1269687428,1269861665,'Virgo'],
  [1269861665,1270039256,'Libra'],
  [1270039256,1270227154,'Scorpio'],
  [1270227154,1270429608,'Sagittarius'],
  [1270429608,1270644651,'Capricorn'],
  [1270644651,1270864059,'Aquarius'],
  [1270864059,1271079051,'Pisces'],
  [1271079051,1271285680,'Aries'],
  [1271285680,1271484471,'Taurus'],
  [1271484471,1271677128,'Gemini'],
  [1271677128,1271864504,'Cancer'],
  [1271864504,1272047049,'Leo'],
  [1272047049,1272226592,'Virgo'],
  [1272226592,1272407317,'Libra'],
  [1272407317,1272594944,'Scorpio'],
  [1272594944,1272794382,'Sagittarius'],
  [1272794382,1273006292,'Capricorn'],
  [1273006292,1273224830,'Aquarius'],
  [1273224830,1273440541,'Pisces'],
  [1273440541,1273646876,'Aries'],
  [1273646876,1273843067,'Taurus'],
  [1273843067,1274031933,'Gemini'],
  [1274031933,1274216773,'Cancer'],
  [1274216773,1274399897,'Leo'],
  [1274399897,1274582981,'Virgo'],
  [1274582981,1274768229,'Libra'],
  [1274768229,1274958928,'Scorpio'],
  [1274958928,1275158633,'Sagittarius'],
  [1275158633,1275368861,'Capricorn'],
  [1275368861,1275586411,'Aquarius'],
  [1275586411,1275803380,'Pisces'],
  [1275803380,1276011642,'Aries'],
  [1276011642,1276207838,'Taurus'],
  [1276207838,1276393816,'Gemini'],
  [1276393816,1276574042,'Cancer'],
  [1276574042,1276753242,'Leo'],
  [1276753242,1276935183,'Virgo'],
  [1276935183,1277122419,'Libra'],
  [1277122419,1277316608,'Scorpio'],
  [1277316608,1277518871,'Sagittarius'],
  [1277518871,1277729511,'Capricorn'],
  [1277729511,1277946571,'Aquarius'],
  [1277946571,1278164641,'Pisces'],
  [1278164641,1278376140,'Aries'],
  [1278376140,1278575429,'Taurus'],
  [1278575429,1278761878,'Gemini'],
  [1278761878,1278939208,'Cancer'],
  [1278939208,1279113295,'Leo'],
  [1279113295,1279290246,'Virgo'],
  [1279290246,1279474908,'Libra'],
  [1279474908,1279669709,'Scorpio'],
  [1279669709,1279874326,'Sagittarius'],
  [1279874326,1280086677,'Capricorn'],
  [1280086677,1280303983,'Aquarius'],
  [1280303983,1280522489,'Pisces'],
  [1280522489,1280736779,'Aries'],
  [1280736779,1280940844,'Taurus'],
  [1280940844,1281131388,'Gemini'],
  [1281131388,1281309773,'Cancer'],
  [1281309773,1281481248,'Leo'],
  [1281481248,1281652959,'Virgo'],
  [1281652959,1281831977,'Libra'],
  [1281831977,1282023228,'Scorpio'],
  [1282023228,1282227427,'Sagittarius'],
  [1282227427,1282441041,'Capricorn'],
  [1282441041,1282659043,'Aquarius'],
  [1282659043,1282877345,'Pisces'],
  [1282877345,1283092517,'Aries'],
  [1283092517,1283300346,'Taurus'],
  [1283300346,1283496623,'Gemini'],
  [1283496623,1283679907,'Cancer'],
  [1283679907,1283853157,'Leo'],
  [1283853157,1284022844,'Virgo'],
  [1284022844,1284196859,'Libra'],
  [1284196859,1284382298,'Scorpio'],
  [1284382298,1284582590,'Sagittarius'],
  [1284582590,1284795274,'Capricorn'],
  [1284795274,1285013684,'Aquarius'],
  [1285013684,1285231622,'Pisces'],
  [1285231622,1285445797,'Aries'],
  [1285445797,1285654231,'Taurus'],
  [1285654231,1285854333,'Gemini'],
  [1285854333,1286043652,'Cancer'],
  [1286043652,1286222391,'Leo'],
  [1286222391,1286394690,'Virgo'],
  [1286394690,1286567509,'Libra'],
  [1286567509,1286748518,'Scorpio'],
  [1286748518,1286943413,'Sagittarius'],
  [1286943413,1287152624,'Capricorn'],
  [1287152624,1287370289,'Aquarius'],
  [1287370289,1287588171,'Pisces'],
  [1287588171,1287800969,'Aries'],
  [1287800969,1288007246,'Taurus'],
  [1288007246,1288206857,'Gemini'],
  [1288206857,1288399108,'Cancer'],
  [1288399108,1288583467,'Leo'],
  [1288583467,1288761520,'Virgo'],
  [1288761520,1288937733,'Libra'],
  [1288937733,1289118445,'Scorpio'],
  [1289118445,1289309788,'Sagittarius'],
  [1289309788,1289514708,'Capricorn'],
  [1289514708,1289730237,'Aquarius'],
  [1289730237,1289948313,'Pisces'],
  [1289948313,1290161058,'Aries'],
  [1290161058,1290365143,'Taurus'],
  [1290365143,1290561231,'Gemini'],
  [1290561231,1290751263,'Cancer'],
  [1290751263,1290936818,'Leo'],
  [1290936818,1291119310,'Virgo'],
  [1291119310,1291301009,'Libra'],
  [1291301009,1291485548,'Scorpio'],
  [1291485548,1291677341,'Sagittarius'],
  [1291677341,1291879826,'Capricorn'],
  [1291879826,1292092828,'Aquarius'],
  [1292092828,1292310871,'Pisces'],
  [1292310871,1292525328,'Aries'],
  [1292525328,1292729840,'Taurus'],
  [1292729840,1292923317,'Gemini'],
  [1292923317,1293108625,'Cancer'],
  [1293108625,1293290039,'Leo'],
  [1293290039,1293471470,'Virgo'],
  [1293471470,1293655766,'Libra'],
  [1293655766,1293844854,'Scorpio'],
  [1293844854,1294040313,'Sagittarius'],
  [1294040313,1294243657,'Capricorn'],
  [1294243657,1294455403,'Aquarius'],
  [1294455403,1294673012,'Pisces'],
  [1294673012,1294889811,'Aries'],
  [1294889811,1295097761,'Taurus'],
  [1295097761,1295292519,'Gemini'],
  [1295292519,1295475348,'Cancer'],
  [1295475348,1295651410,'Leo'],
  [1295651410,1295827137,'Virgo'],
  [1295827137,1296008137,'Libra'],
  [1296008137,1296197689,'Scorpio'],
  [1296197689,1296396229,'Sagittarius'],
  [1296396229,1296602473,'Capricorn'],
  [1296602473,1296815041,'Aquarius'],
  [1296815041,1297032329,'Pisces'],
  [1297032329,1297250542,'Aries'],
  [1297250542,1297462819,'Taurus'],
  [1297462819,1297662509,'Gemini'],
  [1297662509,1297847644,'Cancer'],
  [1297847644,1298021924,'Leo'],
  [1298021924,1298192439,'Virgo'],
  [1298192439,1298366924,'Libra'],
  [1298366924,1298551538,'Scorpio'],
  [1298551538,1298748695,'Sagittarius'],
  [1298748695,1298956452,'Capricorn'],
  [1298956452,1299170798,'Aquarius'],
  [1299170798,1299388426,'Pisces'],
  [1299388426,1299606713,'Aries'],
  [1299606713,1299821455,'Taurus'],
  [1299821455,1300026566,'Gemini'],
  [1300026566,1300217585,'Cancer'],
  [1300217585,1300395172,'Leo'],
  [1300395172,1300564977,'Virgo'],
  [1300564977,1300734997,'Libra'],
  [1300734997,1300913107,'Scorpio'],
  [1300913107,1301104639,'Sagittarius'],
  [1301104639,1301309976,'Capricorn'],
  [1301309976,1301524679,'Aquarius'],
  [1301524679,1301742943,'Pisces'],
  [1301742943,1301960746,'Aries'],
  [1301960746,1302175286,'Taurus'],
  [1302175286,1302382895,'Gemini'],
  [1302382895,1302579429,'Cancer'],
  [1302579429,1302763221,'Leo'],
  [1302763221,1302937118,'Virgo'],
  [1302937118,1303107531,'Libra'],
  [1303107531,1303282176,'Scorpio'],
  [1303282176,1303467864,'Sagittarius'],
  [1303467864,1303667928,'Capricorn'],
  [1303667928,1303880245,'Aquarius'],
  [1303880245,1304098394,'Pisces'],
  [1304098394,1304315893,'Aries'],
  [1304315893,1304528941,'Taurus'],
  [1304528941,1304735493,'Gemini'],
  [1304735493,1304933723,'Cancer'],
  [1304933723,1305122327,'Leo'],
  [1305122327,1305302181,'Virgo'],
  [1305302181,1305477088,'Libra'],
  [1305477088,1305652946,'Scorpio'],
  [1305652946,1305836141,'Sagittarius'],
  [1305836141,1306031488,'Capricorn'],
  [1306031488,1306239809,'Aquarius'],
  [1306239809,1306456577,'Pisces'],
  [1306456577,1306674099,'Aries'],
  [1306674099,1306886164,'Taurus'],
  [1306886164,1307090183,'Gemini'],
  [1307090183,1307286189,'Cancer'],
  [1307286189,1307475187,'Leo'],
  [1307475187,1307658632,'Virgo'],
  [1307658632,1307838795,'Libra'],
  [1307838795,1308019100,'Scorpio'],
  [1308019100,1308203922,'Sagittarius'],
  [1308203922,1308397625,'Capricorn'],
  [1308397625,1308602698,'Aquarius'],
  [1308602698,1308817424,'Pisces'],
  [1308817424,1309035159,'Aries'],
  [1309035159,1309247752,'Taurus'],
  [1309247752,1309450369,'Gemini'],
  [1309450369,1309642953,'Cancer'],
  [1309642953,1309828509,'Leo'],
  [1309828509,1310010819,'Virgo'],
  [1310010819,1310193072,'Libra'],
  [1310193072,1310377601,'Scorpio'],
  [1310377601,1310566410,'Sagittarius'],
  [1310566410,1310761790,'Capricorn'],
  [1310761790,1310965955,'Aquarius'],
  [1310965955,1311179114,'Pisces'],
  [1311179114,1311397079,'Aries'],
  [1311397079,1311611653,'Taurus'],
  [1311611653,1311815483,'Gemini'],
  [1311815483,1312006545,'Cancer'],
  [1312006545,1312188087,'Leo'],
  [1312188087,1312365857,'Virgo'],
  [1312365857,1312545419,'Libra'],
  [1312545419,1312730445,'Scorpio'],
  [1312730445,1312922248,'Sagittarius'],
  [1312922248,1313120843,'Capricorn'],
  [1313120843,1313326440,'Aquarius'],
  [1313326440,1313539291,'Pisces'],
  [1313539291,1313757378,'Aries'],
  [1313757378,1313974375,'Taurus'],
  [1313974375,1314181841,'Gemini'],
  [1314181841,1314374926,'Cancer'],
  [1314374926,1314555193,'Leo'],
  [1314555193,1314728719,'Virgo'],
  [1314728719,1314902871,'Libra'],
  [1314902871,1315083803,'Scorpio'],
  [1315083803,1315274606,'Sagittarius'],
  [1315274606,1315474926,'Capricorn'],
  [1315474926,1315682784,'Aquarius'],
  [1315682784,1315896561,'Pisces'],
  [1315896561,1316114686,'Aries'],
  [1316114686,1316333170,'Taurus'],
  [1316333170,1316544802,'Gemini'],
  [1316544802,1316742915,'Cancer'],
  [1316742915,1316926158,'Leo'],
  [1316926158,1317099044,'Virgo'],
  [1317099044,1317269102,'Libra'],
  [1317269102,1317444081,'Scorpio'],
  [1317444081,1317629735,'Sagittarius'],
  [1317629735,1317827884,'Capricorn'],
  [1317827884,1318036392,'Aquarius'],
  [1318036392,1318251426,'Pisces'],
  [1318251426,1318469693,'Aries'],
  [1318469693,1318688095,'Taurus'],
  [1318688095,1318901869,'Gemini'],
  [1318901869,1319105143,'Cancer'],
  [1319105143,1319294436,'Leo'],
  [1319294436,1319471348,'Virgo'],
  [1319471348,1319641709,'Libra'],
  [1319641709,1319813101,'Scorpio'],
  [1319813101,1319992720,'Sagittarius'],
  [1319992720,1320185266,'Capricorn'],
  [1320185266,1320391068,'Aquarius'],
  [1320391068,1320606127,'Pisces'],
  [1320606127,1320824713,'Aries'],
  [1320824713,1321042197,'Taurus'],
  [1321042197,1321255127,'Gemini'],
  [1321255127,1321460222,'Cancer'],
  [1321460222,1321654718,'Leo'],
  [1321654718,1321838171,'Virgo'],
  [1321838171,1322013495,'Libra'],
  [1322013495,1322186237,'Scorpio'],
  [1322186237,1322363069,'Sagittarius'],
  [1322363069,1322550098,'Capricorn'],
  [1322550098,1322750718,'Aquarius'],
  [1322750718,1322963468,'Pisces'],
  [1322963468,1323182070,'Aries'],
  [1323182070,1323399142,'Taurus'],
  [1323399142,1323609952,'Gemini'],
  [1323609952,1323812882,'Cancer'],
  [1323812882,1324007910,'Leo'],
  [1324007910,1324195571,'Virgo'],
  [1324195571,1324377166,'Libra'],
  [1324377166,1324555361,'Scorpio'],
  [1324555361,1324734420,'Sagittarius'],
  [1324734420,1324919660,'Capricorn'],
  [1324919660,1325115916,'Aquarius'],
  [1325115916,1325324891,'Pisces'],
  [1325324891,1325542554,'Aries'],
  [1325542554,1325760256,'Taurus'],
  [1325760256,1325970307,'Gemini'],
  [1325970307,1326170099,'Cancer'],
  [1326170099,1326361448,'Leo'],
  [1326361448,1326547692,'Virgo'],
  [1326547692,1326731608,'Libra'],
  [1326731608,1326914928,'Scorpio'],
  [1326914928,1327099228,'Sagittarius'],
  [1327099228,1327287185,'Capricorn'],
  [1327287185,1327482668,'Aquarius'],
  [1327482668,1327688873,'Pisces'],
  [1327688873,1327904903,'Aries'],
  [1327904903,1328123668,'Taurus'],
  [1328123668,1328335427,'Gemini'],
  [1328335427,1328534620,'Cancer'],
  [1328534620,1328722338,'Leo'],
  [1328722338,1328903651,'Virgo'],
  [1328903651,1329084081,'Libra'],
  [1329084081,1329267387,'Scorpio'],
  [1329267387,1329454998,'Sagittarius'],
  [1329454998,1329647300,'Capricorn'],
  [1329647300,1329845476,'Aquarius'],
  [1329845476,1330051666,'Pisces'],
  [1330051666,1330266569,'Aries'],
  [1330266569,1330486012,'Taurus'],
  [1330486012,1330700901,'Gemini'],
  [1330700901,1330903054,'Cancer'],
  [1330903054,1331090807,'Leo'],
  [1331090807,1331268624,'Virgo'],
  [1331268624,1331443440,'Libra'],
  [1331443440,1331621610,'Scorpio'],
  [1331621610,1331807037,'Sagittarius'],
  [1331807037,1332000682,'Capricorn'],
  [1332000682,1332201905,'Aquarius'],
  [1332201905,1332410238,'Pisces'],
  [1332410238,1332625405,'Aries'],
  [1332625405,1332844993,'Taurus'],
  [1332844993,1333062429,'Gemini'],
  [1333062429,1333269333,'Cancer'],
  [1333269333,1333461183,'Leo'],
  [1333461183,1333639936,'Virgo'],
  [1333639936,1333811856,'Libra'],
  [1333811856,1333984334,'Scorpio'],
  [1333984334,1334163700,'Sagittarius'],
  [1334163700,1334353661,'Capricorn'],
  [1334353661,1334554661,'Aquarius'],
  [1334554661,1334764730,'Pisces'],
  [1334764730,1334981106,'Aries'],
  [1334981106,1335200712,'Taurus'],
  [1335200712,1335418922,'Gemini'],
  [1335418922,1335629427,'Cancer'],
  [1335629427,1335826948,'Leo'],
  [1335826948,1336010630,'Virgo'],
  [1336010630,1336184379,'Libra'],
  [1336184379,1336354743,'Scorpio'],
  [1336354743,1336528802,'Sagittarius'],
  [1336528802,1336712558,'Capricorn'],
  [1336712558,1336909301,'Aquarius'],
  [1336909301,1337118336,'Pisces'],
  [1337118336,1337335402,'Aries'],
  [1337335402,1337555122,'Taurus'],
  [1337555122,1337772672,'Gemini'],
  [1337772672,1337983881,'Cancer'],
  [1337983881,1338185179,'Leo'],
  [1338185179,1338374751,'Virgo'],
  [1338374751,1338553866,'Libra'],
  [1338553866,1338726742,'Scorpio'],
  [1338726742,1338899453,'Sagittarius'],
  [1338899453,1339078600,'Capricorn'],
  [1339078600,1339269695,'Aquarius'],
  [1339269695,1339474866,'Pisces'],
  [1339474866,1339690903,'Aries'],
  [1339690903,1339910636,'Taurus'],
  [1339910636,1340127223,'Gemini'],
  [1340127223,1340336823,'Cancer'],
  [1340336823,1340538152,'Leo'],
  [1340538152,1340730918,'Virgo'],
  [1340730918,1340915543,'Libra'],
  [1340915543,1341093815,'Scorpio'],
  [1341093815,1341269454,'Sagittarius'],
  [1341269454,1341447941,'Capricorn'],
  [1341447941,1341635340,'Aquarius'],
  [1341635340,1341836016,'Pisces'],
  [1341836016,1342049426,'Aries'],
  [1342049426,1342268787,'Taurus'],
  [1342268787,1342485073,'Gemini'],
  [1342485073,1342692782,'Cancer'],
  [1342692782,1342891440,'Leo'],
  [1342891440,1343083098,'Virgo'],
  [1343083098,1343269752,'Libra'],
  [1343269752,1343452668,'Scorpio'],
  [1343452668,1343633365,'Sagittarius'],
  [1343633365,1343814953,'Capricorn'],
  [1343814953,1344002280,'Aquarius'],
  [1344002280,1344200310,'Pisces'],
  [1344200310,1344410873,'Aries'],
  [1344410873,1344629450,'Taurus'],
  [1344629450,1344846453,'Gemini'],
  [1344846453,1345053881,'Cancer'],
  [1345053881,1345249988,'Leo'],
  [1345249988,1345437918,'Virgo'],
  [1345437918,1345622025,'Libra'],
  [1345622025,1345805406,'Scorpio'],
  [1345805406,1345989505,'Sagittarius'],
  [1345989505,1346175503,'Capricorn'],
  [1346175503,1346365859,'Aquarius'],
  [1346365859,1346564235,'Pisces'],
  [1346564235,1346773267,'Aries'],
  [1346773267,1346990977,'Taurus'],
  [1346990977,1347209348,'Gemini'],
  [1347209348,1347418833,'Cancer'],
  [1347418833,1347615030,'Leo'],
  [1347615030,1347800103,'Virgo'],
  [1347800103,1347979541,'Libra'],
  [1347979541,1348158835,'Scorpio'],
  [1348158835,1348341631,'Sagittarius'],
  [1348341631,1348529546,'Capricorn'],
  [1348529546,1348723410,'Aquarius'],
  [1348723410,1348924439,'Pisces'],
  [1348924439,1349133965,'Aries'],
  [1349133965,1349351194,'Taurus'],
  [1349351194,1349570713,'Gemini'],
  [1349570713,1349783699,'Cancer'],
  [1349783699,1349983407,'Leo'],
  [1349983407,1350169305,'Virgo'],
  [1350169305,1350345978,'Libra'],
  [1350345978,1350519937,'Scorpio'],
  [1350519937,1350697253,'Sagittarius'],
  [1350697253,1350882137,'Capricorn'],
  [1350882137,1351076395,'Aquarius'],
  [1351076395,1351279863,'Pisces'],
  [1351279863,1351491314,'Aries'],
  [1351491314,1351708813,'Taurus'],
  [1351708813,1351928588,'Gemini'],
  [1351928588,1352144342,'Cancer'],
  [1352144342,1352349292,'Leo'],
  [1352349292,1352540101,'Virgo'],
  [1352540101,1352718615,'Libra'],
  [1352718615,1352890323,'Scorpio'],
  [1352890323,1353062120,'Sagittarius'],
  [1353062120,1353240602,'Capricorn'],
  [1353240602,1353430492,'Aquarius'],
  [1353430492,1353633093,'Pisces'],
  [1353633093,1353845896,'Aries'],
  [1353845896,1354064296,'Taurus'],
  [1354064296,1354283689,'Gemini'],
  [1354283689,1354499818,'Cancer'],
  [1354499818,1354708290,'Leo'],
  [1354708290,1354905321,'Virgo'],
  [1354905321,1355089843,'Libra'],
  [1355089843,1355264500,'Scorpio'],
  [1355264500,1355434952,'Sagittarius'],
  [1355434952,1355608362,'Capricorn'],
  [1355608362,1355791696,'Aquarius'],
  [1355791696,1355989393,'Pisces'],
  [1355989393,1356200702,'Aries'],
  [1356200702,1356419601,'Taurus'],
  [1356419601,1356638784,'Gemini'],
  [1356638784,1356853512,'Cancer'],
  [1356853512,1357061689,'Leo'],
  [1357061689,1357261837,'Virgo'],
  [1357261837,1357452535,'Libra'],
  [1357452535,1357633697,'Scorpio'],
  [1357633697,1357808059,'Sagittarius'],
  [1357808059,1357981276,'Capricorn'],
  [1357981276,1358160554,'Aquarius'],
  [1358160554,1358352418,'Pisces'],
  [1358352418,1358559371,'Aries'],
  [1358559371,1358777058,'Taurus'],
  [1358777058,1358996399,'Gemini'],
  [1358996399,1359210010,'Cancer'],
  [1359210010,1359415629,'Leo'],
  [1359415629,1359614141,'Virgo'],
  [1359614141,1359806489,'Libra'],
  [1359806489,1359992721,'Scorpio'],
  [1359992721,1360173301,'Sagittarius'],
  [1360173301,1360350993,'Capricorn'],
  [1360350993,1360531174,'Aquarius'],
  [1360531174,1360720282,'Pisces'],
  [1360720282,1360922866,'Aries'],
  [1360922866,1361137791,'Taurus'],
  [1361137791,1361357088,'Gemini'],
  [1361357088,1361571122,'Cancer'],
  [1361571122,1361775149,'Leo'],
  [1361775149,1361970103,'Virgo'],
  [1361970103,1362159205,'Libra'],
  [1362159205,1362345034,'Scorpio'],
  [1362345034,1362528815,'Sagittarius'],
  [1362528815,1362711693,'Capricorn'],
  [1362711693,1362896323,'Aquarius'],
  [1362896323,1363087029,'Pisces'],
  [1363087029,1363288095,'Aries'],
  [1363288095,1363500539,'Taurus'],
  [1363500539,1363719310,'Gemini'],
  [1363719310,1363934986,'Cancer'],
  [1363934986,1364140149,'Leo'],
  [1364140149,1364333504,'Virgo'],
  [1364333504,1364518415,'Libra'],
  [1364518415,1364699591,'Scorpio'],
  [1364699591,1364880919,'Sagittarius'],
  [1364880919,1365064884,'Capricorn'],
  [1365064884,1365253209,'Aquarius'],
  [1365253209,1365447735,'Pisces'],
  [1365447735,1365650503,'Aries'],
  [1365650503,1365862361,'Taurus'],
  [1365862361,1366080563,'Gemini'],
  [1366080563,1366298010,'Cancer'],
  [1366298010,1366506509,'Leo'],
  [1366506509,1366701885,'Virgo'],
  [1366701885,1366885531,'Libra'],
  [1366885531,1367062313,'Scorpio'],
  [1367062313,1367238074,'Sagittarius'],
  [1367238074,1367417973,'Capricorn'],
  [1367417973,1367605522,'Aquarius'],
  [1367605522,1367802195,'Pisces'],
  [1367802195,1368007741,'Aries'],
  [1368007741,1368220863,'Taurus'],
  [1368220863,1368439008,'Gemini'],
  [1368439008,1368657459,'Cancer'],
  [1368657459,1368869575,'Leo'],
  [1368869575,1369069623,'Virgo'],
  [1369069623,1369256112,'Libra'],
  [1369256112,1369432147,'Scorpio'],
  [1369432147,1369603711,'Sagittarius'],
  [1369603711,1369777691,'Capricorn'],
  [1369777691,1369960197,'Aquarius'],
  [1369960197,1370154805,'Pisces'],
  [1370154805,1370361211,'Aries'],
  [1370361211,1370575918,'Taurus'],
  [1370575918,1370794552,'Gemini'],
  [1370794552,1371013062,'Cancer'],
  [1371013062,1371227151,'Leo'],
  [1371227151,1371431919,'Virgo'],
  [1371431919,1371623916,'Libra'],
  [1371623916,1371803455,'Scorpio'],
  [1371803455,1371974902,'Sagittarius'],
  [1371974902,1372145196,'Capricorn'],
  [1372145196,1372321917,'Aquarius'],
  [1372321917,1372511184,'Pisces'],
  [1372511184,1372714964,'Aries'],
  [1372714964,1372929695,'Taurus'],
  [1372929695,1373148817,'Gemini'],
  [1373148817,1373366882,'Cancer'],
  [1373366882,1373580708,'Leo'],
  [1373580708,1373787640,'Virgo'],
  [1373787640,1373984662,'Libra'],
  [1373984662,1374170061,'Scorpio'],
  [1374170061,1374345527,'Sagittarius'],
  [1374345527,1374516410,'Capricorn'],
  [1374516410,1374690143,'Aquarius'],
  [1374690143,1374874141,'Pisces'],
  [1374874141,1375072971,'Aries'],
  [1375072971,1375285304,'Taurus'],
  [1375285304,1375504165,'Gemini'],
  [1375504165,1375721852,'Cancer'],
  [1375721852,1375934210,'Leo'],
  [1375934210,1376140081,'Virgo'],
  [1376140081,1376338661,'Libra'],
  [1376338661,1376528663,'Scorpio'],
  [1376528663,1376709915,'Sagittarius'],
  [1376709915,1376885196,'Capricorn'],
  [1376885196,1377060207,'Aquarius'],
  [1377060207,1377241978,'Pisces'],
  [1377241978,1377436394,'Aries'],
  [1377436394,1377644876,'Taurus'],
  [1377644876,1377862351,'Gemini'],
  [1377862351,1378080036,'Cancer'],
  [1378080036,1378291411,'Leo'],
  [1378291411,1378494753,'Virgo'],
  [1378494753,1378691045,'Libra'],
  [1378691045,1378881334,'Scorpio'],
  [1378881334,1379066140,'Sagittarius'],
  [1379066140,1379246719,'Capricorn'],
  [1379246719,1379426285,'Aquarius'],
  [1379426285,1379609861,'Pisces'],
  [1379609861,1379802787,'Aries'],
  [1379802787,1380008060,'Taurus'],
  [1380008060,1380223466,'Gemini'],
  [1380223466,1380441427,'Cancer'],
  [1380441427,1380653505,'Leo'],
  [1380653505,1380855569,'Virgo'],
  [1380855569,1381048355,'Libra'],
  [1381048355,1381234886,'Scorpio'],
  [1381234886,1381418232,'Sagittarius'],
  [1381418232,1381600793,'Capricorn'],
  [1381600793,1381784737,'Aquarius'],
  [1381784737,1381972653,'Pisces'],
  [1381972653,1382167594,'Aries'],
  [1382167594,1382372039,'Taurus'],
  [1382372039,1382585746,'Gemini'],
  [1382585746,1382803895,'Cancer'],
  [1382803895,1383018280,'Leo'],
  [1383018280,1383222095,'Virgo'],
  [1383222095,1383413698,'Libra'],
  [1383413698,1383596047,'Scorpio'],
  [1383596047,1383774232,'Sagittarius'],
  [1383774232,1383953384,'Capricorn'],
  [1383953384,1384137384,'Aquarius'],
  [1384137384,1384328346,'Pisces'],
  [1384328346,1384526942,'Aries'],
  [1384526942,1384733198,'Taurus'],
  [1384733198,1384946576,'Gemini'],
  [1384946576,1385164591,'Cancer'],
  [1385164591,1385381445,'Leo'],
  [1385381445,1385589572,'Virgo'],
  [1385589572,1385784171,'Libra'],
  [1385784171,1385965886,'Scorpio'],
  [1385965886,1386139774,'Sagittarius'],
  [1386139774,1386312809,'Capricorn'],
  [1386312809,1386491654,'Aquarius'],
  [1386491654,1386680725,'Pisces'],
  [1386680725,1386880803,'Aries'],
  [1386880803,1387089627,'Taurus'],
  [1387089627,1387304206,'Gemini'],
  [1387304206,1387522058,'Cancer'],
  [1387522058,1387739938,'Leo'],
  [1387739938,1387952219,'Virgo'],
  [1387952219,1388152678,'Libra'],
  [1388152678,1388338626,'Scorpio'],
  [1388338626,1388512868,'Sagittarius'],
  [1388512868,1388682188,'Capricorn'],
  [1388682188,1388854693,'Aquarius'],
  [1388854693,1389037512,'Pisces'],
  [1389037512,1389234223,'Aries'],
  [1389234223,1389443142,'Taurus'],
  [1389443142,1389659090,'Gemini'],
  [1389659090,1389877229,'Cancer'],
  [1389877229,1390094602,'Leo'],
  [1390094602,1390308202,'Virgo'],
  [1390308202,1390513412,'Libra'],
  [1390513412,1390705974,'Scorpio'],
  [1390705974,1390885456,'Sagittarius'],
  [1390885456,1391056374,'Capricorn'],
  [1391056374,1391226274,'Aquarius'],
  [1391226274,1391403274,'Pisces'],
  [1391403274,1391593592,'Aries'],
  [1391593592,1391798628,'Taurus'],
  [1391798628,1392013956,'Gemini'],
  [1392013956,1392232513,'Cancer'],
  [1392232513,1392449131,'Leo'],
  [1392449131,1392661354,'Virgo'],
  [1392661354,1392867171,'Libra'],
  [1392867171,1393063901,'Scorpio'],
  [1393063901,1393249828,'Sagittarius'],
  [1393249828,1393426527,'Capricorn'],
  [1393426527,1393599149,'Aquarius'],
  [1393599149,1393774787,'Pisces'],
  [1393774787,1393960333,'Aries'],
  [1393960333,1394159845,'Taurus'],
  [1394159845,1394371974,'Gemini'],
  [1394371974,1394590112,'Cancer'],
  [1394590112,1394806646,'Leo'],
  [1394806646,1395017148,'Virgo'],
  [1395017148,1395220402,'Libra'],
  [1395220402,1395416337,'Scorpio'],
  [1395416337,1395604976,'Sagittarius'],
  [1395604976,1395787129,'Capricorn'],
  [1395787129,1395965427,'Aquarius'],
  [1395965427,1396144421,'Pisces'],
  [1396144421,1396329615,'Aries'],
  [1396329615,1396525677,'Taurus'],
  [1396525677,1396733975,'Gemini'],
  [1396733975,1396950608,'Cancer'],
  [1396950608,1397167651,'Leo'],
  [1397167651,1397377998,'Virgo'],
  [1397377998,1397578806,'Libra'],
  [1397578806,1397771026,'Scorpio'],
  [1397771026,1397957269,'Sagittarius'],
  [1397957269,1398140273,'Capricorn'],
  [1398140273,1398322502,'Aquarius'],
  [1398322502,1398506442,'Pisces'],
  [1398506442,1398695000,'Aries'],
  [1398695000,1398891335,'Taurus'],
  [1398891335,1399097574,'Gemini'],
  [1399097574,1399312532,'Cancer'],
  [1399312532,1399530242,'Leo'],
  [1399530242,1399742336,'Virgo'],
  [1399742336,1399943217,'Libra'],
  [1399943217,1400132615,'Scorpio'],
  [1400132615,1400314301,'Sagittarius'],
  [1400314301,1400493472,'Capricorn'],
  [1400493472,1400674702,'Aquarius'],
  [1400674702,1400860877,'Pisces'],
  [1400860877,1401053248,'Aries'],
  [1401053248,1401252441,'Taurus'],
  [1401252441,1401459202,'Gemini'],
  [1401459202,1401673386,'Cancer'],
  [1401673386,1401891601,'Leo'],
  [1401891601,1402106453,'Virgo'],
  [1402106453,1402310281,'Libra'],
  [1402310281,1402500182,'Scorpio'],
  [1402500182,1402679065,'Sagittarius'],
  [1402679065,1402853241,'Capricorn'],
  [1402853241,1403029535,'Aquarius'],
  [1403029535,1403213139,'Pisces'],
  [1403213139,1403406180,'Aries'],
  [1403406180,1403607925,'Taurus'],
  [1403607925,1403816730,'Gemini'],
  [1403816730,1404031363,'Cancer'],
  [1404031363,1404249815,'Leo'],
  [1404249815,1404466976,'Virgo'],
  [1404466976,1404675206,'Libra'],
  [1404675206,1404869068,'Scorpio'],
  [1404869068,1405049060,'Sagittarius'],
  [1405049060,1405220804,'Capricorn'],
  [1405220804,1405392025,'Aquarius'],
  [1405392025,1405569991,'Pisces'],
  [1405569991,1405759343,'Aries'],
  [1405759343,1405960548,'Taurus'],
  [1405960548,1406170756,'Gemini'],
  [1406170756,1406386477,'Cancer'],
  [1406386477,1406605006,'Leo'],
  [1406605006,1406822947,'Virgo'],
  [1406822947,1407034606,'Libra'],
  [1407034606,1407233924,'Scorpio'],
  [1407233924,1407418707,'Sagittarius'],
  [1407418707,1407592315,'Capricorn'],
  [1407592315,1407761714,'Aquarius'],
  [1407761714,1407934806,'Pisces'],
  [1407934806,1408118261,'Aries'],
  [1408118261,1408315262,'Taurus'],
  [1408315262,1408524284,'Gemini'],
  [1408524284,1408740544,'Cancer'],
  [1408740544,1408959144,'Leo'],
  [1408959144,1409176445,'Virgo'],
  [1409176445,1409388767,'Libra'],
  [1409388767,1409591801,'Scorpio'],
  [1409591801,1409782485,'Sagittarius'],
  [1409782485,1409961526,'Capricorn'],
  [1409961526,1410133601,'Aquarius'],
  [1410133601,1410305587,'Pisces'],
  [1410305587,1410484600,'Aries'],
  [1410484600,1410675972,'Taurus'],
  [1410675972,1410881042,'Gemini'],
  [1410881042,1411096192,'Cancer'],
  [1411096192,1411314823,'Leo'],
  [1411314823,1411531160,'Virgo'],
  [1411531160,1411741753,'Libra'],
  [1411741753,1411944614,'Scorpio'],
  [1411944614,1412138440,'Sagittarius'],
  [1412138440,1412323193,'Capricorn'],
  [1412323193,1412501049,'Aquarius'],
  [1412501049,1412676407,'Pisces'],
  [1412676407,1412855031,'Aries'],
  [1412855031,1413042661,'Taurus'],
  [1413042661,1413243007,'Gemini'],
  [1413243007,1413455343,'Cancer'],
  [1413455343,1413673668,'Leo'],
  [1413673668,1413889898,'Virgo'],
  [1413889898,1414098583,'Libra'],
  [1414098583,1414298398,'Scorpio'],
  [1414298398,1414490603,'Sagittarius'],
  [1414490603,1414677112,'Capricorn'],
  [1414677112,1414859793,'Aquarius'],
  [1414859793,1415040795,'Pisces'],
  [1415040795,1415223181,'Aries'],
  [1415223181,1415411076,'Taurus'],
  [1415411076,1415608675,'Gemini'],
  [1415608675,1415817853,'Cancer'],
  [1415817853,1416035292,'Leo'],
  [1416035292,1416252594,'Virgo'],
  [1416252594,1416461453,'Libra'],
  [1416461453,1416658753,'Scorpio'],
  [1416658753,1416846682,'Sagittarius'],
  [1416846682,1417029772,'Capricorn'],
  [1417029772,1417212183,'Aquarius'],
  [1417212183,1417396426,'Pisces'],
  [1417396426,1417583690,'Aries'],
  [1417583690,1417775295,'Taurus'],
  [1417775295,1417973655,'Gemini'],
  [1417973655,1418181244,'Cancer'],
  [1418181244,1418397526,'Leo'],
  [1418397526,1418616283,'Virgo'],
  [1418616283,1418827903,'Libra'],
  [1418827903,1419026106,'Scorpio'],
  [1419026106,1419211504,'Sagittarius'],
  [1419211504,1419389530,'Capricorn'],
  [1419389530,1419566808,'Aquarius'],
  [1419566808,1419748509,'Pisces'],
  [1419748509,1419936959,'Aries'],
  [1419936959,1420132120,'Taurus'],
  [1420132120,1420333654,'Gemini'],
  [1420333654,1420542162,'Cancer'],
  [1420542162,1420757867,'Leo'],
  [1420757867,1420977398,'Virgo'],
  [1420977398,1421192642,'Libra'],
  [1421192642,1421395257,'Scorpio'],
  [1421395257,1421582647,'Sagittarius'],
  [1421582647,1421758774,'Capricorn'],
  [1421758774,1421930870,'Aquarius'],
  [1421930870,1422106272,'Pisces'],
  [1422106272,1422290235,'Aries'],
  [1422290235,1422484559,'Taurus'],
  [1422484559,1422688111,'Gemini'],
  [1422688111,1422898854,'Cancer'],
  [1422898854,1423115151,'Leo'],
  [1423115151,1423334618,'Virgo'],
  [1423334618,1423551917,'Libra'],
  [1423551917,1423759599,'Scorpio'],
  [1423759599,1423952668,'Sagittarius'],
  [1423952668,1424131992,'Capricorn'],
  [1424131992,1424303250,'Aquarius'],
  [1424303250,1424473979,'Pisces'],
  [1424473979,1424651289,'Aries'],
  [1424651289,1424840030,'Taurus'],
  [1424840030,1425041369,'Gemini'],
  [1425041369,1425252850,'Cancer'],
  [1425252850,1425470253,'Leo'],
  [1425470253,1425689524,'Virgo'],
  [1425689524,1425906584,'Libra'],
  [1425906584,1426116623,'Scorpio'],
  [1426116623,1426315193,'Sagittarius'],
  [1426315193,1426500834,'Capricorn'],
  [1426500834,1426676274,'Aquarius'],
  [1426676274,1426847281,'Pisces'],
  [1426847281,1427020810,'Aries'],
  [1427020810,1427203354,'Taurus'],
  [1427203354,1427399117,'Gemini'],
  [1427399117,1427608071,'Cancer'],
  [1427608071,1427825528,'Leo'],
  [1427825528,1428044849,'Virgo'],
  [1428044849,1428260657,'Libra'],
  [1428260657,1428469689,'Scorpio'],
  [1428469689,1428670004,'Sagittarius'],
  [1428670004,1428860633,'Capricorn'],
  [1428860633,1429042310,'Aquarius'],
  [1429042310,1429217998,'Pisces'],
  [1429217998,1429392681,'Aries'],
  [1429392681,1429572480,'Taurus'],
  [1429572480,1429763130,'Gemini'],
  [1429763130,1429967560,'Cancer'],
  [1429967560,1430183240,'Leo'],
  [1430183240,1430402570,'Virgo'],
  [1430402570,1430617635,'Libra'],
  [1430617635,1430824355,'Scorpio'],
  [1430824355,1431022580,'Sagittarius'],
  [1431022580,1431213722,'Capricorn'],
  [1431213722,1431399193,'Aquarius'],
  [1431399193,1431580413,'Pisces'],
  [1431580413,1431759741,'Aries'],
  [1431759741,1431941229,'Taurus'],
  [1431941229,1432130140,'Gemini'],
  [1432130140,1432330927,'Cancer'],
  [1432330927,1432543901,'Leo'],
  [1432543901,1432762924,'Virgo'],
  [1432762924,1432978429,'Libra'],
  [1432978429,1433183954,'Scorpio'],
  [1433183954,1433379021,'Sagittarius'],
  [1433379021,1433566913,'Capricorn'],
  [1433566913,1433751370,'Aquarius'],
  [1433751370,1433934826,'Pisces'],
  [1433934826,1434118568,'Aries'],
  [1434118568,1434304253,'Taurus'],
  [1434304253,1434495052,'Gemini'],
  [1434495052,1434694950,'Cancer'],
  [1434694950,1434905928,'Leo'],
  [1434905928,1435124446,'Virgo'],
  [1435124446,1435341407,'Libra'],
  [1435341407,1435548076,'Scorpio'],
  [1435548076,1435741864,'Sagittarius'],
  [1435741864,1435926050,'Capricorn'],
  [1435926050,1436106177,'Aquarius'],
  [1436106177,1436287050,'Pisces'],
  [1436287050,1436471367,'Aries'],
  [1436471367,1436660167,'Taurus'],
  [1436660167,1436854445,'Gemini'],
  [1436854445,1437056099,'Cancer'],
  [1437056099,1437266805,'Leo'],
  [1437266805,1437484963,'Virgo'],
  [1437484963,1437703622,'Libra'],
  [1437703622,1437913473,'Scorpio'],
  [1437913473,1438109257,'Sagittarius'],
  [1438109257,1438292415,'Capricorn'],
  [1438292415,1438468580,'Aquarius'],
  [1438468580,1438644237,'Pisces'],
  [1438644237,1438824563,'Aries'],
  [1438824563,1439012389,'Taurus'],
  [1439012389,1439208496,'Gemini'],
  [1439208496,1439412734,'Cancer'],
  [1439412734,1439624728,'Leo'],
  [1439624728,1439842948,'Virgo'],
  [1439842948,1440062640,'Libra'],
  [1440062640,1440276062,'Scorpio'],
  [1440276062,1440476518,'Sagittarius'],
  [1440476518,1440662615,'Capricorn'],
  [1440662615,1440838268,'Aquarius'],
  [1440838268,1441009980,'Pisces'],
  [1441009980,1441184501,'Aries'],
  [1441184501,1441367263,'Taurus'],
  [1441367263,1441561179,'Gemini'],
  [1441561179,1441766153,'Cancer'],
  [1441766153,1441979728,'Leo'],
  [1441979728,1442198455,'Virgo'],
  [1442198455,1442418159,'Libra'],
  [1442418159,1442633485,'Scorpio'],
  [1442633485,1442838763,'Sagittarius'],
  [1442838763,1443030668,'Capricorn'],
  [1443030668,1443210218,'Aquarius'],
  [1443210218,1443382129,'Pisces'],
  [1443382129,1443553017,'Aries'],
  [1443553017,1443729803,'Taurus'],
  [1443729803,1443918106,'Gemini'],
  [1443918106,1444120241,'Cancer'],
  [1444120241,1444333828,'Leo'],
  [1444333828,1444553125,'Virgo'],
  [1444553125,1444772298,'Libra'],
  [1444772298,1444987085,'Scorpio'],
  [1444987085,1445194332,'Sagittarius'],
  [1445194332,1445391455,'Capricorn'],
  [1445391455,1445577457,'Aquarius'],
  [1445577457,1445754103,'Pisces'],
  [1445754103,1445926040,'Aries'],
  [1445926040,1446099853,'Taurus'],
  [1446099853,1446282545,'Gemini'],
  [1446282545,1446479251,'Cancer'],
  [1446479251,1446690146,'Leo'],
  [1446690146,1446909245,'Virgo'],
  [1446909245,1447128148,'Libra'],
  [1447128148,1447341237,'Scorpio'],
  [1447341237,1447546867,'Sagittarius'],
  [1447546867,1447745062,'Capricorn'],
  [1447745062,1447935680,'Aquarius'],
  [1447935680,1448118740,'Pisces'],
  [1448118740,1448295958,'Aries'],
  [1448295958,1448471714,'Taurus'],
  [1448471714,1448652397,'Gemini'],
  [1448652397,1448844425,'Cancer'],
  [1448844425,1449050947,'Leo'],
  [1449050947,1449268412,'Virgo'],
  [1449268412,1449487538,'Libra'],
  [1449487538,1449699900,'Scorpio'],
  [1449699900,1449902786,'Sagittarius'],
  [1449902786,1450097922,'Capricorn'],
  [1450097922,1450287871,'Aquarius'],
  [1450287871,1450473974,'Pisces'],
  [1450473974,1450656759,'Aries'],
  [1450656759,1450837855,'Taurus'],
  [1450837855,1451021197,'Gemini'],
  [1451021197,1451212264,'Cancer'],
  [1451212264,1451415490,'Leo'],
  [1451415490,1451630438,'Virgo'],
  [1451630438,1451849761,'Libra'],
  [1451849761,1452063364,'Scorpio'],
  [1452063364,1452265609,'Sagittarius'],
  [1452265609,1452457349,'Capricorn'],
  [1452457349,1452642801,'Aquarius'],
  [1452642801,1452826099,'Pisces'],
  [1452826099,1453009687,'Aries'],
  [1453009687,1453194765,'Taurus'],
  [1453194765,1453382881,'Gemini'],
  [1453382881,1453576855,'Cancer'],
  [1453576855,1453779943,'Leo'],
  [1453779943,1453993151,'Virgo'],
  [1453993151,1454212220,'Libra'],
  [1454212220,1454428187,'Scorpio'],
  [1454428187,1454633037,'Sagittarius'],
  [1454633037,1454824734,'Capricorn'],
  [1454824734,1455006683,'Aquarius'],
  [1455006683,1455184472,'Pisces'],
  [1455184472,1455363330,'Aries'],
  [1455363330,1455546875,'Taurus'],
  [1455546875,1455737018,'Gemini'],
  [1455737018,1455934641,'Cancer'],
  [1455934641,1456140256,'Leo'],
  [1456140256,1456353686,'Virgo'],
  [1456353686,1456572365,'Libra'],
  [1456572365,1456790156,'Scorpio'],
  [1456790156,1456999285,'Sagittarius'],
  [1456999285,1457194927,'Capricorn'],
  [1457194927,1457377713,'Aquarius'],
  [1457377713,1457552399,'Pisces'],
  [1457552399,1457725418,'Aries'],
  [1457725418,1457903008,'Taurus'],
  [1457903008,1458089794,'Gemini'],
  [1458089794,1458287662,'Cancer'],
  [1458287662,1458495546,'Leo'],
  [1458495546,1458710593,'Virgo'],
  [1458710593,1458929335,'Libra'],
  [1458929335,1459147559,'Scorpio'],
  [1459147559,1459359879,'Sagittarius'],
  [1459359879,1459561021,'Capricorn'],
  [1459561021,1459748744,'Aquarius'],
  [1459748744,1459925160,'Pisces'],
  [1459925160,1460095830,'Aries'],
  [1460095830,1460267918,'Taurus'],
  [1460267918,1460448392,'Gemini'],
  [1460448392,1460641979,'Cancer'],
  [1460641979,1460848961,'Leo'],
  [1460848961,1461065026,'Virgo'],
  [1461065026,1461284252,'Libra'],
  [1461284252,1461501965,'Scorpio'],
  [1461501965,1461714861,'Sagittarius'],
  [1461714861,1461919603,'Capricorn'],
  [1461919603,1462113213,'Aquarius'],
  [1462113213,1462295065,'Pisces'],
  [1462295065,1462468217,'Aries'],
  [1462468217,1462638874,'Taurus'],
  [1462638874,1462814628,'Gemini'],
  [1462814628,1463002321,'Cancer'],
  [1463002321,1463205101,'Leo'],
  [1463205101,1463419956,'Virgo'],
  [1463419956,1463639368,'Libra'],
  [1463639368,1463856487,'Scorpio'],
  [1463856487,1464068026,'Sagittarius'],
  [1464068026,1464272810,'Capricorn'],
  [1464272810,1464469553,'Aquarius'],
  [1464469553,1464656957,'Pisces'],
  [1464656957,1464835593,'Aries'],
  [1464835593,1465009282,'Taurus'],
  [1465009282,1465184490,'Gemini'],
  [1465184490,1465368435,'Cancer'],
  [1465368435,1465566339,'Leo'],
  [1465566339,1465777988,'Virgo'],
  [1465777988,1465996683,'Libra'],
  [1465996683,1466213641,'Scorpio'],
  [1466213641,1466423690,'Sagittarius'],
  [1466423690,1466626107,'Capricorn'],
  [1466626107,1466821826,'Aquarius'],
  [1466821826,1467011266,'Pisces'],
  [1467011266,1467194596,'Aries'],
  [1467194596,1467373466,'Taurus'],
  [1467373466,1467552003,'Gemini'],
  [1467552003,1467736088,'Cancer'],
  [1467736088,1467931261,'Leo'],
  [1467931261,1468139533,'Virgo'],
  [1468139533,1468356732,'Libra'],
  [1468356732,1468574050,'Scorpio'],
  [1468574050,1468783975,'Sagittarius'],
  [1468783975,1468984226,'Capricorn'],
  [1468984226,1469176516,'Aquarius'],
  [1469176516,1469363567,'Pisces'],
  [1469363567,1469547449,'Aries'],
  [1469547449,1469729802,'Taurus'],
  [1469729802,1469912921,'Gemini'],
  [1469912921,1470100316,'Cancer'],
  [1470100316,1470296032,'Leo'],
  [1470296032,1470502596,'Virgo'],
  [1470502596,1470718284,'Libra'],
  [1470718284,1470936242,'Scorpio'],
  [1470936242,1471147900,'Sagittarius'],
  [1471147900,1471348350,'Capricorn'],
  [1471348350,1471538052,'Aquarius'],
  [1471538052,1471720705,'Pisces'],
  [1471720705,1471900756,'Aries'],
  [1471900756,1472081993,'Taurus'],
  [1472081993,1472267172,'Gemini'],
  [1472267172,1472458285,'Cancer'],
  [1472458285,1472656923,'Leo'],
  [1472656923,1472864128,'Virgo'],
  [1472864128,1473079109,'Libra'],
  [1473079109,1473297579,'Scorpio'],
  [1473297579,1473512087,'Sagittarius'],
  [1473512087,1473715716,'Capricorn'],
  [1473715716,1473906180,'Aquarius'],
  [1473906180,1474086140,'Pisces'],
  [1474086140,1474261088,'Aries'],
  [1474261088,1474437180,'Taurus'],
  [1474437180,1474619593,'Gemini'],
  [1474619593,1474811287,'Cancer'],
  [1474811287,1475012564,'Leo'],
  [1475012564,1475221943,'Virgo'],
  [1475221943,1475437369,'Libra'],
  [1475437369,1475655966,'Scorpio'],
  [1475655966,1475872794,'Sagittarius'],
  [1475872794,1476081176,'Capricorn'],
  [1476081176,1476276178,'Aquarius'],
  [1476276178,1476457692,'Pisces'],
  [1476457692,1476630270,'Aries'],
  [1476630270,1476800998,'Taurus'],
  [1476800998,1476977297,'Gemini'],
  [1476977297,1477164840,'Cancer'],
  [1477164840,1477365374,'Leo'],
  [1477365374,1477576246,'Virgo'],
  [1477576246,1477792853,'Libra'],
  [1477792853,1478011382,'Scorpio'],
  [1478011382,1478228711,'Sagittarius'],
  [1478228711,1478440512,'Capricorn'],
  [1478440512,1478641506,'Aquarius'],
  [1478641506,1478828681,'Pisces'],
  [1478828681,1479003823,'Aries'],
  [1479003823,1479172996,'Taurus'],
  [1479172996,1479344230,'Gemini'],
  [1479344230,1479525260,'Cancer'],
  [1479525260,1479720846,'Leo'],
  [1479720846,1479930125,'Virgo'],
  [1479930125,1480147289,'Libra'],
  [1480147289,1480365943,'Scorpio'],
  [1480365943,1480582333,'Sagittarius'],
  [1480582333,1480794242,'Capricorn'],
  [1480794242,1480998653,'Aquarius'],
  [1480998653,1481192132,'Pisces'],
  [1481192132,1481373647,'Aries'],
  [1481373647,1481546481,'Taurus'],
  [1481546481,1481717326,'Gemini'],
  [1481717326,1481894096,'Cancer'],
  [1481894096,1482083515,'Leo'],
  [1482083515,1482287980,'Virgo'],
  [1482287980,1482503545,'Libra'],
  [1482503545,1482722323,'Scorpio'],
  [1482722323,1482937909,'Sagittarius'],
  [1482937909,1483147724,'Capricorn'],
  [1483147724,1483351032,'Aquarius'],
  [1483351032,1483546775,'Pisces'],
  [1483546775,1483733870,'Aries'],
  [1483733870,1483913164,'Taurus'],
  [1483913164,1484088526,'Gemini'],
  [1484088526,1484266071,'Cancer'],
  [1484266071,1484452343,'Leo'],
  [1484452343,1484651766,'Virgo'],
  [1484651766,1484863753,'Libra'],
  [1484863753,1485081906,'Scorpio'],
  [1485081906,1485297794,'Sagittarius'],
  [1485297794,1485506193,'Capricorn'],
  [1485506193,1485706226,'Aquarius'],
  [1485706226,1485899195,'Pisces'],
  [1485899195,1486086600,'Aries'],
  [1486086600,1486269840,'Taurus'],
  [1486269840,1486450960,'Gemini'],
  [1486450960,1486633270,'Cancer'],
  [1486633270,1486821106,'Leo'],
  [1486821106,1487018565,'Virgo'],
  [1487018565,1487227247,'Libra'],
  [1487227247,1487443936,'Scorpio'],
  [1487443936,1487660869,'Sagittarius'],
  [1487660869,1487870240,'Capricorn'],
  [1487870240,1488068669,'Aquarius'],
  [1488068669,1488257503,'Pisces'],
  [1488257503,1488440556,'Aries'],
  [1488440556,1488621927,'Taurus'],
  [1488621927,1488804852,'Gemini'],
  [1488804852,1488991530,'Cancer'],
  [1488991530,1489183634,'Leo'],
  [1489183634,1489382885,'Virgo'],
  [1489382885,1489590635,'Libra'],
  [1489590635,1489805988,'Scorpio'],
  [1489805988,1490023857,'Sagittarius'],
  [1490023857,1490236096,'Capricorn'],
  [1490236096,1490436389,'Aquarius'],
  [1490436389,1490623853,'Pisces'],
  [1490623853,1490802470,'Aries'],
  [1490802470,1490978420,'Taurus'],
  [1490978420,1491157618,'Gemini'],
  [1491157618,1491344002,'Cancer'],
  [1491344002,1491538777,'Leo'],
  [1491538777,1491741249,'Virgo'],
  [1491741249,1491950493,'Libra'],
  [1491950493,1492165609,'Scorpio'],
  [1492165609,1492383876,'Sagittarius'],
  [1492383876,1492599094,'Capricorn'],
  [1492599094,1492803751,'Aquarius'],
  [1492803751,1492993959,'Pisces'],
  [1492993959,1493171781,'Aries'],
  [1493171781,1493343548,'Taurus'],
  [1493343548,1493516884,'Gemini'],
  [1493516884,1493698315,'Cancer'],
  [1493698315,1493891195,'Leo'],
  [1493891195,1494094803,'Virgo'],
  [1494094803,1494306032,'Libra'],
  [1494306032,1494521972,'Scorpio'],
  [1494521972,1494740250,'Sagittarius'],
  [1494740250,1494956988,'Capricorn'],
  [1494956988,1495165911,'Aquarius'],
  [1495165911,1495361440,'Pisces'],
  [1495361440,1495542768,'Aries'],
  [1495542768,1495714522,'Taurus'],
  [1495714522,1495884281,'Gemini'],
  [1495884281,1496059926,'Cancer'],
  [1496059926,1496247355,'Leo'],
  [1496247355,1496448222,'Virgo'],
  [1496448222,1496659554,'Libra'],
  [1496659554,1496876358,'Scorpio'],
  [1496876358,1497094574,'Sagittarius'],
  [1497094574,1497311075,'Capricorn'],
  [1497311075,1497521843,'Aquarius'],
  [1497521843,1497722090,'Pisces'],
  [1497722090,1497909178,'Aries'],
  [1497909178,1498085052,'Taurus'],
  [1498085052,1498255604,'Gemini'],
  [1498255604,1498428393,'Cancer'],
  [1498428393,1498610487,'Leo'],
  [1498610487,1498806130,'Virgo'],
  [1498806130,1499014746,'Libra'],
  [1499014746,1499231274,'Scorpio'],
  [1499231274,1499449468,'Sagittarius'],
  [1499449468,1499664888,'Capricorn'],
  [1499664888,1499874677,'Aquarius'],
  [1499874677,1500076325,'Pisces'],
  [1500076325,1500267854,'Aries'],
  [1500267854,1500449485,'Taurus'],
  [1500449485,1500624567,'Gemini'],
  [1500624567,1500798814,'Cancer'],
  [1500798814,1500978751,'Leo'],
  [1500978751,1501169832,'Virgo'],
  [1501169832,1501374178,'Libra'],
  [1501374178,1501588873,'Scorpio'],
  [1501588873,1501806994,'Sagittarius'],
  [1501806994,1502021737,'Capricorn'],
  [1502021737,1502229354,'Aquarius'],
  [1502229354,1502428907,'Pisces'],
  [1502428907,1502620779,'Aries'],
  [1502620779,1502805963,'Taurus'],
  [1502805963,1502986382,'Gemini'],
  [1502986382,1503165276,'Cancer'],
  [1503165276,1503347094,'Leo'],
  [1503347094,1503536679,'Virgo'],
  [1503536679,1503737578,'Libra'],
  [1503737578,1503949648,'Scorpio'],
  [1503949648,1504167503,'Sagittarius'],
  [1504167503,1504382788,'Capricorn'],
  [1504382788,1504589308,'Aquarius'],
  [1504589308,1504785677,'Pisces'],
  [1504785677,1504974147,'Aries'],
  [1504974147,1505158165,'Taurus'],
  [1505158165,1505340748,'Gemini'],
  [1505340748,1505524129,'Cancer'],
  [1505524129,1505710334,'Leo'],
  [1505710334,1505901958,'Virgo'],
  [1505901958,1506102002,'Libra'],
  [1506102002,1506312054,'Scorpio'],
  [1506312054,1506529441,'Sagittarius'],
  [1506529441,1506746410,'Capricorn'],
  [1506746410,1506954376,'Aquarius'],
  [1506954376,1507149573,'Pisces'],
  [1507149573,1507334147,'Aries'],
  [1507334147,1507513467,'Taurus'],
  [1507513467,1507693104,'Gemini'],
  [1507693104,1507876889,'Cancer'],
  [1507876889,1508066329,'Leo'],
  [1508066329,1508261692,'Virgo'],
  [1508261692,1508463653,'Libra'],
  [1508463653,1508673402,'Scorpio'],
  [1508673402,1508890325,'Sagittarius'],
  [1508890325,1509109118,'Capricorn'],
  [1509109118,1509320772,'Aquarius'],
  [1509320772,1509518552,'Pisces'],
  [1509518552,1509702368,'Aries'],
  [1509702368,1509877572,'Taurus'],
  [1509877572,1510051470,'Gemini'],
  [1510051470,1510230544,'Cancer'],
  [1510230544,1510418486,'Leo'],
  [1510418486,1510615579,'Virgo'],
  [1510615579,1510820324,'Libra'],
  [1510820324,1511031543,'Scorpio'],
  [1511031543,1511248435,'Sagittarius'],
  [1511248435,1511468049,'Capricorn'],
  [1511468049,1511683428,'Aquarius'],
  [1511683428,1511886612,'Pisces'],
  [1511886612,1512074291,'Aries'],
  [1512074291,1512249663,'Taurus'],
  [1512249663,1512419820,'Gemini'],
  [1512419820,1512592632,'Cancer'],
  [1512592632,1512774511,'Leo'],
  [1512774511,1512968462,'Virgo'],
  [1512968462,1513173516,'Libra'],
  [1513173516,1513386429,'Scorpio'],
  [1513386429,1513603994,'Sagittarius'],
  [1513603994,1513823351,'Capricorn'],
  [1513823351,1514040099,'Aquarius'],
  [1514040099,1514248005,'Pisces'],
  [1514248005,1514442193,'Aries'],
  [1514442193,1514622648,'Taurus'],
  [1514622648,1514794212,'Gemini'],
  [1514794212,1514964152,'Cancer'],
  [1514964152,1515139922,'Leo'],
  [1515139922,1515327276,'Virgo'],
  [1515327276,1515528322,'Libra'],
  [1515528322,1515740659,'Scorpio'],
  [1515740659,1515958932,'Sagittarius'],
  [1515958932,1516177905,'Capricorn'],
  [1516177905,1516393583,'Aquarius'],
  [1516393583,1516602422,'Pisces'],
  [1516602422,1516801167,'Aries'],
  [1516801167,1516988375,'Taurus'],
  [1516988375,1517165848,'Gemini'],
  [1517165848,1517338369,'Cancer'],
  [1517338369,1517512374,'Leo'],
  [1517512374,1517694429,'Virgo'],
  [1517694429,1517889384,'Libra'],
  [1517889384,1518098010,'Scorpio'],
  [1518098010,1518315660,'Sagittarius'],
  [1518315660,1518534684,'Capricorn'],
  [1518534684,1518748896,'Aquarius'],
  [1518748896,1518955475,'Pisces'],
  [1518955475,1519153902,'Aries'],
  [1519153902,1519344440,'Taurus'],
  [1519344440,1519527960,'Gemini'],
  [1519527960,1519706514,'Cancer'],
  [1519706514,1519883854,'Leo'],
  [1519883854,1520065227,'Virgo'],
  [1520065227,1520256172,'Libra'],
  [1520256172,1520460169,'Scorpio'],
  [1520460169,1520675525,'Sagittarius'],
  [1520675525,1520894668,'Capricorn'],
  [1520894668,1521108722,'Aquarius'],
  [1521108722,1521313013,'Pisces'],
  [1521313013,1521508000,'Aries'],
  [1521508000,1521696590,'Taurus'],
  [1521696590,1521881560,'Gemini'],
  [1521881560,1522064683,'Cancer'],
  [1522064683,1522247424,'Leo'],
  [1522247424,1522432324,'Virgo'],
  [1522432324,1522623437,'Libra'],
  [1522623437,1522824893,'Scorpio'],
  [1522824893,1523037682,'Sagittarius'],
  [1523037682,1523256611,'Capricorn'],
  [1523256611,1523471991,'Aquarius'],
  [1523471991,1523676336,'Pisces'],
  [1523676336,1523868665,'Aries'],
  [1523868665,1524052937,'Taurus'],
  [1524052937,1524234385,'Gemini'],
  [1524234385,1524416936,'Cancer'],
  [1524416936,1524602410,'Leo'],
  [1524602410,1524791567,'Virgo'],
  [1524791567,1524985883,'Libra'],
  [1524985883,1525187965,'Scorpio'],
  [1525187965,1525399566,'Sagittarius'],
  [1525399566,1525618111,'Capricorn'],
  [1525618111,1525835441,'Aquarius'],
  [1525835441,1526042415,'Pisces'],
  [1526042415,1526235317,'Aries'],
  [1526235317,1526417002,'Taurus'],
  [1526417002,1526593644,'Gemini'],
  [1526593644,1526771433,'Cancer'],
  [1526771433,1526954574,'Leo'],
  [1526954574,1527144706,'Virgo'],
  [1527144706,1527341971,'Libra'],
  [1527341971,1527546545,'Scorpio'],
  [1527546545,1527758787,'Sagittarius'],
  [1527758787,1527977179,'Capricorn'],
  [1527977179,1528196005,'Aquarius'],
  [1528196005,1528406738,'Pisces'],
  [1528406738,1528603424,'Aries'],
  [1528603424,1528786372,'Taurus'],
  [1528786372,1528960796,'Gemini'],
  [1528960796,1529133640,'Cancer'],
  [1529133640,1529311230,'Leo'],
  [1529311230,1529497763,'Virgo'],
  [1529497763,1529694637,'Libra'],
  [1529694637,1529900959,'Scorpio'],
  [1529900959,1530114740,'Sagittarius'],
  [1530114740,1530333397,'Capricorn'],
  [1530333397,1530552654,'Aquarius'],
  [1530552654,1530766172,'Pisces'],
  [1530766172,1530967854,'Aries'],
  [1530967854,1531155501,'Taurus'],
  [1531155501,1531331917,'Gemini'],
  [1531331917,1531503060,'Cancer'],
  [1531503060,1531675850,'Leo'],
  [1531675850,1531856535,'Virgo'],
  [1531856535,1532049181,'Libra'],
  [1532049181,1532254339,'Scorpio'],
  [1532254339,1532468919,'Sagittarius'],
  [1532468919,1532688047,'Capricorn'],
  [1532688047,1532906864,'Aquarius'],
  [1532906864,1533120849,'Pisces'],
  [1533120849,1533325853,'Aries'],
  [1533325853,1533519103,'Taurus'],
  [1533519103,1533700855,'Gemini'],
  [1533700855,1533874658,'Cancer'],
  [1533874658,1534046336,'Leo'],
  [1534046336,1534222633,'Virgo'],
  [1534222633,1534409656,'Libra'],
  [1534409656,1534610699,'Scorpio'],
  [1534610699,1534824031,'Sagittarius'],
  [1534824031,1535043329,'Capricorn'],
  [1535043329,1535261545,'Aquarius'],
  [1535261545,1535474105,'Pisces'],
  [1535474105,1535679010,'Aries'],
  [1535679010,1535875297,'Taurus'],
  [1535875297,1536062615,'Gemini'],
  [1536062615,1536242054,'Cancer'],
  [1536242054,1536416947,'Leo'],
  [1536416947,1536592791,'Virgo'],
  [1536592791,1536776109,'Libra'],
  [1536776109,1536972307,'Scorpio'],
  [1536972307,1537182444,'Sagittarius'],
  [1537182444,1537401092,'Capricorn'],
  [1537401092,1537619215,'Aquarius'],
  [1537619215,1537830217,'Pisces'],
  [1537830217,1538032531,'Aries'],
  [1538032531,1538227555,'Taurus'],
  [1538227555,1538416827,'Gemini'],
  [1538416827,1538601135,'Cancer'],
  [1538601135,1538781555,'Leo'],
  [1538781555,1538961006,'Virgo'],
  [1538961006,1539144560,'Libra'],
  [1539144560,1539337975,'Scorpio'],
  [1539337975,1539544612,'Sagittarius'],
  [1539544612,1539761744,'Capricorn'],
  [1539761744,1539980420,'Aquarius'],
  [1539980420,1540191498,'Pisces'],
  [1540191498,1540391594,'Aries'],
  [1540391594,1540582840,'Taurus'],
  [1540582840,1540769221,'Gemini'],
  [1540769221,1540953721,'Cancer'],
  [1540953721,1541137662,'Leo'],
  [1541137662,1541322056,'Virgo'],
  [1541322056,1541509341,'Libra'],
  [1541509341,1541703564,'Scorpio'],
  [1541703564,1541908469,'Sagittarius'],
  [1541908469,1542123907,'Capricorn'],
  [1542123907,1542343279,'Aquarius'],
  [1542343279,1542556549,'Pisces'],
  [1542556549,1542757370,'Aries'],
  [1542757370,1542946223,'Taurus'],
  [1542946223,1543127859,'Gemini'],
  [1543127859,1543307699,'Cancer'],
  [1543307699,1543489671,'Leo'],
  [1543489671,1543675723,'Virgo'],
  [1543675723,1543866880,'Libra'],
  [1543866880,1544064530,'Scorpio'],
  [1544064530,1544270482,'Sagittarius'],
  [1544270482,1544485160,'Capricorn'],
  [1544485160,1544704770,'Aquarius'],
  [1544704770,1544921041,'Pisces'],
  [1544921041,1545125836,'Aries'],
  [1545125836,1545316468,'Taurus'],
  [1545316468,1545496088,'Gemini'],
  [1545496088,1545670712,'Cancer'],
  [1545670712,1545846588,'Leo'],
  [1545846588,1546028586,'Virgo'],
  [1546028586,1546219380,'Libra'],
  [1546219380,1546419498,'Scorpio'],
  [1546419498,1546628079,'Sagittarius'],
  [1546628079,1546843551,'Capricorn'],
  [1546843551,1547063010,'Aquarius'],
  [1547063010,1547281060,'Pisces'],
  [1547281060,1547490670,'Aries'],
  [1547490670,1547686816,'Taurus'],
  [1547686816,1547869431,'Gemini'],
  [1547869431,1548042868,'Cancer'],
  [1548042868,1548213725,'Leo'],
  [1548213725,1548388946,'Virgo'],
  [1548388946,1548574241,'Libra'],
  [1548574241,1548772362,'Scorpio'],
  [1548772362,1548982023,'Sagittarius'],
  [1548982023,1549198984,'Capricorn'],
  [1549198984,1549418513,'Aquarius'],
  [1549418513,1549636434,'Pisces'],
  [1549636434,1549848495,'Aries'],
  [1549848495,1550050307,'Taurus'],
  [1550050307,1550239367,'Gemini'],
  [1550239367,1550416857,'Cancer'],
  [1550416857,1550587604,'Leo'],
  [1550587604,1550758625,'Virgo'],
  [1550758625,1550937363,'Libra'],
  [1550937363,1551129568,'Scorpio'],
  [1551129568,1551336488,'Sagittarius'],
  [1551336488,1551553571,'Capricorn'],
  [1551553571,1551773446,'Aquarius'],
  [1551773446,1551990438,'Pisces'],
  [1551990438,1552201781,'Aries'],
  [1552201781,1552405673,'Taurus'],
  [1552405673,1552600145,'Gemini'],
  [1552600145,1552784209,'Cancer'],
  [1552784209,1552959675,'Leo'],
  [1552959675,1553131668,'Virgo'],
  [1553131668,1553307373,'Libra'],
  [1553307373,1553493966,'Scorpio'],
  [1553493966,1553695649,'Sagittarius'],
  [1553695649,1553910348,'Capricorn'],
  [1553910348,1554130082,'Aquarius'],
  [1554130082,1554346576,'Pisces'],
  [1554346576,1554555969,'Aries'],
  [1554555969,1554758107,'Taurus'],
  [1554758107,1554953467,'Gemini'],
  [1554953467,1555141805,'Cancer'],
  [1555141805,1555323232,'Leo'],
  [1555323232,1555500123,'Virgo'],
  [1555500123,1555677628,'Libra'],
  [1555677628,1555862351,'Scorpio'],
  [1555862351,1556059803,'Sagittarius'],
  [1556059803,1556270840,'Capricorn'],
  [1556270840,1556489480,'Aquarius'],
  [1556489480,1556706221,'Pisces'],
  [1556706221,1556914675,'Aries'],
  [1556914675,1557114001,'Taurus'],
  [1557114001,1557306389,'Gemini'],
  [1557306389,1557494025,'Cancer'],
  [1557494025,1557678102,'Leo'],
  [1557678102,1557859841,'Virgo'],
  [1557859841,1558041949,'Libra'],
  [1558041949,1558228862,'Scorpio'],
  [1558228862,1558425360,'Sagittarius'],
  [1558425360,1558633744,'Capricorn'],
  [1558633744,1558850848,'Aquarius'],
  [1558850848,1559068297,'Pisces'],
  [1559068297,1559277770,'Aries'],
  [1559277770,1559476068,'Taurus'],
  [1559476068,1559665022,'Gemini'],
  [1559665022,1559848543,'Cancer'],
  [1559848543,1560030298,'Leo'],
  [1560030298,1560212940,'Virgo'],
  [1560212940,1560398553,'Libra'],
  [1560398553,1560589392,'Scorpio'],
  [1560589392,1560787989,'Sagittarius'],
  [1560787989,1560996023,'Capricorn'],
  [1560996023,1561212077,'Aquarius'],
  [1561212077,1561430261,'Pisces'],
  [1561430261,1561642306,'Aries'],
  [1561642306,1561842526,'Taurus'],
  [1561842526,1562030622,'Gemini'],
  [1562030622,1562210362,'Cancer'],
  [1562210362,1562387112,'Leo'],
  [1562387112,1562566014,'Virgo'],
  [1562566014,1562750916,'Libra'],
  [1562750916,1562943907,'Scorpio'],
  [1562943907,1563145484,'Sagittarius'],
  [1563145484,1563355114,'Capricorn'],
  [1563355114,1563571139,'Aquarius'],
  [1563571139,1563789725,'Pisces'],
  [1563789725,1564004535,'Aries'],
  [1564004535,1564208933,'Taurus'],
  [1564208933,1564399841,'Gemini'],
  [1564399841,1564579095,'Cancer'],
  [1564579095,1564752031,'Leo'],
  [1564752031,1564925388,'Virgo'],
  [1564925388,1565105482,'Libra'],
  [1565105482,1565296477,'Scorpio'],
  [1565296477,1565499005,'Sagittarius'],
  [1565499005,1565710524,'Capricorn'],
  [1565710524,1565927362,'Aquarius'],
  [1565927362,1566145955,'Pisces'],
  [1566145955,1566362218,'Aries'],
  [1566362218,1566570833,'Taurus'],
  [1566570833,1566767113,'Gemini'],
  [1566767113,1566950008,'Cancer'],
  [1566950008,1567123042,'Leo'],
  [1567123042,1567292897,'Virgo'],
  [1567292897,1567467295,'Libra'],
  [1567467295,1567652881,'Scorpio'],
  [1567652881,1567852634,'Sagittarius'],
  [1567852634,1568064223,'Capricorn'],
  [1568064223,1568281890,'Aquarius'],
  [1568281890,1568500340,'Pisces'],
  [1568500340,1568716251,'Aries'],
  [1568716251,1568926662,'Taurus'],
  [1568926662,1569127800,'Gemini'],
  [1569127800,1569316770,'Cancer'],
  [1569316770,1569494213,'Leo'],
  [1569494213,1569664978,'Virgo'],
  [1569664978,1569836513,'Libra'],
  [1569836513,1570016658,'Scorpio'],
  [1570016658,1570211001,'Sagittarius'],
  [1570211001,1570419731,'Capricorn'],
  [1570419731,1570637105,'Aquarius'],
  [1570637105,1570855535,'Pisces'],
  [1570855535,1571070227,'Aries'],
  [1571070227,1571279409,'Taurus'],
  [1571279409,1571481766,'Gemini'],
  [1571481766,1571675315,'Cancer'],
  [1571675315,1571858978,'Leo'],
  [1571858978,1572034792,'Virgo'],
  [1572034792,1572208169,'Libra'],
  [1572208169,1572386308,'Scorpio'],
  [1572386308,1572575899,'Sagittarius'],
  [1572575899,1572779972,'Capricorn'],
  [1572779972,1572995279,'Aquarius'],
  [1572995279,1573213716,'Pisces'],
  [1573213716,1573427874,'Aries'],
  [1573427874,1573634745,'Taurus'],
  [1573634745,1573834507,'Gemini'],
  [1573834507,1574027825,'Cancer'],
  [1574027825,1574214861,'Leo'],
  [1574214861,1574396372,'Virgo'],
  [1574396372,1574575097,'Libra'],
  [1574575097,1574755865,'Scorpio'],
  [1574755865,1574944358,'Sagittarius'],
  [1574944358,1575144804,'Capricorn'],
  [1575144804,1575357030,'Aquarius'],
  [1575357030,1575575065,'Pisces'],
  [1575575065,1575790163,'Aries'],
  [1575790163,1575996420,'Taurus'],
  [1575996420,1576192986,'Gemini'],
  [1576192986,1576382168,'Cancer'],
  [1576382168,1576566960,'Leo'],
  [1576566960,1576749871,'Virgo'],
  [1576749871,1576933034,'Libra'],
  [1576933034,1577118851,'Scorpio'],
  [1577118851,1577310313,'Sagittarius'],
  [1577310313,1577510437,'Capricorn'],
  [1577510437,1577720482,'Aquarius'],
  [1577720482,1577937621,'Pisces'],
  [1577937621,1578154509,'Aries'],
  [1578154509,1578363054,'Taurus'],
  [1578363054,1578559395,'Gemini'],
  [1578559395,1578744966,'Cancer'],
  [1578744966,1578924387,'Leo'],
  [1578924387,1579103011,'Virgo'],
  [1579103011,1579285235,'Libra'],
  [1579285235,1579473655,'Scorpio'],
  [1579473655,1579669190,'Sagittarius'],
  [1579669190,1579872026,'Capricorn'],
  [1579872026,1580082222,'Aquarius'],
  [1580082222,1580298630,'Pisces'],
  [1580298630,1580516865,'Aries'],
  [1580516865,1580729332,'Taurus'],
  [1580729332,1580929374,'Gemini'],
  [1580929374,1581115484,'Cancer'],
  [1581115484,1581291525,'Leo'],
  [1581291525,1581464239,'Virgo'],
  [1581464239,1581640652,'Libra'],
  [1581640652,1581826017,'Scorpio'],
  [1581826017,1582022196,'Sagittarius'],
  [1582022196,1582227700,'Capricorn'],
  [1582227700,1582439836,'Aquarius'],
  [1582439836,1582656433,'Pisces'],
  [1582656433,1582874975,'Aries'],
  [1582874975,1583090438,'Taurus'],
  [1583090438,1583295905,'Gemini'],
  [1583295905,1583486864,'Cancer'],
  [1583486864,1583664426,'Leo'],
  [1583664426,1583834571,'Virgo'],
  [1583834571,1584005295,'Libra'],
  [1584005295,1584184157,'Scorpio'],
  [1584184157,1584375923,'Sagittarius'],
  [1584375923,1584580560,'Capricorn'],
  [1584580560,1584793995,'Aquarius'],
  [1584793995,1585011488,'Pisces'],
  [1585011488,1585229794,'Aries'],
  [1585229794,1585445881,'Taurus'],
  [1585445881,1585654988,'Gemini'],
  [1585654988,1585851988,'Cancer'],
  [1585851988,1586035103,'Leo'],
  [1586035103,1586207763,'Virgo'],
  [1586207763,1586377008,'Libra'],
  [1586377008,1586550916,'Scorpio'],
  [1586550916,1586736326,'Sagittarius'],
  [1586736326,1586936230,'Capricorn'],
  [1586936230,1587148162,'Aquarius'],
  [1587148162,1587366014,'Pisces'],
  [1587366014,1587584149,'Aries'],
  [1587584149,1587799193,'Taurus'],
  [1587799193,1588008470,'Gemini'],
  [1588008470,1588208773,'Cancer'],
  [1588208773,1588397720,'Leo'],
  [1588397720,1588576159,'Virgo'],
  [1588576159,1588748683,'Libra'],
  [1588748683,1588922118,'Scorpio'],
  [1588922118,1589103519,'Sagittarius'],
  [1589103519,1589297917,'Capricorn'],
  [1589297917,1589505855,'Aquarius'],
  [1589505855,1589722535,'Pisces'],
  [1589722535,1589940616,'Aries'],
  [1589940616,1590154544,'Taurus'],
  [1590154544,1590361734,'Gemini'],
  [1590361734,1590561191,'Cancer'],
  [1590561191,1590752411,'Leo'],
  [1590752411,1590935865,'Virgo'],
  [1590935865,1591113939,'Libra'],
  [1591113939,1591291021,'Scorpio'],
  [1591291021,1591472657,'Sagittarius'],
  [1591472657,1591664043,'Capricorn'],
  [1591664043,1591867881,'Aquarius'],
  [1591867881,1592082175,'Pisces'],
  [1592082175,1592300127,'Aries'],
  [1592300127,1592513993,'Taurus'],
  [1592513993,1592719308,'Gemini'],
  [1592719308,1592915600,'Cancer'],
  [1592915600,1593104691,'Leo'],
  [1593104691,1593288983,'Virgo'],
  [1593288983,1593470859,'Libra'],
  [1593470859,1593652864,'Scorpio'],
  [1593652864,1593838083,'Sagittarius'],
  [1593838083,1594030095,'Capricorn'],
  [1594030095,1594231940,'Aquarius'],
  [1594231940,1594443950,'Pisces'],
  [1594443950,1594661637,'Aries'],
  [1594661637,1594876748,'Taurus'],
  [1594876748,1595082251,'Gemini'],
  [1595082251,1595276175,'Cancer'],
  [1595276175,1595461191,'Leo'],
  [1595461191,1595642020,'Virgo'],
  [1595642020,1595823119,'Libra'],
  [1595823119,1596007488,'Scorpio'],
  [1596007488,1596196691,'Sagittarius'],
  [1596196691,1596391851,'Capricorn'],
  [1596391851,1596594452,'Aquarius'],
  [1596594452,1596805474,'Pisces'],
  [1596805474,1597022879,'Aries'],
  [1597022879,1597239952,'Taurus'],
  [1597239952,1597448124,'Gemini'],
  [1597448124,1597642704,'Cancer'],
  [1597642704,1597825223,'Leo'],
  [1597825223,1598001350,'Virgo'],
  [1598001350,1598177756,'Libra'],
  [1598177756,1598359744,'Scorpio'],
  [1598359744,1598549806,'Sagittarius'],
  [1598549806,1598747817,'Capricorn'],
  [1598747817,1598952854,'Aquarius'],
  [1598952854,1599164515,'Pisces'],
  [1599164515,1599381806,'Aries'],
  [1599381806,1599600451,'Taurus'],
  [1599600451,1599812553,'Gemini'],
  [1599812553,1600011138,'Cancer'],
  [1600011138,1600195038,'Leo'],
  [1600195038,1600368959,'Virgo'],
  [1600368959,1600540379,'Libra'],
  [1600540379,1600716688,'Scorpio'],
  [1600716688,1600902977,'Sagittarius'],
  [1600902977,1601100480,'Capricorn'],
  [1601100480,1601307224,'Aquarius'],
  [1601307224,1601520424,'Pisces'],
  [1601520424,1601737939,'Aries'],
  [1601737939,1601956958,'Taurus'],
  [1601956958,1602171925,'Gemini'],
  [1602171925,1602375863,'Cancer'],
  [1602375863,1602564948,'Leo'],
  [1602564948,1602741232,'Virgo'],
  [1602741232,1602911139,'Libra'],
  [1602911139,1603082563,'Scorpio'],
  [1603082563,1603262607,'Sagittarius'],
  [1603262607,1603455411,'Capricorn'],
  [1603455411,1603660701,'Aquarius'],
  [1603660701,1603874679,'Pisces'],
  [1603874679,1604092726,'Aries'],
  [1604092726,1604311176,'Taurus'],
  [1604311176,1604526327,'Gemini'],
  [1604526327,1604733498,'Cancer'],
  [1604733498,1604928592,'Leo'],
  [1604928592,1605110965,'Virgo'],
  [1605110965,1605284333,'Libra'],
  [1605284333,1605455209,'Scorpio'],
  [1605455209,1605630875,'Sagittarius'],
  [1605630875,1605817495,'Capricorn'],
  [1605817495,1606017949,'Aquarius'],
  [1606017949,1606230280,'Pisces'],
  [1606230280,1606448584,'Aries'],
  [1606448584,1606666563,'Taurus'],
  [1606666563,1606879985,'Gemini'],
  [1606879985,1607086365,'Cancer'],
  [1607086365,1607283980,'Leo'],
  [1607283980,1607472075,'Virgo'],
  [1607472075,1607651913,'Libra'],
  [1607651913,1607827156,'Scorpio'],
  [1607827156,1608003289,'Sagittarius'],
  [1608003289,1608186424,'Capricorn'],
  [1608186424,1608381531,'Aquarius'],
  [1608381531,1608589931,'Pisces'],
  [1608589931,1608807324,'Aries'],
  [1608807324,1609025556,'Taurus'],
  [1609025556,1609237705,'Gemini'],
  [1609237705,1609441084,'Cancer'],
  [1609441084,1609636367,'Leo'],
  [1609636367,1609825322,'Virgo'],
  [1609825322,1610009605,'Libra'],
  [1610009605,1610190911,'Scorpio'],
  [1610190911,1610371797,'Sagittarius'],
  [1610371797,1610556239,'Capricorn'],
  [1610556239,1610749025,'Aquarius'],
  [1610749025,1610953629,'Pisces'],
  [1610953629,1611168957,'Aries'],
  [1611168957,1611387783,'Taurus'],
  [1611387783,1611600702,'Gemini'],
  [1611600702,1611802443,'Cancer'],
  [1611802443,1611993744,'Leo'],
  [1611993744,1612178719,'Virgo'],
  [1612178719,1612361676,'Libra'],
  [1612361676,1612545392,'Scorpio'],
  [1612545392,1612731113,'Sagittarius'],
  [1612731113,1612920024,'Capricorn'],
  [1612920024,1613114596,'Aquarius'],
  [1613114596,1613318040,'Pisces'],
  [1613318040,1613531496,'Aries'],
  [1613531496,1613750609,'Taurus'],
  [1613750609,1613965962,'Gemini'],
  [1613965962,1614169365,'Cancer'],
  [1614169365,1614359228,'Leo'],
  [1614359228,1614539813,'Virgo'],
  [1614539813,1614717496,'Libra'],
  [1614717496,1614897772,'Scorpio'],
  [1614897772,1615083626,'Sagittarius'],
  [1615083626,1615275650,'Capricorn'],
  [1615275650,1615473833,'Aquarius'],
  [1615473833,1615679034,'Pisces'],
  [1615679034,1615892177,'Aries'],
  [1615892177,1616111224,'Taurus'],
  [1616111224,1616329052,'Gemini'],
  [1616329052,1616536572,'Cancer'],
  [1616536572,1616729131,'Leo'],
  [1616729131,1616908939,'Virgo'],
  [1616908939,1617082404,'Libra'],
  [1617082404,1617256719,'Scorpio'],
  [1617256719,1617437582,'Sagittarius'],
  [1617437582,1617627813,'Capricorn'],
  [1617627813,1617827413,'Aquarius'],
  [1617827413,1618035062,'Pisces'],
  [1618035062,1618249424,'Aries'],
  [1618249424,1618468496,'Taurus'],
  [1618468496,1618687516,'Gemini'],
  [1618687516,1618899034,'Cancer'],
  [1618899034,1619096899,'Leo'],
  [1619096899,1619280354,'Virgo'],
  [1619280354,1619453906,'Libra'],
  [1619453906,1619624549,'Scorpio'],
  [1619624549,1619799369,'Sagittarius'],
  [1619799369,1619983855,'Capricorn'],
  [1619983855,1620180506,'Aquarius'],
  [1620180506,1620388349,'Pisces'],
  [1620388349,1620603979,'Aries'],
  [1620603979,1620823374,'Taurus'],
  [1620823374,1621042220,'Gemini'],
  [1621042220,1621255433,'Cancer'],
  [1621255433,1621457967,'Leo'],
  [1621457967,1621647328,'Virgo'],
  [1621647328,1621825230,'Libra'],
  [1621825230,1621996764,'Scorpio'],
  [1621996764,1622168610,'Sagittarius'],
  [1622168610,1622347464,'Capricorn'],
  [1622347464,1622538435,'Aquarius'],
  [1622538435,1622743117,'Pisces'],
  [1622743117,1622958381,'Aries'],
  [1622958381,1623178045,'Taurus'],
  [1623178045,1623396151,'Gemini'],
  [1623396151,1623608540,'Cancer'],
  [1623608540,1623812526,'Leo'],
  [1623812526,1624006424,'Virgo'],
  [1624006424,1624190279,'Libra'],
  [1624190279,1624366533,'Scorpio'],
  [1624366533,1624539892,'Sagittarius'],
  [1624539892,1624716511,'Capricorn'],
  [1624716511,1624902641,'Aquarius'],
  [1624902641,1625102464,'Pisces'],
  [1625102464,1625315264,'Aries'],
  [1625315264,1625534618,'Taurus'],
  [1625534618,1625752254,'Gemini'],
  [1625752254,1625962832,'Cancer'],
  [1625962832,1626165029,'Leo'],
  [1626165029,1626359499,'Virgo'],
  [1626359499,1626547102,'Libra'],
  [1626547102,1626728871,'Scorpio'],
  [1626728871,1626906985,'Sagittarius'],
  [1626906985,1627085548,'Capricorn'],
  [1627085548,1627270185,'Aquarius'],
  [1627270185,1627466253,'Pisces'],
  [1627466253,1627675676,'Aries'],
  [1627675676,1627893973,'Taurus'],
  [1627893973,1628111828,'Gemini'],
  [1628111828,1628321491,'Cancer'],
  [1628321491,1628520940,'Leo'],
  [1628520940,1628712467,'Virgo'],
  [1628712467,1628899283,'Libra'],
  [1628899283,1629083504,'Scorpio'],
  [1629083504,1629266279,'Sagittarius'],
  [1629266279,1629449330,'Capricorn'],
  [1629449330,1629636151,'Aquarius'],
  [1629636151,1629831412,'Pisces'],
  [1629831412,1630038398,'Aries'],
  [1630038398,1630255301,'Taurus'],
  [1630255301,1630473949,'Gemini'],
  [1630473949,1630684696,'Cancer'],
  [1630684696,1630883139,'Leo'],
  [1630883139,1631071228,'Virgo'],
  [1631071228,1631253881,'Libra'],
  [1631253881,1631435672,'Scorpio'],
  [1631435672,1631619257,'Sagittarius'],
  [1631619257,1631805784,'Capricorn'],
  [1631805784,1631996545,'Aquarius'],
  [1631996545,1632193967,'Pisces'],
  [1632193967,1632400678,'Aries'],
  [1632400678,1632616584,'Taurus'],
  [1632616584,1632836056,'Gemini'],
  [1632836056,1633049610,'Cancer'],
  [1633049610,1633250258,'Leo'],
  [1633250258,1633437664,'Virgo'],
  [1633437664,1633616522,'Libra'],
  [1633616522,1633793043,'Scorpio'],
  [1633793043,1633972501,'Sagittarius'],
  [1633972501,1634158046,'Capricorn'],
  [1634158046,1634350901,'Aquarius'],
  [1634350901,1634551444,'Pisces'],
  [1634551444,1634759935,'Aries'],
  [1634759935,1634975827,'Taurus'],
  [1634975827,1635195607,'Gemini'],
  [1635195607,1635412037,'Cancer'],
  [1635412037,1635617369,'Leo'],
  [1635617369,1635808263,'Virgo'],
  [1635808263,1635987159,'Libra'],
  [1635987159,1636159952,'Scorpio'],
  [1636159952,1636333401,'Sagittarius'],
  [1636333401,1636513387,'Capricorn'],
  [1636513387,1636703614,'Aquarius'],
  [1636703614,1636904888,'Pisces'],
  [1636904888,1637115468,'Aries'],
  [1637115468,1637332363,'Taurus'],
  [1637332363,1637551974,'Gemini'],
  [1637551974,1637769509,'Cancer'],
  [1637769509,1637979110,'Leo'],
  [1637979110,1638176095,'Virgo'],
  [1638176095,1638359736,'Libra'],
  [1638359736,1638533575,'Scorpio'],
  [1638533575,1638703851,'Sagittarius'],
  [1638703851,1638877714,'Capricorn'],
  [1638877714,1639061591,'Aquarius'],
  [1639061591,1639259156,'Pisces'],
  [1639259156,1639469444,'Aries'],
  [1639469444,1639687359,'Taurus'],
  [1639687359,1639906907,'Gemini'],
  [1639906907,1640123613,'Cancer'],
  [1640123613,1640334265,'Leo'],
  [1640334265,1640535838,'Virgo'],
  [1640535838,1640726187,'Libra'],
  [1640726187,1640905709,'Scorpio'],
  [1640905709,1641078137,'Sagittarius'],
  [1641078137,1641249832,'Capricorn'],
  [1641249832,1641428198,'Aquarius'],
  [1641428198,1641619549,'Pisces'],
  [1641619549,1641826013,'Aries'],
  [1641826013,1642043284,'Taurus'],
  [1642043284,1642263042,'Gemini'],
  [1642263042,1642478578,'Cancer'],
  [1642478578,1642687328,'Leo'],
  [1642687328,1642888959,'Virgo'],
  [1642888959,1643083024,'Libra'],
  [1643083024,1643268880,'Scorpio'],
  [1643268880,1643447347,'Sagittarius'],
  [1643447347,1643622154,'Capricorn'],
  [1643622154,1643799574,'Aquarius'],
  [1643799574,1643986589,'Pisces'],
  [1643986589,1644187940,'Aries'],
  [1644187940,1644402397,'Taurus'],
  [1644402397,1644621999,'Gemini'],
  [1644621999,1644837433,'Cancer'],
  [1644837433,1645044149,'Leo'],
  [1645044149,1645242661,'Virgo'],
  [1645242661,1645435150,'Libra'],
  [1645435150,1645622940,'Scorpio'],
  [1645622940,1645806446,'Sagittarius'],
  [1645806446,1645986939,'Capricorn'],
  [1645986939,1646168009,'Aquarius'],
  [1646168009,1646355149,'Pisces'],
  [1646355149,1646553591,'Aries'],
  [1646553591,1646764772,'Taurus'],
  [1646764772,1646983454,'Gemini'],
  [1646983454,1647199896,'Cancer'],
  [1647199896,1647406723,'Leo'],
  [1647406723,1647602758,'Virgo'],
  [1647602758,1647791076,'Libra'],
  [1647791076,1647975539,'Scorpio'],
  [1647975539,1648158832,'Sagittarius'],
  [1648158832,1648342513,'Capricorn'],
  [1648342513,1648528292,'Aquarius'],
  [1648528292,1648719018,'Pisces'],
  [1648719018,1648918204,'Aries'],
  [1648918204,1649127844,'Taurus'],
  [1649127844,1649345411,'Gemini'],
  [1649345411,1649563177,'Cancer'],
  [1649563177,1649772442,'Leo'],
  [1649772442,1649969152,'Virgo'],
  [1649969152,1650154965,'Libra'],
  [1650154965,1650334589,'Scorpio'],
  [1650334589,1650513129,'Sagittarius'],
  [1650513129,1650694623,'Capricorn'],
  [1650694623,1650881669,'Aquarius'],
  [1650881669,1651075784,'Pisces'],
  [1651075784,1651277918,'Aries'],
  [1651277918,1651488384,'Taurus'],
  [1651488384,1651705506,'Gemini'],
  [1651705506,1651924181,'Cancer'],
  [1651924181,1652136795,'Leo'],
  [1652136795,1652337252,'Virgo'],
  [1652337252,1652524431,'Libra'],
  [1652524431,1652701825,'Scorpio'],
  [1652701825,1652875314,'Sagittarius'],
  [1652875314,1653051167,'Capricorn'],
  [1653051167,1653234561,'Aquarius'],
  [1653234561,1653428361,'Pisces'],
  [1653428361,1653632541,'Aries'],
  [1653632541,1653844947,'Taurus'],
  [1653844947,1654062542,'Gemini'],
  [1654062542,1654281473,'Cancer'],
  [1654281473,1654496509,'Leo'],
  [1654496509,1654701753,'Virgo'],
  [1654701753,1654893654,'Libra'],
  [1654893654,1655073081,'Scorpio'],
  [1655073081,1655244836,'Sagittarius'],
  [1655244836,1655415840,'Capricorn'],
  [1655415840,1655593267,'Aquarius'],
  [1655593267,1655782609,'Pisces'],
  [1655782609,1655985468,'Aries'],
  [1655985468,1656198791,'Taurus'],
  [1656198791,1656417203,'Gemini'],
  [1656417203,1656635968,'Cancer'],
  [1656635968,1656851473,'Leo'],
  [1656851473,1657059886,'Virgo'],
  [1657059886,1657257301,'Libra'],
  [1657257301,1657442055,'Scorpio'],
  [1657442055,1657616460,'Sagittarius'],
  [1657616460,1657786395,'Capricorn'],
  [1657786395,1657959482,'Aquarius'],
  [1657959482,1658143032,'Pisces'],
  [1658143032,1658341352,'Aries'],
  [1658341352,1658553035,'Taurus'],
  [1658553035,1658771616,'Gemini'],
  [1658771616,1658990148,'Cancer'],
  [1658990148,1659204627,'Leo'],
  [1659204627,1659413132,'Virgo'],
  [1659413132,1659613612,'Libra'],
  [1659613612,1659803920,'Scorpio'],
  [1659803920,1659983926,'Sagittarius'],
  [1659983926,1660157091,'Capricorn'],
  [1660157091,1660329858,'Aquarius'],
  [1660329858,1660509763,'Pisces'],
  [1660509763,1660702933,'Aries'],
  [1660702933,1660910764,'Taurus'],
  [1660910764,1661128131,'Gemini'],
  [1661128131,1661346538,'Cancer'],
  [1661346538,1661559875,'Leo'],
  [1661559875,1661766290,'Virgo'],
  [1661766290,1661965872,'Libra'],
  [1661965872,1662158367,'Scorpio'],
  [1662158367,1662343352,'Sagittarius'],
  [1662343352,1662522073,'Capricorn'],
  [1662522073,1662698538,'Aquarius'],
  [1662698538,1662878823,'Pisces'],
  [1662878823,1663069151,'Aries'],
  [1663069151,1663272966,'Taurus'],
  [1663272966,1663487944,'Gemini'],
  [1663487944,1663706249,'Cancer'],
  [1663706249,1663919599,'Leo'],
  [1663919599,1664124165,'Virgo'],
  [1664124165,1664320473,'Libra'],
  [1664320473,1664510602,'Scorpio'],
  [1664510602,1664696261,'Sagittarius'],
  [1664696261,1664878822,'Capricorn'],
  [1664878822,1665060419,'Aquarius'],
  [1665060419,1665244598,'Pisces'],
  [1665244598,1665435811,'Aries'],
  [1665435811,1665637670,'Taurus'],
  [1665637670,1665850247,'Gemini'],
  [1665850247,1666068270,'Cancer'],
  [1666068270,1666283126,'Leo'],
  [1666283126,1666488238,'Virgo'],
  [1666488238,1666682308,'Libra'],
  [1666682308,1666868069,'Scorpio'],
  [1666868069,1667049682,'Sagittarius'],
  [1667049682,1667230968,'Capricorn'],
  [1667230968,1667414782,'Aquarius'],
  [1667414782,1667603214,'Pisces'],
  [1667603214,1667798075,'Aries'],
  [1667798075,1668001010,'Taurus'],
  [1668001010,1668212533,'Gemini'],
  [1668212533,1668430063,'Cancer'],
  [1668430063,1668647018,'Leo'],
  [1668647018,1668855454,'Virgo'],
  [1668855454,1669050950,'Libra'],
  [1669050950,1669234544,'Scorpio'],
  [1669234544,1669411097,'Sagittarius'],
  [1669411097,1669586825,'Capricorn'],
  [1669586825,1669767309,'Aquarius'],
  [1669767309,1669956050,'Pisces'],
  [1669956050,1670153867,'Aries'],
  [1670153867,1670359710,'Taurus'],
  [1670359710,1670572125,'Gemini'],
  [1670572125,1670789319,'Cancer'],
  [1670789319,1671007525,'Leo'],
  [1671007525,1671220150,'Virgo'],
  [1671220150,1671420639,'Libra'],
  [1671420639,1671606765,'Scorpio'],
  [1671606765,1671781776,'Sagittarius'],
  [1671781776,1671952438,'Capricorn'],
  [1671952438,1672126432,'Aquarius'],
  [1672126432,1672310158,'Pisces'],
  [1672310158,1672506497,'Aries'],
  [1672506497,1672713840,'Taurus'],
  [1672713840,1672928084,'Gemini'],
  [1672928084,1673145599,'Cancer'],
  [1673145599,1673363710,'Leo'],
  [1673363710,1673578592,'Virgo'],
  [1673578592,1673784504,'Libra'],
  [1673784504,1673976796,'Scorpio'],
  [1673976796,1674155493,'Sagittarius'],
  [1674155493,1674325726,'Capricorn'],
  [1674325726,1674495354,'Aquarius'],
  [1674495354,1674672472,'Pisces'],
  [1674672472,1674862943,'Aries'],
  [1674862943,1675067679,'Taurus'],
  [1675067679,1675282277,'Gemini'],
  [1675282277,1675500505,'Cancer'],
  [1675500505,1675718044,'Leo'],
  [1675718044,1675932396,'Virgo'],
  [1675932396,1676140471,'Libra'],
  [1676140471,1676338282,'Scorpio'],
  [1676338282,1676523593,'Sagittarius'],
  [1676523593,1676698475,'Capricorn'],
  [1676698475,1676868959,'Aquarius'],
  [1676868959,1677042835,'Pisces'],
  [1677042835,1677227351,'Aries'],
  [1677227351,1677426460,'Taurus'],
  [1677426460,1677638401,'Gemini'],
  [1677638401,1677856540,'Cancer'],
  [1677856540,1678073909,'Leo'],
  [1678073909,1678286641,'Virgo'],
  [1678286641,1678493149,'Libra'],
  [1678493149,1678692049,'Scorpio'],
  [1678692049,1678881943,'Sagittarius'],
  [1678881943,1679063098,'Capricorn'],
  [1679063098,1679238720,'Aquarius'],
  [1679238720,1679414480,'Pisces'],
  [1679414480,1679596923,'Aries'],
  [1679596923,1679791299,'Taurus'],
  [1679791299,1679998915,'Gemini'],
  [1679998915,1680215465,'Cancer'],
  [1680215465,1680433035,'Leo'],
  [1680433035,1680645068,'Virgo'],
  [1680645068,1680848967,'Libra'],
  [1680848967,1681045004,'Scorpio'],
  [1681045004,1681234388,'Sagittarius'],
  [1681234388,1681418522,'Capricorn'],
  [1681418522,1681599405,'Aquarius'],
  [1681599405,1681780157,'Pisces'],
  [1681780157,1681964980,'Aries'],
  [1681964980,1682158256,'Taurus'],
  [1682158256,1682362702,'Gemini'],
  [1682362702,1682576982,'Cancer'],
  [1682576982,1682794747,'Leo'],
  [1682794747,1683007733,'Virgo'],
  [1683007733,1683210743,'Libra'],
  [1683210743,1683403436,'Scorpio'],
  [1683403436,1683588776,'Sagittarius'],
  [1683588776,1683770723,'Capricorn'],
  [1683770723,1683952739,'Aquarius'],
  [1683952739,1684137338,'Pisces'],
  [1684137338,1684326450,'Aries'],
  [1684326450,1684522058,'Taurus'],
  [1684522058,1684726104,'Gemini'],
  [1684726104,1684938880,'Cancer'],
  [1684938880,1685156708,'Leo'],
  [1685156708,1685371833,'Virgo'],
  [1685371833,1685576698,'Libra'],
  [1685576698,1685768604,'Scorpio'],
  [1685768604,1685950251,'Sagittarius'],
  [1685950251,1686127292,'Capricorn'],
  [1686127292,1686305644,'Aquarius'],
  [1686305644,1686489623,'Pisces'],
  [1686489623,1686681066,'Aries'],
  [1686681066,1686879930,'Taurus'],
  [1686879930,1687085858,'Gemini'],
  [1687085858,1687298651,'Cancer'],
  [1687298651,1687516505,'Leo'],
  [1687516505,1687733830,'Virgo'],
  [1687733830,1687942524,'Libra'],
  [1687942524,1688137163,'Scorpio'],
  [1688137163,1688318403,'Sagittarius'],
  [1688318403,1688491801,'Capricorn'],
  [1688491801,1688664749,'Aquarius'],
  [1688664749,1688843933,'Pisces'],
  [1688843933,1689033320,'Aries'],
  [1689033320,1689233149,'Taurus'],
  [1689233149,1689441202,'Gemini'],
  [1689441202,1689655169,'Cancer'],
  [1689655169,1689873156,'Leo'],
  [1689873156,1690091648,'Virgo'],
  [1690091648,1690304119,'Libra'],
  [1690304119,1690503841,'Scorpio'],
  [1690503841,1690688647,'Sagittarius'],
  [1690688647,1690862270,'Capricorn'],
  [1690862270,1691031938,'Aquarius'],
  [1691031938,1691205554,'Pisces'],
  [1691205554,1691389461,'Aries'],
  [1691389461,1691586296,'Taurus'],
  [1691586296,1691794315,'Gemini'],
  [1691794315,1692009367,'Cancer'],
  [1692009367,1692227641,'Leo'],
  [1692227641,1692445995,'Virgo'],
  [1692445995,1692660126,'Libra'],
  [1692660126,1692864443,'Scorpio'],
  [1692864443,1693055119,'Sagittarius'],
  [1693055119,1693233100,'Capricorn'],
  [1693233100,1693403793,'Aquarius'],
  [1693403793,1693574691,'Pisces'],
  [1693574691,1693753181,'Aries'],
  [1693753181,1693944400,'Taurus'],
  [1693944400,1694149179,'Gemini'],
  [1694149179,1694363759,'Cancer'],
  [1694363759,1694582268,'Leo'],
  [1694582268,1694799865,'Virgo'],
  [1694799865,1695013095,'Libra'],
  [1695013095,1695218758,'Scorpio'],
  [1695218758,1695414018,'Sagittarius'],
  [1695414018,1695598167,'Capricorn'],
  [1695598167,1695773890,'Aquarius'],
  [1695773890,1695946636,'Pisces'],
  [1695946636,1696123078,'Aries'],
  [1696123078,1696309391,'Taurus'],
  [1696309391,1696509109,'Gemini'],
  [1696509109,1696721062,'Cancer'],
  [1696721062,1696939296,'Leo'],
  [1696939296,1697156521,'Virgo'],
  [1697156521,1697367853,'Libra'],
  [1697367853,1697571390,'Scorpio'],
  [1697571390,1697766883,'Sagittarius'],
  [1697766883,1697954761,'Capricorn'],
  [1697954761,1698136368,'Aquarius'],
  [1698136368,1698314495,'Pisces'],
  [1698314495,1698493450,'Aries'],
  [1698493450,1698678460,'Taurus'],
  [1698678460,1698874217,'Gemini'],
  [1698874217,1699082455,'Cancer'],
  [1699082455,1699299541,'Leo'],
  [1699299541,1699517269,'Virgo'],
  [1699517269,1699727955,'Libra'],
  [1699727955,1699928574,'Scorpio'],
  [1699928574,1700120489,'Sagittarius'],
  [1700120489,1700306850,'Capricorn'],
  [1700306850,1700490537,'Aquarius'],
  [1700490537,1700673563,'Pisces'],
  [1700673563,1700857715,'Aries'],
  [1700857715,1701045596,'Taurus'],
  [1701045596,1701240813,'Gemini'],
  [1701240813,1701446421,'Cancer'],
  [1701446421,1701661811,'Leo'],
  [1701661811,1701880477,'Virgo'],
  [1701880477,1702092887,'Libra'],
  [1702092887,1702293056,'Scorpio'],
  [1702293056,1702481484,'Sagittarius'],
  [1702481484,1702662958,'Capricorn'],
  [1702662958,1702843097,'Aquarius'],
  [1702843097,1703025999,'Pisces'],
  [1703025999,1703213402,'Aries'],
  [1703213402,1703405680,'Taurus'],
  [1703405680,1703603710,'Gemini'],
  [1703603710,1703809382,'Cancer'],
  [1703809382,1704023591,'Leo'],
  [1704023591,1704242810,'Virgo'],
  [1704242810,1704458369,'Libra'],
  [1704458369,1704661707,'Scorpio'],
  [1704661707,1704850400,'Sagittarius'],
  [1704850400,1705028484,'Capricorn'],
  [1705028484,1705202944,'Aquarius'],
  [1705202944,1705380508,'Pisces'],
  [1705380508,1705565519,'Aries'],
  [1705565519,1705759071,'Taurus'],
  [1705759071,1705960243,'Gemini'],
  [1705960243,1706168197,'Cancer'],
  [1706168197,1706382672,'Leo'],
  [1706382672,1706601850,'Virgo'],
  [1706601850,1706819814,'Libra'],
  [1706819814,1707028088,'Scorpio'],
  [1707028088,1707221322,'Sagittarius'],
  [1707221322,1707400764,'Capricorn'],
  [1707400764,1707572548,'Aquarius'],
  [1707572548,1707744343,'Pisces'],
  [1707744343,1707922931,'Aries'],
  [1707922931,1708112368,'Taurus'],
  [1708112368,1708313080,'Gemini'],
  [1708313080,1708522823,'Cancer'],
  [1708522823,1708738650,'Leo'],
  [1708738650,1708957760,'Virgo'],
  [1708957760,1709176144,'Libra'],
  [1709176144,1709387772,'Scorpio'],
  [1709387772,1709586914,'Sagittarius'],
  [1709586914,1709771910,'Capricorn'],
  [1709771910,1709946203,'Aquarius'],
  [1709946203,1710116354,'Pisces'],
  [1710116354,1710289696,'Aries'],
  [1710289696,1710472540,'Taurus'],
  [1710472540,1710668420,'Gemini'],
  [1710668420,1710876759,'Cancer'],
  [1710876759,1711093300,'Leo'],
  [1711093300,1711312649,'Virgo'],
  [1711312649,1711530163,'Libra'],
  [1711530163,1711741899,'Scorpio'],
  [1711741899,1711944315,'Sagittarius'],
  [1711944315,1712135271,'Capricorn'],
  [1712135271,1712315564,'Aquarius'],
  [1712315564,1712489090,'Pisces'],
  [1712489090,1712661801,'Aries'],
  [1712661801,1712840314,'Taurus'],
  [1712840314,1713030293,'Gemini'],
  [1713030293,1713234235,'Cancer'],
  [1713234235,1713449424,'Leo'],
  [1713449424,1713668893,'Virgo'],
  [1713668893,1713885595,'Libra'],
  [1713885595,1714095418,'Scorpio'],
  [1714095418,1714297049,'Sagittarius'],
  [1714297049,1714490372,'Capricorn'],
  [1714490372,1714675900,'Aquarius'],
  [1714675900,1714855247,'Pisces'],
  [1714855247,1715031737,'Aries'],
  [1715031737,1715210433,'Taurus'],
  [1715210433,1715397182,'Gemini'],
  [1715397182,1715596562,'Cancer'],
  [1715596562,1715808766,'Leo'],
  [1715808766,1716027753,'Virgo'],
  [1716027753,1716244451,'Libra'],
  [1716244451,1716452651,'Scorpio'],
  [1716452651,1716651344,'Sagittarius'],
  [1716651344,1716842678,'Capricorn'],
  [1716842678,1717029160,'Aquarius'],
  [1717029160,1717212495,'Pisces'],
  [1717212495,1717394123,'Aries'],
  [1717394123,1717576570,'Taurus'],
  [1717576570,1717764053,'Gemini'],
  [1717764053,1717961321,'Cancer'],
  [1717961321,1718170716,'Leo'],
  [1718170716,1718388733,'Virgo'],
  [1718388733,1718606275,'Libra'],
  [1718606275,1718814704,'Scorpio'],
  [1718814704,1719011308,'Sagittarius'],
  [1719011308,1719198856,'Capricorn'],
  [1719198856,1719382052,'Aquarius'],
  [1719382052,1719564714,'Pisces'],
  [1719564714,1719748816,'Aries'],
  [1719748816,1719935403,'Taurus'],
  [1719935403,1720126283,'Gemini'],
  [1720126283,1720324542,'Cancer'],
  [1720324542,1720532844,'Leo'],
  [1720532844,1720749980,'Virgo'],
  [1720749980,1720968760,'Libra'],
  [1720968760,1721179494,'Scorpio'],
  [1721179494,1721376827,'Sagittarius'],
  [1721376827,1721562184,'Capricorn'],
  [1721562184,1721740977,'Aquarius'],
  [1721740977,1721919135,'Pisces'],
  [1721919135,1722100952,'Aries'],
  [1722100952,1722288455,'Taurus'],
  [1722288455,1722482340,'Gemini'],
  [1722482340,1722683374,'Cancer'],
  [1722683374,1722892599,'Leo'],
  [1722892599,1723109480,'Virgo'],
  [1723109480,1723329220,'Libra'],
  [1723329220,1723543240,'Scorpio'],
  [1723543240,1723744279,'Sagittarius'],
  [1723744279,1723931082,'Capricorn'],
  [1723931082,1724107900,'Aquarius'],
  [1724107900,1724281297,'Pisces'],
  [1724281297,1724457617,'Aries'],
  [1724457617,1724641436,'Taurus'],
  [1724641436,1724834841,'Gemini'],
  [1724834841,1725037759,'Cancer'],
  [1725037759,1725248898,'Leo'],
  [1725248898,1725466295,'Virgo'],
  [1725466295,1725686304,'Libra'],
  [1725686304,1725902729,'Scorpio'],
  [1725902729,1726108659,'Sagittarius'],
  [1726108659,1726300406,'Capricorn'],
  [1726300406,1726479543,'Aquarius'],
  [1726479543,1726651445,'Pisces'],
  [1726651445,1726822953,'Aries'],
  [1726822953,1727000656,'Taurus'],
  [1727000656,1727189399,'Gemini'],
  [1727189399,1727390836,'Cancer'],
  [1727390836,1727602895,'Leo'],
  [1727602895,1727821171,'Virgo'],
  [1727821171,1728040943,'Libra'],
  [1728040943,1728257650,'Scorpio'],
  [1728257650,1728466701,'Sagittarius'],
  [1728466701,1728664270,'Capricorn'],
  [1728664270,1728849314,'Aquarius'],
  [1728849314,1729024458,'Pisces'],
  [1729024458,1729195188,'Aries'],
  [1729195188,1729368425,'Taurus'],
  [1729368425,1729550976,'Gemini'],
  [1729550976,1729747434,'Cancer'],
  [1729747434,1729957644,'Leo'],
  [1729957644,1730176178,'Virgo'],
  [1730176178,1730395761,'Libra'],
  [1730395761,1730611168,'Scorpio'],
  [1730611168,1730819846,'Sagittarius'],
  [1730819846,1731020258,'Capricorn'],
  [1731020258,1731211190,'Aquarius'],
  [1731211190,1731392742,'Pisces'],
  [1731392742,1731567546,'Aries'],
  [1731567546,1731740926,'Taurus'],
  [1731740926,1731919792,'Gemini'],
  [1731919792,1732110648,'Cancer'],
  [1732110648,1732316453,'Leo'],
  [1732316453,1732533584,'Virgo'],
  [1732533584,1732753237,'Libra'],
  [1732753237,1732967574,'Scorpio'],
  [1732967574,1733173743,'Sagittarius'],
  [1733173743,1733372469,'Capricorn'],
  [1733372469,1733564930,'Aquarius'],
  [1733564930,1733751454,'Pisces'],
  [1733751454,1733932502,'Aries'],
  [1733932502,1734110509,'Taurus'],
  [1734110509,1734290481,'Gemini'],
  [1734290481,1734478750,'Cancer'],
  [1734478750,1734680211,'Leo'],
  [1734680211,1734894455,'Virgo'],
  [1734894455,1735113981,'Libra'],
  [1735113981,1735328788,'Scorpio'],
  [1735328788,1735533434,'Sagittarius'],
  [1735533434,1735728580,'Capricorn'],
  [1735728580,1735917670,'Aquarius'],
  [1735917670,1736103652,'Pisces'],
  [1736103652,1736287874,'Aries'],
  [1736287874,1736471199,'Taurus'],
  [1736471199,1736655851,'Gemini'],
  [1736655851,1736845932,'Cancer'],
  [1736845932,1737045944,'Leo'],
  [1737045944,1737257576,'Virgo'],
  [1737257576,1737476416,'Libra'],
  [1737476416,1737692932,'Scorpio'],
  [1737692932,1737898960,'Sagittarius'],
  [1737898960,1738092689,'Capricorn'],
  [1738092689,1738277545,'Aquarius'],
  [1738277545,1738458594,'Pisces'],
  [1738458594,1738640006,'Aries'],
  [1738640006,1738824226,'Taurus'],
  [1738824226,1739012654,'Gemini'],
  [1739012654,1739206838,'Cancer'],
  [1739206838,1739408826,'Leo'],
  [1739408826,1739619895,'Virgo'],
  [1739619895,1739837931,'Libra'],
  [1739837931,1740056083,'Scorpio'],
  [1740056083,1740265721,'Sagittarius'],
  [1740265721,1740461991,'Capricorn'],
  [1740461991,1740646000,'Aquarius'],
  [1740646000,1740822718,'Pisces'],
  [1740822718,1740998203,'Aries'],
  [1740998203,1741177763,'Taurus'],
  [1741177763,1741364929,'Gemini'],
  [1741364929,1741561135,'Cancer'],
  [1741561135,1741766134,'Leo'],
  [1741766134,1741978727,'Virgo'],
  [1741978727,1742196630,'Libra'],
  [1742196630,1742415417,'Scorpio'],
  [1742415417,1742628520,'Sagittarius'],
  [1742628520,1742829879,'Capricorn'],
  [1742829879,1743017506,'Aquarius'],
  [1743017506,1743194176,'Pisces'],
  [1743194176,1743365751,'Aries'],
  [1743365751,1743539139,'Taurus'],
  [1743539139,1743720602,'Gemini'],
  [1743720602,1743914050,'Cancer'],
  [1743914050,1744119595,'Leo'],
  [1744119595,1744333906,'Virgo'],
  [1744333906,1744552451,'Libra'],
  [1744552451,1744771033,'Scorpio'],
  [1744771033,1744985521,'Sagittarius'],
  [1744985521,1745191293,'Capricorn'],
  [1745191293,1745384804,'Aquarius'],
  [1745384804,1745565853,'Pisces'],
  [1745565853,1745738214,'Aries'],
  [1745738214,1745908473,'Taurus'],
  [1745908473,1746084163,'Gemini'],
  [1746084163,1746271755,'Cancer'],
  [1746271755,1746473987,'Leo'],
  [1746473987,1746687980,'Virgo'],
  [1746687980,1746907100,'Libra'],
  [1746907100,1747125283,'Scorpio'],
  [1747125283,1747339057,'Sagittarius'],
  [1747339057,1747546161,'Capricorn'],
  [1747546161,1747744106,'Aquarius'],
  [1747744106,1747931149,'Pisces'],
  [1747931149,1748108285,'Aries'],
  [1748108285,1748280086,'Taurus'],
  [1748280086,1748453568,'Gemini'],
  [1748453568,1748636199,'Cancer'],
  [1748636199,1748833208,'Leo'],
  [1748833208,1749044297,'Virgo'],
  [1749044297,1749262960,'Libra'],
  [1749262960,1749480932,'Scorpio'],
  [1749480932,1749693286,'Sagittarius'],
  [1749693286,1749898810,'Capricorn'],
  [1749898810,1750097316,'Aquarius'],
  [1750097316,1750288075,'Pisces'],
  [1750288075,1750470769,'Aries'],
  [1750470769,1750647429,'Taurus'],
  [1750647429,1750823040,'Gemini'],
  [1750823040,1751004320,'Cancer'],
  [1751004320,1751197413,'Leo'],
  [1751197413,1751404580,'Virgo'],
  [1751404580,1751621573,'Libra'],
  [1751621573,1751839571,'Scorpio'],
  [1751839571,1752051289,'Sagittarius'],
  [1752051289,1752254476,'Capricorn'],
  [1752254476,1752450287,'Aquarius'],
  [1752450287,1752640338,'Pisces'],
  [1752640338,1752825518,'Aries'],
  [1752825518,1753006901,'Taurus'],
  [1753006901,1753187173,'Gemini'],
  [1753187173,1753370903,'Cancer'],
  [1753370903,1753563323,'Leo'],
  [1753563323,1753767783,'Virgo'],
  [1753767783,1753982694,'Libra'],
  [1753982694,1754200830,'Scorpio'],
  [1754200830,1754413459,'Sagittarius'],
  [1754413459,1754615890,'Capricorn'],
  [1754615890,1754808611,'Aquarius'],
  [1754808611,1754994772,'Pisces'],
  [1754994772,1755177717,'Aries'],
  [1755177717,1755360035,'Taurus'],
  [1755360035,1755543903,'Gemini'],
  [1755543903,1755731794,'Cancer'],
  [1755731794,1755926636,'Leo'],
  [1755926636,1756130890,'Virgo'],
  [1756130890,1756344434,'Libra'],
  [1756344434,1756562661,'Scorpio'],
  [1756562661,1756777482,'Sagittarius'],
  [1756777482,1756981919,'Capricorn'],
  [1756981919,1757174053,'Aquarius'],
  [1757174053,1757356624,'Pisces'],
  [1757356624,1757534596,'Aries'],
  [1757534596,1757713104,'Taurus'],
  [1757713104,1757896216,'Gemini'],
  [1757896216,1758086387,'Cancer'],
  [1758086387,1758284579,'Leo'],
  [1758284579,1758490843,'Virgo'],
  [1758490843,1758704426,'Libra'],
  [1758704426,1758922623,'Scorpio'],
  [1758922623,1759139699,'Sagittarius'],
  [1759139699,1759348291,'Capricorn'],
  [1759348291,1759543615,'Aquarius'],
  [1759543615,1759726074,'Pisces'],
  [1759726074,1759900347,'Aries'],
  [1759900347,1760073119,'Taurus'],
  [1760073119,1760251021,'Gemini'],
  [1760251021,1760438822,'Cancer'],
  [1760438822,1760637933,'Leo'],
  [1760637933,1760846489,'Virgo'],
  [1760846489,1761061337,'Libra'],
  [1761061337,1761279533,'Scorpio'],
  [1761279533,1761497594,'Sagittarius'],
  [1761497594,1761710116,'Capricorn'],
  [1761710116,1761911153,'Aquarius'],
  [1761911153,1762097966,'Pisces'],
  [1762097966,1762272945,'Aries'],
  [1762272945,1762442439,'Taurus'],
  [1762442439,1762614359,'Gemini'],
  [1762614359,1762795997,'Cancer'],
  [1762795997,1762991504,'Leo'],
  [1762991504,1763199824,'Virgo'],
  [1763199824,1763415866,'Libra'],
  [1763415866,1763634356,'Scorpio'],
  [1763634356,1763851954,'Sagittarius'],
  [1763851954,1764065737,'Capricorn'],
  [1764065737,1764271418,'Aquarius'],
  [1764271418,1764464822,'Pisces'],
  [1764464822,1764645169,'Aries'],
  [1764645169,1764816488,'Taurus'],
  [1764816488,1764986065,'Gemini'],
  [1764986065,1765162084,'Cancer'],
  [1765162084,1765351202,'Leo'],
  [1765351202,1765555448,'Virgo'],
  [1765555448,1765770676,'Libra'],
  [1765770676,1765989512,'Scorpio'],
  [1765989512,1766206345,'Sagittarius'],
  [1766206345,1766418711,'Capricorn'],
  [1766418711,1766624931,'Aquarius'],
  [1766624931,1766822504,'Pisces'],
  [1766822504,1767009436,'Aries'],
  [1767009436,1767186780,'Taurus'],
  [1767186780,1767359341,'Gemini'],
  [1767359341,1767534211,'Cancer'],
  [1767534211,1767718609,'Leo'],
  [1767718609,1767917153,'Virgo'],
  [1767917153,1768128921,'Libra'],
  [1768128921,1768347231,'Scorpio'],
  [1768347231,1768564024,'Sagittarius'],
  [1768564024,1768774673,'Capricorn'],
  [1768774673,1768978183,'Aquarius'],
  [1768978183,1769174746,'Pisces'],
  [1769174746,1769364314,'Aries'],
  [1769364314,1769547292,'Taurus'],
  [1769547292,1769725902,'Gemini'],
  [1769725902,1769904545,'Cancer'],
  [1769904545,1770088879,'Leo'],
  [1770088879,1770283956,'Virgo'],
  [1770283956,1770491586,'Libra'],
  [1770491586,1770708113,'Scorpio'],
  [1770708113,1770925466,'Sagittarius'],
  [1770925466,1771136197,'Capricorn'],
  [1771136197,1771337350,'Aquarius'],
  [1771337350,1771529950,'Pisces'],
  [1771529950,1771716659,'Aries'],
  [1771716659,1771900131,'Taurus'],
  [1771900131,1772082664,'Gemini'],
  [1772082664,1772266609,'Cancer'],
  [1772266609,1772454829,'Leo'],
  [1772454829,1772650547,'Virgo'],
  [1772650547,1772856086,'Libra'],
  [1772856086,1773070594,'Scorpio'],
  [1773070594,1773288433,'Sagittarius'],
  [1773288433,1773501207,'Capricorn'],
  [1773501207,1773702945,'Aquarius'],
  [1773702945,1773892990,'Pisces'],
  [1773892990,1774074912,'Aries'],
  [1774074912,1774253924,'Taurus'],
  [1774253924,1774434779,'Gemini'],
  [1774434779,1774620612,'Cancer'],
  [1774620612,1774812801,'Leo'],
  [1774812801,1775011843,'Virgo'],
  [1775011843,1775218251,'Libra'],
  [1775218251,1775431898,'Scorpio'],
  [1775431898,1775649868,'Sagittarius'],
  [1775649868,1775865326,'Capricorn'],
  [1775865326,1776070531,'Aquarius'],
  [1776070531,1776261849,'Pisces'],
  [1776261849,1776441478,'Aries'],
  [1776441478,1776615466,'Taurus'],
  [1776615466,1776790820,'Gemini'],
  [1776790820,1776973244,'Cancer'],
  [1776973244,1777165467,'Leo'],
  [1777165467,1777366961,'Virgo'],
  [1777366961,1777575710,'Libra'],
  [1777575710,1777790017,'Scorpio'],
  [1777790017,1778007976,'Sagittarius'],
  [1778007976,1778225247,'Capricorn'],
  [1778225247,1778434759,'Aquarius'],
  [1778434759,1778630626,'Pisces'],
  [1778630626,1778812273,'Aries'],
  [1778812273,1778984589,'Taurus'],
  [1778984589,1779155176,'Gemini'],
  [1779155176,1779331660,'Cancer'],
  [1779331660,1779519423,'Leo'],
  [1779519423,1779719651,'Virgo'],
  [1779719651,1779929553,'Libra'],
  [1779929553,1780145094,'Scorpio'],
  [1780145094,1780363161,'Sagittarius'],
  [1780363161,1780580739,'Capricorn'],
  [1780580739,1780792964,'Aquarius'],
  [1780792964,1780994008,'Pisces'],
  [1780994008,1781180892,'Aries'],
  [1781180892,1781355959,'Taurus'],
  [1781355959,1781525661,'Gemini'],
  [1781525661,1781697913,'Cancer'],
  [1781697913,1781879818,'Leo'],
  [1781879818,1782075302,'Virgo'],
  [1782075302,1782283397,'Libra'],
  [1782283397,1782499256,'Scorpio'],
  [1782499256,1782717512,'Sagittarius'],
  [1782717512,1782934371,'Capricorn'],
  [1782934371,1783146609,'Aquarius'],
  [1783146609,1783350425,'Pisces'],
  [1783350425,1783542649,'Aries'],
  [1783542649,1783723295,'Taurus'],
  [1783723295,1783896386,'Gemini'],
  [1783896386,1784068511,'Cancer'],
  [1784068511,1784246832,'Leo'],
  [1784246832,1784437005,'Virgo'],
  [1784437005,1784640873,'Libra'],
  [1784640873,1784855217,'Scorpio'],
  [1784855217,1785073454,'Sagittarius'],
  [1785073454,1785289571,'Capricorn'],
  [1785289571,1785500034,'Aquarius'],
  [1785500034,1785703003,'Pisces'],
  [1785703003,1785897324,'Aries'],
  [1785897324,1786082865,'Taurus'],
  [1786082865,1786261538,'Gemini'],
  [1786261538,1786437482,'Cancer'],
  [1786437482,1786616281,'Leo'],
  [1786616281,1786803591,'Virgo'],
  [1786803591,1787003170,'Libra'],
  [1787003170,1787214601,'Scorpio'],
  [1787214601,1787432344,'Sagittarius'],
  [1787432344,1787648505,'Capricorn'],
  [1787648505,1787857433,'Aquarius'],
  [1787857433,1788057462,'Pisces'],
  [1788057462,1788249672,'Aries'],
  [1788249672,1788436037,'Taurus'],
  [1788436037,1788618626,'Gemini'],
  [1788618626,1788799763,'Cancer'],
  [1788799763,1788982494,'Leo'],
  [1788982494,1789170697,'Virgo'],
  [1789170697,1789368236,'Libra'],
  [1789368236,1789576876,'Scorpio'],
  [1789576876,1789793687,'Sagittarius'],
  [1789793687,1790010863,'Capricorn'],
  [1790010863,1790220221,'Aquarius'],
  [1790220221,1790418184,'Pisces'],
  [1790418184,1790606391,'Aries'],
  [1790606391,1790789159,'Taurus'],
  [1790789159,1790970850,'Gemini'],
  [1790970850,1791154453,'Cancer'],
  [1791154453,1791341550,'Leo'],
  [1791341550,1791533427,'Virgo'],
  [1791533427,1791732076,'Libra'],
  [1791732076,1791939567,'Scorpio'],
  [1791939567,1792155420,'Sagittarius'],
  [1792155420,1792373991,'Capricorn'],
  [1792373991,1792586103,'Aquarius'],
  [1792586103,1792785207,'Pisces'],
  [1792785207,1792971274,'Aries'],
  [1792971274,1793149309,'Taurus'],
  [1793149309,1793325930,'Gemini'],
  [1793325930,1793506690,'Cancer'],
  [1793506690,1793694465,'Leo'],
  [1793694465,1793889493,'Virgo'],
  [1793889493,1794091198,'Libra'],
  [1794091198,1794299749,'Scorpio'],
  [1794299749,1794515231,'Sagittarius'],
  [1794515231,1794734649,'Capricorn'],
  [1794734649,1794950359,'Aquarius'],
  [1794950359,1795153928,'Pisces'],
  [1795153928,1795342179,'Aries'],
  [1795342179,1795518585,'Taurus'],
  [1795518585,1795690276,'Gemini'],
  [1795690276,1795864826,'Cancer'],
  [1795864826,1796047954,'Leo'],
  [1796047954,1796241834,'Virgo'],
  [1796241834,1796445300,'Libra'],
  [1796445300,1796655998,'Scorpio'],
  [1796655998,1796872114,'Sagittarius'],
  [1796872114,1797091529,'Capricorn'],
  [1797091529,1797309332,'Aquarius'],
  [1797309332,1797518059,'Pisces'],
  [1797518059,1797712182,'Aries'],
  [1797712182,1797892025,'Taurus'],
  [1797892025,1798063110,'Gemini'],
  [1798063110,1798233138,'Cancer'],
  [1798233138,1798409563,'Leo'],
  [1798409563,1798597603,'Virgo'],
  [1798597603,1798798552,'Libra'],
  [1798798552,1799009821,'Scorpio'],
  [1799009821,1799227030,'Sagittarius'],
  [1799227030,1799446244,'Capricorn'],
  [1799446244,1799663744,'Aquarius'],
  [1799663744,1799874812,'Pisces'],
  [1799874812,1800074628,'Aries'],
  [1800074628,1800261165,'Taurus'],
  [1800261165,1800436856,'Gemini'],
  [1800436856,1800607511,'Cancer'],
  [1800607511,1800780293,'Leo'],
  [1800780293,1800961940,'Virgo'],
  [1800961940,1801156873,'Libra'],
  [1801156873,1801365220,'Scorpio'],
  [1801365220,1801582379,'Sagittarius'],
  [1801582379,1801801710,'Capricorn'],
  [1801801710,1802017902,'Aquarius'],
  [1802017902,1802227716,'Pisces'],
  [1802227716,1802429069,'Aries'],
  [1802429069,1802620711,'Taurus'],
  [1802620711,1802803102,'Gemini'],
  [1802803102,1802979063,'Cancer'],
  [1802979063,1803153541,'Leo'],
  [1803153541,1803332663,'Virgo'],
  [1803332663,1803522254,'Libra'],
  [1803522254,1803725550,'Scorpio'],
  [1803725550,1803940534,'Sagittarius'],
  [1803940534,1804159898,'Capricorn'],
  [1804159898,1804375528,'Aquarius'],
  [1804375528,1804582952,'Pisces'],
  [1804582952,1804781774,'Aries'],
  [1804781774,1804973422,'Taurus'],
  [1804973422,1805159428,'Gemini'],
  [1805159428,1805341239,'Cancer'],
  [1805341239,1805521024,'Leo'],
  [1805521024,1805702500,'Virgo'],
  [1805702500,1805890690,'Libra'],
  [1805890690,1806090183,'Scorpio'],
  [1806090183,1806301983,'Sagittarius'],
  [1806301983,1806520789,'Capricorn'],
  [1806520789,1806737104,'Aquarius'],
  [1806737104,1806943703,'Pisces'],
  [1806943703,1807139376,'Aries'],
  [1807139376,1807327275,'Taurus'],
  [1807327275,1807511507,'Gemini'],
  [1807511507,1807694987,'Cancer'],
  [1807694987,1807879162,'Leo'],
  [1807879162,1808065314,'Virgo'],
  [1808065314,1808256033,'Libra'],
  [1808256033,1808455027,'Scorpio'],
  [1808455027,1808664715,'Sagittarius'],
  [1808664715,1808882622,'Capricorn'],
  [1808882622,1809100337,'Aquarius'],
  [1809100337,1809308564,'Pisces'],
  [1809308564,1809503561,'Aries'],
  [1809503561,1809687993,'Taurus'],
  [1809687993,1809867548,'Gemini'],
  [1809867548,1810047625,'Cancer'],
  [1810047625,1810231529,'Leo'],
  [1810231529,1810420408,'Virgo'],
  [1810420408,1810614796,'Libra'],
  [1810614796,1810816036,'Scorpio'],
  [1810816036,1811025754,'Sagittarius'],
  [1811025754,1811243097,'Capricorn'],
  [1811243097,1811462106,'Aquarius'],
  [1811462106,1811673557,'Pisces'],
  [1811673557,1811871179,'Aries'],
  [1811871179,1812055396,'Taurus'],
  [1812055396,1812231538,'Gemini'],
  [1812231538,1812406371,'Cancer'],
  [1812406371,1812585625,'Leo'],
  [1812585625,1812772626,'Virgo'],
  [1812772626,1812968235,'Libra'],
  [1812968235,1813172018,'Scorpio'],
  [1813172018,1813383328,'Sagittarius'],
  [1813383328,1813600829,'Capricorn'],
  [1813600829,1813820447,'Aquarius'],
  [1813820447,1814034919,'Pisces'],
  [1814034919,1814237183,'Aries'],
  [1814237183,1814424946,'Taurus'],
  [1814424946,1814601502,'Gemini'],
  [1814601502,1814773221,'Cancer'],
  [1814773221,1814947013,'Leo'],
  [1814947013,1815128613,'Virgo'],
  [1815128613,1815321277,'Libra'],
  [1815321277,1815525178,'Scorpio'],
  [1815525178,1815737949,'Sagittarius'],
  [1815737949,1815956129,'Capricorn'],
  [1815956129,1816175644,'Aquarius'],
  [1816175644,1816391351,'Pisces'],
  [1816391351,1816597675,'Aries'],
  [1816597675,1816791002,'Taurus'],
  [1816791002,1816971887,'Gemini'],
  [1816971887,1817144692,'Cancer'],
  [1817144692,1817315823,'Leo'],
  [1817315823,1817492088,'Virgo'],
  [1817492088,1817679162,'Libra'],
  [1817679162,1817879743,'Scorpio'],
  [1817879743,1818092070,'Sagittarius'],
  [1818092070,1818310774,'Capricorn'],
  [1818310774,1818529903,'Aquarius'],
  [1818529903,1818744853,'Pisces'],
  [1818744853,1818952363,'Aries'],
  [1818952363,1819149995,'Taurus'],
  [1819149995,1819336843,'Gemini'],
  [1819336843,1819514551,'Cancer'],
  [1819514551,1819687419,'Leo'],
  [1819687419,1819861619,'Virgo'],
  [1819861619,1820043845,'Libra'],
  [1820043845,1820239276,'Scorpio'],
  [1820239276,1820448707,'Sagittarius'],
  [1820448707,1820666989,'Capricorn'],
  [1820666989,1820885934,'Aquarius'],
  [1820885934,1821099380,'Pisces'],
  [1821099380,1821305114,'Aries'],
  [1821305114,1821503147,'Taurus'],
  [1821503147,1821693730,'Gemini'],
  [1821693730,1821877230,'Cancer'],
  [1821877230,1822055289,'Leo'],
  [1822055289,1822231824,'Virgo'],
  [1822231824,1822412723,'Libra'],
  [1822412723,1822604158,'Scorpio'],
  [1822604158,1822809561,'Sagittarius'],
  [1822809561,1823026175,'Capricorn'],
  [1823026175,1823245293,'Aquarius'],
  [1823245293,1823458183,'Pisces'],
  [1823458183,1823661409,'Aries'],
  [1823661409,1823856376,'Taurus'],
  [1823856376,1824045887,'Gemini'],
  [1824045887,1824231773,'Cancer'],
  [1824231773,1824414829,'Leo'],
  [1824414829,1824596473,'Virgo'],
  [1824596473,1824780170,'Libra'],
  [1824780170,1824971058,'Scorpio'],
  [1824971058,1825173637,'Sagittarius'],
  [1825173637,1825387991,'Capricorn'],
  [1825387991,1825607335,'Aquarius'],
  [1825607335,1825821509,'Pisces'],
  [1825821509,1826024270,'Aries'],
  [1826024270,1826216060,'Taurus'],
  [1826216060,1826401156,'Gemini'],
  [1826401156,1826584052,'Cancer'],
  [1826584052,1826767518,'Leo'],
  [1826767518,1826952752,'Virgo'],
  [1826952752,1827141012,'Libra'],
  [1827141012,1827334843,'Scorpio'],
  [1827334843,1827537501,'Sagittarius'],
  [1827537501,1827750361,'Capricorn'],
  [1827750361,1827969597,'Aquarius'],
  [1827969597,1828186230,'Pisces'],
  [1828186230,1828391744,'Aries'],
  [1828391744,1828583683,'Taurus'],
  [1828583683,1828765443,'Gemini'],
  [1828765443,1828942856,'Cancer'],
  [1828942856,1829121409,'Leo'],
  [1829121409,1829304806,'Virgo'],
  [1829304806,1829494828,'Libra'],
  [1829494828,1829692204,'Scorpio'],
  [1829692204,1829897449,'Sagittarius'],
  [1829897449,1830110640,'Capricorn'],
  [1830110640,1830329563,'Aquarius'],
  [1830329563,1830548121,'Pisces'],
  [1830548121,1830758157,'Aries'],
  [1830758157,1830954382,'Taurus'],
  [1830954382,1831137297,'Gemini'],
  [1831137297,1831311777,'Cancer'],
  [1831311777,1831484399,'Leo'],
  [1831484399,1831661487,'Virgo'],
  [1831661487,1831847709,'Libra'],
  [1831847709,1832045027,'Scorpio'],
  [1832045027,1832252507,'Sagittarius'],
  [1832252507,1832467423,'Capricorn'],
  [1832467423,1832686430,'Aquarius'],
  [1832686430,1832905342,'Pisces'],
  [1832905342,1833118634,'Aries'],
  [1833118634,1833320751,'Taurus'],
  [1833320751,1833509192,'Gemini'],
  [1833509192,1833685945,'Cancer'],
  [1833685945,1833856497,'Leo'],
  [1833856497,1834027964,'Virgo'],
  [1834027964,1834207379,'Libra'],
  [1834207379,1834399768,'Scorpio'],
  [1834399768,1834605916,'Sagittarius'],
  [1834605916,1834821825,'Capricorn'],
  [1834821825,1835041419,'Aquarius'],
  [1835041419,1835259716,'Pisces'],
  [1835259716,1835473298,'Aries'],
  [1835473298,1835678931,'Taurus'],
  [1835678931,1835873644,'Gemini'],
  [1835873644,1836056570,'Cancer'],
  [1836056570,1836230357,'Leo'],
  [1836230357,1836400867,'Virgo'],
  [1836400867,1836575581,'Libra'],
  [1836575581,1836761596,'Scorpio'],
  [1836761596,1836962812,'Sagittarius'],
  [1836962812,1837177040,'Capricorn'],
  [1837177040,1837396826,'Aquarius'],
  [1837396826,1837614629,'Pisces'],
  [1837614629,1837826637,'Aries'],
  [1837826637,1838031798,'Taurus'],
  [1838031798,1838229257,'Gemini'],
  [1838229257,1838417871,'Cancer'],
  [1838417871,1838597794,'Leo'],
  [1838597794,1838772167,'Virgo'],
  [1838772167,1838947003,'Libra'],
  [1838947003,1839129510,'Scorpio'],
  [1839129510,1839325511,'Sagittarius'],
  [1839325511,1839535887,'Capricorn'],
  [1839535887,1839754610,'Aquarius'],
  [1839754610,1839972395,'Pisces'],
  [1839972395,1840183105,'Aries'],
  [1840183105,1840385684,'Taurus'],
  [1840385684,1840581453,'Gemini'],
  [1840581453,1840771382,'Cancer'],
  [1840771382,1840955734,'Leo'],
  [1840955734,1841135636,'Virgo'],
  [1841135636,1841314532,'Libra'],
  [1841314532,1841497937,'Scorpio'],
  [1841497937,1841691597,'Sagittarius'],
  [1841691597,1841898385,'Capricorn'],
  [1841898385,1842115127,'Aquarius'],
  [1842115127,1842333151,'Pisces'],
  [1842333151,1842544107,'Aries'],
  [1842544107,1842744919,'Taurus'],
  [1842744919,1842937202,'Gemini'],
  [1842937202,1843124091,'Cancer'],
  [1843124091,1843308073,'Leo'],
  [1843308073,1843490819,'Virgo'],
  [1843490819,1843674263,'Libra'],
  [1843674263,1843861487,'Scorpio'],
  [1843861487,1844056384,'Sagittarius'],
  [1844056384,1844261832,'Capricorn'],
  [1844261832,1844476850,'Aquarius'],
  [1844476850,1844695131,'Pisces'],
  [1844695131,1844907894,'Aries'],
  [1844907894,1845109488,'Taurus'],
  [1845109488,1845299835,'Gemini'],
  [1845299835,1845482546,'Cancer'],
  [1845482546,1845662257,'Leo'],
  [1845662257,1845842992,'Virgo'],
  [1845842992,1846027656,'Libra'],
  [1846027656,1846218264,'Scorpio'],
  [1846218264,1846416352,'Sagittarius'],
  [1846416352,1846622950,'Capricorn'],
  [1846622950,1846837432,'Aquarius'],
  [1846837432,1847055857,'Pisces'],
  [1847055857,1847271060,'Aries'],
  [1847271060,1847475961,'Taurus'],
  [1847475961,1847667753,'Gemini'],
  [1847667753,1847848615,'Cancer'],
  [1847848615,1848023754,'Leo'],
  [1848023754,1848199266,'Virgo'],
  [1848199266,1848380513,'Libra'],
  [1848380513,1848570887,'Scorpio'],
  [1848570887,1848771164,'Sagittarius'],
  [1848771164,1848980029,'Capricorn'],
  [1848980029,1849195238,'Aquarius'],
  [1849195238,1849413700,'Pisces'],
  [1849413700,1849630635,'Aries'],
  [1849630635,1849839749,'Taurus'],
  [1849839749,1850036107,'Gemini'],
  [1850036107,1850219138,'Cancer'],
  [1850219138,1850392780,'Leo'],
  [1850392780,1850563681,'Virgo'],
  [1850563681,1850739126,'Libra'],
  [1850739126,1850925074,'Scorpio'],
  [1850925074,1851124017,'Sagittarius'],
  [1851124017,1851333982,'Capricorn'],
  [1851333982,1851550388,'Aquarius'],
  [1851550388,1851768901,'Pisces'],
  [1851768901,1851986066,'Aries'],
  [1851986066,1852197879,'Taurus'],
  [1852197879,1852399563,'Gemini'],
  [1852399563,1852588102,'Cancer'],
  [1852588102,1852764702,'Leo'],
  [1852764702,1852934762,'Virgo'],
  [1852934762,1853105931,'Libra'],
  [1853105931,1853285932,'Scorpio'],
  [1853285932,1853479998,'Sagittarius'],
  [1853479998,1853688075,'Capricorn'],
  [1853688075,1853904798,'Aquarius'],
  [1853904798,1854123465,'Pisces'],
  [1854123465,1854339758,'Aries'],
  [1854339758,1854551397,'Taurus'],
  [1854551397,1854755833,'Gemini'],
  [1854755833,1854950010,'Cancer'],
  [1854950010,1855132686,'Leo'],
  [1855132686,1855306539,'Virgo'],
  [1855306539,1855477779,'Libra'],
  [1855477779,1855654173,'Scorpio'],
  [1855654173,1855842657,'Sagittarius'],
  [1855842657,1856046154,'Capricorn'],
  [1856046154,1856261196,'Aquarius'],
  [1856261196,1856479899,'Pisces'],
  [1856479899,1856695462,'Aries'],
  [1856695462,1856905084,'Taurus'],
  [1856905084,1857108239,'Gemini'],
  [1857108239,1857304214,'Cancer'],
  [1857304214,1857491959,'Leo'],
  [1857491959,1857671970,'Virgo'],
  [1857671970,1857847716,'Libra'],
  [1857847716,1858025146,'Scorpio'],
  [1858025146,1858210924,'Sagittarius'],
  [1858210924,1858409793,'Capricorn'],
  [1858409793,1858621457,'Aquarius'],
  [1858621457,1858839561,'Pisces'],
  [1858839561,1859055465,'Aries'],
  [1859055465,1859263777,'Taurus'],
  [1859263777,1859463715,'Gemini'],
  [1859463715,1859656781,'Cancer'],
  [1859656781,1859844526,'Leo'],
  [1859844526,1860028162,'Virgo'],
  [1860028162,1860209489,'Libra'],
  [1860209489,1860391711,'Scorpio'],
  [1860391711,1860579250,'Sagittarius'],
  [1860579250,1860776408,'Capricorn'],
  [1860776408,1860984957,'Aquarius'],
  [1860984957,1861201710,'Pisces'],
  [1861201710,1861418799,'Aries'],
  [1861418799,1861628276,'Taurus'],
  [1861628276,1861826765,'Gemini'],
  [1861826765,1862015681,'Cancer'],
  [1862015681,1862198830,'Leo'],
  [1862198830,1862380239,'Virgo'],
  [1862380239,1862563087,'Libra'],
  [1862563087,1862749600,'Scorpio'],
  [1862749600,1862941550,'Sagittarius'],
  [1862941550,1863140717,'Capricorn'],
  [1863140717,1863348463,'Aquarius'],
  [1863348463,1863563910,'Pisces'],
  [1863563910,1863782045,'Aries'],
  [1863782045,1863994727,'Taurus'],
  [1863994727,1864195508,'Gemini'],
  [1864195508,1864383326,'Cancer'],
  [1864383326,1864561981,'Leo'],
  [1864561981,1864737572,'Virgo'],
  [1864737572,1864916122,'Libra'],
  [1864916122,1865101871,'Scorpio'],
  [1865101871,1865296352,'Sagittarius'],
  [1865296352,1865498919,'Capricorn'],
  [1865498919,1865708383,'Aquarius'],
  [1865708383,1865923628,'Pisces'],
  [1865923628,1866142081,'Aries'],
  [1866142081,1866357898,'Taurus'],
  [1866357898,1866563591,'Gemini'],
  [1866563591,1866754841,'Cancer'],
  [1866754841,1866933169,'Leo'],
  [1866933169,1867104626,'Virgo'],
  [1867104626,1867276902,'Libra'],
  [1867276902,1867456947,'Scorpio'],
  [1867456947,1867648798,'Sagittarius'],
  [1867648798,1867852173,'Capricorn'],
  [1867852173,1868063728,'Aquarius'],
  [1868063728,1868279963,'Pisces'],
  [1868279963,1868498333,'Aries'],
  [1868498333,1868715440,'Taurus'],
  [1868715440,1868925492,'Gemini'],
  [1868925492,1869122678,'Cancer'],
  [1869122678,1869305370,'Leo'],
  [1869305370,1869477516,'Virgo'],
  [1869477516,1869646529,'Libra'],
  [1869646529,1869820559,'Scorpio'],
  [1869820559,1870006199,'Sagittarius'],
  [1870006199,1870205957,'Capricorn'],
  [1870205957,1870417157,'Aquarius'],
  [1870417157,1870634292,'Pisces'],
  [1870634292,1870852683,'Aries'],
  [1870852683,1871069297,'Taurus'],
  [1871069297,1871280729,'Gemini'],
  [1871280729,1871482477,'Cancer'],
  [1871482477,1871671379,'Leo'],
  [1871671379,1871848497,'Virgo'],
  [1871848497,1872019188,'Libra'],
  [1872019188,1872190979,'Scorpio'],
  [1872190979,1872371327,'Sagittarius'],
  [1872371327,1872565252,'Capricorn'],
  [1872565252,1872772918,'Aquarius'],
  [1872772918,1872989371,'Pisces'],
  [1872989371,1873207821,'Aries'],
  [1873207821,1873423423,'Taurus'],
  [1873423423,1873633507,'Gemini'],
  [1873633507,1873835946,'Cancer'],
  [1873835946,1874028782,'Leo'],
  [1874028782,1874211758,'Virgo'],
  [1874211758,1874387642,'Libra'],
  [1874387642,1874561818,'Scorpio'],
  [1874561818,1874740817,'Sagittarius'],
  [1874740817,1874930438,'Capricorn'],
  [1874930438,1875133417,'Aquarius'],
  [1875133417,1875347417,'Pisces'],
  [1875347417,1875565605,'Aries'],
  [1875565605,1875780787,'Taurus'],
  [1875780787,1875988875,'Gemini'],
  [1875988875,1876188858,'Cancer'],
  [1876188858,1876381203,'Leo'],
  [1876381203,1876566930,'Virgo'],
  [1876566930,1876747857,'Libra'],
  [1876747857,1876927037,'Scorpio'],
  [1876927037,1877108729,'Sagittarius'],
  [1877108729,1877297668,'Capricorn'],
  [1877297668,1877497518,'Aquarius'],
  [1877497518,1877708588,'Pisces'],
  [1877708588,1877926096,'Aries'],
  [1877926096,1878141884,'Taurus'],
  [1878141884,1878349356,'Gemini'],
  [1878349356,1878546529,'Cancer'],
  [1878546529,1878735292,'Leo'],
  [1878735292,1878919107,'Virgo'],
  [1878919107,1879101276,'Libra'],
  [1879101276,1879284357,'Scorpio'],
  [1879284357,1879470486,'Sagittarius'],
  [1879470486,1879662043,'Capricorn'],
  [1879662043,1879861686,'Aquarius'],
  [1879861686,1880070942,'Pisces'],
  [1880070942,1880287653,'Aries'],
  [1880287653,1880504816,'Taurus'],
  [1880504816,1880713948,'Gemini'],
  [1880713948,1880910574,'Cancer'],
  [1880910574,1881096021,'Leo'],
  [1881096021,1881275278,'Virgo'],
  [1881275278,1881454064,'Libra'],
  [1881454064,1881636744,'Scorpio'],
  [1881636744,1881825425,'Sagittarius'],
  [1881825425,1882020548,'Capricorn'],
  [1882020548,1882222421,'Aquarius'],
  [1882222421,1882431765,'Pisces'],
  [1882431765,1882647995,'Aries'],
  [1882647995,1882866533,'Taurus'],
  [1882866533,1883079022,'Gemini'],
  [1883079022,1883278422,'Cancer'],
  [1883278422,1883463714,'Leo'],
  [1883463714,1883639549,'Virgo'],
  [1883639549,1883813057,'Libra'],
  [1883813057,1883991002,'Scorpio'],
  [1883991002,1884177695,'Sagittarius'],
  [1884177695,1884373976,'Capricorn'],
  [1884373976,1884578371,'Aquarius'],
  [1884578371,1884789296,'Pisces'],
  [1884789296,1885005658,'Aries'],
  [1885005658,1885224807,'Taurus'],
  [1885224807,1885440470,'Gemini'],
  [1885440470,1885644873,'Cancer'],
  [1885644873,1885834082,'Leo'],
  [1885834082,1886010525,'Virgo'],
  [1886010525,1886180935,'Libra'],
  [1886180935,1886353233,'Scorpio'],
  [1886353233,1886534156,'Sagittarius'],
  [1886534156,1886727158,'Capricorn'],
  [1886727158,1886931515,'Aquarius'],
  [1886931515,1887143921,'Pisces'],
  [1887143921,1887360986,'Aries'],
  [1887360986,1887579911,'Taurus'],
  [1887579911,1887796663,'Gemini'],
  [1887796663,1888005264,'Cancer'],
  [1888005264,1888200586,'Leo'],
  [1888200586,1888382048,'Virgo'],
  [1888382048,1888554123,'Libra'],
  [1888554123,1888724036,'Scorpio'],
  [1888724036,1888899395,'Sagittarius'],
  [1888899395,1889086164,'Capricorn'],
  [1889086164,1889286572,'Aquarius'],
  [1889286572,1889498262,'Pisces'],
  [1889498262,1889715947,'Aries'],
  [1889715947,1889934516,'Taurus'],
  [1889934516,1890150174,'Gemini'],
  [1890150174,1890359452,'Cancer'],
  [1890359452,1890558949,'Leo'],
  [1890558949,1890746895,'Virgo'],
  [1890746895,1890924844,'Libra'],
  [1890924844,1891097532,'Scorpio'],
  [1891097532,1891271462,'Sagittarius'],
  [1891271462,1891453271,'Capricorn'],
  [1891453271,1891647811,'Aquarius'],
  [1891647811,1891855853,'Pisces'],
  [1891855853,1892072917,'Aries'],
  [1892072917,1892291581,'Taurus'],
  [1892291581,1892505801,'Gemini'],
  [1892505801,1892712704,'Cancer'],
  [1892712704,1892911602,'Leo'],
  [1892911602,1893102605,'Virgo'],
  [1893102605,1893286496,'Libra'],
  [1893286496,1893465334,'Scorpio'],
  [1893465334,1893642865,'Sagittarius'],
  [1893642865,1893824256,'Capricorn'],
  [1893824256,1894014939,'Aquarius'],
  [1894014939,1894218390,'Pisces'],
  [1894218390,1894433185,'Aries'],
  [1894433185,1894652109,'Taurus'],
  [1894652109,1894866356,'Gemini'],
  [1894866356,1895070994,'Cancer'],
  [1895070994,1895266200,'Leo'],
  [1895266200,1895454821,'Virgo'],
  [1895454821,1895639798,'Libra'],
  [1895639798,1895823115,'Scorpio'],
  [1895823115,1896006271,'Sagittarius'],
  [1896006271,1896191555,'Capricorn'],
  [1896191555,1896382684,'Aquarius'],
  [1896382684,1896583670,'Pisces'],
  [1896583670,1896795841,'Aries'],
  [1896795841,1897014627,'Taurus'],
  [1897014627,1897230544,'Gemini'],
  [1897230544,1897435615,'Cancer'],
  [1897435615,1897628255,'Leo'],
  [1897628255,1897812238,'Virgo'],
  [1897812238,1897993063,'Libra'],
  [1897993063,1898175167,'Scorpio'],
  [1898175167,1898360744,'Sagittarius'],
  [1898360744,1898550421,'Capricorn'],
  [1898550421,1898745135,'Aquarius'],
  [1898745135,1898947062,'Pisces'],
  [1898947062,1899158099,'Aries'],
  [1899158099,1899376421,'Taurus'],
  [1899376421,1899594471,'Gemini'],
  [1899594471,1899802742,'Cancer'],
  [1899802742,1899996578,'Leo'],
  [1899996578,1900178272,'Virgo'],
  [1900178272,1900354087,'Libra'],
  [1900354087,1900530726,'Scorpio'],
  [1900530726,1900713055,'Sagittarius'],
  [1900713055,1900903060,'Capricorn'],
  [1900903060,1901100619,'Aquarius'],
  [1901100619,1901305330,'Pisces'],
  [1901305330,1901517286,'Aries'],
  [1901517286,1901735426,'Taurus'],
  [1901735426,1901954819,'Gemini'],
  [1901954819,1902167063,'Cancer'],
  [1902167063,1902365389,'Leo'],
  [1902365389,1902549190,'Virgo'],
  [1902549190,1902723386,'Libra'],
  [1902723386,1902895160,'Scorpio'],
  [1902895160,1903071358,'Sagittarius'],
  [1903071358,1903256756,'Capricorn'],
  [1903256756,1903453046,'Aquarius'],
  [1903453046,1903659189,'Pisces'],
  [1903659189,1903872854,'Aries'],
  [1903872854,1904091409,'Taurus'],
  [1904091409,1904311013,'Gemini'],
  [1904311013,1904525693,'Cancer'],
  [1904525693,1904729089,'Leo'],
  [1904729089,1904918250,'Virgo'],
  [1904918250,1905095397,'Libra'],
  [1905095397,1905266342,'Scorpio'],
  [1905266342,1905438151,'Sagittarius'],
  [1905438151,1905617386,'Capricorn'],
  [1905617386,1905808554,'Aquarius'],
  [1905808554,1906012642,'Pisces'],
  [1906012642,1906226758,'Aries'],
  [1906226758,1906445898,'Taurus'],
  [1906445898,1906665074,'Gemini'],
  [1906665074,1906879777,'Cancer'],
  [1906879777,1907085880,'Leo'],
  [1907085880,1907280434,'Virgo'],
  [1907280434,1907463357,'Libra'],
  [1907463357,1907637872,'Scorpio'],
  [1907637872,1907809574,'Sagittarius'],
  [1907809574,1907985083,'Capricorn'],
  [1907985083,1908170601,'Aquarius'],
  [1908170601,1908369914,'Pisces'],
  [1908369914,1908582071,'Aries'],
  [1908582071,1908801180,'Taurus'],
  [1908801180,1909019929,'Gemini'],
  [1909019929,1909233174,'Cancer'],
  [1909233174,1909438614,'Leo'],
  [1909438614,1909635386,'Virgo'],
  [1909635386,1909823349,'Libra'],
  [1909823349,1910003615,'Scorpio'],
  [1910003615,1910179230,'Sagittarius'],
  [1910179230,1910355236,'Capricorn'],
  [1910355236,1910537813,'Aquarius'],
  [1910537813,1910732450,'Pisces'],
  [1910732450,1910940974,'Aries'],
  [1910940974,1911158981,'Taurus'],
  [1911158981,1911377661,'Gemini'],
  [1911377661,1911589664,'Cancer'],
  [1911589664,1911792582,'Leo'],
  [1911792582,1911987613,'Virgo'],
  [1911987613,1912176679,'Libra'],
  [1912176679,1912361072,'Scorpio'],
  [1912361072,1912542004,'Sagittarius'],
  [1912542004,1912722004,'Capricorn'],
  [1912722004,1912905563,'Aquarius'],
  [1912905563,1913098111,'Pisces'],
  [1913098111,1913303329,'Aries'],
  [1913303329,1913519498,'Taurus'],
  [1913519498,1913738466,'Gemini'],
  [1913738466,1913950734,'Cancer'],
  [1913950734,1914151886,'Leo'],
  [1914151886,1914343423,'Virgo'],
  [1914343423,1914529405,'Libra'],
  [1914529405,1914713338,'Scorpio'],
  [1914713338,1914897039,'Sagittarius'],
  [1914897039,1915081559,'Capricorn'],
  [1915081559,1915268932,'Aquarius'],
  [1915268932,1915462763,'Pisces'],
  [1915462763,1915666738,'Aries'],
  [1915666738,1915881276,'Taurus'],
  [1915881276,1916100609,'Gemini'],
  [1916100609,1916314864,'Cancer'],
  [1916314864,1916516953,'Leo'],
  [1916516953,1916706594,'Virgo'],
  [1916706594,1916888308,'Libra'],
  [1916888308,1917067732,'Scorpio'],
  [1917067732,1917249166,'Sagittarius'],
  [1917249166,1917434796,'Capricorn'],
  [1917434796,1917625597,'Aquarius'],
  [1917625597,1917822764,'Pisces'],
  [1917822764,1918028024,'Aries'],
  [1918028024,1918242040,'Taurus'],
  [1918242040,1918461494,'Gemini'],
  [1918461494,1918678371,'Cancer'],
  [1918678371,1918884226,'Leo'],
  [1918884226,1919075795,'Virgo'],
  [1919075795,1919255928,'Libra'],
  [1919255928,1919430652,'Scorpio'],
  [1919430652,1919606331,'Sagittarius'],
  [1919606331,1919787919,'Capricorn'],
  [1919787919,1919978095,'Aquarius'],
  [1919978095,1920177430,'Pisces'],
  [1920177430,1920385217,'Aries'],
  [1920385217,1920600121,'Taurus'],
  [1920600121,1920819463,'Gemini'],
  [1920819463,1921037891,'Cancer'],
  [1921037891,1921248226,'Leo'],
  [1921248226,1921445155,'Virgo'],
  [1921445155,1921628409,'Libra'],
  [1921628409,1921802283,'Scorpio'],
  [1921802283,1921973333,'Sagittarius'],
  [1921973333,1922148432,'Capricorn'],
  [1922148432,1922333209,'Aquarius'],
  [1922333209,1922530469,'Pisces'],
  [1922530469,1922739222,'Aries'],
  [1922739222,1922955591,'Taurus'],
  [1922955591,1923175014,'Gemini'],
  [1923175014,1923393210,'Cancer'],
  [1923393210,1923605749,'Leo'],
  [1923605749,1923808151,'Virgo'],
  [1923808151,1923997869,'Libra'],
  [1923997869,1924176016,'Scorpio'],
  [1924176016,1924347247,'Sagittarius'],
  [1924347247,1924518373,'Capricorn'],
  [1924518373,1924696699,'Aquarius'],
  [1924696699,1924888033,'Pisces'],
  [1924888033,1925093990,'Aries'],
  [1925093990,1925310492,'Taurus'],
  [1925310492,1925530307,'Gemini'],
  [1925530307,1925747508,'Cancer'],
  [1925747508,1925959076,'Leo'],
  [1925959076,1926163266,'Virgo'],
  [1926163266,1926358304,'Libra'],
  [1926358304,1926543231,'Scorpio'],
  [1926543231,1926719564,'Sagittarius'],
  [1926719564,1926892011,'Capricorn'],
  [1926892011,1927067485,'Aquarius'],
  [1927067485,1927253190,'Pisces'],
  [1927253190,1927453758,'Aries'],
  [1927453758,1927667788,'Taurus'],
  [1927667788,1927887563,'Gemini'],
  [1927887563,1928104379,'Cancer'],
  [1928104379,1928313870,'Leo'],
  [1928313870,1928515885,'Virgo'],
  [1928515885,1928711331,'Libra'],
  [1928711331,1928900329,'Scorpio'],
  [1928900329,1929082849,'Sagittarius'],
  [1929082849,1929260682,'Capricorn'],
  [1929260682,1929438435,'Aquarius'],
  [1929438435,1929622545,'Pisces'],
  [1929622545,1929818868,'Aries'],
  [1929818868,1930029042,'Taurus'],
  [1930029042,1930247684,'Gemini'],
  [1930247684,1930465000,'Cancer'],
  [1930465000,1930673805,'Leo'],
  [1930673805,1930872917,'Virgo'],
  [1930872917,1931064852,'Libra'],
  [1931064852,1931252390,'Scorpio'],
  [1931252390,1931437032,'Sagittarius'],
  [1931437032,1931619706,'Capricorn'],
  [1931619706,1931802490,'Aquarius'],
  [1931802490,1931989359,'Pisces'],
  [1931989359,1932185125,'Aries'],
  [1932185125,1932392683,'Taurus'],
  [1932392683,1932609636,'Gemini'],
  [1932609636,1932827767,'Cancer'],
  [1932827767,1933038075,'Leo'],
  [1933038075,1933236655,'Virgo'],
  [1933236655,1933425247,'Libra'],
  [1933425247,1933608156,'Scorpio'],
  [1933608156,1933789526,'Sagittarius'],
  [1933789526,1933972215,'Capricorn'],
  [1933972215,1934158124,'Aquarius'],
  [1934158124,1934349133,'Pisces'],
  [1934349133,1934547530,'Aries'],
  [1934547530,1934755140,'Taurus'],
  [1934755140,1934971051,'Gemini'],
  [1934971051,1935189781,'Cancer'],
  [1935189781,1935402903,'Leo'],
  [1935402903,1935604105,'Virgo'],
  [1935604105,1935792605,'Libra'],
  [1935792605,1935972104,'Scorpio'],
  [1935972104,1936148156,'Sagittarius'],
  [1936148156,1936326178,'Capricorn'],
  [1936326178,1936510285,'Aquarius'],
  [1936510285,1936702757,'Pisces'],
  [1936702757,1936904112,'Aries'],
  [1936904112,1937113705,'Taurus'],
  [1937113705,1937329835,'Gemini'],
  [1937329835,1937548805,'Cancer'],
  [1937548805,1937764465,'Leo'],
  [1937764465,1937970093,'Virgo'],
  [1937970093,1938162194,'Libra'],
  [1938162194,1938342161,'Scorpio'],
  [1938342161,1938515053,'Sagittarius'],
  [1938515053,1938687542,'Capricorn'],
  [1938687542,1938866144,'Aquarius'],
  [1938866144,1939055552,'Pisces'],
  [1939055552,1939257063,'Aries'],
  [1939257063,1939468394,'Taurus'],
  [1939468394,1939685558,'Gemini'],
  [1939685558,1939904554,'Cancer'],
  [1939904554,1940121259,'Leo'],
  [1940121259,1940330681,'Virgo'],
  [1940330681,1940528242,'Libra'],
  [1940528242,1940712549,'Scorpio'],
  [1940712549,1940886521,'Sagittarius'],
  [1940886521,1941056363,'Capricorn'],
  [1941056363,1941229630,'Aquarius'],
  [1941229630,1941413267,'Pisces'],
  [1941413267,1941611139,'Aries'],
  [1941611139,1941821844,'Taurus'],
  [1941821844,1942039698,'Gemini'],
  [1942039698,1942258687,'Cancer'],
  [1942258687,1942474899,'Leo'],
  [1942474899,1942685525,'Virgo'],
  [1942685525,1942887302,'Libra'],
  [1942887302,1943077509,'Scorpio'],
  [1943077509,1943256332,'Sagittarius'],
  [1943256332,1943427920,'Capricorn'],
  [1943427920,1943599236,'Aquarius'],
  [1943599236,1943778043,'Pisces'],
  [1943778043,1943970449,'Aries'],
  [1943970449,1944177706,'Taurus'],
  [1944177706,1944394782,'Gemini'],
  [1944394782,1944613729,'Cancer'],
  [1944613729,1944828897,'Leo'],
  [1944828897,1945038163,'Virgo'],
  [1945038163,1945240559,'Libra'],
  [1945240559,1945434588,'Scorpio'],
  [1945434588,1945619201,'Sagittarius'],
  [1945619201,1945795946,'Capricorn'],
  [1945795946,1945969672,'Aquarius'],
  [1945969672,1946147286,'Pisces'],
  [1946147286,1946335607,'Aries'],
  [1946335607,1946538307,'Taurus'],
  [1946538307,1946752939,'Gemini'],
  [1946752939,1946971611,'Cancer'],
  [1946971611,1947186360,'Leo'],
  [1947186360,1947393602,'Virgo'],
  [1947393602,1947593444,'Libra'],
  [1947593444,1947786835,'Scorpio'],
  [1947786835,1947974154,'Sagittarius'],
  [1947974154,1948156051,'Capricorn'],
  [1948156051,1948334969,'Aquarius'],
  [1948334969,1948515505,'Pisces'],
  [1948515505,1948703328,'Aries'],
  [1948703328,1948902920,'Taurus'],
  [1948902920,1949114533,'Gemini'],
  [1949114533,1949332516,'Cancer'],
  [1949332516,1949548047,'Leo'],
  [1949548047,1949754865,'Virgo'],
  [1949754865,1949951879,'Libra'],
  [1949951879,1950141362,'Scorpio'],
  [1950141362,1950326318,'Sagittarius'],
  [1950326318,1950509208,'Capricorn'],
  [1950509208,1950692114,'Aquarius'],
  [1950692114,1950877469,'Pisces'],
  [1950877469,1951068378,'Aries'],
  [1951068378,1951267994,'Taurus'],
  [1951267994,1951477684,'Gemini'],
  [1951477684,1951694694,'Cancer'],
  [1951694694,1951911769,'Leo'],
  [1951911769,1952120800,'Virgo'],
  [1952120800,1952317791,'Libra'],
  [1952317791,1952504007,'Scorpio'],
  [1952504007,1952683856,'Sagittarius'],
  [1952683856,1952862516,'Capricorn'],
  [1952862516,1953044333,'Aquarius'],
  [1953044333,1953232057,'Pisces'],
  [1953232057,1953426910,'Aries'],
  [1953426910,1953629297,'Taurus'],
  [1953629297,1953839269,'Gemini'],
  [1953839269,1954055564,'Cancer'],
  [1954055564,1954273822,'Leo'],
  [1954273822,1954486633,'Virgo'],
  [1954486633,1954687386,'Libra'],
  [1954687386,1954874367,'Scorpio'],
  [1954874367,1955051077,'Sagittarius'],
  [1955051077,1955223970,'Capricorn'],
  [1955223970,1955399993,'Aquarius'],
  [1955399993,1955584581,'Pisces'],
  [1955584581,1955779987,'Aries'],
  [1955779987,1955985041,'Taurus'],
  [1955985041,1956197010,'Gemini'],
  [1956197010,1956413485,'Cancer'],
  [1956413485,1956631901,'Leo'],
  [1956631901,1956847545,'Virgo'],
  [1956847545,1957053768,'Libra'],
  [1957053768,1957245869,'Scorpio'],
  [1957245869,1957424419,'Sagittarius'],
  [1957424419,1957594942,'Capricorn'],
  [1957594942,1957765301,'Aquarius'],
  [1957765301,1957943248,'Pisces'],
  [1957943248,1958134034,'Aries'],
  [1958134034,1958338107,'Taurus'],
  [1958338107,1958551421,'Gemini'],
  [1958551421,1958768851,'Cancer'],
  [1958768851,1958986912,'Leo'],
  [1958986912,1959202885,'Virgo'],
  [1959202885,1959412550,'Libra'],
  [1959412550,1959610860,'Scorpio'],
  [1959610860,1959795434,'Sagittarius'],
  [1959795434,1959968962,'Capricorn'],
  [1959968962,1960138161,'Aquarius'],
  [1960138161,1960311211,'Pisces'],
  [1960311211,1960495409,'Aries'],
  [1960495409,1960694387,'Taurus'],
  [1960694387,1960905994,'Gemini'],
  [1960905994,1961123842,'Cancer'],
  [1961123842,1961341801,'Leo'],
  [1961341801,1961556510,'Virgo'],
  [1961556510,1961765848,'Libra'],
  [1961765848,1961967059,'Scorpio'],
  [1961967059,1962157540,'Sagittarius'],
  [1962157540,1962337370,'Capricorn'],
  [1962337370,1962510513,'Aquarius'],
  [1962510513,1962683638,'Pisces'],
  [1962683638,1962864052,'Aries'],
  [1962864052,1963057325,'Taurus'],
  [1963057325,1963264540,'Gemini'],
  [1963264540,1963481028,'Cancer'],
  [1963481028,1963699089,'Leo'],
  [1963699089,1963912827,'Virgo'],
  [1963912827,1964119810,'Libra'],
  [1964119810,1964319459,'Scorpio'],
  [1964319459,1964511478,'Sagittarius'],
  [1964511478,1964696077,'Capricorn'],
  [1964696077,1964875122,'Aquarius'],
  [1964875122,1965052607,'Pisces'],
  [1965052607,1965233982,'Aries'],
  [1965233982,1965424636,'Taurus'],
  [1965424636,1965627661,'Gemini'],
  [1965627661,1965841462,'Cancer'],
  [1965841462,1966059380,'Leo'],
  [1966059380,1966273426,'Virgo'],
  [1966273426,1966478852,'Libra'],
  [1966478852,1966675129,'Scorpio'],
  [1966675129,1966864199,'Sagittarius'],
  [1966864199,1967048615,'Capricorn'],
  [1967048615,1967230810,'Aquarius'],
  [1967230810,1967413238,'Pisces'],
  [1967413238,1967598778,'Aries'],
  [1967598778,1967790797,'Taurus'],
  [1967790797,1967992269,'Gemini'],
  [1967992269,1968203753,'Cancer'],
  [1968203753,1968421239,'Leo'],
  [1968421239,1968636747,'Virgo'],
  [1968636747,1968842980,'Libra'],
  [1968842980,1969037432,'Scorpio'],
  [1969037432,1969222411,'Sagittarius'],
  [1969222411,1969402650,'Capricorn'],
  [1969402650,1969582949,'Aquarius'],
  [1969582949,1969766782,'Pisces'],
  [1969766782,1969955988,'Aries'],
  [1969955988,1970151499,'Taurus'],
  [1970151499,1970354315,'Gemini'],
  [1970354315,1970565139,'Cancer'],
  [1970565139,1970782240,'Leo'],
  [1970782240,1970999588,'Virgo'],
  [1970999588,1971208841,'Libra'],
  [1971208841,1971404725,'Scorpio'],
  [1971404725,1971587954,'Sagittarius'],
  [1971587954,1971763774,'Capricorn'],
  [1971763774,1971938970,'Aquarius'],
  [1971938970,1972119425,'Pisces'],
  [1972119425,1972308434,'Aries'],
  [1972308434,1972506266,'Taurus'],
  [1972506266,1972711634,'Gemini'],
  [1972711634,1972923464,'Cancer'],
  [1972923464,1973140550,'Leo'],
  [1973140550,1973359184,'Virgo'],
  [1973359184,1973572156,'Libra'],
  [1973572156,1973772350,'Scorpio'],
  [1973772350,1973957720,'Sagittarius'],
  [1973957720,1974132197,'Capricorn'],
  [1974132197,1974303005,'Aquarius'],
  [1974303005,1974477775,'Pisces'],
  [1974477775,1974662309,'Aries'],
  [1974662309,1974858688,'Taurus'],
  [1974858688,1975065189,'Gemini'],
  [1975065189,1975278542,'Cancer'],
  [1975278542,1975496040,'Leo'],
  [1975496040,1975714936,'Virgo'],
  [1975714936,1975930290,'Libra'],
  [1975930290,1976135446,'Scorpio'],
  [1976135446,1976326102,'Sagittarius'],
  [1976326102,1976503522,'Capricorn'],
  [1976503522,1976673657,'Aquarius'],
  [1976673657,1976844341,'Pisces'],
  [1976844341,1977022972,'Aries'],
  [1977022972,1977214305,'Taurus'],
  [1977214305,1977418649,'Gemini'],
  [1977418649,1977632309,'Cancer'],
  [1977632309,1977850325,'Leo'],
  [1977850325,1978068779,'Virgo'],
  [1978068779,1978284126,'Libra'],
  [1978284126,1978491951,'Scorpio'],
  [1978491951,1978688081,'Sagittarius'],
  [1978688081,1978871444,'Capricorn'],
  [1978871444,1979045357,'Aquarius'],
  [1979045357,1979216176,'Pisces'],
  [1979216176,1979391226,'Aries'],
  [1979391226,1979576865,'Taurus'],
  [1979576865,1979776281,'Gemini'],
  [1979776281,1979987844,'Cancer'],
  [1979987844,1980205828,'Leo'],
  [1980205828,1980423883,'Virgo'],
  [1980423883,1980637667,'Libra'],
  [1980637667,1980844580,'Scorpio'],
  [1980844580,1981042775,'Sagittarius'],
  [1981042775,1981231342,'Capricorn'],
  [1981231342,1981411442,'Aquarius'],
  [1981411442,1981586735,'Pisces'],
  [1981586735,1981762713,'Aries'],
  [1981762713,1981945469,'Taurus'],
  [1981945469,1982139938,'Gemini'],
  [1982139938,1982347541,'Cancer'],
  [1982347541,1982564342,'Leo'],
  [1982564342,1982782531,'Virgo'],
  [1982782531,1982995184,'Libra'],
  [1982995184,1983199291,'Scorpio'],
  [1983199291,1983395152,'Sagittarius'],
  [1983395152,1983584342,'Capricorn'],
  [1983584342,1983768556,'Aquarius'],
  [1983768556,1983949689,'Pisces'],
  [1983949689,1984130456,'Aries'],
  [1984130456,1984314782,'Taurus'],
  [1984314782,1984507254,'Gemini'],
  [1984507254,1984711233,'Cancer'],
  [1984711233,1984925885,'Leo'],
  [1984925885,1985144520,'Virgo'],
  [1985144520,1985357955,'Libra'],
  [1985357955,1985560578,'Scorpio'],
  [1985560578,1985752594,'Sagittarius'],
  [1985752594,1985937821,'Capricorn'],
  [1985937821,1986120612,'Aquarius'],
  [1986120612,1986304019,'Pisces'],
  [1986304019,1986489565,'Aries'],
  [1986489565,1986678441,'Taurus'],
  [1986678441,1986872850,'Gemini'],
  [1986872850,1987075775,'Cancer'],
  [1987075775,1987288519,'Leo'],
  [1987288519,1987507325,'Virgo'],
  [1987507325,1987723204,'Libra'],
  [1987723204,1987927652,'Scorpio'],
  [1987927652,1988118398,'Sagittarius'],
  [1988118398,1988299283,'Capricorn'],
  [1988299283,1988476709,'Aquarius'],
  [1988476709,1988656509,'Pisces'],
  [1988656509,1988842065,'Aries'],
  [1988842065,1989034073,'Taurus'],
  [1989034073,1989232235,'Gemini'],
  [1989232235,1989437049,'Cancer'],
  [1989437049,1989649464,'Leo'],
  [1989649464,1989868038,'Virgo'],
  [1989868038,1990086313,'Libra'],
  [1990086313,1990295095,'Scorpio'],
  [1990295095,1990488917,'Sagittarius'],
  [1990488917,1990669313,'Capricorn'],
  [1990669313,1990842585,'Aquarius'],
  [1990842585,1991016230,'Pisces'],
  [1991016230,1991196426,'Aries'],
  [1991196426,1991386327,'Taurus'],
  [1991386327,1991585829,'Gemini'],
  [1991585829,1991793232,'Cancer'],
  [1991793232,1992006995,'Leo'],
  [1992006995,1992225478,'Virgo'],
  [1992225478,1992444650,'Libra'],
  [1992444650,1992657354,'Scorpio'],
  [1992657354,1992856860,'Sagittarius'],
  [1992856860,1993041518,'Capricorn'],
  [1993041518,1993215410,'Aquarius'],
  [1993215410,1993385630,'Pisces'],
  [1993385630,1993559623,'Aries'],
  [1993559623,1993743274,'Taurus'],
  [1993743274,1993939296,'Gemini'],
  [1993939296,1994146660,'Cancer'],
  [1994146660,1994361797,'Leo'],
  [1994361797,1994580693,'Virgo'],
  [1994580693,1994799426,'Libra'],
  [1994799426,1995013310,'Scorpio'],
  [1995013310,1995217250,'Sagittarius'],
  [1995217250,1995408174,'Capricorn'],
  [1995408174,1995587173,'Aquarius'],
  [1995587173,1995759078,'Pisces'],
  [1995759078,1995930611,'Aries'],
  [1995930611,1996108641,'Taurus'],
  [1996108641,1996298519,'Gemini'],
  [1996298519,1996502134,'Cancer'],
  [1996502134,1996716645,'Leo'],
  [1996716645,1996935933,'Virgo'],
  [1996935933,1997153975,'Libra'],
  [1997153975,1997366601,'Scorpio'],
  [1997366601,1997571204,'Sagittarius'],
  [1997571204,1997766121,'Capricorn'],
  [1997766121,1997951194,'Aquarius'],
  [1997951194,1998128526,'Pisces'],
  [1998128526,1998302491,'Aries'],
  [1998302491,1998479011,'Taurus'],
  [1998479011,1998664280,'Gemini'],
  [1998664280,1998862744,'Cancer'],
  [1998862744,1999074336,'Leo'],
  [1999074336,1999293209,'Virgo'],
  [1999293209,1999511028,'Libra'],
  [1999511028,1999721925,'Scorpio'],
  [1999721925,1999924233,'Sagittarius'],
  [1999924233,2000118742,'Capricorn'],
  [2000118742,2000306680,'Aquarius'],
  [2000306680,2000489274,'Pisces'],
  [2000489274,2000668454,'Aries'],
  [2000668454,2000847767,'Taurus'],
  [2000847767,2001032343,'Gemini'],
  [2001032343,2001227439,'Cancer'],
  [2001227439,2001435529,'Leo'],
  [2001435529,2001653108,'Virgo'],
  [2001653108,2001871286,'Libra'],
  [2001871286,2002081712,'Scorpio'],
  [2002081712,2002281499,'Sagittarius'],
  [2002281499,2002472668,'Capricorn'],
  [2002472668,2002658830,'Aquarius'],
  [2002658830,2002842774,'Pisces'],
  [2002842774,2003026000,'Aries'],
  [2003026000,2003209919,'Taurus'],
  [2003209919,2003397313,'Gemini'],
  [2003397313,2003592327,'Cancer'],
  [2003592327,2003798364,'Leo'],
  [2003798364,2004014479,'Virgo'],
  [2004014479,2004233367,'Libra'],
  [2004233367,2004445210,'Scorpio'],
  [2004445210,2004644613,'Sagittarius'],
  [2004644613,2004832800,'Capricorn'],
  [2004832800,2005014691,'Aquarius'],
  [2005014691,2005195415,'Pisces'],
  [2005195415,2005378333,'Aries'],
  [2005378333,2005564889,'Taurus'],
  [2005564889,2005756031,'Gemini'],
  [2005756031,2005953585,'Cancer'],
  [2005953585,2006159889,'Leo'],
  [2006159889,2006375227,'Virgo'],
  [2006375227,2006594776,'Libra'],
  [2006594776,2006809351,'Scorpio'],
  [2006809351,2007011326,'Sagittarius'],
  [2007011326,2007199527,'Capricorn'],
  [2007199527,2007378301,'Aquarius'],
  [2007378301,2007554013,'Pisces'],
  [2007554013,2007732380,'Aries'],
  [2007732380,2007917035,'Taurus'],
  [2007917035,2008109404,'Gemini'],
  [2008109404,2008309716,'Cancer'],
  [2008309716,2008517975,'Leo'],
  [2008517975,2008733622,'Virgo'],
  [2008733622,2008953477,'Libra'],
  [2008953477,2009170600,'Scorpio'],
  [2009170600,2009377072,'Sagittarius'],
  [2009377072,2009569008,'Capricorn'],
  [2009569008,2009748458,'Aquarius'],
  [2009748458,2009921216,'Pisces'],
  [2009921216,2010094109,'Aries'],
  [2010094109,2010273169,'Taurus'],
  [2010273169,2010462325,'Gemini'],
  [2010462325,2010662659,'Cancer'],
  [2010662659,2010872651,'Leo'],
  [2010872651,2011089380,'Virgo'],
  [2011089380,2011309225,'Libra'],
  [2011309225,2011527296,'Scorpio'],
  [2011527296,2011737617,'Sagittarius'],
  [2011737617,2011935349,'Capricorn'],
  [2011935349,2012119626,'Aquarius'],
  [2012119626,2012293904,'Pisces'],
  [2012293904,2012464304,'Aries'],
  [2012464304,2012637827,'Taurus'],
  [2012637827,2012820828,'Gemini'],
  [2012820828,2013017169,'Cancer'],
  [2013017169,2013226409,'Leo'],
  [2013226409,2013443932,'Virgo'],
  [2013443932,2013663779,'Libra'],
  [2013663779,2013881103,'Scorpio'],
  [2013881103,2014092307,'Sagittarius'],
  [2014092307,2014294280,'Capricorn'],
  [2014294280,2014484991,'Aquarius'],
  [2014484991,2014664955,'Pisces'],
  [2014664955,2014837801,'Aries'],
  [2014837801,2015009608,'Taurus'],
  [2015009608,2015187521,'Gemini'],
  [2015187521,2015377836,'Cancer'],
  [2015377836,2015583113,'Leo'],
  [2015583113,2015799747,'Virgo'],
  [2015799747,2016019715,'Libra'],
  [2016019715,2016235929,'Scorpio'],
  [2016235929,2016445265,'Sagittarius'],
  [2016445265,2016647200,'Capricorn'],
  [2016647200,2016841457,'Aquarius'],
  [2016841457,2017027642,'Pisces'],
  [2017027642,2017206581,'Aries'],
  [2017206581,2017381697,'Taurus'],
  [2017381697,2017558914,'Gemini'],
  [2017558914,2017745093,'Cancer'],
  [2017745093,2017945281,'Leo'],
  [2017945281,2018158964,'Virgo'],
  [2018158964,2018378674,'Libra'],
  [2018378674,2018594805,'Scorpio'],
  [2018594805,2018802146,'Sagittarius'],
  [2018802146,2019000919,'Capricorn'],
  [2019000919,2019193493,'Aquarius'],
  [2019193493,2019381528,'Pisces'],
  [2019381528,2019565540,'Aries'],
  [2019565540,2019746514,'Taurus'],
  [2019746514,2019927608,'Gemini'],
  [2019927608,2020114096,'Cancer'],
  [2020114096,2020311416,'Leo'],
  [2020311416,2020521684,'Virgo'],
  [2020521684,2020740331,'Libra'],
  [2020740331,2020957520,'Scorpio'],
  [2020957520,2021165134,'Sagittarius'],
  [2021165134,2021361498,'Capricorn'],
  [2021361498,2021549774,'Aquarius'],
  [2021549774,2021734215,'Pisces'],
  [2021734215,2021917790,'Aries'],
  [2021917790,2022101938,'Taurus'],
  [2022101938,2022287955,'Gemini'],
  [2022287955,2022478340,'Cancer'],
  [2022478340,2022676627,'Leo'],
  [2022676627,2022885317,'Virgo'],
  [2022885317,2023102615,'Libra'],
  [2023102615,2023321050,'Scorpio'],
  [2023321050,2023531378,'Sagittarius'],
  [2023531378,2023728819,'Capricorn'],
  [2023728819,2023914811,'Aquarius'],
  [2023914811,2024094284,'Pisces'],
  [2024094284,2024272656,'Aries'],
  [2024272656,2024454108,'Taurus'],
  [2024454108,2024641126,'Gemini'],
  [2024641126,2024834996,'Cancer'],
  [2024834996,2025036563,'Leo'],
  [2025036563,2025246313,'Virgo'],
  [2025246313,2025463046,'Libra'],
  [2025463046,2025682076,'Scorpio'],
  [2025682076,2025895752,'Sagittarius'],
  [2025895752,2026097441,'Capricorn'],
  [2026097441,2026285493,'Aquarius'],
  [2026285493,2026463218,'Pisces'],
  [2026463218,2026636551,'Aries'],
  [2026636551,2026811883,'Taurus'],
  [2026811883,2026994532,'Gemini'],
  [2026994532,2027187538,'Cancer'],
  [2027187538,2027391054,'Leo'],
  [2027391054,2027602999,'Virgo'],
  [2027602999,2027820346,'Libra'],
  [2027820346,2028039342,'Scorpio'],
  [2028039342,2028254967,'Sagittarius'],
  [2028254967,2028461402,'Capricorn'],
  [2028461402,2028654774,'Aquarius'],
  [2028654774,2028835437,'Pisces'],
  [2028835437,2029007780,'Aries'],
  [2029007780,2029178536,'Taurus'],
  [2029178536,2029354918,'Gemini'],
  [2029354918,2029542757,'Cancer'],
  [2029542757,2029744284,'Leo'],
  [2029744284,2029956941,'Virgo'],
  [2029956941,2030175261,'Libra'],
  [2030175261,2030394078,'Scorpio'],
  [2030394078,2030609657,'Sagittarius'],
  [2030609657,2030818548,'Capricorn'],
  [2030818548,2031017179,'Aquarius'],
  [2031017179,2031203654,'Pisces'],
  [2031203654,2031379578,'Aries'],
  [2031379578,2031550177,'Taurus'],
  [2031550177,2031722779,'Gemini'],
  [2031722779,2031904821,'Cancer'],
  [2031904821,2032101286,'Leo'],
  [2032101286,2032311736,'Virgo'],
  [2032311736,2032530074,'Libra'],
  [2032530074,2032748802,'Scorpio'],
  [2032748802,2032963248,'Sagittarius'],
  [2032963248,2033171551,'Capricorn'],
  [2033171551,2033372293,'Aquarius'],
  [2033372293,2033563754,'Pisces'],
  [2033563754,2033745465,'Aries'],
  [2033745465,2033920050,'Taurus'],
  [2033920050,2034093273,'Gemini'],
  [2034093273,2034272437,'Cancer'],
  [2034272437,2034464010,'Leo'],
  [2034464010,2034670322,'Virgo'],
  [2034670322,2034887097,'Libra'],
  [2034887097,2035105735,'Scorpio'],
  [2035105735,2035319298,'Sagittarius'],
  [2035319298,2035525461,'Capricorn'],
  [2035525461,2035724620,'Aquarius'],
  [2035724620,2035917181,'Pisces'],
  [2035917181,2036103012,'Aries'],
  [2036103012,2036282962,'Taurus'],
  [2036282962,2036460339,'Gemini'],
  [2036460339,2036640718,'Cancer'],
  [2036640718,2036830271,'Leo'],
  [2036830271,2037032935,'Virgo'],
  [2037032935,2037247193,'Libra'],
  [2037247193,2037465588,'Scorpio'],
  [2037465588,2037679404,'Sagittarius'],
  [2037679404,2037884160,'Capricorn'],
  [2037884160,2038080197,'Aquarius'],
  [2038080197,2038269898,'Pisces'],
  [2038269898,2038455386,'Aries'],
  [2038455386,2038638171,'Taurus'],
  [2038638171,2038820170,'Gemini'],
  [2038820170,2039004585,'Cancer'],
  [2039004585,2039195658,'Leo'],
  [2039195658,2039397067,'Virgo'],
  [2039397067,2039609219,'Libra'],
  [2039609219,2039827216,'Scorpio'],
  [2039827216,2040042501,'Sagittarius'],
  [2040042501,2040248157,'Capricorn'],
  [2040248157,2040442542,'Aquarius'],
  [2040442542,2040628273,'Pisces'],
  [2040628273,2040809554,'Aries'],
  [2040809554,2040990330,'Taurus'],
  [2040990330,2041173609,'Gemini'],
  [2041173609,2041361628,'Cancer'],
  [2041361628,2041556273,'Leo'],
  [2041556273,2041759161,'Virgo'],
  [2041759161,2041970716,'Libra'],
  [2041970716,2042188322,'Scorpio'],
  [2042188322,2042405516,'Sagittarius'],
  [2042405516,2042614450,'Capricorn'],
  [2042614450,2042810596,'Aquarius'],
  [2042810596,2042994757,'Pisces'],
  [2042994757,2043171514,'Aries'],
  [2043171514,2043346885,'Taurus'],
  [2043346885,2043526480,'Gemini'],
  [2043526480,2043714131,'Cancer'],
  [2043714131,2043911159,'Leo'],
  [2043911159,2044116799,'Virgo'],
  [2044116799,2044329444,'Libra'],
  [2044329444,2044546928,'Scorpio'],
  [2044546928,2044765313,'Sagittarius'],
  [2044765313,2044978211,'Capricorn'],
  [2044978211,2045179283,'Aquarius'],
  [2045179283,2045366221,'Pisces'],
  [2045366221,2045541897,'Aries'],
  [2045541897,2045712676,'Taurus'],
  [2045712676,2045886058,'Gemini'],
  [2045886058,2046068608,'Cancer'],
  [2046068608,2046263773,'Leo'],
  [2046263773,2046470538,'Virgo'],
  [2046470538,2046684880,'Libra'],
  [2046684880,2046902754,'Scorpio'],
  [2046902754,2047121104,'Sagittarius'],
  [2047121104,2047336172,'Capricorn'],
  [2047336172,2047542535,'Aquarius'],
  [2047542535,2047735636,'Pisces'],
  [2047735636,2047915179,'Aries'],
  [2047915179,2048085817,'Taurus'],
  [2048085817,2048255133,'Gemini'],
  [2048255133,2048431266,'Cancer'],
  [2048431266,2048620513,'Leo'],
  [2048620513,2048824436,'Virgo'],
  [2048824436,2049038925,'Libra'],
  [2049038925,2049257442,'Scorpio'],
  [2049257442,2049475222,'Sagittarius'],
  [2049475222,2049689735,'Capricorn'],
  [2049689735,2049898215,'Aquarius'],
  [2049898215,2050096860,'Pisces'],
  [2050096860,2050283166,'Aries'],
  [2050283166,2050458682,'Taurus'],
  [2050458682,2050629087,'Gemini'],
  [2050629087,2050802158,'Cancer'],
  [2050802158,2050985470,'Leo'],
  [2050985470,2051183578,'Virgo'],
  [2051183578,2051395170,'Libra'],
  [2051395170,2051613498,'Scorpio'],
  [2051613498,2051831114,'Sagittarius'],
  [2051831114,2052043966,'Capricorn'],
  [2052043966,2052250746,'Aquarius'],
  [2052250746,2052450366,'Pisces'],
  [2052450366,2052641322,'Aries'],
  [2052641322,2052823387,'Taurus'],
  [2052823387,2052999305,'Gemini'],
  [2052999305,2053174605,'Cancer'],
  [2053174605,2053356032,'Leo'],
  [2053356032,2053549301,'Virgo'],
  [2053549301,2053756233,'Libra'],
  [2053756233,2053972723,'Scorpio'],
  [2053972723,2054190577,'Sagittarius'],
  [2054190577,2054402867,'Capricorn'],
  [2054402867,2054606995,'Aquarius'],
  [2054606995,2054803457,'Pisces'],
  [2054803457,2054993549,'Aries'],
  [2054993549,2055178472,'Taurus'],
  [2055178472,2055359877,'Gemini'],
  [2055359877,2055540643,'Cancer'],
  [2055540643,2055724950,'Leo'],
  [2055724950,2055917377,'Virgo'],
  [2055917377,2056120990,'Libra'],
  [2056120990,2056334831,'Scorpio'],
  [2056334831,2056552736,'Sagittarius'],
  [2056552736,2056766252,'Capricorn'],
  [2056766252,2056969851,'Aquarius'],
  [2056969851,2057163015,'Pisces'],
  [2057163015,2057348660,'Aries'],
  [2057348660,2057530767,'Taurus'],
  [2057530767,2057712837,'Gemini'],
  [2057712837,2057897412,'Cancer'],
  [2057897412,2058086403,'Leo'],
  [2058086403,2058281703,'Virgo'],
  [2058281703,2058485200,'Libra'],
  [2058485200,2058697361,'Scorpio'],
  [2058697361,2058914973,'Sagittarius'],
  [2058914973,2059130656,'Capricorn'],
  [2059130656,2059336655,'Aquarius'],
  [2059336655,2059529659,'Pisces'],
  [2059529659,2059711852,'Aries'],
  [2059711852,2059888730,'Taurus'],
  [2059888730,2060066397,'Gemini'],
  [2060066397,2060249583,'Cancer'],
  [2060249583,2060440535,'Leo'],
  [2060440535,2060639264,'Virgo'],
  [2060639264,2060845068,'Libra'],
  [2060845068,2061057439,'Scorpio'],
  [2061057439,2061274797,'Sagittarius'],
  [2061274797,2061492291,'Capricorn'],
  [2061492291,2061702242,'Aquarius'],
  [2061702242,2061898697,'Pisces'],
  [2061898697,2062081326,'Aries'],
  [2062081326,2062255074,'Taurus'],
  [2062255074,2062427291,'Gemini'],
  [2062427291,2062605069,'Cancer'],
  [2062605069,2062793102,'Leo'],
  [2062793102,2062992213,'Virgo'],
  [2062992213,2063200105,'Libra'],
  [2063200105,2063413900,'Scorpio'],
  [2063413900,2063631391,'Sagittarius'],
  [2063631391,2063849566,'Capricorn'],
  [2063849566,2064062752,'Aquarius'],
  [2064062752,2064264331,'Pisces'],
  [2064264331,2064451224,'Aries'],
  [2064451224,2064626137,'Taurus'],
  [2064626137,2064795860,'Gemini'],
  [2064795860,2064968392,'Cancer'],
  [2064968392,2065150620,'Leo'],
  [2065150620,2065345996,'Virgo'],
  [2065345996,2065553260,'Libra'],
  [2065553260,2065768027,'Scorpio'],
  [2065768027,2065985937,'Sagittarius'],
  [2065985937,2066203792,'Capricorn'],
  [2066203792,2066417923,'Aquarius'],
  [2066417923,2066623318,'Pisces'],
  [2066623318,2066815879,'Aries'],
  [2066815879,2066995641,'Taurus'],
  [2066995641,2067167283,'Gemini'],
  [2067167283,2067338057,'Cancer'],
  [2067338057,2067515504,'Leo'],
  [2067515504,2067705263,'Virgo'],
  [2067705263,2067908787,'Libra'],
  [2067908787,2068122639,'Scorpio'],
  [2068122639,2068340762,'Sagittarius'],
  [2068340762,2068558004,'Capricorn'],
  [2068558004,2068770987,'Aquarius'],
  [2068770987,2068976886,'Pisces'],
  [2068976886,2069173051,'Aries'],
  [2069173051,2069358473,'Taurus'],
  [2069358473,2069535312,'Gemini'],
  [2069535312,2069708650,'Cancer'],
  [2069708650,2069885025,'Leo'],
  [2069885025,2070070666,'Virgo'],
  [2070070666,2070269353,'Libra'],
  [2070269353,2070480314,'Scorpio'],
  [2070480314,2070697944,'Sagittarius'],
  [2070697944,2070914972,'Capricorn'],
  [2070914972,2071126321,'Aquarius'],
  [2071126321,2071329939,'Pisces'],
  [2071329939,2071525573,'Aries'],
  [2071525573,2071713704,'Taurus'],
  [2071713704,2071895687,'Gemini'],
  [2071895687,2072074261,'Cancer'],
  [2072074261,2072253610,'Leo'],
  [2072253610,2072438764,'Virgo'],
  [2072438764,2072634222,'Libra'],
  [2072634222,2072841741,'Scorpio'],
  [2072841741,2073058101,'Sagittarius'],
  [2073058101,2073275596,'Capricorn'],
  [2073275596,2073486598,'Aquarius'],
  [2073486598,2073687685,'Pisces'],
  [2073687685,2073879785,'Aries'],
  [2073879785,2074065912,'Taurus'],
  [2074065912,2074249137,'Gemini'],
  [2074249137,2074431841,'Cancer'],
  [2074431841,2074616058,'Leo'],
  [2074616058,2074804285,'Virgo'],
  [2074804285,2074999745,'Libra'],
  [2074999745,2075205152,'Scorpio'],
  [2075205152,2075419994,'Sagittarius'],
  [2075419994,2075638351,'Capricorn'],
  [2075638351,2075851125,'Aquarius'],
  [2075851125,2076052075,'Pisces'],
  [2076052075,2076241091,'Aries'],
  [2076241091,2076422539,'Taurus'],
  [2076422539,2076602050,'Gemini'],
  [2076602050,2076784111,'Cancer'],
  [2076784111,2076970985,'Leo'],
  [2076970985,2077163269,'Virgo'],
  [2077163269,2077361564,'Libra'],
  [2077361564,2077567309,'Scorpio'],
  [2077567309,2077781243,'Sagittarius'],
  [2077781243,2078000223,'Capricorn'],
  [2078000223,2078216112,'Aquarius'],
  [2078216112,2078420315,'Pisces'],
  [2078420315,2078609840,'Aries'],
  [2078609840,2078788203,'Taurus'],
  [2078788203,2078962256,'Gemini'],
  [2078962256,2079138968,'Cancer'],
  [2079138968,2079323176,'Leo'],
  [2079323176,2079516365,'Virgo'],
  [2079516365,2079717560,'Libra'],
  [2079717560,2079925552,'Scorpio'],
  [2079925552,2080139854,'Sagittarius'],
  [2080139854,2080358898,'Capricorn'],
  [2080358898,2080577240,'Aquarius'],
  [2080577240,2080786463,'Pisces'],
  [2080786463,2080980702,'Aries'],
  [2080980702,2081160643,'Taurus'],
  [2081160643,2081332229,'Gemini'],
  [2081332229,2081503290,'Cancer'],
  [2081503290,2081680991,'Leo'],
  [2081680991,2081869804,'Virgo'],
  [2081869804,2082070266,'Libra'],
  [2082070266,2082279910,'Scorpio'],
  [2082279910,2082495559,'Sagittarius'],
  [2082495559,2082714545,'Capricorn'],
  [2082714545,2082933298,'Aquarius'],
  [2082933298,2083145940,'Pisces'],
  [2083145940,2083346328,'Aries'],
  [2083346328,2083532172,'Taurus'],
  [2083532172,2083706608,'Gemini'],
  [2083706608,2083876267,'Cancer'],
  [2083876267,2084048753,'Leo'],
  [2084048753,2084230715,'Virgo'],
  [2084230715,2084425925,'Libra'],
  [2084425925,2084633847,'Scorpio'],
  [2084633847,2084850149,'Sagittarius'],
  [2084850149,2085069413,'Capricorn'],
  [2085069413,2085287217,'Aquarius'],
  [2085287217,2085499790,'Pisces'],
  [2085499790,2085703423,'Aries'],
  [2085703423,2085895525,'Taurus'],
  [2085895525,2086076489,'Gemini'],
  [2086076489,2086250086,'Cancer'],
  [2086250086,2086422345,'Leo'],
  [2086422345,2086600023,'Virgo'],
  [2086600023,2086788965,'Libra'],
  [2086788965,2086991932,'Scorpio'],
  [2086991932,2087206543,'Sagittarius'],
  [2087206543,2087425964,'Capricorn'],
  [2087425964,2087643051,'Aquarius'],
  [2087643051,2087853534,'Pisces'],
  [2087853534,2088055964,'Aries'],
  [2088055964,2088250137,'Taurus'],
  [2088250137,2088436463,'Gemini'],
  [2088436463,2088616429,'Cancer'],
  [2088616429,2088793187,'Leo'],
  [2088793187,2088971617,'Virgo'],
  [2088971617,2089157481,'Libra'],
  [2089157481,2089355550,'Scorpio'],
  [2089355550,2089566631,'Sagittarius'],
  [2089566631,2089785351,'Capricorn'],
  [2089785351,2090002652,'Aquarius'],
  [2090002652,2090211724,'Pisces'],
  [2090211724,2090411017,'Aries'],
  [2090411017,2090602596,'Taurus'],
  [2090602596,2090789241,'Gemini'],
  [2090789241,2090972957,'Cancer'],
  [2090972957,2091155177,'Leo'],
  [2091155177,2091338038,'Virgo'],
  [2091338038,2091525279,'Libra'],
  [2091525279,2091721489,'Scorpio'],
  [2091721489,2091929500,'Sagittarius'],
  [2091929500,2092146828,'Capricorn'],
  [2092146828,2092364975,'Aquarius'],
  [2092364975,2092574736,'Pisces'],
  [2092574736,2092772352,'Aries'],
  [2092772352,2092960085,'Taurus'],
  [2092960085,2093142837,'Gemini'],
  [2093142837,2093325017,'Cancer'],
  [2093325017,2093509095,'Leo'],
  [2093509095,2093696062,'Virgo'],
  [2093696062,2093887162,'Libra'],
  [2093887162,2094084940,'Scorpio'],
  [2094084940,2094292098,'Sagittarius'],
  [2094292098,2094508280,'Capricorn'],
  [2094508280,2094727333,'Aquarius'],
  [2094727333,2094939586,'Pisces'],
  [2094939586,2095138597,'Aries'],
  [2095138597,2095324795,'Taurus'],
  [2095324795,2095503373,'Gemini'],
  [2095503373,2095680651,'Cancer'],
  [2095680651,2095861572,'Leo'],
  [2095861572,2096048616,'Virgo'],
  [2096048616,2096242376,'Libra'],
  [2096242376,2096443139,'Scorpio'],
  [2096443139,2096651628,'Sagittarius'],
  [2096651628,2096867628,'Capricorn'],
  [2096867628,2097087228,'Aquarius'],
  [2097087228,2097302392,'Pisces'],
  [2097302392,2097505328,'Aries'],
  [2097505328,2097693721,'Taurus'],
  [2097693721,2097871192,'Gemini'],
  [2097871192,2098044279,'Cancer'],
  [2098044279,2098219654,'Leo'],
  [2098219654,2098402349,'Virgo'],
  [2098402349,2098594789,'Libra'],
  [2098594789,2098796951,'Scorpio'],
  [2098796951,2099007402,'Sagittarius'],
  [2099007402,2099224139,'Capricorn'],
  [2099224139,2099443838,'Aquarius'],
  [2099443838,2099660754,'Pisces'],
  [2099660754,2099868036,'Aries'],
  [2099868036,2100061449,'Taurus'],
  [2100061449,2100241915,'Gemini'],
  [2100241915,2100414466,'Cancer'],
  [2100414466,2100585868,'Leo'],
  [2100585868,2100762771,'Virgo'],
  [2100762771,2100950221,'Libra'],
  [2100950221,2101150244,'Scorpio'],
  [2101150244,2101361185,'Sagittarius'],
  [2101361185,2101578826,'Capricorn'],
  [2101578826,2101798396,'Aquarius'],
  [2101798396,2102015239,'Pisces'],
  [2102015239,2102224803,'Aries'],
  [2102224803,2102423290,'Taurus'],
  [2102423290,2102609491,'Gemini'],
  [2102609491,2102785755,'Cancer'],
  [2102785755,2102957255,'Leo'],
  [2102957255,2103130617,'Virgo'],
  [2103130617,2103312460,'Libra'],
  [2103312460,2103507507,'Scorpio'],
  [2103507507,2103716213,'Sagittarius'],
  [2103716213,2103933867,'Capricorn'],
  [2103933867,2104153351,'Aquarius'],
  [2104153351,2104368996,'Pisces'],
  [2104368996,2104577814,'Aries'],
  [2104577814,2104778307,'Taurus'],
  [2104778307,2104969552,'Gemini'],
  [2104969552,2105151833,'Cancer'],
  [2105151833,2105327603,'Leo'],
  [2105327603,2105501740,'Virgo'],
  [2105501740,2105680704,'Libra'],
  [2105680704,2105870795,'Scorpio'],
  [2105870795,2106075288,'Sagittarius'],
  [2106075288,2106291392,'Capricorn'],
  [2106291392,2106510887,'Aquarius'],
  [2106510887,2106725647,'Pisces'],
  [2106725647,2106932109,'Aries'],
  [2106932109,2107130694,'Taurus'],
  [2107130694,2107322843,'Gemini'],
  [2107322843,2107509354,'Cancer'],
  [2107509354,2107690897,'Leo'],
  [2107690897,2107869624,'Virgo'],
  [2107869624,2108050037,'Libra'],
  [2108050037,2108238103,'Scorpio'],
  [2108238103,2108438770,'Sagittarius'],
  [2108438770,2108652194,'Capricorn'],
  [2108652194,2108871546,'Aquarius'],
  [2108871546,2109086823,'Pisces'],
  [2109086823,2109291961,'Aries'],
  [2109291961,2109487145,'Taurus'],
  [2109487145,2109675871,'Gemini'],
  [2109675871,2109861488,'Cancer'],
  [2109861488,2110045704,'Leo'],
  [2110045704,2110229364,'Virgo'],
  [2110229364,2110414332,'Libra'],
  [2110414332,2110604357,'Scorpio'],
  [2110604357,2110803897,'Sagittarius'],
  [2110803897,2111015015,'Capricorn'],
  [2111015015,2111233825,'Aquarius'],
  [2111233825,2111450881,'Pisces'],
  [2111450881,2111657522,'Aries'],
  [2111657522,2111851466,'Taurus'],
  [2111851466,2112036094,'Gemini'],
  [2112036094,2112216750,'Cancer'],
  [2112216750,2112397925,'Leo'],
  [2112397925,2112582159,'Virgo'],
  [2112582159,2112770659,'Libra'],
  [2112770659,2112964720,'Scorpio'],
  [2112964720,2113166332,'Sagittarius'],
  [2113166332,2113377044,'Capricorn'],
  [2113377044,2113595179,'Aquarius'],
  [2113595179,2113813998,'Pisces'],
  [2113813998,2114024466,'Aries'],
  [2114024466,2114221216,'Taurus'],
  [2114221216,2114405221,'Gemini'],
  [2114405221,2114581629,'Cancer'],
  [2114581629,2114756725,'Leo'],
  [2114756725,2114935954,'Virgo'],
  [2114935954,2115122832,'Libra'],
  [2115122832,2115318719,'Scorpio'],
  [2115318719,2115523367,'Sagittarius'],
  [2115523367,2115735718,'Capricorn'],
  [2115735718,2115953759,'Aquarius'],
  [2115953759,2116173208,'Pisces'],
  [2116173208,2116387304,'Aries'],
  [2116387304,2116589563,'Taurus'],
  [2116589563,2116777695,'Gemini'],
  [2116777695,2116954449,'Cancer'],
  [2116954449,2117125745,'Leo'],
  [2117125745,2117298538,'Virgo'],
  [2117298538,2117479166,'Libra'],
  [2117479166,2117671734,'Scorpio'],
  [2117671734,2117876653,'Sagittarius'],
  [2117876653,2118090784,'Capricorn'],
  [2118090784,2118309566,'Aquarius'],
  [2118309566,2118528708,'Pisces'],
  [2118528708,2118744016,'Aries'],
  [2118744016,2118950812,'Taurus'],
  [2118950812,2119145374,'Gemini'],
  [2119145374,2119327250,'Cancer'],
  [2119327250,2119499953,'Leo'],
  [2119499953,2119669875,'Virgo'],
  [2119669875,2119844512,'Libra'],
  [2119844512,2120030584,'Scorpio'],
  [2120030584,2120231470,'Sagittarius'],
  [2120231470,2120444936,'Capricorn'],
  [2120444936,2120664361,'Aquarius'],
  [2120664361,2120883151,'Pisces'],
  [2120883151,2121097472,'Aries'],
  [2121097472,2121305184,'Taurus'],
  [2121305184,2121504081,'Gemini'],
  [2121504081,2121692403,'Cancer'],
  [2121692403,2121870694,'Leo'],
  [2121870694,2122042953,'Virgo'],
  [2122042953,2122215863,'Libra'],
  [2122215863,2122396948,'Scorpio'],
  [2122396948,2122592048,'Sagittarius'],
  [2122592048,2122801907,'Capricorn'],
  [2122801907,2123020588,'Aquarius'],
  [2123020588,2123239303,'Pisces'],
  [2123239303,2123452256,'Aries'],
  [2123452256,2123658010,'Taurus'],
  [2123658010,2123856804,'Gemini'],
  [2123856804,2124048381,'Cancer'],
  [2124048381,2124232359,'Leo'],
  [2124232359,2124410129,'Virgo'],
  [2124410129,2124586001,'Libra'],
  [2124586001,2124766400,'Scorpio'],
  [2124766400,2124957756,'Sagittarius'],
  [2124957756,2125163279,'Capricorn'],
  [2125163279,2125379753,'Aquarius'],
  [2125379753,2125598409,'Pisces'],
  [2125598409,2125811038,'Aries'],
  [2125811038,2126014641,'Taurus'],
  [2126014641,2126210407,'Gemini'],
  [2126210407,2126400480,'Cancer'],
  [2126400480,2126586153,'Leo'],
  [2126586153,2126768360,'Virgo'],
  [2126768360,2126949222,'Libra'],
  [2126949222,2127132788,'Scorpio'],
  [2127132788,2127324178,'Sagittarius'],
  [2127324178,2127527235,'Capricorn'],
  [2127527235,2127741303,'Aquarius'],
  [2127741303,2127959739,'Pisces'],
  [2127959739,2128173432,'Aries'],
  [2128173432,2128376822,'Taurus'],
  [2128376822,2128569924,'Gemini'],
  [2128569924,2128755980,'Cancer'],
  [2128755980,2128938686,'Leo'],
  [2128938686,2129120884,'Virgo'],
  [2129120884,2129304724,'Libra'],
  [2129304724,2129492445,'Scorpio'],
  [2129492445,2129686769,'Sagittarius'],
  [2129686769,2129890203,'Capricorn'],
  [2129890203,2130103027,'Aquarius'],
  [2130103027,2130321179,'Pisces'],
  [2130321179,2130536785,'Aries'],
  [2130536785,2130742476,'Taurus'],
  [2130742476,2130935714,'Gemini'],
  [2130935714,2131118863,'Cancer'],
  [2131118863,2131296788,'Leo'],
  [2131296788,2131474717,'Virgo'],
  [2131474717,2131656935,'Libra'],
  [2131656935,2131846178,'Scorpio'],
  [2131846178,2132043627,'Sagittarius'],
  [2132043627,2132249371,'Capricorn'],
  [2132249371,2132462585,'Aquarius'],
  [2132462585,2132680585,'Pisces'],
  [2132680585,2132897903,'Aries'],
  [2132897903,2133107411,'Taurus'],
  [2133107411,2133304114,'Gemini'],
  [2133304114,2133487912,'Cancer'],
  [2133487912,2133662981,'Leo'],
  [2133662981,2133835693,'Virgo'],
  [2133835693,2134012643,'Libra'],
  [2134012643,2134198932,'Scorpio'],
  [2134198932,2134396625,'Sagittarius'],
  [2134396625,2134604378,'Capricorn'],
  [2134604378,2134818998,'Aquarius'],
  [2134818998,2135037124,'Pisces'],
  [2135037124,2135255075,'Aries'],
  [2135255075,2135467807,'Taurus'],
  [2135467807,2135669751,'Gemini'],
  [2135669751,2135858024,'Cancer'],
  [2135858024,2136034417,'Leo'],
  [2136034417,2136204667,'Virgo'],
  [2136204667,2136376350,'Libra'],
  [2136376350,2136556786,'Scorpio'],
  [2136556786,2136750659,'Sagittarius'],
  [2136750659,2136957738,'Capricorn'],
  [2136957738,2137173336,'Aquarius'],
  [2137173336,2137391830,'Pisces'],
  [2137391830,2137609328,'Aries'],
  [2137609328,2137822892,'Taurus'],
  [2137822892,2138028748,'Gemini'],
  [2138028748,2138223056,'Cancer'],
  [2138223056,2138404742,'Leo'],
  [2138404742,2138577174,'Virgo'],
  [2138577174,2138747138,'Libra'],
  [2138747138,2138922658,'Scorpio'],
  [2138922658,2139110626,'Sagittarius'],
  [2139110626,2139313690,'Capricorn'],
  [2139313690,2139528279,'Aquarius'],
  [2139528279,2139747021,'Pisces'],
  [2139747021,2139963832,'Aries'],
  [2139963832,2140175980,'Taurus'],
  [2140175980,2140382040,'Gemini'],
  [2140382040,2140579933,'Cancer'],
  [2140579933,2140767706,'Leo'],
  [2140767706,2140945975,'Virgo'],
  [2140945975,2141119058,'Libra'],
  [2141119058,2141293827,'Scorpio'],
  [2141293827,2141477607,'Sagittarius'],
  [2141477607,2141675392,'Capricorn'],
  [2141675392,2141886660,'Aquarius'],
  [2141886660,2142104840,'Pisces'],
  [2142104840,2142321623,'Aries'],
  [2142321623,2142532142,'Taurus'],
  [2142532142,2142735499,'Gemini'],
  [2142735499,2142932162,'Cancer'],
  [2142932162,2143122193,'Leo'],
  [2143122193,2143305767,'Virgo'],
  [2143305767,2143484757,'Libra'],
  [2143484757,2143663379,'Scorpio'],
  [2143663379,2143847354,'Sagittarius'],
  [2143847354,2144041987,'Capricorn'],
  [2144041987,2144249348,'Aquarius'],
  [2144249348,2144465854,'Pisces'],
  [2144465854,2144683286,'Aries'],
  [2144683286,2144894014,'Taurus'],
  [2144894014,2145095106,'Gemini'],
  [2145095106,2145287744,'Cancer'],
  [2145287744,2145474660,'Leo'],
  [2145474660,2145658412,'Virgo'],
  [2145658412,2145841117,'Libra'],
  [2145841117,2146025030,'Scorpio'],
  [2146025030,2146213057,'Sagittarius'],
  [2146213057,2146408551,'Capricorn'],
  [2146408551,2146613963,'Aquarius'],
  [2146613963,2146828513,'Pisces'],
  [2146828513,2147046560,'Aries'],
  [2147046560,2147259615,'Taurus'],
  [2147259615,2147461599,'Gemini'],
  [2147461599,2147651816,'Cancer'],
  [2147651816,2147833776,'Leo'],
  [2147833776,2148012638,'Virgo'],
  [2148012638,2148193187,'Libra'],
  [2148193187,2148378699,'Scorpio'],
  [2148378699,2148570721,'Sagittarius'],
  [2148570721,2148769787,'Capricorn'],
  [2148769787,2148976283,'Aquarius'],
  [2148976283,2149190001,'Pisces'],
  [2149190001,2149408156,'Aries'],
  [2149408156,2149624126,'Taurus'],
  [2149624126,2149830114,'Gemini'],
  [2149830114,2150022160,'Cancer'],
  [2150022160,2150202092,'Leo'],
  [2150202092,2150375760,'Virgo'],
  [2150375760,2150550245,'Libra'],
  [2150550245,2150731615,'Scorpio'],
  [2150731615,2150923132,'Sagittarius'],
  [2150923132,2151124556,'Capricorn'],
  [2151124556,2151333617,'Aquarius'],
  [2151333617,2151548162,'Pisces'],
  [2151548162,2151766214,'Aries'],
  [2151766214,2151983883,'Taurus'],
  [2151983883,2152194465,'Gemini'],
  [2152194465,2152391780,'Cancer'],
  [2152391780,2152574515,'Leo'],
  [2152574515,2152747004,'Virgo'],
  [2152747004,2152916745,'Libra'],
  [2152916745,2153091666,'Scorpio'],
  [2153091666,2153277846,'Sagittarius'],
  [2153277846,2153477236,'Capricorn'],
  [2153477236,2153687196,'Aquarius'],
  [2153687196,2153903113,'Pisces'],
  [2153903113,2154121334,'Aries'],
  [2154121334,2154339045,'Taurus'],
  [2154339045,2154552034,'Gemini'],
  [2154552034,2154754676,'Cancer'],
  [2154754676,2154943352,'Leo'],
  [2154943352,2155119497,'Virgo'],
  [2155119497,2155289101,'Libra'],
  [2155289101,2155460127,'Scorpio'],
  [2155460127,2155640157,'Sagittarius'],
  [2155640157,2155833976,'Capricorn'],
  [2155833976,2156041318,'Aquarius'],
  [2156041318,2156257260,'Pisces'],
  [2156257260,2156475777,'Aries'],
  [2156475777,2156692740,'Taurus'],
  [2156692740,2156905293,'Gemini'],
  [2156905293,2157110122,'Cancer'],
  [2157110122,2157303973,'Leo'],
  [2157303973,2157486163,'Virgo'],
  [2157486163,2157660018,'Libra'],
  [2157660018,2157831836,'Scorpio'],
  [2157831836,2158008896,'Sagittarius'],
  [2158008896,2158197360,'Capricorn'],
  [2158197360,2158399826,'Aquarius'],
  [2158399826,2158613592,'Pisces'],
  [2158613592,2158831940,'Aries'],
  [2158831940,2159048360,'Taurus'],
  [2159048360,2159259122,'Gemini'],
  [2159259122,2159462556,'Cancer'],
  [2159462556,2159657679,'Leo'],
  [2159657679,2159844235,'Virgo'],
  [2159844235,2160023768,'Libra'],
  [2160023768,2160200067,'Scorpio'],
  [2160200067,2160378535,'Sagittarius'],
  [2160378535,2160564870,'Capricorn'],
  [2160564870,2160763156,'Aquarius'],
  [2160763156,2160973542,'Pisces'],
  [2160973542,2161190973,'Aries'],
  [2161190973,2161407534,'Taurus'],
  [2161407534,2161617156,'Gemini'],
  [2161617156,2161817773,'Cancer'],
  [2161817773,2162010303,'Leo'],
  [2162010303,2162196788,'Virgo'],
  [2162196788,2162379438,'Libra'],
  [2162379438,2162560665,'Scorpio'],
  [2162560665,2162743448,'Sagittarius'],
  [2162743448,2162931455,'Capricorn'],
  [2162931455,2163128365,'Aquarius'],
  [2163128365,2163336057,'Pisces'],
  [2163336057,2163552171,'Aries'],
  [2163552171,2163769515,'Taurus'],
  [2163769515,2163979872,'Gemini'],
  [2163979872,2164179008,'Cancer'],
  [2164179008,2164367886,'Leo'],
  [2164367886,2164550558,'Virgo'],
  [2164550558,2164731577,'Libra'],
  [2164731577,2164914405,'Scorpio'],
  [2164914405,2165101058,'Sagittarius'],
  [2165101058,2165292849,'Capricorn'],
  [2165292849,2165491392,'Aquarius'],
  [2165491392,2165698383,'Pisces'],
  [2165698383,2165913479,'Aries'],
  [2165913479,2166131796,'Taurus'],
  [2166131796,2166344731,'Gemini'],
  [2166344731,2166545368,'Cancer'],
  [2166545368,2166732769,'Leo'],
  [2166732769,2166911277,'Virgo'],
  [2166911277,2167087383,'Libra'],
  [2167087383,2167266992,'Scorpio'],
  [2167266992,2167453633,'Sagittarius'],
  [2167453633,2167648039,'Capricorn'],
  [2167648039,2167849554,'Aquarius'],
  [2167849554,2168057870,'Pisces'],
  [2168057870,2168272789,'Aries'],
  [2168272789,2168491697,'Taurus'],
  [2168491697,2168707721,'Gemini'],
  [2168707721,2168912593,'Cancer'],
  [2168912593,2169102432,'Leo'],
  [2169102432,2169279888,'Virgo'],
  [2169279888,2169451720,'Libra'],
  [2169451720,2169625573,'Scorpio'],
  [2169625573,2169807581,'Sagittarius'],
  [2169807581,2170000471,'Capricorn'],
  [2170000471,2170203336,'Aquarius'],
  [2170203336,2170413653,'Pisces'],
  [2170413653,2170629307,'Aries'],
  [2170629307,2170848225,'Taurus'],
  [2170848225,2171065983,'Gemini'],
  [2171065983,2171275490,'Cancer'],
  [2171275490,2171470918,'Leo'],
  [2171470918,2171651907,'Virgo'],
  [2171651907,2171823532,'Libra'],
  [2171823532,2171993434,'Scorpio'],
  [2171993434,2172169264,'Sagittarius'],
  [2172169264,2172356551,'Capricorn'],
  [2172356551,2172556805,'Aquarius'],
  [2172556805,2172767473,'Pisces'],
  [2172767473,2172984128,'Aries'],
  [2172984128,2173202885,'Taurus'],
  [2173202885,2173420275,'Gemini'],
  [2173420275,2173631792,'Cancer'],
  [2173631792,2173832503,'Leo'],
  [2173832503,2174019957,'Virgo'],
  [2174019957,2174196222,'Libra'],
  [2174196222,2174367021,'Scorpio'],
  [2174367021,2174539612,'Sagittarius'],
  [2174539612,2174720885,'Capricorn'],
  [2174720885,2174915335,'Aquarius'],
  [2174915335,2175123092,'Pisces'],
  [2175123092,2175339644,'Aries'],
  [2175339644,2175558523,'Taurus'],
  [2175558523,2175774614,'Gemini'],
  [2175774614,2175984741,'Cancer'],
  [2175984741,2176186703,'Leo'],
  [2176186703,2176379012,'Virgo'],
  [2176379012,2176561907,'Libra'],
  [2176561907,2176738147,'Scorpio'],
  [2176738147,2176912701,'Sagittarius'],
  [2176912701,2177091716,'Capricorn'],
  [2177091716,2177280990,'Aquarius'],
  [2177280990,2177483749,'Pisces'],
  [2177483749,2177698148,'Aries'],
  [2177698148,2177917154,'Taurus'],
  [2177917154,2178132786,'Gemini'],
  [2178132786,2178340477,'Cancer'],
  [2178340477,2178539631,'Leo'],
  [2178539631,2178731577,'Virgo'],
  [2178731577,2178917861,'Libra'],
  [2178917861,2179100000,'Scorpio'],
  [2179100000,2179280151,'Sagittarius'],
  [2179280151,2179461870,'Capricorn'],
  [2179461870,2179649965,'Aquarius'],
  [2179649965,2179848956,'Pisces'],
  [2179848956,2180060112,'Aries'],
  [2180060112,2180278642,'Taurus'],
  [2180278642,2180495241,'Gemini'],
  [2180495241,2180702344,'Cancer'],
  [2180702344,2180898281,'Leo'],
  [2180898281,2181086050,'Virgo'],
  [2181086050,2181269971,'Libra'],
  [2181269971,2181453344,'Scorpio'],
  [2181453344,2181637841,'Sagittarius'],
  [2181637841,2181824555,'Capricorn'],
  [2181824555,2182015597,'Aquarius'],
  [2182015597,2182214341,'Pisces'],
  [2182214341,2182423383,'Aries'],
  [2182423383,2182640950,'Taurus'],
  [2182640950,2182859177,'Gemini'],
  [2182859177,2183068430,'Cancer'],
  [2183068430,2183264136,'Leo'],
  [2183264136,2183448483,'Virgo'],
  [2183448483,2183627282,'Libra'],
  [2183627282,2183806456,'Scorpio'],
  [2183806456,2183989916,'Sagittarius'],
  [2183989916,2184179018,'Capricorn'],
  [2184179018,2184373895,'Aquarius'],
  [2184373895,2184575282,'Pisces'],
  [2184575282,2184784608,'Aries'],
  [2184784608,2185001563,'Taurus'],
  [2185001563,2185221022,'Gemini'],
  [2185221022,2185433854,'Cancer'],
  [2185433854,2185632918,'Leo'],
  [2185632918,2185817747,'Virgo'],
  [2185817747,2185993447,'Libra'],
  [2185993447,2186167113,'Scorpio'],
  [2186167113,2186345095,'Sagittarius'],
  [2186345095,2186531313,'Capricorn'],
  [2186531313,2186726764,'Aquarius'],
  [2186726764,2186930639,'Pisces'],
  [2186930639,2187141849,'Aries'],
  [2187141849,2187359109,'Taurus'],
  [2187359109,2187578980,'Gemini'],
  [2187578980,2187794660,'Cancer'],
  [2187794660,2187998698,'Leo'],
  [2187998698,2188187886,'Virgo'],
  [2188187886,2188364912,'Libra'],
  [2188364912,2188536102,'Scorpio'],
  [2188536102,2188708670,'Sagittarius'],
  [2188708670,2188888824,'Capricorn'],
  [2188888824,2189080299,'Aquarius'],
  [2189080299,2189283508,'Pisces'],
  [2189283508,2189496003,'Aries'],
  [2189496003,2189714121,'Taurus'],
  [2189714121,2189933859,'Gemini'],
  [2189933859,2190150339,'Cancer'],
  [2190150339,2190358026,'Leo'],
  [2190358026,2190552906,'Virgo'],
  [2190552906,2190734974,'Libra'],
  [2190734974,2190908251,'Scorpio'],
  [2190908251,2191079045,'Sagittarius'],
  [2191079045,2191254226,'Capricorn'],
  [2191254226,2191439726,'Aquarius'],
  [2191439726,2191638745,'Pisces'],
  [2191638745,2191850099,'Aries'],
  [2191850099,2192068617,'Taurus'],
  [2192068617,2192288113,'Gemini'],
  [2192288113,2192503669,'Cancer'],
  [2192503669,2192711902,'Leo'],
  [2192711902,2192910410,'Virgo'],
  [2192910410,2193098252,'Libra'],
  [2193098252,2193276899,'Scorpio'],
  [2193276899,2193450344,'Sagittarius'],
  [2193450344,2193624430,'Capricorn'],
  [2193624430,2193805659,'Aquarius'],
  [2193805659,2193999405,'Pisces'],
  [2193999405,2194207235,'Aries'],
  [2194207235,2194424868,'Taurus'],
  [2194424868,2194644232,'Gemini'],
  [2194644232,2194858506,'Cancer'],
  [2194858506,2195064803,'Leo'],
  [2195064803,2195263029,'Virgo'],
  [2195263029,2195453760,'Libra'],
  [2195453760,2195637706,'Scorpio'],
  [2195637706,2195816483,'Sagittarius'],
  [2195816483,2195993578,'Capricorn'],
  [2195993578,2196174352,'Aquarius'],
  [2196174352,2196364732,'Pisces'],
  [2196364732,2196568548,'Aries'],
  [2196568548,2196784089,'Taurus'],
  [2196784089,2197003398,'Gemini'],
  [2197003398,2197217349,'Cancer'],
  [2197217349,2197421503,'Leo'],
  [2197421503,2197616686,'Virgo'],
  [2197616686,2197805848,'Libra'],
  [2197805848,2197991368,'Scorpio'],
  [2197991368,2198174481,'Sagittarius'],
  [2198174481,2198356524,'Capricorn'],
  [2198356524,2198540458,'Aquarius'],
  [2198540458,2198730941,'Pisces'],
  [2198730941,2198932438,'Aries'],
  [2198932438,2199145702,'Taurus'],
  [2199145702,2199364898,'Gemini'],
  [2199364898,2199580028,'Cancer'],
  [2199580028,2199784028,'Leo'],
  [2199784028,2199976512,'Virgo'],
  [2199976512,2200161544,'Libra'],
  [2200161544,2200343919,'Scorpio'],
  [2200343919,2200526887,'Sagittarius'],
  [2200526887,2200711904,'Capricorn'],
  [2200711904,2200900078,'Aquarius'],
  [2200900078,2201093606,'Pisces'],
  [2201093606,2201295570,'Aries'],
  [2201295570,2201507614,'Taurus'],
  [2201507614,2201726554,'Gemini'],
  [2201726554,2201943798,'Cancer'],
  [2201943798,2202150455,'Leo'],
  [2202150455,2202343358,'Virgo'],
  [2202343358,2202525542,'Libra'],
  [2202525542,2202702883,'Scorpio'],
  [2202702883,2202881090,'Sagittarius'],
  [2202881090,2203064059,'Capricorn'],
  [2203064059,2203253594,'Aquarius'],
  [2203253594,2203450368,'Pisces'],
  [2203450368,2203654906,'Aries'],
  [2203654906,2203867457,'Taurus'],
  [2203867457,2204086136,'Gemini'],
  [2204086136,2204305051,'Cancer'],
  [2204305051,2204515912,'Leo'],
  [2204515912,2204713016,'Virgo'],
  [2204713016,2204896560,'Libra'],
  [2204896560,2205071368,'Scorpio'],
  [2205071368,2205244054,'Sagittarius'],
  [2205244054,2205420953,'Capricorn'],
  [2205420953,2205606689,'Aquarius'],
  [2205606689,2205803233,'Pisces'],
  [2205803233,2206009854,'Aries'],
  [2206009854,2206224121,'Taurus'],
  [2206224121,2206442921,'Gemini'],
  [2206442921,2206662089,'Cancer'],
  [2206662089,2206875951,'Leo'],
  [2206875951,2207078765,'Virgo'],
  [2207078765,2207267868,'Libra'],
  [2207267868,2207445177,'Scorpio'],
  [2207445177,2207616092,'Sagittarius'],
  [2207616092,2207787609,'Capricorn'],
  [2207787609,2207966650,'Aquarius'],
  [2207966650,2208158253,'Pisces'],
  [2208158253,2208363476,'Aries'],
  [2208363476,2208578728,'Taurus'],
  [2208578728,2208798139,'Gemini'],
  [2208798139,2209016617,'Cancer'],
  [2209016617,2209230540,'Leo'],
  [2209230540,2209436642,'Virgo'],
  [2209436642,2209632004,'Libra'],
  [2209632004,2209815724,'Scorpio'],
  [2209815724,2209990227,'Sagittarius'],
  [2209990227,2210161070,'Capricorn'],
  [2210161070,2210335524,'Aquarius'],
  [2210335524,2210520699,'Pisces'],
  [2210520699,2210720847,'Aries'],
  [2210720847,2210934360,'Taurus'],
  [2210934360,2211154048,'Gemini'],
  [2211154048,2211372076,'Cancer'],
  [2211372076,2211584232,'Leo'],
  [2211584232,2211789462,'Virgo'],
  [2211789462,2211987242,'Libra'],
  [2211987242,2212176663,'Scorpio'],
  [2212176663,2212357675,'Sagittarius'],
  [2212357675,2212532881,'Capricorn'],
  [2212532881,2212707843,'Aquarius'],
  [2212707843,2212889654,'Pisces'],
  [2212889654,2213084470,'Aries'],
  [2213084470,2213293912,'Taurus'],
  [2213293912,2213512517,'Gemini'],
  [2213512517,2213730729,'Cancer'],
  [2213730729,2213941697,'Leo'],
  [2213941697,2214144089,'Virgo'],
  [2214144089,2214339584,'Libra'],
  [2214339584,2214529717,'Scorpio'],
  [2214529717,2214714945,'Sagittarius'],
  [2214714945,2214895968,'Capricorn'],
  [2214895968,2215075548,'Aquarius'],
  [2215075548,2215258786,'Pisces'],
  [2215258786,2215451527,'Aries'],
  [2215451527,2215657301,'Taurus'],
  [2215657301,2215873746,'Gemini'],
  [2215873746,2216092322,'Cancer'],
  [2216092322,2216303944,'Leo'],
  [2216303944,2216504857,'Virgo'],
  [2216504857,2216696684,'Libra'],
  [2216696684,2216883068,'Scorpio'],
  [2216883068,2217067018,'Sagittarius'],
  [2217067018,2217250289,'Capricorn'],
  [2217250289,2217434408,'Aquarius'],
  [2217434408,2217621922,'Pisces'],
  [2217621922,2217816486,'Aries'],
  [2217816486,2218021251,'Taurus'],
  [2218021251,2218235918,'Gemini'],
  [2218235918,2218454656,'Cancer'],
  [2218454656,2218668401,'Leo'],
  [2218668401,2218870754,'Virgo'],
  [2218870754,2219061200,'Libra'],
  [2219061200,2219243445,'Scorpio'],
  [2219243445,2219422482,'Sagittarius'],
  [2219422482,2219602682,'Capricorn'],
  [2219602682,2219787090,'Aquarius'],
  [2219787090,2219977630,'Pisces'],
  [2219977630,2220175642,'Aries'],
  [2220175642,2220382055,'Taurus'],
  [2220382055,2220596427,'Gemini'],
  [2220596427,2220815164,'Cancer'],
  [2220815164,2221031261,'Leo'],
  [2221031261,2221237345,'Virgo'],
  [2221237345,2221430077,'Libra'],
  [2221430077,2221611286,'Scorpio'],
  [2221611286,2221786088,'Sagittarius'],
  [2221786088,2221960679,'Capricorn'],
  [2221960679,2222140689,'Aquarius'],
  [2222140689,2222329928,'Pisces'],
  [2222329928,2222529552,'Aries'],
  [2222529552,2222738309,'Taurus'],
  [2222738309,2222953724,'Gemini'],
  [2222953724,2223172512,'Cancer'],
  [2223172512,2223389990,'Leo'],
  [2223389990,2223600076,'Virgo'],
  [2223600076,2223797740,'Libra'],
  [2223797740,2223981987,'Scorpio'],
  [2223981987,2224156255,'Sagittarius'],
  [2224156255,2224326862,'Capricorn'],
  [2224326862,2224501046,'Aquarius'],
  [2224501046,2224685137,'Pisces'],
  [2224685137,2224882442,'Aries'],
  [2224882442,2225091708,'Taurus'],
  [2225091708,2225308315,'Gemini'],
  [2225308315,2225527306,'Cancer'],
  [2225527306,2225744800,'Leo'],
  [2225744800,2225957009,'Virgo'],
  [2225957009,2226159571,'Libra'],
  [2226159571,2226349480,'Scorpio'],
  [2226349480,2226527419,'Sagittarius'],
  [2226527419,2226698133,'Capricorn'],
  [2226698133,2226868862,'Aquarius'],
  [2226868862,2227047324,'Pisces'],
  [2227047324,2227239354,'Aries'],
  [2227239354,2227445982,'Taurus'],
  [2227445982,2227662455,'Gemini'],
  [2227662455,2227881629,'Cancer'],
  [2227881629,2228098354,'Leo'],
  [2228098354,2228310089,'Virgo'],
  [2228310089,2228514711,'Libra'],
  [2228514711,2228709628,'Scorpio'],
  [2228709628,2228893510,'Sagittarius'],
  [2228893510,2229068434,'Capricorn'],
  [2229068434,2229240009,'Aquarius'],
  [2229240009,2229415715,'Pisces'],
  [2229415715,2229602674,'Aries'],
  [2229602674,2229804581,'Taurus'],
  [2229804581,2230018876,'Gemini'],
  [2230018876,2230237829,'Cancer'],
  [2230237829,2230453963,'Leo'],
  [2230453963,2230663861,'Virgo'],
  [2230663861,2230867013,'Libra'],
  [2230867013,2231063120,'Scorpio'],
  [2231063120,2231251384,'Sagittarius'],
  [2231251384,2231432097,'Capricorn'],
  [2231432097,2231608278,'Aquarius'],
  [2231608278,2231785540,'Pisces'],
  [2231785540,2231970508,'Aries'],
  [2231970508,2232168271,'Taurus'],
  [2232168271,2232379134,'Gemini'],
  [2232379134,2232597159,'Cancer'],
  [2232597159,2232813526,'Leo'],
  [2232813526,2233022344,'Virgo'],
  [2233022344,2233222580,'Libra'],
  [2233222580,2233415808,'Scorpio'],
  [2233415808,2233603723,'Sagittarius'],
  [2233603723,2233787522,'Capricorn'],
  [2233787522,2233968860,'Aquarius'],
  [2233968860,2234150825,'Pisces'],
  [2234150825,2234337843,'Aries'],
  [2234337843,2234534363,'Taurus'],
  [2234534363,2234742393,'Gemini'],
  [2234742393,2234958956,'Cancer'],
  [2234958956,2235176263,'Leo'],
  [2235176263,2235386223,'Virgo'],
  [2235386223,2235585262,'Libra'],
  [2235585262,2235774679,'Scorpio'],
  [2235774679,2235958174,'Sagittarius'],
  [2235958174,2236139658,'Capricorn'],
  [2236139658,2236322236,'Aquarius'],
  [2236322236,2236508207,'Pisces'],
  [2236508207,2236699544,'Aries'],
  [2236699544,2236898218,'Taurus'],
  [2236898218,2237105655,'Gemini'],
  [2237105655,2237320953,'Cancer'],
  [2237320953,2237539135,'Leo'],
  [2237539135,2237752158,'Virgo'],
  [2237752158,2237953560,'Libra'],
  [2237953560,2238142118,'Scorpio'],
  [2238142118,2238321369,'Sagittarius'],
  [2238321369,2238497168,'Capricorn'],
  [2238497168,2238675436,'Aquarius'],
  [2238675436,2238860529,'Pisces'],
  [2238860529,2239054294,'Aries'],
  [2239054294,2239256375,'Taurus'],
  [2239256375,2239465607,'Gemini'],
  [2239465607,2239680719,'Cancer'],
  [2239680719,2239899093,'Leo'],
  [2239899093,2240115114,'Virgo'],
  [2240115114,2240321479,'Libra'],
  [2240321479,2240513708,'Scorpio'],
  [2240513708,2240692896,'Sagittarius'],
  [2240692896,2240864703,'Capricorn'],
  [2240864703,2241036685,'Aquarius'],
  [2241036685,2241215940,'Pisces'],
  [2241215940,2241406921,'Aries'],
  [2241406921,2241609764,'Taurus'],
  [2241609764,2241821163,'Gemini'],
  [2241821163,2242037309,'Cancer'],
  [2242037309,2242255474,'Leo'],
  [2242255474,2242472542,'Virgo'],
  [2242472542,2242683184,'Libra'],
  [2242683184,2242881608,'Scorpio'],
  [2242881608,2243065610,'Sagittarius'],
  [2243065610,2243238492,'Capricorn'],
  [2243238492,2243407386,'Aquarius'],
  [2243407386,2243580550,'Pisces'],
  [2243580550,2243765028,'Aries'],
  [2243765028,2243963939,'Taurus'],
  [2243963939,2244174874,'Gemini'],
  [2244174874,2244392008,'Cancer'],
  [2244392008,2244610209,'Leo'],
  [2244610209,2244826518,'Virgo'],
  [2244826518,2245038123,'Libra'],
  [2245038123,2245240936,'Scorpio'],
  [2245240936,2245431461,'Sagittarius'],
  [2245431461,2245609921,'Capricorn'],
  [2245609921,2245781081,'Aquarius'],
  [2245781081,2245952378,'Pisces'],
  [2245952378,2246131581,'Aries'],
  [2246131581,2246324320,'Taurus'],
  [2246324320,2246531308,'Gemini'],
  [2246531308,2246747625,'Cancer'],
  [2246747625,2246966021,'Leo'],
  [2246966021,2247181336,'Virgo'],
  [2247181336,2247391199,'Libra'],
  [2247391199,2247594026,'Scorpio'],
  [2247594026,2247788023,'Sagittarius'],
  [2247788023,2247972460,'Capricorn'],
  [2247972460,2248149404,'Aquarius'],
  [2248149404,2248323837,'Pisces'],
  [2248323837,2248502295,'Aries'],
  [2248502295,2248690918,'Taurus'],
  [2248690918,2248892957,'Gemini'],
  [2248892957,2249106470,'Cancer'],
  [2249106470,2249324597,'Leo'],
  [2249324597,2249539783,'Virgo'],
  [2249539783,2249747762,'Libra'],
  [2249747762,2249947690,'Scorpio'],
  [2249947690,2250140293,'Sagittarius'],
  [2250140293,2250326655,'Capricorn'],
  [2250326655,2250508382,'Aquarius'],
  [2250508382,2250688198,'Pisces'],
  [2250688198,2250870105,'Aries'],
  [2250870105,2251058765,'Taurus'],
  [2251058765,2251257980,'Gemini'],
  [2251257980,2251468408,'Cancer'],
  [2251468408,2251685670,'Leo'],
  [2251685670,2251901696,'Virgo'],
  [2251901696,2252109589,'Libra'],
  [2252109589,2252307004,'Scorpio'],
  [2252307004,2252495676,'Sagittarius'],
  [2252495676,2252679174,'Capricorn'],
  [2252679174,2252861059,'Aquarius'],
  [2252861059,2253044124,'Pisces'],
  [2253044124,2253230530,'Aries'],
  [2253230530,2253422404,'Taurus'],
  [2253422404,2253622070,'Gemini'],
  [2253622070,2253830960,'Cancer'],
  [2253830960,2254047294,'Leo'],
  [2254047294,2254264652,'Virgo'],
  [2254264652,2254474648,'Libra'],
  [2254474648,2254672259,'Scorpio'],
  [2254672259,2254858140,'Sagittarius'],
  [2254858140,2255036991,'Capricorn'],
  [2255036991,2255214715,'Aquarius'],
  [2255214715,2255396241,'Pisces'],
  [2255396241,2255584305,'Aries'],
  [2255584305,2255779528,'Taurus'],
  [2255779528,2255981787,'Gemini'],
  [2255981787,2256191225,'Cancer'],
  [2256191225,2256407176,'Leo'],
  [2256407176,2256625675,'Virgo'],
  [2256625675,2256838994,'Libra'],
  [2256838994,2257039877,'Scorpio'],
  [2257039877,2257226435,'Sagittarius'],
  [2257226435,2257402599,'Capricorn'],
  [2257402599,2257575312,'Aquarius'],
  [2257575312,2257751674,'Pisces'],
  [2257751674,2257936775,'Aries'],
  [2257936775,2258132229,'Taurus'],
  [2258132229,2258336639,'Gemini'],
  [2258336639,2258547822,'Cancer'],
  [2258547822,2258764140,'Leo'],
  [2258764140,2258983113,'Virgo'],
  [2258983113,2259199192,'Libra'],
  [2259199192,2259404909,'Scorpio'],
  [2259404909,2259595749,'Sagittarius'],
  [2259595749,2259773273,'Capricorn'],
  [2259773273,2259943737,'Aquarius'],
  [2259943737,2260115043,'Pisces'],
  [2260115043,2260294344,'Aries'],
  [2260294344,2260485854,'Taurus'],
  [2260485854,2260689443,'Gemini'],
  [2260689443,2260901732,'Cancer'],
  [2260901732,2261118827,'Leo'],
  [2261118827,2261337672,'Virgo'],
  [2261337672,2261554551,'Libra'],
  [2261554551,2261763908,'Scorpio'],
  [2261763908,2261960504,'Sagittarius'],
  [2261960504,2262143164,'Capricorn'],
  [2262143164,2262315838,'Aquarius'],
  [2262315838,2262485562,'Pisces'],
  [2262485562,2262660039,'Aries'],
  [2262660039,2262845573,'Taurus'],
  [2262845573,2263044865,'Gemini'],
  [2263044865,2263255886,'Cancer'],
  [2263255886,2263473345,'Leo'],
  [2263473345,2263691934,'Virgo'],
  [2263691934,2263907804,'Libra'],
  [2263907804,2264117561,'Scorpio'],
  [2264117561,2264317785,'Sagittarius'],
  [2264317785,2264506475,'Capricorn'],
  [2264506475,2264684919,'Aquarius'],
  [2264684919,2264857728,'Pisces'],
  [2264857728,2265031399,'Aries'],
  [2265031399,2265212629,'Taurus'],
  [2265212629,2265406368,'Gemini'],
  [2265406368,2265613575,'Cancer'],
  [2265613575,2265830079,'Leo'],
  [2265830079,2266048661,'Virgo'],
  [2266048661,2266263250,'Libra'],
  [2266263250,2266470764,'Scorpio'],
  [2266470764,2266670247,'Sagittarius'],
  [2266670247,2266861627,'Capricorn'],
  [2266861627,2267045641,'Aquarius'],
  [2267045641,2267224442,'Pisces'],
  [2267224442,2267401872,'Aries'],
  [2267401872,2267583075,'Taurus'],
  [2267583075,2267773362,'Gemini'],
  [2267773362,2267976151,'Cancer'],
  [2267976151,2268190255,'Leo'],
  [2268190255,2268408927,'Virgo'],
  [2268408927,2268623561,'Libra'],
  [2268623561,2268828973,'Scorpio'],
  [2268828973,2269024881,'Sagittarius'],
  [2269024881,2269213841,'Capricorn'],
  [2269213841,2269398778,'Aquarius'],
  [2269398778,2269581885,'Pisces'],
  [2269581885,2269764892,'Aries'],
  [2269764892,2269950112,'Taurus'],
  [2269950112,2270141051,'Gemini'],
  [2270141051,2270341521,'Cancer'],
  [2270341521,2270552979,'Leo'],
  [2270552979,2270771391,'Virgo'],
  [2270771391,2270987685,'Libra'],
  [2270987685,2271193656,'Scorpio'],
  [2271193656,2271387128,'Sagittarius'],
  [2271387128,2271571469,'Capricorn'],
  [2271571469,2271752163,'Aquarius'],
  [2271752163,2271933928,'Pisces'],
  [2271933928,2272119297,'Aries'],
  [2272119297,2272308983,'Taurus'],
  [2272308983,2272503669,'Gemini'],
  [2272503669,2272705204,'Cancer'],
  [2272705204,2272915505,'Leo'],
  [2272915505,2273133307,'Virgo'],
  [2273133307,2273351692,'Libra'],
  [2273351692,2273561066,'Scorpio'],
  [2273561066,2273756025,'Sagittarius'],
  [2273756025,2273938242,'Capricorn'],
  [2273938242,2274113876,'Aquarius'],
  [2274113876,2274289934,'Pisces'],
  [2274289934,2274471750,'Aries'],
  [2274471750,2274661600,'Taurus'],
  [2274661600,2274859191,'Gemini'],
  [2274859191,2275063700,'Cancer'],
  [2275063700,2275275023,'Leo'],
  [2275275023,2275492507,'Virgo'],
  [2275492507,2275712007,'Libra'],
  [2275712007,2275925406,'Scorpio'],
  [2275925406,2276125285,'Sagittarius'],
  [2276125285,2276310134,'Capricorn'],
  [2276310134,2276484499,'Aquarius'],
  [2276484499,2276655724,'Pisces'],
  [2276655724,2276831086,'Aries'],
  [2276831086,2277015806,'Taurus'],
  [2277015806,2277211728,'Gemini'],
  [2277211728,2277417601,'Cancer'],
  [2277417601,2277630803,'Leo'],
  [2277630803,2277848756,'Virgo'],
  [2277848756,2278068183,'Libra'],
  [2278068183,2278283633,'Scorpio'],
  [2278283633,2278488602,'Sagittarius'],
  [2278488602,2278679357,'Capricorn'],
  [2278679357,2278857427,'Aquarius'],
  [2278857427,2279028455,'Pisces'],
  [2279028455,2279199687,'Aries'],
  [2279199687,2279378000,'Taurus'],
  [2279378000,2279568201,'Gemini'],
  [2279568201,2279771467,'Cancer'],
  [2279771467,2279984968,'Leo'],
  [2279984968,2280203652,'Virgo'],
  [2280203652,2280422616,'Libra'],
  [2280422616,2280637597,'Scorpio'],
  [2280637597,2280844621,'Sagittarius'],
  [2280844621,2281040561,'Capricorn'],
  [2281040561,2281224859,'Aquarius'],
  [2281224859,2281400312,'Pisces'],
  [2281400312,2281572299,'Aries'],
  [2281572299,2281747401,'Taurus'],
  [2281747401,2281931911,'Gemini'],
  [2281931911,2282129908,'Cancer'],
  [2282129908,2282340952,'Leo'],
  [2282340952,2282559531,'Virgo'],
  [2282559531,2282778260,'Libra'],
  [2282778260,2282991695,'Scorpio'],
  [2282991695,2283197390,'Sagittarius'],
  [2283197390,2283394620,'Capricorn'],
  [2283394620,2283583397,'Aquarius'],
  [2283583397,2283764762,'Pisces'],
  [2283764762,2283941412,'Aries'],
  [2283941412,2284117938,'Taurus'],
  [2284117938,2284300195,'Gemini'],
  [2284300195,2284493683,'Cancer'],
  [2284493683,2284700792,'Leo'],
  [2284700792,2284917982,'Virgo'],
  [2284917982,2285136780,'Libra'],
  [2285136780,2285349307,'Scorpio'],
  [2285349307,2285552454,'Sagittarius'],
  [2285552454,2285747264,'Capricorn'],
  [2285747264,2285936060,'Aquarius'],
  [2285936060,2286120660,'Pisces'],
  [2286120660,2286302414,'Aries'],
  [2286302414,2286483411,'Taurus'],
  [2286483411,2286667466,'Gemini'],
  [2286667466,2286859585,'Cancer'],
  [2286859585,2287063649,'Leo'],
  [2287063649,2287278844,'Virgo'],
  [2287278844,2287497868,'Libra'],
  [2287497868,2287711024,'Scorpio'],
  [2287711024,2287912927,'Sagittarius'],
  [2287912927,2288104416,'Capricorn'],
  [2288104416,2288289643,'Aquarius'],
  [2288289643,2288472741,'Pisces'],
  [2288472741,2288656190,'Aries'],
  [2288656190,2288841167,'Taurus'],
  [2288841167,2289029189,'Gemini'],
  [2289029189,2289223193,'Cancer'],
  [2289223193,2289426614,'Leo'],
  [2289426614,2289640364,'Virgo'],
  [2289640364,2289859607,'Libra'],
  [2289859607,2290074792,'Scorpio'],
  [2290074792,2290278112,'Sagittarius'],
  [2290278112,2290468379,'Capricorn'],
  [2290468379,2290649790,'Aquarius'],
  [2290649790,2290828244,'Pisces'],
  [2290828244,2291008636,'Aries'],
  [2291008636,2291193683,'Taurus'],
  [2291193683,2291384417,'Gemini'],
  [2291384417,2291581653,'Cancer'],
  [2291581653,2291786730,'Leo'],
  [2291786730,2292000343,'Virgo'],
  [2292000343,2292219699,'Libra'],
  [2292219699,2292437252,'Scorpio'],
  [2292437252,2292644326,'Sagittarius'],
  [2292644326,2292836953,'Capricorn'],
  [2292836953,2293017498,'Aquarius'],
  [2293017498,2293191927,'Pisces'],
  [2293191927,2293366803,'Aries'],
  [2293366803,2293547402,'Taurus'],
  [2293547402,2293736700,'Gemini'],
  [2293736700,2293935408,'Cancer'],
  [2293935408,2294142802,'Leo'],
  [2294142802,2294357503,'Virgo'],
  [2294357503,2294576922,'Libra'],
  [2294576922,2294795834,'Scorpio'],
  [2294795834,2295007016,'Sagittarius'],
  [2295007016,2295204864,'Capricorn'],
  [2295204864,2295388809,'Aquarius'],
  [2295388809,2295563007,'Pisces'],
  [2295563007,2295733965,'Aries'],
  [2295733965,2295908528,'Taurus'],
  [2295908528,2296092364,'Gemini'],
  [2296092364,2296288496,'Cancer'],
  [2296288496,2296496339,'Leo'],
  [2296496339,2296712335,'Virgo'],
  [2296712335,2296931954,'Libra'],
  [2296931954,2297150687,'Scorpio'],
  [2297150687,2297363826,'Sagittarius'],
  [2297363826,2297566780,'Capricorn'],
  [2297566780,2297756990,'Aquarius'],
  [2297756990,2297935603,'Pisces'],
  [2297935603,2298107178,'Aries'],
  [2298107178,2298278315,'Taurus'],
  [2298278315,2298456119,'Gemini'],
  [2298456119,2298646401,'Cancer'],
  [2298646401,2298851181,'Leo'],
  [2298851181,2299067018,'Virgo'],
  [2299067018,2299286955,'Libra'],
  [2299286955,2299504774,'Scorpio'],
  [2299504774,2299716950,'Sagittarius'],
  [2299716950,2299921527,'Capricorn'],
  [2299921527,2300116839,'Aquarius'],
  [2300116839,2300302126,'Pisces'],
  [2300302126,2300478913,'Aries'],
  [2300478913,2300651640,'Taurus'],
  [2300651640,2300826904,'Gemini'],
  [2300826904,2301011782,'Cancer'],
  [2301011782,2301211179,'Leo'],
  [2301211179,2301424372,'Virgo'],
  [2301424372,2301644149,'Libra'],
  [2301644149,2301861585,'Scorpio'],
  [2301861585,2302071713,'Sagittarius'],
  [2302071713,2302274069,'Capricorn'],
  [2302274069,2302469692,'Aquarius'],
  [2302469692,2302658990,'Pisces'],
  [2302658990,2302842026,'Aries'],
  [2302842026,2303020325,'Taurus'],
  [2303020325,2303198090,'Gemini'],
  [2303198090,2303381543,'Cancer'],
  [2303381543,2303576721,'Leo'],
  [2303576721,2303785919,'Virgo'],
  [2303785919,2304004426,'Libra'],
  [2304004426,2304222387,'Scorpio'],
  [2304222387,2304431919,'Sagittarius'],
  [2304431919,2304631362,'Capricorn'],
  [2304631362,2304823319,'Aquarius'],
  [2304823319,2305010957,'Pisces'],
  [2305010957,2305196029,'Aries'],
  [2305196029,2305379294,'Taurus'],
  [2305379294,2305562369,'Gemini'],
  [2305562369,2305748873,'Cancer'],
  [2305748873,2305943649,'Leo'],
  [2305943649,2306150139,'Virgo'],
  [2306150139,2306366728,'Libra'],
  [2306366728,2306585459,'Scorpio'],
  [2306585459,2306796730,'Sagittarius'],
  [2306796730,2306995905,'Capricorn'],
  [2306995905,2307184565,'Aquarius'],
  [2307184565,2307367320,'Pisces'],
  [2307367320,2307548687,'Aries'],
  [2307548687,2307731631,'Taurus'],
  [2307731631,2307917801,'Gemini'],
  [2307917801,2308108708,'Cancer'],
  [2308108708,2308306479,'Leo'],
  [2308306479,2308513195,'Virgo'],
  [2308513195,2308728574,'Libra'],
  [2308728574,2308947644,'Scorpio'],
  [2308947644,2309161828,'Sagittarius'],
  [2309161828,2309364124,'Capricorn'],
  [2309364124,2309553233,'Aquarius'],
  [2309553233,2309732817,'Pisces'],
  [2309732817,2309908634,'Aries'],
  [2309908634,2310086308,'Taurus'],
  [2310086308,2310270042,'Gemini'],
  [2310270042,2310462091,'Cancer'],
  [2310462091,2310662943,'Leo'],
  [2310662943,2310871978,'Virgo'],
  [2310871978,2311087686,'Libra'],
  [2311087686,2311306695,'Scorpio'],
  [2311306695,2311523082,'Sagittarius'],
  [2311523082,2311729980,'Capricorn'],
  [2311729980,2311923394,'Aquarius'],
  [2311923394,2312104264,'Pisces'],
  [2312104264,2312277429,'Aries'],
  [2312277429,2312449533,'Taurus'],
  [2312449533,2312627199,'Gemini'],
  [2312627199,2312815405,'Cancer'],
  [2312815405,2313015877,'Leo'],
  [2313015877,2313226624,'Virgo'],
  [2313226624,2313443589,'Libra'],
  [2313443589,2313662567,'Scorpio'],
  [2313662567,2313879477,'Sagittarius'],
  [2313879477,2314089649,'Capricorn'],
  [2314089649,2314288602,'Aquarius'],
  [2314288602,2314474544,'Pisces'],
  [2314474544,2314649759,'Aries'],
  [2314649759,2314819972,'Taurus'],
  [2314819972,2314992567,'Gemini'],
  [2314992567,2315174672,'Cancer'],
  [2315174672,2315370802,'Leo'],
  [2315370802,2315580376,'Virgo'],
  [2315580376,2315797969,'Libra'],
  [2315797969,2316017071,'Scorpio'],
  [2316017071,2316233261,'Sagittarius'],
  [2316233261,2316443889,'Capricorn'],
  [2316443889,2316646275,'Aquarius'],
  [2316646275,2316837931,'Pisces'],
  [2316837931,2317018546,'Aries'],
  [2317018546,2317191438,'Taurus'],
  [2317191438,2317362990,'Gemini'],
  [2317362990,2317540819,'Cancer'],
  [2317540819,2317731441,'Leo'],
  [2317731441,2317937082,'Virgo'],
  [2317937082,2318153518,'Libra'],
  [2318153518,2318372622,'Scorpio'],
  [2318372622,2318587925,'Sagittarius'],
  [2318587925,2318796917,'Capricorn'],
  [2318796917,2318999056,'Aquarius'],
  [2318999056,2319193518,'Pisces'],
  [2319193518,2319379402,'Aries'],
  [2319379402,2319557663,'Taurus'],
  [2319557663,2319732360,'Gemini'],
  [2319732360,2319909921,'Cancer'],
  [2319909921,2320097178,'Leo'],
  [2320097178,2320298427,'Virgo'],
  [2320298427,2320512154,'Libra'],
  [2320512154,2320730833,'Scorpio'],
  [2320730833,2320945952,'Sagittarius'],
  [2320945952,2321153222,'Capricorn'],
  [2321153222,2321352660,'Aquarius'],
  [2321352660,2321545688,'Pisces'],
  [2321545688,2321733176,'Aries'],
  [2321733176,2321915790,'Taurus'],
  [2321915790,2322095522,'Gemini'],
  [2322095522,2322276460,'Cancer'],
  [2322276460,2322464026,'Leo'],
  [2322464026,2322662868,'Virgo'],
  [2322662868,2322873778,'Libra'],
  [2322873778,2323091616,'Scorpio'],
  [2323091616,2323307538,'Sagittarius'],
  [2323307538,2323514781,'Capricorn'],
  [2323514781,2323711878,'Aquarius'],
  [2323711878,2323901107,'Pisces'],
  [2323901107,2324085705,'Aries'],
  [2324085705,2324268346,'Taurus'],
  [2324268346,2324451162,'Gemini'],
  [2324451162,2324636499,'Cancer'],
  [2324636499,2324827346,'Leo'],
  [2324827346,2325026804,'Virgo'],
  [2325026804,2325236302,'Libra'],
  [2325236302,2325453249,'Scorpio'],
  [2325453249,2325670558,'Sagittarius'],
  [2325670558,2325880081,'Capricorn'],
  [2325880081,2326077596,'Aquarius'],
  [2326077596,2326264151,'Pisces'],
  [2326264151,2326443999,'Aries'],
  [2326443999,2326622248,'Taurus'],
  [2326622248,2326803327,'Gemini'],
  [2326803327,2326990249,'Cancer'],
  [2326990249,2327184556,'Leo'],
  [2327184556,2327386808,'Virgo'],
  [2327386808,2327596934,'Libra'],
  [2327596934,2327813428,'Scorpio'],
  [2327813428,2328031847,'Sagittarius'],
  [2328031847,2328244961,'Capricorn'],
  [2328244961,2328446276,'Aquarius'],
  [2328446276,2328633966,'Pisces'],
  [2328633966,2328811210,'Aries'],
  [2328811210,2328984126,'Taurus'],
  [2328984126,2329159515,'Gemini'],
  [2329159515,2329342990,'Cancer'],
  [2329342990,2329537328,'Leo'],
  [2329537328,2329741875,'Virgo'],
  [2329741875,2329953953,'Libra'],
  [2329953953,2330170776,'Scorpio'],
  [2330170776,2330389429,'Sagittarius'],
  [2330389429,2330605260,'Capricorn'],
  [2330605260,2330811910,'Aquarius'],
  [2330811910,2331004766,'Pisces'],
  [2331004766,2331184111,'Aries'],
  [2331184111,2331355016,'Taurus'],
  [2331355016,2331525065,'Gemini'],
  [2331525065,2331702038,'Cancer'],
  [2331702038,2331891611,'Leo'],
  [2331891611,2332094877,'Virgo'],
  [2332094877,2332308085,'Libra'],
  [2332308085,2332525818,'Scorpio'],
  [2332525818,2332744150,'Sagittarius'],
  [2332744150,2332960298,'Capricorn'],
  [2332960298,2333170345,'Aquarius'],
  [2333170345,2333369433,'Pisces'],
  [2333369433,2333554950,'Aries'],
  [2333554950,2333729088,'Taurus'],
  [2333729088,2333898206,'Gemini'],
  [2333898206,2334070448,'Cancer'],
  [2334070448,2334253431,'Leo'],
  [2334253431,2334451405,'Virgo'],
  [2334451405,2334662681,'Libra'],
  [2334662681,2334880734,'Scorpio'],
  [2334880734,2335098948,'Sagittarius'],
  [2335098948,2335313784,'Capricorn'],
  [2335313784,2335523410,'Aquarius'],
  [2335523410,2335725380,'Pisces'],
  [2335725380,2335916962,'Aries'],
  [2335916962,2336097705,'Taurus'],
  [2336097705,2336271099,'Gemini'],
  [2336271099,2336443681,'Cancer'],
  [2336443681,2336622975,'Leo'],
  [2336622975,2336815076,'Virgo'],
  [2336815076,2337021624,'Libra'],
  [2337021624,2337238105,'Scorpio'],
  [2337238105,2337456441,'Sagittarius'],
  [2337456441,2337670354,'Capricorn'],
  [2337670354,2337877508,'Aquarius'],
  [2337877508,2338077649,'Pisces'],
  [2338077649,2338270582,'Aries'],
  [2338270582,2338456194,'Taurus'],
  [2338456194,2338635867,'Gemini'],
  [2338635867,2338813302,'Cancer'],
  [2338813302,2338993974,'Leo'],
  [2338993974,2339183579,'Virgo'],
  [2339183579,2339385682,'Libra'],
  [2339385682,2339599080,'Scorpio'],
  [2339599080,2339817160,'Sagittarius'],
  [2339817160,2340031599,'Capricorn'],
  [2340031599,2340237395,'Aquarius'],
  [2340237395,2340434034,'Pisces'],
  [2340434034,2340623545,'Aries'],
  [2340623545,2340808473,'Taurus'],
  [2340808473,2340991109,'Gemini'],
  [2340991109,2341173733,'Cancer'],
  [2341173733,2341359113,'Leo'],
  [2341359113,2341550608,'Virgo'],
  [2341550608,2341751327,'Libra'],
  [2341751327,2341962138,'Scorpio'],
  [2341962138,2342179440,'Sagittarius'],
  [2342179440,2342395430,'Capricorn'],
  [2342395430,2342602528,'Aquarius'],
  [2342602528,2342797773,'Pisces'],
  [2342797773,2342983166,'Aries'],
  [2342983166,2343163378,'Taurus'],
  [2343163378,2343343355,'Gemini'],
  [2343343355,2343526827,'Cancer'],
  [2343526827,2343715822,'Leo'],
  [2343715822,2343911222,'Virgo'],
  [2343911222,2344113774,'Libra'],
  [2344113774,2344324054,'Scorpio'],
  [2344324054,2344540655,'Sagittarius'],
  [2344540655,2344758199,'Capricorn'],
  [2344758199,2344968592,'Aquarius'],
  [2344968592,2345166010,'Pisces'],
  [2345166010,2345350332,'Aries'],
  [2345350332,2345526335,'Taurus'],
  [2345526335,2345700829,'Gemini'],
  [2345700829,2345880112,'Cancer'],
  [2345880112,2346068107,'Leo'],
  [2346068107,2346265492,'Virgo'],
  [2346265492,2346470791,'Libra'],
  [2346470791,2346682408,'Scorpio'],
  [2346682408,2346898962,'Sagittarius'],
  [2346898962,2347117325,'Capricorn'],
  [2347117325,2347331095,'Aquarius'],
  [2347331095,2347533134,'Pisces'],
  [2347533134,2347720435,'Aries'],
  [2347720435,2347895968,'Taurus'],
  [2347895968,2348066601,'Gemini'],
  [2348066601,2348240148,'Cancer'],
  [2348240148,2348423030,'Leo'],
  [2348423030,2348618138,'Virgo'],
  [2348618138,2348824103,'Libra'],
  [2348824103,2349037280,'Scorpio'],
  [2349037280,2349254401,'Sagittarius'],
  [2349254401,2349472773,'Capricorn'],
  [2349472773,2349688231,'Aquarius'],
  [2349688231,2349894699,'Pisces'],
  [2349894699,2350087438,'Aries'],
  [2350087438,2350266660,'Taurus'],
  [2350266660,2350437576,'Gemini'],
  [2350437576,2350607851,'Cancer'],
  [2350607851,2350785147,'Leo'],
  [2350785147,2350974868,'Virgo'],
  [2350974868,2351178016,'Libra'],
  [2351178016,2351391087,'Scorpio'],
  [2351391087,2351608754,'Sagittarius'],
  [2351608754,2351826755,'Capricorn'],
  [2351826755,2352041795,'Aquarius'],
  [2352041795,2352250036,'Pisces'],
  [2352250036,2352447471,'Aries'],
  [2352447471,2352632492,'Taurus'],
  [2352632492,2352807687,'Gemini'],
  [2352807687,2352978995,'Cancer'],
  [2352978995,2353153674,'Leo'],
  [2353153674,2353338287,'Virgo'],
  [2353338287,2353536457,'Libra'],
  [2353536457,2353747011,'Scorpio'],
  [2353747011,2353964419,'Sagittarius'],
  [2353964419,2354182169,'Capricorn'],
  [2354182169,2354395769,'Aquarius'],
  [2354395769,2354602688,'Pisces'],
  [2354602688,2354801247,'Aries'],
  [2354801247,2354990524,'Taurus'],
  [2354990524,2355171452,'Gemini'],
  [2355171452,2355347424,'Cancer'],
  [2355347424,2355523746,'Leo'],
  [2355523746,2355706396,'Virgo'],
  [2355706396,2355900284,'Libra'],
  [2355900284,2356106990,'Scorpio'],
  [2356106990,2356323002,'Sagittarius'],
  [2356323002,2356540865,'Capricorn'],
  [2356540865,2356753634,'Aquarius'],
  [2356753634,2356957998,'Pisces'],
  [2356957998,2357153987,'Aries'],
  [2357153987,2357343124,'Taurus'],
  [2357343124,2357527240,'Gemini'],
  [2357527240,2357708422,'Cancer'],
  [2357708422,2357889462,'Leo'],
  [2357889462,2358074139,'Virgo'],
  [2358074139,2358266730,'Libra'],
  [2358266730,2358470357,'Scorpio'],
  [2358470357,2358684336,'Sagittarius'],
  [2358684336,2358902551,'Capricorn'],
  [2358902551,2359116202,'Aquarius'],
  [2359116202,2359319443,'Pisces'],
  [2359319443,2359511927,'Aries'],
  [2359511927,2359697104,'Taurus'],
  [2359697104,2359879362,'Gemini'],
  [2359879362,2360062120,'Cancer'],
  [2360062120,2360247346,'Leo'],
  [2360247346,2360436372,'Virgo'],
  [2360436372,2360631109,'Libra'],
  [2360631109,2360834097,'Scorpio'],
  [2360834097,2361046491,'Sagittarius'],
  [2361046491,2361264929,'Capricorn'],
  [2361264929,2361480992,'Aquarius'],
  [2361480992,2361686190,'Pisces'],
  [2361686190,2361877707,'Aries'],
  [2361877707,2362058853,'Taurus'],
  [2362058853,2362235877,'Gemini'],
  [2362235877,2362414858,'Cancer'],
  [2362414858,2362599682,'Leo'],
  [2362599682,2362791432,'Virgo'],
  [2362791432,2362989728,'Libra'],
  [2362989728,2363194662,'Scorpio'],
  [2363194662,2363406914,'Sagittarius'],
  [2363406914,2363625261,'Capricorn'],
  [2363625261,2363843764,'Aquarius'],
  [2363843764,2364053366,'Pisces'],
  [2364053366,2364248127,'Aries'],
  [2364248127,2364429009,'Taurus'],
  [2364429009,2364602083,'Gemini'],
  [2364602083,2364774991,'Cancer'],
  [2364774991,2364954326,'Leo'],
  [2364954326,2365143686,'Virgo'],
  [2365143686,2365343062,'Libra'],
  [2365343062,2365550473,'Scorpio'],
  [2365550473,2365764090,'Sagittarius'],
  [2365764090,2365982395,'Capricorn'],
  [2365982395,2366201836,'Aquarius'],
  [2366201836,2366415470,'Pisces'],
  [2366415470,2366616156,'Aries'],
  [2366616156,2366801597,'Taurus'],
  [2366801597,2366975552,'Gemini'],
  [2366975552,2367145194,'Cancer'],
  [2367145194,2367318283,'Leo'],
  [2367318283,2367501108,'Virgo'],
  [2367501108,2367696633,'Libra'],
  [2367696633,2367903766,'Scorpio'],
  [2367903766,2368118728,'Sagittarius'],
  [2368118728,2368337469,'Capricorn'],
  [2368337469,2368556405,'Aquarius'],
  [2368556405,2368771139,'Pisces'],
  [2368771139,2368976383,'Aries'],
  [2368976383,2369168482,'Taurus'],
  [2369168482,2369348049,'Gemini'],
  [2369348049,2369519828,'Cancer'],
  [2369519828,2369690703,'Leo'],
  [2369690703,2369867801,'Virgo'],
  [2369867801,2370056729,'Libra'],
  [2370056729,2370259585,'Scorpio'],
  [2370259585,2370473662,'Sagittarius'],
  [2370473662,2370692844,'Capricorn'],
  [2370692844,2370911116,'Aquarius'],
  [2370911116,2371124379,'Pisces'],
  [2371124379,2371329976,'Aries'],
  [2371329976,2371526020,'Taurus'],
  [2371526020,2371712036,'Gemini'],
  [2371712036,2371889896,'Cancer'],
  [2371889896,2372063876,'Leo'],
  [2372063876,2372239877,'Virgo'],
  [2372239877,2372424144,'Libra'],
  [2372424144,2372621356,'Scorpio'],
  [2372621356,2372831948,'Sagittarius'],
  [2372831948,2373050541,'Capricorn'],
  [2373050541,2373268768,'Aquarius'],
  [2373268768,2373480368,'Pisces'],
  [2373480368,2373683331,'Aries'],
  [2373683331,2373878384,'Taurus'],
  [2373878384,2374066877,'Gemini'],
  [2374066877,2374250117,'Cancer'],
  [2374250117,2374429906,'Leo'],
  [2374429906,2374609460,'Virgo'],
  [2374609460,2374793583,'Libra'],
  [2374793583,2374987493,'Scorpio'],
  [2374987493,2375194168,'Sagittarius'],
  [2375194168,2375411022,'Capricorn'],
  [2375411022,2375629644,'Aquarius'],
  [2375629644,2375841157,'Pisces'],
  [2375841157,2376041796,'Aries'],
  [2376041796,2376233188,'Taurus'],
  [2376233188,2376419164,'Gemini'],
  [2376419164,2376603016,'Cancer'],
  [2376603016,2376786575,'Leo'],
  [2376786575,2376971054,'Virgo'],
  [2376971054,2377158653,'Libra'],
  [2377158653,2377353057,'Scorpio'],
  [2377353057,2377557801,'Sagittarius'],
  [2377557801,2377772843,'Capricorn'],
  [2377772843,2377991896,'Aquarius'],
  [2377991896,2378205097,'Pisces'],
  [2378205097,2378405967,'Aries'],
  [2378405967,2378594804,'Taurus'],
  [2378594804,2378776394,'Gemini'],
  [2378776394,2378956339,'Cancer'],
  [2378956339,2379138666,'Leo'],
  [2379138666,2379325163,'Virgo'],
  [2379325163,2379516492,'Libra'],
  [2379516492,2379713879,'Scorpio'],
  [2379713879,2379919353,'Sagittarius'],
  [2379919353,2380133643,'Capricorn'],
  [2380133643,2380352959,'Aquarius'],
  [2380352959,2380568680,'Pisces'],
  [2380568680,2380772522,'Aries'],
  [2380772522,2380962154,'Taurus'],
  [2380962154,2381141325,'Gemini'],
  [2381141325,2381316483,'Cancer'],
  [2381316483,2381493825,'Leo'],
  [2381493825,2381677544,'Virgo'],
  [2381677544,2381869323,'Libra'],
  [2381869323,2382069208,'Scorpio'],
  [2382069208,2382276872,'Sagittarius'],
  [2382276872,2382491734,'Capricorn'],
  [2382491734,2382711151,'Aquarius'],
  [2382711151,2382928842,'Pisces'],
  [2382928842,2383136880,'Aries'],
  [2383136880,2383330600,'Taurus'],
  [2383330600,2383511268,'Gemini'],
  [2383511268,2383684379,'Cancer'],
  [2383684379,2383856826,'Leo'],
  [2383856826,2384034887,'Virgo'],
  [2384034887,2384222819,'Libra'],
  [2384222819,2384421998,'Scorpio'],
  [2384421998,2384631074,'Sagittarius'],
  [2384631074,2384847140,'Capricorn'],
  [2384847140,2385066626,'Aquarius'],
  [2385066626,2385284820,'Pisces'],
  [2385284820,2385495913,'Aries'],
  [2385495913,2385694930,'Taurus'],
  [2385694930,2385880577,'Gemini'],
  [2385880577,2386055922,'Cancer'],
  [2386055922,2386226837,'Leo'],
  [2386226837,2386400174,'Virgo'],
  [2386400174,2386582246,'Libra'],
  [2386582246,2386777132,'Scorpio'],
  [2386777132,2386984937,'Sagittarius'],
  [2386984937,2387201577,'Capricorn'],
  [2387201577,2387421188,'Aquarius'],
  [2387421188,2387638629,'Pisces'],
  [2387638629,2387850054,'Aries'],
  [2387850054,2388052418,'Taurus'],
  [2388052418,2388243818,'Gemini'],
  [2388243818,2388424749,'Cancer'],
  [2388424749,2388598590,'Leo'],
  [2388598590,2388771030,'Virgo'],
  [2388771030,2388948853,'Libra'],
  [2388948853,2389138214,'Scorpio'],
  [2389138214,2389342035,'Sagittarius'],
  [2389342035,2389557528,'Capricorn'],
  [2389557528,2389777204,'Aquarius'],
  [2389777204,2389993714,'Pisces'],
  [2389993714,2390203294,'Aries'],
  [2390203294,2390405168,'Taurus'],
  [2390405168,2390599325,'Gemini'],
  [2390599325,2390785765,'Cancer'],
  [2390785765,2390965416,'Leo'],
  [2390965416,2391141368,'Virgo'],
  [2391141368,2391319040,'Libra'],
  [2391319040,2391504942,'Scorpio'],
  [2391504942,2391704171,'Sagittarius'],
  [2391704171,2391916821,'Capricorn'],
  [2391916821,2392136168,'Aquarius'],
  [2392136168,2392352656,'Pisces'],
  [2392352656,2392560443,'Aries'],
  [2392560443,2392759245,'Taurus'],
  [2392759245,2392951483,'Gemini'],
  [2392951483,2393139243,'Cancer'],
  [2393139243,2393323407,'Leo'],
  [2393323407,2393504900,'Virgo'],
  [2393504900,2393686463,'Libra'],
  [2393686463,2393872964,'Scorpio'],
  [2393872964,2394069757,'Sagittarius'],
  [2394069757,2394279333,'Capricorn'],
  [2394279333,2394497733,'Aquarius'],
  [2394497733,2394715319,'Pisces'],
  [2394715319,2394923495,'Aries'],
  [2394923495,2395120059,'Taurus'],
  [2395120059,2395308092,'Gemini'],
  [2395308092,2395492145,'Cancer'],
  [2395492145,2395675558,'Leo'],
  [2395675558,2395859873,'Virgo'],
  [2395859873,2396046139,'Libra'],
  [2396046139,2396236521,'Scorpio'],
  [2396236521,2396434437,'Sagittarius'],
  [2396434437,2396642656,'Capricorn'],
  [2396642656,2396859879,'Aquarius'],
  [2396859879,2397078839,'Pisces'],
  [2397078839,2397289901,'Aries'],
  [2397289901,2397487744,'Taurus'],
  [2397487744,2397673651,'Gemini'],
  [2397673651,2397852759,'Cancer'],
  [2397852759,2398030783,'Leo'],
  [2398030783,2398212080,'Virgo'],
  [2398212080,2398399059,'Libra'],
  [2398399059,2398592804,'Scorpio'],
  [2398592804,2398794060,'Sagittarius'],
  [2398794060,2399003463,'Capricorn'],
  [2399003463,2399220194,'Aquarius'],
  [2399220194,2399439808,'Pisces'],
  [2399439808,2399654432,'Aries'],
  [2399654432,2399856908,'Taurus'],
  [2399856908,2400045271,'Gemini'],
  [2400045271,2400222880,'Cancer'],
  [2400222880,2400395836,'Leo'],
  [2400395836,2400570662,'Virgo'],
  [2400570662,2400752752,'Libra'],
  [2400752752,2400945207,'Scorpio'],
  [2400945207,2401148282,'Sagittarius'],
  [2401148282,2401360001,'Capricorn'],
  [2401360001,2401577440,'Aquarius'],
  [2401577440,2401796948,'Pisces'],
  [2401796948,2402013470,'Aries'],
  [2402013470,2402220973,'Taurus'],
  [2402220973,2402415259,'Gemini'],
  [2402415259,2402596464,'Cancer'],
  [2402596464,2402768874,'Leo'],
  [2402768874,2402939163,'Virgo'],
  [2402939163,2403114570,'Libra'],
  [2403114570,2403301150,'Scorpio'],
  [2403301150,2403501614,'Sagittarius'],
  [2403501614,2403713849,'Capricorn'],
  [2403713849,2403932383,'Aquarius'],
  [2403932383,2404151724,'Pisces'],
  [2404151724,2404367933,'Aries'],
  [2404367933,2404577642,'Taurus'],
  [2404577642,2404777369,'Gemini'],
  [2404777369,2404965053,'Cancer'],
  [2404965053,2405141888,'Leo'],
  [2405141888,2405312683,'Virgo'],
  [2405312683,2405484551,'Libra'],
  [2405484551,2405665034,'Scorpio'],
  [2405665034,2405859703,'Sagittarius'],
  [2405859703,2406069047,'Capricorn'],
  [2406069047,2406287406,'Aquarius'],
  [2406287406,2406506788,'Pisces'],
  [2406506788,2406721803,'Aries'],
  [2406721803,2406930470,'Taurus'],
  [2406930470,2407131773,'Gemini'],
  [2407131773,2407324320,'Cancer'],
  [2407324320,2407507426,'Leo'],
  [2407507426,2407683044,'Virgo'],
  [2407683044,2407856344,'Libra'],
  [2407856344,2408034428,'Scorpio'],
  [2408034428,2408224111,'Sagittarius'],
  [2408224111,2408428709,'Capricorn'],
  [2408428709,2408644946,'Aquarius'],
  [2408644946,2408864186,'Pisces'],
  [2408864186,2409078552,'Aries'],
  [2409078552,2409285055,'Taurus'],
  [2409285055,2409484244,'Gemini'],
  [2409484244,2409677100,'Cancer'],
  [2409677100,2409863813,'Leo'],
  [2409863813,2410044910,'Virgo'],
  [2410044910,2410222997,'Libra'],
  [2410222997,2410403118,'Scorpio'],
  [2410403118,2410591400,'Sagittarius'],
  [2410591400,2410792400,'Capricorn'],
  [2410792400,2411005664,'Aquarius'],
  [2411005664,2411224319,'Pisces'],
  [2411224319,2411439123,'Aries'],
  [2411439123,2411644658,'Taurus'],
  [2411644658,2411840881,'Gemini'],
  [2411840881,2412030436,'Cancer'],
  [2412030436,2412215917,'Leo'],
  [2412215917,2412399033,'Virgo'],
  [2412399033,2412581457,'Libra'],
  [2412581457,2412765944,'Scorpio'],
  [2412765944,2412956446,'Sagittarius'],
  [2412956446,2413156774,'Capricorn'],
  [2413156774,2413367961,'Aquarius'],
  [2413367961,2413585822,'Pisces'],
  [2413585822,2413801922,'Aries'],
  [2413801922,2414008746,'Taurus'],
  [2414008746,2414203983,'Gemini'],
  [2414203983,2414389995,'Cancer'],
  [2414389995,2414571087,'Leo'],
  [2414571087,2414751431,'Virgo'],
  [2414751431,2414934217,'Libra'],
  [2414934217,2415121749,'Scorpio'],
  [2415121749,2415315881,'Sagittarius'],
  [2415315881,2415518183,'Capricorn'],
  [2415518183,2415729162,'Aquarius'],
  [2415729162,2415946476,'Pisces'],
  [2415946476,2416164010,'Aries'],
  [2416164010,2416373973,'Taurus'],
  [2416373973,2416571432,'Gemini'],
  [2416571432,2416756680,'Cancer'],
  [2416756680,2416933934,'Leo'],
  [2416933934,2417109054,'Virgo'],
  [2417109054,2417287719,'Libra'],
  [2417287719,2417474092,'Scorpio'],
  [2417474092,2417669981,'Sagittarius'],
  [2417669981,2417874937,'Capricorn'],
  [2417874937,2418087288,'Aquarius'],
  [2418087288,2418304611,'Pisces'],
  [2418304611,2418522942,'Aries'],
  [2418522942,2418736247,'Taurus'],
  [2418736247,2418938393,'Gemini'],
  [2418938393,2419126791,'Cancer'],
  [2419126791,2419303737,'Leo'],
  [2419303737,2419475073,'Virgo'],
  [2419475073,2419648034,'Libra'],
  [2419648034,2419829279,'Scorpio'],
  [2419829279,2420022817,'Sagittarius'],
  [2420022817,2420228402,'Capricorn'],
  [2420228402,2420442316,'Aquarius'],
  [2420442316,2420660166,'Pisces'],
  [2420660166,2420878409,'Aries'],
  [2420878409,2421093349,'Taurus'],
  [2421093349,2421300076,'Gemini'],
  [2421300076,2421494270,'Cancer'],
  [2421494270,2421675257,'Leo'],
  [2421675257,2421847017,'Virgo'],
  [2421847017,2422016646,'Libra'],
  [2422016646,2422192129,'Scorpio'],
  [2422192129,2422380032,'Sagittarius'],
  [2422380032,2422582614,'Capricorn'],
  [2422582614,2422796395,'Aquarius'],
  [2422796395,2423014809,'Pisces'],
  [2423014809,2423232566,'Aries'],
  [2423232566,2423446850,'Taurus'],
  [2423446850,2423655207,'Gemini'],
  [2423655207,2423854301,'Cancer'],
  [2423854301,2424041643,'Leo'],
  [2424041643,2424218264,'Virgo'],
  [2424218264,2424389291,'Libra'],
  [2424389291,2424562245,'Scorpio'],
  [2424562245,2424744796,'Sagittarius'],
  [2424744796,2424941928,'Capricorn'],
  [2424941928,2425152843,'Aquarius'],
  [2425152843,2425370967,'Pisces'],
  [2425370967,2425588560,'Aries'],
  [2425588560,2425801258,'Taurus'],
  [2425801258,2426007842,'Gemini'],
  [2426007842,2426207578,'Cancer'],
  [2426207578,2426399122,'Leo'],
  [2426399122,2426581977,'Virgo'],
  [2426581977,2426758444,'Libra'],
  [2426758444,2426933792,'Scorpio'],
  [2426933792,2427114799,'Sagittarius'],
  [2427114799,2427307473,'Capricorn'],
  [2427307473,2427513976,'Aquarius'],
  [2427513976,2427730338,'Pisces'],
  [2427730338,2427948208,'Aries'],
  [2427948208,2428160422,'Taurus'],
  [2428160422,2428364406,'Gemini'],
  [2428364406,2428560881,'Cancer'],
  [2428560881,2428751287,'Leo'],
  [2428751287,2428936704,'Virgo'],
  [2428936704,2429118494,'Libra'],
  [2429118494,2429299332,'Scorpio'],
  [2429299332,2429483404,'Sagittarius'],
  [2429483404,2429675471,'Capricorn'],
  [2429675471,2429878827,'Aquarius'],
  [2429878827,2430092632,'Pisces'],
  [2430092632,2430310673,'Aries'],
  [2430310673,2430524325,'Taurus'],
  [2430524325,2430727980,'Gemini'],
  [2430727980,2430921186,'Cancer'],
  [2430921186,2431106914,'Leo'],
  [2431106914,2431289111,'Virgo'],
  [2431289111,2431471208,'Libra'],
  [2431471208,2431655723,'Scorpio'],
  [2431655723,2431844612,'Sagittarius'],
  [2431844612,2432039820,'Capricorn'],
  [2432039820,2432243253,'Aquarius'],
  [2432243253,2432455412,'Pisces'],
  [2432455412,2432673179,'Aries'],
  [2432673179,2432889256,'Taurus'],
  [2432889256,2433095776,'Gemini'],
  [2433095776,2433289222,'Cancer'],
  [2433289222,2433471574,'Leo'],
  [2433471574,2433648209,'Virgo'],
  [2433648209,2433825289,'Libra'],
  [2433825289,2434007804,'Scorpio'],
  [2434007804,2434198350,'Sagittarius'],
  [2434198350,2434397092,'Capricorn'],
  [2434397092,2434603125,'Aquarius'],
  [2434603125,2434815642,'Pisces'],
  [2434815642,2435033079,'Aries'],
  [2435033079,2435250961,'Taurus'],
  [2435250961,2435461840,'Gemini'],
  [2435461840,2435659457,'Cancer'],
  [2435659457,2435842883,'Leo'],
  [2435842883,2436016637,'Virgo'],
  [2436016637,2436188015,'Libra'],
  [2436188015,2436364417,'Scorpio'],
  [2436364417,2436551179,'Sagittarius'],
  [2436551179,2436749744,'Capricorn'],
  [2436749744,2436957829,'Aquarius'],
  [2436957829,2437171991,'Pisces'],
  [2437171991,2437389607,'Aries'],
  [2437389607,2437607936,'Taurus'],
  [2437607936,2437821934,'Gemini'],
  [2437821934,2438025083,'Cancer'],
  [2438025083,2438213609,'Leo'],
  [2438213609,2438389370,'Virgo'],
  [2438389370,2438558778,'Libra'],
  [2438558778,2438729946,'Scorpio'],
  [2438729946,2438910306,'Sagittarius'],
  [2438910306,2439104192,'Capricorn'],
  [2439104192,2439310945,'Aquarius'],
  [2439310945,2439525941,'Pisces'],
  [2439525941,2439744113,'Aries'],
  [2439744113,2439962027,'Taurus'],
  [2439962027,2440176524,'Gemini'],
  [2440176524,2440383122,'Cancer'],
  [2440383122,2440577507,'Leo'],
  [2440577507,2440758857,'Virgo'],
  [2440758857,2440931118,'Libra'],
  [2440931118,2441101321,'Scorpio'],
  [2441101321,2441277228,'Sagittarius'],
  [2441277228,2441465124,'Capricorn'],
  [2441465124,2441667307,'Aquarius'],
  [2441667307,2441880746,'Pisces'],
  [2441880746,2442099042,'Aries'],
  [2442099042,2442316483,'Taurus'],
  [2442316483,2442529656,'Gemini'],
  [2442529656,2442736122,'Cancer'],
  [2442736122,2442933440,'Leo'],
  [2442933440,2443120280,'Virgo'],
  [2443120280,2443298201,'Libra'],
  [2443298201,2443471838,'Scorpio'],
  [2443471838,2443647604,'Sagittarius'],
  [2443647604,2443831931,'Capricorn'],
  [2443831931,2444029118,'Aquarius'],
  [2444029118,2444239038,'Pisces'],
  [2444239038,2444456419,'Aries'],
  [2444456419,2444673752,'Taurus'],
  [2444673752,2444885560,'Gemini'],
  [2444885560,2445089616,'Cancer'],
  [2445089616,2445285707,'Leo'],
  [2445285707,2445474372,'Virgo'],
  [2445474372,2445656907,'Libra'],
  [2445656907,2445835886,'Scorpio'],
  [2445835886,2446015300,'Sagittarius'],
  [2446015300,2446200030,'Capricorn'],
  [2446200030,2446394576,'Aquarius'],
  [2446394576,2446600988,'Pisces'],
  [2446600988,2446816642,'Aries'],
  [2446816642,2447034265,'Taurus'],
  [2447034265,2447246063,'Gemini'],
  [2447246063,2447448052,'Cancer'],
  [2447448052,2447640669,'Leo'],
  [2447640669,2447826787,'Virgo'],
  [2447826787,2448009667,'Libra'],
  [2448009667,2448192020,'Scorpio'],
  [2448192020,2448376098,'Sagittarius'],
  [2448376098,2448564310,'Capricorn'],
  [2448564310,2448759548,'Aquarius'],
  [2448759548,2448964297,'Pisces'],
  [2448964297,2449178303,'Aries'],
  [2449178303,2449396393,'Taurus'],
  [2449396393,2449609925,'Gemini'],
  [2449609925,2449812246,'Cancer'],
  [2449812246,2450002399,'Leo'],
  [2450002399,2450184173,'Virgo'],
  [2450184173,2450363138,'Libra'],
  [2450363138,2450544174,'Scorpio'],
  [2450544174,2450730154,'Sagittarius'],
  [2450730154,2450922045,'Capricorn'],
  [2450922045,2451120270,'Aquarius'],
  [2451120270,2451325776,'Pisces'],
  [2451325776,2451539080,'Aries'],
  [2451539080,2451757506,'Taurus'],
  [2451757506,2451973720,'Gemini'],
  [2451973720,2452179247,'Cancer'],
  [2452179247,2452370338,'Leo'],
  [2452370338,2452549671,'Virgo'],
  [2452549671,2452723733,'Libra'],
  [2452723733,2452899604,'Scorpio'],
  [2452899604,2453082620,'Sagittarius'],
  [2453082620,2453274875,'Capricorn'],
  [2453274875,2453475616,'Aquarius'],
  [2453475616,2453683353,'Pisces'],
  [2453683353,2453897215,'Aries'],
  [2453897215,2454115694,'Taurus'],
  [2454115694,2454333953,'Gemini'],
  [2454333953,2454544029,'Cancer'],
  [2454544029,2454739708,'Leo'],
  [2454739708,2454920888,'Virgo'],
  [2454920888,2455093007,'Libra'],
  [2455093007,2455263822,'Scorpio'],
  [2455263822,2455440741,'Sagittarius'],
  [2455440741,2455628652,'Capricorn'],
  [2455628652,2455828401,'Aquarius'],
  [2455828401,2456037527,'Pisces'],
  [2456037527,2456252681,'Aries'],
  [2456252681,2456471165,'Taurus'],
  [2456471165,2456689717,'Gemini'],
  [2456689717,2456902812,'Cancer'],
  [2456902812,2457104234,'Leo'],
  [2457104234,2457291169,'Virgo'],
  [2457291169,2457466275,'Libra'],
  [2457466275,2457636052,'Scorpio'],
  [2457636052,2457808225,'Sagittarius'],
  [2457808225,2457989666,'Capricorn'],
  [2457989666,2458184309,'Aquarius'],
  [2458184309,2458391640,'Pisces'],
  [2458391640,2458607344,'Aries'],
  [2458607344,2458826095,'Taurus'],
  [2458826095,2459043698,'Gemini'],
  [2459043698,2459256559,'Cancer'],
  [2459256559,2459460914,'Leo'],
  [2459460914,2459653864,'Virgo'],
  [2459653864,2459835455,'Libra'],
  [2459835455,2460009329,'Scorpio'],
  [2460009329,2460181561,'Sagittarius'],
  [2460181561,2460359009,'Capricorn'],
  [2460359009,2460547574,'Aquarius'],
  [2460547574,2460750009,'Pisces'],
  [2460750009,2460964021,'Aries'],
  [2460964021,2461182974,'Taurus'],
  [2461182974,2461399904,'Gemini'],
  [2461399904,2461610590,'Cancer'],
  [2461610590,2461813473,'Leo'],
  [2461813473,2462008192,'Virgo'],
  [2462008192,2462195022,'Libra'],
  [2462195022,2462375388,'Scorpio'],
  [2462375388,2462552422,'Sagittarius'],
  [2462552422,2462730939,'Capricorn'],
  [2462730939,2462916604,'Aquarius'],
  [2462916604,2463114154,'Pisces'],
  [2463114154,2463324584,'Aries'],
  [2463324584,2463542910,'Taurus'],
  [2463542910,2463760262,'Gemini'],
  [2463760262,2463969653,'Cancer'],
  [2463969653,2464169218,'Leo'],
  [2464169218,2464360889,'Virgo'],
  [2464360889,2464547564,'Libra'],
  [2464547564,2464731469,'Scorpio'],
  [2464731469,2464914130,'Sagittarius'],
  [2464914130,2465097490,'Capricorn'],
  [2465097490,2465284923,'Aquarius'],
  [2465284923,2465480787,'Pisces'],
  [2465480787,2465688092,'Aries'],
  [2465688092,2465904970,'Taurus'],
  [2465904970,2466123402,'Gemini'],
  [2466123402,2466333910,'Cancer'],
  [2466333910,2466532053,'Leo'],
  [2466532053,2466719703,'Virgo'],
  [2466719703,2466901891,'Libra'],
  [2466901891,2467083508,'Scorpio'],
  [2467083508,2467267511,'Sagittarius'],
  [2467267511,2467454953,'Capricorn'],
  [2467454953,2467646613,'Aquarius'],
  [2467646613,2467844475,'Pisces'],
  [2467844475,2468051122,'Aries'],
  [2468051122,2468266779,'Taurus'],
  [2468266779,2468486122,'Gemini'],
  [2468486122,2468699549,'Cancer'],
  [2468699549,2468899760,'Leo'],
  [2468899760,2469086363,'Virgo'],
  [2469086363,2469264387,'Libra'],
  [2469264387,2469440546,'Scorpio'],
  [2469440546,2469620451,'Sagittarius'],
  [2469620451,2469807119,'Capricorn'],
  [2469807119,2470001101,'Aquarius'],
  [2470001101,2470202141,'Pisces'],
  [2470202141,2470410490,'Aries'],
  [2470410490,2470626094,'Taurus'],
  [2470626094,2470845822,'Gemini'],
  [2470845822,2471062153,'Cancer'],
  [2471062153,2471266808,'Leo'],
  [2471266808,2471456454,'Virgo'],
  [2471456454,2471634130,'Libra'],
  [2471634130,2471806427,'Scorpio'],
  [2471806427,2471980458,'Sagittarius'],
  [2471980458,2472161854,'Capricorn'],
  [2472161854,2472353489,'Aquarius'],
  [2472353489,2472555354,'Pisces'],
  [2472555354,2472765693,'Aries'],
  [2472765693,2472982274,'Taurus'],
  [2472982274,2473202051,'Gemini'],
  [2473202051,2473419768,'Cancer'],
  [2473419768,2473628602,'Leo'],
  [2473628602,2473823693,'Virgo'],
  [2473823693,2474005244,'Libra'],
  [2474005244,2474177970,'Scorpio'],
  [2474177970,2474348681,'Sagittarius'],
  [2474348681,2474524277,'Capricorn'],
  [2474524277,2474710202,'Aquarius'],
  [2474710202,2474908946,'Pisces'],
  [2474908946,2475119173,'Aries'],
  [2475119173,2475336641,'Taurus'],
  [2475336641,2475556415,'Gemini'],
  [2475556415,2475773807,'Cancer'],
  [2475773807,2475984306,'Leo'],
  [2475984306,2476184037,'Virgo'],
  [2476184037,2476371492,'Libra'],
  [2476371492,2476548679,'Scorpio'],
  [2476548679,2476720505,'Sagittarius'],
  [2476720505,2476893421,'Capricorn'],
  [2476893421,2477074026,'Aquarius'],
  [2477074026,2477267350,'Pisces'],
  [2477267350,2477474565,'Aries'],
  [2477474565,2477691611,'Taurus'],
  [2477691611,2477911375,'Gemini'],
  [2477911375,2478127683,'Cancer'],
  [2478127683,2478337087,'Leo'],
  [2478337087,2478538052,'Virgo'],
  [2478538052,2478729856,'Libra'],
  [2478729856,2478912901,'Scorpio'],
  [2478912901,2479089481,'Sagittarius'],
  [2479089481,2479264060,'Capricorn'],
  [2479264060,2479442681,'Aquarius'],
  [2479442681,2479631508,'Pisces'],
  [2479631508,2479834288,'Aries'],
  [2479834288,2480049256,'Taurus'],
  [2480049256,2480268838,'Gemini'],
  [2480268838,2480484498,'Cancer'],
  [2480484498,2480691762,'Leo'],
  [2480691762,2480890571,'Virgo'],
  [2480890571,2481082552,'Libra'],
  [2481082552,2481269011,'Scorpio'],
  [2481269011,2481450929,'Sagittarius'],
  [2481450929,2481630257,'Capricorn'],
  [2481630257,2481810949,'Aquarius'],
  [2481810949,2481998513,'Pisces'],
  [2481998513,2482197913,'Aries'],
  [2482197913,2482410064,'Taurus'],
  [2482410064,2482629146,'Gemini'],
  [2482629146,2482845303,'Cancer'],
  [2482845303,2483051601,'Leo'],
  [2483051601,2483247380,'Virgo'],
  [2483247380,2483435955,'Libra'],
  [2483435955,2483621059,'Scorpio'],
  [2483621059,2483804936,'Sagittarius'],
  [2483804936,2483988647,'Capricorn'],
  [2483988647,2484173784,'Aquarius'],
  [2484173784,2484363636,'Pisces'],
  [2484363636,2484562431,'Aries'],
  [2484562431,2484772550,'Taurus'],
  [2484772550,2484990901,'Gemini'],
  [2484990901,2485208536,'Cancer'],
  [2485208536,2485416360,'Leo'],
  [2485416360,2485611264,'Virgo'],
  [2485611264,2485796214,'Libra'],
  [2485796214,2485976641,'Scorpio'],
  [2485976641,2486157370,'Sagittarius'],
  [2486157370,2486341226,'Capricorn'],
  [2486341226,2486529432,'Aquarius'],
  [2486529432,2486723103,'Pisces'],
  [2486723103,2486924092,'Aries'],
  [2486924092,2487134073,'Taurus'],
  [2487134073,2487351805,'Gemini'],
  [2487351805,2487570931,'Cancer'],
  [2487570931,2487782306,'Leo'],
  [2487782306,2487980023,'Virgo'],
  [2487980023,2488164648,'Libra'],
  [2488164648,2488341270,'Scorpio'],
  [2488341270,2488516292,'Sagittarius'],
  [2488516292,2488695262,'Capricorn'],
  [2488695262,2488881700,'Aquarius'],
  [2488881700,2489076935,'Pisces'],
  [2489076935,2489280806,'Aries'],
  [2489280806,2489492464,'Taurus'],
  [2489492464,2489710179,'Gemini'],
  [2489710179,2489929829,'Cancer'],
  [2489929829,2490144564,'Leo'],
  [2490144564,2490347620,'Virgo'],
  [2490347620,2490536431,'Libra'],
  [2490536431,2490713659,'Scorpio'],
  [2490713659,2490885208,'Sagittarius'],
  [2490885208,2491057993,'Capricorn'],
  [2491057993,2491238282,'Aquarius'],
  [2491238282,2491430154,'Pisces'],
  [2491430154,2491634198,'Aries'],
  [2491634198,2491847611,'Taurus'],
  [2491847611,2492066086,'Gemini'],
  [2492066086,2492285364,'Cancer'],
  [2492285364,2492501101,'Leo'],
  [2492501101,2492708508,'Virgo'],
  [2492708508,2492903772,'Libra'],
  [2492903772,2493086355,'Scorpio'],
  [2493086355,2493259626,'Sagittarius'],
  [2493259626,2493429780,'Capricorn'],
  [2493429780,2493604158,'Aquarius'],
  [2493604158,2493789472,'Pisces'],
  [2493789472,2493989363,'Aries'],
  [2493989363,2494202075,'Taurus'],
  [2494202075,2494421262,'Gemini'],
  [2494421262,2494640185,'Cancer'],
  [2494640185,2494854720,'Leo'],
  [2494854720,2495062702,'Virgo'],
  [2495062702,2495262121,'Libra'],
  [2495262121,2495451314,'Scorpio'],
  [2495451314,2495630602,'Sagittarius'],
  [2495630602,2495803543,'Capricorn'],
  [2495803543,2495976471,'Aquarius'],
  [2495976471,2496156826,'Pisces'],
  [2496156826,2496350744,'Aries'],
  [2496350744,2496559638,'Taurus'],
  [2496559638,2496778084,'Gemini'],
  [2496778084,2496997082,'Cancer'],
  [2496997082,2497210241,'Leo'],
  [2497210241,2497415910,'Virgo'],
  [2497415910,2497614671,'Libra'],
  [2497614671,2497806740,'Scorpio'],
  [2497806740,2497991799,'Sagittarius'],
  [2497991799,2498170733,'Capricorn'],
  [2498170733,2498347203,'Aquarius'],
  [2498347203,2498527295,'Pisces'],
  [2498527295,2498717583,'Aries'],
  [2498717583,2498921951,'Taurus'],
  [2498921951,2499137997,'Gemini'],
  [2499137997,2499357061,'Cancer'],
  [2499357061,2499570205,'Leo'],
  [2499570205,2499773804,'Virgo'],
  [2499773804,2499969139,'Libra'],
  [2499969139,2500158926,'Scorpio'],
  [2500158926,2500344956,'Sagittarius'],
  [2500344956,2500528092,'Capricorn'],
  [2500528092,2500709865,'Aquarius'],
  [2500709865,2500893726,'Pisces'],
  [2500893726,2501084600,'Aries'],
  [2501084600,2501286716,'Taurus'],
  [2501286716,2501500220,'Gemini'],
  [2501500220,2501718989,'Cancer'],
  [2501718989,2501933531,'Leo'],
  [2501933531,2502137468,'Virgo'],
  [2502137468,2502330439,'Libra'],
  [2502330439,2502515925,'Scorpio'],
  [2502515925,2502698123,'Sagittarius'],
  [2502698123,2502880229,'Capricorn'],
  [2502880229,2503064347,'Aquarius'],
  [2503064347,2503252365,'Pisces'],
  [2503252365,2503446658,'Aries'],
  [2503446658,2503649695,'Taurus'],
  [2503649695,2503862152,'Gemini'],
  [2503862152,2504080495,'Cancer'],
  [2504080495,2504296972,'Leo'],
  [2504296972,2504503732,'Virgo'],
  [2504503732,2504697631,'Libra'],
  [2504697631,2504880791,'Scorpio'],
  [2504880791,2505058179,'Sagittarius'],
  [2505058179,2505235277,'Capricorn'],
  [2505235277,2505416658,'Aquarius'],
  [2505416658,2505605285,'Pisces'],
  [2505605285,2505802423,'Aries'],
  [2505802423,2506008074,'Taurus'],
  [2506008074,2506221310,'Gemini'],
  [2506221310,2506439516,'Cancer'],
  [2506439516,2506657433,'Leo'],
  [2506657433,2506868008,'Virgo'],
  [2506868008,2507065947,'Libra'],
  [2507065947,2507250685,'Scorpio'],
  [2507250685,2507426039,'Sagittarius'],
  [2507426039,2507598217,'Capricorn'],
  [2507598217,2507773895,'Aquarius'],
  [2507773895,2507958578,'Pisces'],
  [2507958578,2508154989,'Aries'],
  [2508154989,2508362247,'Taurus'],
  [2508362247,2508577039,'Gemini'],
  [2508577039,2508795546,'Cancer'],
  [2508795546,2509013858,'Leo'],
  [2509013858,2509227172,'Virgo'],
  [2509227172,2509430185,'Libra'],
  [2509430185,2509619852,'Scorpio'],
  [2509619852,2509797425,'Sagittarius'],
  [2509797425,2509968081,'Capricorn'],
  [2509968081,2510139091,'Aquarius'],
  [2510139091,2510317861,'Pisces'],
  [2510317861,2510509734,'Aries'],
  [2510509734,2510715490,'Taurus'],
  [2510715490,2510930902,'Gemini'],
  [2510930902,2511149872,'Cancer'],
  [2511149872,2511367765,'Leo'],
  [2511367765,2511581497,'Virgo'],
  [2511581497,2511787751,'Libra'],
  [2511787751,2511983053,'Scorpio'],
  [2511983053,2512166111,'Sagittarius'],
  [2512166111,2512339634,'Capricorn'],
  [2512339634,2512509820,'Aquarius'],
  [2512509820,2512684448,'Pisces'],
  [2512684448,2512870659,'Aries'],
  [2512870659,2513071985,'Taurus'],
  [2513071985,2513285803,'Gemini'],
  [2513285803,2513504808,'Cancer'],
  [2513504808,2513722159,'Leo'],
  [2513722159,2513934519,'Virgo'],
  [2513934519,2514140578,'Libra'],
  [2514140578,2514338755,'Scorpio'],
  [2514338755,2514527327,'Sagittarius'],
  [2514527327,2514706581,'Capricorn'],
  [2514706581,2514880263,'Aquarius'],
  [2514880263,2515054849,'Pisces'],
  [2515054849,2515237630,'Aries'],
  [2515237630,2515434032,'Taurus'],
  [2515434032,2515644313,'Gemini'],
  [2515644313,2515862384,'Cancer'],
  [2515862384,2516079647,'Leo'],
  [2516079647,2516290615,'Virgo'],
  [2516290615,2516494140,'Libra'],
  [2516494140,2516690884,'Scorpio'],
  [2516690884,2516881169,'Sagittarius'],
  [2516881169,2517065156,'Capricorn'],
  [2517065156,2517244452,'Aquarius'],
  [2517244452,2517423003,'Pisces'],
  [2517423003,2517606448,'Aries'],
  [2517606448,2517800263,'Taurus'],
  [2517800263,2518006894,'Gemini'],
  [2518006894,2518223118,'Cancer'],
  [2518223118,2518440789,'Leo'],
  [2518440789,2518652000,'Virgo'],
  [2518652000,2518853544,'Libra'],
  [2518853544,2519046539,'Scorpio'],
  [2519046539,2519233733,'Sagittarius'],
  [2519233733,2519417631,'Capricorn'],
  [2519417631,2519600252,'Aquarius'],
  [2519600252,2519783816,'Pisces'],
  [2519783816,2519971316,'Aries'],
  [2519971316,2520166253,'Taurus'],
  [2520166253,2520371228,'Gemini'],
  [2520371228,2520585548,'Cancer'],
  [2520585548,2520803645,'Leo'],
  [2520803645,2521017048,'Virgo'],
  [2521017048,2521219582,'Libra'],
  [2521219582,2521410421,'Scorpio'],
  [2521410421,2521592904,'Sagittarius'],
  [2521592904,2521772002,'Capricorn'],
  [2521772002,2521952386,'Aquarius'],
  [2521952386,2522137376,'Pisces'],
  [2522137376,2522328748,'Aries'],
  [2522328748,2522527290,'Taurus'],
  [2522527290,2522733471,'Gemini'],
  [2522733471,2522947012,'Cancer'],
  [2522947012,2523165107,'Leo'],
  [2523165107,2523381292,'Virgo'],
  [2523381292,2523587871,'Libra'],
  [2523587871,2523780748,'Scorpio'],
  [2523780748,2523961434,'Sagittarius'],
  [2523961434,2524135456,'Capricorn'],
  [2524135456,2524309752,'Aquarius'],
  [2524309752,2524490483,'Pisces'],
  [2524490483,2524681240,'Aries'],
  [2524681240,2524882136,'Taurus'],
  [2524882136,2525090972,'Gemini'],
  [2525090972,2525305382,'Cancer'],
  [2525305382,2525523259,'Leo'],
  [2525523259,2525740948,'Virgo'],
  [2525740948,2525952110,'Libra'],
  [2525952110,2526150537,'Scorpio'],
  [2526150537,2526334417,'Sagittarius'],
  [2526334417,2526507537,'Capricorn'],
  [2526507537,2526677148,'Aquarius'],
  [2526677148,2526851272,'Pisces'],
  [2526851272,2527036401,'Aries'],
  [2527036401,2527235038,'Taurus'],
  [2527235038,2527444758,'Gemini'],
  [2527444758,2527660647,'Cancer'],
  [2527660647,2527878670,'Leo'],
  [2527878670,2528096129,'Virgo'],
  [2528096129,2528309392,'Libra'],
  [2528309392,2528513174,'Scorpio'],
  [2528513174,2528703444,'Sagittarius'],
  [2528703444,2528880810,'Capricorn'],
  [2528880810,2529050738,'Aquarius'],
  [2529050738,2529221147,'Pisces'],
  [2529221147,2529399964,'Aries'],
  [2529399964,2529592609,'Taurus'],
  [2529592609,2529799346,'Gemini'],
  [2529799346,2530015202,'Cancer'],
  [2530015202,2530233637,'Leo'],
  [2530233637,2530450268,'Virgo'],
  [2530450268,2530662647,'Libra'],
  [2530662647,2530868072,'Scorpio'],
  [2530868072,2531063366,'Sagittarius'],
  [2531063366,2531247186,'Capricorn'],
  [2531247186,2531422068,'Aquarius'],
  [2531422068,2531593951,'Pisces'],
  [2531593951,2531770212,'Aries'],
  [2531770212,2531957468,'Taurus'],
  [2531957468,2532158924,'Gemini'],
  [2532158924,2532372237,'Cancer'],
  [2532372237,2532590516,'Leo'],
  [2532590516,2532806808,'Virgo'],
  [2532806808,2533017321,'Libra'],
  [2533017321,2533220752,'Scorpio'],
  [2533220752,2533416473,'Sagittarius'],
  [2533416473,2533604151,'Capricorn'],
  [2533604151,2533784847,'Aquarius'],
  [2533784847,2533961851,'Pisces'],
  [2533961851,2534140333,'Aries'],
  [2534140333,2534326065,'Taurus'],
  [2534326065,2534523459,'Gemini'],
  [2534523459,2534733105,'Cancer'],
  [2534733105,2534950259,'Leo'],
  [2534950259,2535166915,'Virgo'],
  [2535166915,2535376683,'Libra'],
  [2535376683,2535577331,'Scorpio'],
  [2535577331,2535769835,'Sagittarius'],
  [2535769835,2535956399,'Capricorn'],
  [2535956399,2536139334,'Aquarius'],
  [2536139334,2536321008,'Pisces'],
  [2536321008,2536504217,'Aries'],
  [2536504217,2536692387,'Taurus'],
  [2536692387,2536889046,'Gemini'],
  [2536889046,2537096171,'Cancer'],
  [2537096171,2537311824,'Leo'],
  [2537311824,2537529263,'Virgo'],
  [2537529263,2537740237,'Libra'],
  [2537740237,2537940030,'Scorpio'],
  [2537940030,2538129119,'Sagittarius'],
  [2538129119,2538311409,'Capricorn'],
  [2538311409,2538491681,'Aquarius'],
  [2538491681,2538673858,'Pisces'],
  [2538673858,2538860339,'Aries'],
  [2538860339,2539052420,'Taurus'],
  [2539052420,2539251291,'Gemini'],
  [2539251291,2539458222,'Cancer'],
  [2539458222,2539672930,'Leo'],
  [2539672930,2539891155,'Virgo'],
  [2539891155,2540104819,'Libra'],
  [2540104819,2540306731,'Scorpio'],
  [2540306731,2540495137,'Sagittarius'],
  [2540495137,2540673759,'Capricorn'],
  [2540673759,2540848990,'Aquarius'],
  [2540848990,2541027141,'Pisces'],
  [2541027141,2541212508,'Aries'],
  [2541212508,2541406436,'Taurus'],
  [2541406436,2541608175,'Gemini'],
  [2541608175,2541816780,'Cancer'],
  [2541816780,2542031588,'Leo'],
  [2542031588,2542250266,'Virgo'],
  [2542250266,2542466712,'Libra'],
  [2542466712,2542672917,'Scorpio'],
  [2542672917,2542864339,'Sagittarius'],
  [2542864339,2543042743,'Capricorn'],
  [2543042743,2543214427,'Aquarius'],
  [2543214427,2543387086,'Pisces'],
  [2543387086,2543567383,'Aries'],
  [2543567383,2543758894,'Taurus'],
  [2543758894,2543961231,'Gemini'],
  [2543961231,2544171623,'Cancer'],
  [2544171623,2544387345,'Leo'],
  [2544387345,2544606107,'Virgo'],
  [2544606107,2544823953,'Libra'],
  [2544823953,2545034321,'Scorpio'],
  [2545034321,2545231210,'Sagittarius'],
  [2545231210,2545413523,'Capricorn'],
  [2545413523,2545585721,'Aquarius'],
  [2545585721,2545755251,'Pisces'],
  [2545755251,2545929926,'Aries'],
  [2545929926,2546115767,'Taurus'],
  [2546115767,2546314899,'Gemini'],
  [2546314899,2546525047,'Cancer'],
  [2546525047,2546741586,'Leo'],
  [2546741586,2546960313,'Virgo'],
  [2546960313,2547177785,'Libra'],
  [2547177785,2547389766,'Scorpio'],
  [2547389766,2547591391,'Sagittarius'],
  [2547591391,2547779868,'Capricorn'],
  [2547779868,2547956828,'Aquarius'],
  [2547956828,2548127767,'Pisces'],
  [2548127767,2548299940,'Aries'],
  [2548299940,2548480387,'Taurus'],
  [2548480387,2548673854,'Gemini'],
  [2548673854,2548880757,'Cancer'],
  [2548880757,2549096811,'Leo'],
  [2549096811,2549315588,'Virgo'],
  [2549315588,2549531917,'Libra'],
  [2549531917,2549742539,'Scorpio'],
  [2549742539,2549945123,'Sagittarius'],
  [2549945123,2550138001,'Capricorn'],
  [2550138001,2550321253,'Aquarius'],
  [2550321253,2550497603,'Pisces'],
  [2550497603,2550672051,'Aries'],
  [2550672051,2550850760,'Taurus'],
  [2550850760,2551039505,'Gemini'],
  [2551039505,2551241531,'Cancer'],
  [2551241531,2551455226,'Leo'],
  [2551455226,2551673938,'Virgo'],
  [2551673938,2551889841,'Libra'],
  [2551889841,2552098194,'Scorpio'],
  [2552098194,2552298036,'Sagittarius'],
  [2552298036,2552490420,'Capricorn'],
  [2552490420,2552676816,'Aquarius'],
  [2552676816,2552858864,'Pisces'],
  [2552858864,2553038900,'Aries'],
  [2553038900,2553220510,'Taurus'],
  [2553220510,2553408358,'Gemini'],
  [2553408358,2553606808,'Cancer'],
  [2553606808,2553817239,'Leo'],
  [2553817239,2554035333,'Virgo'],
  [2554035333,2554252171,'Libra'],
  [2554252171,2554460043,'Scorpio'],
  [2554460043,2554656781,'Sagittarius'],
  [2554656781,2554844993,'Capricorn'],
  [2554844993,2555028932,'Aquarius'],
  [2555028932,2555212102,'Pisces'],
  [2555212102,2555396452,'Aries'],
  [2555396452,2555583160,'Taurus'],
  [2555583160,2555774133,'Gemini'],
  [2555774133,2555972464,'Cancer'],
  [2555972464,2556180764,'Leo'],
  [2556180764,2556397761,'Virgo'],
  [2556397761,2556616193,'Libra'],
  [2556616193,2556826380,'Scorpio'],
  [2556826380,2557023094,'Sagittarius'],
  [2557023094,2557207957,'Capricorn'],
  [2557207957,2557386663,'Aquarius'],
  [2557386663,2557565404,'Pisces'],
  [2557565404,2557748516,'Aries'],
  [2557748516,2557937584,'Taurus'],
  [2557937584,2558132547,'Gemini'],
  [2558132547,2558333726,'Cancer'],
  [2558333726,2558542378,'Leo'],
  [2558542378,2558758617,'Virgo'],
  [2558758617,2558978110,'Libra'],
  [2558978110,2559192000,'Scorpio'],
  [2559192000,2559392481,'Sagittarius'],
  [2559392481,2559578223,'Capricorn'],
  [2559578223,2559753998,'Aquarius'],
  [2559753998,2559927092,'Pisces'],
  [2559927092,2560104322,'Aries'],
  [2560104322,2560290063,'Taurus'],
  [2560290063,2560485382,'Gemini'],
  [2560485382,2560689134,'Cancer'],
  [2560689134,2560899876,'Leo'],
  [2560899876,2561116434,'Virgo'],
  [2561116434,2561336062,'Libra'],
  [2561336062,2561552556,'Scorpio'],
  [2561552556,2561758227,'Sagittarius'],
  [2561758227,2561948944,'Capricorn'],
  [2561948944,2562126700,'Aquarius'],
  [2562126700,2562297735,'Pisces'],
  [2562297735,2562469552,'Aries'],
  [2562469552,2562648783,'Taurus'],
  [2562648783,2562839493,'Gemini'],
  [2562839493,2563042150,'Cancer'],
  [2563042150,2563254162,'Leo'],
  [2563254162,2563471744,'Virgo'],
  [2563471744,2563691140,'Libra'],
  [2563691140,2563907946,'Scorpio'],
  [2563907946,2564116820,'Sagittarius'],
  [2564116820,2564313345,'Capricorn'],
  [2564313345,2564496815,'Aquarius'],
  [2564496815,2564670804,'Pisces'],
  [2564670804,2564841550,'Aries'],
  [2564841550,2565016057,'Taurus'],
  [2565016057,2565200478,'Gemini'],
  [2565200478,2565398313,'Cancer'],
  [2565398313,2565608712,'Leo'],
  [2565608712,2565826680,'Virgo'],
  [2565826680,2566045978,'Libra'],
  [2566045978,2566261637,'Scorpio'],
  [2566261637,2566470327,'Sagittarius'],
  [2566470327,2566669734,'Capricorn'],
  [2566669734,2566858801,'Aquarius'],
  [2566858801,2567038678,'Pisces'],
  [2567038678,2567212989,'Aries'],
  [2567212989,2567387284,'Taurus'],
  [2567387284,2567567920,'Gemini'],
  [2567567920,2567760390,'Cancer'],
  [2567760390,2567966795,'Leo'],
  [2567966795,2568183567,'Virgo'],
  [2568183567,2568402861,'Libra'],
  [2568402861,2568617446,'Scorpio'],
  [2568617446,2568823940,'Sagittarius'],
  [2568823940,2569022202,'Capricorn'],
  [2569022202,2569213143,'Aquarius'],
  [2569213143,2569397768,'Pisces'],
  [2569397768,2569577614,'Aries'],
  [2569577614,2569755679,'Taurus'],
  [2569755679,2569936756,'Gemini'],
  [2569936756,2570126476,'Cancer'],
  [2570126476,2570328948,'Leo'],
  [2570328948,2570543360,'Virgo'],
  [2570543360,2570762540,'Libra'],
  [2570762540,2570977149,'Scorpio'],
  [2570977149,2571181861,'Sagittarius'],
  [2571181861,2571376943,'Capricorn'],
  [2571376943,2571565514,'Aquarius'],
  [2571565514,2571750579,'Pisces'],
  [2571750579,2571933905,'Aries'],
  [2571933905,2572116758,'Taurus'],
  [2572116758,2572301475,'Gemini'],
  [2572301475,2572492062,'Cancer'],
  [2572492062,2572692805,'Leo'],
  [2572692805,2572905048,'Virgo'],
  [2572905048,2573123963,'Libra'],
  [2573123963,2573339876,'Scorpio'],
  [2573339876,2573544955,'Sagittarius'],
  [2573544955,2573737892,'Capricorn'],
  [2573737892,2573922468,'Aquarius'],
  [2573922468,2574103854,'Pisces'],
  [2574103854,2574285994,'Aries'],
  [2574285994,2574470830,'Taurus'],
  [2574470830,2574659341,'Gemini'],
  [2574659341,2574853163,'Cancer'],
  [2574853163,2575054922,'Leo'],
  [2575054922,2575266363,'Virgo'],
  [2575266363,2575485004,'Libra'],
  [2575485004,2575702858,'Scorpio'],
  [2575702858,2575910746,'Sagittarius'],
  [2575910746,2576104658,'Capricorn'],
  [2576104658,2576287083,'Aquarius'],
  [2576287083,2576463884,'Pisces'],
  [2576463884,2576641119,'Aries'],
  [2576641119,2576823161,'Taurus'],
  [2576823161,2577012119,'Gemini'],
  [2577012119,2577208619,'Cancer'],
  [2577208619,2577412942,'Leo'],
  [2577412942,2577625222,'Virgo'],
  [2577625222,2577843793,'Libra'],
  [2577843793,2578063119,'Scorpio'],
  [2578063119,2578274933,'Sagittarius'],
  [2578274933,2578473093,'Capricorn'],
  [2578473093,2578657334,'Aquarius'],
  [2578657334,2578832306,'Pisces'],
  [2578832306,2579004653,'Aries'],
  [2579004653,2579180824,'Taurus'],
  [2579180824,2579365612,'Gemini'],
  [2579365612,2579561207,'Cancer'],
  [2579561207,2579767113,'Leo'],
  [2579767113,2579981039,'Virgo'],
  [2579981039,2580199913,'Libra'],
  [2580199913,2580419516,'Scorpio'],
  [2580419516,2580634036,'Sagittarius'],
  [2580634036,2580837573,'Capricorn'],
  [2580837573,2581027306,'Aquarius'],
  [2581027306,2581205082,'Pisces'],
  [2581205082,2581376225,'Aries'],
  [2581376225,2581547602,'Taurus'],
  [2581547602,2581726021,'Gemini'],
  [2581726021,2581916568,'Cancer'],
  [2581916568,2582120671,'Leo'],
  [2582120671,2582335265,'Virgo'],
  [2582335265,2582554715,'Libra'],
  [2582554715,2582773730,'Scorpio'],
  [2582773730,2582988273,'Sagittarius'],
  [2582988273,2583194865,'Capricorn'],
  [2583194865,2583390613,'Aquarius'],
  [2583390613,2583574740,'Pisces'],
  [2583574740,2583749669,'Aries'],
  [2583749669,2583920738,'Taurus'],
  [2583920738,2584094949,'Gemini'],
  [2584094949,2584279292,'Cancer'],
  [2584279292,2584478264,'Leo'],
  [2584478264,2584690893,'Virgo'],
  [2584690893,2584910479,'Libra'],
  [2584910479,2585129051,'Scorpio'],
  [2585129051,2585341860,'Sagittarius'],
  [2585341860,2585547523,'Capricorn'],
  [2585547523,2585745578,'Aquarius'],
  [2585745578,2585935344,'Pisces'],
  [2585935344,2586116857,'Aries'],
  [2586116857,2586292491,'Taurus'],
  [2586292491,2586467444,'Gemini'],
  [2586467444,2586648601,'Cancer'],
  [2586648601,2586842267,'Leo'],
  [2586842267,2587050679,'Virgo'],
  [2587050679,2587269045,'Libra'],
  [2587269045,2587487798,'Scorpio'],
  [2587487798,2587699459,'Sagittarius'],
  [2587699459,2587902235,'Capricorn'],
  [2587902235,2588097863,'Aquarius'],
  [2588097863,2588288220,'Pisces'],
  [2588288220,2588473974,'Aries'],
  [2588473974,2588655628,'Taurus'],
  [2588655628,2588835491,'Gemini'],
  [2588835491,2589018324,'Cancer'],
  [2589018324,2589210009,'Leo'],
  [2589210009,2589414622,'Virgo'],
  [2589414622,2589630605,'Libra'],
  [2589630605,2589849690,'Scorpio'],
  [2589849690,2590062180,'Sagittarius'],
  [2590062180,2590263613,'Capricorn'],
  [2590263613,2590455491,'Aquarius'],
  [2590455491,2590641801,'Pisces'],
  [2590641801,2590825944,'Aries'],
  [2590825944,2591009721,'Taurus'],
  [2591009721,2591194292,'Gemini'],
  [2591194292,2591381756,'Cancer'],
  [2591381756,2591575599,'Leo'],
  [2591575599,2591779296,'Virgo'],
  [2591779296,2591993287,'Libra'],
  [2591993287,2592212314,'Scorpio'],
  [2592212314,2592427075,'Sagittarius'],
  [2592427075,2592630380,'Capricorn'],
  [2592630380,2592821230,'Aquarius'],
  [2592821230,2593003411,'Pisces'],
  [2593003411,2593182243,'Aries'],
  [2593182243,2593362348,'Taurus'],
  [2593362348,2593546765,'Gemini'],
  [2593546765,2593737200,'Cancer'],
  [2593737200,2593934792,'Leo'],
  [2593934792,2594140498,'Virgo'],
  [2594140498,2594354248,'Libra'],
  [2594354248,2594572970,'Scorpio'],
  [2594572970,2594789875,'Sagittarius'],
  [2594789875,2594997230,'Capricorn'],
  [2594997230,2595191068,'Aquarius'],
  [2595191068,2595372857,'Pisces'],
  [2595372857,2595547684,'Aries'],
  [2595547684,2595721858,'Taurus'],
  [2595721858,2595901160,'Gemini'],
  [2595901160,2596089579,'Cancer'],
  [2596089579,2596288466,'Leo'],
  [2596288466,2596496681,'Virgo'],
  [2596496681,2596711744,'Libra'],
  [2596711744,2596930420,'Scorpio'],
  [2596930420,2597148223,'Sagittarius'],
  [2597148223,2597359281,'Capricorn'],
  [2597359281,2597558402,'Aquarius'],
  [2597558402,2597744086,'Pisces'],
  [2597744086,2597919266,'Aries'],
  [2597919266,2598089965,'Taurus'],
  [2598089965,2598263371,'Gemini'],
  [2598263371,2598446037,'Cancer'],
  [2598446037,2598641827,'Leo'],
  [2598641827,2598850118,'Virgo'],
  [2598850118,2599066431,'Libra'],
  [2599066431,2599285438,'Scorpio'],
  [2599285438,2599502947,'Sagittarius'],
  [2599502947,2599715405,'Capricorn'],
  [2599715405,2599918902,'Aquarius'],
  [2599918902,2600110436,'Pisces'],
  [2600110436,2600290097,'Aries'],
  [2600290097,2600461886,'Taurus'],
  [2600461886,2600632596,'Gemini'],
  [2600632596,2600809886,'Cancer'],
  [2600809886,2601000054,'Leo'],
  [2601000054,2601205071,'Virgo'],
  [2601205071,2601420896,'Libra'],
  [2601420896,2601640157,'Scorpio'],
  [2601640157,2601856953,'Sagittarius'],
  [2601856953,2602068481,'Capricorn'],
  [2602068481,2602273112,'Aquarius'],
  [2602273112,2602468853,'Pisces'],
  [2602468853,2602654335,'Aries'],
  [2602654335,2602830903,'Taurus'],
  [2602830903,2603003372,'Gemini'],
  [2603003372,2603178808,'Cancer'],
  [2603178808,2603364419,'Leo'],
  [2603364419,2603564628,'Virgo'],
  [2603564628,2603777876,'Libra'],
  [2603777876,2603996763,'Scorpio'],
  [2603996763,2604213176,'Sagittarius'],
  [2604213176,2604422992,'Capricorn'],
  [2604422992,2604625720,'Aquarius'],
  [2604625720,2604821663,'Pisces'],
  [2604821663,2605010514,'Aries'],
  [2605010514,2605192403,'Taurus'],
  [2605192403,2605369696,'Gemini'],
  [2605369696,2605547404,'Cancer'],
  [2605547404,2605731918,'Leo'],
  [2605731918,2605928595,'Virgo'],
  [2605928595,2606138465,'Libra'],
  [2606138465,2606356218,'Scorpio'],
  [2606356218,2606572919,'Sagittarius'],
  [2606572919,2606782038,'Capricorn'],
  [2606782038,2606982156,'Aquarius'],
  [2606982156,2607174996,'Pisces'],
  [2607174996,2607362659,'Aries'],
  [2607362659,2607546586,'Taurus'],
  [2607546586,2607728317,'Gemini'],
  [2607728317,2607910616,'Cancer'],
  [2607910616,2608097646,'Leo'],
  [2608097646,2608293818,'Virgo'],
  [2608293818,2608501371,'Libra'],
  [2608501371,2608717693,'Scorpio'],
  [2608717693,2608935204,'Sagittarius'],
  [2608935204,2609145628,'Capricorn'],
  [2609145628,2609345040,'Aquarius'],
  [2609345040,2609534558,'Pisces'],
  [2609534558,2609717877,'Aries'],
  [2609717877,2609898982,'Taurus'],
  [2609898982,2610081092,'Gemini'],
  [2610081092,2610266631,'Cancer'],
  [2610266631,2610457683,'Leo'],
  [2610457683,2610656248,'Virgo'],
  [2610656248,2610863695,'Libra'],
  [2610863695,2611079045,'Scorpio'],
  [2611079045,2611297351,'Sagittarius'],
  [2611297351,2611510705,'Capricorn'],
  [2611510705,2611712636,'Aquarius'],
  [2611712636,2611901767,'Pisces'],
  [2611901767,2612081382,'Aries'],
  [2612081382,2612257093,'Taurus'],
  [2612257093,2612434739,'Gemini'],
  [2612434739,2612618859,'Cancer'],
  [2612618859,2612811736,'Leo'],
  [2612811736,2613013407,'Virgo'],
  [2613013407,2613222734,'Libra'],
  [2613222734,2613438140,'Scorpio'],
  [2613438140,2613656726,'Sagittarius'],
  [2613656726,2613872941,'Capricorn'],
  [2613872941,2614079726,'Aquarius'],
  [2614079726,2614272654,'Pisces'],
  [2614272654,2614452560,'Aries'],
  [2614452560,2614624699,'Taurus'],
  [2614624699,2614796360,'Gemini'],
  [2614796360,2614974666,'Cancer'],
  [2614974666,2615164477,'Leo'],
  [2615164477,2615366543,'Virgo'],
  [2615366543,2615577836,'Libra'],
  [2615577836,2615794285,'Scorpio'],
  [2615794285,2616012739,'Sagittarius'],
  [2616012739,2616229994,'Capricorn'],
  [2616229994,2616440994,'Aquarius'],
  [2616440994,2616640133,'Pisces'],
  [2616640133,2616825018,'Aries'],
  [2616825018,2616998482,'Taurus'],
  [2616998482,2617167303,'Gemini'],
  [2617167303,2617339679,'Cancer'],
  [2617339679,2617522955,'Leo'],
  [2617522955,2617720869,'Virgo'],
  [2617720869,2617931474,'Libra'],
  [2617931474,2618148817,'Scorpio'],
  [2618148817,2618367292,'Sagittarius'],
  [2618367292,2618583757,'Capricorn'],
  [2618583757,2618795669,'Aquarius'],
  [2618795669,2618999238,'Pisces'],
  [2618999238,2619190838,'Aries'],
  [2619190838,2619370171,'Taurus'],
  [2619370171,2619541539,'Gemini'],
  [2619541539,2619712243,'Cancer'],
  [2619712243,2619890275,'Leo'],
  [2619890275,2620081810,'Virgo'],
  [2620081810,2620288157,'Libra'],
  [2620288157,2620504507,'Scorpio'],
  [2620504507,2620723179,'Sagittarius'],
  [2620723179,2620938638,'Capricorn'],
  [2620938638,2621148669,'Aquarius'],
  [2621148669,2621352069,'Pisces'],
  [2621352069,2621547127,'Aries'],
  [2621547127,2621732699,'Taurus'],
  [2621732699,2621910284,'Gemini'],
  [2621910284,2622084566,'Cancer'],
  [2622084566,2622262151,'Leo'],
  [2622262151,2622449564,'Virgo'],
  [2622449564,2622650625,'Libra'],
  [2622650625,2622863785,'Scorpio'],
  [2622863785,2623082099,'Sagittarius'],
  [2623082099,2623297581,'Capricorn'],
  [2623297581,2623505783,'Aquarius'],
  [2623505783,2623706043,'Pisces'],
  [2623706043,2623899276,'Aries'],
  [2623899276,2624086488,'Taurus'],
  [2624086488,2624268955,'Gemini'],
  [2624268955,2624449067,'Cancer'],
  [2624449067,2624630686,'Leo'],
  [2624630686,2624818573,'Virgo'],
  [2624818573,2625016835,'Libra'],
  [2625016835,2625226543,'Scorpio'],
  [2625226543,2625443661,'Sagittarius'],
  [2625443661,2625660095,'Capricorn'],
  [2625660095,2625868607,'Aquarius'],
  [2625868607,2626066571,'Pisces'],
  [2626066571,2626255619,'Aries'],
  [2626255619,2626439330,'Taurus'],
  [2626439330,2626621321,'Gemini'],
  [2626621321,2626804431,'Cancer'],
  [2626804431,2626990807,'Leo'],
  [2626990807,2627182481,'Virgo'],
  [2627182481,2627381667,'Libra'],
  [2627381667,2627589867,'Scorpio'],
  [2627589867,2627805695,'Sagittarius'],
  [2627805695,2628023254,'Capricorn'],
  [2628023254,2628234226,'Aquarius'],
  [2628234226,2628433057,'Pisces'],
  [2628433057,2628619764,'Aries'],
  [2628619764,2628798723,'Taurus'],
  [2628798723,2628975915,'Gemini'],
  [2628975915,2629156632,'Cancer'],
  [2629156632,2629344069,'Leo'],
  [2629344069,2629539061,'Virgo'],
  [2629539061,2629741244,'Libra'],
  [2629741244,2629950361,'Scorpio'],
  [2629950361,2630165726,'Sagittarius'],
  [2630165726,2630383997,'Capricorn'],
  [2630383997,2630598137,'Aquarius'],
  [2630598137,2630800742,'Pisces'],
  [2630800742,2630988984,'Aries'],
  [2630988984,2631165953,'Taurus'],
  [2631165953,2631338334,'Gemini'],
  [2631338334,2631513473,'Cancer'],
  [2631513473,2631697104,'Leo'],
  [2631697104,2631891562,'Virgo'],
  [2631891562,2632095643,'Libra'],
  [2632095643,2632306710,'Scorpio'],
  [2632306710,2632522618,'Sagittarius'],
  [2632522618,2632741066,'Capricorn'],
  [2632741066,2632957357,'Aquarius'],
  [2632957357,2633164540,'Pisces'],
  [2633164540,2633357517,'Aries'],
  [2633357517,2633536736,'Taurus'],
  [2633536736,2633707758,'Gemini'],
  [2633707758,2633878393,'Cancer'],
  [2633878393,2634056165,'Leo'],
  [2634056165,2634246043,'Virgo'],
  [2634246043,2634448585,'Libra'],
  [2634448585,2634660448,'Scorpio'],
  [2634660448,2634877232,'Sagittarius'],
  [2634877232,2635095563,'Capricorn'],
  [2635095563,2635312139,'Aquarius'],
  [2635312139,2635522124,'Pisces'],
  [2635522124,2635720371,'Aries'],
  [2635720371,2635904948,'Taurus'],
  [2635904948,2636078936,'Gemini'],
  [2636078936,2636248957,'Cancer'],
  [2636248957,2636422730,'Leo'],
  [2636422730,2636606917,'Virgo'],
  [2636606917,2636804821,'Libra'],
  [2636804821,2637014886,'Scorpio'],
  [2637014886,2637231831,'Sagittarius'],
  [2637231831,2637450040,'Capricorn'],
  [2637450040,2637665576,'Aquarius'],
  [2637665576,2637875346,'Pisces'],
  [2637875346,2638076235,'Aries'],
  [2638076235,2638266107,'Taurus'],
  [2638266107,2638445760,'Gemini'],
  [2638445760,2638619370,'Cancer'],
  [2638619370,2638793233,'Leo'],
  [2638793233,2638974035,'Virgo'],
  [2638974035,2639166876,'Libra'],
  [2639166876,2639373032,'Scorpio'],
  [2639373032,2639588723,'Sagittarius'],
  [2639588723,2639806914,'Capricorn'],
  [2639806914,2640021430,'Aquarius'],
  [2640021430,2640229017,'Pisces'],
  [2640229017,2640428646,'Aries'],
  [2640428646,2640620267,'Taurus'],
  [2640620267,2640804624,'Gemini'],
  [2640804624,2640983844,'Cancer'],
  [2640983844,2641161689,'Leo'],
  [2641161689,2641343151,'Virgo'],
  [2641343151,2641533345,'Libra'],
  [2641533345,2641735575,'Scorpio'],
  [2641735575,2641948881,'Sagittarius'],
  [2641948881,2642167041,'Capricorn'],
  [2642167041,2642381742,'Aquarius'],
  [2642381742,2642587587,'Pisces'],
  [2642587587,2642783838,'Aries'],
  [2642783838,2642972772,'Taurus'],
  [2642972772,2643157367,'Gemini'],
  [2643157367,2643340110,'Cancer'],
  [2643340110,2643523047,'Leo'],
  [2643523047,2643708532,'Virgo'],
  [2643708532,2643899790,'Libra'],
  [2643899790,2644100247,'Scorpio'],
  [2644100247,2644311246,'Sagittarius'],
  [2644311246,2644529164,'Capricorn'],
  [2644529164,2644745503,'Aquarius'],
  [2644745503,2644952095,'Pisces'],
  [2644952095,2645146252,'Aries'],
  [2645146252,2645330826,'Taurus'],
  [2645330826,2645511146,'Gemini'],
  [2645511146,2645692178,'Cancer'],
  [2645692178,2645876940,'Leo'],
  [2645876940,2646066492,'Virgo'],
  [2646066492,2646261405,'Libra'],
  [2646261405,2646463109,'Scorpio'],
  [2646463109,2646673233,'Sagittarius'],
  [2646673233,2646890707,'Capricorn'],
  [2646890707,2647109166,'Aquarius'],
  [2647109166,2647319225,'Pisces'],
  [2647319225,2647515055,'Aries'],
  [2647515055,2647697750,'Taurus'],
  [2647697750,2647873205,'Gemini'],
  [2647873205,2648048552,'Cancer'],
  [2648048552,2648229554,'Leo'],
  [2648229554,2648418944,'Virgo'],
  [2648418944,2648616510,'Libra'],
  [2648616510,2648821114,'Scorpio'],
  [2648821114,2649032324,'Sagittarius'],
  [2649032324,2649249581,'Capricorn'],
  [2649249581,2649469233,'Aquarius'],
  [2649469233,2649683436,'Pisces'],
  [2649683436,2649884400,'Aries'],
  [2649884400,2650069975,'Taurus'],
  [2650069975,2650244366,'Gemini'],
  [2650244366,2650414981,'Cancer'],
  [2650414981,2650589437,'Leo'],
  [2650589437,2650773410,'Virgo'],
  [2650773410,2650968994,'Libra'],
  [2650968994,2651174787,'Scorpio'],
  [2651174787,2651387868,'Sagittarius'],
  [2651387868,2651605617,'Capricorn'],
  [2651605617,2651825167,'Aquarius'],
  [2651825167,2652041437,'Pisces'],
  [2652041437,2652247713,'Aries'],
  [2652247713,2652439601,'Taurus'],
  [2652439601,2652618124,'Gemini'],
  [2652618124,2652788864,'Cancer'],
  [2652788864,2652959295,'Leo'],
  [2652959295,2653136638,'Virgo'],
  [2653136638,2653326022,'Libra'],
  [2653326022,2653528758,'Scorpio'],
  [2653528758,2653741969,'Sagittarius'],
  [2653741969,2653960504,'Capricorn'],
  [2653960504,2654179576,'Aquarius'],
  [2654179576,2654395185,'Pisces'],
  [2654395185,2654603363,'Aries'],
  [2654603363,2654800618,'Taurus'],
  [2654800618,2654985890,'Gemini'],
  [2654985890,2655161704,'Cancer'],
  [2655161704,2655333437,'Leo'],
  [2655333437,2655507792,'Virgo'],
  [2655507792,2655691239,'Libra'],
  [2655691239,2655888113,'Scorpio'],
  [2655888113,2656098334,'Sagittarius'],
  [2656098334,2656316648,'Capricorn'],
  [2656316648,2656535618,'Aquarius'],
  [2656535618,2656749632,'Pisces'],
  [2656749632,2656956091,'Aries'],
  [2656956091,2657154192,'Taurus'],
  [2657154192,2657343863,'Gemini'],
  [2657343863,2657526012,'Cancer'],
  [2657526012,2657703150,'Leo'],
  [2657703150,2657879655,'Virgo'],
  [2657879655,2658061230,'Libra'],
  [2658061230,2658253446,'Scorpio'],
  [2658253446,2658459176,'Sagittarius'],
  [2658459176,2658675658,'Capricorn'],
  [2658675658,2658894752,'Aquarius'],
  [2658894752,2659108139,'Pisces'],
  [2659108139,2659312039,'Aries'],
  [2659312039,2659507218,'Taurus'],
  [2659507218,2659696184,'Gemini'],
  [2659696184,2659881099,'Cancer'],
  [2659881099,2660063444,'Leo'],
  [2660063444,2660245026,'Virgo'],
  [2660245026,2660429147,'Libra'],
  [2660429147,2660620478,'Scorpio'],
  [2660620478,2660823119,'Sagittarius'],
  [2660823119,2661037160,'Capricorn'],
  [2661037160,2661256239,'Aquarius'],
  [2661256239,2661470555,'Pisces'],
  [2661470555,2661673706,'Aries'],
  [2661673706,2661865721,'Taurus'],
  [2661865721,2662050696,'Gemini'],
  [2662050696,2662233265,'Cancer'],
  [2662233265,2662416509,'Leo'],
  [2662416509,2662601786,'Virgo'],
  [2662601786,2662790187,'Libra'],
  [2662790187,2662984017,'Scorpio'],
  [2662984017,2663186468,'Sagittarius'],
  [2663186468,2663399004,'Capricorn'],
  [2663399004,2663617909,'Aquarius'],
  [2663617909,2663834175,'Pisces'],
  [2663834175,2664039241,'Aries'],
  [2664039241,2664230746,'Taurus'],
  [2664230746,2664412340,'Gemini'],
  [2664412340,2664590114,'Cancer'],
  [2664590114,2664769560,'Leo'],
  [2664769560,2664953980,'Virgo'],
  [2664953980,2665144522,'Libra'],
  [2665144522,2665341606,'Scorpio'],
  [2665341606,2665546124,'Sagittarius'],
  [2665546124,2665758805,'Capricorn'],
  [2665758805,2665977591,'Aquarius'],
  [2665977591,2666195745,'Pisces'],
  [2666195745,2666404502,'Aries'],
  [2666404502,2666598916,'Taurus'],
  [2666598916,2666780499,'Gemini'],
  [2666780499,2666954976,'Cancer'],
  [2666954976,2667129128,'Leo'],
  [2667129128,2667308654,'Virgo'],
  [2667308654,2667496929,'Libra'],
  [2667496929,2667694819,'Scorpio'],
  [2667694819,2667901512,'Sagittarius'],
  [2667901512,2668115514,'Capricorn'],
  [2668115514,2668334420,'Aquarius'],
  [2668334420,2668553450,'Pisces'],
  [2668553450,2668765647,'Aries'],
  [2668765647,2668965074,'Taurus'],
  [2668965074,2669150490,'Gemini'],
  [2669150490,2669325600,'Cancer'],
  [2669325600,2669496756,'Leo'],
  [2669496756,2669670813,'Virgo'],
  [2669670813,2669853561,'Libra'],
  [2669853561,2670048307,'Scorpio'],
  [2670048307,2670254883,'Sagittarius'],
  [2670254883,2670470039,'Capricorn'],
  [2670470039,2670689291,'Aquarius'],
  [2670689291,2670908035,'Pisces'],
  [2670908035,2671121525,'Aries'],
  [2671121525,2671325223,'Taurus'],
  [2671325223,2671516479,'Gemini'],
  [2671516479,2671696212,'Cancer'],
  [2671696212,2671868700,'Leo'],
  [2671868700,2672040246,'Virgo'],
  [2672040246,2672217714,'Libra'],
  [2672217714,2672406866,'Scorpio'],
  [2672406866,2672610121,'Sagittarius'],
  [2672610121,2672824775,'Capricorn'],
  [2672824775,2673044313,'Aquarius'],
  [2673044313,2673262296,'Pisces'],
  [2673262296,2673474686,'Aries'],
  [2673474686,2673679360,'Taurus'],
  [2673679360,2673874870,'Gemini'],
  [2673874870,2674060707,'Cancer'],
  [2674060707,2674238378,'Leo'],
  [2674238378,2674411965,'Virgo'],
  [2674411965,2674587611,'Libra'],
  [2674587611,2674772077,'Scorpio'],
  [2674772077,2674970339,'Sagittarius'],
  [2674970339,2675182318,'Capricorn'],
  [2675182318,2675401569,'Aquarius'],
  [2675401569,2675619246,'Pisces'],
  [2675619246,2675829766,'Aries'],
  [2675829766,2676032164,'Taurus'],
  [2676032164,2676227540,'Gemini'],
  [2676227540,2676416722,'Cancer'],
  [2676416722,2676600101,'Leo'],
  [2676600101,2676779087,'Virgo'],
  [2676779087,2676957426,'Libra'],
  [2676957426,2677140914,'Scorpio'],
  [2677140914,2677335482,'Sagittarius'],
  [2677335482,2677543797,'Capricorn'],
  [2677543797,2677761841,'Aquarius'],
  [2677761841,2677980053,'Pisces'],
  [2677980053,2678190100,'Aries'],
  [2678190100,2678389744,'Taurus'],
  [2678389744,2678581468,'Gemini'],
  [2678581468,2678768753,'Cancer'],
  [2678768753,2678953754,'Leo'],
  [2678953754,2679137332,'Virgo'],
  [2679137332,2679320812,'Libra'],
  [2679320812,2679507417,'Scorpio'],
  [2679507417,2679701825,'Sagittarius'],
  [2679701825,2679907725,'Capricorn'],
  [2679907725,2680124048,'Aquarius'],
  [2680124048,2680343139,'Pisces'],
  [2680343139,2680555053,'Aries'],
  [2680555053,2680754586,'Taurus'],
  [2680754586,2680943127,'Gemini'],
  [2680943127,2681125502,'Cancer'],
  [2681125502,2681306583,'Leo'],
  [2681306583,2681489533,'Virgo'],
  [2681489533,2681675870,'Libra'],
  [2681675870,2681866804,'Scorpio'],
  [2681866804,2682064292,'Sagittarius'],
  [2682064292,2682270564,'Capricorn'],
  [2682270564,2682485792,'Aquarius'],
  [2682485792,2682705330,'Pisces'],
  [2682705330,2682920374,'Aries'],
  [2682920374,2683123345,'Taurus'],
  [2683123345,2683312617,'Gemini'],
  [2683312617,2683491947,'Cancer'],
  [2683491947,2683667350,'Leo'],
  [2683667350,2683844652,'Virgo'],
  [2683844652,2684028113,'Libra'],
  [2684028113,2684219909,'Scorpio'],
  [2684219909,2684420461,'Sagittarius'],
  [2684420461,2684629201,'Capricorn'],
  [2684629201,2684844850,'Aquarius'],
  [2684844850,2685064299,'Pisces'],
  [2685064299,2685281606,'Aries'],
  [2685281606,2685489545,'Taurus'],
  [2685489545,2685683690,'Gemini'],
  [2685683690,2685864824,'Cancer'],
  [2685864824,2686037826,'Leo'],
  [2686037826,2686209402,'Virgo'],
  [2686209402,2686386257,'Libra'],
  [2686386257,2686573534,'Scorpio'],
  [2686573534,2686773245,'Sagittarius'],
  [2686773245,2686983654,'Capricorn'],
  [2686983654,2687200718,'Aquarius'],
  [2687200718,2687420130,'Pisces'],
  [2687420130,2687637750,'Aries'],
  [2687637750,2687848905,'Taurus'],
  [2687848905,2688048993,'Gemini'],
  [2688048993,2688235957,'Cancer'],
  [2688235957,2688411774,'Leo'],
  [2688411774,2688581922,'Virgo'],
  [2688581922,2688753682,'Libra'],
  [2688753682,2688934323,'Scorpio'],
  [2688934323,2689128883,'Sagittarius'],
  [2689128883,2689337534,'Capricorn'],
  [2689337534,2689555150,'Aquarius'],
  [2689555150,2689774811,'Pisces'],
  [2689774811,2689991575,'Aries'],
  [2689991575,2690202748,'Taurus'],
  [2690202748,2690405958,'Gemini'],
  [2690405958,2690598858,'Cancer'],
  [2690598858,2690780812,'Leo'],
  [2690780812,2690954528,'Virgo'],
  [2690954528,2691125926,'Libra'],
  [2691125926,2691302512,'Scorpio'],
  [2691302512,2691491190,'Sagittarius'],
  [2691491190,2691695153,'Capricorn'],
  [2691695153,2691911082,'Aquarius'],
  [2691911082,2692130739,'Pisces'],
  [2692130739,2692346763,'Aries'],
  [2692346763,2692556101,'Taurus'],
  [2692556101,2692758444,'Gemini'],
  [2692758444,2692953515,'Cancer'],
  [2692953515,2693140596,'Leo'],
  [2693140596,2693320164,'Virgo'],
  [2693320164,2693495534,'Libra'],
  [2693495534,2693672661,'Scorpio'],
  [2693672661,2693858412,'Sagittarius'],
  [2693858412,2694057792,'Capricorn'],
  [2694057792,2694270427,'Aquarius'],
  [2694270427,2694489334,'Pisces'],
  [2694489334,2694705360,'Aries'],
  [2694705360,2694913266,'Taurus'],
  [2694913266,2695112793,'Gemini'],
  [2695112793,2695305764,'Cancer'],
  [2695305764,2695493570,'Leo'],
  [2695493570,2695676959,'Virgo'],
  [2695676959,2695857465,'Libra'],
  [2695857465,2696038585,'Scorpio'],
  [2696038585,2696225437,'Sagittarius'],
  [2696225437,2696422913,'Capricorn'],
  [2696422913,2696632617,'Aquarius'],
  [2696632617,2696850247,'Pisces'],
  [2696850247,2697066979,'Aries'],
  [2697066979,2697275274,'Taurus'],
  [2697275274,2697472979,'Gemini'],
  [2697472979,2697662265,'Cancer'],
  [2697662265,2697846657,'Leo'],
  [2697846657,2698029148,'Virgo'],
  [2698029148,2698211942,'Libra'],
  [2698211942,2698397209,'Scorpio'],
  [2698397209,2698587695,'Sagittarius'],
  [2698587695,2698786429,'Capricorn'],
  [2698786429,2698995099,'Aquarius'],
  [2698995099,2699211634,'Pisces'],
  [2699211634,2699429347,'Aries'],
  [2699429347,2699639949,'Taurus'],
  [2699639949,2699838640,'Gemini'],
  [2699838640,2700025988,'Cancer'],
  [2700025988,2700206047,'Leo'],
  [2700206047,2700383940,'Virgo'],
  [2700383940,2700564257,'Libra'],
  [2700564257,2700750264,'Scorpio'],
  [2700750264,2700943760,'Sagittarius'],
  [2700943760,2701145421,'Capricorn'],
  [2701145421,2701355135,'Aquarius'],
  [2701355135,2701571345,'Pisces'],
  [2701571345,2701789762,'Aries'],
  [2701789762,2702003463,'Taurus'],
  [2702003463,2702205950,'Gemini'],
  [2702205950,2702395000,'Cancer'],
  [2702395000,2702573280,'Leo'],
  [2702573280,2702746509,'Virgo'],
  [2702746509,2702921325,'Libra'],
  [2702921325,2703103504,'Scorpio'],
  [2703103504,2703296361,'Sagittarius'],
  [2703296361,2703499865,'Capricorn'],
  [2703499865,2703711536,'Aquarius'],
  [2703711536,2703928280,'Pisces'],
  [2703928280,2704146825,'Aries'],
  [2704146825,2704362659,'Taurus'],
  [2704362659,2704569877,'Gemini'],
  [2704569877,2704763961,'Cancer'],
  [2704763961,2704944754,'Leo'],
  [2704944754,2705116692,'Virgo'],
  [2705116692,2705286914,'Libra'],
  [2705286914,2705463078,'Scorpio'],
  [2705463078,2705651171,'Sagittarius'],
  [2705651171,2705853028,'Capricorn'],
  [2705853028,2706065513,'Aquarius'],
  [2706065513,2706283142,'Pisces'],
  [2706283142,2706501451,'Aries'],
  [2706501451,2706717394,'Taurus'],
  [2706717394,2706927410,'Gemini'],
  [2706927410,2707127108,'Cancer'],
  [2707127108,2707313828,'Leo'],
  [2707313828,2707489184,'Virgo'],
  [2707489184,2707658957,'Libra'],
  [2707658957,2707831024,'Scorpio'],
  [2707831024,2708013086,'Sagittarius'],
  [2708013086,2708209875,'Capricorn'],
  [2708209875,2708420323,'Aquarius'],
  [2708420323,2708638123,'Pisces'],
  [2708638123,2708856322,'Aries'],
  [2708856322,2709070999,'Taurus'],
  [2709070999,2709280416,'Gemini'],
  [2709280416,2709482541,'Cancer'],
  [2709482541,2709674842,'Leo'],
  [2709674842,2709856554,'Virgo'],
  [2709856554,2710030641,'Libra'],
  [2710030641,2710203320,'Scorpio'],
  [2710203320,2710382129,'Sagittarius'],
  [2710382129,2710573470,'Capricorn'],
  [2710573470,2710779414,'Aquarius'],
  [2710779414,2710995660,'Pisces'],
  [2710995660,2711213972,'Aries'],
  [2711213972,2711427777,'Taurus'],
  [2711427777,2711634739,'Gemini'],
  [2711634739,2711834883,'Cancer'],
  [2711834883,2712028222,'Leo'],
  [2712028222,2712214507,'Virgo'],
  [2712214507,2712394740,'Libra'],
  [2712394740,2712572331,'Scorpio'],
  [2712572331,2712752727,'Sagittarius'],
  [2712752727,2712941842,'Capricorn'],
  [2712941842,2713143550,'Aquarius'],
  [2713143550,2713356825,'Pisces'],
  [2713356825,2713574973,'Aries'],
  [2713574973,2713789444,'Taurus'],
  [2713789444,2713995159,'Gemini'],
  [2713995159,2714191759,'Cancer'],
  [2714191759,2714381423,'Leo'],
  [2714381423,2714566674,'Virgo'],
  [2714566674,2714749626,'Libra'],
  [2714749626,2714932381,'Scorpio'],
  [2714932381,2715117668,'Sagittarius'],
  [2715117668,2715308935,'Capricorn'],
  [2715308935,2715509434,'Aquarius'],
  [2715509434,2715720162,'Pisces'],
  [2715720162,2715937585,'Aries'],
  [2715937585,2716153850,'Taurus'],
  [2716153850,2716361230,'Gemini'],
  [2716361230,2716556677,'Cancer'],
  [2716556677,2716742143,'Leo'],
  [2716742143,2716922256,'Virgo'],
  [2716922256,2717101981,'Libra'],
  [2717101981,2717285161,'Scorpio'],
  [2717285161,2717473982,'Sagittarius'],
  [2717473982,2717669395,'Capricorn'],
  [2717669395,2717872036,'Aquarius'],
  [2717872036,2718082354,'Pisces'],
  [2718082354,2718299015,'Aries'],
  [2718299015,2718516911,'Taurus'],
  [2718516911,2718728041,'Gemini'],
  [2718728041,2718926298,'Cancer'],
  [2718926298,2719111137,'Leo'],
  [2719111137,2719287046,'Virgo'],
  [2719287046,2719460815,'Libra'],
  [2719460815,2719639026,'Scorpio'],
  [2719639026,2719826125,'Sagittarius'],
  [2719826125,2720023225,'Capricorn'],
  [2720023225,2720228772,'Aquarius'],
  [2720228772,2720440697,'Pisces'],
  [2720440697,2720657339,'Aries'],
  [2720657339,2720875881,'Taurus'],
  [2720875881,2721090453,'Gemini'],
  [2721090453,2721293911,'Cancer'],
  [2721293911,2721482577,'Leo'],
  [2721482577,2721658695,'Virgo'],
  [2721658695,2721828850,'Libra'],
  [2721828850,2722001013,'Scorpio'],
  [2722001013,2722182179,'Sagittarius'],
  [2722182179,2722376075,'Capricorn'],
  [2722376075,2722581784,'Aquarius'],
  [2722581784,2722795300,'Pisces'],
  [2722795300,2723012675,'Aries'],
  [2723012675,2723231095,'Taurus'],
  [2723231095,2723446986,'Gemini'],
  [2723446986,2723654771,'Cancer'],
  [2723654771,2723849374,'Leo'],
  [2723849374,2724030072,'Virgo'],
  [2724030072,2724201385,'Libra'],
  [2724201385,2724370838,'Scorpio'],
  [2724370838,2724546403,'Sagittarius'],
  [2724546403,2724734236,'Capricorn'],
  [2724734236,2724936206,'Aquarius'],
  [2724936206,2725149071,'Pisces'],
  [2725149071,2725366986,'Aries'],
  [2725366986,2725585124,'Taurus'],
  [2725585124,2725800313,'Gemini'],
  [2725800313,2726009262,'Cancer'],
  [2726009262,2726208155,'Leo'],
  [2726208155,2726394865,'Virgo'],
  [2726394865,2726571202,'Libra'],
  [2726571202,2726742641,'Scorpio'],
  [2726742641,2726916399,'Sagittarius'],
  [2726916399,2727099391,'Capricorn'],
  [2727099391,2727295931,'Aquarius'],
  [2727295931,2727505528,'Pisces'],
  [2727505528,2727722792,'Aries'],
  [2727722792,2727940786,'Taurus'],
  [2727940786,2728154662,'Gemini'],
  [2728154662,2728361948,'Cancer'],
  [2728361948,2728561180,'Leo'],
  [2728561180,2728751434,'Virgo'],
  [2728751434,2728933335,'Libra'],
  [2728933335,2729109898,'Scorpio'],
  [2729109898,2729286176,'Sagittarius'],
  [2729286176,2729468098,'Capricorn'],
  [2729468098,2729660769,'Aquarius'],
  [2729660769,2729866243,'Pisces'],
  [2729866243,2730081581,'Aries'],
  [2730081581,2730299548,'Taurus'],
  [2730299548,2730512909,'Gemini'],
  [2730512909,2730717922,'Cancer'],
  [2730717922,2730914345,'Leo'],
  [2730914345,2731103683,'Virgo'],
  [2731103683,2731287884,'Libra'],
  [2731287884,2731469153,'Scorpio'],
  [2731469153,2731650287,'Sagittarius'],
  [2731650287,2731834908,'Capricorn'],
  [2731834908,2732027070,'Aquarius'],
  [2732027070,2732229840,'Pisces'],
  [2732229840,2732442914,'Aries'],
  [2732442914,2732660858,'Taurus'],
  [2732660858,2732875165,'Gemini'],
  [2732875165,2733079554,'Cancer'],
  [2733079554,2733272950,'Leo'],
  [2733272950,2733458351,'Virgo'],
  [2733458351,2733640154,'Libra'],
  [2733640154,2733822159,'Scorpio'],
  [2733822159,2734006815,'Sagittarius'],
  [2734006815,2734195662,'Capricorn'],
  [2734195662,2734390369,'Aquarius'],
  [2734390369,2734593047,'Pisces'],
  [2734593047,2734804725,'Aries'],
  [2734804725,2735022578,'Taurus'],
  [2735022578,2735238961,'Gemini'],
  [2735238961,2735445428,'Cancer'],
  [2735445428,2735638399,'Leo'],
  [2735638399,2735820377,'Virgo'],
  [2735820377,2735997282,'Libra'],
  [2735997282,2736175359,'Scorpio'],
  [2736175359,2736359043,'Sagittarius'],
  [2736359043,2736550011,'Capricorn'],
  [2736550011,2736748023,'Aquarius'],
  [2736748023,2736952802,'Pisces'],
  [2736952802,2737164617,'Aries'],
  [2737164617,2737382344,'Taurus'],
  [2737382344,2737600743,'Gemini'],
  [2737600743,2737811247,'Cancer'],
  [2737811247,2738007511,'Leo'],
  [2738007511,2738189652,'Virgo'],
  [2738189652,2738363200,'Libra'],
  [2738363200,2738535725,'Scorpio'],
  [2738535725,2738714115,'Sagittarius'],
  [2738714115,2738902483,'Capricorn'],
  [2738902483,2739101188,'Aquarius'],
  [2739101188,2739308201,'Pisces'],
  [2739308201,2739521404,'Aries'],
  [2739521404,2739739179,'Taurus'],
  [2739739179,2739958343,'Gemini'],
  [2739958343,2740172438,'Cancer'],
  [2740172438,2740374276,'Leo'],
  [2740374276,2740560942,'Virgo'],
  [2740560942,2740735632,'Libra'],
  [2740735632,2740905348,'Scorpio'],
  [2740905348,2741077986,'Sagittarius'],
  [2741077986,2741260135,'Capricorn'],
  [2741260135,2741455014,'Aquarius'],
  [2741455014,2741661580,'Pisces'],
  [2741661580,2741875994,'Aries'],
  [2741875994,2742094204,'Taurus'],
  [2742094204,2742312855,'Gemini'],
  [2742312855,2742527841,'Cancer'],
  [2742527841,2742733896,'Leo'],
  [2742733896,2742926992,'Virgo'],
  [2742926992,2743107290,'Libra'],
  [2743107290,2743279339,'Scorpio'],
  [2743279339,2743450089,'Sagittarius'],
  [2743450089,2743626835,'Capricorn'],
  [2743626835,2743815320,'Aquarius'],
  [2743815320,2744017650,'Pisces'],
  [2744017650,2744231141,'Aries'],
  [2744231141,2744449791,'Taurus'],
  [2744449791,2744667788,'Gemini'],
  [2744667788,2744881203,'Cancer'],
  [2744881203,2745087353,'Leo'],
  [2745087353,2745284148,'Virgo'],
  [2745284148,2745470832,'Libra'],
  [2745470832,2745649115,'Scorpio'],
  [2745649115,2745823256,'Sagittarius'],
  [2745823256,2745999188,'Capricorn'],
  [2745999188,2746183166,'Aquarius'],
  [2746183166,2746379866,'Pisces'],
  [2746379866,2746589831,'Aries'],
  [2746589831,2746807950,'Taurus'],
  [2746807950,2747026036,'Gemini'],
  [2747026036,2747237808,'Cancer'],
  [2747237808,2747441085,'Leo'],
  [2747441085,2747636473,'Virgo'],
  [2747636473,2747825312,'Libra'],
  [2747825312,2748008953,'Scorpio'],
  [2748008953,2748189195,'Sagittarius'],
  [2748189195,2748369106,'Capricorn'],
  [2748369106,2748553267,'Aquarius'],
  [2748553267,2748746756,'Pisces'],
  [2748746756,2748952709,'Aries'],
  [2748952709,2749169040,'Taurus'],
  [2749169040,2749387735,'Gemini'],
  [2749387735,2749599734,'Cancer'],
  [2749599734,2749800764,'Leo'],
  [2749800764,2749992153,'Virgo'],
  [2749992153,2750177844,'Libra'],
  [2750177844,2750361506,'Scorpio'],
  [2750361506,2750545296,'Sagittarius'],
  [2750545296,2750730371,'Capricorn'],
  [2750730371,2750918484,'Aquarius'],
  [2750918484,2751112861,'Pisces'],
  [2751112861,2751316993,'Aries'],
  [2751316993,2751531406,'Taurus'],
  [2751531406,2751750580,'Gemini'],
  [2751750580,2751964701,'Cancer'],
  [2751964701,2752166510,'Leo'],
  [2752166510,2752355590,'Virgo'],
  [2752355590,2752536624,'Libra'],
  [2752536624,2752715634,'Scorpio'],
  [2752715634,2752897297,'Sagittarius'],
  [2752897297,2753083816,'Capricorn'],
  [2753083816,2753275649,'Aquarius'],
  [2753275649,2753473395,'Pisces'],
  [2753473395,2753678649,'Aries'],
  [2753678649,2753892398,'Taurus'],
  [2753892398,2754111707,'Gemini'],
  [2754111707,2754328479,'Cancer'],
  [2754328479,2754533874,'Leo'],
  [2754533874,2754724529,'Virgo'],
  [2754724529,2754903663,'Libra'],
  [2754903663,2755077869,'Scorpio'],
  [2755077869,2755253890,'Sagittarius'],
  [2755253890,2755436590,'Capricorn'],
  [2755436590,2755628002,'Aquarius'],
  [2755628002,2755827956,'Pisces'],
  [2755827956,2756035626,'Aries'],
  [2756035626,2756250230,'Taurus'],
  [2756250230,2756469584,'Gemini'],
  [2756469584,2756688063,'Cancer'],
  [2756688063,2756897729,'Leo'],
  [2756897729,2757093113,'Virgo'],
  [2757093113,2757274668,'Libra'],
  [2757274668,2757447632,'Scorpio'],
  [2757447632,2757619085,'Sagittarius'],
  [2757619085,2757795729,'Capricorn'],
  [2757795729,2757982325,'Aquarius'],
  [2757982325,2758180610,'Pisces'],
  [2758180610,2758389267,'Aries'],
  [2758389267,2758605183,'Taurus'],
  [2758605183,2758824727,'Gemini'],
  [2758824727,2759043423,'Cancer'],
  [2759043423,2759255646,'Leo'],
  [2759255646,2759456189,'Virgo'],
  [2759456189,2759643209,'Libra'],
  [2759643209,2759819329,'Scorpio'],
  [2759819329,2759990238,'Sagittarius'],
  [2759990238,2760162786,'Capricorn'],
  [2760162786,2760343445,'Aquarius'],
  [2760343445,2760536695,'Pisces'],
  [2760536695,2760743235,'Aries'],
  [2760743235,2760959369,'Taurus'],
  [2760959369,2761179143,'Gemini'],
  [2761179143,2761397103,'Cancer'],
  [2761397103,2761609186,'Leo'],
  [2761609186,2761812346,'Virgo'],
  [2761812346,2762004690,'Libra'],
  [2762004690,2762186598,'Scorpio'],
  [2762186598,2762361195,'Sagittarius'],
  [2762361195,2762533839,'Capricorn'],
  [2762533839,2762711042,'Aquarius'],
  [2762711042,2762898955,'Pisces'],
  [2762898955,2763101033,'Aries'],
  [2763101033,2763315413,'Taurus'],
  [2763315413,2763535096,'Gemini'],
  [2763535096,2763752337,'Cancer'],
  [2763752337,2763962615,'Leo'],
  [2763962615,2764164804,'Virgo'],
  [2764164804,2764359082,'Libra'],
  [2764359082,2764545829,'Scorpio'],
  [2764545829,2764726119,'Sagittarius'],
  [2764726119,2764902753,'Capricorn'],
  [2764902753,2765080628,'Aquarius'],
  [2765080628,2765265862,'Pisces'],
  [2765265862,2765463644,'Aries'],
  [2765463644,2765674886,'Taurus'],
  [2765674886,2765893868,'Gemini'],
  [2765893868,2766111126,'Cancer'],
  [2766111126,2766319956,'Leo'],
  [2766319956,2766519262,'Virgo'],
  [2766519262,2766711344,'Libra'],
  [2766711344,2766898719,'Scorpio'],
  [2766898719,2767082789,'Sagittarius'],
  [2767082789,2767264607,'Capricorn'],
  [2767264607,2767446534,'Aquarius'],
  [2767446534,2767632916,'Pisces'],
  [2767632916,2767828870,'Aries'],
  [2767828870,2768037262,'Taurus'],
  [2768037262,2768255049,'Gemini'],
  [2768255049,2768473156,'Cancer'],
  [2768473156,2768682501,'Leo'],
  [2768682501,2768879976,'Virgo'],
  [2768879976,2769068220,'Libra'],
  [2769068220,2769251924,'Scorpio'],
  [2769251924,2769434866,'Sagittarius'],
  [2769434866,2769618931,'Capricorn'],
  [2769618931,2769805139,'Aquarius'],
  [2769805139,2769995345,'Pisces'],
  [2769995345,2770192709,'Aries'],
  [2770192709,2770400097,'Taurus'],
  [2770400097,2770616752,'Gemini'],
  [2770616752,2770835950,'Cancer'],
  [2770835950,2771047970,'Leo'],
  [2771047970,2771246835,'Virgo'],
  [2771246835,2771433325,'Libra'],
  [2771433325,2771612517,'Scorpio'],
  [2771612517,2771790322,'Sagittarius'],
  [2771790322,2771971306,'Capricorn'],
  [2771971306,2772157926,'Aquarius'],
  [2772157926,2772351185,'Pisces'],
  [2772351185,2772551784,'Aries'],
  [2772551784,2772760475,'Taurus'],
  [2772760475,2772976759,'Gemini'],
  [2772976759,2773196497,'Cancer'],
  [2773196497,2773411805,'Leo'],
  [2773411805,2773615162,'Virgo'],
  [2773615162,2773804215,'Libra'],
  [2773804215,2773982210,'Scorpio'],
  [2773982210,2774155299,'Sagittarius'],
  [2774155299,2774330050,'Capricorn'],
  [2774330050,2774511832,'Aquarius'],
  [2774511832,2774703691,'Pisces'],
  [2774703691,2774905972,'Aries'],
  [2774905972,2775116949,'Taurus'],
  [2775116949,2775333978,'Gemini'],
  [2775333978,2775553562,'Cancer'],
  [2775553562,2775770572,'Leo'],
  [2775770572,2775978790,'Virgo'],
  [2775978790,2776173796,'Libra'],
  [2776173796,2776355607,'Scorpio'],
  [2776355607,2776528437,'Sagittarius'],
  [2776528437,2776698868,'Capricorn'],
  [2776698868,2776874037,'Aquarius'],
  [2776874037,2777059968,'Pisces'],
  [2777059968,2777259540,'Aries'],
  [2777259540,2777471009,'Taurus'],
  [2777471009,2777689183,'Gemini'],
  [2777689183,2777908574,'Cancer'],
  [2777908574,2778125067,'Leo'],
  [2778125067,2778335224,'Virgo'],
  [2778335224,2778535608,'Libra'],
  [2778535608,2778724136,'Scorpio'],
  [2778724136,2778901805,'Sagittarius'],
  [2778901805,2779073111,'Capricorn'],
  [2779073111,2779244915,'Aquarius'],
  [2779244915,2779424692,'Pisces'],
  [2779424692,2779618257,'Aries'],
  [2779618257,2779826659,'Taurus'],
  [2779826659,2780044688,'Gemini'],
  [2780044688,2780264223,'Cancer'],
  [2780264223,2780479428,'Leo'],
  [2780479428,2780688157,'Virgo'],
  [2780688157,2780889678,'Libra'],
  [2780889678,2781082931,'Scorpio'],
  [2781082931,2781267179,'Sagittarius'],
  [2781267179,2781443869,'Capricorn'],
  [2781443869,2781617621,'Aquarius'],
  [2781617621,2781795278,'Pisces'],
  [2781795278,2781983817,'Aries'],
  [2781983817,2782187202,'Taurus'],
  [2782187202,2782402926,'Gemini'],
  [2782402926,2782622442,'Cancer'],
  [2782622442,2782837196,'Leo'],
  [2782837196,2783043663,'Virgo'],
  [2783043663,2783242540,'Libra'],
  [2783242540,2783435388,'Scorpio'],
  [2783435388,2783622807,'Sagittarius'],
  [2783622807,2783805095,'Capricorn'],
  [2783805095,2783984171,'Aquarius'],
  [2783984171,2784164497,'Pisces'],
  [2784164497,2784352077,'Aries'],
  [2784352077,2784551927,'Taurus'],
  [2784551927,2784764459,'Gemini'],
  [2784764459,2784983323,'Cancer'],
  [2784983323,2785198831,'Leo'],
  [2785198831,2785404726,'Virgo'],
  [2785404726,2785600668,'Libra'],
  [2785600668,2785789670,'Scorpio'],
  [2785789670,2785974915,'Sagittarius'],
  [2785974915,2786158409,'Capricorn'],
  [2786158409,2786341567,'Aquarius'],
  [2786341567,2786526587,'Pisces'],
  [2786526587,2786717010,'Aries'],
  [2786717010,2786916703,'Taurus'],
  [2786916703,2787127266,'Gemini'],
  [2787127266,2787345180,'Cancer'],
  [2787345180,2787562079,'Leo'],
  [2787562079,2787769809,'Virgo'],
  [2787769809,2787965420,'Libra'],
  [2787965420,2788151162,'Scorpio'],
  [2788151162,2788331627,'Sagittarius'],
  [2788331627,2788511368,'Capricorn'],
  [2788511368,2788693816,'Aquarius'],
  [2788693816,2788881259,'Pisces'],
  [2788881259,2789075361,'Aries'],
  [2789075361,2789277519,'Taurus'],
  [2789277519,2789488295,'Gemini'],
  [2789488295,2789705665,'Cancer'],
  [2789705665,2789923809,'Leo'],
  [2789923809,2790134851,'Virgo'],
  [2790134851,2790333378,'Libra'],
  [2790333378,2790519230,'Scorpio'],
  [2790519230,2790696427,'Sagittarius'],
  [2790696427,2790870851,'Capricorn'],
  [2790870851,2791048380,'Aquarius'],
  [2791048380,2791233550,'Pisces'],
  [2791233550,2791428591,'Aries'],
  [2791428591,2791633252,'Taurus'],
  [2791633252,2791845710,'Gemini'],
  [2791845710,2792063292,'Cancer'],
  [2792063292,2792282003,'Leo'],
  [2792282003,2792496046,'Virgo'],
  [2792496046,2792699356,'Libra'],
  [2792699356,2792889037,'Scorpio'],
  [2792889037,2793066887,'Sagittarius'],
  [2793066887,2793238328,'Capricorn'],
  [2793238328,2793410417,'Aquarius'],
  [2793410417,2793589997,'Pisces'],
  [2793589997,2793781735,'Aries'],
  [2793781735,2793986229,'Taurus'],
  [2793986229,2794200043,'Gemini'],
  [2794200043,2794418321,'Cancer'],
  [2794418321,2794636935,'Leo'],
  [2794636935,2794852156,'Virgo'],
  [2794852156,2795059499,'Libra'],
  [2795059499,2795254864,'Scorpio'],
  [2795254864,2795437249,'Sagittarius'],
  [2795437249,2795609981,'Capricorn'],
  [2795609981,2795779636,'Aquarius'],
  [2795779636,2795954016,'Pisces'],
  [2795954016,2796140016,'Aries'],
  [2796140016,2796340839,'Taurus'],
  [2796340839,2796553903,'Gemini'],
  [2796553903,2796772603,'Cancer'],
  [2796772603,2796990871,'Leo'],
  [2796990871,2797205345,'Virgo'],
  [2797205345,2797413777,'Libra'],
  [2797413777,2797613356,'Scorpio'],
  [2797613356,2797801747,'Sagittarius'],
  [2797801747,2797979536,'Capricorn'],
  [2797979536,2798151212,'Aquarius'],
  [2798151212,2798323890,'Pisces'],
  [2798323890,2798505226,'Aries'],
  [2798505226,2798700733,'Taurus'],
  [2798700733,2798910532,'Gemini'],
  [2798910532,2799128545,'Cancer'],
  [2799128545,2799346633,'Leo'],
  [2799346633,2799559723,'Virgo'],
  [2799559723,2799766379,'Libra'],
  [2799766379,2799966178,'Scorpio'],
  [2799966178,2800158123,'Sagittarius'],
  [2800158123,2800341664,'Capricorn'],
  [2800341664,2800518699,'Aquarius'],
  [2800518699,2800694107,'Pisces'],
  [2800694107,2800874530,'Aries'],
  [2800874530,2801066178,'Taurus'],
  [2801066178,2801271731,'Gemini'],
  [2801271731,2801487727,'Cancer'],
  [2801487727,2801705860,'Leo'],
  [2801705860,2801918550,'Virgo'],
  [2801918550,2802122880,'Libra'],
  [2802122880,2802319570,'Scorpio'],
  [2802319570,2802510201,'Sagittarius'],
  [2802510201,2802695874,'Capricorn'],
  [2802695874,2802877804,'Aquarius'],
  [2802877804,2803058509,'Pisces'],
  [2803058509,2803242138,'Aries'],
  [2803242138,2803433572,'Taurus'],
  [2803433572,2803636336,'Gemini'],
  [2803636336,2803849813,'Cancer'],
  [2803849813,2804067907,'Leo'],
  [2804067907,2804281917,'Virgo'],
  [2804281917,2804486051,'Libra'],
  [2804486051,2804679749,'Scorpio'],
  [2804679749,2804865908,'Sagittarius'],
  [2804865908,2805048361,'Capricorn'],
  [2805048361,2805230413,'Aquarius'],
  [2805230413,2805414559,'Pisces'],
  [2805414559,2805602888,'Aries'],
  [2805602888,2805797549,'Taurus'],
  [2805797549,2806000578,'Gemini'],
  [2806000578,2806212504,'Cancer'],
  [2806212504,2806430222,'Leo'],
  [2806430222,2806646520,'Virgo'],
  [2806646520,2806853547,'Libra'],
  [2806853547,2807047677,'Scorpio'],
  [2807047677,2807230675,'Sagittarius'],
  [2807230675,2807407671,'Capricorn'],
  [2807407671,2807584678,'Aquarius'],
  [2807584678,2807766716,'Pisces'],
  [2807766716,2807956610,'Aries'],
  [2807956610,2808154822,'Taurus'],
  [2808154822,2808360555,'Gemini'],
  [2808360555,2808572890,'Cancer'],
  [2808572890,2808790181,'Leo'],
  [2808790181,2809008128,'Virgo'],
  [2809008128,2809219537,'Libra'],
  [2809219537,2809418093,'Scorpio'],
  [2809418093,2809602481,'Sagittarius'],
  [2809602481,2809776781,'Capricorn'],
  [2809776781,2809948067,'Aquarius'],
  [2809948067,2810123805,'Pisces'],
  [2810123805,2810309678,'Aries'],
  [2810309678,2810507588,'Taurus'],
  [2810507588,2810715434,'Gemini'],
  [2810715434,2810929528,'Cancer'],
  [2810929528,2811146950,'Leo'],
  [2811146950,2811365096,'Virgo'],
  [2811365096,2811579433,'Libra'],
  [2811579433,2811783690,'Scorpio'],
  [2811783690,2811973664,'Sagittarius'],
  [2811973664,2812150474,'Capricorn'],
  [2812150474,2812320085,'Aquarius'],
  [2812320085,2812490592,'Pisces'],
  [2812490592,2812669771,'Aries'],
  [2812669771,2812862581,'Taurus'],
  [2812862581,2813068833,'Gemini'],
  [2813068833,2813283786,'Cancer'],
  [2813283786,2813501864,'Leo'],
  [2813501864,2813719445,'Virgo'],
  [2813719445,2813933849,'Libra'],
  [2813933849,2814141204,'Scorpio'],
  [2814141204,2814337172,'Sagittarius'],
  [2814337172,2814520156,'Capricorn'],
  [2814520156,2814693312,'Aquarius'],
  [2814693312,2814863381,'Pisces'],
  [2814863381,2815038298,'Aries'],
  [2815038298,2815224873,'Taurus'],
  [2815224873,2815426063,'Gemini'],
  [2815426063,2815639136,'Cancer'],
  [2815639136,2815857382,'Leo'],
  [2815857382,2816074611,'Virgo'],
  [2816074611,2816287464,'Libra'],
  [2816287464,2816494037,'Scorpio'],
  [2816494037,2816692282,'Sagittarius'],
  [2816692282,2816880620,'Capricorn'],
  [2816880620,2817059897,'Aquarius'],
  [2817059897,2817234173,'Pisces'],
  [2817234173,2817409699,'Aries'],
  [2817409699,2817593119,'Taurus'],
  [2817593119,2817789214,'Gemini'],
  [2817789214,2817998361,'Cancer'],
  [2817998361,2818215481,'Leo'],
  [2818215481,2818432799,'Virgo'],
  [2818432799,2818644527,'Libra'],
  [2818644527,2818848477,'Scorpio'],
  [2818848477,2819044695,'Sagittarius'],
  [2819044695,2819233894,'Capricorn'],
  [2819233894,2819417249,'Aquarius'],
  [2819417249,2819597015,'Pisces'],
  [2819597015,2819776865,'Aries'],
  [2819776865,2819961515,'Taurus'],
  [2819961515,2820155507,'Gemini'],
  [2820155507,2820361168,'Cancer'],
  [2820361168,2820576305,'Leo'],
  [2820576305,2820793929,'Virgo'],
  [2820793929,2821006089,'Libra'],
  [2821006089,2821208416,'Scorpio'],
  [2821208416,2821401081,'Sagittarius'],
  [2821401081,2821586963,'Capricorn'],
  [2821586963,2821769542,'Aquarius'],
  [2821769542,2821951797,'Pisces'],
  [2821951797,2822136092,'Aries'],
  [2822136092,2822324672,'Taurus'],
  [2822324672,2822520082,'Gemini'],
  [2822520082,2822724572,'Cancer'],
  [2822724572,2822938076,'Leo'],
  [2822938076,2823156011,'Virgo'],
  [2823156011,2823370117,'Libra'],
  [2823370117,2823573425,'Scorpio'],
  [2823573425,2823764282,'Sagittarius'],
  [2823764282,2823945994,'Capricorn'],
  [2823945994,2824124129,'Aquarius'],
  [2824124129,2824304006,'Pisces'],
  [2824304006,2824489151,'Aries'],
  [2824489151,2824680918,'Taurus'],
  [2824680918,2824879505,'Gemini'],
  [2824879505,2825085262,'Cancer'],
  [2825085262,2825298365,'Leo'],
  [2825298365,2825516506,'Virgo'],
  [2825516506,2825733110,'Libra'],
  [2825733110,2825939880,'Scorpio'],
  [2825939880,2826132384,'Sagittarius'],
  [2826132384,2826312452,'Capricorn'],
  [2826312452,2826486165,'Aquarius'],
  [2826486165,2826660735,'Pisces'],
  [2826660735,2826842117,'Aries'],
  [2826842117,2827033247,'Taurus'],
  [2827033247,2827233747,'Gemini'],
  [2827233747,2827441731,'Cancer'],
  [2827441731,2827655680,'Leo'],
  [2827655680,2827873940,'Virgo'],
  [2827873940,2828092260,'Libra'],
  [2828092260,2828303260,'Scorpio'],
  [2828303260,2828500479,'Sagittarius'],
  [2828500479,2828682984,'Capricorn'],
  [2828682984,2828855561,'Aquarius'],
  [2828855561,2829025788,'Pisces'],
  [2829025788,2829201320,'Aries'],
  [2829201320,2829387680,'Taurus'],
  [2829387680,2829586413,'Gemini'],
  [2829586413,2829795232,'Cancer'],
  [2829795232,2830010400,'Leo'],
  [2830010400,2830228821,'Virgo'],
  [2830228821,2830447350,'Libra'],
  [2830447350,2830660916,'Scorpio'],
  [2830660916,2830863424,'Sagittarius'],
  [2830863424,2831051600,'Capricorn'],
  [2831051600,2831227519,'Aquarius'],
  [2831227519,2831397384,'Pisces'],
  [2831397384,2831568934,'Aries'],
  [2831568934,2831749290,'Taurus'],
  [2831749290,2831942806,'Gemini'],
  [2831942806,2832149329,'Cancer'],
  [2832149329,2832364654,'Leo'],
  [2832364654,2832583315,'Virgo'],
  [2832583315,2832801032,'Libra'],
  [2832801032,2833014276,'Scorpio'],
  [2833014276,2833219306,'Sagittarius'],
  [2833219306,2833413034,'Capricorn'],
  [2833413034,2833595213,'Aquarius'],
  [2833595213,2833769317,'Pisces'],
  [2833769317,2833941398,'Aries'],
  [2833941398,2834118380,'Taurus'],
  [2834118380,2834306252,'Gemini'],
  [2834306252,2834507888,'Cancer'],
  [2834507888,2834721224,'Leo'],
  [2834721224,2834939880,'Virgo'],
  [2834939880,2835156979,'Libra'],
  [2835156979,2835368200,'Scorpio'],
  [2835368200,2835571737,'Sagittarius'],
  [2835571737,2835766992,'Capricorn'],
  [2835766992,2835954099,'Aquarius'],
  [2835954099,2836134508,'Pisces'],
  [2836134508,2836311459,'Aries'],
  [2836311459,2836489806,'Taurus'],
  [2836489806,2836675145,'Gemini'],
  [2836675145,2836872118,'Cancer'],
  [2836872118,2837081825,'Leo'],
  [2837081825,2837299682,'Virgo'],
  [2837299682,2837517155,'Libra'],
  [2837517155,2837727181,'Scorpio'],
  [2837727181,2837927505,'Sagittarius'],
  [2837927505,2838119695,'Capricorn'],
  [2838119695,2838306533,'Aquarius'],
  [2838306533,2838490357,'Pisces'],
  [2838490357,2838672911,'Aries'],
  [2838672911,2838856228,'Taurus'],
  [2838856228,2839043537,'Gemini'],
  [2839043537,2839238974,'Cancer'],
  [2839238974,2839445551,'Leo'],
  [2839445551,2839661833,'Virgo'],
  [2839661833,2839880343,'Libra'],
  [2839880343,2840091606,'Scorpio'],
  [2840091606,2840290649,'Sagittarius'],
  [2840290649,2840478833,'Capricorn'],
  [2840478833,2840661056,'Aquarius'],
  [2840661056,2840842413,'Pisces'],
  [2840842413,2841026210,'Aries'],
  [2841026210,2841213681,'Taurus'],
  [2841213681,2841405422,'Gemini'],
  [2841405422,2841603051,'Cancer'],
  [2841603051,2841809008,'Leo'],
  [2841809008,2842023919,'Virgo'],
  [2842023919,2842243211,'Libra'],
  [2842243211,2842457538,'Scorpio'],
  [2842457538,2842658991,'Sagittarius'],
  [2842658991,2842846388,'Capricorn'],
  [2842846388,2843024459,'Aquarius'],
  [2843024459,2843200111,'Pisces'],
  [2843200111,2843379422,'Aries'],
  [2843379422,2843565823,'Taurus'],
  [2843565823,2843759859,'Gemini'],
  [2843759859,2843960865,'Cancer'],
  [2843960865,2844168731,'Leo'],
  [2844168731,2844383560,'Virgo'],
  [2844383560,2844602980,'Libra'],
  [2844602980,2844820099,'Scorpio'],
  [2844820099,2845026324,'Sagittarius'],
  [2845026324,2845217353,'Capricorn'],
  [2845217353,2845395566,'Aquarius'],
  [2845395566,2845567539,'Pisces'],
  [2845567539,2845740751,'Aries'],
  [2845740751,2845921329,'Taurus'],
  [2845921329,2846112463,'Gemini'],
  [2846112463,2846314053,'Cancer'],
  [2846314053,2846524027,'Leo'],
  [2846524027,2846740004,'Virgo'],
  [2846740004,2846959328,'Libra'],
  [2846959328,2847177403,'Scorpio'],
  [2847177403,2847387593,'Sagittarius'],
  [2847387593,2847584436,'Capricorn'],
  [2847584436,2847767285,'Aquarius'],
  [2847767285,2847940451,'Pisces'],
  [2847940451,2848110811,'Aries'],
  [2848110811,2848285546,'Taurus'],
  [2848285546,2848470435,'Gemini'],
  [2848470435,2848668230,'Cancer'],
  [2848668230,2848877724,'Leo'],
  [2848877724,2849094655,'Virgo'],
  [2849094655,2849314081,'Libra'],
  [2849314081,2849531513,'Scorpio'],
  [2849531513,2849742680,'Sagittarius'],
  [2849742680,2849943692,'Capricorn'],
  [2849943692,2850132641,'Aquarius'],
  [2850132641,2850311028,'Pisces'],
  [2850311028,2850483445,'Aries'],
  [2850483445,2850656229,'Taurus'],
  [2850656229,2850836009,'Gemini'],
  [2850836009,2851028028,'Cancer'],
  [2851028028,2851233921,'Leo'],
  [2851233921,2851450139,'Virgo'],
  [2851450139,2851669682,'Libra'],
  [2851669682,2851886113,'Scorpio'],
  [2851886113,2852095735,'Sagittarius'],
  [2852095735,2852297065,'Capricorn'],
  [2852297065,2852489568,'Aquarius'],
  [2852489568,2852673673,'Pisces'],
  [2852673673,2852851406,'Aries'],
  [2852851406,2853026782,'Taurus'],
  [2853026782,2853205438,'Gemini'],
  [2853205438,2853393383,'Cancer'],
  [2853393383,2853594701,'Leo'],
  [2853594701,2853808464,'Virgo'],
  [2853808464,2854027761,'Libra'],
  [2854027761,2854243842,'Scorpio'],
  [2854243842,2854451491,'Sagittarius'],
  [2854451491,2854650232,'Capricorn'],
  [2854650232,2854841918,'Aquarius'],
  [2854841918,2855028389,'Pisces'],
  [2855028389,2855210951,'Aries'],
  [2855210951,2855391314,'Taurus'],
  [2855391314,2855572784,'Gemini'],
  [2855572784,2855760299,'Cancer'],
  [2855760299,2855958736,'Leo'],
  [2855958736,2856169665,'Virgo'],
  [2856169665,2856388286,'Libra'],
  [2856388286,2856605034,'Scorpio'],
  [2856605034,2856812207,'Sagittarius'],
  [2856812207,2857008268,'Capricorn'],
  [2857008268,2857196327,'Aquarius'],
  [2857196327,2857380579,'Pisces'],
  [2857380579,2857563976,'Aries'],
  [2857563976,2857747942,'Taurus'],
  [2857747942,2857933755,'Gemini'],
  [2857933755,2858124032,'Cancer'],
  [2858124032,2858322541,'Leo'],
  [2858322541,2858531845,'Virgo'],
  [2858531845,2858749690,'Libra'],
  [2858749690,2858967816,'Scorpio'],
  [2858967816,2859176794,'Sagittarius'],
  [2859176794,2859372584,'Capricorn'],
  [2859372584,2859557580,'Aquarius'],
  [2859557580,2859737273,'Pisces'],
  [2859737273,2859916982,'Aries'],
  [2859916982,2860100116,'Taurus'],
  [2860100116,2860288130,'Gemini'],
  [2860288130,2860481887,'Cancer'],
  [2860481887,2860682814,'Leo'],
  [2860682814,2860892433,'Virgo'],
  [2860892433,2861109858,'Libra'],
  [2861109858,2861329293,'Scorpio'],
  [2861329293,2861541668,'Sagittarius'],
  [2861541668,2861740497,'Capricorn'],
  [2861740497,2861925752,'Aquarius'],
  [2861925752,2862102330,'Pisces'],
  [2862102330,2862276759,'Aries'],
  [2862276759,2862454862,'Taurus'],
  [2862454862,2862640449,'Gemini'],
  [2862640449,2862835014,'Cancer'],
  [2862835014,2863038424,'Leo'],
  [2863038424,2863249793,'Virgo'],
  [2863249793,2863467451,'Libra'],
  [2863467451,2863687413,'Scorpio'],
  [2863687413,2863902848,'Sagittarius'],
  [2863902848,2864106775,'Capricorn'],
  [2864106775,2864296312,'Aquarius'],
  [2864296312,2864473953,'Pisces'],
  [2864473953,2864645557,'Aries'],
  [2864645557,2864818012,'Taurus'],
  [2864818012,2864997582,'Gemini'],
  [2864997582,2865188451,'Cancer'],
  [2865188451,2865391515,'Leo'],
  [2865391515,2865604339,'Virgo'],
  [2865604339,2865822787,'Libra'],
  [2865822787,2866042498,'Scorpio'],
  [2866042498,2866258848,'Sagittarius'],
  [2866258848,2866466845,'Capricorn'],
  [2866466845,2866662610,'Aquarius'],
  [2866662610,2866845636,'Pisces'],
  [2866845636,2867019274,'Aries'],
  [2867019274,2867189559,'Taurus'],
  [2867189559,2867363633,'Gemini'],
  [2867363633,2867548111,'Cancer'],
  [2867548111,2867746861,'Leo'],
  [2867746861,2867958692,'Virgo'],
  [2867958692,2868177704,'Libra'],
  [2868177704,2868397088,'Scorpio'],
  [2868397088,2868612275,'Sagittarius'],
  [2868612275,2868820765,'Capricorn'],
  [2868820765,2869020543,'Aquarius'],
  [2869020543,2869210105,'Pisces'],
  [2869210105,2869389855,'Aries'],
  [2869389855,2869563166,'Taurus'],
  [2869563166,2869736060,'Gemini'],
  [2869736060,2869915776,'Cancer'],
  [2869915776,2870108573,'Leo'],
  [2870108573,2870316423,'Virgo'],
  [2870316423,2870534545,'Libra'],
  [2870534545,2870753981,'Scorpio'],
  [2870753981,2870967807,'Sagittarius'],
  [2870967807,2871173929,'Capricorn'],
  [2871173929,2871372937,'Aquarius'],
  [2871372937,2871565320,'Pisces'],
  [2871565320,2871750928,'Aries'],
  [2871750928,2871930465,'Taurus'],
  [2871930465,2872107176,'Gemini'],
  [2872107176,2872286836,'Cancer'],
  [2872286836,2872476049,'Leo'],
  [2872476049,2872679220,'Virgo'],
  [2872679220,2872894731,'Libra'],
  [2872894731,2873114202,'Scorpio'],
  [2873114202,2873328123,'Sagittarius'],
  [2873328123,2873532208,'Capricorn'],
  [2873532208,2873727637,'Aquarius'],
  [2873727637,2873917473,'Pisces'],
  [2873917473,2874103872,'Aries'],
  [2874103872,2874287676,'Taurus'],
  [2874287676,2874469989,'Gemini'],
  [2874469989,2874653790,'Cancer'],
  [2874653790,2874843856,'Leo'],
  [2874843856,2875044776,'Virgo'],
  [2875044776,2875257494,'Libra'],
  [2875257494,2875476483,'Scorpio'],
  [2875476483,2875691955,'Sagittarius'],
  [2875691955,2875896704,'Capricorn'],
  [2875896704,2876089933,'Aquarius'],
  [2876089933,2876275295,'Pisces'],
  [2876275295,2876457399,'Aries'],
  [2876457399,2876639698,'Taurus'],
  [2876639698,2876824167,'Gemini'],
  [2876824167,2877012309,'Cancer'],
  [2877012309,2877206200,'Leo'],
  [2877206200,2877408371,'Virgo'],
  [2877408371,2877620017,'Libra'],
  [2877620017,2877838274,'Scorpio'],
  [2877838274,2878055575,'Sagittarius'],
  [2878055575,2878263530,'Capricorn'],
  [2878263530,2878458297,'Aquarius'],
  [2878458297,2878641751,'Pisces'],
  [2878641751,2878818997,'Aries'],
  [2878818997,2878995755,'Taurus'],
  [2878995755,2879176754,'Gemini'],
  [2879176754,2879364985,'Cancer'],
  [2879364985,2879561667,'Leo'],
  [2879561667,2879766775,'Virgo'],
  [2879766775,2879979480,'Libra'],
  [2879979480,2880197463,'Scorpio'],
  [2880197463,2880415790,'Sagittarius'],
  [2880415790,2880627469,'Capricorn'],
  [2880627469,2880826806,'Aquarius'],
  [2880826806,2881012695,'Pisces'],
  [2881012695,2881188608,'Aries'],
  [2881188608,2881360651,'Taurus'],
  [2881360651,2881535559,'Gemini'],
  [2881535559,2881719065,'Cancer'],
  [2881719065,2881914300,'Leo'],
  [2881914300,2882120773,'Virgo'],
  [2882120773,2882335226,'Libra'],
  [2882335226,2882553634,'Scorpio'],
  [2882553634,2882772000,'Sagittarius'],
  [2882772000,2882985798,'Capricorn'],
  [2882985798,2883189985,'Aquarius'],
  [2883189985,2883381298,'Pisces'],
  [2883381298,2883560375,'Aries'],
  [2883560375,2883731803,'Taurus'],
  [2883731803,2883902548,'Gemini'],
  [2883902548,2884080052,'Cancer'],
  [2884080052,2884270131,'Leo'],
  [2884270131,2884474410,'Virgo'],
  [2884474410,2884689217,'Libra'],
  [2884689217,2884908205,'Scorpio'],
  [2884908205,2885126126,'Sagittarius'],
  [2885126126,2885339771,'Capricorn'],
  [2885339771,2885546337,'Aquarius'],
  [2885546337,2885742798,'Pisces'],
  [2885742798,2885927633,'Aries'],
  [2885927633,2886102756,'Taurus'],
  [2886102756,2886273649,'Gemini'],
  [2886273649,2886447765,'Cancer'],
  [2886447765,2886632410,'Leo'],
  [2886632410,2886831903,'Virgo'],
  [2886831903,2887044620,'Libra'],
  [2887044620,2887263509,'Scorpio'],
  [2887263509,2887481056,'Sagittarius'],
  [2887481056,2887693272,'Capricorn'],
  [2887693272,2887898986,'Aquarius'],
  [2887898986,2888097288,'Pisces'],
  [2888097288,2888286863,'Aries'],
  [2888286863,2888467645,'Taurus'],
  [2888467645,2888642589,'Gemini'],
  [2888642589,2888817554,'Cancer'],
  [2888817554,2888999638,'Leo'],
  [2888999638,2889194638,'Virgo'],
  [2889194638,2889403685,'Libra'],
  [2889403685,2889621375,'Scorpio'],
  [2889621375,2889838904,'Sagittarius'],
  [2889838904,2890050045,'Capricorn'],
  [2890050045,2890253295,'Aquarius'],
  [2890253295,2890449618,'Pisces'],
  [2890449618,2890639875,'Aries'],
  [2890639875,2890824433,'Taurus'],
  [2890824433,2891004577,'Gemini'],
  [2891004577,2891183729,'Cancer'],
  [2891183729,2891367179,'Leo'],
  [2891367179,2891560404,'Virgo'],
  [2891560404,2891766247,'Libra'],
  [2891766247,2891982042,'Scorpio'],
  [2891982042,2892199868,'Sagittarius'],
  [2892199868,2892411477,'Capricorn'],
  [2892411477,2892613214,'Aquarius'],
  [2892613214,2892806076,'Pisces'],
  [2892806076,2892992976,'Aries'],
  [2892992976,2893176639,'Taurus'],
  [2893176639,2893359167,'Gemini'],
  [2893359167,2893542719,'Cancer'],
  [2893542719,2893730181,'Leo'],
  [2893730181,2893924993,'Virgo'],
  [2893924993,2894129782,'Libra'],
  [2894129782,2894343965,'Scorpio'],
  [2894343965,2894562127,'Sagittarius'],
  [2894562127,2894775863,'Capricorn'],
  [2894775863,2894978854,'Aquarius'],
  [2894978854,2895170080,'Pisces'],
  [2895170080,2895352719,'Aries'],
  [2895352719,2895531627,'Taurus'],
  [2895531627,2895711470,'Gemini'],
  [2895711470,2895895726,'Cancer'],
  [2895895726,2896086469,'Leo'],
  [2896086469,2896284727,'Virgo'],
  [2896284727,2896490966,'Libra'],
  [2896490966,2896704708,'Scorpio'],
  [2896704708,2896922962,'Sagittarius'],
  [2896922962,2897139341,'Capricorn'],
  [2897139341,2897346321,'Aquarius'],
  [2897346321,2897539810,'Pisces'],
  [2897539810,2897721090,'Aries'],
  [2897721090,2897895354,'Taurus'],
  [2897895354,2898069308,'Gemini'],
  [2898069308,2898249149,'Cancer'],
  [2898249149,2898438843,'Leo'],
  [2898438843,2898639045,'Virgo'],
  [2898639045,2898847795,'Libra'],
  [2898847795,2899062496,'Scorpio'],
  [2899062496,2899280660,'Sagittarius'],
  [2899280660,2899498534,'Capricorn'],
  [2899498534,2899710017,'Aquarius'],
  [2899710017,2899909079,'Pisces'],
  [2899909079,2900093756,'Aries'],
  [2900093756,2900267413,'Taurus'],
  [2900267413,2900436957,'Gemini'],
  [2900436957,2900610331,'Cancer'],
  [2900610331,2900794306,'Leo'],
  [2900794306,2900991982,'Virgo'],
  [2900991982,2901201385,'Libra'],
  [2901201385,2901417485,'Scorpio'],
  [2901417485,2901635805,'Sagittarius'],
  [2901635805,2901853448,'Capricorn'],
  [2901853448,2902067014,'Aquarius'],
  [2902067014,2902271494,'Pisces'],
  [2902271494,2902462753,'Aries'],
  [2902462753,2902640923,'Taurus'],
  [2902640923,2902811024,'Gemini'],
  [2902811024,2902980834,'Cancer'],
  [2902980834,2903158484,'Leo'],
  [2903158484,2903349948,'Virgo'],
  [2903349948,2903556086,'Libra'],
  [2903556086,2903772011,'Scorpio'],
  [2903772011,2903990732,'Sagittarius'],
  [2903990732,2904207507,'Capricorn'],
  [2904207507,2904420070,'Aquarius'],
  [2904420070,2904626115,'Pisces'],
  [2904626115,2904822524,'Aries'],
  [2904822524,2905007492,'Taurus'],
  [2905007492,2905182963,'Gemini'],
  [2905182963,2905354596,'Cancer'],
  [2905354596,2905529866,'Leo'],
  [2905529866,2905715822,'Virgo'],
  [2905715822,2905916299,'Libra'],
  [2905916299,2906129333,'Scorpio'],
  [2906129333,2906347832,'Sagittarius'],
  [2906347832,2906564354,'Capricorn'],
  [2906564354,2906775000,'Aquarius'],
  [2906775000,2906978779,'Pisces'],
  [2906978779,2907175312,'Aries'],
  [2907175312,2907364101,'Taurus'],
  [2907364101,2907545713,'Gemini'],
  [2907545713,2907723007,'Cancer'],
  [2907723007,2907901032,'Leo'],
  [2907901032,2908085763,'Virgo'],
  [2908085763,2908282048,'Libra'],
  [2908282048,2908490973,'Scorpio'],
  [2908490973,2908708040,'Sagittarius'],
  [2908708040,2908925037,'Capricorn'],
  [2908925037,2909135210,'Aquarius'],
  [2909135210,2909336223,'Pisces'],
  [2909336223,2909529140,'Aries'],
  [2909529140,2909716216,'Taurus'],
  [2909716216,2909899682,'Gemini'],
  [2909899682,2910081724,'Cancer'],
  [2910081724,2910264969,'Leo'],
  [2910264969,2910452768,'Virgo'],
  [2910452768,2910648705,'Libra'],
  [2910648705,2910855004,'Scorpio'],
  [2910855004,2911070161,'Sagittarius'],
  [2911070161,2911287791,'Capricorn'],
  [2911287791,2911499541,'Aquarius'],
  [2911499541,2911700233,'Pisces'],
  [2911700233,2911889922,'Aries'],
  [2911889922,2912072348,'Taurus'],
  [2912072348,2912252384,'Gemini'],
  [2912252384,2912434196,'Cancer'],
  [2912434196,2912620428,'Leo'],
  [2912620428,2912812410,'Virgo'],
  [2912812410,2913011109,'Libra'],
  [2913011109,2913217564,'Scorpio'],
  [2913217564,2913431626,'Sagittarius'],
  [2913431626,2913649648,'Capricorn'],
  [2913649648,2913864087,'Aquarius'],
  [2913864087,2914067493,'Pisces'],
  [2914067493,2914257274,'Aries'],
  [2914257274,2914436471,'Taurus'],
  [2914436471,2914611312,'Gemini'],
  [2914611312,2914788400,'Cancer'],
  [2914788400,2914972622,'Leo'],
  [2914972622,2915165881,'Virgo'],
  [2915165881,2915367464,'Libra'],
  [2915367464,2915575952,'Scorpio'],
  [2915575952,2915790294,'Sagittarius'],
  [2915790294,2916008449,'Capricorn'],
  [2916008449,2916225183,'Aquarius'],
  [2916225183,2916432889,'Pisces'],
  [2916432889,2916626349,'Aries'],
  [2916626349,2916806238,'Taurus'],
  [2916806238,2916978241,'Gemini'],
  [2916978241,2917150042,'Cancer'],
  [2917150042,2917328763,'Leo'],
  [2917328763,2917518778,'Virgo'],
  [2917518778,2917720301,'Libra'],
  [2917720301,2917930436,'Scorpio'],
  [2917930436,2918145877,'Sagittarius'],
  [2918145877,2918364083,'Capricorn'],
  [2918364083,2918581659,'Aquarius'],
  [2918581659,2918792841,'Pisces'],
  [2918792841,2918991612,'Aries'],
  [2918991612,2919175941,'Taurus'],
  [2919175941,2919349360,'Gemini'],
  [2919349360,2919518944,'Cancer'],
  [2919518944,2919692608,'Leo'],
  [2919692608,2919876875,'Virgo'],
  [2919876875,2920074599,'Libra'],
  [2920074599,2920283927,'Scorpio'],
  [2920283927,2920500052,'Sagittarius'],
  [2920500052,2920718348,'Capricorn'],
  [2920718348,2920935381,'Aquarius'],
  [2920935381,2921147438,'Pisces'],
  [2921147438,2921350047,'Aries'],
  [2921350047,2921540116,'Taurus'],
  [2921540116,2921718547,'Gemini'],
  [2921718547,2921890291,'Cancer'],
  [2921890291,2922062426,'Leo'],
  [2922062426,2922242094,'Virgo'],
  [2922242094,2922434378,'Libra'],
  [2922434378,2922640142,'Scorpio'],
  [2922640142,2922855422,'Sagittarius'],
  [2922855422,2923073773,'Capricorn'],
  [2923073773,2923289853,'Aquarius'],
  [2923289853,2923500396,'Pisces'],
  [2923500396,2923703217,'Aries'],
  [2923703217,2923896704,'Taurus'],
  [2923896704,2924080762,'Gemini'],
  [2924080762,2924257848,'Cancer'],
  [2924257848,2924432766,'Leo'],
  [2924432766,2924611556,'Virgo'],
  [2924611556,2924799930,'Libra'],
  [2924799930,2925001176,'Scorpio'],
  [2925001176,2925213977,'Sagittarius'],
  [2925213977,2925432113,'Capricorn'],
  [2925432113,2925647933,'Aquarius'],
  [2925647933,2925856508,'Pisces'],
  [2925856508,2926056572,'Aries'],
  [2926056572,2926249018,'Taurus'],
  [2926249018,2926435362,'Gemini'],
  [2926435362,2926617406,'Cancer'],
  [2926617406,2926797627,'Leo'],
  [2926797627,2926979572,'Virgo'],
  [2926979572,2927167660,'Libra'],
  [2927167660,2927365962,'Scorpio'],
  [2927365962,2927575804,'Sagittarius'],
  [2927575804,2927793288,'Capricorn'],
  [2927793288,2928010031,'Aquarius'],
  [2928010031,2928218364,'Pisces'],
  [2928218364,2928415662,'Aries'],
  [2928415662,2928604064,'Taurus'],
  [2928604064,2928787695,'Gemini'],
  [2928787695,2928970290,'Cancer'],
  [2928970290,2929154225,'Leo'],
  [2929154225,2929340947,'Virgo'],
  [2929340947,2929532223,'Libra'],
  [2929532223,2929730740,'Scorpio'],
  [2929730740,2929938821,'Sagittarius'],
  [2929938821,2930155382,'Capricorn'],
  [2930155382,2930373727,'Aquarius'],
  [2930373727,2930584446,'Pisces'],
  [2930584446,2930781941,'Aries'],
  [2930781941,2930967261,'Taurus'],
  [2930967261,2931145809,'Gemini'],
  [2931145809,2931323893,'Cancer'],
  [2931323893,2931506270,'Leo'],
  [2931506270,2931694973,'Virgo'],
  [2931694973,2931890011,'Libra'],
  [2931890011,2932091366,'Scorpio'],
  [2932091366,2932299941,'Sagittarius'],
  [2932299941,2932515902,'Capricorn'],
  [2932515902,2932735405,'Aquarius'],
  [2932735405,2932949933,'Pisces'],
  [2932949933,2933151379,'Aries'],
  [2933151379,2933337794,'Taurus'],
  [2933337794,2933513587,'Gemini'],
  [2933513587,2933686083,'Cancer'],
  [2933686083,2933862450,'Leo'],
  [2933862450,2934047541,'Virgo'],
  [2934047541,2934242663,'Libra'],
  [2934242663,2934446462,'Scorpio'],
  [2934446462,2934657139,'Sagittarius'],
  [2934657139,2934873462,'Capricorn'],
  [2934873462,2935093123,'Aquarius'],
  [2935093123,2935310343,'Pisces'],
  [2935310343,2935517238,'Aries'],
  [2935517238,2935708998,'Taurus'],
  [2935708998,2935887102,'Gemini'],
  [2935887102,2936057743,'Cancer'],
  [2936057743,2936228685,'Leo'],
  [2936228685,2936406975,'Virgo'],
  [2936406975,2936597038,'Libra'],
  [2936597038,2936799398,'Scorpio'],
  [2936799398,2937011257,'Sagittarius'],
  [2937011257,2937228660,'Capricorn'],
  [2937228660,2937448058,'Aquarius'],
  [2937448058,2937665463,'Pisces'],
  [2937665463,2937875573,'Aries'],
  [2937875573,2938073482,'Taurus'],
  [2938073482,2938257862,'Gemini'],
  [2938257862,2938432018,'Cancer'],
  [2938432018,2938602272,'Leo'],
  [2938602272,2938775867,'Virgo'],
  [2938775867,2938959243,'Libra'],
  [2938959243,2939156157,'Scorpio'],
  [2939156157,2939365954,'Sagittarius'],
  [2939365954,2939583692,'Capricorn'],
  [2939583692,2939803087,'Aquarius'],
  [2939803087,2940019221,'Pisces'],
  [2940019221,2940228796,'Aries'],
  [2940228796,2940429360,'Taurus'],
  [2940429360,2940619554,'Gemini'],
  [2940619554,2940800218,'Cancer'],
  [2940800218,2940974800,'Leo'],
  [2940974800,2941148784,'Virgo'],
  [2941148784,2941328541,'Libra'],
  [2941328541,2941519727,'Scorpio'],
  [2941519727,2941724879,'Sagittarius'],
  [2941724879,2941941013,'Capricorn'],
  [2941941013,2942160474,'Aquarius'],
  [2942160474,2942375707,'Pisces'],
  [2942375707,2942582903,'Aries'],
  [2942582903,2942781753,'Taurus'],
  [2942781753,2942973257,'Gemini'],
  [2942973257,2943158549,'Cancer'],
  [2943158549,2943339112,'Leo'],
  [2943339112,2943517646,'Virgo'],
  [2943517646,2943698568,'Libra'],
  [2943698568,2943887320,'Scorpio'],
  [2943887320,2944088294,'Sagittarius'],
  [2944088294,2944301532,'Capricorn'],
  [2944301532,2944520665,'Aquarius'],
  [2944520665,2944736210,'Pisces'],
  [2944736210,2944941957,'Aries'],
  [2944941957,2945137517,'Taurus'],
  [2945137517,2945326014,'Gemini'],
  [2945326014,2945510912,'Cancer'],
  [2945510912,2945694433,'Leo'],
  [2945694433,2945877852,'Virgo'],
  [2945877852,2946063007,'Libra'],
  [2946063007,2946253320,'Scorpio'],
  [2946253320,2946452934,'Sagittarius'],
  [2946452934,2946663820,'Capricorn'],
  [2946663820,2946882288,'Aquarius'],
  [2946882288,2947099148,'Pisces'],
  [2947099148,2947305782,'Aries'],
  [2947305782,2947499750,'Taurus'],
  [2947499750,2947684373,'Gemini'],
  [2947684373,2947865099,'Cancer'],
  [2947865099,2948046526,'Leo'],
  [2948046526,2948231123,'Virgo'],
  [2948231123,2948419810,'Libra'],
  [2948419810,2948613674,'Scorpio'],
  [2948613674,2948814845,'Sagittarius'],
  [2948814845,2949025192,'Capricorn'],
  [2949025192,2949243119,'Aquarius'],
  [2949243119,2949461544,'Pisces'],
  [2949461544,2949671115,'Aries'],
  [2949671115,2949866717,'Taurus'],
  [2949866717,2950049959,'Gemini'],
  [2950049959,2950226545,'Cancer'],
  [2950226545,2950402893,'Leo'],
  [2950402893,2950583941,'Virgo'],
  [2950583941,2950772200,'Libra'],
  [2950772200,2950968258,'Scorpio'],
  [2950968258,2951172079,'Sagittarius'],
  [2951172079,2951383604,'Capricorn'],
  [2951383604,2951601497,'Aquarius'],
  [2951601497,2951820917,'Pisces'],
  [2951820917,2952033922,'Aries'],
  [2952033922,2952233839,'Taurus'],
  [2952233839,2952419541,'Gemini'],
  [2952419541,2952595197,'Cancer'],
  [2952595197,2952767407,'Leo'],
  [2952767407,2952942799,'Virgo'],
  [2952942799,2953126457,'Libra'],
  [2953126457,2953320871,'Scorpio'],
  [2953320871,2953525764,'Sagittarius'],
  [2953525764,2953738919,'Capricorn'],
  [2953738919,2953957295,'Aquarius'],
  [2953957295,2954176802,'Pisces'],
  [2954176802,2954391815,'Aries'],
  [2954391815,2954596436,'Taurus'],
  [2954596436,2954787500,'Gemini'],
  [2954787500,2954966447,'Cancer'],
  [2954966447,2955138323,'Leo'],
  [2955138323,2955309819,'Virgo'],
  [2955309819,2955487641,'Libra'],
  [2955487641,2955676946,'Scorpio'],
  [2955676946,2955879565,'Sagittarius'],
  [2955879565,2956093020,'Capricorn'],
  [2956093020,2956311984,'Aquarius'],
  [2956311984,2956531018,'Pisces'],
  [2956531018,2956745760,'Aries'],
  [2956745760,2956952663,'Taurus'],
  [2956952663,2957148955,'Gemini'],
  [2957148955,2957333917,'Cancer'],
  [2957333917,2957509826,'Leo'],
  [2957509826,2957681686,'Virgo'],
  [2957681686,2957856126,'Libra'],
  [2957856126,2958039882,'Scorpio'],
  [2958039882,2958237568,'Sagittarius'],
  [2958237568,2958448864,'Capricorn'],
  [2958448864,2958667800,'Aquarius'],
  [2958667800,2958886484,'Pisces'],
  [2958886484,2959099613,'Aries'],
  [2959099613,2959305350,'Taurus'],
  [2959305350,2959503314,'Gemini'],
  [2959503314,2959693191,'Cancer'],
  [2959693191,2959875260,'Leo'],
  [2959875260,2960051712,'Virgo'],
  [2960051712,2960227287,'Libra'],
  [2960227287,2960408453,'Scorpio'],
  [2960408453,2960601397,'Sagittarius'],
  [2960601397,2960808740,'Capricorn'],
  [2960808740,2961026437,'Aquarius'],
  [2961026437,2961245291,'Pisces'],
  [2961245291,2961457406,'Aries'],
  [2961457406,2961660380,'Taurus'],
  [2961660380,2961855806,'Gemini'],
  [2961855806,2962045882,'Cancer'],
  [2962045882,2962231685,'Leo'],
  [2962231685,2962413806,'Virgo'],
  [2962413806,2962594218,'Libra'],
  [2962594218,2962777240,'Scorpio'],
  [2962777240,2962968554,'Sagittarius'],
  [2962968554,2963172455,'Capricorn'],
  [2963172455,2963387966,'Aquarius'],
  [2963387966,2963607224,'Pisces'],
  [2963607224,2963820260,'Aries'],
  [2963820260,2964022025,'Taurus'],
  [2964022025,2964213782,'Gemini'],
  [2964213782,2964399728,'Cancer'],
  [2964399728,2964583659,'Leo'],
  [2964583659,2964767586,'Virgo'],
  [2964767586,2964952495,'Libra'],
  [2964952495,2965140118,'Scorpio'],
  [2965140118,2965333710,'Sagittarius'],
  [2965333710,2965536883,'Capricorn'],
  [2965536883,2965750564,'Aquarius'],
  [2965750564,2965969898,'Pisces'],
  [2965969898,2966185396,'Aries'],
  [2966185396,2966389272,'Taurus'],
  [2966389272,2966580186,'Gemini'],
  [2966580186,2966762038,'Cancer'],
  [2966762038,2966940471,'Leo'],
  [2966940471,2967120366,'Virgo'],
  [2967120366,2967304781,'Libra'],
  [2967304781,2967495212,'Scorpio'],
  [2967495212,2967692608,'Sagittarius'],
  [2967692608,2967897948,'Capricorn'],
  [2967897948,2968111484,'Aquarius'],
  [2968111484,2968330537,'Pisces'],
  [2968330537,2968548315,'Aries'],
  [2968548315,2968756621,'Taurus'],
  [2968756621,2968951000,'Gemini'],
  [2968951000,2969132820,'Cancer'],
  [2969132820,2969307321,'Leo'],
  [2969307321,2969480984,'Virgo'],
  [2969480984,2969659711,'Libra'],
  [2969659711,2969847566,'Scorpio'],
  [2969847566,2970045983,'Sagittarius'],
  [2970045983,2970253909,'Capricorn'],
  [2970253909,2970468933,'Aquarius'],
  [2970468933,2970687932,'Pisces'],
  [2970687932,2970906483,'Aries'],
  [2970906483,2971118608,'Taurus'],
  [2971118608,2971318804,'Gemini'],
  [2971318804,2971505254,'Cancer'],
  [2971505254,2971680719,'Leo'],
  [2971680719,2971851139,'Virgo'],
  [2971851139,2972023698,'Libra'],
  [2972023698,2972205108,'Scorpio'],
  [2972205108,2972399650,'Sagittarius'],
  [2972399650,2972607231,'Capricorn'],
  [2972607231,2972823551,'Aquarius'],
  [2972823551,2973043001,'Pisces'],
  [2973043001,2973261089,'Aries'],
  [2973261089,2973474271,'Taurus'],
  [2973474271,2973678794,'Gemini'],
  [2973678794,2973871598,'Cancer'],
  [2973871598,2974052405,'Leo'],
  [2974052405,2974224737,'Virgo'],
  [2974224737,2974395068,'Libra'],
  [2974395068,2974571030,'Scorpio'],
  [2974571030,2974759324,'Sagittarius'],
  [2974759324,2974962809,'Capricorn'],
  [2974962809,2975178199,'Aquarius'],
  [2975178199,2975397953,'Pisces'],
  [2975397953,2975615401,'Aries'],
  [2975615401,2975827336,'Taurus'],
  [2975827336,2976032402,'Gemini'],
  [2976032402,2976229047,'Cancer'],
  [2976229047,2976415919,'Leo'],
  [2976415919,2976593788,'Virgo'],
  [2976593788,2976766775,'Libra'],
  [2976766775,2976941567,'Scorpio'],
  [2976941567,2977125484,'Sagittarius'],
  [2977125484,2977323713,'Capricorn'],
  [2977323713,2977535843,'Aquarius'],
  [2977535843,2977754932,'Pisces'],
  [2977754932,2977972165,'Aries'],
  [2977972165,2978182517,'Taurus'],
  [2978182517,2978385337,'Gemini'],
  [2978385337,2978581420,'Cancer'],
  [2978581420,2978770956,'Leo'],
  [2978770956,2978953993,'Virgo'],
  [2978953993,2979132268,'Libra'],
  [2979132268,2979310142,'Scorpio'],
  [2979310142,2979493744,'Sagittarius'],
  [2979493744,2979688775,'Capricorn'],
  [2979688775,2979897230,'Aquarius'],
  [2979897230,2980114703,'Pisces'],
  [2980114703,2980332175,'Aries'],
  [2980332175,2980542210,'Taurus'],
  [2980542210,2980742733,'Gemini'],
  [2980742733,2980935510,'Cancer'],
  [2980935510,2981123088,'Leo'],
  [2981123088,2981307248,'Virgo'],
  [2981307248,2981489438,'Libra'],
  [2981489438,2981672007,'Scorpio'],
  [2981672007,2981858736,'Sagittarius'],
  [2981858736,2982053981,'Capricorn'],
  [2982053981,2982260421,'Aquarius'],
  [2982260421,2982476186,'Pisces'],
  [2982476186,2982694120,'Aries'],
  [2982694120,2982905606,'Taurus'],
  [2982905606,2983106009,'Gemini'],
  [2983106009,2983296026,'Cancer'],
  [2983296026,2983479335,'Leo'],
  [2983479335,2983660112,'Virgo'],
  [2983660112,2983841771,'Libra'],
  [2983841771,2984026844,'Scorpio'],
  [2984026844,2984217414,'Sagittarius'],
  [2984217414,2984415432,'Capricorn'],
  [2984415432,2984622286,'Aquarius'],
  [2984622286,2984837183,'Pisces'],
  [2984837183,2985055509,'Aries'],
  [2985055509,2985269579,'Taurus'],
  [2985269579,2985472700,'Gemini'],
  [2985472700,2985663011,'Cancer'],
  [2985663011,2985843376,'Leo'],
  [2985843376,2986019163,'Virgo'],
  [2986019163,2986196171,'Libra'],
  [2986196171,2986379150,'Scorpio'],
  [2986379150,2986570820,'Sagittarius'],
  [2986570820,2986771637,'Capricorn'],
  [2986771637,2986980553,'Aquarius'],
  [2986980553,2987195778,'Pisces'],
  [2987195778,2987414236,'Aries'],
  [2987414236,2987630593,'Taurus'],
  [2987630593,2987838128,'Gemini'],
  [2987838128,2988032346,'Cancer'],
  [2988032346,2988213611,'Leo'],
  [2988213611,2988386614,'Virgo'],
  [2988386614,2988558272,'Libra'],
  [2988558272,2988735642,'Scorpio'],
  [2988735642,2988923939,'Sagittarius'],
  [2988923939,2989124638,'Capricorn'],
  [2989124638,2989335242,'Aquarius'],
  [2989335242,2989551576,'Pisces'],
  [2989551576,2989769987,'Aries'],
  [2989769987,2989987076,'Taurus'],
  [2989987076,2990198179,'Gemini'],
  [2990198179,2990398098,'Cancer'],
  [2990398098,2990584304,'Leo'],
  [2990584304,2990759028,'Virgo'],
  [2990759028,2990928477,'Libra'],
  [2990928477,2991100579,'Scorpio'],
  [2991100579,2991282774,'Sagittarius'],
  [2991282774,2991479335,'Capricorn'],
  [2991479335,2991689009,'Aquarius'],
  [2991689009,2991906070,'Pisces'],
  [2991906070,2992124536,'Aries'],
  [2992124536,2992340843,'Taurus'],
  [2992340843,2992552556,'Gemini'],
  [2992552556,2992756354,'Cancer'],
  [2992756354,2992948817,'Leo'],
  [2992948817,2993129280,'Virgo'],
  [2993129280,2993301454,'Libra'],
  [2993301454,2993472288,'Scorpio'],
  [2993472288,2993649755,'Sagittarius'],
  [2993649755,2993840359,'Capricorn'],
  [2993840359,2994045918,'Aquarius'],
  [2994045918,2994261928,'Pisces'],
  [2994261928,2994480547,'Aries'],
  [2994480547,2994695887,'Taurus'],
  [2994695887,2994905697,'Gemini'],
  [2994905697,2995109098,'Cancer'],
  [2995109098,2995304648,'Leo'],
  [2995304648,2995491054,'Virgo'],
  [2995491054,2995669356,'Libra'],
  [2995669356,2995843875,'Scorpio'],
  [2995843875,2996021157,'Sagittarius'],
  [2996021157,2996207959,'Capricorn'],
  [2996207959,2996408477,'Aquarius'],
  [2996408477,2996621402,'Pisces'],
  [2996621402,2996839715,'Aries'],
  [2996839715,2997055154,'Taurus'],
  [2997055154,2997263187,'Gemini'],
  [2997263187,2997463362,'Cancer'],
  [2997463362,2997656826,'Leo'],
  [2997656826,2997844572,'Virgo'],
  [2997844572,2998027590,'Libra'],
  [2998027590,2998207976,'Scorpio'],
  [2998207976,2998389490,'Sagittarius'],
  [2998389490,2998577014,'Capricorn'],
  [2998577014,2998774904,'Aquarius'],
  [2998774904,2998984439,'Pisces'],
  [2998984439,2999201621,'Aries'],
  [2999201621,2999418214,'Taurus'],
  [2999418214,2999626809,'Gemini'],
  [2999626809,2999824793,'Cancer'],
  [2999824793,3000013887,'Leo'],
  [3000013887,3000197694,'Virgo'],
  [3000197694,3000379783,'Libra'],
  [3000379783,3000562936,'Scorpio'],
  [3000562936,3000749295,'Sagittarius'],
  [3000749295,3000940915,'Capricorn'],
  [3000940915,3001140016,'Aquarius'],
  [3001140016,3001348130,'Pisces'],
  [3001348130,3001563982,'Aries'],
  [3001563982,3001781826,'Taurus'],
  [3001781826,3001993315,'Gemini'],
  [3001993315,3002192671,'Cancer'],
  [3002192671,3002379665,'Leo'],
  [3002379665,3002558514,'Virgo'],
  [3002558514,3002735202,'Libra'],
  [3002735202,3002915235,'Scorpio'],
  [3002915235,3003102160,'Sagittarius'],
  [3003102160,3003297060,'Capricorn'],
  [3003297060,3003499461,'Aquarius'],
  [3003499461,3003708770,'Pisces'],
  [3003708770,3003924167,'Aries'],
  [3003924167,3004142613,'Taurus'],
  [3004142613,3004357478,'Gemini'],
  [3004357478,3004561260,'Cancer'],
  [3004561260,3004750551,'Leo'],
  [3004750551,3004927868,'Virgo'],
  [3004927868,3005099696,'Libra'],
  [3005099696,3005273568,'Scorpio'],
  [3005273568,3005455773,'Sagittarius'],
  [3005455773,3005649359,'Capricorn'],
  [3005649359,3005853407,'Aquarius'],
  [3005853407,3006064857,'Pisces'],
  [3006064857,3006280979,'Aries'],
  [3006280979,3006499464,'Taurus'],
  [3006499464,3006716231,'Gemini'],
  [3006716231,3006924746,'Cancer'],
  [3006924746,3007119482,'Leo'],
  [3007119482,3007299964,'Virgo'],
  [3007299964,3007471147,'Libra'],
  [3007471147,3007640774,'Scorpio'],
  [3007640774,3007816752,'Sagittarius'],
  [3007816752,3008004858,'Capricorn'],
  [3008004858,3008206468,'Aquarius'],
  [3008206468,3008418335,'Pisces'],
  [3008418335,3008635427,'Aries'],
  [3008635427,3008853848,'Taurus'],
  [3008853848,3009070568,'Gemini'],
  [3009070568,3009281399,'Cancer'],
  [3009281399,3009481322,'Leo'],
  [3009481322,3009667708,'Virgo'],
  [3009667708,3009842765,'Libra'],
  [3009842765,3010012688,'Scorpio'],
  [3010012688,3010185246,'Sagittarius'],
  [3010185246,3010367585,'Capricorn'],
  [3010367585,3010563835,'Aquarius'],
  [3010563835,3010773097,'Pisces'],
  [3010773097,3010990030,'Aries'],
  [3010990030,3011208440,'Taurus'],
  [3011208440,3011424117,'Gemini'],
  [3011424117,3011634253,'Cancer'],
  [3011634253,3011836078,'Leo'],
  [3011836078,3012027339,'Virgo'],
  [3012027339,3012208278,'Libra'],
  [3012208278,3012382531,'Scorpio'],
  [3012382531,3012556147,'Sagittarius'],
  [3012556147,3012735879,'Capricorn'],
  [3012735879,3012927219,'Aquarius'],
  [3012927219,3013132067,'Pisces'],
  [3013132067,3013347158,'Aries'],
  [3013347158,3013565441,'Taurus'],
  [3013565441,3013780358,'Gemini'],
  [3013780358,3013988382,'Cancer'],
  [3013988382,3014188456,'Leo'],
  [3014188456,3014380594,'Virgo'],
  [3014380594,3014565520,'Libra'],
  [3014565520,3014745226,'Scorpio'],
  [3014745226,3014923295,'Sagittarius'],
  [3014923295,3015104552,'Capricorn'],
  [3015104552,3015294031,'Aquarius'],
  [3015294031,3015495180,'Pisces'],
  [3015495180,3015707523,'Aries'],
  [3015707523,3015925410,'Taurus'],
  [3015925410,3016140640,'Gemini'],
  [3016140640,3016347378,'Cancer'],
  [3016347378,3016544331,'Leo'],
  [3016544331,3016733475,'Virgo'],
  [3016733475,3016917851,'Libra'],
  [3016917851,3017100234,'Scorpio'],
  [3017100234,3017282956,'Sagittarius'],
  [3017282956,3017468421,'Capricorn'],
  [3017468421,3017659595,'Aquarius'],
  [3017659595,3017859588,'Pisces'],
  [3017859588,3018069751,'Aries'],
  [3018069751,3018287049,'Taurus'],
  [3018287049,3018503672,'Gemini'],
  [3018503672,3018711411,'Cancer'],
  [3018711411,3018906845,'Leo'],
  [3018906845,3019092095,'Virgo'],
  [3019092095,3019272222,'Libra'],
  [3019272222,3019452410,'Scorpio'],
  [3019452410,3019636223,'Sagittarius'],
  [3019636223,3019825220,'Capricorn'],
  [3019825220,3020020006,'Aquarius'],
  [3020020006,3020221598,'Pisces'],
  [3020221598,3020431238,'Aries'],
  [3020431238,3020648027,'Taurus'],
  [3020648027,3020866356,'Gemini'],
  [3020866356,3021077326,'Cancer'],
  [3021077326,3021274655,'Leo'],
  [3021274655,3021458567,'Virgo'],
  [3021458567,3021634403,'Libra'],
  [3021634403,3021809243,'Scorpio'],
  [3021809243,3021989202,'Sagittarius'],
  [3021989202,3022177599,'Capricorn'],
  [3022177599,3022374600,'Aquarius'],
  [3022374600,3022578942,'Pisces'],
  [3022578942,3022789805,'Aries'],
  [3022789805,3023006495,'Taurus'],
  [3023006495,3023225795,'Gemini'],
  [3023225795,3023440464,'Cancer'],
  [3023440464,3023642674,'Leo'],
  [3023642674,3023829576,'Virgo'],
  [3023829576,3024004738,'Libra'],
  [3024004738,3024175366,'Scorpio'],
  [3024175366,3024349230,'Sagittarius'],
  [3024349230,3024532379,'Capricorn'],
  [3024532379,3024727259,'Aquarius'],
  [3024727259,3024932538,'Pisces'],
  [3024932538,3025145147,'Aries'],
  [3025145147,3025362362,'Taurus'],
  [3025362362,3025581542,'Gemini'],
  [3025581542,3025798016,'Cancer'],
  [3025798016,3026005176,'Leo'],
  [3026005176,3026198201,'Virgo'],
  [3026198201,3026377556,'Libra'],
  [3026377556,3026548572,'Scorpio'],
  [3026548572,3026718790,'Sagittarius'],
  [3026718790,3026895657,'Capricorn'],
  [3026895657,3027084516,'Aquarius'],
  [3027084516,3027286727,'Pisces'],
  [3027286727,3027499377,'Aries'],
  [3027499377,3027717347,'Taurus'],
  [3027717347,3027936046,'Gemini'],
  [3027936046,3028151749,'Cancer'],
  [3028151749,3028360554,'Leo'],
  [3028360554,3028558726,'Virgo'],
  [3028558726,3028744799,'Libra'],
  [3028744799,3028921048,'Scorpio'],
  [3028921048,3029092842,'Sagittarius'],
  [3029092842,3029266991,'Capricorn'],
  [3029266991,3029450068,'Aquarius'],
  [3029450068,3029646440,'Pisces'],
  [3029646440,3029856065,'Aries'],
  [3029856065,3030073845,'Taurus'],
  [3030073845,3030292515,'Gemini'],
  [3030292515,3030506581,'Cancer'],
  [3030506581,3030713414,'Leo'],
  [3030713414,3030912087,'Virgo'],
  [3030912087,3031102376,'Libra'],
  [3031102376,3031285066,'Scorpio'],
  [3031285066,3031462601,'Sagittarius'],
  [3031462601,3031639292,'Capricorn'],
  [3031639292,3031820750,'Aquarius'],
  [3031820750,3032012492,'Pisces'],
  [3032012492,3032217511,'Aries'],
  [3032217511,3032433419,'Taurus'],
  [3032433419,3032652390,'Gemini'],
  [3032652390,3032866029,'Cancer'],
  [3032866029,3033070236,'Leo'],
  [3033070236,3033265564,'Virgo'],
  [3033265564,3033454580,'Libra'],
  [3033454580,3033639666,'Scorpio'],
  [3033639666,3033822457,'Sagittarius'],
  [3033822457,3034004634,'Capricorn'],
  [3034004634,3034189136,'Aquarius'],
  [3034189136,3034380304,'Pisces'],
  [3034380304,3034582250,'Aries'],
  [3034582250,3034795580,'Taurus'],
  [3034795580,3035014603,'Gemini'],
  [3035014603,3035229564,'Cancer'],
  [3035229564,3035433412,'Leo'],
  [3035433412,3035625587,'Virgo'],
  [3035625587,3035810126,'Libra'],
  [3035810126,3035992066,'Scorpio'],
  [3035992066,3036175046,'Sagittarius'],
  [3036175046,3036360679,'Capricorn'],
  [3036360679,3036549736,'Aquarius'],
  [3036549736,3036743901,'Pisces'],
  [3036743901,3036946014,'Aries'],
  [3036946014,3037157863,'Taurus'],
  [3037157863,3037376606,'Gemini'],
  [3037376606,3037593737,'Cancer'],
  [3037593737,3037800125,'Leo'],
  [3037800125,3037992419,'Virgo'],
  [3037992419,3038173813,'Libra'],
  [3038173813,3038350607,'Scorpio'],
  [3038350607,3038528912,'Sagittarius'],
  [3038528912,3038712691,'Capricorn'],
  [3038712691,3038903298,'Aquarius'],
  [3038903298,3039100734,'Pisces'],
  [3039100734,3039305299,'Aries'],
  [3039305299,3039517587,'Taurus'],
  [3039517587,3039736147,'Gemini'],
  [3039736147,3039955015,'Cancer'],
  [3039955015,3040165369,'Leo'],
  [3040165369,3040361330,'Virgo'],
  [3040361330,3040543563,'Libra'],
  [3040543563,3040717613,'Scorpio'],
  [3040717613,3040890573,'Sagittarius'],
  [3040890573,3041068714,'Capricorn'],
  [3041068714,3041255972,'Aquarius'],
  [3041255972,3041453401,'Pisces'],
  [3041453401,3041659952,'Aries'],
  [3041659952,3041873799,'Taurus'],
  [3041873799,3042092602,'Gemini'],
  [3042092602,3042312072,'Cancer'],
  [3042312072,3042525538,'Leo'],
  [3042525538,3042726668,'Virgo'],
  [3042726668,3042913457,'Libra'],
  [3042913457,3043089115,'Scorpio'],
  [3043089115,3043259914,'Sagittarius'],
  [3043259914,3043432881,'Capricorn'],
  [3043432881,3043614147,'Aquarius'],
  [3043614147,3043807473,'Pisces'],
  [3043807473,3044013091,'Aries'],
  [3044013091,3044227865,'Taurus'],
  [3044227865,3044447163,'Gemini'],
  [3044447163,3044666292,'Cancer'],
  [3044666292,3044880538,'Leo'],
  [3044880538,3045085360,'Virgo'],
  [3045085360,3045277885,'Libra'],
  [3045277885,3045458691,'Scorpio'],
  [3045458691,3045631766,'Sagittarius'],
  [3045631766,3045803202,'Capricorn'],
  [3045803202,3045979756,'Aquarius'],
  [3045979756,3046167334,'Pisces'],
  [3046167334,3046368915,'Aries'],
  [3046368915,3046582554,'Taurus'],
  [3046582554,3046802034,'Gemini'],
  [3046802034,3047020572,'Cancer'],
  [3047020572,3047233591,'Leo'],
  [3047233591,3047438754,'Virgo'],
  [3047438754,3047634755,'Libra'],
  [3047634755,3047821263,'Scorpio'],
  [3047821263,3047999751,'Sagittarius'],
  [3047999751,3048173976,'Capricorn'],
  [3048173976,3048349642,'Aquarius'],
  [3048349642,3048533222,'Pisces'],
  [3048533222,3048729874,'Aries'],
  [3048729874,3048940366,'Taurus'],
  [3048940366,3049159176,'Gemini'],
  [3049159176,3049377489,'Cancer'],
  [3049377489,3049588914,'Leo'],
  [3049588914,3049791767,'Virgo'],
  [3049791767,3049987095,'Libra'],
  [3049987095,3050176145,'Scorpio'],
  [3050176145,3050359739,'Sagittarius'],
  [3050359739,3050539288,'Capricorn'],
  [3050539288,3050718093,'Aquarius'],
  [3050718093,3050901425,'Pisces'],
  [3050901425,3051095004,'Aries'],
  [3051095004,3051301942,'Taurus'],
  [3051301942,3051519221,'Gemini'],
  [3051519221,3051737867,'Cancer'],
  [3051737867,3051949021,'Leo'],
  [3051949021,3052149502,'Virgo'],
  [3052149502,3052341355,'Libra'],
  [3052341355,3052528256,'Scorpio'],
  [3052528256,3052712869,'Sagittarius'],
  [3052712869,3052896407,'Capricorn'],
  [3052896407,3053080080,'Aquarius'],
  [3053080080,3053266686,'Pisces'],
  [3053266686,3053460565,'Aries'],
  [3053460565,3053665499,'Taurus'],
  [3053665499,3053881062,'Gemini'],
  [3053881062,3054100297,'Cancer'],
  [3054100297,3054313186,'Leo'],
  [3054313186,3054513767,'Virgo'],
  [3054513767,3054702844,'Libra'],
  [3054702844,3054885182,'Scorpio'],
  [3054885182,3055065928,'Sagittarius'],
  [3055065928,3055248558,'Capricorn'],
  [3055248558,3055434670,'Aquarius'],
  [3055434670,3055625317,'Pisces'],
  [3055625317,3055822278,'Aries'],
  [3055822278,3056027810,'Taurus'],
  [3056027810,3056242443,'Gemini'],
  [3056242443,3056461992,'Cancer'],
  [3056461992,3056677743,'Leo'],
  [3056677743,3056881672,'Virgo'],
  [3056881672,3057071654,'Libra'],
  [3057071654,3057251296,'Scorpio'],
  [3057251296,3057426714,'Sagittarius'],
  [3057426714,3057603870,'Capricorn'],
  [3057603870,3057787053,'Aquarius'],
  [3057787053,3057978367,'Pisces'],
  [3057978367,3058178227,'Aries'],
  [3058178227,3058386220,'Taurus'],
  [3058386220,3058601350,'Gemini'],
  [3058601350,3058820783,'Cancer'],
  [3058820783,3059038601,'Leo'],
  [3059038601,3059247338,'Virgo'],
  [3059247338,3059442228,'Libra'],
  [3059442228,3059623889,'Scorpio'],
  [3059623889,3059797189,'Sagittarius'],
  [3059797189,3059968833,'Capricorn'],
  [3059968833,3060145479,'Aquarius'],
  [3060145479,3060332221,'Pisces'],
  [3060332221,3060531145,'Aries'],
  [3060531145,3060740780,'Taurus'],
  [3060740780,3060957365,'Gemini'],
  [3060957365,3061176732,'Cancer'],
  [3061176732,3061394681,'Leo'],
  [3061394681,3061606430,'Virgo'],
  [3061606430,3061807267,'Libra'],
  [3061807267,3061995011,'Scorpio'],
  [3061995011,3062171492,'Sagittarius'],
  [3062171492,3062341999,'Capricorn'],
  [3062341999,3062513649,'Aquarius'],
  [3062513649,3062693654,'Pisces'],
  [3062693654,3062887227,'Aries'],
  [3062887227,3063094978,'Taurus'],
  [3063094978,3063312165,'Gemini'],
  [3063312165,3063531847,'Cancer'],
  [3063531847,3063748798,'Leo'],
  [3063748798,3063960203,'Virgo'],
  [3063960203,3064163868,'Libra'],
  [3064163868,3064357610,'Scorpio'],
  [3064357610,3064540659,'Sagittarius'],
  [3064540659,3064715283,'Capricorn'],
  [3064715283,3064886976,'Aquarius'],
  [3064886976,3065063055,'Pisces'],
  [3065063055,3065250583,'Aries'],
  [3065250583,3065453336,'Taurus'],
  [3065453336,3065668686,'Gemini'],
  [3065668686,3065888482,'Cancer'],
  [3065888482,3066104793,'Leo'],
  [3066104793,3066314131,'Virgo'],
  [3066314131,3066516363,'Libra'],
  [3066516363,3066711732,'Scorpio'],
  [3066711732,3066899789,'Sagittarius'],
  [3066899789,3067080664,'Capricorn'],
  [3067080664,3067256972,'Aquarius'],
  [3067256972,3067434161,'Pisces'],
  [3067434161,3067619042,'Aries'],
  [3067619042,3067817114,'Taurus'],
  [3067817114,3068028884,'Gemini'],
  [3068028884,3068247871,'Cancer'],
  [3068247871,3068464456,'Leo'],
  [3068464456,3068672587,'Virgo'],
  [3068672587,3068871795,'Libra'],
  [3068871795,3069064355,'Scorpio'],
  [3069064355,3069252276,'Sagittarius'],
  [3069252276,3069436483,'Capricorn'],
  [3069436483,3069618052,'Aquarius'],
  [3069618052,3069799799,'Pisces'],
  [3069799799,3069986444,'Aries'],
  [3069986444,3070183026,'Taurus'],
  [3070183026,3070391852,'Gemini'],
  [3070391852,3070609378,'Cancer'],
  [3070609378,3070826798,'Leo'],
  [3070826798,3071035822,'Virgo'],
  [3071035822,3071233664,'Libra'],
  [3071233664,3071422505,'Scorpio'],
  [3071422505,3071606321,'Sagittarius'],
  [3071606321,3071788565,'Capricorn'],
  [3071788565,3071971562,'Aquarius'],
  [3071971562,3072157203,'Pisces'],
  [3072157203,3072347835,'Aries'],
  [3072347835,3072546289,'Taurus'],
  [3072546289,3072754480,'Gemini'],
  [3072754480,3072970878,'Cancer'],
  [3072970878,3073189156,'Leo'],
  [3073189156,3073400781,'Virgo'],
  [3073400781,3073600328,'Libra'],
  [3073600328,3073787948,'Scorpio'],
  [3073787948,3073967674,'Sagittarius'],
  [3073967674,3074144836,'Capricorn'],
  [3074144836,3074324310,'Aquarius'],
  [3074324310,3074509623,'Pisces'],
  [3074509623,3074702715,'Aries'],
  [3074702715,3074904225,'Taurus'],
  [3074904225,3075113908,'Gemini'],
  [3075113908,3075330197,'Cancer'],
  [3075330197,3075548979,'Leo'],
  [3075548979,3075763519,'Virgo'],
  [3075763519,3075967181,'Libra'],
  [3075967181,3076157317,'Scorpio'],
  [3076157317,3076336173,'Sagittarius'],
  [3076336173,3076509213,'Capricorn'],
  [3076509213,3076683045,'Aquarius'],
  [3076683045,3076863711,'Pisces'],
  [3076863711,3077055112,'Aries'],
  [3077055112,3077257811,'Taurus'],
  [3077257811,3077469437,'Gemini'],
  [3077469437,3077686514,'Cancer'],
  [3077686514,3077905390,'Leo'],
  [3077905390,3078121630,'Virgo'],
  [3078121630,3078329666,'Libra'],
  [3078329666,3078525017,'Scorpio'],
  [3078525017,3078707118,'Sagittarius'],
  [3078707118,3078879814,'Capricorn'],
  [3078879814,3079049823,'Aquarius'],
  [3079049823,3079224708,'Pisces'],
  [3079224708,3079410867,'Aries'],
  [3079410867,3079611067,'Taurus'],
  [3079611067,3079822937,'Gemini'],
  [3079822937,3080040859,'Cancer'],
  [3080040859,3080259635,'Leo'],
  [3080259635,3080475781,'Virgo'],
  [3080475781,3080686019,'Libra'],
  [3080686019,3080886434,'Scorpio'],
  [3080886434,3081074400,'Sagittarius'],
  [3081074400,3081251002,'Capricorn'],
  [3081251002,3081421372,'Aquarius'],
  [3081421372,3081593002,'Pisces'],
  [3081593002,3081773627,'Aries'],
  [3081773627,3081968601,'Taurus'],
  [3081968601,3082177862,'Gemini'],
  [3082177862,3082395565,'Cancer'],
  [3082395565,3082614260,'Leo'],
  [3082614260,3082829282,'Virgo'],
  [3082829282,3083038732,'Libra'],
  [3083038732,3083240993,'Scorpio'],
  [3083240993,3083433907,'Sagittarius'],
  [3083433907,3083616577,'Capricorn'],
  [3083616577,3083791438,'Aquarius'],
  [3083791438,3083964239,'Pisces'],
  [3083964239,3084142351,'Aries'],
  [3084142351,3084332422,'Taurus'],
  [3084332422,3084537186,'Gemini'],
  [3084537186,3084752981,'Cancer'],
  [3084752981,3084971575,'Leo'],
  [3084971575,3085185844,'Virgo'],
  [3085185844,3085393059,'Libra'],
  [3085393059,3085593311,'Scorpio'],
  [3085593311,3085786883,'Sagittarius'],
  [3085786883,3085973597,'Capricorn'],
  [3085973597,3086154231,'Aquarius'],
  [3086154231,3086331904,'Pisces'],
  [3086331904,3086511919,'Aries'],
  [3086511919,3086700285,'Taurus'],
  [3086700285,3086901198,'Gemini'],
  [3086901198,3087114006,'Cancer'],
  [3087114006,3087332194,'Leo'],
  [3087332194,3087547040,'Virgo'],
  [3087547040,3087753176,'Libra'],
  [3087753176,3087950147,'Scorpio'],
  [3087950147,3088140157,'Sagittarius'],
  [3088140157,3088325697,'Capricorn'],
  [3088325697,3088508753,'Aquarius'],
  [3088508753,3088691322,'Pisces'],
  [3088691322,3088876157,'Aries'],
  [3088876157,3089066849,'Taurus'],
  [3089066849,3089266826,'Gemini'],
  [3089266826,3089477221,'Cancer'],
  [3089477221,3089694574,'Leo'],
  [3089694574,3089911065,'Virgo'],
  [3089911065,3090118893,'Libra'],
  [3090118893,3090314904,'Scorpio'],
  [3090314904,3090500925,'Sagittarius'],
  [3090500925,3090681416,'Capricorn'],
  [3090681416,3090861191,'Aquarius'],
  [3090861191,3091044054,'Pisces'],
  [3091044054,3091232327,'Aries'],
  [3091232327,3091427195,'Taurus'],
  [3091427195,3091629441,'Gemini'],
  [3091629441,3091839503,'Cancer'],
  [3091839503,3092056021,'Leo'],
  [3092056021,3092274007,'Virgo'],
  [3092274007,3092485607,'Libra'],
  [3092485607,3092684640,'Scorpio'],
  [3092684640,3092870286,'Sagittarius'],
  [3092870286,3093046696,'Capricorn'],
  [3093046696,3093220459,'Aquarius'],
  [3093220459,3093398181,'Pisces'],
  [3093398181,3093584562,'Aries'],
  [3093584562,3093781078,'Taurus'],
  [3093781078,3093986342,'Gemini'],
  [3093986342,3094198122,'Cancer'],
  [3094198122,3094414563,'Leo'],
  [3094414563,3094632980,'Virgo'],
  [3094632980,3094847922,'Libra'],
  [3094847922,3095052394,'Scorpio'],
  [3095052394,3095242321,'Sagittarius'],
  [3095242321,3095419328,'Capricorn'],
  [3095419328,3095589620,'Aquarius'],
  [3095589620,3095761161,'Pisces'],
  [3095761161,3095941265,'Aries'],
  [3095941265,3096134222,'Taurus'],
  [3096134222,3096339514,'Gemini'],
  [3096339514,3096552988,'Cancer'],
  [3096552988,3096770242,'Leo'],
  [3096770242,3096988350,'Virgo'],
  [3096988350,3097204239,'Libra'],
  [3097204239,3097412888,'Scorpio'],
  [3097412888,3097609093,'Sagittarius'],
  [3097609093,3097791324,'Capricorn'],
  [3097791324,3097963369,'Aquarius'],
  [3097963369,3098132532,'Pisces'],
  [3098132532,3098306999,'Aries'],
  [3098306999,3098493491,'Taurus'],
  [3098493491,3098694544,'Gemini'],
  [3098694544,3098907133,'Cancer'],
  [3098907133,3099125012,'Leo'],
  [3099125012,3099342888,'Virgo'],
  [3099342888,3099557750,'Libra'],
  [3099557750,3099766957,'Scorpio'],
  [3099766957,3099967064,'Sagittarius'],
  [3099967064,3100155517,'Capricorn'],
  [3100155517,3100333257,'Aquarius'],
  [3100333257,3100505184,'Pisces'],
  [3100505184,3100678442,'Aries'],
  [3100678442,3100860269,'Taurus'],
  [3100860269,3101055581,'Gemini'],
  [3101055581,3101264418,'Cancer'],
  [3101264418,3101481459,'Leo'],
  [3101481459,3101699359,'Virgo'],
  [3101699359,3101912995,'Libra'],
  [3101912995,3102120130,'Scorpio'],
  [3102120130,3102319727,'Sagittarius'],
  [3102319727,3102510985,'Capricorn'],
  [3102510985,3102694157,'Aquarius'],
  [3102694157,3102871699,'Pisces'],
  [3102871699,3103048301,'Aries'],
  [3103048301,3103229836,'Taurus'],
  [3103229836,3103421639,'Gemini'],
  [3103421639,3103626192,'Cancer'],
  [3103626192,3103840977,'Leo'],
  [3103840977,3104058869,'Virgo'],
  [3104058869,3104272361,'Libra'],
  [3104272361,3104477450,'Scorpio'],
  [3104477450,3104673862,'Sagittarius'],
  [3104673862,3104863242,'Capricorn'],
  [3104863242,3105047680,'Aquarius'],
  [3105047680,3105229390,'Pisces'],
  [3105229390,3105411023,'Aries'],
  [3105411023,3105595959,'Taurus'],
  [3105595959,3105788035,'Gemini'],
  [3105788035,3105990293,'Cancer'],
  [3105990293,3106202735,'Leo'],
  [3106202735,3106420450,'Virgo'],
  [3106420450,3106635151,'Libra'],
  [3106635151,3106840221,'Scorpio'],
  [3106840221,3107034042,'Sagittarius'],
  [3107034042,3107219299,'Capricorn'],
  [3107219299,3107400478,'Aquarius'],
  [3107400478,3107581775,'Pisces'],
  [3107581775,3107766088,'Aries'],
  [3107766088,3107955109,'Taurus'],
  [3107955109,3108150203,'Gemini'],
  [3108150203,3108352992,'Cancer'],
  [3108352992,3108564327,'Leo'],
  [3108564327,3108781820,'Virgo'],
  [3108781820,3108998519,'Libra'],
  [3108998519,3109206068,'Scorpio'],
  [3109206068,3109400214,'Sagittarius'],
  [3109400214,3109582695,'Capricorn'],
  [3109582695,3109759112,'Aquarius'],
  [3109759112,3109935925,'Pisces'],
  [3109935925,3110118224,'Aries'],
  [3110118224,3110308417,'Taurus'],
  [3110308417,3110506461,'Gemini'],
  [3110506461,3110711584,'Cancer'],
  [3110711584,3110923444,'Leo'],
  [3110923444,3111140875,'Virgo'],
  [3111140875,3111359305,'Libra'],
  [3111359305,3111570746,'Scorpio'],
  [3111570746,3111768539,'Sagittarius'],
  [3111768539,3111951916,'Capricorn'],
  [3111951916,3112125756,'Aquarius'],
  [3112125756,3112297493,'Pisces'],
  [3112297493,3112474350,'Aries'],
  [3112474350,3112661193,'Taurus'],
  [3112661193,3112859080,'Gemini'],
  [3112859080,3113066013,'Cancer'],
  [3113066013,3113279335,'Leo'],
  [3113279335,3113497005,'Virgo'],
  [3113497005,3113716063,'Libra'],
  [3113716063,3113930655,'Scorpio'],
  [3113930655,3114133729,'Sagittarius'],
  [3114133729,3114321793,'Capricorn'],
  [3114321793,3114497338,'Aquarius'],
  [3114497338,3114667033,'Pisces'],
  [3114667033,3114838816,'Aries'],
  [3114838816,3115019638,'Taurus'],
  [3115019638,3115213299,'Gemini'],
  [3115213299,3115419160,'Cancer'],
  [3115419160,3115633341,'Leo'],
  [3115633341,3115851482,'Virgo'],
  [3115851482,3116070134,'Libra'],
  [3116070134,3116285417,'Scorpio'],
  [3116285417,3116492234,'Sagittarius'],
  [3116492234,3116686340,'Capricorn'],
  [3116686340,3116867448,'Aquarius'],
  [3116867448,3117039811,'Pisces'],
  [3117039811,3117210324,'Aries'],
  [3117210324,3117386397,'Taurus'],
  [3117386397,3117573988,'Gemini'],
  [3117573988,3117775451,'Cancer'],
  [3117775451,3117988317,'Leo'],
  [3117988317,3118206696,'Virgo'],
  [3118206696,3118424772,'Libra'],
  [3118424772,3118638593,'Scorpio'],
  [3118638593,3118845373,'Sagittarius'],
  [3118845373,3119042832,'Capricorn'],
  [3119042832,3119229995,'Aquarius'],
  [3119229995,3119408477,'Pisces'],
  [3119408477,3119582565,'Aries'],
  [3119582565,3119758238,'Taurus'],
  [3119758238,3119941765,'Gemini'],
  [3119941765,3120137813,'Cancer'],
  [3120137813,3120347046,'Leo'],
  [3120347046,3120564679,'Virgo'],
  [3120564679,3120782789,'Libra'],
  [3120782789,3120995075,'Scorpio'],
  [3120995075,3121199069,'Sagittarius'],
  [3121199069,3121395058,'Capricorn'],
  [3121395058,3121584211,'Aquarius'],
  [3121584211,3121767900,'Pisces'],
  [3121767900,3121948074,'Aries'],
  [3121948074,3122127892,'Taurus'],
  [3122127892,3122311853,'Gemini'],
  [3122311853,3122504878,'Cancer'],
  [3122504878,3122710106,'Leo'],
  [3122710106,3122925817,'Virgo'],
  [3122925817,3123144472,'Libra'],
  [3123144472,3123357065,'Scorpio'],
  [3123357065,3123558913,'Sagittarius'],
  [3123558913,3123750894,'Capricorn'],
  [3123750894,3123936779,'Aquarius'],
  [3123936779,3124120362,'Pisces'],
  [3124120362,3124304055,'Aries'],
  [3124304055,3124489164,'Taurus'],
  [3124489164,3124677301,'Gemini'],
  [3124677301,3124871395,'Cancer'],
  [3124871395,3125074819,'Leo'],
  [3125074819,3125288463,'Virgo'],
  [3125288463,3125507490,'Libra'],
  [3125507490,3125722338,'Scorpio'],
  [3125722338,3125925222,'Sagittarius'],
  [3125925222,3126115032,'Capricorn'],
  [3126115032,3126296166,'Aquarius'],
  [3126296166,3126474818,'Pisces'],
  [3126474818,3126656085,'Aries'],
  [3126656085,3126842513,'Taurus'],
  [3126842513,3127034497,'Gemini'],
  [3127034497,3127232221,'Cancer'],
  [3127232221,3127436947,'Leo'],
  [3127436947,3127649855,'Virgo'],
  [3127649855,3127868786,'Libra'],
  [3127868786,3128086262,'Scorpio'],
  [3128086262,3128293098,'Sagittarius'],
  [3128293098,3128484977,'Capricorn'],
  [3128484977,3128664516,'Aquarius'],
  [3128664516,3128838330,'Pisces'],
  [3128838330,3129013576,'Aries'],
  [3129013576,3129195640,'Taurus'],
  [3129195640,3129386817,'Gemini'],
  [3129386817,3129586714,'Cancer'],
  [3129586714,3129794081,'Leo'],
  [3129794081,3130007998,'Virgo'],
  [3130007998,3130226794,'Libra'],
  [3130226794,3130445632,'Scorpio'],
  [3130445632,3130656734,'Sagittarius'],
  [3130656734,3130853865,'Capricorn'],
  [3130853865,3131036558,'Aquarius'],
  [3131036558,3131209714,'Pisces'],
  [3131209714,3131380587,'Aries'],
  [3131380587,3131556286,'Taurus'],
  [3131556286,3131741984,'Gemini'],
  [3131741984,3131939607,'Cancer'],
  [3131939607,3132147755,'Leo'],
  [3132147755,3132363138,'Virgo'],
  [3132363138,3132582191,'Libra'],
  [3132582191,3132800883,'Scorpio'],
  [3132800883,3133013971,'Sagittarius'],
  [3133013971,3133216099,'Capricorn'],
  [3133216099,3133404749,'Aquarius'],
  [3133404749,3133581929,'Pisces'],
  [3133581929,3133753109,'Aries'],
  [3133753109,3133925199,'Taurus'],
  [3133925199,3134104867,'Gemini'],
  [3134104867,3134296876,'Cancer'],
  [3134296876,3134502278,'Leo'],
  [3134502278,3134717658,'Virgo'],
  [3134717658,3134937082,'Libra'],
  [3134937082,3135155010,'Scorpio'],
  [3135155010,3135367391,'Sagittarius'],
  [3135367391,3135571289,'Capricorn'],
  [3135571289,3135764795,'Aquarius'],
  [3135764795,3135948020,'Pisces'],
  [3135948020,3136123706,'Aries'],
  [3136123706,3136296867,'Taurus'],
  [3136296867,3136473793,'Gemini'],
  [3136473793,3136660625,'Cancer'],
  [3136660625,3136861191,'Leo'],
  [3136861191,3137074360,'Virgo'],
  [3137074360,3137293634,'Libra'],
  [3137293634,3137511077,'Scorpio'],
  [3137511077,3137721618,'Sagittarius'],
  [3137721618,3137923882,'Capricorn'],
  [3137923882,3138118278,'Aquarius'],
  [3138118278,3138305540,'Pisces'],
  [3138305540,3138486824,'Aries'],
  [3138486824,3138664562,'Taurus'],
  [3138664562,3138843071,'Gemini'],
  [3138843071,3139028025,'Cancer'],
  [3139028025,3139224626,'Leo'],
  [3139224626,3139434479,'Virgo'],
  [3139434479,3139652835,'Libra'],
  [3139652835,3139870476,'Scorpio'],
  [3139870476,3140079972,'Sagittarius'],
  [3140079972,3140279446,'Capricorn'],
  [3140279446,3140471086,'Aquarius'],
  [3140471086,3140657909,'Pisces'],
  [3140657909,3140841945,'Aries'],
  [3140841945,3141024424,'Taurus'],
  [3141024424,3141207247,'Gemini'],
  [3141207247,3141394059,'Cancer'],
  [3141394059,3141589568,'Leo'],
  [3141589568,3141796906,'Virgo'],
  [3141796906,3142013968,'Libra'],
  [3142013968,3142232409,'Scorpio'],
  [3142232409,3142442775,'Sagittarius'],
  [3142442775,3142640984,'Capricorn'],
  [3142640984,3142829115,'Aquarius'],
  [3142829115,3143012003,'Pisces'],
  [3143012003,3143194036,'Aries'],
  [3143194036,3143377708,'Taurus'],
  [3143377708,3143564137,'Gemini'],
  [3143564137,3143754731,'Cancer'],
  [3143754731,3143952107,'Leo'],
  [3143952107,3144158988,'Virgo'],
  [3144158988,3144375105,'Libra'],
  [3144375105,3144594480,'Scorpio'],
  [3144594480,3144807493,'Sagittarius'],
  [3144807493,3145007466,'Capricorn'],
  [3145007466,3145194479,'Aquarius'],
  [3145194479,3145373417,'Pisces'],
  [3145373417,3145550422,'Aries'],
  [3145550422,3145730500,'Taurus'],
  [3145730500,3145916477,'Gemini'],
  [3145916477,3146109408,'Cancer'],
  [3146109408,3146309801,'Leo'],
  [3146309801,3146518227,'Virgo'],
  [3146518227,3146734290,'Libra'],
  [3146734290,3146954193,'Scorpio'],
  [3146954193,3147170226,'Sagittarius'],
  [3147170226,3147374584,'Capricorn'],
  [3147374584,3147564427,'Aquarius'],
  [3147564427,3147742747,'Pisces'],
  [3147742747,3147915683,'Aries'],
  [3147915683,3148089898,'Taurus'],
  [3148089898,3148270891,'Gemini'],
  [3148270891,3148461866,'Cancer'],
  [3148461866,3148663366,'Leo'],
  [3148663366,3148873852,'Virgo'],
  [3148873852,3149090778,'Libra'],
  [3149090778,3149310668,'Scorpio'],
  [3149310668,3149528272,'Sagittarius'],
  [3149528272,3149737198,'Capricorn'],
  [3149737198,3149932840,'Aquarius'],
  [3149932840,3150115127,'Pisces'],
  [3150115127,3150288241,'Aries'],
  [3150288241,3150458672,'Taurus'],
  [3150458672,3150633439,'Gemini'],
  [3150633439,3150818523,'Cancer'],
  [3150818523,3151017012,'Leo'],
  [3151017012,3151227638,'Virgo'],
  [3151227638,3151445579,'Libra'],
  [3151445579,3151665340,'Scorpio'],
  [3151665340,3151882465,'Sagittarius'],
  [3151882465,3152093206,'Capricorn'],
  [3152093206,3152294049,'Aquarius'],
  [3152294049,3152482986,'Pisces'],
  [3152482986,3152661080,'Aries'],
  [3152661080,3152832686,'Taurus'],
  [3152832686,3153004412,'Gemini'],
  [3153004412,3153183556,'Cancer'],
  [3153183556,3153376030,'Leo'],
  [3153376030,3153583385,'Virgo'],
  [3153583385,3153801012,'Libra'],
  [3153801012,3154020883,'Scorpio'],
  [3154020883,3154236736,'Sagittarius'],
  [3154236736,3154446002,'Capricorn'],
  [3154446002,3154647891,'Aquarius'],
  [3154647891,3154841528,'Pisces'],
  [3154841528,3155026311,'Aries'],
  [3155026311,3155203538,'Taurus'],
  [3155203538,3155377474,'Gemini'],
  [3155377474,3155554680,'Cancer'],
  [3155554680,3155742151,'Leo'],
  [3155742151,3155944324,'Virgo'],
  [3155944324,3156159445,'Libra'],
  [3156159445,3156379258,'Scorpio'],
  [3156379258,3156594717,'Sagittarius'],
  [3156594717,3156801689,'Capricorn'],
  [3156801689,3157000766,'Aquarius'],
  [3157000766,3157193813,'Pisces'],
  [3157193813,3157381734,'Aries'],
  [3157381734,3157564762,'Taurus'],
  [3157564762,3157744373,'Gemini'],
  [3157744373,3157924587,'Cancer'],
  [3157924587,3158111281,'Leo'],
  [3158111281,3158309841,'Virgo'],
  [3158309841,3158521493,'Libra'],
  [3158521493,3158740493,'Scorpio'],
  [3158740493,3158956837,'Sagittarius'],
  [3158956837,3159163445,'Capricorn'],
  [3159163445,3159359591,'Aquarius'],
  [3159359591,3159548511,'Pisces'],
  [3159548511,3159733838,'Aries'],
  [3159733838,3159917798,'Taurus'],
  [3159917798,3160101558,'Gemini'],
  [3160101558,3160286819,'Cancer'],
  [3160286819,3160476787,'Leo'],
  [3160476787,3160675440,'Virgo'],
  [3160675440,3160885010,'Libra'],
  [3160885010,3161102751,'Scorpio'],
  [3161102751,3161320447,'Sagittarius'],
  [3161320447,3161529268,'Capricorn'],
  [3161529268,3161725544,'Aquarius'],
  [3161725544,3161911381,'Pisces'],
  [3161911381,3162091649,'Aries'],
  [3162091649,3162271230,'Taurus'],
  [3162271230,3162453673,'Gemini'],
  [3162453673,3162641109,'Cancer'],
  [3162641109,3162834954,'Leo'],
  [3162834954,3163036497,'Virgo'],
  [3163036497,3163246526,'Libra'],
  [3163246526,3163463537,'Scorpio'],
  [3163463537,3163682134,'Sagittarius'],
  [3163682134,3163894340,'Capricorn'],
  [3163894340,3164094141,'Aquarius'],
  [3164094141,3164280839,'Pisces'],
  [3164280839,3164458288,'Aries'],
  [3164458288,3164632441,'Taurus'],
  [3164632441,3164809332,'Gemini'],
  [3164809332,3164993681,'Cancer'],
  [3164993681,3165187924,'Leo'],
  [3165187924,3165391962,'Virgo'],
  [3165391962,3165603983,'Libra'],
  [3165603983,3165821315,'Scorpio'],
  [3165821315,3166040111,'Sagittarius'],
  [3166040111,3166254844,'Capricorn'],
  [3166254844,3166459482,'Aquarius'],
  [3166459482,3166650713,'Pisces'],
  [3166650713,3166829765,'Aries'],
  [3166829765,3167001655,'Taurus'],
  [3167001655,3167173289,'Gemini'],
  [3167173289,3167351622,'Cancer'],
  [3167351622,3167541770,'Leo'],
  [3167541770,3167745001,'Virgo'],
  [3167745001,3167958258,'Libra'],
  [3167958258,3168176463,'Scorpio'],
  [3168176463,3168395069,'Sagittarius'],
  [3168395069,3168610368,'Capricorn'],
  [3168610368,3168818341,'Aquarius'],
  [3168818341,3169015121,'Pisces'],
  [3169015121,3169199308,'Aries'],
  [3169199308,3169373462,'Taurus'],
  [3169373462,3169543565,'Gemini'],
  [3169543565,3169717201,'Cancer'],
  [3169717201,3169901501,'Leo'],
  [3169901501,3170100471,'Virgo'],
  [3170100471,3170312449,'Libra'],
  [3170312449,3170530994,'Scorpio'],
  [3170530994,3170749385,'Sagittarius'],
  [3170749385,3170963718,'Capricorn'],
  [3170963718,3171171988,'Aquarius'],
  [3171171988,3171372046,'Pisces'],
  [3171372046,3171561809,'Aries'],
  [3171561809,3171741339,'Taurus'],
  [3171741339,3171914276,'Gemini'],
  [3171914276,3172087165,'Cancer'],
  [3172087165,3172267535,'Leo'],
  [3172267535,3172461359,'Virgo'],
  [3172461359,3172669736,'Libra'],
  [3172669736,3172887285,'Scorpio'],
  [3172887285,3173105573,'Sagittarius'],
  [3173105573,3173318736,'Capricorn'],
  [3173318736,3173525047,'Aquarius'],
  [3173525047,3173724523,'Pisces'],
  [3173724523,3173916773,'Aries'],
  [3173916773,3174101340,'Taurus'],
  [3174101340,3174279592,'Gemini'],
  [3174279592,3174455748,'Cancer'],
  [3174455748,3174636070,'Leo'],
  [3174636070,3174826829,'Virgo'],
  [3174826829,3175031263,'Libra'],
  [3175031263,3175246636,'Scorpio'],
  [3175246636,3175464864,'Sagittarius'],
  [3175464864,3175677878,'Capricorn'],
  [3175677878,3175882236,'Aquarius'],
  [3175882236,3176078618,'Pisces'],
  [3176078618,3176268951,'Aries'],
  [3176268951,3176454656,'Taurus'],
  [3176454656,3176636939,'Gemini'],
  [3176636939,3176818040,'Cancer'],
  [3176818040,3177001814,'Leo'],
  [3177001814,3177193027,'Virgo'],
  [3177193027,3177395337,'Libra'],
  [3177395337,3177608438,'Scorpio'],
  [3177608438,3177826515,'Sagittarius'],
  [3177826515,3178040850,'Capricorn'],
  [3178040850,3178245352,'Aquarius'],
  [3178245352,3178439238,'Pisces'],
  [3178439238,3178625353,'Aries'],
  [3178625353,3178807568,'Taurus'],
  [3178807568,3178989257,'Gemini'],
  [3178989257,3179173001,'Cancer'],
  [3179173001,3179360999,'Leo'],
  [3179360999,3179555481,'Virgo'],
  [3179555481,3179758478,'Libra'],
  [3179758478,3179970444,'Scorpio'],
  [3179970444,3180188234,'Sagittarius'],
  [3180188234,3180404726,'Capricorn'],
  [3180404726,3180612143,'Aquarius'],
  [3180612143,3180806782,'Pisces'],
  [3180806782,3180990223,'Aries'],
  [3180990223,3181167346,'Taurus'],
  [3181167346,3181343999,'Gemini'],
  [3181343999,3181525253,'Cancer'],
  [3181525253,3181714255,'Leo'],
  [3181714255,3181911891,'Virgo'],
  [3181911891,3182117548,'Libra'],
  [3182117548,3182330127,'Scorpio'],
  [3182330127,3182547668,'Sagittarius'],
  [3182547668,3182765790,'Capricorn'],
  [3182765790,3182977500,'Aquarius'],
  [3182977500,3183176623,'Pisces'],
  [3183176623,3183361716,'Aries'],
  [3183361716,3183536495,'Taurus'],
  [3183536495,3183707710,'Gemini'],
  [3183707710,3183882742,'Cancer'],
  [3183882742,3184067530,'Leo'],
  [3184067530,3184264531,'Virgo'],
  [3184264531,3184472067,'Libra'],
  [3184472067,3184686359,'Scorpio'],
  [3184686359,3184904091,'Sagittarius'],
  [3184904091,3185122443,'Capricorn'],
  [3185122443,3185337073,'Aquarius'],
  [3185337073,3185541955,'Pisces'],
  [3185541955,3185732817,'Aries'],
  [3185732817,3185910360,'Taurus'],
  [3185910360,3186080126,'Gemini'],
  [3186080126,3186250058,'Cancer'],
  [3186250058,3186428110,'Leo'],
  [3186428110,3186619780,'Virgo'],
  [3186619780,3186825465,'Libra'],
  [3186825465,3187040497,'Scorpio'],
  [3187040497,3187258869,'Sagittarius'],
  [3187258869,3187476622,'Capricorn'],
  [3187476622,3187691243,'Aquarius'],
  [3187691243,3187899236,'Pisces'],
  [3187899236,3188096298,'Aries'],
  [3188096298,3188280372,'Taurus'],
  [3188280372,3188454043,'Gemini'],
  [3188454043,3188623791,'Cancer'],
  [3188623791,3188797651,'Leo'],
  [3188797651,3188982890,'Virgo'],
  [3188982890,3189183129,'Libra'],
  [3189183129,3189395989,'Scorpio'],
  [3189395989,3189614486,'Sagittarius'],
  [3189614486,3189831918,'Capricorn'],
  [3189831918,3190044879,'Aquarius'],
  [3190044879,3190251855,'Pisces'],
  [3190251855,3190451064,'Aries'],
  [3190451064,3190640676,'Taurus'],
  [3190640676,3190820926,'Gemini'],
  [3190820926,3190995412,'Cancer'],
  [3190995412,3191170307,'Leo'],
  [3191170307,3191352530,'Virgo'],
  [3191352530,3191547406,'Libra'],
  [3191547406,3191755859,'Scorpio'],
  [3191755859,3191972959,'Sagittarius'],
  [3191972959,3192190576,'Capricorn'],
  [3192190576,3192402557,'Aquarius'],
  [3192402557,3192606774,'Pisces'],
  [3192606774,3192803513,'Aries'],
  [3192803513,3192993546,'Taurus'],
  [3192993546,3193177794,'Gemini'],
  [3193177794,3193358126,'Cancer'],
  [3193358126,3193537964,'Leo'],
  [3193537964,3193722008,'Virgo'],
  [3193722008,3193915022,'Libra'],
  [3193915022,3194119737,'Scorpio'],
  [3194119737,3194334404,'Sagittarius'],
  [3194334404,3194552216,'Capricorn'],
  [3194552216,3194764965,'Aquarius'],
  [3194764965,3194967913,'Pisces'],
  [3194967913,3195161038,'Aries'],
  [3195161038,3195347194,'Taurus'],
  [3195347194,3195529924,'Gemini'],
  [3195529924,3195712274,'Cancer'],
  [3195712274,3195896617,'Leo'],
  [3195896617,3196085110,'Virgo'],
  [3196085110,3196280153,'Libra'],
  [3196280153,3196483963,'Scorpio'],
  [3196483963,3196696754,'Sagittarius'],
  [3196696754,3196914509,'Capricorn'],
  [3196914509,3197129305,'Aquarius'],
  [3197129305,3197333839,'Pisces'],
  [3197333839,3197525761,'Aries'],
  [3197525761,3197707883,'Taurus'],
  [3197707883,3197885703,'Gemini'],
  [3197885703,3198064821,'Cancer'],
  [3198064821,3198249232,'Leo'],
  [3198249232,3198440638,'Virgo'],
  [3198440638,3198639148,'Libra'],
  [3198639148,3198844698,'Scorpio'],
  [3198844698,3199057240,'Sagittarius'],
  [3199057240,3199274861,'Capricorn'],
  [3199274861,3199491797,'Aquarius'],
  [3199491797,3199700011,'Pisces'],
  [3199700011,3199894348,'Aries'],
  [3199894348,3200075644,'Taurus'],
  [3200075644,3200249471,'Gemini'],
  [3200249471,3200423109,'Cancer'],
  [3200423109,3200603027,'Leo'],
  [3200603027,3200792920,'Virgo'],
  [3200792920,3200992863,'Libra'],
  [3200992863,3201200713,'Scorpio'],
  [3201200713,3201414372,'Sagittarius'],
  [3201414372,3201632044,'Capricorn'],
  [3201632044,3201850150,'Aquarius'],
  [3201850150,3202062111,'Pisces'],
  [3202062111,3202261319,'Aries'],
  [3202261319,3202445801,'Taurus'],
  [3202445801,3202619420,'Gemini'],
  [3202619420,3202789447,'Cancer'],
  [3202789447,3202963727,'Leo'],
  [3202963727,3203148412,'Virgo'],
  [3203148412,3203345831,'Libra'],
  [3203345831,3203554013,'Scorpio'],
  [3203554013,3203768869,'Sagittarius'],
  [3203768869,3203986827,'Capricorn'],
  [3203986827,3204204867,'Aquarius'],
  [3204204867,3204418624,'Pisces'],
  [3204418624,3204622422,'Aries'],
  [3204622422,3204812502,'Taurus'],
  [3204812502,3204990019,'Gemini'],
  [3204990019,3205160587,'Cancer'],
  [3205160587,3205331814,'Leo'],
  [3205331814,3205511044,'Virgo'],
  [3205511044,3205703146,'Libra'],
  [3205703146,3205908519,'Scorpio'],
  [3205908519,3206123160,'Sagittarius'],
  [3206123160,3206341390,'Capricorn'],
  [3206341390,3206558722,'Aquarius'],
  [3206558722,3206771803,'Pisces'],
  [3206771803,3206977242,'Aries'],
  [3206977242,3207171994,'Taurus'],
  [3207171994,3207355406,'Gemini'],
  [3207355406,3207530471,'Cancer'],
  [3207530471,3207702974,'Leo'],
  [3207702974,3207879775,'Virgo'],
  [3207879775,3208066944,'Libra'],
  [3208066944,3208267575,'Scorpio'],
  [3208267575,3208479957,'Sagittarius'],
  [3208479957,3208698016,'Capricorn'],
  [3208698016,3208914898,'Aquarius'],
  [3208914898,3209126145,'Pisces'],
  [3209126145,3209329829,'Aries'],
  [3209329829,3209525326,'Taurus'],
  [3209525326,3209712763,'Gemini'],
  [3209712763,3209893561,'Cancer'],
  [3209893561,3210070917,'Leo'],
  [3210070917,3210249586,'Virgo'],
  [3210249586,3210434994,'Libra'],
  [3210434994,3210631612,'Scorpio'],
  [3210631612,3210840578,'Sagittarius'],
  [3210840578,3211057730,'Capricorn'],
  [3211057730,3211274988,'Aquarius'],
  [3211274988,3211485307,'Pisces'],
  [3211485307,3211686049,'Aries'],
  [3211686049,3211878409,'Taurus'],
  [3211878409,3212065070,'Gemini'],
  [3212065070,3212248563,'Cancer'],
  [3212248563,3212430947,'Leo'],
  [3212430947,3212614421,'Virgo'],
  [3212614421,3212802056,'Libra'],
  [3212802056,3212997630,'Scorpio'],
  [3212997630,3213203902,'Sagittarius'],
  [3213203902,3213419630,'Capricorn'],
  [3213419630,3213637907,'Aquarius'],
  [3213637907,3213849554,'Pisces'],
  [3213849554,3214049276,'Aries'],
  [3214049276,3214237886,'Taurus'],
  [3214237886,3214419985,'Gemini'],
  [3214419985,3214600770,'Cancer'],
  [3214600770,3214783951,'Leo'],
  [3214783951,3214971169,'Virgo'],
  [3214971169,3215163070,'Libra'],
  [3215163070,3215360927,'Scorpio'],
  [3215360927,3215566819,'Sagittarius'],
  [3215566819,3215781390,'Capricorn'],
  [3215781390,3216000547,'Aquarius'],
  [3216000547,3216215342,'Pisces'],
  [3216215342,3216417640,'Aries'],
  [3216417640,3216605672,'Taurus'],
  [3216605672,3216783780,'Gemini'],
  [3216783780,3216958881,'Cancer'],
  [3216958881,3217137400,'Leo'],
  [3217137400,3217323248,'Virgo'],
  [3217323248,3217517192,'Libra'],
  [3217517192,3217718336,'Scorpio'],
  [3217718336,3217926180,'Sagittarius'],
  [3217926180,3218140753,'Capricorn'],
  [3218140753,3218360111,'Aquarius'],
  [3218360111,3218577823,'Pisces'],
  [3218577823,3218785145,'Aries'],
  [3218785145,3218977116,'Taurus'],
  [3218977116,3219155611,'Gemini'],
  [3219155611,3219327144,'Cancer'],
  [3219327144,3219499472,'Leo'],
  [3219499472,3219679182,'Virgo'],
  [3219679182,3219869840,'Libra'],
  [3219869840,3220071326,'Scorpio'],
  [3220071326,3220281251,'Sagittarius'],
  [3220281251,3220497028,'Capricorn'],
  [3220497028,3220716270,'Aquarius'],
  [3220716270,3220934893,'Pisces'],
  [3220934893,3221146325,'Aries'],
  [3221146325,3221344529,'Taurus'],
  [3221344529,3221528178,'Gemini'],
  [3221528178,3221701334,'Cancer'],
  [3221701334,3221871020,'Leo'],
  [3221871020,3222044748,'Virgo'],
  [3222044748,3222228672,'Libra'],
  [3222228672,3222425783,'Scorpio'],
  [3222425783,3222634900,'Sagittarius'],
  [3222634900,3222851642,'Capricorn'],
  [3222851642,3223071045,'Aquarius'],
  [3223071045,3223288880,'Pisces'],
  [3223288880,3223501041,'Aries'],
  [3223501041,3223703427,'Taurus'],
  [3223703427,3223893616,'Gemini'],
  [3223893616,3224072688,'Cancer'],
  [3224072688,3224245111,'Leo'],
  [3224245111,3224417302,'Virgo'],
  [3224417302,3224596054,'Libra'],
  [3224596054,3224786850,'Scorpio'],
  [3224786850,3224991686,'Sagittarius'],
  [3224991686,3225207379,'Capricorn'],
  [3225207379,3225426985,'Aquarius'],
  [3225426985,3225643890,'Pisces'],
  [3225643890,3225854222,'Aries'],
  [3225854222,3226056405,'Taurus'],
  [3226056405,3226249850,'Gemini'],
  [3226249850,3226434868,'Cancer'],
  [3226434868,3226613294,'Leo'],
  [3226613294,3226788905,'Virgo'],
  [3226788905,3226967134,'Libra'],
  [3226967134,3227153947,'Scorpio'],
  [3227153947,3227353758,'Sagittarius'],
  [3227353758,3227566396,'Capricorn'],
  [3227566396,3227785576,'Aquarius'],
  [3227785576,3228002380,'Pisces'],
  [3228002380,3228210893,'Aries'],
  [3228210893,3228410157,'Taurus'],
  [3228410157,3228602061,'Gemini'],
  [3228602061,3228788784,'Cancer'],
  [3228788784,3228971887,'Leo'],
  [3228971887,3229152936,'Virgo'],
  [3229152936,3229334753,'Libra'],
  [3229334753,3229521812,'Scorpio'],
  [3229521812,3229718954,'Sagittarius'],
  [3229718954,3229928423,'Capricorn'],
  [3229928423,3230146507,'Aquarius'],
  [3230146507,3230364043,'Pisces'],
  [3230364043,3230572554,'Aries'],
  [3230572554,3230769475,'Taurus'],
  [3230769475,3230957555,'Gemini'],
  [3230957555,3231141321,'Cancer'],
  [3231141321,3231324356,'Leo'],
  [3231324356,3231508476,'Virgo'],
  [3231508476,3231694737,'Libra'],
  [3231694737,3231885123,'Scorpio'],
  [3231885123,3232082942,'Sagittarius'],
  [3232082942,3232290975,'Capricorn'],
  [3232290975,3232507963,'Aquarius'],
  [3232507963,3232726589,'Pisces'],
  [3232726589,3232937165,'Aries'],
  [3232937165,3233134484,'Taurus'],
  [3233134484,3233320087,'Gemini'],
  [3233320087,3233499391,'Cancer'],
  [3233499391,3233678198,'Leo'],
  [3233678198,3233860562,'Virgo'],
  [3233860562,3234048264,'Libra'],
  [3234048264,3234241926,'Scorpio'],
  [3234241926,3234442483,'Sagittarius'],
  [3234442483,3234651253,'Capricorn'],
  [3234651253,3234867828,'Aquarius'],
  [3234867828,3235087314,'Pisces'],
  [3235087314,3235300983,'Aries'],
  [3235300983,3235501639,'Taurus'],
  [3235501639,3235688255,'Gemini'],
  [3235688255,3235865258,'Cancer'],
  [3235865258,3236039243,'Leo'],
  [3236039243,3236216393,'Virgo'],
  [3236216393,3236400942,'Libra'],
  [3236400942,3236594633,'Scorpio'],
  [3236594633,3236797318,'Sagittarius'],
  [3236797318,3237007982,'Capricorn'],
  [3237007982,3237225004,'Aquarius'],
  [3237225004,3237444772,'Pisces'],
  [3237444772,3237660843,'Aries'],
  [3237660843,3237866149,'Taurus'],
  [3237866149,3238057210,'Gemini'],
  [3238057210,3238235970,'Cancer'],
  [3238235970,3238408048,'Leo'],
  [3238408048,3238580294,'Virgo'],
  [3238580294,3238759033,'Libra'],
  [3238759033,3238948641,'Scorpio'],
  [3238948641,3239150370,'Sagittarius'],
  [3239150370,3239362166,'Capricorn'],
  [3239362166,3239580060,'Aquarius'],
  [3239580060,3239799650,'Pisces'],
  [3239799650,3240016214,'Aries'],
  [3240016214,3240224786,'Taurus'],
  [3240224786,3240421457,'Gemini'],
  [3240421457,3240605546,'Cancer'],
  [3240605546,3240780166,'Leo'],
  [3240780166,3240951074,'Virgo'],
  [3240951074,3241125146,'Libra'],
  [3241125146,3241308840,'Scorpio'],
  [3241308840,3241506198,'Sagittarius'],
  [3241506198,3241716657,'Capricorn'],
  [3241716657,3241934944,'Aquarius'],
  [3241934944,3242154315,'Pisces'],
  [3242154315,3242369750,'Aries'],
  [3242369750,3242578394,'Taurus'],
  [3242578394,3242778314,'Gemini'],
  [3242778314,3242968269,'Cancer'],
  [3242968269,3243148771,'Leo'],
  [3243148771,3243322964,'Virgo'],
  [3243322964,3243496444,'Libra'],
  [3243496444,3243676075,'Scorpio'],
  [3243676075,3243868008,'Sagittarius'],
  [3243868008,3244074617,'Capricorn'],
  [3244074617,3244291900,'Aquarius'],
  [3244291900,3244511301,'Pisces'],
  [3244511301,3244725514,'Aries'],
  [3244725514,3244931839,'Taurus'],
  [3244931839,3245130714,'Gemini'],
  [3245130714,3245322942,'Cancer'],
  [3245322942,3245508757,'Leo'],
  [3245508757,3245688909,'Virgo'],
  [3245688909,3245866275,'Libra'],
  [3245866275,3246046174,'Scorpio'],
  [3246046174,3246234986,'Sagittarius'],
  [3246234986,3246437308,'Capricorn'],
  [3246437308,3246652138,'Aquarius'],
  [3246652138,3246871599,'Pisces'],
  [3246871599,3247085978,'Aries'],
  [3247085978,3247290390,'Taurus'],
  [3247290390,3247485723,'Gemini'],
  [3247485723,3247675241,'Cancer'],
  [3247675241,3247861511,'Leo'],
  [3247861511,3248045590,'Virgo'],
  [3248045590,3248228381,'Libra'],
  [3248228381,3248412445,'Scorpio'],
  [3248412445,3248602288,'Sagittarius'],
  [3248602288,3248802609,'Capricorn'],
  [3248802609,3249014851,'Aquarius'],
  [3249014851,3249233966,'Pisces'],
  [3249233966,3249450046,'Aries'],
  [3249450046,3249655291,'Taurus'],
  [3249655291,3249848539,'Gemini'],
  [3249848539,3250033555,'Cancer'],
  [3250033555,3250215312,'Leo'],
  [3250215312,3250397561,'Virgo'],
  [3250397561,3250582250,'Libra'],
  [3250582250,3250770576,'Scorpio'],
  [3250770576,3250964337,'Sagittarius'],
  [3250964337,3251166069,'Capricorn'],
  [3251166069,3251377353,'Aquarius'],
  [3251377353,3251595807,'Pisces'],
  [3251595807,3251813890,'Aries'],
  [3251813890,3252022684,'Taurus'],
  [3252022684,3252217830,'Gemini'],
  [3252217830,3252401144,'Cancer'],
  [3252401144,3252577973,'Leo'],
  [3252577973,3252754301,'Virgo'],
  [3252754301,3252934997,'Libra'],
  [3252934997,3253123012,'Scorpio'],
  [3253123012,3253319461,'Sagittarius'],
  [3253319461,3253524289,'Capricorn'],
  [3253524289,3253736803,'Aquarius'],
  [3253736803,3253954984,'Pisces'],
  [3253954984,3254174056,'Aries'],
  [3254174056,3254386816,'Taurus'],
  [3254386816,3254587100,'Gemini'],
  [3254587100,3254773479,'Cancer'],
  [3254773479,3254949391,'Leo'],
  [3254949391,3255121005,'Virgo'],
  [3255121005,3255295145,'Libra'],
  [3255295145,3255477693,'Scorpio'],
  [3255477693,3255672048,'Sagittarius'],
  [3255672048,3255878015,'Capricorn'],
  [3255878015,3256092426,'Aquarius'],
  [3256092426,3256311146,'Pisces'],
  [3256311146,3256530097,'Aries'],
  [3256530097,3256744774,'Taurus'],
  [3256744774,3256950105,'Gemini'],
  [3256950105,3257142590,'Cancer'],
  [3257142590,3257322523,'Leo'],
  [3257322523,3257494181,'Virgo'],
  [3257494181,3257664363,'Libra'],
  [3257664363,3257840548,'Scorpio'],
  [3257840548,3258028947,'Sagittarius'],
  [3258028947,3258231933,'Capricorn'],
  [3258231933,3258446397,'Aquarius'],
  [3258446397,3258665808,'Pisces'],
  [3258665808,3258884326,'Aries'],
  [3258884326,3259098490,'Taurus'],
  [3259098490,3259305743,'Gemini'],
  [3259305743,3259503336,'Cancer'],
  [3259503336,3259689596,'Leo'],
  [3259689596,3259865857,'Virgo'],
  [3259865857,3260037025,'Libra'],
  [3260037025,3260210289,'Scorpio'],
  [3260210289,3260393130,'Sagittarius'],
  [3260393130,3260590647,'Capricorn'],
  [3260590647,3260802298,'Aquarius'],
  [3260802298,3261021384,'Pisces'],
  [3261021384,3261239677,'Aries'],
  [3261239677,3261452387,'Taurus'],
  [3261452387,3261658296,'Gemini'],
  [3261658296,3261857010,'Cancer'],
  [3261857010,3262047608,'Leo'],
  [3262047608,3262229776,'Virgo'],
  [3262229776,3262405741,'Libra'],
  [3262405741,3262580740,'Scorpio'],
  [3262580740,3262761682,'Sagittarius'],
  [3262761682,3262954798,'Capricorn'],
  [3262954798,3263162283,'Aquarius'],
  [3263162283,3263379652,'Pisces'],
  [3263379652,3263597907,'Aries'],
  [3263597907,3263809846,'Taurus'],
  [3263809846,3264013372,'Gemini'],
  [3264013372,3264209633,'Cancer'],
  [3264209633,3264400042,'Leo'],
  [3264400042,3264585254,'Virgo'],
  [3264585254,3264766263,'Libra'],
  [3264766263,3264945896,'Scorpio'],
  [3264945896,3265128994,'Sagittarius'],
  [3265128994,3265321040,'Capricorn'],
  [3265321040,3265525480,'Aquarius'],
  [3265525480,3265740576,'Pisces'],
  [3265740576,3265958820,'Aries'],
  [3265958820,3266171440,'Taurus'],
  [3266171440,3266373973,'Gemini'],
  [3266373973,3266567085,'Cancer'],
  [3266567085,3266753859,'Leo'],
  [3266753859,3266937356,'Virgo'],
  [3266937356,3267119849,'Libra'],
  [3267119849,3267303395,'Scorpio'],
  [3267303395,3267490641,'Sagittarius'],
  [3267490641,3267684871,'Capricorn'],
  [3267684871,3267888828,'Aquarius'],
  [3267888828,3268102359,'Pisces'],
  [3268102359,3268320541,'Aries'],
  [3268320541,3268535077,'Taurus'],
  [3268535077,3268739209,'Gemini'],
  [3268739209,3268931380,'Cancer'],
  [3268931380,3269114468,'Leo'],
  [3269114468,3269293266,'Virgo'],
  [3269293266,3269472526,'Libra'],
  [3269472526,3269655937,'Scorpio'],
  [3269655937,3269845831,'Sagittarius'],
  [3269845831,3270043425,'Capricorn'],
  [3270043425,3270249204,'Aquarius'],
  [3270249204,3270462616,'Pisces'],
  [3270462616,3270680708,'Aries'],
  [3270680708,3270897366,'Taurus'],
  [3270897366,3271105241,'Gemini'],
  [3271105241,3271299999,'Cancer'],
  [3271299999,3271482455,'Leo'],
  [3271482455,3271657349,'Virgo'],
  [3271657349,3271831118,'Libra'],
  [3271831118,3272009969,'Scorpio'],
  [3272009969,3272198243,'Sagittarius'],
  [3272198243,3272397223,'Capricorn'],
  [3272397223,3272605349,'Aquarius'],
  [3272605349,3272819900,'Pisces'],
  [3272819900,3273037989,'Aries'],
  [3273037989,3273255763,'Taurus'],
  [3273255763,3273467517,'Gemini'],
  [3273467517,3273667509,'Cancer'],
  [3273667509,3273853550,'Leo'],
  [3273853550,3274028416,'Virgo'],
  [3274028416,3274198486,'Libra'],
  [3274198486,3274371454,'Scorpio'],
  [3274371454,3274554214,'Sagittarius'],
  [3274554214,3274750444,'Capricorn'],
  [3274750444,3274958878,'Aquarius'],
  [3274958878,3275174693,'Pisces'],
  [3275174693,3275393011,'Aries'],
  [3275393011,3275610511,'Taurus'],
  [3275610511,3275823931,'Gemini'],
  [3275823931,3276028750,'Cancer'],
  [3276028750,3276221008,'Leo'],
  [3276221008,3276400420,'Virgo'],
  [3276400420,3276571388,'Libra'],
  [3276571388,3276741317,'Scorpio'],
  [3276741317,3276918304,'Sagittarius'],
  [3276918304,3277108662,'Capricorn'],
  [3277108662,3277313847,'Aquarius'],
  [3277313847,3277529347,'Pisces'],
  [3277529347,3277748009,'Aries'],
  [3277748009,3277964679,'Taurus'],
  [3277964679,3278177018,'Gemini'],
  [3278177018,3278383080,'Cancer'],
  [3278383080,3278580062,'Leo'],
  [3278580062,3278766003,'Virgo'],
  [3278766003,3278942321,'Libra'],
  [3278942321,3279114258,'Scorpio'],
  [3279114258,3279289199,'Sagittarius'],
  [3279289199,3279474425,'Capricorn'],
  [3279474425,3279674202,'Aquarius'],
  [3279674202,3279886884,'Pisces'],
  [3279886884,3280105325,'Aries'],
  [3280105325,3280321772,'Taurus'],
  [3280321772,3280532208,'Gemini'],
  [3280532208,3280735883,'Cancer'],
  [3280735883,3280932719,'Leo'],
  [3280932719,3281122207,'Virgo'],
  [3281122207,3281304549,'Libra'],
  [3281304549,3281482215,'Scorpio'],
  [3281482215,3281660113,'Sagittarius'],
  [3281660113,3281844361,'Capricorn'],
  [3281844361,3282040131,'Aquarius'],
  [3282040131,3282248787,'Pisces'],
  [3282248787,3282465862,'Aries'],
  [3282465862,3282682930,'Taurus'],
  [3282682930,3282893042,'Gemini'],
  [3282893042,3283093954,'Cancer'],
  [3283093954,3283286934,'Leo'],
  [3283286934,3283474314,'Virgo'],
  [3283474314,3283658192,'Libra'],
  [3283658192,3283840537,'Scorpio'],
  [3283840537,3284023842,'Sagittarius'],
  [3284023842,3284211473,'Capricorn'],
  [3284211473,3284407142,'Aquarius'],
  [3284407142,3284613233,'Pisces'],
  [3284613233,3284828376,'Aries'],
  [3284828376,3285046220,'Taurus'],
  [3285046220,3285258281,'Gemini'],
  [3285258281,3285459221,'Cancer'],
  [3285459221,3285649027,'Leo'],
  [3285649027,3285831399,'Virgo'],
  [3285831399,3286011225,'Libra'],
  [3286011225,3286192768,'Scorpio'],
  [3286192768,3286378823,'Sagittarius'],
  [3286378823,3286570813,'Capricorn'],
  [3286570813,3286769619,'Aquarius'],
  [3286769619,3286976115,'Pisces'],
  [3286976115,3287190147,'Aries'],
  [3287190147,3287408332,'Taurus'],
  [3287408332,3287623373,'Gemini'],
  [3287623373,3287827665,'Cancer'],
  [3287827665,3288018165,'Leo'],
  [3288018165,3288197518,'Virgo'],
  [3288197518,3288371831,'Libra'],
  [3288371831,3288547897,'Scorpio'],
  [3288547897,3288731080,'Sagittarius'],
  [3288731080,3288923815,'Capricorn'],
  [3288923815,3289125516,'Aquarius'],
  [3289125516,3289334358,'Pisces'],
  [3289334358,3289548849,'Aries'],
  [3289548849,3289767037,'Taurus'],
  [3289767037,3289984260,'Gemini'],
  [3289984260,3290193212,'Cancer'],
  [3290193212,3290388199,'Leo'],
  [3290388199,3290569070,'Virgo'],
  [3290569070,3290741013,'Libra'],
  [3290741013,3290911714,'Scorpio'],
  [3290911714,3291088723,'Sagittarius'],
  [3291088723,3291277217,'Capricorn'],
  [3291277217,3291478107,'Aquarius'],
  [3291478107,3291688433,'Pisces'],
  [3291688433,3291904213,'Aries'],
  [3291904213,3292122482,'Taurus'],
  [3292122482,3292340226,'Gemini'],
  [3292340226,3292552359,'Cancer'],
  [3292552359,3292752892,'Leo'],
  [3292752892,3292938983,'Virgo'],
  [3292938983,3293113286,'Libra'],
  [3293113286,3293282517,'Scorpio'],
  [3293282517,3293454731,'Sagittarius'],
  [3293454731,3293637043,'Capricorn'],
  [3293637043,3293833213,'Aquarius'],
  [3293833213,3294041962,'Pisces'],
  [3294041962,3294258223,'Aries'],
  [3294258223,3294476706,'Taurus'],
  [3294476706,3294693804,'Gemini'],
  [3294693804,3294906281,'Cancer'],
  [3294906281,3295110080,'Leo'],
  [3295110080,3295301850,'Virgo'],
  [3295301850,3295481720,'Libra'],
  [3295481720,3295654024,'Scorpio'],
  [3295654024,3295825642,'Sagittarius'],
  [3295825642,3296003905,'Capricorn'],
  [3296003905,3296194466,'Aquarius'],
  [3296194466,3296398935,'Pisces'],
  [3296398935,3296613748,'Aries'],
  [3296613748,3296832214,'Taurus'],
  [3296832214,3297048543,'Gemini'],
  [3297048543,3297259380,'Cancer'],
  [3297259380,3297462738,'Leo'],
  [3297462738,3297657113,'Virgo'],
  [3297657113,3297842194,'Libra'],
  [3297842194,3298020056,'Scorpio'],
  [3298020056,3298195200,'Sagittarius'],
  [3298195200,3298373540,'Capricorn'],
  [3298373540,3298560869,'Aquarius'],
  [3298560869,3298760823,'Pisces'],
  [3298760823,3298972648,'Aries'],
  [3298972648,3299190543,'Taurus'],
  [3299190543,3299406764,'Gemini'],
  [3299406764,3299615982,'Cancer'],
  [3299615982,3299816579,'Leo'],
  [3299816579,3300009324,'Virgo'],
  [3300009324,3300195801,'Libra'],
  [3300195801,3300377933,'Scorpio'],
  [3300377933,3300558260,'Sagittarius'],
  [3300558260,3300740242,'Capricorn'],
  [3300740242,3300928089,'Aquarius'],
  [3300928089,3301125708,'Pisces'],
  [3301125708,3301334588,'Aries'],
  [3301334588,3301551438,'Taurus'],
  [3301551438,3301768419,'Gemini'],
  [3301768419,3301977726,'Cancer'],
  [3301977726,3302176075,'Leo'],
  [3302176075,3302365004,'Virgo'],
  [3302365004,3302548455,'Libra'],
  [3302548455,3302730403,'Scorpio'],
  [3302730403,3302913689,'Sagittarius'],
  [3302913689,3303100108,'Capricorn'],
  [3303100108,3303291358,'Aquarius'],
  [3303291358,3303489730,'Pisces'],
  [3303489730,3303697241,'Aries'],
  [3303697241,3303913057,'Taurus'],
  [3303913057,3304131254,'Gemini'],
  [3304131254,3304342848,'Cancer'],
  [3304342848,3304541758,'Leo'],
  [3304541758,3304728181,'Virgo'],
  [3304728181,3304906995,'Libra'],
  [3304906995,3305084489,'Scorpio'],
  [3305084489,3305265825,'Sagittarius'],
  [3305265825,3305453638,'Capricorn'],
  [3305453638,3305648266,'Aquarius'],
  [3305648266,3305849485,'Pisces'],
  [3305849485,3306057757,'Aries'],
  [3306057757,3306273113,'Taurus'],
  [3306273113,3306492210,'Gemini'],
  [3306492210,3306707205,'Cancer'],
  [3306707205,3306909942,'Leo'],
  [3306909942,3307097722,'Virgo'],
  [3307097722,3307274271,'Libra'],
  [3307274271,3307446694,'Scorpio'],
  [3307446694,3307622334,'Sagittarius'],
  [3307622334,3307806490,'Capricorn'],
  [3307806490,3308000897,'Aquarius'],
  [3308000897,3308204276,'Pisces'],
  [3308204276,3308414581,'Aries'],
  [3308414581,3308630388,'Taurus'],
  [3308630388,3308849610,'Gemini'],
  [3308849610,3309066987,'Cancer'],
  [3309066987,3309274819,'Leo'],
  [3309274819,3309467823,'Virgo'],
  [3309467823,3309646835,'Libra'],
  [3309646835,3309817746,'Scorpio'],
  [3309817746,3309988384,'Sagittarius'],
  [3309988384,3310166070,'Capricorn'],
  [3310166070,3310355524,'Aquarius'],
  [3310355524,3310557366,'Pisces'],
  [3310557366,3310768719,'Aries'],
  [3310768719,3310985568,'Taurus'],
  [3310985568,3311204529,'Gemini'],
  [3311204529,3311421966,'Cancer'],
  [3311421966,3311632743,'Leo'],
  [3311632743,3311831692,'Virgo'],
  [3311831692,3312016971,'Libra'],
  [3312016971,3312191565,'Scorpio'],
  [3312191565,3312361790,'Sagittarius'],
  [3312361790,3312535056,'Capricorn'],
  [3312535056,3312717989,'Aquarius'],
  [3312717989,3312914415,'Pisces'],
  [3312914415,3313123664,'Aries'],
  [3313123664,3313340847,'Taurus'],
  [3313340847,3313559829,'Gemini'],
  [3313559829,3313775925,'Cancer'],
  [3313775925,3313985927,'Leo'],
  [3313985927,3314187260,'Virgo'],
  [3314187260,3314378273,'Libra'],
  [3314378273,3314559542,'Scorpio'],
  [3314559542,3314734422,'Sagittarius'],
  [3314734422,3314908411,'Capricorn'],
  [3314908411,3315087913,'Aquarius'],
  [3315087913,3315278603,'Pisces'],
  [3315278603,3315483094,'Aries'],
  [3315483094,3315698644,'Taurus'],
  [3315698644,3315917826,'Gemini'],
  [3315917826,3316133117,'Cancer'],
  [3316133117,3316340579,'Leo'],
  [3316340579,3316539766,'Virgo'],
  [3316539766,3316731654,'Libra'],
  [3316731654,3316917410,'Scorpio'],
  [3316917410,3317098514,'Sagittarius'],
  [3317098514,3317277534,'Capricorn'],
  [3317277534,3317458649,'Aquarius'],
  [3317458649,3317647111,'Pisces'],
  [3317647111,3317847352,'Aries'],
  [3317847352,3318059848,'Taurus'],
  [3318059848,3318278777,'Gemini'],
  [3318278777,3318494703,'Cancer'],
  [3318494703,3318700936,'Leo'],
  [3318700936,3318896643,'Virgo'],
  [3318896643,3319084920,'Libra'],
  [3319084920,3319269564,'Scorpio'],
  [3319269564,3319453196,'Sagittarius'],
  [3319453196,3319637188,'Capricorn'],
  [3319637188,3319823011,'Aquarius'],
  [3319823011,3320013550,'Pisces'],
  [3320013550,3320212702,'Aries'],
  [3320212702,3320422791,'Taurus'],
  [3320422791,3320640957,'Gemini'],
  [3320640957,3320858461,'Cancer'],
  [3320858461,3321066145,'Leo'],
  [3321066145,3321260686,'Virgo'],
  [3321260686,3321445032,'Libra'],
  [3321445032,3321624888,'Scorpio'],
  [3321624888,3321805480,'Sagittarius'],
  [3321805480,3321989855,'Capricorn'],
  [3321989855,3322178967,'Aquarius'],
  [3322178967,3322373351,'Pisces'],
  [3322373351,3322574540,'Aries'],
  [3322574540,3322784352,'Taurus'],
  [3322784352,3323001897,'Gemini'],
  [3323001897,3323220914,'Cancer'],
  [3323220914,3323431946,'Leo'],
  [3323431946,3323628889,'Virgo'],
  [3323628889,3323812534,'Libra'],
  [3323812534,3323988481,'Scorpio'],
  [3323988481,3324163571,'Sagittarius'],
  [3324163571,3324343419,'Capricorn'],
  [3324343419,3324531070,'Aquarius'],
  [3324531070,3324727100,'Pisces'],
  [3324727100,3324931009,'Aries'],
  [3324931009,3325142347,'Taurus'],
  [3325142347,3325359978,'Gemini'],
  [3325359978,3325579758,'Cancer'],
  [3325579758,3325794088,'Leo'],
  [3325794088,3325995751,'Virgo'],
  [3325995751,3326182705,'Libra'],
  [3326182705,3326358625,'Scorpio'],
  [3326358625,3326530145,'Sagittarius'],
  [3326530145,3326704238,'Capricorn'],
  [3326704238,3326886484,'Aquarius'],
  [3326886484,3327079818,'Pisces'],
  [3327079818,3327284123,'Aries'],
  [3327284123,3327497036,'Taurus'],
  [3327497036,3327715350,'Gemini'],
  [3327715350,3327935122,'Cancer'],
  [3327935122,3328150986,'Leo'],
  [3328150986,3328357003,'Virgo'],
  [3328357003,3328549540,'Libra'],
  [3328549540,3328729518,'Scorpio'],
  [3328729518,3328901709,'Sagittarius'],
  [3328901709,3329072736,'Capricorn'],
  [3329072736,3329249384,'Aquarius'],
  [3329249384,3329437097,'Pisces'],
  [3329437097,3329638242,'Aries'],
  [3329638242,3329850865,'Taurus'],
  [3329850865,3330069737,'Gemini'],
  [3330069737,3330289164,'Cancer'],
  [3330289164,3330504500,'Leo'],
  [3330504500,3330712120,'Virgo'],
  [3330712120,3330909281,'Libra'],
  [3330909281,3331095204,'Scorpio'],
  [3331095204,3331271977,'Sagittarius'],
  [3331271977,3331444299,'Capricorn'],
  [3331444299,3331618489,'Aquarius'],
  [3331618489,3331801131,'Pisces'],
  [3331801131,3331997115,'Aries'],
  [3331997115,3332206946,'Taurus'],
  [3332206946,3332425420,'Gemini'],
  [3332425420,3332644600,'Cancer'],
  [3332644600,3332858494,'Leo'],
  [3332858494,3333064692,'Virgo'],
  [3333064692,3333262814,'Libra'],
  [3333262814,3333452890,'Scorpio'],
  [3333452890,3333635469,'Sagittarius'],
  [3333635469,3333812631,'Capricorn'],
  [3333812631,3333988654,'Aquarius'],
  [3333988654,3334169536,'Pisces'],
  [3334169536,3334361317,'Aries'],
  [3334361317,3334567128,'Taurus'],
  [3334567128,3334783955,'Gemini'],
  [3334783955,3335003147,'Cancer'],
  [3335003147,3335216266,'Leo'],
  [3335216266,3335419985,'Virgo'],
  [3335419985,3335615500,'Libra'],
  [3335615500,3335805257,'Scorpio'],
  [3335805257,3335990854,'Sagittarius'],
  [3335990854,3336173183,'Capricorn'],
  [3336173183,3336354005,'Aquarius'],
  [3336354005,3336537139,'Pisces'],
  [3336537139,3336727895,'Aries'],
  [3336727895,3336930679,'Taurus'],
  [3336930679,3337145252,'Gemini'],
  [3337145252,3337364553,'Cancer'],
  [3337364553,3337578541,'Leo'],
  [3337578541,3337781335,'Virgo'],
  [3337781335,3337973558,'Libra'],
  [3337973558,3338159361,'Scorpio'],
  [3338159361,3338342892,'Sagittarius'],
  [3338342892,3338526555,'Capricorn'],
  [3338526555,3338711422,'Aquarius'],
  [3338711422,3338898973,'Pisces'],
  [3338898973,3339092162,'Aries'],
  [3339092162,3339294561,'Taurus'],
  [3339294561,3339507496,'Gemini'],
  [3339507496,3339726718,'Cancer'],
  [3339726718,3339942920,'Leo'],
  [3339942920,3340147804,'Virgo'],
  [3340147804,3340339429,'Libra'],
  [3340339429,3340521509,'Scorpio'],
  [3340521509,3340699833,'Sagittarius'],
  [3340699833,3340879512,'Capricorn'],
  [3340879512,3341063693,'Aquarius'],
  [3341063693,3341253783,'Pisces'],
  [3341253783,3341450622,'Aries'],
  [3341450622,3341655240,'Taurus'],
  [3341655240,3341868162,'Gemini'],
  [3341868162,3342087091,'Cancer'],
  [3342087091,3342305373,'Leo'],
  [3342305373,3342514535,'Virgo'],
  [3342514535,3342709674,'Libra'],
  [3342709674,3342891948,'Scorpio'],
  [3342891948,3343066631,'Sagittarius'],
  [3343066631,3343240287,'Capricorn'],
  [3343240287,3343418835,'Aquarius'],
  [3343418835,3343606272,'Pisces'],
  [3343606272,3343804019,'Aries'],
  [3343804019,3344011190,'Taurus'],
  [3344011190,3344225642,'Gemini'],
  [3344225642,3344444504,'Cancer'],
  [3344444504,3344663402,'Leo'],
  [3344663402,3344876221,'Virgo'],
  [3344876221,3345077208,'Libra'],
  [3345077208,3345264343,'Scorpio'],
  [3345264343,3345440299,'Sagittarius'],
  [3345440299,3345610943,'Capricorn'],
  [3345610943,3345783375,'Aquarius'],
  [3345783375,3345964259,'Pisces'],
  [3345964259,3346157969,'Aries'],
  [3346157969,3346364717,'Taurus'],
  [3346364717,3346580526,'Gemini'],
  [3346580526,3346799875,'Cancer'],
  [3346799875,3347018156,'Leo'],
  [3347018156,3347231727,'Virgo'],
  [3347231727,3347436887,'Libra'],
  [3347436887,3347630572,'Scorpio'],
  [3347630572,3347812330,'Sagittarius'],
  [3347812330,3347985360,'Capricorn'],
  [3347985360,3348155841,'Aquarius'],
  [3348155841,3348331273,'Pisces'],
  [3348331273,3348518491,'Aries'],
  [3348518491,3348720846,'Taurus'],
  [3348720846,3348935631,'Gemini'],
  [3348935631,3349155399,'Cancer'],
  [3349155399,3349373057,'Leo'],
  [3349373057,3349585076,'Virgo'],
  [3349585076,3349790266,'Libra'],
  [3349790266,3349987473,'Scorpio'],
  [3349987473,3350175462,'Sagittarius'],
  [3350175462,3350354595,'Capricorn'],
  [3350354595,3350528366,'Aquarius'],
  [3350528366,3350703064,'Pisces'],
  [3350703064,3350886004,'Aries'],
  [3350886004,3351082859,'Taurus'],
  [3351082859,3351294061,'Gemini'],
  [3351294061,3351513129,'Cancer'],
  [3351513129,3351730788,'Leo'],
  [3351730788,3351941282,'Virgo'],
  [3351941282,3352143835,'Libra'],
  [3352143835,3352339737,'Scorpio'],
  [3352339737,3352529743,'Sagittarius'],
  [3352529743,3352713930,'Capricorn'],
  [3352713930,3352893429,'Aquarius'],
  [3352893429,3353071894,'Pisces'],
  [3353071894,3353255119,'Aries'],
  [3353255119,3353449032,'Taurus'],
  [3353449032,3353656408,'Gemini'],
  [3353656408,3353873642,'Cancer'],
  [3353873642,3354091681,'Leo'],
  [3354091681,3354302274,'Virgo'],
  [3354302274,3354502753,'Libra'],
  [3354502753,3354695018,'Scorpio'],
  [3354695018,3354882193,'Sagittarius'],
  [3354882193,3355066531,'Capricorn'],
  [3355066531,3355249425,'Aquarius'],
  [3355249425,3355432714,'Pisces'],
  [3355432714,3355619648,'Aries'],
  [3355619648,3355814426,'Taurus'],
  [3355814426,3356020104,'Gemini'],
  [3356020104,3356235534,'Cancer'],
  [3356235534,3356453951,'Leo'],
  [3356453951,3356666351,'Virgo'],
  [3356666351,3356867368,'Libra'],
  [3356867368,3357057354,'Scorpio'],
  [3357057354,3357240142,'Sagittarius'],
  [3357240142,3357420288,'Capricorn'],
  [3357420288,3357601523,'Aquarius'],
  [3357601523,3357786459,'Pisces'],
  [3357786459,3357977027,'Aries'],
  [3357977027,3358174966,'Taurus'],
  [3358174966,3358381600,'Gemini'],
  [3358381600,3358596367,'Cancer'],
  [3358596367,3358815005,'Leo'],
  [3358815005,3359029949,'Virgo'],
  [3359029949,3359234162,'Libra'],
  [3359234162,3359425280,'Scorpio'],
  [3359425280,3359605863,'Sagittarius'],
  [3359605863,3359781211,'Capricorn'],
  [3359781211,3359957248,'Aquarius'],
  [3359957248,3360139031,'Pisces'],
  [3360139031,3360329701,'Aries'],
  [3360329701,3360530026,'Taurus'],
  [3360530026,3360738923,'Gemini'],
  [3360738923,3360954349,'Cancer'],
  [3360954349,3361173083,'Leo'],
  [3361173083,3361389953,'Virgo'],
  [3361389953,3361598443,'Libra'],
  [3361598443,3361793904,'Scorpio'],
  [3361793904,3361976258,'Sagittarius'],
  [3361976258,3362149722,'Capricorn'],
  [3362149722,3362320921,'Aquarius'],
  [3362320921,3362496926,'Pisces'],
  [3362496926,3362683418,'Aries'],
  [3362683418,3362882703,'Taurus'],
  [3362882703,3363092847,'Gemini'],
  [3363092847,3363309469,'Cancer'],
  [3363309469,3363528296,'Leo'],
  [3363528296,3363745633,'Virgo'],
  [3363745633,3363957131,'Libra'],
  [3363957131,3364157961,'Scorpio'],
  [3364157961,3364345497,'Sagittarius'],
  [3364345497,3364521406,'Capricorn'],
  [3364521406,3364691291,'Aquarius'],
  [3364691291,3364862757,'Pisces'],
  [3364862757,3365043339,'Aries'],
  [3365043339,3365238012,'Taurus'],
  [3365238012,3365446534,'Gemini'],
  [3365446534,3365663546,'Cancer'],
  [3365663546,3365882505,'Leo'],
  [3365882505,3366099125,'Virgo'],
  [3366099125,3366310892,'Libra'],
  [3366310892,3366514958,'Scorpio'],
  [3366514958,3366708250,'Sagittarius'],
  [3366708250,3366889873,'Capricorn'],
  [3366889873,3367062925,'Aquarius'],
  [3367062925,3367233855,'Pisces'],
  [3367233855,3367410469,'Aries'],
  [3367410469,3367599569,'Taurus'],
  [3367599569,3367803769,'Gemini'],
  [3367803769,3368019286,'Cancer'],
  [3368019286,3368238215,'Leo'],
  [3368238215,3368454007,'Virgo'],
  [3368454007,3368663989,'Libra'],
  [3368663989,3368867434,'Scorpio'],
  [3368867434,3369063276,'Sagittarius'],
  [3369063276,3369250315,'Capricorn'],
  [3369250315,3369429272,'Aquarius'],
  [3369429272,3369604050,'Pisces'],
  [3369604050,3369780971,'Aries'],
  [3369780971,3369966880,'Taurus'],
  [3369966880,3370166386,'Gemini'],
  [3370166386,3370378710,'Cancer'],
  [3370378710,3370597058,'Leo'],
  [3370597058,3370812891,'Virgo'],
  [3370812891,3371021287,'Libra'],
  [3371021287,3371221708,'Scorpio'],
  [3371221708,3371415433,'Sagittarius'],
  [3371415433,3371603515,'Capricorn'],
  [3371603515,3371786811,'Aquarius'],
  [3371786811,3371967213,'Pisces'],
  [3371967213,3372148394,'Aries'],
  [3372148394,3372335315,'Taurus'],
  [3372335315,3372532552,'Gemini'],
  [3372532552,3372741635,'Cancer'],
  [3372741635,3372958720,'Leo'],
  [3372958720,3373175551,'Virgo'],
  [3373175551,3373384544,'Libra'],
  [3373384544,3373582975,'Scorpio'],
  [3373582975,3373772524,'Sagittarius'],
  [3373772524,3373956711,'Capricorn'],
  [3373956711,3374138964,'Aquarius'],
  [3374138964,3374321959,'Pisces'],
  [3374321959,3374507879,'Aries'],
  [3374507879,3374698952,'Taurus'],
  [3374698952,3374897569,'Gemini'],
  [3374897569,3375105348,'Cancer'],
  [3375105348,3375321050,'Leo'],
  [3375321050,3375539000,'Virgo'],
  [3375539000,3375750895,'Libra'],
  [3375750895,3375950868,'Scorpio'],
  [3375950868,3376138520,'Sagittarius'],
  [3376138520,3376317837,'Capricorn'],
  [3376317837,3376494626,'Aquarius'],
  [3376494626,3376674361,'Pisces'],
  [3376674361,3376860738,'Aries'],
  [3376860738,3377055107,'Taurus'],
  [3377055107,3377257160,'Gemini'],
  [3377257160,3377466242,'Cancer'],
  [3377466242,3377681433,'Leo'],
  [3377681433,3377899807,'Virgo'],
  [3377899807,3378115035,'Libra'],
  [3378115035,3378319680,'Scorpio'],
  [3378319680,3378510008,'Sagittarius'],
  [3378510008,3378688061,'Capricorn'],
  [3378688061,3378860012,'Aquarius'],
  [3378860012,3379033375,'Pisces'],
  [3379033375,3379214706,'Aries'],
  [3379214706,3379407521,'Taurus'],
  [3379407521,3379611216,'Gemini'],
  [3379611216,3379822594,'Cancer'],
  [3379822594,3380038568,'Leo'],
  [3380038568,3380256782,'Virgo'],
  [3380256782,3380473626,'Libra'],
  [3380473626,3380683024,'Scorpio'],
  [3380683024,3380879249,'Sagittarius'],
  [3380879249,3381061072,'Capricorn'],
  [3381061072,3381232817,'Aquarius'],
  [3381232817,3381402061,'Pisces'],
  [3381402061,3381576940,'Aries'],
  [3381576940,3381763795,'Taurus'],
  [3381763795,3381964625,'Gemini'],
  [3381964625,3382176313,'Cancer'],
  [3382176313,3382393381,'Leo'],
  [3382393381,3382611521,'Virgo'],
  [3382611521,3382827952,'Libra'],
  [3382827952,3383039184,'Scorpio'],
  [3383039184,3383240497,'Sagittarius'],
  [3383240497,3383428697,'Capricorn'],
  [3383428697,3383605064,'Aquarius'],
  [3383605064,3383775278,'Pisces'],
  [3383775278,3383947116,'Aries'],
  [3383947116,3384128126,'Taurus'],
  [3384128126,3384323116,'Gemini'],
  [3384323116,3384531706,'Cancer'],
  [3384531706,3384748489,'Leo'],
  [3384748489,3384966763,'Virgo'],
  [3384966763,3385182101,'Libra'],
  [3385182101,3385392107,'Scorpio'],
  [3385392107,3385594555,'Sagittarius'],
  [3385594555,3385787220,'Capricorn'],
  [3385787220,3385969722,'Aquarius'],
  [3385969722,3386144988,'Pisces'],
  [3386144988,3386318726,'Aries'],
  [3386318726,3386497757,'Taurus'],
  [3386497757,3386687963,'Gemini'],
  [3386687963,3386891792,'Cancer'],
  [3386891792,3387106353,'Leo'],
  [3387106353,3387324522,'Virgo'],
  [3387324522,3387539377,'Libra'],
  [3387539377,3387747276,'Scorpio'],
  [3387747276,3387947365,'Sagittarius'],
  [3387947365,3388139902,'Capricorn'],
  [3388139902,3388325609,'Aquarius'],
  [3388325609,3388506202,'Pisces'],
  [3388506202,3388684911,'Aries'],
  [3388684911,3388866317,'Taurus'],
  [3388866317,3389055400,'Gemini'],
  [3389055400,3389255785,'Cancer'],
  [3389255785,3389467396,'Leo'],
  [3389467396,3389685001,'Virgo'],
  [3389685001,3389900439,'Libra'],
  [3389900439,3390107547,'Scorpio'],
  [3390107547,3390304678,'Sagittarius'],
  [3390304678,3390493696,'Capricorn'],
  [3390493696,3390677792,'Aquarius'],
  [3390677792,3390860010,'Pisces'],
  [3390860010,3391042869,'Aries'],
  [3391042869,3391228707,'Taurus'],
  [3391228707,3391420183,'Gemini'],
  [3391420183,3391620079,'Cancer'],
  [3391620079,3391829739,'Leo'],
  [3391829739,3392046603,'Virgo'],
  [3392046603,3392263437,'Libra'],
  [3392263437,3392472023,'Scorpio'],
  [3392472023,3392668328,'Sagittarius'],
  [3392668328,3392853847,'Capricorn'],
  [3392853847,3393033440,'Aquarius'],
  [3393033440,3393212566,'Pisces'],
  [3393212566,3393395393,'Aries'],
  [3393395393,3393584021,'Taurus'],
  [3393584021,3393779063,'Gemini'],
  [3393779063,3393981018,'Cancer'],
  [3393981018,3394190619,'Leo'],
  [3394190619,3394407029,'Virgo'],
  [3394407029,3394625344,'Libra'],
  [3394625344,3394837188,'Scorpio'],
  [3394837188,3395035912,'Sagittarius'],
  [3395035912,3395220871,'Capricorn'],
  [3395220871,3395396801,'Aquarius'],
  [3395396801,3395570703,'Pisces'],
  [3395570703,3395749126,'Aries'],
  [3395749126,3395936184,'Taurus'],
  [3395936184,3396132653,'Gemini'],
  [3396132653,3396337141,'Cancer'],
  [3396337141,3396548202,'Leo'],
  [3396548202,3396764741,'Virgo'],
  [3396764741,3396983869,'Libra'],
  [3396983869,3397199045,'Scorpio'],
  [3397199045,3397402562,'Sagittarius'],
  [3397402562,3397590902,'Capricorn'],
  [3397590902,3397766863,'Aquarius'],
  [3397766863,3397937307,'Pisces'],
  [3397937307,3398110092,'Aries'],
  [3398110092,3398291750,'Taurus'],
  [3398291750,3398485433,'Gemini'],
  [3398485433,3398690194,'Cancer'],
  [3398690194,3398902748,'Leo'],
  [3398902748,3399119929,'Virgo'],
  [3399119929,3399339015,'Libra'],
  [3399339015,3399555716,'Scorpio'],
  [3399555716,3399763723,'Sagittarius'],
  [3399763723,3399957950,'Capricorn'],
  [3399957950,3400138271,'Aquarius'],
  [3400138271,3400309619,'Pisces'],
  [3400309619,3400479464,'Aries'],
  [3400479464,3400655427,'Taurus'],
  [3400655427,3400843208,'Gemini'],
  [3400843208,3401044536,'Cancer'],
  [3401044536,3401256674,'Leo'],
  [3401256674,3401474441,'Virgo'],
  [3401474441,3401693146,'Libra'],
  [3401693146,3401909124,'Scorpio'],
  [3401909124,3402118531,'Sagittarius'],
  [3402118531,3402317500,'Capricorn'],
  [3402317500,3402504258,'Aquarius'],
  [3402504258,3402680848,'Pisces'],
  [3402680848,3402852593,'Aries'],
  [3402852593,3403026365,'Taurus'],
  [3403026365,3403208839,'Gemini'],
  [3403208839,3403404476,'Cancer'],
  [3403404476,3403613386,'Leo'],
  [3403613386,3403830707,'Virgo'],
  [3403830707,3404049333,'Libra'],
  [3404049333,3404263788,'Scorpio'],
  [3404263788,3404471274,'Sagittarius'],
  [3404471274,3404670609,'Capricorn'],
  [3404670609,3404861356,'Aquarius'],
  [3404861356,3405044221,'Pisces'],
  [3405044221,3405221730,'Aries'],
  [3405221730,3405398270,'Taurus'],
  [3405398270,3405579440,'Gemini'],
  [3405579440,3405770676,'Cancer'],
  [3405770676,3405974987,'Leo'],
  [3405974987,3406190277,'Virgo'],
  [3406190277,3406409117,'Libra'],
  [3406409117,3406623198,'Scorpio'],
  [3406623198,3406828140,'Sagittarius'],
  [3406828140,3407024113,'Capricorn'],
  [3407024113,3407213478,'Aquarius'],
  [3407213478,3407398642,'Pisces'],
  [3407398642,3407581409,'Aries'],
  [3407581409,3407763588,'Taurus'],
  [3407763588,3407948033,'Gemini'],
  [3407948033,3408138869,'Cancer'],
  [3408138869,3408340118,'Leo'],
  [3408340118,3408552687,'Virgo'],
  [3408552687,3408771480,'Libra'],
  [3408771480,3408986982,'Scorpio'],
  [3408986982,3409191739,'Sagittarius'],
  [3409191739,3409384605,'Capricorn'],
  [3409384605,3409569347,'Aquarius'],
  [3409569347,3409751121,'Pisces'],
  [3409751121,3409933900,'Aries'],
  [3409933900,3410119562,'Taurus'],
  [3410119562,3410308790,'Gemini'],
  [3410308790,3410502898,'Cancer'],
  [3410502898,3410704446,'Leo'],
  [3410704446,3410915426,'Virgo'],
  [3410915426,3411133730,'Libra'],
  [3411133730,3411351433,'Scorpio'],
  [3411351433,3411559071,'Sagittarius'],
  [3411559071,3411752420,'Capricorn'],
  [3411752420,3411934138,'Aquarius'],
  [3411934138,3412110567,'Pisces'],
  [3412110567,3412288237,'Aries'],
  [3412288237,3412471611,'Taurus'],
  [3412471611,3412662219,'Gemini'],
  [3412662219,3412859749,'Cancer'],
  [3412859749,3413064031,'Leo'],
  [3413064031,3413275563,'Virgo'],
  [3413275563,3413493480,'Libra'],
  [3413493480,3413712668,'Scorpio'],
  [3413712668,3413924420,'Sagittarius'],
  [3413924420,3414122008,'Capricorn'],
  [3414122008,3414305183,'Aquarius'],
  [3414305183,3414479220,'Pisces'],
  [3414479220,3414651472,'Aries'],
  [3414651472,3414828704,'Taurus'],
  [3414828704,3415015296,'Gemini'],
  [3415015296,3415212382,'Cancer'],
  [3415212382,3415418637,'Leo'],
  [3415418637,3415631952,'Virgo'],
  [3415631952,3415850139,'Libra'],
  [3415850139,3416069560,'Scorpio'],
  [3416069560,3416284024,'Sagittarius'],
  [3416284024,3416486901,'Capricorn'],
  [3416486901,3416675305,'Aquarius'],
  [3416675305,3416851797,'Pisces'],
  [3416851797,3417022545,'Aries'],
  [3417022545,3417194795,'Taurus'],
  [3417194795,3417375014,'Gemini'],
  [3417375014,3417567281,'Cancer'],
  [3417567281,3417772033,'Leo'],
  [3417772033,3417986173,'Virgo'],
  [3417986173,3418205015,'Libra'],
  [3418205015,3418423981,'Scorpio'],
  [3418423981,3418638620,'Sagittarius'],
  [3418638620,3418844526,'Capricorn'],
  [3418844526,3419038562,'Aquarius'],
  [3419038562,3419220781,'Pisces'],
  [3419220781,3419394748,'Aries'],
  [3419394748,3419566356,'Taurus'],
  [3419566356,3419742334,'Gemini'],
  [3419742334,3419928714,'Cancer'],
  [3419928714,3420128855,'Leo'],
  [3420128855,3420341376,'Virgo'],
  [3420341376,3420560373,'Libra'],
  [3420560373,3420778913,'Scorpio'],
  [3420778913,3420992112,'Sagittarius'],
  [3420992112,3421197562,'Capricorn'],
  [3421197562,3421394135,'Aquarius'],
  [3421394135,3421581611,'Pisces'],
  [3421581611,3421761298,'Aries'],
  [3421761298,3421936541,'Taurus'],
  [3421936541,3422112591,'Gemini'],
  [3422112591,3422295633,'Cancer'],
  [3422295633,3422490939,'Leo'],
  [3422490939,3422699961,'Virgo'],
  [3422699961,3422918038,'Libra'],
  [3422918038,3423136523,'Scorpio'],
  [3423136523,3423348404,'Sagittarius'],
  [3423348404,3423551367,'Capricorn'],
  [3423551367,3423746446,'Aquarius'],
  [3423746446,3423935359,'Pisces'],
  [3423935359,3424119383,'Aries'],
  [3424119383,3424299905,'Taurus'],
  [3424299905,3424479683,'Gemini'],
  [3424479683,3424663341,'Cancer'],
  [3424663341,3424856277,'Leo'],
  [3424856277,3425061947,'Virgo'],
  [3425061947,3425278312,'Libra'],
  [3425278312,3425497111,'Scorpio'],
  [3425497111,3425709095,'Sagittarius'],
  [3425709095,3425910131,'Capricorn'],
  [3425910131,3426101761,'Aquarius'],
  [3426101761,3426287895,'Pisces'],
  [3426287895,3426471863,'Aries'],
  [3426471863,3426655417,'Taurus'],
  [3426655417,3426839698,'Gemini'],
  [3426839698,3427026908,'Cancer'],
  [3427026908,3427220799,'Leo'],
  [3427220799,3427425051,'Virgo'],
  [3427425051,3427639845,'Libra'],
  [3427639845,3427859094,'Scorpio'],
  [3427859094,3428072895,'Sagittarius'],
  [3428072895,3428274498,'Capricorn'],
  [3428274498,3428463944,'Aquarius'],
  [3428463944,3428645833,'Pisces'],
  [3428645833,3428825662,'Aries'],
  [3428825662,3429007481,'Taurus'],
  [3429007481,3429193266,'Gemini'],
  [3429193266,3429383967,'Cancer'],
  [3429383967,3429580963,'Leo'],
  [3429580963,3429786230,'Virgo'],
  [3429786230,3430000462,'Libra'],
  [3430000462,3430220007,'Scorpio'],
  [3430220007,3430436464,'Sagittarius'],
  [3430436464,3430641456,'Capricorn'],
  [3430641456,3430832222,'Aquarius'],
  [3430832222,3431012046,'Pisces'],
  [3431012046,3431187081,'Aries'],
  [3431187081,3431363518,'Taurus'],
  [3431363518,3431545919,'Gemini'],
  [3431545919,3431736565,'Cancer'],
  [3431736565,3431935920,'Leo'],
  [3431935920,3432143554,'Virgo'],
  [3432143554,3432358509,'Libra'],
  [3432358509,3432578096,'Scorpio'],
  [3432578096,3432796464,'Sagittarius'],
  [3432796464,3433006004,'Capricorn'],
  [3433006004,3433201637,'Aquarius'],
  [3433201637,3433383771,'Pisces'],
  [3433383771,3433557227,'Aries'],
  [3433557227,3433728698,'Taurus'],
  [3433728698,3433904831,'Gemini'],
  [3433904831,3434090745,'Cancer'],
  [3434090745,3434288715,'Leo'],
  [3434288715,3434497612,'Virgo'],
  [3434497612,3434713940,'Libra'],
  [3434713940,3434933574,'Scorpio'],
  [3434933574,3435152106,'Sagittarius'],
  [3435152106,3435364492,'Capricorn'],
  [3435364492,3435565880,'Aquarius'],
  [3435565880,3435754068,'Pisces'],
  [3435754068,3435930919,'Aries'],
  [3435930919,3436101631,'Taurus'],
  [3436101631,3436273139,'Gemini'],
  [3436273139,3436452517,'Cancer'],
  [3436452517,3436645057,'Leo'],
  [3436645057,3436851806,'Virgo'],
  [3436851806,3437068547,'Libra'],
  [3437068547,3437288469,'Scorpio'],
  [3437288469,3437506036,'Sagittarius'],
  [3437506036,3437718039,'Capricorn'],
  [3437718039,3437922167,'Aquarius'],
  [3437922167,3438116330,'Pisces'],
  [3438116330,3438299864,'Aries'],
  [3438299864,3438474935,'Taurus'],
  [3438474935,3438646748,'Gemini'],
  [3438646748,3438822377,'Cancer'],
  [3438822377,3439008883,'Leo'],
  [3439008883,3439210461,'Virgo'],
  [3439210461,3439425170,'Libra'],
  [3439425170,3439645157,'Scorpio'],
  [3439645157,3439862103,'Sagittarius'],
  [3439862103,3440071983,'Capricorn'],
  [3440071983,3440274536,'Aquarius'],
  [3440274536,3440470231,'Pisces'],
  [3440470231,3440658853,'Aries'],
  [3440658853,3440840446,'Taurus'],
  [3440840446,3441017223,'Gemini'],
  [3441017223,3441194241,'Cancer'],
  [3441194241,3441378203,'Leo'],
  [3441378203,3441574960,'Virgo'],
  [3441574960,3441785804,'Libra'],
  [3441785804,3442004846,'Scorpio'],
  [3442004846,3442222161,'Sagittarius'],
  [3442222161,3442430934,'Capricorn'],
  [3442430934,3442630352,'Aquarius'],
  [3442630352,3442822936,'Pisces'],
  [3442822936,3443011128,'Aries'],
  [3443011128,3443196006,'Taurus'],
  [3443196006,3443378313,'Gemini'],
  [3443378313,3443560323,'Cancer'],
  [3443560323,3443746435,'Leo'],
  [3443746435,3443941840,'Virgo'],
  [3443941840,3444149539,'Libra'],
  [3444149539,3444366812,'Scorpio'],
  [3444366812,3444584963,'Sagittarius'],
  [3444584963,3444794951,'Capricorn'],
  [3444794951,3444993290,'Aquarius'],
  [3444993290,3445182111,'Pisces'],
  [3445182111,3445365773,'Aries'],
  [3445365773,3445548106,'Taurus'],
  [3445548106,3445731467,'Gemini'],
  [3445731467,3445917415,'Cancer'],
  [3445917415,3446107901,'Leo'],
  [3446107901,3446305630,'Virgo'],
  [3446305630,3446512860,'Libra'],
  [3446512860,3446728762,'Scorpio'],
  [3446728762,3446947491,'Sagittarius'],
  [3446947491,3447160261,'Capricorn'],
  [3447160261,3447360897,'Aquarius'],
  [3447360897,3447549066,'Pisces'],
  [3447549066,3447728803,'Aries'],
  [3447728803,3447905666,'Taurus'],
  [3447905666,3448084751,'Gemini'],
  [3448084751,3448269673,'Cancer'],
  [3448269673,3448462349,'Leo'],
  [3448462349,3448663356,'Virgo'],
  [3448663356,3448872467,'Libra'],
  [3448872467,3449088333,'Scorpio'],
  [3449088333,3449307201,'Sagittarius'],
  [3449307201,3449522570,'Capricorn'],
  [3449522570,3449727598,'Aquarius'],
  [3449727598,3449919074,'Pisces'],
  [3449919074,3450098779,'Aries'],
  [3450098779,3450271968,'Taurus'],
  [3450271968,3450445249,'Gemini'],
  [3450445249,3450624834,'Cancer'],
  [3450624834,3450814983,'Leo'],
  [3450814983,3451016703,'Virgo'],
  [3451016703,3451227821,'Libra'],
  [3451227821,3451444708,'Scorpio'],
  [3451444708,3451663534,'Sagittarius'],
  [3451663534,3451880014,'Capricorn'],
  [3451880014,3452088943,'Aquarius'],
  [3452088943,3452285832,'Pisces'],
  [3452285832,3452469600,'Aries'],
  [3452469600,3452643430,'Taurus'],
  [3452643430,3452813604,'Gemini'],
  [3452813604,3452987579,'Cancer'],
  [3452987579,3453172045,'Leo'],
  [3453172045,3453370521,'Virgo'],
  [3453370521,3453581405,'Libra'],
  [3453581405,3453799145,'Scorpio'],
  [3453799145,3454017974,'Sagittarius'],
  [3454017974,3454234021,'Capricorn'],
  [3454234021,3454444330,'Aquarius'],
  [3454444330,3454645564,'Pisces'],
  [3454645564,3454835153,'Aries'],
  [3454835153,3455013535,'Taurus'],
  [3455013535,3455185030,'Gemini'],
  [3455185030,3455356644,'Cancer'],
  [3455356644,3455536062,'Leo'],
  [3455536062,3455729177,'Virgo'],
  [3455729177,3455936938,'Libra'],
  [3455936938,3456154141,'Scorpio'],
  [3456154141,3456372974,'Sagittarius'],
  [3456372974,3456587991,'Capricorn'],
  [3456587991,3456797105,'Aquarius'],
  [3456797105,3456999241,'Pisces'],
  [3456999241,3457192833,'Aries'],
  [3457192833,3457376918,'Taurus'],
  [3457376918,3457553230,'Gemini'],
  [3457553230,3457726798,'Cancer'],
  [3457726798,3457904633,'Leo'],
  [3457904633,3458093513,'Virgo'],
  [3458093513,3458296868,'Libra'],
  [3458296868,3458511884,'Scorpio'],
  [3458511884,3458730511,'Sagittarius'],
  [3458730511,3458945019,'Capricorn'],
  [3458945019,3459152112,'Aquarius'],
  [3459152112,3459351956,'Pisces'],
  [3459351956,3459545337,'Aries'],
  [3459545337,3459732439,'Taurus'],
  [3459732439,3459913886,'Gemini'],
  [3459913886,3460092300,'Cancer'],
  [3460092300,3460272562,'Leo'],
  [3460272562,3460460552,'Virgo'],
  [3460460552,3460660708,'Libra'],
  [3460660708,3460872887,'Scorpio'],
  [3460872887,3461090964,'Sagittarius'],
  [3461090964,3461306097,'Capricorn'],
  [3461306097,3461512484,'Aquarius'],
  [3461512484,3461709429,'Pisces'],
  [3461709429,3461899222,'Aries'],
  [3461899222,3462084559,'Taurus'],
  [3462084559,3462267534,'Gemini'],
  [3462267534,3462450103,'Cancer'],
  [3462450103,3462634922,'Leo'],
  [3462634922,3462825513,'Virgo'],
  [3462825513,3463025320,'Libra'],
  [3463025320,3463235550,'Scorpio'],
  [3463235550,3463452855,'Sagittarius'],
  [3463452855,3463669524,'Capricorn'],
  [3463669524,3463877703,'Aquarius'],
  [3463877703,3464074085,'Pisces'],
  [3464074085,3464260355,'Aries'],
  [3464260355,3464440841,'Taurus'],
  [3464440841,3464620286,'Gemini'],
  [3464620286,3464802553,'Cancer'],
  [3464802553,3464990185,'Leo'],
  [3464990185,3465184643,'Virgo'],
  [3465184643,3465386824,'Libra'],
  [3465386824,3465597048,'Scorpio'],
  [3465597048,3465813743,'Sagittarius'],
  [3465813743,3466031877,'Capricorn'],
  [3466031877,3466243750,'Aquarius'],
  [3466243750,3466443267,'Pisces'],
  [3466443267,3466629494,'Aries'],
  [3466629494,3466806288,'Taurus'],
  [3466806288,3466979961,'Gemini'],
  [3466979961,3467157038,'Cancer'],
  [3467157038,3467342452,'Leo'],
  [3467342452,3467538159,'Virgo'],
  [3467538159,3467743144,'Libra'],
  [3467743144,3467955108,'Scorpio'],
  [3467955108,3468171852,'Sagittarius'],
  [3468171852,3468390478,'Capricorn'],
  [3468390478,3468605680,'Aquarius'],
  [3468605680,3468810682,'Pisces'],
  [3468810682,3469001371,'Aries'],
  [3469001371,3469179026,'Taurus'],
  [3469179026,3469349463,'Gemini'],
  [3469349463,3469520475,'Cancer'],
  [3469520475,3469699532,'Leo'],
  [3469699532,3469891429,'Virgo'],
  [3469891429,3470096196,'Libra'],
  [3470096196,3470309752,'Scorpio'],
  [3470309752,3470527308,'Sagittarius'],
  [3470527308,3470745618,'Capricorn'],
  [3470745618,3470961741,'Aquarius'],
  [3470961741,3471170989,'Pisces'],
  [3471170989,3471368191,'Aries'],
  [3471368191,3471551400,'Taurus'],
  [3471551400,3471723883,'Gemini'],
  [3471723883,3471892692,'Cancer'],
  [3471892692,3472066105,'Leo'],
  [3472066105,3472251297,'Virgo'],
  [3472251297,3472451467,'Libra'],
  [3472451467,3472663912,'Scorpio'],
  [3472663912,3472882067,'Sagittarius'],
  [3472882067,3473100140,'Capricorn'],
  [3473100140,3473315117,'Aquarius'],
  [3473315117,3473524773,'Pisces'],
  [3473524773,3473725918,'Aries'],
  [3473725918,3473915682,'Taurus'],
  [3473915682,3474094352,'Gemini'],
  [3474094352,3474266381,'Cancer'],
  [3474266381,3474438870,'Leo'],
  [3474438870,3474619379,'Virgo'],
  [3474619379,3474813438,'Libra'],
  [3474813438,3475021654,'Scorpio'],
  [3475021654,3475238756,'Sagittarius'],
  [3475238756,3475456928,'Capricorn'],
  [3475456928,3475670714,'Aquarius'],
  [3475670714,3475878074,'Pisces'],
  [3475878074,3476078325,'Aries'],
  [3476078325,3476270690,'Taurus'],
  [3476270690,3476454999,'Gemini'],
  [3476454999,3476633179,'Cancer'],
  [3476633179,3476809643,'Leo'],
  [3476809643,3476990332,'Virgo'],
  [3476990332,3477180943,'Libra'],
  [3477180943,3477384484,'Scorpio'],
  [3477384484,3477598860,'Sagittarius'],
  [3477598860,3477816945,'Capricorn'],
  [3477816945,3478030855,'Aquarius'],
  [3478030855,3478236335,'Pisces'],
  [3478236335,3478433139,'Aries'],
  [3478433139,3478623008,'Taurus'],
  [3478623008,3478808017,'Gemini'],
  [3478808017,3478990229,'Cancer'],
  [3478990229,3479172095,'Leo'],
  [3479172095,3479356850,'Virgo'],
  [3479356850,3479548311,'Libra'],
  [3479548311,3479749684,'Scorpio'],
  [3479749684,3479961366,'Sagittarius'],
  [3479961366,3480178924,'Capricorn'],
  [3480178924,3480394200,'Aquarius'],
  [3480394200,3480600197,'Pisces'],
  [3480600197,3480794792,'Aries'],
  [3480794792,3480980376,'Taurus'],
  [3480980376,3481161441,'Gemini'],
  [3481161441,3481342398,'Cancer'],
  [3481342398,3481526421,'Leo'],
  [3481526421,3481715327,'Virgo'],
  [3481715327,3481910326,'Libra'],
  [3481910326,3482112750,'Scorpio'],
  [3482112750,3482323406,'Sagittarius'],
  [3482323406,3482540377,'Capricorn'],
  [3482540377,3482757406,'Aquarius'],
  [3482757406,3482966244,'Pisces'],
  [3482966244,3483161929,'Aries'],
  [3483161929,3483345362,'Taurus'],
  [3483345362,3483521759,'Gemini'],
  [3483521759,3483697713,'Cancer'],
  [3483697713,3483878825,'Leo'],
  [3483878825,3484068139,'Virgo'],
  [3484068139,3484265874,'Libra'],
  [3484265874,3484470926,'Scorpio'],
  [3484470926,3484682443,'Sagittarius'],
  [3484682443,3484899249,'Capricorn'],
  [3484899249,3485117510,'Aquarius'],
  [3485117510,3485329975,'Pisces'],
  [3485329975,3485529714,'Aries'],
  [3485529714,3485714900,'Taurus'],
  [3485714900,3485889552,'Gemini'],
  [3485889552,3486060869,'Cancer'],
  [3486060869,3486236360,'Leo'],
  [3486236360,3486421592,'Virgo'],
  [3486421592,3486618382,'Libra'],
  [3486618382,3486824894,'Scorpio'],
  [3486824894,3487037992,'Sagittarius'],
  [3487037992,3487255170,'Capricorn'],
  [3487255170,3487473717,'Aquarius'],
  [3487473717,3487688618,'Pisces'],
  [3487688618,3487893209,'Aries'],
  [3487893209,3488083340,'Taurus'],
  [3488083340,3488260472,'Gemini'],
  [3488260472,3488430686,'Cancer'],
  [3488430686,3488601854,'Leo'],
  [3488601854,3488781272,'Virgo'],
  [3488781272,3488973409,'Libra'],
  [3488973409,3489178215,'Scorpio'],
  [3489178215,3489391853,'Sagittarius'],
  [3489391853,3489609579,'Capricorn'],
  [3489609579,3489827740,'Aquarius'],
  [3489827740,3490042825,'Pisces'],
  [3490042825,3490250261,'Aries'],
  [3490250261,3490445779,'Taurus'],
  [3490445779,3490628451,'Gemini'],
  [3490628451,3490801885,'Cancer'],
  [3490801885,3490972683,'Leo'],
  [3490972683,3491148262,'Virgo'],
  [3491148262,3491334824,'Libra'],
  [3491334824,3491535112,'Scorpio'],
  [3491535112,3491747036,'Sagittarius'],
  [3491747036,3491964837,'Capricorn'],
  [3491964837,3492182578,'Aquarius'],
  [3492182578,3492396243,'Pisces'],
  [3492396243,3492603143,'Aries'],
  [3492603143,3492801098,'Taurus'],
  [3492801098,3492989018,'Gemini'],
  [3492989018,3493168263,'Cancer'],
  [3493168263,3493342908,'Leo'],
  [3493342908,3493518811,'Virgo'],
  [3493518811,3493702165,'Libra'],
  [3493702165,3493897615,'Scorpio'],
  [3493897615,3494105966,'Sagittarius'],
  [3494105966,3494322835,'Capricorn'],
  [3494322835,3494540623,'Aquarius'],
  [3494540623,3494753014,'Pisces'],
  [3494753014,3494957270,'Aries'],
  [3494957270,3495153434,'Taurus'],
  [3495153434,3495342621,'Gemini'],
  [3495342621,3495526303,'Cancer'],
  [3495526303,3495706589,'Leo'],
  [3495706589,3495886685,'Virgo'],
  [3495886685,3496070938,'Libra'],
  [3496070938,3496263992,'Scorpio'],
  [3496263992,3496468794,'Sagittarius'],
  [3496468794,3496683834,'Capricorn'],
  [3496683834,3496902121,'Aquarius'],
  [3496902121,3497114937,'Pisces'],
  [3497114937,3497317329,'Aries'],
  [3497317329,3497509680,'Taurus'],
  [3497509680,3497695488,'Gemini'],
  [3497695488,3497878635,'Cancer'],
  [3497878635,3498061887,'Leo'],
  [3498061887,3498246888,'Virgo'],
  [3498246888,3498435264,'Libra'],
  [3498435264,3498629614,'Scorpio'],
  [3498629614,3498832963,'Sagittarius'],
  [3498832963,3499046192,'Capricorn'],
  [3499046192,3499264933,'Aquarius'],
  [3499264933,3499480065,'Pisces'],
  [3499480065,3499683658,'Aries'],
  [3499683658,3499874057,'Taurus'],
  [3499874057,3500055254,'Gemini'],
  [3500055254,3500233427,'Cancer'],
  [3500233427,3500414002,'Leo'],
  [3500414002,3500599984,'Virgo'],
  [3500599984,3500791971,'Libra'],
  [3500791971,3500989907,'Scorpio'],
  [3500989907,3501194656,'Sagittarius'],
  [3501194656,3501407292,'Capricorn'],
  [3501407292,3501626050,'Aquarius'],
  [3501626050,3501843945,'Pisces'],
  [3501843945,3502051708,'Aries'],
  [3502051708,3502244423,'Taurus'],
  [3502244423,3502424206,'Gemini'],
  [3502424206,3502597589,'Cancer'],
  [3502597589,3502772002,'Leo'],
  [3502772002,3502953310,'Virgo'],
  [3502953310,3503144176,'Libra'],
  [3503144176,3503344127,'Scorpio'],
  [3503344127,3503551529,'Sagittarius'],
  [3503551529,3503765236,'Capricorn'],
  [3503765236,3503983871,'Aquarius'],
  [3503983871,3504203161,'Pisces'],
  [3504203161,3504415418,'Aries'],
  [3504415418,3504613805,'Taurus'],
  [3504613805,3504797170,'Gemini'],
  [3504797170,3504970182,'Cancer'],
  [3504970182,3505140277,'Leo'],
  [3505140277,3505314958,'Virgo'],
  [3505314958,3505499836,'Libra'],
  [3505499836,3505697036,'Scorpio'],
  [3505697036,3505905021,'Sagittarius'],
  [3505905021,3506120252,'Capricorn'],
  [3506120252,3506339181,'Aquarius'],
  [3506339181,3506558199,'Pisces'],
  [3506558199,3506772335,'Aries'],
  [3506772335,3506975939,'Taurus'],
  [3506975939,3507165821,'Gemini'],
  [3507165821,3507343517,'Cancer'],
  [3507343517,3507514446,'Leo'],
  [3507514446,3507685719,'Virgo'],
  [3507685719,3507864292,'Libra'],
  [3507864292,3508055228,'Scorpio'],
  [3508055228,3508259836,'Sagittarius'],
  [3508259836,3508474833,'Capricorn'],
  [3508474833,3508694231,'Aquarius'],
  [3508694231,3508912481,'Pisces'],
  [3508912481,3509125595,'Aries'],
  [3509125595,3509330598,'Taurus'],
  [3509330598,3509525342,'Gemini'],
  [3509525342,3509709591,'Cancer'],
  [3509709591,3509885823,'Leo'],
  [3509885823,3510058924,'Virgo'],
  [3510058924,3510235157,'Libra'],
  [3510235157,3510420759,'Scorpio'],
  [3510420759,3510619905,'Sagittarius'],
  [3510619905,3510832075,'Capricorn'],
  [3510832075,3511051194,'Aquarius'],
  [3511051194,3511269153,'Pisces'],
  [3511269153,3511480420,'Aries'],
  [3511480420,3511683321,'Taurus'],
  [3511683321,3511878289,'Gemini'],
  [3511878289,3512066211,'Cancer'],
  [3512066211,3512248269,'Leo'],
  [3512248269,3512426666,'Virgo'],
  [3512426666,3512605318,'Libra'],
  [3512605318,3512789596,'Scorpio'],
  [3512789596,3512984774,'Sagittarius'],
  [3512984774,3513193133,'Capricorn'],
  [3513193133,3513410899,'Aquarius'],
  [3513410899,3513629149,'Pisces'],
  [3513629149,3513839749,'Aries'],
  [3513839749,3514039958,'Taurus'],
  [3514039958,3514231707,'Gemini'],
  [3514231707,3514418349,'Cancer'],
  [3514418349,3514602437,'Leo'],
  [3514602437,3514785410,'Virgo'],
  [3514785410,3514968821,'Libra'],
  [3514968821,3515155694,'Scorpio'],
  [3515155694,3515350360,'Sagittarius'],
  [3515350360,3515556262,'Capricorn'],
  [3515556262,3515772343,'Aquarius'],
  [3515772343,3515991166,'Pisces'],
  [3515991166,3516202966,'Aries'],
  [3516202966,3516402502,'Taurus'],
  [3516402502,3516591067,'Gemini'],
  [3516591067,3516773515,'Cancer'],
  [3516773515,3516954794,'Leo'],
  [3516954794,3517138042,'Virgo'],
  [3517138042,3517324559,'Libra'],
  [3517324559,3517515333,'Scorpio'],
  [3517515333,3517712394,'Sagittarius'],
  [3517712394,3517918296,'Capricorn'],
  [3517918296,3518133385,'Aquarius'],
  [3518133385,3518352728,'Pisces'],
  [3518352728,3518567041,'Aries'],
  [3518567041,3518768797,'Taurus'],
  [3518768797,3518957003,'Gemini'],
  [3518957003,3519136111,'Cancer'],
  [3519136111,3519312451,'Leo'],
  [3519312451,3519491548,'Virgo'],
  [3519491548,3519676724,'Libra'],
  [3519676724,3519869165,'Scorpio'],
  [3519869165,3520069122,'Sagittarius'],
  [3520069122,3520276883,'Capricorn'],
  [3520276883,3520492156,'Aquarius'],
  [3520492156,3520711752,'Pisces'],
  [3520711752,3520928520,'Aries'],
  [3520928520,3521134457,'Taurus'],
  [3521134457,3521325902,'Gemini'],
  [3521325902,3521505203,'Cancer'],
  [3521505203,3521678314,'Leo'],
  [3521678314,3521852009,'Virgo'],
  [3521852009,3522032026,'Libra'],
  [3522032026,3522221855,'Scorpio'],
  [3522221855,3522422281,'Sagittarius'],
  [3522422281,3522631899,'Capricorn'],
  [3522631899,3522848206,'Aquarius'],
  [3522848206,3523067822,'Pisces'],
  [3523067822,3523285662,'Aries'],
  [3523285662,3523495429,'Taurus'],
  [3523495429,3523692296,'Gemini'],
  [3523692296,3523875792,'Cancer'],
  [3523875792,3524049794,'Leo'],
  [3524049794,3524220600,'Virgo'],
  [3524220600,3524395095,'Libra'],
  [3524395095,3524579227,'Scorpio'],
  [3524579227,3524776316,'Sagittarius'],
  [3524776316,3524985628,'Capricorn'],
  [3524985628,3525202815,'Aquarius'],
  [3525202815,3525422428,'Pisces'],
  [3525422428,3525639719,'Aries'],
  [3525639719,3525850728,'Taurus'],
  [3525850728,3526052003,'Gemini'],
  [3526052003,3526241630,'Cancer'],
  [3526241630,3526420629,'Leo'],
  [3526420629,3526593101,'Virgo'],
  [3526593101,3526765298,'Libra'],
  [3526765298,3526944210,'Scorpio'],
  [3526944210,3527135676,'Sagittarius'],
  [3527135676,3527341668,'Capricorn'],
  [3527341668,3527558336,'Aquarius'],
  [3527558336,3527778043,'Pisces'],
  [3527778043,3527994194,'Aries'],
  [3527994194,3528203662,'Taurus'],
  [3528203662,3528405528,'Gemini'],
  [3528405528,3528599198,'Cancer'],
  [3528599198,3528784379,'Leo'],
  [3528784379,3528962356,'Virgo'],
  [3528962356,3529137009,'Libra'],
  [3529137009,3529314461,'Scorpio'],
  [3529314461,3529501473,'Sagittarius'],
  [3529501473,3529702658,'Capricorn'],
  [3529702658,3529916901,'Aquarius'],
  [3529916901,3530136523,'Pisces'],
  [3530136523,3530352343,'Aries'],
  [3530352343,3530559631,'Taurus'],
  [3530559631,3530758651,'Gemini'],
  [3530758651,3530951451,'Cancer'],
  [3530951451,3531139346,'Leo'],
  [3531139346,3531322774,'Virgo'],
  [3531322774,3531502987,'Libra'],
  [3531502987,3531683553,'Scorpio'],
  [3531683553,3531870051,'Sagittarius'],
  [3531870051,3532067944,'Capricorn'],
  [3532067944,3532278950,'Aquarius'],
  [3532278950,3532497874,'Pisces'],
  [3532497874,3532714681,'Aries'],
  [3532714681,3532921725,'Taurus'],
  [3532921725,3533117883,'Gemini'],
  [3533117883,3533306481,'Cancer'],
  [3533306481,3533491540,'Leo'],
  [3533491540,3533675596,'Virgo'],
  [3533675596,3533859754,'Libra'],
  [3533859754,3534045342,'Scorpio'],
  [3534045342,3534235232,'Sagittarius'],
  [3534235232,3534433391,'Capricorn'],
  [3534433391,3534642459,'Aquarius'],
  [3534642459,3534860232,'Pisces'],
  [3534860232,3535078570,'Aries'],
  [3535078570,3535288104,'Taurus'],
  [3535288104,3535484635,'Gemini'],
  [3535484635,3535670231,'Cancer'],
  [3535670231,3535850062,'Leo'],
  [3535850062,3536029346,'Virgo'],
  [3536029346,3536211763,'Libra'],
  [3536211763,3536399288,'Scorpio'],
  [3536399288,3536593079,'Sagittarius'],
  [3536593079,3536794323,'Capricorn'],
  [3536794323,3537004006,'Aquarius'],
  [3537004006,3537221069,'Pisces'],
  [3537221069,3537440350,'Aries'],
  [3537440350,3537653575,'Taurus'],
  [3537653575,3537854155,'Gemini'],
  [3537854155,3538041092,'Cancer'],
  [3538041092,3538218315,'Leo'],
  [3538218315,3538391974,'Virgo'],
  [3538391974,3538568265,'Libra'],
  [3538568265,3538752021,'Scorpio'],
  [3538752021,3538945761,'Sagittarius'],
  [3538945761,3539149464,'Capricorn'],
  [3539149464,3539361357,'Aquarius'],
  [3539361357,3539578844,'Pisces'],
  [3539578844,3539798197,'Aries'],
  [3539798197,3540013899,'Taurus'],
  [3540013899,3540219698,'Gemini'],
  [3540219698,3540411907,'Cancer'],
  [3540411907,3540591487,'Leo'],
  [3540591487,3540763321,'Virgo'],
  [3540763321,3540934284,'Libra'],
  [3540934284,3541111426,'Scorpio'],
  [3541111426,3541300208,'Sagittarius'],
  [3541300208,3541502449,'Capricorn'],
  [3541502449,3541715451,'Aquarius'],
  [3541715451,3541933978,'Pisces'],
  [3541933978,3542153118,'Aries'],
  [3542153118,3542369048,'Taurus'],
  [3542369048,3542577929,'Gemini'],
  [3542577929,3542775959,'Cancer'],
  [3542775959,3542961458,'Leo'],
  [3542961458,3543136480,'Virgo'],
  [3543136480,3543306589,'Libra'],
  [3543306589,3543479216,'Scorpio'],
  [3543479216,3543661717,'Sagittarius'],
  [3543661717,3543858848,'Capricorn'],
  [3543858848,3544069888,'Aquarius'],
  [3544069888,3544288627,'Pisces'],
  [3544288627,3544507683,'Aries'],
  [3544507683,3544722505,'Taurus'],
  [3544722505,3544931137,'Gemini'],
  [3544931137,3545131898,'Cancer'],
  [3545131898,3545322941,'Leo'],
  [3545322941,3545503933,'Virgo'],
  [3545503933,3545677785,'Libra'],
  [3545677785,3545850505,'Scorpio'],
  [3545850505,3546029520,'Sagittarius'],
  [3546029520,3546221306,'Capricorn'],
  [3546221306,3546428063,'Aquarius'],
  [3546428063,3546645284,'Pisces'],
  [3546645284,3546864245,'Aries'],
  [3546864245,3547078103,'Taurus'],
  [3547078103,3547284638,'Gemini'],
  [3547284638,3547484168,'Cancer'],
  [3547484168,3547676883,'Leo'],
  [3547676883,3547862498,'Virgo'],
  [3547862498,3548041902,'Libra'],
  [3548041902,3548218611,'Scorpio'],
  [3548218611,3548398445,'Sagittarius'],
  [3548398445,3548587755,'Capricorn'],
  [3548587755,3548790525,'Aquarius'],
  [3548790525,3549005075,'Pisces'],
  [3549005075,3549223693,'Aries'],
  [3549223693,3549437635,'Taurus'],
  [3549437635,3549642606,'Gemini'],
  [3549642606,3549839065,'Cancer'],
  [3549839065,3550029285,'Leo'],
  [3550029285,3550215112,'Virgo'],
  [3550215112,3550397826,'Libra'],
  [3550397826,3550579335,'Scorpio'],
  [3550579335,3550763068,'Sagittarius'],
  [3550763068,3550953586,'Capricorn'],
  [3550953586,3551154780,'Aquarius'],
  [3551154780,3551367005,'Pisces'],
  [3551367005,3551585067,'Aries'],
  [3551585067,3551800227,'Taurus'],
  [3551800227,3552005765,'Gemini'],
  [3552005765,3552200339,'Cancer'],
  [3552200339,3552386638,'Leo'],
  [3552386638,3552568657,'Virgo'],
  [3552568657,3552749966,'Libra'],
  [3552749966,3552933276,'Scorpio'],
  [3552933276,3553120820,'Sagittarius'],
  [3553120820,3553314795,'Capricorn'],
  [3553314795,3553517219,'Aquarius'],
  [3553517219,3553728651,'Pisces'],
  [3553728651,3553946211,'Aries'],
  [3553946211,3554163085,'Taurus'],
  [3554163085,3554371475,'Gemini'],
  [3554371475,3554567287,'Cancer'],
  [3554567287,3554751657,'Leo'],
  [3554751657,3554929153,'Virgo'],
  [3554929153,3555105486,'Libra'],
  [3555105486,3555285818,'Scorpio'],
  [3555285818,3555473636,'Sagittarius'],
  [3555473636,3555670280,'Capricorn'],
  [3555670280,3555875380,'Aquarius'],
  [3555875380,3556087729,'Pisces'],
  [3556087729,3556305124,'Aries'],
  [3556305124,3556523213,'Taurus'],
  [3556523213,3556735358,'Gemini'],
  [3556735358,3556935517,'Cancer'],
  [3556935517,3557121937,'Leo'],
  [3557121937,3557297793,'Virgo'],
  [3557297793,3557469377,'Libra'],
  [3557469377,3557643872,'Scorpio'],
  [3557643872,3557827382,'Sagittarius'],
  [3557827382,3558022951,'Capricorn'],
  [3558022951,3558229554,'Aquarius'],
  [3558229554,3558443564,'Pisces'],
  [3558443564,3558661275,'Aries'],
  [3558661275,3558879495,'Taurus'],
  [3558879495,3559094061,'Gemini'],
  [3559094061,3559299416,'Cancer'],
  [3559299416,3559491392,'Leo'],
  [3559491392,3559670233,'Virgo'],
  [3559670233,3559840871,'Libra'],
  [3559840871,3560010871,'Scorpio'],
  [3560010871,3560188150,'Sagittarius'],
  [3560188150,3560378565,'Capricorn'],
  [3560378565,3560583171,'Aquarius'],
  [3560583171,3560797723,'Pisces'],
  [3560797723,3561016034,'Aries'],
  [3561016034,3561233693,'Taurus'],
  [3561233693,3561448098,'Gemini'],
  [3561448098,3561656143,'Cancer'],
  [3561656143,3561853871,'Leo'],
  [3561853871,3562039044,'Virgo'],
  [3562039044,3562213671,'Libra'],
  [3562213671,3562383778,'Scorpio'],
  [3562383778,3562557283,'Sagittarius'],
  [3562557283,3562741674,'Capricorn'],
  [3562741674,3562941051,'Aquarius'],
  [3562941051,3563153435,'Pisces'],
  [3563153435,3563371823,'Aries'],
  [3563371823,3563589167,'Taurus'],
  [3563589167,3563801903,'Gemini'],
  [3563801903,3564008770,'Cancer'],
  [3564008770,3564208341,'Leo'],
  [3564208341,3564398785,'Virgo'],
  [3564398785,3564579910,'Libra'],
  [3564579910,3564754851,'Scorpio'],
  [3564754851,3564929610,'Sagittarius'],
  [3564929610,3565111252,'Capricorn'],
  [3565111252,3565305477,'Aquarius'],
  [3565305477,3565513553,'Pisces'],
  [3565513553,3565730594,'Aries'],
  [3565730594,3565948209,'Taurus'],
  [3565948209,3566160034,'Gemini'],
  [3566160034,3566364080,'Cancer'],
  [3566364080,3566560927,'Leo'],
  [3566560927,3566751458,'Virgo'],
  [3566751458,3566936380,'Libra'],
  [3566936380,3567117204,'Scorpio'],
  [3567117204,3567297130,'Sagittarius'],
  [3567297130,3567480885,'Capricorn'],
  [3567480885,3567673456,'Aquarius'],
  [3567673456,3567877843,'Pisces'],
  [3567877843,3568092443,'Aries'],
  [3568092443,3568310392,'Taurus'],
  [3568310392,3568523267,'Gemini'],
  [3568523267,3568726244,'Cancer'],
  [3568726244,3568919380,'Leo'],
  [3568919380,3569105605,'Virgo'],
  [3569105605,3569288461,'Libra'],
  [3569288461,3569470938,'Scorpio'],
  [3569470938,3569655363,'Sagittarius'],
  [3569655363,3569843875,'Capricorn'],
  [3569843875,3570038859,'Aquarius'],
  [3570038859,3570242537,'Pisces'],
  [3570242537,3570455223,'Aries'],
  [3570455223,3570673104,'Taurus'],
  [3570673104,3570888348,'Gemini'],
  [3570888348,3571093462,'Cancer'],
  [3571093462,3571285805,'Leo'],
  [3571285805,3571467967,'Virgo'],
  [3571467967,3571645392,'Libra'],
  [3571645392,3571823845,'Scorpio'],
  [3571823845,3572007654,'Sagittarius'],
  [3572007654,3572198843,'Capricorn'],
  [3572198843,3572397528,'Aquarius'],
  [3572397528,3572603324,'Pisces'],
  [3572603324,3572815913,'Aries'],
  [3572815913,3573033542,'Taurus'],
  [3573033542,3573250934,'Gemini'],
  [3573250934,3573460218,'Cancer'],
  [3573460218,3573655774,'Leo'],
  [3573655774,3573837760,'Virgo'],
  [3573837760,3574011374,'Libra'],
  [3574011374,3574183948,'Scorpio'],
  [3574183948,3574362390,'Sagittarius'],
  [3574362390,3574551119,'Capricorn'],
  [3574551119,3574750731,'Aquarius'],
  [3574750731,3574958893,'Pisces'],
  [3574958893,3575172868,'Aries'],
  [3575172868,3575390565,'Taurus'],
  [3575390565,3575608856,'Gemini'],
  [3575608856,3575821805,'Cancer'],
  [3575821805,3576022726,'Leo'],
  [3576022726,3576208796,'Virgo'],
  [3576208796,3576383059,'Libra'],
  [3576383059,3576552511,'Scorpio'],
  [3576552511,3576725213,'Sagittarius'],
  [3576725213,3576907985,'Capricorn'],
  [3576907985,3577104070,'Aquarius'],
  [3577104070,3577311929,'Pisces'],
  [3577311929,3577527050,'Aries'],
  [3577527050,3577745177,'Taurus'],
  [3577745177,3577963238,'Gemini'],
  [3577963238,3578177489,'Cancer'],
  [3578177489,3578382680,'Leo'],
  [3578382680,3578574639,'Virgo'],
  [3578574639,3578753605,'Libra'],
  [3578753605,3578924558,'Scorpio'],
  [3578924558,3579094982,'Sagittarius'],
  [3579094982,3579272529,'Capricorn'],
  [3579272529,3579462791,'Aquarius'],
  [3579462791,3579666974,'Pisces'],
  [3579666974,3579881321,'Aries'],
  [3579881321,3580099704,'Taurus'],
  [3580099704,3580317165,'Gemini'],
  [3580317165,3580530458,'Cancer'],
  [3580530458,3580736590,'Leo'],
  [3580736590,3580932604,'Virgo'],
  [3580932604,3581117414,'Libra'],
  [3581117414,3581293417,'Scorpio'],
  [3581293417,3581466037,'Sagittarius'],
  [3581466037,3581642081,'Capricorn'],
  [3581642081,3581827870,'Aquarius'],
  [3581827870,3582027042,'Pisces'],
  [3582027042,3582238487,'Aries'],
  [3582238487,3582456358,'Taurus'],
  [3582456358,3582673522,'Gemini'],
  [3582673522,3582885185,'Cancer'],
  [3582885185,3583089304,'Leo'],
  [3583089304,3583285297,'Virgo'],
  [3583285297,3583473301,'Libra'],
  [3583473301,3583654636,'Scorpio'],
  [3583654636,3583832337,'Sagittarius'],
  [3583832337,3584010995,'Capricorn'],
  [3584010995,3584195911,'Aquarius'],
  [3584195911,3584391578,'Pisces'],
  [3584391578,3584599457,'Aries'],
  [3584599457,3584815974,'Taurus'],
  [3584815974,3585033408,'Gemini'],
  [3585033408,3585244495,'Cancer'],
  [3585244495,3585446052,'Leo'],
  [3585446052,3585638839,'Virgo'],
  [3585638839,3585825457,'Libra'],
  [3585825457,3586008637,'Scorpio'],
  [3586008637,3586190746,'Sagittarius'],
  [3586190746,3586374148,'Capricorn'],
  [3586374148,3586561776,'Aquarius'],
  [3586561776,3586757081,'Pisces'],
  [3586757081,3586962641,'Aries'],
  [3586962641,3587177553,'Taurus'],
  [3587177553,3587395654,'Gemini'],
  [3587395654,3587608092,'Cancer'],
  [3587608092,3587809078,'Leo'],
  [3587809078,3587998638,'Virgo'],
  [3587998638,3588180907,'Libra'],
  [3588180907,3588361110,'Scorpio'],
  [3588361110,3588543383,'Sagittarius'],
  [3588543383,3588729914,'Capricorn'],
  [3588729914,3588921579,'Aquarius'],
  [3588921579,3589119384,'Pisces'],
  [3589119384,3589324961,'Aries'],
  [3589324961,3589538862,'Taurus'],
  [3589538862,3589757556,'Gemini'],
  [3589757556,3589972800,'Cancer'],
  [3589972800,3590176383,'Leo'],
  [3590176383,3590365760,'Virgo'],
  [3590365760,3590544573,'Libra'],
  [3590544573,3590719511,'Scorpio'],
  [3590719511,3590897205,'Sagittarius'],
  [3590897205,3591082079,'Capricorn'],
  [3591082079,3591275365,'Aquarius'],
  [3591275365,3591476209,'Pisces'],
  [3591476209,3591683778,'Aries'],
  [3591683778,3591897839,'Taurus'],
  [3591897839,3592116684,'Gemini'],
  [3592116684,3592334501,'Cancer'],
  [3592334501,3592542796,'Leo'],
  [3592542796,3592736095,'Virgo'],
  [3592736095,3592915555,'Libra'],
  [3592915555,3593087346,'Scorpio'],
  [3593087346,3593259279,'Sagittarius'],
  [3593259279,3593438260,'Capricorn'],
  [3593438260,3593628235,'Aquarius'],
  [3593628235,3593829226,'Pisces'],
  [3593829226,3594038720,'Aries'],
  [3594038720,3594253972,'Taurus'],
  [3594253972,3594472718,'Gemini'],
  [3594472718,3594691298,'Cancer'],
  [3594691298,3594903412,'Leo'],
  [3594903412,3595102754,'Virgo'],
  [3595102754,3595287392,'Libra'],
  [3595287392,3595461003,'Scorpio'],
  [3595461003,3595630596,'Sagittarius'],
  [3595630596,3595803890,'Capricorn'],
  [3595803890,3595987296,'Aquarius'],
  [3595987296,3596183925,'Pisces'],
  [3596183925,3596392540,'Aries'],
  [3596392540,3596608724,'Taurus'],
  [3596608724,3596827631,'Gemini'],
  [3596827631,3597045343,'Cancer'],
  [3597045343,3597257963,'Leo'],
  [3597257963,3597461270,'Virgo'],
  [3597461270,3597652427,'Libra'],
  [3597652427,3597832136,'Scorpio'],
  [3597832136,3598004759,'Sagittarius'],
  [3598004759,3598176800,'Capricorn'],
  [3598176800,3598355184,'Aquarius'],
  [3598355184,3598545478,'Pisces'],
  [3598545478,3598749716,'Aries'],
  [3598749716,3598964829,'Taurus'],
  [3598964829,3599184027,'Gemini'],
  [3599184027,3599400829,'Cancer'],
  [3599400829,3599611413,'Leo'],
  [3599611413,3599814130,'Virgo'],
  [3599814130,3600008263,'Libra'],
  [3600008263,3600193961,'Scorpio'],
  [3600193961,3600372936,'Sagittarius'],
  [3600372936,3600548866,'Capricorn'],
  [3600548866,3600727089,'Aquarius'],
  [3600727089,3600913502,'Pisces'],
  [3600913502,3601112579,'Aries'],
  [3601112579,3601324475,'Taurus'],
  [3601324475,3601543320,'Gemini'],
  [3601543320,3601760262,'Cancer'],
  [3601760262,3601969095,'Leo'],
  [3601969095,3602168566,'Virgo'],
  [3602168566,3602360542,'Libra'],
  [3602360542,3602547410,'Scorpio'],
  [3602547410,3602730935,'Sagittarius'],
  [3602730935,3602912644,'Capricorn'],
  [3602912644,3603095022,'Aquarius'],
  [3603095022,3603282143,'Pisces'],
  [3603282143,3603478704,'Aries'],
  [3603478704,3603687295,'Taurus'],
  [3603687295,3603904947,'Gemini'],
  [3603904947,3604122886,'Cancer'],
  [3604122886,3604332172,'Leo'],
  [3604332172,3604529503,'Virgo'],
  [3604529503,3604717341,'Libra'],
  [3604717341,3604900483,'Scorpio'],
  [3604900483,3605083082,'Sagittarius'],
  [3605083082,3605267380,'Capricorn'],
  [3605267380,3605454309,'Aquarius'],
  [3605454309,3605645253,'Pisces'],
  [3605645253,3605842989,'Aries'],
  [3605842989,3606050333,'Taurus'],
  [3606050333,3606266777,'Gemini'],
  [3606266777,3606485822,'Cancer'],
  [3606485822,3606697648,'Leo'],
  [3606697648,3606896070,'Virgo'],
  [3606896070,3607081873,'Libra'],
  [3607081873,3607260443,'Scorpio'],
  [3607260443,3607438085,'Sagittarius'],
  [3607438085,3607619570,'Capricorn'],
  [3607619570,3607807113,'Aquarius'],
  [3607807113,3608001117,'Pisces'],
  [3608001117,3608201900,'Aries'],
  [3608201900,3608410398,'Taurus'],
  [3608410398,3608626532,'Gemini'],
  [3608626532,3608846256,'Cancer'],
  [3608846256,3609061214,'Leo'],
  [3609061214,3609263548,'Virgo'],
  [3609263548,3609451227,'Libra'],
  [3609451227,3609628218,'Scorpio'],
  [3609628218,3609801260,'Sagittarius'],
  [3609801260,3609977037,'Capricorn'],
  [3609977037,3610160392,'Aquarius'],
  [3610160392,3610353429,'Pisces'],
  [3610353429,3610555898,'Aries'],
  [3610555898,3610766425,'Taurus'],
  [3610766425,3610983255,'Gemini'],
  [3610983255,3611203155,'Cancer'],
  [3611203155,3611420136,'Leo'],
  [3611420136,3611627025,'Virgo'],
  [3611627025,3611819647,'Libra'],
  [3611819647,3611999300,'Scorpio'],
  [3611999300,3612171376,'Sagittarius'],
  [3612171376,3612342809,'Capricorn'],
  [3612342809,3612520196,'Aquarius'],
  [3612520196,3612708324,'Pisces'],
  [3612708324,3612908887,'Aries'],
  [3612908887,3613120075,'Taurus'],
  [3613120075,3613337845,'Gemini'],
  [3613337845,3613557664,'Cancer'],
  [3613557664,3613774807,'Leo'],
  [3613774807,3613984343,'Virgo'],
  [3613984343,3614182232,'Libra'],
  [3614182232,3614367480,'Scorpio'],
  [3614367480,3614542894,'Sagittarius'],
  [3614542894,3614713995,'Capricorn'],
  [3614713995,3614887500,'Aquarius'],
  [3614887500,3615069876,'Pisces'],
  [3615069876,3615265532,'Aries'],
  [3615265532,3615474640,'Taurus'],
  [3615474640,3615692478,'Gemini'],
  [3615692478,3615912200,'Cancer'],
  [3615912200,3616128268,'Leo'],
  [3616128268,3616337442,'Virgo'],
  [3616337442,3616537818,'Libra'],
  [3616537818,3616728342,'Scorpio'],
  [3616728342,3616909606,'Sagittarius'],
  [3616909606,3617084543,'Capricorn'],
  [3617084543,3617258338,'Aquarius'],
  [3617258338,3617437481,'Pisces'],
  [3617437481,3617628064,'Aries'],
  [3617628064,3617833033,'Taurus'],
  [3617833033,3618049380,'Gemini'],
  [3618049380,3618269014,'Cancer'],
  [3618269014,3618484097,'Leo'],
  [3618484097,3618691085,'Virgo'],
  [3618691085,3618890092,'Libra'],
  [3618890092,3619082186,'Scorpio'],
  [3619082186,3619268069,'Sagittarius'],
  [3619268069,3619448682,'Capricorn'],
  [3619448682,3619626606,'Aquarius'],
  [3619626606,3619806637,'Pisces'],
  [3619806637,3619994792,'Aries'],
  [3619994792,3620195821,'Taurus'],
  [3620195821,3620409538,'Gemini'],
  [3620409538,3620628928,'Cancer'],
  [3620628928,3620844198,'Leo'],
  [3620844198,3621049588,'Virgo'],
  [3621049588,3621245323,'Libra'],
  [3621245323,3621434646,'Scorpio'],
  [3621434646,3621620542,'Sagittarius'],
  [3621620542,3621804500,'Capricorn'],
  [3621804500,3621987468,'Aquarius'],
  [3621987468,3622171659,'Pisces'],
  [3622171659,3622361183,'Aries'],
  [3622361183,3622560660,'Taurus'],
  [3622560660,3622771976,'Gemini'],
  [3622771976,3622990831,'Cancer'],
  [3622990831,3623207584,'Leo'],
  [3623207584,3623413866,'Virgo'],
  [3623413866,3623607821,'Libra'],
  [3623607821,3623792987,'Scorpio'],
  [3623792987,3623974532,'Sagittarius'],
  [3623974532,3624156524,'Capricorn'],
  [3624156524,3624341059,'Aquarius'],
  [3624341059,3624529212,'Pisces'],
  [3624529212,3624722566,'Aries'],
  [3624722566,3624923602,'Taurus'],
  [3624923602,3625134160,'Gemini'],
  [3625134160,3625352348,'Cancer'],
  [3625352348,3625570894,'Leo'],
  [3625570894,3625780591,'Virgo'],
  [3625780591,3625976526,'Libra'],
  [3625976526,3626160247,'Scorpio'],
  [3626160247,3626337161,'Sagittarius'],
  [3626337161,3626513415,'Capricorn'],
  [3626513415,3626693956,'Aquarius'],
  [3626693956,3626881665,'Pisces'],
  [3626881665,3627077566,'Aries'],
  [3627077566,3627281669,'Taurus'],
  [3627281669,3627493522,'Gemini'],
  [3627493522,3627711450,'Cancer'],
  [3627711450,3627930848,'Leo'],
  [3627930848,3628144366,'Virgo'],
  [3628144366,3628345472,'Libra'],
  [3628345472,3628532462,'Scorpio'],
  [3628532462,3628708727,'Sagittarius'],
  [3628708727,3628880461,'Capricorn'],
  [3628880461,3629054482,'Aquarius'],
  [3629054482,3629236628,'Pisces'],
  [3629236628,3629430308,'Aries'],
  [3629430308,3629635505,'Taurus'],
  [3629635505,3629849318,'Gemini'],
  [3629849318,3630067807,'Cancer'],
  [3630067807,3630286937,'Leo'],
  [3630286937,3630502133,'Virgo'],
  [3630502133,3630708235,'Libra'],
  [3630708235,3630901582,'Scorpio'],
  [3630901582,3631082293,'Sagittarius'],
  [3631082293,3631254450,'Capricorn'],
  [3631254450,3631424674,'Aquarius'],
  [3631424674,3631600361,'Pisces'],
  [3631600361,3631787816,'Aries'],
  [3631787816,3631989785,'Taurus'],
  [3631989785,3632203620,'Gemini'],
  [3632203620,3632422910,'Cancer'],
  [3632422910,3632641568,'Leo'],
  [3632641568,3632855924,'Virgo'],
  [3632855924,3633063544,'Libra'],
  [3633063544,3633261907,'Scorpio'],
  [3633261907,3633449310,'Sagittarius'],
  [3633449310,3633626687,'Capricorn'],
  [3633626687,3633798446,'Aquarius'],
  [3633798446,3633971482,'Pisces'],
  [3633971482,3634153303,'Aries'],
  [3634153303,3634349458,'Taurus'],
  [3634349458,3634560167,'Gemini'],
  [3634560167,3634779130,'Cancer'],
  [3634779130,3634997723,'Leo'],
  [3634997723,3635210547,'Virgo'],
  [3635210547,3635416328,'Libra'],
  [3635416328,3635615150,'Scorpio'],
  [3635615150,3635806541,'Sagittarius'],
  [3635806541,3635990057,'Capricorn'],
  [3635990057,3636167253,'Aquarius'],
  [3636167253,3636342712,'Pisces'],
  [3636342712,3636523097,'Aries'],
  [3636523097,3636714916,'Taurus'],
  [3636714916,3636921172,'Gemini'],
  [3636921172,3637138181,'Cancer'],
  [3637138181,3637356875,'Leo'],
  [3637356875,3637569228,'Virgo'],
  [3637569228,3637772619,'Libra'],
  [3637772619,3637968431,'Scorpio'],
  [3637968431,3638158722,'Sagittarius'],
  [3638158722,3638344554,'Capricorn'],
  [3638344554,3638526674,'Aquarius'],
  [3638526674,3638707222,'Pisces'],
  [3638707222,3638890472,'Aries'],
  [3638890472,3639081816,'Taurus'],
  [3639081816,3639285210,'Gemini'],
  [3639285210,3639499764,'Cancer'],
  [3639499764,3639718380,'Leo'],
  [3639718380,3639931777,'Virgo'],
  [3639931777,3640134705,'Libra'],
  [3640134705,3640327565,'Scorpio'],
  [3640327565,3640513765,'Sagittarius'],
  [3640513765,3640696875,'Capricorn'],
  [3640696875,3640879447,'Aquarius'],
  [3640879447,3641063388,'Pisces'],
  [3641063388,3641250936,'Aries'],
  [3641250936,3641445059,'Taurus'],
  [3641445059,3641648541,'Gemini'],
  [3641648541,3641861685,'Cancer'],
  [3641861685,3642080079,'Leo'],
  [3642080079,3642295461,'Virgo'],
  [3642295461,3642500546,'Libra'],
  [3642500546,3642693231,'Scorpio'],
  [3642693231,3642876219,'Sagittarius'],
  [3642876219,3643054431,'Capricorn'],
  [3643054431,3643232886,'Aquarius'],
  [3643232886,3643415553,'Pisces'],
  [3643415553,3643604954,'Aries'],
  [3643604954,3643802328,'Taurus'],
  [3643802328,3644008040,'Gemini'],
  [3644008040,3644221455,'Cancer'],
  [3644221455,3644439725,'Leo'],
  [3644439725,3644656965,'Virgo'],
  [3644656965,3644865861,'Libra'],
  [3644865861,3645061752,'Scorpio'],
  [3645061752,3645245012,'Sagittarius'],
  [3645245012,3645420048,'Capricorn'],
  [3645420048,3645593163,'Aquarius'],
  [3645593163,3645770694,'Pisces'],
  [3645770694,3645957449,'Aries'],
  [3645957449,3646155350,'Taurus'],
  [3646155350,3646363167,'Gemini'],
  [3646363167,3646577951,'Cancer'],
  [3646577951,3646796370,'Leo'],
  [3646796370,3647014443,'Virgo'],
  [3647014443,3647226769,'Libra'],
  [3647226769,3647427819,'Scorpio'],
  [3647427819,3647615172,'Sagittarius'],
  [3647615172,3647791055,'Capricorn'],
  [3647791055,3647961334,'Aquarius'],
  [3647961334,3648133465,'Pisces'],
  [3648133465,3648314518,'Aries'],
  [3648314518,3648508915,'Taurus'],
  [3648508915,3648716313,'Gemini'],
  [3648716313,3648932129,'Cancer'],
  [3648932129,3649150912,'Leo'],
  [3649150912,3649368704,'Virgo'],
  [3649368704,3649582257,'Libra'],
  [3649582257,3649787531,'Scorpio'],
  [3649787531,3649980821,'Sagittarius'],
  [3649980821,3650161514,'Capricorn'],
  [3650161514,3650333364,'Aquarius'],
  [3650333364,3650503283,'Pisces'],
  [3650503283,3650679226,'Aries'],
  [3650679226,3650867873,'Taurus'],
  [3650867873,3651071579,'Gemini'],
  [3651071579,3651286577,'Cancer'],
  [3651286577,3651505570,'Leo'],
  [3651505570,3651722674,'Virgo'],
  [3651722674,3651935137,'Libra'],
  [3651935137,3652141252,'Scorpio'],
  [3652141252,3652338661,'Sagittarius'],
  [3652338661,3652525465,'Capricorn'],
  [3652525465,3652702662,'Aquarius'],
  [3652702662,3652874975,'Pisces'],
  [3652874975,3653049520,'Aries'],
  [3653049520,3653233667,'Taurus'],
  [3653233667,3653432194,'Gemini'],
  [3653432194,3653644134,'Cancer'],
  [3653644134,3653862604,'Leo'],
  [3653862604,3654079463,'Virgo'],
  [3654079463,3654290212,'Libra'],
  [3654290212,3654494033,'Scorpio'],
  [3654494033,3654691084,'Sagittarius'],
  [3654691084,3654881005,'Capricorn'],
  [3654881005,3655063835,'Aquarius'],
  [3655063835,3655241735,'Pisces'],
  [3655241735,3655419409,'Aries'],
  [3655419409,3655602999,'Taurus'],
  [3655602999,3655797945,'Gemini'],
  [3655797945,3656005988,'Cancer'],
  [3656005988,3656222915,'Leo'],
  [3656222915,3656440233,'Virgo'],
  [3656440233,3656650716,'Libra'],
  [3656650716,3656851980,'Scorpio'],
  [3656851980,3657045324,'Sagittarius'],
  [3657045324,3657233091,'Capricorn'],
  [3657233091,3657417255,'Aquarius'],
  [3657417255,3657599610,'Pisces'],
  [3657599610,3657782598,'Aries'],
  [3657782598,3657969683,'Taurus'],
  [3657969683,3658164762,'Gemini'],
  [3658164762,3658370406,'Cancer'],
  [3658370406,3658585356,'Leo'],
  [3658585356,3658803312,'Virgo'],
  [3658803312,3659015730,'Libra'],
  [3659015730,3659217166,'Scorpio'],
  [3659217166,3659407514,'Sagittarius'],
  [3659407514,3659590344,'Capricorn'],
  [3659590344,3659770390,'Aquarius'],
  [3659770390,3659951824,'Pisces'],
  [3659951824,3660137481,'Aries'],
  [3660137481,3660328967,'Taurus'],
  [3660328967,3660527334,'Gemini'],
  [3660527334,3660733497,'Cancer'],
  [3660733497,3660947294,'Leo'],
  [3660947294,3661165438,'Virgo'],
  [3661165438,3661380818,'Libra'],
  [3661380818,3661585818,'Scorpio'],
  [3661585818,3661777156,'Sagittarius'],
  [3661777156,3661957137,'Capricorn'],
  [3661957137,3662131615,'Aquarius'],
  [3662131615,3662307343,'Pisces'],
  [3662307343,3662489873,'Aries'],
  [3662489873,3662681987,'Taurus'],
  [3662681987,3662883344,'Gemini'],
  [3662883344,3663092033,'Cancer'],
  [3663092033,3663306323,'Leo'],
  [3663306323,3663524277,'Virgo'],
  [3663524277,3663741636,'Libra'],
  [3663741636,3663951429,'Scorpio'],
  [3663951429,3664147726,'Sagittarius'],
  [3664147726,3664329729,'Capricorn'],
  [3664329729,3664502109,'Aquarius'],
  [3664502109,3664672418,'Pisces'],
  [3664672418,3664848425,'Aries'],
  [3664848425,3665035831,'Taurus'],
  [3665035831,3665236083,'Gemini'],
  [3665236083,3665446281,'Cancer'],
  [3665446281,3665662015,'Leo'],
  [3665662015,3665879994,'Virgo'],
  [3665879994,3666097513,'Libra'],
  [3666097513,3666310164,'Scorpio'],
  [3666310164,3666512160,'Sagittarius'],
  [3666512160,3666700006,'Capricorn'],
  [3666700006,3666875456,'Aquarius'],
  [3666875456,3667044794,'Pisces'],
  [3667044794,3667216140,'Aries'],
  [3667216140,3667397058,'Taurus'],
  [3667397058,3667592020,'Gemini'],
  [3667592020,3667800214,'Cancer'],
  [3667800214,3668016392,'Leo'],
  [3668016392,3668234708,'Virgo'],
  [3668234708,3668451425,'Libra'],
  [3668451425,3668663853,'Scorpio'],
  [3668663853,3668868534,'Sagittarius'],
  [3668868534,3669062005,'Capricorn'],
  [3669062005,3669243577,'Aquarius'],
  [3669243577,3669416808,'Pisces'],
  [3669416808,3669588305,'Aries'],
  [3669588305,3669765578,'Taurus'],
  [3669765578,3669954799,'Gemini'],
  [3669954799,3670158211,'Cancer'],
  [3670158211,3670372554,'Leo'],
  [3670372554,3670590891,'Virgo'],
  [3670590891,3670807017,'Libra'],
  [3670807017,3671017611,'Scorpio'],
  [3671017611,3671221104,'Sagittarius'],
  [3671221104,3671416287,'Capricorn'],
  [3671416287,3671602650,'Aquarius'],
  [3671602650,3671781712,'Pisces'],
  [3671781712,3671957495,'Aries'],
  [3671957495,3672135727,'Taurus'],
  [3672135727,3672322316,'Gemini'],
  [3672322316,3672521261,'Cancer'],
  [3672521261,3672732277,'Leo'],
  [3672732277,3672949857,'Virgo'],
  [3672949857,3673166123,'Libra'],
  [3673166123,3673375440,'Scorpio'],
  [3673375440,3673576053,'Sagittarius'],
  [3673576053,3673768818,'Capricorn'],
  [3673768818,3673955477,'Aquarius'],
  [3673955477,3674138019,'Pisces'],
  [3674138019,3674318883,'Aries'],
  [3674318883,3674501308,'Taurus'],
  [3674501308,3674689252,'Gemini'],
  [3674689252,3674886493,'Cancer'],
  [3674886493,3675094681,'Leo'],
  [3675094681,3675311015,'Virgo'],
  [3675311015,3675528087,'Libra'],
  [3675528087,3675737982,'Scorpio'],
  [3675737982,3675936898,'Sagittarius'],
  [3675936898,3676125926,'Capricorn'],
  [3676125926,3676308933,'Aquarius'],
  [3676308933,3676490188,'Pisces'],
  [3676490188,3676672989,'Aries'],
  [3676672989,3676859426,'Taurus'],
  [3676859426,3677051056,'Gemini'],
  [3677051056,3677249697,'Cancer'],
  [3677249697,3677457008,'Leo'],
  [3677457008,3677672336,'Virgo'],
  [3677672336,3677890452,'Libra'],
  [3677890452,3678102801,'Scorpio'],
  [3678102801,3678302900,'Sagittarius'],
  [3678302900,3678490139,'Capricorn'],
  [3678490139,3678668871,'Aquarius'],
  [3678668871,3678845389,'Pisces'],
  [3678845389,3679025352,'Aries'],
  [3679025352,3679212146,'Taurus'],
  [3679212146,3679406553,'Gemini'],
  [3679406553,3679608084,'Cancer'],
  [3679608084,3679816559,'Leo'],
  [3679816559,3680031686,'Virgo'],
  [3680031686,3680250543,'Libra'],
  [3680250543,3680466035,'Scorpio'],
  [3680466035,3680670081,'Sagittarius'],
  [3680670081,3680859251,'Capricorn'],
  [3680859251,3681036480,'Aquarius'],
  [3681036480,3681208540,'Pisces'],
  [3681208540,3681382929,'Aries'],
  [3681382929,3681565542,'Taurus'],
  [3681565542,3681758884,'Gemini'],
  [3681758884,3681961970,'Cancer'],
  [3681961970,3682172383,'Leo'],
  [3682172383,3682388171,'Virgo'],
  [3682388171,3682607208,'Libra'],
  [3682607208,3682824766,'Scorpio'],
  [3682824766,3683033532,'Sagittarius'],
  [3683033532,3683227891,'Capricorn'],
  [3683227891,3683407963,'Aquarius'],
  [3683407963,3683579169,'Pisces'],
  [3683579169,3683749263,'Aries'],
  [3683749263,3683925808,'Taurus'],
  [3683925808,3684114031,'Gemini'],
  [3684114031,3684315026,'Cancer'],
  [3684315026,3684526013,'Leo'],
  [3684526013,3684742741,'Virgo'],
  [3684742741,3684961643,'Libra'],
  [3684961643,3685179236,'Scorpio'],
  [3685179236,3685390612,'Sagittarius'],
  [3685390612,3685590516,'Capricorn'],
  [3685590516,3685776692,'Aquarius'],
  [3685776692,3685951756,'Pisces'],
  [3685951756,3686121908,'Aries'],
  [3686121908,3686294642,'Taurus'],
  [3686294642,3686476777,'Gemini'],
  [3686476777,3686672367,'Cancer'],
  [3686672367,3686880929,'Leo'],
  [3686880929,3687097704,'Virgo'],
  [3687097704,3687316599,'Libra'],
  [3687316599,3687532964,'Scorpio'],
  [3687532964,3687743552,'Sagittarius'],
  [3687743552,3687945619,'Capricorn'],
  [3687945619,3688137253,'Aquarius'],
  [3688137253,3688318849,'Pisces'],
  [3688318849,3688493750,'Aries'],
  [3688493750,3688667523,'Taurus'],
  [3688667523,3688846620,'Gemini'],
  [3688846620,3689036725,'Cancer'],
  [3689036725,3689240502,'Leo'],
  [3689240502,3689455444,'Virgo'],
  [3689455444,3689674427,'Libra'],
  [3689674427,3689890032,'Scorpio'],
  [3689890032,3690098157,'Sagittarius'],
  [3690098157,3690298045,'Capricorn'],
  [3690298045,3690490437,'Aquarius'],
  [3690490437,3690676420,'Pisces'],
  [3690676420,3690857558,'Aries'],
  [3690857558,3691036528,'Taurus'],
  [3691036528,3691217486,'Gemini'],
  [3691217486,3691405551,'Cancer'],
  [3691405551,3691605097,'Leo'],
  [3691605097,3691816842,'Virgo'],
  [3691816842,3692035466,'Libra'],
  [3692035466,3692251765,'Scorpio'],
  [3692251765,3692458771,'Sagittarius'],
  [3692458771,3692655176,'Capricorn'],
  [3692655176,3692843805,'Aquarius'],
  [3692843805,3693028496,'Pisces'],
  [3693028496,3693212099,'Aries'],
  [3693212099,3693396169,'Taurus'],
  [3693396169,3693582109,'Gemini'],
  [3693582109,3693772512,'Cancer'],
  [3693772512,3693971055,'Leo'],
  [3693971055,3694180257,'Virgo'],
  [3694180257,3694397926,'Libra'],
  [3694397926,3694615851,'Scorpio'],
  [3694615851,3694824588,'Sagittarius'],
  [3694824588,3695020056,'Capricorn'],
  [3695020056,3695204728,'Aquarius'],
  [3695204728,3695384343,'Pisces'],
  [3695384343,3695564512,'Aries'],
  [3695564512,3695748707,'Taurus'],
  [3695748707,3695937978,'Gemini'],
  [3695937978,3696132506,'Cancer'],
  [3696132506,3696333375,'Leo'],
  [3696333375,3696542354,'Virgo'],
  [3696542354,3696759178,'Libra'],
  [3696759178,3696978439,'Scorpio'],
  [3696978439,3697190761,'Sagittarius'],
  [3697190761,3697389168,'Capricorn'],
  [3697389168,3697573588,'Aquarius'],
  [3697573588,3697749410,'Pisces'],
  [3697749410,3697923783,'Aries'],
  [3697923783,3698102864,'Taurus'],
  [3698102864,3698290122,'Gemini'],
  [3698290122,3698486089,'Cancer'],
  [3698486089,3698689844,'Leo'],
  [3698689844,3698900612,'Virgo'],
  [3698900612,3699117504,'Libra'],
  [3699117504,3699337179,'Scorpio'],
  [3699337179,3699552575,'Sagittarius'],
  [3699552575,3699756035,'Capricorn'],
  [3699756035,3699944499,'Aquarius'],
  [3699944499,3700121016,'Pisces'],
  [3700121016,3700292220,'Aries'],
  [3700292220,3700465432,'Taurus'],
  [3700465432,3700646683,'Gemini'],
  [3700646683,3700839222,'Cancer'],
  [3700839222,3701042952,'Leo'],
  [3701042952,3701255339,'Virgo'],
  [3701255339,3701473090,'Libra'],
  [3701473090,3701692582,'Scorpio'],
  [3701692582,3701908940,'Sagittarius'],
  [3701908940,3702116336,'Capricorn'],
  [3702116336,3702310618,'Aquarius'],
  [3702310618,3702491976,'Pisces'],
  [3702491976,3702664785,'Aries'],
  [3702664785,3702835632,'Taurus'],
  [3702835632,3703011450,'Gemini'],
  [3703011450,3703197937,'Cancer'],
  [3703197937,3703397807,'Leo'],
  [3703397807,3703609463,'Virgo'],
  [3703609463,3703827805,'Libra'],
  [3703827805,3704047060,'Scorpio'],
  [3704047060,3704262541,'Sagittarius'],
  [3704262541,3704470716,'Capricorn'],
  [3704470716,3704668915,'Aquarius'],
  [3704668915,3704856170,'Pisces'],
  [3704856170,3705034202,'Aries'],
  [3705034202,3705207326,'Taurus'],
  [3705207326,3705381574,'Gemini'],
  [3705381574,3705563416,'Cancer'],
  [3705563416,3705757944,'Leo'],
  [3705757944,3705966302,'Virgo'],
  [3705966302,3706183983,'Libra'],
  [3706183983,3706403146,'Scorpio'],
  [3706403146,3706617316,'Sagittarius'],
  [3706617316,3706823654,'Capricorn'],
  [3706823654,3707021845,'Aquarius'],
  [3707021845,3707212277,'Pisces'],
  [3707212277,3707395714,'Aries'],
  [3707395714,3707574025,'Taurus'],
  [3707574025,3707750947,'Gemini'],
  [3707750947,3707931944,'Cancer'],
  [3707931944,3708122846,'Leo'],
  [3708122846,3708327195,'Virgo'],
  [3708327195,3708542951,'Libra'],
  [3708542951,3708762112,'Scorpio'],
  [3708762112,3708975854,'Sagittarius'],
  [3708975854,3709179975,'Capricorn'],
  [3709179975,3709375262,'Aquarius'],
  [3709375262,3709564462,'Pisces'],
  [3709564462,3709749809,'Aries'],
  [3709749809,3709932585,'Taurus'],
  [3709932585,3710114308,'Gemini'],
  [3710114308,3710298132,'Cancer'],
  [3710298132,3710488800,'Leo'],
  [3710488800,3710690681,'Virgo'],
  [3710690681,3710904242,'Libra'],
  [3710904242,3711123375,'Scorpio'],
  [3711123375,3711338147,'Sagittarius'],
  [3711338147,3711541837,'Capricorn'],
  [3711541837,3711734281,'Aquarius'],
  [3711734281,3711919515,'Pisces'],
  [3711919515,3712102151,'Aries'],
  [3712102151,3712285241,'Taurus'],
  [3712285241,3712470165,'Gemini'],
  [3712470165,3712658122,'Cancer'],
  [3712658122,3712851513,'Leo'],
  [3712851513,3713053582,'Virgo'],
  [3713053582,3713265894,'Libra'],
  [3713265894,3713484915,'Scorpio'],
  [3713484915,3713701768,'Sagittarius'],
  [3713701768,3713907729,'Capricorn'],
  [3713907729,3714100092,'Aquarius'],
  [3714100092,3714282195,'Pisces'],
  [3714282195,3714459927,'Aries'],
  [3714459927,3714638774,'Taurus'],
  [3714638774,3714822280,'Gemini'],
  [3714822280,3715011995,'Cancer'],
  [3715011995,3715208626,'Leo'],
  [3715208626,3715413000,'Virgo'],
  [3715413000,3715625643,'Libra'],
  [3715625643,3715844543,'Scorpio'],
  [3715844543,3716063313,'Sagittarius'],
  [3716063313,3716273365,'Capricorn'],
  [3716273365,3716469339,'Aquarius'],
  [3716469339,3716652061,'Pisces'],
  [3716652061,3716826745,'Aries'],
  [3716826745,3717000033,'Taurus'],
  [3717000033,3717177955,'Gemini'],
  [3717177955,3717364624,'Cancer'],
  [3717364624,3717561599,'Leo'],
  [3717561599,3717768174,'Virgo'],
  [3717768174,3717982352,'Libra'],
  [3717982352,3718201357,'Scorpio'],
  [3718201357,3718420764,'Sagittarius'],
  [3718420764,3718634275,'Capricorn'],
  [3718634275,3718835924,'Aquarius'],
  [3718835924,3719023554,'Pisces'],
  [3719023554,3719199822,'Aries'],
  [3719199822,3719370553,'Taurus'],
  [3719370553,3719542749,'Gemini'],
  [3719542749,3719722991,'Cancer'],
  [3719722991,3719915734,'Leo'],
  [3719915734,3720121549,'Virgo'],
  [3720121549,3720336886,'Libra'],
  [3720336886,3720556381,'Scorpio'],
  [3720556381,3720775230,'Sagittarius'],
  [3720775230,3720989451,'Capricorn'],
  [3720989451,3721195167,'Aquarius'],
  [3721195167,3721389313,'Pisces'],
  [3721389313,3721571509,'Aries'],
  [3721571509,3721744892,'Taurus'],
  [3721744892,3721915425,'Gemini'],
  [3721915425,3722090404,'Cancer'],
  [3722090404,3722276653,'Leo'],
  [3722276653,3722477880,'Virgo'],
  [3722477880,3722691993,'Libra'],
  [3722691993,3722911847,'Scorpio'],
  [3722911847,3723130078,'Sagittarius'],
  [3723130078,3723342696,'Capricorn'],
  [3723342696,3723548339,'Aquarius'],
  [3723548339,3723745984,'Pisces'],
  [3723745984,3723934547,'Aries'],
  [3723934547,3724114321,'Taurus'],
  [3724114321,3724288465,'Gemini'],
  [3724288465,3724462936,'Cancer'],
  [3724462936,3724644949,'Leo'],
  [3724644949,3724840500,'Virgo'],
  [3724840500,3725050752,'Libra'],
  [3725050752,3725269787,'Scorpio'],
  [3725269787,3725488078,'Sagittarius'],
  [3725488078,3725699188,'Capricorn'],
  [3725699188,3725902031,'Aquarius'],
  [3725902031,3726098115,'Pisces'],
  [3726098115,3726288565,'Aries'],
  [3726288565,3726473540,'Taurus'],
  [3726473540,3726653798,'Gemini'],
  [3726653798,3726832470,'Cancer'],
  [3726832470,3727015069,'Leo'],
  [3727015069,3727207700,'Virgo'],
  [3727207700,3727413851,'Libra'],
  [3727413851,3727630754,'Scorpio'],
  [3727630754,3727849441,'Sagittarius'],
  [3727849441,3728060890,'Capricorn'],
  [3728060890,3728261777,'Aquarius'],
  [3728261777,3728454017,'Pisces'],
  [3728454017,3728641175,'Aries'],
  [3728641175,3728825875,'Taurus'],
  [3728825875,3729009436,'Gemini'],
  [3729009436,3729193223,'Cancer'],
  [3729193223,3729380019,'Leo'],
  [3729380019,3729573919,'Virgo'],
  [3729573919,3729778427,'Libra'],
  [3729778427,3729993222,'Scorpio'],
  [3729993222,3730212057,'Sagittarius'],
  [3730212057,3730425541,'Capricorn'],
  [3730425541,3730627471,'Aquarius'],
  [3730627471,3730817778,'Pisces'],
  [3730817778,3731000443,'Aries'],
  [3731000443,3731180380,'Taurus'],
  [3731180380,3731361558,'Gemini'],
  [3731361558,3731546536,'Cancer'],
  [3731546536,3731736994,'Leo'],
  [3731736994,3731934465,'Virgo'],
  [3731934465,3732140336,'Libra'],
  [3732140336,3732354477,'Scorpio'],
  [3732354477,3732573172,'Sagittarius'],
  [3732573172,3732789029,'Capricorn'],
  [3732789029,3732994570,'Aquarius'],
  [3732994570,3733186779,'Pisces'],
  [3733186779,3733367876,'Aries'],
  [3733367876,3733543147,'Taurus'],
  [3733543147,3733718654,'Gemini'],
  [3733718654,3733899645,'Cancer'],
  [3733899645,3734089476,'Leo'],
  [3734089476,3734289098,'Virgo'],
  [3734289098,3734497483,'Libra'],
  [3734497483,3734712557,'Scorpio'],
  [3734712557,3734931176,'Sagittarius'],
  [3734931176,3735148438,'Capricorn'],
  [3735148438,3735358026,'Aquarius'],
  [3735358026,3735555036,'Pisces'],
  [3735555036,3735738821,'Aries'],
  [3735738821,3735913083,'Taurus'],
  [3735913083,3736084187,'Gemini'],
  [3736084187,3736259210,'Cancer'],
  [3736259210,3736444151,'Leo'],
  [3736444151,3736641953,'Virgo'],
  [3736641953,3736851243,'Libra'],
  [3736851243,3737067633,'Scorpio'],
  [3737067633,3737286434,'Sagittarius'],
  [3737286434,3737503748,'Capricorn'],
  [3737503748,3737715589,'Aquarius'],
  [3737715589,3737917541,'Pisces'],
  [3737917541,3738106823,'Aries'],
  [3738106823,3738284403,'Taurus'],
  [3738284403,3738455175,'Gemini'],
  [3738455175,3738626372,'Cancer'],
  [3738626372,3738805562,'Leo'],
  [3738805562,3738998309,'Virgo'],
  [3738998309,3739205347,'Libra'],
  [3739205347,3739421855,'Scorpio'],
  [3739421855,3739640892,'Sagittarius'],
  [3739640892,3739857469,'Capricorn'],
  [3739857469,3740069000,'Aquarius'],
  [3740069000,3740273231,'Pisces'],
  [3740273231,3740467578,'Aries'],
  [3740467578,3740650898,'Taurus'],
  [3740650898,3740825483,'Gemini'],
  [3740825483,3740997075,'Cancer'],
  [3740997075,3741173177,'Leo'],
  [3741173177,3741360793,'Virgo'],
  [3741360793,3741563346,'Libra'],
  [3741563346,3741777970,'Scorpio'],
  [3741777970,3741996880,'Sagittarius'],
  [3741996880,3742212835,'Capricorn'],
  [3742212835,3742422606,'Aquarius'],
  [3742422606,3742625657,'Pisces'],
  [3742625657,3742821540,'Aries'],
  [3742821540,3743009379,'Taurus'],
  [3743009379,3743189558,'Gemini'],
  [3743189558,3743365314,'Cancer'],
  [3743365314,3743542477,'Leo'],
  [3743542477,3743727780,'Virgo'],
  [3743727780,3743926189,'Libra'],
  [3743926189,3744137623,'Scorpio'],
  [3744137623,3744355762,'Sagittarius'],
  [3744355762,3744571842,'Capricorn'],
  [3744571842,3744780374,'Aquarius'],
  [3744780374,3744980593,'Pisces'],
  [3744980593,3745174013,'Aries'],
  [3745174013,3745362041,'Taurus'],
  [3745362041,3745545631,'Gemini'],
  [3745545631,3745726458,'Cancer'],
  [3745726458,3745907892,'Leo'],
  [3745907892,3746094721,'Virgo'],
  [3746094721,3746291574,'Libra'],
  [3746291574,3746500224,'Scorpio'],
  [3746500224,3746717114,'Sagittarius'],
  [3746717114,3746934098,'Capricorn'],
  [3746934098,3747143402,'Aquarius'],
  [3747143402,3747342057,'Pisces'],
  [3747342057,3747531658,'Aries'],
  [3747531658,3747715735,'Taurus'],
  [3747715735,3747897751,'Gemini'],
  [3747897751,3748080421,'Cancer'],
  [3748080421,3748266008,'Leo'],
  [3748266008,3748456839,'Virgo'],
  [3748456839,3748655361,'Libra'],
  [3748655361,3748863158,'Scorpio'],
  [3748863158,3749078915,'Sagittarius'],
  [3749078915,3749296976,'Capricorn'],
  [3749296976,3749509130,'Aquarius'],
  [3749509130,3749709512,'Pisces'],
  [3749709512,3749897610,'Aries'],
  [3749897610,3750077195,'Taurus'],
  [3750077195,3750253866,'Gemini'],
  [3750253866,3750433044,'Cancer'],
  [3750433044,3750618613,'Leo'],
  [3750618613,3750812308,'Virgo'],
  [3750812308,3751014116,'Libra'],
  [3751014116,3751223341,'Scorpio'],
  [3751223341,3751438792,'Sagittarius'],
  [3751438792,3751657358,'Capricorn'],
  [3751657358,3751872818,'Aquarius'],
  [3751872818,3752077912,'Pisces'],
  [3752077912,3752268888,'Aries'],
  [3752268888,3752447504,'Taurus'],
  [3752447504,3752619586,'Gemini'],
  [3752619586,3752792477,'Cancer'],
  [3752792477,3752972860,'Leo'],
  [3752972860,3753164704,'Virgo'],
  [3753164704,3753367904,'Libra'],
  [3753367904,3753579347,'Scorpio'],
  [3753579347,3753795616,'Sagittarius'],
  [3753795616,3754014059,'Capricorn'],
  [3754014059,3754231148,'Aquarius'],
  [3754231148,3754441085,'Pisces'],
  [3754441085,3754638180,'Aries'],
  [3754638180,3754820859,'Taurus'],
  [3754820859,3754992982,'Gemini'],
  [3754992982,3755161878,'Cancer'],
  [3755161878,3755335752,'Leo'],
  [3755335752,3755521379,'Virgo'],
  [3755521379,3755721398,'Libra'],
  [3755721398,3755932980,'Scorpio'],
  [3755932980,3756150330,'Sagittarius'],
  [3756150330,3756368684,'Capricorn'],
  [3756368684,3756585265,'Aquarius'],
  [3756585265,3756796984,'Pisces'],
  [3756796984,3756999337,'Aries'],
  [3756999337,3757188792,'Taurus'],
  [3757188792,3757365994,'Gemini'],
  [3757365994,3757536207,'Cancer'],
  [3757536207,3757707188,'Leo'],
  [3757707188,3757886825,'Virgo'],
  [3757886825,3758080578,'Libra'],
  [3758080578,3758288633,'Scorpio'],
  [3758288633,3758505548,'Sagittarius'],
  [3758505548,3758724088,'Capricorn'],
  [3758724088,3758939534,'Aquarius'],
  [3758939534,3759149785,'Pisces'],
  [3759149785,3759353024,'Aries'],
  [3759353024,3759546990,'Taurus'],
  [3759546990,3759730746,'Gemini'],
  [3759730746,3759906610,'Cancer'],
  [3759906610,3760080044,'Leo'],
  [3760080044,3760258009,'Virgo'],
  [3760258009,3760446854,'Libra'],
  [3760446854,3760649649,'Scorpio'],
  [3760649649,3760863885,'Sagittarius'],
  [3760863885,3761082269,'Capricorn'],
  [3761082269,3761297419,'Aquarius'],
  [3761297419,3761505561,'Pisces'],
  [3761505561,3761706062,'Aries'],
  [3761706062,3761899354,'Taurus'],
  [3761899354,3762086026,'Gemini'],
  [3762086026,3762267418,'Cancer'],
  [3762267418,3762446409,'Leo'],
  [3762446409,3762627447,'Virgo'],
  [3762627447,3762815631,'Libra'],
  [3762815631,3763014933,'Scorpio'],
  [3763014933,3763225758,'Sagittarius'],
  [3763225758,3763443244,'Capricorn'],
  [3763443244,3763659150,'Aquarius'],
  [3763659150,3763866918,'Pisces'],
  [3763866918,3764064601,'Aries'],
  [3764064601,3764253970,'Taurus'],
  [3764253970,3764438263,'Gemini'],
  [3764438263,3764620614,'Cancer'],
  [3764620614,3764803579,'Leo'],
  [3764803579,3764989433,'Virgo'],
  [3764989433,3765180676,'Libra'],
  [3765180676,3765379977,'Scorpio'],
  [3765379977,3765588821,'Sagittarius'],
  [3765588821,3765805161,'Capricorn'],
  [3765805161,3766022305,'Aquarius'],
  [3766022305,3766231979,'Pisces'],
  [3766231979,3766429509,'Aries'],
  [3766429509,3766615742,'Taurus'],
  [3766615742,3766795289,'Gemini'],
  [3766795289,3766973779,'Cancer'],
  [3766973779,3767155817,'Leo'],
  [3767155817,3767343942,'Virgo'],
  [3767343942,3767538851,'Libra'],
  [3767538851,3767740696,'Scorpio'],
  [3767740696,3767949838,'Sagittarius'],
  [3767949838,3768165577,'Capricorn'],
  [3768165577,3768383760,'Aquarius'],
  [3768383760,3768596623,'Pisces'],
  [3768596623,3768797146,'Aries'],
  [3768797146,3768983670,'Taurus'],
  [3768983670,3769160178,'Gemini'],
  [3769160178,3769333525,'Cancer'],
  [3769333525,3769510615,'Leo'],
  [3769510615,3769696277,'Virgo'],
  [3769696277,3769891928,'Libra'],
  [3769891928,3770096182,'Scorpio'],
  [3770096182,3770307057,'Sagittarius'],
  [3770307057,3770523063,'Capricorn'],
  [3770523063,3770741685,'Aquarius'],
  [3770741685,3770957283,'Pisces'],
  [3770957283,3771162452,'Aries'],
  [3771162452,3771352887,'Taurus'],
  [3771352887,3771530315,'Gemini'],
  [3771530315,3771701050,'Cancer'],
  [3771701050,3771872960,'Leo'],
  [3771872960,3772053039,'Virgo'],
  [3772053039,3772245215,'Libra'],
  [3772245215,3772449091,'Scorpio'],
  [3772449091,3772661258,'Sagittarius'],
  [3772661258,3772878045,'Capricorn'],
  [3772878045,3773096572,'Aquarius'],
  [3773096572,3773313100,'Pisces'],
  [3773313100,3773521957,'Aries'],
  [3773521957,3773717923,'Taurus'],
  [3773717923,3773900019,'Gemini'],
  [3773900019,3774072431,'Cancer'],
  [3774072431,3774242346,'Leo'],
  [3774242346,3774417480,'Virgo'],
  [3774417480,3774603934,'Libra'],
  [3774603934,3774803989,'Scorpio'],
  [3774803989,3775015260,'Sagittarius'],
  [3775015260,3775232506,'Capricorn'],
  [3775232506,3775450791,'Aquarius'],
  [3775450791,3775666480,'Pisces'],
  [3775666480,3775876055,'Aries'],
  [3775876055,3776075839,'Taurus'],
  [3776075839,3776263784,'Gemini'],
  [3776263784,3776441444,'Cancer'],
  [3776441444,3776613804,'Leo'],
  [3776613804,3776787624,'Virgo'],
  [3776787624,3776969613,'Libra'],
  [3776969613,3777164377,'Scorpio'],
  [3777164377,3777372290,'Sagittarius'],
  [3777372290,3777588832,'Capricorn'],
  [3777588832,3777807062,'Aquarius'],
  [3777807062,3778021448,'Pisces'],
  [3778021448,3778229061,'Aries'],
  [3778229061,3778428643,'Taurus'],
  [3778428643,3778619722,'Gemini'],
  [3778619722,3778802963,'Cancer'],
  [3778802963,3778980857,'Leo'],
  [3778980857,3779157738,'Virgo'],
  [3779157738,3779339085,'Libra'],
  [3779339085,3779530160,'Scorpio'],
  [3779530160,3779733879,'Sagittarius'],
  [3779733879,3779948390,'Capricorn'],
  [3779948390,3780166757,'Aquarius'],
  [3780166757,3780380911,'Pisces'],
  [3780380911,3780586252,'Aries'],
  [3780586252,3780782539,'Taurus'],
  [3780782539,3780971913,'Gemini'],
  [3780971913,3781156845,'Cancer'],
  [3781156845,3781339401,'Leo'],
  [3781339401,3781521630,'Virgo'],
  [3781521630,3781706357,'Libra'],
  [3781706357,3781897422,'Scorpio'],
  [3781897422,3782098533,'Sagittarius'],
  [3782098533,3782310591,'Capricorn'],
  [3782310591,3782528957,'Aquarius'],
  [3782528957,3782744578,'Pisces'],
  [3782744578,3782949914,'Aries'],
  [3782949914,3783143320,'Taurus'],
  [3783143320,3783328161,'Gemini'],
  [3783328161,3783509551,'Cancer'],
  [3783509551,3783691764,'Leo'],
  [3783691764,3783877093,'Virgo'],
  [3783877093,3784066400,'Libra'],
  [3784066400,3784260766,'Scorpio'],
  [3784260766,3784462357,'Sagittarius'],
  [3784462357,3784673039,'Capricorn'],
  [3784673039,3784891057,'Aquarius'],
  [3784891057,3785108996,'Pisces'],
  [3785108996,3785317391,'Aries'],
  [3785317391,3785511488,'Taurus'],
  [3785511488,3785693448,'Gemini'],
  [3785693448,3785869499,'Cancer'],
  [3785869499,3786046427,'Leo'],
  [3786046427,3786229167,'Virgo'],
  [3786229167,3786419591,'Libra'],
  [3786419591,3786617277,'Scorpio'],
  [3786617277,3786821647,'Sagittarius'],
  [3786821647,3787032964,'Capricorn'],
  [3787032964,3787250650,'Aquarius'],
  [3787250650,3787470166,'Pisces'],
  [3787470166,3787682931,'Aries'],
  [3787682931,3787881639,'Taurus'],
  [3787881639,3788065379,'Gemini'],
  [3788065379,3788239200,'Cancer'],
  [3788239200,3788410645,'Leo'],
  [3788410645,3788586915,'Virgo'],
  [3788586915,3788772858,'Libra'],
  [3788772858,3788969753,'Scorpio'],
  [3788969753,3789176012,'Sagittarius'],
  [3789176012,3789389196,'Capricorn'],
  [3789389196,3789607180,'Aquarius'],
  [3789607180,3789826851,'Pisces'],
  [3789826851,3790042360,'Aries'],
  [3790042360,3790246716,'Taurus'],
  [3790246716,3790436265,'Gemini'],
  [3790436265,3790613090,'Cancer'],
  [3790613090,3790783374,'Leo'],
  [3790783374,3790954653,'Virgo'],
  [3790954653,3791133786,'Libra'],
  [3791133786,3791325191,'Scorpio'],
  [3791325191,3791529431,'Sagittarius'],
  [3791529431,3791743329,'Capricorn'],
  [3791743329,3791962073,'Aquarius'],
  [3791962073,3792181237,'Pisces'],
  [3792181237,3792396646,'Aries'],
  [3792396646,3792603866,'Taurus'],
  [3792603866,3792799330,'Gemini'],
  [3792799330,3792982555,'Cancer'],
  [3792982555,3793156838,'Leo'],
  [3793156838,3793328076,'Virgo'],
  [3793328076,3793503129,'Libra'],
  [3793503129,3793688249,'Scorpio'],
  [3793688249,3793887140,'Sagittarius'],
  [3793887140,3794098850,'Capricorn'],
  [3794098850,3794317682,'Aquarius'],
  [3794317682,3794536564,'Pisces'],
  [3794536564,3794750401,'Aries'],
  [3794750401,3794956660,'Taurus'],
  [3794956660,3795154178,'Gemini'],
  [3795154178,3795342649,'Cancer'],
  [3795342649,3795523202,'Leo'],
  [3795523202,3795698932,'Virgo'],
  [3795698932,3795874837,'Libra'],
  [3795874837,3796056973,'Scorpio'],
  [3796056973,3796250780,'Sagittarius'],
  [3796250780,3796458351,'Capricorn'],
  [3796458351,3796675837,'Aquarius'],
  [3796675837,3796894768,'Pisces'],
  [3796894768,3797107543,'Aries'],
  [3797107543,3797311190,'Taurus'],
  [3797311190,3797506581,'Gemini'],
  [3797506581,3797695709,'Cancer'],
  [3797695709,3797880188,'Leo'],
  [3797880188,3798061426,'Virgo'],
  [3798061426,3798241775,'Libra'],
  [3798241775,3798425327,'Scorpio'],
  [3798425327,3798617230,'Sagittarius'],
  [3798617230,3798821326,'Capricorn'],
  [3798821326,3799036623,'Aquarius'],
  [3799036623,3799255682,'Pisces'],
  [3799255682,3799468902,'Aries'],
  [3799468902,3799671069,'Taurus'],
  [3799671069,3799863042,'Gemini'],
  [3799863042,3800048829,'Cancer'],
  [3800048829,3800232336,'Leo'],
  [3800232336,3800415864,'Virgo'],
  [3800415864,3800600567,'Libra'],
  [3800600567,3800788106,'Scorpio'],
  [3800788106,3800981637,'Sagittarius'],
  [3800981637,3801184742,'Capricorn'],
  [3801184742,3801398335,'Aquarius'],
  [3801398335,3801617453,'Pisces'],
  [3801617453,3801832489,'Aries'],
  [3801832489,3802035755,'Taurus'],
  [3802035755,3802226204,'Gemini'],
  [3802226204,3802408063,'Cancer'],
  [3802408063,3802587134,'Leo'],
  [3802587134,3802768099,'Virgo'],
  [3802768099,3802953423,'Libra'],
  [3802953423,3803144018,'Scorpio'],
  [3803144018,3803340807,'Sagittarius'],
  [3803340807,3803545394,'Capricorn'],
  [3803545394,3803758664,'Aquarius'],
  [3803758664,3803977783,'Pisces'],
  [3803977783,3804195030,'Aries'],
  [3804195030,3804401707,'Taurus'],
  [3804401707,3804594058,'Gemini'],
  [3804594058,3804774667,'Cancer'],
  [3804774667,3804949578,'Leo'],
  [3804949578,3805125249,'Virgo'],
  [3805125249,3805306651,'Libra'],
  [3805306651,3805496386,'Scorpio'],
  [3805496386,3805694989,'Sagittarius'],
  [3805694989,3805901921,'Capricorn'],
  [3805901921,3806116182,'Aquarius'],
  [3806116182,3806335344,'Pisces'],
  [3806335344,3806553978,'Aries'],
  [3806553978,3806764607,'Taurus'],
  [3806764607,3806961715,'Gemini'],
  [3806961715,3807145108,'Cancer'],
  [3807145108,3807319275,'Leo'],
  [3807319275,3807490817,'Virgo'],
  [3807490817,3807666399,'Libra'],
  [3807666399,3807851254,'Scorpio'],
  [3807851254,3808047917,'Sagittarius'],
  [3808047917,3808255648,'Capricorn'],
  [3808255648,3808471229,'Aquarius'],
  [3808471229,3808690584,'Pisces'],
  [3808690584,3808909212,'Aries'],
  [3808909212,3809122022,'Taurus'],
  [3809122022,3809324166,'Gemini'],
  [3809324166,3809513322,'Cancer'],
  [3809513322,3809691158,'Leo'],
  [3809691158,3809862629,'Virgo'],
  [3809862629,3810034409,'Libra'],
  [3810034409,3810213357,'Scorpio'],
  [3810213357,3810404758,'Sagittarius'],
  [3810404758,3810610089,'Capricorn'],
  [3810610089,3810825818,'Aquarius'],
  [3810825818,3811045468,'Pisces'],
  [3811045468,3811263239,'Aries'],
  [3811263239,3811475464,'Taurus'],
  [3811475464,3811679738,'Gemini'],
  [3811679738,3811874180,'Cancer'],
  [3811874180,3812058318,'Leo'],
  [3812058318,3812234228,'Virgo'],
  [3812234228,3812406752,'Libra'],
  [3812406752,3812582567,'Scorpio'],
  [3812582567,3812768513,'Sagittarius'],
  [3812768513,3812968959,'Capricorn'],
  [3812968959,3813182623,'Aquarius'],
  [3813182623,3813402265,'Pisces'],
  [3813402265,3813619481,'Aries'],
  [3813619481,3813829671,'Taurus'],
  [3813829671,3814032227,'Gemini'],
  [3814032227,3814227786,'Cancer'],
  [3814227786,3814416513,'Leo'],
  [3814416513,3814598631,'Virgo'],
  [3814598631,3814776102,'Libra'],
  [3814776102,3814953528,'Scorpio'],
  [3814953528,3815137299,'Sagittarius'],
  [3815137299,3815333309,'Capricorn'],
  [3815333309,3815543336,'Aquarius'],
  [3815543336,3815762102,'Pisces'],
  [3815762102,3815979745,'Aries'],
  [3815979745,3816188920,'Taurus'],
  [3816188920,3816388379,'Gemini'],
  [3816388379,3816580700,'Cancer'],
  [3816580700,3816768713,'Leo'],
  [3816768713,3816953809,'Virgo'],
  [3816953809,3817136643,'Libra'],
  [3817136643,3817319078,'Scorpio'],
  [3817319078,3817505149,'Sagittarius'],
  [3817505149,3817700016,'Capricorn'],
  [3817700016,3817907081,'Aquarius'],
  [3817907081,3818124208,'Pisces'],
  [3818124208,3818342845,'Aries'],
  [3818342845,3818553437,'Taurus'],
  [3818553437,3818751963,'Gemini'],
  [3818751963,3818940510,'Cancer'],
  [3818940510,3819123773,'Leo'],
  [3819123773,3819305960,'Virgo'],
  [3819305960,3819489536,'Libra'],
  [3819489536,3819675801,'Scorpio'],
  [3819675801,3819866347,'Sagittarius'],
  [3819866347,3820063736,'Capricorn'],
  [3820063736,3820270477,'Aquarius'],
  [3820270477,3820486278,'Pisces'],
  [3820486278,3820705588,'Aries'],
  [3820705588,3820919276,'Taurus'],
  [3820919276,3821120528,'Gemini'],
  [3821120528,3821308739,'Cancer'],
  [3821308739,3821488105,'Leo'],
  [3821488105,3821664486,'Virgo'],
  [3821664486,3821843201,'Libra'],
  [3821843201,3822027903,'Scorpio'],
  [3822027903,3822220404,'Sagittarius'],
  [3822220404,3822421185,'Capricorn'],
  [3822421185,3822630052,'Aquarius'],
  [3822630052,3822845906,'Pisces'],
  [3822845906,3823065277,'Aries'],
  [3823065277,3823281648,'Taurus'],
  [3823281648,3823487773,'Gemini'],
  [3823487773,3823679988,'Cancer'],
  [3823679988,3823859900,'Leo'],
  [3823859900,3824032801,'Virgo'],
  [3824032801,3824205389,'Libra'],
  [3824205389,3824384015,'Scorpio'],
  [3824384015,3824573187,'Sagittarius'],
  [3824573187,3824774232,'Capricorn'],
  [3824774232,3824985152,'Aquarius'],
  [3824985152,3825202233,'Pisces'],
  [3825202233,3825421521,'Aries'],
  [3825421521,3825638740,'Taurus'],
  [3825638740,3825848741,'Gemini'],
  [3825848741,3826046880,'Cancer'],
  [3826046880,3826231727,'Leo'],
  [3826231727,3826406093,'Virgo'],
  [3826406093,3826576013,'Libra'],
  [3826576013,3826748898,'Scorpio'],
  [3826748898,3826931693,'Sagittarius'],
  [3826931693,3827128585,'Capricorn'],
  [3827128585,3827338712,'Aquarius'],
  [3827338712,3827556635,'Pisces'],
  [3827556635,3827776048,'Aries'],
  [3827776048,3827992620,'Taurus'],
  [3827992620,3828203500,'Gemini'],
  [3828203500,3828405700,'Cancer'],
  [3828405700,3828596695,'Leo'],
  [3828596695,3828776448,'Virgo'],
  [3828776448,3828948629,'Libra'],
  [3828948629,3829119835,'Scorpio'],
  [3829119835,3829297734,'Sagittarius'],
  [3829297734,3829488764,'Capricorn'],
  [3829488764,3829694956,'Aquarius'],
  [3829694956,3829911867,'Pisces'],
  [3829911867,3830131326,'Aries'],
  [3830131326,3830346974,'Taurus'],
  [3830346974,3830556345,'Gemini'],
  [3830556345,3830758744,'Cancer'],
  [3830758744,3830953133,'Leo'],
  [3830953133,3831138562,'Virgo'],
  [3831138562,3831316149,'Libra'],
  [3831316149,3831490196,'Scorpio'],
  [3831490196,3831667338,'Sagittarius'],
  [3831667338,3831854514,'Capricorn'],
  [3831854514,3832056006,'Aquarius'],
  [3832056006,3832270126,'Pisces'],
  [3832270126,3832489124,'Aries'],
  [3832489124,3832704478,'Taurus'],
  [3832704478,3832912049,'Gemini'],
  [3832912049,3833111903,'Cancer'],
  [3833111903,3833305309,'Leo'],
  [3833305309,3833492897,'Virgo'],
  [3833492897,3833675208,'Libra'],
  [3833675208,3833854331,'Scorpio'],
  [3833854331,3834034602,'Sagittarius'],
  [3834034602,3834221707,'Capricorn'],
  [3834221707,3834420442,'Aquarius'],
  [3834420442,3834631527,'Pisces'],
  [3834631527,3834849549,'Aries'],
  [3834849549,3835065503,'Taurus'],
  [3835065503,3835272796,'Gemini'],
  [3835272796,3835470189,'Cancer'],
  [3835470189,3835659977,'Leo'],
  [3835659977,3835845161,'Virgo'],
  [3835845161,3836028081,'Libra'],
  [3836028081,3836210679,'Scorpio'],
  [3836210679,3836395400,'Sagittarius'],
  [3836395400,3836585566,'Capricorn'],
  [3836585566,3836784618,'Aquarius'],
  [3836784618,3836994066,'Pisces'],
  [3836994066,3837211057,'Aries'],
  [3837211057,3837428181,'Taurus'],
  [3837428181,3837637360,'Gemini'],
  [3837637360,3837834757,'Cancer'],
  [3837834757,3838021675,'Leo'],
  [3838021675,3838202292,'Virgo'],
  [3838202292,3838381372,'Libra'],
  [3838381372,3838562918,'Scorpio'],
  [3838562918,3838749711,'Sagittarius'],
  [3838749711,3838943442,'Capricorn'],
  [3838943442,3839145102,'Aquarius'],
  [3839145102,3839354964,'Pisces'],
  [3839354964,3839571413,'Aries'],
  [3839571413,3839789582,'Taurus'],
  [3839789582,3840002041,'Gemini'],
  [3840002041,3840202643,'Cancer'],
  [3840202643,3840390078,'Leo'],
  [3840390078,3840567739,'Virgo'],
  [3840567739,3840741589,'Libra'],
  [3840741589,3840918031,'Scorpio'],
  [3840918031,3841102204,'Sagittarius'],
  [3841102204,3841296607,'Capricorn'],
  [3841296607,3841500753,'Aquarius'],
  [3841500753,3841712432,'Pisces'],
  [3841712432,3841929114,'Aries'],
  [3841929114,3842147626,'Taurus'],
  [3842147626,3842362880,'Gemini'],
  [3842362880,3842568498,'Cancer'],
  [3842568498,3842760369,'Leo'],
  [3842760369,3842939300,'Virgo'],
  [3842939300,3843110537,'Libra'],
  [3843110537,3843281523,'Scorpio'],
  [3843281523,3843459694,'Sagittarius'],
  [3843459694,3843650235,'Capricorn'],
  [3843650235,3843853863,'Aquarius'],
  [3843853863,3844066920,'Pisces'],
  [3844066920,3844284421,'Aries'],
  [3844284421,3844502657,'Taurus'],
  [3844502657,3844718598,'Gemini'],
  [3844718598,3844927968,'Cancer'],
  [3844927968,3845125932,'Leo'],
  [3845125932,3845310332,'Virgo'],
  [3845310332,3845483835,'Libra'],
  [3845483835,3845653025,'Scorpio'],
  [3845653025,3845826038,'Sagittarius'],
  [3845826038,3846010259,'Capricorn'],
  [3846010259,3846209414,'Aquarius'],
  [3846209414,3846421275,'Pisces'],
  [3846421275,3846639289,'Aries'],
  [3846639289,3846857290,'Taurus'],
  [3846857290,3847072054,'Gemini'],
  [3847072054,3847281614,'Cancer'],
  [3847281614,3847483172,'Leo'],
  [3847483172,3847673868,'Virgo'],
  [3847673868,3847853520,'Libra'],
  [3847853520,3848026069,'Scorpio'],
  [3848026069,3848198417,'Sagittarius'],
  [3848198417,3848378262,'Capricorn'],
  [3848378262,3848571540,'Aquarius'],
  [3848571540,3848779267,'Pisces'],
  [3848779267,3848996245,'Aries'],
  [3848996245,3849214377,'Taurus'],
  [3849214377,3849427966,'Gemini'],
  [3849427966,3849635130,'Cancer'],
  [3849635130,3849835539,'Leo'],
  [3849835539,3850028559,'Virgo'],
  [3850028559,3850213733,'Libra'],
  [3850213733,3850392522,'Scorpio'],
  [3850392522,3850569071,'Sagittarius'],
  [3850569071,3850749357,'Capricorn'],
  [3850749357,3850939370,'Aquarius'],
  [3850939370,3851142472,'Pisces'],
  [3851142472,3851356733,'Aries'],
  [3851356733,3851574892,'Taurus'],
  [3851574892,3851788793,'Gemini'],
  [3851788793,3851994149,'Cancer'],
  [3851994149,3852190919,'Leo'],
  [3852190919,3852381014,'Virgo'],
  [3852381014,3852566471,'Libra'],
  [3852566471,3852749134,'Scorpio'],
  [3852749134,3852931243,'Sagittarius'],
  [3852931243,3853115956,'Capricorn'],
  [3853115956,3853307163,'Aquarius'],
  [3853307163,3853508231,'Pisces'],
  [3853508231,3853719742,'Aries'],
  [3853719742,3853937389,'Taurus'],
  [3853937389,3854152961,'Gemini'],
  [3854152961,3854359261,'Cancer'],
  [3854359261,3854554031,'Leo'],
  [3854554031,3854739611,'Virgo'],
  [3854739611,3854920503,'Libra'],
  [3854920503,3855101208,'Scorpio'],
  [3855101208,3855285049,'Sagittarius'],
  [3855285049,3855473954,'Capricorn'],
  [3855473954,3855669085,'Aquarius'],
  [3855669085,3855871588,'Pisces'],
  [3855871588,3856082175,'Aries'],
  [3856082175,3856299130,'Taurus'],
  [3856299130,3856516553,'Gemini'],
  [3856516553,3856726228,'Cancer'],
  [3856726228,3856922789,'Leo'],
  [3856922789,3857106641,'Virgo'],
  [3857106641,3857282753,'Libra'],
  [3857282753,3857457805,'Scorpio'],
  [3857457805,3857637802,'Sagittarius'],
  [3857637802,3857826360,'Capricorn'],
  [3857826360,3858024019,'Aquarius'],
  [3858024019,3858229418,'Pisces'],
  [3858229418,3858441179,'Aries'],
  [3858441179,3858657969,'Taurus'],
  [3858657969,3858876427,'Gemini'],
  [3858876427,3859089844,'Cancer'],
  [3859089844,3859291120,'Leo'],
  [3859291120,3859477618,'Virgo'],
  [3859477618,3859652655,'Libra'],
  [3859652655,3859823241,'Scorpio'],
  [3859823241,3859997157,'Sagittarius'],
  [3859997157,3860180672,'Capricorn'],
  [3860180672,3860376440,'Aquarius'],
  [3860376440,3860582885,'Pisces'],
  [3860582885,3860796343,'Aries'],
  [3860796343,3861013670,'Taurus'],
  [3861013670,3861232226,'Gemini'],
  [3861232226,3861447692,'Cancer'],
  [3861447692,3861653784,'Leo'],
  [3861653784,3861845812,'Virgo'],
  [3861845812,3862024260,'Libra'],
  [3862024260,3862194622,'Scorpio'],
  [3862194622,3862364726,'Sagittarius'],
  [3862364726,3862542282,'Capricorn'],
  [3862542282,3862732596,'Aquarius'],
  [3862732596,3862936416,'Pisces'],
  [3862936416,3863149968,'Aries'],
  [3863149968,3863367900,'Taurus'],
  [3863367900,3863586117,'Gemini'],
  [3863586117,3863801392,'Cancer'],
  [3863801392,3864009697,'Leo'],
  [3864009697,3864206790,'Virgo'],
  [3864206790,3864391095,'Libra'],
  [3864391095,3864565478,'Scorpio'],
  [3864565478,3864736187,'Sagittarius'],
  [3864736187,3864910678,'Capricorn'],
  [3864910678,3865095566,'Aquarius'],
  [3865095566,3865294313,'Pisces'],
  [3865294313,3865505418,'Aries'],
  [3865505418,3865723127,'Taurus'],
  [3865723127,3865941065,'Gemini'],
  [3865941065,3866154971,'Cancer'],
  [3866154971,3866362283,'Leo'],
  [3866362283,3866561000,'Virgo'],
  [3866561000,3866749931,'Libra'],
  [3866749931,3866930082,'Scorpio'],
  [3866930082,3867105188,'Sagittarius'],
  [3867105188,3867280920,'Capricorn'],
  [3867280920,3867463464,'Aquarius'],
  [3867463464,3867657684,'Pisces'],
  [3867657684,3867864862,'Aries'],
  [3867864862,3868081141,'Taurus'],
  [3868081141,3868299062,'Gemini'],
  [3868299062,3868512010,'Cancer'],
  [3868512010,3868716860,'Leo'],
  [3868716860,3868913429,'Virgo'],
  [3868913429,3869102822,'Libra'],
  [3869102822,3869286610,'Scorpio'],
  [3869286610,3869466998,'Sagittarius'],
  [3869466998,3869647179,'Capricorn'],
  [3869647179,3869831340,'Aquarius'],
  [3869831340,3870023916,'Pisces'],
  [3870023916,3870227835,'Aries'],
  [3870227835,3870442008,'Taurus'],
  [3870442008,3870660103,'Gemini'],
  [3870660103,3870873592,'Cancer'],
  [3870873592,3871077045,'Leo'],
  [3871077045,3871270169,'Virgo'],
  [3871270169,3871456098,'Libra'],
  [3871456098,3871638784,'Scorpio'],
  [3871638784,3871821382,'Sagittarius'],
  [3871821382,3872005959,'Capricorn'],
  [3872005959,3872194249,'Aquarius'],
  [3872194249,3872388561,'Pisces'],
  [3872388561,3872591526,'Aries'],
  [3872591526,3872804010,'Taurus'],
  [3872804010,3873022248,'Gemini'],
  [3873022248,3873237795,'Cancer'],
  [3873237795,3873442608,'Leo'],
  [3873442608,3873634261,'Virgo'],
  [3873634261,3873816068,'Libra'],
  [3873816068,3873993997,'Scorpio'],
  [3873993997,3874173720,'Sagittarius'],
  [3874173720,3874358782,'Capricorn'],
  [3874358782,3874550232,'Aquarius'],
  [3874550232,3874747999,'Pisces'],
  [3874747999,3874952550,'Aries'],
  [3874952550,3875164671,'Taurus'],
  [3875164671,3875382854,'Gemini'],
  [3875382854,3875600810,'Cancer'],
  [3875600810,3875809555,'Leo'],
  [3875809555,3876003630,'Virgo'],
  [3876003630,3876184391,'Libra'],
  [3876184391,3876357993,'Scorpio'],
  [3876357993,3876531917,'Sagittarius'],
  [3876531917,3876712392,'Capricorn'],
  [3876712392,3876902531,'Aquarius'],
  [3876902531,3877102042,'Pisces'],
  [3877102042,3877309113,'Aries'],
  [3877309113,3877522348,'Taurus'],
  [3877522348,3877740448,'Gemini'],
  [3877740448,3877959622,'Cancer'],
  [3877959622,3878172555,'Leo'],
  [3878172555,3878372143,'Virgo'],
  [3878372143,3878556563,'Libra'],
  [3878556563,3878730044,'Scorpio'],
  [3878730044,3878899990,'Sagittarius'],
  [3878899990,3879074138,'Capricorn'],
  [3879074138,3879258424,'Aquarius'],
  [3879258424,3879455144,'Pisces'],
  [3879455144,3879662688,'Aries'],
  [3879662688,3879877394,'Taurus'],
  [3879877394,3880095784,'Gemini'],
  [3880095784,3880314607,'Cancer'],
  [3880314607,3880529205,'Leo'],
  [3880529205,3880733826,'Virgo'],
  [3880733826,3880924769,'Libra'],
  [3880924769,3881103109,'Scorpio'],
  [3881103109,3881274151,'Sagittarius'],
  [3881274151,3881445143,'Capricorn'],
  [3881445143,3881623257,'Aquarius'],
  [3881623257,3881813702,'Pisces'],
  [3881813702,3882017789,'Aries'],
  [3882017789,3882232241,'Taurus'],
  [3882232241,3882451146,'Gemini'],
  [3882451146,3882669172,'Cancer'],
  [3882669172,3882882533,'Leo'],
  [3882882533,3883088241,'Virgo'],
  [3883088241,3883283907,'Libra'],
  [3883283907,3883468958,'Scorpio'],
  [3883468958,3883645673,'Sagittarius'],
  [3883645673,3883818902,'Capricorn'],
  [3883818902,3883994942,'Aquarius'],
  [3883994942,3884180069,'Pisces'],
  [3884180069,3884378526,'Aries'],
  [3884378526,3884590004,'Taurus'],
  [3884590004,3884808700,'Gemini'],
  [3884808700,3885026592,'Cancer'],
  [3885026592,3885238055,'Leo'],
  [3885238055,3885441267,'Virgo'],
  [3885441267,3885636624,'Libra'],
  [3885636624,3885825048,'Scorpio'],
  [3885825048,3886007726,'Sagittarius'],
  [3886007726,3886186738,'Capricorn'],
  [3886186738,3886365759,'Aquarius'],
  [3886365759,3886549919,'Pisces'],
  [3886549919,3886744432,'Aries'],
  [3886744432,3886951891,'Taurus'],
  [3886951891,3887169140,'Gemini'],
  [3887169140,3887387566,'Cancer'],
  [3887387566,3887598684,'Leo'],
  [3887598684,3887799197,'Virgo'],
  [3887799197,3887990834,'Libra'],
  [3887990834,3888177192,'Scorpio'],
  [3888177192,3888361263,'Sagittarius'],
  [3888361263,3888544727,'Capricorn'],
  [3888544727,3888728900,'Aquarius'],
  [3888728900,3888916251,'Pisces'],
  [3888916251,3889110693,'Aries'],
  [3889110693,3889315779,'Taurus'],
  [3889315779,3889531187,'Gemini'],
  [3889531187,3889750244,'Cancer'],
  [3889750244,3889963035,'Leo'],
  [3889963035,3890163422,'Virgo'],
  [3890163422,3890352044,'Libra'],
  [3890352044,3890533785,'Scorpio'],
  [3890533785,3890714138,'Sagittarius'],
  [3890714138,3890896914,'Capricorn'],
  [3890896914,3891083691,'Aquarius'],
  [3891083691,3891275067,'Pisces'],
  [3891275067,3891472396,'Aries'],
  [3891472396,3891677908,'Taurus'],
  [3891677908,3891892385,'Gemini'],
  [3891892385,3892111821,'Cancer'],
  [3892111821,3892327302,'Leo'],
  [3892327302,3892530565,'Virgo'],
  [3892530565,3892719600,'Libra'],
  [3892719600,3892898455,'Scorpio'],
  [3892898455,3893073711,'Sagittarius'],
  [3893073711,3893251514,'Capricorn'],
  [3893251514,3893435842,'Aquarius'],
  [3893435842,3893628091,'Pisces'],
  [3893628091,3893828165,'Aries'],
  [3893828165,3894035854,'Taurus'],
  [3894035854,3894250798,'Gemini'],
  [3894250798,3894470386,'Cancer'],
  [3894470386,3894688069,'Leo'],
  [3894688069,3894895659,'Virgo'],
  [3894895659,3895088622,'Libra'],
  [3895088622,3895268592,'Scorpio'],
  [3895268592,3895441371,'Sagittarius'],
  [3895441371,3895613971,'Capricorn'],
  [3895613971,3895792582,'Aquarius'],
  [3895792582,3895981185,'Pisces'],
  [3895981185,3896180845,'Aries'],
  [3896180845,3896390107,'Taurus'],
  [3896390107,3896606264,'Gemini'],
  [3896606264,3896825957,'Cancer'],
  [3896825957,3897044366,'Leo'],
  [3897044366,3897255312,'Virgo'],
  [3897255312,3897453652,'Libra'],
  [3897453652,3897638371,'Scorpio'],
  [3897638371,3897812980,'Sagittarius'],
  [3897812980,3897983639,'Capricorn'],
  [3897983639,3898157249,'Aquarius'],
  [3898157249,3898339938,'Pisces'],
  [3898339938,3898535456,'Aries'],
  [3898535456,3898743643,'Taurus'],
  [3898743643,3898960445,'Gemini'],
  [3898960445,3899180276,'Cancer'],
  [3899180276,3899398086,'Leo'],
  [3899398086,3899609739,'Virgo'],
  [3899609739,3899811799,'Libra'],
  [3899811799,3900002334,'Scorpio'],
  [3900002334,3900182235,'Sagittarius'],
  [3900182235,3900355356,'Capricorn'],
  [3900355356,3900527630,'Aquarius'],
  [3900527630,3900705803,'Pisces'],
  [3900705803,3900895770,'Aries'],
  [3900895770,3901100111,'Taurus'],
  [3901100111,3901315860,'Gemini'],
  [3901315860,3901535709,'Cancer'],
  [3901535709,3901752583,'Leo'],
  [3901752583,3901962654,'Virgo'],
  [3901962654,3902164772,'Libra'],
  [3902164772,3902358584,'Scorpio'],
  [3902358584,3902544135,'Sagittarius'],
  [3902544135,3902722767,'Capricorn'],
  [3902722767,3902898018,'Aquarius'],
  [3902898018,3903075522,'Pisces'],
  [3903075522,3903261729,'Aries'],
  [3903261729,3903461459,'Taurus'],
  [3903461459,3903674464,'Gemini'],
  [3903674464,3903893921,'Cancer'],
  [3903893921,3904110540,'Leo'],
  [3904110540,3904318724,'Virgo'],
  [3904318724,3904518093,'Libra'],
  [3904518093,3904710717,'Scorpio'],
  [3904710717,3904898358,'Sagittarius'],
  [3904898358,3905081867,'Capricorn'],
  [3905081867,3905262469,'Aquarius'],
  [3905262469,3905443308,'Pisces'],
  [3905443308,3905629521,'Aries'],
  [3905629521,3905826474,'Taurus'],
  [3905826474,3906036380,'Gemini'],
  [3906036380,3906254902,'Cancer'],
  [3906254902,3906472329,'Leo'],
  [3906472329,3906680402,'Virgo'],
  [3906680402,3906877235,'Libra'],
  [3906877235,3907065906,'Scorpio'],
  [3907065906,3907250676,'Sagittarius'],
  [3907250676,3907434479,'Capricorn'],
  [3907434479,3907618605,'Aquarius'],
  [3907618605,3907804210,'Pisces'],
  [3907804210,3907993847,'Aries'],
  [3907993847,3908191337,'Taurus'],
  [3908191337,3908399568,'Gemini'],
  [3908399568,3908616926,'Cancer'],
  [3908616926,3908835666,'Leo'],
  [3908835666,3909046126,'Virgo'],
  [3909046126,3909243464,'Libra'],
  [3909243464,3909429419,'Scorpio'],
  [3909429419,3909609238,'Sagittarius'],
  [3909609238,3909788379,'Capricorn'],
  [3909788379,3909970666,'Aquarius'],
  [3909970666,3910158002,'Pisces'],
  [3910158002,3910351384,'Aries'],
  [3910351384,3910551961,'Taurus'],
  [3910551961,3910760921,'Gemini'],
  [3910760921,3910977614,'Cancer'],
  [3910977614,3911197168,'Leo'],
  [3911197168,3911411180,'Virgo'],
  [3911411180,3911612594,'Libra'],
  [3911612594,3911800074,'Scorpio'],
  [3911800074,3911977533,'Sagittarius'],
  [3911977533,3912151224,'Capricorn'],
  [3912151224,3912327413,'Aquarius'],
  [3912327413,3912510895,'Pisces'],
  [3912510895,3912704117,'Aries'],
  [3912704117,3912907123,'Taurus'],
  [3912907123,3913118354,'Gemini'],
  [3913118354,3913335493,'Cancer'],
  [3913335493,3913554996,'Leo'],
  [3913554996,3913771304,'Virgo'],
  [3913771304,3913977944,'Libra'],
  [3913977944,3914170947,'Scorpio'],
  [3914170947,3914351117,'Sagittarius'],
  [3914351117,3914523265,'Capricorn'],
  [3914523265,3914694199,'Aquarius'],
  [3914694199,3914870924,'Pisces'],
  [3914870924,3915058944,'Aries'],
  [3915058944,3915260317,'Taurus'],
  [3915260317,3915472682,'Gemini'],
  [3915472682,3915690959,'Cancer'],
  [3915690959,3915910176,'Leo'],
  [3915910176,3916126409,'Virgo'],
  [3916126409,3916335862,'Libra'],
  [3916335862,3916534777,'Scorpio'],
  [3916534777,3916721327,'Sagittarius'],
  [3916721327,3916897239,'Capricorn'],
  [3916897239,3917067735,'Aquarius'],
  [3917067735,3917240047,'Pisces'],
  [3917240047,3917421570,'Aries'],
  [3917421570,3917617445,'Taurus'],
  [3917617445,3917827590,'Gemini'],
  [3917827590,3918046124,'Cancer'],
  [3918046124,3918265367,'Leo'],
  [3918265367,3918480314,'Virgo'],
  [3918480314,3918689005,'Libra'],
  [3918689005,3918890162,'Scorpio'],
  [3918890162,3919082217,'Sagittarius'],
  [3919082217,3919264588,'Capricorn'],
  [3919264588,3919439538,'Aquarius'],
  [3919439538,3919612538,'Pisces'],
  [3919612538,3919790849,'Aries'],
  [3919790849,3919981246,'Taurus'],
  [3919981246,3920186720,'Gemini'],
  [3920186720,3920403510,'Cancer'],
  [3920403510,3920622792,'Leo'],
  [3920622792,3920836952,'Virgo'],
  [3920836952,3921043338,'Libra'],
  [3921043338,3921242581,'Scorpio'],
  [3921242581,3921435509,'Sagittarius'],
  [3921435509,3921622124,'Capricorn'],
  [3921622124,3921802888,'Aquarius'],
  [3921802888,3921980547,'Pisces'],
  [3921980547,3922160397,'Aries'],
  [3922160397,3922348779,'Taurus'],
  [3922348779,3922550273,'Gemini'],
  [3922550273,3922764118,'Cancer'],
  [3922764118,3922982996,'Leo'],
  [3922982996,3923197571,'Virgo'],
  [3923197571,3923402750,'Libra'],
  [3923402750,3923598828,'Scorpio'],
  [3923598828,3923788543,'Sagittarius'],
  [3923788543,3923974329,'Capricorn'],
  [3923974329,3924157633,'Aquarius'],
  [3924157633,3924339972,'Pisces'],
  [3924339972,3924524184,'Aries'],
  [3924524184,3924714486,'Taurus'],
  [3924714486,3924914929,'Gemini'],
  [3924914929,3925126511,'Cancer'],
  [3925126511,3925344665,'Leo'],
  [3925344665,3925560594,'Virgo'],
  [3925560594,3925766903,'Libra'],
  [3925766903,3925961697,'Scorpio'],
  [3925961697,3926147639,'Sagittarius'],
  [3926147639,3926329047,'Capricorn'],
  [3926329047,3926509860,'Aquarius'],
  [3926509860,3926692964,'Pisces'],
  [3926692964,3926880510,'Aries'],
  [3926880510,3927074472,'Taurus'],
  [3927074472,3927276717,'Gemini'],
  [3927276717,3927487915,'Cancer'],
  [3927487915,3927705525,'Leo'],
  [3927705525,3927922997,'Virgo'],
  [3927922997,3928132393,'Libra'],
  [3928132393,3928329138,'Scorpio'],
  [3928329138,3928513972,'Sagittarius'],
  [3928513972,3928691300,'Capricorn'],
  [3928691300,3928866877,'Aquarius'],
  [3928866877,3929046093,'Pisces'],
  [3929046093,3929232823,'Aries'],
  [3929232823,3929428785,'Taurus'],
  [3929428785,3929633712,'Gemini'],
  [3929633712,3929846197,'Cancer'],
  [3929846197,3930063810,'Leo'],
  [3930063810,3930282236,'Virgo'],
  [3930282236,3930495092,'Libra'],
  [3930495092,3930696358,'Scorpio'],
  [3930696358,3930883947,'Sagittarius'],
  [3930883947,3931060549,'Capricorn'],
  [3931060549,3931232073,'Aquarius'],
  [3931232073,3931405576,'Pisces'],
  [3931405576,3931587423,'Aries'],
  [3931587423,3931781373,'Taurus'],
  [3931781373,3931987146,'Gemini'],
  [3931987146,3932201212,'Cancer'],
  [3932201212,3932419340,'Leo'],
  [3932419340,3932637843,'Virgo'],
  [3932637843,3932852654,'Libra'],
  [3932852654,3933058648,'Scorpio'],
  [3933058648,3933251780,'Sagittarius'],
  [3933251780,3933431895,'Capricorn'],
  [3933431895,3933603299,'Aquarius'],
  [3933603299,3933773116,'Pisces'],
  [3933773116,3933949169,'Aries'],
  [3933949169,3934137756,'Taurus'],
  [3934137756,3934340880,'Gemini'],
  [3934340880,3934554983,'Cancer'],
  [3934554983,3934773651,'Leo'],
  [3934773651,3934991726,'Virgo'],
  [3934991726,3935206242,'Libra'],
  [3935206242,3935414408,'Scorpio'],
  [3935414408,3935612724,'Sagittarius'],
  [3935612724,3935798954,'Capricorn'],
  [3935798954,3935974597,'Aquarius'],
  [3935974597,3936145112,'Pisces'],
  [3936145112,3936318131,'Aries'],
  [3936318131,3936501248,'Taurus'],
  [3936501248,3936699171,'Gemini'],
  [3936699171,3936910723,'Cancer'],
  [3936910723,3937129154,'Leo'],
  [3937129154,3937346930,'Virgo'],
  [3937346930,3937559933,'Libra'],
  [3937559933,3937766869,'Scorpio'],
  [3937766869,3937966648,'Sagittarius'],
  [3937966648,3938157651,'Capricorn'],
  [3938157651,3938339479,'Aquarius'],
  [3938339479,3938514847,'Pisces'],
  [3938514847,3938689459,'Aries'],
  [3938689459,3938870370,'Taurus'],
  [3938870370,3939063586,'Gemini'],
  [3939063586,3939270887,'Cancer'],
  [3939270887,3939487734,'Leo'],
  [3939487734,3939705621,'Virgo'],
  [3939705621,3939917796,'Libra'],
  [3939917796,3940122100,'Scorpio'],
  [3940122100,3940319216,'Sagittarius'],
  [3940319216,3940510137,'Capricorn'],
  [3940510137,3940695469,'Aquarius'],
  [3940695469,3940876483,'Pisces'],
  [3940876483,3941056224,'Aries'],
  [3941056224,3941239441,'Taurus'],
  [3941239441,3941431319,'Gemini'],
  [3941431319,3941635136,'Cancer'],
  [3941635136,3941849493,'Leo'],
  [3941849493,3942067557,'Virgo'],
  [3942067557,3942280756,'Libra'],
  [3942280756,3942484122,'Scorpio'],
  [3942484122,3942677690,'Sagittarius'],
  [3942677690,3942864355,'Capricorn'],
  [3942864355,3943047539,'Aquarius'],
  [3943047539,3943230077,'Pisces'],
  [3943230077,3943414241,'Aries'],
  [3943414241,3943602274,'Taurus'],
  [3943602274,3943796733,'Gemini'],
  [3943796733,3943999975,'Cancer'],
  [3943999975,3944212395,'Leo'],
  [3944212395,3944430258,'Virgo'],
  [3944430258,3944645803,'Libra'],
  [3944645803,3944851471,'Scorpio'],
  [3944851471,3945044464,'Sagittarius'],
  [3945044464,3945227164,'Capricorn'],
  [3945227164,3945404828,'Aquarius'],
  [3945404828,3945583145,'Pisces'],
  [3945583145,3945766529,'Aries'],
  [3945766529,3945957223,'Taurus'],
  [3945957223,3946155539,'Gemini'],
  [3946155539,3946361081,'Cancer'],
  [3946361081,3946573419,'Leo'],
  [3946573419,3946790851,'Virgo'],
  [3946790851,3947008411,'Libra'],
  [3947008411,3947218431,'Scorpio'],
  [3947218431,3947415062,'Sagittarius'],
  [3947415062,3947597964,'Capricorn'],
  [3947597964,3947771930,'Aquarius'],
  [3947771930,3947944179,'Pisces'],
  [3947944179,3948121808,'Aries'],
  [3948121808,3948309671,'Taurus'],
  [3948309671,3948508785,'Gemini'],
  [3948508785,3948716833,'Cancer'],
  [3948716833,3948930718,'Leo'],
  [3948930718,3949148127,'Virgo'],
  [3949148127,3949366264,'Libra'],
  [3949366264,3949579791,'Scorpio'],
  [3949579791,3949782115,'Sagittarius'],
  [3949782115,3949969755,'Capricorn'],
  [3949969755,3950144960,'Aquarius'],
  [3950144960,3950314374,'Pisces'],
  [3950314374,3950486158,'Aries'],
  [3950486158,3950667597,'Taurus'],
  [3950667597,3950862621,'Gemini'],
  [3950862621,3951070074,'Cancer'],
  [3951070074,3951285171,'Leo'],
  [3951285171,3951503115,'Virgo'],
  [3951503115,3951720795,'Libra'],
  [3951720795,3951935098,'Scorpio'],
  [3951935098,3952141358,'Sagittarius'],
  [3952141358,3952335154,'Capricorn'],
  [3952335154,3952515790,'Aquarius'],
  [3952515790,3952687494,'Pisces'],
  [3952687494,3952857563,'Aries'],
  [3952857563,3953033910,'Taurus'],
  [3953033910,3953222738,'Gemini'],
  [3953222738,3953425924,'Cancer'],
  [3953425924,3953639913,'Leo'],
  [3953639913,3953858182,'Virgo'],
  [3953858182,3954075347,'Libra'],
  [3954075347,3954288347,'Scorpio'],
  [3954288347,3954494778,'Sagittarius'],
  [3954494778,3954691979,'Capricorn'],
  [3954691979,3954878442,'Aquarius'],
  [3954878442,3955055787,'Pisces'],
  [3955055787,3955228923,'Aries'],
  [3955228923,3955404563,'Taurus'],
  [3955404563,3955589297,'Gemini'],
  [3955589297,3955787283,'Cancer'],
  [3955787283,3955997915,'Leo'],
  [3955997915,3956215485,'Virgo'],
  [3956215485,3956432564,'Libra'],
  [3956432564,3956644102,'Scorpio'],
  [3956644102,3956848149,'Sagittarius'],
  [3956848149,3957044395,'Capricorn'],
  [3957044395,3957233089,'Aquarius'],
  [3957233089,3957415352,'Pisces'],
  [3957415352,3957593862,'Aries'],
  [3957593862,3957772902,'Taurus'],
  [3957772902,3957957634,'Gemini'],
  [3957957634,3958152622,'Cancer'],
  [3958152622,3958359643,'Leo'],
  [3958359643,3958575595,'Virgo'],
  [3958575595,3958793005,'Libra'],
  [3958793005,3959004408,'Scorpio'],
  [3959004408,3959206238,'Sagittarius'],
  [3959206238,3959399026,'Capricorn'],
  [3959399026,3959585422,'Aquarius'],
  [3959585422,3959768397,'Pisces'],
  [3959768397,3959950555,'Aries'],
  [3959950555,3960134292,'Taurus'],
  [3960134292,3960322311,'Gemini'],
  [3960322311,3960517703,'Cancer'],
  [3960517703,3960722866,'Leo'],
  [3960722866,3960937182,'Virgo'],
  [3960937182,3961155123,'Libra'],
  [3961155123,3961368138,'Scorpio'],
  [3961368138,3961570031,'Sagittarius'],
  [3961570031,3961760141,'Capricorn'],
  [3961760141,3961942203,'Aquarius'],
  [3961942203,3962121533,'Pisces'],
  [3962121533,3962302763,'Aries'],
  [3962302763,3962488694,'Taurus'],
  [3962488694,3962680438,'Gemini'],
  [3962680438,3962878648,'Cancer'],
  [3962878648,3963084371,'Leo'],
  [3963084371,3963297945,'Virgo'],
  [3963297945,3963516331,'Libra'],
  [3963516331,3963732015,'Scorpio'],
  [3963732015,3963936806,'Sagittarius'],
  [3963936806,3964127415,'Capricorn'],
  [3964127415,3964306722,'Aquarius'],
  [3964306722,3964481131,'Pisces'],
  [3964481131,3964657506,'Aries'],
  [3964657506,3964840944,'Taurus'],
  [3964840944,3965033416,'Gemini'],
  [3965033416,3965234226,'Cancer'],
  [3965234226,3965442043,'Leo'],
  [3965442043,3965656084,'Virgo'],
  [3965656084,3965874663,'Libra'],
  [3965874663,3966092616,'Scorpio'],
  [3966092616,3966301882,'Sagittarius'],
  [3966301882,3966496591,'Capricorn'],
  [3966496591,3966677104,'Aquarius'],
  [3966677104,3966849086,'Pisces'],
  [3966849086,3967020284,'Aries'],
  [3967020284,3967197936,'Taurus'],
  [3967197936,3967386624,'Gemini'],
  [3967386624,3967586896,'Cancer'],
  [3967586896,3967796221,'Leo'],
  [3967796221,3968011453,'Virgo'],
  [3968011453,3968230087,'Libra'],
  [3968230087,3968448714,'Scorpio'],
  [3968448714,3968661423,'Sagittarius'],
  [3968661423,3968861854,'Capricorn'],
  [3968861854,3969047551,'Aquarius'],
  [3969047551,3969221704,'Pisces'],
  [3969221704,3969391157,'Aries'],
  [3969391157,3969563736,'Taurus'],
  [3969563736,3969746152,'Gemini'],
  [3969746152,3969941876,'Cancer'],
  [3969941876,3970149886,'Leo'],
  [3970149886,3970365764,'Virgo'],
  [3970365764,3970584568,'Libra'],
  [3970584568,3970802429,'Scorpio'],
  [3970802429,3971015555,'Sagittarius'],
  [3971015555,3971219653,'Capricorn'],
  [3971219653,3971411591,'Aquarius'],
  [3971411591,3971591770,'Pisces'],
  [3971591770,3971764453,'Aries'],
  [3971764453,3971936196,'Taurus'],
  [3971936196,3972114039,'Gemini'],
  [3972114039,3972303660,'Cancer'],
  [3972303660,3972507193,'Leo'],
  [3972507193,3972721746,'Virgo'],
  [3972721746,3972940715,'Libra'],
  [3972940715,3973157716,'Scorpio'],
  [3973157716,3973368874,'Sagittarius'],
  [3973368874,3973572321,'Capricorn'],
  [3973572321,3973767085,'Aquarius'],
  [3973767085,3973953138,'Pisces'],
  [3973953138,3974132193,'Aries'],
  [3974132193,3974308019,'Taurus'],
  [3974308019,3974485982,'Gemini'],
  [3974485982,3974671937,'Cancer'],
  [3974671937,3974870335,'Leo'],
  [3974870335,3975081521,'Virgo'],
  [3975081521,3975300014,'Libra'],
  [3975300014,3975517177,'Scorpio'],
  [3975517177,3975726654,'Sagittarius'],
  [3975726654,3975926831,'Capricorn'],
  [3975926831,3976119310,'Aquarius'],
  [3976119310,3976306421,'Pisces'],
  [3976306421,3976490038,'Aries'],
  [3976490038,3976671821,'Taurus'],
  [3976671821,3976854222,'Gemini'],
  [3976854222,3977041117,'Cancer'],
  [3977041117,3977237049,'Leo'],
  [3977237049,3977444778,'Virgo'],
  [3977444778,3977661901,'Libra'],
  [3977661901,3977880102,'Scorpio'],
  [3977880102,3978090235,'Sagittarius'],
  [3978090235,3978288386,'Capricorn'],
  [3978288386,3978476602,'Aquarius'],
  [3978476602,3978659688,'Pisces'],
  [3978659688,3978842101,'Aries'],
  [3978842101,3979026405,'Taurus'],
  [3979026405,3979213563,'Gemini'],
  [3979213563,3979404625,'Cancer'],
  [3979404625,3979601984,'Leo'],
  [3979601984,3979808452,'Virgo'],
  [3979808452,3980024127,'Libra'],
  [3980024127,3980243316,'Scorpio'],
  [3980243316,3980456252,'Sagittarius'],
  [3980456252,3980655934,'Capricorn'],
  [3980655934,3980842376,'Aquarius'],
  [3980842376,3981020795,'Pisces'],
  [3981020795,3981197824,'Aries'],
  [3981197824,3981378768,'Taurus'],
  [3981378768,3981566196,'Gemini'],
  [3981566196,3981760354,'Cancer'],
  [3981760354,3981961062,'Leo'],
  [3981961062,3982168938,'Virgo'],
  [3982168938,3982384231,'Libra'],
  [3982384231,3982603784,'Scorpio'],
  [3982603784,3982819784,'Sagittarius'],
  [3982819784,3983023832,'Capricorn'],
  [3983023832,3983212839,'Aquarius'],
  [3983212839,3983390202,'Pisces'],
  [3983390202,3983562748,'Aries'],
  [3983562748,3983737604,'Taurus'],
  [3983737604,3983920135,'Gemini'],
  [3983920135,3984112705,'Cancer'],
  [3984112705,3984314895,'Leo'],
  [3984314895,3984524990,'Virgo'],
  [3984524990,3984741157,'Libra'],
  [3984741157,3984960669,'Scorpio'],
  [3984960669,3985178207,'Sagittarius'],
  [3985178207,3985386658,'Capricorn'],
  [3985386658,3985581097,'Aquarius'],
  [3985581097,3985761977,'Pisces'],
  [3985761977,3985934364,'Aries'],
  [3985934364,3986105304,'Taurus'],
  [3986105304,3986281704,'Gemini'],
  [3986281704,3986468705,'Cancer'],
  [3986468705,3986668270,'Leo'],
  [3986668270,3986878706,'Virgo'],
  [3986878706,3987095925,'Libra'],
  [3987095925,3987315416,'Scorpio'],
  [3987315416,3987532686,'Sagittarius'],
  [3987532686,3987743042,'Capricorn'],
  [3987743042,3987942354,'Aquarius'],
  [3987942354,3988129150,'Pisces'],
  [3988129150,3988305729,'Aries'],
  [3988305729,3988477321,'Taurus'],
  [3988477321,3988650543,'Gemini'],
  [3988650543,3988831914,'Cancer'],
  [3988831914,3989026121,'Leo'],
  [3989026121,3989233872,'Virgo'],
  [3989233872,3989450928,'Libra'],
  [3989450928,3989670466,'Scorpio'],
  [3989670466,3989886653,'Sagittarius'],
  [3989886653,3990096053,'Capricorn'],
  [3990096053,3990296877,'Aquarius'],
  [3990296877,3990488242,'Pisces'],
  [3990488242,3990670680,'Aries'],
  [3990670680,3990846785,'Taurus'],
  [3990846785,3991021275,'Gemini'],
  [3991021275,3991200262,'Cancer'],
  [3991200262,3991389753,'Leo'],
  [3991389753,3991593151,'Virgo'],
  [3991593151,3991808347,'Libra'],
  [3991808347,3992027785,'Scorpio'],
  [3992027785,3992243271,'Sagittarius'],
  [3992243271,3992450531,'Capricorn'],
  [3992450531,3992649400,'Aquarius'],
  [3992649400,3992841274,'Pisces'],
  [3992841274,3993027368,'Aries'],
  [3993027368,3993208808,'Taurus'],
  [3993208808,3993387797,'Gemini'],
  [3993387797,3993568478,'Cancer'],
  [3993568478,3993756378,'Leo'],
  [3993756378,3993956285,'Virgo'],
  [3993956285,3994168785,'Libra'],
  [3994168785,3994387826,'Scorpio'],
  [3994387826,3994603701,'Sagittarius'],
  [3994603701,3994809812,'Capricorn'],
  [3994809812,3995005633,'Aquarius'],
  [3995005633,3995194367,'Pisces'],
  [3995194367,3995379538,'Aries'],
  [3995379538,3995563277,'Taurus'],
  [3995563277,3995746701,'Gemini'],
  [3995746701,3995931583,'Cancer'],
  [3995931583,3996121396,'Leo'],
  [3996121396,3996320433,'Virgo'],
  [3996320433,3996530897,'Libra'],
  [3996530897,3996749342,'Scorpio'],
  [3996749342,3996966637,'Sagittarius'],
  [3996966637,3997173931,'Capricorn'],
  [3997173931,3997368514,'Aquarius'],
  [3997368514,3997553532,'Pisces'],
  [3997553532,3997734330,'Aries'],
  [3997734330,3997915491,'Taurus'],
  [3997915491,3998099577,'Gemini'],
  [3998099577,3998287715,'Cancer'],
  [3998287715,3998481164,'Leo'],
  [3998481164,3998682052,'Virgo'],
  [3998682052,3998892207,'Libra'],
  [3998892207,3999110163,'Scorpio'],
  [3999110163,3999329100,'Sagittarius'],
  [3999329100,3999539719,'Capricorn'],
  [3999539719,3999736522,'Aquarius'],
  [3999736522,3999920614,'Pisces'],
  [3999920614,4000097341,'Aries'],
  [4000097341,4000273031,'Taurus'],
  [4000273031,4000452886,'Gemini'],
  [4000452886,4000639968,'Cancer'],
  [4000639968,4000835358,'Leo'],
  [4000835358,4001039056,'Virgo'],
  [4001039056,4001250635,'Libra'],
  [4001250635,4001468565,'Scorpio'],
  [4001468565,4001688363,'Sagittarius'],
  [4001688363,4001902601,'Capricorn'],
  [4001902601,4002104459,'Aquarius'],
  [4002104459,4002291971,'Pisces'],
  [4002291971,4002468460,'Aries'],
  [4002468460,4002640133,'Taurus'],
  [4002640133,4002813802,'Gemini'],
  [4002813802,4002995305,'Cancer'],
  [4002995305,4003188132,'Leo'],
  [4003188132,4003392525,'Virgo'],
  [4003392525,4003605888,'Libra'],
  [4003605888,4003824435,'Scorpio'],
  [4003824435,4004044055,'Sagittarius'],
  [4004044055,4004259914,'Capricorn'],
  [4004259914,4004466641,'Aquarius'],
  [4004466641,4004660478,'Pisces'],
  [4004660478,4004841570,'Aries'],
  [4004841570,4005013973,'Taurus'],
  [4005013973,4005184172,'Gemini'],
  [4005184172,4005359407,'Cancer'],
  [4005359407,4005545971,'Leo'],
  [4005545971,4005746902,'Virgo'],
  [4005746902,4005960071,'Libra'],
  [4005960071,4006179354,'Scorpio'],
  [4006179354,4006398516,'Sagittarius'],
  [4006398516,4006613508,'Capricorn'],
  [4006613508,4006821686,'Aquarius'],
  [4006821686,4007020550,'Pisces'],
  [4007020550,4007208486,'Aries'],
  [4007208486,4007386387,'Taurus'],
  [4007386387,4007558412,'Gemini'],
  [4007558412,4007731184,'Cancer'],
  [4007731184,4007912120,'Leo'],
  [4007912120,4008107041,'Virgo'],
  [4008107041,4008316822,'Libra'],
  [4008316822,4008535677,'Scorpio'],
  [4008535677,4008754800,'Sagittarius'],
  [4008754800,4008968229,'Capricorn'],
  [4008968229,4009174404,'Aquarius'],
  [4009174404,4009373564,'Pisces'],
  [4009373564,4009565512,'Aries'],
  [4009565512,4009749827,'Taurus'],
  [4009749827,4009927710,'Gemini'],
  [4009927710,4010103286,'Cancer'],
  [4010103286,4010282982,'Leo'],
  [4010282982,4010473484,'Virgo'],
  [4010473484,4010678488,'Libra'],
  [4010678488,4010895113,'Scorpio'],
  [4010895113,4011114359,'Sagittarius'],
  [4011114359,4011327468,'Capricorn'],
  [4011327468,4011531230,'Aquarius'],
  [4011531230,4011727088,'Pisces'],
  [4011727088,4011917543,'Aries'],
  [4011917543,4012103976,'Taurus'],
  [4012103976,4012286956,'Gemini'],
  [4012286956,4012468072,'Cancer'],
  [4012468072,4012651126,'Leo'],
  [4012651126,4012841456,'Virgo'],
  [4012841456,4013043522,'Libra'],
  [4013043522,4013257335,'Scorpio'],
  [4013257335,4013476311,'Sagittarius'],
  [4013476311,4013690694,'Capricorn'],
  [4013690694,4013894364,'Aquarius'],
  [4013894364,4014087387,'Pisces'],
  [4014087387,4014273432,'Aries'],
  [4014273432,4014456518,'Taurus'],
  [4014456518,4014639398,'Gemini'],
  [4014639398,4014823760,'Cancer'],
  [4014823760,4015011412,'Leo'],
  [4015011412,4015205033,'Virgo'],
  [4015205033,4015407547,'Libra'],
  [4015407547,4015619868,'Scorpio'],
  [4015619868,4015838266,'Sagittarius'],
  [4015838266,4016054573,'Capricorn'],
  [4016054573,4016260872,'Aquarius'],
  [4016260872,4016454373,'Pisces'],
  [4016454373,4016637582,'Aries'],
  [4016637582,4016815587,'Taurus'],
  [4016815587,4016993661,'Gemini'],
  [4016993661,4017175931,'Cancer'],
  [4017175931,4017364940,'Leo'],
  [4017364940,4017561859,'Virgo'],
  [4017561859,4017767010,'Libra'],
  [4017767010,4017979875,'Scorpio'],
  [4017979875,4018197943,'Sagittarius'],
  [4018197943,4018415676,'Capricorn'],
  [4018415676,4018625775,'Aquarius'],
  [4018625775,4018823105,'Pisces'],
  [4018823105,4019007477,'Aries'],
  [4019007477,4019182967,'Taurus'],
  [4019182967,4019355795,'Gemini'],
  [4019355795,4019532405,'Cancer'],
  [4019532405,4019717907,'Leo'],
  [4019717907,4019914669,'Virgo'],
  [4019914669,4020121787,'Libra'],
  [4020121787,4020336268,'Scorpio'],
  [4020336268,4020554559,'Sagittarius'],
  [4020554559,4020772682,'Capricorn'],
  [4020772682,4020985596,'Aquarius'],
  [4020985596,4021187967,'Pisces'],
  [4021187967,4021377031,'Aries'],
  [4021377031,4021554343,'Taurus'],
  [4021554343,4021725211,'Gemini'],
  [4021725211,4021896847,'Cancer'],
  [4021896847,4022076442,'Leo'],
  [4022076442,4022269008,'Virgo'],
  [4022269008,4022475059,'Libra'],
  [4022475059,4022690399,'Scorpio'],
  [4022690399,4022909193,'Sagittarius'],
  [4022909193,4023126923,'Capricorn'],
  [4023126923,4023340393,'Aquarius'],
  [4023340393,4023546142,'Pisces'],
  [4023546142,4023740787,'Aries'],
  [4023740787,4023923300,'Taurus'],
  [4023923300,4024096610,'Gemini'],
  [4024096610,4024266997,'Cancer'],
  [4024266997,4024442186,'Leo'],
  [4024442186,4024629134,'Virgo'],
  [4024629134,4024831074,'Libra'],
  [4024831074,4025045142,'Scorpio'],
  [4025045142,4025264078,'Sagittarius'],
  [4025264078,4025481274,'Capricorn'],
  [4025481274,4025693487,'Aquarius'],
  [4025693487,4025899316,'Pisces'],
  [4025899316,4026097068,'Aries'],
  [4026097068,4026285065,'Taurus'],
  [4026285065,4026463783,'Gemini'],
  [4026463783,4026637179,'Cancer'],
  [4026637179,4026811870,'Leo'],
  [4026811870,4026995153,'Virgo'],
  [4026995153,4027192269,'Libra'],
  [4027192269,4027403103,'Scorpio'],
  [4027403103,4027621283,'Sagittarius'],
  [4027621283,4027838335,'Capricorn'],
  [4027838335,4028049103,'Aquarius'],
  [4028049103,4028252589,'Pisces'],
  [4028252589,4028449341,'Aries'],
  [4028449341,4028639457,'Taurus'],
  [4028639457,4028823002,'Gemini'],
  [4028823002,4029001720,'Cancer'],
  [4029001720,4029179846,'Leo'],
  [4029179846,4029363290,'Virgo'],
  [4029363290,4029557597,'Libra'],
  [4029557597,4029764916,'Scorpio'],
  [4029764916,4029981490,'Sagittarius'],
  [4029981490,4030198921,'Capricorn'],
  [4030198921,4030409648,'Aquarius'],
  [4030409648,4030610967,'Pisces'],
  [4030610967,4030804169,'Aries'],
  [4030804169,4030991774,'Taurus'],
  [4030991774,4031175883,'Gemini'],
  [4031175883,4031358267,'Cancer'],
  [4031358267,4031541266,'Leo'],
  [4031541266,4031728272,'Virgo'],
  [4031728272,4031923191,'Libra'],
  [4031923191,4032128662,'Scorpio'],
  [4032128662,4032343506,'Sagittarius'],
  [4032343506,4032561516,'Capricorn'],
  [4032561516,4032774167,'Aquarius'],
  [4032774167,4032975911,'Pisces'],
  [4032975911,4033166535,'Aries'],
  [4033166535,4033349489,'Taurus'],
  [4033349489,4033529402,'Gemini'],
  [4033529402,4033710418,'Cancer'],
  [4033710418,4033895499,'Leo'],
  [4033895499,4034086502,'Virgo'],
  [4034086502,4034284674,'Libra'],
  [4034284674,4034490918,'Scorpio'],
  [4034490918,4034704896,'Sagittarius'],
  [4034704896,4034923186,'Capricorn'],
  [4034923186,4035138758,'Aquarius'],
  [4035138758,4035344121,'Pisces'],
  [4035344121,4035535975,'Aries'],
  [4035535975,4035716410,'Taurus'],
  [4035716410,4035890993,'Gemini'],
  [4035890993,4036066315,'Cancer'],
  [4036066315,4036248030,'Leo'],
  [4036248030,4036439302,'Virgo'],
  [4036439302,4036640216,'Libra'],
  [4036640216,4036848954,'Scorpio'],
  [4036848954,4037063520,'Sagittarius'],
  [4037063520,4037281708,'Capricorn'],
  [4037281708,4037499295,'Aquarius'],
  [4037499295,4037709533,'Pisces'],
  [4037709533,4037906544,'Aries'],
  [4037906544,4038089269,'Taurus'],
  [4038089269,4038261976,'Gemini'],
  [4038261976,4038431972,'Cancer'],
  [4038431972,4038607073,'Leo'],
  [4038607073,4038793374,'Virgo'],
  [4038793374,4038992904,'Libra'],
  [4038992904,4039203022,'Scorpio'],
  [4039203022,4039419033,'Sagittarius'],
  [4039419033,4039637243,'Capricorn'],
  [4039637243,4039854943,'Aquarius'],
  [4039854943,4040068074,'Pisces'],
  [4040068074,4040271024,'Aries'],
  [4040271024,4040459987,'Taurus'],
  [4040459987,4040636148,'Gemini'],
  [4040636148,4040805414,'Cancer'],
  [4040805414,4040975883,'Leo'],
  [4040975883,4041155461,'Virgo'],
  [4041155461,4041349272,'Libra'],
  [4041349272,4041557038,'Scorpio'],
  [4041557038,4041773406,'Sagittarius'],
  [4041773406,4041991988,'Capricorn'],
  [4041991988,4042208804,'Aquarius'],
  [4042208804,4042421512,'Pisces'],
  [4042421512,4042627067,'Aries'],
  [4042627067,4042821911,'Taurus'],
  [4042821911,4043004722,'Gemini'],
  [4043004722,4043178444,'Cancer'],
  [4043178444,4043349482,'Leo'],
  [4043349482,4043525536,'Virgo'],
  [4043525536,4043713317,'Libra'],
  [4043713317,4043915744,'Scorpio'],
  [4043915744,4044129876,'Sagittarius'],
  [4044129876,4044348460,'Capricorn'],
  [4044348460,4044564790,'Aquarius'],
  [4044564790,4044775538,'Pisces'],
  [4044775538,4044979507,'Aries'],
  [4044979507,4045175697,'Taurus'],
  [4045175697,4045363325,'Gemini'],
  [4045363325,4045543343,'Cancer'],
  [4045543343,4045719349,'Leo'],
  [4045719349,4045896989,'Virgo'],
  [4045896989,4046082420,'Libra'],
  [4046082420,4046280139,'Scorpio'],
  [4046280139,4046490397,'Sagittarius'],
  [4046490397,4046707916,'Capricorn'],
  [4046707916,4046924550,'Aquarius'],
  [4046924550,4047134291,'Pisces'],
  [4047134291,4047335298,'Aries'],
  [4047335298,4047528519,'Taurus'],
  [4047528519,4047715751,'Gemini'],
  [4047715751,4047898883,'Cancer'],
  [4047898883,4048080155,'Leo'],
  [4048080155,4048262607,'Virgo'],
  [4048262607,4048450103,'Libra'],
  [4048450103,4048646493,'Scorpio'],
  [4048646493,4048853743,'Sagittarius'],
  [4048853743,4049069568,'Capricorn'],
  [4049069568,4049286909,'Aquarius'],
  [4049286909,4049497655,'Pisces'],
  [4049497655,4049697474,'Aries'],
  [4049697474,4049887034,'Taurus'],
  [4049887034,4050070086,'Gemini'],
  [4050070086,4050251062,'Cancer'],
  [4050251062,4050433546,'Leo'],
  [4050433546,4050619830,'Virgo'],
  [4050619830,4050811410,'Libra'],
  [4050811410,4051009813,'Scorpio'],
  [4051009813,4051216508,'Sagittarius'],
  [4051216508,4051431111,'Capricorn'],
  [4051431111,4051649110,'Aquarius'],
  [4051649110,4051862391,'Pisces'],
  [4051862391,4052064039,'Aries'],
  [4052064039,4052252548,'Taurus'],
  [4052252548,4052431659,'Gemini'],
  [4052431659,4052607607,'Cancer'],
  [4052607607,4052786442,'Leo'],
  [4052786442,4052972190,'Virgo'],
  [4052972190,4053166092,'Libra'],
  [4053166092,4053367529,'Scorpio'],
  [4053367529,4053575795,'Sagittarius'],
  [4053575795,4053790326,'Capricorn'],
  [4053790326,4054008683,'Aquarius'],
  [4054008683,4054224658,'Pisces'],
  [4054224658,4054430364,'Aries'],
  [4054430364,4054621513,'Taurus'],
  [4054621513,4054800001,'Gemini'],
  [4054800001,4054972122,'Cancer'],
  [4054972122,4055145468,'Leo'],
  [4055145468,4055326488,'Virgo'],
  [4055326488,4055518492,'Libra'],
  [4055518492,4055720932,'Scorpio'],
  [4055720932,4055931109,'Sagittarius'],
  [4055931109,4056146512,'Capricorn'],
  [4056146512,4056364942,'Aquarius'],
  [4056364942,4056582369,'Pisces'],
  [4056582369,4056792174,'Aries'],
  [4056792174,4056988474,'Taurus'],
  [4056988474,4057170388,'Gemini'],
  [4057170388,4057342546,'Cancer'],
  [4057342546,4057512458,'Leo'],
  [4057512458,4057687876,'Virgo'],
  [4057687876,4057874579,'Libra'],
  [4057874579,4058074323,'Scorpio'],
  [4058074323,4058284594,'Sagittarius'],
  [4058284594,4058500884,'Capricorn'],
  [4058500884,4058719298,'Aquarius'],
  [4058719298,4058936507,'Pisces'],
  [4058936507,4059148142,'Aries'],
  [4059148142,4059349183,'Taurus'],
  [4059349183,4059536911,'Gemini'],
  [4059536911,4059713245,'Cancer'],
  [4059713245,4059883975,'Leo'],
  [4059883975,4060056513,'Virgo'],
  [4060056513,4060237833,'Libra'],
  [4060237833,4060432308,'Scorpio'],
  [4060432308,4060639824,'Sagittarius'],
  [4060639824,4060855864,'Capricorn'],
  [4060855864,4061074313,'Aquarius'],
  [4061074313,4061290440,'Pisces'],
  [4061290440,4061501044,'Aries'],
  [4061501044,4061703488,'Taurus'],
  [4061703488,4061895813,'Gemini'],
  [4061895813,4062078175,'Cancer'],
  [4062078175,4062253692,'Leo'],
  [4062253692,4062427801,'Virgo'],
  [4062427801,4062606890,'Libra'],
  [4062606890,4062796594,'Scorpio'],
  [4062796594,4062999604,'Sagittarius'],
  [4062999604,4063213690,'Capricorn'],
  [4063213690,4063432124,'Aquarius'],
  [4063432124,4063647648,'Pisces'],
  [4063647648,4063856002,'Aries'],
  [4063856002,4064056149,'Taurus'],
  [4064056149,4064248684,'Gemini'],
  [4064248684,4064434709,'Cancer'],
  [4064434709,4064615919,'Leo'],
  [4064615919,4064795100,'Virgo'],
  [4064795100,4064976349,'Libra'],
  [4064976349,4065164561,'Scorpio'],
  [4065164561,4065363866,'Sagittarius'],
  [4065363866,4065574994,'Capricorn'],
  [4065574994,4065793062,'Aquarius'],
  [4065793062,4066009316,'Pisces'],
  [4066009316,4066216751,'Aries'],
  [4066216751,4066413622,'Taurus'],
  [4066413622,4066602382,'Gemini'],
  [4066602382,4066786815,'Cancer'],
  [4066786815,4066970019,'Leo'],
  [4066970019,4067153901,'Virgo'],
  [4067153901,4067339997,'Libra'],
  [4067339997,4067530683,'Scorpio'],
  [4067530683,4067729273,'Sagittarius'],
  [4067729273,4067938139,'Capricorn'],
  [4067938139,4068155401,'Aquarius'],
  [4068155401,4068373369,'Pisces'],
  [4068373369,4068582681,'Aries'],
  [4068582681,4068778804,'Taurus'],
  [4068778804,4068963728,'Gemini'],
  [4068963728,4069143048,'Cancer'],
  [4069143048,4069322598,'Leo'],
  [4069322598,4069506294,'Virgo'],
  [4069506294,4069695489,'Libra'],
  [4069695489,4069890243,'Scorpio'],
  [4069890243,4070091241,'Sagittarius'],
  [4070091241,4070300008,'Capricorn'],
  [4070300008,4070516528,'Aquarius'],
  [4070516528,4070735959,'Pisces'],
  [4070735959,4070949097,'Aries'],
  [4070949097,4071148463,'Taurus'],
  [4071148463,4071333364,'Gemini'],
  [4071333364,4071508955,'Cancer'],
  [4071508955,4071682566,'Leo'],
  [4071682566,4071860803,'Virgo'],
  [4071860803,4072047600,'Libra'],
  [4072047600,4072243573,'Scorpio'],
  [4072243573,4072447456,'Sagittarius'],
  [4072447456,4072658109,'Capricorn'],
  [4072658109,4072874730,'Aquarius'],
  [4072874730,4073094558,'Pisces'],
  [4073094558,4073310912,'Aries'],
  [4073310912,4073515748,'Taurus'],
  [4073515748,4073705214,'Gemini'],
  [4073705214,4073881904,'Cancer'],
  [4073881904,4074052504,'Leo'],
  [4074052504,4074224686,'Virgo'],
  [4074224686,4074404950,'Libra'],
  [4074404950,4074596889,'Scorpio'],
  [4074596889,4074800391,'Sagittarius'],
  [4074800391,4075012661,'Capricorn'],
  [4075012661,4075230246,'Aquarius'],
  [4075230246,4075449824,'Pisces'],
  [4075449824,4075666954,'Aries'],
  [4075666954,4075875777,'Taurus'],
  [4075875777,4076071540,'Gemini'],
  [4076071540,4076253786,'Cancer'],
  [4076253786,4076426657,'Leo'],
  [4076426657,4076596861,'Virgo'],
  [4076596861,4076771602,'Libra'],
  [4076771602,4076956900,'Scorpio'],
  [4076956900,4077155779,'Sagittarius'],
  [4077155779,4077366860,'Capricorn'],
  [4077366860,4077585045,'Aquarius'],
  [4077585045,4077804480,'Pisces'],
  [4077804480,4078020530,'Aries'],
  [4078020530,4078229691,'Taurus'],
  [4078229691,4078429155,'Gemini'],
  [4078429155,4078617620,'Cancer'],
  [4078617620,4078796467,'Leo'],
  [4078796467,4078969812,'Virgo'],
  [4078969812,4079143607,'Libra'],
  [4079143607,4079324357,'Scorpio'],
  [4079324357,4079517401,'Sagittarius'],
  [4079517401,4079724450,'Capricorn'],
  [4079724450,4079941592,'Aquarius'],
  [4079941592,4080161048,'Pisces'],
  [4080161048,4080375917,'Aries'],
  [4080375917,4080582942,'Taurus'],
  [4080582942,4080781723,'Gemini'],
  [4080781723,4080972792,'Cancer'],
  [4080972792,4081157016,'Leo'],
  [4081157016,4081336118,'Virgo'],
  [4081336118,4081513457,'Libra'],
  [4081513457,4081694113,'Scorpio'],
  [4081694113,4081883801,'Sagittarius'],
  [4081883801,4082086505,'Capricorn'],
  [4082086505,4082301162,'Aquarius'],
  [4082301162,4082520462,'Pisces'],
  [4082520462,4082735215,'Aries'],
  [4082735215,4082940284,'Taurus'],
  [4082940284,4083135913,'Gemini'],
  [4083135913,4083324993,'Cancer'],
  [4083324993,4083510274,'Leo'],
  [4083510274,4083693416,'Virgo'],
  [4083693416,4083875788,'Libra'],
  [4083875788,4084059960,'Scorpio'],
  [4084059960,4084250140,'Sagittarius'],
  [4084250140,4084450699,'Capricorn'],
  [4084450699,4084662907,'Aquarius'],
  [4084662907,4084881794,'Pisces'],
  [4084881794,4085097664,'Aries'],
  [4085097664,4085302831,'Taurus'],
  [4085302831,4085496090,'Gemini'],
  [4085496090,4085681186,'Cancer'],
  [4085681186,4085863127,'Leo'],
  [4085863127,4086045639,'Virgo'],
  [4086045639,4086230501,'Libra'],
  [4086230501,4086418693,'Scorpio'],
  [4086418693,4086612022,'Sagittarius'],
  [4086612022,4086813340,'Capricorn'],
  [4086813340,4087024505,'Aquarius'],
  [4087024505,4087242961,'Pisces'],
  [4087242961,4087460583,'Aries'],
  [4087460583,4087668225,'Taurus'],
  [4087668225,4087862065,'Gemini'],
  [4087862065,4088044731,'Cancer'],
  [4088044731,4088222091,'Leo'],
  [4088222091,4088400051,'Virgo'],
  [4088400051,4088582689,'Libra'],
  [4088582689,4088771840,'Scorpio'],
  [4088771840,4088968068,'Sagittarius'],
  [4088968068,4089171884,'Capricorn'],
  [4089171884,4089383735,'Aquarius'],
  [4089383735,4089602043,'Pisces'],
  [4089602043,4089821078,'Aries'],
  [4089821078,4090032396,'Taurus'],
  [4090032396,4090229992,'Gemini'],
  [4090229992,4090413928,'Cancer'],
  [4090413928,4090589087,'Leo'],
  [4090589087,4090762130,'Virgo'],
  [4090762130,4090939280,'Libra'],
  [4090939280,4091124900,'Scorpio'],
  [4091124900,4091320790,'Sagittarius'],
  [4091320790,4091526420,'Capricorn'],
  [4091526420,4091739875,'Aquarius'],
  [4091739875,4091958455,'Pisces'],
  [4091958455,4092177879,'Aries'],
  [4092177879,4092391977,'Taurus'],
  [4092391977,4092594689,'Gemini'],
  [4092594689,4092783504,'Cancer'],
  [4092783504,4092960753,'Leo'],
  [4092960753,4093132056,'Virgo'],
  [4093132056,4093304269,'Libra'],
  [4093304269,4093483879,'Scorpio'],
  [4093483879,4093675419,'Sagittarius'],
  [4093675419,4093879863,'Capricorn'],
  [4093879863,4094094204,'Aquarius'],
  [4094094204,4094313327,'Pisces'],
  [4094313327,4094532263,'Aries'],
  [4094532263,4094746731,'Taurus'],
  [4094746731,4094952807,'Gemini'],
  [4094952807,4095147515,'Cancer'],
  [4095147515,4095330504,'Leo'],
  [4095330504,4095504757,'Virgo'],
  [4095504757,4095675923,'Libra'],
  [4095675923,4095850972,'Scorpio'],
  [4095850972,4096036539,'Sagittarius'],
  [4096036539,4096236520,'Capricorn'],
  [4096236520,4096449474,'Aquarius'],
  [4096449474,4096668852,'Pisces'],
  [4096668852,4096887249,'Aries'],
  [4096887249,4097100151,'Taurus'],
  [4097100151,4097305874,'Gemini'],
  [4097305874,4097503535,'Cancer'],
  [4097503535,4097692372,'Leo'],
  [4097692372,4097872795,'Virgo'],
  [4097872795,4098047695,'Libra'],
  [4098047695,4098222596,'Scorpio'],
  [4098222596,4098404402,'Sagittarius'],
  [4098404402,4098599122,'Capricorn'],
  [4098599122,4098808394,'Aquarius'],
  [4098808394,4099026959,'Pisces'],
  [4099026959,4099245440,'Aries'],
  [4099245440,4099456915,'Taurus'],
  [4099456915,4099659837,'Gemini'],
  [4099659837,4099855738,'Cancer'],
  [4099855738,4100046113,'Leo'],
  [4100046113,4100231417,'Virgo'],
  [4100231417,4100412303,'Libra'],
  [4100412303,4100591477,'Scorpio'],
  [4100591477,4100774072,'Sagittarius'],
  [4100774072,4100966136,'Capricorn'],
  [4100966136,4101171530,'Aquarius'],
  [4101171530,4101388096,'Pisces'],
  [4101388096,4101607092,'Aries'],
  [4101607092,4101819042,'Taurus'],
  [4101819042,4102020084,'Gemini'],
  [4102020084,4102212072,'Cancer'],
  [4102212072,4102398909,'Leo'],
  [4102398909,4102583617,'Virgo'],
  [4102583617,4102767586,'Libra'],
  [4102767586,4102951854,'Scorpio'],
  [4102951854,4103138783,'Sagittarius'],
  [4103138783,4103332307,'Capricorn'],
  [4103332307,4103536202,'Aquarius'],
  [4103536202,4103750733,'Pisces'],
  [4103750733,4103970001,'Aries'],
  [4103970001,4104184267,'Taurus'],
  [4104184267,4104386668,'Gemini'],
  [4104386668,4104576883,'Cancer'],
  [4104576883,4104759115,'Leo'],
  [4104759115,4104938656,'Virgo'],
  [4104938656,4105119730,'Libra'],
  [4105119730,4105304834,'Scorpio'],
  [4105304834,4105495380,'Sagittarius'],
  [4105495380,4105692680,'Capricorn'],
  [4105692680,4105898176,'Aquarius'],
  [4105898176,4106112126,'Pisces'],
  [4106112126,4106331227,'Aries'],
  [4106331227,4106548040,'Taurus'],
  [4106548040,4106754552,'Gemini'],
  [4106754552,4106947252,'Cancer'],
  [4106947252,4107128286,'Leo'],
  [4107128286,4107303119,'Virgo'],
  [4107303119,4107478012,'Libra'],
  [4107478012,4107658370,'Scorpio'],
  [4107658370,4107847654,'Sagittarius'],
  [4107847654,4108046895,'Capricorn'],
  [4108046895,4108255092,'Aquarius'],
  [4108255092,4108470194,'Pisces'],
  [4108470194,4108689176,'Aries'],
  [4108689176,4108907234,'Taurus'],
  [4108907234,4109117967,'Gemini'],
  [4109117967,4109316119,'Cancer'],
  [4109316119,4109500680,'Leo'],
  [4109500680,4109675142,'Virgo'],
  [4109675142,4109845791,'Libra'],
  [4109845791,4110019753,'Scorpio'],
  [4110019753,4110203289,'Sagittarius'],
  [4110203289,4110399859,'Capricorn'],
  [4110399859,4110608595,'Aquarius'],
  [4110608595,4110825130,'Pisces'],
  [4110825130,4111044407,'Aries'],
  [4111044407,4111262281,'Taurus'],
  [4111262281,4111474889,'Gemini'],
  [4111474889,4111677994,'Cancer'],
  [4111677994,4111868665,'Leo'],
  [4111868665,4112047391,'Virgo'],
  [4112047391,4112218558,'Libra'],
  [4112218558,4112389126,'Scorpio'],
  [4112389126,4112566728,'Sagittarius'],
  [4112566728,4112757487,'Capricorn'],
  [4112757487,4112963115,'Aquarius'],
  [4112963115,4113179394,'Pisces'],
  [4113179394,4113398997,'Aries'],
  [4113398997,4113616154,'Taurus'],
  [4113616154,4113828036,'Gemini'],
  [4113828036,4114032786,'Cancer'],
  [4114032786,4114228220,'Leo'],
  [4114228220,4114413043,'Virgo'],
  [4114413043,4114588863,'Libra'],
  [4114588863,4114760759,'Scorpio'],
  [4114760759,4114935944,'Sagittarius'],
  [4114935944,4115121662,'Capricorn'],
  [4115121662,4115322255,'Aquarius'],
  [4115322255,4115535970,'Pisces'],
  [4115535970,4115755231,'Aries'],
  [4115755231,4115971948,'Taurus'],
  [4115971948,4116182111,'Gemini'],
  [4116182111,4116385210,'Cancer'],
  [4116385210,4116581357,'Leo'],
  [4116581357,4116770064,'Virgo'],
  [4116770064,4116951455,'Libra'],
  [4116951455,4117128079,'Scorpio'],
  [4117128079,4117305192,'Sagittarius'],
  [4117305192,4117489377,'Capricorn'],
  [4117489377,4117686075,'Aquarius'],
  [4117686075,4117896226,'Pisces'],
  [4117896226,4118114265,'Aries'],
  [4118114265,4118331127,'Taurus'],
  [4118331127,4118540424,'Gemini'],
  [4118540424,4118740899,'Cancer'],
  [4118740899,4118934235,'Leo'],
  [4118934235,4119122287,'Virgo'],
  [4119122287,4119306234,'Libra'],
  [4119306234,4119487544,'Scorpio'],
  [4119487544,4119669158,'Sagittarius'],
  [4119669158,4119855557,'Capricorn'],
  [4119855557,4120051415,'Aquarius'],
  [4120051415,4120259006,'Pisces'],
  [4120259006,4120475468,'Aries'],
  [4120475468,4120692936,'Taurus'],
  [4120692936,4120903207,'Gemini'],
  [4120903207,4121102682,'Cancer'],
  [4121102682,4121292655,'Leo'],
  [4121292655,4121476694,'Virgo'],
  [4121476694,4121658429,'Libra'],
  [4121658429,4121840717,'Scorpio'],
  [4121840717,4122025880,'Sagittarius'],
  [4122025880,4122216241,'Capricorn'],
  [4122216241,4122414224,'Aquarius'],
  [4122414224,4122621465,'Pisces'],
  [4122621465,4122836831,'Aries'],
  [4122836831,4123054966,'Taurus'],
  [4123054966,4123267814,'Gemini'],
  [4123267814,4123469262,'Cancer'],
  [4123469262,4123658379,'Leo'],
  [4123658379,4123838579,'Virgo'],
  [4123838579,4124015247,'Libra'],
  [4124015247,4124193779,'Scorpio'],
  [4124193779,4124378281,'Sagittarius'],
  [4124378281,4124570910,'Capricorn'],
  [4124570910,4124772006,'Aquarius'],
  [4124772006,4124980911,'Pisces'],
  [4124980911,4125196210,'Aries'],
  [4125196210,4125414660,'Taurus'],
  [4125414660,4125630294,'Gemini'],
  [4125630294,4125836130,'Cancer'],
  [4125836130,4126028295,'Leo'],
  [4126028295,4126208093,'Virgo'],
  [4126208093,4126380843,'Libra'],
  [4126380843,4126553587,'Scorpio'],
  [4126553587,4126733010,'Sagittarius'],
  [4126733010,4126923488,'Capricorn'],
  [4126923488,4127125574,'Aquarius'],
  [4127125574,4127336527,'Pisces'],
  [4127336527,4127552729,'Aries'],
  [4127552729,4127771096,'Taurus'],
  [4127771096,4127988047,'Gemini'],
  [4127988047,4128198202,'Cancer'],
  [4128198202,4128396153,'Leo'],
  [4128396153,4128580078,'Virgo'],
  [4128580078,4128753240,'Libra'],
  [4128753240,4128922502,'Scorpio'],
  [4128922502,4129095916,'Sagittarius'],
  [4129095916,4129280464,'Capricorn'],
  [4129280464,4129479344,'Aquarius'],
  [4129479344,4129690261,'Pisces'],
  [4129690261,4129907448,'Aries'],
  [4129907448,4130125744,'Taurus'],
  [4130125744,4130342129,'Gemini'],
  [4130342129,4130553773,'Cancer'],
  [4130553773,4130756592,'Leo'],
  [4130756592,4130947064,'Virgo'],
  [4130947064,4131125332,'Libra'],
  [4131125332,4131296124,'Scorpio'],
  [4131296124,4131466968,'Sagittarius'],
  [4131466968,4131645873,'Capricorn'],
  [4131645873,4131838721,'Aquarius'],
  [4131838721,4132046168,'Pisces'],
  [4132046168,4132262890,'Aries'],
  [4132262890,4132481365,'Taurus'],
  [4132481365,4132696604,'Gemini'],
  [4132696604,4132906655,'Cancer'],
  [4132906655,4133110099,'Leo'],
  [4133110099,4133304836,'Virgo'],
  [4133304836,4133489592,'Libra'],
  [4133489592,4133666149,'Scorpio'],
  [4133666149,4133839664,'Sagittarius'],
  [4133839664,4134017142,'Capricorn'],
  [4134017142,4134205260,'Aquarius'],
  [4134205260,4134407510,'Pisces'],
  [4134407510,4134621571,'Aries'],
  [4134621571,4134839970,'Taurus'],
  [4134839970,4135055015,'Gemini'],
  [4135055015,4135262938,'Cancer'],
  [4135262938,4135463405,'Leo'],
  [4135463405,4135657090,'Virgo'],
  [4135657090,4135844491,'Libra'],
  [4135844491,4136026576,'Scorpio'],
  [4136026576,4136205893,'Sagittarius'],
  [4136205893,4136386795,'Capricorn'],
  [4136386795,4136574534,'Aquarius'],
  [4136574534,4136773371,'Pisces'],
  [4136773371,4136983956,'Aries'],
  [4136983956,4137201486,'Taurus'],
  [4137201486,4137417544,'Gemini'],
  [4137417544,4137625379,'Cancer'],
  [4137625379,4137823059,'Leo'],
  [4137823059,4138012457,'Virgo'],
  [4138012457,4138196865,'Libra'],
  [4138196865,4138379391,'Scorpio'],
  [4138379391,4138562531,'Sagittarius'],
  [4138562531,4138748502,'Capricorn'],
  [4138748502,4138939754,'Aquarius'],
  [4138939754,4139138925,'Pisces'],
  [4139138925,4139347570,'Aries'],
  [4139347570,4139563855,'Taurus'],
  [4139563855,4139781300,'Gemini'],
  [4139781300,4139991553,'Cancer'],
  [4139991553,4140189624,'Leo'],
  [4140189624,4140376063,'Virgo'],
  [4140376063,4140555356,'Libra'],
  [4140555356,4140733235,'Scorpio'],
  [4140733235,4140914609,'Sagittarius'],
  [4140914609,4141102382,'Capricorn'],
  [4141102382,4141297385,'Aquarius'],
  [4141297385,4141499514,'Pisces'],
  [4141499514,4141708769,'Aries'],
  [4141708769,4141924428,'Taurus'],
  [4141924428,4142142788,'Gemini'],
  [4142142788,4142356493,'Cancer'],
  [4142356493,4142558285,'Leo'],
  [4142558285,4142745803,'Virgo'],
  [4142745803,4142922472,'Libra'],
  [4142922472,4143095037,'Scorpio'],
  [4143095037,4143270713,'Sagittarius'],
  [4143270713,4143454995,'Capricorn'],
  [4143454995,4143649985,'Aquarius'],
  [4143649985,4143854382,'Pisces'],
  [4143854382,4144065638,'Aries'],
  [4144065638,4144281743,'Taurus'],
  [4144281743,4144500358,'Gemini'],
  [4144500358,4144716556,'Cancer'],
  [4144716556,4144923223,'Leo'],
  [4144923223,4145115431,'Virgo'],
  [4145115431,4145293953,'Libra'],
  [4145293953,4145464595,'Scorpio'],
  [4145464595,4145635260,'Sagittarius'],
  [4145635260,4145813441,'Capricorn'],
  [4145813441,4146003958,'Aquarius'],
  [4146003958,4146207121,'Pisces'],
  [4146207121,4146419401,'Aries'],
  [4146419401,4146636428,'Taurus'],
  [4146636428,4146854957,'Gemini'],
  [4146854957,4147071684,'Cancer'],
  [4147071684,4147281568,'Leo'],
  [4147281568,4147479318,'Virgo'],
  [4147479318,4147663133,'Libra'],
  [4147663133,4147836390,'Scorpio'],
  [4147836390,4148005963,'Sagittarius'],
  [4148005963,4148179707,'Capricorn'],
  [4148179707,4148364286,'Aquarius'],
  [4148364286,4148562825,'Pisces'],
  [4148562825,4148773457,'Aries'],
  [4148773457,4148990725,'Taurus'],
  [4148990725,4149209139,'Gemini'],
  [4149209139,4149424942,'Cancer'],
  [4149424942,4149634973,'Leo'],
  [4149634973,4149835819,'Virgo'],
  [4149835819,4150025174,'Libra'],
  [4150025174,4150203999,'Scorpio'],
  [4150203999,4150376815,'Sagittarius'],
  [4150376815,4150550222,'Capricorn'],
  [4150550222,4150731053,'Aquarius'],
  [4150731053,4150924334,'Pisces'],
  [4150924334,4151131043,'Aries'],
  [4151131043,4151347078,'Taurus'],
  [4151347078,4151565407,'Gemini'],
  [4151565407,4151780150,'Cancer'],
  [4151780150,4151988182,'Leo'],
  [4151988182,4152188239,'Virgo'],
  [4152188239,4152379874,'Libra'],
  [4152379874,4152563678,'Scorpio'],
  [4152563678,4152742002,'Sagittarius'],
  [4152742002,4152919028,'Capricorn'],
  [4152919028,4153100098,'Aquarius'],
  [4153100098,4153290417,'Pisces'],
  [4153290417,4153493061,'Aries'],
  [4153493061,4153706670,'Taurus'],
  [4153706670,4153924831,'Gemini'],
  [4153924831,4154139515,'Cancer'],
  [4154139515,4154345684,'Leo'],
  [4154345684,4154542586,'Virgo'],
  [4154542586,4154732122,'Libra'],
  [4154732122,4154916847,'Scorpio'],
  [4154916847,4155099108,'Sagittarius'],
  [4155099108,4155281195,'Capricorn'],
  [4155281195,4155465928,'Aquarius'],
  [4155465928,4155656877,'Pisces'],
  [4155656877,4155857464,'Aries'],
  [4155857464,4156068676,'Taurus'],
  [4156068676,4156286498,'Gemini'],
  [4156286498,4156502474,'Cancer'],
  [4156502474,4156708908,'Leo'],
  [4156708908,4156903427,'Virgo'],
  [4156903427,4157088773,'Libra'],
  [4157088773,4157269895,'Scorpio'],
  [4157269895,4157451336,'Sagittarius'],
  [4157451336,4157635909,'Capricorn'],
  [4157635909,4157824852,'Aquarius'],
  [4157824852,4158019156,'Pisces'],
  [4158019156,4158220576,'Aries'],
  [4158220576,4158430698,'Taurus'],
  [4158430698,4158648071,'Gemini'],
  [4158648071,4158866021,'Cancer'],
  [4158866021,4159075374,'Leo'],
  [4159075374,4159270816,'Virgo'],
  [4159270816,4159453730,'Libra'],
  [4159453730,4159629948,'Scorpio'],
  [4159629948,4159806313,'Sagittarius'],
  [4159806313,4159988167,'Capricorn'],
  [4159988167,4160177880,'Aquarius'],
  [4160177880,4160375213,'Pisces'],
  [4160375213,4160579355,'Aries'],
  [4160579355,4160790242,'Taurus'],
  [4160790242,4161007345,'Gemini'],
  [4161007345,4161226664,'Cancer'],
  [4161226664,4161440083,'Leo'],
  [4161440083,4161640035,'Virgo'],
  [4161640035,4161824885,'Libra'],
  [4161824885,4161999192,'Scorpio'],
  [4161999192,4162170442,'Sagittarius'],
  [4162170442,4162346090,'Capricorn'],
  [4162346090,4162531372,'Aquarius'],
  [4162531372,4162727793,'Pisces'],
  [4162727793,4162933675,'Aries'],
  [4162933675,4163146383,'Taurus'],
  [4163146383,4163363799,'Gemini'],
  [4163363799,4163583197,'Cancer'],
  [4163583197,4163799140,'Leo'],
  [4163799140,4164004568,'Virgo'],
  [4164004568,4164195248,'Libra'],
  [4164195248,4164372733,'Scorpio'],
  [4164372733,4164543078,'Sagittarius'],
  [4164543078,4164713979,'Capricorn'],
  [4164713979,4164892581,'Aquarius'],
  [4164892581,4165083505,'Pisces'],
  [4165083505,4165287295,'Aries'],
  [4165287295,4165500684,'Taurus'],
  [4165500684,4165718876,'Gemini'],
  [4165718876,4165937716,'Cancer'],
  [4165937716,4166153358,'Leo'],
  [4166153358,4166361412,'Virgo'],
  [4166361412,4166557965,'Libra'],
  [4166557965,4166742056,'Scorpio'],
  [4166742056,4166916737,'Sagittarius'],
  [4166916737,4167087931,'Capricorn'],
  [4167087931,4167262637,'Aquarius'],
  [4167262637,4167447240,'Pisces'],
  [4167447240,4167645512,'Aries'],
  [4167645512,4167856597,'Taurus'],
  [4167856597,4168074939,'Gemini'],
  [4168074939,4168293581,'Cancer'],
  [4168293581,4168507523,'Leo'],
  [4168507523,4168714223,'Virgo'],
  [4168714223,4168912437,'Libra'],
  [4168912437,4169101701,'Scorpio'],
  [4169101701,4169282964,'Sagittarius'],
  [4169282964,4169459180,'Capricorn'],
  [4169459180,4169635227,'Aquarius'],
  [4169635227,4169817072,'Pisces'],
  [4169817072,4170010168,'Aries'],
  [4170010168,4170216864,'Taurus'],
  [4170216864,4170433775,'Gemini'],
  [4170433775,4170652672,'Cancer'],
  [4170652672,4170865739,'Leo'],
  [4170865739,4171069649,'Virgo'],
  [4171069649,4171265145,'Libra'],
  [4171265145,4171454390,'Scorpio'],
  [4171454390,4171639242,'Sagittarius'],
  [4171639242,4171821163,'Capricorn'],
  [4171821163,4172002229,'Aquarius'],
  [4172002229,4172186090,'Pisces'],
  [4172186090,4172377609,'Aries'],
  [4172377609,4172580786,'Taurus'],
  [4172580786,4172795306,'Gemini'],
  [4172795306,4173014405,'Cancer'],
  [4173014405,4173228342,'Leo'],
  [4173228342,4173431136,'Virgo'],
  [4173431136,4173623113,'Libra'],
  [4173623113,4173808361,'Scorpio'],
  [4173808361,4173991305,'Sagittarius'],
  [4173991305,4174174801,'Capricorn'],
  [4174174801,4174360095,'Aquarius'],
  [4174360095,4174548357,'Pisces'],
  [4174548357,4174742092,'Aries'],
  [4174742092,4174944655,'Taurus'],
  [4174944655,4175157461,'Gemini'],
  [4175157461,4175376502,'Cancer'],
  [4175376502,4175592515,'Leo'],
  [4175592515,4175797060,'Virgo'],
  [4175797060,4175988113,'Libra'],
  [4175988113,4176169568,'Scorpio'],
  [4176169568,4176347563,'Sagittarius'],
  [4176347563,4176527475,'Capricorn'],
  [4176527475,4176712381,'Aquarius'],
  [4176712381,4176903219,'Pisces'],
  [4176903219,4177100365,'Aries'],
  [4177100365,4177304871,'Taurus'],
  [4177304871,4177517643,'Gemini'],
  [4177517643,4177736586,'Cancer'],
  [4177736586,4177954681,'Leo'],
  [4177954681,4178162975,'Virgo'],
  [4178162975,4178356711,'Libra'],
  [4178356711,4178537742,'Scorpio'],
  [4178537742,4178712040,'Sagittarius'],
  [4178712040,4178886450,'Capricorn'],
  [4178886450,4179066547,'Aquarius'],
  [4179066547,4179255430,'Pisces'],
  [4179255430,4179453697,'Aries'],
  [4179453697,4179660498,'Taurus'],
  [4179660498,4179874552,'Gemini'],
  [4179874552,4180093621,'Cancer'],
  [4180093621,4180312790,'Leo'],
  [4180312790,4180524753,'Virgo'],
  [4180524753,4180723485,'Libra'],
  [4180723485,4180908060,'Scorpio'],
  [4180908060,4181082577,'Sagittarius'],
  [4181082577,4181253621,'Capricorn'],
  [4181253621,4181428052,'Aquarius'],
  [4181428052,4181611456,'Pisces'],
  [4181611456,4181806808,'Aries'],
  [4181806808,4182013707,'Taurus'],
  [4182013707,4182228977,'Gemini'],
  [4182228977,4182448408,'Cancer'],
  [4182448408,4182667449,'Leo'],
  [4182667449,4182881045,'Virgo'],
  [4182881045,4183084301,'Libra'],
  [4183084301,4183274636,'Scorpio'],
  [4183274636,4183453410,'Sagittarius'],
  [4183453410,4183625330,'Capricorn'],
  [4183625330,4183796878,'Aquarius'],
  [4183796878,4183974827,'Pisces'],
  [4183974827,4184164647,'Aries'],
  [4184164647,4184368418,'Taurus'],
  [4184368418,4184583305,'Gemini'],
  [4184583305,4184803012,'Cancer'],
  [4184803012,4185021348,'Leo'],
  [4185021348,4185234151,'Virgo'],
  [4185234151,4185438881,'Libra'],
  [4185438881,4185633811,'Scorpio'],
  [4185633811,4185818614,'Sagittarius'],
  [4185818614,4185995291,'Capricorn'],
  [4185995291,4186168340,'Aquarius'],
  [4186168340,4186344032,'Pisces'],
  [4186344032,4186528982,'Aries'],
  [4186528982,4186727835,'Taurus'],
  [4186727835,4186940189,'Gemini'],
  [4186940189,4187159585,'Cancer'],
  [4187159585,4187377481,'Leo'],
  [4187377481,4187588469,'Virgo'],
  [4187588469,4187791368,'Libra'],
  [4187791368,4187986871,'Scorpio'],
  [4187986871,4188175567,'Sagittarius'],
  [4188175567,4188358010,'Capricorn'],
  [4188358010,4188536046,'Aquarius'],
  [4188536046,4188713812,'Pisces'],
  [4188713812,4188897255,'Aries'],
  [4188897255,4189092187,'Taurus'],
  [4189092187,4189300934,'Gemini'],
  [4189300934,4189519156,'Cancer'],
  [4189519156,4189737341,'Leo'],
  [4189737341,4189947505,'Virgo'],
  [4189947505,4190147599,'Libra'],
  [4190147599,4190339947,'Scorpio'],
  [4190339947,4190527665,'Sagittarius'],
  [4190527665,4190712589,'Capricorn'],
  [4190712589,4190895560,'Aquarius'],
  [4190895560,4191078204,'Pisces'],
  [4191078204,4191264147,'Aries'],
  [4191264147,4191458339,'Taurus'],
  [4191458339,4191664428,'Gemini'],
  [4191664428,4191880967,'Cancer'],
  [4191880967,4192099920,'Leo'],
  [4192099920,4192311444,'Virgo'],
  [4192311444,4192510793,'Libra'],
  [4192510793,4192699664,'Scorpio'],
  [4192699664,4192882838,'Sagittarius'],
  [4192882838,4193064831,'Capricorn'],
  [4193064831,4193248319,'Aquarius'],
  [4193248319,4193434528,'Pisces'],
  [4193434528,4193624813,'Aries'],
  [4193624813,4193821600,'Taurus'],
  [4193821600,4194027549,'Gemini'],
  [4194027549,4194242836,'Cancer'],
  [4194242836,4194462332,'Leo'],
  [4194462332,4194676811,'Virgo'],
  [4194676811,4194878918,'Libra'],
  [4194878918,4195067640,'Scorpio'],
  [4195067640,4195247157,'Sagittarius'],
  [4195247157,4195423505,'Capricorn'],
  [4195423505,4195602139,'Aquarius'],
  [4195602139,4195786685,'Pisces'],
  [4195786685,4195978812,'Aries'],
  [4195978812,4196178965,'Taurus'],
  [4196178965,4196387109,'Gemini'],
  [4196387109,4196602487,'Cancer'],
  [4196602487,4196821944,'Leo'],
  [4196821944,4197038962,'Virgo'],
  [4197038962,4197245968,'Libra'],
  [4197245968,4197438911,'Scorpio'],
  [4197438911,4197619261,'Sagittarius'],
  [4197619261,4197792336,'Capricorn'],
  [4197792336,4197964864,'Aquarius'],
  [4197964864,4198143185,'Pisces'],
  [4198143185,4198331792,'Aries'],
  [4198331792,4198532110,'Taurus'],
  [4198532110,4198742369,'Gemini'],
  [4198742369,4198959061,'Cancer'],
  [4198959061,4199178350,'Leo'],
  [4199178350,4199395959,'Virgo'],
  [4199395959,4199606694,'Libra'],
  [4199606694,4199805763,'Scorpio'],
  [4199805763,4199991514,'Sagittarius'],
  [4199991514,4200166536,'Capricorn'],
  [4200166536,4200336669,'Aquarius'],
  [4200336669,4200509209,'Pisces'],
  [4200509209,4200691138,'Aries'],
  [4200691138,4200886939,'Taurus'],
  [4200886939,4201096235,'Gemini'],
  [4201096235,4201313859,'Cancer'],
  [4201313859,4201533340,'Leo'],
  [4201533340,4201750070,'Virgo'],
  [4201750070,4201961222,'Libra'],
  [4201961222,4202164077,'Scorpio'],
  [4202164077,4202356199,'Sagittarius'],
  [4202356199,4202537233,'Capricorn'],
  [4202537233,4202710302,'Aquarius'],
  [4202710302,4202881603,'Pisces'],
  [4202881603,4203058704,'Aries'],
  [4203058704,4203248340,'Taurus'],
  [4203248340,4203453264,'Gemini'],
  [4203453264,4203669695,'Cancer'],
  [4203669695,4203889355,'Leo'],
  [4203889355,4204105225,'Virgo'],
  [4204105225,4204314516,'Libra'],
  [4204314516,4204516873,'Scorpio'],
  [4204516873,4204711818,'Sagittarius'],
  [4204711818,4204898525,'Capricorn'],
  [4204898525,4205077555,'Aquarius'],
  [4205077555,4205252459,'Pisces'],
  [4205252459,4205429435,'Aries'],
  [4205429435,4205615483,'Taurus'],
  [4205615483,4205815525,'Gemini'],
  [4205815525,4206028812,'Cancer'],
  [4206028812,4206247957,'Leo'],
  [4206247957,4206463811,'Virgo'],
  [4206463811,4206671465,'Libra'],
  [4206671465,4206870927,'Scorpio'],
  [4206870927,4207064029,'Sagittarius'],
  [4207064029,4207251985,'Capricorn'],
  [4207251985,4207435345,'Aquarius'],
  [4207435345,4207615592,'Pisces'],
  [4207615592,4207796380,'Aries'],
  [4207796380,4207983086,'Taurus'],
  [4207983086,4208180776,'Gemini'],
  [4208180776,4208390962,'Cancer'],
  [4208390962,4208608934,'Leo'],
  [4208608934,4208825551,'Virgo'],
  [4208825551,4209033432,'Libra'],
  [4209033432,4209230810,'Scorpio'],
  [4209230810,4209420101,'Sagittarius'],
  [4209420101,4209604798,'Capricorn'],
  [4209604798,4209787648,'Aquarius'],
  [4209787648,4209970598,'Pisces'],
  [4209970598,4210155737,'Aries'],
  [4210155737,4210345989,'Taurus'],
  [4210345989,4210544668,'Gemini'],
  [4210544668,4210753592,'Cancer'],
  [4210753592,4210970458,'Leo'],
  [4210970458,4211188146,'Virgo'],
  [4211188146,4211398257,'Libra'],
  [4211398257,4211596354,'Scorpio'],
  [4211596354,4211783410,'Sagittarius'],
  [4211783410,4211963626,'Capricorn'],
  [4211963626,4212141984,'Aquarius'],
  [4212141984,4212322773,'Pisces'],
  [4212322773,4212508997,'Aries'],
  [4212508997,4212702432,'Taurus'],
  [4212702432,4212903987,'Gemini'],
  [4212903987,4213113813,'Cancer'],
  [4213113813,4213330314,'Leo'],
  [4213330314,4213548824,'Virgo'],
  [4213548824,4213762083,'Libra'],
  [4213762083,4213963765,'Scorpio'],
  [4213963765,4214152148,'Sagittarius'],
  [4214152148,4214330241,'Capricorn'],
  [4214330241,4214503778,'Aquarius'],
  [4214503778,4214679170,'Pisces'],
  [4214679170,4214861879,'Aries'],
  [4214861879,4215055004,'Taurus'],
  [4215055004,4215258556,'Gemini'],
  [4215258556,4215470305,'Cancer'],
  [4215470305,4215687308,'Leo'],
  [4215687308,4215906082,'Virgo'],
  [4215906082,4216121707,'Libra'],
  [4216121707,4216328130,'Scorpio'],
  [4216328130,4216521203,'Sagittarius'],
  [4216521203,4216701299,'Capricorn'],
  [4216701299,4216873103,'Aquarius'],
  [4216873103,4217043698,'Pisces'],
  [4217043698,4217220506,'Aries'],
  [4217220506,4217409215,'Taurus'],
  [4217409215,4217611462,'Gemini'],
  [4217611462,4217824154,'Cancer'],
  [4217824154,4218042014,'Leo'],
  [4218042014,4218260635,'Virgo'],
  [4218260635,4218476713,'Libra'],
  [4218476713,4218686333,'Scorpio'],
  [4218686333,4218885068,'Sagittarius'],
  [4218885068,4219070670,'Capricorn'],
  [4219070670,4219245237,'Aquarius'],
  [4219245237,4219414783,'Pisces'],
  [4219414783,4219587168,'Aries'],
  [4219587168,4219769920,'Taurus'],
  [4219769920,4219967462,'Gemini'],
  [4219967462,4220178442,'Cancer'],
  [4220178442,4220396521,'Leo'],
  [4220396521,4220614966,'Virgo'],
  [4220614966,4220829965,'Libra'],
  [4220829965,4221039566,'Scorpio'],
  [4221039566,4221241393,'Sagittarius'],
  [4221241393,4221432818,'Capricorn'],
  [4221432818,4221613383,'Aquarius'],
  [4221613383,4221786509,'Pisces'],
  [4221786509,4221958740,'Aries'],
  [4221958740,4222137739,'Taurus'],
  [4222137739,4222329795,'Gemini'],
  [4222329795,4222536569,'Cancer'],
  [4222536569,4222753305,'Leo'],
  [4222753305,4222971733,'Virgo'],
  [4222971733,4223185662,'Libra'],
  [4223185662,4223393009,'Scorpio'],
  [4223393009,4223593619,'Sagittarius'],
  [4223593619,4223787063,'Capricorn'],
  [4223787063,4223972799,'Aquarius'],
  [4223972799,4224151975,'Pisces'],
  [4224151975,4224328469,'Aries'],
  [4224328469,4224508216,'Taurus'],
  [4224508216,4224697407,'Gemini'],
  [4224697407,4224899778,'Cancer'],
  [4224899778,4225113711,'Leo'],
  [4225113711,4225331986,'Virgo'],
  [4225331986,4225546199,'Libra'],
  [4225546199,4225751870,'Scorpio'],
  [4225751870,4225948983,'Sagittarius'],
  [4225948983,4226139508,'Capricorn'],
  [4226139508,4226325395,'Aquarius'],
  [4226325395,4226508282,'Pisces'],
  [4226508282,4226690261,'Aries'],
  [4226690261,4226874518,'Taurus'],
  [4226874518,4227065107,'Gemini'],
  [4227065107,4227265616,'Cancer'],
  [4227265616,4227476795,'Leo'],
  [4227476795,4227694428,'Virgo'],
  [4227694428,4227910272,'Libra'],
  [4227910272,4228117007,'Scorpio'],
  [4228117007,4228312283,'Sagittarius'],
  [4228312283,4228498352,'Capricorn'],
  [4228498352,4228679582,'Aquarius'],
  [4228679582,4228860359,'Pisces'],
  [4228860359,4229043978,'Aries'],
  [4229043978,4229232475,'Taurus'],
  [4229232475,4229427171,'Gemini'],
  [4229427171,4229629288,'Cancer'],
  [4229629288,4229839551,'Leo'],
  [4229839551,4230056328,'Virgo'],
  [4230056328,4230273931,'Libra'],
  [4230273931,4230484223,'Scorpio'],
  [4230484223,4230681634,'Sagittarius'],
  [4230681634,4230866226,'Capricorn'],
  [4230866226,4231042668,'Aquarius'],
  [4231042668,4231217537,'Pisces'],
  [4231217537,4231396965,'Aries'],
  [4231396965,4231584882,'Taurus'],
  [4231584882,4231782132,'Gemini'],
  [4231782132,4231987363,'Cancer'],
  [4231987363,4232198948,'Leo'],
  [4232198948,4232415444,'Virgo'],
  [4232415444,4232633809,'Libra'],
  [4232633809,4232847817,'Scorpio'],
  [4232847817,4233050357,'Sagittarius'],
  [4233050357,4233238194,'Capricorn'],
  [4233238194,4233413987,'Aquarius'],
  [4233413987,4233584463,'Pisces'],
  [4233584463,4233757518,'Aries'],
  [4233757518,4233939861,'Taurus'],
  [4233939861,4234134757,'Gemini'],
  [4234134757,4234340912,'Cancer'],
  [4234340912,4234554355,'Leo'],
  [4234554355,4234771470,'Virgo'],
  [4234771470,4234989670,'Libra'],
  [4234989670,4235205295,'Scorpio'],
  [4235205295,4235412569,'Sagittarius'],
  [4235412569,4235606432,'Capricorn'],
  [4235606432,4235786412,'Aquarius'],
  [4235786412,4235957325,'Pisces'],
  [4235957325,4236126890,'Aries'],
  [4236126890,4236303132,'Taurus'],
  [4236303132,4236492022,'Gemini'],
  [4236492022,4236694963,'Cancer'],
  [4236694963,4236908273,'Leo'],
  [4236908273,4237126106,'Virgo'],
  [4237126106,4237343972,'Libra'],
  [4237343972,4237558970,'Scorpio'],
  [4237558970,4237767772,'Sagittarius'],
  [4237767772,4237966369,'Capricorn'],
  [4237966369,4238152550,'Aquarius'],
  [4238152550,4238328275,'Pisces'],
  [4238328275,4238499298,'Aries'],
  [4238499298,4238673089,'Taurus'],
  [4238673089,4238856656,'Gemini'],
  [4238856656,4239054108,'Cancer'],
  [4239054108,4239264445,'Leo'],
  [4239264445,4239481896,'Virgo'],
  [4239481896,4239699656,'Libra'],
  [4239699656,4239913284,'Scorpio'],
  [4239913284,4240120533,'Sagittarius'],
  [4240120533,4240319813,'Capricorn'],
  [4240319813,4240509939,'Aquarius'],
  [4240509939,4240691433,'Pisces'],
  [4240691433,4240867471,'Aries'],
  [4240867471,4241043410,'Taurus'],
  [4241043410,4241225430,'Gemini'],
  [4241225430,4241418659,'Cancer'],
  [4241418659,4241624837,'Leo'],
  [4241624837,4241840527,'Virgo'],
  [4241840527,4242058330,'Libra'],
  [4242058330,4242271354,'Scorpio'],
  [4242271354,4242476247,'Sagittarius'],
  [4242476247,4242672829,'Capricorn'],
  [4242672829,4242862355,'Aquarius'],
  [4242862355,4243046502,'Pisces'],
  [4243046502,4243227431,'Aries'],
  [4243227431,4243408148,'Taurus'],
  [4243408148,4243592582,'Gemini'],
  [4243592582,4243784966,'Cancer'],
  [4243784966,4243988243,'Leo'],
  [4243988243,4244201703,'Virgo'],
  [4244201703,4244419555,'Libra'],
  [4244419555,4244633423,'Scorpio'],
  [4244633423,4244837487,'Sagittarius'],
  [4244837487,4245030926,'Capricorn'],
  [4245030926,4245216631,'Aquarius'],
  [4245216631,4245398708,'Pisces'],
  [4245398708,4245580731,'Aries'],
  [4245580731,4245765156,'Taurus'],
  [4245765156,4245953751,'Gemini'],
  [4245953751,4246148443,'Cancer'],
  [4246148443,4246351402,'Leo'],
  [4246351402,4246563417,'Virgo'],
  [4246563417,4246781265,'Libra'],
  [4246781265,4246997161,'Scorpio'],
  [4246997161,4247203015,'Sagittarius'],
  [4247203015,4247395683,'Capricorn'],
  [4247395683,4247577792,'Aquarius'],
  [4247577792,4247755097,'Pisces'],
  [4247755097,4247933578,'Aries'],
  [4247933578,4248117466,'Taurus'],
  [4248117466,4248308422,'Gemini'],
  [4248308422,4248506379,'Cancer'],
  [4248506379,4248711243,'Leo'],
  [4248711243,4248923287,'Virgo'],
  [4248923287,4249141116,'Libra'],
  [4249141116,4249359160,'Scorpio'],
  [4249359160,4249568870,'Sagittarius'],
  [4249568870,4249764334,'Capricorn'],
  [4249764334,4249946073,'Aquarius'],
  [4249946073,4250119724,'Pisces'],
  [4250119724,4250292743,'Aries'],
  [4250292743,4250471783,'Taurus'],
  [4250471783,4250660689,'Gemini'],
  [4250660689,4250859674,'Cancer'],
  [4250859674,4251066773,'Leo'],
  [4251066773,4251280066,'Virgo'],
  [4251280066,4251497995,'Libra'],
  [4251497995,4251717122,'Scorpio'],
  [4251717122,4251930660,'Sagittarius'],
  [4251930660,4252131455,'Capricorn'],
  [4252131455,4252317052,'Aquarius'],
  [4252317052,4252491098,'Pisces'],
  [4252491098,4252660799,'Aries'],
  [4252660799,4252834030,'Taurus'],
  [4252834030,4253017143,'Gemini'],
  [4253017143,4253212927,'Cancer'],
  [4253212927,4253419982,'Leo'],
  [4253419982,4253634503,'Virgo'],
  [4253634503,4253852787,'Libra'],
  [4253852787,4254071647,'Scorpio'],
  [4254071647,4254286679,'Sagittarius'],
  [4254286679,4254492167,'Capricorn'],
  [4254492167,4254684064,'Aquarius'],
  [4254684064,4254863019,'Pisces'],
  [4254863019,4255034147,'Aries'],
  [4255034147,4255204737,'Taurus'],
  [4255204737,4255382141,'Gemini'],
  [4255382141,4255571794,'Cancer'],
  [4255571794,4255775180,'Leo'],
  [4255775180,4255989134,'Virgo'],
  [4255989134,4256207809,'Libra'],
  [4256207809,4256425936,'Scorpio'],
  [4256425936,4256639782,'Sagittarius'],
  [4256639782,4256846244,'Capricorn'],
  [4256846244,4257042669,'Aquarius'],
  [4257042669,4257228212,'Pisces'],
  [4257228212,4257405064,'Aries'],
  [4257405064,4257578135,'Taurus'],
  [4257578135,4257753801,'Gemini'],
  [4257753801,4257938383,'Cancer'],
  [4257938383,4258136156,'Leo'],
  [4258136156,4258346960,'Virgo'],
  [4258346960,4258565277,'Libra'],
  [4258565277,4258783270,'Scorpio'],
  [4258783270,4258995271,'Sagittarius'],
  [4258995271,4259199211,'Capricorn'],
  [4259199211,4259395220,'Aquarius'],
  [4259395220,4259584063,'Pisces'],
  [4259584063,4259766923,'Aries'],
  [4259766923,4259945971,'Taurus'],
  [4259945971,4260124895,'Gemini'],
  [4260124895,4260308725,'Cancer'],
  [4260308725,4260502587,'Leo'],
  [4260502587,4260709215,'Virgo'],
  [4260709215,4260925914,'Libra'],
  [4260925914,4261144458,'Scorpio'],
  [4261144458,4261356244,'Sagittarius'],
  [4261356244,4261557516,'Capricorn'],
  [4261557516,4261749642,'Aquarius'],
  [4261749642,4261936173,'Pisces'],
  [4261936173,4262120286,'Aries'],
  [4262120286,4262303874,'Taurus'],
  [4262303874,4262488253,'Gemini'],
  [4262488253,4262675625,'Cancer'],
  [4262675625,4262869609,'Leo'],
  [4262869609,4263073785,'Virgo'],
  [4263073785,4263288392,'Libra'],
  [4263288392,4263507482,'Scorpio'],
  [4263507482,4263721186,'Sagittarius'],
  [4263721186,4263922651,'Capricorn'],
  [4263922651,4264111847,'Aquarius'],
  [4264111847,4264293517,'Pisces'],
  [4264293517,4264473458,'Aries'],
  [4264473458,4264655954,'Taurus'],
  [4264655954,4264842837,'Gemini'],
  [4264842837,4265034474,'Cancer'],
  [4265034474,4265231716,'Leo'],
  [4265231716,4265436525,'Virgo'],
  [4265436525,4265650068,'Libra'],
  [4265650068,4265869256,'Scorpio'],
  [4265869256,4266085690,'Sagittarius'],
  [4266085690,4266290520,'Capricorn'],
  [4266290520,4266480698,'Aquarius'],
  [4266480698,4266659770,'Pisces'],
  [4266659770,4266834465,'Aries'],
  [4266834465,4267011432,'Taurus'],
  [4267011432,4267195187,'Gemini'],
  [4267195187,4267387289,'Cancer'],
  [4267387289,4267587311,'Leo'],
  [4267587311,4267794600,'Virgo'],
  [4267794600,4268008766,'Libra'],
  [4268008766,4268227859,'Scorpio'],
  [4268227859,4268446124,'Sagittarius'],
  [4268446124,4268655359,'Capricorn'],
  [4268655359,4268850104,'Aquarius'],
  [4268850104,4269031100,'Pisces'],
  [4269031100,4269203909,'Aries'],
  [4269203909,4269375786,'Taurus'],
  [4269375786,4269553367,'Gemini'],
  [4269553367,4269741043,'Cancer'],
  [4269741043,4269940028,'Leo'],
  [4269940028,4270148749,'Virgo'],
  [4270148749,4270364326,'Libra'],
  [4270364326,4270583543,'Scorpio'],
  [4270583543,4270802075,'Sagittarius'],
  [4270802075,4271014082,'Capricorn'],
  [4271014082,4271214138,'Aquarius'],
  [4271214138,4271400488,'Pisces'],
  [4271400488,4271576068,'Aries'],
  [4271576068,4271746871,'Taurus'],
  [4271746871,4271919877,'Gemini'],
  [4271919877,4272101430,'Cancer'],
  [4272101430,4272295605,'Leo'],
  [4272295605,4272502630,'Virgo'],
  [4272502630,4272718698,'Libra'],
  [4272718698,4272938199,'Scorpio'],
  [4272938199,4273156008,'Sagittarius'],
  [4273156008,4273368033,'Capricorn'],
  [4273368033,4273570958,'Aquarius'],
  [4273570958,4273762769,'Pisces'],
  [4273762769,4273944031,'Aries'],
  [4273944031,4274118196,'Taurus'],
  [4274118196,4274290860,'Gemini'],
  [4274290860,4274468569,'Cancer'],
  [4274468569,4274657265,'Leo'],
  [4274657265,4274860003,'Virgo'],
  [4274860003,4275074588,'Libra'],
  [4275074588,4275294106,'Scorpio'],
  [4275294106,4275511182,'Sagittarius'],
  [4275511182,4275721457,'Capricorn'],
  [4275721457,4275923642,'Aquarius'],
  [4275923642,4276117677,'Pisces'],
  [4276117677,4276303912,'Aries'],
  [4276303912,4276483650,'Taurus'],
  [4276483650,4276659980,'Gemini'],
  [4276659980,4276837964,'Cancer'],
  [4276837964,4277023677,'Leo'],
  [4277023677,4277222066,'Virgo'],
  [4277222066,4277433685,'Libra'],
  [4277433685,4277652631,'Scorpio'],
  [4277652631,4277869663,'Sagittarius'],
  [4277869663,4278078395,'Capricorn'],
  [4278078395,4278277781,'Aquarius'],
  [4278277781,4278469935,'Pisces'],
  [4278469935,4278657175,'Aries'],
  [4278657175,4278840887,'Taurus'],
  [4278840887,4279022296,'Gemini'],
  [4279022296,4279203991,'Cancer'],
  [4279203991,4279390463,'Leo'],
  [4279390463,4279586794,'Virgo'],
  [4279586794,4279795599,'Libra'],
  [4279795599,4280013495,'Scorpio'],
  [4280013495,4280231322,'Sagittarius'],
  [4280231322,4280440299,'Capricorn'],
  [4280440299,4280637638,'Aquarius'],
  [4280637638,4280826032,'Pisces'],
  [4280826032,4281010011,'Aries'],
  [4281010011,4281193124,'Taurus'],
  [4281193124,4281377123,'Gemini'],
  [4281377123,4281563080,'Cancer'],
  [4281563080,4281753054,'Leo'],
  [4281753054,4281950422,'Virgo'],
  [4281950422,4282158078,'Libra'],
  [4282158078,4282374969,'Scorpio'],
  [4282374969,4282593978,'Sagittarius'],
  [4282593978,4282805357,'Capricorn'],
  [4282805357,4283003560,'Aquarius'],
  [4283003560,4283189787,'Pisces'],
  [4283189787,4283369237,'Aries'],
  [4283369237,4283547661,'Taurus'],
  [4283547661,4283729277,'Gemini'],
  [4283729277,4283916208,'Cancer'],
  [4283916208,4284109378,'Leo'],
  [4284109378,4284309738,'Virgo'],
  [4284309738,4284518398,'Libra'],
  [4284518398,4284734919,'Scorpio'],
  [4284734919,4284954740,'Sagittarius'],
  [4284954740,4285169490,'Capricorn'],
  [4285169490,4285371744,'Aquarius'],
  [4285371744,4285559766,'Pisces'],
  [4285559766,4285737347,'Aries'],
  [4285737347,4285910806,'Taurus'],
  [4285910806,4286086516,'Gemini'],
  [4286086516,4286269368,'Cancer'],
  [4286269368,4286461889,'Leo'],
  [4286461889,4286664256,'Virgo'],
  [4286664256,4286875074,'Libra'],
  [4286875074,4287092172,'Scorpio'],
  [4287092172,4287312059,'Sagittarius'],
  [4287312059,4287529028,'Capricorn'],
  [4287529028,4287736371,'Aquarius'],
  [4287736371,4287929914,'Pisces'],
  [4287929914,4288110421,'Aries'],
  [4288110421,4288282707,'Taurus'],
  [4288282707,4288453518,'Gemini'],
  [4288453518,4288629775,'Cancer'],
  [4288629775,4288816979,'Leo'],
  [4288816979,4289017414,'Virgo'],
  [4289017414,4289229130,'Libra'],
  [4289229130,4289447317,'Scorpio'],
  [4289447317,4289666961,'Sagittarius'],
  [4289666961,4289883853,'Capricorn'],
  [4289883853,4290093956,'Aquarius'],
  [4290093956,4290293424,'Pisces'],
  [4290293424,4290480457,'Aries'],
  [4290480457,4290656775,'Taurus'],
  [4290656775,4290827430,'Gemini'],
  [4290827430,4290999449,'Cancer'],
  [4290999449,4291180142,'Leo'],
  [4291180142,4291374872,'Virgo'],
  [4291374872,4291584121,'Libra'],
  [4291584121,4291802469,'Scorpio'],
  [4291802469,4292022146,'Sagittarius'],
  [4292022146,4292237709,'Capricorn'],
  [4292237709,4292446921,'Aquarius'],
  [4292446921,4292648563,'Pisces'],
  [4292648563,4292841232,'Aries'],
  [4292841232,4293024338,'Taurus'],
  [4293024338,4293199850,'Gemini'],
  [4293199850,4293372864,'Cancer'],
  [4293372864,4293550446,'Leo'],
  [4293550446,4293739539,'Virgo'],
  [4293739539,4293943771,'Libra'],
  [4293943771,4294160132,'Scorpio'],
  [4294160132,4294379868,'Sagittarius'],
  [4294379868,4294594716,'Capricorn'],
  [4294594716,4294801509,'Aquarius'],
  [4294801509,4295000941,'Pisces'],
  [4295000941,4295194234,'Aries'],
  [4295194234,4295381619,'Taurus'],
  [4295381619,4295563311,'Gemini'],
  [4295563311,4295741496,'Cancer'],
  [4295741496,4295921048,'Leo'],
  [4295921048,4296108292,'Virgo'],
  [4296108292,4296308344,'Libra'],
  [4296308344,4296521366,'Scorpio'],
  [4296521366,4296740538,'Sagittarius'],
  [4296740538,4296956001,'Capricorn'],
  [4296956001,4297161809,'Aquarius'],
  [4297161809,4297357995,'Pisces'],
  [4297357995,4297547637,'Aries'],
  [4297547637,4297733646,'Taurus'],
  [4297733646,4297917593,'Gemini'],
  [4297917593,4298100621,'Cancer'],
  [4298100621,4298285021,'Leo'],
  [4298285021,4298474714,'Virgo'],
  [4298474714,4298673969,'Libra'],
  [4298673969,4298884536,'Scorpio'],
  [4298884536,4299102625,'Sagittarius'],
  [4299102625,4299319453,'Capricorn'],
  [4299319453,4299526845,'Aquarius'],
  [4299526845,4299722225,'Pisces'],
  [4299722225,4299908191,'Aries'],
  [4299908191,4300089384,'Taurus'],
  [4300089384,4300270072,'Gemini'],
  [4300270072,4300453217,'Cancer'],
  [4300453217,4300640766,'Leo'],
  [4300640766,4300834428,'Virgo'],
  [4300834428,4301035987,'Libra'],
  [4301035987,4301246400,'Scorpio'],
  [4301246400,4301463693,'Sagittarius'],
  [4301463693,4301681719,'Capricorn'],
  [4301681719,4301892354,'Aquarius'],
  [4301892354,4302090369,'Pisces'],
  [4302090369,4302275988,'Aries'],
  [4302275988,4302453475,'Taurus'],
  [4302453475,4302628675,'Gemini'],
  [4302628675,4302807165,'Cancer'],
  [4302807165,4302993041,'Leo'],
  [4302993041,4303188232,'Virgo'],
  [4303188232,4303392574,'Libra'],
  [4303392574,4303604627,'Scorpio'],
  [4303604627,4303821978,'Sagittarius'],
  [4303821978,4304040520,'Capricorn'],
  [4304040520,4304254174,'Aquarius'],
  [4304254174,4304456870,'Pisces'],
  [4304456870,4304646023,'Aries'],
  [4304646023,4304823738,'Taurus'],
  [4304823738,4304995544,'Gemini'],
  [4304995544,4305168392,'Cancer'],
  [4305168392,4305348839,'Leo'],
  [4305348839,4305541187,'Virgo'],
  [4305541187,4305745813,'Libra'],
  [4305745813,4305959425,'Scorpio'],
  [4305959425,4306177475,'Sagittarius'],
  [4306177475,4306395914,'Capricorn'],
  [4306395914,4306610837,'Aquarius'],
  [4306610837,4306817618,'Pisces'],
  [4306817618,4307012310,'Aries'],
  [4307012310,4307194223,'Taurus'],
  [4307194223,4307366892,'Gemini'],
  [4307366892,4307536922,'Cancer'],
  [4307536922,4307711997,'Leo'],
  [4307711997,4307898764,'Virgo'],
  [4307898764,4308100116,'Libra'],
  [4308100116,4308313309,'Scorpio'],
  [4308313309,4308531887,'Sagittarius'],
  [4308531887,4308750000,'Capricorn'],
  [4308750000,4308964297,'Aquarius'],
  [4308964297,4309172387,'Pisces'],
  [4309172387,4309371396,'Aries'],
  [4309371396,4309559146,'Taurus'],
  [4309559146,4309736471,'Gemini'],
  [4309736471,4309908039,'Cancer'],
  [4309908039,4310081021,'Leo'],
  [4310081021,4310262992,'Virgo'],
  [4310262992,4310459227,'Libra'],
  [4310459227,4310669509,'Scorpio'],
  [4310669509,4310887593,'Sagittarius'],
  [4310887593,4311105516,'Capricorn'],
  [4311105516,4311318455,'Aquarius'],
  [4311318455,4311525012,'Pisces'],
  [4311525012,4311724621,'Aries'],
  [4311724621,4311916156,'Taurus'],
  [4311916156,4312099115,'Gemini'],
  [4312099115,4312275608,'Cancer'],
  [4312275608,4312450764,'Leo'],
  [4312450764,4312631389,'Virgo'],
  [4312631389,4312823656,'Libra'],
  [4312823656,4313029921,'Scorpio'],
  [4313029921,4313246256,'Sagittarius'],
  [4313246256,4313464219,'Capricorn'],
  [4313464219,4313676574,'Aquarius'],
  [4313676574,4313880785,'Pisces'],
  [4313880785,4314077624,'Aries'],
  [4314077624,4314268425,'Taurus'],
  [4314268425,4314453982,'Gemini'],
  [4314453982,4314635428,'Cancer'],
  [4314635428,4314815505,'Leo'],
  [4314815505,4314998750,'Virgo'],
  [4314998750,4315190335,'Libra'],
  [4315190335,4315393719,'Scorpio'],
  [4315393719,4315607764,'Sagittarius'],
  [4315607764,4315825817,'Capricorn'],
  [4315825817,4316039229,'Aquarius'],
  [4316039229,4316242808,'Pisces'],
  [4316242808,4316436479,'Aries'],
  [4316436479,4316623134,'Taurus'],
  [4316623134,4316806208,'Gemini'],
  [4316806208,4316988534,'Cancer'],
  [4316988534,4317172411,'Leo'],
  [4317172411,4317360171,'Virgo'],
  [4317360171,4317554465,'Libra'],
  [4317554465,4317757675,'Scorpio'],
  [4317757675,4317970140,'Sagittarius'],
  [4317970140,4318188076,'Capricorn'],
  [4318188076,4318403787,'Aquarius'],
  [4318403787,4318609754,'Pisces'],
  [4318609754,4318803139,'Aries'],
  [4318803139,4318986176,'Taurus'],
  [4318986176,4319163907,'Gemini'],
  [4319163907,4319341892,'Cancer'],
  [4319341892,4319524617,'Leo'],
  [4319524617,4319714621,'Virgo'],
  [4319714621,4319912551,'Libra'],
  [4319912551,4320118107,'Scorpio'],
  [4320118107,4320330670,'Sagittarius'],
  [4320330670,4320548316,'Capricorn'],
  [4320548316,4320766078,'Aquarius'],
  [4320766078,4320976462,'Pisces'],
  [4320976462,4321173667,'Aries'],
  [4321173667,4321357168,'Taurus'],
  [4321357168,4321531420,'Gemini'],
  [4321531420,4321703410,'Cancer'],
  [4321703410,4321880252,'Leo'],
  [4321880252,4322067144,'Virgo'],
  [4322067144,4322265610,'Libra'],
  [4322265610,4322473572,'Scorpio'],
  [4322473572,4322687709,'Sagittarius'],
  [4322687709,4322905363,'Capricorn'],
  [4322905363,4323123709,'Aquarius'],
  [4323123709,4323337685,'Pisces'],
  [4323337685,4323540837,'Aries'],
  [4323540837,4323729431,'Taurus'],
  [4323729431,4323905232,'Gemini'],
  [4323905232,4324074540,'Cancer'],
  [4324074540,4324245485,'Leo'],
  [4324245485,4324425672,'Virgo'],
  [4324425672,4324619655,'Libra'],
  [4324619655,4324826761,'Scorpio'],
  [4324826761,4325042075,'Sagittarius'],
  [4325042075,4325260288,'Capricorn'],
  [4325260288,4325478093,'Aquarius'],
  [4325478093,4325692724,'Pisces'],
  [4325692724,4325899890,'Aries'],
  [4325899890,4326095027,'Taurus'],
  [4326095027,4326276799,'Gemini'],
  [4326276799,4326448864,'Cancer'],
  [4326448864,4326618355,'Leo'],
  [4326618355,4326793400,'Virgo'],
  [4326793400,4326980778,'Libra'],
  [4326980778,4327183067,'Scorpio'],
  [4327183067,4327396957,'Sagittarius'],
  [4327396957,4327615506,'Capricorn'],
  [4327615506,4327832834,'Aquarius'],
  [4327832834,4328045969,'Pisces'],
  [4328045969,4328252977,'Aries'],
  [4328252977,4328451392,'Taurus'],
  [4328451392,4328639296,'Gemini'],
  [4328639296,4328817619,'Cancer'],
  [4328817619,4328990838,'Leo'],
  [4328990838,4329165655,'Virgo'],
  [4329165655,4329349012,'Libra'],
  [4329349012,4329545681,'Scorpio'],
  [4329545681,4329755621,'Sagittarius'],
  [4329755621,4329973210,'Capricorn'],
  [4329973210,4330190592,'Aquarius'],
  [4330190592,4330402389,'Pisces'],
  [4330402389,4330606764,'Aries'],
  [4330606764,4330803647,'Taurus'],
  [4330803647,4330993299,'Gemini'],
  [4330993299,4331176529,'Cancer'],
  [4331176529,4331355607,'Leo'],
  [4331355607,4331534565,'Virgo'],
  [4331534565,4331718569,'Libra'],
  [4331718569,4331912441,'Scorpio'],
  [4331912441,4332118423,'Sagittarius'],
  [4332118423,4332333904,'Capricorn'],
  [4332333904,4332551556,'Aquarius'],
  [4332551556,4332763594,'Pisces'],
  [4332763594,4332966057,'Aries'],
  [4332966057,4333159286,'Taurus'],
  [4333159286,4333345938,'Gemini'],
  [4333345938,4333529079,'Cancer'],
  [4333529079,4333711383,'Leo'],
  [4333711383,4333895220,'Virgo'],
  [4333895220,4334083144,'Libra'],
  [4334083144,4334278073,'Scorpio'],
  [4334278073,4334482421,'Sagittarius'],
  [4334482421,4334695959,'Capricorn'],
  [4334695959,4334913792,'Aquarius'],
  [4334913792,4335127618,'Pisces'],
  [4335127618,4335330776,'Aries'],
  [4335330776,4335521869,'Taurus'],
  [4335521869,4335704191,'Gemini'],
  [4335704191,4335883078,'Cancer'],
  [4335883078,4336063529,'Leo'],
  [4336063529,4336248829,'Virgo'],
  [4336248829,4336440338,'Libra'],
  [4336440338,4336638489,'Scorpio'],
  [4336638489,4336843896,'Sagittarius'],
  [4336843896,4337056784,'Capricorn'],
  [4337056784,4337274674,'Aquarius'],
  [4337274674,4337490867,'Pisces'],
  [4337490867,4337697232,'Aries'],
  [4337697232,4337889608,'Taurus'],
  [4337889608,4338069932,'Gemini'],
  [4338069932,4338244220,'Cancer'],
  [4338244220,4338419509,'Leo'],
  [4338419509,4338601501,'Virgo'],
  [4338601501,4338792907,'Libra'],
  [4338792907,4338993310,'Scorpio'],
  [4338993310,4339200990,'Sagittarius'],
  [4339200990,4339414621,'Capricorn'],
  [4339414621,4339632561,'Aquarius'],
  [4339632561,4339850446,'Pisces'],
  [4339850446,4340060886,'Aries'],
  [4340060886,4340257617,'Taurus'],
  [4340257617,4340439918,'Gemini'],
  [4340439918,4340612667,'Cancer'],
  [4340612667,4340783430,'Leo'],
  [4340783430,4340959728,'Virgo'],
  [4340959728,4341146825,'Libra'],
  [4341146825,4341345970,'Scorpio'],
  [4341345970,4341554764,'Sagittarius'],
  [4341554764,4341769643,'Capricorn'],
  [4341769643,4341987743,'Aquarius'],
  [4341987743,4342205944,'Pisces'],
  [4342205944,4342419048,'Aries'],
  [4342419048,4342620914,'Taurus'],
  [4342620914,4342808433,'Gemini'],
  [4342808433,4342983942,'Cancer'],
  [4342983942,4343153844,'Leo'],
  [4343153844,4343325935,'Virgo'],
  [4343325935,4343507205,'Libra'],
  [4343507205,4343701627,'Scorpio'],
  [4343701627,4343908614,'Sagittarius'],
  [4343908614,4344123849,'Capricorn'],
  [4344123849,4344342189,'Aquarius'],
  [4344342189,4344559679,'Pisces'],
  [4344559679,4344772769,'Aries'],
  [4344772769,4344977444,'Taurus'],
  [4344977444,4345170462,'Gemini'],
  [4345170462,4345351764,'Cancer'],
  [4345351764,4345525215,'Leo'],
  [4345525215,4345697206,'Virgo'],
  [4345697206,4345874778,'Libra'],
  [4345874778,4346063704,'Scorpio'],
  [4346063704,4346266295,'Sagittarius'],
  [4346266295,4346479955,'Capricorn'],
  [4346479955,4346698345,'Aquarius'],
  [4346698345,4346915133,'Pisces'],
  [4346915133,4347126360,'Aries'],
  [4347126360,4347330051,'Taurus'],
  [4347330051,4347525163,'Gemini'],
  [4347525163,4347711599,'Cancer'],
  [4347711599,4347891027,'Leo'],
  [4347891027,4348067190,'Virgo'],
  [4348067190,4348245385,'Libra'],
  [4348245385,4348431329,'Scorpio'],
  [4348431329,4348629322,'Sagittarius'],
  [4348629322,4348839771,'Capricorn'],
  [4348839771,4349057610,'Aquarius'],
  [4349057610,4349274594,'Pisces'],
  [4349274594,4349484352,'Aries'],
  [4349484352,4349684918,'Taurus'],
  [4349684918,4349877576,'Gemini'],
  [4349877576,4350064597,'Cancer'],
  [4350064597,4350248030,'Leo'],
  [4350248030,4350429788,'Virgo'],
  [4350429788,4350612403,'Libra'],
  [4350612403,4350799563,'Scorpio'],
  [4350799563,4350995498,'Sagittarius'],
  [4350995498,4351202823,'Capricorn'],
  [4351202823,4351419420,'Aquarius'],
  [4351419420,4351637493,'Pisces'],
  [4351637493,4351848035,'Aries'],
  [4351848035,4352046761,'Taurus'],
  [4352046761,4352235252,'Gemini'],
  [4352235252,4352418146,'Cancer'],
  [4352418146,4352600085,'Leo'],
  [4352600085,4352784021,'Virgo'],
  [4352784021,4352971182,'Libra'],
  [4352971182,4353162505,'Scorpio'],
  [4353162505,4353360007,'Sagittarius'],
  [4353360007,4353566256,'Capricorn'],
  [4353566256,4353781554,'Aquarius'],
  [4353781554,4354000747,'Pisces'],
  [4354000747,4354214297,'Aries'],
  [4354214297,4354414791,'Taurus'],
  [4354414791,4354601667,'Gemini'],
  [4354601667,4354779895,'Cancer'],
  [4354779895,4354956262,'Leo'],
  [4354956262,4355136509,'Virgo'],
  [4355136509,4355323637,'Libra'],
  [4355323637,4355517929,'Scorpio'],
  [4355517929,4355718833,'Sagittarius'],
  [4355718833,4355926598,'Capricorn'],
  [4355926598,4356141567,'Aquarius'],
  [4356141567,4356361166,'Pisces'],
  [4356361166,4356577984,'Aries'],
  [4356577984,4356783253,'Taurus'],
  [4356783253,4356973117,'Gemini'],
  [4356973117,4357150543,'Cancer'],
  [4357150543,4357322425,'Leo'],
  [4357322425,4357496276,'Virgo'],
  [4357496276,4357677976,'Libra'],
  [4357677976,4357870204,'Scorpio'],
  [4357870204,4358072398,'Sagittarius'],
  [4358072398,4358282460,'Capricorn'],
  [4358282460,4358498404,'Aquarius'],
  [4358498404,4358717903,'Pisces'],
  [4358717903,4358936186,'Aries'],
  [4358936186,4359146084,'Taurus'],
  [4359146084,4359341955,'Gemini'],
  [4359341955,4359523555,'Cancer'],
  [4359523555,4359695770,'Leo'],
  [4359695770,4359865860,'Virgo'],
  [4359865860,4360041113,'Libra'],
  [4360041113,4360227076,'Scorpio'],
  [4360227076,4360425953,'Sagittarius'],
  [4360425953,4360636052,'Capricorn'],
  [4360636052,4360853126,'Aquarius'],
  [4360853126,4361072664,'Pisces'],
  [4361072664,4361290458,'Aries'],
  [4361290458,4361501961,'Taurus'],
  [4361501961,4361702774,'Gemini'],
  [4361702774,4361890860,'Cancer'],
  [4361890860,4362068093,'Leo'],
  [4362068093,4362239594,'Virgo'],
  [4362239594,4362412066,'Libra'],
  [4362412066,4362592216,'Scorpio'],
  [4362592216,4362785043,'Sagittarius'],
  [4362785043,4362991705,'Capricorn'],
  [4362991705,4363208318,'Aquarius'],
  [4363208318,4363428024,'Pisces'],
  [4363428024,4363644757,'Aries'],
  [4363644757,4363854907,'Taurus'],
  [4363854907,4364056642,'Gemini'],
  [4364056642,4364249034,'Cancer'],
  [4364249034,4364432466,'Leo'],
  [4364432466,4364609284,'Virgo'],
  [4364609284,4364783922,'Libra'],
  [4364783922,4364962288,'Scorpio'],
  [4364962288,4365150412,'Sagittarius'],
  [4365150412,4365352169,'Capricorn'],
  [4365352169,4365566309,'Aquarius'],
  [4365566309,4365785794,'Pisces'],
  [4365785794,4366002082,'Aries'],
  [4366002082,4366210158,'Taurus'],
  [4366210158,4366409471,'Gemini'],
  [4366409471,4366601565,'Cancer'],
  [4366601565,4366788021,'Leo'],
  [4366788021,4366970139,'Virgo'],
  [4366970139,4367149850,'Libra'],
  [4367149850,4367330754,'Scorpio'],
  [4367330754,4367517967,'Sagittarius'],
  [4367517967,4367716379,'Capricorn'],
  [4367716379,4367927421,'Aquarius'],
  [4367927421,4368146120,'Pisces'],
  [4368146120,4368362928,'Aries'],
  [4368362928,4368570314,'Taurus'],
  [4368570314,4368766811,'Gemini'],
  [4368766811,4368955421,'Cancer'],
  [4368955421,4369140115,'Leo'],
  [4369140115,4369323649,'Virgo'],
  [4369323649,4369507390,'Libra'],
  [4369507390,4369692734,'Scorpio'],
  [4369692734,4369882510,'Sagittarius'],
  [4369882510,4370080660,'Capricorn'],
  [4370080660,4370289786,'Aquarius'],
  [4370289786,4370507529,'Pisces'],
  [4370507529,4370725526,'Aries'],
  [4370725526,4370934417,'Taurus'],
  [4370934417,4371130322,'Gemini'],
  [4371130322,4371315703,'Cancer'],
  [4371315703,4371495980,'Leo'],
  [4371495980,4371676281,'Virgo'],
  [4371676281,4371859762,'Libra'],
  [4371859762,4372047723,'Scorpio'],
  [4372047723,4372241074,'Sagittarius'],
  [4372241074,4372441486,'Capricorn'],
  [4372441486,4372650718,'Aquarius'],
  [4372650718,4372867908,'Pisces'],
  [4372867908,4373087090,'Aries'],
  [4373087090,4373299081,'Taurus'],
  [4373299081,4373497557,'Gemini'],
  [4373497557,4373682747,'Cancer'],
  [4373682747,4373859687,'Leo'],
  [4373859687,4374034850,'Virgo'],
  [4374034850,4374213805,'Libra'],
  [4374213805,4374399975,'Scorpio'],
  [4374399975,4374594588,'Sagittarius'],
  [4374594588,4374797587,'Capricorn'],
  [4374797587,4375008459,'Aquarius'],
  [4375008459,4375225812,'Pisces'],
  [4375225812,4375445555,'Aries'],
  [4375445555,4375660540,'Taurus'],
  [4375660540,4375863726,'Gemini'],
  [4375863726,4376052561,'Cancer'],
  [4376052561,4376229946,'Leo'],
  [4376229946,4376401936,'Virgo'],
  [4376401936,4376575331,'Libra'],
  [4376575331,4376756024,'Scorpio'],
  [4376756024,4376947669,'Sagittarius'],
  [4376947669,4377150836,'Capricorn'],
  [4377150836,4377363275,'Aquarius'],
  [4377363275,4377581362,'Pisces'],
  [4377581362,4377800952,'Aries'],
  [4377800952,4378017110,'Taurus'],
  [4378017110,4378224451,'Gemini'],
  [4378224451,4378419142,'Cancer'],
  [4378419142,4378601172,'Leo'],
  [4378601172,4378774401,'Virgo'],
  [4378774401,4378945073,'Libra'],
  [4378945073,4379120194,'Scorpio'],
  [4379120194,4379305936,'Sagittarius'],
  [4379305936,4379505550,'Capricorn'],
  [4379505550,4379717514,'Aquarius'],
  [4379717514,4379936234,'Pisces'],
  [4379936234,4380155460,'Aries'],
  [4380155460,4380370713,'Taurus'],
  [4380370713,4380579080,'Gemini'],
  [4380579080,4380778168,'Cancer'],
  [4380778168,4380966574,'Leo'],
  [4380966574,4381145228,'Virgo'],
  [4381145228,4381318019,'Libra'],
  [4381318019,4381491184,'Scorpio'],
  [4381491184,4381671849,'Sagittarius'],
  [4381671849,4381865838,'Capricorn'],
  [4381865838,4382074494,'Aquarius'],
  [4382074494,4382292715,'Pisces'],
  [4382292715,4382511908,'Aries'],
  [4382511908,4382725674,'Taurus'],
  [4382725674,4382931981,'Gemini'],
  [4382931981,4383131065,'Cancer'],
  [4383131065,4383323058,'Leo'],
  [4383323058,4383507808,'Virgo'],
  [4383507808,4383686393,'Libra'],
  [4383686393,4383862515,'Scorpio'],
  [4383862515,4384042225,'Sagittarius'],
  [4384042225,4384232125,'Capricorn'],
  [4384232125,4384436251,'Aquarius'],
  [4384436251,4384652354,'Pisces'],
  [4384652354,4384871739,'Aries'],
  [4384871739,4385085269,'Taurus'],
  [4385085269,4385289197,'Gemini'],
  [4385289197,4385484868,'Cancer'],
  [4385484868,4385675106,'Leo'],
  [4385675106,4385861679,'Virgo'],
  [4385861679,4386045200,'Libra'],
  [4386045200,4386226893,'Scorpio'],
  [4386226893,4386410119,'Sagittarius'],
  [4386410119,4386600042,'Capricorn'],
  [4386600042,4386801390,'Aquarius'],
  [4386801390,4387014779,'Pisces'],
  [4387014779,4387234024,'Aries'],
  [4387234024,4387449052,'Taurus'],
  [4387449052,4387653094,'Gemini'],
  [4387653094,4387845967,'Cancer'],
  [4387845967,4388031590,'Leo'],
  [4388031590,4388214414,'Virgo'],
  [4388214414,4388397439,'Libra'],
  [4388397439,4388582201,'Scorpio'],
  [4388582201,4388770111,'Sagittarius'],
  [4388770111,4388963567,'Capricorn'],
  [4388963567,4389165572,'Aquarius'],
  [4389165572,4389377530,'Pisces'],
  [4389377530,4389596212,'Aries'],
  [4389596212,4389813385,'Taurus'],
  [4389813385,4390020508,'Gemini'],
  [4390020508,4390214289,'Cancer'],
  [4390214289,4390397240,'Leo'],
  [4390397240,4390574744,'Virgo'],
  [4390574744,4390752366,'Libra'],
  [4390752366,4390934368,'Scorpio'],
  [4390934368,4391123231,'Sagittarius'],
  [4391123231,4391319993,'Capricorn'],
  [4391319993,4391524913,'Aquarius'],
  [4391524913,4391737624,'Pisces'],
  [4391737624,4391955936,'Aries'],
  [4391955936,4392174480,'Taurus'],
  [4392174480,4392385720,'Gemini'],
  [4392385720,4392584015,'Cancer'],
  [4392584015,4392768842,'Leo'],
  [4392768842,4392944231,'Virgo'],
  [4392944231,4393116480,'Libra'],
  [4393116480,4393292168,'Scorpio'],
  [4393292168,4393476629,'Sagittarius'],
  [4393476629,4393672557,'Capricorn'],
  [4393672557,4393879303,'Aquarius'],
  [4393879303,4394093852,'Pisces'],
  [4394093852,4394312496,'Aries'],
  [4394312496,4394531212,'Taurus'],
  [4394531212,4394745058,'Gemini'],
  [4394745058,4394948671,'Cancer'],
  [4394948671,4395138978,'Leo'],
  [4395138978,4395317118,'Virgo'],
  [4395317118,4395488067,'Libra'],
  [4395488067,4395658904,'Scorpio'],
  [4395658904,4395836953,'Sagittarius'],
  [4395836953,4396027760,'Capricorn'],
  [4396027760,4396232645,'Aquarius'],
  [4396232645,4396447833,'Pisces'],
  [4396447833,4396667122,'Aries'],
  [4396667122,4396885404,'Taurus'],
  [4396885404,4397099366,'Gemini'],
  [4397099366,4397305897,'Cancer'],
  [4397305897,4397501830,'Leo'],
  [4397501830,4397685842,'Virgo'],
  [4397685842,4397860199,'Libra'],
  [4397860199,4398030639,'Scorpio'],
  [4398030639,4398204700,'Sagittarius'],
  [4398204700,4398389648,'Capricorn'],
  [4398389648,4398589648,'Aquarius'],
  [4398589648,4398802870,'Pisces'],
  [4398802870,4399022151,'Aries'],
  [4399022151,4399240044,'Taurus'],
  [4399240044,4399452631,'Gemini'],
  [4399452631,4399658645,'Cancer'],
  [4399658645,4399856956,'Leo'],
  [4399856956,4400046150,'Virgo'],
  [4400046150,4400226280,'Libra'],
  [4400226280,4400400546,'Scorpio'],
  [4400400546,4400575025,'Sagittarius'],
  [4400575025,4400756937,'Capricorn'],
  [4400756937,4400952100,'Aquarius'],
  [4400952100,4401161527,'Pisces'],
  [4401161527,4401379587,'Aries'],
  [4401379587,4401597381,'Taurus'],
  [4401597381,4401808797,'Gemini'],
  [4401808797,4402012429,'Cancer'],
  [4402012429,4402209141,'Leo'],
  [4402209141,4402399561,'Virgo'],
  [4402399561,4402583889,'Libra'],
  [4402583889,4402763456,'Scorpio'],
  [4402763456,4402941915,'Sagittarius'],
  [4402941915,4403124826,'Capricorn'],
  [4403124826,4403317853,'Aquarius'],
  [4403317853,4403523835,'Pisces'],
  [4403523835,4403739874,'Aries'],
  [4403739874,4403957801,'Taurus'],
  [4403957801,4404169433,'Gemini'],
  [4404169433,4404371373,'Cancer'],
  [4404371373,4404564722,'Leo'],
  [4404564722,4404752222,'Virgo'],
  [4404752222,4404936263,'Libra'],
  [4404936263,4405118688,'Scorpio'],
  [4405118688,4405301676,'Sagittarius'],
  [4405301676,4405488406,'Capricorn'],
  [4405488406,4405682695,'Aquarius'],
  [4405682695,4405887359,'Pisces'],
  [4405887359,4406101642,'Aries'],
  [4406101642,4406319749,'Taurus'],
  [4406319749,4406533164,'Gemini'],
  [4406533164,4406735901,'Cancer'],
  [4406735901,4406927310,'Leo'],
  [4406927310,4407110617,'Virgo'],
  [4407110617,4407290398,'Libra'],
  [4407290398,4407470870,'Scorpio'],
  [4407470870,4407655178,'Sagittarius'],
  [4407655178,4407845417,'Capricorn'],
  [4407845417,4408043001,'Aquarius'],
  [4408043001,4408248843,'Pisces'],
  [4408248843,4408462535,'Aries'],
  [4408462535,4408680700,'Taurus'],
  [4408680700,4408896569,'Gemini'],
  [4408896569,4409102768,'Cancer'],
  [4409102768,4409295756,'Leo'],
  [4409295756,4409477200,'Virgo'],
  [4409477200,4409652266,'Libra'],
  [4409652266,4409827318,'Scorpio'],
  [4409827318,4410008064,'Sagittarius'],
  [4410008064,4410198063,'Capricorn'],
  [4410198063,4410397968,'Aquarius'],
  [4410397968,4410606243,'Pisces'],
  [4410606243,4410820709,'Aries'],
  [4410820709,4411038809,'Taurus'],
  [4411038809,4411256325,'Gemini'],
  [4411256325,4411466900,'Cancer'],
  [4411466900,4411664844,'Leo'],
  [4411664844,4411848810,'Virgo'],
  [4411848810,4412022508,'Libra'],
  [4412022508,4412192805,'Scorpio'],
  [4412192805,4412367367,'Sagittarius'],
  [4412367367,4412552502,'Capricorn'],
  [4412552502,4412750823,'Aquarius'],
  [4412750823,4412960239,'Pisces'],
  [4412960239,4413176081,'Aries'],
  [4413176081,4413394254,'Taurus'],
  [4413394254,4413611788,'Gemini'],
  [4413611788,4413824891,'Cancer'],
  [4413824891,4414028368,'Leo'],
  [4414028368,4414218409,'Virgo'],
  [4414218409,4414395685,'Libra'],
  [4414395685,4414565559,'Scorpio'],
  [4414565559,4414735886,'Sagittarius'],
  [4414735886,4414914664,'Capricorn'],
  [4414914664,4415107451,'Aquarius'],
  [4415107451,4415314496,'Pisces'],
  [4415314496,4415530617,'Aries'],
  [4415530617,4415749137,'Taurus'],
  [4415749137,4415965766,'Gemini'],
  [4415965766,4416178294,'Cancer'],
  [4416178294,4416384093,'Leo'],
  [4416384093,4416579782,'Virgo'],
  [4416579782,4416763676,'Libra'],
  [4416763676,4416938142,'Scorpio'],
  [4416938142,4417109261,'Sagittarius'],
  [4417109261,4417284767,'Capricorn'],
  [4417284767,4417471716,'Aquarius'],
  [4417471716,4417673497,'Pisces'],
  [4417673497,4417887393,'Aries'],
  [4417887393,4418105953,'Taurus'],
  [4418105953,4418322135,'Gemini'],
  [4418322135,4418532626,'Cancer'],
  [4418532626,4418736591,'Leo'],
  [4418736591,4418933317,'Virgo'],
  [4418933317,4419121879,'Libra'],
  [4419121879,4419302741,'Scorpio'],
  [4419302741,4419479093,'Sagittarius'],
  [4419479093,4419656492,'Capricorn'],
  [4419656492,4419841311,'Aquarius'],
  [4419841311,4420038428,'Pisces'],
  [4420038428,4420248390,'Aries'],
  [4420248390,4420465920,'Taurus'],
  [4420465920,4420682599,'Gemini'],
  [4420682599,4420892237,'Cancer'],
  [4420892237,4421093133,'Leo'],
  [4421093133,4421286470,'Virgo'],
  [4421286470,4421474118,'Libra'],
  [4421474118,4421657800,'Scorpio'],
  [4421657800,4421839499,'Sagittarius'],
  [4421839499,4422022084,'Capricorn'],
  [4422022084,4422209410,'Aquarius'],
  [4422209410,4422405455,'Pisces'],
  [4422405455,4422612388,'Aries'],
  [4422612388,4422828127,'Taurus'],
  [4422828127,4423045679,'Gemini'],
  [4423045679,4423256758,'Cancer'],
  [4423256758,4423456825,'Leo'],
  [4423456825,4423646445,'Virgo'],
  [4423646445,4423829368,'Libra'],
  [4423829368,4424010107,'Scorpio'],
  [4424010107,4424192397,'Sagittarius'],
  [4424192397,4424378664,'Capricorn'],
  [4424378664,4424570396,'Aquarius'],
  [4424570396,4424768937,'Pisces'],
  [4424768937,4424975580,'Aries'],
  [4424975580,4425190038,'Taurus'],
  [4425190038,4425408183,'Gemini'],
  [4425408183,4425622148,'Cancer'],
  [4425622148,4425824745,'Leo'],
  [4425824745,4426013920,'Virgo'],
  [4426013920,4426193026,'Libra'],
  [4426193026,4426368260,'Scorpio'],
  [4426368260,4426545982,'Sagittarius'],
  [4426545982,4426730782,'Capricorn'],
  [4426730782,4426924371,'Aquarius'],
  [4426924371,4427126077,'Pisces'],
  [4427126077,4427334676,'Aries'],
  [4427334676,4427549233,'Taurus'],
  [4427549233,4427767571,'Gemini'],
  [4427767571,4427984139,'Cancer'],
  [4427984139,4428191228,'Leo'],
  [4428191228,4428383904,'Virgo'],
  [4428383904,4428563209,'Libra'],
  [4428563209,4428735027,'Scorpio'],
  [4428735027,4428907054,'Sagittarius'],
  [4428907054,4429086299,'Capricorn'],
  [4429086299,4429276935,'Aquarius'],
  [4429276935,4429478971,'Pisces'],
  [4429478971,4429689428,'Aries'],
  [4429689428,4429905086,'Taurus'],
  [4429905086,4430123484,'Gemini'],
  [4430123484,4430341139,'Cancer'],
  [4430341139,4430552072,'Leo'],
  [4430552072,4430750224,'Virgo'],
  [4430750224,4430933788,'Libra'],
  [4430933788,4431106590,'Scorpio'],
  [4431106590,4431275897,'Sagittarius'],
  [4431275897,4431449691,'Capricorn'],
  [4431449691,4431634446,'Aquarius'],
  [4431634446,4431832822,'Pisces'],
  [4431832822,4432042693,'Aries'],
  [4432042693,4432259134,'Taurus'],
  [4432259134,4432477641,'Gemini'],
  [4432477641,4432694894,'Cancer'],
  [4432694894,4432907072,'Leo'],
  [4432907072,4433109448,'Virgo'],
  [4433109448,4433298872,'Libra'],
  [4433298872,4433476479,'Scorpio'],
  [4433476479,4433647542,'Sagittarius'],
  [4433647542,4433819372,'Capricorn'],
  [4433819372,4433999199,'Aquarius'],
  [4433999199,4434192010,'Pisces'],
  [4434192010,4434398381,'Aries'],
  [4434398381,4434614054,'Taurus'],
  [4434614054,4434832599,'Gemini'],
  [4434832599,4435048922,'Cancer'],
  [4435048922,4435259834,'Leo'],
  [4435259834,4435462897,'Virgo'],
  [4435462897,4435656166,'Libra'],
  [4435656166,4435839507,'Scorpio'],
  [4435839507,4436015676,'Sagittarius'],
  [4436015676,4436189873,'Capricorn'],
  [4436189873,4436368414,'Aquarius'],
  [4436368414,4436557046,'Pisces'],
  [4436557046,4436758813,'Aries'],
  [4436758813,4436972012,'Taurus'],
  [4436972012,4437190261,'Gemini'],
  [4437190261,4437406172,'Cancer'],
  [4437406172,4437615122,'Leo'],
  [4437615122,4437815769,'Virgo'],
  [4437815769,4438008603,'Libra'],
  [4438008603,4438194779,'Scorpio'],
  [4438194779,4438376089,'Sagittarius'],
  [4438376089,4438555367,'Capricorn'],
  [4438555367,4438736622,'Aquarius'],
  [4438736622,4438924549,'Pisces'],
  [4438924549,4439123137,'Aries'],
  [4439123137,4439333320,'Taurus'],
  [4439333320,4439550828,'Gemini'],
  [4439550828,4439767371,'Cancer'],
  [4439767371,4439975735,'Leo'],
  [4439975735,4440173535,'Virgo'],
  [4440173535,4440362708,'Libra'],
  [4440362708,4440546927,'Scorpio'],
  [4440546927,4440729555,'Sagittarius'],
  [4440729555,4440912929,'Capricorn'],
  [4440912929,4441098841,'Aquarius'],
  [4441098841,4441289524,'Pisces'],
  [4441289524,4441487904,'Aries'],
  [4441487904,4441696139,'Taurus'],
  [4441696139,4441912697,'Gemini'],
  [4441912697,4442130633,'Cancer'],
  [4442130633,4442340842,'Leo'],
  [4442340842,4442538234,'Virgo'],
  [4442538234,4442724038,'Libra'],
  [4442724038,4442903459,'Scorpio'],
  [4442903459,4443082411,'Sagittarius'],
  [4443082411,4443265241,'Capricorn'],
  [4443265241,4443453806,'Aquarius'],
  [4443453806,4443648323,'Pisces'],
  [4443648323,4443849187,'Aries'],
  [4443849187,4444057555,'Taurus'],
  [4444057555,4444273450,'Gemini'],
  [4444273450,4444492614,'Cancer'],
  [4444492614,4444706371,'Leo'],
  [4444706371,4444906985,'Virgo'],
  [4444906985,4445093015,'Libra'],
  [4445093015,4445269086,'Scorpio'],
  [4445269086,4445442452,'Sagittarius'],
  [4445442452,4445619991,'Capricorn'],
  [4445619991,4445806077,'Aquarius'],
  [4445806077,4446001597,'Pisces'],
  [4446001597,4446205187,'Aries'],
  [4446205187,4446415435,'Taurus'],
  [4446415435,4446631483,'Gemini'],
  [4446631483,4446850967,'Cancer'],
  [4446850967,4447067708,'Leo'],
  [4447067708,4447273631,'Virgo'],
  [4447273631,4447464269,'Libra'],
  [4447464269,4447641633,'Scorpio'],
  [4447641633,4447812256,'Sagittarius'],
  [4447812256,4447983987,'Capricorn'],
  [4447983987,4448163660,'Aquarius'],
  [4448163660,4448355125,'Pisces'],
  [4448355125,4448558247,'Aries'],
  [4448558247,4448770063,'Taurus'],
  [4448770063,4448987078,'Gemini'],
  [4448987078,4449206258,'Cancer'],
  [4449206258,4449423594,'Leo'],
  [4449423594,4449633321,'Virgo'],
  [4449633321,4449830267,'Libra'],
  [4449830267,4450013393,'Scorpio'],
  [4450013393,4450186575,'Sagittarius'],
  [4450186575,4450356592,'Capricorn'],
  [4450356592,4450530868,'Aquarius'],
  [4450530868,4450715637,'Pisces'],
  [4450715637,4450913992,'Aries'],
  [4450913992,4451124538,'Taurus'],
  [4451124538,4451342202,'Gemini'],
  [4451342202,4451561268,'Cancer'],
  [4451561268,4451777357,'Leo'],
  [4451777357,4451987080,'Virgo'],
  [4451987080,4452187489,'Libra'],
  [4452187489,4452376934,'Scorpio'],
  [4452376934,4452556484,'Sagittarius'],
  [4452556484,4452730133,'Capricorn'],
  [4452730133,4452903841,'Aquarius'],
  [4452903841,4453084160,'Pisces'],
  [4453084160,4453276503,'Aries'],
  [4453276503,4453482758,'Taurus'],
  [4453482758,4453699319,'Gemini'],
  [4453699319,4453918568,'Cancer'],
  [4453918568,4454133545,'Leo'],
  [4454133545,4454340839,'Virgo'],
  [4454340839,4454539986,'Libra'],
  [4454539986,4454731562,'Scorpio'],
  [4454731562,4454916456,'Sagittarius'],
  [4454916456,4455096293,'Capricorn'],
  [4455096293,4455274185,'Aquarius'],
  [4455274185,4455454929,'Pisces'],
  [4455454929,4455644092,'Aries'],
  [4455644092,4455845834,'Taurus'],
  [4455845834,4456059673,'Gemini'],
  [4456059673,4456278847,'Cancer'],
  [4456278847,4456494052,'Leo'],
  [4456494052,4456699561,'Virgo'],
  [4456699561,4456895226,'Libra'],
  [4456895226,4457084042,'Scorpio'],
  [4457084042,4457269188,'Sagittarius'],
  [4457269188,4457452689,'Capricorn'],
  [4457452689,4457635848,'Aquarius'],
  [4457635848,4457820716,'Pisces'],
  [4457820716,4458010963,'Aries'],
  [4458010963,4458210828,'Taurus'],
  [4458210828,4458422116,'Gemini'],
  [4458422116,4458640766,'Cancer'],
  [4458640766,4458857382,'Leo'],
  [4458857382,4459063565,'Virgo'],
  [4459063565,4459257229,'Libra'],
  [4459257229,4459441873,'Scorpio'],
  [4459441873,4459622895,'Sagittarius'],
  [4459622895,4459804718,'Capricorn'],
  [4459804718,4459989611,'Aquarius'],
  [4459989611,4460178390,'Pisces'],
  [4460178390,4460372205,'Aries'],
  [4460372205,4460573370,'Taurus'],
  [4460573370,4460783865,'Gemini'],
  [4460783865,4461001975,'Cancer'],
  [4461001975,4461220319,'Leo'],
  [4461220319,4461429436,'Virgo'],
  [4461429436,4461624454,'Libra'],
  [4461624454,4461807296,'Scorpio'],
  [4461807296,4461983846,'Sagittarius'],
  [4461983846,4462160524,'Capricorn'],
  [4462160524,4462342109,'Aquarius'],
  [4462342109,4462530857,'Pisces'],
  [4462530857,4462727164,'Aries'],
  [4462727164,4462931024,'Taurus'],
  [4462931024,4463142589,'Gemini'],
  [4463142589,4463360632,'Cancer'],
  [4463360632,4463580138,'Leo'],
  [4463580138,4463792852,'Virgo'],
  [4463792852,4463992093,'Libra'],
  [4463992093,4464177062,'Scorpio'],
  [4464177062,4464352273,'Sagittarius'],
  [4464352273,4464524495,'Capricorn'],
  [4464524495,4464700331,'Aquarius'],
  [4464700331,4464884639,'Pisces'],
  [4464884639,4465079594,'Aries'],
  [4465079594,4465284734,'Taurus'],
  [4465284734,4465497961,'Gemini'],
  [4465497961,4465716482,'Cancer'],
  [4465716482,4465936221,'Leo'],
  [4465936221,4466151230,'Virgo'],
  [4466151230,4466355315,'Libra'],
  [4466355315,4466545465,'Scorpio'],
  [4466545465,4466723565,'Sagittarius'],
  [4466723565,4466895027,'Capricorn'],
  [4466895027,4467066666,'Aquarius'],
  [4467066666,4467245060,'Pisces'],
  [4467245060,4467435055,'Aries'],
  [4467435055,4467638156,'Taurus'],
  [4467638156,4467851807,'Gemini'],
  [4467851807,4468070921,'Cancer'],
  [4468070921,4468290272,'Leo'],
  [4468290272,4468505324,'Virgo'],
  [4468505324,4468712103,'Libra'],
  [4468712103,4468907642,'Scorpio'],
  [4468907642,4469091518,'Sagittarius'],
  [4469091518,4469266529,'Capricorn'],
  [4469266529,4469438034,'Aquarius'],
  [4469438034,4469612712,'Pisces'],
  [4469612712,4469797091,'Aries'],
  [4469797091,4469995419,'Taurus'],
  [4469995419,4470207087,'Gemini'],
  [4470207087,4470426182,'Cancer'],
  [4470426182,4470645129,'Leo'],
  [4470645129,4470858728,'Virgo'],
  [4470858728,4471064836,'Libra'],
  [4471064836,4471262648,'Scorpio'],
  [4471262648,4471451735,'Sagittarius'],
  [4471451735,4471632705,'Capricorn'],
  [4471632705,4471808260,'Aquarius'],
  [4471808260,4471983468,'Pisces'],
  [4471983468,4472164836,'Aries'],
  [4472164836,4472358327,'Taurus'],
  [4472358327,4472566183,'Gemini'],
  [4472566183,4472784101,'Cancer'],
  [4472784101,4473003035,'Leo'],
  [4473003035,4473215426,'Virgo'],
  [4473215426,4473418931,'Libra'],
  [4473418931,4473614853,'Scorpio'],
  [4473614853,4473805000,'Sagittarius'],
  [4473805000,4473990280,'Capricorn'],
  [4473990280,4474171492,'Aquarius'],
  [4474171492,4474351034,'Pisces'],
  [4474351034,4474533579,'Aries'],
  [4474533579,4474724931,'Taurus'],
  [4474724931,4474929210,'Gemini'],
  [4474929210,4475145026,'Cancer'],
  [4475145026,4475364243,'Leo'],
  [4475364243,4475577103,'Virgo'],
  [4475577103,4475778961,'Libra'],
  [4475778961,4475971231,'Scorpio'],
  [4475971231,4476157916,'Sagittarius'],
  [4476157916,4476342407,'Capricorn'],
  [4476342407,4476526357,'Aquarius'],
  [4476526357,4476710718,'Pisces'],
  [4476710718,4476897543,'Aries'],
  [4476897543,4477090535,'Taurus'],
  [4477090535,4477293578,'Gemini'],
  [4477293578,4477507452,'Cancer'],
  [4477507452,4477726800,'Leo'],
  [4477726800,4477941839,'Virgo'],
  [4477941839,4478145106,'Libra'],
  [4478145106,4478335807,'Scorpio'],
  [4478335807,4478518118,'Sagittarius'],
  [4478518118,4478697566,'Capricorn'],
  [4478697566,4478878576,'Aquarius'],
  [4478878576,4479063630,'Pisces'],
  [4479063630,4479253943,'Aries'],
  [4479253943,4479450699,'Taurus'],
  [4479450699,4479655438,'Gemini'],
  [4479655438,4479868798,'Cancer'],
  [4479868798,4480087902,'Leo'],
  [4480087902,4480305361,'Virgo'],
  [4480305361,4480512761,'Libra'],
  [4480512761,4480706123,'Scorpio'],
  [4480706123,4480887469,'Sagittarius'],
  [4480887469,4481062365,'Capricorn'],
  [4481062365,4481237193,'Aquarius'],
  [4481237193,4481417372,'Pisces'],
  [4481417372,4481606286,'Aries'],
  [4481606286,4481804937,'Taurus'],
  [4481804937,4482012459,'Gemini'],
  [4482012459,4482227048,'Cancer'],
  [4482227048,4482445950,'Leo'],
  [4482445950,4482664452,'Virgo'],
  [4482664452,4482876015,'Libra'],
  [4482876015,4483075072,'Scorpio'],
  [4483075072,4483260355,'Sagittarius'],
  [4483260355,4483435246,'Capricorn'],
  [4483435246,4483605971,'Aquarius'],
  [4483605971,4483779616,'Pisces'],
  [4483779616,4483962465,'Aries'],
  [4483962465,4484158157,'Taurus'],
  [4484158157,4484366146,'Gemini'],
  [4484366146,4484582292,'Cancer'],
  [4484582292,4484801522,'Leo'],
  [4484801522,4485019593,'Virgo'],
  [4485019593,4485232668,'Libra'],
  [4485232668,4485436610,'Scorpio'],
  [4485436610,4485628395,'Sagittarius'],
  [4485628395,4485808195,'Capricorn'],
  [4485808195,4485980001,'Aquarius'],
  [4485980001,4486150507,'Pisces'],
  [4486150507,4486327297,'Aries'],
  [4486327297,4486516761,'Taurus'],
  [4486516761,4486721226,'Gemini'],
  [4486721226,4486937011,'Cancer'],
  [4486937011,4487156703,'Leo'],
  [4487156703,4487374028,'Virgo'],
  [4487374028,4487585948,'Libra'],
  [4487585948,4487790930,'Scorpio'],
  [4487790930,4487987202,'Sagittarius'],
  [4487987202,4488173422,'Capricorn'],
  [4488173422,4488350604,'Aquarius'],
  [4488350604,4488523170,'Pisces'],
  [4488523170,4488698006,'Aries'],
  [4488698006,4488882469,'Taurus'],
  [4488882469,4489081543,'Gemini'],
  [4489081543,4489294374,'Cancer'],
  [4489294374,4489513693,'Leo'],
  [4489513693,4489730791,'Virgo'],
  [4489730791,4489940973,'Libra'],
  [4489940973,4490143766,'Scorpio'],
  [4490143766,4490339889,'Sagittarius'],
  [4490339889,4490529359,'Capricorn'],
  [4490529359,4490712127,'Aquarius'],
  [4490712127,4490889998,'Pisces'],
  [4490889998,4491067545,'Aries'],
  [4491067545,4491251121,'Taurus'],
  [4491251121,4491446522,'Gemini'],
  [4491446522,4491655571,'Cancer'],
  [4491655571,4491873438,'Leo'],
  [4491873438,4492090848,'Virgo'],
  [4492090848,4492300561,'Libra'],
  [4492300561,4492500852,'Scorpio'],
  [4492500852,4492693667,'Sagittarius'],
  [4492693667,4492881476,'Capricorn'],
  [4492881476,4493065832,'Aquarius'],
  [4493065832,4493247993,'Pisces'],
  [4493247993,4493430316,'Aries'],
  [4493430316,4493616794,'Taurus'],
  [4493616794,4493812042,'Gemini'],
  [4493812042,4494018813,'Cancer'],
  [4494018813,4494234970,'Leo'],
  [4494234970,4494452930,'Virgo'],
  [4494452930,4494664008,'Libra'],
  [4494664008,4494863929,'Scorpio'],
  [4494863929,4495053749,'Sagittarius'],
  [4495053749,4495237251,'Capricorn'],
  [4495237251,4495418445,'Aquarius'],
  [4495418445,4495600451,'Pisces'],
  [4495600451,4495785591,'Aries'],
  [4495785591,4495975992,'Taurus'],
  [4495975992,4496173870,'Gemini'],
  [4496173870,4496380852,'Cancer'],
  [4496380852,4496596072,'Leo'],
  [4496596072,4496814514,'Virgo'],
  [4496814514,4497028182,'Libra'],
  [4497028182,4497230594,'Scorpio'],
  [4497230594,4497420368,'Sagittarius'],
  [4497420368,4497600664,'Capricorn'],
  [4497600664,4497776822,'Aquarius'],
  [4497776822,4497954383,'Pisces'],
  [4497954383,4498137782,'Aries'],
  [4498137782,4498329571,'Taurus'],
  [4498329571,4498530322,'Gemini'],
  [4498530322,4498739273,'Cancer'],
  [4498739273,4498954757,'Leo'],
  [4498954757,4499173434,'Virgo'],
  [4499173434,4499389544,'Libra'],
  [4499389544,4499596281,'Scorpio'],
  [4499596281,4499789584,'Sagittarius'],
  [4499789584,4499970322,'Capricorn'],
  [4499970322,4500143371,'Aquarius'],
  [4500143371,4500315522,'Pisces'],
  [4500315522,4500493543,'Aries'],
  [4500493543,4500682346,'Taurus'],
  [4500682346,4500883276,'Gemini'],
  [4500883276,4501093983,'Cancer'],
  [4501093983,4501310525,'Leo'],
  [4501310525,4501529238,'Virgo'],
  [4501529238,4501746375,'Libra'],
  [4501746375,4501956927,'Scorpio'],
  [4501956927,4502155790,'Sagittarius'],
  [4502155790,4502340956,'Capricorn'],
  [4502340956,4502515112,'Aquarius'],
  [4502515112,4502684593,'Pisces'],
  [4502684593,4502857212,'Aries'],
  [4502857212,4503040150,'Taurus'],
  [4503040150,4503237369,'Gemini'],
  [4503237369,4503447444,'Cancer'],
  [4503447444,4503664741,'Leo'],
  [4503664741,4503883485,'Virgo'],
  [4503883485,4504100085,'Libra'],
  [4504100085,4504311788,'Scorpio'],
  [4504311788,4504514977,'Sagittarius'],
  [4504514977,4504706337,'Capricorn'],
  [4504706337,4504885666,'Aquarius'],
  [4504885666,4505057109,'Pisces'],
  [4505057109,4505227808,'Aries'],
  [4505227808,4505405728,'Taurus'],
  [4505405728,4505597159,'Gemini'],
  [4505597159,4505803520,'Cancer'],
  [4505803520,4506019983,'Leo'],
  [4506019983,4506238787,'Virgo'],
  [4506238787,4506454358,'Libra'],
  [4506454358,4506664528,'Scorpio'],
  [4506664528,4506868127,'Sagittarius'],
  [4506868127,4507063341,'Capricorn'],
  [4507063341,4507248818,'Aquarius'],
  [4507248818,4507425944,'Pisces'],
  [4507425944,4507599517,'Aries'],
  [4507599517,4507776440,'Taurus'],
  [4507776440,4507963601,'Gemini'],
  [4507963601,4508164955,'Cancer'],
  [4508164955,4508378608,'Leo'],
  [4508378608,4508597130,'Virgo'],
  [4508597130,4508812489,'Libra'],
  [4508812489,4509020665,'Scorpio'],
  [4509020665,4509221385,'Sagittarius'],
  [4509221385,4509415477,'Capricorn'],
  [4509415477,4509603395,'Aquarius'],
  [4509603395,4509785857,'Pisces'],
  [4509785857,4509965176,'Aries'],
  [4509965176,4510145654,'Taurus'],
  [4510145654,4510332697,'Gemini'],
  [4510332697,4510530852,'Cancer'],
  [4510530852,4510741038,'Leo'],
  [4510741038,4510958551,'Virgo'],
  [4510958551,4511174863,'Libra'],
  [4511174863,4511383035,'Scorpio'],
  [4511383035,4511581098,'Sagittarius'],
  [4511581098,4511770939,'Capricorn'],
  [4511770939,4511955779,'Aquarius'],
  [4511955779,4512138564,'Pisces'],
  [4512138564,4512321654,'Aries'],
  [4512321654,4512507278,'Taurus'],
  [4512507278,4512698024,'Gemini'],
  [4512698024,4512896685,'Cancer'],
  [4512896685,4513104938,'Leo'],
  [4513104938,4513321061,'Virgo'],
  [4513321061,4513538684,'Libra'],
  [4513538684,4513749424,'Scorpio'],
  [4513749424,4513948129,'Sagittarius'],
  [4513948129,4514135156,'Capricorn'],
  [4514135156,4514314797,'Aquarius'],
  [4514314797,4514492680,'Pisces'],
  [4514492680,4514673752,'Aries'],
  [4514673752,4514861093,'Taurus'],
  [4514861093,4515055730,'Gemini'],
  [4515055730,4515257599,'Cancer'],
  [4515257599,4515466582,'Leo'],
  [4515466582,4515681945,'Virgo'],
  [4515681945,4515900265,'Libra'],
  [4515900265,4516114516,'Scorpio'],
  [4516114516,4516317360,'Sagittarius'],
  [4516317360,4516505952,'Capricorn'],
  [4516505952,4516683216,'Aquarius'],
  [4516683216,4516855676,'Pisces'],
  [4516855676,4517030648,'Aries'],
  [4517030648,4517214008,'Taurus'],
  [4517214008,4517408340,'Gemini'],
  [4517408340,4517612530,'Cancer'],
  [4517612530,4517823741,'Leo'],
  [4517823741,4518039602,'Virgo'],
  [4518039602,4518257901,'Libra'],
  [4518257901,4518474336,'Scorpio'],
  [4518474336,4518682184,'Sagittarius'],
  [4518682184,4518876080,'Capricorn'],
  [4518876080,4519055911,'Aquarius'],
  [4519055911,4519226914,'Pisces'],
  [4519226914,4519396935,'Aries'],
  [4519396935,4519573817,'Taurus'],
  [4519573817,4519763041,'Gemini'],
  [4519763041,4519965508,'Cancer'],
  [4519965508,4520177665,'Leo'],
  [4520177665,4520394604,'Virgo'],
  [4520394604,4520612759,'Libra'],
  [4520612759,4520829259,'Scorpio'],
  [4520829259,4521039807,'Sagittarius'],
  [4521039807,4521239244,'Capricorn'],
  [4521239244,4521424980,'Aquarius'],
  [4521424980,4521599446,'Pisces'],
  [4521599446,4521769102,'Aries'],
  [4521769102,4521941901,'Taurus'],
  [4521941901,4522125001,'Gemini'],
  [4522125001,4522322252,'Cancer'],
  [4522322252,4522532239,'Leo'],
  [4522532239,4522749326,'Virgo'],
  [4522749326,4522967506,'Libra'],
  [4522967506,4523182937,'Scorpio'],
  [4523182937,4523392972,'Sagittarius'],
  [4523392972,4523594697,'Capricorn'],
  [4523594697,4523785657,'Aquarius'],
  [4523785657,4523966076,'Pisces'],
  [4523966076,4524139799,'Aries'],
  [4524139799,4524313165,'Taurus'],
  [4524313165,4524493134,'Gemini'],
  [4524493134,4524685171,'Cancer'],
  [4524685171,4524890815,'Leo'],
  [4524890815,4525106299,'Virgo'],
  [4525106299,4525324452,'Libra'],
  [4525324452,4525539066,'Scorpio'],
  [4525539066,4525746973,'Sagittarius'],
  [4525746973,4525947142,'Capricorn'],
  [4525947142,4526139334,'Aquarius'],
  [4526139334,4526324048,'Pisces'],
  [4526324048,4526503301,'Aries'],
  [4526503301,4526680926,'Taurus'],
  [4526680926,4526862052,'Gemini'],
  [4526862052,4527051856,'Cancer'],
  [4527051856,4527253625,'Leo'],
  [4527253625,4527466438,'Virgo'],
  [4527466438,4527684293,'Libra'],
  [4527684293,4527899148,'Scorpio'],
  [4527899148,4528105625,'Sagittarius'],
  [4528105625,4528302649,'Capricorn'],
  [4528302649,4528492052,'Aquarius'],
  [4528492052,4528676571,'Pisces'],
  [4528676571,4528858798,'Aries'],
  [4528858798,4529041150,'Taurus'],
  [4529041150,4529226312,'Gemini'],
  [4529226312,4529417515,'Cancer'],
  [4529417515,4529617885,'Leo'],
  [4529617885,4529828476,'Virgo'],
  [4529828476,4530045828,'Libra'],
  [4530045828,4530262025,'Scorpio'],
  [4530262025,4530469258,'Sagittarius'],
  [4530469258,4530664517,'Capricorn'],
  [4530664517,4530849981,'Aquarius'],
  [4530849981,4531030488,'Pisces'],
  [4531030488,4531210932,'Aries'],
  [4531210932,4531394726,'Taurus'],
  [4531394726,4531583528,'Gemini'],
  [4531583528,4531778192,'Cancer'],
  [4531778192,4531979917,'Leo'],
  [4531979917,4532189868,'Virgo'],
  [4532189868,4532406794,'Libra'],
  [4532406794,4532624766,'Scorpio'],
  [4532624766,4532835001,'Sagittarius'],
  [4532835001,4533031703,'Capricorn'],
  [4533031703,4533215434,'Aquarius'],
  [4533215434,4533391538,'Pisces'],
  [4533391538,4533566890,'Aries'],
  [4533566890,4533747341,'Taurus'],
  [4533747341,4533936014,'Gemini'],
  [4533936014,4534133080,'Cancer'],
  [4534133080,4534337442,'Leo'],
  [4534337442,4534548440,'Virgo'],
  [4534548440,4534765309,'Libra'],
  [4534765309,4534984496,'Scorpio'],
  [4534984496,4535198503,'Sagittarius'],
  [4535198503,4535399704,'Capricorn'],
  [4535399704,4535585758,'Aquarius'],
  [4535585758,4535760579,'Pisces'],
  [4535760579,4535931444,'Aries'],
  [4535931444,4536105995,'Taurus'],
  [4536105995,4536289994,'Gemini'],
  [4536289994,4536485536,'Cancer'],
  [4536485536,4536691110,'Leo'],
  [4536691110,4536903782,'Virgo'],
  [4536903782,4537121100,'Libra'],
  [4537121100,4537340428,'Scorpio'],
  [4537340428,4537556731,'Sagittarius'],
  [4537556731,4537763083,'Capricorn'],
  [4537763083,4537954854,'Aquarius'],
  [4537954854,4538133055,'Pisces'],
  [4538133055,4538303474,'Aries'],
  [4538303474,4538473847,'Taurus'],
  [4538473847,4538651564,'Gemini'],
  [4538651564,4538841595,'Cancer'],
  [4538841595,4539044728,'Leo'],
  [4539044728,4539257731,'Virgo'],
  [4539257731,4539475728,'Libra'],
  [4539475728,4539694583,'Scorpio'],
  [4539694583,4539910602,'Sagittarius'],
  [4539910602,4540119405,'Capricorn'],
  [4540119405,4540316824,'Aquarius'],
  [4540316824,4540501535,'Pisces'],
  [4540501535,4540676407,'Aries'],
  [4540676407,4540847388,'Taurus'],
  [4540847388,4541021601,'Gemini'],
  [4541021601,4541205568,'Cancer'],
  [4541205568,4541403160,'Leo'],
  [4541403160,4541613636,'Virgo'],
  [4541613636,4541831611,'Libra'],
  [4541831611,4542050257,'Scorpio'],
  [4542050257,4542264627,'Sagittarius'],
  [4542264627,4542472051,'Capricorn'],
  [4542472051,4542671030,'Aquarius'],
  [4542671030,4542860849,'Pisces'],
  [4542860849,4543042356,'Aries'],
  [4543042356,4543218554,'Taurus'],
  [4543218554,4543394384,'Gemini'],
  [4543394384,4543575808,'Cancer'],
  [4543575808,4543768253,'Leo'],
  [4543768253,4543974180,'Virgo'],
  [4543974180,4544190552,'Libra'],
  [4544190552,4544409445,'Scorpio'],
  [4544409445,4544623014,'Sagittarius'],
  [4544623014,4544827632,'Capricorn'],
  [4544827632,4545023738,'Aquarius'],
  [4545023738,4545213376,'Pisces'],
  [4545213376,4545398453,'Aries'],
  [4545398453,4545580545,'Taurus'],
  [4545580545,4545761730,'Gemini'],
  [4545761730,4545945486,'Cancer'],
  [4545945486,4546136483,'Leo'],
  [4546136483,4546338763,'Virgo'],
  [4546338763,4546552491,'Libra'],
  [4546552491,4546771518,'Scorpio'],
  [4546771518,4546986153,'Sagittarius'],
  [4546986153,4547189850,'Capricorn'],
  [4547189850,4547382385,'Aquarius'],
  [4547382385,4547567712,'Pisces'],
  [4547567712,4547750500,'Aries'],
  [4547750500,4547933964,'Taurus'],
  [4547933964,4548119505,'Gemini'],
  [4548119505,4548308035,'Cancer'],
  [4548308035,4548501618,'Leo'],
  [4548501618,4548703411,'Virgo'],
  [4548703411,4548915231,'Libra'],
  [4548915231,4549133948,'Scorpio'],
  [4549133948,4549350764,'Sagittarius'],
  [4549350764,4549556662,'Capricorn'],
  [4549556662,4549748673,'Aquarius'],
  [4549748673,4549930262,'Pisces'],
  [4549930262,4550107747,'Aries'],
  [4550107747,4550287021,'Taurus'],
  [4550287021,4550471653,'Gemini'],
  [4550471653,4550662623,'Cancer'],
  [4550662623,4550859867,'Leo'],
  [4550859867,4551063961,'Virgo'],
  [4551063961,4551275851,'Libra'],
  [4551275851,4551494200,'Scorpio'],
  [4551494200,4551712842,'Sagittarius'],
  [4551712842,4551922734,'Capricorn'],
  [4551922734,4552118104,'Aquarius'],
  [4552118104,4552299935,'Pisces'],
  [4552299935,4552474042,'Aries'],
  [4552474042,4552647616,'Taurus'],
  [4552647616,4552826775,'Gemini'],
  [4552826775,4553015032,'Cancer'],
  [4553015032,4553212977,'Leo'],
  [4553212977,4553419431,'Virgo'],
  [4553419431,4553632867,'Libra'],
  [4553632867,4553851321,'Scorpio'],
  [4553851321,4554070593,'Sagittarius'],
  [4554070593,4554283774,'Capricorn'],
  [4554283774,4554484367,'Aquarius'],
  [4554484367,4554670511,'Pisces'],
  [4554670511,4554845734,'Aries'],
  [4554845734,4555016583,'Taurus'],
  [4555016583,4555190168,'Gemini'],
  [4555190168,4555372433,'Cancer'],
  [4555372433,4555566678,'Leo'],
  [4555566678,4555772693,'Virgo'],
  [4555772693,4555987315,'Libra'],
  [4555987315,4556206288,'Scorpio'],
  [4556206288,4556425222,'Sagittarius'],
  [4556425222,4556639340,'Capricorn'],
  [4556639340,4556843831,'Aquarius'],
  [4556843831,4557035755,'Pisces'],
  [4557035755,4557215919,'Aries'],
  [4557215919,4557388639,'Taurus'],
  [4557388639,4557560224,'Gemini'],
  [4557560224,4557737429,'Cancer'],
  [4557737429,4557925898,'Leo'],
  [4557925898,4558128163,'Virgo'],
  [4558128163,4558341967,'Libra'],
  [4558341967,4558561243,'Scorpio'],
  [4558561243,4558779593,'Sagittarius'],
  [4558779593,4558992570,'Capricorn'],
  [4558992570,4559197640,'Aquarius'],
  [4559197640,4559393263,'Pisces'],
  [4559393263,4559579154,'Aries'],
  [4559579154,4559757069,'Taurus'],
  [4559757069,4559931066,'Gemini'],
  [4559931066,4560106979,'Cancer'],
  [4560106979,4560291187,'Leo'],
  [4560291187,4560488545,'Virgo'],
  [4560488545,4560699437,'Libra'],
  [4560699437,4560918201,'Scorpio'],
  [4560918201,4561136309,'Sagittarius'],
  [4561136309,4561347669,'Capricorn'],
  [4561347669,4561550581,'Aquarius'],
  [4561550581,4561745854,'Pisces'],
  [4561745854,4561934572,'Aries'],
  [4561934572,4562117638,'Taurus'],
  [4562117638,4562296728,'Gemini'],
  [4562296728,4562475385,'Cancer'],
  [4562475385,4562658966,'Leo'],
  [4562658966,4562853070,'Virgo'],
  [4562853070,4563060495,'Libra'],
  [4563060495,4563277901,'Scorpio'],
  [4563277901,4563496315,'Sagittarius'],
  [4563496315,4563707219,'Capricorn'],
  [4563707219,4563907674,'Aquarius'],
  [4563907674,4564099675,'Pisces'],
  [4564099675,4564286688,'Aries'],
  [4564286688,4564471197,'Taurus'],
  [4564471197,4564654423,'Gemini'],
  [4564654423,4564837749,'Cancer'],
  [4564837749,4565024196,'Leo'],
  [4565024196,4565218234,'Virgo'],
  [4565218234,4565423555,'Libra'],
  [4565423555,4565639388,'Scorpio'],
  [4565639388,4565858454,'Sagittarius'],
  [4565858454,4566070827,'Capricorn'],
  [4566070827,4566270969,'Aquarius'],
  [4566270969,4566459981,'Pisces'],
  [4566459981,4566642627,'Aries'],
  [4566642627,4566823834,'Taurus'],
  [4566823834,4567006781,'Gemini'],
  [4567006781,4567192890,'Cancer'],
  [4567192890,4567383291,'Leo'],
  [4567383291,4567580039,'Virgo'],
  [4567580039,4567785647,'Libra'],
  [4567785647,4568000568,'Scorpio'],
  [4568000568,4568220166,'Sagittarius'],
  [4568220166,4568435358,'Capricorn'],
  [4568435358,4568638342,'Aquarius'],
  [4568638342,4568827581,'Pisces'],
  [4568827581,4569007087,'Aries'],
  [4569007087,4569183021,'Taurus'],
  [4569183021,4569361073,'Gemini'],
  [4569361073,4569545061,'Cancer'],
  [4569545061,4569736710,'Leo'],
  [4569736710,4569936446,'Virgo'],
  [4569936446,4570144246,'Libra'],
  [4570144246,4570359482,'Scorpio'],
  [4570359482,4570579181,'Sagittarius'],
  [4570579181,4570796821,'Capricorn'],
  [4570796821,4571004581,'Aquarius'],
  [4571004581,4571198098,'Pisces'],
  [4571198098,4571378727,'Aries'],
  [4571378727,4571551812,'Taurus'],
  [4571551812,4571724104,'Gemini'],
  [4571724104,4571901942,'Cancer'],
  [4571901942,4572089837,'Leo'],
  [4572089837,4572289367,'Virgo'],
  [4572289367,4572499043,'Libra'],
  [4572499043,4572715580,'Scorpio'],
  [4572715580,4572935201,'Sagittarius'],
  [4572935201,4573153450,'Capricorn'],
  [4573153450,4573364883,'Aquarius'],
  [4573364883,4573564531,'Pisces'],
  [4573564531,4573750705,'Aries'],
  [4573750705,4573926009,'Taurus'],
  [4573926009,4574096197,'Gemini'],
  [4574096197,4574268425,'Cancer'],
  [4574268425,4574449608,'Leo'],
  [4574449608,4574644395,'Virgo'],
  [4574644395,4574852863,'Libra'],
  [4574852863,4575070241,'Scorpio'],
  [4575070241,4575290057,'Sagittarius'],
  [4575290057,4575507400,'Capricorn'],
  [4575507400,4575719173,'Aquarius'],
  [4575719173,4575922613,'Pisces'],
  [4575922613,4576115338,'Aries'],
  [4576115338,4576296983,'Taurus'],
  [4576296983,4576470463,'Gemini'],
  [4576470463,4576641690,'Cancer'],
  [4576641690,4576818073,'Leo'],
  [4576818073,4577006486,'Virgo'],
  [4577006486,4577210244,'Libra'],
  [4577210244,4577426228,'Scorpio'],
  [4577426228,4577646238,'Sagittarius'],
  [4577646238,4577862735,'Capricorn'],
  [4577862735,4578072496,'Aquarius'],
  [4578072496,4578275205,'Pisces'],
  [4578275205,4578470676,'Aries'],
  [4578470676,4578658218,'Taurus'],
  [4578658218,4578838124,'Gemini'],
  [4578838124,4579013444,'Cancer'],
  [4579013444,4579190022,'Leo'],
  [4579190022,4579374873,'Virgo'],
  [4579374873,4579573445,'Libra'],
  [4579573445,4579785880,'Scorpio'],
  [4579785880,4580005251,'Sagittarius'],
  [4580005251,4580221885,'Capricorn'],
  [4580221885,4580430091,'Aquarius'],
  [4580430091,4580629683,'Pisces'],
  [4580629683,4580822865,'Aries'],
  [4580822865,4581011297,'Taurus'],
  [4581011297,4581195549,'Gemini'],
  [4581195549,4581376618,'Cancer'],
  [4581376618,4581557576,'Leo'],
  [4581557576,4581743544,'Virgo'],
  [4581743544,4581939872,'Libra'],
  [4581939872,4582148900,'Scorpio'],
  [4582148900,4582366740,'Sagittarius'],
  [4582366740,4582584188,'Capricorn'],
  [4582584188,4582793002,'Aquarius'],
  [4582793002,4582990781,'Pisces'],
  [4582990781,4583179995,'Aries'],
  [4583179995,4583364579,'Taurus'],
  [4583364579,4583547631,'Gemini'],
  [4583547631,4583731041,'Cancer'],
  [4583731041,4583916493,'Leo'],
  [4583916493,4584106510,'Virgo'],
  [4584106510,4584304341,'Libra'],
  [4584304341,4584512244,'Scorpio'],
  [4584512244,4584728669,'Sagittarius'],
  [4584728669,4584946917,'Capricorn'],
  [4584946917,4585158219,'Aquarius'],
  [4585158219,4585357365,'Pisces'],
  [4585357365,4585544894,'Aries'],
  [4585544894,4585725052,'Taurus'],
  [4585725052,4585903069,'Gemini'],
  [4585903069,4586083455,'Cancer'],
  [4586083455,4586269296,'Leo'],
  [4586269296,4586462319,'Virgo'],
  [4586462319,4586663356,'Libra'],
  [4586663356,4586872579,'Scorpio'],
  [4586872579,4587088655,'Sagittarius'],
  [4587088655,4587307309,'Capricorn'],
  [4587307309,4587521497,'Aquarius'],
  [4587521497,4587724598,'Pisces'],
  [4587724598,4587914296,'Aries'],
  [4587914296,4588093144,'Taurus'],
  [4588093144,4588266692,'Gemini'],
  [4588266692,4588441384,'Cancer'],
  [4588441384,4588622914,'Leo'],
  [4588622914,4588814797,'Virgo'],
  [4588814797,4589017458,'Libra'],
  [4589017458,4589228761,'Scorpio'],
  [4589228761,4589445565,'Sagittarius'],
  [4589445565,4589664261,'Capricorn'],
  [4589664261,4589880186,'Aquarius'],
  [4589880186,4590087636,'Pisces'],
  [4590087636,4590282336,'Aries'],
  [4590282336,4590464058,'Taurus'],
  [4590464058,4590636839,'Gemini'],
  [4590636839,4590807381,'Cancer'],
  [4590807381,4590983071,'Leo'],
  [4590983071,4591169997,'Virgo'],
  [4591169997,4591370615,'Libra'],
  [4591370615,4591582483,'Scorpio'],
  [4591582483,4591800216,'Sagittarius'],
  [4591800216,4592018821,'Capricorn'],
  [4592018821,4592234750,'Aquarius'],
  [4592234750,4592444546,'Pisces'],
  [4592444546,4592644291,'Aries'],
  [4592644291,4592831610,'Taurus'],
  [4592831610,4593007863,'Gemini'],
  [4593007863,4593178313,'Cancer'],
  [4593178313,4593350435,'Leo'],
  [4593350435,4593531805,'Virgo'],
  [4593531805,4593727495,'Libra'],
  [4593727495,4593937145,'Scorpio'],
  [4593937145,4594154855,'Sagittarius'],
  [4594154855,4594373395,'Capricorn'],
  [4594373395,4594588269,'Aquarius'],
  [4594588269,4594797526,'Pisces'],
  [4594797526,4594999398,'Aries'],
  [4594999398,4595191714,'Taurus'],
  [4595191714,4595373749,'Gemini'],
  [4595373749,4595548184,'Cancer'],
  [4595548184,4595720948,'Leo'],
  [4595720948,4595899469,'Virgo'],
  [4595899469,4596090270,'Libra'],
  [4596090270,4596295740,'Scorpio'],
  [4596295740,4596511837,'Sagittarius'],
  [4596511837,4596730300,'Capricorn'],
  [4596730300,4596944333,'Aquarius'],
  [4596944333,4597151456,'Pisces'],
  [4597151456,4597351723,'Aries'],
  [4597351723,4597545184,'Taurus'],
  [4597545184,4597731494,'Gemini'],
  [4597731494,4597911504,'Cancer'],
  [4597911504,4598088609,'Leo'],
  [4598088609,4598268431,'Virgo'],
  [4598268431,4598457149,'Libra'],
  [4598457149,4598658797,'Scorpio'],
  [4598658797,4598872200,'Sagittarius'],
  [4598872200,4599090387,'Capricorn'],
  [4599090387,4599304776,'Aquarius'],
  [4599304776,4599510545,'Pisces'],
  [4599510545,4599707578,'Aries'],
  [4599707578,4599897981,'Taurus'],
  [4599897981,4600083848,'Gemini'],
  [4600083848,4600266806,'Cancer'],
  [4600266806,4600448839,'Leo'],
  [4600448839,4600633046,'Virgo'],
  [4600633046,4600823483,'Libra'],
  [4600823483,4601023810,'Scorpio'],
  [4601023810,4601234854,'Sagittarius'],
  [4601234854,4601452460,'Capricorn'],
  [4601452460,4601668431,'Aquarius'],
  [4601668431,4601875391,'Pisces'],
  [4601875391,4602070916,'Aries'],
  [4602070916,4602257175,'Taurus'],
  [4602257175,4602438428,'Gemini'],
  [4602438428,4602618977,'Cancer'],
  [4602618977,4602802145,'Leo'],
  [4602802145,4602990155,'Virgo'],
  [4602990155,4603184552,'Libra'],
  [4603184552,4603386643,'Scorpio'],
  [4603386643,4603597052,'Sagittarius'],
  [4603597052,4603813985,'Capricorn'],
  [4603813985,4604031744,'Aquarius'],
  [4604031744,4604242309,'Pisces'],
  [4604242309,4604440150,'Aries'],
  [4604440150,4604625208,'Taurus'],
  [4604625208,4604801889,'Gemini'],
  [4604801889,4604976560,'Cancer'],
  [4604976560,4605155351,'Leo'],
  [4605155351,4605342461,'Virgo'],
  [4605342461,4605539153,'Libra'],
  [4605539153,4605744291,'Scorpio'],
  [4605744291,4605956092,'Sagittarius'],
  [4605956092,4606172830,'Capricorn'],
  [4606172830,4606391405,'Aquarius'],
  [4606391405,4606605790,'Pisces'],
  [4606605790,4606808992,'Aries'],
  [4606808992,4606997598,'Taurus'],
  [4606997598,4607173879,'Gemini'],
  [4607173879,4607344252,'Cancer'],
  [4607344252,4607516563,'Leo'],
  [4607516563,4607697807,'Virgo'],
  [4607697807,4607891806,'Libra'],
  [4607891806,4608097687,'Scorpio'],
  [4608097687,4608311347,'Sagittarius'],
  [4608311347,4608528731,'Capricorn'],
  [4608528731,4608747084,'Aquarius'],
  [4608747084,4608963055,'Pisces'],
  [4608963055,4609171182,'Aries'],
  [4609171182,4609366248,'Taurus'],
  [4609366248,4609547202,'Gemini'],
  [4609547202,4609718357,'Cancer'],
  [4609718357,4609887288,'Leo'],
  [4609887288,4610062240,'Virgo'],
  [4610062240,4610249765,'Libra'],
  [4610249765,4610451945,'Scorpio'],
  [4610451945,4610665263,'Sagittarius'],
  [4610665263,4610883401,'Capricorn'],
  [4610883401,4611101412,'Aquarius'],
  [4611101412,4611316556,'Pisces'],
  [4611316556,4611526014,'Aries'],
  [4611526014,4611725926,'Taurus'],
  [4611725926,4611913579,'Gemini'],
  [4611913579,4612090194,'Cancer'],
  [4612090194,4612261137,'Leo'],
  [4612261137,4612433924,'Virgo'],
  [4612433924,4612615986,'Libra'],
  [4612615986,4612812124,'Scorpio'],
  [4612812124,4613021890,'Sagittarius'],
  [4613021890,4613239453,'Capricorn'],
  [4613239453,4613457470,'Aquarius'],
  [4613457470,4613671241,'Pisces'],
  [4613671241,4613878807,'Aries'],
  [4613878807,4614078923,'Taurus'],
  [4614078923,4614270332,'Gemini'],
  [4614270332,4614453037,'Cancer'],
  [4614453037,4614629667,'Leo'],
  [4614629667,4614805342,'Virgo'],
  [4614805342,4614986355,'Libra'],
  [4614986355,4615178253,'Scorpio'],
  [4615178253,4615383353,'Sagittarius'],
  [4615383353,4615598648,'Capricorn'],
  [4615598648,4615816676,'Aquarius'],
  [4615816676,4616030133,'Pisces'],
  [4616030133,4616235440,'Aries'],
  [4616235440,4616432454,'Taurus'],
  [4616432454,4616622527,'Gemini'],
  [4616622527,4616807308,'Cancer'],
  [4616807308,4616988781,'Leo'],
  [4616988781,4617169730,'Virgo'],
  [4617169730,4617353922,'Libra'],
  [4617353922,4617545572,'Scorpio'],
  [4617545572,4617747837,'Sagittarius'],
  [4617747837,4617960485,'Capricorn'],
  [4617960485,4618178235,'Aquarius'],
  [4618178235,4618392760,'Pisces'],
  [4618392760,4618597777,'Aries'],
  [4618597777,4618791939,'Taurus'],
  [4618791939,4618977881,'Gemini'],
  [4618977881,4619159783,'Cancer'],
  [4619159783,4619341486,'Leo'],
  [4619341486,4619525710,'Virgo'],
  [4619525710,4619714264,'Libra'],
  [4619714264,4619908835,'Scorpio'],
  [4619908835,4620111306,'Sagittarius'],
  [4620111306,4620322526,'Capricorn'],
  [4620322526,4620539874,'Aquarius'],
  [4620539874,4620756247,'Pisces'],
  [4620756247,4620963487,'Aries'],
  [4620963487,4621157633,'Taurus'],
  [4621157633,4621340513,'Gemini'],
  [4621340513,4621517603,'Cancer'],
  [4621517603,4621695117,'Leo'],
  [4621695117,4621877869,'Virgo'],
  [4621877869,4622068112,'Libra'],
  [4622068112,4622265878,'Scorpio'],
  [4622265878,4622470635,'Sagittarius'],
  [4622470635,4622682204,'Capricorn'],
  [4622682204,4622899358,'Aquarius'],
  [4622899358,4623117373,'Pisces'],
  [4623117373,4623328296,'Aries'],
  [4623328296,4623525719,'Taurus'],
  [4623525719,4623709075,'Gemini'],
  [4623709075,4623883274,'Cancer'],
  [4623883274,4624055656,'Leo'],
  [4624055656,4624233255,'Virgo'],
  [4624233255,4624420670,'Libra'],
  [4624420670,4624618757,'Scorpio'],
  [4624618757,4624825527,'Sagittarius'],
  [4624825527,4625038532,'Capricorn'],
  [4625038532,4625255881,'Aquarius'],
  [4625255881,4625474564,'Pisces'],
  [4625474564,4625688621,'Aries'],
  [4625688621,4625891058,'Taurus'],
  [4625891058,4626078608,'Gemini'],
  [4626078608,4626253978,'Cancer'],
  [4626253978,4626423935,'Leo'],
  [4626423935,4626596391,'Virgo'],
  [4626596391,4626778107,'Libra'],
  [4626778107,4626972520,'Scorpio'],
  [4626972520,4627178674,'Sagittarius'],
  [4627178674,4627392685,'Capricorn'],
  [4627392685,4627610499,'Aquarius'],
  [4627610499,4627828878,'Pisces'],
  [4627828878,4628043861,'Aries'],
  [4628043861,4628250149,'Taurus'],
  [4628250149,4628443481,'Gemini'],
  [4628443481,4628623830,'Cancer'],
  [4628623830,4628795785,'Leo'],
  [4628795785,4628966464,'Virgo'],
  [4628966464,4629143297,'Libra'],
  [4629143297,4629331971,'Scorpio'],
  [4629331971,4629534293,'Sagittarius'],
  [4629534293,4629747384,'Capricorn'],
  [4629747384,4629965486,'Aquarius'],
  [4629965486,4630183277,'Pisces'],
  [4630183277,4630397039,'Aries'],
  [4630397039,4630603761,'Taurus'],
  [4630603761,4630800796,'Gemini'],
  [4630800796,4630987096,'Cancer'],
  [4630987096,4631164604,'Leo'],
  [4631164604,4631338088,'Virgo'],
  [4631338088,4631513868,'Libra'],
  [4631513868,4631698224,'Scorpio'],
  [4631698224,4631895401,'Sagittarius'],
  [4631895401,4632105366,'Capricorn'],
  [4632105366,4632322966,'Aquarius'],
  [4632322966,4632540658,'Pisces'],
  [4632540658,4632752775,'Aries'],
  [4632752775,4632957007,'Taurus'],
  [4632957007,4633153264,'Gemini'],
  [4633153264,4633342239,'Cancer'],
  [4633342239,4633525181,'Leo'],
  [4633525181,4633704386,'Virgo'],
  [4633704386,4633883566,'Libra'],
  [4633883566,4634067604,'Scorpio'],
  [4634067604,4634261385,'Sagittarius'],
  [4634261385,4634467521,'Capricorn'],
  [4634467521,4634683582,'Aquarius'],
  [4634683582,4634901837,'Pisces'],
  [4634901837,4635113863,'Aries'],
  [4635113863,4635315610,'Taurus'],
  [4635315610,4635508024,'Gemini'],
  [4635508024,4635694482,'Cancer'],
  [4635694482,4635878293,'Leo'],
  [4635878293,4636061663,'Virgo'],
  [4636061663,4636246125,'Libra'],
  [4636246125,4636433775,'Scorpio'],
  [4636433775,4636627903,'Sagittarius'],
  [4636627903,4636831847,'Capricorn'],
  [4636831847,4637045999,'Aquarius'],
  [4637045999,4637264918,'Pisces'],
  [4637264918,4637479017,'Aries'],
  [4637479017,4637681144,'Taurus'],
  [4637681144,4637870746,'Gemini'],
  [4637870746,4638052300,'Cancer'],
  [4638052300,4638231721,'Leo'],
  [4638231721,4638413687,'Virgo'],
  [4638413687,4638600410,'Libra'],
  [4638600410,4638792265,'Scorpio'],
  [4638792265,4638989739,'Sagittarius'],
  [4638989739,4639194442,'Capricorn'],
  [4639194442,4639407617,'Aquarius'],
  [4639407617,4639626723,'Pisces'],
  [4639626723,4639843779,'Aries'],
  [4639843779,4640049625,'Taurus'],
  [4640049625,4640240520,'Gemini'],
  [4640240520,4640419601,'Cancer'],
  [4640419601,4640593654,'Leo'],
  [4640593654,4640769727,'Virgo'],
  [4640769727,4640952852,'Libra'],
  [4640952852,4641144849,'Scorpio'],
  [4641144849,4641345053,'Sagittarius'],
  [4641345053,4641552363,'Capricorn'],
  [4641552363,4641766252,'Aquarius'],
  [4641766252,4641985233,'Pisces'],
  [4641985233,4642204152,'Aries'],
  [4642204152,4642414743,'Taurus'],
  [4642414743,4642610779,'Gemini'],
  [4642610779,4642792314,'Cancer'],
  [4642792314,4642964776,'Leo'],
  [4642964776,4643135692,'Virgo'],
  [4643135692,4643312165,'Libra'],
  [4643312165,4643499036,'Scorpio'],
  [4643499036,4643697663,'Sagittarius'],
  [4643697663,4643906269,'Capricorn'],
  [4643906269,4644121702,'Aquarius'],
  [4644121702,4644340839,'Pisces'],
  [4644340839,4644559836,'Aries'],
  [4644559836,4644773081,'Taurus'],
  [4644773081,4644974745,'Gemini'],
  [4644974745,4645162336,'Cancer'],
  [4645162336,4645338344,'Leo'],
  [4645338344,4645508757,'Virgo'],
  [4645508757,4645680783,'Libra'],
  [4645680783,4645861090,'Scorpio'],
  [4645861090,4646054098,'Sagittarius'],
  [4646054098,4646260327,'Capricorn'],
  [4646260327,4646476074,'Aquarius'],
  [4646476074,4646695626,'Pisces'],
  [4646695626,4646913841,'Aries'],
  [4646913841,4647126694,'Taurus'],
  [4647126694,4647330826,'Gemini'],
  [4647330826,4647523958,'Cancer'],
  [4647523958,4647706278,'Leo'],
  [4647706278,4647880955,'Virgo'],
  [4647880955,4648053446,'Libra'],
  [4648053446,4648230271,'Scorpio'],
  [4648230271,4648417527,'Sagittarius'],
  [4648417527,4648618737,'Capricorn'],
  [4648618737,4648832386,'Aquarius'],
  [4648832386,4649051882,'Pisces'],
  [4649051882,4649269553,'Aries'],
  [4649269553,4649480550,'Taurus'],
  [4649480550,4649683355,'Gemini'],
  [4649683355,4649878004,'Cancer'],
  [4649878004,4650065002,'Leo'],
  [4650065002,4650245605,'Virgo'],
  [4650245605,4650422579,'Libra'],
  [4650422579,4650600561,'Scorpio'],
  [4650600561,4650785366,'Sagittarius'],
  [4650785366,4650982137,'Capricorn'],
  [4650982137,4651192264,'Aquarius'],
  [4651192264,4651410796,'Pisces'],
  [4651410796,4651628572,'Aries'],
  [4651628572,4651838366,'Taurus'],
  [4651838366,4652038345,'Gemini'],
  [4652038345,4652230515,'Cancer'],
  [4652230515,4652417623,'Leo'],
  [4652417623,4652601545,'Virgo'],
  [4652601545,4652783574,'Libra'],
  [4652783574,4652965830,'Scorpio'],
  [4652965830,4653152182,'Sagittarius'],
  [4653152182,4653347455,'Capricorn'],
  [4653347455,4653554746,'Aquarius'],
  [4653554746,4653771812,'Pisces'],
  [4653771812,4653990222,'Aries'],
  [4653990222,4654200636,'Taurus'],
  [4654200636,4654399109,'Gemini'],
  [4654399109,4654587720,'Cancer'],
  [4654587720,4654771163,'Leo'],
  [4654771163,4654953608,'Virgo'],
  [4654953608,4655137369,'Libra'],
  [4655137369,4655323528,'Scorpio'],
  [4655323528,4655513634,'Sagittarius'],
  [4655513634,4655710534,'Capricorn'],
  [4655710534,4655917105,'Aquarius'],
  [4655917105,4656133048,'Pisces'],
  [4656133048,4656352233,'Aries'],
  [4656352233,4656564991,'Taurus'],
  [4656564991,4656764816,'Gemini'],
  [4656764816,4656951971,'Cancer'],
  [4656951971,4657131389,'Leo'],
  [4657131389,4657309098,'Virgo'],
  [4657309098,4657489837,'Libra'],
  [4657489837,4657676125,'Scorpio'],
  [4657676125,4657868887,'Sagittarius'],
  [4657868887,4658068788,'Capricorn'],
  [4658068788,4658276729,'Aquarius'],
  [4658276729,4658492500,'Pisces'],
  [4658492500,4658712171,'Aries'],
  [4658712171,4658927781,'Taurus'],
  [4658927781,4659131540,'Gemini'],
  [4659131540,4659320930,'Cancer'],
  [4659320930,4659499249,'Leo'],
  [4659499249,4659672738,'Virgo'],
  [4659672738,4659847908,'Libra'],
  [4659847908,4660029862,'Scorpio'],
  [4660029862,4660221349,'Sagittarius'],
  [4660221349,4660422730,'Capricorn'],
  [4660422730,4660632735,'Aquarius'],
  [4660632735,4660849279,'Pisces'],
  [4660849279,4661068998,'Aries'],
  [4661068998,4661286316,'Taurus'],
  [4661286316,4661494524,'Gemini'],
  [4661494524,4661689174,'Cancer'],
  [4661689174,4661870698,'Leo'],
  [4661870698,4662043692,'Virgo'],
  [4662043692,4662214755,'Libra'],
  [4662214755,4662390686,'Scorpio'],
  [4662390686,4662576960,'Sagittarius'],
  [4662576960,4662776094,'Capricorn'],
  [4662776094,4662986647,'Aquarius'],
  [4662986647,4663204213,'Pisces'],
  [4663204213,4663423799,'Aries'],
  [4663423799,4663640912,'Taurus'],
  [4663640912,4663851337,'Gemini'],
  [4663851337,4664051274,'Cancer'],
  [4664051274,4664238982,'Leo'],
  [4664238982,4664416121,'Virgo'],
  [4664416121,4664587496,'Libra'],
  [4664587496,4664759816,'Scorpio'],
  [4664759816,4664940144,'Sagittarius'],
  [4664940144,4665133849,'Capricorn'],
  [4665133849,4665341872,'Aquarius'],
  [4665341872,4665559462,'Pisces'],
  [4665559462,4665779086,'Aries'],
  [4665779086,4665994937,'Taurus'],
  [4665994937,4666204330,'Gemini'],
  [4666204330,4666406027,'Cancer'],
  [4666406027,4666598890,'Leo'],
  [4666598890,4666782541,'Virgo'],
  [4666782541,4666958807,'Libra'],
  [4666958807,4667132385,'Scorpio'],
  [4667132385,4667309985,'Sagittarius'],
  [4667309985,4667498440,'Capricorn'],
  [4667498440,4667701685,'Aquarius'],
  [4667701685,4667917346,'Pisces'],
  [4667917346,4668137049,'Aries'],
  [4668137049,4668352239,'Taurus'],
  [4668352239,4668559221,'Gemini'],
  [4668559221,4668758553,'Cancer'],
  [4668758553,4668951744,'Leo'],
  [4668951744,4669139384,'Virgo'],
  [4669139384,4669321709,'Libra'],
  [4669321709,4669500532,'Scorpio'],
  [4669500532,4669680284,'Sagittarius'],
  [4669680284,4669867111,'Capricorn'],
  [4669867111,4670066363,'Aquarius'],
  [4670066363,4670278803,'Pisces'],
  [4670278803,4670498058,'Aries'],
  [4670498058,4670714021,'Taurus'],
  [4670714021,4670920132,'Gemini'],
  [4670920132,4671116169,'Cancer'],
  [4671116169,4671305462,'Leo'],
  [4671305462,4671491365,'Virgo'],
  [4671491365,4671675672,'Libra'],
  [4671675672,4671859295,'Scorpio'],
  [4671859295,4672044055,'Sagittarius'],
  [4672044055,4672233567,'Capricorn'],
  [4672233567,4672432202,'Aquarius'],
  [4672432202,4672642244,'Pisces'],
  [4672642244,4672860464,'Aries'],
  [4672860464,4673078020,'Taurus'],
  [4673078020,4673286080,'Gemini'],
  [4673286080,4673481578,'Cancer'],
  [4673481578,4673667177,'Leo'],
  [4673667177,4673847897,'Virgo'],
  [4673847897,4674028361,'Libra'],
  [4674028361,4674211606,'Scorpio'],
  [4674211606,4674399350,'Sagittarius'],
  [4674399350,4674593004,'Capricorn'],
  [4674593004,4674794253,'Aquarius'],
  [4674794253,4675004316,'Pisces'],
  [4675004316,4675221707,'Aries'],
  [4675221707,4675440492,'Taurus'],
  [4675440492,4675652185,'Gemini'],
  [4675652185,4675850949,'Cancer'],
  [4675850949,4676036729,'Leo'],
  [4676036729,4676213888,'Virgo'],
  [4676213888,4676388490,'Libra'],
  [4676388490,4676566308,'Scorpio'],
  [4676566308,4676751584,'Sagittarius'],
  [4676751584,4676946339,'Capricorn'],
  [4676946339,4677150445,'Aquarius'],
  [4677150445,4677362443,'Pisces'],
  [4677362443,4677579987,'Aries'],
  [4677579987,4677799115,'Taurus'],
  [4677799115,4678013795,'Gemini'],
  [4678013795,4678217713,'Cancer'],
  [4678217713,4678407868,'Leo'],
  [4678407868,4678586055,'Virgo'],
  [4678586055,4678757662,'Libra'],
  [4678757662,4678929638,'Scorpio'],
  [4678929638,4679108721,'Sagittarius'],
  [4679108721,4679299667,'Capricorn'],
  [4679299667,4679503430,'Aquarius'],
  [4679503430,4679716948,'Pisces'],
  [4679716948,4679935386,'Aries'],
  [4679935386,4680154335,'Taurus'],
  [4680154335,4680369892,'Gemini'],
  [4680369892,4680577671,'Cancer'],
  [4680577671,4680773731,'Leo'],
  [4680773731,4680956990,'Virgo'],
  [4680956990,4681130420,'Libra'],
  [4681130420,4681300236,'Scorpio'],
  [4681300236,4681474042,'Sagittarius'],
  [4681474042,4681658839,'Capricorn'],
  [4681658839,4681858408,'Aquarius'],
  [4681858408,4682070880,'Pisces'],
  [4682070880,4682289789,'Aries'],
  [4682289789,4682508530,'Taurus'],
  [4682508530,4682723226,'Gemini'],
  [4682723226,4682931697,'Cancer'],
  [4682931697,4683131561,'Leo'],
  [4683131561,4683320734,'Virgo'],
  [4683320734,4683499510,'Libra'],
  [4683499510,4683671816,'Scorpio'],
  [4683671816,4683844368,'Sagittarius'],
  [4683844368,4684024748,'Capricorn'],
  [4684024748,4684218884,'Aquarius'],
  [4684218884,4684427722,'Pisces'],
  [4684427722,4684645688,'Aries'],
  [4684645688,4684864301,'Taurus'],
  [4684864301,4685077795,'Gemini'],
  [4685077795,4685284473,'Cancer'],
  [4685284473,4685484197,'Leo'],
  [4685484197,4685676373,'Virgo'],
  [4685676373,4685860493,'Libra'],
  [4685860493,4686038077,'Scorpio'],
  [4686038077,4686213592,'Sagittarius'],
  [4686213592,4686393508,'Capricorn'],
  [4686393508,4686584206,'Aquarius'],
  [4686584206,4686788885,'Pisces'],
  [4686788885,4687004593,'Aries'],
  [4687004593,4687223036,'Taurus'],
  [4687223036,4687436210,'Gemini'],
  [4687436210,4687640862,'Cancer'],
  [4687640862,4687837704,'Leo'],
  [4687837704,4688028466,'Virgo'],
  [4688028466,4688214281,'Libra'],
  [4688214281,4688396220,'Scorpio'],
  [4688396220,4688576647,'Sagittarius'],
  [4688576647,4688759723,'Capricorn'],
  [4688759723,4688950515,'Aquarius'],
  [4688950515,4689152799,'Pisces'],
  [4689152799,4689366090,'Aries'],
  [4689366090,4689584232,'Taurus'],
  [4689584232,4689798426,'Gemini'],
  [4689798426,4690002878,'Cancer'],
  [4690002878,4690197084,'Leo'],
  [4690197084,4690383866,'Virgo'],
  [4690383866,4690566782,'Libra'],
  [4690566782,4690748804,'Scorpio'],
  [4690748804,4690932303,'Sagittarius'],
  [4690932303,4691119627,'Capricorn'],
  [4691119627,4691313418,'Aquarius'],
  [4691313418,4691516082,'Pisces'],
  [4691516082,4691728072,'Aries'],
  [4691728072,4691945843,'Taurus'],
  [4691945843,4692161945,'Gemini'],
  [4692161945,4692368791,'Cancer'],
  [4692368791,4692563190,'Leo'],
  [4692563190,4692747010,'Virgo'],
  [4692747010,4692925022,'Libra'],
  [4692925022,4693102666,'Scorpio'],
  [4693102666,4693284525,'Sagittarius'],
  [4693284525,4693473471,'Capricorn'],
  [4693473471,4693670561,'Aquarius'],
  [4693670561,4693875672,'Pisces'],
  [4693875672,4694088053,'Aries'],
  [4694088053,4694305563,'Taurus'],
  [4694305563,4694523320,'Gemini'],
  [4694523320,4694734157,'Cancer'],
  [4694734157,4694932337,'Leo'],
  [4694932337,4695117014,'Virgo'],
  [4695117014,4695292149,'Libra'],
  [4695292149,4695464338,'Scorpio'],
  [4695464338,4695640573,'Sagittarius'],
  [4695640573,4695826277,'Capricorn'],
  [4695826277,4696023546,'Aquarius'],
  [4696023546,4696230814,'Pisces'],
  [4696230814,4696444772,'Aries'],
  [4696444772,4696662384,'Taurus'],
  [4696662384,4696880589,'Gemini'],
  [4696880589,4697094598,'Cancer'],
  [4697094598,4697298345,'Leo'],
  [4697298345,4697488055,'Virgo'],
  [4697488055,4697664986,'Libra'],
  [4697664986,4697834905,'Scorpio'],
  [4697834905,4698005689,'Sagittarius'],
  [4698005689,4698185016,'Capricorn'],
  [4698185016,4698377880,'Aquarius'],
  [4698377880,4698584176,'Pisces'],
  [4698584176,4698799197,'Aries'],
  [4698799197,4699017350,'Taurus'],
  [4699017350,4699234994,'Gemini'],
  [4699234994,4699449468,'Cancer'],
  [4699449468,4699656912,'Leo'],
  [4699656912,4699852942,'Virgo'],
  [4699852942,4700035850,'Libra'],
  [4700035850,4700208701,'Scorpio'],
  [4700208701,4700378286,'Sagittarius'],
  [4700378286,4700552749,'Capricorn'],
  [4700552749,4700739212,'Aquarius'],
  [4700739212,4700940758,'Pisces'],
  [4700940758,4701154342,'Aries'],
  [4701154342,4701372832,'Taurus'],
  [4701372832,4701589995,'Gemini'],
  [4701589995,4701802869,'Cancer'],
  [4701802869,4702009911,'Leo'],
  [4702009911,4702208969,'Virgo'],
  [4702208969,4702397943,'Libra'],
  [4702397943,4702577197,'Scorpio'],
  [4702577197,4702750762,'Sagittarius'],
  [4702750762,4702925257,'Capricorn'],
  [4702925257,4703107873,'Aquarius'],
  [4703107873,4703303830,'Pisces'],
  [4703303830,4703513419,'Aries'],
  [4703513419,4703730980,'Taurus'],
  [4703730980,4703948324,'Gemini'],
  [4703948324,4704159905,'Cancer'],
  [4704159905,4704364121,'Leo'],
  [4704364121,4704561240,'Virgo'],
  [4704561240,4704751589,'Libra'],
  [4704751589,4704935667,'Scorpio'],
  [4704935667,4705115323,'Sagittarius'],
  [4705115323,4705294365,'Capricorn'],
  [4705294365,4705478009,'Aquarius'],
  [4705478009,4705671334,'Pisces'],
  [4705671334,4705876892,'Aries'],
  [4705876892,4706092254,'Taurus'],
  [4706092254,4706310028,'Gemini'],
  [4706310028,4706522180,'Cancer'],
  [4706522180,4706724658,'Leo'],
  [4706724658,4706917883,'Virgo'],
  [4706917883,4707104612,'Libra'],
  [4707104612,4707287937,'Scorpio'],
  [4707287937,4707470484,'Sagittarius'],
  [4707470484,4707654541,'Capricorn'],
  [4707654541,4707842572,'Aquarius'],
  [4707842572,4708037427,'Pisces'],
  [4708037427,4708241536,'Aries'],
  [4708241536,4708454855,'Taurus'],
  [4708454855,4708672782,'Gemini'],
  [4708672782,4708887100,'Cancer'],
  [4708887100,4709090876,'Leo'],
  [4709090876,4709282345,'Virgo'],
  [4709282345,4709464584,'Libra'],
  [4709464584,4709642954,'Scorpio'],
  [4709642954,4709822717,'Sagittarius'],
  [4709822717,4710007539,'Capricorn'],
  [4710007539,4710199024,'Aquarius'],
  [4710199024,4710397464,'Pisces'],
  [4710397464,4710603073,'Aries'],
  [4710603073,4710815879,'Taurus'],
  [4710815879,4711033716,'Gemini'],
  [4711033716,4711250440,'Cancer'],
  [4711250440,4711457980,'Leo'],
  [4711457980,4711651567,'Virgo'],
  [4711651567,4711832430,'Libra'],
  [4711832430,4712006284,'Scorpio'],
  [4712006284,4712180329,'Sagittarius'],
  [4712180329,4712360830,'Capricorn'],
  [4712360830,4712551257,'Aquarius'],
  [4712551257,4712751548,'Pisces'],
  [4712751548,4712959602,'Aries'],
  [4712959602,4713173448,'Taurus'],
  [4713173448,4713391312,'Gemini'],
  [4713391312,4713609437,'Cancer'],
  [4713609437,4713821027,'Leo'],
  [4713821027,4714019539,'Virgo'],
  [4714019539,4714203303,'Libra'],
  [4714203303,4714376457,'Scorpio'],
  [4714376457,4714546394,'Sagittarius'],
  [4714546394,4714720960,'Capricorn'],
  [4714720960,4714906196,'Aquarius'],
  [4714906196,4715104230,'Pisces'],
  [4715104230,4715312879,'Aries'],
  [4715312879,4715528013,'Taurus'],
  [4715528013,4715746169,'Gemini'],
  [4715746169,4715964375,'Cancer'],
  [4715964375,4716178115,'Leo'],
  [4716178115,4716381520,'Virgo'],
  [4716381520,4716570886,'Libra'],
  [4716570886,4716747642,'Scorpio'],
  [4716747642,4716917678,'Sagittarius'],
  [4716917678,4717088762,'Capricorn'],
  [4717088762,4717268273,'Aquarius'],
  [4717268273,4717460961,'Pisces'],
  [4717460961,4717666949,'Aries'],
  [4717666949,4717881988,'Taurus'],
  [4717881988,4718100433,'Gemini'],
  [4718100433,4718317991,'Cancer'],
  [4718317991,4718531337,'Leo'],
  [4718531337,4718736829,'Virgo'],
  [4718736829,4718931170,'Libra'],
  [4718931170,4719113781,'Scorpio'],
  [4719113781,4719287986,'Sagittarius'],
  [4719287986,4719459910,'Capricorn'],
  [4719459910,4719636611,'Aquarius'],
  [4719636611,4719824151,'Pisces'],
  [4719824151,4720025377,'Aries'],
  [4720025377,4720238219,'Taurus'],
  [4720238219,4720456463,'Gemini'],
  [4720456463,4720673501,'Cancer'],
  [4720673501,4720885116,'Leo'],
  [4720885116,4721089260,'Virgo'],
  [4721089260,4721284911,'Libra'],
  [4721284911,4721471922,'Scorpio'],
  [4721471922,4721651836,'Sagittarius'],
  [4721651836,4721828259,'Capricorn'],
  [4721828259,4722006362,'Aquarius'],
  [4722006362,4722191766,'Pisces'],
  [4722191766,4722388805,'Aries'],
  [4722388805,4722598218,'Taurus'],
  [4722598218,4722815500,'Gemini'],
  [4722815500,4723032693,'Cancer'],
  [4723032693,4723243180,'Leo'],
  [4723243180,4723444483,'Virgo'],
  [4723444483,4723637513,'Libra'],
  [4723637513,4723824488,'Scorpio'],
  [4723824488,4724007658,'Sagittarius'],
  [4724007658,4724189212,'Capricorn'],
  [4724189212,4724371798,'Aquarius'],
  [4724371798,4724558934,'Pisces'],
  [4724558934,4724754541,'Aries'],
  [4724754541,4724961117,'Taurus'],
  [4724961117,4725176948,'Gemini'],
  [4725176948,4725394939,'Cancer'],
  [4725394939,4725606280,'Leo'],
  [4725606280,4725806146,'Virgo'],
  [4725806146,4725995414,'Libra'],
  [4725995414,4726178369,'Scorpio'],
  [4726178369,4726359753,'Sagittarius'],
  [4726359753,4726542946,'Capricorn'],
  [4726542946,4726729629,'Aquarius'],
  [4726729629,4726920833,'Pisces'],
  [4726920833,4727118253,'Aries'],
  [4727118253,4727324091,'Taurus'],
  [4727324091,4727538701,'Gemini'],
  [4727538701,4727757555,'Cancer'],
  [4727757555,4727971671,'Leo'],
  [4727971671,4728173384,'Virgo'],
  [4728173384,4728361375,'Libra'],
  [4728361375,4728540063,'Scorpio'],
  [4728540063,4728716145,'Sagittarius'],
  [4728716145,4728895652,'Capricorn'],
  [4728895652,4729082061,'Aquarius'],
  [4729082061,4729275953,'Pisces'],
  [4729275953,4729476654,'Aries'],
  [4729476654,4729684079,'Taurus'],
  [4729684079,4729898465,'Gemini'],
  [4729898465,4730117639,'Cancer'],
  [4730117639,4730334777,'Leo'],
  [4730334777,4730541126,'Virgo'],
  [4730541126,4730732190,'Libra'],
  [4730732190,4730910314,'Scorpio'],
  [4730910314,4731082205,'Sagittarius'],
  [4731082205,4731255553,'Capricorn'],
  [4731255553,4731436614,'Aquarius'],
  [4731436614,4731628371,'Pisces'],
  [4731628371,4731830244,'Aries'],
  [4731830244,4732039913,'Taurus'],
  [4732039913,4732255282,'Gemini'],
  [4732255282,4732474315,'Cancer'],
  [4732474315,4732692750,'Leo'],
  [4732692750,4732903573,'Virgo'],
  [4732903573,4733100675,'Libra'],
  [4733100675,4733283162,'Scorpio'],
  [4733283162,4733455633,'Sagittarius'],
  [4733455633,4733625439,'Capricorn'],
  [4733625439,4733800151,'Aquarius'],
  [4733800151,4733985590,'Pisces'],
  [4733985590,4734184035,'Aries'],
  [4734184035,4734393684,'Taurus'],
  [4734393684,4734610218,'Gemini'],
  [4734610218,4734829282,'Cancer'],
  [4734829282,4735047056,'Leo'],
  [4735047056,4735259212,'Virgo'],
  [4735259212,4735461152,'Libra'],
  [4735461152,4735650325,'Scorpio'],
  [4735650325,4735828204,'Sagittarius'],
  [4735828204,4735999829,'Capricorn'],
  [4735999829,4736172020,'Aquarius'],
  [4736172020,4736351644,'Pisces'],
  [4736351644,4736543818,'Aries'],
  [4736543818,4736749798,'Taurus'],
  [4736749798,4736965842,'Gemini'],
  [4736965842,4737185195,'Cancer'],
  [4737185195,4737401884,'Leo'],
  [4737401884,4737612345,'Virgo'],
  [4737612345,4737814718,'Libra'],
  [4737814718,4738007961,'Scorpio'],
  [4738007961,4738192255,'Sagittarius'],
  [4738192255,4738369745,'Capricorn'],
  [4738369745,4738544708,'Aquarius'],
  [4738544708,4738722934,'Pisces'],
  [4738722934,4738910425,'Aries'],
  [4738910425,4739111230,'Taurus'],
  [4739111230,4739324554,'Gemini'],
  [4739324554,4739543768,'Cancer'],
  [4739543768,4739760263,'Leo'],
  [4739760263,4739968644,'Virgo'],
  [4739968644,4740168111,'Libra'],
  [4740168111,4740360301,'Scorpio'],
  [4740360301,4740547063,'Sagittarius'],
  [4740547063,4740729843,'Capricorn'],
  [4740729843,4740910384,'Aquarius'],
  [4740910384,4741091837,'Pisces'],
  [4741091837,4741278928,'Aries'],
  [4741278928,4741476508,'Taurus'],
  [4741476508,4741686529,'Gemini'],
  [4741686529,4741904841,'Cancer'],
  [4741904841,4742122148,'Leo'],
  [4742122148,4742330290,'Virgo'],
  [4742330290,4742527059,'Libra'],
  [4742527059,4742715294,'Scorpio'],
  [4742715294,4742899372,'Sagittarius'],
  [4742899372,4743082661,'Capricorn'],
  [4743082661,4743266839,'Aquarius'],
  [4743266839,4743452984,'Pisces'],
  [4743452984,4743643243,'Aries'],
  [4743643243,4743841103,'Taurus'],
  [4743841103,4744049376,'Gemini'],
  [4744049376,4744266593,'Cancer'],
  [4744266593,4744485133,'Leo'],
  [4744485133,4744695290,'Virgo'],
  [4744695290,4744892143,'Libra'],
  [4744892143,4745077509,'Scorpio'],
  [4745077509,4745256908,'Sagittarius'],
  [4745256908,4745436075,'Capricorn'],
  [4745436075,4745618883,'Aquarius'],
  [4745618883,4745806907,'Pisces'],
  [4745806907,4746000673,'Aries'],
  [4746000673,4746201213,'Taurus'],
  [4746201213,4746410031,'Gemini'],
  [4746410031,4746626761,'Cancer'],
  [4746626761,4746846298,'Leo'],
  [4746846298,4747059653,'Virgo'],
  [4747059653,4747259693,'Libra'],
  [4747259693,4747445715,'Scorpio'],
  [4747445715,4747622427,'Sagittarius'],
  [4747622427,4747796538,'Capricorn'],
  [4747796538,4747974162,'Aquarius'],
  [4747974162,4748159302,'Pisces'],
  [4748159302,4748353425,'Aries'],
  [4748353425,4748556264,'Taurus'],
  [4748556264,4748766954,'Gemini'],
  [4748766954,4748984090,'Cancer'],
  [4748984090,4749204030,'Leo'],
  [4749204030,4749420012,'Virgo'],
  [4749420012,4749624747,'Libra'],
  [4749624747,4749814965,'Scorpio'],
  [4749814965,4749993028,'Sagittarius'],
  [4749993028,4750164850,'Capricorn'],
  [4750164850,4750337351,'Aquarius'],
  [4750337351,4750516706,'Pisces'],
  [4750516706,4750706973,'Aries'],
  [4750706973,4750909112,'Taurus'],
  [4750909112,4751121041,'Gemini'],
  [4751121041,4751339046,'Cancer'],
  [4751339046,4751558897,'Leo'],
  [4751558897,4751775664,'Virgo'],
  [4751775664,4751983970,'Libra'],
  [4751983970,4752179801,'Scorpio'],
  [4752179801,4752362851,'Sagittarius'],
  [4752362851,4752536726,'Capricorn'],
  [4752536726,4752707463,'Aquarius'],
  [4752707463,4752881928,'Pisces'],
  [4752881928,4753066324,'Aries'],
  [4753066324,4753264319,'Taurus'],
  [4753264319,4753475106,'Gemini'],
  [4753475106,4753693528,'Cancer'],
  [4753693528,4753913161,'Leo'],
  [4753913161,4754129018,'Virgo'],
  [4754129018,4754337875,'Libra'],
  [4754337875,4754537402,'Scorpio'],
  [4754537402,4754726368,'Sagittarius'],
  [4754726368,4754905743,'Capricorn'],
  [4754905743,4755079180,'Aquarius'],
  [4755079180,4755252521,'Pisces'],
  [4755252521,4755432570,'Aries'],
  [4755432570,4755625176,'Taurus'],
  [4755625176,4755832324,'Gemini'],
  [4755832324,4756049831,'Cancer'],
  [4756049831,4756269375,'Leo'],
  [4756269375,4756483957,'Virgo'],
  [4756483957,4756690810,'Libra'],
  [4756690810,4756889983,'Scorpio'],
  [4756889983,4757081916,'Sagittarius'],
  [4757081916,4757266855,'Capricorn'],
  [4757266855,4757445947,'Aquarius'],
  [4757445947,4757622535,'Pisces'],
  [4757622535,4757802201,'Aries'],
  [4757802201,4757991304,'Taurus'],
  [4757991304,4758194157,'Gemini'],
  [4758194157,4758409348,'Cancer'],
  [4758409348,4758628849,'Leo'],
  [4758628849,4758843243,'Virgo'],
  [4758843243,4759047966,'Libra'],
  [4759047966,4759243892,'Scorpio'],
  [4759243892,4759433962,'Sagittarius'],
  [4759433962,4759620354,'Capricorn'],
  [4759620354,4759803972,'Aquarius'],
  [4759803972,4759985922,'Pisces'],
  [4759985922,4760169183,'Aries'],
  [4760169183,4760358618,'Taurus'],
  [4760358618,4760559033,'Gemini'],
  [4760559033,4760771600,'Cancer'],
  [4760771600,4760990793,'Leo'],
  [4760990793,4761206559,'Virgo'],
  [4761206559,4761411479,'Libra'],
  [4761411479,4761604831,'Scorpio'],
  [4761604831,4761790489,'Sagittarius'],
  [4761790489,4761973177,'Capricorn'],
  [4761973177,4762156163,'Aquarius'],
  [4762156163,4762340977,'Pisces'],
  [4762340977,4762528792,'Aries'],
  [4762528792,4762721788,'Taurus'],
  [4762721788,4762923008,'Gemini'],
  [4762923008,4763134251,'Cancer'],
  [4763134251,4763352817,'Leo'],
  [4763352817,4763570602,'Virgo'],
  [4763570602,4763778614,'Libra'],
  [4763778614,4763973025,'Scorpio'],
  [4763973025,4764156208,'Sagittarius'],
  [4764156208,4764333705,'Capricorn'],
  [4764333705,4764511276,'Aquarius'],
  [4764511276,4764693222,'Pisces'],
  [4764693222,4764881885,'Aries'],
  [4764881885,4765078171,'Taurus'],
  [4765078171,4765282394,'Gemini'],
  [4765282394,4765494464,'Cancer'],
  [4765494464,4765712593,'Leo'],
  [4765712593,4765931589,'Virgo'],
  [4765931589,4766143709,'Libra'],
  [4766143709,4766342864,'Scorpio'],
  [4766342864,4766528255,'Sagittarius'],
  [4766528255,4766703894,'Capricorn'],
  [4766703894,4766876134,'Aquarius'],
  [4766876134,4767051583,'Pisces'],
  [4767051583,4767235568,'Aries'],
  [4767235568,4767430831,'Taurus'],
  [4767430831,4767636896,'Gemini'],
  [4767636896,4767850944,'Cancer'],
  [4767850944,4768069411,'Leo'],
  [4768069411,4768288348,'Virgo'],
  [4768288348,4768502822,'Libra'],
  [4768502822,4768707384,'Scorpio'],
  [4768707384,4768898717,'Sagittarius'],
  [4768898717,4769077687,'Capricorn'],
  [4769077687,4769249040,'Aquarius'],
  [4769249040,4769419712,'Pisces'],
  [4769419712,4769597012,'Aries'],
  [4769597012,4769786702,'Taurus'],
  [4769786702,4769990570,'Gemini'],
  [4769990570,4770205246,'Cancer'],
  [4770205246,4770424496,'Leo'],
  [4770424496,4770642902,'Virgo'],
  [4770642902,4770857052,'Libra'],
  [4770857052,4771064090,'Scorpio'],
  [4771064090,4771261063,'Sagittarius'],
  [4771261063,4771446454,'Capricorn'],
  [4771446454,4771621978,'Aquarius'],
  [4771621978,4771792863,'Pisces'],
  [4771792863,4771966427,'Aries'],
  [4771966427,4772150074,'Taurus'],
  [4772150074,4772348576,'Gemini'],
  [4772348576,4772560912,'Cancer'],
  [4772560912,4772780165,'Leo'],
  [4772780165,4772998333,'Virgo'],
  [4772998333,4773210938,'Libra'],
  [4773210938,4773416825,'Scorpio'],
  [4773416825,4773615443,'Sagittarius'],
  [4773615443,4773805737,'Capricorn'],
  [4773805737,4773987417,'Aquarius'],
  [4773987417,4774162895,'Pisces'],
  [4774162895,4774337641,'Aries'],
  [4774337641,4774518729,'Taurus'],
  [4774518729,4774712394,'Gemini'],
  [4774712394,4774920572,'Cancer'],
  [4774920572,4775138355,'Leo'],
  [4775138355,4775356581,'Virgo'],
  [4775356581,4775568280,'Libra'],
  [4775568280,4775771659,'Scorpio'],
  [4775771659,4775967961,'Sagittarius'],
  [4775967961,4776158482,'Capricorn'],
  [4776158482,4776343693,'Aquarius'],
  [4776343693,4776524494,'Pisces'],
  [4776524494,4776703801,'Aries'],
  [4776703801,4776886681,'Taurus'],
  [4776886681,4777078823,'Gemini'],
  [4777078823,4777283687,'Cancer'],
  [4777283687,4777499231,'Leo'],
  [4777499231,4777717549,'Virgo'],
  [4777717549,4777929849,'Libra'],
  [4777929849,4778132013,'Scorpio'],
  [4778132013,4778325011,'Sagittarius'],
  [4778325011,4778511981,'Capricorn'],
  [4778511981,4778695802,'Aquarius'],
  [4778695802,4778878484,'Pisces'],
  [4778878484,4779061949,'Aries'],
  [4779061949,4779248947,'Taurus'],
  [4779248947,4779443034,'Gemini'],
  [4779443034,4779647153,'Cancer'],
  [4779647153,4779861047,'Leo'],
  [4779861047,4780079381,'Virgo'],
  [4780079381,4780293582,'Libra'],
  [4780293582,4780497124,'Scorpio'],
  [4780497124,4780688890,'Sagittarius'],
  [4780688890,4780872002,'Capricorn'],
  [4780872002,4781051189,'Aquarius'],
  [4781051189,4781230929,'Pisces'],
  [4781230929,4781414616,'Aries'],
  [4781414616,4781604482,'Taurus'],
  [4781604482,4781801916,'Gemini'],
  [4781801916,4782007702,'Cancer'],
  [4782007702,4782221378,'Leo'],
  [4782221378,4782439694,'Virgo'],
  [4782439694,4782656110,'Libra'],
  [4782656110,4782863246,'Scorpio'],
  [4782863246,4783057231,'Sagittarius'],
  [4783057231,4783239331,'Capricorn'],
  [4783239331,4783414410,'Aquarius'],
  [4783414410,4783588729,'Pisces'],
  [4783588729,4783768171,'Aries'],
  [4783768171,4783956796,'Taurus'],
  [4783956796,4784155840,'Gemini'],
  [4784155840,4784363967,'Cancer'],
  [4784363967,4784578701,'Leo'],
  [4784578701,4784797077,'Virgo'],
  [4784797077,4785014838,'Libra'],
  [4785014838,4785225962,'Scorpio'],
  [4785225962,4785424913,'Sagittarius'],
  [4785424913,4785610069,'Capricorn'],
  [4785610069,4785784601,'Aquarius'],
  [4785784601,4785954922,'Pisces'],
  [4785954922,4786128528,'Aries'],
  [4786128528,4786311996,'Taurus'],
  [4786311996,4786508722,'Gemini'],
  [4786508722,4786717393,'Cancer'],
  [4786717393,4786933380,'Leo'],
  [4786933380,4787151982,'Virgo'],
  [4787151982,4787369725,'Libra'],
  [4787369725,4787582958,'Scorpio'],
  [4787582958,4787786948,'Sagittarius'],
  [4787786948,4787978020,'Capricorn'],
  [4787978020,4788156436,'Aquarius'],
  [4788156436,4788326955,'Pisces'],
  [4788326955,4788497047,'Aries'],
  [4788497047,4788674680,'Taurus'],
  [4788674680,4788865879,'Gemini'],
  [4788865879,4789071749,'Cancer'],
  [4789071749,4789287614,'Leo'],
  [4789287614,4789506489,'Virgo'],
  [4789506489,4789723447,'Libra'],
  [4789723447,4789936060,'Scorpio'],
  [4789936060,4790142022,'Sagittarius'],
  [4790142022,4790338288,'Capricorn'],
  [4790338288,4790523073,'Aquarius'],
  [4790523073,4790698265,'Pisces'],
  [4790698265,4790869517,'Aries'],
  [4790869517,4791044421,'Taurus'],
  [4791044421,4791230248,'Gemini'],
  [4791230248,4791430949,'Cancer'],
  [4791430949,4791644347,'Leo'],
  [4791644347,4791863039,'Virgo'],
  [4791863039,4792079549,'Libra'],
  [4792079549,4792290253,'Scorpio'],
  [4792290253,4792494405,'Sagittarius'],
  [4792494405,4792691530,'Capricorn'],
  [4792691530,4792880706,'Aquarius'],
  [4792880706,4793062105,'Pisces'],
  [4793062105,4793238593,'Aries'],
  [4793238593,4793415601,'Taurus'],
  [4793415601,4793599635,'Gemini'],
  [4793599635,4793795924,'Cancer'],
  [4793795924,4794005384,'Leo'],
  [4794005384,4794222880,'Virgo'],
  [4794222880,4794439808,'Libra'],
  [4794439808,4794649726,'Scorpio'],
  [4794649726,4794850920,'Sagittarius'],
  [4794850920,4795044673,'Capricorn'],
  [4795044673,4795232841,'Aquarius'],
  [4795232841,4795416945,'Pisces'],
  [4795416945,4795598739,'Aries'],
  [4795598739,4795781024,'Taurus'],
  [4795781024,4795967765,'Gemini'],
  [4795967765,4796163164,'Cancer'],
  [4796163164,4796369615,'Leo'],
  [4796369615,4796585186,'Virgo'],
  [4796585186,4796802910,'Libra'],
  [4796802910,4797014373,'Scorpio'],
  [4797014373,4797214909,'Sagittarius'],
  [4797214909,4797405016,'Capricorn'],
  [4797405016,4797588346,'Aquarius'],
  [4797588346,4797769299,'Pisces'],
  [4797769299,4797951540,'Aries'],
  [4797951540,4798137533,'Taurus'],
  [4798137533,4798328885,'Gemini'],
  [4798328885,4798527027,'Cancer'],
  [4798527027,4798733279,'Leo'],
  [4798733279,4798947426,'Virgo'],
  [4798947426,4799165563,'Libra'],
  [4799165563,4799380008,'Scorpio'],
  [4799380008,4799583440,'Sagittarius'],
  [4799583440,4799773455,'Capricorn'],
  [4799773455,4799953055,'Aquarius'],
  [4799953055,4800128270,'Pisces'],
  [4800128270,4800305525,'Aries'],
  [4800305525,4800489684,'Taurus'],
  [4800489684,4800682796,'Gemini'],
  [4800682796,4800884300,'Cancer'],
  [4800884300,4801092759,'Leo'],
  [4801092759,4801307019,'Virgo'],
  [4801307019,4801525080,'Libra'],
  [4801525080,4801741935,'Scorpio'],
  [4801741935,4801950127,'Sagittarius'],
  [4801950127,4802144270,'Capricorn'],
  [4802144270,4802324650,'Aquarius'],
  [4802324650,4802496691,'Pisces'],
  [4802496691,4802668073,'Aries'],
  [4802668073,4802846149,'Taurus'],
  [4802846149,4803035704,'Gemini'],
  [4803035704,4803237224,'Cancer'],
  [4803237224,4803447624,'Leo'],
  [4803447624,4803663170,'Virgo'],
  [4803663170,4803881183,'Libra'],
  [4803881183,4804098684,'Scorpio'],
  [4804098684,4804310411,'Sagittarius'],
  [4804310411,4804510309,'Capricorn'],
  [4804510309,4804695703,'Aquarius'],
  [4804695703,4804869520,'Pisces'],
  [4804869520,4805038696,'Aries'],
  [4805038696,4805211384,'Taurus'],
  [4805211384,4805394614,'Gemini'],
  [4805394614,4805591795,'Cancer'],
  [4805591795,4805801171,'Leo'],
  [4805801171,4806017502,'Virgo'],
  [4806017502,4806235739,'Libra'],
  [4806235739,4806452587,'Scorpio'],
  [4806452587,4806664888,'Sagittarius'],
  [4806664888,4806868438,'Capricorn'],
  [4806868438,4807059761,'Aquarius'],
  [4807059761,4807239055,'Pisces'],
  [4807239055,4807410888,'Aries'],
  [4807410888,4807582395,'Taurus'],
  [4807582395,4807761055,'Gemini'],
  [4807761055,4807952435,'Cancer'],
  [4807952435,4808157741,'Leo'],
  [4808157741,4808372938,'Virgo'],
  [4808372938,4808591282,'Libra'],
  [4808591282,4808807329,'Scorpio'],
  [4808807329,4809018033,'Sagittarius'],
  [4809018033,4809221399,'Capricorn'],
  [4809221399,4809415685,'Aquarius'],
  [4809415685,4809600420,'Pisces'],
  [4809600420,4809777765,'Aries'],
  [4809777765,4809952492,'Taurus'],
  [4809952492,4810130787,'Gemini'],
  [4810130787,4810318552,'Cancer'],
  [4810318552,4810519222,'Leo'],
  [4810519222,4810731574,'Virgo'],
  [4810731574,4810949478,'Libra'],
  [4810949478,4811165380,'Scorpio'],
  [4811165380,4811374381,'Sagittarius'],
  [4811374381,4811575046,'Capricorn'],
  [4811575046,4811767972,'Aquarius'],
  [4811767972,4811954447,'Pisces'],
  [4811954447,4812136273,'Aries'],
  [4812136273,4812316140,'Taurus'],
  [4812316140,4812497817,'Gemini'],
  [4812497817,4812685757,'Cancer'],
  [4812685757,4812883847,'Leo'],
  [4812883847,4813093237,'Virgo'],
  [4813093237,4813310198,'Libra'],
  [4813310198,4813526824,'Scorpio'],
  [4813526824,4813735727,'Sagittarius'],
  [4813735727,4813933997,'Capricorn'],
  [4813933997,4814123176,'Aquarius'],
  [4814123176,4814306934,'Pisces'],
  [4814306934,4814488964,'Aries'],
  [4814488964,4814672030,'Taurus'],
  [4814672030,4814858118,'Gemini'],
  [4814858118,4815049223,'Cancer'],
  [4815049223,4815247792,'Leo'],
  [4815247792,4815455696,'Virgo'],
  [4815455696,4815671697,'Libra'],
  [4815671697,4815889572,'Scorpio'],
  [4815889572,4816100531,'Sagittarius'],
  [4816100531,4816298992,'Capricorn'],
  [4816298992,4816485417,'Aquarius'],
  [4816485417,4816664594,'Pisces'],
  [4816664594,4816842539,'Aries'],
  [4816842539,4817024152,'Taurus'],
  [4817024152,4817211976,'Gemini'],
  [4817211976,4817406488,'Cancer'],
  [4817406488,4817607696,'Leo'],
  [4817607696,4817816164,'Virgo'],
  [4817816164,4818031735,'Libra'],
  [4818031735,4818250683,'Scorpio'],
  [4818250683,4818464996,'Sagittarius'],
  [4818464996,4818666846,'Capricorn'],
  [4818666846,4818854036,'Aquarius'],
  [4818854036,4819030524,'Pisces'],
  [4819030524,4819203359,'Aries'],
  [4819203359,4819379669,'Taurus'],
  [4819379669,4819564457,'Gemini'],
  [4819564457,4819759236,'Cancer'],
  [4819759236,4819962720,'Leo'],
  [4819962720,4820173062,'Virgo'],
  [4820173062,4820389007,'Libra'],
  [4820389007,4820608319,'Scorpio'],
  [4820608319,4820825358,'Sagittarius'],
  [4820825358,4821032261,'Capricorn'],
  [4821032261,4821224100,'Aquarius'],
  [4821224100,4821402244,'Pisces'],
  [4821402244,4821572899,'Aries'],
  [4821572899,4821743953,'Taurus'],
  [4821743953,4821922562,'Gemini'],
  [4821922562,4822113051,'Cancer'],
  [4822113051,4822315586,'Leo'],
  [4822315586,4822527151,'Virgo'],
  [4822527151,4822744022,'Libra'],
  [4822744022,4822963140,'Scorpio'],
  [4822963140,4823180748,'Sagittarius'],
  [4823180748,4823391224,'Capricorn'],
  [4823391224,4823589152,'Aquarius'],
  [4823589152,4823773032,'Pisces'],
  [4823773032,4823946459,'Aries'],
  [4823946459,4824116203,'Taurus'],
  [4824116203,4824289849,'Gemini'],
  [4824289849,4824473862,'Cancer'],
  [4824473862,4824671522,'Leo'],
  [4824671522,4824881526,'Virgo'],
  [4824881526,4825098857,'Libra'],
  [4825098857,4825317860,'Scorpio'],
  [4825317860,4825534278,'Sagittarius'],
  [4825534278,4825744711,'Capricorn'],
  [4825744711,4825945982,'Aquarius'],
  [4825945982,4826136108,'Pisces'],
  [4826136108,4826315961,'Aries'],
  [4826315961,4826489546,'Taurus'],
  [4826489546,4826662920,'Gemini'],
  [4826662920,4826842713,'Cancer'],
  [4826842713,4827034390,'Leo'],
  [4827034390,4827239934,'Virgo'],
  [4827239934,4827455979,'Libra'],
  [4827455979,4827675131,'Scorpio'],
  [4827675131,4827890475,'Sagittarius'],
  [4827890475,4828098451,'Capricorn'],
  [4828098451,4828298338,'Aquarius'],
  [4828298338,4828490508,'Pisces'],
  [4828490508,4828675765,'Aries'],
  [4828675765,4828855765,'Taurus'],
  [4828855765,4829033649,'Gemini'],
  [4829033649,4829214145,'Cancer'],
  [4829214145,4829402720,'Leo'],
  [4829402720,4829603592,'Virgo'],
  [4829603592,4829816666,'Libra'],
  [4829816666,4830035677,'Scorpio'],
  [4830035677,4830251386,'Sagittarius'],
  [4830251386,4830457668,'Capricorn'],
  [4830457668,4830653939,'Aquarius'],
  [4830653939,4830843047,'Pisces'],
  [4830843047,4831028308,'Aries'],
  [4831028308,4831211974,'Taurus'],
  [4831211974,4831395414,'Gemini'],
  [4831395414,4831580461,'Cancer'],
  [4831580461,4831770441,'Leo'],
  [4831770441,4831969471,'Virgo'],
  [4831969471,4832179745,'Libra'],
  [4832179745,4832398000,'Scorpio'],
  [4832398000,4832615249,'Sagittarius'],
  [4832615249,4832822571,'Capricorn'],
  [4832822571,4833017064,'Aquarius'],
  [4833017064,4833201858,'Pisces'],
  [4833201858,4833382535,'Aries'],
  [4833382535,4833563991,'Taurus'],
  [4833563991,4833748888,'Gemini'],
  [4833748888,4833937976,'Cancer'],
  [4833937976,4834131923,'Leo'],
  [4834131923,4834332606,'Virgo'],
  [4834332606,4834542110,'Libra'],
  [4834542110,4834759534,'Scorpio'],
  [4834759534,4834978348,'Sagittarius'],
  [4834978348,4835188943,'Capricorn'],
  [4835188943,4835385412,'Aquarius'],
  [4835385412,4835568866,'Pisces'],
  [4835568866,4835745106,'Aries'],
  [4835745106,4835920966,'Taurus'],
  [4835920966,4836101817,'Gemini'],
  [4836101817,4836290272,'Cancer'],
  [4836290272,4836486558,'Leo'],
  [4836486558,4836690191,'Virgo'],
  [4836690191,4836901063,'Libra'],
  [4836901063,4837118352,'Scorpio'],
  [4837118352,4837337923,'Sagittarius'],
  [4837337923,4837551937,'Capricorn'],
  [4837551937,4837753067,'Aquarius'],
  [4837753067,4837939464,'Pisces'],
  [4837939464,4838115111,'Aries'],
  [4838115111,4838286863,'Taurus'],
  [4838286863,4838461716,'Gemini'],
  [4838461716,4838644996,'Cancer'],
  [4838644996,4838839157,'Leo'],
  [4838839157,4839043707,'Virgo'],
  [4839043707,4839256358,'Libra'],
  [4839256358,4839474290,'Scorpio'],
  [4839474290,4839693830,'Sagittarius'],
  [4839693830,4839909511,'Capricorn'],
  [4839909511,4840115139,'Aquarius'],
  [4840115139,4840307065,'Pisces'],
  [4840307065,4840486462,'Aries'],
  [4840486462,4840658416,'Taurus'],
  [4840658416,4840829733,'Gemini'],
  [4840829733,4841007158,'Cancer'],
  [4841007158,4841195819,'Leo'],
  [4841195819,4841397608,'Virgo'],
  [4841397608,4841610311,'Libra'],
  [4841610311,4841828918,'Scorpio'],
  [4841828918,4842048121,'Sagittarius'],
  [4842048121,4842263370,'Capricorn'],
  [4842263370,4842470814,'Aquarius'],
  [4842470814,4842667507,'Pisces'],
  [4842667507,4842852772,'Aries'],
  [4842852772,4843029011,'Taurus'],
  [4843029011,4843201211,'Gemini'],
  [4843201211,4843375784,'Cancer'],
  [4843375784,4843559176,'Leo'],
  [4843559176,4843755923,'Virgo'],
  [4843755923,4843966131,'Libra'],
  [4843966131,4844184522,'Scorpio'],
  [4844184522,4844403493,'Sagittarius'],
  [4844403493,4844617326,'Capricorn'],
  [4844617326,4844823537,'Aquarius'],
  [4844823537,4845021481,'Pisces'],
  [4845021481,4845211068,'Aries'],
  [4845211068,4845393025,'Taurus'],
  [4845393025,4845569744,'Gemini'],
  [4845569744,4845745735,'Cancer'],
  [4845745735,4845927021,'Leo'],
  [4845927021,4846119448,'Virgo'],
  [4846119448,4846325791,'Libra'],
  [4846325791,4846542736,'Scorpio'],
  [4846542736,4846761727,'Sagittarius'],
  [4846761727,4846974682,'Capricorn'],
  [4846974682,4847178438,'Aquarius'],
  [4847178438,4847374053,'Pisces'],
  [4847374053,4847563733,'Aries'],
  [4847563733,4847748982,'Taurus'],
  [4847748982,4847930826,'Gemini'],
  [4847930826,4848111285,'Cancer'],
  [4848111285,4848294380,'Leo'],
  [4848294380,4848485457,'Virgo'],
  [4848485457,4848688733,'Libra'],
  [4848688733,4848903599,'Scorpio'],
  [4848903599,4849122759,'Sagittarius'],
  [4849122759,4849336363,'Capricorn'],
  [4849336363,4849538917,'Aquarius'],
  [4849538917,4849731211,'Pisces'],
  [4849731211,4849917286,'Aries'],
  [4849917286,4850101046,'Taurus'],
  [4850101046,4850284696,'Gemini'],
  [4850284696,4850469303,'Cancer'],
  [4850469303,4850656534,'Leo'],
  [4850656534,4850849602,'Virgo'],
  [4850849602,4851052207,'Libra'],
  [4851052207,4851265484,'Scorpio'],
  [4851265484,4851484745,'Sagittarius'],
  [4851484745,4851700446,'Capricorn'],
  [4851700446,4851904602,'Aquarius'],
  [4851904602,4852095777,'Pisces'],
  [4852095777,4852277941,'Aries'],
  [4852277941,4852456814,'Taurus'],
  [4852456814,4852637191,'Gemini'],
  [4852637191,4852821827,'Cancer'],
  [4852821827,4853011931,'Leo'],
  [4853011931,4853208502,'Virgo'],
  [4853208502,4853412951,'Libra'],
  [4853412951,4853626040,'Scorpio'],
  [4853626040,4853845213,'Sagittarius'],
  [4853845213,4854063237,'Capricorn'],
  [4854063237,4854271443,'Aquarius'],
  [4854271443,4854465422,'Pisces'],
  [4854465422,4854646990,'Aries'],
  [4854646990,4854821758,'Taurus'],
  [4854821758,4854996223,'Gemini'],
  [4854996223,4855175902,'Cancer'],
  [4855175902,4855364224,'Leo'],
  [4855364224,4855562260,'Virgo'],
  [4855562260,4855769283,'Libra'],
  [4855769283,4855983657,'Scorpio'],
  [4855983657,4856202774,'Sagittarius'],
  [4856202774,4856421868,'Capricorn'],
  [4856421868,4856634169,'Aquarius'],
  [4856634169,4856833844,'Pisces'],
  [4856833844,4857019510,'Aries'],
  [4857019510,4857194574,'Taurus'],
  [4857194574,4857365248,'Gemini'],
  [4857365248,4857538554,'Cancer'],
  [4857538554,4857720735,'Leo'],
  [4857720735,4857915547,'Virgo'],
  [4857915547,4858122781,'Libra'],
  [4858122781,4858338625,'Scorpio'],
  [4858338625,4858558092,'Sagittarius'],
  [4858558092,4858776762,'Capricorn'],
  [4858776762,4858990541,'Aquarius'],
  [4858990541,4859195142,'Pisces'],
  [4859195142,4859387497,'Aries'],
  [4859387497,4859567771,'Taurus'],
  [4859567771,4859739839,'Gemini'],
  [4859739839,4859910197,'Cancer'],
  [4859910197,4860086303,'Leo'],
  [4860086303,4860274654,'Virgo'],
  [4860274654,4860478049,'Libra'],
  [4860478049,4860693369,'Scorpio'],
  [4860693369,4860913305,'Sagittarius'],
  [4860913305,4861131215,'Capricorn'],
  [4861131215,4861343699,'Aquarius'],
  [4861343699,4861549202,'Pisces'],
  [4861549202,4861746116,'Aries'],
  [4861746116,4861933148,'Taurus'],
  [4861933148,4862111072,'Gemini'],
  [4862111072,4862283908,'Cancer'],
  [4862283908,4862458261,'Leo'],
  [4862458261,4862641515,'Virgo'],
  [4862641515,4862839144,'Libra'],
  [4862839144,4863051126,'Scorpio'],
  [4863051126,4863270600,'Sagittarius'],
  [4863270600,4863488386,'Capricorn'],
  [4863488386,4863699105,'Aquarius'],
  [4863699105,4863902135,'Pisces'],
  [4863902135,4864098543,'Aries'],
  [4864098543,4864288705,'Taurus'],
  [4864288705,4864472493,'Gemini'],
  [4864472493,4864651181,'Cancer'],
  [4864651181,4864828798,'Leo'],
  [4864828798,4865011496,'Virgo'],
  [4865011496,4865205399,'Libra'],
  [4865205399,4865413191,'Scorpio'],
  [4865413191,4865630867,'Sagittarius'],
  [4865630867,4865849032,'Capricorn'],
  [4865849032,4866059560,'Aquarius'],
  [4866059560,4866260156,'Pisces'],
  [4866260156,4866452914,'Aries'],
  [4866452914,4866640807,'Taurus'],
  [4866640807,4866825706,'Gemini'],
  [4866825706,4867008659,'Cancer'],
  [4867008659,4867191467,'Leo'],
  [4867191467,4867377668,'Virgo'],
  [4867377668,4867571865,'Libra'],
  [4867571865,4867777381,'Scorpio'],
  [4867777381,4867992971,'Sagittarius'],
  [4867992971,4868211470,'Capricorn'],
  [4868211470,4868423662,'Aquarius'],
  [4868423662,4868624427,'Pisces'],
  [4868624427,4868814485,'Aries'],
  [4868814485,4868997828,'Taurus'],
  [4868997828,4869178840,'Gemini'],
  [4869178840,4869360844,'Cancer'],
  [4869360844,4869546055,'Leo'],
  [4869546055,4869736318,'Virgo'],
  [4869736318,4869933652,'Libra'],
  [4869933652,4870139804,'Scorpio'],
  [4870139804,4870354407,'Sagittarius'],
  [4870354407,4870572992,'Capricorn'],
  [4870572992,4870787663,'Aquarius'],
  [4870787663,4870991415,'Pisces'],
  [4870991415,4871182223,'Aries'],
  [4871182223,4871362941,'Taurus'],
  [4871362941,4871538921,'Gemini'],
  [4871538921,4871715866,'Cancer'],
  [4871715866,4871898430,'Leo'],
  [4871898430,4872089398,'Virgo'],
  [4872089398,4872289490,'Libra'],
  [4872289490,4872497946,'Scorpio'],
  [4872497946,4872713064,'Sagittarius'],
  [4872713064,4872931633,'Capricorn'],
  [4872931633,4873148214,'Aquarius'],
  [4873148214,4873356154,'Pisces'],
  [4873356154,4873551041,'Aries'],
  [4873551041,4873733140,'Taurus'],
  [4873733140,4873906838,'Gemini'],
  [4873906838,4874078705,'Cancer'],
  [4874078705,4874255575,'Leo'],
  [4874255575,4874442770,'Virgo'],
  [4874442770,4874642310,'Libra'],
  [4874642310,4874852296,'Scorpio'],
  [4874852296,4875068651,'Sagittarius'],
  [4875068651,4875287288,'Capricorn'],
  [4875287288,4875504388,'Aquarius'],
  [4875504388,4875715396,'Pisces'],
  [4875715396,4875915533,'Aries'],
  [4875915533,4876102483,'Taurus'],
  [4876102483,4876278190,'Gemini'],
  [4876278190,4876448339,'Cancer'],
  [4876448339,4876620450,'Leo'],
  [4876620450,4876801834,'Virgo'],
  [4876801834,4876997151,'Libra'],
  [4876997151,4877205920,'Scorpio'],
  [4877205920,4877422846,'Sagittarius'],
  [4877422846,4877641640,'Capricorn'],
  [4877641640,4877858101,'Aquarius'],
  [4877858101,4878069586,'Pisces'],
  [4878069586,4878273114,'Aries'],
  [4878273114,4878465706,'Taurus'],
  [4878465706,4878646734,'Gemini'],
  [4878646734,4878819531,'Cancer'],
  [4878819531,4878990644,'Leo'],
  [4878990644,4879167841,'Virgo'],
  [4879167841,4879357724,'Libra'],
  [4879357724,4879562563,'Scorpio'],
  [4879562563,4879778301,'Sagittarius'],
  [4879778301,4879997110,'Capricorn'],
  [4879997110,4880212728,'Aquarius'],
  [4880212728,4880422606,'Pisces'],
  [4880422606,4880625902,'Aries'],
  [4880625902,4880821375,'Taurus'],
  [4880821375,4881007809,'Gemini'],
  [4881007809,4881186117,'Cancer'],
  [4881186117,4881360478,'Leo'],
  [4881360478,4881537433,'Virgo'],
  [4881537433,4881723875,'Libra'],
  [4881723875,4881924179,'Scorpio'],
  [4881924179,4882137077,'Sagittarius'],
  [4882137077,4882355444,'Capricorn'],
  [4882355444,4882570949,'Aquarius'],
  [4882570949,4882779121,'Pisces'],
  [4882779121,4882979617,'Aries'],
  [4882979617,4883173545,'Taurus'],
  [4883173545,4883361619,'Gemini'],
  [4883361619,4883544500,'Cancer'],
  [4883544500,4883724221,'Leo'],
  [4883724221,4883904836,'Virgo'],
  [4883904836,4884091681,'Libra'],
  [4884091681,4884289436,'Scorpio'],
  [4884289436,4884499251,'Sagittarius'],
  [4884499251,4884716619,'Capricorn'],
  [4884716619,4884933030,'Aquarius'],
  [4884933030,4885141371,'Pisces'],
  [4885141371,4885339545,'Aries'],
  [4885339545,4885529434,'Taurus'],
  [4885529434,4885714270,'Gemini'],
  [4885714270,4885896971,'Cancer'],
  [4885896971,4886079867,'Leo'],
  [4886079867,4886265234,'Virgo'],
  [4886265234,4886455761,'Libra'],
  [4886455761,4886654321,'Scorpio'],
  [4886654321,4886862587,'Sagittarius'],
  [4886862587,4887078770,'Capricorn'],
  [4887078770,4887296503,'Aquarius'],
  [4887296503,4887507454,'Pisces'],
  [4887507454,4887706472,'Aries'],
  [4887706472,4887893838,'Taurus'],
  [4887893838,4888073666,'Gemini'],
  [4888073666,4888251415,'Cancer'],
  [4888251415,4888432009,'Leo'],
  [4888432009,4888618715,'Virgo'],
  [4888618715,4888812882,'Libra'],
  [4888812882,4889014635,'Scorpio'],
  [4889014635,4889223772,'Sagittarius'],
  [4889223772,4889439347,'Capricorn'],
  [4889439347,4889657859,'Aquarius'],
  [4889657859,4889872417,'Pisces'],
  [4889872417,4890075770,'Aries'],
  [4890075770,4890264965,'Taurus'],
  [4890264965,4890442631,'Gemini'],
  [4890442631,4890615016,'Cancer'],
  [4890615016,4890789371,'Leo'],
  [4890789371,4890971804,'Virgo'],
  [4890971804,4891165373,'Libra'],
  [4891165373,4891369320,'Scorpio'],
  [4891369320,4891580716,'Sagittarius'],
  [4891580716,4891796833,'Capricorn'],
  [4891796833,4892015317,'Aquarius'],
  [4892015317,4892232100,'Pisces'],
  [4892232100,4892440704,'Aries'],
  [4892440704,4892635618,'Taurus'],
  [4892635618,4892816253,'Gemini'],
  [4892816253,4892987410,'Cancer'],
  [4892987410,4893156802,'Leo'],
  [4893156802,4893332475,'Virgo'],
  [4893332475,4893520470,'Libra'],
  [4893520470,4893722309,'Scorpio'],
  [4893722309,4893934541,'Sagittarius'],
  [4893934541,4894151793,'Capricorn'],
  [4894151793,4894370101,'Aquarius'],
  [4894370101,4894586790,'Pisces'],
  [4894586790,4894798049,'Aries'],
  [4894798049,4894998804,'Taurus'],
  [4894998804,4895185926,'Gemini'],
  [4895185926,4895361137,'Cancer'],
  [4895361137,4895530562,'Leo'],
  [4895530562,4895702239,'Virgo'],
  [4895702239,4895883785,'Libra'],
  [4895883785,4896079787,'Scorpio'],
  [4896079787,4896289344,'Sagittarius'],
  [4896289344,4896506632,'Capricorn'],
  [4896506632,4896725051,'Aquarius'],
  [4896725051,4896940579,'Pisces'],
  [4896940579,4897150979,'Aries'],
  [4897150979,4897353729,'Taurus'],
  [4897353729,4897546198,'Gemini'],
  [4897546198,4897727925,'Cancer'],
  [4897727925,4897902149,'Leo'],
  [4897902149,4898075029,'Virgo'],
  [4898075029,4898253735,'Libra'],
  [4898253735,4898444278,'Scorpio'],
  [4898444278,4898648859,'Sagittarius'],
  [4898648859,4898864057,'Capricorn'],
  [4898864057,4899082445,'Aquarius'],
  [4899082445,4899297349,'Pisces'],
  [4899297349,4899505535,'Aries'],
  [4899505535,4899706214,'Taurus'],
  [4899706214,4899899290,'Gemini'],
  [4899899290,4900085062,'Cancer'],
  [4900085062,4900265129,'Leo'],
  [4900265129,4900442979,'Virgo'],
  [4900442979,4900623622,'Libra'],
  [4900623622,4900812386,'Scorpio'],
  [4900812386,4901012957,'Sagittarius'],
  [4901012957,4901224957,'Capricorn'],
  [4901224957,4901442739,'Aquarius'],
  [4901442739,4901658111,'Pisces'],
  [4901658111,4901865266,'Aries'],
  [4901865266,4902062828,'Taurus'],
  [4902062828,4902252561,'Gemini'],
  [4902252561,4902437281,'Cancer'],
  [4902437281,4902619683,'Leo'],
  [4902619683,4902802195,'Virgo'],
  [4902802195,4902987385,'Libra'],
  [4902987385,4903178286,'Scorpio'],
  [4903178286,4903377930,'Sagittarius'],
  [4903377930,4903587604,'Capricorn'],
  [4903587604,4903804458,'Aquarius'],
  [4903804458,4904021083,'Pisces'],
  [4904021083,4904229474,'Aries'],
  [4904229474,4904425907,'Taurus'],
  [4904425907,4904611945,'Gemini'],
  [4904611945,4904792264,'Cancer'],
  [4904792264,4904972013,'Leo'],
  [4904972013,4905155089,'Virgo'],
  [4905155089,4905343524,'Libra'],
  [4905343524,4905538124,'Scorpio'],
  [4905538124,4905739673,'Sagittarius'],
  [4905739673,4905949031,'Capricorn'],
  [4905949031,4906165242,'Aquarius'],
  [4906165242,4906383213,'Pisces'],
  [4906383213,4906594629,'Aries'],
  [4906594629,4906793127,'Taurus'],
  [4906793127,4906978242,'Gemini'],
  [4906978242,4907154682,'Cancer'],
  [4907154682,4907329290,'Leo'],
  [4907329290,4907508367,'Virgo'],
  [4907508367,4907695784,'Libra'],
  [4907695784,4907892222,'Scorpio'],
  [4907892222,4908096416,'Sagittarius'],
  [4908096416,4908307144,'Capricorn'],
  [4908307144,4908523385,'Aquarius'],
  [4908523385,4908742135,'Pisces'],
  [4908742135,4908956771,'Aries'],
  [4908956771,4909159727,'Taurus'],
  [4909159727,4909347741,'Gemini'],
  [4909347741,4909523759,'Cancer'],
  [4909523759,4909694655,'Leo'],
  [4909694655,4909868180,'Virgo'],
  [4909868180,4910050634,'Libra'],
  [4910050634,4910244854,'Scorpio'],
  [4910244854,4910449708,'Sagittarius'],
  [4910449708,4910662012,'Capricorn'],
  [4910662012,4910878863,'Aquarius'],
  [4910878863,4911097639,'Pisces'],
  [4911097639,4911313932,'Aries'],
  [4911313932,4911521317,'Taurus'],
  [4911521317,4911714814,'Gemini'],
  [4911714814,4911894576,'Cancer'],
  [4911894576,4912065785,'Leo'],
  [4912065785,4912236022,'Virgo'],
  [4912236022,4912412844,'Libra'],
  [4912412844,4912601638,'Scorpio'],
  [4912601638,4912803652,'Sagittarius'],
  [4912803652,4913015882,'Capricorn'],
  [4913015882,4913233351,'Aquarius'],
  [4913233351,4913451776,'Pisces'],
  [4913451776,4913667601,'Aries'],
  [4913667601,4913876743,'Taurus'],
  [4913876743,4914075082,'Gemini'],
  [4914075082,4914260917,'Cancer'],
  [4914260917,4914436672,'Leo'],
  [4914436672,4914608069,'Virgo'],
  [4914608069,4914782202,'Libra'],
  [4914782202,4914965662,'Scorpio'],
  [4914965662,4915162440,'Sagittarius'],
  [4915162440,4915371999,'Capricorn'],
  [4915371999,4915589243,'Aquarius'],
  [4915589243,4915807506,'Pisces'],
  [4915807506,4916021840,'Aries'],
  [4916021840,4916229477,'Taurus'],
  [4916229477,4916428819,'Gemini'],
  [4916428819,4916619051,'Cancer'],
  [4916619051,4916800941,'Leo'],
  [4916800941,4916977470,'Virgo'],
  [4916977470,4917153550,'Libra'],
  [4917153550,4917335056,'Scorpio'],
  [4917335056,4917527270,'Sagittarius'],
  [4917527270,4917732586,'Capricorn'],
  [4917732586,4917948226,'Aquarius'],
  [4917948226,4918166708,'Pisces'],
  [4918166708,4918380368,'Aries'],
  [4918380368,4918585362,'Taurus'],
  [4918585362,4918781776,'Gemini'],
  [4918781776,4918971482,'Cancer'],
  [4918971482,4919156460,'Leo'],
  [4919156460,4919338501,'Virgo'],
  [4919338501,4919519836,'Libra'],
  [4919519836,4919703855,'Scorpio'],
  [4919703855,4919894954,'Sagittarius'],
  [4919894954,4920096958,'Capricorn'],
  [4920096958,4920310147,'Aquarius'],
  [4920310147,4920528844,'Pisces'],
  [4920528844,4920743683,'Aries'],
  [4920743683,4920947914,'Taurus'],
  [4920947914,4921140847,'Gemini'],
  [4921140847,4921326159,'Cancer'],
  [4921326159,4921508591,'Leo'],
  [4921508591,4921691688,'Virgo'],
  [4921691688,4921877170,'Libra'],
  [4921877170,4922065951,'Scorpio'],
  [4922065951,4922259766,'Sagittarius'],
  [4922259766,4922461447,'Capricorn'],
  [4922461447,4922672858,'Aquarius'],
  [4922672858,4922891364,'Pisces'],
  [4922891364,4923108593,'Aries'],
  [4923108593,4923315308,'Taurus'],
  [4923315308,4923507931,'Gemini'],
  [4923507931,4923689533,'Cancer'],
  [4923689533,4923866468,'Leo'],
  [4923866468,4924045007,'Virgo'],
  [4924045007,4924229206,'Libra'],
  [4924229206,4924420242,'Scorpio'],
  [4924420242,4924617765,'Sagittarius'],
  [4924617765,4924821897,'Capricorn'],
  [4924821897,4925033466,'Aquarius'],
  [4925033466,4925251609,'Pisces'],
  [4925251609,4925470777,'Aries'],
  [4925470777,4925681868,'Taurus'],
  [4925681868,4925878358,'Gemini'],
  [4925878358,4926060579,'Cancer'],
  [4926060579,4926234240,'Leo'],
  [4926234240,4926406838,'Virgo'],
  [4926406838,4926585008,'Libra'],
  [4926585008,4926772720,'Scorpio'],
  [4926772720,4926970598,'Sagittarius'],
  [4926970598,4927177103,'Capricorn'],
  [4927177103,4927390381,'Aquarius'],
  [4927390381,4927608649,'Pisces'],
  [4927608649,4927828319,'Aries'],
  [4927828319,4928042758,'Taurus'],
  [4928042758,4928244951,'Gemini'],
  [4928244951,4928432203,'Cancer'],
  [4928432203,4928607618,'Leo'],
  [4928607618,4928777829,'Virgo'],
  [4928777829,4928950287,'Libra'],
  [4928950287,4929131370,'Scorpio'],
  [4929131370,4929324731,'Sagittarius'],
  [4929324731,4929530265,'Capricorn'],
  [4929530265,4929744687,'Aquarius'],
  [4929744687,4929963610,'Pisces'],
  [4929963610,4930182839,'Aries'],
  [4930182839,4930397867,'Taurus'],
  [4930397867,4930603808,'Gemini'],
  [4930603808,4930797224,'Cancer'],
  [4930797224,4930978376,'Leo'],
  [4930978376,4931151329,'Virgo'],
  [4931151329,4931322404,'Libra'],
  [4931322404,4931498505,'Scorpio'],
  [4931498505,4931685544,'Sagittarius'],
  [4931685544,4931886488,'Capricorn'],
  [4931886488,4932099539,'Aquarius'],
  [4932099539,4932318755,'Pisces'],
  [4932318755,4932537528,'Aries'],
  [4932537528,4932751185,'Taurus'],
  [4932751185,4932957106,'Gemini'],
  [4932957106,4933153743,'Cancer'],
  [4933153743,4933340704,'Leo'],
  [4933340704,4933519519,'Virgo'],
  [4933519519,4933693945,'Libra'],
  [4933693945,4933869553,'Scorpio'],
  [4933869553,4934052630,'Sagittarius'],
  [4934052630,4934248312,'Capricorn'],
  [4934248312,4934457759,'Aquarius'],
  [4934457759,4934676091,'Pisces'],
  [4934676091,4934894767,'Aries'],
  [4934894767,4935107007,'Taurus'],
  [4935107007,4935310514,'Gemini'],
  [4935310514,4935506060,'Cancer'],
  [4935506060,4935695065,'Leo'],
  [4935695065,4935878722,'Virgo'],
  [4935878722,4936058602,'Libra'],
  [4936058602,4936237758,'Scorpio'],
  [4936237758,4936421034,'Sagittarius'],
  [4936421034,4936613881,'Capricorn'],
  [4936613881,4936819655,'Aquarius'],
  [4936819655,4937036139,'Pisces'],
  [4937036139,4937255008,'Aries'],
  [4937255008,4937467159,'Taurus'],
  [4937467159,4937668579,'Gemini'],
  [4937668579,4937860744,'Cancer'],
  [4937860744,4938047356,'Leo'],
  [4938047356,4938231520,'Virgo'],
  [4938231520,4938414900,'Libra'],
  [4938414900,4938598725,'Scorpio'],
  [4938598725,4938785408,'Sagittarius'],
  [4938785408,4938978895,'Capricorn'],
  [4938978895,4939182942,'Aquarius'],
  [4939182942,4939397652,'Pisces'],
  [4939397652,4939616804,'Aries'],
  [4939616804,4939830497,'Taurus'],
  [4939830497,4940032146,'Gemini'],
  [4940032146,4940221906,'Cancer'],
  [4940221906,4940404339,'Leo'],
  [4940404339,4940584773,'Virgo'],
  [4940584773,4940767009,'Libra'],
  [4940767009,4940952827,'Scorpio'],
  [4940952827,4941143175,'Sagittarius'],
  [4941143175,4941339640,'Capricorn'],
  [4941339640,4941544470,'Aquarius'],
  [4941544470,4941758454,'Pisces'],
  [4941758454,4941977798,'Aries'],
  [4941977798,4942193916,'Taurus'],
  [4942193916,4942398502,'Gemini'],
  [4942398502,4942589072,'Cancer'],
  [4942589072,4942769116,'Leo'],
  [4942769116,4942944797,'Virgo'],
  [4942944797,4943122105,'Libra'],
  [4943122105,4943305222,'Scorpio'],
  [4943305222,4943496088,'Sagittarius'],
  [4943496088,4943695128,'Capricorn'],
  [4943695128,4943902227,'Aquarius'],
  [4943902227,4944116803,'Pisces'],
  [4944116803,4944336196,'Aries'],
  [4944336196,4944554237,'Taurus'],
  [4944554237,4944763096,'Gemini'],
  [4944763096,4944957920,'Cancer'],
  [4944957920,4945139572,'Leo'],
  [4945139572,4945313177,'Virgo'],
  [4945313177,4945485447,'Libra'],
  [4945485447,4945662739,'Scorpio'],
  [4945662739,4945849651,'Sagittarius'],
  [4945849651,4946047988,'Capricorn'],
  [4946047988,4946256613,'Aquarius'],
  [4946256613,4946472503,'Pisces'],
  [4946472503,4946691942,'Aries'],
  [4946691942,4946910378,'Taurus'],
  [4946910378,4947122300,'Gemini'],
  [4947122300,4947322687,'Cancer'],
  [4947322687,4947509724,'Leo'],
  [4947509724,4947685862,'Virgo'],
  [4947685862,4947856653,'Libra'],
  [4947856653,4948029023,'Scorpio'],
  [4948029023,4948209706,'Sagittarius'],
  [4948209706,4948403387,'Capricorn'],
  [4948403387,4948610587,'Aquarius'],
  [4948610587,4948827137,'Pisces'],
  [4948827137,4949046798,'Aries'],
  [4949046798,4949264375,'Taurus'],
  [4949264375,4949476392,'Gemini'],
  [4949476392,4949680053,'Cancer'],
  [4949680053,4949873154,'Leo'],
  [4949873154,4950055450,'Virgo'],
  [4950055450,4950229700,'Libra'],
  [4950229700,4950401463,'Scorpio'],
  [4950401463,4950577825,'Sagittarius'],
  [4950577825,4950765542,'Capricorn'],
  [4950765542,4950968207,'Aquarius'],
  [4950968207,4951183340,'Pisces'],
  [4951183340,4951403171,'Aries'],
  [4951403171,4951619946,'Taurus'],
  [4951619946,4951829935,'Gemini'],
  [4951829935,4952032650,'Cancer'],
  [4952032650,4952228146,'Leo'],
  [4952228146,4952416043,'Virgo'],
  [4952416043,4952596639,'Libra'],
  [4952596639,4952772619,'Scorpio'],
  [4952772619,4952949408,'Sagittarius'],
  [4952949408,4953133830,'Capricorn'],
  [4953133830,4953331532,'Aquarius'],
  [4953331532,4953543236,'Pisces'],
  [4953543236,4953762509,'Aries'],
  [4953762509,4953979519,'Taurus'],
  [4953979519,4954188002,'Gemini'],
  [4954188002,4954387501,'Cancer'],
  [4954387501,4954580445,'Leo'],
  [4954580445,4954768921,'Virgo'],
  [4954768921,4954953684,'Libra'],
  [4954953684,4955135456,'Scorpio'],
  [4955135456,4955316816,'Sagittarius'],
  [4955316816,4955502576,'Capricorn'],
  [4955502576,4955698194,'Aquarius'],
  [4955698194,4955906555,'Pisces'],
  [4955906555,4956124365,'Aries'],
  [4956124365,4956342393,'Taurus'],
  [4956342393,4956551747,'Gemini'],
  [4956551747,4956749553,'Cancer'],
  [4956749553,4956938378,'Leo'],
  [4956938378,4957122587,'Virgo'],
  [4957122587,4957305659,'Libra'],
  [4957305659,4957489481,'Scorpio'],
  [4957489481,4957675366,'Sagittarius'],
  [4957675366,4957865440,'Capricorn'],
  [4957865440,4958062856,'Aquarius'],
  [4958062856,4958270223,'Pisces'],
  [4958270223,4958486593,'Aries'],
  [4958486593,4958705510,'Taurus'],
  [4958705510,4958917752,'Gemini'],
  [4958917752,4959117441,'Cancer'],
  [4959117441,4959304898,'Leo'],
  [4959304898,4959484590,'Virgo'],
  [4959484590,4959662085,'Libra'],
  [4959662085,4959842121,'Scorpio'],
  [4959842121,4960027804,'Sagittarius'],
  [4960027804,4960220728,'Capricorn'],
  [4960220728,4960421593,'Aquarius'],
  [4960421593,4960630600,'Pisces'],
  [4960630600,4960846694,'Aries'],
  [4960846694,4961065897,'Taurus'],
  [4961065897,4961281140,'Gemini'],
  [4961281140,4961485363,'Cancer'],
  [4961485363,4961675775,'Leo'],
  [4961675775,4961854755,'Virgo'],
  [4961854755,4962027885,'Libra'],
  [4962027885,4962201733,'Scorpio'],
  [4962201733,4962382200,'Sagittarius'],
  [4962382200,4962573115,'Capricorn'],
  [4962573115,4962775217,'Aquarius'],
  [4962775217,4962986447,'Pisces'],
  [4962986447,4963203500,'Aries'],
  [4963203500,4963422659,'Taurus'],
  [4963422659,4963639343,'Gemini'],
  [4963639343,4963847938,'Cancer'],
  [4963847938,4964043962,'Leo'],
  [4964043962,4964226761,'Virgo'],
  [4964226761,4964399963,'Libra'],
  [4964399963,4964570046,'Scorpio'],
  [4964570046,4964744414,'Sagittarius'],
  [4964744414,4964929537,'Capricorn'],
  [4964929537,4965128645,'Aquarius'],
  [4965128645,4965339958,'Pisces'],
  [4965339958,4965558000,'Aries'],
  [4965558000,4965777166,'Taurus'],
  [4965777166,4965993560,'Gemini'],
  [4965993560,4966203964,'Cancer'],
  [4966203964,4966404811,'Leo'],
  [4966404811,4966593639,'Virgo'],
  [4966593639,4966771218,'Libra'],
  [4966771218,4966942167,'Scorpio'],
  [4966942167,4967113618,'Sagittarius'],
  [4967113618,4967293238,'Capricorn'],
  [4967293238,4967486800,'Aquarius'],
  [4967486800,4967695072,'Pisces'],
  [4967695072,4967912701,'Aries'],
  [4967912701,4968131888,'Taurus'],
  [4968131888,4968347269,'Gemini'],
  [4968347269,4968556710,'Cancer'],
  [4968556710,4968758935,'Leo'],
  [4968758935,4968952223,'Virgo'],
  [4968952223,4969135683,'Libra'],
  [4969135683,4969311290,'Scorpio'],
  [4969311290,4969484309,'Sagittarius'],
  [4969484309,4969661893,'Capricorn'],
  [4969661893,4969850858,'Aquarius'],
  [4969850858,4970054560,'Pisces'],
  [4970054560,4970269984,'Aries'],
  [4970269984,4970488918,'Taurus'],
  [4970488918,4970703690,'Gemini'],
  [4970703690,4970911130,'Cancer'],
  [4970911130,4971111365,'Leo'],
  [4971111365,4971304967,'Virgo'],
  [4971304967,4971491915,'Libra'],
  [4971491915,4971672824,'Scorpio'],
  [4971672824,4971850523,'Sagittarius'],
  [4971850523,4972030172,'Capricorn'],
  [4972030172,4972217870,'Aquarius'],
  [4972217870,4972418109,'Pisces'],
  [4972418109,4972630571,'Aries'],
  [4972630571,4972848835,'Taurus'],
  [4972848835,4973064001,'Gemini'],
  [4973064001,4973270505,'Cancer'],
  [4973270505,4973467847,'Leo'],
  [4973467847,4973658229,'Virgo'],
  [4973658229,4973844032,'Libra'],
  [4973844032,4974027032,'Scorpio'],
  [4974027032,4974209115,'Sagittarius'],
  [4974209115,4974393173,'Capricorn'],
  [4974393173,4974583123,'Aquarius'],
  [4974583123,4974782694,'Pisces'],
  [4974782694,4974993035,'Aries'],
  [4974993035,4975210423,'Taurus'],
  [4975210423,4975426859,'Gemini'],
  [4975426859,4975634698,'Cancer'],
  [4975634698,4975831071,'Leo'],
  [4975831071,4976017859,'Virgo'],
  [4976017859,4976199208,'Libra'],
  [4976199208,4976379424,'Scorpio'],
  [4976379424,4976561946,'Sagittarius'],
  [4976561946,4976749201,'Capricorn'],
  [4976749201,4976942949,'Aquarius'],
  [4976942949,4977144582,'Pisces'],
  [4977144582,4977354677,'Aries'],
  [4977354677,4977571403,'Taurus'],
  [4977571403,4977789228,'Gemini'],
  [4977789228,4978000354,'Cancer'],
  [4978000354,4978199169,'Leo'],
  [4978199169,4978385275,'Virgo'],
  [4978385275,4978562669,'Libra'],
  [4978562669,4978737412,'Scorpio'],
  [4978737412,4978915555,'Sagittarius'],
  [4978915555,4979101536,'Capricorn'],
  [4979101536,4979297129,'Aquarius'],
  [4979297129,4979501620,'Pisces'],
  [4979501620,4979713223,'Aries'],
  [4979713223,4979929894,'Taurus'],
  [4979929894,4980148359,'Gemini'],
  [4980148359,4980362864,'Cancer'],
  [4980362864,4980566731,'Leo'],
  [4980566731,4980756455,'Virgo'],
  [4980756455,4980933827,'Libra'],
  [4980933827,4981104768,'Scorpio'],
  [4981104768,4981276872,'Sagittarius'],
  [4981276872,4981457201,'Capricorn'],
  [4981457201,4981650020,'Aquarius'],
  [4981650020,4981855041,'Pisces'],
  [4981855041,4982068385,'Aries'],
  [4982068385,4982285719,'Taurus'],
  [4982285719,4982503946,'Gemini'],
  [4982503946,4982719799,'Cancer'],
  [4982719799,4982928243,'Leo'],
  [4982928243,4983124231,'Virgo'],
  [4983124231,4983306342,'Libra'],
  [4983306342,4983478301,'Scorpio'],
  [4983478301,4983647336,'Sagittarius'],
  [4983647336,4983821681,'Capricorn'],
  [4983821681,4984008218,'Aquarius'],
  [4984008218,4984209564,'Pisces'],
  [4984209564,4984422511,'Aries'],
  [4984422511,4984640571,'Taurus'],
  [4984640571,4984858435,'Gemini'],
  [4984858435,4985073345,'Cancer'],
  [4985073345,4985282877,'Leo'],
  [4985282877,4985483496,'Virgo'],
  [4985483496,4985672285,'Libra'],
  [4985672285,4985849867,'Scorpio'],
  [4985849867,4986021146,'Sagittarius'],
  [4986021146,4986193557,'Capricorn'],
  [4986193557,4986374787,'Aquarius'],
  [4986374787,4986570123,'Pisces'],
  [4986570123,4986779488,'Aries'],
  [4986779488,4986996995,'Taurus'],
  [4986996995,4987214931,'Gemini'],
  [4987214931,4987428436,'Cancer'],
  [4987428436,4987635846,'Leo'],
  [4987635846,4987836319,'Virgo'],
  [4987836319,4988028641,'Libra'],
  [4988028641,4988212385,'Scorpio'],
  [4988212385,4988389653,'Sagittarius'],
  [4988389653,4988565325,'Capricorn'],
  [4988565325,4988745801,'Aquarius'],
  [4988745801,4988936982,'Pisces'],
  [4988936982,4989141576,'Aries'],
  [4989141576,4989356736,'Taurus'],
  [4989356736,4989574821,'Gemini'],
  [4989574821,4989788230,'Cancer'],
  [4989788230,4989993392,'Leo'],
  [4989993392,4990190406,'Virgo'],
  [4990190406,4990380804,'Libra'],
  [4990380804,4990566169,'Scorpio'],
  [4990566169,4990748226,'Sagittarius'],
  [4990748226,4990929509,'Capricorn'],
  [4990929509,4991113680,'Aquarius'],
  [4991113680,4991305016,'Pisces'],
  [4991305016,4991506861,'Aries'],
  [4991506861,4991719232,'Taurus'],
  [4991719232,4991937033,'Gemini'],
  [4991937033,4992151865,'Cancer'],
  [4992151865,4992357195,'Leo'],
  [4992357195,4992551501,'Virgo'],
  [4992551501,4992737372,'Libra'],
  [4992737372,4992919058,'Scorpio'],
  [4992919058,4993100553,'Sagittarius'],
  [4993100553,4993284733,'Capricorn'],
  [4993284733,4993473445,'Aquarius'],
  [4993473445,4993668216,'Pisces'],
  [4993668216,4993870700,'Aries'],
  [4993870700,4994081718,'Taurus'],
  [4994081718,4994298978,'Gemini'],
  [4994298978,4994515788,'Cancer'],
  [4994515788,4994723938,'Leo'],
  [4994723938,4994918947,'Virgo'],
  [4994918947,4995102118,'Libra'],
  [4995102118,4995278740,'Scorpio'],
  [4995278740,4995455228,'Sagittarius'],
  [4995455228,4995636903,'Capricorn'],
  [4995636903,4995826585,'Aquarius'],
  [4995826585,4996024469,'Pisces'],
  [4996024469,4996229608,'Aries'],
  [4996229608,4996441307,'Taurus'],
  [4996441307,4996658338,'Gemini'],
  [4996658338,4996876588,'Cancer'],
  [4996876588,4997088597,'Leo'],
  [4997088597,4997287605,'Virgo'],
  [4997287605,4997472152,'Libra'],
  [4997472152,4997646506,'Scorpio'],
  [4997646506,4997817923,'Sagittarius'],
  [4997817923,4997993828,'Capricorn'],
  [4997993828,4998179623,'Aquarius'],
  [4998179623,4998376931,'Pisces'],
  [4998376931,4998583798,'Aries'],
  [4998583798,4998797127,'Taurus'],
  [4998797127,4999014501,'Gemini'],
  [4999014501,4999233176,'Cancer'],
  [4999233176,4999447940,'Leo'],
  [4999447940,4999652012,'Virgo'],
  [4999652012,4999841403,'Libra'],
  [4999841403,5000017871,'Scorpio'],
  [5000017871,5000187716,'Sagittarius'],
  [5000187716,5000358902,'Capricorn'],
  [5000358902,5000538705,'Aquarius'],
  [5000538705,5000731449,'Pisces'],
  [5000731449,5000936836,'Aries'],
  [5000936836,5001150848,'Taurus'],
  [5001150848,5001368794,'Gemini'],
  [5001368794,5001587159,'Cancer'],
  [5001587159,5001802399,'Leo'],
  [5001802399,5002009705,'Virgo'],
  [5002009705,5002204662,'Libra'],
  [5002204662,5002386512,'Scorpio'],
  [5002386512,5002559191,'Sagittarius'],
  [5002559191,5002729569,'Capricorn'],
  [5002729569,5002905191,'Aquarius'],
  [5002905191,5003092214,'Pisces'],
  [5003092214,5003293141,'Aries'],
  [5003293141,5003505555,'Taurus'],
  [5003505555,5003723590,'Gemini'],
  [5003723590,5003941524,'Cancer'],
  [5003941524,5004155512,'Leo'],
  [5004155512,5004362712,'Virgo'],
  [5004362712,5004560583,'Libra'],
  [5004560583,5004747877,'Scorpio'],
  [5004747877,5004926177,'Sagittarius'],
  [5004926177,5005099974,'Capricorn'],
  [5005099974,5005275466,'Aquarius'],
  [5005275466,5005458967,'Pisces'],
  [5005458967,5005654950,'Aries'],
  [5005654950,5005863832,'Taurus'],
  [5005863832,5006080923,'Gemini'],
  [5006080923,5006298760,'Cancer'],
  [5006298760,5006511400,'Leo'],
  [5006511400,5006716193,'Virgo'],
  [5006716193,5006912852,'Libra'],
  [5006912852,5007102050,'Scorpio'],
  [5007102050,5007285109,'Sagittarius'],
  [5007285109,5007464408,'Capricorn'],
  [5007464408,5007643643,'Aquarius'],
  [5007643643,5007827544,'Pisces'],
  [5007827544,5008020808,'Aries'],
  [5008020808,5008226059,'Taurus'],
  [5008226059,5008441316,'Gemini'],
  [5008441316,5008659454,'Cancer'],
  [5008659454,5008872151,'Leo'],
  [5008872151,5009074865,'Virgo'],
  [5009074865,5009267937,'Libra'],
  [5009267937,5009454459,'Scorpio'],
  [5009454459,5009637851,'Sagittarius'],
  [5009637851,5009820694,'Capricorn'],
  [5009820694,5010004869,'Aquarius'],
  [5010004869,5010192489,'Pisces'],
  [5010192489,5010386531,'Aries'],
  [5010386531,5010590009,'Taurus'],
  [5010590009,5010803410,'Gemini'],
  [5010803410,5011021933,'Cancer'],
  [5011021933,5011236533,'Leo'],
  [5011236533,5011439805,'Virgo'],
  [5011439805,5011630459,'Libra'],
  [5011630459,5011812429,'Scorpio'],
  [5011812429,5011991539,'Sagittarius'],
  [5011991539,5012172771,'Capricorn'],
  [5012172771,5012358825,'Aquarius'],
  [5012358825,5012550366,'Pisces'],
  [5012550366,5012747729,'Aries'],
  [5012747729,5012952148,'Taurus'],
  [5012952148,5013164728,'Gemini'],
  [5013164728,5013383341,'Cancer'],
  [5013383341,5013600645,'Leo'],
  [5013600645,5013807536,'Virgo'],
  [5013807536,5013999631,'Libra'],
  [5013999631,5014179418,'Scorpio'],
  [5014179418,5014353467,'Sagittarius'],
  [5014353467,5014528996,'Capricorn'],
  [5014528996,5014711447,'Aquarius'],
  [5014711447,5014902981,'Pisces'],
  [5014902981,5015102928,'Aries'],
  [5015102928,5015309918,'Taurus'],
  [5015309918,5015523256,'Gemini'],
  [5015523256,5015741719,'Cancer'],
  [5015741719,5015960722,'Leo'],
  [5015960722,5016172213,'Virgo'],
  [5016172213,5016369487,'Libra'],
  [5016369487,5016551908,'Scorpio'],
  [5016551908,5016724592,'Sagittarius'],
  [5016724592,5016895165,'Capricorn'],
  [5016895165,5017071045,'Aquarius'],
  [5017071045,5017257409,'Pisces'],
  [5017257409,5017455687,'Aries'],
  [5017455687,5017663927,'Taurus'],
  [5017663927,5017878830,'Gemini'],
  [5017878830,5018097427,'Cancer'],
  [5018097427,5018316350,'Leo'],
  [5018316350,5018530291,'Virgo'],
  [5018530291,5018733178,'Libra'],
  [5018733178,5018921887,'Scorpio'],
  [5018921887,5019098459,'Sagittarius'],
  [5019098459,5019268839,'Capricorn'],
  [5019268839,5019440435,'Aquarius'],
  [5019440435,5019620165,'Pisces'],
  [5019620165,5019812607,'Aries'],
  [5019812607,5020018292,'Taurus'],
  [5020018292,5020233511,'Gemini'],
  [5020233511,5020452605,'Cancer'],
  [5020452605,5020670660,'Leo'],
  [5020670660,5020883873,'Virgo'],
  [5020883873,5021088879,'Libra'],
  [5021088879,5021283112,'Scorpio'],
  [5021283112,5021466364,'Sagittarius'],
  [5021466364,5021641568,'Capricorn'],
  [5021641568,5021814130,'Aquarius'],
  [5021814130,5021990612,'Pisces'],
  [5021990612,5022177180,'Aries'],
  [5022177180,5022377516,'Taurus'],
  [5022377516,5022590413,'Gemini'],
  [5022590413,5022809537,'Cancer'],
  [5022809537,5023027207,'Leo'],
  [5023027207,5023238418,'Virgo'],
  [5023238418,5023441550,'Libra'],
  [5023441550,5023636677,'Scorpio'],
  [5023636677,5023824360,'Sagittarius'],
  [5023824360,5024005788,'Capricorn'],
  [5024005788,5024183493,'Aquarius'],
  [5024183493,5024361793,'Pisces'],
  [5024361793,5024546277,'Aries'],
  [5024546277,5024742128,'Taurus'],
  [5024742128,5024951205,'Gemini'],
  [5024951205,5025169248,'Cancer'],
  [5025169248,5025387286,'Leo'],
  [5025387286,5025597595,'Virgo'],
  [5025597595,5025797781,'Libra'],
  [5025797781,5025989763,'Scorpio'],
  [5025989763,5026176651,'Sagittarius'],
  [5026176651,5026360776,'Capricorn'],
  [5026360776,5026543538,'Aquarius'],
  [5026543538,5026726649,'Pisces'],
  [5026726649,5026913372,'Aries'],
  [5026913372,5027108189,'Taurus'],
  [5027108189,5027314475,'Gemini'],
  [5027314475,5027530864,'Cancer'],
  [5027530864,5027749619,'Leo'],
  [5027749619,5027961044,'Virgo'],
  [5027961044,5028160232,'Libra'],
  [5028160232,5028348710,'Scorpio'],
  [5028348710,5028531346,'Sagittarius'],
  [5028531346,5028712953,'Capricorn'],
  [5028712953,5028896487,'Aquarius'],
  [5028896487,5029083124,'Pisces'],
  [5029083124,5029273866,'Aries'],
  [5029273866,5029470890,'Taurus'],
  [5029470890,5029676892,'Gemini'],
  [5029676892,5029892184,'Cancer'],
  [5029892184,5030111575,'Leo'],
  [5030111575,5030325574,'Virgo'],
  [5030325574,5030526790,'Libra'],
  [5030526790,5030714544,'Scorpio'],
  [5030714544,5030893504,'Sagittarius'],
  [5030893504,5031070053,'Capricorn'],
  [5031070053,5031249604,'Aquarius'],
  [5031249604,5031435261,'Pisces'],
  [5031435261,5031627995,'Aries'],
  [5031627995,5031828019,'Taurus'],
  [5031828019,5032035788,'Gemini'],
  [5032035788,5032251174,'Cancer'],
  [5032251174,5032470909,'Leo'],
  [5032470909,5032687534,'Virgo'],
  [5032687534,5032892902,'Libra'],
  [5032892902,5033083606,'Scorpio'],
  [5033083606,5033262362,'Sagittarius'],
  [5033262362,5033435355,'Capricorn'],
  [5033435355,5033609382,'Aquarius'],
  [5033609382,5033790010,'Pisces'],
  [5033790010,5033980424,'Aries'],
  [5033980424,5034181169,'Taurus'],
  [5034181169,5034390863,'Gemini'],
  [5034390863,5034607254,'Cancer'],
  [5034607254,5034827082,'Leo'],
  [5034827082,5035045029,'Virgo'],
  [5035045029,5035254426,'Libra'],
  [5035254426,5035450434,'Scorpio'],
  [5035450434,5035632992,'Sagittarius'],
  [5035632992,5035806417,'Capricorn'],
  [5035806417,5035977213,'Aquarius'],
  [5035977213,5036152207,'Pisces'],
  [5036152207,5036337067,'Aries'],
  [5036337067,5036534749,'Taurus'],
  [5036534749,5036744331,'Gemini'],
  [5036744331,5036961622,'Cancer'],
  [5036961622,5037181475,'Leo'],
  [5037181475,5037399111,'Virgo'],
  [5037399111,5037610169,'Libra'],
  [5037610169,5037810855,'Scorpio'],
  [5037810855,5037999396,'Sagittarius'],
  [5037999396,5038177332,'Capricorn'],
  [5038177332,5038349231,'Aquarius'],
  [5038349231,5038521505,'Pisces'],
  [5038521505,5038701006,'Aries'],
  [5038701006,5038893220,'Taurus'],
  [5038893220,5039099740,'Gemini'],
  [5039099740,5039316616,'Cancer'],
  [5039316616,5039536497,'Leo'],
  [5039536497,5039753048,'Virgo'],
  [5039753048,5039962968,'Libra'],
  [5039962968,5040164887,'Scorpio'],
  [5040164887,5040357929,'Sagittarius'],
  [5040357929,5040541996,'Capricorn'],
  [5040541996,5040718895,'Aquarius'],
  [5040718895,5040892950,'Pisces'],
  [5040892950,5041070436,'Aries'],
  [5041070436,5041257972,'Taurus'],
  [5041257972,5041459808,'Gemini'],
  [5041459808,5041674444,'Cancer'],
  [5041674444,5041894170,'Leo'],
  [5041894170,5042110151,'Virgo'],
  [5042110151,5042317884,'Libra'],
  [5042317884,5042517458,'Scorpio'],
  [5042517458,5042710517,'Sagittarius'],
  [5042710517,5042898074,'Capricorn'],
  [5042898074,5043080642,'Aquarius'],
  [5043080642,5043259872,'Pisces'],
  [5043259872,5043439760,'Aries'],
  [5043439760,5043626116,'Taurus'],
  [5043626116,5043824347,'Gemini'],
  [5043824347,5044035809,'Cancer'],
  [5044035809,5044254882,'Leo'],
  [5044254882,5044471531,'Virgo'],
  [5044471531,5044678515,'Libra'],
  [5044678515,5044875020,'Scorpio'],
  [5044875020,5045064310,'Sagittarius'],
  [5045064310,5045250051,'Capricorn'],
  [5045250051,5045434353,'Aquarius'],
  [5045434353,5045618137,'Pisces'],
  [5045618137,5045802941,'Aries'],
  [5045802941,5045992085,'Taurus'],
  [5045992085,5046189921,'Gemini'],
  [5046189921,5046399133,'Cancer'],
  [5046399133,5046617106,'Leo'],
  [5046617106,5046835215,'Virgo'],
  [5046835215,5047044152,'Libra'],
  [5047044152,5047240260,'Scorpio'],
  [5047240260,5047426038,'Sagittarius'],
  [5047426038,5047606701,'Capricorn'],
  [5047606701,5047787129,'Aquarius'],
  [5047787129,5047970423,'Pisces'],
  [5047970423,5048158115,'Aries'],
  [5048158115,5048351399,'Taurus'],
  [5048351399,5048551946,'Gemini'],
  [5048551946,5048761265,'Cancer'],
  [5048761265,5048978364,'Leo'],
  [5048978364,5049197574,'Virgo'],
  [5049197574,5049410150,'Libra'],
  [5049410150,5049609713,'Scorpio'],
  [5049609713,5049795920,'Sagittarius'],
  [5049795920,5049973191,'Capricorn'],
  [5049973191,5050147741,'Aquarius'],
  [5050147741,5050325428,'Pisces'],
  [5050325428,5050510448,'Aries'],
  [5050510448,5050704742,'Taurus'],
  [5050704742,5050908224,'Gemini'],
  [5050908224,5051119616,'Cancer'],
  [5051119616,5051336858,'Leo'],
  [5051336858,5051556208,'Virgo'],
  [5051556208,5051771619,'Libra'],
  [5051771619,5051976517,'Scorpio'],
  [5051976517,5052167547,'Sagittarius'],
  [5052167547,5052346311,'Capricorn'],
  [5052346311,5052518119,'Aquarius'],
  [5052518119,5052689885,'Pisces'],
  [5052689885,5052868362,'Aries'],
  [5052868362,5053058437,'Taurus'],
  [5053058437,5053261363,'Gemini'],
  [5053261363,5053474356,'Cancer'],
  [5053474356,5053692623,'Leo'],
  [5053692623,5053911658,'Virgo'],
  [5053911658,5054127550,'Libra'],
  [5054127550,5054336058,'Scorpio'],
  [5054336058,5054533238,'Sagittarius'],
  [5054533238,5054717725,'Capricorn'],
  [5054717725,5054892053,'Aquarius'],
  [5054892053,5055062093,'Pisces'],
  [5055062093,5055235316,'Aries'],
  [5055235316,5055418874,'Taurus'],
  [5055418874,5055617076,'Gemini'],
  [5055617076,5055828723,'Cancer'],
  [5055828723,5056047531,'Leo'],
  [5056047531,5056266452,'Virgo'],
  [5056266452,5056481207,'Libra'],
  [5056481207,5056689777,'Scorpio'],
  [5056689777,5056890260,'Sagittarius'],
  [5056890260,5057080742,'Capricorn'],
  [5057080742,5057261063,'Aquarius'],
  [5057261063,5057434414,'Pisces'],
  [5057434414,5057607027,'Aries'],
  [5057607027,5057786418,'Taurus'],
  [5057786418,5057978957,'Gemini'],
  [5057978957,5058186496,'Cancer'],
  [5058186496,5058404125,'Leo'],
  [5058404125,5058623065,'Virgo'],
  [5058623065,5058836746,'Libra'],
  [5058836746,5059043185,'Scorpio'],
  [5059043185,5059242707,'Sagittarius'],
  [5059242707,5059435361,'Capricorn'],
  [5059435361,5059620752,'Aquarius'],
  [5059620752,5059799785,'Pisces'],
  [5059799785,5059976138,'Aries'],
  [5059976138,5060155845,'Taurus'],
  [5060155845,5060345400,'Gemini'],
  [5060345400,5060548720,'Cancer'],
  [5060548720,5060763782,'Leo'],
  [5060763782,5060982516,'Virgo'],
  [5060982516,5061196215,'Libra'],
  [5061196215,5061400910,'Scorpio'],
  [5061400910,5061597303,'Sagittarius'],
  [5061597303,5061787668,'Capricorn'],
  [5061787668,5061973672,'Aquarius'],
  [5061973672,5062156394,'Pisces'],
  [5062156394,5062337690,'Aries'],
  [5062337690,5062521144,'Taurus'],
  [5062521144,5062711568,'Gemini'],
  [5062711568,5062913003,'Cancer'],
  [5062913003,5063125657,'Leo'],
  [5063125657,5063343923,'Virgo'],
  [5063343923,5063558822,'Libra'],
  [5063558822,5063763881,'Scorpio'],
  [5063763881,5063958154,'Sagittarius'],
  [5063958154,5064144524,'Capricorn'],
  [5064144524,5064326895,'Aquarius'],
  [5064326895,5064508561,'Pisces'],
  [5064508561,5064691990,'Aries'],
  [5064691990,5064879382,'Taurus'],
  [5064879382,5065073151,'Gemini'],
  [5065073151,5065275596,'Cancer'],
  [5065275596,5065487328,'Leo'],
  [5065487328,5065705143,'Virgo'],
  [5065705143,5065921810,'Libra'],
  [5065921810,5066129550,'Scorpio'],
  [5066129550,5066324725,'Sagittarius'],
  [5066324725,5066508873,'Capricorn'],
  [5066508873,5066686633,'Aquarius'],
  [5066686633,5066863506,'Pisces'],
  [5066863506,5067044320,'Aries'],
  [5067044320,5067232325,'Taurus'],
  [5067232325,5067428893,'Gemini'],
  [5067428893,5067633930,'Cancer'],
  [5067633930,5067846461,'Leo'],
  [5067846461,5068064148,'Virgo'],
  [5068064148,5068282197,'Libra'],
  [5068282197,5068493693,'Scorpio'],
  [5068493693,5068692885,'Sagittarius'],
  [5068692885,5068878590,'Capricorn'],
  [5068878590,5069054309,'Aquarius'],
  [5069054309,5069226299,'Pisces'],
  [5069226299,5069401473,'Aries'],
  [5069401473,5069585592,'Taurus'],
  [5069585592,5069781476,'Gemini'],
  [5069781476,5069988166,'Cancer'],
  [5069988166,5070202298,'Leo'],
  [5070202298,5070420296,'Virgo'],
  [5070420296,5070638709,'Libra'],
  [5070638709,5070852945,'Scorpio'],
  [5070852945,5071057337,'Sagittarius'],
  [5071057337,5071248147,'Capricorn'],
  [5071248147,5071426189,'Aquarius'],
  [5071426189,5071596656,'Pisces'],
  [5071596656,5071767067,'Aries'],
  [5071767067,5071945107,'Taurus'],
  [5071945107,5072136301,'Gemini'],
  [5072136301,5072341430,'Cancer'],
  [5072341430,5072556241,'Leo'],
  [5072556241,5072774778,'Virgo'],
  [5072774778,5072992742,'Libra'],
  [5072992742,5073207293,'Scorpio'],
  [5073207293,5073414943,'Sagittarius'],
  [5073414943,5073611660,'Capricorn'],
  [5073611660,5073795592,'Aquarius'],
  [5073795592,5073969264,'Pisces'],
  [5073969264,5074139002,'Aries'],
  [5074139002,5074312786,'Taurus'],
  [5074312786,5074497967,'Gemini'],
  [5074497967,5074698281,'Cancer'],
  [5074698281,5074911314,'Leo'],
  [5074911314,5075129959,'Virgo'],
  [5075129959,5075347472,'Libra'],
  [5075347472,5075560523,'Scorpio'],
  [5075560523,5075767695,'Sagittarius'],
  [5075767695,5075967151,'Capricorn'],
  [5075967151,5076156837,'Aquarius'],
  [5076156837,5076336779,'Pisces'],
  [5076336779,5076510600,'Aries'],
  [5076510600,5076684732,'Taurus'],
  [5076684732,5076866479,'Gemini'],
  [5076866479,5077061461,'Cancer'],
  [5077061461,5077270449,'Leo'],
  [5077270449,5077487965,'Virgo'],
  [5077487965,5077705567,'Libra'],
  [5077705567,5077917390,'Scorpio'],
  [5077917390,5078121828,'Sagittarius'],
  [5078121828,5078319326,'Capricorn'],
  [5078319326,5078510255,'Aquarius'],
  [5078510255,5078694888,'Pisces'],
  [5078694888,5078874767,'Aries'],
  [5078874767,5079053556,'Taurus'],
  [5079053556,5079236554,'Gemini'],
  [5079236554,5079429113,'Cancer'],
  [5079429113,5079634104,'Leo'],
  [5079634104,5079849290,'Virgo'],
  [5079849290,5080067232,'Libra'],
  [5080067232,5080279686,'Scorpio'],
  [5080279686,5080482497,'Sagittarius'],
  [5080482497,5080676130,'Capricorn'],
];

export default signs;
